module.exports = {
	"type": "FeatureCollection",
	"features": [
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							151.0772196590001,
							-33.943755274999944
						],
						[
							151.03564678500004,
							-33.940449430999934
						],
						[
							150.97068284400007,
							-33.946932824999976
						],
						[
							150.9828127410001,
							-33.95570772599996
						],
						[
							150.9811569200001,
							-33.964902775999974
						],
						[
							150.997432816,
							-33.97403463799998
						],
						[
							150.99606395500007,
							-33.98166466799995
						],
						[
							151.015588642,
							-33.98206646999995
						],
						[
							151.02260642400006,
							-33.96408324999993
						],
						[
							151.02480748200003,
							-33.97729426999996
						],
						[
							151.04434542,
							-33.970113251999976
						],
						[
							151.0419966830001,
							-33.94735903199995
						],
						[
							151.04661232000012,
							-33.969977281999945
						],
						[
							151.03351339000005,
							-33.98456133099995
						],
						[
							151.03637644800006,
							-33.99080634199993
						],
						[
							151.05286732600007,
							-33.99099128299997
						],
						[
							151.04936449800005,
							-33.98015933299996
						],
						[
							151.06182876700007,
							-33.97522489399995
						],
						[
							151.0553664460001,
							-33.98595732299998
						],
						[
							151.07463435400007,
							-33.98397129499995
						],
						[
							151.06956556400007,
							-33.99051735499995
						],
						[
							151.07628470200007,
							-33.99404633499995
						],
						[
							151.09017744200003,
							-33.982462306999935
						],
						[
							151.08595271100012,
							-33.98981159599998
						],
						[
							151.09220950000008,
							-33.99091478699995
						],
						[
							151.12967656700005,
							-33.97361798999998
						],
						[
							151.09438965300012,
							-33.96541390699997
						],
						[
							151.0772196590001,
							-33.943755274999944
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "101",
				"CED_NAME21": "Banks",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 49.4371,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/101",
				"SHAPE_Leng": 0.662152952594,
				"SHAPE_Area": 0.0048223157101
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							151.1742456170001,
							-33.924953623999954
						],
						[
							151.14722978300006,
							-33.91128495099997
						],
						[
							151.1190596770001,
							-33.912187038999946
						],
						[
							151.09488364900005,
							-33.92219376699995
						],
						[
							151.10078835600007,
							-33.939246786999945
						],
						[
							151.0772196590001,
							-33.943755274999944
						],
						[
							151.09438965300012,
							-33.96541390699997
						],
						[
							151.12967656700005,
							-33.97361798999998
						],
						[
							151.13713249700004,
							-33.96429594099993
						],
						[
							151.1548474340001,
							-33.96665632199995
						],
						[
							151.16803842500008,
							-33.949761303999935
						],
						[
							151.16046168800005,
							-33.93399630299996
						],
						[
							151.1742456170001,
							-33.924953623999954
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "102",
				"CED_NAME21": "Barton",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 39.547,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/102",
				"SHAPE_Leng": 0.293774860043,
				"SHAPE_Area": 0.00385673438757
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							151.12832469500006,
							-33.84168988899995
						],
						[
							151.136892417,
							-33.81516027999993
						],
						[
							151.14372955600004,
							-33.81675434999994
						],
						[
							151.14358450800012,
							-33.80292026999996
						],
						[
							151.1576881860001,
							-33.80067694199994
						],
						[
							151.15711177700007,
							-33.79269615099997
						],
						[
							151.14847722800005,
							-33.79432906099993
						],
						[
							151.13928930200007,
							-33.77473028999998
						],
						[
							151.10009550100006,
							-33.75350983599998
						],
						[
							151.08557044300005,
							-33.75355730499996
						],
						[
							151.08362973200008,
							-33.76417619399996
						],
						[
							151.048963167,
							-33.75883241099996
						],
						[
							151.0476059570001,
							-33.76647620099993
						],
						[
							151.06637921000004,
							-33.79264551299997
						],
						[
							151.05507878100002,
							-33.79919656199996
						],
						[
							151.0511083780001,
							-33.82422551199994
						],
						[
							151.09283345300003,
							-33.81959627599997
						],
						[
							151.1086306190001,
							-33.83554229699996
						],
						[
							151.11286851900002,
							-33.82971128799994
						],
						[
							151.12832469500006,
							-33.84168988899995
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "103",
				"CED_NAME21": "Bennelong",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 58.691,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/103",
				"SHAPE_Leng": 0.472892495175,
				"SHAPE_Area": 0.00571349760501
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								151.0476059570001,
								-33.76647620099993
							],
							[
								151.048963167,
								-33.75883241099996
							],
							[
								151.08362973200008,
								-33.76417619399996
							],
							[
								151.08557044300005,
								-33.75355730499996
							],
							[
								151.10009550100006,
								-33.75350983599998
							],
							[
								151.09002077500008,
								-33.73540827499994
							],
							[
								151.10069647800003,
								-33.695809295999936
							],
							[
								151.11237326900005,
								-33.67854415599993
							],
							[
								151.1379961550001,
								-33.68338290899993
							],
							[
								151.15969518500003,
								-33.660484020999945
							],
							[
								151.1588506160001,
								-33.652375280999934
							],
							[
								151.14945460700005,
								-33.655450309999935
							],
							[
								151.16298340600008,
								-33.64649126099994
							],
							[
								151.15847262700004,
								-33.64111331099997
							],
							[
								151.17037348700012,
								-33.62906528199994
							],
							[
								151.16393130900008,
								-33.625852290999944
							],
							[
								151.21315841400008,
								-33.60774329499998
							],
							[
								151.20926357700012,
								-33.59405233499996
							],
							[
								151.18631756000002,
								-33.59210328299997
							],
							[
								151.23276439300002,
								-33.59403028699995
							],
							[
								151.24708557300005,
								-33.579058327999974
							],
							[
								151.2310284880001,
								-33.56141633699997
							],
							[
								151.22413663700002,
								-33.57497332599996
							],
							[
								151.21289956900011,
								-33.572668334999946
							],
							[
								151.2112464800001,
								-33.56719632499994
							],
							[
								151.22196148800003,
								-33.56943632599996
							],
							[
								151.23139459100003,
								-33.53890427699997
							],
							[
								151.20219357400003,
								-33.54404230399996
							],
							[
								151.22899052100001,
								-33.54151634599998
							],
							[
								151.2259035300001,
								-33.54701734599996
							],
							[
								151.19853557400006,
								-33.54996132399998
							],
							[
								151.19994535500007,
								-33.541824333999955
							],
							[
								151.18615342700002,
								-33.536760681999965
							],
							[
								151.17509061200008,
								-33.51423330099993
							],
							[
								151.16418945200007,
								-33.529118309999944
							],
							[
								151.1700646390001,
								-33.538620340999955
							],
							[
								151.14886854300005,
								-33.53679134899994
							],
							[
								151.16958655700012,
								-33.558497270999965
							],
							[
								151.1520473600001,
								-33.55084825899996
							],
							[
								151.162254436,
								-33.57576233999998
							],
							[
								151.15015555800005,
								-33.56854126899998
							],
							[
								151.13371830000006,
								-33.57094734799995
							],
							[
								151.14434837700003,
								-33.58707227899998
							],
							[
								151.1325695690001,
								-33.58139632799998
							],
							[
								151.12343567000005,
								-33.58583234699995
							],
							[
								151.12079036800003,
								-33.59953529699993
							],
							[
								151.116072561,
								-33.587452335999956
							],
							[
								151.1027835320001,
								-33.58776528499993
							],
							[
								151.12005956000007,
								-33.585990306999975
							],
							[
								151.13148238000008,
								-33.57834632799995
							],
							[
								151.13098051100008,
								-33.56785330699995
							],
							[
								151.15146561900008,
								-33.56193734899995
							],
							[
								151.14490854300004,
								-33.54206031899997
							],
							[
								151.1387684020001,
								-33.55047233799996
							],
							[
								151.12827261500001,
								-33.54161831699997
							],
							[
								151.11695637600008,
								-33.54619426599993
							],
							[
								151.12709362600003,
								-33.537614306999956
							],
							[
								151.137588584,
								-33.541952067999944
							],
							[
								151.1433555440001,
								-33.529800327999965
							],
							[
								151.13579468600005,
								-33.522238967999954
							],
							[
								151.12637592700003,
								-33.53108306699994
							],
							[
								151.13130850800007,
								-33.51927032699996
							],
							[
								151.12171666900008,
								-33.52151528599995
							],
							[
								151.1114544820001,
								-33.50702934499998
							],
							[
								151.13018062000003,
								-33.50507733699993
							],
							[
								151.12126451000006,
								-33.510581265999974
							],
							[
								151.12550960900012,
								-33.51775031699998
							],
							[
								151.13377053800002,
								-33.51336228699995
							],
							[
								151.14076860600005,
								-33.52436493799996
							],
							[
								151.15393664400005,
								-33.52390028899998
							],
							[
								151.15528053700007,
								-33.49893734899996
							],
							[
								151.1312995710001,
								-33.491250916999945
							],
							[
								151.1432864200001,
								-33.49098628799993
							],
							[
								151.15553542100008,
								-33.46708427899995
							],
							[
								151.13840929200012,
								-33.47538083699993
							],
							[
								151.1223895160001,
								-33.466624955999976
							],
							[
								151.10224461600012,
								-33.484150333999935
							],
							[
								151.08561625000004,
								-33.47549931299994
							],
							[
								151.07976658400003,
								-33.448832281999955
							],
							[
								151.07706930300003,
								-33.46083140199994
							],
							[
								151.06845347400008,
								-33.46009149099996
							],
							[
								151.06322047700007,
								-33.442476599999964
							],
							[
								151.03233589400008,
								-33.427329966999935
							],
							[
								151.03190866700004,
								-33.40534091699993
							],
							[
								150.99481222300005,
								-33.399371333999966
							],
							[
								150.98846301600008,
								-33.37921897299998
							],
							[
								150.97665753500007,
								-33.40022056199996
							],
							[
								150.95174807700005,
								-33.41374281999998
							],
							[
								150.95158221500003,
								-33.42746080999996
							],
							[
								150.93985118800003,
								-33.413909968999974
							],
							[
								150.92496053800005,
								-33.43244916699996
							],
							[
								150.92454437000004,
								-33.418316146999985
							],
							[
								150.90358063300005,
								-33.41948036499997
							],
							[
								150.89376388300002,
								-33.42721146399998
							],
							[
								150.8981729410001,
								-33.43585739499997
							],
							[
								150.8873581030001,
								-33.43718849399994
							],
							[
								150.8755454620001,
								-33.45273457299993
							],
							[
								150.89825615900008,
								-33.45173635499998
							],
							[
								150.9052692260001,
								-33.46959731599998
							],
							[
								150.87106972000004,
								-33.47311364299998
							],
							[
								150.87902178700006,
								-33.486545543999966
							],
							[
								150.8704930870001,
								-33.50017856299996
							],
							[
								150.8935175360001,
								-33.484646434999945
							],
							[
								150.92767729800005,
								-33.50485105799993
							],
							[
								150.91928353800006,
								-33.51674716699995
							],
							[
								150.89854778100005,
								-33.51234331599994
							],
							[
								150.9078037390001,
								-33.52255927599998
							],
							[
								150.88940014900004,
								-33.54062545499994
							],
							[
								150.88965750600005,
								-33.56154229499998
							],
							[
								150.91655749300003,
								-33.554614286999936
							],
							[
								150.9357365290001,
								-33.56476528899998
							],
							[
								150.90435728700004,
								-33.61179572699996
							],
							[
								150.92316892400004,
								-33.61980156899995
							],
							[
								150.92444750100003,
								-33.639308288999985
							],
							[
								150.9373494890001,
								-33.64336629999997
							],
							[
								150.93659849800008,
								-33.64956423999996
							],
							[
								150.92783751900004,
								-33.64921229899994
							],
							[
								150.93007747700005,
								-33.66007728899996
							],
							[
								150.99994047000007,
								-33.71410528599995
							],
							[
								151.01880596700005,
								-33.71646796799996
							],
							[
								151.0168367560001,
								-33.730669337999984
							],
							[
								151.02694083400002,
								-33.732740898999964
							],
							[
								151.02095986200004,
								-33.75734245899997
							],
							[
								151.03113653900004,
								-33.768953059999944
							],
							[
								151.0476059570001,
								-33.76647620099993
							]
						]
					],
					[
						[
							[
								151.17863841100007,
								-33.51549528199996
							],
							[
								151.18314562000012,
								-33.51923235199996
							],
							[
								151.1772754330001,
								-33.50730132099994
							],
							[
								151.17863841100007,
								-33.51549528199996
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "104",
				"CED_NAME21": "Berowra",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 743.9867,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/104",
				"SHAPE_Leng": 2.93272944149,
				"SHAPE_Area": 0.0722450845445
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							151.03564678500004,
							-33.940449430999934
						],
						[
							151.04228384500004,
							-33.86171663099998
						],
						[
							151.0370725570001,
							-33.851327270999946
						],
						[
							151.04362528700005,
							-33.843361320999975
						],
						[
							151.03008347000002,
							-33.83516529999997
						],
						[
							151.01835047100008,
							-33.83796630899997
						],
						[
							151.01338147,
							-33.85393639899996
						],
						[
							150.99647773300012,
							-33.851309706999984
						],
						[
							150.98552346200006,
							-33.87047938599994
						],
						[
							150.96715115200004,
							-33.890130564999936
						],
						[
							150.97945011800005,
							-33.90634060599996
						],
						[
							150.9731132080001,
							-33.907555644999945
						],
						[
							150.9790524450001,
							-33.92914864599993
						],
						[
							150.96860362600012,
							-33.931061704999934
						],
						[
							150.97068284400007,
							-33.946932824999976
						],
						[
							151.03564678500004,
							-33.940449430999934
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "105",
				"CED_NAME21": "Blaxland",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 60.9795,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/105",
				"SHAPE_Leng": 0.381874705792,
				"SHAPE_Area": 0.00594347274671
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							151.15969518500003,
							-33.660484020999945
						],
						[
							151.1379961550001,
							-33.68338290899993
						],
						[
							151.11237326900005,
							-33.67854415599993
						],
						[
							151.10069647800003,
							-33.695809295999936
						],
						[
							151.09002077500008,
							-33.73540827499994
						],
						[
							151.10009550100006,
							-33.75350983599998
						],
						[
							151.13928930200007,
							-33.77473028999998
						],
						[
							151.14847722800005,
							-33.79432906099993
						],
						[
							151.15711177700007,
							-33.79269615099997
						],
						[
							151.17824271400002,
							-33.797708882999984
						],
						[
							151.2036674420001,
							-33.78684031599994
						],
						[
							151.21474143000012,
							-33.78987631699994
						],
						[
							151.2330524570001,
							-33.78974231899997
						],
						[
							151.20293737300005,
							-33.77354884599998
						],
						[
							151.19385905800004,
							-33.75022437499996
						],
						[
							151.18032819100006,
							-33.74056854299994
						],
						[
							151.1917420310001,
							-33.72828247399997
						],
						[
							151.1914225150001,
							-33.70268653399995
						],
						[
							151.16570287000002,
							-33.685858801999984
						],
						[
							151.1718510710001,
							-33.677529421999964
						],
						[
							151.16151029500008,
							-33.65959185099996
						],
						[
							151.15969518500003,
							-33.660484020999945
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "106",
				"CED_NAME21": "Bradfield",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 99.4745,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/106",
				"SHAPE_Leng": 0.590641381364,
				"SHAPE_Area": 0.00967750963968
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							149.79567046700004,
							-32.058077165999975
						],
						[
							149.77848385700008,
							-32.07753731499997
						],
						[
							149.77762494500007,
							-32.09154039499998
						],
						[
							149.76287514700005,
							-32.089288402999955
						],
						[
							149.75183933800008,
							-32.09954849199994
						],
						[
							149.750816535,
							-32.11980948199994
						],
						[
							149.68187935600008,
							-32.111131685999965
						],
						[
							149.6694768760001,
							-32.12190917499993
						],
						[
							149.63819488100012,
							-32.11268816299997
						],
						[
							149.60281087400006,
							-32.12694715999993
						],
						[
							149.57815287000005,
							-32.10656315699998
						],
						[
							149.57323588300005,
							-32.08641115699993
						],
						[
							149.53281888800007,
							-32.08945015299997
						],
						[
							149.5003070350001,
							-32.07321213999995
						],
						[
							149.49495839200006,
							-32.102100279999945
						],
						[
							149.4797216830001,
							-32.108781318999945
						],
						[
							149.48015056500003,
							-32.09413824899997
						],
						[
							149.4725107160001,
							-32.093259297999964
						],
						[
							149.47072385500007,
							-32.10351332799996
						],
						[
							149.41502855300007,
							-32.09554154299997
						],
						[
							149.412261703,
							-32.10609759299996
						],
						[
							149.42909582700008,
							-32.135415594999984
						],
						[
							149.41178905900006,
							-32.13818171299994
						],
						[
							149.41328333400008,
							-32.17552385399995
						],
						[
							149.3967625560001,
							-32.17682092199993
						],
						[
							149.3846869360001,
							-32.19315300099993
						],
						[
							149.37311103800005,
							-32.18990603999998
						],
						[
							149.37372320500003,
							-32.215752099999975
						],
						[
							149.3610164260001,
							-32.22038116899995
						],
						[
							149.3397900750001,
							-32.256422347999944
						],
						[
							149.32650030600007,
							-32.26036341699995
						],
						[
							149.33517048200008,
							-32.285077427999965
						],
						[
							149.32102074300008,
							-32.28679449599997
						],
						[
							149.3051153230001,
							-32.30473357499994
						],
						[
							149.29333546500004,
							-32.302685613999984
						],
						[
							149.28539831800003,
							-32.28860564299998
						],
						[
							149.2397132430001,
							-32.299236829999984
						],
						[
							149.2350041640001,
							-32.29340283899995
						],
						[
							149.18916481100007,
							-32.29056201499998
						],
						[
							149.20302393800011,
							-32.21359912599996
						],
						[
							149.19070997000006,
							-32.21203177499996
						],
						[
							149.19244000100002,
							-32.201744754999936
						],
						[
							149.19876880200002,
							-32.18673866499995
						],
						[
							149.22056791900002,
							-32.18252612699996
						],
						[
							149.2109719220001,
							-32.170783135999955
						],
						[
							149.2114639140001,
							-32.150393115999975
						],
						[
							149.1973539270001,
							-32.144630124999935
						],
						[
							149.20151590900002,
							-32.11975711499997
						],
						[
							149.19376193200003,
							-32.10440813399998
						],
						[
							149.16911092600003,
							-32.102949121999984
						],
						[
							149.17114193300006,
							-32.124800121999954
						],
						[
							149.15465393600005,
							-32.12174413099996
						],
						[
							149.15403394600003,
							-32.11589111099994
						],
						[
							149.1386909580001,
							-32.11719911999995
						],
						[
							149.12215894200006,
							-32.10103411799997
						],
						[
							149.11945892200004,
							-32.107960127999945
						],
						[
							149.1102549430001,
							-32.11140811699994
						],
						[
							149.10624694400008,
							-32.10484311699997
						],
						[
							149.09619893400009,
							-32.114945115999944
						],
						[
							149.07119092900007,
							-32.10329410399993
						],
						[
							149.05961496200007,
							-32.08720611299998
						],
						[
							149.05473597200012,
							-32.100327111999945
						],
						[
							149.03292295500012,
							-32.09983210099995
						],
						[
							149.02563893500007,
							-32.10883710999997
						],
						[
							149.0152534460001,
							-32.10524223899995
						],
						[
							149.00078594400009,
							-32.13961810799998
						],
						[
							148.9909171060001,
							-32.13846241699997
						],
						[
							148.96840197500012,
							-32.16760953599993
						],
						[
							148.95291907900003,
							-32.15757048399996
						],
						[
							148.94532740800003,
							-32.171343553999975
						],
						[
							148.92725284900007,
							-32.271650972999964
						],
						[
							148.89617551100002,
							-32.29114623999993
						],
						[
							148.88751680200005,
							-32.28993527999995
						],
						[
							148.88355104000004,
							-32.311995458999945
						],
						[
							148.85119747400006,
							-32.31336660699998
						],
						[
							148.85067187200002,
							-32.33245271699997
						],
						[
							148.84103394400006,
							-32.33124808599996
						],
						[
							148.80460304400003,
							-32.36738404299996
						],
						[
							148.76808932200004,
							-32.34183313999995
						],
						[
							148.75838480800007,
							-32.389360428999964
						],
						[
							148.76567086700004,
							-32.390249359999984
						],
						[
							148.7645969670001,
							-32.39656745999997
						],
						[
							148.75736419800012,
							-32.395640438999976
						],
						[
							148.75411521500007,
							-32.419038558999944
						],
						[
							148.72671269900002,
							-32.422227626999984
						],
						[
							148.70814391300007,
							-32.40604272499996
						],
						[
							148.69825219400002,
							-32.407264744999964
						],
						[
							148.70384301,
							-32.43493273499996
						],
						[
							148.71637279900006,
							-32.435594685999945
						],
						[
							148.73410496200006,
							-32.468266667999956
						],
						[
							148.72293020300003,
							-32.48053978699994
						],
						[
							148.7234662410001,
							-32.49522283699997
						],
						[
							148.70041254400007,
							-32.49692294499994
						],
						[
							148.69920476100003,
							-32.52274942599996
						],
						[
							148.70840885000007,
							-32.52281332599995
						],
						[
							148.71270800800005,
							-32.53150839699998
						],
						[
							148.70069154700002,
							-32.55306376599998
						],
						[
							148.71532987500007,
							-32.55281203699997
						],
						[
							148.7245779120001,
							-32.570403357999965
						],
						[
							148.69858483500002,
							-32.57818295599998
						],
						[
							148.70974124200006,
							-32.58519565699993
						],
						[
							148.6902547730001,
							-32.598878344999946
						],
						[
							148.70204912000008,
							-32.61369559599996
						],
						[
							148.6861604920001,
							-32.612724044999936
						],
						[
							148.67032303300005,
							-32.623213103999944
						],
						[
							148.6640189320001,
							-32.641240092999965
						],
						[
							148.63771794700006,
							-32.63321808099994
						],
						[
							148.63107494500002,
							-32.65185909099995
						],
						[
							148.6215339570001,
							-32.64794307999995
						],
						[
							148.6145989570001,
							-32.653603078999936
						],
						[
							148.50119008800004,
							-32.614104089999955
						],
						[
							148.47526498000002,
							-32.62777007799997
						],
						[
							148.459258964,
							-32.60734405599993
						],
						[
							148.4354243260001,
							-32.62058633399994
						],
						[
							148.3859311330001,
							-32.62206645999993
						],
						[
							148.37546830300005,
							-32.630348469999944
						],
						[
							148.36178145600002,
							-32.62193451799993
						],
						[
							148.347262816,
							-32.641573636999965
						],
						[
							148.3471489320001,
							-32.67574962799995
						],
						[
							148.3349661430001,
							-32.67902070699995
						],
						[
							148.32951939200007,
							-32.70101180599994
						],
						[
							148.335336062,
							-32.78159504699994
						],
						[
							148.3275642210001,
							-32.80081012699998
						],
						[
							148.32938330900004,
							-32.81081816699998
						],
						[
							148.3454120670001,
							-32.81157411799995
						],
						[
							148.37834196000006,
							-32.83260207099994
						],
						[
							148.37578096900006,
							-32.845411060999936
						],
						[
							148.3830639570001,
							-32.850585071999944
						],
						[
							148.38126311000008,
							-32.91400940199998
						],
						[
							148.37251946900005,
							-32.92915858099997
						],
						[
							148.38183729800005,
							-32.93453755199994
						],
						[
							148.37218479500007,
							-32.971569761999945
						],
						[
							148.38963693200003,
							-32.974128072999974
						],
						[
							148.3993581620001,
							-32.95915158399998
						],
						[
							148.4186500180001,
							-32.973555644999976
						],
						[
							148.43017076700005,
							-32.96992860599994
						],
						[
							148.44585276200007,
							-32.99218372799993
						],
						[
							148.45506763000003,
							-32.99357971899997
						],
						[
							148.46334366700012,
							-33.01343076899997
						],
						[
							148.4810612440001,
							-33.01636369099998
						],
						[
							148.49304415100005,
							-33.030226701999936
						],
						[
							148.50726191600006,
							-33.055503072999954
						],
						[
							148.49966097200002,
							-33.09992231299998
						],
						[
							148.4865725510001,
							-33.123223431999975
						],
						[
							148.50433829700012,
							-33.13418642399995
						],
						[
							148.5055265530001,
							-33.16584450399995
						],
						[
							148.49304888300003,
							-33.179692572999954
						],
						[
							148.4959009920001,
							-33.19085562299995
						],
						[
							148.47545091400002,
							-33.196155071999954
						],
						[
							148.46668569400003,
							-33.208757770999966
						],
						[
							148.42913031000012,
							-33.20127579799998
						],
						[
							148.43099490600002,
							-33.23442307799996
						],
						[
							148.39715443600005,
							-33.26998018599994
						],
						[
							148.41566189700006,
							-33.32721006799994
						],
						[
							148.40308465900011,
							-33.32892175699993
						],
						[
							148.38427989900003,
							-33.35323706499997
						],
						[
							148.41474589200004,
							-33.37028405799998
						],
						[
							148.41822938000007,
							-33.38498693799994
						],
						[
							148.4126136000001,
							-33.394654257999946
						],
						[
							148.401207601,
							-33.396584806999954
						],
						[
							148.406674059,
							-33.40526961799998
						],
						[
							148.398228151,
							-33.40105867699998
						],
						[
							148.387393921,
							-33.413674535999974
						],
						[
							148.3679372040001,
							-33.410811283999976
						],
						[
							148.36772988300004,
							-33.42087606399997
						],
						[
							148.34594069600007,
							-33.42090035299998
						],
						[
							148.34434389500007,
							-33.429483052999956
						],
						[
							148.365226892,
							-33.43531607399996
						],
						[
							148.36161291100007,
							-33.44921804399996
						],
						[
							148.3499128730001,
							-33.44368406299998
						],
						[
							148.3499769020001,
							-33.45355607299996
						],
						[
							148.333065905,
							-33.44422206199994
						],
						[
							148.32932775500012,
							-33.45591539199995
						],
						[
							148.3185618970001,
							-33.44910206099996
						],
						[
							148.3081539970001,
							-33.45791769999994
						],
						[
							148.3161006350001,
							-33.466212920999965
						],
						[
							148.307152437,
							-33.461905059999935
						],
						[
							148.30544431600003,
							-33.46884054999998
						],
						[
							148.29839327800005,
							-33.467996908999964
						],
						[
							148.29065688600008,
							-33.49189605899994
						],
						[
							148.30114377400002,
							-33.49811664999993
						],
						[
							148.30797901300002,
							-33.49405802999996
						],
						[
							148.309797042,
							-33.50017802999997
						],
						[
							148.32492041000012,
							-33.497399660999974
						],
						[
							148.32323258100007,
							-33.49113959099998
						],
						[
							148.35048781700004,
							-33.49386002399996
						],
						[
							148.35925993400008,
							-33.51240903399997
						],
						[
							148.39277773800006,
							-33.51871407699997
						],
						[
							148.40018077500008,
							-33.53504304799998
						],
						[
							148.39125542500005,
							-33.546959296999944
						],
						[
							148.42359580800007,
							-33.56518969999996
						],
						[
							148.41671912800007,
							-33.57395085999997
						],
						[
							148.414476099,
							-33.56691387899997
						],
						[
							148.39046443300003,
							-33.56764089699993
						],
						[
							148.38846160200012,
							-33.57966493699996
						],
						[
							148.41800845500006,
							-33.59615797999993
						],
						[
							148.41545363500006,
							-33.606180019999954
						],
						[
							148.4365631920001,
							-33.60397101099994
						],
						[
							148.44567515900007,
							-33.61429505199993
						],
						[
							148.47891595600004,
							-33.60100008499995
						],
						[
							148.4834613380001,
							-33.58128567499995
						],
						[
							148.51411750300008,
							-33.58123292799996
						],
						[
							148.5182520840001,
							-33.57219190799998
						],
						[
							148.53406311000003,
							-33.582308928999964
						],
						[
							148.54567722600007,
							-33.60335700999997
						],
						[
							148.55728904400007,
							-33.603957040999944
						],
						[
							148.56278988400004,
							-33.59616700199996
						],
						[
							148.56742483300002,
							-33.60108900199998
						],
						[
							148.57497657300007,
							-33.592795972999966
						],
						[
							148.6226765560001,
							-33.59252191699994
						],
						[
							148.6298484780001,
							-33.570537886999944
						],
						[
							148.65178785600006,
							-33.56009280899997
						],
						[
							148.6583123040001,
							-33.56642614899994
						],
						[
							148.65254059400002,
							-33.57708877899995
						],
						[
							148.68281960800005,
							-33.58640182199997
						],
						[
							148.71203179600002,
							-33.57371480399996
						],
						[
							148.738300986,
							-33.53813275599998
						],
						[
							148.7614234140001,
							-33.52751664799996
						],
						[
							148.78731457000004,
							-33.52904141999994
						],
						[
							148.8038658150001,
							-33.55001611199998
						],
						[
							148.81040180500008,
							-33.546473101999936
						],
						[
							148.81943482200006,
							-33.55886011299998
						],
						[
							148.8150498220001,
							-33.56722710299994
						],
						[
							148.82582881000008,
							-33.56512410299996
						],
						[
							148.82756580900002,
							-33.574116093999976
						],
						[
							148.84471781700006,
							-33.568742104999956
						],
						[
							148.8469447860001,
							-33.57896409499995
						],
						[
							148.86318980300007,
							-33.57980610699997
						],
						[
							148.8725877930001,
							-33.57332411699997
						],
						[
							148.87410779000004,
							-33.594362117999935
						],
						[
							148.88359578000006,
							-33.58196910799995
						],
						[
							148.9089057960001,
							-33.58265211099996
						],
						[
							148.9108628150001,
							-33.594290110999964
						],
						[
							148.92246079200004,
							-33.59891411199993
						],
						[
							148.9073287970001,
							-33.658261110999945
						],
						[
							148.91167580400008,
							-33.68347412099996
						],
						[
							148.9578067960001,
							-33.68830711499993
						],
						[
							148.96262979300002,
							-33.70781111599996
						],
						[
							148.99366547700004,
							-33.72059590899994
						],
						[
							148.97839376700006,
							-33.73759311699996
						],
						[
							148.97602276600003,
							-33.749848106999934
						],
						[
							148.9929337630001,
							-33.75400511899994
						],
						[
							148.97561075600004,
							-33.75170911699996
						],
						[
							148.9848347740001,
							-33.75803212799997
						],
						[
							148.98195981300012,
							-33.77227499799994
						],
						[
							148.99049968100007,
							-33.77358497899996
						],
						[
							148.98892507100004,
							-33.78108293899993
						],
						[
							149.00988650700003,
							-33.78399994999995
						],
						[
							149.00771015600003,
							-33.79489246999998
						],
						[
							149.02901575300007,
							-33.79315711199996
						],
						[
							149.0261709030001,
							-33.80335587199994
						],
						[
							149.04128873000002,
							-33.80932086299998
						],
						[
							149.06459433600003,
							-33.81237286499993
						],
						[
							149.06718101800004,
							-33.79006983499994
						],
						[
							149.09160273400005,
							-33.793674806999945
						],
						[
							149.09145289800006,
							-33.76540217699994
						],
						[
							149.10556226500012,
							-33.768609727999944
						],
						[
							149.10820358600006,
							-33.76109817899993
						],
						[
							149.1387546320001,
							-33.75987762099993
						],
						[
							149.13337957400006,
							-33.748221600999955
						],
						[
							149.14600919400004,
							-33.73202350199995
						],
						[
							149.1691347520001,
							-33.72120313399995
						],
						[
							149.2148450840001,
							-33.73262222799997
						],
						[
							149.22505135300003,
							-33.72626166799995
						],
						[
							149.2376129700001,
							-33.73974440999996
						],
						[
							149.25774873700004,
							-33.740643140999964
						],
						[
							149.24284973700003,
							-33.759800129999974
						],
						[
							149.23401373800004,
							-33.76050512899997
						],
						[
							149.21942173600007,
							-33.79235113799996
						],
						[
							149.2030527270001,
							-33.801932146999945
						],
						[
							149.1851667400001,
							-33.79769314499998
						],
						[
							149.17737873800002,
							-33.82312213499995
						],
						[
							149.18335973500007,
							-33.83885714599995
						],
						[
							149.17028974700008,
							-33.841165124999975
						],
						[
							149.183917704,
							-33.85182314599996
						],
						[
							149.18189674300004,
							-33.85819213599996
						],
						[
							149.1456297300001,
							-33.850423131999946
						],
						[
							149.13472070900002,
							-33.86883713199995
						],
						[
							149.11817158100007,
							-33.87056357999995
						],
						[
							149.11984181900004,
							-33.887815520999936
						],
						[
							149.15453979900008,
							-33.92609531399995
						],
						[
							149.1533327080001,
							-33.93628713399994
						],
						[
							149.14038272900007,
							-33.945520132999945
						],
						[
							149.16488371100002,
							-33.97794213499998
						],
						[
							149.1977437050001,
							-33.98488313799993
						],
						[
							149.20213670700002,
							-33.96948913799997
						],
						[
							149.21239170500007,
							-33.97117113899998
						],
						[
							149.21790170500003,
							-33.96359113899996
						],
						[
							149.23551441100005,
							-33.97964083099998
						],
						[
							149.23387925200007,
							-33.96764388099996
						],
						[
							149.27503233700008,
							-33.95928972399997
						],
						[
							149.27932710800007,
							-33.948509754999975
						],
						[
							149.29094392600007,
							-33.95290567599994
						],
						[
							149.299679695,
							-33.94620865599995
						],
						[
							149.3016027640001,
							-33.953614596999955
						],
						[
							149.31415358200002,
							-33.95673750799995
						],
						[
							149.34778398700007,
							-33.953286299999945
						],
						[
							149.3520711650001,
							-33.971223160999955
						],
						[
							149.36443991300007,
							-33.96915208199994
						],
						[
							149.36342109200007,
							-33.97689004199998
						],
						[
							149.37580995000008,
							-33.984363892999966
						],
						[
							149.3835767490001,
							-33.97961385399998
						],
						[
							149.38531089700007,
							-33.99097679399995
						],
						[
							149.40049668400002,
							-33.99697915499996
						],
						[
							149.40269566300003,
							-34.00603215599995
						],
						[
							149.43473867600005,
							-34.02291416799994
						],
						[
							149.4558986720001,
							-34.02960514999995
						],
						[
							149.46468867300007,
							-34.010364150999976
						],
						[
							149.50927966400002,
							-34.03687817499997
						],
						[
							149.5131626440001,
							-34.03199717499996
						],
						[
							149.5183966620001,
							-34.04152115599993
						],
						[
							149.5123996420001,
							-34.04823316499994
						],
						[
							149.53022265800007,
							-34.05398416699995
						],
						[
							149.5257526480001,
							-34.05915916699996
						],
						[
							149.54541063400006,
							-34.07114317799994
						],
						[
							149.5511776300001,
							-34.093863168999974
						],
						[
							149.55455863100008,
							-34.08828615899995
						],
						[
							149.5636166480001,
							-34.09616116999996
						],
						[
							149.5633050790001,
							-34.08746597999993
						],
						[
							149.5718558970001,
							-34.09644407099995
						],
						[
							149.57892693600002,
							-34.092696900999954
						],
						[
							149.58173268400003,
							-34.10741805199996
						],
						[
							149.58872670300002,
							-34.10551590199998
						],
						[
							149.6036788890001,
							-34.12304445399997
						],
						[
							149.62042647900012,
							-34.10558637499997
						],
						[
							149.62250562600002,
							-34.12862917499996
						],
						[
							149.62833660700005,
							-34.11340017599997
						],
						[
							149.6464946200001,
							-34.14061517799996
						],
						[
							149.64338362,
							-34.14665416699995
						],
						[
							149.65394861800007,
							-34.15022818799997
						],
						[
							149.6492045980001,
							-34.158817177999936
						],
						[
							149.65943562600012,
							-34.160377178999966
						],
						[
							149.65713462500003,
							-34.170588178999935
						],
						[
							149.66379262500004,
							-34.16429717899996
						],
						[
							149.6638186140001,
							-34.17305217899997
						],
						[
							149.67793663200007,
							-34.17271618099994
						],
						[
							149.6825295980001,
							-34.19919417099993
						],
						[
							149.69372060700005,
							-34.19214517199998
						],
						[
							149.694795386,
							-34.20279698199994
						],
						[
							149.7002356060001,
							-34.19681519299996
						],
						[
							149.7125735830001,
							-34.19853618399998
						],
						[
							149.716533614,
							-34.19021718399995
						],
						[
							149.7248745920001,
							-34.19902717499997
						],
						[
							149.72678960300004,
							-34.18957819499997
						],
						[
							149.73292759100002,
							-34.19754318599996
						],
						[
							149.74410158900002,
							-34.19422718699997
						],
						[
							149.7417255910001,
							-34.18820018599996
						],
						[
							149.75674960900005,
							-34.18669419799994
						],
						[
							149.7610505770001,
							-34.19416918799993
						],
						[
							149.76935859600007,
							-34.189890178999974
						],
						[
							149.79686660000004,
							-34.20591720099998
						],
						[
							149.84990656500008,
							-34.18368519599994
						],
						[
							149.87332559100003,
							-34.18836119799994
						],
						[
							149.88866956000004,
							-34.18039619899997
						],
						[
							149.90197859700004,
							-34.18757419999997
						],
						[
							149.93712367400008,
							-34.16918570299998
						],
						[
							149.94972781800004,
							-34.125052953999955
						],
						[
							149.93158218200006,
							-34.11629825199998
						],
						[
							149.92893567700003,
							-34.079104591999965
						],
						[
							149.94488256300008,
							-34.09163732299993
						],
						[
							149.9624048920001,
							-34.07737824499998
						],
						[
							150.00703756500002,
							-34.08516321899998
						],
						[
							150.00281458400002,
							-34.097279198999956
						],
						[
							150.01650157000006,
							-34.11229919999994
						],
						[
							150.06923355000004,
							-34.13143522499996
						],
						[
							150.08546118900006,
							-34.120550745999935
						],
						[
							150.09394243600002,
							-34.136522516999946
						],
						[
							150.10524630400005,
							-34.13848342799997
						],
						[
							150.11492526100005,
							-34.15103230899996
						],
						[
							150.12505203900002,
							-34.14916525999996
						],
						[
							150.1233850110001,
							-34.141277299999956
						],
						[
							150.11280917300007,
							-34.13945837899996
						],
						[
							150.10527499600005,
							-34.11815860799993
						],
						[
							150.11303277700006,
							-34.10292664799994
						],
						[
							150.10900559000004,
							-34.08488677799994
						],
						[
							150.11767554800008,
							-34.091980698999976
						],
						[
							150.1169703700001,
							-34.07789779899997
						],
						[
							150.1327801870001,
							-34.08214565999998
						],
						[
							150.1294571190001,
							-34.07353773999995
						],
						[
							150.145661807,
							-34.07135065099993
						],
						[
							150.14495046000002,
							-34.04362283099994
						],
						[
							150.15682417000005,
							-34.033998821999944
						],
						[
							150.16802499800008,
							-34.03551574299996
						],
						[
							150.1590800900001,
							-34.03160880199994
						],
						[
							150.1693638490001,
							-34.02725977299997
						],
						[
							150.16688382000007,
							-34.02151383299997
						],
						[
							150.20160305700006,
							-34.004891715999975
						],
						[
							150.22850538600005,
							-33.97867264799993
						],
						[
							150.2412059280001,
							-33.95201999899996
						],
						[
							150.2170281120001,
							-33.94780883699997
						],
						[
							150.2147689840001,
							-33.93634594599996
						],
						[
							150.19038055600004,
							-33.95034202399995
						],
						[
							150.17556173800006,
							-33.94516518299997
						],
						[
							150.1652064440001,
							-33.91540251199996
						],
						[
							150.16908511500003,
							-33.89896663199994
						],
						[
							150.15591325800006,
							-33.89307677099998
						],
						[
							150.18522173500003,
							-33.88038660299998
						],
						[
							150.1660586900001,
							-33.86504089199997
						],
						[
							150.17571950900003,
							-33.86123982199996
						],
						[
							150.18539095100004,
							-33.837690952999935
						],
						[
							150.1827308720001,
							-33.829865042999984
						],
						[
							150.17532301300002,
							-33.83424806199997
						],
						[
							150.16928799400011,
							-33.82702716199998
						],
						[
							150.18113640600006,
							-33.80258226199993
						],
						[
							150.16873545900012,
							-33.79511834099998
						],
						[
							150.17758934000005,
							-33.77827419199997
						],
						[
							150.1956804880001,
							-33.76662436399994
						],
						[
							150.19180518100006,
							-33.750265542999955
						],
						[
							150.1798042040001,
							-33.74315778199997
						],
						[
							150.2124204920001,
							-33.72121549499997
						],
						[
							150.1956525050001,
							-33.71285467299998
						],
						[
							150.17917384700002,
							-33.72212484199997
						],
						[
							150.18108684800006,
							-33.70439871199994
						],
						[
							150.2076263240001,
							-33.70850155399995
						],
						[
							150.21483668700012,
							-33.67482744499995
						],
						[
							150.22892053500004,
							-33.67598530599997
						],
						[
							150.2313692470001,
							-33.66299127599996
						],
						[
							150.2481511840001,
							-33.66409515699996
						],
						[
							150.2378129970001,
							-33.65120917599995
						],
						[
							150.24050976800004,
							-33.638563096999974
						],
						[
							150.26192365500003,
							-33.64165091899997
						],
						[
							150.27147511600003,
							-33.619132718999936
						],
						[
							150.258982198,
							-33.61745685799997
						],
						[
							150.26028710900005,
							-33.610701837999954
						],
						[
							150.24322420300007,
							-33.60242693699996
						],
						[
							150.22745697000005,
							-33.563519474999964
						],
						[
							150.2121859230001,
							-33.55853709399997
						],
						[
							150.2156477640001,
							-33.54796400399994
						],
						[
							150.22689564200004,
							-33.54949793499998
						],
						[
							150.22612378000008,
							-33.56050297499996
						],
						[
							150.25067954700012,
							-33.558032726999954
						],
						[
							150.2568194050001,
							-33.49429240699993
						],
						[
							150.31467390500006,
							-33.50440095199997
						],
						[
							150.31191723300003,
							-33.52013704199993
						],
						[
							150.33100703000002,
							-33.52251290399994
						],
						[
							150.33562475100007,
							-33.511934803999964
						],
						[
							150.34821754000006,
							-33.50895562499994
						],
						[
							150.35486401200012,
							-33.48575236599993
						],
						[
							150.3694459090001,
							-33.49108323699994
						],
						[
							150.38284662800004,
							-33.48763503799995
						],
						[
							150.38652041800003,
							-33.479368948999934
						],
						[
							150.3990704350001,
							-33.48947384999997
						],
						[
							150.39727528600008,
							-33.47963078999993
						],
						[
							150.40852798600008,
							-33.47326961099998
						],
						[
							150.41694010300012,
							-33.48656855099995
						],
						[
							150.44740536900008,
							-33.48141000399994
						],
						[
							150.45126006200007,
							-33.458799933999956
						],
						[
							150.46835666000004,
							-33.45405566599993
						],
						[
							150.4600227620001,
							-33.44930178499993
						],
						[
							150.479168221,
							-33.42973757699997
						],
						[
							150.4757558760001,
							-33.39897561599997
						],
						[
							150.4850397250001,
							-33.39734448699994
						],
						[
							150.4878175560001,
							-33.38675941699995
						],
						[
							150.48234357700005,
							-33.38271048699994
						],
						[
							150.52565473200002,
							-33.37567269999994
						],
						[
							150.5410933510001,
							-33.36345443199997
						],
						[
							150.5588251580001,
							-33.36617019299996
						],
						[
							150.5906265870001,
							-33.34259172599997
						],
						[
							150.58379335000006,
							-33.32192881499998
						],
						[
							150.5515287060001,
							-33.315272241999935
						],
						[
							150.56672139500006,
							-33.30629102399996
						],
						[
							150.5575083980001,
							-33.290764052999975
						],
						[
							150.5755661060001,
							-33.28960584399994
						],
						[
							150.55320833100006,
							-33.274818951999976
						],
						[
							150.56039507200012,
							-33.256905812999946
						],
						[
							150.54393423500005,
							-33.25598005099994
						],
						[
							150.52570511900012,
							-33.238953479999964
						],
						[
							150.53151792000006,
							-33.22421733999994
						],
						[
							150.54434274900007,
							-33.22094013099996
						],
						[
							150.52383369500012,
							-33.19455525899997
						],
						[
							150.55235921300005,
							-33.18371387199994
						],
						[
							150.5549429350001,
							-33.16167273199994
						],
						[
							150.56984172400007,
							-33.15588452299994
						],
						[
							150.5696968520001,
							-33.168016602999955
						],
						[
							150.5836066700001,
							-33.16811043399997
						],
						[
							150.5865754030001,
							-33.14767929399994
						],
						[
							150.6098840400001,
							-33.14334902599995
						],
						[
							150.59849988400003,
							-33.12538206499994
						],
						[
							150.61224859300012,
							-33.11888388699998
						],
						[
							150.60991156400007,
							-33.10840781599995
						],
						[
							150.61974642300004,
							-33.10999674699997
						],
						[
							150.60162063600012,
							-33.10061383499993
						],
						[
							150.6108484550001,
							-33.09885370599994
						],
						[
							150.60708347700006,
							-33.089639655999974
						],
						[
							150.61355138600004,
							-33.089174585999956
						],
						[
							150.61418017800008,
							-33.07345152599993
						],
						[
							150.60561931900008,
							-33.07393563599993
						],
						[
							150.61069311000006,
							-33.06612454599997
						],
						[
							150.6046902500001,
							-33.06996760499993
						],
						[
							150.572202596,
							-33.05889592199998
						],
						[
							150.5528828880001,
							-33.05960912099994
						],
						[
							150.54661478100002,
							-33.04291519999998
						],
						[
							150.52006808600004,
							-33.03489448799996
						],
						[
							150.49736438900004,
							-33.03508371499993
						],
						[
							150.4884536090001,
							-33.04811078499995
						],
						[
							150.46638487200005,
							-33.04660098299996
						],
						[
							150.40915233300007,
							-33.023751456999946
						],
						[
							150.3942996830001,
							-33.03939968599997
						],
						[
							150.3703377700001,
							-33.014076813999964
						],
						[
							150.37630749200002,
							-32.99021467399996
						],
						[
							150.3666114560001,
							-32.97163570299995
						],
						[
							150.3763051960001,
							-32.959148623999965
						],
						[
							150.3527341240001,
							-32.92314189199993
						],
						[
							150.347095899,
							-32.89055488099996
						],
						[
							150.33538200100008,
							-32.882071939999946
						],
						[
							150.3410308120001,
							-32.87063286999995
						],
						[
							150.3614294890001,
							-32.868092701999956
						],
						[
							150.36253227200007,
							-32.845610661999956
						],
						[
							150.33854568000004,
							-32.80895022999994
						],
						[
							150.34122569200008,
							-32.79374422999996
						],
						[
							150.28882769200004,
							-32.76529621499998
						],
						[
							150.2754247160001,
							-32.74742621299998
						],
						[
							150.32016810300001,
							-32.64790964699995
						],
						[
							150.25116186600007,
							-32.61525697999997
						],
						[
							150.22766773000012,
							-32.61233121799995
						],
						[
							150.23936872000002,
							-32.601116228999956
						],
						[
							150.25947561700002,
							-32.59770384099994
						],
						[
							150.26604835900002,
							-32.577705710999965
						],
						[
							150.23683876300004,
							-32.57402992899995
						],
						[
							150.2475434150001,
							-32.54997470999996
						],
						[
							150.24015210200002,
							-32.49818771799994
						],
						[
							150.2476058730001,
							-32.48317661899995
						],
						[
							150.23734400500007,
							-32.47977865799993
						],
						[
							150.2272519490001,
							-32.456000666999955
						],
						[
							150.2539815460001,
							-32.457987438999965
						],
						[
							150.26885624500005,
							-32.44794923099994
						],
						[
							150.28004284700012,
							-32.421821001999945
						],
						[
							150.31892275300004,
							-32.40824821499996
						],
						[
							150.31934472500006,
							-32.38820222499993
						],
						[
							150.308962747,
							-32.385937213999966
						],
						[
							150.30620673900012,
							-32.37390622399994
						],
						[
							150.28700077000008,
							-32.386876221999955
						],
						[
							150.2842717420001,
							-32.37451022199997
						],
						[
							150.27628674200002,
							-32.38144021099998
						],
						[
							150.26676674400005,
							-32.37685220999998
						],
						[
							150.2596577500001,
							-32.338558208999984
						],
						[
							150.2707767500001,
							-32.323464229999956
						],
						[
							150.2517187520001,
							-32.32502421799995
						],
						[
							150.26220177200003,
							-32.31645522899993
						],
						[
							150.2527587840001,
							-32.309829227999955
						],
						[
							150.2550017750001,
							-32.302801227999964
						],
						[
							150.24528577500007,
							-32.31297921799995
						],
						[
							150.2369297570001,
							-32.30811022699993
						],
						[
							150.2215707780001,
							-32.31480420599996
						],
						[
							150.2161767670001,
							-32.32329121499998
						],
						[
							150.20817377900005,
							-32.31881720399997
						],
						[
							150.21764676500004,
							-32.337715214999946
						],
						[
							150.19694977900008,
							-32.332579212999974
						],
						[
							150.1892877680001,
							-32.35002521299998
						],
						[
							150.1873037800001,
							-32.33343220299997
						],
						[
							150.165247775,
							-32.320017210999936
						],
						[
							150.16380675300002,
							-32.332494219999944
						],
						[
							150.15526977500008,
							-32.326994199999945
						],
						[
							150.14254978500003,
							-32.34148621899993
						],
						[
							150.13289976700003,
							-32.33693521799995
						],
						[
							150.06666877500004,
							-32.34376021199995
						],
						[
							150.06789177400003,
							-32.35606920199996
						],
						[
							150.05392078600005,
							-32.350869200999966
						],
						[
							150.0396118010001,
							-32.32823119899996
						],
						[
							150.0290227920001,
							-32.333126198999935
						],
						[
							150.03205878300002,
							-32.31549120899996
						],
						[
							150.02172877600003,
							-32.304247197999985
						],
						[
							150.02797578700006,
							-32.29151420799997
						],
						[
							150.03559479500007,
							-32.29514619899993
						],
						[
							150.032906797,
							-32.28819019899993
						],
						[
							150.04302981600006,
							-32.284194198999955
						],
						[
							150.0421377890001,
							-32.261406198999964
						],
						[
							150.05318579800007,
							-32.258429199999966
						],
						[
							150.04409379100002,
							-32.24417118899993
						],
						[
							150.05823078800006,
							-32.25099719099995
						],
						[
							150.06299578800008,
							-32.24582321099996
						],
						[
							150.05530181000006,
							-32.239083189999974
						],
						[
							150.0602727800001,
							-32.22724219099996
						],
						[
							150.04794666300006,
							-32.22148336899994
						],
						[
							150.07024181400004,
							-32.18849021099993
						],
						[
							150.06301780500007,
							-32.18408318999997
						],
						[
							150.0600787950001,
							-32.19311118999997
						],
						[
							150.05329282600007,
							-32.18814919999994
						],
						[
							150.04504980700005,
							-32.19353820899994
						],
						[
							150.0366548080001,
							-32.18901819799993
						],
						[
							150.03649081700007,
							-32.20163619799996
						],
						[
							150.02776913700006,
							-32.205971406999936
						],
						[
							150.03480921800008,
							-32.195891717999984
						],
						[
							150.02691375900008,
							-32.19485146699998
						],
						[
							150.023082401,
							-32.18361941699993
						],
						[
							150.01398784200012,
							-32.18658520599996
						],
						[
							150.00946541500002,
							-32.16264642599998
						],
						[
							150.0011307860001,
							-32.16157120499997
						],
						[
							149.9851478380001,
							-32.17057219299994
						],
						[
							149.98262733600006,
							-32.18470869299995
						],
						[
							149.96076029900007,
							-32.18186351099996
						],
						[
							149.96463364200008,
							-32.16014072199994
						],
						[
							149.93934845500007,
							-32.15702853899995
						],
						[
							149.9481017070001,
							-32.13493670999998
						],
						[
							149.92075182000008,
							-32.13750918799997
						],
						[
							149.93232283100008,
							-32.11921918799993
						],
						[
							149.89335784600007,
							-32.119699184999945
						],
						[
							149.89351585800011,
							-32.10514919499997
						],
						[
							149.89227284700007,
							-32.11265719499994
						],
						[
							149.84985255300012,
							-32.109154230999934
						],
						[
							149.84519453300004,
							-32.116957130999936
						],
						[
							149.84596472400005,
							-32.106066950999946
						],
						[
							149.81943586800003,
							-32.103611187999945
						],
						[
							149.81249587000002,
							-32.09064418799994
						],
						[
							149.7952438530001,
							-32.092708175999974
						],
						[
							149.79567046700004,
							-32.058077165999975
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "107",
				"CED_NAME21": "Calare",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 32648.0514,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/107",
				"SHAPE_Leng": 14.6546341909,
				"SHAPE_Area": 3.15321141979
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							150.8969430940001,
							-33.79793218699996
						],
						[
							150.90634407700009,
							-33.76564317799995
						],
						[
							150.9001475110001,
							-33.741093286999956
						],
						[
							150.87603649800008,
							-33.71213628499993
						],
						[
							150.85104751000006,
							-33.650125281999976
						],
						[
							150.81811637300007,
							-33.66168527899998
						],
						[
							150.81306645300003,
							-33.66926565899996
						],
						[
							150.8191145710001,
							-33.67577626899998
						],
						[
							150.81239963200005,
							-33.67760118899997
						],
						[
							150.80054184400012,
							-33.67458349799995
						],
						[
							150.77879189300006,
							-33.702138875999935
						],
						[
							150.7661094650001,
							-33.70549838499994
						],
						[
							150.75967578300003,
							-33.72960488399997
						],
						[
							150.7841315080001,
							-33.74111232699994
						],
						[
							150.8033866400001,
							-33.77679860899997
						],
						[
							150.8969430940001,
							-33.79793218699996
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "108",
				"CED_NAME21": "Chifley",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 125.8036,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/108",
				"SHAPE_Leng": 0.524926611504,
				"SHAPE_Area": 0.0122384614984
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								151.07712039400008,
								-34.05397834599995
							],
							[
								151.09218843100007,
								-34.057648306999965
							],
							[
								151.096983442,
								-34.047040307999964
							],
							[
								151.1015504300001,
								-34.05907130799994
							],
							[
								151.10512242200002,
								-34.04211329799995
							],
							[
								151.11211944000001,
								-34.04313131899994
							],
							[
								151.10596640900008,
								-34.05942629899994
							],
							[
								151.11440641800004,
								-34.05941630899997
							],
							[
								151.11159543700012,
								-34.07241130899996
							],
							[
								151.1296634140001,
								-34.06928531099993
							],
							[
								151.1339394260001,
								-34.055537310999966
							],
							[
								151.1403464120001,
								-34.07378131199994
							],
							[
								151.14891143400007,
								-34.05456831299995
							],
							[
								151.1474214310001,
								-34.073353312999984
							],
							[
								151.1535014100001,
								-34.07311930299994
							],
							[
								151.1653734030001,
								-34.04081932399998
							],
							[
								151.1859234110001,
								-34.03455032599993
							],
							[
								151.2145253960001,
								-34.041917318999936
							],
							[
								151.23193140700005,
								-34.016726319999975
							],
							[
								151.22188942000002,
								-34.00120530899994
							],
							[
								151.2114064010001,
								-34.00787931799994
							],
							[
								151.186756424,
								-34.007517305999954
							],
							[
								151.20643543100005,
								-34.014032327999985
							],
							[
								151.1963234310001,
								-34.02121531699993
							],
							[
								151.1595634460001,
								-34.02324532299997
							],
							[
								151.15832043800003,
								-34.01449831299993
							],
							[
								151.17862940500004,
								-34.01283032499998
							],
							[
								151.16212443900008,
								-34.00001531299995
							],
							[
								151.15739834800002,
								-34.01320527299998
							],
							[
								151.14178945000003,
								-34.014433321999945
							],
							[
								151.1611905850001,
								-34.028224302999945
							],
							[
								151.14774639600012,
								-34.03878228199994
							],
							[
								151.13367542900005,
								-34.03306430099997
							],
							[
								151.12696249300006,
								-34.00988633999998
							],
							[
								151.11040441300008,
								-34.02373630899996
							],
							[
								151.1078636850001,
								-34.01435162799993
							],
							[
								151.1172514540001,
								-34.01394131899997
							],
							[
								151.11582339500012,
								-34.007201288999966
							],
							[
								151.0976984770001,
								-34.005833276999965
							],
							[
								151.09771249900007,
								-33.99761132699996
							],
							[
								151.08818832800011,
								-34.01157033699997
							],
							[
								151.07712039400008,
								-34.05397834599995
							]
						]
					],
					[
						[
							[
								151.09220950000008,
								-33.99091478699995
							],
							[
								151.103252579,
								-33.98913135799995
							],
							[
								151.10226944700003,
								-34.00072348799995
							],
							[
								151.1137055160001,
								-33.99621929899996
							],
							[
								151.11518544600005,
								-34.00140733899997
							],
							[
								151.12987742600012,
								-33.98358530999997
							],
							[
								151.1216084250001,
								-34.00096729999996
							],
							[
								151.1396132420001,
								-34.003367270999945
							],
							[
								151.149477412,
								-33.99418731199995
							],
							[
								151.1548474340001,
								-33.96665632199995
							],
							[
								151.13713249700004,
								-33.96429594099993
							],
							[
								151.12967656700005,
								-33.97361798999998
							],
							[
								151.09220950000008,
								-33.99091478699995
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "109",
				"CED_NAME21": "Cook",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 64.4127,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/109",
				"SHAPE_Leng": 1.33630836007,
				"SHAPE_Area": 0.00628720756566
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							152.9152015100001,
							-31.492801464999957
						],
						[
							152.93845493000003,
							-31.472914816999946
						],
						[
							152.9334067640001,
							-31.447586875999946
						],
						[
							152.91475286000002,
							-31.423716973999944
						],
						[
							152.9178515630001,
							-31.398790923999968
						],
						[
							152.94416660600007,
							-31.351360736999936
						],
						[
							152.9764237070001,
							-31.314128509999932
						],
						[
							152.96454284900005,
							-31.30632757799998
						],
						[
							152.9711653060001,
							-31.252593478999984
						],
						[
							152.96020238800008,
							-31.24203851699997
						],
						[
							152.96647692200008,
							-31.212956447999943
						],
						[
							152.98424829300006,
							-31.18664230899998
						],
						[
							152.97639539400006,
							-31.184014368999954
						],
						[
							152.9773652760001,
							-31.171419338999954
						],
						[
							153.00664021900002,
							-31.123395080999956
						],
						[
							153.0557279290001,
							-31.07862366599994
						],
						[
							153.066387361,
							-31.04744356699996
						],
						[
							153.05439463200003,
							-31.053693634999945
						],
						[
							153.04204755500007,
							-31.043404473999942
						],
						[
							153.03976255100008,
							-30.999125483999933
						],
						[
							153.05734559500002,
							-30.958394474999977
						],
						[
							153.0907195860001,
							-30.921550467999964
						],
						[
							153.07601750300012,
							-30.87819653599996
						],
						[
							153.06637559500007,
							-30.87506448499994
						],
						[
							153.06905359400002,
							-30.881763485999954
						],
						[
							153.06029458400008,
							-30.88667447499995
						],
						[
							153.03718957700005,
							-30.88246947199997
						],
						[
							153.015337573,
							-30.86341946999994
						],
						[
							153.0042065780001,
							-30.83493146899997
						],
						[
							152.9971946060001,
							-30.78494545799998
						],
						[
							153.0016876200001,
							-30.74874647799993
						],
						[
							152.99115660200005,
							-30.741460466999968
						],
						[
							152.9882896050001,
							-30.727071465999984
						],
						[
							152.9974966200001,
							-30.678901466999946
						],
						[
							153.0203676310001,
							-30.647570478999967
						],
						[
							153.010119647,
							-30.615452477999952
						],
						[
							153.0126286210001,
							-30.579840477999937
						],
						[
							153.02959561400007,
							-30.546951468999964
						],
						[
							153.02509363600007,
							-30.53310246899997
						],
						[
							153.04119565200006,
							-30.474938469999984
						],
						[
							153.07632464300002,
							-30.431877482999937
						],
						[
							153.07581265600004,
							-30.410580462999974
						],
						[
							153.10452165700008,
							-30.376984464999964
						],
						[
							153.11345701100004,
							-30.340604535999944
						],
						[
							153.1360883220001,
							-30.31592251799998
						],
						[
							153.15293497000005,
							-30.30947944999997
						],
						[
							153.14023618200008,
							-30.31006451899998
						],
						[
							153.14250710200008,
							-30.30308951899997
						],
						[
							153.15457787100001,
							-30.30513548999994
						],
						[
							153.1390311440001,
							-30.29657255799998
						],
						[
							153.147843845,
							-30.277590518999943
						],
						[
							153.1382639080001,
							-30.26253958799998
						],
						[
							153.14835755000001,
							-30.241808598999967
						],
						[
							153.14157465200003,
							-30.232417477999945
						],
						[
							153.09227965700006,
							-30.239122462999944
						],
						[
							153.082538676,
							-30.258342461999973
						],
						[
							153.084889674,
							-30.27265747299998
						],
						[
							153.0608724540001,
							-30.287772879999977
						],
						[
							153.04626468700008,
							-30.27887046899997
						],
						[
							153.04647704800004,
							-30.271932968999977
						],
						[
							153.02064768200012,
							-30.26905246599995
						],
						[
							153.01070183600007,
							-30.248762454999962
						],
						[
							152.99494573800007,
							-30.246747382999956
						],
						[
							152.99908586100003,
							-30.22139148399998
						],
						[
							152.98726610200004,
							-30.22227559199996
						],
						[
							152.985747843,
							-30.214117691999945
						],
						[
							152.96693640500007,
							-30.22257179999997
						],
						[
							152.95215770700008,
							-30.215494458999956
						],
						[
							152.93779385900007,
							-30.21702009699993
						],
						[
							152.92761608900003,
							-30.22718615699995
						],
						[
							152.8899376930001,
							-30.22748846299993
						],
						[
							152.87356167600012,
							-30.220551460999957
						],
						[
							152.8684406980001,
							-30.21020244999994
						],
						[
							152.8295452010001,
							-30.222065536999935
						],
						[
							152.8328632020001,
							-30.216948636999973
						],
						[
							152.81744885400008,
							-30.21334107499996
						],
						[
							152.80345891900004,
							-30.189554243999964
						],
						[
							152.7679415340001,
							-30.18242947999994
						],
						[
							152.75518971600002,
							-30.18077651899995
						],
						[
							152.75076887400007,
							-30.196603548999974
						],
						[
							152.69299281200006,
							-30.189002742999946
						],
						[
							152.70745666800008,
							-30.204232683999976
						],
						[
							152.69399396900008,
							-30.211109782999984
						],
						[
							152.69775499700006,
							-30.223593783999945
						],
						[
							152.65538170800005,
							-30.25530360999994
						],
						[
							152.64898617900008,
							-30.252401128999963
						],
						[
							152.6465749890001,
							-30.258185968999953
						],
						[
							152.6382973410001,
							-30.25124306799995
						],
						[
							152.62689354100007,
							-30.259966316999964
						],
						[
							152.61623776200008,
							-30.258137105999936
						],
						[
							152.61123095400012,
							-30.249248154999975
						],
						[
							152.6030180150001,
							-30.25247372399997
						],
						[
							152.58653231800008,
							-30.240873292999936
						],
						[
							152.57388561900007,
							-30.244507391999946
						],
						[
							152.56123366200006,
							-30.233626449999974
						],
						[
							152.56493166100006,
							-30.239288430999977
						],
						[
							152.5512969,
							-30.257760348999966
						],
						[
							152.55727990900004,
							-30.26228753999993
						],
						[
							152.55022821800003,
							-30.277679588999945
						],
						[
							152.55500938700004,
							-30.28091455999993
						],
						[
							152.54378464700005,
							-30.29265064899994
						],
						[
							152.5329548080001,
							-30.29276669799998
						],
						[
							152.525934107,
							-30.31158970699994
						],
						[
							152.50630947800005,
							-30.320539794999945
						],
						[
							152.4933618670001,
							-30.33685287399993
						],
						[
							152.48048306900012,
							-30.33247995299996
						],
						[
							152.474917397,
							-30.35662399299997
						],
						[
							152.47767369200005,
							-30.389820962999977
						],
						[
							152.4846375610001,
							-30.39078193399996
						],
						[
							152.47859075100007,
							-30.396980912999936
						],
						[
							152.43806148600004,
							-30.400233148999973
						],
						[
							152.428083914,
							-30.418884197999944
						],
						[
							152.41721129300004,
							-30.436811217999946
						],
						[
							152.40181052600008,
							-30.434996325999975
						],
						[
							152.39205579600002,
							-30.44290435499994
						],
						[
							152.39324222100004,
							-30.476402234999966
						],
						[
							152.40842905800002,
							-30.489248046999933
						],
						[
							152.4002583570001,
							-30.50092905599996
						],
						[
							152.38581260800004,
							-30.50518112499998
						],
						[
							152.38671688500006,
							-30.52917499499995
						],
						[
							152.3640854260001,
							-30.545042072999934
						],
						[
							152.3616545650001,
							-30.55578706299997
						],
						[
							152.33581424600004,
							-30.56702538099995
						],
						[
							152.32991664500003,
							-30.584210309999946
						],
						[
							152.3117281850001,
							-30.600178287999938
						],
						[
							152.3334431300001,
							-30.620557910999935
						],
						[
							152.3368812770001,
							-30.640458730999967
						],
						[
							152.34519411600002,
							-30.639851651999948
						],
						[
							152.3692970300001,
							-30.658892334999962
						],
						[
							152.35799742900008,
							-30.678431273999934
						],
						[
							152.36933257500004,
							-30.698675124999966
						],
						[
							152.375396098,
							-30.744651015999978
						],
						[
							152.35196159800012,
							-30.769142993999935
						],
						[
							152.35500365600012,
							-30.778107003999935
						],
						[
							152.34386293600005,
							-30.791888022999956
						],
						[
							152.31703631900007,
							-30.79262412999998
						],
						[
							152.31715942800008,
							-30.802486149999936
						],
						[
							152.2867870880001,
							-30.82985632799995
						],
						[
							152.2845452570001,
							-30.84149334799997
						],
						[
							152.29949025200006,
							-30.866219298999965
						],
						[
							152.28724876900003,
							-30.899957357999938
						],
						[
							152.29601628400007,
							-30.930784348999964
						],
						[
							152.2843114630001,
							-30.94911248799997
						],
						[
							152.2941465990001,
							-30.973069489999943
						],
						[
							152.26983033800002,
							-30.99913470699994
						],
						[
							152.2765233760001,
							-31.009497687999954
						],
						[
							152.2925610740001,
							-31.01145361999994
						],
						[
							152.3152728990001,
							-31.027837501999954
						],
						[
							152.3243977180001,
							-31.024844422999934
						],
						[
							152.34335566400011,
							-31.039932394999937
						],
						[
							152.3451758120001,
							-31.05060541499995
						],
						[
							152.33105702300008,
							-31.057261533999963
						],
						[
							152.34064006000006,
							-31.06819745499996
						],
						[
							152.3342242000001,
							-31.07570253399996
						],
						[
							152.3365562560001,
							-31.105216404999965
						],
						[
							152.34815526400007,
							-31.10921132599998
						],
						[
							152.34959230300012,
							-31.11699129599998
						],
						[
							152.368281098,
							-31.136461087999976
						],
						[
							152.3691866250001,
							-31.156085407999967
						],
						[
							152.3864616310001,
							-31.166733419999957
						],
						[
							152.45583761400007,
							-31.15581842699993
						],
						[
							152.47077162100004,
							-31.16627641799994
						],
						[
							152.5196766140001,
							-31.167123432999972
						],
						[
							152.53970259200003,
							-31.16287342499993
						],
						[
							152.5411676340001,
							-31.15202142499993
						],
						[
							152.55623563200004,
							-31.148175416999948
						],
						[
							152.5616556340001,
							-31.129540426999938
						],
						[
							152.5961526200001,
							-31.12376942999998
						],
						[
							152.6322496140001,
							-31.138540443999943
						],
						[
							152.64966161000007,
							-31.15451942599998
						],
						[
							152.65778657900012,
							-31.149213446999966
						],
						[
							152.67377561700005,
							-31.153514437999945
						],
						[
							152.68116058700002,
							-31.14082543899997
						],
						[
							152.69288460600012,
							-31.141066439999975
						],
						[
							152.70694860300011,
							-31.15149944099994
						],
						[
							152.70596159900003,
							-31.180708481999943
						],
						[
							152.7279651870001,
							-31.176265323999928
						],
						[
							152.72620136600005,
							-31.185216303999937
						],
						[
							152.75166007100006,
							-31.194700075999947
						],
						[
							152.7464044290001,
							-31.216447045999928
						],
						[
							152.73052259100007,
							-31.215682433999973
						],
						[
							152.72285259300008,
							-31.205397432999973
						],
						[
							152.70473260500012,
							-31.20777744199995
						],
						[
							152.68966259500007,
							-31.22862933999994
						],
						[
							152.67969857600008,
							-31.22719042899996
						],
						[
							152.6741725830001,
							-31.253853448999962
						],
						[
							152.6915276000001,
							-31.26418444099994
						],
						[
							152.71207256200012,
							-31.30122344299997
						],
						[
							152.73536656700003,
							-31.31881744599997
						],
						[
							152.73227559600002,
							-31.325757434999957
						],
						[
							152.74825756400003,
							-31.323963436999975
						],
						[
							152.73490155500008,
							-31.332866455999977
						],
						[
							152.73667957400005,
							-31.340128445999937
						],
						[
							152.75776654000003,
							-31.347590457999956
						],
						[
							152.7659114700001,
							-31.338446698999974
						],
						[
							152.78594456700012,
							-31.343081450999932
						],
						[
							152.79395332400009,
							-31.354999561999932
						],
						[
							152.82542025200007,
							-31.415478374999964
						],
						[
							152.81498555500002,
							-31.476768454999956
						],
						[
							152.85852624900008,
							-31.47965323899996
						],
						[
							152.8625454060001,
							-31.502235219999932
						],
						[
							152.87435151600005,
							-31.488109510999948
						],
						[
							152.86683251800002,
							-31.481119449999937
						],
						[
							152.87610395700005,
							-31.47829387099995
						],
						[
							152.89516107500003,
							-31.478552342999933
						],
						[
							152.9032975120001,
							-31.492057473999978
						],
						[
							152.9152015100001,
							-31.492801464999957
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "110",
				"CED_NAME21": "Cowper",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 7286.0543,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/110",
				"SHAPE_Leng": 5.63013478862,
				"SHAPE_Area": 0.686438597194
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							150.89778561000003,
							-34.50071061199998
						],
						[
							150.92196341700003,
							-34.49374229499995
						],
						[
							150.91364938300012,
							-34.46478730399997
						],
						[
							150.90794140200012,
							-34.475499302999935
						],
						[
							150.88408989800007,
							-34.45769312099998
						],
						[
							150.89490141700003,
							-34.45101924199997
						],
						[
							150.8987624550001,
							-34.46200626199993
						],
						[
							150.90981542300005,
							-34.46475030299996
						],
						[
							150.90108440500012,
							-34.459305281999946
						],
						[
							150.9108514090001,
							-34.42129430299997
						],
						[
							150.9020903920001,
							-34.407683291999945
						],
						[
							150.93130539300012,
							-34.368739294999955
						],
						[
							150.91942139600008,
							-34.35858429299998
						],
						[
							150.93029142800003,
							-34.33108929399998
						],
						[
							150.92639542000006,
							-34.31941230399997
						],
						[
							150.9878364230001,
							-34.23272429899998
						],
						[
							151.06616377000012,
							-34.17231657599996
						],
						[
							151.01592842800005,
							-34.16642730099994
						],
						[
							151.02213642800007,
							-34.15570029099996
						],
						[
							150.97987742700002,
							-34.13839729699998
						],
						[
							150.92258542600007,
							-34.12999929199998
						],
						[
							150.8993604420001,
							-34.18960029999994
						],
						[
							150.85953142800008,
							-34.18103528699993
						],
						[
							150.85748742700002,
							-34.19275827699994
						],
						[
							150.89052244000004,
							-34.214063289999956
						],
						[
							150.89793342600012,
							-34.23192530099993
						],
						[
							150.8808193850001,
							-34.25851784899993
						],
						[
							150.85280103600007,
							-34.279939216999935
						],
						[
							150.805194894,
							-34.27132694199997
						],
						[
							150.81676582800003,
							-34.30636272399994
						],
						[
							150.75086617800002,
							-34.301913526999954
						],
						[
							150.74568241400004,
							-34.33740338699994
						],
						[
							150.70794276000004,
							-34.40761710399994
						],
						[
							150.75356041300006,
							-34.414239288999966
						],
						[
							150.75192141000002,
							-34.43416526799996
						],
						[
							150.7652254080001,
							-34.43537128999998
						],
						[
							150.76404240700003,
							-34.44696626999996
						],
						[
							150.78523616300004,
							-34.44936568199995
						],
						[
							150.79224442300006,
							-34.442817281999965
						],
						[
							150.8059174990001,
							-34.46118337399997
						],
						[
							150.82977995500005,
							-34.46368909599994
						],
						[
							150.85643221300006,
							-34.453435937999984
						],
						[
							150.87534840800004,
							-34.46663027999995
						],
						[
							150.863244387,
							-34.48830928899997
						],
						[
							150.8866102930001,
							-34.491582250999954
						],
						[
							150.88606662200004,
							-34.49804830099998
						],
						[
							150.89778561000003,
							-34.50071061199998
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "111",
				"CED_NAME21": "Cunningham",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 490.4266,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/111",
				"SHAPE_Leng": 1.79487557141,
				"SHAPE_Area": 0.0480333978646
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								151.449195765,
								-33.429649575999974
							],
							[
								151.4850084740001,
								-33.39861633899994
							],
							[
								151.48737148700002,
								-33.37453033899993
							],
							[
								151.50444844600008,
								-33.36249835099994
							],
							[
								151.50496046700005,
								-33.35272933099998
							],
							[
								151.4937424210001,
								-33.33649232999994
							],
							[
								151.4740965100001,
								-33.365844297999956
							],
							[
								151.44886158500003,
								-33.35466934599998
							],
							[
								151.4390573280001,
								-33.341647344999956
							],
							[
								151.44180055900006,
								-33.32990532499997
							],
							[
								151.46858636600007,
								-33.32848429699993
							],
							[
								151.44984150900007,
								-33.320517335999966
							],
							[
								151.44119141200008,
								-33.30793335499993
							],
							[
								151.45198241200012,
								-33.29874532599996
							],
							[
								151.4650115600001,
								-33.30192333699995
							],
							[
								151.47509622100006,
								-33.28242318799994
							],
							[
								151.48807853900007,
								-33.28060332899997
							],
							[
								151.4945833910001,
								-33.26378330899996
							],
							[
								151.5190425080001,
								-33.26165437199995
							],
							[
								151.5069303130001,
								-33.231815309999945
							],
							[
								151.5132508040001,
								-33.220773830999974
							],
							[
								151.50757195500012,
								-33.21801280999995
							],
							[
								151.51636403500004,
								-33.205778040999974
							],
							[
								151.48825075900004,
								-33.20843680799993
							],
							[
								151.48860751200004,
								-33.18813033799995
							],
							[
								151.4551202240001,
								-33.202830354999946
							],
							[
								151.44324892600002,
								-33.20101696399996
							],
							[
								151.44470520700008,
								-33.193343023999944
							],
							[
								151.43146533800007,
								-33.199294262999956
							],
							[
								151.4331752180001,
								-33.19419625299997
							],
							[
								151.4109626720001,
								-33.19412840099994
							],
							[
								151.41107458200008,
								-33.18744840099998
							],
							[
								151.39863078400003,
								-33.18573447999995
							],
							[
								151.40406151500008,
								-33.17358643999995
							],
							[
								151.38999791800006,
								-33.16990859899994
							],
							[
								151.39749250700004,
								-33.16501458999994
							],
							[
								151.3830564330001,
								-33.139753567999946
							],
							[
								151.378945519,
								-33.09969832699994
							],
							[
								151.35662149300003,
								-33.09003233499993
							],
							[
								151.35710651400007,
								-33.08179631499996
							],
							[
								151.30519954600004,
								-33.04376532999993
							],
							[
								151.29591751600003,
								-33.05487331899997
							],
							[
								151.26644126000008,
								-33.057584445999964
							],
							[
								151.26173351500006,
								-33.09892932599996
							],
							[
								151.23251953800002,
								-33.10847632399998
							],
							[
								151.2026315180001,
								-33.13884731099995
							],
							[
								151.20906598500005,
								-33.153367421999974
							],
							[
								151.20148658400012,
								-33.16749156099996
							],
							[
								151.20923666200008,
								-33.17897924199997
							],
							[
								151.19926139000006,
								-33.20062641099997
							],
							[
								151.21295892600006,
								-33.21892772299998
							],
							[
								151.2235355240001,
								-33.21904932399997
							],
							[
								151.21673897100004,
								-33.24834845299995
							],
							[
								151.2288960200001,
								-33.24998093399995
							],
							[
								151.22611019800001,
								-33.26409895399996
							],
							[
								151.23904706500002,
								-33.27132384499998
							],
							[
								151.2363382540001,
								-33.28536788499997
							],
							[
								151.26656689800006,
								-33.29661960799996
							],
							[
								151.2638770970001,
								-33.31058266799994
							],
							[
								151.2812667940001,
								-33.312992529999974
							],
							[
								151.27995388300008,
								-33.31992055999996
							],
							[
								151.30013156000007,
								-33.319895420999956
							],
							[
								151.30013465800005,
								-33.34030845199993
							],
							[
								151.29312741900003,
								-33.339269360999936
							],
							[
								151.29093606800006,
								-33.35016295099996
							],
							[
								151.30906963300004,
								-33.36405050299993
							],
							[
								151.3766436830001,
								-33.37127898899996
							],
							[
								151.37101735200008,
								-33.38156963899996
							],
							[
								151.35548302400002,
								-33.38253533699998
							],
							[
								151.34322533400007,
								-33.39583598599995
							],
							[
								151.34923820200004,
								-33.40599595699996
							],
							[
								151.34432647200003,
								-33.412400325999954
							],
							[
								151.39460046300007,
								-33.42769132099994
							],
							[
								151.43841147700005,
								-33.422129094999946
							],
							[
								151.449195765,
								-33.429649575999974
							]
						]
					],
					[
						[
							[
								151.56258609400004,
								-33.24603382599997
							],
							[
								151.55751748300008,
								-33.25209932499996
							],
							[
								151.55324432500004,
								-33.24417932499995
							],
							[
								151.53703135500007,
								-33.26248037299996
							],
							[
								151.52049261700006,
								-33.26254833199994
							],
							[
								151.5373445140001,
								-33.26694933299996
							],
							[
								151.5456425320001,
								-33.27773331399993
							],
							[
								151.50281333100008,
								-33.32689536099997
							],
							[
								151.5019245090001,
								-33.343916340999954
							],
							[
								151.52589548900005,
								-33.31449435299993
							],
							[
								151.57903042600003,
								-33.28221434799997
							],
							[
								151.56359648000011,
								-33.27171434599995
							],
							[
								151.56509046300005,
								-33.247313335999934
							],
							[
								151.56258609400004,
								-33.24603382599997
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "112",
				"CED_NAME21": "Dobell",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 715.1442,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/112",
				"SHAPE_Leng": 2.1413056898,
				"SHAPE_Area": 0.0691877185839
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								150.13446429500004,
								-36.06600223399994
							],
							[
								150.12305530700007,
								-36.06459024299994
							],
							[
								150.1300142870001,
								-36.05603123299994
							],
							[
								150.11535133100006,
								-36.046031221999954
							],
							[
								150.12109329100008,
								-36.03871124199998
							],
							[
								150.11561731200004,
								-36.03255423199994
							],
							[
								150.08944330600002,
								-36.033313229999976
							],
							[
								150.09690660400008,
								-36.04378161999995
							],
							[
								150.08181831500008,
								-36.05173523899998
							],
							[
								150.0772882970001,
								-36.044946238999955
							],
							[
								150.0142733980001,
								-36.03578018299993
							],
							[
								149.966670689,
								-36.01047657799995
							],
							[
								149.96643928100002,
								-35.992082437999954
							],
							[
								149.98056898000004,
								-35.98793926999997
							],
							[
								149.98514363100003,
								-35.97618012999993
							],
							[
								149.97084866400007,
								-35.966117148999956
							],
							[
								149.98368250200008,
								-35.96781108999994
							],
							[
								149.9964321010001,
								-35.95647292099994
							],
							[
								149.98715223300007,
								-35.95520699999997
							],
							[
								149.9918530330001,
								-35.94846292999995
							],
							[
								149.96560832800003,
								-35.94477904799993
							],
							[
								149.9698825910001,
								-35.91947200799996
							],
							[
								149.9797329600001,
								-35.91175143899994
							],
							[
								149.95900632400003,
								-35.90641021699997
							],
							[
								149.960361357,
								-35.880052226999965
							],
							[
								149.9485493410001,
								-35.863302215999965
							],
							[
								149.93228037400002,
								-35.86148621399997
							],
							[
								149.91515236100008,
								-35.83119522299995
							],
							[
								149.90162236300012,
								-35.83010721199997
							],
							[
								149.88694538800007,
								-35.80787220999997
							],
							[
								149.8595763730001,
								-35.805646217999936
							],
							[
								149.86001036400012,
								-35.793233217999955
							],
							[
								149.81219639500011,
								-35.769751192999934
							],
							[
								149.82019938500002,
								-35.757411203999936
							],
							[
								149.82649541400008,
								-35.75984321399994
							],
							[
								149.81712838600004,
								-35.75386626399995
							],
							[
								149.81449823900005,
								-35.736133122999945
							],
							[
								149.82983385900002,
								-35.721397973999956
							],
							[
								149.83955172700007,
								-35.72369099499997
							],
							[
								149.84014462800008,
								-35.71497088499996
							],
							[
								149.85416230500005,
								-35.72012679699998
							],
							[
								149.86262088500007,
								-35.71379369699997
							],
							[
								149.9084042280001,
								-35.637005950999935
							],
							[
								149.92183476600007,
								-35.63469989199996
							],
							[
								149.92207847800012,
								-35.61829892199995
							],
							[
								149.9351169370001,
								-35.61086473299997
							],
							[
								149.93007589400008,
								-35.56498210199993
							],
							[
								149.94597021100003,
								-35.56570166399996
							],
							[
								149.94285549300002,
								-35.553296512999964
							],
							[
								149.95676122300006,
								-35.54361936399994
							],
							[
								149.94913031400006,
								-35.54046252399996
							],
							[
								149.94932796600006,
								-35.529419433999976
							],
							[
								149.95743983400007,
								-35.53071740399997
							],
							[
								149.96405053700005,
								-35.500774304999936
							],
							[
								149.9790344050001,
								-35.50244321599996
							],
							[
								149.97740540600012,
								-35.490234215999976
							],
							[
								150.00206356500007,
								-35.47530197799995
							],
							[
								150.00538323800004,
								-35.44455994799995
							],
							[
								150.01409206800008,
								-35.43813290899993
							],
							[
								150.0073031400001,
								-35.429044947999955
							],
							[
								150.02088885000012,
								-35.41225685899997
							],
							[
								150.0384555280001,
								-35.40571776099995
							],
							[
								150.03701940400003,
								-35.36740721999996
							],
							[
								150.04672676500002,
								-35.34738384099995
							],
							[
								150.03804571800003,
								-35.33162188999995
							],
							[
								150.04466849900007,
								-35.31781394099994
							],
							[
								150.05105832900006,
								-35.309052950999956
							],
							[
								150.08537267400004,
								-35.305250703999945
							],
							[
								150.08604941600004,
								-35.29107822399993
							],
							[
								150.09803941400003,
								-35.29311621499994
							],
							[
								150.10541040400005,
								-35.28469922599993
							],
							[
								150.11660605100008,
								-35.29344644699995
							],
							[
								150.1379604110001,
								-35.27325223899993
							],
							[
								150.15192617900004,
								-35.266771209999945
							],
							[
								150.16437494700006,
								-35.26976512099998
							],
							[
								150.16868855000007,
								-35.239239140999985
							],
							[
								150.19793398700006,
								-35.22946194399998
							],
							[
								150.19498989900012,
								-35.21920297299994
							],
							[
								150.18744506000007,
								-35.220094022999945
							],
							[
								150.18632294300005,
								-35.199828052999976
							],
							[
								150.2150635480001,
								-35.203987834999964
							],
							[
								150.20392740400007,
								-35.17068722399995
							],
							[
								150.17580339900007,
								-35.165414220999935
							],
							[
								150.16975889200012,
								-35.14839994099998
							],
							[
								150.1416483470001,
								-35.14444718799996
							],
							[
								150.12940906500012,
								-35.09707016699997
							],
							[
								150.10588230000008,
								-35.08603432499996
							],
							[
								150.10793809200004,
								-35.072138234999954
							],
							[
								150.08908132500005,
								-35.06780840299996
							],
							[
								150.08765223700004,
								-35.05927139299996
							],
							[
								150.07245733000002,
								-35.050900490999936
							],
							[
								150.07609320000006,
								-35.042552401999956
							],
							[
								150.06159336300004,
								-35.03682651999998
							],
							[
								150.0646931650001,
								-35.02266845099996
							],
							[
								150.05291530700003,
								-35.01861156899997
							],
							[
								150.05191546900005,
								-35.00726322899993
							],
							[
								150.04308243100002,
								-34.99950722799997
							],
							[
								150.0241344430001,
								-35.003454216999955
							],
							[
								150.02856845600002,
								-35.054153207999946
							],
							[
								149.99680746800004,
								-35.075748224999984
							],
							[
								149.97738944200012,
								-35.066114212999935
							],
							[
								149.98063044800006,
								-35.09501521399994
							],
							[
								149.99708446500006,
								-35.102367224999966
							],
							[
								150.0266614310001,
								-35.09532821799996
							],
							[
								150.01802144900012,
								-35.11904121699996
							],
							[
								150.03134445700005,
								-35.11968921799996
							],
							[
								150.03513545500005,
								-35.128476218999936
							],
							[
								149.99608045900004,
								-35.14275821499996
							],
							[
								149.99220641700003,
								-35.161994224999944
							],
							[
								149.97841244900007,
								-35.16622720399994
							],
							[
								149.96088843400003,
								-35.15022320199995
							],
							[
								149.9315834680001,
								-35.14999120999994
							],
							[
								149.93399443600003,
								-35.16554219999995
							],
							[
								149.95246843100006,
								-35.178513221999935
							],
							[
								149.95208346700008,
								-35.20962321199994
							],
							[
								149.92688345800002,
								-35.23748120999994
							],
							[
								149.8974214320001,
								-35.23923021699994
							],
							[
								149.89739344200007,
								-35.234242206999966
							],
							[
								149.91406445000007,
								-35.233465208999974
							],
							[
								149.9175564410001,
								-35.22489219899995
							],
							[
								149.9005314530001,
								-35.22466120699994
							],
							[
								149.88271744500003,
								-35.23530921599996
							],
							[
								149.89280845100006,
								-35.24708220699995
							],
							[
								149.8828344320001,
								-35.25615619599995
							],
							[
								149.8489084480001,
								-35.246454202999985
							],
							[
								149.849730431,
								-35.222600212999964
							],
							[
								149.83555237500002,
								-35.20697938199993
							],
							[
								149.80713745900005,
								-35.21079218899996
							],
							[
								149.79401549200009,
								-35.20296618799995
							],
							[
								149.79591247300004,
								-35.194793207999965
							],
							[
								149.76782145700008,
								-35.19616018499994
							],
							[
								149.77294349900012,
								-35.17861619599995
							],
							[
								149.76601445100005,
								-35.17099219499994
							],
							[
								149.73099048400002,
								-35.18277619199995
							],
							[
								149.7077554990001,
								-35.17498518999997
							],
							[
								149.69974740200007,
								-35.16015301899995
							],
							[
								149.66066124100007,
								-35.13791984599993
							],
							[
								149.6527718750001,
								-35.11561874499995
							],
							[
								149.63484004800011,
								-35.11690268299998
							],
							[
								149.6315262160001,
								-35.13463365299998
							],
							[
								149.60714659000007,
								-35.129648230999976
							],
							[
								149.59099161900008,
								-35.15673257999998
							],
							[
								149.57248659200002,
								-35.153505407999944
							],
							[
								149.55909113400003,
								-35.159245546999955
							],
							[
								149.54238446700003,
								-35.15242431599995
							],
							[
								149.559788539,
								-35.11550827699995
							],
							[
								149.54310925200002,
								-35.110792524999965
							],
							[
								149.55665411500001,
								-35.071150375999935
							],
							[
								149.53825267900004,
								-35.06855612499993
							],
							[
								149.55123357900004,
								-34.97555675499996
							],
							[
								149.5190410250001,
								-34.96615307199994
							],
							[
								149.52863052500004,
								-34.95225516299996
							],
							[
								149.52640052800007,
								-34.931346092999945
							],
							[
								149.535562356,
								-34.93258602299994
							],
							[
								149.54100220700002,
								-34.92488693399997
							],
							[
								149.52465638,
								-34.917837101999964
							],
							[
								149.52645374100007,
								-34.90790389199998
							],
							[
								149.49097370700008,
								-34.90218437899995
							],
							[
								149.4884942960001,
								-34.91624159899993
							],
							[
								149.45506950100003,
								-34.911499755999955
							],
							[
								149.4478188500001,
								-34.92784381599995
							],
							[
								149.42799756300008,
								-34.93061215399996
							],
							[
								149.41314754500002,
								-34.92819117299996
							],
							[
								149.40656947800005,
								-34.918676121999965
							],
							[
								149.38715275000004,
								-34.92149704099995
							],
							[
								149.37465106900004,
								-34.948743579999984
							],
							[
								149.3474253930001,
								-34.94325288699997
							],
							[
								149.3367254540001,
								-34.948763035999946
							],
							[
								149.34636901600004,
								-34.92303589699998
							],
							[
								149.33324014800007,
								-34.92117849599998
							],
							[
								149.33059707000007,
								-34.910028025999964
							],
							[
								149.31630032300006,
								-34.908182153999974
							],
							[
								149.3143654920001,
								-34.91832418399997
							],
							[
								149.28045407800005,
								-34.91166143099997
							],
							[
								149.2737361400001,
								-34.90344045099994
							],
							[
								149.2812138600001,
								-34.89381344099996
							],
							[
								149.2710270020001,
								-34.88668249999995
							],
							[
								149.2508809750001,
								-34.890317478999975
							],
							[
								149.24888198400004,
								-34.897453817999974
							],
							[
								149.237054746,
								-34.89402581699994
							],
							[
								149.22974003600007,
								-34.90536589699997
							],
							[
								149.21222722900006,
								-34.90353102499995
							],
							[
								149.2176549300001,
								-34.890147955999964
							],
							[
								149.18708753400006,
								-34.89444822299998
							],
							[
								149.15624664100005,
								-34.87542940999998
							],
							[
								149.14545107100002,
								-34.88955953999994
							],
							[
								149.12193339400005,
								-34.888769697999976
							],
							[
								149.1099876070001,
								-34.87951914699994
							],
							[
								149.11210559900007,
								-34.86559313699996
							],
							[
								149.06792954700006,
								-34.855226992999974
							],
							[
								149.06055461100004,
								-34.83114212199996
							],
							[
								149.04346046400008,
								-34.82899403099998
							],
							[
								149.04270710700007,
								-34.80292393999997
							],
							[
								149.02200303300003,
								-34.78097701799993
							],
							[
								149.03802562200008,
								-34.76738487999995
							],
							[
								149.03760452300003,
								-34.75830485999995
							],
							[
								149.02202263700008,
								-34.747890137999946
							],
							[
								149.02601361900008,
								-34.72757411799995
							],
							[
								149.00327062300005,
								-34.72432512599994
							],
							[
								148.99036057700005,
								-34.706210134999935
							],
							[
								148.9655115590001,
								-34.71827309299994
							],
							[
								148.9578595920001,
								-34.70739918199996
							],
							[
								148.93901665500005,
								-34.704639130999965
							],
							[
								148.94714768400002,
								-34.70023912099998
							],
							[
								148.941408646,
								-34.69026912099997
							],
							[
								148.94947066100008,
								-34.646062110999935
							],
							[
								148.93258145200002,
								-34.651627119999944
							],
							[
								148.91370862700012,
								-34.63971914799998
							],
							[
								148.8908939700001,
								-34.64260529599994
							],
							[
								148.8950398620001,
								-34.623539136999966
							],
							[
								148.88399394400005,
								-34.61900717599997
							],
							[
								148.86981187900005,
								-34.59167505399995
							],
							[
								148.85040088300002,
								-34.581437182999935
							],
							[
								148.84739168500005,
								-34.56895712199997
							],
							[
								148.81669665200002,
								-34.55654814999997
							],
							[
								148.7829991960001,
								-34.564732496999966
							],
							[
								148.78271223500008,
								-34.57200854699994
							],
							[
								148.7654874870001,
								-34.57110762499997
							],
							[
								148.7563446790001,
								-34.569827664999934
							],
							[
								148.75801663000004,
								-34.561131614999965
							],
							[
								148.74774882200006,
								-34.55626663399994
							],
							[
								148.73927195200008,
								-34.569285742999966
							],
							[
								148.71558264600003,
								-34.565997040999946
							],
							[
								148.71146176800005,
								-34.55271313099996
							],
							[
								148.68786871100008,
								-34.55870209899996
							],
							[
								148.68346470300003,
								-34.54545609799993
							],
							[
								148.67380194400005,
								-34.54574900799997
							],
							[
								148.68240769300007,
								-34.54228809799997
							],
							[
								148.68016272500006,
								-34.53556510799996
							],
							[
								148.6629821460001,
								-34.54731906699993
							],
							[
								148.65364723800008,
								-34.54240610599993
							],
							[
								148.64664452600005,
								-34.56564221499997
							],
							[
								148.6613724220001,
								-34.57746318699998
							],
							[
								148.65940952100004,
								-34.58778423699994
							],
							[
								148.67039371900012,
								-34.58924409799994
							],
							[
								148.65958770800012,
								-34.614277096999956
							],
							[
								148.62913321300005,
								-34.61069856399996
							],
							[
								148.6264033320001,
								-34.62284464399994
							],
							[
								148.59505684700002,
								-34.61873076099994
							],
							[
								148.59965070500004,
								-34.62914709199998
							],
							[
								148.58671502700008,
								-34.627427850999936
							],
							[
								148.5721179100001,
								-34.70210516999998
							],
							[
								148.5632760410001,
								-34.70688837899996
							],
							[
								148.57440886900008,
								-34.708394339999984
							],
							[
								148.57148758200003,
								-34.772386780999966
							],
							[
								148.5815156960001,
								-34.80679310199997
							],
							[
								148.5634087090001,
								-34.80551809999997
							],
							[
								148.55865274300004,
								-34.859341289999975
							],
							[
								148.5452489260001,
								-34.855730318999974
							],
							[
								148.53921325500005,
								-34.87365444899996
							],
							[
								148.52787843600004,
								-34.87222548799997
							],
							[
								148.5222726840001,
								-34.901457096999934
							],
							[
								148.5349457000001,
								-34.91565708899998
							],
							[
								148.54998767900008,
								-34.91011609999998
							],
							[
								148.5360316880001,
								-34.92844507899997
							],
							[
								148.54305869400002,
								-34.95232108899995
							],
							[
								148.53212669100003,
								-34.99132807899997
							],
							[
								148.54235467900003,
								-34.99461808999996
							],
							[
								148.55869266800005,
								-34.987613100999965
							],
							[
								148.56086568500007,
								-35.005002100999945
							],
							[
								148.58310028200003,
								-35.00263192299997
							],
							[
								148.57218065200004,
								-35.018596971999955
							],
							[
								148.57551995900008,
								-35.041604922999966
							],
							[
								148.564627448,
								-35.05716598199996
							],
							[
								148.57330013500007,
								-35.07721056299994
							],
							[
								148.56475044500007,
								-35.08357732199994
							],
							[
								148.56702727300012,
								-35.09498249199993
							],
							[
								148.54503686400005,
								-35.11585621099994
							],
							[
								148.54830259200003,
								-35.13215791099998
							],
							[
								148.54182603200002,
								-35.13535317099996
							],
							[
								148.52394768700003,
								-35.12239608899995
							],
							[
								148.52472667100005,
								-35.08772408899995
							],
							[
								148.46923142000003,
								-35.08013027399994
							],
							[
								148.45683634300008,
								-35.15451110399994
							],
							[
								148.424165667,
								-35.16460708099993
							],
							[
								148.41369065000004,
								-35.15298905999998
							],
							[
								148.3946932030001,
								-35.15049637899995
							],
							[
								148.39682608400005,
								-35.13987701899998
							],
							[
								148.34759383200003,
								-35.13706753499997
							],
							[
								148.34189103200004,
								-35.14184952399995
							],
							[
								148.2837676040001,
								-35.11823346899996
							],
							[
								148.1998697780001,
								-35.11088673199998
							],
							[
								148.22364469800004,
								-35.16282701499995
							],
							[
								148.19157555100003,
								-35.17334931199997
							],
							[
								148.18384372100002,
								-35.18936206199993
							],
							[
								148.164411523,
								-35.193600739999965
							],
							[
								148.15776640500007,
								-35.186276738999936
							],
							[
								148.14954770500003,
								-35.19783505899994
							],
							[
								148.1221989500001,
								-35.18996817699997
							],
							[
								148.11979326900007,
								-35.20254931599993
							],
							[
								148.11200644000007,
								-35.203826395999954
							],
							[
								148.0825836460001,
								-35.19470949299995
							],
							[
								148.0592950780001,
								-35.200866701999985
							],
							[
								147.96173888500005,
								-35.18735059399995
							],
							[
								147.97778373000006,
								-35.20893804499997
							],
							[
								147.96105249200002,
								-35.21733486399995
							],
							[
								147.95862776100012,
								-35.22905477399996
							],
							[
								147.89664876000006,
								-35.231497048999984
							],
							[
								147.89915331800012,
								-35.24481082899996
							],
							[
								147.87957873800008,
								-35.26817503799998
							],
							[
								147.88428872600002,
								-35.277641037999956
							],
							[
								147.85585275000005,
								-35.27936803599994
							],
							[
								147.84272373900012,
								-35.30871103499993
							],
							[
								147.850347746,
								-35.32238502599995
							],
							[
								147.84554974600007,
								-35.32997404499997
							],
							[
								147.86635923000006,
								-35.357727316999956
							],
							[
								147.88429674700012,
								-35.35739204799995
							],
							[
								147.88914672400006,
								-35.37577103899997
							],
							[
								147.8993187220001,
								-35.37935503999995
							],
							[
								147.89412674000005,
								-35.40232003999995
							],
							[
								147.90765166500012,
								-35.42617116099996
							],
							[
								147.89321193700005,
								-35.42434922999996
							],
							[
								147.88936337600012,
								-35.444275448999974
							],
							[
								147.87279168800012,
								-35.44209549799996
							],
							[
								147.8730219670001,
								-35.457003647999954
							],
							[
								147.8859748640001,
								-35.46411160899993
							],
							[
								147.88382439100008,
								-35.48848465899994
							],
							[
								147.9075727070001,
								-35.490067040999975
							],
							[
								147.9047653450001,
								-35.51329658099996
							],
							[
								147.9279749210001,
								-35.51632246299994
							],
							[
								147.92560220000007,
								-35.52851050299995
							],
							[
								147.90802548300007,
								-35.526159561999975
							],
							[
								147.90711072200008,
								-35.530923050999945
							],
							[
								147.9078287110001,
								-35.53833304199998
							],
							[
								147.93144668600007,
								-35.55003804399996
							],
							[
								147.9298126960001,
								-35.55847965299995
							],
							[
								147.89097637200007,
								-35.55327076999998
							],
							[
								147.89268114300012,
								-35.54430471999996
							],
							[
								147.86333671800003,
								-35.54064684799994
							],
							[
								147.86217385800012,
								-35.546854887999984
							],
							[
								147.8473071200001,
								-35.54488393699995
							],
							[
								147.84539641900005,
								-35.55458598699994
							],
							[
								147.84343862800006,
								-35.56459004699997
							],
							[
								147.85532930700003,
								-35.55988495799994
							],
							[
								147.89758384200002,
								-35.63358619099995
							],
							[
								147.87593526500007,
								-35.63375579999996
							],
							[
								147.86808652500008,
								-35.642925928999944
							],
							[
								147.84750792900002,
								-35.638013496999974
							],
							[
								147.8189307020001,
								-35.649331794999966
							],
							[
								147.8009337210001,
								-35.68511402399997
							],
							[
								147.81966270100008,
								-35.74410103599996
							],
							[
								147.80320870900005,
								-35.780990034999945
							],
							[
								147.80596967600002,
								-35.79902903499993
							],
							[
								147.77163472100005,
								-35.80733803199996
							],
							[
								147.77416368900003,
								-35.81880803299998
							],
							[
								147.76059386800011,
								-35.83974315199998
							],
							[
								147.7348976930001,
								-35.83312502999996
							],
							[
								147.7095927160001,
								-35.84106702799994
							],
							[
								147.70140270500008,
								-35.85881503699994
							],
							[
								147.70760171200004,
								-35.879241037999975
							],
							[
								147.6884377140001,
								-35.88864902599994
							],
							[
								147.6964507,
								-35.91214701699994
							],
							[
								147.6874137110001,
								-35.91815602699995
							],
							[
								147.6893353380001,
								-35.93771200699996
							],
							[
								147.7097891960001,
								-35.928901647999965
							],
							[
								147.71819437200008,
								-35.94514114899994
							],
							[
								147.74129737700002,
								-35.95647679099994
							],
							[
								147.77326659200003,
								-35.95884961399997
							],
							[
								147.7668026220001,
								-35.96414495299996
							],
							[
								147.7768551800001,
								-35.968601053999976
							],
							[
								147.80615885600002,
								-35.965043985999955
							],
							[
								147.81750335200002,
								-35.97972762699993
							],
							[
								147.85092432700003,
								-35.981569459999946
							],
							[
								147.8496317160001,
								-35.98972073999994
							],
							[
								147.8731259320001,
								-35.99099400199998
							],
							[
								147.88288551900007,
								-36.00178538299997
							],
							[
								147.897511967,
								-35.99984882399997
							],
							[
								147.8957036380001,
								-35.993005213999936
							],
							[
								147.91257091500006,
								-35.99527415499995
							],
							[
								147.9114953620001,
								-36.02658425499993
							],
							[
								147.92713888900005,
								-36.03094143599998
							],
							[
								147.93158784700006,
								-36.03612033699994
							],
							[
								147.924004759,
								-36.03552470599993
							],
							[
								147.92337605800003,
								-36.04183862599996
							],
							[
								147.93369877600003,
								-36.047558186999936
							],
							[
								147.95878559300002,
								-36.04095198899995
							],
							[
								147.964966451,
								-36.046844369999974
							],
							[
								147.9742661800001,
								-36.03849249999996
							],
							[
								147.97433421900007,
								-36.046916789999955
							],
							[
								147.98130362900008,
								-36.04025602099995
							],
							[
								147.98794805800003,
								-36.04312932099998
							],
							[
								147.98740881700007,
								-36.05227469099998
							],
							[
								147.99969713500002,
								-36.04619064199994
							],
							[
								147.99233544300012,
								-36.074602021999965
							],
							[
								147.9802357740001,
								-36.086627360999955
							],
							[
								147.99922372900005,
								-36.09864219299993
							],
							[
								147.99062110800003,
								-36.12107400199994
							],
							[
								148.00054203600007,
								-36.12434268299995
							],
							[
								148.0043720330001,
								-36.14007897299996
							],
							[
								148.0377320880001,
								-36.14078454599996
							],
							[
								148.03519651700003,
								-36.15252361599994
							],
							[
								148.0229041890001,
								-36.15344489499995
							],
							[
								148.03480070500007,
								-36.16296993599997
							],
							[
								148.0218248860001,
								-36.17644952499995
							],
							[
								148.04062608900006,
								-36.20693906699995
							],
							[
								148.0261014890001,
								-36.223028925999984
							],
							[
								148.03868227300006,
								-36.25920852699994
							],
							[
								148.03523900900007,
								-36.29231629699996
							],
							[
								148.043933207,
								-36.29946686799997
							],
							[
								148.03501710700004,
								-36.31056500699998
							],
							[
								148.0589461720001,
								-36.32003377899997
							],
							[
								148.05124812300005,
								-36.32454457799997
							],
							[
								148.04896467900005,
								-36.35561887799997
							],
							[
								148.0378409000001,
								-36.36623339799996
							],
							[
								148.04597129900003,
								-36.367025067999975
							],
							[
								148.03754817700008,
								-36.39012593799998
							],
							[
								148.05816896200008,
								-36.40079070899998
							],
							[
								148.05995008000002,
								-36.41552531999997
							],
							[
								148.080285526,
								-36.42208826099994
							],
							[
								148.08760677100008,
								-36.45188240199997
							],
							[
								148.124667734,
								-36.46470048499998
							],
							[
								148.11909879200005,
								-36.481871824999985
							],
							[
								148.12623900100004,
								-36.48566862499996
							],
							[
								148.11763627100004,
								-36.49546329499998
							],
							[
								148.139821234,
								-36.52543296699997
							],
							[
								148.124342543,
								-36.55062934599994
							],
							[
								148.1334156700001,
								-36.56690830699995
							],
							[
								148.15049359800003,
								-36.55832286799995
							],
							[
								148.16071861400007,
								-36.579762538999944
							],
							[
								148.169416543,
								-36.57368249999996
							],
							[
								148.17919884000003,
								-36.58003206999996
							],
							[
								148.19013928900006,
								-36.57660790099993
							],
							[
								148.19033554800012,
								-36.584878740999955
							],
							[
								148.205996055,
								-36.586919782999985
							],
							[
								148.21756930200002,
								-36.59822643399997
							],
							[
								148.20278620300007,
								-36.61190302299997
							],
							[
								148.21436955100012,
								-36.61057934299998
							],
							[
								148.22069018800005,
								-36.62554161399993
							],
							[
								148.19926650600007,
								-36.67220506299998
							],
							[
								148.18402125700004,
								-36.68314074099993
							],
							[
								148.18906153500006,
								-36.68811643199996
							],
							[
								148.1696565750001,
								-36.71335903999994
							],
							[
								148.162581487,
								-36.71151927999995
							],
							[
								148.1307080690001,
								-36.73467015699998
							],
							[
								148.1344704070001,
								-36.74372618799998
							],
							[
								148.09794882800009,
								-36.78728484499993
							],
							[
								148.11919966200003,
								-36.80576059699996
							],
							[
								148.12677633200008,
								-36.796439007999936
							],
							[
								148.15634663800006,
								-36.79002657999996
							],
							[
								148.17960061300005,
								-36.79631323199993
							],
							[
								148.18247886200004,
								-36.804882771999985
							],
							[
								148.1949512110001,
								-36.79624011299995
							],
							[
								149.08844964700006,
								-37.15676929999995
							],
							[
								149.97619755300002,
								-37.50514655899997
							],
							[
								149.97541516100011,
								-37.445437228999936
							],
							[
								149.9565591270001,
								-37.42349622699993
							],
							[
								149.94983615500007,
								-37.374656225999956
							],
							[
								149.97216715800005,
								-37.32851023799998
							],
							[
								149.96973115100002,
								-37.309684226999934
							],
							[
								149.95085316600012,
								-37.29563523599995
							],
							[
								149.94401314000004,
								-37.27771622499995
							],
							[
								149.96603017000007,
								-37.24983023699997
							],
							[
								149.9868751680001,
								-37.239937227999974
							],
							[
								150.01311614100007,
								-37.25548323099997
							],
							[
								150.051937134,
								-37.26226022399993
							],
							[
								150.03092015100003,
								-37.23786523199993
							],
							[
								150.02783915400005,
								-37.222502221999946
							],
							[
								150.0108611380001,
								-37.21181822999995
							],
							[
								150.02347115600003,
								-37.21255923099994
							],
							[
								150.01561814900003,
								-37.20111123099997
							],
							[
								150.02095515000008,
								-37.18541923099997
							],
							[
								150.0030531750001,
								-37.168510228999935
							],
							[
								150.00955517500006,
								-37.161255239999946
							],
							[
								150.00487416900012,
								-37.14125623899997
							],
							[
								149.99226218100011,
								-37.13628722799996
							],
							[
								149.9876211720001,
								-37.14111122799994
							],
							[
								149.9689671870001,
								-37.12566922599996
							],
							[
								149.97131716700005,
								-37.11782122599993
							],
							[
								149.9523251720001,
								-37.10871423399993
							],
							[
								149.953794183,
								-37.10087522499998
							],
							[
								149.94324517400003,
								-37.105370223999955
							],
							[
								149.93831417500007,
								-37.098567222999975
							],
							[
								149.92666318700003,
								-37.09984621199993
							],
							[
								149.92973119500004,
								-37.11010023199998
							],
							[
								149.91139016800003,
								-37.11178722099993
							],
							[
								149.89349221300006,
								-37.09707422899993
							],
							[
								149.88650721300007,
								-37.10367620899996
							],
							[
								149.87831018500003,
								-37.10103120799994
							],
							[
								149.87251920800009,
								-37.08319520699996
							],
							[
								149.9018811950001,
								-37.06914521999994
							],
							[
								149.914852192,
								-37.076106220999975
							],
							[
								149.90992119500004,
								-37.062070209999945
							],
							[
								149.9234192250001,
								-37.046293230999936
							],
							[
								149.94465718100003,
								-37.05398322299993
							],
							[
								149.93990320400007,
								-37.03120322299998
							],
							[
								149.94773720500007,
								-37.01754323299997
							],
							[
								149.93079320900006,
								-37.00781822199997
							],
							[
								149.92667017200006,
								-36.99204721099994
							],
							[
								149.93351020500006,
								-36.95932221199996
							],
							[
								149.945923235,
								-36.94911722299997
							],
							[
								149.92880918900005,
								-36.941860230999964
							],
							[
								149.91344120100007,
								-36.94457922999993
							],
							[
								149.90506620600001,
								-36.913594228999955
							],
							[
								149.91970219600012,
								-36.895428229999936
							],
							[
								149.93810724200011,
								-36.90244023199995
							],
							[
								149.92959719500004,
								-36.89470121099998
							],
							[
								149.93017721800004,
								-36.87397522099997
							],
							[
								149.93912121800008,
								-36.85749923199995
							],
							[
								149.9500162070001,
								-36.85537722299995
							],
							[
								149.934357201,
								-36.84411322099993
							],
							[
								149.9406262340001,
								-36.81167022099993
							],
							[
								149.97720324400007,
								-36.76961822399994
							],
							[
								149.9818552480001,
								-36.737067234999984
							],
							[
								149.991874208,
								-36.725559234999935
							],
							[
								149.97931123000012,
								-36.72221522399997
							],
							[
								149.9827620530001,
								-36.70226821399996
							],
							[
								149.99712123200004,
								-36.69220423599995
							],
							[
								149.99988621500006,
								-36.66498923599994
							],
							[
								150.04414823800005,
								-36.588989218999984
							],
							[
								150.05681822700012,
								-36.58292623999995
							],
							[
								150.0557882290001,
								-36.570655219999935
							],
							[
								150.068293239,
								-36.554124230999946
							],
							[
								150.0555422230001,
								-36.54019322999994
							],
							[
								150.06221125700006,
								-36.50653723999994
							],
							[
								150.05482326000003,
								-36.488102228999935
							],
							[
								150.08476527400012,
								-36.42918123199996
							],
							[
								150.06738827800007,
								-36.41889721999996
							],
							[
								150.06894625100006,
								-36.392993229999945
							],
							[
								150.0930102630001,
								-36.34993724199995
							],
							[
								150.13972825200005,
								-36.30488924599996
							],
							[
								150.13076028500006,
								-36.28893924499994
							],
							[
								150.14857425500009,
								-36.26695623599994
							],
							[
								150.14754729000003,
								-36.23798123599994
							],
							[
								150.13238330600007,
								-36.20838223499993
							],
							[
								150.13586427000007,
								-36.172511234999945
							],
							[
								150.12440729600007,
								-36.14741624299995
							],
							[
								150.14150729000005,
								-36.09442223499997
							],
							[
								150.1339653020001,
								-36.09020123399995
							],
							[
								150.13446429500004,
								-36.06600223399994
							]
						],
						[
							[
								149.2063651740001,
								-35.345920157999956
							],
							[
								149.13822591400003,
								-35.42909021299994
							],
							[
								149.15510071000006,
								-35.43597895399995
							],
							[
								149.13509793100002,
								-35.45402107299998
							],
							[
								149.1516156140001,
								-35.493187313999954
							],
							[
								149.1314590390001,
								-35.55358992299995
							],
							[
								149.14268707200006,
								-35.592776353999966
							],
							[
								149.08461994300012,
								-35.58080176899995
							],
							[
								149.0781532730001,
								-35.58640404899995
							],
							[
								149.08756849500003,
								-35.63963966999995
							],
							[
								149.0974849920001,
								-35.64728233099993
							],
							[
								149.09530366900003,
								-35.67926740099995
							],
							[
								149.10942325400003,
								-35.69657283199996
							],
							[
								149.0907150280001,
								-35.765604020999945
							],
							[
								149.10060541000007,
								-35.81469063199995
							],
							[
								149.09357740000007,
								-35.82409883099996
							],
							[
								149.09569287700003,
								-35.845623821999936
							],
							[
								149.06428931800008,
								-35.87493448899994
							],
							[
								149.0517860770001,
								-35.90208943799996
							],
							[
								149.05487563500003,
								-35.91393029899996
							],
							[
								149.04638631500006,
								-35.92051720799998
							],
							[
								149.01240047300007,
								-35.89961068499997
							],
							[
								148.99942254500002,
								-35.902664303999984
							],
							[
								148.9976681160001,
								-35.89641361399998
							],
							[
								148.97566167000002,
								-35.892163221999965
							],
							[
								148.96160460200008,
								-35.896707540999955
							],
							[
								148.90945125500002,
								-35.85306070599995
							],
							[
								148.9070689890001,
								-35.82956586599994
							],
							[
								148.88668449500005,
								-35.81005085399994
							],
							[
								148.89778257500006,
								-35.79464634499993
							],
							[
								148.89486838800008,
								-35.771865273999936
							],
							[
								148.90332515900002,
								-35.757924344999935
							],
							[
								148.88807889400005,
								-35.737045733999935
							],
							[
								148.88937302500005,
								-35.72277494399998
							],
							[
								148.87771954800007,
								-35.71494868199994
							],
							[
								148.85567113600007,
								-35.76094555099996
							],
							[
								148.85608899600004,
								-35.75353168099997
							],
							[
								148.8357971910001,
								-35.741909858999975
							],
							[
								148.8225000860001,
								-35.72095786799997
							],
							[
								148.79110332300002,
								-35.703412484999944
							],
							[
								148.79845373600006,
								-35.66658330599995
							],
							[
								148.76750406400004,
								-35.64739976299995
							],
							[
								148.78344799400008,
								-35.62849744399995
							],
							[
								148.76843939900004,
								-35.603292962999944
							],
							[
								148.7887788380001,
								-35.58832686399995
							],
							[
								148.77294533300005,
								-35.56778509299994
							],
							[
								148.7779544130001,
								-35.558506842999975
							],
							[
								148.76279568300004,
								-35.49548612099994
							],
							[
								148.7743865230001,
								-35.48613215199998
							],
							[
								148.76674716600007,
								-35.46716842199993
							],
							[
								148.78892181800006,
								-35.426481862999935
							],
							[
								148.78580004100002,
								-35.408897862999936
							],
							[
								148.7959819890001,
								-35.406624043999955
							],
							[
								148.7956926810001,
								-35.39299024299993
							],
							[
								148.80866523100008,
								-35.38244174399995
							],
							[
								148.79355220800005,
								-35.33910928299997
							],
							[
								148.80107450900005,
								-35.32175799299995
							],
							[
								148.8101399100001,
								-35.307435693999935
							],
							[
								148.96166256800007,
								-35.21833162599995
							],
							[
								149.12095342500004,
								-35.124402938999935
							],
							[
								149.13899202200002,
								-35.12797041099998
							],
							[
								149.14673173800008,
								-35.14453988099996
							],
							[
								149.16428377600005,
								-35.141892232999965
							],
							[
								149.167583583,
								-35.15973914299997
							],
							[
								149.18561189000002,
								-35.16110917499998
							],
							[
								149.18364640900006,
								-35.17565604499998
							],
							[
								149.19704078600012,
								-35.18535545599997
							],
							[
								149.18954750500006,
								-35.20331081499995
							],
							[
								149.20070222300012,
								-35.20555282599997
							],
							[
								149.20852309100007,
								-35.21149882699996
							],
							[
								149.20499151900003,
								-35.229087456999935
							],
							[
								149.21378999900003,
								-35.21959329799995
							],
							[
								149.24553711300007,
								-35.22670985999997
							],
							[
								149.23437914300007,
								-35.242778699999974
							],
							[
								149.27318448500012,
								-35.25916603299993
							],
							[
								149.27181343300003,
								-35.27347192299993
							],
							[
								149.315305856,
								-35.27621808699996
							],
							[
								149.32248233400003,
								-35.28672741699995
							],
							[
								149.3415037110001,
								-35.28668998899997
							],
							[
								149.3616713450001,
								-35.30901194099994
							],
							[
								149.39479073000007,
								-35.303175873999976
							],
							[
								149.39929254800006,
								-35.31907684399994
							],
							[
								149.35604362000004,
								-35.350636270999985
							],
							[
								149.33641903500006,
								-35.33971404899995
							],
							[
								149.2936679820001,
								-35.33212167499994
							],
							[
								149.281725133,
								-35.33806310399996
							],
							[
								149.25474977800002,
								-35.33010834199996
							],
							[
								149.2063651740001,
								-35.345920157999956
							]
						]
					],
					[
						[
							[
								150.23068223600012,
								-36.24466224399998
							],
							[
								150.2231742570001,
								-36.24558924299998
							],
							[
								150.22734427400007,
								-36.25955823299995
							],
							[
								150.23068223600012,
								-36.24466224399998
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "113",
				"CED_NAME21": "Eden-Monaro",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 41714.6559,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/113",
				"SHAPE_Leng": 19.6790322939,
				"SHAPE_Area": 4.17221517924
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							146.1772805490001,
							-36.03402765199996
						],
						[
							146.18809513600002,
							-36.04157777299997
						],
						[
							146.20087299600004,
							-36.02743129399994
						],
						[
							146.19930686500004,
							-36.03746409399997
						],
						[
							146.2118145940001,
							-36.02851238499994
						],
						[
							146.2101306730001,
							-36.03848375399997
						],
						[
							146.21973712200008,
							-36.03685661499998
						],
						[
							146.2213307620001,
							-36.03018717499998
						],
						[
							146.24321925900006,
							-36.02864194699998
						],
						[
							146.24143892000006,
							-36.02351130699998
						],
						[
							146.25089481800012,
							-36.02311704699997
						],
						[
							146.2445991300001,
							-36.018327746999944
						],
						[
							146.25718882800004,
							-36.01204001799994
						],
						[
							146.27286490400002,
							-36.02661757899995
						],
						[
							146.27503603600007,
							-36.01242753899993
						],
						[
							146.28290106400004,
							-36.011035299999946
						],
						[
							146.2788097550001,
							-36.01583806899998
						],
						[
							146.29113159200006,
							-36.020151089999956
						],
						[
							146.28218712300009,
							-36.02617518999995
						],
						[
							146.29311027100005,
							-36.02949051099995
						],
						[
							146.28302928100004,
							-36.04147433999998
						],
						[
							146.29140179,
							-36.03893832999995
						],
						[
							146.299015058,
							-36.047846610999954
						],
						[
							146.3009688290001,
							-36.03657736099996
						],
						[
							146.31299203600008,
							-36.04555498199994
						],
						[
							146.31588084600003,
							-36.038440281999954
						],
						[
							146.32907759300008,
							-36.04313122299993
						],
						[
							146.3250280750001,
							-36.033529872999964
						],
						[
							146.338895244,
							-36.02638202399993
						],
						[
							146.35002012000007,
							-36.04174432499997
						],
						[
							146.36958443600008,
							-36.05072692599998
						],
						[
							146.37957418500002,
							-36.04472274699998
						],
						[
							146.37626142600004,
							-36.03835155699994
						],
						[
							146.38756223500002,
							-36.03562574799997
						],
						[
							146.37959918700005,
							-36.028113796999946
						],
						[
							146.3806112090001,
							-36.01288171699997
						],
						[
							146.3991403560001,
							-36.007186187999935
						],
						[
							146.4029679880001,
							-35.98876719799995
						],
						[
							146.4251749560001,
							-35.97301409999994
						],
						[
							146.4216790170001,
							-35.965818129999946
						],
						[
							146.4371648650001,
							-35.967002040999944
						],
						[
							146.44331283300005,
							-35.976228040999956
						],
						[
							146.45460066200008,
							-35.96223391199993
						],
						[
							146.469971578,
							-35.976187882999966
						],
						[
							146.46741265800006,
							-35.984226932999945
						],
						[
							146.49973268200006,
							-35.99085709599996
						],
						[
							146.50214019200007,
							-35.983174625999936
						],
						[
							146.4924863540001,
							-35.98499872499997
						],
						[
							146.500680213,
							-35.979230635999954
						],
						[
							146.50259108500006,
							-35.95822156599996
						],
						[
							146.5119689930001,
							-35.964165495999964
						],
						[
							146.51968685200006,
							-35.96059141699993
						],
						[
							146.53229878700006,
							-35.98428636799997
						],
						[
							146.54958646400007,
							-35.992444208999984
						],
						[
							146.5629526240001,
							-35.96769251999996
						],
						[
							146.56238635300008,
							-35.97690406999993
						],
						[
							146.58397271900003,
							-35.98385079199994
						],
						[
							146.5841528100001,
							-35.97497378199995
						],
						[
							146.6125259360001,
							-35.97284540399994
						],
						[
							146.6187218540001,
							-35.97592436399998
						],
						[
							146.6078261550001,
							-35.986358533999976
						],
						[
							146.6130551430001,
							-35.99515156399997
						],
						[
							146.6337168990001,
							-35.99978928599995
						],
						[
							146.64037896700006,
							-36.00950879599998
						],
						[
							146.6421336080001,
							-36.00411549599994
						],
						[
							146.65087346600012,
							-36.007722856999976
						],
						[
							146.6501839550001,
							-36.01378407699997
						],
						[
							146.65857951400005,
							-36.01447553799994
						],
						[
							146.65034141500007,
							-36.01839837699998
						],
						[
							146.65600189300005,
							-36.026239317999966
						],
						[
							146.67022759000008,
							-36.02790029899995
						],
						[
							146.66835286200012,
							-36.01777101799996
						],
						[
							146.67136704000006,
							-36.025857858999984
						],
						[
							146.67965186900005,
							-36.02208787899997
						],
						[
							146.67537030900007,
							-36.02858661899995
						],
						[
							146.68752884600008,
							-36.04105103999996
						],
						[
							146.6950080260001,
							-36.03430261099993
						],
						[
							146.68960855700004,
							-36.030432959999985
						],
						[
							146.70714688300006,
							-36.036108630999934
						],
						[
							146.70888439400005,
							-36.02942163199998
						],
						[
							146.73185547100002,
							-36.02378221299995
						],
						[
							146.73084830900007,
							-36.04522579299993
						],
						[
							146.74463125600005,
							-36.04782440399998
						],
						[
							146.75293381500012,
							-36.04210021499995
						],
						[
							146.74798913400002,
							-36.06032269499997
						],
						[
							146.76232149300006,
							-36.05165221599998
						],
						[
							146.762824442,
							-36.05950527599998
						],
						[
							146.7671610420001,
							-36.05565524599996
						],
						[
							146.79618700600008,
							-36.06512555799998
						],
						[
							146.79457583700002,
							-36.05853224799995
						],
						[
							146.80394196600002,
							-36.055181768999944
						],
						[
							146.81838602200003,
							-36.06782108999994
						],
						[
							146.81630724100012,
							-36.074364369999955
						],
						[
							146.82554761000006,
							-36.07083452099994
						],
						[
							146.82505488800007,
							-36.08871862099994
						],
						[
							146.83670585700008,
							-36.08206026199997
						],
						[
							146.85716312400007,
							-36.08490537299997
						],
						[
							146.85870991500008,
							-36.07437367299997
						],
						[
							146.8729579520001,
							-36.07366841399994
						],
						[
							146.88056202000007,
							-36.087511064999944
						],
						[
							146.90691554600005,
							-36.084933976999935
						],
						[
							146.90776845300002,
							-36.111271416999955
						],
						[
							146.92406328000004,
							-36.10830140799993
						],
						[
							146.9268095010001,
							-36.09716550799993
						],
						[
							146.94371060600008,
							-36.11597698999998
						],
						[
							146.95250415500004,
							-36.11077526099996
						],
						[
							146.95630056900006,
							-36.078177610999944
						],
						[
							146.972594565,
							-36.08210022199995
						],
						[
							146.98130432300002,
							-36.09486331299996
						],
						[
							147.00687243000004,
							-36.083577584999944
						],
						[
							147.00640088900002,
							-36.08910159499993
						],
						[
							147.0163240180001,
							-36.08978466499997
						],
						[
							147.013478576,
							-36.10470834499995
						],
						[
							147.0227821850001,
							-36.09988217599994
						],
						[
							147.0341463520001,
							-36.11522562699997
						],
						[
							147.04235013200002,
							-36.10429150699997
						],
						[
							147.05308605000005,
							-36.10767842799993
						],
						[
							147.06219660300007,
							-36.06572399899994
						],
						[
							147.0668165520001,
							-36.068608978999976
						],
						[
							147.0682825030001,
							-36.06056688899997
						],
						[
							147.07452947100012,
							-36.06407784999993
						],
						[
							147.09040606000008,
							-36.04921253099997
						],
						[
							147.09555704900004,
							-36.052557460999935
						],
						[
							147.09158797100008,
							-36.043848450999974
						],
						[
							147.09700895000003,
							-36.046771400999944
						],
						[
							147.10371765000002,
							-36.03284118199997
						],
						[
							147.09214576300008,
							-36.02763729099996
						],
						[
							147.09910062200004,
							-36.02618119099998
						],
						[
							147.09767657300006,
							-36.01581011099995
						],
						[
							147.10636945200008,
							-36.01644196199993
						],
						[
							147.0980794940001,
							-36.01023307099996
						],
						[
							147.10923335200005,
							-36.01253589199996
						],
						[
							147.10682529300004,
							-36.00481186199994
						],
						[
							147.1162862010001,
							-36.00762174199997
						],
						[
							147.1119371630001,
							-36.00090873199997
						],
						[
							147.12336301200003,
							-35.99448452299998
						],
						[
							147.12739716800002,
							-36.01803366299998
						],
						[
							147.14436711300004,
							-36.03775158499997
						],
						[
							147.16446185100006,
							-36.030785295999976
						],
						[
							147.20630471200002,
							-36.05012310999996
						],
						[
							147.24238400700006,
							-36.038469461999966
						],
						[
							147.28518255000006,
							-36.03942600599993
						],
						[
							147.319263502,
							-36.06111386899994
						],
						[
							147.35283044000005,
							-36.03173614099995
						],
						[
							147.34568635300002,
							-36.018759029999956
						],
						[
							147.35819871400008,
							-35.991262630999984
						],
						[
							147.3836850130001,
							-35.972339312999964
						],
						[
							147.39250587100003,
							-35.97333128399998
						],
						[
							147.39184543400006,
							-35.94762720299997
						],
						[
							147.40502411300008,
							-35.943507103999934
						],
						[
							147.4506905830001,
							-35.960790997999936
						],
						[
							147.4640780430001,
							-35.94412395899997
						],
						[
							147.47884089100012,
							-35.94267598999994
						],
						[
							147.48155884000005,
							-35.949209939999946
						],
						[
							147.49411754800008,
							-35.94353586099993
						],
						[
							147.5117987530001,
							-35.962252812999964
						],
						[
							147.5255189610001,
							-35.96319558399995
						],
						[
							147.51523588100008,
							-35.97597395299994
						],
						[
							147.52111575900005,
							-35.98638427399993
						],
						[
							147.55187927200006,
							-36.00408231599994
						],
						[
							147.58403296900008,
							-35.98463493899993
						],
						[
							147.58143370000005,
							-35.97801360899996
						],
						[
							147.5588934650001,
							-35.97247585699995
						],
						[
							147.54765939600009,
							-35.978612435999935
						],
						[
							147.5491207970001,
							-35.96453659599996
						],
						[
							147.56739252400007,
							-35.96482206699994
						],
						[
							147.56416119400012,
							-35.969420636999985
						],
						[
							147.5748908920001,
							-35.975145547999944
						],
						[
							147.58087284200008,
							-35.967988197999944
						],
						[
							147.59420894900006,
							-35.96982426899996
						],
						[
							147.60144308700012,
							-35.979105619999984
						],
						[
							147.63777623300007,
							-35.96209704299997
						],
						[
							147.64678269400008,
							-35.94599549299994
						],
						[
							147.68001498900003,
							-35.94442616599997
						],
						[
							147.6893353380001,
							-35.93771200699996
						],
						[
							147.6874137110001,
							-35.91815602699995
						],
						[
							147.6964507,
							-35.91214701699994
						],
						[
							147.6884377140001,
							-35.88864902599994
						],
						[
							147.70760171200004,
							-35.879241037999975
						],
						[
							147.70140270500008,
							-35.85881503699994
						],
						[
							147.7095927160001,
							-35.84106702799994
						],
						[
							147.7348976930001,
							-35.83312502999996
						],
						[
							147.76059386800011,
							-35.83974315199998
						],
						[
							147.77416368900003,
							-35.81880803299998
						],
						[
							147.77163472100005,
							-35.80733803199996
						],
						[
							147.80596967600002,
							-35.79902903499993
						],
						[
							147.80320870900005,
							-35.780990034999945
						],
						[
							147.81966270100008,
							-35.74410103599996
						],
						[
							147.8009337210001,
							-35.68511402399997
						],
						[
							147.8189307020001,
							-35.649331794999966
						],
						[
							147.84750792900002,
							-35.638013496999974
						],
						[
							147.86808652500008,
							-35.642925928999944
						],
						[
							147.87593526500007,
							-35.63375579999996
						],
						[
							147.89758384200002,
							-35.63358619099995
						],
						[
							147.85532930700003,
							-35.55988495799994
						],
						[
							147.84343862800006,
							-35.56459004699997
						],
						[
							147.84539641900005,
							-35.55458598699994
						],
						[
							147.75438105500007,
							-35.54467139899998
						],
						[
							147.75572385600003,
							-35.53344944899993
						],
						[
							147.73692073900008,
							-35.53100901799996
						],
						[
							147.73829174800005,
							-35.54106902799998
						],
						[
							147.6855993370001,
							-35.534184893999964
						],
						[
							147.6811947750001,
							-35.556655973999966
						],
						[
							147.65029676200004,
							-35.53879901099998
						],
						[
							147.62518074500008,
							-35.546171018999985
						],
						[
							147.522043778,
							-35.482110010999975
						],
						[
							147.51477578900005,
							-35.488621009999974
						],
						[
							147.51815232700005,
							-35.496950339999955
						],
						[
							147.5001698090001,
							-35.508743608999964
						],
						[
							147.50045209600012,
							-35.52846883899997
						],
						[
							147.48825558600004,
							-35.545645107999974
						],
						[
							147.45628286300007,
							-35.53094302599993
						],
						[
							147.42717251700003,
							-35.53950719299996
						],
						[
							147.419017509,
							-35.533587172999944
						],
						[
							147.39151245900007,
							-35.56361106099996
						],
						[
							147.3823312820001,
							-35.55091078999993
						],
						[
							147.3881028840001,
							-35.53195946999995
						],
						[
							147.37801300500007,
							-35.530860589999975
						],
						[
							147.36380999000005,
							-35.51385778799994
						],
						[
							147.33354025500012,
							-35.50947698599998
						],
						[
							147.3030323910001,
							-35.49558328399996
						],
						[
							147.29389158200001,
							-35.501289422999946
						],
						[
							147.26320275800003,
							-35.488537719999954
						],
						[
							147.2514768100001,
							-35.49107898899996
						],
						[
							147.23789172400006,
							-35.47048876799994
						],
						[
							147.2110161280001,
							-35.472722155999975
						],
						[
							147.19545921100007,
							-35.466077294999934
						],
						[
							147.18498400500005,
							-35.44846416399997
						],
						[
							147.15779781700007,
							-35.46914677199993
						],
						[
							147.1324092310001,
							-35.46789192999995
						],
						[
							147.12181915400004,
							-35.456201858999975
						],
						[
							147.1052643270001,
							-35.452734937999935
						],
						[
							147.07022787300002,
							-35.452947034999966
						],
						[
							147.07124801200007,
							-35.460585134999974
						],
						[
							147.04017684400003,
							-35.48419198299996
						],
						[
							147.01661083600004,
							-35.49387297099997
						],
						[
							146.99390733000007,
							-35.48927377999996
						],
						[
							146.99118647800003,
							-35.51682698999997
						],
						[
							146.95547312300005,
							-35.523064026999975
						],
						[
							146.90085679700007,
							-35.56048095299997
						],
						[
							146.89091317800012,
							-35.560469171999955
						],
						[
							146.88838349700006,
							-35.57322845199997
						],
						[
							146.7976744130001,
							-35.56628077499994
						],
						[
							146.79615575200012,
							-35.57498705499995
						],
						[
							146.67296860300007,
							-35.55526314599996
						],
						[
							146.6741714640001,
							-35.54915007599993
						],
						[
							146.6623286360001,
							-35.54775014499995
						],
						[
							146.6697750080001,
							-35.52026587499995
						],
						[
							146.5400999520001,
							-35.48716093499996
						],
						[
							146.4311891110001,
							-35.474984796999934
						],
						[
							146.39151808200006,
							-35.430408743999976
						],
						[
							146.38079883600005,
							-35.40568157299998
						],
						[
							146.3650817900001,
							-35.389308031999974
						],
						[
							146.35423173200002,
							-35.387784410999984
						],
						[
							146.3729499970001,
							-35.32098892199997
						],
						[
							146.38876719400002,
							-35.32283805299994
						],
						[
							146.3924706360001,
							-35.30298259299997
						],
						[
							146.4038103040001,
							-35.304439043999935
						],
						[
							146.41366424800003,
							-35.25053186399998
						],
						[
							146.38640488300007,
							-35.24738360199996
						],
						[
							146.38925747400003,
							-35.23171836199998
						],
						[
							146.4482614000001,
							-35.18719831599998
						],
						[
							146.45132049900008,
							-35.19116536699994
						],
						[
							146.56462531900002,
							-35.11859732499994
						],
						[
							146.6149859720001,
							-35.11451693799995
						],
						[
							146.62522495200005,
							-35.100656938999975
						],
						[
							146.66092796700002,
							-35.08971695199995
						],
						[
							146.68848396600004,
							-35.06796594399998
						],
						[
							146.76153012300006,
							-35.07642823899994
						],
						[
							146.77031133000003,
							-35.09727542999997
						],
						[
							146.7787908680001,
							-35.09839214099998
						],
						[
							146.80888909600003,
							-34.98503569199994
						],
						[
							146.77908211600004,
							-34.93962822999998
						],
						[
							146.78448283700004,
							-34.924045029999945
						],
						[
							146.84370448100003,
							-34.89880641399998
						],
						[
							146.83281657300006,
							-34.89327842299997
						],
						[
							146.8415913230001,
							-34.88105322399997
						],
						[
							146.82925647500008,
							-34.877526272999944
						],
						[
							146.84633288600003,
							-34.844469843999946
						],
						[
							146.9115744070001,
							-34.48257804699995
						],
						[
							146.79175719600005,
							-34.47228529699993
						],
						[
							146.823034419,
							-34.31083764899995
						],
						[
							146.71875083600003,
							-34.298097730999984
						],
						[
							146.7290492410001,
							-34.23675535099994
						],
						[
							146.62387779800008,
							-34.22472191299994
						],
						[
							146.63541055400003,
							-34.15117362299998
						],
						[
							146.5974424210001,
							-34.147175310999955
						],
						[
							146.59152844200003,
							-34.14010736999995
						],
						[
							146.5855015620001,
							-34.14625642999994
						],
						[
							146.45821210300005,
							-34.13291691999996
						],
						[
							146.49281511100003,
							-33.91964393099994
						],
						[
							146.4174391130001,
							-33.91062191599997
						],
						[
							146.43719113200007,
							-33.79448591599993
						],
						[
							146.32013777100008,
							-33.78105379699997
						],
						[
							146.31916683000009,
							-33.78638179699993
						],
						[
							146.31723277100002,
							-33.78053580699998
						],
						[
							146.070306081,
							-33.75352075899997
						],
						[
							146.09514737300003,
							-33.60311810999997
						],
						[
							146.05396863200008,
							-33.47575424599995
						],
						[
							146.0669832320001,
							-33.356815875999985
						],
						[
							146.07577122300006,
							-33.339043886999946
						],
						[
							146.08610324200004,
							-33.337396886999954
						],
						[
							146.09077922300003,
							-33.319042896999974
						],
						[
							146.08113023600004,
							-33.303996876999975
						],
						[
							146.08910625500005,
							-33.30361589699993
						],
						[
							146.08361924700012,
							-33.29047587699995
						],
						[
							146.09145323500002,
							-33.29148788699996
						],
						[
							146.09517525600006,
							-33.27835787799995
						],
						[
							146.05889827800002,
							-33.211794563999945
						],
						[
							146.09363737600006,
							-33.18907021699994
						],
						[
							146.03166582400002,
							-33.093565411999975
						],
						[
							145.9053368330001,
							-33.087735291999934
						],
						[
							145.90683172400009,
							-33.078610251999976
						],
						[
							145.8726453490001,
							-33.07478639999994
						],
						[
							145.87087652800005,
							-33.08629744999996
						],
						[
							145.645263891,
							-33.08029877399997
						],
						[
							145.66853531200002,
							-32.93585785399995
						],
						[
							145.6517933550001,
							-32.935337852999965
						],
						[
							145.67192939500012,
							-32.805708583999944
						],
						[
							145.58652122800004,
							-32.79622286799997
						],
						[
							145.59572927300007,
							-32.737755497999956
						],
						[
							145.55664299900002,
							-32.733270654999956
						],
						[
							145.54889656700004,
							-32.76518285499998
						],
						[
							145.56910504400003,
							-32.757861745999946
						],
						[
							145.5508278840001,
							-32.791602024999975
						],
						[
							145.53793802600012,
							-32.78324202399995
						],
						[
							145.54486579600007,
							-32.775358954999945
						],
						[
							145.50435449200006,
							-32.77007908199994
						],
						[
							145.51044283600004,
							-32.72784880199998
						],
						[
							145.46746854200012,
							-32.72249389899997
						],
						[
							145.4149502360001,
							-32.76139848499997
						],
						[
							145.41263740500005,
							-32.775935824999976
						],
						[
							145.3305693970001,
							-32.76666082999998
						],
						[
							145.34428442400008,
							-32.68247281999993
						],
						[
							145.25728588700008,
							-32.67124056399996
						],
						[
							145.24938053300002,
							-32.72437988399997
						],
						[
							145.16499973600003,
							-32.714817247999974
						],
						[
							145.1272603980001,
							-32.95467281699996
						],
						[
							145.11883941000008,
							-32.95369481599994
						],
						[
							145.10756239300008,
							-33.03369882599998
						],
						[
							145.027704426,
							-33.021909799999946
						],
						[
							145.01027242800012,
							-33.024435808999954
						],
						[
							145.00798117800002,
							-33.035529578999956
						],
						[
							144.99173751000012,
							-33.03364862799998
						],
						[
							144.99356138100006,
							-33.02250855799997
						],
						[
							144.98488653200002,
							-33.02154958699998
						],
						[
							144.9859181270001,
							-33.07051483799995
						],
						[
							144.97940842700007,
							-33.083777907999945
						],
						[
							144.96350666000012,
							-33.081978025999945
						],
						[
							144.96278672900007,
							-33.08727606599996
						],
						[
							144.90887153800008,
							-33.07443440299994
						],
						[
							144.9130841100001,
							-33.04911826299997
						],
						[
							144.79824183800008,
							-33.03620614499994
						],
						[
							144.77798042900008,
							-33.16344779399998
						],
						[
							144.77226544000007,
							-33.157388803999936
						],
						[
							144.76241245100005,
							-33.163216802999955
						],
						[
							144.7571974430001,
							-33.15235880299997
						],
						[
							144.74731944300004,
							-33.16178279199994
						],
						[
							144.733430429,
							-33.23138456199996
						],
						[
							144.64568772200005,
							-33.222338295999975
						],
						[
							144.64265406100003,
							-33.241108415999975
						],
						[
							144.61222649600006,
							-33.23779068399995
						],
						[
							144.60942844400006,
							-33.25632779399996
						],
						[
							144.59801744600009,
							-33.25507378299994
						],
						[
							144.5956741450001,
							-33.27002497299998
						],
						[
							144.58018639800002,
							-33.26836407199994
						],
						[
							144.57753572600006,
							-33.28865321199993
						],
						[
							144.5492394700001,
							-33.285506779999935
						],
						[
							144.54695343900005,
							-33.299997779999956
						],
						[
							144.49109808800006,
							-33.29296196599995
						],
						[
							144.48868225800004,
							-33.300450025999965
						],
						[
							144.47179948000007,
							-33.29895718499995
						],
						[
							144.4717083810001,
							-33.29119014499997
						],
						[
							144.43358486700004,
							-33.28766245199995
						],
						[
							144.4334958380001,
							-33.28046841199995
						],
						[
							144.41620805000002,
							-33.27905856099994
						],
						[
							144.41416916000003,
							-33.28647762099996
						],
						[
							144.26264725400006,
							-33.272892870999954
						],
						[
							144.26427409400003,
							-33.26300181099998
						],
						[
							144.277784493,
							-33.25420277199993
						],
						[
							144.23626130000002,
							-33.24981600899997
						],
						[
							144.2514328960001,
							-33.15505645899998
						],
						[
							143.90591343000006,
							-33.11569438699996
						],
						[
							143.89819857700002,
							-33.16137873699995
						],
						[
							143.8390290860001,
							-33.15457711299996
						],
						[
							143.81666916100005,
							-33.13743225099995
						],
						[
							143.78988275400002,
							-33.148852499999975
						],
						[
							143.72095744500007,
							-33.14043925499993
						],
						[
							143.71480774400004,
							-33.15459737499998
						],
						[
							143.66648878900003,
							-33.179079901999955
						],
						[
							143.6484818140001,
							-33.15899702099995
						],
						[
							143.6361136060001,
							-33.157774709999956
						],
						[
							143.63729460600007,
							-33.14990271999994
						],
						[
							143.5524661390001,
							-33.14046779499995
						],
						[
							143.5728171180001,
							-33.012416024999936
						],
						[
							143.60280558400007,
							-33.007090726999934
						],
						[
							143.65341991600008,
							-33.012399269999946
						],
						[
							143.66154416000006,
							-32.95528490999993
						],
						[
							143.67181387000005,
							-32.94075075099994
						],
						[
							143.58516003300008,
							-32.931016504999945
						],
						[
							143.59199346600008,
							-32.88512722499996
						],
						[
							143.505858589,
							-32.875990989999934
						],
						[
							143.4995721460001,
							-32.918335249999984
						],
						[
							143.41697521900005,
							-32.90748000499997
						],
						[
							143.4324418760001,
							-32.808432334999964
						],
						[
							143.26962103100004,
							-32.79137380499998
						],
						[
							143.27121885100007,
							-32.780215734999956
						],
						[
							142.96464484800003,
							-32.74852364599997
						],
						[
							142.9443567190001,
							-32.890519505999976
						],
						[
							142.51554255500002,
							-32.847440379999966
						],
						[
							142.55192365800008,
							-32.991603762999944
						],
						[
							142.54799402600008,
							-33.01712697299996
						],
						[
							142.42447578600002,
							-33.00521285599996
						],
						[
							142.42801738700007,
							-32.97901368599997
						],
						[
							142.37648209500003,
							-32.973662212999955
						],
						[
							142.37210679400005,
							-32.99594265299993
						],
						[
							142.38469181200003,
							-32.999883643999965
						],
						[
							142.38287878200003,
							-33.00493165399996
						],
						[
							142.35735079300002,
							-33.03456164299996
						],
						[
							142.3133558180001,
							-33.05012464999993
						],
						[
							142.31157381700007,
							-33.06684163999995
						],
						[
							142.28747479900005,
							-33.08487463899996
						],
						[
							142.30194580600005,
							-33.09222962999996
						],
						[
							142.28703478700004,
							-33.10739363899995
						],
						[
							142.29478779600004,
							-33.10908564899995
						],
						[
							142.29338681600007,
							-33.11658363899994
						],
						[
							142.2740807990001,
							-33.11257163799996
						],
						[
							142.27528379800003,
							-33.12381563799994
						],
						[
							142.244610813,
							-33.11944362699995
						],
						[
							142.24283403200002,
							-33.13085966699998
						],
						[
							142.2214678050001,
							-33.128853634999984
						],
						[
							142.22449380600005,
							-33.12002164599994
						],
						[
							142.1056859240001,
							-33.11240662899996
						],
						[
							142.10780857500004,
							-33.09011752899994
						],
						[
							142.02293991800002,
							-33.08478704399994
						],
						[
							142.03836219100003,
							-33.143927144999964
						],
						[
							141.560780055,
							-33.096279608999964
						],
						[
							141.57321094000008,
							-33.00555819899995
						],
						[
							141.40258693600003,
							-32.98764657899994
						],
						[
							141.34800977600003,
							-33.36664475899994
						],
						[
							141.30584728300005,
							-33.36244024699994
						],
						[
							141.3087280840001,
							-33.341389136999965
						],
						[
							141.26663249000012,
							-33.33722763399993
						],
						[
							141.26399868900012,
							-33.35574174399994
						],
						[
							141.00241215000005,
							-33.329009550999956
						],
						[
							141.0024129400001,
							-33.33000950099995
						],
						[
							141.002962539,
							-34.021878544999936
						],
						[
							141.012372077,
							-34.02472245599995
						],
						[
							141.00378256800002,
							-34.02759112499996
						],
						[
							141.0019413880001,
							-34.03927064499993
						],
						[
							141.02347418300008,
							-34.059749496999984
						],
						[
							141.03434319300004,
							-34.03572137699996
						],
						[
							141.04344646100003,
							-34.042690196999956
						],
						[
							141.04247060000012,
							-34.061088077999955
						],
						[
							141.06560759700005,
							-34.05004885899996
						],
						[
							141.07195768500003,
							-34.06289616899994
						],
						[
							141.08491737300005,
							-34.06227489999998
						],
						[
							141.08922427200002,
							-34.076683249999974
						],
						[
							141.09759396100003,
							-34.07002192999994
						],
						[
							141.0872633030001,
							-34.05715999999995
						],
						[
							141.09424484300007,
							-34.05064372999993
						],
						[
							141.12034472800008,
							-34.064852791999954
						],
						[
							141.1373142660001,
							-34.057547641999975
						],
						[
							141.14298060400006,
							-34.06352066299996
						],
						[
							141.15311819300007,
							-34.05450776299995
						],
						[
							141.15344973300012,
							-34.06417566299996
						],
						[
							141.1438547240001,
							-34.06778556299997
						],
						[
							141.15318727200008,
							-34.06890188299997
						],
						[
							141.15367703100003,
							-34.082104852999976
						],
						[
							141.16586167900005,
							-34.08319881399996
						],
						[
							141.17467520900004,
							-34.07332008399993
						],
						[
							141.18623652600002,
							-34.09196316499998
						],
						[
							141.19444347500007,
							-34.08759431599998
						],
						[
							141.18745554600002,
							-34.07928062499997
						],
						[
							141.20591430500008,
							-34.061709495999935
						],
						[
							141.22212568200007,
							-34.06166338699995
						],
						[
							141.22847520000005,
							-34.073637566999935
						],
						[
							141.2418141490001,
							-34.06130124799995
						],
						[
							141.2425493170001,
							-34.087328207999974
						],
						[
							141.259572025,
							-34.07812119899995
						],
						[
							141.28370840000002,
							-34.10386162999998
						],
						[
							141.298550717,
							-34.10694678099998
						],
						[
							141.30079747600007,
							-34.113705110999945
						],
						[
							141.31745816400007,
							-34.11240024199998
						],
						[
							141.31353630400008,
							-34.12484710199993
						],
						[
							141.32592827100007,
							-34.12685258299996
						],
						[
							141.32494416100008,
							-34.138768572999936
						],
						[
							141.34641417900002,
							-34.12433419399997
						],
						[
							141.3485115190001,
							-34.112297773999956
						],
						[
							141.3589858680001,
							-34.11071023399995
						],
						[
							141.36876522500006,
							-34.12710130499994
						],
						[
							141.36970019500006,
							-34.12019026499996
						],
						[
							141.38159355300002,
							-34.122129195999946
						],
						[
							141.38812499100004,
							-34.134716985999944
						],
						[
							141.4082540390001,
							-34.12784267699993
						],
						[
							141.4074107670001,
							-34.14638735699998
						],
						[
							141.4171623860001,
							-34.150764547999984
						],
						[
							141.43390769300004,
							-34.14589086899997
						],
						[
							141.4328085420001,
							-34.15992724899996
						],
						[
							141.44454630000007,
							-34.168001938999964
						],
						[
							141.45064968000008,
							-34.160990509999976
						],
						[
							141.4828085150001,
							-34.16341177099997
						],
						[
							141.4949727930001,
							-34.15459766199996
						],
						[
							141.51875026800008,
							-34.18089689399994
						],
						[
							141.506676609,
							-34.19060590299995
						],
						[
							141.51858304600012,
							-34.20314606399995
						],
						[
							141.50615511700005,
							-34.21048484299996
						],
						[
							141.51007725600005,
							-34.21646599299993
						],
						[
							141.53386995300002,
							-34.21068334499995
						],
						[
							141.53355317500007,
							-34.19142116399996
						],
						[
							141.5477444920001,
							-34.20082803499997
						],
						[
							141.56047538000007,
							-34.19088639599994
						],
						[
							141.58392851600001,
							-34.19880342699997
						],
						[
							141.5897496660001,
							-34.18688028699995
						],
						[
							141.60329152400004,
							-34.19121555799995
						],
						[
							141.60495407400003,
							-34.18392044799998
						],
						[
							141.5893901070001,
							-34.177340526999956
						],
						[
							141.60296570600008,
							-34.16224072799997
						],
						[
							141.58390898000005,
							-34.15195254699995
						],
						[
							141.60458621700002,
							-34.14910176799998
						],
						[
							141.61854491400004,
							-34.156274088999965
						],
						[
							141.61182460700002,
							-34.139010257999985
						],
						[
							141.62798919400007,
							-34.145403948999956
						],
						[
							141.63265944500006,
							-34.121471628999984
						],
						[
							141.654678772,
							-34.116675509999936
						],
						[
							141.67745632000003,
							-34.10121139199998
						],
						[
							141.70829153500006,
							-34.09633814299997
						],
						[
							141.71901791200003,
							-34.11488113399997
						],
						[
							141.72987834100002,
							-34.10556402399993
						],
						[
							141.72547561300007,
							-34.09401020399997
						],
						[
							141.73146555200003,
							-34.09094445399995
						],
						[
							141.7463493990001,
							-34.10339083499997
						],
						[
							141.76184326700002,
							-34.09752398599994
						],
						[
							141.75262995800006,
							-34.10622951599993
						],
						[
							141.75695373700012,
							-34.112083095999935
						],
						[
							141.77790439400007,
							-34.10176135699993
						],
						[
							141.7768933330001,
							-34.11686483699998
						],
						[
							141.78645219200007,
							-34.111672417999955
						],
						[
							141.8413902420001,
							-34.13243850099997
						],
						[
							141.85070042100006,
							-34.12429376099993
						],
						[
							141.85326411000005,
							-34.13122017099994
						],
						[
							141.86776980800005,
							-34.128638371999955
						],
						[
							141.87663348600006,
							-34.137404412999956
						],
						[
							141.88879627500012,
							-34.12440252299996
						],
						[
							141.88475084700008,
							-34.11497142299993
						],
						[
							141.90351132400008,
							-34.111137163999956
						],
						[
							141.922598181,
							-34.11455742499993
						],
						[
							141.92979042900004,
							-34.12577622599997
						],
						[
							141.9256356290001,
							-34.134591444999955
						],
						[
							141.93405918700012,
							-34.138243315999944
						],
						[
							141.945010367,
							-34.11946440599996
						],
						[
							141.9704435220001,
							-34.136094207999975
						],
						[
							141.96974869300004,
							-34.119884757999955
						],
						[
							141.97765740300008,
							-34.11268854799994
						],
						[
							142.02225229500004,
							-34.12521751099996
						],
						[
							142.01331830800007,
							-34.10536788999997
						],
						[
							142.0377776150001,
							-34.09980379199993
						],
						[
							142.04214867300004,
							-34.10598673199996
						],
						[
							142.02958631400008,
							-34.12612531099995
						],
						[
							142.07564482600003,
							-34.13140528399998
						],
						[
							142.06535247600004,
							-34.15059723299993
						],
						[
							142.0775456340001,
							-34.15733284399994
						],
						[
							142.08277731200008,
							-34.17353194499998
						],
						[
							142.11961979600005,
							-34.17489512699996
						],
						[
							142.1201191870001,
							-34.15687758699994
						],
						[
							142.1380078640001,
							-34.160118857999976
						],
						[
							142.14871073400002,
							-34.14874313799993
						],
						[
							142.16663590000007,
							-34.15312105899994
						],
						[
							142.1592649700001,
							-34.17116492899993
						],
						[
							142.1665357390001,
							-34.17138253899998
						],
						[
							142.16615456800002,
							-34.18291005899994
						],
						[
							142.17831517600007,
							-34.18372954999995
						],
						[
							142.1839063960001,
							-34.17568845999995
						],
						[
							142.19858700300006,
							-34.18348274099998
						],
						[
							142.21910894000007,
							-34.181050751999976
						],
						[
							142.22796855800004,
							-34.18945080299994
						],
						[
							142.22947464600009,
							-34.20804165299995
						],
						[
							142.23664375600003,
							-34.203777242999934
						],
						[
							142.2441863040001,
							-34.21152822399995
						],
						[
							142.23534042400001,
							-34.22373445399995
						],
						[
							142.24358641100002,
							-34.24575575399996
						],
						[
							142.23242617200003,
							-34.25603941399993
						],
						[
							142.24957152800005,
							-34.26691491499997
						],
						[
							142.24820530700003,
							-34.287312364999934
						],
						[
							142.2321335690001,
							-34.29769273399995
						],
						[
							142.23590043700005,
							-34.30696032399993
						],
						[
							142.25306372500006,
							-34.30612627499994
						],
						[
							142.26733894300003,
							-34.29527061599998
						],
						[
							142.27367905200003,
							-34.304007765999984
						],
						[
							142.2861389200001,
							-34.296523056999945
						],
						[
							142.298893388,
							-34.30568998799998
						],
						[
							142.28402998900003,
							-34.31074629699998
						],
						[
							142.28387997800007,
							-34.32655413699996
						],
						[
							142.29439287700006,
							-34.323437017999936
						],
						[
							142.33093136000002,
							-34.33936436999994
						],
						[
							142.36775425500002,
							-34.32689472199996
						],
						[
							142.39657231,
							-34.33773628299997
						],
						[
							142.39700651900012,
							-34.343788383999936
						],
						[
							142.38446483100006,
							-34.34690123299998
						],
						[
							142.3897580590001,
							-34.36278607299994
						],
						[
							142.37132360200007,
							-34.35783526199998
						],
						[
							142.3635372230001,
							-34.36214568199995
						],
						[
							142.37827605000007,
							-34.36473744299997
						],
						[
							142.36806351200005,
							-34.37063736199997
						],
						[
							142.37393403900012,
							-34.388137452999956
						],
						[
							142.36390344100005,
							-34.38566669199997
						],
						[
							142.35097559200005,
							-34.39661603099995
						],
						[
							142.36070097900006,
							-34.41175488199997
						],
						[
							142.35184346000005,
							-34.42227452099996
						],
						[
							142.36454555800003,
							-34.422690931999966
						],
						[
							142.35990385800005,
							-34.43192020199996
						],
						[
							142.3679431060001,
							-34.43540149199998
						],
						[
							142.35334101600006,
							-34.46956873199997
						],
						[
							142.37927375200002,
							-34.46669102299995
						],
						[
							142.3841695100001,
							-34.478077783999936
						],
						[
							142.36427405300003,
							-34.48470138299996
						],
						[
							142.359582272,
							-34.498765971999944
						],
						[
							142.36972844000002,
							-34.50380579299997
						],
						[
							142.37773358000004,
							-34.491383062999944
						],
						[
							142.39468759700003,
							-34.49347106399995
						],
						[
							142.37494881800012,
							-34.515270742999974
						],
						[
							142.39995257400005,
							-34.52227686499998
						],
						[
							142.36770162800008,
							-34.53043294299994
						],
						[
							142.3781894860001,
							-34.53213200399995
						],
						[
							142.3767114860001,
							-34.540972023999984
						],
						[
							142.39021738300005,
							-34.549105804999954
						],
						[
							142.40556472100002,
							-34.541495434999945
						],
						[
							142.40769953900008,
							-34.56795863599996
						],
						[
							142.42606891600008,
							-34.56233520699993
						],
						[
							142.43018429500012,
							-34.57478011699993
						],
						[
							142.44492955200008,
							-34.57547658799996
						],
						[
							142.45162859100003,
							-34.58425175799994
						],
						[
							142.45875407000005,
							-34.58148423899996
						],
						[
							142.44885412300005,
							-34.55947000799995
						],
						[
							142.46797444000003,
							-34.564282068999944
						],
						[
							142.47271130800004,
							-34.57668191899995
						],
						[
							142.4583697590001,
							-34.58756175899998
						],
						[
							142.47127076700008,
							-34.59266377899996
						],
						[
							142.4613137870001,
							-34.60655232899995
						],
						[
							142.46826370600002,
							-34.61292051899994
						],
						[
							142.45916660700004,
							-34.61627576899997
						],
						[
							142.46399543500002,
							-34.626664018999975
						],
						[
							142.45233359600002,
							-34.63348498899995
						],
						[
							142.47108345300012,
							-34.640122109999936
						],
						[
							142.4836511310001,
							-34.63642170999998
						],
						[
							142.47166055200012,
							-34.65178297999995
						],
						[
							142.47559243900002,
							-34.67260493999993
						],
						[
							142.49312395700008,
							-34.672188560999984
						],
						[
							142.48695909800006,
							-34.66342745099996
						],
						[
							142.4995944860001,
							-34.66483706199995
						],
						[
							142.50567877600008,
							-34.65693514199995
						],
						[
							142.5158622240001,
							-34.66367013299998
						],
						[
							142.49743456600004,
							-34.67428167199995
						],
						[
							142.51367532200004,
							-34.69220377299996
						],
						[
							142.49975074300005,
							-34.703124801999934
						],
						[
							142.51895623000007,
							-34.702932662999956
						],
						[
							142.49956538000004,
							-34.73910398199996
						],
						[
							142.51169460800008,
							-34.74107080299996
						],
						[
							142.50811692800005,
							-34.74949828299998
						],
						[
							142.5242214640001,
							-34.75936757399995
						],
						[
							142.5335660930001,
							-34.75305398399996
						],
						[
							142.55675107800005,
							-34.77536034599996
						],
						[
							142.567182687,
							-34.76691516599993
						],
						[
							142.61682757800008,
							-34.78548589899998
						],
						[
							142.63932902500005,
							-34.78025831999997
						],
						[
							142.64637067500007,
							-34.76330243099994
						],
						[
							142.62050419000002,
							-34.75711428899996
						],
						[
							142.61832258200002,
							-34.72873853899995
						],
						[
							142.6373404090001,
							-34.73503039999997
						],
						[
							142.6614187460001,
							-34.72169340099998
						],
						[
							142.6674188940001,
							-34.73589493199995
						],
						[
							142.6789609320001,
							-34.739188372999934
						],
						[
							142.68666338100002,
							-34.73391547299997
						],
						[
							142.67656038300004,
							-34.729032761999974
						],
						[
							142.678652843,
							-34.72233170199996
						],
						[
							142.69941216000007,
							-34.72446026399996
						],
						[
							142.6844798730001,
							-34.714037202999975
						],
						[
							142.69107935300008,
							-34.70137675299998
						],
						[
							142.67890607700008,
							-34.68083419199996
						],
						[
							142.68415064700002,
							-34.67087071199995
						],
						[
							142.70592544300007,
							-34.67949421399993
						],
						[
							142.71076007200008,
							-34.67575673399995
						],
						[
							142.70861426400006,
							-34.66215384399993
						],
						[
							142.68921303800005,
							-34.65253315299998
						],
						[
							142.700794878,
							-34.62450223299993
						],
						[
							142.70879573700006,
							-34.62265013399997
						],
						[
							142.6895103810001,
							-34.618284451999955
						],
						[
							142.70397271900003,
							-34.61349378299997
						],
						[
							142.69998735100012,
							-34.599366292999946
						],
						[
							142.71482799800003,
							-34.60042986399998
						],
						[
							142.72362252800008,
							-34.592272193999975
						],
						[
							142.74319851400003,
							-34.60279808499996
						],
						[
							142.75917981100008,
							-34.60012279599994
						],
						[
							142.76341237200006,
							-34.59042318699994
						],
						[
							142.74690429400005,
							-34.58776642599997
						],
						[
							142.7482975150001,
							-34.576746525999965
						],
						[
							142.7837642290001,
							-34.579063477999966
						],
						[
							142.77020711300008,
							-34.56794613699998
						],
						[
							142.78751082100007,
							-34.55904709799995
						],
						[
							142.79143490100012,
							-34.54637560799995
						],
						[
							142.81011018700008,
							-34.560841798999945
						],
						[
							142.78690269800006,
							-34.589343817999975
						],
						[
							142.79792566600008,
							-34.59761544899993
						],
						[
							142.8106447240001,
							-34.58929240899994
						],
						[
							142.8033501440001,
							-34.60707846899993
						],
						[
							142.81826504100002,
							-34.61242901999998
						],
						[
							142.82378363100008,
							-34.60048103999998
						],
						[
							142.8406859470001,
							-34.625738430999945
						],
						[
							142.85247310500006,
							-34.619181451999964
						],
						[
							142.86834821200011,
							-34.627441672999964
						],
						[
							142.8553881030001,
							-34.63866183199997
						],
						[
							142.87187300000005,
							-34.650278912999966
						],
						[
							142.8605576000001,
							-34.66514871299995
						],
						[
							142.8721579480001,
							-34.66410553299994
						],
						[
							142.8758877570001,
							-34.67484607399996
						],
						[
							142.88646337500006,
							-34.67207173399993
						],
						[
							142.8868219950001,
							-34.67979490399995
						],
						[
							142.90018238300001,
							-34.67145109499995
						],
						[
							142.89327579500002,
							-34.665665554999975
						],
						[
							142.9015336450001,
							-34.654944744999966
						],
						[
							142.92385032200002,
							-34.647843275999946
						],
						[
							142.9222734210001,
							-34.65646960599997
						],
						[
							142.93261208,
							-34.65550188699996
						],
						[
							142.94887369600008,
							-34.66966157799993
						],
						[
							142.95926991500005,
							-34.66496879899995
						],
						[
							142.97271489000002,
							-34.695193709999955
						],
						[
							142.9824339700001,
							-34.682727159999956
						],
						[
							142.9752887620001,
							-34.670848329999956
						],
						[
							142.98932005000006,
							-34.66256626999996
						],
						[
							142.99457971800007,
							-34.67385854099996
						],
						[
							143.01728701500008,
							-34.67364706199993
						],
						[
							143.01018602400006,
							-34.69364464199998
						],
						[
							143.03250819200002,
							-34.68291499299994
						],
						[
							143.02943000100004,
							-34.69183800299993
						],
						[
							143.03947443900006,
							-34.70259757399998
						],
						[
							143.0404282500001,
							-34.68587509399998
						],
						[
							143.05482884700007,
							-34.69884140499994
						],
						[
							143.07076937600004,
							-34.678366935999975
						],
						[
							143.07622881400005,
							-34.695945105999954
						],
						[
							143.09283476100006,
							-34.701259756999946
						],
						[
							143.1123486790001,
							-34.680889957999966
						],
						[
							143.12109494800006,
							-34.68747278899997
						],
						[
							143.1114284790001,
							-34.68719891799998
						],
						[
							143.1070660580001,
							-34.70153734799993
						],
						[
							143.12761473600006,
							-34.69273249899993
						],
						[
							143.11803029700002,
							-34.70297907899993
						],
						[
							143.13347003400008,
							-34.70056392899994
						],
						[
							143.1474057810001,
							-34.71474415999995
						],
						[
							143.1616959800001,
							-34.69790262099997
						],
						[
							143.16536696800006,
							-34.71812258199998
						],
						[
							143.1732040270001,
							-34.719695961999946
						],
						[
							143.18099335600004,
							-34.70946826199997
						],
						[
							143.17928877600002,
							-34.717315301999975
						],
						[
							143.20009222300007,
							-34.71704945399995
						],
						[
							143.20091975100001,
							-34.73343373399996
						],
						[
							143.2188540190001,
							-34.72945697499995
						],
						[
							143.2138532790001,
							-34.73848232499995
						],
						[
							143.22439531500004,
							-34.75871199499994
						],
						[
							143.2287810050001,
							-34.747775385999944
						],
						[
							143.24066711400008,
							-34.74544759599996
						],
						[
							143.24893269100005,
							-34.757842806999975
						],
						[
							143.26529119000008,
							-34.74854526799993
						],
						[
							143.27402238800005,
							-34.75267184799998
						],
						[
							143.25213609900004,
							-34.77278976699995
						],
						[
							143.2577337880001,
							-34.77852911799994
						],
						[
							143.2730116560001,
							-34.776399347999984
						],
						[
							143.27674199400008,
							-34.79224754899997
						],
						[
							143.28688009200005,
							-34.79497190899997
						],
						[
							143.28433343300003,
							-34.78523245899993
						],
						[
							143.29429187100004,
							-34.790808959999936
						],
						[
							143.30885090000004,
							-34.779925710999976
						],
						[
							143.31827607800005,
							-34.790829050999946
						],
						[
							143.32909734600003,
							-34.78634426199994
						],
						[
							143.33299376500008,
							-34.793193851999945
						],
						[
							143.3478831330001,
							-34.79162234299997
						],
						[
							143.34756528100002,
							-34.807288692999975
						],
						[
							143.35956504900003,
							-34.81688644399998
						],
						[
							143.3411971390001,
							-34.84629608299997
						],
						[
							143.3549636470001,
							-34.846026423999945
						],
						[
							143.34521652800004,
							-34.85345053299994
						],
						[
							143.35256945600008,
							-34.85822192399996
						],
						[
							143.33840996700008,
							-34.87029973299997
						],
						[
							143.3421180260001,
							-34.881238432999965
						],
						[
							143.32130011800007,
							-34.88872190199993
						],
						[
							143.34025582300012,
							-34.91377140299994
						],
						[
							143.34269676100007,
							-34.93286118399993
						],
						[
							143.33850228000006,
							-34.94424895399993
						],
						[
							143.33284737200006,
							-34.938745652999955
						],
						[
							143.32179756300002,
							-34.942518262999954
						],
						[
							143.31722647300012,
							-34.95334556199998
						],
						[
							143.32378059000007,
							-34.97882911299996
						],
						[
							143.3186458990001,
							-34.99295513299995
						],
						[
							143.32970074700006,
							-34.99555305299998
						],
						[
							143.3381241940001,
							-35.01087855399993
						],
						[
							143.33599352200008,
							-35.03736235399998
						],
						[
							143.32208759500008,
							-35.036713662999944
						],
						[
							143.3286858030001,
							-35.04588675399998
						],
						[
							143.3365496120001,
							-35.04320700399995
						],
						[
							143.3304986820001,
							-35.05386644399994
						],
						[
							143.33677842100008,
							-35.04813480399997
						],
						[
							143.3376691300001,
							-35.061280763999946
						],
						[
							143.3508437480001,
							-35.06468886499994
						],
						[
							143.34966536700006,
							-35.06991536499993
						],
						[
							143.33906473900004,
							-35.06817763399994
						],
						[
							143.3455267280001,
							-35.07404258499997
						],
						[
							143.33745278800006,
							-35.080404563999934
						],
						[
							143.3450298360001,
							-35.08700647499995
						],
						[
							143.3408642060001,
							-35.09570106499996
						],
						[
							143.34810863400003,
							-35.10542737499998
						],
						[
							143.3528913340001,
							-35.09961736499997
						],
						[
							143.36076861300012,
							-35.10301902599997
						],
						[
							143.36197389100005,
							-35.11688685599995
						],
						[
							143.3906537040001,
							-35.14509373799996
						],
						[
							143.38223609400006,
							-35.15634870799994
						],
						[
							143.38207062300012,
							-35.17334794799996
						],
						[
							143.3899411120001,
							-35.17108055799997
						],
						[
							143.3939683200001,
							-35.17727379899998
						],
						[
							143.38816603100008,
							-35.185824597999954
						],
						[
							143.41650666500004,
							-35.194875069999966
						],
						[
							143.44949254100004,
							-35.18909881199994
						],
						[
							143.47148791400002,
							-35.219280253999955
						],
						[
							143.51832792800008,
							-35.21160738599997
						],
						[
							143.52916145500012,
							-35.21990836699996
						],
						[
							143.54834178300007,
							-35.21377728799996
						],
						[
							143.54702930400003,
							-35.206159527999944
						],
						[
							143.5708340000001,
							-35.206891549999966
						],
						[
							143.58099053700005,
							-35.220023089999984
						],
						[
							143.56372403700004,
							-35.243532699999946
						],
						[
							143.5740826650001,
							-35.25649251999994
						],
						[
							143.57169580400011,
							-35.26794632999997
						],
						[
							143.58351357200002,
							-35.26499204099997
						],
						[
							143.59086651000007,
							-35.28164602099997
						],
						[
							143.57794352000008,
							-35.30318354099995
						],
						[
							143.5690252810001,
							-35.302434139999946
						],
						[
							143.56137961000002,
							-35.32458971999995
						],
						[
							143.56627241800004,
							-35.34321511999997
						],
						[
							143.57352926700003,
							-35.33722911099994
						],
						[
							143.59712452200006,
							-35.351051481999946
						],
						[
							143.60302145000003,
							-35.36539419299993
						],
						[
							143.61604376700006,
							-35.368871103999936
						],
						[
							143.61955841500003,
							-35.38684266399997
						],
						[
							143.63302539300003,
							-35.383454204999964
						],
						[
							143.62938778300008,
							-35.39235528499995
						],
						[
							143.6404176110001,
							-35.40105681499995
						],
						[
							143.65714607900009,
							-35.38498638599998
						],
						[
							143.66808698800003,
							-35.38572238699993
						],
						[
							143.6674952190001,
							-35.37141523699995
						],
						[
							143.68263346600008,
							-35.37407783799995
						],
						[
							143.6842306970001,
							-35.36816886799994
						],
						[
							143.69315505400004,
							-35.383904358999985
						],
						[
							143.70235274300012,
							-35.37768598899993
						],
						[
							143.70335584200006,
							-35.389395288999935
						],
						[
							143.7116910410001,
							-35.38467731999998
						],
						[
							143.70918117000008,
							-35.392525589999934
						],
						[
							143.73963830500008,
							-35.39358134199995
						],
						[
							143.75101034400006,
							-35.38782219199993
						],
						[
							143.76883003000012,
							-35.401795542999935
						],
						[
							143.7588075100001,
							-35.41541361299994
						],
						[
							143.76596837900001,
							-35.41584486299996
						],
						[
							143.76285797900005,
							-35.42305343299995
						],
						[
							143.79012345500007,
							-35.422464194999975
						],
						[
							143.80016813200007,
							-35.433435875999976
						],
						[
							143.8180234790001,
							-35.437531856999954
						],
						[
							143.81302657900005,
							-35.44625224699996
						],
						[
							143.84604162200003,
							-35.46327913899995
						],
						[
							143.8554418110001,
							-35.461825568999984
						],
						[
							143.85879045800004,
							-35.47996489999997
						],
						[
							143.87138710600004,
							-35.47781545999993
						],
						[
							143.87659049500007,
							-35.486153410999975
						],
						[
							143.90773892900006,
							-35.49414888299998
						],
						[
							143.9061894890001,
							-35.499944952999954
						],
						[
							143.91222752800002,
							-35.494875252999975
						],
						[
							143.91826740700003,
							-35.500748183999974
						],
						[
							143.93505143400012,
							-35.499274224999965
						],
						[
							143.9333606040001,
							-35.50659697499998
						],
						[
							143.97010738900008,
							-35.50006487699994
						],
						[
							143.97253900700002,
							-35.509565486999975
						],
						[
							143.9624475480001,
							-35.51396746699993
						],
						[
							143.9746659550001,
							-35.53254369699994
						],
						[
							143.99673630100006,
							-35.53593177899995
						],
						[
							143.9992266600001,
							-35.54535403899996
						],
						[
							143.9898712800001,
							-35.55465080899995
						],
						[
							144.00965165600007,
							-35.56329384999998
						],
						[
							144.01270787700003,
							-35.554059809999956
						],
						[
							144.0340887530001,
							-35.55595801099997
						],
						[
							144.03922172300008,
							-35.549243761999946
						],
						[
							144.0468067500001,
							-35.563128871999936
						],
						[
							144.0639640070001,
							-35.57053229299993
						],
						[
							144.0622915660001,
							-35.576755342999945
						],
						[
							144.10502150800005,
							-35.59076754599994
						],
						[
							144.11755250300007,
							-35.625912926999945
						],
						[
							144.13149394900006,
							-35.64074828799994
						],
						[
							144.1429328270001,
							-35.64723910899994
						],
						[
							144.15263535500003,
							-35.64266483999995
						],
						[
							144.16235635100008,
							-35.671512949999965
						],
						[
							144.186794017,
							-35.67041778199996
						],
						[
							144.19514468400007,
							-35.685845212999936
						],
						[
							144.21348836100003,
							-35.68665782399995
						],
						[
							144.22165364900002,
							-35.69393922399996
						],
						[
							144.2159585290001,
							-35.70646356399993
						],
						[
							144.2481558720001,
							-35.721020625999984
						],
						[
							144.26450160700006,
							-35.75138988799995
						],
						[
							144.27050509600008,
							-35.75398681799993
						],
						[
							144.27784545600002,
							-35.74074079799993
						],
						[
							144.29606707300002,
							-35.737077599999964
						],
						[
							144.30128478200004,
							-35.742972409999936
						],
						[
							144.29528250200008,
							-35.75436552999997
						],
						[
							144.32783814700008,
							-35.75263301199993
						],
						[
							144.318657217,
							-35.766561500999956
						],
						[
							144.33640116300012,
							-35.77038104199994
						],
						[
							144.34152793300007,
							-35.76388781299994
						],
						[
							144.34295432200008,
							-35.77153557299994
						],
						[
							144.34911711200004,
							-35.76712886299998
						],
						[
							144.35155238900006,
							-35.78505559399997
						],
						[
							144.36028868800008,
							-35.78479746399995
						],
						[
							144.35534414900008,
							-35.78846524399995
						],
						[
							144.36233529700007,
							-35.79582085399994
						],
						[
							144.37685573500005,
							-35.792965934999984
						],
						[
							144.3667154540001,
							-35.81124001499995
						],
						[
							144.37749075200009,
							-35.81433294499993
						],
						[
							144.3688741940001,
							-35.81321616499997
						],
						[
							144.36481254400007,
							-35.82092379499994
						],
						[
							144.38412478100008,
							-35.819552115999954
						],
						[
							144.37219584100012,
							-35.83193749499998
						],
						[
							144.3866136590001,
							-35.83610967599998
						],
						[
							144.37308256100005,
							-35.83726578499994
						],
						[
							144.3843199790001,
							-35.84190940599996
						],
						[
							144.38143947800006,
							-35.85241028599995
						],
						[
							144.39032459700002,
							-35.85053956699994
						],
						[
							144.38889092600004,
							-35.85846715599996
						],
						[
							144.39864141400005,
							-35.862653586999954
						],
						[
							144.4113944820001,
							-35.858990277999965
						],
						[
							144.40193228300006,
							-35.868006596999976
						],
						[
							144.41094253100005,
							-35.87117560799993
						],
						[
							144.40363435200004,
							-35.880653017999975
						],
						[
							144.4181889780001,
							-35.89320659899994
						],
						[
							144.40854469900012,
							-35.89887767799996
						],
						[
							144.40972535800006,
							-35.90477754799997
						],
						[
							144.4247104860001,
							-35.90046703899998
						],
						[
							144.4157794570001,
							-35.90904504899993
						],
						[
							144.42343451600004,
							-35.905991868999934
						],
						[
							144.44102181000005,
							-35.93263296999993
						],
						[
							144.46047082600012,
							-35.93958088199997
						],
						[
							144.4662122860001,
							-35.93332975199996
						],
						[
							144.46385287600003,
							-35.94057175199998
						],
						[
							144.4722388140001,
							-35.94071264299998
						],
						[
							144.4669319850001,
							-35.94618908199993
						],
						[
							144.47942052300004,
							-35.94526227299997
						],
						[
							144.47976406200007,
							-35.95328246299994
						],
						[
							144.48758843100006,
							-35.94949862399994
						],
						[
							144.48123587100008,
							-35.958595222999975
						],
						[
							144.48864421000007,
							-35.95711011399993
						],
						[
							144.49365305800006,
							-35.96839152399997
						],
						[
							144.5013695980001,
							-35.958069644999966
						],
						[
							144.5004728570001,
							-35.97022723499998
						],
						[
							144.51516668500005,
							-35.965452665999976
						],
						[
							144.510816685,
							-35.97387099499997
						],
						[
							144.5216955730001,
							-35.97201865599993
						],
						[
							144.51579175200004,
							-35.994426465999936
						],
						[
							144.5536671850001,
							-36.00297110799994
						],
						[
							144.55766102300004,
							-36.01409397899994
						],
						[
							144.56339120300004,
							-36.00779291899994
						],
						[
							144.57113376000007,
							-36.02406596999998
						],
						[
							144.57933815900003,
							-36.021013979999964
						],
						[
							144.58645096700002,
							-36.027169200999936
						],
						[
							144.58328146700012,
							-36.039012140999944
						],
						[
							144.60665717200004,
							-36.04255458199998
						],
						[
							144.615478692,
							-36.03158060299995
						],
						[
							144.6084383100001,
							-36.06362754199995
						],
						[
							144.61675969700002,
							-36.07664633299993
						],
						[
							144.6282277570001,
							-36.06524656399995
						],
						[
							144.61830609900005,
							-36.05969472299995
						],
						[
							144.6262947670001,
							-36.06178753399996
						],
						[
							144.62500515800002,
							-36.05206823299994
						],
						[
							144.63275022800008,
							-36.048084123999956
						],
						[
							144.64392678500008,
							-36.056650814999955
						],
						[
							144.65319753400001,
							-36.05322719499998
						],
						[
							144.65497146100006,
							-36.075335905999964
						],
						[
							144.65802803100007,
							-36.07036610599994
						],
						[
							144.66474059900008,
							-36.07651803599998
						],
						[
							144.66786191000006,
							-36.068583915999966
						],
						[
							144.6887150870001,
							-36.06127215799995
						],
						[
							144.68424634400003,
							-36.09551827799993
						],
						[
							144.7190310200001,
							-36.08589168999998
						],
						[
							144.72603512800004,
							-36.09062191999993
						],
						[
							144.71840848700003,
							-36.11355193999998
						],
						[
							144.73369408400004,
							-36.11702400099995
						],
						[
							144.74066390400003,
							-36.10757411199995
						],
						[
							144.7533914400001,
							-36.12245182199996
						],
						[
							144.77156097800002,
							-36.116003983999974
						],
						[
							144.77798046600003,
							-36.129906183999935
						],
						[
							144.7985575240001,
							-36.11318651499994
						],
						[
							144.7965823940001,
							-36.11985628499997
						],
						[
							144.80849721100003,
							-36.12326585599993
						],
						[
							144.81336811100005,
							-36.113899585999945
						],
						[
							144.8064046930001,
							-36.10744457599998
						],
						[
							144.81636218100004,
							-36.109681386999966
						],
						[
							144.8101924330001,
							-36.102249865999966
						],
						[
							144.81990962100008,
							-36.10793456699997
						],
						[
							144.84192792800002,
							-36.10056352799995
						],
						[
							144.84196556000006,
							-36.08296019799997
						],
						[
							144.8506163090001,
							-36.08132200899996
						],
						[
							144.84718252000005,
							-36.07286837799995
						],
						[
							144.8564799090001,
							-36.07353988899996
						],
						[
							144.8563176890001,
							-36.06561376899998
						],
						[
							144.86149246800005,
							-36.071718568999984
						],
						[
							144.86326526900007,
							-36.05913972899998
						],
						[
							144.932620057,
							-36.06703601399994
						],
						[
							144.94829604300003,
							-36.08289071499996
						],
						[
							144.98164163800004,
							-36.07255940799996
						],
						[
							144.98593781900001,
							-36.056496547999984
						],
						[
							144.96781426400003,
							-36.04206497699994
						],
						[
							144.96183697700008,
							-36.01820249599996
						],
						[
							144.94550527,
							-36.012172634999956
						],
						[
							144.94576527100003,
							-36.004298794999954
						],
						[
							144.92362193600002,
							-35.98893804299996
						],
						[
							144.93101140700003,
							-35.96845650399996
						],
						[
							144.95742910400008,
							-35.96088481499993
						],
						[
							144.94891382800006,
							-35.93166867399998
						],
						[
							144.97496093900008,
							-35.88383179599998
						],
						[
							144.9682524420001,
							-35.865400844999954
						],
						[
							145.000584988,
							-35.849316786999964
						],
						[
							145.01933506500006,
							-35.85653120899997
						],
						[
							145.03891088300009,
							-35.838279099999966
						],
						[
							145.06809180900007,
							-35.83537440199996
						],
						[
							145.07412638900007,
							-35.82671922199995
						],
						[
							145.07648613800006,
							-35.83180907299993
						],
						[
							145.09175421600003,
							-35.82594182399998
						],
						[
							145.0924976350001,
							-35.83581179399994
						],
						[
							145.11423095300006,
							-35.82051791499998
						],
						[
							145.11534212200002,
							-35.826025254999934
						],
						[
							145.12232741200012,
							-35.82079087599993
						],
						[
							145.1256400200001,
							-35.829784125999936
						],
						[
							145.12798510100004,
							-35.82080642599993
						],
						[
							145.1366421680001,
							-35.834257546999936
						],
						[
							145.13958500800004,
							-35.82852553699996
						],
						[
							145.15881066500003,
							-35.83076627799994
						],
						[
							145.1536446440001,
							-35.84306671799993
						],
						[
							145.18101932000002,
							-35.84201338999998
						],
						[
							145.18981283900007,
							-35.834254589999944
						],
						[
							145.22278963300005,
							-35.84243778299998
						],
						[
							145.22503518400003,
							-35.83217098299997
						],
						[
							145.24635953100005,
							-35.830330523999976
						],
						[
							145.26072233800005,
							-35.835412634999955
						],
						[
							145.25835871700008,
							-35.85062970499996
						],
						[
							145.26708036500008,
							-35.852432885999974
						],
						[
							145.27270456500003,
							-35.84518966599995
						],
						[
							145.29654776000007,
							-35.86055333799993
						],
						[
							145.32445919600002,
							-35.850673109999946
						],
						[
							145.355183419,
							-35.86707108199994
						],
						[
							145.38715630600007,
							-35.85012879399994
						],
						[
							145.4106312020001,
							-35.84859980599998
						],
						[
							145.4097269240001,
							-35.83654861599996
						],
						[
							145.42048261200011,
							-35.83727063699996
						],
						[
							145.4136345940001,
							-35.83133467599998
						],
						[
							145.41987989300003,
							-35.82816069599994
						],
						[
							145.44179938900004,
							-35.83564556799996
						],
						[
							145.45066425900006,
							-35.82140495899995
						],
						[
							145.46253216600007,
							-35.82685621899998
						],
						[
							145.472134277,
							-35.809217399999966
						],
						[
							145.49198266300004,
							-35.81506325099997
						],
						[
							145.50256182200008,
							-35.80943549199998
						],
						[
							145.5216598080001,
							-35.81864226399995
						],
						[
							145.53570214700005,
							-35.80199174399996
						],
						[
							145.53876964500012,
							-35.82180003499997
						],
						[
							145.546747234,
							-35.81288145499997
						],
						[
							145.5628413720001,
							-35.81343590599994
						],
						[
							145.55800270100008,
							-35.82821739599996
						],
						[
							145.56684585000005,
							-35.82648412699996
						],
						[
							145.56401712900004,
							-35.83417662699998
						],
						[
							145.59323663300006,
							-35.84906417899998
						],
						[
							145.5867973930001,
							-35.86123167799997
						],
						[
							145.59803470100007,
							-35.86144449899996
						],
						[
							145.60114103900003,
							-35.87499496899994
						],
						[
							145.60175416000004,
							-35.86784378899995
						],
						[
							145.62635313600003,
							-35.862745160999964
						],
						[
							145.6283265950001,
							-35.86776233099994
						],
						[
							145.61486342700005,
							-35.87255751999993
						],
						[
							145.62813951500004,
							-35.87539641099994
						],
						[
							145.62032720500008,
							-35.883871640999985
						],
						[
							145.6295761140001,
							-35.880091851999964
						],
						[
							145.6397361710001,
							-35.89422625199995
						],
						[
							145.65745441700005,
							-35.900673293999944
						],
						[
							145.66912693300003,
							-35.919573224999965
						],
						[
							145.6790590820001,
							-35.91681595499995
						],
						[
							145.67387059200007,
							-35.925879864999956
						],
						[
							145.68585741900006,
							-35.93060282599998
						],
						[
							145.69818665800005,
							-35.92096440699993
						],
						[
							145.69733335700005,
							-35.93648862699996
						],
						[
							145.7202804530001,
							-35.93443634799996
						],
						[
							145.72630660200002,
							-35.94229868899998
						],
						[
							145.7167713220001,
							-35.95058146799994
						],
						[
							145.7341453990001,
							-35.95128876899997
						],
						[
							145.73071474900007,
							-35.95847683899996
						],
						[
							145.74611519600012,
							-35.964225289999945
						],
						[
							145.75790305500004,
							-35.958075390999966
						],
						[
							145.76611123300006,
							-35.96667476199997
						],
						[
							145.7782172410001,
							-35.96023045299995
						],
						[
							145.7768891400001,
							-35.972428312999966
						],
						[
							145.79273800800001,
							-35.972788073999936
						],
						[
							145.79345057600005,
							-35.98280422399995
						],
						[
							145.807985894,
							-35.98374898499998
						],
						[
							145.81004106300009,
							-35.99135417499997
						],
						[
							145.81667876200004,
							-35.98839625599993
						],
						[
							145.81135862300005,
							-35.98408908499994
						],
						[
							145.82825804100003,
							-35.98296925599993
						],
						[
							145.82755373200007,
							-35.97542484599995
						],
						[
							145.8400265690001,
							-35.98323040699995
						],
						[
							145.84859529800008,
							-35.980886477999945
						],
						[
							145.84555442900012,
							-35.97344700799994
						],
						[
							145.85800298700008,
							-35.97527159799995
						],
						[
							145.84791395900004,
							-35.96842863799998
						],
						[
							145.8540477690001,
							-35.95991381799996
						],
						[
							145.90269934200012,
							-35.95248265199996
						],
						[
							145.910320801,
							-35.95594836199996
						],
						[
							145.90076163100002,
							-35.96151573099996
						],
						[
							145.90293931000008,
							-35.96884264199997
						],
						[
							145.90609000000006,
							-35.96324923199995
						],
						[
							145.9138213880001,
							-35.96954878199995
						],
						[
							145.9258271970001,
							-35.96455033299998
						],
						[
							145.9280059560001,
							-35.973933803999955
						],
						[
							145.95372165300012,
							-35.96154240499993
						],
						[
							145.9441766440001,
							-35.96686123499995
						],
						[
							145.95107715200004,
							-35.97661343499993
						],
						[
							145.94574980200002,
							-35.98379610499995
						],
						[
							145.96482366700002,
							-35.996757085999946
						],
						[
							145.9583423670001,
							-36.00696006599998
						],
						[
							145.97131953500002,
							-36.00563889699998
						],
						[
							145.97182160400007,
							-36.015659676999974
						],
						[
							146.00587211000004,
							-36.00355564899996
						],
						[
							146.01614896800004,
							-36.00694878999997
						],
						[
							146.0314935670001,
							-35.99470041099994
						],
						[
							146.04842732300006,
							-36.00314455199998
						],
						[
							146.05235219300005,
							-35.99545238299993
						],
						[
							146.05930122000007,
							-36.014534812999955
						],
						[
							146.07138590800002,
							-36.01564279399997
						],
						[
							146.07355583800006,
							-36.00962364399993
						],
						[
							146.07564482700002,
							-36.01816384499995
						],
						[
							146.09220540400008,
							-36.02125287599995
						],
						[
							146.09147634500005,
							-36.00946357599997
						],
						[
							146.10077721400012,
							-36.01304151599993
						],
						[
							146.1123839920001,
							-36.00679817699995
						],
						[
							146.10768412200002,
							-36.01435544699996
						],
						[
							146.11872396,
							-36.018001347999984
						],
						[
							146.1347668090001,
							-36.00253365899994
						],
						[
							146.14065530800008,
							-36.00894073899997
						],
						[
							146.13169617900007,
							-36.010527568999976
						],
						[
							146.13153604800004,
							-36.01952677899993
						],
						[
							146.14586910600008,
							-36.01376276999997
						],
						[
							146.1546860940001,
							-36.02514615999996
						],
						[
							146.1731100610001,
							-36.01928024199998
						],
						[
							146.1772805490001,
							-36.03402765199996
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "114",
				"CED_NAME21": "Farrer",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 126562.8993,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/114",
				"SHAPE_Leng": 33.2520060265,
				"SHAPE_Area": 12.4017004554
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							150.98552346200006,
							-33.87047938599994
						],
						[
							150.96133148500007,
							-33.86756730399998
						],
						[
							150.9624752840001,
							-33.87853032399994
						],
						[
							150.94500853500006,
							-33.88566394199995
						],
						[
							150.91657282100005,
							-33.874445229999935
						],
						[
							150.9164284630001,
							-33.85888825999996
						],
						[
							150.8765729900001,
							-33.85110971599994
						],
						[
							150.87043142900006,
							-33.865377414999955
						],
						[
							150.85367231100008,
							-33.86314821399998
						],
						[
							150.84245348100012,
							-33.87623628299997
						],
						[
							150.88911069200003,
							-33.89306201699998
						],
						[
							150.90768546700008,
							-33.91411730899995
						],
						[
							150.8986528470001,
							-33.92654734799993
						],
						[
							150.906412745,
							-33.92740730899993
						],
						[
							150.904571464,
							-33.93765528899996
						],
						[
							150.91893275200005,
							-33.939083359999984
						],
						[
							150.9281180920001,
							-33.926880780999966
						],
						[
							150.96860362600012,
							-33.931061704999934
						],
						[
							150.9790524450001,
							-33.92914864599993
						],
						[
							150.9731132080001,
							-33.907555644999945
						],
						[
							150.97945011800005,
							-33.90634060599996
						],
						[
							150.96715115200004,
							-33.890130564999936
						],
						[
							150.98552346200006,
							-33.87047938599994
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "115",
				"CED_NAME21": "Fowler",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 60.2618,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/115",
				"SHAPE_Leng": 0.54165004846,
				"SHAPE_Area": 0.00587334481461
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								150.70195618500009,
								-35.12301691899995
							],
							[
								150.6916133320001,
								-35.08314828699997
							],
							[
								150.69796433300007,
								-35.07112228799997
							],
							[
								150.6768333560001,
								-35.06901328599997
							],
							[
								150.67951537900012,
								-35.04924627599996
							],
							[
								150.6711353820001,
								-35.037140284999964
							],
							[
								150.69300337100003,
								-35.013571286999934
							],
							[
								150.72840234700004,
								-35.00753628999996
							],
							[
								150.72703534900006,
								-34.99613627999997
							],
							[
								150.75389934500004,
								-34.990994272999956
							],
							[
								150.77165937100006,
								-35.00498127399993
							],
							[
								150.77827634000005,
								-35.00243528499993
							],
							[
								150.76725736000003,
								-35.01516029399994
							],
							[
								150.78711634400008,
								-35.03621429599997
							],
							[
								150.77574334300004,
								-35.05413128499998
							],
							[
								150.77619433900009,
								-35.08302728499996
							],
							[
								150.7862643190001,
								-35.07252929599997
							],
							[
								150.80617429300003,
								-35.094339297999966
							],
							[
								150.833432312,
								-35.07470028999995
							],
							[
								150.84057430300004,
								-35.06040029099995
							],
							[
								150.8429883440001,
								-35.05062330099997
							],
							[
								150.83165133700004,
								-35.041171299999974
							],
							[
								150.8497203380001,
								-35.012878290999936
							],
							[
								150.84303135000005,
								-35.00442229099997
							],
							[
								150.82936432200006,
								-35.00289429999998
							],
							[
								150.82161935200008,
								-35.01460329899993
							],
							[
								150.8139423130001,
								-35.01391727799995
							],
							[
								150.78765535000002,
								-34.99068429599998
							],
							[
								150.7763293280001,
								-34.94992829399996
							],
							[
								150.785758159,
								-34.93041628499998
							],
							[
								150.76862634200006,
								-34.926035282999976
							],
							[
								150.7709003660001,
								-34.895802282999966
							],
							[
								150.75578337800005,
								-34.896787281999934
							],
							[
								150.74837436200005,
								-34.872524290999934
							],
							[
								150.7550423660001,
								-34.83378629199996
							],
							[
								150.77662737800006,
								-34.79722128299994
							],
							[
								150.80983539600004,
								-34.77333328599997
							],
							[
								150.82514035300005,
								-34.78249228799996
							],
							[
								150.822904364,
								-34.773146286999975
							],
							[
								150.8370123850001,
								-34.75453429899994
							],
							[
								150.8333043880001,
								-34.738631287999965
							],
							[
								150.86094738000008,
								-34.68813027999994
							],
							[
								150.85509938300004,
								-34.67638527999998
							],
							[
								150.86470775200007,
								-34.67162511999993
							],
							[
								150.85677488300007,
								-34.67118416999995
							],
							[
								150.85474238500012,
								-34.662734299999954
							],
							[
								150.86548352500006,
								-34.648877039999945
							],
							[
								150.85580062700012,
								-34.642609068999946
							],
							[
								150.86089135800012,
								-34.62786993999998
							],
							[
								150.83778003400005,
								-34.61155254799996
							],
							[
								150.84800769900005,
								-34.635135108999975
							],
							[
								150.8450986800001,
								-34.63096109799994
							],
							[
								150.83247903100005,
								-34.63900924699993
							],
							[
								150.80019040500008,
								-34.64298328399997
							],
							[
								150.79017740200004,
								-34.602253272999974
							],
							[
								150.76829178600008,
								-34.598936580999975
							],
							[
								150.7581361760001,
								-34.61300974999995
							],
							[
								150.69847240600006,
								-34.60074627499995
							],
							[
								150.69042838600012,
								-34.60825827399998
							],
							[
								150.668041409,
								-34.60961726199997
							],
							[
								150.66700039800003,
								-34.61914828199997
							],
							[
								150.6568034290001,
								-34.62354027099997
							],
							[
								150.63473640200004,
								-34.62646026899995
							],
							[
								150.62290847100007,
								-34.644469837999964
							],
							[
								150.60396095300007,
								-34.65187196599993
							],
							[
								150.59069324600011,
								-34.64710105499995
							],
							[
								150.59076339400008,
								-34.65844203499995
							],
							[
								150.5763816650001,
								-34.66961814399997
							],
							[
								150.57706002100008,
								-34.695523213999934
							],
							[
								150.56715216300006,
								-34.69663128299993
							],
							[
								150.569071924,
								-34.68182721399995
							],
							[
								150.55935003600007,
								-34.68328729299998
							],
							[
								150.5664354160001,
								-34.67230726299994
							],
							[
								150.5590535220001,
								-34.63861924199995
							],
							[
								150.5534537210001,
								-34.65114528199996
							],
							[
								150.5463978030001,
								-34.64410031099993
							],
							[
								150.538770171,
								-34.664995430999966
							],
							[
								150.52623633400003,
								-34.65710349899996
							],
							[
								150.5025948860001,
								-34.667720696999936
							],
							[
								150.49825817500005,
								-34.68187974699998
							],
							[
								150.46922111000003,
								-34.678178973999934
							],
							[
								150.45179715000006,
								-34.69175606299996
							],
							[
								150.43272841400005,
								-34.689630240999975
							],
							[
								150.39814842700002,
								-34.70513625799998
							],
							[
								150.37145444600003,
								-34.74372925599994
							],
							[
								150.33821646,
								-34.74842223299993
							],
							[
								150.31475345,
								-34.77415424099996
							],
							[
								150.2900234650001,
								-34.76445923899996
							],
							[
								150.27650642600008,
								-34.76922823799998
							],
							[
								150.25581544700003,
								-34.79145123599994
							],
							[
								150.23695742900009,
								-34.793477233999965
							],
							[
								150.1937144320001,
								-34.81971223099998
							],
							[
								150.12742449200005,
								-34.81754423499996
							],
							[
								150.12143648500012,
								-34.80368723399994
							],
							[
								150.074225457,
								-34.768084219999935
							],
							[
								150.05620646900002,
								-34.77044122799998
							],
							[
								150.06687746600005,
								-34.78274921899998
							],
							[
								150.0419984780001,
								-34.79317822699994
							],
							[
								150.04669748600008,
								-34.80464922699997
							],
							[
								150.0361044970001,
								-34.808606226999984
							],
							[
								150.043761463,
								-34.827766216999976
							],
							[
								150.04061348000005,
								-34.86018722699998
							],
							[
								150.05275447500003,
								-34.88215121899998
							],
							[
								150.0757084700001,
								-34.89754322099998
							],
							[
								150.08686944800002,
								-34.89378123199998
							],
							[
								150.0816144680001,
								-34.905019220999975
							],
							[
								150.0918084750001,
								-34.911312221999935
							],
							[
								150.08824746400012,
								-34.92487422199997
							],
							[
								150.06776745600007,
								-34.93649622999993
							],
							[
								150.05552546400008,
								-34.96527221899993
							],
							[
								150.07879044900005,
								-34.97591522099998
							],
							[
								150.08578143600005,
								-34.98897322199997
							],
							[
								150.05191546900005,
								-35.00726322899993
							],
							[
								150.05291530700003,
								-35.01861156899997
							],
							[
								150.0646931650001,
								-35.02266845099996
							],
							[
								150.06159336300004,
								-35.03682651999998
							],
							[
								150.07609320000006,
								-35.042552401999956
							],
							[
								150.07245733000002,
								-35.050900490999936
							],
							[
								150.08765223700004,
								-35.05927139299996
							],
							[
								150.08908132500005,
								-35.06780840299996
							],
							[
								150.10793809200004,
								-35.072138234999954
							],
							[
								150.10588230000008,
								-35.08603432499996
							],
							[
								150.12940906500012,
								-35.09707016699997
							],
							[
								150.1416483470001,
								-35.14444718799996
							],
							[
								150.16975889200012,
								-35.14839994099998
							],
							[
								150.17580339900007,
								-35.165414220999935
							],
							[
								150.20392740400007,
								-35.17068722399995
							],
							[
								150.2150635480001,
								-35.203987834999964
							],
							[
								150.18632294300005,
								-35.199828052999976
							],
							[
								150.18744506000007,
								-35.220094022999945
							],
							[
								150.19498989900012,
								-35.21920297299994
							],
							[
								150.19793398700006,
								-35.22946194399998
							],
							[
								150.16868855000007,
								-35.239239140999985
							],
							[
								150.16437494700006,
								-35.26976512099998
							],
							[
								150.15192617900004,
								-35.266771209999945
							],
							[
								150.1379604110001,
								-35.27325223899993
							],
							[
								150.11660605100008,
								-35.29344644699995
							],
							[
								150.10541040400005,
								-35.28469922599993
							],
							[
								150.09803941400003,
								-35.29311621499994
							],
							[
								150.08604941600004,
								-35.29107822399993
							],
							[
								150.08537267400004,
								-35.305250703999945
							],
							[
								150.05105832900006,
								-35.309052950999956
							],
							[
								150.04466849900007,
								-35.31781394099994
							],
							[
								150.03804571800003,
								-35.33162188999995
							],
							[
								150.04672676500002,
								-35.34738384099995
							],
							[
								150.03701940400003,
								-35.36740721999996
							],
							[
								150.0384555280001,
								-35.40571776099995
							],
							[
								150.02088885000012,
								-35.41225685899997
							],
							[
								150.0073031400001,
								-35.429044947999955
							],
							[
								150.01409206800008,
								-35.43813290899993
							],
							[
								150.00538323800004,
								-35.44455994799995
							],
							[
								150.00206356500007,
								-35.47530197799995
							],
							[
								149.97740540600012,
								-35.490234215999976
							],
							[
								149.9790344050001,
								-35.50244321599996
							],
							[
								149.96405053700005,
								-35.500774304999936
							],
							[
								149.95743983400007,
								-35.53071740399997
							],
							[
								149.94932796600006,
								-35.529419433999976
							],
							[
								149.94913031400006,
								-35.54046252399996
							],
							[
								149.95676122300006,
								-35.54361936399994
							],
							[
								149.94285549300002,
								-35.553296512999964
							],
							[
								149.94597021100003,
								-35.56570166399996
							],
							[
								149.93007589400008,
								-35.56498210199993
							],
							[
								149.9351169370001,
								-35.61086473299997
							],
							[
								149.92207847800012,
								-35.61829892199995
							],
							[
								149.92183476600007,
								-35.63469989199996
							],
							[
								149.9084042280001,
								-35.637005950999935
							],
							[
								149.86262088500007,
								-35.71379369699997
							],
							[
								149.85416230500005,
								-35.72012679699998
							],
							[
								149.84014462800008,
								-35.71497088499996
							],
							[
								149.83955172700007,
								-35.72369099499997
							],
							[
								149.82983385900002,
								-35.721397973999956
							],
							[
								149.81449823900005,
								-35.736133122999945
							],
							[
								149.81712838600004,
								-35.75386626399995
							],
							[
								149.82649541400008,
								-35.75984321399994
							],
							[
								149.82019938500002,
								-35.757411203999936
							],
							[
								149.81219639500011,
								-35.769751192999934
							],
							[
								149.86001036400012,
								-35.793233217999955
							],
							[
								149.8595763730001,
								-35.805646217999936
							],
							[
								149.88694538800007,
								-35.80787220999997
							],
							[
								149.90162236300012,
								-35.83010721199997
							],
							[
								149.91515236100008,
								-35.83119522299995
							],
							[
								149.93228037400002,
								-35.86148621399997
							],
							[
								149.9485493410001,
								-35.863302215999965
							],
							[
								149.960361357,
								-35.880052226999965
							],
							[
								149.95900632400003,
								-35.90641021699997
							],
							[
								149.9797329600001,
								-35.91175143899994
							],
							[
								149.9698825910001,
								-35.91947200799996
							],
							[
								149.96560832800003,
								-35.94477904799993
							],
							[
								149.9918530330001,
								-35.94846292999995
							],
							[
								149.98715223300007,
								-35.95520699999997
							],
							[
								149.9964321010001,
								-35.95647292099994
							],
							[
								149.98368250200008,
								-35.96781108999994
							],
							[
								149.97084866400007,
								-35.966117148999956
							],
							[
								149.98514363100003,
								-35.97618012999993
							],
							[
								149.98056898000004,
								-35.98793926999997
							],
							[
								149.96643928100002,
								-35.992082437999954
							],
							[
								149.966670689,
								-36.01047657799995
							],
							[
								150.0142733980001,
								-36.03578018299993
							],
							[
								150.0772882970001,
								-36.044946238999955
							],
							[
								150.08181831500008,
								-36.05173523899998
							],
							[
								150.09690660400008,
								-36.04378161999995
							],
							[
								150.08944330600002,
								-36.033313229999976
							],
							[
								150.11561731200004,
								-36.03255423199994
							],
							[
								150.12109329100008,
								-36.03871124199998
							],
							[
								150.11535133100006,
								-36.046031221999954
							],
							[
								150.1300142870001,
								-36.05603123299994
							],
							[
								150.12305530700007,
								-36.06459024299994
							],
							[
								150.13446429500004,
								-36.06600223399994
							],
							[
								150.14454030500008,
								-36.05697923499997
							],
							[
								150.149243328,
								-36.028797234999956
							],
							[
								150.1645582870001,
								-36.01301124599996
							],
							[
								150.15741231900006,
								-36.007976224999936
							],
							[
								150.16433232000009,
								-35.99362724599996
							],
							[
								150.1540842920001,
								-35.99189823499995
							],
							[
								150.1510723140001,
								-35.97884723499993
							],
							[
								150.16040930600002,
								-35.95388422499997
							],
							[
								150.1550623180001,
								-35.94584923499997
							],
							[
								150.16182230200002,
								-35.90865424499998
							],
							[
								150.1508883240001,
								-35.904868233999935
							],
							[
								150.15256532700005,
								-35.88415622399998
							],
							[
								150.171720337,
								-35.86072623599995
							],
							[
								150.1913643140001,
								-35.86049223699996
							],
							[
								150.1774333180001,
								-35.848817235999945
							],
							[
								150.18989832700004,
								-35.83845123699996
							],
							[
								150.18712629800007,
								-35.83285223699994
							],
							[
								150.19914132700012,
								-35.82858322799996
							],
							[
								150.21017330400002,
								-35.835833228999945
							],
							[
								150.21754930400004,
								-35.83068823999997
							],
							[
								150.2353803100001,
								-35.83535024099996
							],
							[
								150.22493934300007,
								-35.82778023999998
							],
							[
								150.230798283,
								-35.81838923099997
							],
							[
								150.22419631600008,
								-35.80873624999998
							],
							[
								150.23712432500008,
								-35.802135240999974
							],
							[
								150.23011333600004,
								-35.80109323099998
							],
							[
								150.2373843160001,
								-35.79192624099994
							],
							[
								150.23494932900007,
								-35.771749230999944
							],
							[
								150.21196232400007,
								-35.76010923899997
							],
							[
								150.21448531700003,
								-35.73791322899996
							],
							[
								150.17726825700004,
								-35.70306270499998
							],
							[
								150.21027833200003,
								-35.70234324799998
							],
							[
								150.21221933100003,
								-35.71179424799993
							],
							[
								150.23397431800004,
								-35.70292023999997
							],
							[
								150.25049731500008,
								-35.71147524199995
							],
							[
								150.2510333140001,
								-35.71938724199998
							],
							[
								150.2624333220001,
								-35.71785024299993
							],
							[
								150.2654163200001,
								-35.72645025299994
							],
							[
								150.27022633100012,
								-35.71915124399993
							],
							[
								150.27669430900005,
								-35.72342823399998
							],
							[
								150.28094630100009,
								-35.70333524399996
							],
							[
								150.2912243410001,
								-35.693665254999985
							],
							[
								150.29744532000007,
								-35.69608723599998
							],
							[
								150.29906633100006,
								-35.68371023599997
							],
							[
								150.30655733000003,
								-35.686093246999974
							],
							[
								150.29969234200007,
								-35.678840245999936
							],
							[
								150.30756232200008,
								-35.668750246999934
							],
							[
								150.29743532400005,
								-35.66307524599995
							],
							[
								150.2992593460001,
								-35.64737523599996
							],
							[
								150.31356631500012,
								-35.63554924699997
							],
							[
								150.32605333300012,
								-35.637202257999945
							],
							[
								150.32261032700012,
								-35.61352625799998
							],
							[
								150.33412432500006,
								-35.61109424899996
							],
							[
								150.33409935600002,
								-35.603554258999964
							],
							[
								150.34564533500009,
								-35.60423925999993
							],
							[
								150.34003433600003,
								-35.59729523899995
							],
							[
								150.34639631700009,
								-35.58789324999998
							],
							[
								150.36487831600004,
								-35.57062925099996
							],
							[
								150.3768073540001,
								-35.57178926199998
							],
							[
								150.375844335,
								-35.56353826199995
							],
							[
								150.38692434400002,
								-35.56269525299996
							],
							[
								150.38504733600007,
								-35.54611925299997
							],
							[
								150.3962073560001,
								-35.533107263999966
							],
							[
								150.4063363250001,
								-35.533915244999946
							],
							[
								150.4015893190001,
								-35.50617925399996
							],
							[
								150.39087935200007,
								-35.49841826299996
							],
							[
								150.3928522860001,
								-35.46459632299997
							],
							[
								150.40375432500002,
								-35.458102243999974
							],
							[
								150.4060958770001,
								-35.44585831399996
							],
							[
								150.41573968500006,
								-35.44540930499994
							],
							[
								150.41075071700004,
								-35.436509343999944
							],
							[
								150.42308932700007,
								-35.42096231499994
							],
							[
								150.44910364500004,
								-35.40674421799997
							],
							[
								150.4520983970001,
								-35.38995520799995
							],
							[
								150.47854968600006,
								-35.36783195999993
							],
							[
								150.49238132400012,
								-35.36665126099996
							],
							[
								150.47488735800005,
								-35.35654126999998
							],
							[
								150.48503949700012,
								-35.35327085999995
							],
							[
								150.47559136900009,
								-35.34643325999997
							],
							[
								150.47590436200005,
								-35.33026824899997
							],
							[
								150.48729936100005,
								-35.324964259999945
							],
							[
								150.4719063340001,
								-35.31653425899998
							],
							[
								150.4780293560001,
								-35.291811268999936
							],
							[
								150.51820333500007,
								-35.260346262999974
							],
							[
								150.54431634200012,
								-35.249373264999974
							],
							[
								150.5302053360001,
								-35.23506126399997
							],
							[
								150.53951236700004,
								-35.216601253999954
							],
							[
								150.57275634500002,
								-35.19302226699995
							],
							[
								150.59630234200006,
								-35.191089258999966
							],
							[
								150.594496853,
								-35.18398433899995
							],
							[
								150.60617065500003,
								-35.15532991999993
							],
							[
								150.59397443900002,
								-35.14382316899997
							],
							[
								150.63375089200008,
								-35.14893223299998
							],
							[
								150.66135525200002,
								-35.11780707499997
							],
							[
								150.70195618500009,
								-35.12301691899995
							]
						]
					],
					[
						[
							[
								150.418539333,
								-35.53120325599997
							],
							[
								150.4205753440001,
								-35.52595325599998
							],
							[
								150.4113386140001,
								-35.53026122499995
							],
							[
								150.418539333,
								-35.53120325599997
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "116",
				"CED_NAME21": "Gilmore",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 6254.6162,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/116",
				"SHAPE_Leng": 7.76425197697,
				"SHAPE_Area": 0.619319380386
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							151.11750981000012,
							-33.88850287799994
						],
						[
							151.13243130800004,
							-33.891390799999954
						],
						[
							151.1190596770001,
							-33.912187038999946
						],
						[
							151.14722978300006,
							-33.91128495099997
						],
						[
							151.1742456170001,
							-33.924953623999954
						],
						[
							151.1793543770001,
							-33.920175323999956
						],
						[
							151.17871757000012,
							-33.89773050399998
						],
						[
							151.17147075200012,
							-33.89537898399993
						],
						[
							151.17527642400012,
							-33.87243030399998
						],
						[
							151.19651245300008,
							-33.85968131599998
						],
						[
							151.1845524250001,
							-33.85363230399997
						],
						[
							151.19054346500002,
							-33.852362324999945
						],
						[
							151.18546755600005,
							-33.84598527399993
						],
						[
							151.1508756280001,
							-33.87225215099994
						],
						[
							151.14207748900003,
							-33.87040781099995
						],
						[
							151.12769507100006,
							-33.87423047899995
						],
						[
							151.11750981000012,
							-33.88850287799994
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "117",
				"CED_NAME21": "Grayndler",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 27.6897,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/117",
				"SHAPE_Leng": 0.417598334182,
				"SHAPE_Area": 0.00269834314091
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							150.96688398600008,
							-33.781107943999984
						],
						[
							150.92709750300003,
							-33.69620129899994
						],
						[
							150.8982675210001,
							-33.665212276999966
						],
						[
							150.87404451600003,
							-33.656658283999946
						],
						[
							150.85874550900007,
							-33.64630427299994
						],
						[
							150.85104751000006,
							-33.650125281999976
						],
						[
							150.87603649800008,
							-33.71213628499993
						],
						[
							150.9001475110001,
							-33.741093286999956
						],
						[
							150.90634407700009,
							-33.76564317799995
						],
						[
							150.8969430940001,
							-33.79793218699996
						],
						[
							150.952392174,
							-33.811560922999945
						],
						[
							150.94758446900005,
							-33.78040729199995
						],
						[
							150.96688398600008,
							-33.781107943999984
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "118",
				"CED_NAME21": "Greenway",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 81.2585,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/118",
				"SHAPE_Leng": 0.479480760466,
				"SHAPE_Area": 0.00790521541361
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							151.08818832800011,
							-34.01157033699997
						],
						[
							151.07759643000009,
							-34.01191628599997
						],
						[
							151.08754538900007,
							-34.008014335999974
						],
						[
							151.08896633000006,
							-33.99712631699998
						],
						[
							151.06999757200003,
							-34.00227432499997
						],
						[
							151.069654473,
							-33.99593130499994
						],
						[
							151.0597184840001,
							-33.99807428399998
						],
						[
							151.05881452300002,
							-34.00814034399997
						],
						[
							151.04652734500007,
							-34.00753635299998
						],
						[
							151.0514384930001,
							-34.016803282999945
						],
						[
							151.04191035200006,
							-34.02878426199993
						],
						[
							151.04888032200006,
							-34.02069730299996
						],
						[
							151.04300330500007,
							-34.00765928199996
						],
						[
							151.06607751400009,
							-33.99187427399994
						],
						[
							151.03281531900006,
							-33.99253226099995
						],
						[
							151.03434139000012,
							-33.97738229099997
						],
						[
							151.015588642,
							-33.98206646999995
						],
						[
							150.99606395500007,
							-33.98166466799995
						],
						[
							150.997432816,
							-33.97403463799998
						],
						[
							150.9811569200001,
							-33.964902775999974
						],
						[
							150.9828127410001,
							-33.95570772599996
						],
						[
							150.97068284400007,
							-33.946932824999976
						],
						[
							150.96860362600012,
							-33.931061704999934
						],
						[
							150.9281180920001,
							-33.926880780999966
						],
						[
							150.91893275200005,
							-33.939083359999984
						],
						[
							150.907825397,
							-33.99034219999993
						],
						[
							150.91255575500008,
							-34.00027319999998
						],
						[
							150.90150640600007,
							-34.00721232899997
						],
						[
							150.90677445300003,
							-34.01773628999996
						],
						[
							150.89291313500007,
							-34.01949550899997
						],
						[
							150.88857814800008,
							-34.005450037999935
						],
						[
							150.8866624740001,
							-34.032101987999965
						],
						[
							150.94079671500003,
							-34.04002047299997
						],
						[
							150.93717835100006,
							-34.075338622999936
						],
						[
							150.9233437910001,
							-34.089793791999966
						],
						[
							150.93660062900005,
							-34.09511667299995
						],
						[
							150.92258542600007,
							-34.12999929199998
						],
						[
							150.97987742700002,
							-34.13839729699998
						],
						[
							151.02213642800007,
							-34.15570029099996
						],
						[
							151.01592842800005,
							-34.16642730099994
						],
						[
							151.06616377000012,
							-34.17231657599996
						],
						[
							151.11144541600004,
							-34.14799630999994
						],
						[
							151.1187013970001,
							-34.13699829999996
						],
						[
							151.12788742500004,
							-34.13790630099993
						],
						[
							151.13579941700004,
							-34.120290301999944
						],
						[
							151.15179740500002,
							-34.11506232299996
						],
						[
							151.17178641600003,
							-34.08628830499998
						],
						[
							151.16897941800005,
							-34.07490531499997
						],
						[
							151.1500374190001,
							-34.08368230299993
						],
						[
							151.136956402,
							-34.08168732199994
						],
						[
							151.13315544300008,
							-34.07351531099994
						],
						[
							151.1351664020001,
							-34.082247310999946
						],
						[
							151.12419626200005,
							-34.092200349999985
						],
						[
							151.13216840300004,
							-34.07595931099996
						],
						[
							151.1102094260001,
							-34.078271308999945
						],
						[
							151.09922847600012,
							-34.089618317999964
						],
						[
							151.07858750900004,
							-34.089303315999985
						],
						[
							151.09816358700004,
							-34.085936337999954
						],
						[
							151.10621340700004,
							-34.07194330899995
						],
						[
							151.09579040100004,
							-34.057989317999954
						],
						[
							151.08845149,
							-34.06955534699995
						],
						[
							151.063038365,
							-34.06463728499995
						],
						[
							151.05747014400004,
							-34.07359622399997
						],
						[
							151.06155340500004,
							-34.06402934399995
						],
						[
							151.08948831100008,
							-34.06513734699996
						],
						[
							151.08908440200003,
							-34.05820130699993
						],
						[
							151.07712039400008,
							-34.05397834599995
						],
						[
							151.08818832800011,
							-34.01157033699997
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "119",
				"CED_NAME21": "Hughes",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 358.8192,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/119",
				"SHAPE_Leng": 1.73062212847,
				"SHAPE_Area": 0.0350403491813
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							150.85953142800008,
							-34.18103528699993
						],
						[
							150.7520687660001,
							-34.163850836999984
						],
						[
							150.75625432900006,
							-34.141318756999965
						],
						[
							150.7499042510001,
							-34.13158783599994
						],
						[
							150.7567129910001,
							-34.121928726999954
						],
						[
							150.73766718500008,
							-34.114561984999966
						],
						[
							150.7409876690001,
							-34.08328189499997
						],
						[
							150.76642816600008,
							-34.07805057699994
						],
						[
							150.7809354960001,
							-34.059665278999944
						],
						[
							150.7270544580001,
							-34.02799626299998
						],
						[
							150.7231764820001,
							-33.99979527299996
						],
						[
							150.73881849500003,
							-33.96146027399993
						],
						[
							150.75422649300003,
							-33.95872227499996
						],
						[
							150.7392169960001,
							-33.955762463999974
						],
						[
							150.73174048900012,
							-33.93990026299997
						],
						[
							150.7100854050001,
							-33.91665301099994
						],
						[
							150.72331749700004,
							-33.886434261999966
						],
						[
							150.72094949000007,
							-33.86943426199997
						],
						[
							150.70862541200006,
							-33.86466681099995
						],
						[
							150.71435650400008,
							-33.84477258099997
						],
						[
							150.6885829780001,
							-33.84131692899996
						],
						[
							150.6127985160001,
							-33.86183427199995
						],
						[
							150.61171084500006,
							-33.872679611999956
						],
						[
							150.59646290600006,
							-33.88413158999998
						],
						[
							150.5214105120001,
							-33.92144325399994
						],
						[
							150.4972405420001,
							-33.94565424199993
						],
						[
							150.47134452400007,
							-33.95847525999994
						],
						[
							150.45166653900003,
							-33.94067423799993
						],
						[
							150.43919956000002,
							-33.94561623699997
						],
						[
							150.4320295430001,
							-33.93252125599997
						],
						[
							150.4191915440001,
							-33.939539244999935
						],
						[
							150.3981345190001,
							-33.924684242999945
						],
						[
							150.39429957200002,
							-33.90530523199993
						],
						[
							150.401543542,
							-33.89608824299995
						],
						[
							150.38770355300005,
							-33.90382725199993
						],
						[
							150.37225156600005,
							-33.90082123999997
						],
						[
							150.3684315580001,
							-33.888928239999984
						],
						[
							150.3557705490001,
							-33.89236423899996
						],
						[
							150.35552355000004,
							-33.88631024899996
						],
						[
							150.34267354000008,
							-33.90088023799996
						],
						[
							150.34275654200007,
							-33.88440524799995
						],
						[
							150.3310225360001,
							-33.86713423599997
						],
						[
							150.35051455400003,
							-33.85991423799993
						],
						[
							150.32461261800006,
							-33.85607456599996
						],
						[
							150.32095645000004,
							-33.849353624999935
						],
						[
							150.3036207130001,
							-33.845365913999956
						],
						[
							150.27957808600001,
							-33.85075708199997
						],
						[
							150.2549224160001,
							-33.871461229999966
						],
						[
							150.2470826880001,
							-33.86921131899993
						],
						[
							150.2351746380001,
							-33.88435084799994
						],
						[
							150.20659025200007,
							-33.88513185499994
						],
						[
							150.1962751740001,
							-33.87773781399994
						],
						[
							150.18910719400003,
							-33.88609324399994
						],
						[
							150.18522173500003,
							-33.88038660299998
						],
						[
							150.15591325800006,
							-33.89307677099998
						],
						[
							150.16908511500003,
							-33.89896663199994
						],
						[
							150.1652064440001,
							-33.91540251199996
						],
						[
							150.17556173800006,
							-33.94516518299997
						],
						[
							150.19038055600004,
							-33.95034202399995
						],
						[
							150.2147689840001,
							-33.93634594599996
						],
						[
							150.2170281120001,
							-33.94780883699997
						],
						[
							150.2412059280001,
							-33.95201999899996
						],
						[
							150.22850538600005,
							-33.97867264799993
						],
						[
							150.20160305700006,
							-34.004891715999975
						],
						[
							150.16688382000007,
							-34.02151383299997
						],
						[
							150.1693638490001,
							-34.02725977299997
						],
						[
							150.1590800900001,
							-34.03160880199994
						],
						[
							150.16802499800008,
							-34.03551574299996
						],
						[
							150.15682417000005,
							-34.033998821999944
						],
						[
							150.14495046000002,
							-34.04362283099994
						],
						[
							150.145661807,
							-34.07135065099993
						],
						[
							150.1294571190001,
							-34.07353773999995
						],
						[
							150.1327801870001,
							-34.08214565999998
						],
						[
							150.1169703700001,
							-34.07789779899997
						],
						[
							150.11767554800008,
							-34.091980698999976
						],
						[
							150.10900559000004,
							-34.08488677799994
						],
						[
							150.11303277700006,
							-34.10292664799994
						],
						[
							150.10527499600005,
							-34.11815860799993
						],
						[
							150.11280917300007,
							-34.13945837899996
						],
						[
							150.1233850110001,
							-34.141277299999956
						],
						[
							150.12505203900002,
							-34.14916525999996
						],
						[
							150.11492526100005,
							-34.15103230899996
						],
						[
							150.10524630400005,
							-34.13848342799997
						],
						[
							150.09394243600002,
							-34.136522516999946
						],
						[
							150.08546118900006,
							-34.120550745999935
						],
						[
							150.06923355000004,
							-34.13143522499996
						],
						[
							150.01650157000006,
							-34.11229919999994
						],
						[
							150.00281458400002,
							-34.097279198999956
						],
						[
							150.00703756500002,
							-34.08516321899998
						],
						[
							149.9624048920001,
							-34.07737824499998
						],
						[
							149.94488256300008,
							-34.09163732299993
						],
						[
							149.92893567700003,
							-34.079104591999965
						],
						[
							149.93158218200006,
							-34.11629825199998
						],
						[
							149.94972781800004,
							-34.125052953999955
						],
						[
							149.93712367400008,
							-34.16918570299998
						],
						[
							149.90197859700004,
							-34.18757419999997
						],
						[
							149.88866956000004,
							-34.18039619899997
						],
						[
							149.87332559100003,
							-34.18836119799994
						],
						[
							149.84990656500008,
							-34.18368519599994
						],
						[
							149.79686660000004,
							-34.20591720099998
						],
						[
							149.76935859600007,
							-34.189890178999974
						],
						[
							149.7610505770001,
							-34.19416918799993
						],
						[
							149.75674960900005,
							-34.18669419799994
						],
						[
							149.7417255910001,
							-34.18820018599996
						],
						[
							149.74410158900002,
							-34.19422718699997
						],
						[
							149.73292759100002,
							-34.19754318599996
						],
						[
							149.72678960300004,
							-34.18957819499997
						],
						[
							149.7248745920001,
							-34.19902717499997
						],
						[
							149.716533614,
							-34.19021718399995
						],
						[
							149.7125735830001,
							-34.19853618399998
						],
						[
							149.7002356060001,
							-34.19681519299996
						],
						[
							149.694795386,
							-34.20279698199994
						],
						[
							149.69372060700005,
							-34.19214517199998
						],
						[
							149.6825295980001,
							-34.19919417099993
						],
						[
							149.67793663200007,
							-34.17271618099994
						],
						[
							149.6638186140001,
							-34.17305217899997
						],
						[
							149.66379262500004,
							-34.16429717899996
						],
						[
							149.65713462500003,
							-34.170588178999935
						],
						[
							149.65943562600012,
							-34.160377178999966
						],
						[
							149.6492045980001,
							-34.158817177999936
						],
						[
							149.65394861800007,
							-34.15022818799997
						],
						[
							149.64338362,
							-34.14665416699995
						],
						[
							149.6464946200001,
							-34.14061517799996
						],
						[
							149.62833660700005,
							-34.11340017599997
						],
						[
							149.62250562600002,
							-34.12862917499996
						],
						[
							149.62042647900012,
							-34.10558637499997
						],
						[
							149.6036788890001,
							-34.12304445399997
						],
						[
							149.58872670300002,
							-34.10551590199998
						],
						[
							149.58173268400003,
							-34.10741805199996
						],
						[
							149.57892693600002,
							-34.092696900999954
						],
						[
							149.5718558970001,
							-34.09644407099995
						],
						[
							149.5633050790001,
							-34.08746597999993
						],
						[
							149.5636166480001,
							-34.09616116999996
						],
						[
							149.55455863100008,
							-34.08828615899995
						],
						[
							149.5511776300001,
							-34.093863168999974
						],
						[
							149.54541063400006,
							-34.07114317799994
						],
						[
							149.5257526480001,
							-34.05915916699996
						],
						[
							149.53022265800007,
							-34.05398416699995
						],
						[
							149.5123996420001,
							-34.04823316499994
						],
						[
							149.5183966620001,
							-34.04152115599993
						],
						[
							149.5131626440001,
							-34.03199717499996
						],
						[
							149.50927966400002,
							-34.03687817499997
						],
						[
							149.46468867300007,
							-34.010364150999976
						],
						[
							149.4558986720001,
							-34.02960514999995
						],
						[
							149.43473867600005,
							-34.02291416799994
						],
						[
							149.40269566300003,
							-34.00603215599995
						],
						[
							149.40049668400002,
							-33.99697915499996
						],
						[
							149.38531089700007,
							-33.99097679399995
						],
						[
							149.3835767490001,
							-33.97961385399998
						],
						[
							149.37580995000008,
							-33.984363892999966
						],
						[
							149.36342109200007,
							-33.97689004199998
						],
						[
							149.36443991300007,
							-33.96915208199994
						],
						[
							149.3520711650001,
							-33.971223160999955
						],
						[
							149.34778398700007,
							-33.953286299999945
						],
						[
							149.31415358200002,
							-33.95673750799995
						],
						[
							149.3016027640001,
							-33.953614596999955
						],
						[
							149.299679695,
							-33.94620865599995
						],
						[
							149.29094392600007,
							-33.95290567599994
						],
						[
							149.27932710800007,
							-33.948509754999975
						],
						[
							149.27503233700008,
							-33.95928972399997
						],
						[
							149.23387925200007,
							-33.96764388099996
						],
						[
							149.23551441100005,
							-33.97964083099998
						],
						[
							149.21790170500003,
							-33.96359113899996
						],
						[
							149.21239170500007,
							-33.97117113899998
						],
						[
							149.20213670700002,
							-33.96948913799997
						],
						[
							149.1977437050001,
							-33.98488313799993
						],
						[
							149.16488371100002,
							-33.97794213499998
						],
						[
							149.14038272900007,
							-33.945520132999945
						],
						[
							149.1533327080001,
							-33.93628713399994
						],
						[
							149.15453979900008,
							-33.92609531399995
						],
						[
							149.11984181900004,
							-33.887815520999936
						],
						[
							149.09829433000004,
							-33.89983255899995
						],
						[
							149.09539755000003,
							-33.90978953899997
						],
						[
							149.0820838510001,
							-33.91286756699998
						],
						[
							149.06971173500006,
							-33.89965112599998
						],
						[
							149.073555735,
							-33.89268012699995
						],
						[
							149.06510773600007,
							-33.89284912599993
						],
						[
							149.0519352560001,
							-33.91258166499995
						],
						[
							149.0360764080001,
							-33.91012371399995
						],
						[
							149.02509066900006,
							-33.91780775299998
						],
						[
							149.0218499870001,
							-33.93376568299993
						],
						[
							148.9811515440001,
							-33.92443179899993
						],
						[
							148.98096692100012,
							-33.94994173899994
						],
						[
							148.970192192,
							-33.956109777999984
						],
						[
							148.96750243100007,
							-33.969065727999975
						],
						[
							148.942212755,
							-33.96940211599997
						],
						[
							148.93446274400003,
							-33.98209211499994
						],
						[
							148.915357738,
							-33.97031111399997
						],
						[
							148.90458476900005,
							-33.97480611299994
						],
						[
							148.889850743,
							-33.96342011199994
						],
						[
							148.89001674600001,
							-33.938843100999975
						],
						[
							148.882411756,
							-33.94787612099998
						],
						[
							148.85058277000007,
							-33.95217510799995
						],
						[
							148.83175377400005,
							-33.94521211699998
						],
						[
							148.8215200830001,
							-33.96581898599993
						],
						[
							148.80793336500005,
							-33.96391502499995
						],
						[
							148.80400074300007,
							-33.98388497499997
						],
						[
							148.767369389,
							-33.981943040999965
						],
						[
							148.765328747,
							-34.00057500099996
						],
						[
							148.75273496900002,
							-33.99917702999994
						],
						[
							148.74372249700002,
							-34.020711019999965
						],
						[
							148.76314045200002,
							-34.03823795099993
						],
						[
							148.7309945720001,
							-34.07868621899996
						],
						[
							148.71818475500004,
							-34.073990107999975
						],
						[
							148.709256965,
							-34.08201516699995
						],
						[
							148.68690659800006,
							-34.08211706499998
						],
						[
							148.6700778290001,
							-34.09934725399995
						],
						[
							148.6613319600001,
							-34.098099282999954
						],
						[
							148.66143506900005,
							-34.10819429299994
						],
						[
							148.64070537200007,
							-34.10643534199994
						],
						[
							148.64495978000002,
							-34.12174209199998
						],
						[
							148.6362450680001,
							-34.14619136199997
						],
						[
							148.6502500040001,
							-34.15944234299997
						],
						[
							148.64332037400004,
							-34.17304835199997
						],
						[
							148.62323267700003,
							-34.170536400999936
						],
						[
							148.62135084600004,
							-34.18095342099997
						],
						[
							148.63721458400005,
							-34.182928371999935
						],
						[
							148.64682169800005,
							-34.21957250299994
						],
						[
							148.63801224200006,
							-34.28112165299996
						],
						[
							148.62123950400007,
							-34.279502710999964
						],
						[
							148.60880089400007,
							-34.29619078999997
						],
						[
							148.61242289200004,
							-34.311588780999955
						],
						[
							148.6221138200001,
							-34.31439377199996
						],
						[
							148.60988346700003,
							-34.35630385099995
						],
						[
							148.57591397900012,
							-34.376761097999974
						],
						[
							148.55362762800007,
							-34.41141629699996
						],
						[
							148.5624774570001,
							-34.41292222699997
						],
						[
							148.5677125740001,
							-34.431624247999935
						],
						[
							148.58029638200003,
							-34.43327720899998
						],
						[
							148.5805747280001,
							-34.46205134899998
						],
						[
							148.61475975300004,
							-34.466270091999945
						],
						[
							148.60954543100002,
							-34.48706924199996
						],
						[
							148.62153030900004,
							-34.48812216299996
						],
						[
							148.6125934690001,
							-34.498880251999935
						],
						[
							148.62535572700006,
							-34.50053209299995
						],
						[
							148.619596644,
							-34.529450262999944
						],
						[
							148.6283985130001,
							-34.53060220399993
						],
						[
							148.63068863,
							-34.547511233999955
						],
						[
							148.6436704680001,
							-34.54920217499995
						],
						[
							148.64580126900012,
							-34.53794812499996
						],
						[
							148.65364723800008,
							-34.54240610599993
						],
						[
							148.6629821460001,
							-34.54731906699993
						],
						[
							148.68016272500006,
							-34.53556510799996
						],
						[
							148.68240769300007,
							-34.54228809799997
						],
						[
							148.67380194400005,
							-34.54574900799997
						],
						[
							148.68346470300003,
							-34.54545609799993
						],
						[
							148.68786871100008,
							-34.55870209899996
						],
						[
							148.71146176800005,
							-34.55271313099996
						],
						[
							148.71558264600003,
							-34.565997040999946
						],
						[
							148.73927195200008,
							-34.569285742999966
						],
						[
							148.74774882200006,
							-34.55626663399994
						],
						[
							148.75801663000004,
							-34.561131614999965
						],
						[
							148.7563446790001,
							-34.569827664999934
						],
						[
							148.7654874870001,
							-34.57110762499997
						],
						[
							148.78271223500008,
							-34.57200854699994
						],
						[
							148.7829991960001,
							-34.564732496999966
						],
						[
							148.81669665200002,
							-34.55654814999997
						],
						[
							148.84739168500005,
							-34.56895712199997
						],
						[
							148.85040088300002,
							-34.581437182999935
						],
						[
							148.86981187900005,
							-34.59167505399995
						],
						[
							148.88399394400005,
							-34.61900717599997
						],
						[
							148.8950398620001,
							-34.623539136999966
						],
						[
							148.8908939700001,
							-34.64260529599994
						],
						[
							148.91370862700012,
							-34.63971914799998
						],
						[
							148.93258145200002,
							-34.651627119999944
						],
						[
							148.94947066100008,
							-34.646062110999935
						],
						[
							148.941408646,
							-34.69026912099997
						],
						[
							148.94714768400002,
							-34.70023912099998
						],
						[
							148.93901665500005,
							-34.704639130999965
						],
						[
							148.9578595920001,
							-34.70739918199996
						],
						[
							148.9655115590001,
							-34.71827309299994
						],
						[
							148.99036057700005,
							-34.706210134999935
						],
						[
							149.00327062300005,
							-34.72432512599994
						],
						[
							149.02601361900008,
							-34.72757411799995
						],
						[
							149.02202263700008,
							-34.747890137999946
						],
						[
							149.03760452300003,
							-34.75830485999995
						],
						[
							149.03802562200008,
							-34.76738487999995
						],
						[
							149.02200303300003,
							-34.78097701799993
						],
						[
							149.04270710700007,
							-34.80292393999997
						],
						[
							149.04346046400008,
							-34.82899403099998
						],
						[
							149.06055461100004,
							-34.83114212199996
						],
						[
							149.06792954700006,
							-34.855226992999974
						],
						[
							149.11210559900007,
							-34.86559313699996
						],
						[
							149.1099876070001,
							-34.87951914699994
						],
						[
							149.12193339400005,
							-34.888769697999976
						],
						[
							149.14545107100002,
							-34.88955953999994
						],
						[
							149.15624664100005,
							-34.87542940999998
						],
						[
							149.18708753400006,
							-34.89444822299998
						],
						[
							149.2176549300001,
							-34.890147955999964
						],
						[
							149.21222722900006,
							-34.90353102499995
						],
						[
							149.22974003600007,
							-34.90536589699997
						],
						[
							149.237054746,
							-34.89402581699994
						],
						[
							149.24888198400004,
							-34.897453817999974
						],
						[
							149.2508809750001,
							-34.890317478999975
						],
						[
							149.2710270020001,
							-34.88668249999995
						],
						[
							149.2812138600001,
							-34.89381344099996
						],
						[
							149.2737361400001,
							-34.90344045099994
						],
						[
							149.28045407800005,
							-34.91166143099997
						],
						[
							149.3143654920001,
							-34.91832418399997
						],
						[
							149.31630032300006,
							-34.908182153999974
						],
						[
							149.33059707000007,
							-34.910028025999964
						],
						[
							149.33324014800007,
							-34.92117849599998
						],
						[
							149.34636901600004,
							-34.92303589699998
						],
						[
							149.3367254540001,
							-34.948763035999946
						],
						[
							149.3474253930001,
							-34.94325288699997
						],
						[
							149.37465106900004,
							-34.948743579999984
						],
						[
							149.38715275000004,
							-34.92149704099995
						],
						[
							149.40656947800005,
							-34.918676121999965
						],
						[
							149.41314754500002,
							-34.92819117299996
						],
						[
							149.42799756300008,
							-34.93061215399996
						],
						[
							149.4478188500001,
							-34.92784381599995
						],
						[
							149.45506950100003,
							-34.911499755999955
						],
						[
							149.4884942960001,
							-34.91624159899993
						],
						[
							149.49097370700008,
							-34.90218437899995
						],
						[
							149.52645374100007,
							-34.90790389199998
						],
						[
							149.52465638,
							-34.917837101999964
						],
						[
							149.54100220700002,
							-34.92488693399997
						],
						[
							149.535562356,
							-34.93258602299994
						],
						[
							149.52640052800007,
							-34.931346092999945
						],
						[
							149.52863052500004,
							-34.95225516299996
						],
						[
							149.5190410250001,
							-34.96615307199994
						],
						[
							149.55123357900004,
							-34.97555675499996
						],
						[
							149.53825267900004,
							-35.06855612499993
						],
						[
							149.55665411500001,
							-35.071150375999935
						],
						[
							149.54310925200002,
							-35.110792524999965
						],
						[
							149.559788539,
							-35.11550827699995
						],
						[
							149.54238446700003,
							-35.15242431599995
						],
						[
							149.55909113400003,
							-35.159245546999955
						],
						[
							149.57248659200002,
							-35.153505407999944
						],
						[
							149.59099161900008,
							-35.15673257999998
						],
						[
							149.60714659000007,
							-35.129648230999976
						],
						[
							149.6315262160001,
							-35.13463365299998
						],
						[
							149.63484004800011,
							-35.11690268299998
						],
						[
							149.6527718750001,
							-35.11561874499995
						],
						[
							149.66066124100007,
							-35.13791984599993
						],
						[
							149.69974740200007,
							-35.16015301899995
						],
						[
							149.7077554990001,
							-35.17498518999997
						],
						[
							149.73099048400002,
							-35.18277619199995
						],
						[
							149.76601445100005,
							-35.17099219499994
						],
						[
							149.77294349900012,
							-35.17861619599995
						],
						[
							149.76782145700008,
							-35.19616018499994
						],
						[
							149.79591247300004,
							-35.194793207999965
						],
						[
							149.79401549200009,
							-35.20296618799995
						],
						[
							149.80713745900005,
							-35.21079218899996
						],
						[
							149.83555237500002,
							-35.20697938199993
						],
						[
							149.849730431,
							-35.222600212999964
						],
						[
							149.8489084480001,
							-35.246454202999985
						],
						[
							149.8828344320001,
							-35.25615619599995
						],
						[
							149.89280845100006,
							-35.24708220699995
						],
						[
							149.88271744500003,
							-35.23530921599996
						],
						[
							149.9005314530001,
							-35.22466120699994
						],
						[
							149.9175564410001,
							-35.22489219899995
						],
						[
							149.91406445000007,
							-35.233465208999974
						],
						[
							149.89739344200007,
							-35.234242206999966
						],
						[
							149.8974214320001,
							-35.23923021699994
						],
						[
							149.92688345800002,
							-35.23748120999994
						],
						[
							149.95208346700008,
							-35.20962321199994
						],
						[
							149.95246843100006,
							-35.178513221999935
						],
						[
							149.93399443600003,
							-35.16554219999995
						],
						[
							149.9315834680001,
							-35.14999120999994
						],
						[
							149.96088843400003,
							-35.15022320199995
						],
						[
							149.97841244900007,
							-35.16622720399994
						],
						[
							149.99220641700003,
							-35.161994224999944
						],
						[
							149.99608045900004,
							-35.14275821499996
						],
						[
							150.03513545500005,
							-35.128476218999936
						],
						[
							150.03134445700005,
							-35.11968921799996
						],
						[
							150.01802144900012,
							-35.11904121699996
						],
						[
							150.0266614310001,
							-35.09532821799996
						],
						[
							149.99708446500006,
							-35.102367224999966
						],
						[
							149.98063044800006,
							-35.09501521399994
						],
						[
							149.97738944200012,
							-35.066114212999935
						],
						[
							149.99680746800004,
							-35.075748224999984
						],
						[
							150.02856845600002,
							-35.054153207999946
						],
						[
							150.0241344430001,
							-35.003454216999955
						],
						[
							150.04308243100002,
							-34.99950722799997
						],
						[
							150.05191546900005,
							-35.00726322899993
						],
						[
							150.08578143600005,
							-34.98897322199997
						],
						[
							150.07879044900005,
							-34.97591522099998
						],
						[
							150.05552546400008,
							-34.96527221899993
						],
						[
							150.06776745600007,
							-34.93649622999993
						],
						[
							150.08824746400012,
							-34.92487422199997
						],
						[
							150.0918084750001,
							-34.911312221999935
						],
						[
							150.0816144680001,
							-34.905019220999975
						],
						[
							150.08686944800002,
							-34.89378123199998
						],
						[
							150.0757084700001,
							-34.89754322099998
						],
						[
							150.05275447500003,
							-34.88215121899998
						],
						[
							150.04061348000005,
							-34.86018722699998
						],
						[
							150.043761463,
							-34.827766216999976
						],
						[
							150.0361044970001,
							-34.808606226999984
						],
						[
							150.04669748600008,
							-34.80464922699997
						],
						[
							150.0419984780001,
							-34.79317822699994
						],
						[
							150.06687746600005,
							-34.78274921899998
						],
						[
							150.05620646900002,
							-34.77044122799998
						],
						[
							150.074225457,
							-34.768084219999935
						],
						[
							150.12143648500012,
							-34.80368723399994
						],
						[
							150.12742449200005,
							-34.81754423499996
						],
						[
							150.1937144320001,
							-34.81971223099998
						],
						[
							150.23695742900009,
							-34.793477233999965
						],
						[
							150.25581544700003,
							-34.79145123599994
						],
						[
							150.27650642600008,
							-34.76922823799998
						],
						[
							150.2900234650001,
							-34.76445923899996
						],
						[
							150.31475345,
							-34.77415424099996
						],
						[
							150.33821646,
							-34.74842223299993
						],
						[
							150.37145444600003,
							-34.74372925599994
						],
						[
							150.39814842700002,
							-34.70513625799998
						],
						[
							150.3951444490001,
							-34.69039125799998
						],
						[
							150.41547344900005,
							-34.671412259999954
						],
						[
							150.40349141500008,
							-34.63925703799998
						],
						[
							150.41280143500012,
							-34.625232238999956
						],
						[
							150.39931643600005,
							-34.632445237999946
						],
						[
							150.36885654200012,
							-34.618637354999976
						],
						[
							150.37870544400005,
							-34.59299424599993
						],
						[
							150.3716894580001,
							-34.57277225499996
						],
						[
							150.34808348100012,
							-34.577898242999936
						],
						[
							150.34519046000003,
							-34.59048324299994
						],
						[
							150.32855847100006,
							-34.59539325099996
						],
						[
							150.3328214500001,
							-34.603718251999965
						],
						[
							150.31522148300007,
							-34.597588239999936
						],
						[
							150.30543758400006,
							-34.603152688999955
						],
						[
							150.28724277800006,
							-34.59392273699996
						],
						[
							150.28586146700002,
							-34.60107724699998
						],
						[
							150.257513452,
							-34.59740423499994
						],
						[
							150.24841148200005,
							-34.60663123399996
						],
						[
							150.25248046900003,
							-34.62321323499998
						],
						[
							150.23602302100005,
							-34.626292122999985
						],
						[
							150.23278715100003,
							-34.63324217299993
						],
						[
							150.228314113,
							-34.621063161999984
						],
						[
							150.21553447500003,
							-34.61927922099994
						],
						[
							150.2488466740001,
							-34.58815894399993
						],
						[
							150.2574488570001,
							-34.560503764999964
						],
						[
							150.30767248600011,
							-34.511167238999974
						],
						[
							150.31567047900012,
							-34.48011423899993
						],
						[
							150.38033048300008,
							-34.44759224499995
						],
						[
							150.46064945400008,
							-34.431216251999956
						],
						[
							150.49732545000006,
							-34.41547125499994
						],
						[
							150.50870446900012,
							-34.41377724599994
						],
						[
							150.51369346700005,
							-34.42407225699998
						],
						[
							150.5266404560001,
							-34.41781226799998
						],
						[
							150.53096647900009,
							-34.39060825799993
						],
						[
							150.53562544700003,
							-34.39565326899998
						],
						[
							150.5698294440001,
							-34.38489226199994
						],
						[
							150.57448644500005,
							-34.36837725199996
						],
						[
							150.59377158300003,
							-34.36320730399996
						],
						[
							150.605170605,
							-34.33527428399998
						],
						[
							150.6161214430001,
							-34.33688528499994
						],
						[
							150.63462348300004,
							-34.31963627699997
						],
						[
							150.74568241400004,
							-34.33740338699994
						],
						[
							150.75086617800002,
							-34.301913526999954
						],
						[
							150.81676582800003,
							-34.30636272399994
						],
						[
							150.805194894,
							-34.27132694199997
						],
						[
							150.85280103600007,
							-34.279939216999935
						],
						[
							150.8808193850001,
							-34.25851784899993
						],
						[
							150.89793342600012,
							-34.23192530099993
						],
						[
							150.89052244000004,
							-34.214063289999956
						],
						[
							150.85748742700002,
							-34.19275827699994
						],
						[
							150.85953142800008,
							-34.18103528699993
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "120",
				"CED_NAME21": "Hume",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 17259.7988,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/120",
				"SHAPE_Leng": 11.5640273393,
				"SHAPE_Area": 1.6929967433
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							151.4030599130001,
							-32.66292608599997
						],
						[
							151.4243889820001,
							-32.646203827999955
						],
						[
							151.43081531500002,
							-32.61534083899994
						],
						[
							151.4408645740001,
							-32.61561072999996
						],
						[
							151.44586605400002,
							-32.60774473999993
						],
						[
							151.451175013,
							-32.61546869099993
						],
						[
							151.4708216900001,
							-32.61816460299997
						],
						[
							151.47972356700006,
							-32.55520033299996
						],
						[
							151.49607319400002,
							-32.55729211399995
						],
						[
							151.5007329010001,
							-32.50417500499998
						],
						[
							151.45568231100003,
							-32.47070107999997
						],
						[
							151.47434859400005,
							-32.430930341999954
						],
						[
							151.46902058600006,
							-32.421016340999984
						],
						[
							151.4461545810001,
							-32.40706231899998
						],
						[
							151.45055359100002,
							-32.40171933899995
						],
						[
							151.43419367500007,
							-32.38745017699995
						],
						[
							151.42813354800012,
							-32.370029226999975
						],
						[
							151.39796568600002,
							-32.34296028399996
						],
						[
							151.39580349800008,
							-32.32504423299997
						],
						[
							151.3830026600001,
							-32.32410029199997
						],
						[
							151.3902754300001,
							-32.315579242999945
						],
						[
							151.38055961200007,
							-32.314213311999936
						],
						[
							151.37149246600006,
							-32.29158541099997
						],
						[
							151.341988613,
							-32.26769331799994
						],
						[
							151.33714517800001,
							-32.237309756999935
						],
						[
							151.3507176290001,
							-32.21343331799994
						],
						[
							151.34554164300005,
							-32.18296331799996
						],
						[
							151.32721929700006,
							-32.171658925999964
						],
						[
							151.32789962900006,
							-32.154607315999954
						],
						[
							151.30970409400004,
							-32.13897111399996
						],
						[
							151.2875636220001,
							-32.17624232199995
						],
						[
							151.27024762300005,
							-32.18327831099998
						],
						[
							151.24626209300004,
							-32.20955542799993
						],
						[
							151.20882064700004,
							-32.220152834999965
						],
						[
							151.19682900700002,
							-32.23364694399993
						],
						[
							151.17402403300002,
							-32.21179418199995
						],
						[
							151.1590522450001,
							-32.21108031999995
						],
						[
							151.15476711700012,
							-32.199325389999956
						],
						[
							151.114229603,
							-32.195081795999954
						],
						[
							151.10098462700012,
							-32.178611984999975
						],
						[
							151.06604866300006,
							-32.16574162099994
						],
						[
							151.04612313500002,
							-32.17018250999996
						],
						[
							151.04472726400002,
							-32.17734148899996
						],
						[
							151.0318223270001,
							-32.16645867799997
						],
						[
							151.01591266800006,
							-32.17755181699994
						],
						[
							151.00300773100003,
							-32.16951497599996
						],
						[
							150.9160597010001,
							-32.18178027799996
						],
						[
							150.8725326980001,
							-32.17637927399994
						],
						[
							150.8789457050001,
							-32.18987426399997
						],
						[
							150.86791069700007,
							-32.18936327299997
						],
						[
							150.880194694,
							-32.19723526399997
						],
						[
							150.87494869400007,
							-32.20012126399996
						],
						[
							150.8613206970001,
							-32.18952927299995
						],
						[
							150.78833993900002,
							-32.17653013599994
						],
						[
							150.764496322,
							-32.17854341399993
						],
						[
							150.76658317200008,
							-32.17103443399998
						],
						[
							150.76283031200012,
							-32.175846442999955
						],
						[
							150.6564477280001,
							-32.16059525399993
						],
						[
							150.65682543000003,
							-32.15019977399993
						],
						[
							150.49890615300012,
							-32.130026448999956
						],
						[
							150.50952874900008,
							-32.15503622999995
						],
						[
							150.49102174900008,
							-32.170543248999934
						],
						[
							150.49574576400005,
							-32.20594423899996
						],
						[
							150.4865437410001,
							-32.239996248999944
						],
						[
							150.5000197180001,
							-32.25339723999997
						],
						[
							150.50960972200005,
							-32.292949240999974
						],
						[
							150.52760071700004,
							-32.313590242999965
						],
						[
							150.5299337240001,
							-32.33177524299998
						],
						[
							150.54398172300012,
							-32.326472244999934
						],
						[
							150.55781373000002,
							-32.33015823599993
						],
						[
							150.5526267890001,
							-32.34540730599997
						],
						[
							150.540413961,
							-32.343598413999985
						],
						[
							150.5363371300001,
							-32.35330747399996
						],
						[
							150.52570223200007,
							-32.35173055299998
						],
						[
							150.52085638200003,
							-32.358495612999945
						],
						[
							150.5299173300001,
							-32.36230753399997
						],
						[
							150.51463963100002,
							-32.36940169199994
						],
						[
							150.50731572200004,
							-32.36836173199998
						],
						[
							150.51187636500003,
							-32.34424066199995
						],
						[
							150.4967735470001,
							-32.34221680999997
						],
						[
							150.4928697260001,
							-32.352231899999936
						],
						[
							150.487674609,
							-32.33741496999994
						],
						[
							150.46942764300002,
							-32.32195625799994
						],
						[
							150.43873906800002,
							-32.32214460499995
						],
						[
							150.42989931800003,
							-32.32785468399993
						],
						[
							150.43240839600003,
							-32.34040463499997
						],
						[
							150.42026966700007,
							-32.34705574399993
						],
						[
							150.40692275000004,
							-32.333069861999945
						],
						[
							150.39631786200005,
							-32.33293998099998
						],
						[
							150.38654968700007,
							-32.38005197099994
						],
						[
							150.34234549300004,
							-32.38509739699998
						],
						[
							150.3407796020001,
							-32.394321436999974
						],
						[
							150.31892275300004,
							-32.40824821499996
						],
						[
							150.28004284700012,
							-32.421821001999945
						],
						[
							150.26885624500005,
							-32.44794923099994
						],
						[
							150.2539815460001,
							-32.457987438999965
						],
						[
							150.2272519490001,
							-32.456000666999955
						],
						[
							150.23734400500007,
							-32.47977865799993
						],
						[
							150.2476058730001,
							-32.48317661899995
						],
						[
							150.24015210200002,
							-32.49818771799994
						],
						[
							150.2475434150001,
							-32.54997470999996
						],
						[
							150.23683876300004,
							-32.57402992899995
						],
						[
							150.26604835900002,
							-32.577705710999965
						],
						[
							150.25947561700002,
							-32.59770384099994
						],
						[
							150.23936872000002,
							-32.601116228999956
						],
						[
							150.22766773000012,
							-32.61233121799995
						],
						[
							150.25116186600007,
							-32.61525697999997
						],
						[
							150.32016810300001,
							-32.64790964699995
						],
						[
							150.2754247160001,
							-32.74742621299998
						],
						[
							150.28882769200004,
							-32.76529621499998
						],
						[
							150.34122569200008,
							-32.79374422999996
						],
						[
							150.33854568000004,
							-32.80895022999994
						],
						[
							150.36253227200007,
							-32.845610661999956
						],
						[
							150.3614294890001,
							-32.868092701999956
						],
						[
							150.3410308120001,
							-32.87063286999995
						],
						[
							150.33538200100008,
							-32.882071939999946
						],
						[
							150.347095899,
							-32.89055488099996
						],
						[
							150.3527341240001,
							-32.92314189199993
						],
						[
							150.3763051960001,
							-32.959148623999965
						],
						[
							150.3666114560001,
							-32.97163570299995
						],
						[
							150.37630749200002,
							-32.99021467399996
						],
						[
							150.3703377700001,
							-33.014076813999964
						],
						[
							150.3942996830001,
							-33.03939968599997
						],
						[
							150.40915233300007,
							-33.023751456999946
						],
						[
							150.46638487200005,
							-33.04660098299996
						],
						[
							150.4884536090001,
							-33.04811078499995
						],
						[
							150.49736438900004,
							-33.03508371499993
						],
						[
							150.52006808600004,
							-33.03489448799996
						],
						[
							150.54661478100002,
							-33.04291519999998
						],
						[
							150.5528828880001,
							-33.05960912099994
						],
						[
							150.572202596,
							-33.05889592199998
						],
						[
							150.6046902500001,
							-33.06996760499993
						],
						[
							150.61069311000006,
							-33.06612454599997
						],
						[
							150.63024378800003,
							-33.058573327999966
						],
						[
							150.72788667300006,
							-33.07201040699994
						],
						[
							150.70721180700002,
							-33.05863057499994
						],
						[
							150.70539771900008,
							-33.04462454399993
						],
						[
							150.68210043200008,
							-33.04473017199996
						],
						[
							150.67220316700002,
							-33.02146080099993
						],
						[
							150.68579459800003,
							-32.99675726199996
						],
						[
							150.69668820700008,
							-32.99639346299995
						],
						[
							150.71144201200002,
							-33.014516844999946
						],
						[
							150.72351227100012,
							-33.012300135999965
						],
						[
							150.74543175700012,
							-33.021940177999966
						],
						[
							150.76106309500005,
							-33.01477066899997
						],
						[
							150.76383731700002,
							-33.00030880999998
						],
						[
							150.80479261000005,
							-33.00603227299996
						],
						[
							150.81979158700005,
							-33.014570284999934
						],
						[
							150.81850160600004,
							-33.023640274999934
						],
						[
							150.83071658300003,
							-33.033331285999964
						],
						[
							150.8551476,
							-33.03239027799998
						],
						[
							150.85796258800008,
							-33.043064277999974
						],
						[
							150.84975957900008,
							-33.04580627799993
						],
						[
							150.85753860700004,
							-33.05000427799996
						],
						[
							150.84708459900003,
							-33.05231128799994
						],
						[
							150.85896458600007,
							-33.06106228899995
						],
						[
							150.84836560500003,
							-33.074520277999966
						],
						[
							150.85324160400012,
							-33.08337527799995
						],
						[
							150.84704058300008,
							-33.09805826799993
						],
						[
							150.85875156100008,
							-33.09411828899994
						],
						[
							150.8843975950001,
							-33.118963270999984
						],
						[
							150.899996632,
							-33.121163982999974
						],
						[
							150.9241132400001,
							-33.111093764999964
						],
						[
							150.9659025520001,
							-33.12988328899996
						],
						[
							150.99416712900006,
							-33.12241608199997
						],
						[
							151.0351564030001,
							-33.12405472499995
						],
						[
							151.0418155760001,
							-33.09124728599994
						],
						[
							151.05214255600004,
							-33.08019544699994
						],
						[
							151.0839479230001,
							-33.075235189999944
						],
						[
							151.10397755000008,
							-33.07695630099994
						],
						[
							151.11453954600006,
							-33.091159312999935
						],
						[
							151.1279425340001,
							-33.091688303999945
						],
						[
							151.1355325610001,
							-33.11038830499996
						],
						[
							151.2026315180001,
							-33.13884731099995
						],
						[
							151.23251953800002,
							-33.10847632399998
						],
						[
							151.26173351500006,
							-33.09892932599996
						],
						[
							151.26644126000008,
							-33.057584445999964
						],
						[
							151.29591751600003,
							-33.05487331899997
						],
						[
							151.30519954600004,
							-33.04376532999993
						],
						[
							151.35710651400007,
							-33.08179631499996
						],
						[
							151.35662149300003,
							-33.09003233499993
						],
						[
							151.378945519,
							-33.09969832699994
						],
						[
							151.3830564330001,
							-33.139753567999946
						],
						[
							151.39749250700004,
							-33.16501458999994
						],
						[
							151.38999791800006,
							-33.16990859899994
						],
						[
							151.40406151500008,
							-33.17358643999995
						],
						[
							151.39863078400003,
							-33.18573447999995
						],
						[
							151.41107458200008,
							-33.18744840099998
						],
						[
							151.4109626720001,
							-33.19412840099994
						],
						[
							151.4331752180001,
							-33.19419625299997
						],
						[
							151.43146533800007,
							-33.199294262999956
						],
						[
							151.44470520700008,
							-33.193343023999944
						],
						[
							151.44324892600002,
							-33.20101696399996
						],
						[
							151.4551202240001,
							-33.202830354999946
						],
						[
							151.48860751200004,
							-33.18813033799995
						],
						[
							151.5121859180001,
							-33.19429402099996
						],
						[
							151.51551548800012,
							-33.18393735099994
						],
						[
							151.52766049700006,
							-33.179953341999976
						],
						[
							151.52720049000004,
							-33.156646311999964
						],
						[
							151.52727933300002,
							-33.13904638199995
						],
						[
							151.50985350500002,
							-33.13770636999993
						],
						[
							151.5196433960001,
							-33.12645439099998
						],
						[
							151.54159653300007,
							-33.12620031299997
						],
						[
							151.53901532400005,
							-33.11439537299998
						],
						[
							151.55248149200008,
							-33.12084532399996
						],
						[
							151.55030959300007,
							-33.114611373999935
						],
						[
							151.56873943000005,
							-33.11416732499998
						],
						[
							151.56514662300003,
							-33.10057335499994
						],
						[
							151.5484426270001,
							-33.08854837299998
						],
						[
							151.5386045560001,
							-33.10401135199993
						],
						[
							151.524792487,
							-33.10749735099995
						],
						[
							151.51845348900008,
							-33.10005734999993
						],
						[
							151.5095216200001,
							-33.102506379999966
						],
						[
							151.51246246100004,
							-33.09000932999993
						],
						[
							151.53404446900004,
							-33.08552634199998
						],
						[
							151.54155442,
							-33.07294632199995
						],
						[
							151.5505695180001,
							-33.07343737299993
						],
						[
							151.5457955700001,
							-33.06547236299997
						],
						[
							151.5539405500001,
							-33.06089137399994
						],
						[
							151.571754445,
							-33.07511937499993
						],
						[
							151.5941133130001,
							-33.07172934699997
						],
						[
							151.60717446900003,
							-33.08516833899995
						],
						[
							151.6138495880001,
							-33.082005368999944
						],
						[
							151.6111643600001,
							-33.07213534899995
						],
						[
							151.58076238500007,
							-33.06844938599994
						],
						[
							151.58852542500006,
							-33.05997434699998
						],
						[
							151.58200258600004,
							-33.05662932599995
						],
						[
							151.58594242700008,
							-33.04719680599993
						],
						[
							151.600069533,
							-33.05933130799997
						],
						[
							151.59467060600002,
							-33.04327935699996
						],
						[
							151.600048656,
							-33.041127367999934
						],
						[
							151.5921293680001,
							-33.03293134699993
						],
						[
							151.57732942000007,
							-33.03287031599996
						],
						[
							151.5935686690001,
							-33.02672429699993
						],
						[
							151.61379287300008,
							-33.05050166899997
						],
						[
							151.6195534520001,
							-33.04816933999996
						],
						[
							151.595763561,
							-33.010539336999955
						],
						[
							151.59771149200003,
							-32.99723233699996
						],
						[
							151.5898575020001,
							-33.00446835699995
						],
						[
							151.59257551300004,
							-32.99821635699993
						],
						[
							151.58408648400007,
							-32.996111345999964
						],
						[
							151.58906150400003,
							-32.98924235599998
						],
						[
							151.61664141800009,
							-33.00577833899996
						],
						[
							151.6210496320001,
							-32.976181398999984
						],
						[
							151.60718062500007,
							-32.96849933799996
						],
						[
							151.61400549400003,
							-32.96269037899998
						],
						[
							151.6217094860001,
							-32.94301040899995
						],
						[
							151.65332578200002,
							-32.937966331999974
						],
						[
							151.66241720200003,
							-32.929838582999935
						],
						[
							151.652143184,
							-32.92357198199994
						],
						[
							151.66540125500012,
							-32.90759596299995
						],
						[
							151.6478239170001,
							-32.910929290999945
						],
						[
							151.61472853300006,
							-32.900701167999955
						],
						[
							151.6008514560001,
							-32.88924765699994
						],
						[
							151.60858350600006,
							-32.880138346999956
						],
						[
							151.5582449840001,
							-32.87277371299996
						],
						[
							151.55654002300003,
							-32.88163675299995
						],
						[
							151.54112031600005,
							-32.872262810999985
						],
						[
							151.53839445500012,
							-32.88640682099998
						],
						[
							151.50338355000008,
							-32.884986337999976
						],
						[
							151.49419252200005,
							-32.88118734699998
						],
						[
							151.49710551200008,
							-32.87642832699993
						],
						[
							151.4835415340001,
							-32.878350325999975
						],
						[
							151.4778575350001,
							-32.872265324999944
						],
						[
							151.47429853500012,
							-32.87819533499993
						],
						[
							151.4516405380001,
							-32.874021322999965
						],
						[
							151.4536025320001,
							-32.84448733299996
						],
						[
							151.44262154400008,
							-32.84278633099996
						],
						[
							151.4309496840001,
							-32.85430573999997
						],
						[
							151.4355785360001,
							-32.834700330999965
						],
						[
							151.41586755900005,
							-32.83192732899994
						],
						[
							151.41917453000008,
							-32.823200328999974
						],
						[
							151.39706455200007,
							-32.82938733699996
						],
						[
							151.40755669100008,
							-32.82567328799996
						],
						[
							151.414373543,
							-32.80020531899993
						],
						[
							151.40272354500007,
							-32.80080932699997
						],
						[
							151.3961145290001,
							-32.77726332699996
						],
						[
							151.4093245370001,
							-32.77634331799993
						],
						[
							151.41637254800003,
							-32.76319433799995
						],
						[
							151.43150252600003,
							-32.764309329999946
						],
						[
							151.43429557700006,
							-32.75201531999994
						],
						[
							151.4320605680001,
							-32.743243329999984
						],
						[
							151.42003755000007,
							-32.74154933899996
						],
						[
							151.4234826720001,
							-32.72352781899997
						],
						[
							151.40051315800008,
							-32.70283223699994
						],
						[
							151.4030599130001,
							-32.66292608599997
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "121",
				"CED_NAME21": "Hunter",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 10562.2591,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/121",
				"SHAPE_Leng": 7.51243314718,
				"SHAPE_Area": 1.01521871623
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							151.26654443600012,
							-33.91392232299995
						],
						[
							151.21503615500012,
							-33.90088347799997
						],
						[
							151.2142729420001,
							-33.92431947799997
						],
						[
							151.1793543770001,
							-33.920175323999956
						],
						[
							151.1742456170001,
							-33.924953623999954
						],
						[
							151.16046168800005,
							-33.93399630299996
						],
						[
							151.16803842500008,
							-33.949761303999935
						],
						[
							151.18172541,
							-33.96788531499993
						],
						[
							151.18607242200005,
							-33.95234331499995
						],
						[
							151.192727428,
							-33.97391231599994
						],
						[
							151.1923543910001,
							-33.954210315999944
						],
						[
							151.21246640700008,
							-33.96349931799995
						],
						[
							151.19910342900005,
							-33.959856496999976
						],
						[
							151.20207924700003,
							-33.97131086699994
						],
						[
							151.22008541500009,
							-33.967191328999945
						],
						[
							151.20886939500008,
							-33.98215230799997
						],
						[
							151.2260293930001,
							-33.97672431899997
						],
						[
							151.2308094000001,
							-33.99254131999993
						],
						[
							151.23549644000002,
							-33.98940430999994
						],
						[
							151.23765540800002,
							-33.99836332999996
						],
						[
							151.24921641600008,
							-34.00180131199994
						],
						[
							151.25119040900006,
							-33.97892332199996
						],
						[
							151.25895739800012,
							-33.97575533199995
						],
						[
							151.2518914310001,
							-33.96465833199994
						],
						[
							151.26597038800003,
							-33.96801732299997
						],
						[
							151.2569724220001,
							-33.951583321999976
						],
						[
							151.2656984020001,
							-33.941434312999945
						],
						[
							151.25768741600007,
							-33.92202931199995
						],
						[
							151.26654443600012,
							-33.91392232299995
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "122",
				"CED_NAME21": "Kingsford Smith",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 58.5024,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/122",
				"SHAPE_Leng": 0.624306810826,
				"SHAPE_Area": 0.0057056852208
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							150.8033866400001,
							-33.77679860899997
						],
						[
							150.7841315080001,
							-33.74111232699994
						],
						[
							150.75967578300003,
							-33.72960488399997
						],
						[
							150.7661094650001,
							-33.70549838499994
						],
						[
							150.77879189300006,
							-33.702138875999935
						],
						[
							150.80054184400012,
							-33.67458349799995
						],
						[
							150.81239963200005,
							-33.67760118899997
						],
						[
							150.78215341100008,
							-33.63750452599993
						],
						[
							150.70141633600008,
							-33.61239742799995
						],
						[
							150.6814994570001,
							-33.62506096599998
						],
						[
							150.65789471400012,
							-33.677018404999956
						],
						[
							150.65796862900004,
							-33.71370924499996
						],
						[
							150.64405870000007,
							-33.721199713999965
						],
						[
							150.64304052300008,
							-33.77976462399994
						],
						[
							150.5880476520001,
							-33.84492037899997
						],
						[
							150.5936597000001,
							-33.85629930999994
						],
						[
							150.6127985160001,
							-33.86183427199995
						],
						[
							150.6885829780001,
							-33.84131692899996
						],
						[
							150.71435650400008,
							-33.84477258099997
						],
						[
							150.70862541200006,
							-33.86466681099995
						],
						[
							150.72094949000007,
							-33.86943426199997
						],
						[
							150.7679134120001,
							-33.875715165999964
						],
						[
							150.77605350200008,
							-33.87119627699997
						],
						[
							150.76538841600006,
							-33.84933962599996
						],
						[
							150.7663942480001,
							-33.82921006599997
						],
						[
							150.77896047700006,
							-33.82724727699997
						],
						[
							150.77599634800004,
							-33.820799835999935
						],
						[
							150.74108322400002,
							-33.815344762999985
						],
						[
							150.7415462250001,
							-33.803345322999974
						],
						[
							150.74836103500002,
							-33.80285296399995
						],
						[
							150.7468722760001,
							-33.79665698399998
						],
						[
							150.75693367400004,
							-33.79809160499997
						],
						[
							150.75701606600012,
							-33.782895003999954
						],
						[
							150.81149069700007,
							-33.79110887899998
						],
						[
							150.8033866400001,
							-33.77679860899997
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "123",
				"CED_NAME21": "Lindsay",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 330.5664,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/123",
				"SHAPE_Leng": 1.15335939243,
				"SHAPE_Area": 0.0321650069645
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								151.94453193800007,
								-32.675840377999975
							],
							[
								151.95632749600009,
								-32.67499137899995
							],
							[
								151.95778147700003,
								-32.666819378999946
							],
							[
								151.96341447600003,
								-32.67139538999993
							],
							[
								151.96992034700008,
								-32.65376541999996
							],
							[
								151.9842595140001,
								-32.66486539199997
							],
							[
								151.99168548400007,
								-32.65957037299995
							],
							[
								151.99401848200012,
								-32.66886339299998
							],
							[
								152.02980800800003,
								-32.66400813599995
							],
							[
								152.0429864340001,
								-32.679670477999935
							],
							[
								152.04379549600003,
								-32.66034537799993
							],
							[
								152.0611394550001,
								-32.649936398999955
							],
							[
								152.06138948300008,
								-32.669602398999984
							],
							[
								152.0503034830001,
								-32.67612837799993
							],
							[
								152.06581806100007,
								-32.68153492999994
							],
							[
								152.06142846000012,
								-32.68805937899998
							],
							[
								152.11439046400005,
								-32.68109239499995
							],
							[
								152.12190391600006,
								-32.65773868499997
							],
							[
								152.1376574620001,
								-32.67096738699996
							],
							[
								152.12762284300004,
								-32.67610165599996
							],
							[
								152.12949548100005,
								-32.685664395999936
							],
							[
								152.13992144000008,
								-32.68579239699994
							],
							[
								152.1455374100001,
								-32.67741752799998
							],
							[
								152.15810847800003,
								-32.68259939899997
							],
							[
								152.17310848600005,
								-32.678327389999936
							],
							[
								152.19175844100005,
								-32.70046740199996
							],
							[
								152.20504845900007,
								-32.701207402999955
							],
							[
								152.20871246900003,
								-32.69557039399996
							],
							[
								152.19188846200007,
								-32.69433441199993
							],
							[
								152.18667648400003,
								-32.68538041199997
							],
							[
								152.1956834780001,
								-32.64790940199998
							],
							[
								152.23126046700008,
								-32.615832404999935
							],
							[
								152.2850314630001,
								-32.59476241099998
							],
							[
								152.3029384350001,
								-32.55928240199995
							],
							[
								152.3356351750001,
								-32.52706617499996
							],
							[
								152.4188592900001,
								-32.482536462999974
							],
							[
								152.47905972500007,
								-32.46087610899997
							],
							[
								152.51972009000008,
								-32.454940792999935
							],
							[
								152.52122098100006,
								-32.44707568299998
							],
							[
								152.5399125890001,
								-32.44345130399995
							],
							[
								152.5375325010001,
								-32.43359128399993
							],
							[
								152.51955774400005,
								-32.42827852199997
							],
							[
								152.51632140700008,
								-32.40849247199998
							],
							[
								152.52274087900003,
								-32.38806829199996
							],
							[
								152.53371755900002,
								-32.37975711299998
							],
							[
								152.5345100520001,
								-32.35563703299994
							],
							[
								152.5516951630001,
								-32.334597764999955
							],
							[
								152.54622122400008,
								-32.327416823999954
							],
							[
								152.53638553500002,
								-32.328970942999945
							],
							[
								152.52344646900008,
								-32.311713001999976
							],
							[
								152.52370018200008,
								-32.29439792199997
							],
							[
								152.5366933150001,
								-32.25926359299996
							],
							[
								152.56636208500004,
								-32.22950126499995
							],
							[
								152.57087771600004,
								-32.215620215999934
							],
							[
								152.54325412200012,
								-32.20157432299993
							],
							[
								152.53623393500004,
								-32.18278533199998
							],
							[
								152.51287429900003,
								-32.177619489999984
							],
							[
								152.50529395400008,
								-32.15128846899995
							],
							[
								152.51686583800006,
								-32.10797319999995
							],
							[
								152.54801351900005,
								-32.07325884299996
							],
							[
								152.54381588400008,
								-32.03608074199997
							],
							[
								152.6335301480001,
								-31.92242503999995
							],
							[
								152.69099048700002,
								-31.877646814999935
							],
							[
								152.7545627930001,
								-31.845064520999983
							],
							[
								152.73454199700006,
								-31.83197262899995
							],
							[
								152.73917137000012,
								-31.80389256899997
							],
							[
								152.7651045120001,
								-31.767507531999968
							],
							[
								152.8056355020001,
								-31.730307325999945
							],
							[
								152.79276468600006,
								-31.710709533999932
							],
							[
								152.80492218900008,
								-31.681847484999935
							],
							[
								152.84952850800005,
								-31.641334468999958
							],
							[
								152.83800152000003,
								-31.639234457999976
							],
							[
								152.83396107200008,
								-31.62893535799998
							],
							[
								152.84829349400002,
								-31.601562298999966
							],
							[
								152.84010950700008,
								-31.588047337999967
							],
							[
								152.8523075490001,
								-31.560558448999984
							],
							[
								152.9152015100001,
								-31.492801464999957
							],
							[
								152.9032975120001,
								-31.492057473999978
							],
							[
								152.89516107500003,
								-31.478552342999933
							],
							[
								152.87610395700005,
								-31.47829387099995
							],
							[
								152.86683251800002,
								-31.481119449999937
							],
							[
								152.87435151600005,
								-31.488109510999948
							],
							[
								152.8625454060001,
								-31.502235219999932
							],
							[
								152.85852624900008,
								-31.47965323899996
							],
							[
								152.81498555500002,
								-31.476768454999956
							],
							[
								152.82542025200007,
								-31.415478374999964
							],
							[
								152.79395332400009,
								-31.354999561999932
							],
							[
								152.78594456700012,
								-31.343081450999932
							],
							[
								152.7659114700001,
								-31.338446698999974
							],
							[
								152.75776654000003,
								-31.347590457999956
							],
							[
								152.73667957400005,
								-31.340128445999937
							],
							[
								152.73490155500008,
								-31.332866455999977
							],
							[
								152.74825756400003,
								-31.323963436999975
							],
							[
								152.73227559600002,
								-31.325757434999957
							],
							[
								152.73536656700003,
								-31.31881744599997
							],
							[
								152.71207256200012,
								-31.30122344299997
							],
							[
								152.6915276000001,
								-31.26418444099994
							],
							[
								152.6741725830001,
								-31.253853448999962
							],
							[
								152.67969857600008,
								-31.22719042899996
							],
							[
								152.68966259500007,
								-31.22862933999994
							],
							[
								152.70473260500012,
								-31.20777744199995
							],
							[
								152.72285259300008,
								-31.205397432999973
							],
							[
								152.73052259100007,
								-31.215682433999973
							],
							[
								152.7464044290001,
								-31.216447045999928
							],
							[
								152.75166007100006,
								-31.194700075999947
							],
							[
								152.72620136600005,
								-31.185216303999937
							],
							[
								152.7279651870001,
								-31.176265323999928
							],
							[
								152.70596159900003,
								-31.180708481999943
							],
							[
								152.70694860300011,
								-31.15149944099994
							],
							[
								152.69288460600012,
								-31.141066439999975
							],
							[
								152.68116058700002,
								-31.14082543899997
							],
							[
								152.67377561700005,
								-31.153514437999945
							],
							[
								152.65778657900012,
								-31.149213446999966
							],
							[
								152.64966161000007,
								-31.15451942599998
							],
							[
								152.6322496140001,
								-31.138540443999943
							],
							[
								152.5961526200001,
								-31.12376942999998
							],
							[
								152.5616556340001,
								-31.129540426999938
							],
							[
								152.55623563200004,
								-31.148175416999948
							],
							[
								152.5411676340001,
								-31.15202142499993
							],
							[
								152.53970259200003,
								-31.16287342499993
							],
							[
								152.5196766140001,
								-31.167123432999972
							],
							[
								152.47077162100004,
								-31.16627641799994
							],
							[
								152.45583761400007,
								-31.15581842699993
							],
							[
								152.3864616310001,
								-31.166733419999957
							],
							[
								152.3691866250001,
								-31.156085407999967
							],
							[
								152.368281098,
								-31.136461087999976
							],
							[
								152.34959230300012,
								-31.11699129599998
							],
							[
								152.3379553740001,
								-31.114413344999946
							],
							[
								152.34261043200001,
								-31.12833026499993
							],
							[
								152.3309025840001,
								-31.12745134399995
							],
							[
								152.31657753500008,
								-31.202923132999956
							],
							[
								152.25468617400008,
								-31.194522476999964
							],
							[
								152.25168138300012,
								-31.20626553699998
							],
							[
								152.23411250700008,
								-31.197448624999936
							],
							[
								152.22340286700012,
								-31.207889783999974
							],
							[
								152.19967816100007,
								-31.19356804199998
							],
							[
								152.17896959300003,
								-31.199496199999942
							],
							[
								152.17065657600006,
								-31.190687238999942
							],
							[
								152.15185177800004,
								-31.18809432699993
							],
							[
								152.14963213400006,
								-31.223761326999977
							],
							[
								152.16056406200005,
								-31.229977237999947
							],
							[
								152.16096819000006,
								-31.24020823899997
							],
							[
								152.15287668700012,
								-31.272974397999974
							],
							[
								152.13890006700012,
								-31.285382586999958
							],
							[
								152.12368432000005,
								-31.27871672499998
							],
							[
								152.0996300380001,
								-31.393043063999983
							],
							[
								152.09664203900002,
								-31.38823709299993
							],
							[
								152.0705706000001,
								-31.40365727099993
							],
							[
								152.06786260100012,
								-31.398384300999965
							],
							[
								152.06466891700006,
								-31.438578350999933
							],
							[
								152.08781568100005,
								-31.45616308299998
							],
							[
								152.0785489100001,
								-31.47351310199997
							],
							[
								152.0838026460001,
								-31.50048338299996
							],
							[
								151.91277524100008,
								-31.47668733599994
							],
							[
								151.91576071600002,
								-31.510054856999943
							],
							[
								151.84458521700003,
								-31.49946269999998
							],
							[
								151.8427643760001,
								-31.509025719999954
							],
							[
								151.80235702200002,
								-31.504989955999974
							],
							[
								151.78933232200006,
								-31.514925044999984
							],
							[
								151.75334894700006,
								-31.51429523099995
							],
							[
								151.75846310300005,
								-31.53535920199994
							],
							[
								151.78661372800002,
								-31.547798134999937
							],
							[
								151.8025027530001,
								-31.573848105999957
							],
							[
								151.78165132300012,
								-31.592615244999934
							],
							[
								151.7567519050001,
								-31.60173742199993
							],
							[
								151.7568726400001,
								-31.63814535299997
							],
							[
								151.71301665800002,
								-31.620554337999977
							],
							[
								151.69057664100012,
								-31.622539355999947
							],
							[
								151.69195266200006,
								-31.614499345999945
							],
							[
								151.68211565400009,
								-31.608773354999983
							],
							[
								151.6571096560001,
								-31.613240342999973
							],
							[
								151.65258365800003,
								-31.602647331999947
							],
							[
								151.63361668900006,
								-31.61521235099997
							],
							[
								151.62470868100002,
								-31.606784339999933
							],
							[
								151.61007068300012,
								-31.607961347999947
							],
							[
								151.6014126660001,
								-31.595591336999973
							],
							[
								151.56940768800007,
								-31.609940344999984
							],
							[
								151.53565241400008,
								-31.596073590999936
							],
							[
								151.52091221700005,
								-31.664838249999946
							],
							[
								151.52330150500006,
								-31.683472580999933
							],
							[
								151.53478914200002,
								-31.694094381999946
							],
							[
								151.51770100400006,
								-31.76928235099996
							],
							[
								151.53104868200012,
								-31.77030233199997
							],
							[
								151.55410740700006,
								-31.78729027399993
							],
							[
								151.5940393520001,
								-31.78958655799994
							],
							[
								151.58439060700005,
								-31.83923701799995
							],
							[
								151.57691376500009,
								-31.85472412699994
							],
							[
								151.56302208600005,
								-31.86159500599996
							],
							[
								151.5508987180001,
								-31.859762884999952
							],
							[
								151.55696866800008,
								-31.855680744999972
							],
							[
								151.5525046900001,
								-31.847324864999962
							],
							[
								151.51594454400004,
								-31.852828190999958
							],
							[
								151.51316532200008,
								-31.868402500999935
							],
							[
								151.49369399400007,
								-31.87588889899996
							],
							[
								151.48525957300012,
								-31.89256570899994
							],
							[
								151.46912905400006,
								-31.89692953699995
							],
							[
								151.44157031100008,
								-31.951826024999946
							],
							[
								151.4547315430001,
								-31.99596590599998
							],
							[
								151.43861687300011,
								-32.01716540499996
							],
							[
								151.4049781450001,
								-32.036640311999975
							],
							[
								151.40694436100011,
								-32.058326971999975
							],
							[
								151.38955908100002,
								-32.083227990999944
							],
							[
								151.33545389800008,
								-32.082390155999974
							],
							[
								151.3342510770001,
								-32.092142115999934
							],
							[
								151.30394888800004,
								-32.116734202999965
							],
							[
								151.3118189050001,
								-32.126529163999976
							],
							[
								151.30970409400004,
								-32.13897111399996
							],
							[
								151.32789962900006,
								-32.154607315999954
							],
							[
								151.32721929700006,
								-32.171658925999964
							],
							[
								151.34554164300005,
								-32.18296331799996
							],
							[
								151.3507176290001,
								-32.21343331799994
							],
							[
								151.33714517800001,
								-32.237309756999935
							],
							[
								151.341988613,
								-32.26769331799994
							],
							[
								151.37149246600006,
								-32.29158541099997
							],
							[
								151.38055961200007,
								-32.314213311999936
							],
							[
								151.3902754300001,
								-32.315579242999945
							],
							[
								151.3830026600001,
								-32.32410029199997
							],
							[
								151.39580349800008,
								-32.32504423299997
							],
							[
								151.39796568600002,
								-32.34296028399996
							],
							[
								151.42813354800012,
								-32.370029226999975
							],
							[
								151.43419367500007,
								-32.38745017699995
							],
							[
								151.45055359100002,
								-32.40171933899995
							],
							[
								151.4461545810001,
								-32.40706231899998
							],
							[
								151.46902058600006,
								-32.421016340999984
							],
							[
								151.47434859400005,
								-32.430930341999954
							],
							[
								151.45568231100003,
								-32.47070107999997
							],
							[
								151.5007329010001,
								-32.50417500499998
							],
							[
								151.49607319400002,
								-32.55729211399995
							],
							[
								151.47972356700006,
								-32.55520033299996
							],
							[
								151.4708216900001,
								-32.61816460299997
							],
							[
								151.451175013,
								-32.61546869099993
							],
							[
								151.44586605400002,
								-32.60774473999993
							],
							[
								151.4408645740001,
								-32.61561072999996
							],
							[
								151.43081531500002,
								-32.61534083899994
							],
							[
								151.4243889820001,
								-32.646203827999955
							],
							[
								151.4030599130001,
								-32.66292608599997
							],
							[
								151.4081935600001,
								-32.68188333699993
							],
							[
								151.43150756500006,
								-32.69221632899996
							],
							[
								151.43823156700012,
								-32.669521319999944
							],
							[
								151.45406456500007,
								-32.66741133099998
							],
							[
								151.45009855700005,
								-32.65764934099997
							],
							[
								151.47619455300003,
								-32.660588322999956
							],
							[
								151.48931155500009,
								-32.635909323999954
							],
							[
								151.51037555800008,
								-32.662317336999934
							],
							[
								151.51436554400004,
								-32.693349326999964
							],
							[
								151.53814854300003,
								-32.67817932899993
							],
							[
								151.54381353100007,
								-32.68784933999996
							],
							[
								151.56603654700007,
								-32.68819033199998
							],
							[
								151.55708152300008,
								-32.732296351999935
							],
							[
								151.58349850900004,
								-32.736326333999955
							],
							[
								151.60049753900012,
								-32.715855345999955
							],
							[
								151.61464344700005,
								-32.71500434699993
							],
							[
								151.6252035450001,
								-32.72409334799994
							],
							[
								151.64130355300006,
								-32.71884735899994
							],
							[
								151.66906255600009,
								-32.741456151999955
							],
							[
								151.6873040160001,
								-32.72701244399997
							],
							[
								151.72419566000008,
								-32.73487692699996
							],
							[
								151.72947176600007,
								-32.76044198799997
							],
							[
								151.75218151400009,
								-32.749500369999964
							],
							[
								151.7340004980001,
								-32.736229357999946
							],
							[
								151.74761448800007,
								-32.721169359999976
							],
							[
								151.75563252300003,
								-32.67831236999996
							],
							[
								151.80984753500002,
								-32.68620935499996
							],
							[
								151.82835986400005,
								-32.67294232699993
							],
							[
								151.8295355260001,
								-32.65947036699998
							],
							[
								151.89488051500007,
								-32.66887636299998
							],
							[
								151.89624693700011,
								-32.65898685299993
							],
							[
								151.91339036400007,
								-32.65853564499997
							],
							[
								151.93617347100007,
								-32.66367037699996
							],
							[
								151.94453193800007,
								-32.675840377999975
							]
						]
					],
					[
						[
							[
								151.96535748500003,
								-32.673529379999934
							],
							[
								151.97486248300004,
								-32.68021737099997
							],
							[
								151.970314475,
								-32.667532380999944
							],
							[
								151.96535748500003,
								-32.673529379999934
							]
						]
					],
					[
						[
							[
								152.22256385800006,
								-32.68932011499993
							],
							[
								152.22873870800004,
								-32.68725006599993
							],
							[
								152.22347128900003,
								-32.68375246499994
							],
							[
								152.22256385800006,
								-32.68932011499993
							]
						]
					],
					[
						[
							[
								152.32357643500006,
								-32.615588413999944
							],
							[
								152.305314908,
								-32.60715546299997
							],
							[
								152.31203181500007,
								-32.626769372999945
							],
							[
								152.3192242140001,
								-32.62789396399995
							],
							[
								152.31506846500008,
								-32.618481403999965
							],
							[
								152.32610245400008,
								-32.62041741499996
							],
							[
								152.32357643500006,
								-32.615588413999944
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "124",
				"CED_NAME21": "Lyne",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 16041.8507,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/124",
				"SHAPE_Leng": 8.67803048377,
				"SHAPE_Area": 1.53035338022
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							150.88857814800008,
							-34.005450037999935
						],
						[
							150.866308483,
							-33.98666128599996
						],
						[
							150.83785943500004,
							-34.00668860299993
						],
						[
							150.84446246700008,
							-33.984446273999936
						],
						[
							150.8151174630001,
							-33.96785327099997
						],
						[
							150.82256922400006,
							-33.951984951999975
						],
						[
							150.73174048900012,
							-33.93990026299997
						],
						[
							150.7392169960001,
							-33.955762463999974
						],
						[
							150.75422649300003,
							-33.95872227499996
						],
						[
							150.73881849500003,
							-33.96146027399993
						],
						[
							150.7231764820001,
							-33.99979527299996
						],
						[
							150.7270544580001,
							-34.02799626299998
						],
						[
							150.7809354960001,
							-34.059665278999944
						],
						[
							150.76642816600008,
							-34.07805057699994
						],
						[
							150.7409876690001,
							-34.08328189499997
						],
						[
							150.73766718500008,
							-34.114561984999966
						],
						[
							150.7567129910001,
							-34.121928726999954
						],
						[
							150.7499042510001,
							-34.13158783599994
						],
						[
							150.75625432900006,
							-34.141318756999965
						],
						[
							150.7520687660001,
							-34.163850836999984
						],
						[
							150.85953142800008,
							-34.18103528699993
						],
						[
							150.8993604420001,
							-34.18960029999994
						],
						[
							150.92258542600007,
							-34.12999929199998
						],
						[
							150.93660062900005,
							-34.09511667299995
						],
						[
							150.9233437910001,
							-34.089793791999966
						],
						[
							150.93717835100006,
							-34.075338622999936
						],
						[
							150.94079671500003,
							-34.04002047299997
						],
						[
							150.8866624740001,
							-34.032101987999965
						],
						[
							150.88857814800008,
							-34.005450037999935
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "125",
				"CED_NAME21": "Macarthur",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 361.5934,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/125",
				"SHAPE_Leng": 1.05874763294,
				"SHAPE_Area": 0.035315341036
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							151.29972244200007,
							-33.75658833499995
						],
						[
							151.30318144300008,
							-33.746785314999954
						],
						[
							151.29138066500002,
							-33.746653623999975
						],
						[
							151.31771946100002,
							-33.74196731599994
						],
						[
							151.30020344600007,
							-33.72703532399993
						],
						[
							151.307737588,
							-33.70320334499996
						],
						[
							151.29995943900008,
							-33.70496330399993
						],
						[
							151.29358132800007,
							-33.721301353999934
						],
						[
							151.2825595700001,
							-33.71350529299997
						],
						[
							151.27473028000009,
							-33.723651331999974
						],
						[
							151.26970361200006,
							-33.71493430099997
						],
						[
							151.2811955210001,
							-33.708676321999974
						],
						[
							151.29372746800004,
							-33.71451931399997
						],
						[
							151.29775337900003,
							-33.70361330399993
						],
						[
							151.3100894380001,
							-33.70395333499994
						],
						[
							151.3152734580001,
							-33.69637133599997
						],
						[
							151.30979145000003,
							-33.686337314999946
						],
						[
							151.34302642400007,
							-33.624495337999974
						],
						[
							151.3253424300001,
							-33.59734232599993
						],
						[
							151.3310064310001,
							-33.57891932599995
						],
						[
							151.32275546200003,
							-33.579556314999934
						],
						[
							151.31589736000012,
							-33.60180430499997
						],
						[
							151.332153435,
							-33.623351336999974
						],
						[
							151.3160724490001,
							-33.61417533499997
						],
						[
							151.31491944700008,
							-33.63103532499997
						],
						[
							151.30468747800012,
							-33.63529132399998
						],
						[
							151.30941645600012,
							-33.63922233499994
						],
						[
							151.30102346600006,
							-33.65051410399997
						],
						[
							151.3120464220001,
							-33.66671832499998
						],
						[
							151.30670713400002,
							-33.66245763499995
						],
						[
							151.3010515640001,
							-33.66727049399998
						],
						[
							151.30460845400012,
							-33.66051833399996
						],
						[
							151.2847764390001,
							-33.64419369199993
						],
						[
							151.26981739000007,
							-33.65623630099998
						],
						[
							151.28266846000008,
							-33.63664232199994
						],
						[
							151.27042446300004,
							-33.63152331099997
						],
						[
							151.2905134,
							-33.62847732299997
						],
						[
							151.2829154520001,
							-33.621837321999976
						],
						[
							151.30286245000002,
							-33.62052832399996
						],
						[
							151.30443344200012,
							-33.60317832399994
						],
						[
							151.29252346300007,
							-33.605316322999954
						],
						[
							151.31084244400006,
							-33.579556313999944
						],
						[
							151.29298157800008,
							-33.57186229299998
						],
						[
							151.28361439900004,
							-33.57296632199996
						],
						[
							151.27301632800004,
							-33.588946360999955
						],
						[
							151.25009046200012,
							-33.58800927899995
						],
						[
							151.26262853900005,
							-33.597705349999956
						],
						[
							151.2519534600001,
							-33.59806128899993
						],
						[
							151.25673356800007,
							-33.605432278999956
						],
						[
							151.243545282,
							-33.594432307999966
						],
						[
							151.23676939200004,
							-33.60262834799994
						],
						[
							151.21938141400005,
							-33.59964529599995
						],
						[
							151.22888035100004,
							-33.618163326999934
						],
						[
							151.21850836300007,
							-33.60908628599998
						],
						[
							151.182184376,
							-33.62808528299996
						],
						[
							151.1732524570001,
							-33.62634828199998
						],
						[
							151.16151029500008,
							-33.65959185099996
						],
						[
							151.1718510710001,
							-33.677529421999964
						],
						[
							151.16570287000002,
							-33.685858801999984
						],
						[
							151.1914225150001,
							-33.70268653399995
						],
						[
							151.1917420310001,
							-33.72828247399997
						],
						[
							151.18032819100006,
							-33.74056854299994
						],
						[
							151.19385905800004,
							-33.75022437499996
						],
						[
							151.20293737300005,
							-33.77354884599998
						],
						[
							151.20437124300008,
							-33.77246851599995
						],
						[
							151.20809311400012,
							-33.76090229599998
						],
						[
							151.22744314300007,
							-33.75132198799997
						],
						[
							151.29972244200007,
							-33.75658833499995
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "126",
				"CED_NAME21": "Mackellar",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 212.5278,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/126",
				"SHAPE_Leng": 1.70008506367,
				"SHAPE_Area": 0.020661590591
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							150.6127985160001,
							-33.86183427199995
						],
						[
							150.5936597000001,
							-33.85629930999994
						],
						[
							150.5880476520001,
							-33.84492037899997
						],
						[
							150.64304052300008,
							-33.77976462399994
						],
						[
							150.64405870000007,
							-33.721199713999965
						],
						[
							150.65796862900004,
							-33.71370924499996
						],
						[
							150.65789471400012,
							-33.677018404999956
						],
						[
							150.6814994570001,
							-33.62506096599998
						],
						[
							150.70141633600008,
							-33.61239742799995
						],
						[
							150.78215341100008,
							-33.63750452599993
						],
						[
							150.81239963200005,
							-33.67760118899997
						],
						[
							150.8191145710001,
							-33.67577626899998
						],
						[
							150.81306645300003,
							-33.66926565899996
						],
						[
							150.81811637300007,
							-33.66168527899998
						],
						[
							150.85104751000006,
							-33.650125281999976
						],
						[
							150.85874550900007,
							-33.64630427299994
						],
						[
							150.87404451600003,
							-33.656658283999946
						],
						[
							150.90435728700004,
							-33.61179572699996
						],
						[
							150.9357365290001,
							-33.56476528899998
						],
						[
							150.91655749300003,
							-33.554614286999936
						],
						[
							150.88965750600005,
							-33.56154229499998
						],
						[
							150.88940014900004,
							-33.54062545499994
						],
						[
							150.9078037390001,
							-33.52255927599998
						],
						[
							150.89854778100005,
							-33.51234331599994
						],
						[
							150.91928353800006,
							-33.51674716699995
						],
						[
							150.92767729800005,
							-33.50485105799993
						],
						[
							150.8935175360001,
							-33.484646434999945
						],
						[
							150.8704930870001,
							-33.50017856299996
						],
						[
							150.87902178700006,
							-33.486545543999966
						],
						[
							150.87106972000004,
							-33.47311364299998
						],
						[
							150.9052692260001,
							-33.46959731599998
						],
						[
							150.89825615900008,
							-33.45173635499998
						],
						[
							150.8755454620001,
							-33.45273457299993
						],
						[
							150.8873581030001,
							-33.43718849399994
						],
						[
							150.8981729410001,
							-33.43585739499997
						],
						[
							150.89376388300002,
							-33.42721146399998
						],
						[
							150.90358063300005,
							-33.41948036499997
						],
						[
							150.92454437000004,
							-33.418316146999985
						],
						[
							150.92496053800005,
							-33.43244916699996
						],
						[
							150.93985118800003,
							-33.413909968999974
						],
						[
							150.95158221500003,
							-33.42746080999996
						],
						[
							150.95174807700005,
							-33.41374281999998
						],
						[
							150.97665753500007,
							-33.40022056199996
						],
						[
							150.98846301600008,
							-33.37921897299998
						],
						[
							150.9843341080001,
							-33.371031441999946
						],
						[
							151.00044385800004,
							-33.35050123399998
						],
						[
							151.0310719140001,
							-33.35157827699993
						],
						[
							151.0896327590001,
							-33.32692375199997
						],
						[
							151.0842252210001,
							-33.31853215099994
						],
						[
							151.09606344100007,
							-33.29981522199995
						],
						[
							151.08688453700006,
							-33.26903477099995
						],
						[
							151.09996726600002,
							-33.261618951999935
						],
						[
							151.1068148590001,
							-33.23123918299996
						],
						[
							151.09833434200004,
							-33.21819774199997
						],
						[
							151.10582561,
							-33.15150098199996
						],
						[
							151.09967893100008,
							-33.14428650199994
						],
						[
							151.1076975520001,
							-33.12794230199995
						],
						[
							151.1355325610001,
							-33.11038830499996
						],
						[
							151.1279425340001,
							-33.091688303999945
						],
						[
							151.11453954600006,
							-33.091159312999935
						],
						[
							151.10397755000008,
							-33.07695630099994
						],
						[
							151.0839479230001,
							-33.075235189999944
						],
						[
							151.05214255600004,
							-33.08019544699994
						],
						[
							151.0418155760001,
							-33.09124728599994
						],
						[
							151.0351564030001,
							-33.12405472499995
						],
						[
							150.99416712900006,
							-33.12241608199997
						],
						[
							150.9659025520001,
							-33.12988328899996
						],
						[
							150.9241132400001,
							-33.111093764999964
						],
						[
							150.899996632,
							-33.121163982999974
						],
						[
							150.8843975950001,
							-33.118963270999984
						],
						[
							150.85875156100008,
							-33.09411828899994
						],
						[
							150.84704058300008,
							-33.09805826799993
						],
						[
							150.85324160400012,
							-33.08337527799995
						],
						[
							150.84836560500003,
							-33.074520277999966
						],
						[
							150.85896458600007,
							-33.06106228899995
						],
						[
							150.84708459900003,
							-33.05231128799994
						],
						[
							150.85753860700004,
							-33.05000427799996
						],
						[
							150.84975957900008,
							-33.04580627799993
						],
						[
							150.85796258800008,
							-33.043064277999974
						],
						[
							150.8551476,
							-33.03239027799998
						],
						[
							150.83071658300003,
							-33.033331285999964
						],
						[
							150.81850160600004,
							-33.023640274999934
						],
						[
							150.81979158700005,
							-33.014570284999934
						],
						[
							150.80479261000005,
							-33.00603227299996
						],
						[
							150.76383731700002,
							-33.00030880999998
						],
						[
							150.76106309500005,
							-33.01477066899997
						],
						[
							150.74543175700012,
							-33.021940177999966
						],
						[
							150.72351227100012,
							-33.012300135999965
						],
						[
							150.71144201200002,
							-33.014516844999946
						],
						[
							150.69668820700008,
							-32.99639346299995
						],
						[
							150.68579459800003,
							-32.99675726199996
						],
						[
							150.67220316700002,
							-33.02146080099993
						],
						[
							150.68210043200008,
							-33.04473017199996
						],
						[
							150.70539771900008,
							-33.04462454399993
						],
						[
							150.70721180700002,
							-33.05863057499994
						],
						[
							150.72788667300006,
							-33.07201040699994
						],
						[
							150.63024378800003,
							-33.058573327999966
						],
						[
							150.61069311000006,
							-33.06612454599997
						],
						[
							150.60561931900008,
							-33.07393563599993
						],
						[
							150.61418017800008,
							-33.07345152599993
						],
						[
							150.61355138600004,
							-33.089174585999956
						],
						[
							150.60708347700006,
							-33.089639655999974
						],
						[
							150.6108484550001,
							-33.09885370599994
						],
						[
							150.60162063600012,
							-33.10061383499993
						],
						[
							150.61974642300004,
							-33.10999674699997
						],
						[
							150.60991156400007,
							-33.10840781599995
						],
						[
							150.61224859300012,
							-33.11888388699998
						],
						[
							150.59849988400003,
							-33.12538206499994
						],
						[
							150.6098840400001,
							-33.14334902599995
						],
						[
							150.5865754030001,
							-33.14767929399994
						],
						[
							150.5836066700001,
							-33.16811043399997
						],
						[
							150.5696968520001,
							-33.168016602999955
						],
						[
							150.56984172400007,
							-33.15588452299994
						],
						[
							150.5549429350001,
							-33.16167273199994
						],
						[
							150.55235921300005,
							-33.18371387199994
						],
						[
							150.52383369500012,
							-33.19455525899997
						],
						[
							150.54434274900007,
							-33.22094013099996
						],
						[
							150.53151792000006,
							-33.22421733999994
						],
						[
							150.52570511900012,
							-33.238953479999964
						],
						[
							150.54393423500005,
							-33.25598005099994
						],
						[
							150.56039507200012,
							-33.256905812999946
						],
						[
							150.55320833100006,
							-33.274818951999976
						],
						[
							150.5755661060001,
							-33.28960584399994
						],
						[
							150.5575083980001,
							-33.290764052999975
						],
						[
							150.56672139500006,
							-33.30629102399996
						],
						[
							150.5515287060001,
							-33.315272241999935
						],
						[
							150.58379335000006,
							-33.32192881499998
						],
						[
							150.5906265870001,
							-33.34259172599997
						],
						[
							150.5588251580001,
							-33.36617019299996
						],
						[
							150.5410933510001,
							-33.36345443199997
						],
						[
							150.52565473200002,
							-33.37567269999994
						],
						[
							150.48234357700005,
							-33.38271048699994
						],
						[
							150.4878175560001,
							-33.38675941699995
						],
						[
							150.4850397250001,
							-33.39734448699994
						],
						[
							150.4757558760001,
							-33.39897561599997
						],
						[
							150.479168221,
							-33.42973757699997
						],
						[
							150.4600227620001,
							-33.44930178499993
						],
						[
							150.46835666000004,
							-33.45405566599993
						],
						[
							150.45126006200007,
							-33.458799933999956
						],
						[
							150.44740536900008,
							-33.48141000399994
						],
						[
							150.41694010300012,
							-33.48656855099995
						],
						[
							150.40852798600008,
							-33.47326961099998
						],
						[
							150.39727528600008,
							-33.47963078999993
						],
						[
							150.3990704350001,
							-33.48947384999997
						],
						[
							150.38652041800003,
							-33.479368948999934
						],
						[
							150.38284662800004,
							-33.48763503799995
						],
						[
							150.3694459090001,
							-33.49108323699994
						],
						[
							150.35486401200012,
							-33.48575236599993
						],
						[
							150.34821754000006,
							-33.50895562499994
						],
						[
							150.33562475100007,
							-33.511934803999964
						],
						[
							150.33100703000002,
							-33.52251290399994
						],
						[
							150.31191723300003,
							-33.52013704199993
						],
						[
							150.31467390500006,
							-33.50440095199997
						],
						[
							150.2568194050001,
							-33.49429240699993
						],
						[
							150.25067954700012,
							-33.558032726999954
						],
						[
							150.22612378000008,
							-33.56050297499996
						],
						[
							150.22689564200004,
							-33.54949793499998
						],
						[
							150.2156477640001,
							-33.54796400399994
						],
						[
							150.2121859230001,
							-33.55853709399997
						],
						[
							150.22745697000005,
							-33.563519474999964
						],
						[
							150.24322420300007,
							-33.60242693699996
						],
						[
							150.26028710900005,
							-33.610701837999954
						],
						[
							150.258982198,
							-33.61745685799997
						],
						[
							150.27147511600003,
							-33.619132718999936
						],
						[
							150.26192365500003,
							-33.64165091899997
						],
						[
							150.24050976800004,
							-33.638563096999974
						],
						[
							150.2378129970001,
							-33.65120917599995
						],
						[
							150.2481511840001,
							-33.66409515699996
						],
						[
							150.2313692470001,
							-33.66299127599996
						],
						[
							150.22892053500004,
							-33.67598530599997
						],
						[
							150.21483668700012,
							-33.67482744499995
						],
						[
							150.2076263240001,
							-33.70850155399995
						],
						[
							150.18108684800006,
							-33.70439871199994
						],
						[
							150.17917384700002,
							-33.72212484199997
						],
						[
							150.1956525050001,
							-33.71285467299998
						],
						[
							150.2124204920001,
							-33.72121549499997
						],
						[
							150.1798042040001,
							-33.74315778199997
						],
						[
							150.19180518100006,
							-33.750265542999955
						],
						[
							150.1956804880001,
							-33.76662436399994
						],
						[
							150.17758934000005,
							-33.77827419199997
						],
						[
							150.16873545900012,
							-33.79511834099998
						],
						[
							150.18113640600006,
							-33.80258226199993
						],
						[
							150.16928799400011,
							-33.82702716199998
						],
						[
							150.17532301300002,
							-33.83424806199997
						],
						[
							150.1827308720001,
							-33.829865042999984
						],
						[
							150.18539095100004,
							-33.837690952999935
						],
						[
							150.17571950900003,
							-33.86123982199996
						],
						[
							150.1660586900001,
							-33.86504089199997
						],
						[
							150.18522173500003,
							-33.88038660299998
						],
						[
							150.18910719400003,
							-33.88609324399994
						],
						[
							150.1962751740001,
							-33.87773781399994
						],
						[
							150.20659025200007,
							-33.88513185499994
						],
						[
							150.2351746380001,
							-33.88435084799994
						],
						[
							150.2470826880001,
							-33.86921131899993
						],
						[
							150.2549224160001,
							-33.871461229999966
						],
						[
							150.27957808600001,
							-33.85075708199997
						],
						[
							150.3036207130001,
							-33.845365913999956
						],
						[
							150.32095645000004,
							-33.849353624999935
						],
						[
							150.32461261800006,
							-33.85607456599996
						],
						[
							150.35051455400003,
							-33.85991423799993
						],
						[
							150.3310225360001,
							-33.86713423599997
						],
						[
							150.34275654200007,
							-33.88440524799995
						],
						[
							150.34267354000008,
							-33.90088023799996
						],
						[
							150.35552355000004,
							-33.88631024899996
						],
						[
							150.3557705490001,
							-33.89236423899996
						],
						[
							150.3684315580001,
							-33.888928239999984
						],
						[
							150.37225156600005,
							-33.90082123999997
						],
						[
							150.38770355300005,
							-33.90382725199993
						],
						[
							150.401543542,
							-33.89608824299995
						],
						[
							150.39429957200002,
							-33.90530523199993
						],
						[
							150.3981345190001,
							-33.924684242999945
						],
						[
							150.4191915440001,
							-33.939539244999935
						],
						[
							150.4320295430001,
							-33.93252125599997
						],
						[
							150.43919956000002,
							-33.94561623699997
						],
						[
							150.45166653900003,
							-33.94067423799993
						],
						[
							150.47134452400007,
							-33.95847525999994
						],
						[
							150.4972405420001,
							-33.94565424199993
						],
						[
							150.5214105120001,
							-33.92144325399994
						],
						[
							150.59646290600006,
							-33.88413158999998
						],
						[
							150.61171084500006,
							-33.872679611999956
						],
						[
							150.6127985160001,
							-33.86183427199995
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "127",
				"CED_NAME21": "Macquarie",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 4360.4273,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/127",
				"SHAPE_Leng": 5.70111666445,
				"SHAPE_Area": 0.422959120985
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							150.8033866400001,
							-33.77679860899997
						],
						[
							150.81149069700007,
							-33.79110887899998
						],
						[
							150.75701606600012,
							-33.782895003999954
						],
						[
							150.75693367400004,
							-33.79809160499997
						],
						[
							150.7468722760001,
							-33.79665698399998
						],
						[
							150.74836103500002,
							-33.80285296399995
						],
						[
							150.7415462250001,
							-33.803345322999974
						],
						[
							150.74108322400002,
							-33.815344762999985
						],
						[
							150.77599634800004,
							-33.820799835999935
						],
						[
							150.77896047700006,
							-33.82724727699997
						],
						[
							150.7663942480001,
							-33.82921006599997
						],
						[
							150.76538841600006,
							-33.84933962599996
						],
						[
							150.77605350200008,
							-33.87119627699997
						],
						[
							150.7679134120001,
							-33.875715165999964
						],
						[
							150.7978144970001,
							-33.88087028899997
						],
						[
							150.84245348100012,
							-33.87623628299997
						],
						[
							150.85367231100008,
							-33.86314821399998
						],
						[
							150.87043142900006,
							-33.865377414999955
						],
						[
							150.8765729900001,
							-33.85110971599994
						],
						[
							150.9164284630001,
							-33.85888825999996
						],
						[
							150.91657282100005,
							-33.874445229999935
						],
						[
							150.94500853500006,
							-33.88566394199995
						],
						[
							150.9624752840001,
							-33.87853032399994
						],
						[
							150.96133148500007,
							-33.86756730399998
						],
						[
							150.98552346200006,
							-33.87047938599994
						],
						[
							150.99647773300012,
							-33.851309706999984
						],
						[
							150.98917361400004,
							-33.84761381599998
						],
						[
							150.99213646500004,
							-33.83697429599994
						],
						[
							150.96950168900003,
							-33.832319663999954
						],
						[
							150.96953395100002,
							-33.81547002399998
						],
						[
							150.952392174,
							-33.811560922999945
						],
						[
							150.8969430940001,
							-33.79793218699996
						],
						[
							150.8033866400001,
							-33.77679860899997
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "128",
				"CED_NAME21": "McMahon",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 172.8271,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/128",
				"SHAPE_Leng": 0.851828524035,
				"SHAPE_Area": 0.0168328775883
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							151.03113653900004,
							-33.768953059999944
						],
						[
							151.02095986200004,
							-33.75734245899997
						],
						[
							151.02694083400002,
							-33.732740898999964
						],
						[
							151.0168367560001,
							-33.730669337999984
						],
						[
							151.01880596700005,
							-33.71646796799996
						],
						[
							150.99994047000007,
							-33.71410528599995
						],
						[
							150.93007747700005,
							-33.66007728899996
						],
						[
							150.92783751900004,
							-33.64921229899994
						],
						[
							150.93659849800008,
							-33.64956423999996
						],
						[
							150.9373494890001,
							-33.64336629999997
						],
						[
							150.92444750100003,
							-33.639308288999985
						],
						[
							150.92316892400004,
							-33.61980156899995
						],
						[
							150.90435728700004,
							-33.61179572699996
						],
						[
							150.87404451600003,
							-33.656658283999946
						],
						[
							150.8982675210001,
							-33.665212276999966
						],
						[
							150.92709750300003,
							-33.69620129899994
						],
						[
							150.96688398600008,
							-33.781107943999984
						],
						[
							150.98716645100012,
							-33.79661930599997
						],
						[
							151.03113653900004,
							-33.768953059999944
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "129",
				"CED_NAME21": "Mitchell",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 99.6797,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/129",
				"SHAPE_Leng": 0.606859858839,
				"SHAPE_Area": 0.00969529768542
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							152.48764139500008,
							-28.253481767999972
						],
						[
							152.46187749700005,
							-28.260315894999962
						],
						[
							152.44295099400006,
							-28.29841489399996
						],
						[
							152.4151789970001,
							-28.29806039099998
						],
						[
							152.4105764950001,
							-28.320394890999978
						],
						[
							152.41636749200006,
							-28.334989890999964
						],
						[
							152.38797699100007,
							-28.36745088899994
						],
						[
							152.35663749600008,
							-28.36117388599996
						],
						[
							152.34185899700003,
							-28.367956883999966
						],
						[
							152.30937300100004,
							-28.362826880999933
						],
						[
							152.2886145000001,
							-28.391490378999947
						],
						[
							152.2666825020001,
							-28.390729376999957
						],
						[
							152.21724050000012,
							-28.449100872999963
						],
						[
							152.19022500500012,
							-28.43402686999997
						],
						[
							152.18427200500003,
							-28.439031369999952
						],
						[
							152.16008150900007,
							-28.43325136699997
						],
						[
							152.12124501000005,
							-28.462636363999934
						],
						[
							152.0696880150001,
							-28.468521858999964
						],
						[
							152.06712451300007,
							-28.48513935899996
						],
						[
							152.0455590140001,
							-28.495205856999974
						],
						[
							152.01671351400012,
							-28.52522035399994
						],
						[
							151.98880001700002,
							-28.52560385099997
						],
						[
							151.98263152000004,
							-28.50331535099997
						],
						[
							151.9553575210001,
							-28.51917784799997
						],
						[
							151.95733851600005,
							-28.564733848999936
						],
						[
							151.98594351000008,
							-28.582117850999964
						],
						[
							151.99099250400002,
							-28.624572351999973
						],
						[
							152.01050049700007,
							-28.66497385399998
						],
						[
							152.03906149400007,
							-28.66456435699996
						],
						[
							152.0525489900001,
							-28.682216358999938
						],
						[
							152.0664514890001,
							-28.681177859999934
						],
						[
							152.06608098700008,
							-28.69757335999998
						],
						[
							152.0760409840001,
							-28.708331860999976
						],
						[
							152.04229648500007,
							-28.73181535799995
						],
						[
							152.04770398300002,
							-28.740418358999932
						],
						[
							152.0360784830001,
							-28.757258357999945
						],
						[
							152.04049297900008,
							-28.782176857999957
						],
						[
							152.03209947900007,
							-28.79088085799998
						],
						[
							152.0366084750001,
							-28.81777885799994
						],
						[
							152.0333859740001,
							-28.828057357999967
						],
						[
							152.0169304750001,
							-28.83791885599993
						],
						[
							152.01492097400012,
							-28.85021885599997
						],
						[
							152.02598947100012,
							-28.858226356999978
						],
						[
							152.03756797100004,
							-28.85162785899996
						],
						[
							152.03754946900006,
							-28.864342358999977
						],
						[
							152.0107024670001,
							-28.906671855999946
						],
						[
							152.0016219680001,
							-28.908478354999943
						],
						[
							151.99631647,
							-28.894776854999975
						],
						[
							151.96849697100004,
							-28.916669851999984
						],
						[
							151.91632197500007,
							-28.929328846999965
						],
						[
							151.91369647700003,
							-28.92010734699994
						],
						[
							151.90033947900008,
							-28.91465184599997
						],
						[
							151.84978098600004,
							-28.90761084099995
						],
						[
							151.83822948600005,
							-28.916349839999953
						],
						[
							151.83990848200006,
							-28.942765839999936
						],
						[
							151.8306654810001,
							-28.961734338999975
						],
						[
							151.81332098300004,
							-28.959798837999983
						],
						[
							151.80690598600006,
							-28.945284836999974
						],
						[
							151.77690348800002,
							-28.95898833399997
						],
						[
							151.77063598900008,
							-28.955752333999953
						],
						[
							151.77334499100004,
							-28.938063333999935
						],
						[
							151.74244499700012,
							-28.91849033099993
						],
						[
							151.7338680030001,
							-28.87144232999998
						],
						[
							151.72642200500002,
							-28.866942328999983
						],
						[
							151.71649800500006,
							-28.874939327999982
						],
						[
							151.70637350700008,
							-28.87170582699997
						],
						[
							151.67477750600005,
							-28.90773582399993
						],
						[
							151.6660185070001,
							-28.905599822999932
						],
						[
							151.6441970080001,
							-28.917346820999967
						],
						[
							151.63519050800005,
							-28.92956482099993
						],
						[
							151.60978751100004,
							-28.92344481799995
						],
						[
							151.5884750130001,
							-28.93204931599996
						],
						[
							151.57894601200007,
							-28.94410681499994
						],
						[
							151.56671151400008,
							-28.941823813999974
						],
						[
							151.54483451500005,
							-28.953273311999965
						],
						[
							151.53729451300012,
							-28.979790811999976
						],
						[
							151.49780451200002,
							-29.020866807999937
						],
						[
							151.49009750900007,
							-29.05656180799997
						],
						[
							151.50278150600002,
							-29.069853808999937
						],
						[
							151.49343450700007,
							-29.07175830799997
						],
						[
							151.48534650600004,
							-29.089322307999964
						],
						[
							151.46294750700008,
							-29.098300305999942
						],
						[
							151.4527500050001,
							-29.126238804999957
						],
						[
							151.4098995070001,
							-29.15392030099997
						],
						[
							151.3941220050001,
							-29.17801529999997
						],
						[
							151.35847551000006,
							-29.172266295999975
						],
						[
							151.33843351200005,
							-29.179253294999967
						],
						[
							151.315602516,
							-29.166079791999948
						],
						[
							151.30931651900005,
							-29.146574791999967
						],
						[
							151.31801451900003,
							-29.13804429199996
						],
						[
							151.30107902400005,
							-29.11399979099997
						],
						[
							151.29035252500012,
							-29.113873789999957
						],
						[
							151.28047352800002,
							-29.102144287999977
						],
						[
							151.27513753200003,
							-29.076411287999974
						],
						[
							151.29055103300004,
							-29.051082788999963
						],
						[
							151.2865160350001,
							-29.036728788999937
						],
						[
							151.2716820380001,
							-29.03037878699996
						],
						[
							151.28410853900004,
							-29.006808787999944
						],
						[
							151.27639754200004,
							-28.98705028699993
						],
						[
							151.28209304200004,
							-28.98094728799998
						],
						[
							151.27194504500005,
							-28.97271978699996
						],
						[
							151.28153354500012,
							-28.958478786999933
						],
						[
							151.274172549,
							-28.937899286999937
						],
						[
							151.24232405400005,
							-28.923360283999955
						],
						[
							151.23464755700002,
							-28.904790282999954
						],
						[
							151.21497206000004,
							-28.90428628099994
						],
						[
							151.1995955640001,
							-28.88424177899998
						],
						[
							151.1729910670001,
							-28.880289276999974
						],
						[
							151.1610715700001,
							-28.865367275999972
						],
						[
							151.13190407500008,
							-28.860049772999957
						],
						[
							151.1251555760001,
							-28.85054327199998
						],
						[
							151.10449758000004,
							-28.844055769999954
						],
						[
							151.103334581,
							-28.83657126999998
						],
						[
							151.0826695830001,
							-28.83450176799994
						],
						[
							151.053696585,
							-28.84980476499993
						],
						[
							151.04440858700002,
							-28.843878764999943
						],
						[
							151.03657609000004,
							-28.82568026399997
						],
						[
							151.04270959200005,
							-28.80158376399993
						],
						[
							151.024093095,
							-28.79347076199997
						],
						[
							151.01859359800005,
							-28.773097761999963
						],
						[
							151.02853959700008,
							-28.770519262999983
						],
						[
							151.0282310980001,
							-28.76196226199994
						],
						[
							151.0099291030001,
							-28.74093426099995
						],
						[
							150.93842661200006,
							-28.731234253999958
						],
						[
							150.93062061600006,
							-28.705095752999966
						],
						[
							150.9074426210001,
							-28.688511750999965
						],
						[
							150.87407062400007,
							-28.694380747999958
						],
						[
							150.84905412900002,
							-28.67370574499995
						],
						[
							150.81878063400006,
							-28.666680741999983
						],
						[
							150.8186031350001,
							-28.657540241999982
						],
						[
							150.79633963800006,
							-28.656115239999963
						],
						[
							150.75126514500005,
							-28.634237235999933
						],
						[
							150.72729064800012,
							-28.635550733999935
						],
						[
							150.7095576480001,
							-28.652144231999955
						],
						[
							150.68137765000006,
							-28.661661229999936
						],
						[
							150.67342715200004,
							-28.650449228999946
						],
						[
							150.64152615400008,
							-28.66534572599994
						],
						[
							150.63223565400006,
							-28.677077224999948
						],
						[
							150.625400656,
							-28.669033724999963
						],
						[
							150.60045815800004,
							-28.671314722999966
						],
						[
							150.58063116300002,
							-28.655820220999942
						],
						[
							150.56089616400004,
							-28.66229121899994
						],
						[
							150.5526946660001,
							-28.653626217999943
						],
						[
							150.5510296640001,
							-28.671586717999958
						],
						[
							150.52747216700004,
							-28.669317715999966
						],
						[
							150.5392921670001,
							-28.660035216999972
						],
						[
							150.530699668,
							-28.655309715999977
						],
						[
							150.51385066900002,
							-28.662294214999974
						],
						[
							150.48632867300012,
							-28.657346211999936
						],
						[
							150.48383809300003,
							-28.66224669199994
						],
						[
							150.4804211820001,
							-28.675397221999958
						],
						[
							150.51243817700004,
							-28.68408922499998
						],
						[
							150.5205601570001,
							-28.67937322499995
						],
						[
							150.53871715100001,
							-28.707623226999942
						],
						[
							150.5436351620001,
							-28.700822217999928
						],
						[
							150.5543201690001,
							-28.708837208999967
						],
						[
							150.5762611570001,
							-28.70599121099997
						],
						[
							150.59893115300008,
							-28.716790222999975
						],
						[
							150.60507115100006,
							-28.72842822299998
						],
						[
							150.6323051480001,
							-28.72917822599993
						],
						[
							150.65179015400008,
							-28.740203227999928
						],
						[
							150.6643511540001,
							-28.734540238999955
						],
						[
							150.66294616300002,
							-28.74023122899996
						],
						[
							150.67269013200007,
							-28.741383239999948
						],
						[
							150.6652731380001,
							-28.782152228999962
						],
						[
							150.6720311460001,
							-28.79389122999993
						],
						[
							150.64520014700008,
							-28.813972227999955
						],
						[
							150.63428814600002,
							-28.832221236999942
						],
						[
							150.63926914400008,
							-28.845325226999933
						],
						[
							150.61196112200003,
							-28.887332234999974
						],
						[
							150.61549712700003,
							-28.924855225999977
						],
						[
							150.63114212300002,
							-28.942183236999938
						],
						[
							150.61155836900002,
							-29.00001325599993
						],
						[
							150.63053606500011,
							-29.01387615799996
						],
						[
							150.6262262240001,
							-29.02427920799994
						],
						[
							150.63300405300004,
							-29.023395147999963
						],
						[
							150.6343601320001,
							-29.037329177999936
						],
						[
							150.65474592700002,
							-29.056837989999963
						],
						[
							150.6673906950001,
							-29.058020901999953
						],
						[
							150.66888076300006,
							-29.074304841999947
						],
						[
							150.68127861100004,
							-29.079614762999938
						],
						[
							150.68729943100004,
							-29.072048722999966
						],
						[
							150.69541038800003,
							-29.08845069399996
						],
						[
							150.70493118700006,
							-29.08670465499995
						],
						[
							150.7035912760001,
							-29.09980666499996
						],
						[
							150.72230693400002,
							-29.09657055699995
						],
						[
							150.73176390000003,
							-29.12581453799993
						],
						[
							150.7491265870001,
							-29.13474746999998
						],
						[
							150.74380075600004,
							-29.14198450899994
						],
						[
							150.7522835740001,
							-29.15095748999994
						],
						[
							150.74510785300004,
							-29.164948478999975
						],
						[
							150.75250071100004,
							-29.17438244999994
						],
						[
							150.74899485000003,
							-29.19049340999993
						],
						[
							150.75757763900003,
							-29.19069345099996
						],
						[
							150.7549027670001,
							-29.205930440999964
						],
						[
							150.76381552600003,
							-29.20849648199993
						],
						[
							150.7497772910001,
							-29.26202048099998
						],
						[
							150.75761818000012,
							-29.263137450999977
						],
						[
							150.75435026000002,
							-29.270016460999955
						],
						[
							150.76391909900008,
							-29.26918540199995
						],
						[
							150.7589882090001,
							-29.276349451999977
						],
						[
							150.77393510500008,
							-29.289721362999956
						],
						[
							150.7754901830001,
							-29.307785342999978
						],
						[
							150.80186383800003,
							-29.32150516599995
						],
						[
							150.79650796800001,
							-29.32752521499998
						],
						[
							150.805530846,
							-29.335288145999982
						],
						[
							150.79892999700007,
							-29.33629317599997
						],
						[
							150.8228108500001,
							-29.37156196799998
						],
						[
							150.81738398900006,
							-29.377928977999943
						],
						[
							150.8301880460001,
							-29.396508808999954
						],
						[
							150.82793526400008,
							-29.411848748999944
						],
						[
							150.85027092100006,
							-29.41470260099993
						],
						[
							150.85166080200008,
							-29.407864650999954
						],
						[
							150.8904162760001,
							-29.41713737499998
						],
						[
							150.88343572200006,
							-29.45916617399996
						],
						[
							150.86363403500002,
							-29.456504312999982
						],
						[
							150.8567904990001,
							-29.51250618199998
						],
						[
							150.80407162300003,
							-29.52974343799997
						],
						[
							150.74910068500003,
							-29.569419902999982
						],
						[
							150.73331378700004,
							-29.56926015099998
						],
						[
							150.72603801000002,
							-29.635626240999954
						],
						[
							150.71191204000002,
							-29.643671239999946
						],
						[
							150.7117900190001,
							-29.65716423999993
						],
						[
							150.68434201900004,
							-29.680385227999977
						],
						[
							150.69439301500006,
							-29.70391123899998
						],
						[
							150.68228502600005,
							-29.71311322799994
						],
						[
							150.68615303400009,
							-29.724417247999952
						],
						[
							150.67687203100002,
							-29.75561523799996
						],
						[
							150.65865703200006,
							-29.76663023599997
						],
						[
							150.658357001,
							-29.774053245999937
						],
						[
							150.64737704300012,
							-29.77323423499996
						],
						[
							150.6719840190001,
							-29.778570246999948
						],
						[
							150.6782790300001,
							-29.767704227999957
						],
						[
							150.68422502900012,
							-29.76978523899993
						],
						[
							150.66810903200007,
							-29.842055227999936
						],
						[
							150.6263680390001,
							-29.828720243999953
						],
						[
							150.6110883030001,
							-29.807219231999966
						],
						[
							150.6114942160001,
							-29.785091231999957
						],
						[
							150.57437799100012,
							-29.78082848899993
						],
						[
							150.56893003900007,
							-29.79950821799997
						],
						[
							150.5536080390001,
							-29.812236216999963
						],
						[
							150.53804403200002,
							-29.805700224999953
						],
						[
							150.52704403300004,
							-29.81161522499997
						],
						[
							150.520021035,
							-29.800205223999967
						],
						[
							150.46466105500008,
							-29.771353228999942
						],
						[
							150.45117404600012,
							-29.775706216999936
						],
						[
							150.43691904900004,
							-29.765029225999967
						],
						[
							150.41649905000008,
							-29.77824521399998
						],
						[
							150.41295607200004,
							-29.767813213999943
						],
						[
							150.42522880100012,
							-29.75731792499994
						],
						[
							150.4125444240001,
							-29.746090023999955
						],
						[
							150.40019775500002,
							-29.752471432999982
						],
						[
							150.30242737900005,
							-29.735552693999978
						],
						[
							150.28796588900002,
							-29.74981956299996
						],
						[
							150.29444182800012,
							-29.755860482999935
						],
						[
							150.29072630200005,
							-29.802685362999966
						],
						[
							150.29947922100007,
							-29.80828328399997
						],
						[
							150.29863031000002,
							-29.81726425399995
						],
						[
							150.3073831490001,
							-29.818428204999975
						],
						[
							150.29125481500012,
							-29.861303213999975
						],
						[
							150.31385174900004,
							-29.89670005599993
						],
						[
							150.300202097,
							-29.921944104999966
						],
						[
							150.30278326300004,
							-29.953445014999943
						],
						[
							150.29074961300012,
							-29.966967083999975
						],
						[
							150.29286471000012,
							-29.99051803499998
						],
						[
							150.28463995000004,
							-29.996638093999934
						],
						[
							150.27263407300006,
							-29.989379192999934
						],
						[
							150.2500994950001,
							-29.992596340999967
						],
						[
							150.24884662300008,
							-30.010254330999942
						],
						[
							150.23618189400008,
							-30.012456399999962
						],
						[
							150.1975179530001,
							-30.06256162699998
						],
						[
							150.17196240600003,
							-30.062950814999965
						],
						[
							150.16112475600005,
							-30.081372873999953
						],
						[
							150.14060022700005,
							-30.08721099199994
						],
						[
							150.12281432200007,
							-30.069446119999952
						],
						[
							150.10298479300002,
							-30.081949218999966
						],
						[
							150.0741765030001,
							-30.10493734599993
						],
						[
							150.07440773000008,
							-30.137109325999972
						],
						[
							150.10226868000007,
							-30.191933098999982
						],
						[
							150.14486501300007,
							-30.202341802999968
						],
						[
							150.14637502200003,
							-30.21563120299993
						],
						[
							150.1663580380001,
							-30.22705319499994
						],
						[
							150.17559012200002,
							-30.264958645999968
						],
						[
							150.16592503200002,
							-30.273936195999966
						],
						[
							150.19366202600008,
							-30.29323318799993
						],
						[
							150.18297019700003,
							-30.299493366999968
						],
						[
							150.19500409300008,
							-30.321074248999935
						],
						[
							150.1922054580001,
							-30.366175218999956
						],
						[
							150.20342434600002,
							-30.375033109999947
						],
						[
							150.22402896300002,
							-30.370908000999975
						],
						[
							150.23586280100005,
							-30.378507912999964
						],
						[
							150.22575716000006,
							-30.39928494199995
						],
						[
							150.28324734900002,
							-30.43083553699995
						],
						[
							150.31643398500012,
							-30.427962209999976
						],
						[
							150.32863027700012,
							-30.402439330999982
						],
						[
							150.36250284900007,
							-30.432450053999958
						],
						[
							150.36250204700002,
							-30.450670043999935
						],
						[
							150.34654198600003,
							-30.469526222999946
						],
						[
							150.3675881040001,
							-30.470067994999965
						],
						[
							150.36416297200003,
							-30.489282224999954
						],
						[
							150.34888298300007,
							-30.494004213999972
						],
						[
							150.36257548100002,
							-30.498565964999955
						],
						[
							150.35475093800005,
							-30.528221963999954
						],
						[
							150.3685427160001,
							-30.530063905999953
						],
						[
							150.36613283500003,
							-30.54340190499994
						],
						[
							150.39376534100006,
							-30.54705269799996
						],
						[
							150.3907076590001,
							-30.569307697999932
						],
						[
							150.35973413400006,
							-30.56089792499995
						],
						[
							150.36229621200005,
							-30.573966884999948
						],
						[
							150.37024208100001,
							-30.57621183599997
						],
						[
							150.36389425000004,
							-30.584055855999964
						],
						[
							150.378275206,
							-30.60269171699997
						],
						[
							150.3908350050001,
							-30.60521863799994
						],
						[
							150.3960827950001,
							-30.59367661899995
						],
						[
							150.41065446400012,
							-30.58983951999994
						],
						[
							150.43182523000007,
							-30.603869361999955
						],
						[
							150.43787405000012,
							-30.597414321999963
						],
						[
							150.46851385200011,
							-30.628322054999956
						],
						[
							150.50322538600005,
							-30.64043574899995
						],
						[
							150.50965244300005,
							-30.66007567899993
						],
						[
							150.45780073600008,
							-30.69022607499994
						],
						[
							150.4534678130001,
							-30.71536991499994
						],
						[
							150.4645025320001,
							-30.717082265999977
						],
						[
							150.46856011900002,
							-30.733654135999984
						],
						[
							150.46718436800006,
							-30.745193255999936
						],
						[
							150.45261870800005,
							-30.75722028499996
						],
						[
							150.46742150600005,
							-30.75952127599993
						],
						[
							150.456456827,
							-30.767961344999947
						],
						[
							150.46339883400003,
							-30.778944355999954
						],
						[
							150.49039339000012,
							-30.783312157999944
						],
						[
							150.48727365900004,
							-30.798971257999938
						],
						[
							150.52015530500012,
							-30.800444950999974
						],
						[
							150.54384617000005,
							-30.813409553999975
						],
						[
							150.55927146800002,
							-30.81080166499993
						],
						[
							150.56170791500006,
							-30.83757580499997
						],
						[
							150.54947118600012,
							-30.843978913999933
						],
						[
							150.5466163740001,
							-30.858743983999943
						],
						[
							150.52706872700003,
							-30.855806111999982
						],
						[
							150.52281472900006,
							-30.847176171999934
						],
						[
							150.53022122100003,
							-30.90299914299993
						],
						[
							150.51677630300003,
							-30.90090528199994
						],
						[
							150.5155113620001,
							-30.90735227199997
						],
						[
							150.49937168400004,
							-30.90880943999997
						],
						[
							150.49177610300012,
							-30.921367519999933
						],
						[
							150.51003351100007,
							-30.921089310999946
						],
						[
							150.51406873000008,
							-30.92869324199995
						],
						[
							150.5222684590001,
							-30.92356215199993
						],
						[
							150.53306836600007,
							-30.940486973999953
						],
						[
							150.5282746030001,
							-30.970904022999946
						],
						[
							150.55181646500012,
							-31.011402765999946
						],
						[
							150.59772579600008,
							-31.038329359999977
						],
						[
							150.5809053050001,
							-31.141210368999964
						],
						[
							150.59050108400004,
							-31.142469279999943
						],
						[
							150.57973442500008,
							-31.147043378999967
						],
						[
							150.5714364380001,
							-31.20820251899994
						],
						[
							150.586724096,
							-31.210346349999952
						],
						[
							150.58554178500003,
							-31.217598129999942
						],
						[
							150.58017285500011,
							-31.222304229999963
						],
						[
							150.56196986800012,
							-31.217292657999963
						],
						[
							150.56046584700005,
							-31.22526169799994
						],
						[
							150.56232993600008,
							-31.235910687999933
						],
						[
							150.58375642400006,
							-31.228463459999944
						],
						[
							150.57530039000005,
							-31.27378563999997
						],
						[
							150.573656539,
							-31.281366669999954
						],
						[
							150.55041400200002,
							-31.278058887999975
						],
						[
							150.54985462700006,
							-31.319216017999963
						],
						[
							150.54614071700007,
							-31.329187127999944
						],
						[
							150.5376589980001,
							-31.328088176999984
						],
						[
							150.53461127600008,
							-31.343079246999935
						],
						[
							150.54985199400005,
							-31.34395610799993
						],
						[
							150.54329743300002,
							-31.36285721799993
						],
						[
							150.51824588700003,
							-31.35831243499996
						],
						[
							150.51670127600005,
							-31.366736424999942
						],
						[
							150.50570284700007,
							-31.367275243999984
						],
						[
							150.50765285800003,
							-31.356843243999947
						],
						[
							150.49884683000005,
							-31.350973222999983
						],
						[
							150.4855438620001,
							-31.349148231999948
						],
						[
							150.4842398610001,
							-31.356188221999957
						],
						[
							150.46834685400006,
							-31.353983230999972
						],
						[
							150.46963085400012,
							-31.346965230999956
						],
						[
							150.41948807200004,
							-31.340016995999974
						],
						[
							150.4343718870001,
							-31.365384217999974
						],
						[
							150.43462172300008,
							-31.39328710799998
						],
						[
							150.41891044500005,
							-31.391023466999968
						],
						[
							150.41767309500005,
							-31.39761817599998
						],
						[
							150.38247130000002,
							-31.39266581299995
						],
						[
							150.38372387100003,
							-31.386109232999956
						],
						[
							150.370731373,
							-31.382265851999932
						],
						[
							150.35095683500003,
							-31.389325009999936
						],
						[
							150.28591089500003,
							-31.373826383999983
						],
						[
							150.22653996300005,
							-31.36966271899996
						],
						[
							150.20026861700012,
							-31.36286995699993
						],
						[
							150.20171723800001,
							-31.35407388699997
						],
						[
							150.16096706300004,
							-31.354946102999975
						],
						[
							150.15936574900002,
							-31.31376002299993
						],
						[
							150.14865179100002,
							-31.303828031999956
						],
						[
							150.15629398800002,
							-31.242323931999977
						],
						[
							150.1632948670001,
							-31.24331189299994
						],
						[
							150.16530072800003,
							-31.232992862999936
						],
						[
							150.1448052500001,
							-31.236725040999943
						],
						[
							150.14766302100008,
							-31.225147980999964
						],
						[
							150.13832420200004,
							-31.223905039999977
						],
						[
							150.13465650000012,
							-31.244300099999975
						],
						[
							150.10338494500002,
							-31.240005266999958
						],
						[
							150.078844236,
							-31.33808151599993
						],
						[
							150.0065633380001,
							-31.32079288899996
						],
						[
							150.00556436700003,
							-31.326202878999936
						],
						[
							149.98668291900003,
							-31.32930218699994
						],
						[
							149.99871594600006,
							-31.34462617899993
						],
						[
							149.9992067940001,
							-31.36163395899996
						],
						[
							149.98813541700008,
							-31.42735401799996
						],
						[
							150.00439722500005,
							-31.429578939999942
						],
						[
							150.0022633630001,
							-31.445615979999957
						],
						[
							149.97035491600002,
							-31.45821710699994
						],
						[
							149.882917248,
							-31.451981468999975
						],
						[
							149.86695510000004,
							-31.537256627999966
						],
						[
							149.90441416500005,
							-31.536884201999953
						],
						[
							149.91472924000004,
							-31.57124694299995
						],
						[
							149.8929161100001,
							-31.59253968099995
						],
						[
							149.90107480500012,
							-31.624414351999974
						],
						[
							149.84089518400003,
							-31.616094836999935
						],
						[
							149.86558297800002,
							-31.63798475899995
						],
						[
							149.866314503,
							-31.678945778999946
						],
						[
							149.90478936500006,
							-31.706751482999948
						],
						[
							149.9293088920001,
							-31.698151354999936
						],
						[
							149.94174279900005,
							-31.71099531599998
						],
						[
							149.94699661000004,
							-31.70226431699996
						],
						[
							149.96554725700003,
							-31.700960307999935
						],
						[
							149.98412633200007,
							-31.72792420999997
						],
						[
							149.9937427010001,
							-31.721775900999944
						],
						[
							149.99055095200004,
							-31.713960570999973
						],
						[
							150.00438789200007,
							-31.702556191999975
						],
						[
							150.0138758800001,
							-31.70477919299998
						],
						[
							150.0282711110001,
							-31.68519803399994
						],
						[
							150.05223485600004,
							-31.69796092599995
						],
						[
							150.04577515500011,
							-31.714143965999938
						],
						[
							150.07507803800002,
							-31.739855877999958
						],
						[
							150.1050857140001,
							-31.73953180099994
						],
						[
							150.11026279200007,
							-31.74890605099995
						],
						[
							150.0701559460001,
							-31.76511459799997
						],
						[
							150.0239884440001,
							-31.82873920399993
						],
						[
							149.92148349100012,
							-31.885135255999955
						],
						[
							149.9023563610001,
							-31.904676863999953
						],
						[
							149.8660661990001,
							-31.96158602099996
						],
						[
							149.83912163900004,
							-31.987365248999936
						],
						[
							149.87556955500008,
							-31.98450177199993
						],
						[
							149.87379273400006,
							-31.995904821999943
						],
						[
							149.8825208620001,
							-31.996881172999963
						],
						[
							149.873056162,
							-32.01350562199997
						],
						[
							149.87485618900007,
							-32.03105090299994
						],
						[
							149.85984330200006,
							-32.02251690099996
						],
						[
							149.85837983200008,
							-32.03041718099996
						],
						[
							149.84988085300006,
							-32.025546179999935
						],
						[
							149.80816584700005,
							-32.03926416699994
						],
						[
							149.80527325600008,
							-32.05516414699997
						],
						[
							149.79567046700004,
							-32.058077165999975
						],
						[
							149.7952438530001,
							-32.092708175999974
						],
						[
							149.81249587000002,
							-32.09064418799994
						],
						[
							149.81943586800003,
							-32.103611187999945
						],
						[
							149.84596472400005,
							-32.106066950999946
						],
						[
							149.84519453300004,
							-32.116957130999936
						],
						[
							149.84985255300012,
							-32.109154230999934
						],
						[
							149.89227284700007,
							-32.11265719499994
						],
						[
							149.89351585800011,
							-32.10514919499997
						],
						[
							149.89335784600007,
							-32.119699184999945
						],
						[
							149.93232283100008,
							-32.11921918799993
						],
						[
							149.92075182000008,
							-32.13750918799997
						],
						[
							149.9481017070001,
							-32.13493670999998
						],
						[
							149.93934845500007,
							-32.15702853899995
						],
						[
							149.96463364200008,
							-32.16014072199994
						],
						[
							149.96076029900007,
							-32.18186351099996
						],
						[
							149.98262733600006,
							-32.18470869299995
						],
						[
							149.9851478380001,
							-32.17057219299994
						],
						[
							150.0011307860001,
							-32.16157120499997
						],
						[
							150.00946541500002,
							-32.16264642599998
						],
						[
							150.01398784200012,
							-32.18658520599996
						],
						[
							150.023082401,
							-32.18361941699993
						],
						[
							150.02691375900008,
							-32.19485146699998
						],
						[
							150.03480921800008,
							-32.195891717999984
						],
						[
							150.02776913700006,
							-32.205971406999936
						],
						[
							150.03649081700007,
							-32.20163619799996
						],
						[
							150.0366548080001,
							-32.18901819799993
						],
						[
							150.04504980700005,
							-32.19353820899994
						],
						[
							150.05329282600007,
							-32.18814919999994
						],
						[
							150.0600787950001,
							-32.19311118999997
						],
						[
							150.06301780500007,
							-32.18408318999997
						],
						[
							150.07024181400004,
							-32.18849021099993
						],
						[
							150.04794666300006,
							-32.22148336899994
						],
						[
							150.0602727800001,
							-32.22724219099996
						],
						[
							150.05530181000006,
							-32.239083189999974
						],
						[
							150.06299578800008,
							-32.24582321099996
						],
						[
							150.05823078800006,
							-32.25099719099995
						],
						[
							150.04409379100002,
							-32.24417118899993
						],
						[
							150.05318579800007,
							-32.258429199999966
						],
						[
							150.0421377890001,
							-32.261406198999964
						],
						[
							150.04302981600006,
							-32.284194198999955
						],
						[
							150.032906797,
							-32.28819019899993
						],
						[
							150.03559479500007,
							-32.29514619899993
						],
						[
							150.02797578700006,
							-32.29151420799997
						],
						[
							150.02172877600003,
							-32.304247197999985
						],
						[
							150.03205878300002,
							-32.31549120899996
						],
						[
							150.0290227920001,
							-32.333126198999935
						],
						[
							150.0396118010001,
							-32.32823119899996
						],
						[
							150.05392078600005,
							-32.350869200999966
						],
						[
							150.06789177400003,
							-32.35606920199996
						],
						[
							150.06666877500004,
							-32.34376021199995
						],
						[
							150.13289976700003,
							-32.33693521799995
						],
						[
							150.14254978500003,
							-32.34148621899993
						],
						[
							150.15526977500008,
							-32.326994199999945
						],
						[
							150.16380675300002,
							-32.332494219999944
						],
						[
							150.165247775,
							-32.320017210999936
						],
						[
							150.1873037800001,
							-32.33343220299997
						],
						[
							150.1892877680001,
							-32.35002521299998
						],
						[
							150.19694977900008,
							-32.332579212999974
						],
						[
							150.21764676500004,
							-32.337715214999946
						],
						[
							150.20817377900005,
							-32.31881720399997
						],
						[
							150.2161767670001,
							-32.32329121499998
						],
						[
							150.2215707780001,
							-32.31480420599996
						],
						[
							150.2369297570001,
							-32.30811022699993
						],
						[
							150.24528577500007,
							-32.31297921799995
						],
						[
							150.2550017750001,
							-32.302801227999964
						],
						[
							150.2527587840001,
							-32.309829227999955
						],
						[
							150.26220177200003,
							-32.31645522899993
						],
						[
							150.2517187520001,
							-32.32502421799995
						],
						[
							150.2707767500001,
							-32.323464229999956
						],
						[
							150.2596577500001,
							-32.338558208999984
						],
						[
							150.26676674400005,
							-32.37685220999998
						],
						[
							150.27628674200002,
							-32.38144021099998
						],
						[
							150.2842717420001,
							-32.37451022199997
						],
						[
							150.28700077000008,
							-32.386876221999955
						],
						[
							150.30620673900012,
							-32.37390622399994
						],
						[
							150.308962747,
							-32.385937213999966
						],
						[
							150.31934472500006,
							-32.38820222499993
						],
						[
							150.31892275300004,
							-32.40824821499996
						],
						[
							150.3407796020001,
							-32.394321436999974
						],
						[
							150.34234549300004,
							-32.38509739699998
						],
						[
							150.38654968700007,
							-32.38005197099994
						],
						[
							150.39631786200005,
							-32.33293998099998
						],
						[
							150.40692275000004,
							-32.333069861999945
						],
						[
							150.42026966700007,
							-32.34705574399993
						],
						[
							150.43240839600003,
							-32.34040463499997
						],
						[
							150.42989931800003,
							-32.32785468399993
						],
						[
							150.43873906800002,
							-32.32214460499995
						],
						[
							150.46942764300002,
							-32.32195625799994
						],
						[
							150.487674609,
							-32.33741496999994
						],
						[
							150.4928697260001,
							-32.352231899999936
						],
						[
							150.4967735470001,
							-32.34221680999997
						],
						[
							150.51187636500003,
							-32.34424066199995
						],
						[
							150.50731572200004,
							-32.36836173199998
						],
						[
							150.51463963100002,
							-32.36940169199994
						],
						[
							150.5299173300001,
							-32.36230753399997
						],
						[
							150.52085638200003,
							-32.358495612999945
						],
						[
							150.52570223200007,
							-32.35173055299998
						],
						[
							150.5363371300001,
							-32.35330747399996
						],
						[
							150.540413961,
							-32.343598413999985
						],
						[
							150.5526267890001,
							-32.34540730599997
						],
						[
							150.55781373000002,
							-32.33015823599993
						],
						[
							150.54398172300012,
							-32.326472244999934
						],
						[
							150.5299337240001,
							-32.33177524299998
						],
						[
							150.52760071700004,
							-32.313590242999965
						],
						[
							150.50960972200005,
							-32.292949240999974
						],
						[
							150.5000197180001,
							-32.25339723999997
						],
						[
							150.4865437410001,
							-32.239996248999944
						],
						[
							150.49574576400005,
							-32.20594423899996
						],
						[
							150.49102174900008,
							-32.170543248999934
						],
						[
							150.50952874900008,
							-32.15503622999995
						],
						[
							150.49890615300012,
							-32.130026448999956
						],
						[
							150.65682543000003,
							-32.15019977399993
						],
						[
							150.6564477280001,
							-32.16059525399993
						],
						[
							150.76283031200012,
							-32.175846442999955
						],
						[
							150.76658317200008,
							-32.17103443399998
						],
						[
							150.764496322,
							-32.17854341399993
						],
						[
							150.78833993900002,
							-32.17653013599994
						],
						[
							150.8613206970001,
							-32.18952927299995
						],
						[
							150.87494869400007,
							-32.20012126399996
						],
						[
							150.880194694,
							-32.19723526399997
						],
						[
							150.86791069700007,
							-32.18936327299997
						],
						[
							150.8789457050001,
							-32.18987426399997
						],
						[
							150.8725326980001,
							-32.17637927399994
						],
						[
							150.9160597010001,
							-32.18178027799996
						],
						[
							151.00300773100003,
							-32.16951497599996
						],
						[
							151.01591266800006,
							-32.17755181699994
						],
						[
							151.0318223270001,
							-32.16645867799997
						],
						[
							151.04472726400002,
							-32.17734148899996
						],
						[
							151.04612313500002,
							-32.17018250999996
						],
						[
							151.06604866300006,
							-32.16574162099994
						],
						[
							151.10098462700012,
							-32.178611984999975
						],
						[
							151.114229603,
							-32.195081795999954
						],
						[
							151.15476711700012,
							-32.199325389999956
						],
						[
							151.1590522450001,
							-32.21108031999995
						],
						[
							151.17402403300002,
							-32.21179418199995
						],
						[
							151.19682900700002,
							-32.23364694399993
						],
						[
							151.20882064700004,
							-32.220152834999965
						],
						[
							151.24626209300004,
							-32.20955542799993
						],
						[
							151.27024762300005,
							-32.18327831099998
						],
						[
							151.2875636220001,
							-32.17624232199995
						],
						[
							151.30970409400004,
							-32.13897111399996
						],
						[
							151.3118189050001,
							-32.126529163999976
						],
						[
							151.30394888800004,
							-32.116734202999965
						],
						[
							151.3342510770001,
							-32.092142115999934
						],
						[
							151.33545389800008,
							-32.082390155999974
						],
						[
							151.38955908100002,
							-32.083227990999944
						],
						[
							151.40694436100011,
							-32.058326971999975
						],
						[
							151.4049781450001,
							-32.036640311999975
						],
						[
							151.43861687300011,
							-32.01716540499996
						],
						[
							151.4547315430001,
							-31.99596590599998
						],
						[
							151.44157031100008,
							-31.951826024999946
						],
						[
							151.46912905400006,
							-31.89692953699995
						],
						[
							151.48525957300012,
							-31.89256570899994
						],
						[
							151.49369399400007,
							-31.87588889899996
						],
						[
							151.51316532200008,
							-31.868402500999935
						],
						[
							151.51594454400004,
							-31.852828190999958
						],
						[
							151.5525046900001,
							-31.847324864999962
						],
						[
							151.55696866800008,
							-31.855680744999972
						],
						[
							151.5508987180001,
							-31.859762884999952
						],
						[
							151.56302208600005,
							-31.86159500599996
						],
						[
							151.57691376500009,
							-31.85472412699994
						],
						[
							151.58439060700005,
							-31.83923701799995
						],
						[
							151.5940393520001,
							-31.78958655799994
						],
						[
							151.55410740700006,
							-31.78729027399993
						],
						[
							151.53104868200012,
							-31.77030233199997
						],
						[
							151.51770100400006,
							-31.76928235099996
						],
						[
							151.53478914200002,
							-31.694094381999946
						],
						[
							151.52330150500006,
							-31.683472580999933
						],
						[
							151.52091221700005,
							-31.664838249999946
						],
						[
							151.53565241400008,
							-31.596073590999936
						],
						[
							151.56940768800007,
							-31.609940344999984
						],
						[
							151.6014126660001,
							-31.595591336999973
						],
						[
							151.61007068300012,
							-31.607961347999947
						],
						[
							151.62470868100002,
							-31.606784339999933
						],
						[
							151.63361668900006,
							-31.61521235099997
						],
						[
							151.65258365800003,
							-31.602647331999947
						],
						[
							151.6571096560001,
							-31.613240342999973
						],
						[
							151.68211565400009,
							-31.608773354999983
						],
						[
							151.69195266200006,
							-31.614499345999945
						],
						[
							151.69057664100012,
							-31.622539355999947
						],
						[
							151.71301665800002,
							-31.620554337999977
						],
						[
							151.7568726400001,
							-31.63814535299997
						],
						[
							151.7567519050001,
							-31.60173742199993
						],
						[
							151.78165132300012,
							-31.592615244999934
						],
						[
							151.8025027530001,
							-31.573848105999957
						],
						[
							151.78661372800002,
							-31.547798134999937
						],
						[
							151.75846310300005,
							-31.53535920199994
						],
						[
							151.75334894700006,
							-31.51429523099995
						],
						[
							151.78933232200006,
							-31.514925044999984
						],
						[
							151.80235702200002,
							-31.504989955999974
						],
						[
							151.8427643760001,
							-31.509025719999954
						],
						[
							151.84458521700003,
							-31.49946269999998
						],
						[
							151.91576071600002,
							-31.510054856999943
						],
						[
							151.91277524100008,
							-31.47668733599994
						],
						[
							152.0838026460001,
							-31.50048338299996
						],
						[
							152.0785489100001,
							-31.47351310199997
						],
						[
							152.08781568100005,
							-31.45616308299998
						],
						[
							152.06466891700006,
							-31.438578350999933
						],
						[
							152.06786260100012,
							-31.398384300999965
						],
						[
							152.0705706000001,
							-31.40365727099993
						],
						[
							152.09664203900002,
							-31.38823709299993
						],
						[
							152.0996300380001,
							-31.393043063999983
						],
						[
							152.12368432000005,
							-31.27871672499998
						],
						[
							152.13890006700012,
							-31.285382586999958
						],
						[
							152.15287668700012,
							-31.272974397999974
						],
						[
							152.16096819000006,
							-31.24020823899997
						],
						[
							152.16056406200005,
							-31.229977237999947
						],
						[
							152.14963213400006,
							-31.223761326999977
						],
						[
							152.15185177800004,
							-31.18809432699993
						],
						[
							152.17065657600006,
							-31.190687238999942
						],
						[
							152.17896959300003,
							-31.199496199999942
						],
						[
							152.19967816100007,
							-31.19356804199998
						],
						[
							152.22340286700012,
							-31.207889783999974
						],
						[
							152.23411250700008,
							-31.197448624999936
						],
						[
							152.25168138300012,
							-31.20626553699998
						],
						[
							152.25468617400008,
							-31.194522476999964
						],
						[
							152.31657753500008,
							-31.202923132999956
						],
						[
							152.3309025840001,
							-31.12745134399995
						],
						[
							152.34261043200001,
							-31.12833026499993
						],
						[
							152.3379553740001,
							-31.114413344999946
						],
						[
							152.34959230300012,
							-31.11699129599998
						],
						[
							152.34815526400007,
							-31.10921132599998
						],
						[
							152.3365562560001,
							-31.105216404999965
						],
						[
							152.3342242000001,
							-31.07570253399996
						],
						[
							152.34064006000006,
							-31.06819745499996
						],
						[
							152.33105702300008,
							-31.057261533999963
						],
						[
							152.3451758120001,
							-31.05060541499995
						],
						[
							152.34335566400011,
							-31.039932394999937
						],
						[
							152.3243977180001,
							-31.024844422999934
						],
						[
							152.3152728990001,
							-31.027837501999954
						],
						[
							152.2925610740001,
							-31.01145361999994
						],
						[
							152.2765233760001,
							-31.009497687999954
						],
						[
							152.26983033800002,
							-30.99913470699994
						],
						[
							152.2941465990001,
							-30.973069489999943
						],
						[
							152.2843114630001,
							-30.94911248799997
						],
						[
							152.29601628400007,
							-30.930784348999964
						],
						[
							152.28724876900003,
							-30.899957357999938
						],
						[
							152.29949025200006,
							-30.866219298999965
						],
						[
							152.2845452570001,
							-30.84149334799997
						],
						[
							152.2867870880001,
							-30.82985632799995
						],
						[
							152.31715942800008,
							-30.802486149999936
						],
						[
							152.31703631900007,
							-30.79262412999998
						],
						[
							152.34386293600005,
							-30.791888022999956
						],
						[
							152.35500365600012,
							-30.778107003999935
						],
						[
							152.35196159800012,
							-30.769142993999935
						],
						[
							152.375396098,
							-30.744651015999978
						],
						[
							152.36933257500004,
							-30.698675124999966
						],
						[
							152.35799742900008,
							-30.678431273999934
						],
						[
							152.3692970300001,
							-30.658892334999962
						],
						[
							152.34519411600002,
							-30.639851651999948
						],
						[
							152.3368812770001,
							-30.640458730999967
						],
						[
							152.3334431300001,
							-30.620557910999935
						],
						[
							152.3117281850001,
							-30.600178287999938
						],
						[
							152.32991664500003,
							-30.584210309999946
						],
						[
							152.33581424600004,
							-30.56702538099995
						],
						[
							152.3616545650001,
							-30.55578706299997
						],
						[
							152.3640854260001,
							-30.545042072999934
						],
						[
							152.38671688500006,
							-30.52917499499995
						],
						[
							152.38581260800004,
							-30.50518112499998
						],
						[
							152.4002583570001,
							-30.50092905599996
						],
						[
							152.40842905800002,
							-30.489248046999933
						],
						[
							152.39324222100004,
							-30.476402234999966
						],
						[
							152.39205579600002,
							-30.44290435499994
						],
						[
							152.40181052600008,
							-30.434996325999975
						],
						[
							152.41721129300004,
							-30.436811217999946
						],
						[
							152.428083914,
							-30.418884197999944
						],
						[
							152.38753706400007,
							-30.383146463999935
						],
						[
							152.3819253370001,
							-30.362615223999967
						],
						[
							152.35178543200004,
							-30.355346720999933
						],
						[
							152.35477324400006,
							-30.34035770099996
						],
						[
							152.34519225600002,
							-30.332105799999965
						],
						[
							152.34187312900008,
							-30.310948868999958
						],
						[
							152.34930775100008,
							-30.29160638999997
						],
						[
							152.33934773300007,
							-30.28221440899995
						],
						[
							152.33732976700003,
							-30.25814640799996
						],
						[
							152.3503957480001,
							-30.235165408999933
						],
						[
							152.31047975700005,
							-30.200799394999933
						],
						[
							152.3170787790001,
							-30.18210638599993
						],
						[
							152.3031967710001,
							-30.179172393999977
						],
						[
							152.31112676100008,
							-30.173618404999957
						],
						[
							152.30924478300005,
							-30.16100140499998
						],
						[
							152.316559782,
							-30.161615395999945
						],
						[
							152.30493077300002,
							-30.16139339399996
						],
						[
							152.3096777840001,
							-30.14789439499998
						],
						[
							152.29779678600005,
							-30.147292403999984
						],
						[
							152.30525376600008,
							-30.140490393999983
						],
						[
							152.29700976700008,
							-30.138074383999935
						],
						[
							152.29826979000006,
							-30.117062402999977
						],
						[
							152.27943878400004,
							-30.09932539199997
						],
						[
							152.27975279600003,
							-30.088017400999945
						],
						[
							152.2939037740001,
							-30.085378392999928
						],
						[
							152.2924157760001,
							-30.071120392999944
						],
						[
							152.29985878500008,
							-30.071117392999952
						],
						[
							152.29176877700002,
							-30.063251391999984
						],
						[
							152.29996580700004,
							-30.05693039299996
						],
						[
							152.29283479900005,
							-30.051904401999934
						],
						[
							152.29918977900002,
							-30.046238392999953
						],
						[
							152.29464681000002,
							-30.040781392999975
						],
						[
							152.31517779800004,
							-30.034196384999973
						],
						[
							152.31709278200003,
							-30.005929383999955
						],
						[
							152.300612816,
							-29.985242392999965
						],
						[
							152.30807180600004,
							-29.980226392999953
						],
						[
							152.28986378900004,
							-29.97535038199993
						],
						[
							152.27242281400004,
							-29.95155638999995
						],
						[
							152.26965582700007,
							-29.932379398999956
						],
						[
							152.2834138060001,
							-29.925058390999936
						],
						[
							152.2785978170001,
							-29.921219379999968
						],
						[
							152.2680617970001,
							-29.92856237899997
						],
						[
							152.27839881800003,
							-29.91785639999995
						],
						[
							152.2689998090001,
							-29.912477388999946
						],
						[
							152.2856588080001,
							-29.907890390999967
						],
						[
							152.28126881200012,
							-29.878258389999928
						],
						[
							152.28767880200007,
							-29.873402390999956
						],
						[
							152.276795815,
							-29.86446339899993
						],
						[
							152.2819908250001,
							-29.856776389999936
						],
						[
							152.27353081700005,
							-29.84621538899995
						],
						[
							152.25109682800007,
							-29.86496339699994
						],
						[
							152.23411984000006,
							-29.86393738499993
						],
						[
							152.22191884000006,
							-29.87206038399995
						],
						[
							152.20803384300007,
							-29.86603938299993
						],
						[
							152.19242483300002,
							-29.87660239099995
						],
						[
							152.172907806,
							-29.871149378999974
						],
						[
							152.1683638190001,
							-29.85351737899998
						],
						[
							152.17755681900007,
							-29.84803538999995
						],
						[
							152.17022583000005,
							-29.84057237899998
						],
						[
							152.1779488310001,
							-29.827460369999983
						],
						[
							152.17022682300012,
							-29.822447368999974
						],
						[
							152.1798668340001,
							-29.80669537999995
						],
						[
							152.19313882200004,
							-29.80671838099994
						],
						[
							152.186527833,
							-29.80252538999997
						],
						[
							152.194182833,
							-29.80015038099998
						],
						[
							152.19086884500007,
							-29.788445370999966
						],
						[
							152.20295983300002,
							-29.786723371999983
						],
						[
							152.2147628450001,
							-29.761564372999942
						],
						[
							152.22969784400004,
							-29.75483539399994
						],
						[
							152.26063082000007,
							-29.75698838699998
						],
						[
							152.26459282100006,
							-29.74990837699994
						],
						[
							152.25508983400005,
							-29.73406138599995
						],
						[
							152.2657498330001,
							-29.727575386999945
						],
						[
							152.26215484600004,
							-29.712491386999943
						],
						[
							152.27075482600003,
							-29.707124397999962
						],
						[
							152.2617158280001,
							-29.69842839699993
						],
						[
							152.28097389000004,
							-29.66555625799998
						],
						[
							152.28954875700003,
							-29.676281208999967
						],
						[
							152.30535434700005,
							-29.661837120999962
						],
						[
							152.3118272260001,
							-29.66453310099996
						],
						[
							152.31251210800008,
							-29.651354150999964
						],
						[
							152.32571977600003,
							-29.655449102999967
						],
						[
							152.33612848600012,
							-29.64076404399998
						],
						[
							152.35449777600002,
							-29.54545802499996
						],
						[
							152.41246170400007,
							-29.506867729999954
						],
						[
							152.38879132500006,
							-29.445303706999937
						],
						[
							152.39456222400008,
							-29.446100627999954
						],
						[
							152.39717723600006,
							-29.431754677999947
						],
						[
							152.40432313500003,
							-29.432765588999928
						],
						[
							152.40866228900006,
							-29.39846579899995
						],
						[
							152.43223044700005,
							-29.392608420999977
						],
						[
							152.43448041800002,
							-29.378476880999983
						],
						[
							152.45226763800008,
							-29.360153612999966
						],
						[
							152.33152317500003,
							-29.34182471099996
						],
						[
							152.3370500750001,
							-29.336874700999942
						],
						[
							152.33134110700007,
							-29.329005760999962
						],
						[
							152.30010277200006,
							-29.313592057999983
						],
						[
							152.30004080300012,
							-29.30444512699995
						],
						[
							152.3146614520001,
							-29.298506028999952
						],
						[
							152.30647870500002,
							-29.283084187999975
						],
						[
							152.3518196240001,
							-29.248707861999947
						],
						[
							152.39373389000002,
							-29.241391695999937
						],
						[
							152.41412363000006,
							-29.22888164799997
						],
						[
							152.40521671300007,
							-29.211154826999973
						],
						[
							152.4251431250001,
							-29.17837771899997
						],
						[
							152.41381031800006,
							-29.161244847999967
						],
						[
							152.4177591790001,
							-29.15226387799993
						],
						[
							152.4442367570001,
							-29.144162619999975
						],
						[
							152.45501141300008,
							-29.08901463099994
						],
						[
							152.41898398800004,
							-29.081032026999935
						],
						[
							152.4311162880001,
							-29.071950068999968
						],
						[
							152.4439024300001,
							-29.03974280999995
						],
						[
							152.42377574300008,
							-29.036634007999965
						],
						[
							152.4461283810001,
							-29.02832780999995
						],
						[
							152.45983620900006,
							-29.03157866099997
						],
						[
							152.4551762210001,
							-29.020496739999942
						],
						[
							152.4717498110001,
							-29.004902641999934
						],
						[
							152.4638788840001,
							-28.99197775099998
						],
						[
							152.4762336230001,
							-28.99036566199993
						],
						[
							152.46261178600002,
							-28.97589278099997
						],
						[
							152.48865529300008,
							-28.977080592999982
						],
						[
							152.48665933400002,
							-28.96996162299996
						],
						[
							152.5095789610001,
							-28.97324137499993
						],
						[
							152.50833102,
							-28.980340384999977
						],
						[
							152.530145897,
							-28.988425407999955
						],
						[
							152.5331359070001,
							-28.983922407999955
						],
						[
							152.55852224300008,
							-28.990064909999944
						],
						[
							152.54558789200007,
							-28.936304408999945
						],
						[
							152.56594167100002,
							-28.926060980999978
						],
						[
							152.58087447900004,
							-28.92921684199996
						],
						[
							152.58011338100005,
							-28.911470921999978
						],
						[
							152.57057590300008,
							-28.904952410999954
						],
						[
							152.5550846740001,
							-28.91257608899997
						],
						[
							152.54814592500009,
							-28.90878941899996
						],
						[
							152.57331190800005,
							-28.863637410999957
						],
						[
							152.5372059340001,
							-28.84773140699997
						],
						[
							152.5572158550001,
							-28.82324234899994
						],
						[
							152.53921000800005,
							-28.81492348699993
						],
						[
							152.541566632,
							-28.781782566999937
						],
						[
							152.5309978030001,
							-28.78136163599993
						],
						[
							152.5193601730001,
							-28.79474366499994
						],
						[
							152.51104416600003,
							-28.77972975399996
						],
						[
							152.49700246600003,
							-28.785518862999936
						],
						[
							152.4801107090001,
							-28.780134010999973
						],
						[
							152.49204793,
							-28.764548411999954
						],
						[
							152.47982948300012,
							-28.75078713099998
						],
						[
							152.49494417100004,
							-28.748589011999968
						],
						[
							152.49764002200004,
							-28.737871001999963
						],
						[
							152.47308658400004,
							-28.74706817999993
						],
						[
							152.47361944600004,
							-28.73076022999993
						],
						[
							152.4652826260001,
							-28.735824288999936
						],
						[
							152.42075694400012,
							-28.717969394999955
						],
						[
							152.40861861400003,
							-28.724016753999933
						],
						[
							152.40653847700003,
							-28.70447181299994
						],
						[
							152.37670904100003,
							-28.702926969999965
						],
						[
							152.37365695300002,
							-28.687289989999954
						],
						[
							152.3894346620001,
							-28.68259595099994
						],
						[
							152.3892845040001,
							-28.665360980999935
						],
						[
							152.40312015300003,
							-28.65867388299995
						],
						[
							152.39858119500002,
							-28.64679793199997
						],
						[
							152.4139867550001,
							-28.63202289299994
						],
						[
							152.40577983700007,
							-28.621642962999942
						],
						[
							152.42482550500006,
							-28.620812873999967
						],
						[
							152.41700760700007,
							-28.61497989399993
						],
						[
							152.42134142800012,
							-28.60737586399995
						],
						[
							152.44282602600003,
							-28.603370755999947
						],
						[
							152.4382499090001,
							-28.583009754999978
						],
						[
							152.44611179800006,
							-28.584600715999954
						],
						[
							152.44747269800007,
							-28.57703169599995
						],
						[
							152.44016980900005,
							-28.576271735999967
						],
						[
							152.4577643780001,
							-28.568964646999973
						],
						[
							152.441400562,
							-28.555885715999977
						],
						[
							152.446425373,
							-28.539178695999965
						],
						[
							152.44046842500006,
							-28.530310724999936
						],
						[
							152.46066205300008,
							-28.52920762699995
						],
						[
							152.45984101400006,
							-28.52247863699995
						],
						[
							152.46609697300005,
							-28.52658460799995
						],
						[
							152.472188823,
							-28.51921958799994
						],
						[
							152.48525867000012,
							-28.531177509999964
						],
						[
							152.50269697800002,
							-28.527535400999966
						],
						[
							152.50335496000002,
							-28.51153539099994
						],
						[
							152.53183495700011,
							-28.514718393999942
						],
						[
							152.53734795800005,
							-28.50087540499993
						],
						[
							152.52743496000005,
							-28.495752403999973
						],
						[
							152.53908795000007,
							-28.480575404999968
						],
						[
							152.55321297900002,
							-28.477581405999956
						],
						[
							152.5514999610001,
							-28.46656339599997
						],
						[
							152.5612809690001,
							-28.469888406999928
						],
						[
							152.56524696200006,
							-28.44014941699993
						],
						[
							152.58042895100004,
							-28.435061417999975
						],
						[
							152.57643607400007,
							-28.41559443799997
						],
						[
							152.59455795300005,
							-28.408729408999932
						],
						[
							152.61439910800004,
							-28.352671260999955
						],
						[
							152.62817898700007,
							-28.34897041199997
						],
						[
							152.6313999680001,
							-28.338777412999946
						],
						[
							152.6275569500001,
							-28.326741401999982
						],
						[
							152.59757760500008,
							-28.314538738999943
						],
						[
							152.57951147300003,
							-28.339185406999945
						],
						[
							152.57230497600005,
							-28.32674140699993
						],
						[
							152.55468097800008,
							-28.325523404999956
						],
						[
							152.55495197900007,
							-28.318956904999936
						],
						[
							152.54701874900002,
							-28.320474133999937
						],
						[
							152.52513298400004,
							-28.304191401999958
						],
						[
							152.53398098800005,
							-28.26268140199994
						],
						[
							152.5093109930001,
							-28.249170899999967
						],
						[
							152.48764139500008,
							-28.253481767999972
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "130",
				"CED_NAME21": "New England",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 66293.6981,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/130",
				"SHAPE_Leng": 24.8232287206,
				"SHAPE_Area": 6.22715485686
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								151.73792013700006,
								-32.962934779999955
							],
							[
								151.80297032500005,
								-32.915868355999976
							],
							[
								151.78551956600006,
								-32.92551239499994
							],
							[
								151.7635145590001,
								-32.924445342999945
							],
							[
								151.76147049200006,
								-32.90764740199995
							],
							[
								151.76425039900005,
								-32.92205235299997
							],
							[
								151.77026062900006,
								-32.91631637299997
							],
							[
								151.77697746700005,
								-32.92354733399998
							],
							[
								151.768034542,
								-32.89486514299995
							],
							[
								151.733837149,
								-32.87762609899994
							],
							[
								151.77461443200002,
								-32.88956541299996
							],
							[
								151.7773083500001,
								-32.902170343999956
							],
							[
								151.7841792910001,
								-32.88767513399995
							],
							[
								151.77476963700008,
								-32.857088362999946
							],
							[
								151.7465189610001,
								-32.85361607999994
							],
							[
								151.72816545400008,
								-32.846897388999935
							],
							[
								151.726224096,
								-32.83811606799998
							],
							[
								151.69646046000003,
								-32.83292933499996
							],
							[
								151.69661667800005,
								-32.84785200599998
							],
							[
								151.72822823,
								-32.87868606899997
							],
							[
								151.70923954400007,
								-32.868670376999944
							],
							[
								151.6902977300001,
								-32.84167605499994
							],
							[
								151.69064320200005,
								-32.82786649499997
							],
							[
								151.67407352400005,
								-32.828626362999955
							],
							[
								151.63534651500004,
								-32.86023534999998
							],
							[
								151.61415603900002,
								-32.856813457999976
							],
							[
								151.60858350600006,
								-32.880138346999956
							],
							[
								151.6008514560001,
								-32.88924765699994
							],
							[
								151.61472853300006,
								-32.900701167999955
							],
							[
								151.6478239170001,
								-32.910929290999945
							],
							[
								151.66540125500012,
								-32.90759596299995
							],
							[
								151.652143184,
								-32.92357198199994
							],
							[
								151.66241720200003,
								-32.929838582999935
							],
							[
								151.68624147800006,
								-32.93769535499996
							],
							[
								151.68462649700007,
								-32.948455354999965
							],
							[
								151.72906473000012,
								-32.95506945899996
							],
							[
								151.73792013700006,
								-32.962934779999955
							]
						]
					],
					[
						[
							[
								151.79395683100006,
								-32.875700344999984
							],
							[
								151.77761647900002,
								-32.91141335399993
							],
							[
								151.78466958700005,
								-32.92022139499994
							],
							[
								151.79153549600005,
								-32.91545436499996
							],
							[
								151.79159845900006,
								-32.89619236499993
							],
							[
								151.81011563900006,
								-32.878207506999956
							],
							[
								151.79395683100006,
								-32.875700344999984
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "131",
				"CED_NAME21": "Newcastle",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 156.3537,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/131",
				"SHAPE_Leng": 1.169126724,
				"SHAPE_Area": 0.015067672565
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								151.136892417,
								-33.81516027999993
							],
							[
								151.12832469500006,
								-33.84168988899995
							],
							[
								151.13791839300006,
								-33.84472527999998
							],
							[
								151.14890029200012,
								-33.83879806099998
							],
							[
								151.13590746500006,
								-33.836456349999935
							],
							[
								151.15334114200004,
								-33.836487430999966
							],
							[
								151.16162047000012,
								-33.84478729199998
							],
							[
								151.18030948800003,
								-33.83640927399995
							],
							[
								151.16933053900004,
								-33.83929628299995
							],
							[
								151.14554860400006,
								-33.830349300999956
							],
							[
								151.14691049500004,
								-33.82001730099995
							],
							[
								151.136892417,
								-33.81516027999993
							]
						]
					],
					[
						[
							[
								151.23106335400007,
								-33.81674580899994
							],
							[
								151.22599021400003,
								-33.82232931799996
							],
							[
								151.2193460850001,
								-33.818814456999974
							],
							[
								151.232174664,
								-33.81361686899993
							],
							[
								151.23056344500003,
								-33.80548432799998
							],
							[
								151.217319717,
								-33.805402826999966
							],
							[
								151.23054943600005,
								-33.80236231799995
							],
							[
								151.23087643700012,
								-33.79566331799998
							],
							[
								151.21767212800012,
								-33.79726612699994
							],
							[
								151.22284143800005,
								-33.79424730799997
							],
							[
								151.21474143000012,
								-33.78987631699994
							],
							[
								151.2036674420001,
								-33.78684031599994
							],
							[
								151.17824271400002,
								-33.797708882999984
							],
							[
								151.15711177700007,
								-33.79269615099997
							],
							[
								151.1576881860001,
								-33.80067694199994
							],
							[
								151.14358450800012,
								-33.80292026999996
							],
							[
								151.14587944400012,
								-33.82897632099997
							],
							[
								151.15203845400004,
								-33.82182831099993
							],
							[
								151.16898544000003,
								-33.83606432299996
							],
							[
								151.17309946000012,
								-33.828175312999974
							],
							[
								151.18163841900002,
								-33.829507313999954
							],
							[
								151.1811234370001,
								-33.84224432399998
							],
							[
								151.187603426,
								-33.843105314999946
							],
							[
								151.1890474070001,
								-33.83362187499995
							],
							[
								151.19298797500005,
								-33.847608874999935
							],
							[
								151.19904099500002,
								-33.84114886599997
							],
							[
								151.2037332430001,
								-33.85056626599993
							],
							[
								151.208167343,
								-33.84415755699996
							],
							[
								151.21879059100002,
								-33.85268586799998
							],
							[
								151.21520351300012,
								-33.84106403699997
							],
							[
								151.21678243400004,
								-33.830053316999965
							],
							[
								151.23091757200007,
								-33.82776549899995
							],
							[
								151.23106335400007,
								-33.81674580899994
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "132",
				"CED_NAME21": "North Sydney",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 41.5633,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/132",
				"SHAPE_Leng": 0.761905174788,
				"SHAPE_Area": 0.00404761016064
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							153.14835755000001,
							-30.241808598999967
						],
						[
							153.16699292400006,
							-30.198016619999976
						],
						[
							153.20668105400011,
							-30.156993503999956
						],
						[
							153.19957005700007,
							-30.141259582999965
						],
						[
							153.21371965000003,
							-30.109711593999975
						],
						[
							153.19964678200006,
							-30.10388969299993
						],
						[
							153.20786651600008,
							-30.068513733999964
						],
						[
							153.20634869800006,
							-30.05830148299998
						],
						[
							153.19634565900003,
							-30.054891831999953
						],
						[
							153.19708960100002,
							-30.04056486199994
						],
						[
							153.23337184500008,
							-29.979740824999965
						],
						[
							153.26013429500006,
							-29.951926777999972
						],
						[
							153.27689799100006,
							-29.893285928999944
						],
						[
							153.2675597230001,
							-29.885666497999978
						],
						[
							153.267653966,
							-29.865237977999982
						],
						[
							153.28247676800004,
							-29.83381707899997
						],
						[
							153.2944225980001,
							-29.82506705999998
						],
						[
							153.28804860200012,
							-29.798304169999938
						],
						[
							153.30394943400006,
							-29.77452423099993
						],
						[
							153.29201560800004,
							-29.755900339999982
						],
						[
							153.29589651000003,
							-29.73710140999998
						],
						[
							153.33397999400006,
							-29.674538562999942
						],
						[
							153.32290272500006,
							-29.670516491999933
						],
						[
							153.32108071800008,
							-29.65345150199994
						],
						[
							153.34278964100008,
							-29.60826867399993
						],
						[
							153.3317856640001,
							-29.595774681999956
						],
						[
							153.33852845800004,
							-29.564373702999944
						],
						[
							153.36259580000012,
							-29.52534065499998
						],
						[
							153.35874070400007,
							-29.496068633999982
						],
						[
							153.36884744500003,
							-29.484039604999964
						],
						[
							153.35842158800006,
							-29.465830623999977
						],
						[
							153.37278018000006,
							-29.440329464999934
						],
						[
							153.36399923300007,
							-29.430198493999967
						],
						[
							153.37282307200007,
							-29.425109444999975
						],
						[
							153.363287774,
							-29.42155949399995
						],
						[
							153.37668755000004,
							-29.36558338499998
						],
						[
							153.36290176300008,
							-29.35538549399996
						],
						[
							153.3539337530001,
							-29.357696502999943
						],
						[
							153.3444468560001,
							-29.34443362199994
						],
						[
							153.34432747300002,
							-29.296566690999953
						],
						[
							153.4005248090001,
							-29.20136546599997
						],
						[
							153.45666455000003,
							-29.140178221999975
						],
						[
							153.44857359200012,
							-29.133376290999934
						],
						[
							153.4514004140001,
							-29.11886230099998
						],
						[
							153.43528062600012,
							-29.113090428999953
						],
						[
							153.43279055800008,
							-29.101075458999958
						],
						[
							153.45297178400006,
							-29.039236400999982
						],
						[
							153.49799278800003,
							-28.971451514999956
						],
						[
							153.5511581400001,
							-28.910602059999974
						],
						[
							153.52325174400005,
							-28.90164916699996
						],
						[
							153.49726012500003,
							-28.921015093999983
						],
						[
							153.4767768060001,
							-28.924883491999935
						],
						[
							153.47753479800008,
							-28.913208491999967
						],
						[
							153.46624779900003,
							-28.91146250099996
						],
						[
							153.47434383300003,
							-28.878588500999967
						],
						[
							153.48559280100005,
							-28.880147502999932
						],
						[
							153.49381380300008,
							-28.86396349299997
						],
						[
							153.50155283100003,
							-28.86776150399993
						],
						[
							153.5026748030001,
							-28.85409750399998
						],
						[
							153.49301978500012,
							-28.846476502999963
						],
						[
							153.48292279600003,
							-28.849366491999945
						],
						[
							153.48178665400008,
							-28.859891811999944
						],
						[
							153.47603487700007,
							-28.846067480999977
						],
						[
							153.448964111,
							-28.839594638999984
						],
						[
							153.44855549200008,
							-28.833108857999946
						],
						[
							153.43916882200006,
							-28.83566849799996
						],
						[
							153.4446762450001,
							-28.810902237999983
						],
						[
							153.4566018150001,
							-28.804338508999933
						],
						[
							153.43925982700011,
							-28.800395486999946
						],
						[
							153.45215184800009,
							-28.778657487999965
						],
						[
							153.44358581000006,
							-28.777460507999933
						],
						[
							153.4416268220001,
							-28.762968496999974
						],
						[
							153.44998284200005,
							-28.757280497999943
						],
						[
							153.44857050300004,
							-28.747998647999964
						],
						[
							153.4353178340001,
							-28.747615485999972
						],
						[
							153.42646683700002,
							-28.738375495999946
						],
						[
							153.42243782600008,
							-28.74505249499998
						],
						[
							153.40767481800003,
							-28.744166493999955
						],
						[
							153.41215581100005,
							-28.720579493999935
						],
						[
							153.4006408350001,
							-28.69874250299995
						],
						[
							153.4077528260001,
							-28.686137492999933
						],
						[
							153.42409785300003,
							-28.69336849499996
						],
						[
							153.42662785400012,
							-28.681004494999968
						],
						[
							153.4160428570001,
							-28.671384493999938
						],
						[
							153.4193360280001,
							-28.661739203999957
						],
						[
							153.42437131600002,
							-28.667204204999962
						],
						[
							153.43029383600003,
							-28.661465504999967
						],
						[
							153.41163785100002,
							-28.641031492999957
						],
						[
							153.4126328440001,
							-28.61855049299993
						],
						[
							153.3730932090001,
							-28.61396341899996
						],
						[
							153.3789538630001,
							-28.58221748899996
						],
						[
							153.3506648780001,
							-28.566666475999966
						],
						[
							153.32857585400006,
							-28.54084247399993
						],
						[
							153.2913968780001,
							-28.54156346999997
						],
						[
							153.28276087200004,
							-28.516015468999967
						],
						[
							153.25543737400005,
							-28.52713851599998
						],
						[
							153.2472328760001,
							-28.51580147599998
						],
						[
							153.20571788900008,
							-28.52652748099996
						],
						[
							153.16026287500006,
							-28.52412846699997
						],
						[
							153.15008189800005,
							-28.505627465999964
						],
						[
							153.15385461000005,
							-28.484603255999957
						],
						[
							153.14108556400004,
							-28.471441743999947
						],
						[
							153.14362464500005,
							-28.461867394999956
						],
						[
							153.1340547860001,
							-28.458859393999944
						],
						[
							153.14387547800004,
							-28.43875544499997
						],
						[
							153.1207327310001,
							-28.433251611999935
						],
						[
							153.12812847300006,
							-28.406383802999983
						],
						[
							153.1122785660001,
							-28.400589750999984
						],
						[
							153.11806502600007,
							-28.396443571999953
						],
						[
							153.10708034800007,
							-28.386939749999954
						],
						[
							153.11320721000004,
							-28.366519730999983
						],
						[
							153.1085534120001,
							-28.356314959999963
						],
						[
							153.08068041500007,
							-28.354394456999955
						],
						[
							153.04490742100006,
							-28.338998953999976
						],
						[
							152.99609792700005,
							-28.339952448999952
						],
						[
							152.97318543000006,
							-28.331809446999955
						],
						[
							152.93427143400004,
							-28.337641942999937
						],
						[
							152.89992043900008,
							-28.32536493899994
						],
						[
							152.88042994400007,
							-28.30979993699998
						],
						[
							152.8494299470001,
							-28.311172933999956
						],
						[
							152.84021144700012,
							-28.32159893299996
						],
						[
							152.83137494800008,
							-28.31965693199993
						],
						[
							152.8042649460001,
							-28.353557429999967
						],
						[
							152.77739095000004,
							-28.345953926999982
						],
						[
							152.75095495100004,
							-28.363866924999968
						],
						[
							152.72305895700003,
							-28.34411942199995
						],
						[
							152.70764295800006,
							-28.344274419999977
						],
						[
							152.67949946300007,
							-28.33057191699993
						],
						[
							152.66752246700003,
							-28.311689915999978
						],
						[
							152.63975297000002,
							-28.312173412999982
						],
						[
							152.62412947400003,
							-28.29828491199993
						],
						[
							152.6142479780001,
							-28.269463909999956
						],
						[
							152.59962997800005,
							-28.283668408999972
						],
						[
							152.59757760500008,
							-28.314538738999943
						],
						[
							152.6275569500001,
							-28.326741401999982
						],
						[
							152.6313999680001,
							-28.338777412999946
						],
						[
							152.62817898700007,
							-28.34897041199997
						],
						[
							152.61439910800004,
							-28.352671260999955
						],
						[
							152.59455795300005,
							-28.408729408999932
						],
						[
							152.57643607400007,
							-28.41559443799997
						],
						[
							152.58042895100004,
							-28.435061417999975
						],
						[
							152.56524696200006,
							-28.44014941699993
						],
						[
							152.5612809690001,
							-28.469888406999928
						],
						[
							152.5514999610001,
							-28.46656339599997
						],
						[
							152.55321297900002,
							-28.477581405999956
						],
						[
							152.53908795000007,
							-28.480575404999968
						],
						[
							152.52743496000005,
							-28.495752403999973
						],
						[
							152.53734795800005,
							-28.50087540499993
						],
						[
							152.53183495700011,
							-28.514718393999942
						],
						[
							152.50335496000002,
							-28.51153539099994
						],
						[
							152.50269697800002,
							-28.527535400999966
						],
						[
							152.48525867000012,
							-28.531177509999964
						],
						[
							152.472188823,
							-28.51921958799994
						],
						[
							152.46609697300005,
							-28.52658460799995
						],
						[
							152.45984101400006,
							-28.52247863699995
						],
						[
							152.46066205300008,
							-28.52920762699995
						],
						[
							152.44046842500006,
							-28.530310724999936
						],
						[
							152.446425373,
							-28.539178695999965
						],
						[
							152.441400562,
							-28.555885715999977
						],
						[
							152.4577643780001,
							-28.568964646999973
						],
						[
							152.44016980900005,
							-28.576271735999967
						],
						[
							152.44747269800007,
							-28.57703169599995
						],
						[
							152.44611179800006,
							-28.584600715999954
						],
						[
							152.4382499090001,
							-28.583009754999978
						],
						[
							152.44282602600003,
							-28.603370755999947
						],
						[
							152.42134142800012,
							-28.60737586399995
						],
						[
							152.41700760700007,
							-28.61497989399993
						],
						[
							152.42482550500006,
							-28.620812873999967
						],
						[
							152.40577983700007,
							-28.621642962999942
						],
						[
							152.4139867550001,
							-28.63202289299994
						],
						[
							152.39858119500002,
							-28.64679793199997
						],
						[
							152.40312015300003,
							-28.65867388299995
						],
						[
							152.3892845040001,
							-28.665360980999935
						],
						[
							152.3894346620001,
							-28.68259595099994
						],
						[
							152.37365695300002,
							-28.687289989999954
						],
						[
							152.37670904100003,
							-28.702926969999965
						],
						[
							152.40653847700003,
							-28.70447181299994
						],
						[
							152.40861861400003,
							-28.724016753999933
						],
						[
							152.42075694400012,
							-28.717969394999955
						],
						[
							152.4652826260001,
							-28.735824288999936
						],
						[
							152.47361944600004,
							-28.73076022999993
						],
						[
							152.47308658400004,
							-28.74706817999993
						],
						[
							152.49764002200004,
							-28.737871001999963
						],
						[
							152.49494417100004,
							-28.748589011999968
						],
						[
							152.47982948300012,
							-28.75078713099998
						],
						[
							152.49204793,
							-28.764548411999954
						],
						[
							152.4801107090001,
							-28.780134010999973
						],
						[
							152.49700246600003,
							-28.785518862999936
						],
						[
							152.51104416600003,
							-28.77972975399996
						],
						[
							152.5193601730001,
							-28.79474366499994
						],
						[
							152.5309978030001,
							-28.78136163599993
						],
						[
							152.541566632,
							-28.781782566999937
						],
						[
							152.53921000800005,
							-28.81492348699993
						],
						[
							152.5572158550001,
							-28.82324234899994
						],
						[
							152.5372059340001,
							-28.84773140699997
						],
						[
							152.57331190800005,
							-28.863637410999957
						],
						[
							152.54814592500009,
							-28.90878941899996
						],
						[
							152.5550846740001,
							-28.91257608899997
						],
						[
							152.57057590300008,
							-28.904952410999954
						],
						[
							152.58011338100005,
							-28.911470921999978
						],
						[
							152.58087447900004,
							-28.92921684199996
						],
						[
							152.56594167100002,
							-28.926060980999978
						],
						[
							152.54558789200007,
							-28.936304408999945
						],
						[
							152.55852224300008,
							-28.990064909999944
						],
						[
							152.5331359070001,
							-28.983922407999955
						],
						[
							152.530145897,
							-28.988425407999955
						],
						[
							152.50833102,
							-28.980340384999977
						],
						[
							152.5095789610001,
							-28.97324137499993
						],
						[
							152.48665933400002,
							-28.96996162299996
						],
						[
							152.48865529300008,
							-28.977080592999982
						],
						[
							152.46261178600002,
							-28.97589278099997
						],
						[
							152.4762336230001,
							-28.99036566199993
						],
						[
							152.4638788840001,
							-28.99197775099998
						],
						[
							152.4717498110001,
							-29.004902641999934
						],
						[
							152.4551762210001,
							-29.020496739999942
						],
						[
							152.45983620900006,
							-29.03157866099997
						],
						[
							152.4461283810001,
							-29.02832780999995
						],
						[
							152.42377574300008,
							-29.036634007999965
						],
						[
							152.4439024300001,
							-29.03974280999995
						],
						[
							152.4311162880001,
							-29.071950068999968
						],
						[
							152.41898398800004,
							-29.081032026999935
						],
						[
							152.45501141300008,
							-29.08901463099994
						],
						[
							152.4442367570001,
							-29.144162619999975
						],
						[
							152.4177591790001,
							-29.15226387799993
						],
						[
							152.41381031800006,
							-29.161244847999967
						],
						[
							152.4251431250001,
							-29.17837771899997
						],
						[
							152.40521671300007,
							-29.211154826999973
						],
						[
							152.41412363000006,
							-29.22888164799997
						],
						[
							152.39373389000002,
							-29.241391695999937
						],
						[
							152.3518196240001,
							-29.248707861999947
						],
						[
							152.30647870500002,
							-29.283084187999975
						],
						[
							152.3146614520001,
							-29.298506028999952
						],
						[
							152.30004080300012,
							-29.30444512699995
						],
						[
							152.30010277200006,
							-29.313592057999983
						],
						[
							152.33134110700007,
							-29.329005760999962
						],
						[
							152.3370500750001,
							-29.336874700999942
						],
						[
							152.33152317500003,
							-29.34182471099996
						],
						[
							152.45226763800008,
							-29.360153612999966
						],
						[
							152.43448041800002,
							-29.378476880999983
						],
						[
							152.43223044700005,
							-29.392608420999977
						],
						[
							152.40866228900006,
							-29.39846579899995
						],
						[
							152.40432313500003,
							-29.432765588999928
						],
						[
							152.39717723600006,
							-29.431754677999947
						],
						[
							152.39456222400008,
							-29.446100627999954
						],
						[
							152.38879132500006,
							-29.445303706999937
						],
						[
							152.41246170400007,
							-29.506867729999954
						],
						[
							152.35449777600002,
							-29.54545802499996
						],
						[
							152.33612848600012,
							-29.64076404399998
						],
						[
							152.32571977600003,
							-29.655449102999967
						],
						[
							152.31251210800008,
							-29.651354150999964
						],
						[
							152.3118272260001,
							-29.66453310099996
						],
						[
							152.30535434700005,
							-29.661837120999962
						],
						[
							152.28954875700003,
							-29.676281208999967
						],
						[
							152.28097389000004,
							-29.66555625799998
						],
						[
							152.2617158280001,
							-29.69842839699993
						],
						[
							152.27075482600003,
							-29.707124397999962
						],
						[
							152.26215484600004,
							-29.712491386999943
						],
						[
							152.2657498330001,
							-29.727575386999945
						],
						[
							152.25508983400005,
							-29.73406138599995
						],
						[
							152.26459282100006,
							-29.74990837699994
						],
						[
							152.26063082000007,
							-29.75698838699998
						],
						[
							152.22969784400004,
							-29.75483539399994
						],
						[
							152.2147628450001,
							-29.761564372999942
						],
						[
							152.20295983300002,
							-29.786723371999983
						],
						[
							152.19086884500007,
							-29.788445370999966
						],
						[
							152.194182833,
							-29.80015038099998
						],
						[
							152.186527833,
							-29.80252538999997
						],
						[
							152.19313882200004,
							-29.80671838099994
						],
						[
							152.1798668340001,
							-29.80669537999995
						],
						[
							152.17022682300012,
							-29.822447368999974
						],
						[
							152.1779488310001,
							-29.827460369999983
						],
						[
							152.17022583000005,
							-29.84057237899998
						],
						[
							152.17755681900007,
							-29.84803538999995
						],
						[
							152.1683638190001,
							-29.85351737899998
						],
						[
							152.172907806,
							-29.871149378999974
						],
						[
							152.19242483300002,
							-29.87660239099995
						],
						[
							152.20803384300007,
							-29.86603938299993
						],
						[
							152.22191884000006,
							-29.87206038399995
						],
						[
							152.23411984000006,
							-29.86393738499993
						],
						[
							152.25109682800007,
							-29.86496339699994
						],
						[
							152.27353081700005,
							-29.84621538899995
						],
						[
							152.2819908250001,
							-29.856776389999936
						],
						[
							152.276795815,
							-29.86446339899993
						],
						[
							152.28767880200007,
							-29.873402390999956
						],
						[
							152.28126881200012,
							-29.878258389999928
						],
						[
							152.2856588080001,
							-29.907890390999967
						],
						[
							152.2689998090001,
							-29.912477388999946
						],
						[
							152.27839881800003,
							-29.91785639999995
						],
						[
							152.2680617970001,
							-29.92856237899997
						],
						[
							152.2785978170001,
							-29.921219379999968
						],
						[
							152.2834138060001,
							-29.925058390999936
						],
						[
							152.26965582700007,
							-29.932379398999956
						],
						[
							152.27242281400004,
							-29.95155638999995
						],
						[
							152.28986378900004,
							-29.97535038199993
						],
						[
							152.30807180600004,
							-29.980226392999953
						],
						[
							152.300612816,
							-29.985242392999965
						],
						[
							152.31709278200003,
							-30.005929383999955
						],
						[
							152.31517779800004,
							-30.034196384999973
						],
						[
							152.29464681000002,
							-30.040781392999975
						],
						[
							152.29918977900002,
							-30.046238392999953
						],
						[
							152.29283479900005,
							-30.051904401999934
						],
						[
							152.29996580700004,
							-30.05693039299996
						],
						[
							152.29176877700002,
							-30.063251391999984
						],
						[
							152.29985878500008,
							-30.071117392999952
						],
						[
							152.2924157760001,
							-30.071120392999944
						],
						[
							152.2939037740001,
							-30.085378392999928
						],
						[
							152.27975279600003,
							-30.088017400999945
						],
						[
							152.27943878400004,
							-30.09932539199997
						],
						[
							152.29826979000006,
							-30.117062402999977
						],
						[
							152.29700976700008,
							-30.138074383999935
						],
						[
							152.30525376600008,
							-30.140490393999983
						],
						[
							152.29779678600005,
							-30.147292403999984
						],
						[
							152.3096777840001,
							-30.14789439499998
						],
						[
							152.30493077300002,
							-30.16139339399996
						],
						[
							152.316559782,
							-30.161615395999945
						],
						[
							152.30924478300005,
							-30.16100140499998
						],
						[
							152.31112676100008,
							-30.173618404999957
						],
						[
							152.3031967710001,
							-30.179172393999977
						],
						[
							152.3170787790001,
							-30.18210638599993
						],
						[
							152.31047975700005,
							-30.200799394999933
						],
						[
							152.3503957480001,
							-30.235165408999933
						],
						[
							152.33732976700003,
							-30.25814640799996
						],
						[
							152.33934773300007,
							-30.28221440899995
						],
						[
							152.34930775100008,
							-30.29160638999997
						],
						[
							152.34187312900008,
							-30.310948868999958
						],
						[
							152.34519225600002,
							-30.332105799999965
						],
						[
							152.35477324400006,
							-30.34035770099996
						],
						[
							152.35178543200004,
							-30.355346720999933
						],
						[
							152.3819253370001,
							-30.362615223999967
						],
						[
							152.38753706400007,
							-30.383146463999935
						],
						[
							152.428083914,
							-30.418884197999944
						],
						[
							152.43806148600004,
							-30.400233148999973
						],
						[
							152.47859075100007,
							-30.396980912999936
						],
						[
							152.4846375610001,
							-30.39078193399996
						],
						[
							152.47767369200005,
							-30.389820962999977
						],
						[
							152.474917397,
							-30.35662399299997
						],
						[
							152.48048306900012,
							-30.33247995299996
						],
						[
							152.4933618670001,
							-30.33685287399993
						],
						[
							152.50630947800005,
							-30.320539794999945
						],
						[
							152.525934107,
							-30.31158970699994
						],
						[
							152.5329548080001,
							-30.29276669799998
						],
						[
							152.54378464700005,
							-30.29265064899994
						],
						[
							152.55500938700004,
							-30.28091455999993
						],
						[
							152.55022821800003,
							-30.277679588999945
						],
						[
							152.55727990900004,
							-30.26228753999993
						],
						[
							152.5512969,
							-30.257760348999966
						],
						[
							152.56493166100006,
							-30.239288430999977
						],
						[
							152.56123366200006,
							-30.233626449999974
						],
						[
							152.57388561900007,
							-30.244507391999946
						],
						[
							152.58653231800008,
							-30.240873292999936
						],
						[
							152.6030180150001,
							-30.25247372399997
						],
						[
							152.61123095400012,
							-30.249248154999975
						],
						[
							152.61623776200008,
							-30.258137105999936
						],
						[
							152.62689354100007,
							-30.259966316999964
						],
						[
							152.6382973410001,
							-30.25124306799995
						],
						[
							152.6465749890001,
							-30.258185968999953
						],
						[
							152.64898617900008,
							-30.252401128999963
						],
						[
							152.65538170800005,
							-30.25530360999994
						],
						[
							152.69775499700006,
							-30.223593783999945
						],
						[
							152.69399396900008,
							-30.211109782999984
						],
						[
							152.70745666800008,
							-30.204232683999976
						],
						[
							152.69299281200006,
							-30.189002742999946
						],
						[
							152.75076887400007,
							-30.196603548999974
						],
						[
							152.75518971600002,
							-30.18077651899995
						],
						[
							152.7679415340001,
							-30.18242947999994
						],
						[
							152.80345891900004,
							-30.189554243999964
						],
						[
							152.81744885400008,
							-30.21334107499996
						],
						[
							152.8328632020001,
							-30.216948636999973
						],
						[
							152.8295452010001,
							-30.222065536999935
						],
						[
							152.8684406980001,
							-30.21020244999994
						],
						[
							152.87356167600012,
							-30.220551460999957
						],
						[
							152.8899376930001,
							-30.22748846299993
						],
						[
							152.92761608900003,
							-30.22718615699995
						],
						[
							152.93779385900007,
							-30.21702009699993
						],
						[
							152.95215770700008,
							-30.215494458999956
						],
						[
							152.96693640500007,
							-30.22257179999997
						],
						[
							152.985747843,
							-30.214117691999945
						],
						[
							152.98726610200004,
							-30.22227559199996
						],
						[
							152.99908586100003,
							-30.22139148399998
						],
						[
							152.99494573800007,
							-30.246747382999956
						],
						[
							153.01070183600007,
							-30.248762454999962
						],
						[
							153.02064768200012,
							-30.26905246599995
						],
						[
							153.04647704800004,
							-30.271932968999977
						],
						[
							153.04626468700008,
							-30.27887046899997
						],
						[
							153.0608724540001,
							-30.287772879999977
						],
						[
							153.084889674,
							-30.27265747299998
						],
						[
							153.082538676,
							-30.258342461999973
						],
						[
							153.09227965700006,
							-30.239122462999944
						],
						[
							153.14157465200003,
							-30.232417477999945
						],
						[
							153.14835755000001,
							-30.241808598999967
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "133",
				"CED_NAME21": "Page",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 19319.892,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/133",
				"SHAPE_Leng": 10.0368560017,
				"SHAPE_Area": 1.79471917086
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							148.3471489320001,
							-32.67574962799995
						],
						[
							148.347262816,
							-32.641573636999965
						],
						[
							148.36178145600002,
							-32.62193451799993
						],
						[
							148.37546830300005,
							-32.630348469999944
						],
						[
							148.3859311330001,
							-32.62206645999993
						],
						[
							148.4354243260001,
							-32.62058633399994
						],
						[
							148.459258964,
							-32.60734405599993
						],
						[
							148.47526498000002,
							-32.62777007799997
						],
						[
							148.50119008800004,
							-32.614104089999955
						],
						[
							148.6145989570001,
							-32.653603078999936
						],
						[
							148.6215339570001,
							-32.64794307999995
						],
						[
							148.63107494500002,
							-32.65185909099995
						],
						[
							148.63771794700006,
							-32.63321808099994
						],
						[
							148.6640189320001,
							-32.641240092999965
						],
						[
							148.67032303300005,
							-32.623213103999944
						],
						[
							148.6861604920001,
							-32.612724044999936
						],
						[
							148.70204912000008,
							-32.61369559599996
						],
						[
							148.6902547730001,
							-32.598878344999946
						],
						[
							148.70974124200006,
							-32.58519565699993
						],
						[
							148.69858483500002,
							-32.57818295599998
						],
						[
							148.7245779120001,
							-32.570403357999965
						],
						[
							148.71532987500007,
							-32.55281203699997
						],
						[
							148.70069154700002,
							-32.55306376599998
						],
						[
							148.71270800800005,
							-32.53150839699998
						],
						[
							148.70840885000007,
							-32.52281332599995
						],
						[
							148.69920476100003,
							-32.52274942599996
						],
						[
							148.70041254400007,
							-32.49692294499994
						],
						[
							148.7234662410001,
							-32.49522283699997
						],
						[
							148.72293020300003,
							-32.48053978699994
						],
						[
							148.73410496200006,
							-32.468266667999956
						],
						[
							148.71637279900006,
							-32.435594685999945
						],
						[
							148.70384301,
							-32.43493273499996
						],
						[
							148.69825219400002,
							-32.407264744999964
						],
						[
							148.70814391300007,
							-32.40604272499996
						],
						[
							148.72671269900002,
							-32.422227626999984
						],
						[
							148.75411521500007,
							-32.419038558999944
						],
						[
							148.75736419800012,
							-32.395640438999976
						],
						[
							148.7645969670001,
							-32.39656745999997
						],
						[
							148.76567086700004,
							-32.390249359999984
						],
						[
							148.75838480800007,
							-32.389360428999964
						],
						[
							148.76808932200004,
							-32.34183313999995
						],
						[
							148.80460304400003,
							-32.36738404299996
						],
						[
							148.84103394400006,
							-32.33124808599996
						],
						[
							148.85067187200002,
							-32.33245271699997
						],
						[
							148.85119747400006,
							-32.31336660699998
						],
						[
							148.88355104000004,
							-32.311995458999945
						],
						[
							148.88751680200005,
							-32.28993527999995
						],
						[
							148.89617551100002,
							-32.29114623999993
						],
						[
							148.92725284900007,
							-32.271650972999964
						],
						[
							148.94532740800003,
							-32.171343553999975
						],
						[
							148.95291907900003,
							-32.15757048399996
						],
						[
							148.96840197500012,
							-32.16760953599993
						],
						[
							148.9909171060001,
							-32.13846241699997
						],
						[
							149.00078594400009,
							-32.13961810799998
						],
						[
							149.0152534460001,
							-32.10524223899995
						],
						[
							149.02563893500007,
							-32.10883710999997
						],
						[
							149.03292295500012,
							-32.09983210099995
						],
						[
							149.05473597200012,
							-32.100327111999945
						],
						[
							149.05961496200007,
							-32.08720611299998
						],
						[
							149.07119092900007,
							-32.10329410399993
						],
						[
							149.09619893400009,
							-32.114945115999944
						],
						[
							149.10624694400008,
							-32.10484311699997
						],
						[
							149.1102549430001,
							-32.11140811699994
						],
						[
							149.11945892200004,
							-32.107960127999945
						],
						[
							149.12215894200006,
							-32.10103411799997
						],
						[
							149.1386909580001,
							-32.11719911999995
						],
						[
							149.15403394600003,
							-32.11589111099994
						],
						[
							149.15465393600005,
							-32.12174413099996
						],
						[
							149.17114193300006,
							-32.124800121999954
						],
						[
							149.16911092600003,
							-32.102949121999984
						],
						[
							149.19376193200003,
							-32.10440813399998
						],
						[
							149.20151590900002,
							-32.11975711499997
						],
						[
							149.1973539270001,
							-32.144630124999935
						],
						[
							149.2114639140001,
							-32.150393115999975
						],
						[
							149.2109719220001,
							-32.170783135999955
						],
						[
							149.22056791900002,
							-32.18252612699996
						],
						[
							149.19876880200002,
							-32.18673866499995
						],
						[
							149.19244000100002,
							-32.201744754999936
						],
						[
							149.19070997000006,
							-32.21203177499996
						],
						[
							149.20302393800011,
							-32.21359912599996
						],
						[
							149.18916481100007,
							-32.29056201499998
						],
						[
							149.2350041640001,
							-32.29340283899995
						],
						[
							149.2397132430001,
							-32.299236829999984
						],
						[
							149.28539831800003,
							-32.28860564299998
						],
						[
							149.29333546500004,
							-32.302685613999984
						],
						[
							149.3051153230001,
							-32.30473357499994
						],
						[
							149.32102074300008,
							-32.28679449599997
						],
						[
							149.33517048200008,
							-32.285077427999965
						],
						[
							149.32650030600007,
							-32.26036341699995
						],
						[
							149.3397900750001,
							-32.256422347999944
						],
						[
							149.3610164260001,
							-32.22038116899995
						],
						[
							149.37372320500003,
							-32.215752099999975
						],
						[
							149.37311103800005,
							-32.18990603999998
						],
						[
							149.3846869360001,
							-32.19315300099993
						],
						[
							149.3967625560001,
							-32.17682092199993
						],
						[
							149.41328333400008,
							-32.17552385399995
						],
						[
							149.41178905900006,
							-32.13818171299994
						],
						[
							149.42909582700008,
							-32.135415594999984
						],
						[
							149.412261703,
							-32.10609759299996
						],
						[
							149.41502855300007,
							-32.09554154299997
						],
						[
							149.47072385500007,
							-32.10351332799996
						],
						[
							149.4725107160001,
							-32.093259297999964
						],
						[
							149.48015056500003,
							-32.09413824899997
						],
						[
							149.4797216830001,
							-32.108781318999945
						],
						[
							149.49495839200006,
							-32.102100279999945
						],
						[
							149.5003070350001,
							-32.07321213999995
						],
						[
							149.53281888800007,
							-32.08945015299997
						],
						[
							149.57323588300005,
							-32.08641115699993
						],
						[
							149.57815287000005,
							-32.10656315699998
						],
						[
							149.60281087400006,
							-32.12694715999993
						],
						[
							149.63819488100012,
							-32.11268816299997
						],
						[
							149.6694768760001,
							-32.12190917499993
						],
						[
							149.68187935600008,
							-32.111131685999965
						],
						[
							149.750816535,
							-32.11980948199994
						],
						[
							149.75183933800008,
							-32.09954849199994
						],
						[
							149.76287514700005,
							-32.089288402999955
						],
						[
							149.77762494500007,
							-32.09154039499998
						],
						[
							149.77848385700008,
							-32.07753731499997
						],
						[
							149.79567046700004,
							-32.058077165999975
						],
						[
							149.80527325600008,
							-32.05516414699997
						],
						[
							149.80816584700005,
							-32.03926416699994
						],
						[
							149.84988085300006,
							-32.025546179999935
						],
						[
							149.85837983200008,
							-32.03041718099996
						],
						[
							149.85984330200006,
							-32.02251690099996
						],
						[
							149.87485618900007,
							-32.03105090299994
						],
						[
							149.873056162,
							-32.01350562199997
						],
						[
							149.8825208620001,
							-31.996881172999963
						],
						[
							149.87379273400006,
							-31.995904821999943
						],
						[
							149.87556955500008,
							-31.98450177199993
						],
						[
							149.83912163900004,
							-31.987365248999936
						],
						[
							149.8660661990001,
							-31.96158602099996
						],
						[
							149.9023563610001,
							-31.904676863999953
						],
						[
							149.92148349100012,
							-31.885135255999955
						],
						[
							150.0239884440001,
							-31.82873920399993
						],
						[
							150.0701559460001,
							-31.76511459799997
						],
						[
							150.11026279200007,
							-31.74890605099995
						],
						[
							150.1050857140001,
							-31.73953180099994
						],
						[
							150.07507803800002,
							-31.739855877999958
						],
						[
							150.04577515500011,
							-31.714143965999938
						],
						[
							150.05223485600004,
							-31.69796092599995
						],
						[
							150.0282711110001,
							-31.68519803399994
						],
						[
							150.0138758800001,
							-31.70477919299998
						],
						[
							150.00438789200007,
							-31.702556191999975
						],
						[
							149.99055095200004,
							-31.713960570999973
						],
						[
							149.9937427010001,
							-31.721775900999944
						],
						[
							149.98412633200007,
							-31.72792420999997
						],
						[
							149.96554725700003,
							-31.700960307999935
						],
						[
							149.94699661000004,
							-31.70226431699996
						],
						[
							149.94174279900005,
							-31.71099531599998
						],
						[
							149.9293088920001,
							-31.698151354999936
						],
						[
							149.90478936500006,
							-31.706751482999948
						],
						[
							149.866314503,
							-31.678945778999946
						],
						[
							149.86558297800002,
							-31.63798475899995
						],
						[
							149.84089518400003,
							-31.616094836999935
						],
						[
							149.90107480500012,
							-31.624414351999974
						],
						[
							149.8929161100001,
							-31.59253968099995
						],
						[
							149.91472924000004,
							-31.57124694299995
						],
						[
							149.90441416500005,
							-31.536884201999953
						],
						[
							149.86695510000004,
							-31.537256627999966
						],
						[
							149.882917248,
							-31.451981468999975
						],
						[
							149.97035491600002,
							-31.45821710699994
						],
						[
							150.0022633630001,
							-31.445615979999957
						],
						[
							150.00439722500005,
							-31.429578939999942
						],
						[
							149.98813541700008,
							-31.42735401799996
						],
						[
							149.9992067940001,
							-31.36163395899996
						],
						[
							149.99871594600006,
							-31.34462617899993
						],
						[
							149.98668291900003,
							-31.32930218699994
						],
						[
							150.00556436700003,
							-31.326202878999936
						],
						[
							150.0065633380001,
							-31.32079288899996
						],
						[
							150.078844236,
							-31.33808151599993
						],
						[
							150.10338494500002,
							-31.240005266999958
						],
						[
							150.13465650000012,
							-31.244300099999975
						],
						[
							150.13832420200004,
							-31.223905039999977
						],
						[
							150.14766302100008,
							-31.225147980999964
						],
						[
							150.1448052500001,
							-31.236725040999943
						],
						[
							150.16530072800003,
							-31.232992862999936
						],
						[
							150.1632948670001,
							-31.24331189299994
						],
						[
							150.15629398800002,
							-31.242323931999977
						],
						[
							150.14865179100002,
							-31.303828031999956
						],
						[
							150.15936574900002,
							-31.31376002299993
						],
						[
							150.16096706300004,
							-31.354946102999975
						],
						[
							150.20171723800001,
							-31.35407388699997
						],
						[
							150.20026861700012,
							-31.36286995699993
						],
						[
							150.22653996300005,
							-31.36966271899996
						],
						[
							150.28591089500003,
							-31.373826383999983
						],
						[
							150.35095683500003,
							-31.389325009999936
						],
						[
							150.370731373,
							-31.382265851999932
						],
						[
							150.38372387100003,
							-31.386109232999956
						],
						[
							150.38247130000002,
							-31.39266581299995
						],
						[
							150.41767309500005,
							-31.39761817599998
						],
						[
							150.41891044500005,
							-31.391023466999968
						],
						[
							150.43462172300008,
							-31.39328710799998
						],
						[
							150.4343718870001,
							-31.365384217999974
						],
						[
							150.41948807200004,
							-31.340016995999974
						],
						[
							150.46963085400012,
							-31.346965230999956
						],
						[
							150.46834685400006,
							-31.353983230999972
						],
						[
							150.4842398610001,
							-31.356188221999957
						],
						[
							150.4855438620001,
							-31.349148231999948
						],
						[
							150.49884683000005,
							-31.350973222999983
						],
						[
							150.50765285800003,
							-31.356843243999947
						],
						[
							150.50570284700007,
							-31.367275243999984
						],
						[
							150.51670127600005,
							-31.366736424999942
						],
						[
							150.51824588700003,
							-31.35831243499996
						],
						[
							150.54329743300002,
							-31.36285721799993
						],
						[
							150.54985199400005,
							-31.34395610799993
						],
						[
							150.53461127600008,
							-31.343079246999935
						],
						[
							150.5376589980001,
							-31.328088176999984
						],
						[
							150.54614071700007,
							-31.329187127999944
						],
						[
							150.54985462700006,
							-31.319216017999963
						],
						[
							150.55041400200002,
							-31.278058887999975
						],
						[
							150.573656539,
							-31.281366669999954
						],
						[
							150.57530039000005,
							-31.27378563999997
						],
						[
							150.58375642400006,
							-31.228463459999944
						],
						[
							150.56232993600008,
							-31.235910687999933
						],
						[
							150.56046584700005,
							-31.22526169799994
						],
						[
							150.56196986800012,
							-31.217292657999963
						],
						[
							150.58017285500011,
							-31.222304229999963
						],
						[
							150.58554178500003,
							-31.217598129999942
						],
						[
							150.586724096,
							-31.210346349999952
						],
						[
							150.5714364380001,
							-31.20820251899994
						],
						[
							150.57973442500008,
							-31.147043378999967
						],
						[
							150.59050108400004,
							-31.142469279999943
						],
						[
							150.5809053050001,
							-31.141210368999964
						],
						[
							150.59772579600008,
							-31.038329359999977
						],
						[
							150.55181646500012,
							-31.011402765999946
						],
						[
							150.5282746030001,
							-30.970904022999946
						],
						[
							150.53306836600007,
							-30.940486973999953
						],
						[
							150.5222684590001,
							-30.92356215199993
						],
						[
							150.51406873000008,
							-30.92869324199995
						],
						[
							150.51003351100007,
							-30.921089310999946
						],
						[
							150.49177610300012,
							-30.921367519999933
						],
						[
							150.49937168400004,
							-30.90880943999997
						],
						[
							150.5155113620001,
							-30.90735227199997
						],
						[
							150.51677630300003,
							-30.90090528199994
						],
						[
							150.53022122100003,
							-30.90299914299993
						],
						[
							150.52281472900006,
							-30.847176171999934
						],
						[
							150.52706872700003,
							-30.855806111999982
						],
						[
							150.5466163740001,
							-30.858743983999943
						],
						[
							150.54947118600012,
							-30.843978913999933
						],
						[
							150.56170791500006,
							-30.83757580499997
						],
						[
							150.55927146800002,
							-30.81080166499993
						],
						[
							150.54384617000005,
							-30.813409553999975
						],
						[
							150.52015530500012,
							-30.800444950999974
						],
						[
							150.48727365900004,
							-30.798971257999938
						],
						[
							150.49039339000012,
							-30.783312157999944
						],
						[
							150.46339883400003,
							-30.778944355999954
						],
						[
							150.456456827,
							-30.767961344999947
						],
						[
							150.46742150600005,
							-30.75952127599993
						],
						[
							150.45261870800005,
							-30.75722028499996
						],
						[
							150.46718436800006,
							-30.745193255999936
						],
						[
							150.46856011900002,
							-30.733654135999984
						],
						[
							150.4645025320001,
							-30.717082265999977
						],
						[
							150.4534678130001,
							-30.71536991499994
						],
						[
							150.45780073600008,
							-30.69022607499994
						],
						[
							150.50965244300005,
							-30.66007567899993
						],
						[
							150.50322538600005,
							-30.64043574899995
						],
						[
							150.46851385200011,
							-30.628322054999956
						],
						[
							150.43787405000012,
							-30.597414321999963
						],
						[
							150.43182523000007,
							-30.603869361999955
						],
						[
							150.41065446400012,
							-30.58983951999994
						],
						[
							150.3960827950001,
							-30.59367661899995
						],
						[
							150.3908350050001,
							-30.60521863799994
						],
						[
							150.378275206,
							-30.60269171699997
						],
						[
							150.36389425000004,
							-30.584055855999964
						],
						[
							150.37024208100001,
							-30.57621183599997
						],
						[
							150.36229621200005,
							-30.573966884999948
						],
						[
							150.35973413400006,
							-30.56089792499995
						],
						[
							150.3907076590001,
							-30.569307697999932
						],
						[
							150.39376534100006,
							-30.54705269799996
						],
						[
							150.36613283500003,
							-30.54340190499994
						],
						[
							150.3685427160001,
							-30.530063905999953
						],
						[
							150.35475093800005,
							-30.528221963999954
						],
						[
							150.36257548100002,
							-30.498565964999955
						],
						[
							150.34888298300007,
							-30.494004213999972
						],
						[
							150.36416297200003,
							-30.489282224999954
						],
						[
							150.3675881040001,
							-30.470067994999965
						],
						[
							150.34654198600003,
							-30.469526222999946
						],
						[
							150.36250204700002,
							-30.450670043999935
						],
						[
							150.36250284900007,
							-30.432450053999958
						],
						[
							150.32863027700012,
							-30.402439330999982
						],
						[
							150.31643398500012,
							-30.427962209999976
						],
						[
							150.28324734900002,
							-30.43083553699995
						],
						[
							150.22575716000006,
							-30.39928494199995
						],
						[
							150.23586280100005,
							-30.378507912999964
						],
						[
							150.22402896300002,
							-30.370908000999975
						],
						[
							150.20342434600002,
							-30.375033109999947
						],
						[
							150.1922054580001,
							-30.366175218999956
						],
						[
							150.19500409300008,
							-30.321074248999935
						],
						[
							150.18297019700003,
							-30.299493366999968
						],
						[
							150.19366202600008,
							-30.29323318799993
						],
						[
							150.16592503200002,
							-30.273936195999966
						],
						[
							150.17559012200002,
							-30.264958645999968
						],
						[
							150.1663580380001,
							-30.22705319499994
						],
						[
							150.14637502200003,
							-30.21563120299993
						],
						[
							150.14486501300007,
							-30.202341802999968
						],
						[
							150.10226868000007,
							-30.191933098999982
						],
						[
							150.07440773000008,
							-30.137109325999972
						],
						[
							150.0741765030001,
							-30.10493734599993
						],
						[
							150.10298479300002,
							-30.081949218999966
						],
						[
							150.12281432200007,
							-30.069446119999952
						],
						[
							150.14060022700005,
							-30.08721099199994
						],
						[
							150.16112475600005,
							-30.081372873999953
						],
						[
							150.17196240600003,
							-30.062950814999965
						],
						[
							150.1975179530001,
							-30.06256162699998
						],
						[
							150.23618189400008,
							-30.012456399999962
						],
						[
							150.24884662300008,
							-30.010254330999942
						],
						[
							150.2500994950001,
							-29.992596340999967
						],
						[
							150.27263407300006,
							-29.989379192999934
						],
						[
							150.28463995000004,
							-29.996638093999934
						],
						[
							150.29286471000012,
							-29.99051803499998
						],
						[
							150.29074961300012,
							-29.966967083999975
						],
						[
							150.30278326300004,
							-29.953445014999943
						],
						[
							150.300202097,
							-29.921944104999966
						],
						[
							150.31385174900004,
							-29.89670005599993
						],
						[
							150.29125481500012,
							-29.861303213999975
						],
						[
							150.3073831490001,
							-29.818428204999975
						],
						[
							150.29863031000002,
							-29.81726425399995
						],
						[
							150.29947922100007,
							-29.80828328399997
						],
						[
							150.29072630200005,
							-29.802685362999966
						],
						[
							150.29444182800012,
							-29.755860482999935
						],
						[
							150.28796588900002,
							-29.74981956299996
						],
						[
							150.30242737900005,
							-29.735552693999978
						],
						[
							150.40019775500002,
							-29.752471432999982
						],
						[
							150.4125444240001,
							-29.746090023999955
						],
						[
							150.42522880100012,
							-29.75731792499994
						],
						[
							150.41295607200004,
							-29.767813213999943
						],
						[
							150.41649905000008,
							-29.77824521399998
						],
						[
							150.43691904900004,
							-29.765029225999967
						],
						[
							150.45117404600012,
							-29.775706216999936
						],
						[
							150.46466105500008,
							-29.771353228999942
						],
						[
							150.520021035,
							-29.800205223999967
						],
						[
							150.52704403300004,
							-29.81161522499997
						],
						[
							150.53804403200002,
							-29.805700224999953
						],
						[
							150.5536080390001,
							-29.812236216999963
						],
						[
							150.56893003900007,
							-29.79950821799997
						],
						[
							150.57437799100012,
							-29.78082848899993
						],
						[
							150.6114942160001,
							-29.785091231999957
						],
						[
							150.6110883030001,
							-29.807219231999966
						],
						[
							150.6263680390001,
							-29.828720243999953
						],
						[
							150.66810903200007,
							-29.842055227999936
						],
						[
							150.68422502900012,
							-29.76978523899993
						],
						[
							150.6782790300001,
							-29.767704227999957
						],
						[
							150.6719840190001,
							-29.778570246999948
						],
						[
							150.64737704300012,
							-29.77323423499996
						],
						[
							150.658357001,
							-29.774053245999937
						],
						[
							150.65865703200006,
							-29.76663023599997
						],
						[
							150.67687203100002,
							-29.75561523799996
						],
						[
							150.68615303400009,
							-29.724417247999952
						],
						[
							150.68228502600005,
							-29.71311322799994
						],
						[
							150.69439301500006,
							-29.70391123899998
						],
						[
							150.68434201900004,
							-29.680385227999977
						],
						[
							150.7117900190001,
							-29.65716423999993
						],
						[
							150.71191204000002,
							-29.643671239999946
						],
						[
							150.72603801000002,
							-29.635626240999954
						],
						[
							150.73331378700004,
							-29.56926015099998
						],
						[
							150.74910068500003,
							-29.569419902999982
						],
						[
							150.80407162300003,
							-29.52974343799997
						],
						[
							150.8567904990001,
							-29.51250618199998
						],
						[
							150.86363403500002,
							-29.456504312999982
						],
						[
							150.88343572200006,
							-29.45916617399996
						],
						[
							150.8904162760001,
							-29.41713737499998
						],
						[
							150.85166080200008,
							-29.407864650999954
						],
						[
							150.85027092100006,
							-29.41470260099993
						],
						[
							150.82793526400008,
							-29.411848748999944
						],
						[
							150.8301880460001,
							-29.396508808999954
						],
						[
							150.81738398900006,
							-29.377928977999943
						],
						[
							150.8228108500001,
							-29.37156196799998
						],
						[
							150.79892999700007,
							-29.33629317599997
						],
						[
							150.805530846,
							-29.335288145999982
						],
						[
							150.79650796800001,
							-29.32752521499998
						],
						[
							150.80186383800003,
							-29.32150516599995
						],
						[
							150.7754901830001,
							-29.307785342999978
						],
						[
							150.77393510500008,
							-29.289721362999956
						],
						[
							150.7589882090001,
							-29.276349451999977
						],
						[
							150.76391909900008,
							-29.26918540199995
						],
						[
							150.75435026000002,
							-29.270016460999955
						],
						[
							150.75761818000012,
							-29.263137450999977
						],
						[
							150.7497772910001,
							-29.26202048099998
						],
						[
							150.76381552600003,
							-29.20849648199993
						],
						[
							150.7549027670001,
							-29.205930440999964
						],
						[
							150.75757763900003,
							-29.19069345099996
						],
						[
							150.74899485000003,
							-29.19049340999993
						],
						[
							150.75250071100004,
							-29.17438244999994
						],
						[
							150.74510785300004,
							-29.164948478999975
						],
						[
							150.7522835740001,
							-29.15095748999994
						],
						[
							150.74380075600004,
							-29.14198450899994
						],
						[
							150.7491265870001,
							-29.13474746999998
						],
						[
							150.73176390000003,
							-29.12581453799993
						],
						[
							150.72230693400002,
							-29.09657055699995
						],
						[
							150.7035912760001,
							-29.09980666499996
						],
						[
							150.70493118700006,
							-29.08670465499995
						],
						[
							150.69541038800003,
							-29.08845069399996
						],
						[
							150.68729943100004,
							-29.072048722999966
						],
						[
							150.68127861100004,
							-29.079614762999938
						],
						[
							150.66888076300006,
							-29.074304841999947
						],
						[
							150.6673906950001,
							-29.058020901999953
						],
						[
							150.65474592700002,
							-29.056837989999963
						],
						[
							150.6343601320001,
							-29.037329177999936
						],
						[
							150.63300405300004,
							-29.023395147999963
						],
						[
							150.6262262240001,
							-29.02427920799994
						],
						[
							150.63053606500011,
							-29.01387615799996
						],
						[
							150.61155836900002,
							-29.00001325599993
						],
						[
							150.63114212300002,
							-28.942183236999938
						],
						[
							150.61549712700003,
							-28.924855225999977
						],
						[
							150.61196112200003,
							-28.887332234999974
						],
						[
							150.63926914400008,
							-28.845325226999933
						],
						[
							150.63428814600002,
							-28.832221236999942
						],
						[
							150.64520014700008,
							-28.813972227999955
						],
						[
							150.6720311460001,
							-28.79389122999993
						],
						[
							150.6652731380001,
							-28.782152228999962
						],
						[
							150.67269013200007,
							-28.741383239999948
						],
						[
							150.66294616300002,
							-28.74023122899996
						],
						[
							150.6643511540001,
							-28.734540238999955
						],
						[
							150.65179015400008,
							-28.740203227999928
						],
						[
							150.6323051480001,
							-28.72917822599993
						],
						[
							150.60507115100006,
							-28.72842822299998
						],
						[
							150.59893115300008,
							-28.716790222999975
						],
						[
							150.5762611570001,
							-28.70599121099997
						],
						[
							150.5543201690001,
							-28.708837208999967
						],
						[
							150.5436351620001,
							-28.700822217999928
						],
						[
							150.53871715100001,
							-28.707623226999942
						],
						[
							150.5205601570001,
							-28.67937322499995
						],
						[
							150.51243817700004,
							-28.68408922499998
						],
						[
							150.4804211820001,
							-28.675397221999958
						],
						[
							150.48383809300003,
							-28.66224669199994
						],
						[
							150.45893167500003,
							-28.668947209999942
						],
						[
							150.4246331810001,
							-28.650613205999946
						],
						[
							150.41438618200004,
							-28.65198470599995
						],
						[
							150.41531668400012,
							-28.63460820499995
						],
						[
							150.401611687,
							-28.62716370399994
						],
						[
							150.3875236870001,
							-28.63379420299998
						],
						[
							150.38670068800002,
							-28.626021202999937
						],
						[
							150.37015169100005,
							-28.621123200999932
						],
						[
							150.363311693,
							-28.60736770099993
						],
						[
							150.36823469400008,
							-28.598262700999953
						],
						[
							150.35153269700004,
							-28.586731698999984
						],
						[
							150.3505811980001,
							-28.575043198999936
						],
						[
							150.32787870200002,
							-28.571096196999974
						],
						[
							150.32016270400004,
							-28.556942695999965
						],
						[
							150.29136571000004,
							-28.537286193999932
						],
						[
							150.23562721400003,
							-28.553912688999958
						],
						[
							150.23858271300003,
							-28.559962688999974
						],
						[
							150.22994421500005,
							-28.55572168799995
						],
						[
							150.22845921300006,
							-28.56774768799994
						],
						[
							150.21373421500004,
							-28.56722168699997
						],
						[
							150.21259271400004,
							-28.57428568699993
						],
						[
							150.19182321800008,
							-28.566648184999963
						],
						[
							150.18638821800005,
							-28.573003683999957
						],
						[
							150.181085219,
							-28.569131183999957
						],
						[
							150.1858497190001,
							-28.565095183999972
						],
						[
							150.17731672000002,
							-28.563368683999954
						],
						[
							150.18257872000004,
							-28.55645868399995
						],
						[
							150.17049372100007,
							-28.563498682999978
						],
						[
							150.1686582220001,
							-28.55058218299996
						],
						[
							150.15426522300004,
							-28.55739318199994
						],
						[
							150.152537724,
							-28.550182680999967
						],
						[
							150.1384712240001,
							-28.565437179999947
						],
						[
							150.12158472700003,
							-28.55963067899995
						],
						[
							150.11115022700005,
							-28.570331177999947
						],
						[
							150.09221623000008,
							-28.564046175999977
						],
						[
							150.09277022800006,
							-28.578414675999966
						],
						[
							150.08089622900002,
							-28.57744567499998
						],
						[
							150.0800492290001,
							-28.58426717499998
						],
						[
							150.07263573000012,
							-28.57662867399995
						],
						[
							150.05810523200012,
							-28.57897017299996
						],
						[
							150.0488382320001,
							-28.589431671999932
						],
						[
							150.04569223300007,
							-28.582286171999954
						],
						[
							150.01536873700002,
							-28.580534168999975
						],
						[
							149.97725573700006,
							-28.613551665999978
						],
						[
							149.95092074100012,
							-28.608315663999974
						],
						[
							149.94209924100005,
							-28.61837466299994
						],
						[
							149.93606524200004,
							-28.610376162999955
						],
						[
							149.91733774500005,
							-28.608130160999963
						],
						[
							149.8996512450001,
							-28.62218865899996
						],
						[
							149.8895532470001,
							-28.61891565899998
						],
						[
							149.89050574700002,
							-28.612678158999984
						],
						[
							149.87748874900012,
							-28.611974656999962
						],
						[
							149.87412475000008,
							-28.603503156999977
						],
						[
							149.8679652510001,
							-28.607486156999983
						],
						[
							149.8621327520001,
							-28.602402155999982
						],
						[
							149.84494475300005,
							-28.61057665499993
						],
						[
							149.83141225500003,
							-28.60379665299996
						],
						[
							149.81938225500005,
							-28.61681465199996
						],
						[
							149.8116757570001,
							-28.606055151999954
						],
						[
							149.78376376000006,
							-28.61441464899997
						],
						[
							149.7724857610001,
							-28.609240647999968
						],
						[
							149.77258976100006,
							-28.61450464799998
						],
						[
							149.75988826200012,
							-28.61547064699994
						],
						[
							149.7546897630001,
							-28.609843146999935
						],
						[
							149.744995764,
							-28.618709645999957
						],
						[
							149.72119376700005,
							-28.609412143999975
						],
						[
							149.7040352690001,
							-28.61665714199995
						],
						[
							149.71021526700008,
							-28.62036464299996
						],
						[
							149.70397126700004,
							-28.63390014199996
						],
						[
							149.69112676800012,
							-28.634307140999965
						],
						[
							149.68947176900008,
							-28.628378140999928
						],
						[
							149.67845876900003,
							-28.635021139999935
						],
						[
							149.6667362710001,
							-28.63211863899994
						],
						[
							149.6732027710001,
							-28.623910139999964
						],
						[
							149.66179827400003,
							-28.61042163899998
						],
						[
							149.65632977400003,
							-28.615914637999936
						],
						[
							149.64756677600008,
							-28.612282636999964
						],
						[
							149.64209427800006,
							-28.599186136999947
						],
						[
							149.62545078000005,
							-28.59354263499995
						],
						[
							149.61096928100005,
							-28.60107713399998
						],
						[
							149.60597878300007,
							-28.587735633999955
						],
						[
							149.5977452840001,
							-28.588874632999932
						],
						[
							149.59833428500008,
							-28.57983563299996
						],
						[
							149.58724778700002,
							-28.573364131999938
						],
						[
							149.56837178900003,
							-28.571578629999976
						],
						[
							149.55285929000001,
							-28.58090012899993
						],
						[
							149.52945229400007,
							-28.574387626999965
						],
						[
							149.5137642940001,
							-28.581922624999947
						],
						[
							149.50365679700008,
							-28.574273124999934
						],
						[
							149.50285779600006,
							-28.580711624999935
						],
						[
							149.48121529800005,
							-28.582709122999972
						],
						[
							149.47535929800006,
							-28.59376162199993
						],
						[
							149.45249080000008,
							-28.59484261999995
						],
						[
							149.45181879900008,
							-28.604200119999973
						],
						[
							149.43903880000005,
							-28.61164661899994
						],
						[
							149.44310679800003,
							-28.620196119999946
						],
						[
							149.42818979900005,
							-28.629405617999964
						],
						[
							149.42853229700006,
							-28.64691211899998
						],
						[
							149.41682179800011,
							-28.651319117999947
						],
						[
							149.42335629700005,
							-28.655110117999982
						],
						[
							149.417066298,
							-28.65465061799995
						],
						[
							149.40538629700006,
							-28.675392116999944
						],
						[
							149.39382729800002,
							-28.67747661599998
						],
						[
							149.38749779700004,
							-28.696159114999944
						],
						[
							149.358581801,
							-28.684053112999948
						],
						[
							149.34660680100012,
							-28.696815111999967
						],
						[
							149.33062730300003,
							-28.697334110999975
						],
						[
							149.31842580300008,
							-28.71388510999998
						],
						[
							149.29675630600002,
							-28.70973510799996
						],
						[
							149.28572330400004,
							-28.731866606999972
						],
						[
							149.2718908060001,
							-28.73322260599997
						],
						[
							149.26932530500005,
							-28.74324910599995
						],
						[
							149.26209380700004,
							-28.734111604999953
						],
						[
							149.2535823070001,
							-28.742227103999937
						],
						[
							149.24535330800006,
							-28.738946603999977
						],
						[
							149.2246253080001,
							-28.76464360199998
						],
						[
							149.188625311,
							-28.775100598999984
						],
						[
							149.19238081000003,
							-28.78072859899993
						],
						[
							149.179199809,
							-28.80301759799994
						],
						[
							149.16002431100003,
							-28.81084059699998
						],
						[
							149.13957381300008,
							-28.806721094999943
						],
						[
							149.14352531100008,
							-28.82232709599998
						],
						[
							149.12787981200006,
							-28.83552209399994
						],
						[
							149.11191531400004,
							-28.830008592999945
						],
						[
							149.10323031400003,
							-28.83857659199998
						],
						[
							149.09678681600008,
							-28.83154959199993
						],
						[
							149.0805353170001,
							-28.84198558999998
						],
						[
							149.08004481500006,
							-28.858159589999957
						],
						[
							149.05502681500002,
							-28.884371588999954
						],
						[
							149.06403781300003,
							-28.889100588999952
						],
						[
							149.05766881400007,
							-28.89362258899996
						],
						[
							149.0584318120001,
							-28.910959588999958
						],
						[
							149.04499431200009,
							-28.92054358799993
						],
						[
							149.04562981100003,
							-28.934567087999937
						],
						[
							149.03188481000007,
							-28.95658558699995
						],
						[
							149.0116263120001,
							-28.955466084999955
						],
						[
							148.99713130200007,
							-28.972739083999954
						],
						[
							148.97172331500008,
							-28.978277581999976
						],
						[
							148.95809518400006,
							-28.999051080999948
						],
						[
							147.94549673500012,
							-28.999134897999966
						],
						[
							146.94501658500008,
							-28.999119419999943
						],
						[
							145.9164726790001,
							-28.999063843999977
						],
						[
							144.92550629900006,
							-28.99907927499993
						],
						[
							143.94811041900005,
							-28.99916670999994
						],
						[
							143.00086103500007,
							-28.998892651999938
						],
						[
							141.9999976590001,
							-28.999024593999934
						],
						[
							140.9992722830001,
							-28.999086879999936
						],
						[
							141.00033710200012,
							-30.050610947999928
						],
						[
							141.00060143300004,
							-31.199954385999945
						],
						[
							141.00153704100012,
							-32.21805605299994
						],
						[
							141.00241215000005,
							-33.329009550999956
						],
						[
							141.26399868900012,
							-33.35574174399994
						],
						[
							141.26663249000012,
							-33.33722763399993
						],
						[
							141.3087280840001,
							-33.341389136999965
						],
						[
							141.30584728300005,
							-33.36244024699994
						],
						[
							141.34800977600003,
							-33.36664475899994
						],
						[
							141.40258693600003,
							-32.98764657899994
						],
						[
							141.57321094000008,
							-33.00555819899995
						],
						[
							141.560780055,
							-33.096279608999964
						],
						[
							142.03836219100003,
							-33.143927144999964
						],
						[
							142.02293991800002,
							-33.08478704399994
						],
						[
							142.10780857500004,
							-33.09011752899994
						],
						[
							142.1056859240001,
							-33.11240662899996
						],
						[
							142.22449380600005,
							-33.12002164599994
						],
						[
							142.2214678050001,
							-33.128853634999984
						],
						[
							142.24283403200002,
							-33.13085966699998
						],
						[
							142.244610813,
							-33.11944362699995
						],
						[
							142.27528379800003,
							-33.12381563799994
						],
						[
							142.2740807990001,
							-33.11257163799996
						],
						[
							142.29338681600007,
							-33.11658363899994
						],
						[
							142.29478779600004,
							-33.10908564899995
						],
						[
							142.28703478700004,
							-33.10739363899995
						],
						[
							142.30194580600005,
							-33.09222962999996
						],
						[
							142.28747479900005,
							-33.08487463899996
						],
						[
							142.31157381700007,
							-33.06684163999995
						],
						[
							142.3133558180001,
							-33.05012464999993
						],
						[
							142.35735079300002,
							-33.03456164299996
						],
						[
							142.38287878200003,
							-33.00493165399996
						],
						[
							142.38469181200003,
							-32.999883643999965
						],
						[
							142.37210679400005,
							-32.99594265299993
						],
						[
							142.37648209500003,
							-32.973662212999955
						],
						[
							142.42801738700007,
							-32.97901368599997
						],
						[
							142.42447578600002,
							-33.00521285599996
						],
						[
							142.54799402600008,
							-33.01712697299996
						],
						[
							142.55192365800008,
							-32.991603762999944
						],
						[
							142.51554255500002,
							-32.847440379999966
						],
						[
							142.9443567190001,
							-32.890519505999976
						],
						[
							142.96464484800003,
							-32.74852364599997
						],
						[
							143.27121885100007,
							-32.780215734999956
						],
						[
							143.26962103100004,
							-32.79137380499998
						],
						[
							143.4324418760001,
							-32.808432334999964
						],
						[
							143.41697521900005,
							-32.90748000499997
						],
						[
							143.4995721460001,
							-32.918335249999984
						],
						[
							143.505858589,
							-32.875990989999934
						],
						[
							143.59199346600008,
							-32.88512722499996
						],
						[
							143.58516003300008,
							-32.931016504999945
						],
						[
							143.67181387000005,
							-32.94075075099994
						],
						[
							143.66154416000006,
							-32.95528490999993
						],
						[
							143.65341991600008,
							-33.012399269999946
						],
						[
							143.60280558400007,
							-33.007090726999934
						],
						[
							143.5728171180001,
							-33.012416024999936
						],
						[
							143.5524661390001,
							-33.14046779499995
						],
						[
							143.63729460600007,
							-33.14990271999994
						],
						[
							143.6361136060001,
							-33.157774709999956
						],
						[
							143.6484818140001,
							-33.15899702099995
						],
						[
							143.66648878900003,
							-33.179079901999955
						],
						[
							143.71480774400004,
							-33.15459737499998
						],
						[
							143.72095744500007,
							-33.14043925499993
						],
						[
							143.78988275400002,
							-33.148852499999975
						],
						[
							143.81666916100005,
							-33.13743225099995
						],
						[
							143.8390290860001,
							-33.15457711299996
						],
						[
							143.89819857700002,
							-33.16137873699995
						],
						[
							143.90591343000006,
							-33.11569438699996
						],
						[
							144.2514328960001,
							-33.15505645899998
						],
						[
							144.23626130000002,
							-33.24981600899997
						],
						[
							144.277784493,
							-33.25420277199993
						],
						[
							144.26427409400003,
							-33.26300181099998
						],
						[
							144.26264725400006,
							-33.272892870999954
						],
						[
							144.41416916000003,
							-33.28647762099996
						],
						[
							144.41620805000002,
							-33.27905856099994
						],
						[
							144.4334958380001,
							-33.28046841199995
						],
						[
							144.43358486700004,
							-33.28766245199995
						],
						[
							144.4717083810001,
							-33.29119014499997
						],
						[
							144.47179948000007,
							-33.29895718499995
						],
						[
							144.48868225800004,
							-33.300450025999965
						],
						[
							144.49109808800006,
							-33.29296196599995
						],
						[
							144.54695343900005,
							-33.299997779999956
						],
						[
							144.5492394700001,
							-33.285506779999935
						],
						[
							144.57753572600006,
							-33.28865321199993
						],
						[
							144.58018639800002,
							-33.26836407199994
						],
						[
							144.5956741450001,
							-33.27002497299998
						],
						[
							144.59801744600009,
							-33.25507378299994
						],
						[
							144.60942844400006,
							-33.25632779399996
						],
						[
							144.61222649600006,
							-33.23779068399995
						],
						[
							144.64265406100003,
							-33.241108415999975
						],
						[
							144.64568772200005,
							-33.222338295999975
						],
						[
							144.733430429,
							-33.23138456199996
						],
						[
							144.74731944300004,
							-33.16178279199994
						],
						[
							144.7571974430001,
							-33.15235880299997
						],
						[
							144.76241245100005,
							-33.163216802999955
						],
						[
							144.77226544000007,
							-33.157388803999936
						],
						[
							144.77798042900008,
							-33.16344779399998
						],
						[
							144.79824183800008,
							-33.03620614499994
						],
						[
							144.9130841100001,
							-33.04911826299997
						],
						[
							144.90887153800008,
							-33.07443440299994
						],
						[
							144.96278672900007,
							-33.08727606599996
						],
						[
							144.96350666000012,
							-33.081978025999945
						],
						[
							144.97940842700007,
							-33.083777907999945
						],
						[
							144.9859181270001,
							-33.07051483799995
						],
						[
							144.98488653200002,
							-33.02154958699998
						],
						[
							144.99356138100006,
							-33.02250855799997
						],
						[
							144.99173751000012,
							-33.03364862799998
						],
						[
							145.00798117800002,
							-33.035529578999956
						],
						[
							145.01027242800012,
							-33.024435808999954
						],
						[
							145.027704426,
							-33.021909799999946
						],
						[
							145.10756239300008,
							-33.03369882599998
						],
						[
							145.11883941000008,
							-32.95369481599994
						],
						[
							145.1272603980001,
							-32.95467281699996
						],
						[
							145.16499973600003,
							-32.714817247999974
						],
						[
							145.24938053300002,
							-32.72437988399997
						],
						[
							145.25728588700008,
							-32.67124056399996
						],
						[
							145.34428442400008,
							-32.68247281999993
						],
						[
							145.3305693970001,
							-32.76666082999998
						],
						[
							145.41263740500005,
							-32.775935824999976
						],
						[
							145.4149502360001,
							-32.76139848499997
						],
						[
							145.46746854200012,
							-32.72249389899997
						],
						[
							145.51044283600004,
							-32.72784880199998
						],
						[
							145.50435449200006,
							-32.77007908199994
						],
						[
							145.54486579600007,
							-32.775358954999945
						],
						[
							145.53793802600012,
							-32.78324202399995
						],
						[
							145.5508278840001,
							-32.791602024999975
						],
						[
							145.56910504400003,
							-32.757861745999946
						],
						[
							145.54889656700004,
							-32.76518285499998
						],
						[
							145.55664299900002,
							-32.733270654999956
						],
						[
							145.59572927300007,
							-32.737755497999956
						],
						[
							145.58652122800004,
							-32.79622286799997
						],
						[
							145.67192939500012,
							-32.805708583999944
						],
						[
							145.6517933550001,
							-32.935337852999965
						],
						[
							145.66853531200002,
							-32.93585785399995
						],
						[
							145.645263891,
							-33.08029877399997
						],
						[
							145.87087652800005,
							-33.08629744999996
						],
						[
							145.8726453490001,
							-33.07478639999994
						],
						[
							145.90683172400009,
							-33.078610251999976
						],
						[
							145.9053368330001,
							-33.087735291999934
						],
						[
							146.03166582400002,
							-33.093565411999975
						],
						[
							146.09363737600006,
							-33.18907021699994
						],
						[
							146.05889827800002,
							-33.211794563999945
						],
						[
							146.09517525600006,
							-33.27835787799995
						],
						[
							146.09145323500002,
							-33.29148788699996
						],
						[
							146.08361924700012,
							-33.29047587699995
						],
						[
							146.08910625500005,
							-33.30361589699993
						],
						[
							146.08113023600004,
							-33.303996876999975
						],
						[
							146.09077922300003,
							-33.319042896999974
						],
						[
							146.08610324200004,
							-33.337396886999954
						],
						[
							146.07577122300006,
							-33.339043886999946
						],
						[
							146.0669832320001,
							-33.356815875999985
						],
						[
							146.05396863200008,
							-33.47575424599995
						],
						[
							146.09514737300003,
							-33.60311810999997
						],
						[
							146.44081375100006,
							-33.52084497499993
						],
						[
							146.44562915500012,
							-33.563861954999936
						],
						[
							146.80888585800005,
							-33.60713801299994
						],
						[
							146.8214616130001,
							-33.53757681299993
						],
						[
							146.81429556500007,
							-33.53008693299995
						],
						[
							146.82041566500004,
							-33.52815990299996
						],
						[
							146.82981153200012,
							-33.53796668399997
						],
						[
							146.8307734130001,
							-33.532413703999964
						],
						[
							146.9884814180001,
							-33.551946605999944
						],
						[
							146.98643683700004,
							-33.56382060599998
						],
						[
							147.24278392600002,
							-33.59180344599997
						],
						[
							147.24588350800002,
							-33.57190038599998
						],
						[
							147.27613711300012,
							-33.57517513799996
						],
						[
							147.27812085400012,
							-33.562794087999976
						],
						[
							147.32036623800002,
							-33.567787721999935
						],
						[
							147.32241395900007,
							-33.554798681999955
						],
						[
							147.33894093600009,
							-33.55673552299993
						],
						[
							147.34275555800002,
							-33.535177432999944
						],
						[
							147.35835711700008,
							-33.525329703999944
						],
						[
							147.40348925000012,
							-33.52742902799997
						],
						[
							147.4260940370001,
							-33.43449098899998
						],
						[
							147.48041303800005,
							-33.44172099299993
						],
						[
							147.5146830430001,
							-33.263333984999974
						],
						[
							147.48232597900005,
							-33.258226871999966
						],
						[
							147.48553972900004,
							-33.246605821999935
						],
						[
							147.47194392200004,
							-33.24450295099996
						],
						[
							147.46482679500002,
							-33.22740696099993
						],
						[
							147.4439731770001,
							-33.23152017899997
						],
						[
							147.44341903800012,
							-33.22291917899997
						],
						[
							147.4208675110001,
							-33.22820236699994
						],
						[
							147.37882291800008,
							-33.21554973399998
						],
						[
							147.35722342000008,
							-33.224438961999965
						],
						[
							147.34190755400004,
							-33.21235510099996
						],
						[
							147.308800119,
							-33.20704942799995
						],
						[
							147.31438688900005,
							-33.19907732899998
						],
						[
							147.29794593200006,
							-33.19182734699996
						],
						[
							147.30615858200008,
							-33.18027039799995
						],
						[
							147.29682257500008,
							-33.17162752699994
						],
						[
							147.30808145100002,
							-33.10437142799998
						],
						[
							147.31742051800006,
							-33.117339337999965
						],
						[
							147.33049109700005,
							-33.11005316899997
						],
						[
							147.3423600850001,
							-33.11426801999994
						],
						[
							147.34073729400006,
							-33.12332302999994
						],
						[
							147.3543090920001,
							-33.12052187099994
						],
						[
							147.3691990090001,
							-33.131823732999976
						],
						[
							147.3853236870001,
							-33.130048563999935
						],
						[
							147.3809937970001,
							-33.13653860299996
						],
						[
							147.3885397350001,
							-33.13940351399998
						],
						[
							147.40530379400002,
							-33.037483374999965
						],
						[
							147.55498121200003,
							-33.04818355699996
						],
						[
							147.55917087400007,
							-33.02201902699994
						],
						[
							147.54302560600001,
							-33.02013811499995
						],
						[
							147.5466191480001,
							-32.99843002499995
						],
						[
							147.55690003200004,
							-32.94819598599997
						],
						[
							147.57105561000003,
							-32.949700976999964
						],
						[
							147.60426306600004,
							-32.76268199799995
						],
						[
							147.5984001500001,
							-32.73861158799997
						],
						[
							147.5683703640001,
							-32.735368394999966
						],
						[
							147.57764126000006,
							-32.67562521599996
						],
						[
							147.5537125930001,
							-32.67297140399995
						],
						[
							147.55687630800003,
							-32.629316253999946
						],
						[
							147.58153205700012,
							-32.60455104499994
						],
						[
							147.55060721200005,
							-32.59723727299996
						],
						[
							147.56176180500006,
							-32.553752163999945
						],
						[
							147.5452709980001,
							-32.55131925199993
						],
						[
							147.560871216,
							-32.455905282999936
						],
						[
							147.58952674400007,
							-32.43835399499994
						],
						[
							147.61151543100004,
							-32.44116584699998
						],
						[
							147.61230427200007,
							-32.42329087699994
						],
						[
							147.6965091070001,
							-32.369205002999934
						],
						[
							147.7196740810001,
							-32.39615101499993
						],
						[
							147.7491120950001,
							-32.409687996999935
						],
						[
							147.76288011300005,
							-32.40740200799996
						],
						[
							147.7720970900001,
							-32.423210008999945
						],
						[
							147.8205760940001,
							-32.41945501299995
						],
						[
							147.8568020770001,
							-32.43717201599998
						],
						[
							147.88452908300007,
							-32.44030800799993
						],
						[
							147.90508106100003,
							-32.43197601999998
						],
						[
							147.89958106000006,
							-32.452009019999934
						],
						[
							147.90529107800012,
							-32.46057301999997
						],
						[
							147.92487704400003,
							-32.46980402199995
						],
						[
							147.93640706000008,
							-32.490964032999955
						],
						[
							147.96538904500005,
							-32.49898901499995
						],
						[
							147.96405405300004,
							-32.518836024999985
						],
						[
							147.99255003700011,
							-32.53876102799995
						],
						[
							148.0036990330001,
							-32.564179028999945
						],
						[
							148.01867206000009,
							-32.565018039999984
						],
						[
							148.021624029,
							-32.572190029999945
						],
						[
							148.0309120380001,
							-32.56882904099996
						],
						[
							148.06717704000005,
							-32.598605033999945
						],
						[
							148.09134503600012,
							-32.604510035999965
						],
						[
							148.0920770140001,
							-32.61676404599996
						],
						[
							148.10815701,
							-32.63518802799996
						],
						[
							148.1072730080001,
							-32.64982504799997
						],
						[
							148.13060902200004,
							-32.67605103999995
						],
						[
							148.12804202200005,
							-32.68278904999994
						],
						[
							148.24873071500008,
							-32.68162708999995
						],
						[
							148.2469457840001,
							-32.68989409899996
						],
						[
							148.26304549200006,
							-32.69209104099997
						],
						[
							148.26446644300006,
							-32.67823305099995
						],
						[
							148.3471489320001,
							-32.67574962799995
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "134",
				"CED_NAME21": "Parkes",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 393066.4821,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/134",
				"SHAPE_Leng": 41.6502010261,
				"SHAPE_Area": 37.1019587106
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							151.03113653900004,
							-33.768953059999944
						],
						[
							150.98716645100012,
							-33.79661930599997
						],
						[
							150.96688398600008,
							-33.781107943999984
						],
						[
							150.94758446900005,
							-33.78040729199995
						],
						[
							150.952392174,
							-33.811560922999945
						],
						[
							150.96953395100002,
							-33.81547002399998
						],
						[
							150.96950168900003,
							-33.832319663999954
						],
						[
							150.99213646500004,
							-33.83697429599994
						],
						[
							150.98917361400004,
							-33.84761381599998
						],
						[
							150.99647773300012,
							-33.851309706999984
						],
						[
							151.01338147,
							-33.85393639899996
						],
						[
							151.01835047100008,
							-33.83796630899997
						],
						[
							151.03008347000002,
							-33.83516529999997
						],
						[
							151.0511083780001,
							-33.82422551199994
						],
						[
							151.05507878100002,
							-33.79919656199996
						],
						[
							151.06637921000004,
							-33.79264551299997
						],
						[
							151.0476059570001,
							-33.76647620099993
						],
						[
							151.03113653900004,
							-33.768953059999944
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "135",
				"CED_NAME21": "Parramatta",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 56.7463,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/135",
				"SHAPE_Leng": 0.398178609998,
				"SHAPE_Area": 0.00552553628802
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								151.94453193800007,
								-32.675840377999975
							],
							[
								151.93617347100007,
								-32.66367037699996
							],
							[
								151.91339036400007,
								-32.65853564499997
							],
							[
								151.89624693700011,
								-32.65898685299993
							],
							[
								151.89488051500007,
								-32.66887636299998
							],
							[
								151.8295355260001,
								-32.65947036699998
							],
							[
								151.82835986400005,
								-32.67294232699993
							],
							[
								151.80984753500002,
								-32.68620935499996
							],
							[
								151.75563252300003,
								-32.67831236999996
							],
							[
								151.74761448800007,
								-32.721169359999976
							],
							[
								151.7340004980001,
								-32.736229357999946
							],
							[
								151.75218151400009,
								-32.749500369999964
							],
							[
								151.72947176600007,
								-32.76044198799997
							],
							[
								151.72419566000008,
								-32.73487692699996
							],
							[
								151.6873040160001,
								-32.72701244399997
							],
							[
								151.66906255600009,
								-32.741456151999955
							],
							[
								151.64130355300006,
								-32.71884735899994
							],
							[
								151.6252035450001,
								-32.72409334799994
							],
							[
								151.61464344700005,
								-32.71500434699993
							],
							[
								151.60049753900012,
								-32.715855345999955
							],
							[
								151.58349850900004,
								-32.736326333999955
							],
							[
								151.55708152300008,
								-32.732296351999935
							],
							[
								151.56603654700007,
								-32.68819033199998
							],
							[
								151.54381353100007,
								-32.68784933999996
							],
							[
								151.53814854300003,
								-32.67817932899993
							],
							[
								151.51436554400004,
								-32.693349326999964
							],
							[
								151.51037555800008,
								-32.662317336999934
							],
							[
								151.48931155500009,
								-32.635909323999954
							],
							[
								151.47619455300003,
								-32.660588322999956
							],
							[
								151.45009855700005,
								-32.65764934099997
							],
							[
								151.45406456500007,
								-32.66741133099998
							],
							[
								151.43823156700012,
								-32.669521319999944
							],
							[
								151.43150756500006,
								-32.69221632899996
							],
							[
								151.4081935600001,
								-32.68188333699993
							],
							[
								151.4030599130001,
								-32.66292608599997
							],
							[
								151.40051315800008,
								-32.70283223699994
							],
							[
								151.4234826720001,
								-32.72352781899997
							],
							[
								151.42003755000007,
								-32.74154933899996
							],
							[
								151.4320605680001,
								-32.743243329999984
							],
							[
								151.43429557700006,
								-32.75201531999994
							],
							[
								151.43150252600003,
								-32.764309329999946
							],
							[
								151.41637254800003,
								-32.76319433799995
							],
							[
								151.4093245370001,
								-32.77634331799993
							],
							[
								151.3961145290001,
								-32.77726332699996
							],
							[
								151.40272354500007,
								-32.80080932699997
							],
							[
								151.414373543,
								-32.80020531899993
							],
							[
								151.40755669100008,
								-32.82567328799996
							],
							[
								151.39706455200007,
								-32.82938733699996
							],
							[
								151.41917453000008,
								-32.823200328999974
							],
							[
								151.41586755900005,
								-32.83192732899994
							],
							[
								151.4355785360001,
								-32.834700330999965
							],
							[
								151.4309496840001,
								-32.85430573999997
							],
							[
								151.44262154400008,
								-32.84278633099996
							],
							[
								151.4536025320001,
								-32.84448733299996
							],
							[
								151.4516405380001,
								-32.874021322999965
							],
							[
								151.47429853500012,
								-32.87819533499993
							],
							[
								151.4778575350001,
								-32.872265324999944
							],
							[
								151.4835415340001,
								-32.878350325999975
							],
							[
								151.49710551200008,
								-32.87642832699993
							],
							[
								151.49419252200005,
								-32.88118734699998
							],
							[
								151.50338355000008,
								-32.884986337999976
							],
							[
								151.53839445500012,
								-32.88640682099998
							],
							[
								151.54112031600005,
								-32.872262810999985
							],
							[
								151.55654002300003,
								-32.88163675299995
							],
							[
								151.5582449840001,
								-32.87277371299996
							],
							[
								151.60858350600006,
								-32.880138346999956
							],
							[
								151.61415603900002,
								-32.856813457999976
							],
							[
								151.63534651500004,
								-32.86023534999998
							],
							[
								151.67407352400005,
								-32.828626362999955
							],
							[
								151.69064320200005,
								-32.82786649499997
							],
							[
								151.68754063300003,
								-32.82165909499997
							],
							[
								151.7006164600001,
								-32.83132838599994
							],
							[
								151.72994639500007,
								-32.836544328999935
							],
							[
								151.74275786200008,
								-32.848383069999954
							],
							[
								151.76739031800003,
								-32.852319361999946
							],
							[
								151.7750722610001,
								-32.823798902999954
							],
							[
								151.7966498090001,
								-32.81911487499997
							],
							[
								151.8170605050001,
								-32.823930906999976
							],
							[
								151.81417959300006,
								-32.83949697699995
							],
							[
								151.79038312400007,
								-32.86038606499994
							],
							[
								151.79395683100006,
								-32.875700344999984
							],
							[
								151.81011563900006,
								-32.878207506999956
							],
							[
								151.8909384640001,
								-32.83582937399996
							],
							[
								152.00730545300007,
								-32.79572937499995
							],
							[
								152.07093443600002,
								-32.783439390999945
							],
							[
								152.1156074690001,
								-32.792863384999976
							],
							[
								152.11170347000007,
								-32.78796138499996
							],
							[
								152.1233094490001,
								-32.78478639599996
							],
							[
								152.11624144100006,
								-32.77789840499997
							],
							[
								152.121566421,
								-32.769230395999955
							],
							[
								152.17262046500002,
								-32.76164340099996
							],
							[
								152.1709864380001,
								-32.74442439999996
							],
							[
								152.1868554660001,
								-32.74111939199997
							],
							[
								152.18750645000011,
								-32.71154041199998
							],
							[
								152.1761654600001,
								-32.71982641099993
							],
							[
								152.16185147400006,
								-32.709591398999976
							],
							[
								152.13478746600003,
								-32.71966939699996
							],
							[
								152.10364847100004,
								-32.71621439399996
							],
							[
								152.10207646000003,
								-32.726858403999984
							],
							[
								152.09107846100005,
								-32.72816339299993
							],
							[
								152.06380847900004,
								-32.69845637999998
							],
							[
								152.05950246800012,
								-32.710290388999965
							],
							[
								152.0719464440001,
								-32.72670239099995
							],
							[
								152.06955036300008,
								-32.73596310099998
							],
							[
								152.06000360400003,
								-32.73586617999996
							],
							[
								152.05857342700006,
								-32.71614102899997
							],
							[
								152.05502759600006,
								-32.72726213899995
							],
							[
								152.04019436800002,
								-32.72966539799995
							],
							[
								152.02151334100006,
								-32.720367275999934
							],
							[
								151.99787247400002,
								-32.72742537399995
							],
							[
								151.98808949600004,
								-32.71920039299994
							],
							[
								151.98731444500004,
								-32.725742372999946
							],
							[
								151.94310247900012,
								-32.73922437799996
							],
							[
								151.93592351100006,
								-32.736213377999945
							],
							[
								151.9464334700001,
								-32.73393237899995
							],
							[
								151.943354472,
								-32.71799738799996
							],
							[
								151.969267499,
								-32.71479439099994
							],
							[
								151.9788644900001,
								-32.69663738199995
							],
							[
								151.97760848200005,
								-32.68765739099996
							],
							[
								151.96008848300005,
								-32.69741437999994
							],
							[
								151.9548774960001,
								-32.67732137899998
							],
							[
								151.94453193800007,
								-32.675840377999975
							]
						]
					],
					[
						[
							[
								152.19824445400002,
								-32.74635239299994
							],
							[
								152.20339146300012,
								-32.748524413999974
							],
							[
								152.20313928400003,
								-32.74234431399998
							],
							[
								152.19236747600007,
								-32.739821382999935
							],
							[
								152.18494443500003,
								-32.74970840199995
							],
							[
								152.19824445400002,
								-32.74635239299994
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "136",
				"CED_NAME21": "Paterson",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 1052.7896,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/136",
				"SHAPE_Leng": 3.42552454953,
				"SHAPE_Area": 0.10131683952
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							151.14207748900003,
							-33.87040781099995
						],
						[
							151.1497224190001,
							-33.86575728099996
						],
						[
							151.1452202900001,
							-33.86261232099997
						],
						[
							151.16613543800008,
							-33.855058302999964
						],
						[
							151.1540485810001,
							-33.84205732199996
						],
						[
							151.14443944200002,
							-33.843518280999945
						],
						[
							151.14953130100002,
							-33.846895340999936
						],
						[
							151.1422783910001,
							-33.85334530099993
						],
						[
							151.14206957200008,
							-33.84583227999997
						],
						[
							151.13306236300002,
							-33.84946430999997
						],
						[
							151.12698846500007,
							-33.844182298999954
						],
						[
							151.128402552,
							-33.86094830899998
						],
						[
							151.1190749430001,
							-33.86469798799993
						],
						[
							151.12179835400002,
							-33.85739033899995
						],
						[
							151.11378831500008,
							-33.85395826799993
						],
						[
							151.12105170600012,
							-33.84179306799996
						],
						[
							151.10414932900005,
							-33.834374286999946
						],
						[
							151.09965832900002,
							-33.84419633599998
						],
						[
							151.10222044900001,
							-33.83808930699996
						],
						[
							151.09360747000005,
							-33.83975132599994
						],
						[
							151.0989264310001,
							-33.831628285999955
						],
						[
							151.08985100200005,
							-33.83312704499997
						],
						[
							151.09244250300003,
							-33.82360631599994
						],
						[
							151.08323297300012,
							-33.827884274999974
						],
						[
							151.08200828200006,
							-33.83954576499997
						],
						[
							151.07527301400012,
							-33.83267507399995
						],
						[
							151.08401202400012,
							-33.82206641499994
						],
						[
							151.0511083780001,
							-33.82422551199994
						],
						[
							151.03008347000002,
							-33.83516529999997
						],
						[
							151.04362528700005,
							-33.843361320999975
						],
						[
							151.0370725570001,
							-33.851327270999946
						],
						[
							151.04228384500004,
							-33.86171663099998
						],
						[
							151.06118346100004,
							-33.86644330299998
						],
						[
							151.06877465800005,
							-33.88582612399995
						],
						[
							151.08113651500003,
							-33.89112214499994
						],
						[
							151.09419365400004,
							-33.88557737599996
						],
						[
							151.11750981000012,
							-33.88850287799994
						],
						[
							151.12769507100006,
							-33.87423047899995
						],
						[
							151.14207748900003,
							-33.87040781099995
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "137",
				"CED_NAME21": "Reid",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 49.2349,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/137",
				"SHAPE_Leng": 0.613259823831,
				"SHAPE_Area": 0.00479656043412
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							153.5511581400001,
							-28.910602059999974
						],
						[
							153.59008481000012,
							-28.877567512999974
						],
						[
							153.57291772200006,
							-28.876918521999983
						],
						[
							153.57075196100004,
							-28.88505750099995
						],
						[
							153.5265828470001,
							-28.873813506999966
						],
						[
							153.5462115260001,
							-28.86721254899993
						],
						[
							153.56410093300008,
							-28.873693610999965
						],
						[
							153.57679490200007,
							-28.86982552199993
						],
						[
							153.57106261600006,
							-28.84927853099998
						],
						[
							153.5634486470001,
							-28.84707046999995
						],
						[
							153.57487522600002,
							-28.840152300999932
						],
						[
							153.57704869200006,
							-28.868436471999928
						],
						[
							153.5920448600001,
							-28.87557947399995
						],
						[
							153.60882880200006,
							-28.843262524999943
						],
						[
							153.59581878300003,
							-28.775176512999963
						],
						[
							153.61887182700002,
							-28.722242514999948
						],
						[
							153.61765879300003,
							-28.67812950499996
						],
						[
							153.63873283600003,
							-28.63608951599997
						],
						[
							153.61801382800002,
							-28.641988513999934
						],
						[
							153.5906738430001,
							-28.624814520999962
						],
						[
							153.56850283000006,
							-28.589688508999927
						],
						[
							153.55346284000007,
							-28.531838506999975
						],
						[
							153.55382784800008,
							-28.464412505999974
						],
						[
							153.58071083900006,
							-28.362958507999963
						],
						[
							153.571401884,
							-28.32711750699997
						],
						[
							153.58630188200004,
							-28.258193507999977
						],
						[
							153.57003288600004,
							-28.243084495999938
						],
						[
							153.57143690100008,
							-28.199425515999962
						],
						[
							153.55647088700005,
							-28.17005450399995
						],
						[
							153.54864875700002,
							-28.175516483999957
						],
						[
							153.56520876100012,
							-28.20494153599998
						],
						[
							153.55310195800007,
							-28.23768847499997
						],
						[
							153.53734655900007,
							-28.240359282999975
						],
						[
							153.55269983900007,
							-28.234773463999943
						],
						[
							153.54171083000006,
							-28.234460532999947
						],
						[
							153.5617999210001,
							-28.207127524999976
						],
						[
							153.5544159640001,
							-28.192924543999936
						],
						[
							153.542882995,
							-28.19434051299993
						],
						[
							153.5379330070001,
							-28.183818522999957
						],
						[
							153.53518189600004,
							-28.19164447199995
						],
						[
							153.51674701800005,
							-28.19387150999995
						],
						[
							153.50976373600008,
							-28.21760353999997
						],
						[
							153.5201479440001,
							-28.221028480999962
						],
						[
							153.50534398500008,
							-28.224386469999956
						],
						[
							153.49304494700004,
							-28.21648851799995
						],
						[
							153.50055996700007,
							-28.21457646899995
						],
						[
							153.50009374800004,
							-28.205984538999928
						],
						[
							153.49375994900004,
							-28.207069487999945
						],
						[
							153.49908397900003,
							-28.200087458999974
						],
						[
							153.50828413800002,
							-28.19975121999994
						],
						[
							153.50795114900006,
							-28.194159239999976
						],
						[
							153.50697086800005,
							-28.20286250999993
						],
						[
							153.51224087700007,
							-28.200408489999973
						],
						[
							153.50878202900003,
							-28.190001519999953
						],
						[
							153.52813487700007,
							-28.19078749199997
						],
						[
							153.54234337700007,
							-28.17809704299998
						],
						[
							153.54550646600012,
							-28.183382292999966
						],
						[
							153.5391214870001,
							-28.18331606299995
						],
						[
							153.54761587600012,
							-28.184004503999972
						],
						[
							153.54435974800003,
							-28.16969050299997
						],
						[
							153.55606087700005,
							-28.168577503999984
						],
						[
							153.55217713800005,
							-28.164395983999952
						],
						[
							153.5346548880001,
							-28.177630001999944
						],
						[
							153.4769523970001,
							-28.15687949599993
						],
						[
							153.4570553960001,
							-28.180504993999932
						],
						[
							153.43576239800007,
							-28.187159991999977
						],
						[
							153.4057193980001,
							-28.211009988999933
						],
						[
							153.3897293970001,
							-28.234818987999972
						],
						[
							153.36472889800007,
							-28.247341484999936
						],
						[
							153.33910990000004,
							-28.25053348299997
						],
						[
							153.3297714030001,
							-28.236861481999938
						],
						[
							153.304766405,
							-28.239682478999953
						],
						[
							153.29684115700002,
							-28.23426928799995
						],
						[
							153.2779439090001,
							-28.233839475999957
						],
						[
							153.24393091100012,
							-28.247286972999973
						],
						[
							153.23284391000004,
							-28.265062971999953
						],
						[
							153.18817241700003,
							-28.247498966999956
						],
						[
							153.17667241800007,
							-28.249590465999972
						],
						[
							153.17517741500012,
							-28.27419346599993
						],
						[
							153.16120891600008,
							-28.279388464999954
						],
						[
							153.1677419130001,
							-28.295463965999943
						],
						[
							153.1551514150001,
							-28.296108464999975
						],
						[
							153.14328741400004,
							-28.312190962999978
						],
						[
							153.12501041500002,
							-28.317751461999933
						],
						[
							153.13024591300007,
							-28.33026596199994
						],
						[
							153.1085534120001,
							-28.356314959999963
						],
						[
							153.11320721000004,
							-28.366519730999983
						],
						[
							153.10708034800007,
							-28.386939749999954
						],
						[
							153.11806502600007,
							-28.396443571999953
						],
						[
							153.1122785660001,
							-28.400589750999984
						],
						[
							153.12812847300006,
							-28.406383802999983
						],
						[
							153.1207327310001,
							-28.433251611999935
						],
						[
							153.14387547800004,
							-28.43875544499997
						],
						[
							153.1340547860001,
							-28.458859393999944
						],
						[
							153.14362464500005,
							-28.461867394999956
						],
						[
							153.14108556400004,
							-28.471441743999947
						],
						[
							153.15385461000005,
							-28.484603255999957
						],
						[
							153.15008189800005,
							-28.505627465999964
						],
						[
							153.16026287500006,
							-28.52412846699997
						],
						[
							153.20571788900008,
							-28.52652748099996
						],
						[
							153.2472328760001,
							-28.51580147599998
						],
						[
							153.25543737400005,
							-28.52713851599998
						],
						[
							153.28276087200004,
							-28.516015468999967
						],
						[
							153.2913968780001,
							-28.54156346999997
						],
						[
							153.32857585400006,
							-28.54084247399993
						],
						[
							153.3506648780001,
							-28.566666475999966
						],
						[
							153.3789538630001,
							-28.58221748899996
						],
						[
							153.3730932090001,
							-28.61396341899996
						],
						[
							153.4126328440001,
							-28.61855049299993
						],
						[
							153.41163785100002,
							-28.641031492999957
						],
						[
							153.43029383600003,
							-28.661465504999967
						],
						[
							153.42437131600002,
							-28.667204204999962
						],
						[
							153.4193360280001,
							-28.661739203999957
						],
						[
							153.4160428570001,
							-28.671384493999938
						],
						[
							153.42662785400012,
							-28.681004494999968
						],
						[
							153.42409785300003,
							-28.69336849499996
						],
						[
							153.4077528260001,
							-28.686137492999933
						],
						[
							153.4006408350001,
							-28.69874250299995
						],
						[
							153.41215581100005,
							-28.720579493999935
						],
						[
							153.40767481800003,
							-28.744166493999955
						],
						[
							153.42243782600008,
							-28.74505249499998
						],
						[
							153.42646683700002,
							-28.738375495999946
						],
						[
							153.4353178340001,
							-28.747615485999972
						],
						[
							153.44857050300004,
							-28.747998647999964
						],
						[
							153.44998284200005,
							-28.757280497999943
						],
						[
							153.4416268220001,
							-28.762968496999974
						],
						[
							153.44358581000006,
							-28.777460507999933
						],
						[
							153.45215184800009,
							-28.778657487999965
						],
						[
							153.43925982700011,
							-28.800395486999946
						],
						[
							153.4566018150001,
							-28.804338508999933
						],
						[
							153.4446762450001,
							-28.810902237999983
						],
						[
							153.43916882200006,
							-28.83566849799996
						],
						[
							153.44855549200008,
							-28.833108857999946
						],
						[
							153.448964111,
							-28.839594638999984
						],
						[
							153.47603487700007,
							-28.846067480999977
						],
						[
							153.48178665400008,
							-28.859891811999944
						],
						[
							153.48292279600003,
							-28.849366491999945
						],
						[
							153.49301978500012,
							-28.846476502999963
						],
						[
							153.5026748030001,
							-28.85409750399998
						],
						[
							153.50155283100003,
							-28.86776150399993
						],
						[
							153.49381380300008,
							-28.86396349299997
						],
						[
							153.48559280100005,
							-28.880147502999932
						],
						[
							153.47434383300003,
							-28.878588500999967
						],
						[
							153.46624779900003,
							-28.91146250099996
						],
						[
							153.47753479800008,
							-28.913208491999967
						],
						[
							153.4767768060001,
							-28.924883491999935
						],
						[
							153.49726012500003,
							-28.921015093999983
						],
						[
							153.52325174400005,
							-28.90164916699996
						],
						[
							153.5511581400001,
							-28.910602059999974
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "138",
				"CED_NAME21": "Richmond",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 2131.1404,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/138",
				"SHAPE_Leng": 3.95648809208,
				"SHAPE_Area": 0.19637309169
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							147.84539641900005,
							-35.55458598699994
						],
						[
							147.8473071200001,
							-35.54488393699995
						],
						[
							147.86217385800012,
							-35.546854887999984
						],
						[
							147.86333671800003,
							-35.54064684799994
						],
						[
							147.89268114300012,
							-35.54430471999996
						],
						[
							147.89097637200007,
							-35.55327076999998
						],
						[
							147.9298126960001,
							-35.55847965299995
						],
						[
							147.93144668600007,
							-35.55003804399996
						],
						[
							147.9078287110001,
							-35.53833304199998
						],
						[
							147.90711072200008,
							-35.530923050999945
						],
						[
							147.90802548300007,
							-35.526159561999975
						],
						[
							147.92560220000007,
							-35.52851050299995
						],
						[
							147.9279749210001,
							-35.51632246299994
						],
						[
							147.9047653450001,
							-35.51329658099996
						],
						[
							147.9075727070001,
							-35.490067040999975
						],
						[
							147.88382439100008,
							-35.48848465899994
						],
						[
							147.8859748640001,
							-35.46411160899993
						],
						[
							147.8730219670001,
							-35.457003647999954
						],
						[
							147.87279168800012,
							-35.44209549799996
						],
						[
							147.88936337600012,
							-35.444275448999974
						],
						[
							147.89321193700005,
							-35.42434922999996
						],
						[
							147.90765166500012,
							-35.42617116099996
						],
						[
							147.89412674000005,
							-35.40232003999995
						],
						[
							147.8993187220001,
							-35.37935503999995
						],
						[
							147.88914672400006,
							-35.37577103899997
						],
						[
							147.88429674700012,
							-35.35739204799995
						],
						[
							147.86635923000006,
							-35.357727316999956
						],
						[
							147.84554974600007,
							-35.32997404499997
						],
						[
							147.850347746,
							-35.32238502599995
						],
						[
							147.84272373900012,
							-35.30871103499993
						],
						[
							147.85585275000005,
							-35.27936803599994
						],
						[
							147.88428872600002,
							-35.277641037999956
						],
						[
							147.87957873800008,
							-35.26817503799998
						],
						[
							147.89915331800012,
							-35.24481082899996
						],
						[
							147.89664876000006,
							-35.231497048999984
						],
						[
							147.95862776100012,
							-35.22905477399996
						],
						[
							147.96105249200002,
							-35.21733486399995
						],
						[
							147.97778373000006,
							-35.20893804499997
						],
						[
							147.96173888500005,
							-35.18735059399995
						],
						[
							148.0592950780001,
							-35.200866701999985
						],
						[
							148.0825836460001,
							-35.19470949299995
						],
						[
							148.11200644000007,
							-35.203826395999954
						],
						[
							148.11979326900007,
							-35.20254931599993
						],
						[
							148.1221989500001,
							-35.18996817699997
						],
						[
							148.14954770500003,
							-35.19783505899994
						],
						[
							148.15776640500007,
							-35.186276738999936
						],
						[
							148.164411523,
							-35.193600739999965
						],
						[
							148.18384372100002,
							-35.18936206199993
						],
						[
							148.19157555100003,
							-35.17334931199997
						],
						[
							148.22364469800004,
							-35.16282701499995
						],
						[
							148.1998697780001,
							-35.11088673199998
						],
						[
							148.2837676040001,
							-35.11823346899996
						],
						[
							148.34189103200004,
							-35.14184952399995
						],
						[
							148.34759383200003,
							-35.13706753499997
						],
						[
							148.39682608400005,
							-35.13987701899998
						],
						[
							148.3946932030001,
							-35.15049637899995
						],
						[
							148.41369065000004,
							-35.15298905999998
						],
						[
							148.424165667,
							-35.16460708099993
						],
						[
							148.45683634300008,
							-35.15451110399994
						],
						[
							148.46923142000003,
							-35.08013027399994
						],
						[
							148.52472667100005,
							-35.08772408899995
						],
						[
							148.52394768700003,
							-35.12239608899995
						],
						[
							148.54182603200002,
							-35.13535317099996
						],
						[
							148.54830259200003,
							-35.13215791099998
						],
						[
							148.54503686400005,
							-35.11585621099994
						],
						[
							148.56702727300012,
							-35.09498249199993
						],
						[
							148.56475044500007,
							-35.08357732199994
						],
						[
							148.57330013500007,
							-35.07721056299994
						],
						[
							148.564627448,
							-35.05716598199996
						],
						[
							148.57551995900008,
							-35.041604922999966
						],
						[
							148.57218065200004,
							-35.018596971999955
						],
						[
							148.58310028200003,
							-35.00263192299997
						],
						[
							148.56086568500007,
							-35.005002100999945
						],
						[
							148.55869266800005,
							-34.987613100999965
						],
						[
							148.54235467900003,
							-34.99461808999996
						],
						[
							148.53212669100003,
							-34.99132807899997
						],
						[
							148.54305869400002,
							-34.95232108899995
						],
						[
							148.5360316880001,
							-34.92844507899997
						],
						[
							148.54998767900008,
							-34.91011609999998
						],
						[
							148.5349457000001,
							-34.91565708899998
						],
						[
							148.5222726840001,
							-34.901457096999934
						],
						[
							148.52787843600004,
							-34.87222548799997
						],
						[
							148.53921325500005,
							-34.87365444899996
						],
						[
							148.5452489260001,
							-34.855730318999974
						],
						[
							148.55865274300004,
							-34.859341289999975
						],
						[
							148.5634087090001,
							-34.80551809999997
						],
						[
							148.5815156960001,
							-34.80679310199997
						],
						[
							148.57148758200003,
							-34.772386780999966
						],
						[
							148.57440886900008,
							-34.708394339999984
						],
						[
							148.5632760410001,
							-34.70688837899996
						],
						[
							148.5721179100001,
							-34.70210516999998
						],
						[
							148.58671502700008,
							-34.627427850999936
						],
						[
							148.59965070500004,
							-34.62914709199998
						],
						[
							148.59505684700002,
							-34.61873076099994
						],
						[
							148.6264033320001,
							-34.62284464399994
						],
						[
							148.62913321300005,
							-34.61069856399996
						],
						[
							148.65958770800012,
							-34.614277096999956
						],
						[
							148.67039371900012,
							-34.58924409799994
						],
						[
							148.65940952100004,
							-34.58778423699994
						],
						[
							148.6613724220001,
							-34.57746318699998
						],
						[
							148.64664452600005,
							-34.56564221499997
						],
						[
							148.65364723800008,
							-34.54240610599993
						],
						[
							148.64580126900012,
							-34.53794812499996
						],
						[
							148.6436704680001,
							-34.54920217499995
						],
						[
							148.63068863,
							-34.547511233999955
						],
						[
							148.6283985130001,
							-34.53060220399993
						],
						[
							148.619596644,
							-34.529450262999944
						],
						[
							148.62535572700006,
							-34.50053209299995
						],
						[
							148.6125934690001,
							-34.498880251999935
						],
						[
							148.62153030900004,
							-34.48812216299996
						],
						[
							148.60954543100002,
							-34.48706924199996
						],
						[
							148.61475975300004,
							-34.466270091999945
						],
						[
							148.5805747280001,
							-34.46205134899998
						],
						[
							148.58029638200003,
							-34.43327720899998
						],
						[
							148.5677125740001,
							-34.431624247999935
						],
						[
							148.5624774570001,
							-34.41292222699997
						],
						[
							148.55362762800007,
							-34.41141629699996
						],
						[
							148.57591397900012,
							-34.376761097999974
						],
						[
							148.60988346700003,
							-34.35630385099995
						],
						[
							148.6221138200001,
							-34.31439377199996
						],
						[
							148.61242289200004,
							-34.311588780999955
						],
						[
							148.60880089400007,
							-34.29619078999997
						],
						[
							148.62123950400007,
							-34.279502710999964
						],
						[
							148.63801224200006,
							-34.28112165299996
						],
						[
							148.64682169800005,
							-34.21957250299994
						],
						[
							148.63721458400005,
							-34.182928371999935
						],
						[
							148.62135084600004,
							-34.18095342099997
						],
						[
							148.62323267700003,
							-34.170536400999936
						],
						[
							148.64332037400004,
							-34.17304835199997
						],
						[
							148.6502500040001,
							-34.15944234299997
						],
						[
							148.6362450680001,
							-34.14619136199997
						],
						[
							148.64495978000002,
							-34.12174209199998
						],
						[
							148.64070537200007,
							-34.10643534199994
						],
						[
							148.66143506900005,
							-34.10819429299994
						],
						[
							148.6613319600001,
							-34.098099282999954
						],
						[
							148.6700778290001,
							-34.09934725399995
						],
						[
							148.68690659800006,
							-34.08211706499998
						],
						[
							148.709256965,
							-34.08201516699995
						],
						[
							148.71818475500004,
							-34.073990107999975
						],
						[
							148.7309945720001,
							-34.07868621899996
						],
						[
							148.76314045200002,
							-34.03823795099993
						],
						[
							148.74372249700002,
							-34.020711019999965
						],
						[
							148.75273496900002,
							-33.99917702999994
						],
						[
							148.765328747,
							-34.00057500099996
						],
						[
							148.767369389,
							-33.981943040999965
						],
						[
							148.80400074300007,
							-33.98388497499997
						],
						[
							148.80793336500005,
							-33.96391502499995
						],
						[
							148.8215200830001,
							-33.96581898599993
						],
						[
							148.83175377400005,
							-33.94521211699998
						],
						[
							148.85058277000007,
							-33.95217510799995
						],
						[
							148.882411756,
							-33.94787612099998
						],
						[
							148.89001674600001,
							-33.938843100999975
						],
						[
							148.889850743,
							-33.96342011199994
						],
						[
							148.90458476900005,
							-33.97480611299994
						],
						[
							148.915357738,
							-33.97031111399997
						],
						[
							148.93446274400003,
							-33.98209211499994
						],
						[
							148.942212755,
							-33.96940211599997
						],
						[
							148.96750243100007,
							-33.969065727999975
						],
						[
							148.970192192,
							-33.956109777999984
						],
						[
							148.98096692100012,
							-33.94994173899994
						],
						[
							148.9811515440001,
							-33.92443179899993
						],
						[
							149.0218499870001,
							-33.93376568299993
						],
						[
							149.02509066900006,
							-33.91780775299998
						],
						[
							149.0360764080001,
							-33.91012371399995
						],
						[
							149.0519352560001,
							-33.91258166499995
						],
						[
							149.06510773600007,
							-33.89284912599993
						],
						[
							149.073555735,
							-33.89268012699995
						],
						[
							149.06971173500006,
							-33.89965112599998
						],
						[
							149.0820838510001,
							-33.91286756699998
						],
						[
							149.09539755000003,
							-33.90978953899997
						],
						[
							149.09829433000004,
							-33.89983255899995
						],
						[
							149.11984181900004,
							-33.887815520999936
						],
						[
							149.11817158100007,
							-33.87056357999995
						],
						[
							149.13472070900002,
							-33.86883713199995
						],
						[
							149.1456297300001,
							-33.850423131999946
						],
						[
							149.18189674300004,
							-33.85819213599996
						],
						[
							149.183917704,
							-33.85182314599996
						],
						[
							149.17028974700008,
							-33.841165124999975
						],
						[
							149.18335973500007,
							-33.83885714599995
						],
						[
							149.17737873800002,
							-33.82312213499995
						],
						[
							149.1851667400001,
							-33.79769314499998
						],
						[
							149.2030527270001,
							-33.801932146999945
						],
						[
							149.21942173600007,
							-33.79235113799996
						],
						[
							149.23401373800004,
							-33.76050512899997
						],
						[
							149.24284973700003,
							-33.759800129999974
						],
						[
							149.25774873700004,
							-33.740643140999964
						],
						[
							149.2376129700001,
							-33.73974440999996
						],
						[
							149.22505135300003,
							-33.72626166799995
						],
						[
							149.2148450840001,
							-33.73262222799997
						],
						[
							149.1691347520001,
							-33.72120313399995
						],
						[
							149.14600919400004,
							-33.73202350199995
						],
						[
							149.13337957400006,
							-33.748221600999955
						],
						[
							149.1387546320001,
							-33.75987762099993
						],
						[
							149.10820358600006,
							-33.76109817899993
						],
						[
							149.10556226500012,
							-33.768609727999944
						],
						[
							149.09145289800006,
							-33.76540217699994
						],
						[
							149.09160273400005,
							-33.793674806999945
						],
						[
							149.06718101800004,
							-33.79006983499994
						],
						[
							149.06459433600003,
							-33.81237286499993
						],
						[
							149.04128873000002,
							-33.80932086299998
						],
						[
							149.0261709030001,
							-33.80335587199994
						],
						[
							149.02901575300007,
							-33.79315711199996
						],
						[
							149.00771015600003,
							-33.79489246999998
						],
						[
							149.00988650700003,
							-33.78399994999995
						],
						[
							148.98892507100004,
							-33.78108293899993
						],
						[
							148.99049968100007,
							-33.77358497899996
						],
						[
							148.98195981300012,
							-33.77227499799994
						],
						[
							148.9848347740001,
							-33.75803212799997
						],
						[
							148.97561075600004,
							-33.75170911699996
						],
						[
							148.9929337630001,
							-33.75400511899994
						],
						[
							148.97602276600003,
							-33.749848106999934
						],
						[
							148.97839376700006,
							-33.73759311699996
						],
						[
							148.99366547700004,
							-33.72059590899994
						],
						[
							148.96262979300002,
							-33.70781111599996
						],
						[
							148.9578067960001,
							-33.68830711499993
						],
						[
							148.91167580400008,
							-33.68347412099996
						],
						[
							148.9073287970001,
							-33.658261110999945
						],
						[
							148.92246079200004,
							-33.59891411199993
						],
						[
							148.9108628150001,
							-33.594290110999964
						],
						[
							148.9089057960001,
							-33.58265211099996
						],
						[
							148.88359578000006,
							-33.58196910799995
						],
						[
							148.87410779000004,
							-33.594362117999935
						],
						[
							148.8725877930001,
							-33.57332411699997
						],
						[
							148.86318980300007,
							-33.57980610699997
						],
						[
							148.8469447860001,
							-33.57896409499995
						],
						[
							148.84471781700006,
							-33.568742104999956
						],
						[
							148.82756580900002,
							-33.574116093999976
						],
						[
							148.82582881000008,
							-33.56512410299996
						],
						[
							148.8150498220001,
							-33.56722710299994
						],
						[
							148.81943482200006,
							-33.55886011299998
						],
						[
							148.81040180500008,
							-33.546473101999936
						],
						[
							148.8038658150001,
							-33.55001611199998
						],
						[
							148.78731457000004,
							-33.52904141999994
						],
						[
							148.7614234140001,
							-33.52751664799996
						],
						[
							148.738300986,
							-33.53813275599998
						],
						[
							148.71203179600002,
							-33.57371480399996
						],
						[
							148.68281960800005,
							-33.58640182199997
						],
						[
							148.65254059400002,
							-33.57708877899995
						],
						[
							148.6583123040001,
							-33.56642614899994
						],
						[
							148.65178785600006,
							-33.56009280899997
						],
						[
							148.6298484780001,
							-33.570537886999944
						],
						[
							148.6226765560001,
							-33.59252191699994
						],
						[
							148.57497657300007,
							-33.592795972999966
						],
						[
							148.56742483300002,
							-33.60108900199998
						],
						[
							148.56278988400004,
							-33.59616700199996
						],
						[
							148.55728904400007,
							-33.603957040999944
						],
						[
							148.54567722600007,
							-33.60335700999997
						],
						[
							148.53406311000003,
							-33.582308928999964
						],
						[
							148.5182520840001,
							-33.57219190799998
						],
						[
							148.51411750300008,
							-33.58123292799996
						],
						[
							148.4834613380001,
							-33.58128567499995
						],
						[
							148.47891595600004,
							-33.60100008499995
						],
						[
							148.44567515900007,
							-33.61429505199993
						],
						[
							148.4365631920001,
							-33.60397101099994
						],
						[
							148.41545363500006,
							-33.606180019999954
						],
						[
							148.41800845500006,
							-33.59615797999993
						],
						[
							148.38846160200012,
							-33.57966493699996
						],
						[
							148.39046443300003,
							-33.56764089699993
						],
						[
							148.414476099,
							-33.56691387899997
						],
						[
							148.41671912800007,
							-33.57395085999997
						],
						[
							148.42359580800007,
							-33.56518969999996
						],
						[
							148.39125542500005,
							-33.546959296999944
						],
						[
							148.40018077500008,
							-33.53504304799998
						],
						[
							148.39277773800006,
							-33.51871407699997
						],
						[
							148.35925993400008,
							-33.51240903399997
						],
						[
							148.35048781700004,
							-33.49386002399996
						],
						[
							148.32323258100007,
							-33.49113959099998
						],
						[
							148.32492041000012,
							-33.497399660999974
						],
						[
							148.309797042,
							-33.50017802999997
						],
						[
							148.30797901300002,
							-33.49405802999996
						],
						[
							148.30114377400002,
							-33.49811664999993
						],
						[
							148.29065688600008,
							-33.49189605899994
						],
						[
							148.29839327800005,
							-33.467996908999964
						],
						[
							148.30544431600003,
							-33.46884054999998
						],
						[
							148.307152437,
							-33.461905059999935
						],
						[
							148.3161006350001,
							-33.466212920999965
						],
						[
							148.3081539970001,
							-33.45791769999994
						],
						[
							148.3185618970001,
							-33.44910206099996
						],
						[
							148.32932775500012,
							-33.45591539199995
						],
						[
							148.333065905,
							-33.44422206199994
						],
						[
							148.3499769020001,
							-33.45355607299996
						],
						[
							148.3499128730001,
							-33.44368406299998
						],
						[
							148.36161291100007,
							-33.44921804399996
						],
						[
							148.365226892,
							-33.43531607399996
						],
						[
							148.34434389500007,
							-33.429483052999956
						],
						[
							148.34594069600007,
							-33.42090035299998
						],
						[
							148.36772988300004,
							-33.42087606399997
						],
						[
							148.3679372040001,
							-33.410811283999976
						],
						[
							148.387393921,
							-33.413674535999974
						],
						[
							148.398228151,
							-33.40105867699998
						],
						[
							148.406674059,
							-33.40526961799998
						],
						[
							148.401207601,
							-33.396584806999954
						],
						[
							148.4126136000001,
							-33.394654257999946
						],
						[
							148.41822938000007,
							-33.38498693799994
						],
						[
							148.41474589200004,
							-33.37028405799998
						],
						[
							148.38427989900003,
							-33.35323706499997
						],
						[
							148.40308465900011,
							-33.32892175699993
						],
						[
							148.41566189700006,
							-33.32721006799994
						],
						[
							148.39715443600005,
							-33.26998018599994
						],
						[
							148.43099490600002,
							-33.23442307799996
						],
						[
							148.42913031000012,
							-33.20127579799998
						],
						[
							148.46668569400003,
							-33.208757770999966
						],
						[
							148.47545091400002,
							-33.196155071999954
						],
						[
							148.4959009920001,
							-33.19085562299995
						],
						[
							148.49304888300003,
							-33.179692572999954
						],
						[
							148.5055265530001,
							-33.16584450399995
						],
						[
							148.50433829700012,
							-33.13418642399995
						],
						[
							148.4865725510001,
							-33.123223431999975
						],
						[
							148.49966097200002,
							-33.09992231299998
						],
						[
							148.50726191600006,
							-33.055503072999954
						],
						[
							148.49304415100005,
							-33.030226701999936
						],
						[
							148.4810612440001,
							-33.01636369099998
						],
						[
							148.46334366700012,
							-33.01343076899997
						],
						[
							148.45506763000003,
							-32.99357971899997
						],
						[
							148.44585276200007,
							-32.99218372799993
						],
						[
							148.43017076700005,
							-32.96992860599994
						],
						[
							148.4186500180001,
							-32.973555644999976
						],
						[
							148.3993581620001,
							-32.95915158399998
						],
						[
							148.38963693200003,
							-32.974128072999974
						],
						[
							148.37218479500007,
							-32.971569761999945
						],
						[
							148.38183729800005,
							-32.93453755199994
						],
						[
							148.37251946900005,
							-32.92915858099997
						],
						[
							148.38126311000008,
							-32.91400940199998
						],
						[
							148.3830639570001,
							-32.850585071999944
						],
						[
							148.37578096900006,
							-32.845411060999936
						],
						[
							148.37834196000006,
							-32.83260207099994
						],
						[
							148.3454120670001,
							-32.81157411799995
						],
						[
							148.32938330900004,
							-32.81081816699998
						],
						[
							148.3275642210001,
							-32.80081012699998
						],
						[
							148.335336062,
							-32.78159504699994
						],
						[
							148.32951939200007,
							-32.70101180599994
						],
						[
							148.3349661430001,
							-32.67902070699995
						],
						[
							148.3471489320001,
							-32.67574962799995
						],
						[
							148.26446644300006,
							-32.67823305099995
						],
						[
							148.26304549200006,
							-32.69209104099997
						],
						[
							148.2469457840001,
							-32.68989409899996
						],
						[
							148.24873071500008,
							-32.68162708999995
						],
						[
							148.12804202200005,
							-32.68278904999994
						],
						[
							148.13060902200004,
							-32.67605103999995
						],
						[
							148.1072730080001,
							-32.64982504799997
						],
						[
							148.10815701,
							-32.63518802799996
						],
						[
							148.0920770140001,
							-32.61676404599996
						],
						[
							148.09134503600012,
							-32.604510035999965
						],
						[
							148.06717704000005,
							-32.598605033999945
						],
						[
							148.0309120380001,
							-32.56882904099996
						],
						[
							148.021624029,
							-32.572190029999945
						],
						[
							148.01867206000009,
							-32.565018039999984
						],
						[
							148.0036990330001,
							-32.564179028999945
						],
						[
							147.99255003700011,
							-32.53876102799995
						],
						[
							147.96405405300004,
							-32.518836024999985
						],
						[
							147.96538904500005,
							-32.49898901499995
						],
						[
							147.93640706000008,
							-32.490964032999955
						],
						[
							147.92487704400003,
							-32.46980402199995
						],
						[
							147.90529107800012,
							-32.46057301999997
						],
						[
							147.89958106000006,
							-32.452009019999934
						],
						[
							147.90508106100003,
							-32.43197601999998
						],
						[
							147.88452908300007,
							-32.44030800799993
						],
						[
							147.8568020770001,
							-32.43717201599998
						],
						[
							147.8205760940001,
							-32.41945501299995
						],
						[
							147.7720970900001,
							-32.423210008999945
						],
						[
							147.76288011300005,
							-32.40740200799996
						],
						[
							147.7491120950001,
							-32.409687996999935
						],
						[
							147.7196740810001,
							-32.39615101499993
						],
						[
							147.6965091070001,
							-32.369205002999934
						],
						[
							147.61230427200007,
							-32.42329087699994
						],
						[
							147.61151543100004,
							-32.44116584699998
						],
						[
							147.58952674400007,
							-32.43835399499994
						],
						[
							147.560871216,
							-32.455905282999936
						],
						[
							147.5452709980001,
							-32.55131925199993
						],
						[
							147.56176180500006,
							-32.553752163999945
						],
						[
							147.55060721200005,
							-32.59723727299996
						],
						[
							147.58153205700012,
							-32.60455104499994
						],
						[
							147.55687630800003,
							-32.629316253999946
						],
						[
							147.5537125930001,
							-32.67297140399995
						],
						[
							147.57764126000006,
							-32.67562521599996
						],
						[
							147.5683703640001,
							-32.735368394999966
						],
						[
							147.5984001500001,
							-32.73861158799997
						],
						[
							147.60426306600004,
							-32.76268199799995
						],
						[
							147.57105561000003,
							-32.949700976999964
						],
						[
							147.55690003200004,
							-32.94819598599997
						],
						[
							147.5466191480001,
							-32.99843002499995
						],
						[
							147.54302560600001,
							-33.02013811499995
						],
						[
							147.55917087400007,
							-33.02201902699994
						],
						[
							147.55498121200003,
							-33.04818355699996
						],
						[
							147.40530379400002,
							-33.037483374999965
						],
						[
							147.3885397350001,
							-33.13940351399998
						],
						[
							147.3809937970001,
							-33.13653860299996
						],
						[
							147.3853236870001,
							-33.130048563999935
						],
						[
							147.3691990090001,
							-33.131823732999976
						],
						[
							147.3543090920001,
							-33.12052187099994
						],
						[
							147.34073729400006,
							-33.12332302999994
						],
						[
							147.3423600850001,
							-33.11426801999994
						],
						[
							147.33049109700005,
							-33.11005316899997
						],
						[
							147.31742051800006,
							-33.117339337999965
						],
						[
							147.30808145100002,
							-33.10437142799998
						],
						[
							147.29682257500008,
							-33.17162752699994
						],
						[
							147.30615858200008,
							-33.18027039799995
						],
						[
							147.29794593200006,
							-33.19182734699996
						],
						[
							147.31438688900005,
							-33.19907732899998
						],
						[
							147.308800119,
							-33.20704942799995
						],
						[
							147.34190755400004,
							-33.21235510099996
						],
						[
							147.35722342000008,
							-33.224438961999965
						],
						[
							147.37882291800008,
							-33.21554973399998
						],
						[
							147.4208675110001,
							-33.22820236699994
						],
						[
							147.44341903800012,
							-33.22291917899997
						],
						[
							147.4439731770001,
							-33.23152017899997
						],
						[
							147.46482679500002,
							-33.22740696099993
						],
						[
							147.47194392200004,
							-33.24450295099996
						],
						[
							147.48553972900004,
							-33.246605821999935
						],
						[
							147.48232597900005,
							-33.258226871999966
						],
						[
							147.5146830430001,
							-33.263333984999974
						],
						[
							147.48041303800005,
							-33.44172099299993
						],
						[
							147.4260940370001,
							-33.43449098899998
						],
						[
							147.40348925000012,
							-33.52742902799997
						],
						[
							147.35835711700008,
							-33.525329703999944
						],
						[
							147.34275555800002,
							-33.535177432999944
						],
						[
							147.33894093600009,
							-33.55673552299993
						],
						[
							147.32241395900007,
							-33.554798681999955
						],
						[
							147.32036623800002,
							-33.567787721999935
						],
						[
							147.27812085400012,
							-33.562794087999976
						],
						[
							147.27613711300012,
							-33.57517513799996
						],
						[
							147.24588350800002,
							-33.57190038599998
						],
						[
							147.24278392600002,
							-33.59180344599997
						],
						[
							146.98643683700004,
							-33.56382060599998
						],
						[
							146.9884814180001,
							-33.551946605999944
						],
						[
							146.8307734130001,
							-33.532413703999964
						],
						[
							146.82981153200012,
							-33.53796668399997
						],
						[
							146.82041566500004,
							-33.52815990299996
						],
						[
							146.81429556500007,
							-33.53008693299995
						],
						[
							146.8214616130001,
							-33.53757681299993
						],
						[
							146.80888585800005,
							-33.60713801299994
						],
						[
							146.44562915500012,
							-33.563861954999936
						],
						[
							146.44081375100006,
							-33.52084497499993
						],
						[
							146.09514737300003,
							-33.60311810999997
						],
						[
							146.070306081,
							-33.75352075899997
						],
						[
							146.31723277100002,
							-33.78053580699998
						],
						[
							146.31916683000009,
							-33.78638179699993
						],
						[
							146.32013777100008,
							-33.78105379699997
						],
						[
							146.43719113200007,
							-33.79448591599993
						],
						[
							146.4174391130001,
							-33.91062191599997
						],
						[
							146.49281511100003,
							-33.91964393099994
						],
						[
							146.45821210300005,
							-34.13291691999996
						],
						[
							146.5855015620001,
							-34.14625642999994
						],
						[
							146.59152844200003,
							-34.14010736999995
						],
						[
							146.5974424210001,
							-34.147175310999955
						],
						[
							146.63541055400003,
							-34.15117362299998
						],
						[
							146.62387779800008,
							-34.22472191299994
						],
						[
							146.7290492410001,
							-34.23675535099994
						],
						[
							146.71875083600003,
							-34.298097730999984
						],
						[
							146.823034419,
							-34.31083764899995
						],
						[
							146.79175719600005,
							-34.47228529699993
						],
						[
							146.9115744070001,
							-34.48257804699995
						],
						[
							146.84633288600003,
							-34.844469843999946
						],
						[
							146.82925647500008,
							-34.877526272999944
						],
						[
							146.8415913230001,
							-34.88105322399997
						],
						[
							146.83281657300006,
							-34.89327842299997
						],
						[
							146.84370448100003,
							-34.89880641399998
						],
						[
							146.78448283700004,
							-34.924045029999945
						],
						[
							146.77908211600004,
							-34.93962822999998
						],
						[
							146.80888909600003,
							-34.98503569199994
						],
						[
							146.7787908680001,
							-35.09839214099998
						],
						[
							146.77031133000003,
							-35.09727542999997
						],
						[
							146.76153012300006,
							-35.07642823899994
						],
						[
							146.68848396600004,
							-35.06796594399998
						],
						[
							146.66092796700002,
							-35.08971695199995
						],
						[
							146.62522495200005,
							-35.100656938999975
						],
						[
							146.6149859720001,
							-35.11451693799995
						],
						[
							146.56462531900002,
							-35.11859732499994
						],
						[
							146.45132049900008,
							-35.19116536699994
						],
						[
							146.4482614000001,
							-35.18719831599998
						],
						[
							146.38925747400003,
							-35.23171836199998
						],
						[
							146.38640488300007,
							-35.24738360199996
						],
						[
							146.41366424800003,
							-35.25053186399998
						],
						[
							146.4038103040001,
							-35.304439043999935
						],
						[
							146.3924706360001,
							-35.30298259299997
						],
						[
							146.38876719400002,
							-35.32283805299994
						],
						[
							146.3729499970001,
							-35.32098892199997
						],
						[
							146.35423173200002,
							-35.387784410999984
						],
						[
							146.3650817900001,
							-35.389308031999974
						],
						[
							146.38079883600005,
							-35.40568157299998
						],
						[
							146.39151808200006,
							-35.430408743999976
						],
						[
							146.4311891110001,
							-35.474984796999934
						],
						[
							146.5400999520001,
							-35.48716093499996
						],
						[
							146.6697750080001,
							-35.52026587499995
						],
						[
							146.6623286360001,
							-35.54775014499995
						],
						[
							146.6741714640001,
							-35.54915007599993
						],
						[
							146.67296860300007,
							-35.55526314599996
						],
						[
							146.79615575200012,
							-35.57498705499995
						],
						[
							146.7976744130001,
							-35.56628077499994
						],
						[
							146.88838349700006,
							-35.57322845199997
						],
						[
							146.89091317800012,
							-35.560469171999955
						],
						[
							146.90085679700007,
							-35.56048095299997
						],
						[
							146.95547312300005,
							-35.523064026999975
						],
						[
							146.99118647800003,
							-35.51682698999997
						],
						[
							146.99390733000007,
							-35.48927377999996
						],
						[
							147.01661083600004,
							-35.49387297099997
						],
						[
							147.04017684400003,
							-35.48419198299996
						],
						[
							147.07124801200007,
							-35.460585134999974
						],
						[
							147.07022787300002,
							-35.452947034999966
						],
						[
							147.1052643270001,
							-35.452734937999935
						],
						[
							147.12181915400004,
							-35.456201858999975
						],
						[
							147.1324092310001,
							-35.46789192999995
						],
						[
							147.15779781700007,
							-35.46914677199993
						],
						[
							147.18498400500005,
							-35.44846416399997
						],
						[
							147.19545921100007,
							-35.466077294999934
						],
						[
							147.2110161280001,
							-35.472722155999975
						],
						[
							147.23789172400006,
							-35.47048876799994
						],
						[
							147.2514768100001,
							-35.49107898899996
						],
						[
							147.26320275800003,
							-35.488537719999954
						],
						[
							147.29389158200001,
							-35.501289422999946
						],
						[
							147.3030323910001,
							-35.49558328399996
						],
						[
							147.33354025500012,
							-35.50947698599998
						],
						[
							147.36380999000005,
							-35.51385778799994
						],
						[
							147.37801300500007,
							-35.530860589999975
						],
						[
							147.3881028840001,
							-35.53195946999995
						],
						[
							147.3823312820001,
							-35.55091078999993
						],
						[
							147.39151245900007,
							-35.56361106099996
						],
						[
							147.419017509,
							-35.533587172999944
						],
						[
							147.42717251700003,
							-35.53950719299996
						],
						[
							147.45628286300007,
							-35.53094302599993
						],
						[
							147.48825558600004,
							-35.545645107999974
						],
						[
							147.50045209600012,
							-35.52846883899997
						],
						[
							147.5001698090001,
							-35.508743608999964
						],
						[
							147.51815232700005,
							-35.496950339999955
						],
						[
							147.51477578900005,
							-35.488621009999974
						],
						[
							147.522043778,
							-35.482110010999975
						],
						[
							147.62518074500008,
							-35.546171018999985
						],
						[
							147.65029676200004,
							-35.53879901099998
						],
						[
							147.6811947750001,
							-35.556655973999966
						],
						[
							147.6855993370001,
							-35.534184893999964
						],
						[
							147.73829174800005,
							-35.54106902799998
						],
						[
							147.73692073900008,
							-35.53100901799996
						],
						[
							147.75572385600003,
							-35.53344944899993
						],
						[
							147.75438105500007,
							-35.54467139899998
						],
						[
							147.84539641900005,
							-35.55458598699994
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "139",
				"CED_NAME21": "Riverina",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 48976.2538,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/139",
				"SHAPE_Leng": 18.5427904374,
				"SHAPE_Area": 4.78887200783
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							151.06845347400008,
							-33.46009149099996
						],
						[
							151.07916144500007,
							-33.44519529199994
						],
						[
							151.0993196270001,
							-33.48067328399998
						],
						[
							151.11484964700003,
							-33.46382834499997
						],
						[
							151.13905859300007,
							-33.46958726699995
						],
						[
							151.14816260300006,
							-33.46115535799993
						],
						[
							151.14570849500012,
							-33.44786127799995
						],
						[
							151.16643899500002,
							-33.42669394999996
						],
						[
							151.17288748200008,
							-33.43804755999997
						],
						[
							151.15174851300003,
							-33.45953431899994
						],
						[
							151.1721478080001,
							-33.46944166099996
						],
						[
							151.1622664900001,
							-33.47041031999993
						],
						[
							151.1535081390001,
							-33.48672875899996
						],
						[
							151.1626119970001,
							-33.49333371999995
						],
						[
							151.1598091950001,
							-33.51098976999998
						],
						[
							151.16438637300007,
							-33.51526631999997
						],
						[
							151.1704426340001,
							-33.50204236099995
						],
						[
							151.1819475430001,
							-33.50081727199995
						],
						[
							151.19945037600007,
							-33.53611832399997
						],
						[
							151.2046904670001,
							-33.52068845399998
						],
						[
							151.19356859000004,
							-33.512015522999945
						],
						[
							151.19191843300007,
							-33.48878032299996
						],
						[
							151.21472049200008,
							-33.47044227499998
						],
						[
							151.2212026310001,
							-33.47608329499997
						],
						[
							151.2320163390001,
							-33.47313535599994
						],
						[
							151.2293476420001,
							-33.45625134599993
						],
						[
							151.23748364100004,
							-33.45373936699997
						],
						[
							151.2376884780001,
							-33.47557731699993
						],
						[
							151.2222754400001,
							-33.48055331499995
						],
						[
							151.21426833200007,
							-33.47637130499993
						],
						[
							151.21272248000002,
							-33.48621028399998
						],
						[
							151.206706552,
							-33.481227323999974
						],
						[
							151.19756647100007,
							-33.495161322999934
						],
						[
							151.21023846600008,
							-33.521141333999935
						],
						[
							151.22529445400005,
							-33.52134531599995
						],
						[
							151.22701342300002,
							-33.53044132599996
						],
						[
							151.23140645500007,
							-33.50738233599998
						],
						[
							151.26572456300005,
							-33.48493433899995
						],
						[
							151.25909265200005,
							-33.49907631899998
						],
						[
							151.24574241400012,
							-33.49968030799994
						],
						[
							151.247047403,
							-33.50829626799998
						],
						[
							151.23727233400007,
							-33.51090428699996
						],
						[
							151.2367766210001,
							-33.52806829699995
						],
						[
							151.25501851800004,
							-33.53528836899994
						],
						[
							151.24592238700006,
							-33.55557227799994
						],
						[
							151.25873334300002,
							-33.570626318999985
						],
						[
							151.27389850300005,
							-33.55093398099996
						],
						[
							151.30974532800008,
							-33.55461028399998
						],
						[
							151.31271147100006,
							-33.52979031399997
						],
						[
							151.33056138900008,
							-33.52436539599995
						],
						[
							151.33636445900004,
							-33.51517633599997
						],
						[
							151.35039939700005,
							-33.515628307999975
						],
						[
							151.33044532200006,
							-33.49828234599994
						],
						[
							151.33645552300004,
							-33.48438131599994
						],
						[
							151.3239950950001,
							-33.483155634999946
						],
						[
							151.29960363700002,
							-33.495832682999946
						],
						[
							151.3180055460001,
							-33.486181303999956
						],
						[
							151.30453040800012,
							-33.48156664299995
						],
						[
							151.3071234800001,
							-33.46788332299997
						],
						[
							151.31584948700004,
							-33.47912431399993
						],
						[
							151.32415542600006,
							-33.47681932499995
						],
						[
							151.31347243000005,
							-33.46061635399997
						],
						[
							151.3183943800001,
							-33.45166036399996
						],
						[
							151.3294243890001,
							-33.45049036499995
						],
						[
							151.33211561000007,
							-33.43632917499997
						],
						[
							151.31982142200002,
							-33.433715363999966
						],
						[
							151.32696878100012,
							-33.43294533499994
						],
						[
							151.32284165300007,
							-33.42781953399998
						],
						[
							151.3387793400001,
							-33.42998133599997
						],
						[
							151.34192176700003,
							-33.45064228599995
						],
						[
							151.34534656800008,
							-33.440597226999955
						],
						[
							151.35126956600004,
							-33.44519934699997
						],
						[
							151.3694715250001,
							-33.43872934899997
						],
						[
							151.35375853400012,
							-33.459673247999945
						],
						[
							151.35986454200008,
							-33.46947821799995
						],
						[
							151.3359279550001,
							-33.47423940599998
						],
						[
							151.34198392300004,
							-33.481107366999936
						],
						[
							151.36980954800003,
							-33.49194013899995
						],
						[
							151.36705245000007,
							-33.47423816899993
						],
						[
							151.38281920800011,
							-33.471880029999966
						],
						[
							151.37301946800005,
							-33.48623312999996
						],
						[
							151.38222918600002,
							-33.49073008999994
						],
						[
							151.37569852600006,
							-33.50056109999997
						],
						[
							151.3657954570001,
							-33.50232533899998
						],
						[
							151.36991535700008,
							-33.49373537899993
						],
						[
							151.35857769900008,
							-33.48976721799994
						],
						[
							151.3524964290001,
							-33.501423347999946
						],
						[
							151.34116545200004,
							-33.489299356999936
						],
						[
							151.3634058450001,
							-33.52085017899998
						],
						[
							151.3467521660001,
							-33.52724127699997
						],
						[
							151.34173717800002,
							-33.519524316999934
						],
						[
							151.3359295880001,
							-33.52232936599995
						],
						[
							151.34542845400006,
							-33.54715632699998
						],
						[
							151.36426045300004,
							-33.53071232899998
						],
						[
							151.38061245100005,
							-33.53327334099998
						],
						[
							151.3873934510001,
							-33.52427932099994
						],
						[
							151.40489443800004,
							-33.52871133299993
						],
						[
							151.41899843700003,
							-33.52149533399995
						],
						[
							151.42791060900004,
							-33.494628784999975
						],
						[
							151.4468864370001,
							-33.48645933599994
						],
						[
							151.43549147200008,
							-33.46773533499993
						],
						[
							151.45259443100008,
							-33.451134346999936
						],
						[
							151.44360093400007,
							-33.442552615999944
						],
						[
							151.449195765,
							-33.429649575999974
						],
						[
							151.43841147700005,
							-33.422129094999946
						],
						[
							151.39460046300007,
							-33.42769132099994
						],
						[
							151.34432647200003,
							-33.412400325999954
						],
						[
							151.34923820200004,
							-33.40599595699996
						],
						[
							151.34322533400007,
							-33.39583598599995
						],
						[
							151.35548302400002,
							-33.38253533699998
						],
						[
							151.37101735200008,
							-33.38156963899996
						],
						[
							151.3766436830001,
							-33.37127898899996
						],
						[
							151.30906963300004,
							-33.36405050299993
						],
						[
							151.29093606800006,
							-33.35016295099996
						],
						[
							151.29312741900003,
							-33.339269360999936
						],
						[
							151.30013465800005,
							-33.34030845199993
						],
						[
							151.30013156000007,
							-33.319895420999956
						],
						[
							151.27995388300008,
							-33.31992055999996
						],
						[
							151.2812667940001,
							-33.312992529999974
						],
						[
							151.2638770970001,
							-33.31058266799994
						],
						[
							151.26656689800006,
							-33.29661960799996
						],
						[
							151.2363382540001,
							-33.28536788499997
						],
						[
							151.23904706500002,
							-33.27132384499998
						],
						[
							151.22611019800001,
							-33.26409895399996
						],
						[
							151.2288960200001,
							-33.24998093399995
						],
						[
							151.21673897100004,
							-33.24834845299995
						],
						[
							151.2235355240001,
							-33.21904932399997
						],
						[
							151.21295892600006,
							-33.21892772299998
						],
						[
							151.19926139000006,
							-33.20062641099997
						],
						[
							151.20923666200008,
							-33.17897924199997
						],
						[
							151.20148658400012,
							-33.16749156099996
						],
						[
							151.20906598500005,
							-33.153367421999974
						],
						[
							151.2026315180001,
							-33.13884731099995
						],
						[
							151.1355325610001,
							-33.11038830499996
						],
						[
							151.1076975520001,
							-33.12794230199995
						],
						[
							151.09967893100008,
							-33.14428650199994
						],
						[
							151.10582561,
							-33.15150098199996
						],
						[
							151.09833434200004,
							-33.21819774199997
						],
						[
							151.1068148590001,
							-33.23123918299996
						],
						[
							151.09996726600002,
							-33.261618951999935
						],
						[
							151.08688453700006,
							-33.26903477099995
						],
						[
							151.09606344100007,
							-33.29981522199995
						],
						[
							151.0842252210001,
							-33.31853215099994
						],
						[
							151.0896327590001,
							-33.32692375199997
						],
						[
							151.0310719140001,
							-33.35157827699993
						],
						[
							151.00044385800004,
							-33.35050123399998
						],
						[
							150.9843341080001,
							-33.371031441999946
						],
						[
							150.98846301600008,
							-33.37921897299998
						],
						[
							150.99481222300005,
							-33.399371333999966
						],
						[
							151.03190866700004,
							-33.40534091699993
						],
						[
							151.03233589400008,
							-33.427329966999935
						],
						[
							151.06322047700007,
							-33.442476599999964
						],
						[
							151.06845347400008,
							-33.46009149099996
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "140",
				"CED_NAME21": "Robertson",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 893.9798,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/140",
				"SHAPE_Leng": 3.69363857584,
				"SHAPE_Area": 0.086613379111
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								151.56509046300005,
								-33.247313335999934
							],
							[
								151.59975948300007,
								-33.21068633899995
							],
							[
								151.6251474610001,
								-33.198017360999984
							],
							[
								151.62282449300005,
								-33.187998350999976
							],
							[
								151.63867344200003,
								-33.175822351999955
							],
							[
								151.6301684770001,
								-33.153759340999954
							],
							[
								151.6430424670001,
								-33.140511352999965
							],
							[
								151.6474944790001,
								-33.12112534299996
							],
							[
								151.65351544800012,
								-33.12065135299997
							],
							[
								151.64704546000007,
								-33.11161335299994
							],
							[
								151.66574448100005,
								-33.08676835399996
							],
							[
								151.65785347100007,
								-33.092193383999984
							],
							[
								151.64201455400007,
								-33.08722735199996
							],
							[
								151.64299549300006,
								-33.095262341999955
							],
							[
								151.65469947100007,
								-33.09388635299996
							],
							[
								151.64155549300006,
								-33.09637536199995
							],
							[
								151.63379432700003,
								-33.07065033099997
							],
							[
								151.61099550400002,
								-33.117671378999944
							],
							[
								151.61496451300002,
								-33.12453235999993
							],
							[
								151.6033185330001,
								-33.13185933899996
							],
							[
								151.59720033000008,
								-33.16154637799997
							],
							[
								151.58792637300007,
								-33.149897316999954
							],
							[
								151.5912595950001,
								-33.131829367999956
							],
							[
								151.58436956700007,
								-33.12644934699995
							],
							[
								151.59052159700002,
								-33.120127396999976
							],
							[
								151.58141540000008,
								-33.10263930599996
							],
							[
								151.583906597,
								-33.12289830699996
							],
							[
								151.56672958800004,
								-33.13627733499993
							],
							[
								151.55722952000008,
								-33.13159931399997
							],
							[
								151.55281950800008,
								-33.145729323999944
							],
							[
								151.57194163500003,
								-33.15479134599997
							],
							[
								151.56787542200004,
								-33.17526237599998
							],
							[
								151.54487035800003,
								-33.157407372999955
							],
							[
								151.5406774600001,
								-33.143463312999984
							],
							[
								151.53018739900006,
								-33.16081035199994
							],
							[
								151.52720049000004,
								-33.156646311999964
							],
							[
								151.52766049700006,
								-33.179953341999976
							],
							[
								151.51551548800012,
								-33.18393735099994
							],
							[
								151.5121859180001,
								-33.19429402099996
							],
							[
								151.48860751200004,
								-33.18813033799995
							],
							[
								151.48825075900004,
								-33.20843680799993
							],
							[
								151.51636403500004,
								-33.205778040999974
							],
							[
								151.50757195500012,
								-33.21801280999995
							],
							[
								151.5132508040001,
								-33.220773830999974
							],
							[
								151.5274366420001,
								-33.22035534199995
							],
							[
								151.53439039800003,
								-33.23930430299998
							],
							[
								151.54763730700006,
								-33.23304832399998
							],
							[
								151.56157362500005,
								-33.23970031599998
							],
							[
								151.5536323880001,
								-33.225869374999945
							],
							[
								151.5636533590001,
								-33.20748030599998
							],
							[
								151.55537662100005,
								-33.198963324999966
							],
							[
								151.57700863800005,
								-33.19654530699995
							],
							[
								151.5858686050001,
								-33.207939307999936
							],
							[
								151.56243563500004,
								-33.23380920599993
							],
							[
								151.56258609400004,
								-33.24603382599997
							],
							[
								151.56509046300005,
								-33.247313335999934
							]
						]
					],
					[
						[
							[
								151.5990394580001,
								-33.09949034799996
							],
							[
								151.59105647100012,
								-33.08799735699995
							],
							[
								151.58500748100005,
								-33.09157434699995
							],
							[
								151.5990394580001,
								-33.09949034799996
							]
						]
					],
					[
						[
							[
								151.61400549400003,
								-32.96269037899998
							],
							[
								151.63068643100007,
								-32.97364933999995
							],
							[
								151.64165960900004,
								-32.97237735099998
							],
							[
								151.64506845800008,
								-32.97961139199998
							],
							[
								151.62955967800008,
								-32.993861349999975
							],
							[
								151.64047160500002,
								-33.00421739099994
							],
							[
								151.62795440600007,
								-33.01176936999997
							],
							[
								151.63346455300007,
								-33.028531330999954
							],
							[
								151.65748340900006,
								-33.03598035299996
							],
							[
								151.6518734970001,
								-33.05336430299997
							],
							[
								151.6388995090001,
								-33.05511535199997
							],
							[
								151.64954359600006,
								-33.062722322999946
							],
							[
								151.6410494270001,
								-33.06489835199994
							],
							[
								151.6409565340001,
								-33.08518436199995
							],
							[
								151.6611254820001,
								-33.08381735399996
							],
							[
								151.65819847400007,
								-33.07068036399994
							],
							[
								151.66886147500009,
								-33.05193235399997
							],
							[
								151.7287104520001,
								-33.01073734999994
							],
							[
								151.7269364770001,
								-32.97815435899997
							],
							[
								151.73792013700006,
								-32.962934779999955
							],
							[
								151.72906473000012,
								-32.95506945899996
							],
							[
								151.68462649700007,
								-32.948455354999965
							],
							[
								151.68624147800006,
								-32.93769535499996
							],
							[
								151.66241720200003,
								-32.929838582999935
							],
							[
								151.65332578200002,
								-32.937966331999974
							],
							[
								151.6217094860001,
								-32.94301040899995
							],
							[
								151.61400549400003,
								-32.96269037899998
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "141",
				"CED_NAME21": "Shortland",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 203.5551,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/141",
				"SHAPE_Leng": 1.98816676237,
				"SHAPE_Area": 0.0196583563095
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								151.1793543770001,
								-33.920175323999956
							],
							[
								151.2142729420001,
								-33.92431947799997
							],
							[
								151.21503615500012,
								-33.90088347799997
							],
							[
								151.21699847700006,
								-33.88057382799997
							],
							[
								151.22828448600012,
								-33.87858129899996
							],
							[
								151.22757233700008,
								-33.86803602899994
							],
							[
								151.2299334180001,
								-33.85824332899995
							],
							[
								151.22061145800012,
								-33.86908332799993
							],
							[
								151.22272940900007,
								-33.85921431799994
							],
							[
								151.2097054510001,
								-33.86099131699996
							],
							[
								151.20805043200005,
								-33.853499316999944
							],
							[
								151.200181433,
								-33.85537031599995
							],
							[
								151.20154346000004,
								-33.873162315999934
							],
							[
								151.19408743300005,
								-33.86235831499994
							],
							[
								151.185990413,
								-33.86836831499994
							],
							[
								151.1893424320001,
								-33.87582731499998
							],
							[
								151.17527642400012,
								-33.87243030399998
							],
							[
								151.17147075200012,
								-33.89537898399993
							],
							[
								151.17871757000012,
								-33.89773050399998
							],
							[
								151.1793543770001,
								-33.920175323999956
							]
						]
					],
					[
						[
							[
								159.06341356100006,
								-31.515766962999976
							],
							[
								159.06466150200004,
								-31.509653972999956
							],
							[
								159.03691106400004,
								-31.516885138999953
							],
							[
								159.03932805300008,
								-31.52271511999993
							],
							[
								159.0452068930001,
								-31.517142069999977
							],
							[
								159.05143284200005,
								-31.52330503099995
							],
							[
								159.0569997120001,
								-31.51976000199994
							],
							[
								159.07707952500004,
								-31.54308386499997
							],
							[
								159.06664219900006,
								-31.58835989399995
							],
							[
								159.07356310600005,
								-31.597782834999975
							],
							[
								159.09422151800004,
								-31.570957706999934
							],
							[
								159.09963841700005,
								-31.573359667999966
							],
							[
								159.09775435900008,
								-31.56426268699994
							],
							[
								159.1054472080001,
								-31.56387462799995
							],
							[
								159.09468223300007,
								-31.545023716999935
							],
							[
								159.08191745500005,
								-31.53975482499993
							],
							[
								159.08118274700007,
								-31.52659514499993
							],
							[
								159.06341356100006,
								-31.515766962999976
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "142",
				"CED_NAME21": "Sydney",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 40.6793,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/142",
				"SHAPE_Leng": 0.904645799886,
				"SHAPE_Area": 0.00392432406078
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								151.21520351300012,
								-33.84106403699997
							],
							[
								151.22472158100004,
								-33.84657783799997
							],
							[
								151.22488036200002,
								-33.83926012799998
							],
							[
								151.2328716290001,
								-33.84869687899993
							],
							[
								151.2328504310001,
								-33.836402318999944
							],
							[
								151.2465054370001,
								-33.853524309999955
							],
							[
								151.24616043800006,
								-33.842660319999936
							],
							[
								151.25432442700003,
								-33.844030320999934
							],
							[
								151.26892242700012,
								-33.82739332199998
							],
							[
								151.25245241900006,
								-33.82712131099993
							],
							[
								151.2459494430001,
								-33.803339319999964
							],
							[
								151.23512346400003,
								-33.811560318999966
							],
							[
								151.23907842300002,
								-33.81687430899996
							],
							[
								151.23106335400007,
								-33.81674580899994
							],
							[
								151.23091757200007,
								-33.82776549899995
							],
							[
								151.21678243400004,
								-33.830053316999965
							],
							[
								151.21520351300012,
								-33.84106403699997
							]
						]
					],
					[
						[
							[
								151.29972244200007,
								-33.75658833499995
							],
							[
								151.22744314300007,
								-33.75132198799997
							],
							[
								151.20809311400012,
								-33.76090229599998
							],
							[
								151.20437124300008,
								-33.77246851599995
							],
							[
								151.22465946900002,
								-33.78374130799995
							],
							[
								151.23078643000008,
								-33.77270731799996
							],
							[
								151.23515044500004,
								-33.80339431899995
							],
							[
								151.2504864230001,
								-33.80027930999995
							],
							[
								151.26121544900002,
								-33.81797133099997
							],
							[
								151.27512541800002,
								-33.80999331299995
							],
							[
								151.26609145100008,
								-33.79817031199997
							],
							[
								151.28561741800002,
								-33.80024431399994
							],
							[
								151.28255644700005,
								-33.80920233299997
							],
							[
								151.29112642600012,
								-33.80864832399993
							],
							[
								151.28549243600003,
								-33.81875432399994
							],
							[
								151.30027643300002,
								-33.82391632499997
							],
							[
								151.30741043400008,
								-33.807070315999965
							],
							[
								151.28787176900005,
								-33.79193043399994
							],
							[
								151.2931764210001,
								-33.773209323999936
							],
							[
								151.30252243000007,
								-33.76818832499998
							],
							[
								151.29972244200007,
								-33.75658833499995
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "143",
				"CED_NAME21": "Warringah",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 52.2575,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/143",
				"SHAPE_Leng": 0.782768312937,
				"SHAPE_Area": 0.00508721660098
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							151.0772196590001,
							-33.943755274999944
						],
						[
							151.10078835600007,
							-33.939246786999945
						],
						[
							151.09488364900005,
							-33.92219376699995
						],
						[
							151.1190596770001,
							-33.912187038999946
						],
						[
							151.13243130800004,
							-33.891390799999954
						],
						[
							151.11750981000012,
							-33.88850287799994
						],
						[
							151.09419365400004,
							-33.88557737599996
						],
						[
							151.08113651500003,
							-33.89112214499994
						],
						[
							151.06877465800005,
							-33.88582612399995
						],
						[
							151.06118346100004,
							-33.86644330299998
						],
						[
							151.04228384500004,
							-33.86171663099998
						],
						[
							151.03564678500004,
							-33.940449430999934
						],
						[
							151.0772196590001,
							-33.943755274999944
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "144",
				"CED_NAME21": "Watson",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 47.6314,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/144",
				"SHAPE_Leng": 0.344489110048,
				"SHAPE_Area": 0.00464298579552
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							151.26654443600012,
							-33.91392232299995
						],
						[
							151.27485442700004,
							-33.89332332299995
						],
						[
							151.28592440600005,
							-33.89187331399995
						],
						[
							151.28785343100003,
							-33.850189323999984
						],
						[
							151.2811004240001,
							-33.83283132299994
						],
						[
							151.277586422,
							-33.85107732299997
						],
						[
							151.26438142400002,
							-33.85087232199993
						],
						[
							151.2669764210001,
							-33.87063833199994
						],
						[
							151.25571642300008,
							-33.871256320999976
						],
						[
							151.25145644400004,
							-33.863830330999974
						],
						[
							151.24613642400004,
							-33.873408309999945
						],
						[
							151.24009643600004,
							-33.86637930999996
						],
						[
							151.23215841600006,
							-33.87480931899995
						],
						[
							151.22757233700008,
							-33.86803602899994
						],
						[
							151.22828448600012,
							-33.87858129899996
						],
						[
							151.21699847700006,
							-33.88057382799997
						],
						[
							151.21503615500012,
							-33.90088347799997
						],
						[
							151.26654443600012,
							-33.91392232299995
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "145",
				"CED_NAME21": "Wentworth",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 28.0548,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/145",
				"SHAPE_Leng": 0.410746343452,
				"SHAPE_Area": 0.00273390598809
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							150.91893275200005,
							-33.939083359999984
						],
						[
							150.904571464,
							-33.93765528899996
						],
						[
							150.906412745,
							-33.92740730899993
						],
						[
							150.8986528470001,
							-33.92654734799993
						],
						[
							150.90768546700008,
							-33.91411730899995
						],
						[
							150.88911069200003,
							-33.89306201699998
						],
						[
							150.84245348100012,
							-33.87623628299997
						],
						[
							150.7978144970001,
							-33.88087028899997
						],
						[
							150.7679134120001,
							-33.875715165999964
						],
						[
							150.72094949000007,
							-33.86943426199997
						],
						[
							150.72331749700004,
							-33.886434261999966
						],
						[
							150.7100854050001,
							-33.91665301099994
						],
						[
							150.73174048900012,
							-33.93990026299997
						],
						[
							150.82256922400006,
							-33.951984951999975
						],
						[
							150.8151174630001,
							-33.96785327099997
						],
						[
							150.84446246700008,
							-33.984446273999936
						],
						[
							150.83785943500004,
							-34.00668860299993
						],
						[
							150.866308483,
							-33.98666128599996
						],
						[
							150.88857814800008,
							-34.005450037999935
						],
						[
							150.89291313500007,
							-34.01949550899997
						],
						[
							150.90677445300003,
							-34.01773628999996
						],
						[
							150.90150640600007,
							-34.00721232899997
						],
						[
							150.91255575500008,
							-34.00027319999998
						],
						[
							150.907825397,
							-33.99034219999993
						],
						[
							150.91893275200005,
							-33.939083359999984
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "146",
				"CED_NAME21": "Werriwa",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 170.9302,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/146",
				"SHAPE_Leng": 0.738410307107,
				"SHAPE_Area": 0.0166661627313
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								150.86089135800012,
								-34.62786993999998
							],
							[
								150.85555433100012,
								-34.61560990899994
							],
							[
								150.86521708100008,
								-34.60518075999994
							],
							[
								150.87688988900004,
								-34.60801171099996
							],
							[
								150.88755259800007,
								-34.59832559199998
							],
							[
								150.90446129600002,
								-34.59695542399993
							],
							[
								150.87492572200006,
								-34.58900858099997
							],
							[
								150.86845160500002,
								-34.57019453999993
							],
							[
								150.87353624800005,
								-34.54428543999995
							],
							[
								150.85324838200006,
								-34.537691318999975
							],
							[
								150.83716940300008,
								-34.542726296999945
							],
							[
								150.8323423820001,
								-34.55684428699993
							],
							[
								150.81640940500006,
								-34.553529294999976
							],
							[
								150.80424362600002,
								-34.56133814399993
							],
							[
								150.7951907580001,
								-34.55373221299993
							],
							[
								150.81036336600005,
								-34.54923805499993
							],
							[
								150.7968005890001,
								-34.54618619299998
							],
							[
								150.81351112800007,
								-34.53417300499996
							],
							[
								150.8076491600001,
								-34.525060063999945
							],
							[
								150.81257844900006,
								-34.53026324499996
							],
							[
								150.8089350900001,
								-34.524878043999934
							],
							[
								150.8193348090001,
								-34.51864892499998
							],
							[
								150.81537022200007,
								-34.50202026499994
							],
							[
								150.83764956900006,
								-34.50047227699997
							],
							[
								150.8324001420001,
								-34.48628676599998
							],
							[
								150.863244387,
								-34.48830928899997
							],
							[
								150.87534840800004,
								-34.46663027999995
							],
							[
								150.85643221300006,
								-34.453435937999984
							],
							[
								150.82977995500005,
								-34.46368909599994
							],
							[
								150.8059174990001,
								-34.46118337399997
							],
							[
								150.79224442300006,
								-34.442817281999965
							],
							[
								150.78523616300004,
								-34.44936568199995
							],
							[
								150.76404240700003,
								-34.44696626999996
							],
							[
								150.7652254080001,
								-34.43537128999998
							],
							[
								150.75192141000002,
								-34.43416526799996
							],
							[
								150.75356041300006,
								-34.414239288999966
							],
							[
								150.70794276000004,
								-34.40761710399994
							],
							[
								150.74568241400004,
								-34.33740338699994
							],
							[
								150.63462348300004,
								-34.31963627699997
							],
							[
								150.6161214430001,
								-34.33688528499994
							],
							[
								150.605170605,
								-34.33527428399998
							],
							[
								150.59377158300003,
								-34.36320730399996
							],
							[
								150.57448644500005,
								-34.36837725199996
							],
							[
								150.5698294440001,
								-34.38489226199994
							],
							[
								150.53562544700003,
								-34.39565326899998
							],
							[
								150.53096647900009,
								-34.39060825799993
							],
							[
								150.5266404560001,
								-34.41781226799998
							],
							[
								150.51369346700005,
								-34.42407225699998
							],
							[
								150.50870446900012,
								-34.41377724599994
							],
							[
								150.49732545000006,
								-34.41547125499994
							],
							[
								150.46064945400008,
								-34.431216251999956
							],
							[
								150.38033048300008,
								-34.44759224499995
							],
							[
								150.31567047900012,
								-34.48011423899993
							],
							[
								150.30767248600011,
								-34.511167238999974
							],
							[
								150.2574488570001,
								-34.560503764999964
							],
							[
								150.2488466740001,
								-34.58815894399993
							],
							[
								150.21553447500003,
								-34.61927922099994
							],
							[
								150.228314113,
								-34.621063161999984
							],
							[
								150.23278715100003,
								-34.63324217299993
							],
							[
								150.23602302100005,
								-34.626292122999985
							],
							[
								150.25248046900003,
								-34.62321323499998
							],
							[
								150.24841148200005,
								-34.60663123399996
							],
							[
								150.257513452,
								-34.59740423499994
							],
							[
								150.28586146700002,
								-34.60107724699998
							],
							[
								150.28724277800006,
								-34.59392273699996
							],
							[
								150.30543758400006,
								-34.603152688999955
							],
							[
								150.31522148300007,
								-34.597588239999936
							],
							[
								150.3328214500001,
								-34.603718251999965
							],
							[
								150.32855847100006,
								-34.59539325099996
							],
							[
								150.34519046000003,
								-34.59048324299994
							],
							[
								150.34808348100012,
								-34.577898242999936
							],
							[
								150.3716894580001,
								-34.57277225499996
							],
							[
								150.37870544400005,
								-34.59299424599993
							],
							[
								150.36885654200012,
								-34.618637354999976
							],
							[
								150.39931643600005,
								-34.632445237999946
							],
							[
								150.41280143500012,
								-34.625232238999956
							],
							[
								150.40349141500008,
								-34.63925703799998
							],
							[
								150.41547344900005,
								-34.671412259999954
							],
							[
								150.3951444490001,
								-34.69039125799998
							],
							[
								150.39814842700002,
								-34.70513625799998
							],
							[
								150.43272841400005,
								-34.689630240999975
							],
							[
								150.45179715000006,
								-34.69175606299996
							],
							[
								150.46922111000003,
								-34.678178973999934
							],
							[
								150.49825817500005,
								-34.68187974699998
							],
							[
								150.5025948860001,
								-34.667720696999936
							],
							[
								150.52623633400003,
								-34.65710349899996
							],
							[
								150.538770171,
								-34.664995430999966
							],
							[
								150.5463978030001,
								-34.64410031099993
							],
							[
								150.5534537210001,
								-34.65114528199996
							],
							[
								150.5590535220001,
								-34.63861924199995
							],
							[
								150.5664354160001,
								-34.67230726299994
							],
							[
								150.55935003600007,
								-34.68328729299998
							],
							[
								150.569071924,
								-34.68182721399995
							],
							[
								150.56715216300006,
								-34.69663128299993
							],
							[
								150.57706002100008,
								-34.695523213999934
							],
							[
								150.5763816650001,
								-34.66961814399997
							],
							[
								150.59076339400008,
								-34.65844203499995
							],
							[
								150.59069324600011,
								-34.64710105499995
							],
							[
								150.60396095300007,
								-34.65187196599993
							],
							[
								150.62290847100007,
								-34.644469837999964
							],
							[
								150.63473640200004,
								-34.62646026899995
							],
							[
								150.6568034290001,
								-34.62354027099997
							],
							[
								150.66700039800003,
								-34.61914828199997
							],
							[
								150.668041409,
								-34.60961726199997
							],
							[
								150.69042838600012,
								-34.60825827399998
							],
							[
								150.69847240600006,
								-34.60074627499995
							],
							[
								150.7581361760001,
								-34.61300974999995
							],
							[
								150.76829178600008,
								-34.598936580999975
							],
							[
								150.79017740200004,
								-34.602253272999974
							],
							[
								150.80019040500008,
								-34.64298328399997
							],
							[
								150.83247903100005,
								-34.63900924699993
							],
							[
								150.8450986800001,
								-34.63096109799994
							],
							[
								150.84800769900005,
								-34.635135108999975
							],
							[
								150.83778003400005,
								-34.61155254799996
							],
							[
								150.86089135800012,
								-34.62786993999998
							]
						]
					],
					[
						[
							[
								150.88606662200004,
								-34.49804830099998
							],
							[
								150.87361246400008,
								-34.49862626999993
							],
							[
								150.8627472510001,
								-34.52908050899998
							],
							[
								150.87427903800005,
								-34.54218464999997
							],
							[
								150.89778561000003,
								-34.50071061199998
							],
							[
								150.88606662200004,
								-34.49804830099998
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "147",
				"CED_NAME21": "Whitlam",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 1314.1749,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/147",
				"SHAPE_Leng": 3.11087318752,
				"SHAPE_Area": 0.129026292405
			}
		},
		{
			"type": "Feature",
			"geometry": null,
			"properties": {
				"CED_CODE21": "194",
				"CED_NAME21": "No usual address (NSW)",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 0,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/194",
				"SHAPE_Leng": 0,
				"SHAPE_Area": 0
			}
		},
		{
			"type": "Feature",
			"geometry": null,
			"properties": {
				"CED_CODE21": "197",
				"CED_NAME21": "Migratory - Offshore - Shipping (NSW)",
				"STE_CODE21": "1",
				"STE_NAME21": "New South Wales",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 0,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/197",
				"SHAPE_Leng": 0,
				"SHAPE_Area": 0
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							145.31797933200005,
							-37.84390566199994
						],
						[
							145.28728020800008,
							-37.83331421999998
						],
						[
							145.21674755000004,
							-37.83814442499994
						],
						[
							145.19570971100006,
							-37.865163043999985
						],
						[
							145.19087288000003,
							-37.88056986299995
						],
						[
							145.20834688500008,
							-37.89903485499997
						],
						[
							145.2056528920001,
							-37.924387854999964
						],
						[
							145.22919987500006,
							-37.95206285699993
						],
						[
							145.23325586600004,
							-37.94187714699996
						],
						[
							145.27962672700005,
							-37.94758318999993
						],
						[
							145.29318680300003,
							-37.964854980999974
						],
						[
							145.3038729440001,
							-37.933415381999964
						],
						[
							145.2945265400001,
							-37.900332290999984
						],
						[
							145.30501653700003,
							-37.90570027199993
						],
						[
							145.30946938700004,
							-37.899469171999954
						],
						[
							145.32424710400005,
							-37.899445972999956
						],
						[
							145.30454075900002,
							-37.88797166099994
						],
						[
							145.30850177000002,
							-37.87105291199998
						],
						[
							145.30214884200007,
							-37.86420305099995
						],
						[
							145.32421746800003,
							-37.86705262299995
						],
						[
							145.33662564700012,
							-37.85617294299993
						],
						[
							145.3476252050001,
							-37.85939667399998
						],
						[
							145.31797933200005,
							-37.84390566199994
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "201",
				"CED_NAME21": "Aston",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 113.9114,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/201",
				"SHAPE_Leng": 0.75704302599,
				"SHAPE_Area": 0.0116670126863
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							144.41526448700006,
							-37.38246997799996
						],
						[
							144.419037429,
							-37.360494287999984
						],
						[
							144.39277075300004,
							-37.35813585599993
						],
						[
							144.39574254600006,
							-37.33156739599997
						],
						[
							144.3802657880001,
							-37.32973770499996
						],
						[
							144.31040564400007,
							-37.29277271999996
						],
						[
							144.34399257500002,
							-37.22621259199997
						],
						[
							144.37612870200007,
							-37.202228393999974
						],
						[
							144.37535578300003,
							-37.19580545399998
						],
						[
							144.36033873600002,
							-37.194034332999934
						],
						[
							144.36299301700012,
							-37.17938685299998
						],
						[
							144.37554372500006,
							-37.180869593999944
						],
						[
							144.38023127400004,
							-37.174843823999936
						],
						[
							144.29216796100002,
							-37.16355683799998
						],
						[
							144.2842580370001,
							-37.208000967999965
						],
						[
							144.27663610900004,
							-37.20905003799993
						],
						[
							144.18515369600004,
							-37.19534440199993
						],
						[
							144.19045214800008,
							-37.16612613199993
						],
						[
							144.0743472690001,
							-37.14764654399994
						],
						[
							144.06008934600004,
							-37.20771658399997
						],
						[
							144.067540344,
							-37.21040456399993
						],
						[
							144.0635679410001,
							-37.24949484399997
						],
						[
							144.041997314,
							-37.256040122999934
						],
						[
							144.03862351300006,
							-37.27022825299997
						],
						[
							144.0330625250001,
							-37.26251125199997
						],
						[
							144.00139078100005,
							-37.255242529999975
						],
						[
							143.99674565400005,
							-37.235334439999974
						],
						[
							143.95887402200003,
							-37.220481796999934
						],
						[
							143.9494175760001,
							-37.19444682599993
						],
						[
							143.87500820900004,
							-37.18638875199997
						],
						[
							143.8584431170001,
							-37.23533382099998
						],
						[
							143.82206719400006,
							-37.225931757999945
						],
						[
							143.82019737400003,
							-37.23520704799995
						],
						[
							143.76629023400005,
							-37.228220704999956
						],
						[
							143.75890125400008,
							-37.23309331399997
						],
						[
							143.72701745200004,
							-37.21365765199994
						],
						[
							143.71392107200006,
							-37.230268301999956
						],
						[
							143.68703243700008,
							-37.22894828999995
						],
						[
							143.66513507000002,
							-37.236641848999966
						],
						[
							143.62001583500012,
							-37.46494853699994
						],
						[
							143.60924406700008,
							-37.467129185999966
						],
						[
							143.62150291500006,
							-37.46770763699993
						],
						[
							143.6202767740001,
							-37.47378218699998
						],
						[
							143.59500475400012,
							-37.527254065999955
						],
						[
							143.6060573110001,
							-37.53491160699997
						],
						[
							143.62203993900005,
							-37.52513848799998
						],
						[
							143.66856501000007,
							-37.538429390999966
						],
						[
							143.65164751200007,
							-37.647039579999955
						],
						[
							143.59530930200003,
							-37.644294936999984
						],
						[
							143.58664266200003,
							-37.65371118599995
						],
						[
							143.5365443820001,
							-37.64829831299994
						],
						[
							143.53578368,
							-37.66669134299997
						],
						[
							143.49483262800004,
							-37.66086528099993
						],
						[
							143.49987549700006,
							-37.656783150999956
						],
						[
							143.4879130700001,
							-37.655115629999955
						],
						[
							143.48972744000002,
							-37.64679756999993
						],
						[
							143.46555094300004,
							-37.65426962899994
						],
						[
							143.4407181250001,
							-37.78483621799995
						],
						[
							143.4478029500001,
							-37.821387028999936
						],
						[
							143.44055933800007,
							-37.85941813799997
						],
						[
							143.45250414400005,
							-37.87728989899995
						],
						[
							143.44278127300004,
							-37.90565609899994
						],
						[
							143.47712345500008,
							-37.92435279099993
						],
						[
							143.47941664300004,
							-37.94083673099993
						],
						[
							143.59345598100003,
							-37.95465561899994
						],
						[
							143.5973227500001,
							-37.962173048999944
						],
						[
							143.61177605800003,
							-37.958800519999954
						],
						[
							143.62182975400003,
							-37.98184650999997
						],
						[
							143.64708085900008,
							-37.98720664199993
						],
						[
							143.65625370500004,
							-38.00747611299994
						],
						[
							143.63341543800004,
							-38.01265905099996
						],
						[
							143.6289192580001,
							-38.02339335099998
						],
						[
							143.67241506000005,
							-38.02938694399995
						],
						[
							143.76697256400007,
							-38.01975379999993
						],
						[
							143.82972072300004,
							-38.02234985399997
						],
						[
							143.82316014100002,
							-38.05577875399996
						],
						[
							143.8580062840001,
							-38.059766725999964
						],
						[
							143.85691296700008,
							-38.030322775999934
						],
						[
							143.99493009100001,
							-38.04669376499993
						],
						[
							144.00112745900003,
							-38.05489258499995
						],
						[
							144.01714723700002,
							-38.052661615999966
						],
						[
							144.0156418680001,
							-38.048212285999966
						],
						[
							144.04602183200006,
							-38.05155059799995
						],
						[
							144.0545871390001,
							-38.06172762899996
						],
						[
							144.07834305500012,
							-38.05763278999996
						],
						[
							144.09378507200006,
							-38.06546978099993
						],
						[
							144.09717081700012,
							-38.00975464099997
						],
						[
							144.11099405400012,
							-38.01273580199995
						],
						[
							144.11334016500007,
							-38.000143821999984
						],
						[
							144.13414907100002,
							-38.00259077299995
						],
						[
							144.16351338900006,
							-37.976613414999974
						],
						[
							144.19534572200007,
							-37.988866446999964
						],
						[
							144.1897356400001,
							-38.01888060699997
						],
						[
							144.2106320260001,
							-38.02422279799998
						],
						[
							144.21784906300002,
							-38.04118177899994
						],
						[
							144.23481404000006,
							-38.041066789999945
						],
						[
							144.2393160570001,
							-38.057099790999985
						],
						[
							144.2583211640001,
							-38.059790061999934
						],
						[
							144.262691205,
							-38.043695011999944
						],
						[
							144.24071605200004,
							-38.00854478999997
						],
						[
							144.24773004300005,
							-37.99131979099997
						],
						[
							144.2354840380001,
							-37.964544789999934
						],
						[
							144.23684042000002,
							-37.94236930999995
						],
						[
							144.20252593600003,
							-37.93824459699994
						],
						[
							144.2134373980001,
							-37.90143418799994
						],
						[
							144.24846655500005,
							-37.87376978999998
						],
						[
							144.23421738800005,
							-37.86664626899994
						],
						[
							144.23021415200003,
							-37.83384966899996
						],
						[
							144.2106823460001,
							-37.824980696999944
						],
						[
							144.222451846,
							-37.81018783799993
						],
						[
							144.17639589500004,
							-37.80286627499993
						],
						[
							144.17324207600007,
							-37.79264678499993
						],
						[
							144.19034732500006,
							-37.77783879599997
						],
						[
							144.16453709100006,
							-37.759890773999985
						],
						[
							144.17012192200002,
							-37.74306277399995
						],
						[
							144.1829822200001,
							-37.74448279499995
						],
						[
							144.18052124200005,
							-37.72951211499998
						],
						[
							144.15189907700005,
							-37.72328878299993
						],
						[
							144.15722709700003,
							-37.713222782999935
						],
						[
							144.16529610600003,
							-37.71450278399993
						],
						[
							144.1740023870001,
							-37.687473473999944
						],
						[
							144.16627507900012,
							-37.68275778299994
						],
						[
							144.178885099,
							-37.66151179399998
						],
						[
							144.15260412400005,
							-37.65275577199998
						],
						[
							144.1562553660001,
							-37.62996239199998
						],
						[
							144.13342308100005,
							-37.624431770999934
						],
						[
							144.13990413300007,
							-37.59295278099995
						],
						[
							144.13013108400003,
							-37.592244790999985
						],
						[
							144.1323941160001,
							-37.575802780999936
						],
						[
							144.1414141040001,
							-37.57943154099996
						],
						[
							144.14366309500008,
							-37.56663777099993
						],
						[
							144.18703084800006,
							-37.561613533999946
						],
						[
							144.18769507900004,
							-37.551863793999985
						],
						[
							144.19872307700007,
							-37.549489774999984
						],
						[
							144.19244950000007,
							-37.52693479399994
						],
						[
							144.16672207700003,
							-37.50667128199996
						],
						[
							144.15828708100003,
							-37.47884195199998
						],
						[
							144.1648159130001,
							-37.45443997199993
						],
						[
							144.1793421000001,
							-37.45126878299993
						],
						[
							144.17393945300012,
							-37.43603902199993
						],
						[
							144.26353908600004,
							-37.44627777799997
						],
						[
							144.26870532700002,
							-37.42757729899995
						],
						[
							144.3003190710001,
							-37.43639978099998
						],
						[
							144.30548809100003,
							-37.42462079099994
						],
						[
							144.3420534160001,
							-37.42063595299993
						],
						[
							144.3472825130001,
							-37.43212445399996
						],
						[
							144.3792841070001,
							-37.43877539599998
						],
						[
							144.38197292200005,
							-37.39331406599996
						],
						[
							144.41494748600007,
							-37.39683431799995
						],
						[
							144.41526448700006,
							-37.38246997799996
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "202",
				"CED_NAME21": "Ballarat",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 5399.3279,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/202",
				"SHAPE_Leng": 5.51655500363,
				"SHAPE_Area": 0.551044654575
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							144.70381747500005,
							-37.21294511599996
						],
						[
							144.71610399400004,
							-37.208782466999935
						],
						[
							144.71025706000012,
							-37.15952780599997
						],
						[
							144.72654941700011,
							-37.15961324699998
						],
						[
							144.73522360900006,
							-37.12650088799995
						],
						[
							144.71535305400005,
							-37.11548681599993
						],
						[
							144.72843706700007,
							-37.06601781699993
						],
						[
							144.72598507200007,
							-37.018810815999984
						],
						[
							144.71464408600002,
							-36.99794281499993
						],
						[
							144.7430400610001,
							-36.99770581699994
						],
						[
							144.75345690300003,
							-36.962980707999975
						],
						[
							144.76599896000005,
							-36.97361860899997
						],
						[
							144.79657880600007,
							-36.96552627099993
						],
						[
							144.7912734580001,
							-36.95201698999995
						],
						[
							144.8063221850001,
							-36.95562967099994
						],
						[
							144.80427267900006,
							-36.92587514099995
						],
						[
							144.82239185800006,
							-36.89969585199998
						],
						[
							144.85356927500004,
							-36.880237223999984
						],
						[
							144.79855302900012,
							-36.83260812999998
						],
						[
							144.787319614,
							-36.805316638999955
						],
						[
							144.79170869600011,
							-36.780023478999965
						],
						[
							144.78477260700004,
							-36.780512888999965
						],
						[
							144.78481217800004,
							-36.77064458899997
						],
						[
							144.7947474660001,
							-36.770657908999965
						],
						[
							144.7946913390001,
							-36.75070975899996
						],
						[
							144.76693316400008,
							-36.74724420699994
						],
						[
							144.75032205500008,
							-36.757543545999965
						],
						[
							144.66616521900005,
							-36.76259867099998
						],
						[
							144.66711167200003,
							-36.72538941099998
						],
						[
							144.51803879700003,
							-36.72543776099997
						],
						[
							144.5224719800001,
							-36.69315421099998
						],
						[
							144.53477028800012,
							-36.68802168099995
						],
						[
							144.52544487300008,
							-36.65978840099996
						],
						[
							144.54574993100005,
							-36.64676559199995
						],
						[
							144.5618412120001,
							-36.61342644299998
						],
						[
							144.5897253490001,
							-36.59482182499994
						],
						[
							144.58343581100007,
							-36.58470230399996
						],
						[
							144.59841000900008,
							-36.57450873499994
						],
						[
							144.5872251730001,
							-36.557886193999934
						],
						[
							144.61054129900003,
							-36.55591725599993
						],
						[
							144.60629076100008,
							-36.546791164999945
						],
						[
							144.6171217000001,
							-36.537830765999956
						],
						[
							144.60843959200008,
							-36.528956594999954
						],
						[
							144.62603102000003,
							-36.52737186699994
						],
						[
							144.61026087300002,
							-36.516752494999935
						],
						[
							144.62354413200012,
							-36.50450547599996
						],
						[
							144.61132791500006,
							-36.499131044999956
						],
						[
							144.62621392300002,
							-36.49214153599996
						],
						[
							144.6206227450001,
							-36.48132255599995
						],
						[
							144.65474999100002,
							-36.472629017999964
						],
						[
							144.65326933200004,
							-36.46560271799996
						],
						[
							144.6715526490001,
							-36.45710462899996
						],
						[
							144.6719367810001,
							-36.44309126899998
						],
						[
							144.65872513300008,
							-36.44047011799995
						],
						[
							144.67426741200006,
							-36.42548709899995
						],
						[
							144.6681837750001,
							-36.406579448999935
						],
						[
							144.43010538400006,
							-36.406672672999946
						],
						[
							144.43021699400003,
							-36.41129103299994
						],
						[
							144.4157082480001,
							-36.39631106199994
						],
						[
							144.399760269,
							-36.40750985099993
						],
						[
							144.36940505400003,
							-36.407836188999966
						],
						[
							144.3583274880001,
							-36.385170047999964
						],
						[
							144.34409993100007,
							-36.385206506999964
						],
						[
							144.34375865100003,
							-36.487082457999975
						],
						[
							144.209675263,
							-36.48750696899998
						],
						[
							144.1993443010001,
							-36.52447878799995
						],
						[
							144.1704633160001,
							-36.52441281599994
						],
						[
							144.16265023300002,
							-36.56555920599993
						],
						[
							144.18473444400001,
							-36.618467857999974
						],
						[
							144.14040334100002,
							-36.618422764999934
						],
						[
							144.14049691800005,
							-36.64729845499994
						],
						[
							144.12588812100012,
							-36.64730008399994
						],
						[
							144.12581289900004,
							-36.66200797399995
						],
						[
							144.0687010690001,
							-36.66199204099996
						],
						[
							144.06872697300003,
							-36.720214650999935
						],
						[
							144.06207342400012,
							-36.71939637099996
						],
						[
							144.05984612300006,
							-36.73073870099995
						],
						[
							144.07566091,
							-36.74312469199998
						],
						[
							144.07128550800007,
							-36.766426241999966
						],
						[
							144.06231862900006,
							-36.76667606099994
						],
						[
							144.04794269900003,
							-36.79223571999995
						],
						[
							144.0259053420001,
							-36.89788336899994
						],
						[
							143.89170497700002,
							-36.88188821099993
						],
						[
							143.89210209500004,
							-36.893916280999974
						],
						[
							143.86640146900004,
							-36.90124253899995
						],
						[
							143.8629757980001,
							-36.915505818999975
						],
						[
							143.84655120000002,
							-36.927952277999964
						],
						[
							143.8598884050001,
							-36.94995219899994
						],
						[
							143.83641718800004,
							-36.96326206799995
						],
						[
							143.83064427700003,
							-36.980718886999966
						],
						[
							143.884250618,
							-36.986312270999974
						],
						[
							143.8822938070001,
							-36.99855840099997
						],
						[
							143.89970361400003,
							-37.00054227199996
						],
						[
							143.8957050020001,
							-37.02355951199996
						],
						[
							143.97345082800007,
							-37.02936481699993
						],
						[
							143.9915989530001,
							-37.05403378799997
						],
						[
							144.01259374800009,
							-37.06674561999995
						],
						[
							144.0120589070001,
							-37.07681168999994
						],
						[
							143.98614979,
							-37.08679598799995
						],
						[
							143.9797090400001,
							-37.09938203799993
						],
						[
							143.97196830200005,
							-37.091553396999984
						],
						[
							143.96463833300004,
							-37.10076289699998
						],
						[
							143.95518655000012,
							-37.139883735999945
						],
						[
							143.9629549880001,
							-37.148713476999944
						],
						[
							143.96265626500008,
							-37.17652061699994
						],
						[
							143.9494175760001,
							-37.19444682599993
						],
						[
							143.95887402200003,
							-37.220481796999934
						],
						[
							143.99674565400005,
							-37.235334439999974
						],
						[
							144.00139078100005,
							-37.255242529999975
						],
						[
							144.0330625250001,
							-37.26251125199997
						],
						[
							144.03862351300006,
							-37.27022825299997
						],
						[
							144.041997314,
							-37.256040122999934
						],
						[
							144.0635679410001,
							-37.24949484399997
						],
						[
							144.067540344,
							-37.21040456399993
						],
						[
							144.06008934600004,
							-37.20771658399997
						],
						[
							144.0743472690001,
							-37.14764654399994
						],
						[
							144.19045214800008,
							-37.16612613199993
						],
						[
							144.18515369600004,
							-37.19534440199993
						],
						[
							144.27663610900004,
							-37.20905003799993
						],
						[
							144.2842580370001,
							-37.208000967999965
						],
						[
							144.29216796100002,
							-37.16355683799998
						],
						[
							144.38023127400004,
							-37.174843823999936
						],
						[
							144.37554372500006,
							-37.180869593999944
						],
						[
							144.36299301700012,
							-37.17938685299998
						],
						[
							144.36033873600002,
							-37.194034332999934
						],
						[
							144.37535578300003,
							-37.19580545399998
						],
						[
							144.37612870200007,
							-37.202228393999974
						],
						[
							144.34399257500002,
							-37.22621259199997
						],
						[
							144.31040564400007,
							-37.29277271999996
						],
						[
							144.3802657880001,
							-37.32973770499996
						],
						[
							144.39574254600006,
							-37.33156739599997
						],
						[
							144.39277075300004,
							-37.35813585599993
						],
						[
							144.419037429,
							-37.360494287999984
						],
						[
							144.41526448700006,
							-37.38246997799996
						],
						[
							144.44639402100006,
							-37.386059279999984
						],
						[
							144.460576424,
							-37.338585870999964
						],
						[
							144.4803946510001,
							-37.332807281999976
						],
						[
							144.50101156000005,
							-37.307073672999934
						],
						[
							144.49103421200005,
							-37.300660781999966
						],
						[
							144.4941212430001,
							-37.29220274299996
						],
						[
							144.56460160000006,
							-37.29948077699993
						],
						[
							144.56946219200006,
							-37.27355265699998
						],
						[
							144.57983323000008,
							-37.27529985799998
						],
						[
							144.58394408100003,
							-37.262392777999935
						],
						[
							144.59513103900008,
							-37.26292377899995
						],
						[
							144.59715675100006,
							-37.24055568899996
						],
						[
							144.61737781700003,
							-37.24089954999994
						],
						[
							144.63651020600003,
							-37.223224321999965
						],
						[
							144.660529063,
							-37.214165812999966
						],
						[
							144.65996192300008,
							-37.20826052299998
						],
						[
							144.68334761900007,
							-37.210801464999975
						],
						[
							144.69248407600003,
							-37.22152972499998
						],
						[
							144.70381747500005,
							-37.21294511599996
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "203",
				"CED_NAME21": "Bendigo",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 5281.3561,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/203",
				"SHAPE_Leng": 5.32537908966,
				"SHAPE_Area": 0.533887979842
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							145.29318680300003,
							-37.964854980999974
						],
						[
							145.27962672700005,
							-37.94758318999993
						],
						[
							145.23325586600004,
							-37.94187714699996
						],
						[
							145.22919987500006,
							-37.95206285699993
						],
						[
							145.2056528920001,
							-37.924387854999964
						],
						[
							145.19549158400002,
							-37.92311495399997
						],
						[
							145.1930601690001,
							-37.97902044399996
						],
						[
							145.22602988000006,
							-38.001782866999974
						],
						[
							145.251859426,
							-38.00362220799997
						],
						[
							145.2489944350001,
							-38.01699776799995
						],
						[
							145.2867607170001,
							-38.02162130099998
						],
						[
							145.28635027600012,
							-38.035562770999945
						],
						[
							145.30145590100005,
							-38.05374654199994
						],
						[
							145.29820905000008,
							-38.069887421999965
						],
						[
							145.33535027300002,
							-38.07449802499997
						],
						[
							145.34807384600003,
							-38.02756785499997
						],
						[
							145.34394894900004,
							-38.011221424999974
						],
						[
							145.32899669200003,
							-38.00749367399993
						],
						[
							145.33401679200006,
							-37.999381823999954
						],
						[
							145.3409774800001,
							-38.007763774999944
						],
						[
							145.34713025000008,
							-37.99580774499998
						],
						[
							145.34984183900008,
							-38.00077486499998
						],
						[
							145.36099773,
							-37.972040935999985
						],
						[
							145.29318680300003,
							-37.964854980999974
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "204",
				"CED_NAME21": "Bruce",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 114.0706,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/204",
				"SHAPE_Leng": 0.675775059367,
				"SHAPE_Area": 0.0116996279726
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							144.95263077200002,
							-37.60032903499996
						],
						[
							144.96535821200007,
							-37.57216812599995
						],
						[
							144.9537888870001,
							-37.54504662499994
						],
						[
							144.97259923500008,
							-37.53526660599994
						],
						[
							144.9772112270001,
							-37.51371547699995
						],
						[
							144.87533989500002,
							-37.50210582899996
						],
						[
							144.86633588600012,
							-37.50684781899997
						],
						[
							144.87051119500006,
							-37.51552263899998
						],
						[
							144.85167383600003,
							-37.53254183799993
						],
						[
							144.85807498400004,
							-37.541243848999954
						],
						[
							144.84796116400003,
							-37.55688881799995
						],
						[
							144.82840596800008,
							-37.55525378699997
						],
						[
							144.8324300160001,
							-37.56402482699997
						],
						[
							144.81913595800006,
							-37.57215686599994
						],
						[
							144.82204799600004,
							-37.57879579599995
						],
						[
							144.80900482800007,
							-37.58182483499996
						],
						[
							144.80729808800004,
							-37.59072278499997
						],
						[
							144.81609896600003,
							-37.59494082599997
						],
						[
							144.80614497700003,
							-37.598150844999964
						],
						[
							144.81795189500008,
							-37.60070181599997
						],
						[
							144.80173282700002,
							-37.60969568499996
						],
						[
							144.81973535200007,
							-37.61996279599998
						],
						[
							144.8183821120001,
							-37.627608565999935
						],
						[
							144.83636915800002,
							-37.62959180799993
						],
						[
							144.83392402700008,
							-37.643974887999946
						],
						[
							144.84416687500004,
							-37.64575451799993
						],
						[
							144.88158896400012,
							-37.68890382099994
						],
						[
							144.8855989640001,
							-37.680694840999934
						],
						[
							144.9054401410001,
							-37.68119286299998
						],
						[
							144.90959781900006,
							-37.69400644299998
						],
						[
							144.97206678800012,
							-37.69098585699993
						],
						[
							144.97628309200002,
							-37.65006986699996
						],
						[
							144.95280103900006,
							-37.623192175999975
						],
						[
							144.9464664720001,
							-37.60741247499993
						],
						[
							144.95263077200002,
							-37.60032903499996
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "205",
				"CED_NAME21": "Calwell",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 222.3009,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/205",
				"SHAPE_Leng": 0.971937906479,
				"SHAPE_Area": 0.0226811080355
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							145.36641766600007,
							-37.545112813999935
						],
						[
							145.3538896880001,
							-37.64389711299998
						],
						[
							145.33037171900003,
							-37.67192061199995
						],
						[
							145.33103685600008,
							-37.692148661999965
						],
						[
							145.31706005900003,
							-37.69198978099996
						],
						[
							145.32205106600009,
							-37.707452941999975
						],
						[
							145.31417016800003,
							-37.70663096099997
						],
						[
							145.31125735700004,
							-37.716104050999945
						],
						[
							145.29359753100005,
							-37.71222106999994
						],
						[
							145.28167140900007,
							-37.74256713899996
						],
						[
							145.28957843600006,
							-37.76280578999996
						],
						[
							145.30788552100012,
							-37.777542850999964
						],
						[
							145.30429343700007,
							-37.821524840999984
						],
						[
							145.31681352500004,
							-37.81814561199997
						],
						[
							145.31797933200005,
							-37.84390566199994
						],
						[
							145.3476252050001,
							-37.85939667399998
						],
						[
							145.33662564700012,
							-37.85617294299993
						],
						[
							145.32421746800003,
							-37.86705262299995
						],
						[
							145.30214884200007,
							-37.86420305099995
						],
						[
							145.30850177000002,
							-37.87105291199998
						],
						[
							145.30454075900002,
							-37.88797166099994
						],
						[
							145.32424710400005,
							-37.899445972999956
						],
						[
							145.30946938700004,
							-37.899469171999954
						],
						[
							145.30501653700003,
							-37.90570027199993
						],
						[
							145.2945265400001,
							-37.900332290999984
						],
						[
							145.3038729440001,
							-37.933415381999964
						],
						[
							145.29318680300003,
							-37.964854980999974
						],
						[
							145.36099773,
							-37.972040935999985
						],
						[
							145.38794874500002,
							-37.97127666799997
						],
						[
							145.38352294000003,
							-37.93826016699995
						],
						[
							145.4265998730001,
							-37.936928869999974
						],
						[
							145.43243286200004,
							-37.93227788099995
						],
						[
							145.41968903500003,
							-37.92636460999995
						],
						[
							145.42292403500005,
							-37.919173859999944
						],
						[
							145.44373246300006,
							-37.90646061099994
						],
						[
							145.46885496800007,
							-37.910641312999985
						],
						[
							145.4692037960001,
							-37.92843989299996
						],
						[
							145.49136681200002,
							-37.92698688499996
						],
						[
							145.49405083300007,
							-37.91434087499994
						],
						[
							145.52686306100009,
							-37.885306696999976
						],
						[
							145.52677243300002,
							-37.86360935699997
						],
						[
							145.51913958500006,
							-37.85774095599993
						],
						[
							145.5533233980001,
							-37.87357862899995
						],
						[
							145.56904854200002,
							-37.897979609999936
						],
						[
							145.62793070100008,
							-37.904014883999935
						],
						[
							145.6260466000001,
							-37.91757098399995
						],
						[
							145.6526115160001,
							-37.91642215599995
						],
						[
							145.65796132600008,
							-37.907976805999965
						],
						[
							145.67070642300007,
							-37.90712882699995
						],
						[
							145.670541855,
							-37.89429663699997
						],
						[
							145.68631817300002,
							-37.88880581799998
						],
						[
							145.68685924400006,
							-37.88080175799996
						],
						[
							145.72154719700006,
							-37.88522574099994
						],
						[
							145.72923041400009,
							-37.90285879199996
						],
						[
							145.7481202900001,
							-37.90751870299994
						],
						[
							145.76502277800012,
							-37.89856688399993
						],
						[
							145.76950376900004,
							-37.88088989399995
						],
						[
							145.80421578400012,
							-37.87351688699994
						],
						[
							145.80325579600003,
							-37.86067389699997
						],
						[
							145.8107077840001,
							-37.864450886999975
						],
						[
							145.81762077400003,
							-37.857737887999974
						],
						[
							145.80455479700004,
							-37.85158689699995
						],
						[
							145.81121480700006,
							-37.836120896999944
						],
						[
							145.80385779000005,
							-37.82604488599998
						],
						[
							145.79376580100006,
							-37.82628089599996
						],
						[
							145.7949557720001,
							-37.815095905999954
						],
						[
							145.80961779100005,
							-37.80753589699998
						],
						[
							145.8292477770001,
							-37.812096887999985
						],
						[
							145.84471180600008,
							-37.797612888999936
						],
						[
							145.8927497740001,
							-37.82543589299996
						],
						[
							145.90547275300003,
							-37.81636989399993
						],
						[
							145.92638575800004,
							-37.829632894999975
						],
						[
							145.9290117810001,
							-37.79836090499998
						],
						[
							145.91747278600008,
							-37.77750990399994
						],
						[
							145.936776763,
							-37.77156591599993
						],
						[
							145.94361978300003,
							-37.75821890599997
						],
						[
							146.03863875500008,
							-37.774441912999976
						],
						[
							146.0677737410001,
							-37.768966914999965
						],
						[
							146.08910075900008,
							-37.75377791699998
						],
						[
							146.1213297390001,
							-37.78817892899997
						],
						[
							146.1337667470001,
							-37.78801292999998
						],
						[
							146.1422757370001,
							-37.771868920999964
						],
						[
							146.15688172600005,
							-37.76504792199995
						],
						[
							146.16322973700005,
							-37.747335921999934
						],
						[
							146.15308872200012,
							-37.71806493099996
						],
						[
							146.13555376700003,
							-37.70206492999995
						],
						[
							146.14267374700012,
							-37.69141591999994
						],
						[
							146.13232476000007,
							-37.67688791899997
						],
						[
							146.13095276400009,
							-37.64389590899998
						],
						[
							146.14416576400004,
							-37.627415929999984
						],
						[
							146.15854877100003,
							-37.630279910999946
						],
						[
							146.16483075100007,
							-37.62298292099996
						],
						[
							146.16130474500005,
							-37.59624792099993
						],
						[
							146.17198774200006,
							-37.599471921999964
						],
						[
							146.17325575300003,
							-37.58868892199996
						],
						[
							146.18640776200004,
							-37.580052912999975
						],
						[
							146.1919287500001,
							-37.58751692299995
						],
						[
							146.18601071700004,
							-37.53481057199997
						],
						[
							145.8263261300001,
							-37.52812325599996
						],
						[
							145.80918977800002,
							-37.56437824499994
						],
						[
							145.79084995200003,
							-37.56200665399996
						],
						[
							145.75536042600004,
							-37.57475145099994
						],
						[
							145.73869460000003,
							-37.56637865999994
						],
						[
							145.73057839000012,
							-37.58209390999997
						],
						[
							145.73734745700006,
							-37.593978609999965
						],
						[
							145.67585836500007,
							-37.62418233599993
						],
						[
							145.65929586800007,
							-37.61777990499996
						],
						[
							145.6406806550001,
							-37.58922506299996
						],
						[
							145.61492553100004,
							-37.571031640999934
						],
						[
							145.60248031300011,
							-37.57604041999997
						],
						[
							145.59987355400006,
							-37.56606418999996
						],
						[
							145.57802983700003,
							-37.57204099899997
						],
						[
							145.56260318700004,
							-37.59323124799994
						],
						[
							145.5314805270001,
							-37.556853494999984
						],
						[
							145.52536075700004,
							-37.56368959499997
						],
						[
							145.5079828910001,
							-37.55589264399998
						],
						[
							145.50876198000003,
							-37.563633693999975
						],
						[
							145.4819963550001,
							-37.56011782199994
						],
						[
							145.48200931600002,
							-37.55466579199998
						],
						[
							145.46992054700002,
							-37.557658910999976
						],
						[
							145.4677583990001,
							-37.54980889099994
						],
						[
							145.43781800400006,
							-37.545864248999976
						],
						[
							145.44053645500003,
							-37.533421128999976
						],
						[
							145.4260037570001,
							-37.53498741799996
						],
						[
							145.4182307200001,
							-37.526383616999965
						],
						[
							145.40345903200011,
							-37.52711884599995
						],
						[
							145.39390639200008,
							-37.540880055999935
						],
						[
							145.36641766600007,
							-37.545112813999935
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "206",
				"CED_NAME21": "Casey",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 2480.8197,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/206",
				"SHAPE_Leng": 3.72728660296,
				"SHAPE_Area": 0.253506004829
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							145.1541979430001,
							-37.81754792099997
						],
						[
							145.11503572000004,
							-37.81688082799997
						],
						[
							145.11138855800004,
							-37.83749361799994
						],
						[
							145.0982131610001,
							-37.835964926999964
						],
						[
							145.093659569,
							-37.861362156999974
						],
						[
							145.08823201600012,
							-37.89296327599993
						],
						[
							145.1244827490001,
							-37.89913889899998
						],
						[
							145.1273816470001,
							-37.914552208999964
						],
						[
							145.19549158400002,
							-37.92311495399997
						],
						[
							145.2056528920001,
							-37.924387854999964
						],
						[
							145.20834688500008,
							-37.89903485499997
						],
						[
							145.19087288000003,
							-37.88056986299995
						],
						[
							145.19570971100006,
							-37.865163043999985
						],
						[
							145.16923294600008,
							-37.862002201999985
						],
						[
							145.16438096800005,
							-37.84679197099996
						],
						[
							145.1544009600001,
							-37.845400230999985
						],
						[
							145.1541979430001,
							-37.81754792099997
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "207",
				"CED_NAME21": "Chisholm",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 76.6618,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/207",
				"SHAPE_Leng": 0.488209401489,
				"SHAPE_Area": 0.00785022611551
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							144.98687106700004,
							-37.77436482899998
						],
						[
							145.00809994200006,
							-37.786894839999945
						],
						[
							145.00195118200008,
							-37.79664577999995
						],
						[
							145.01998761800007,
							-37.803526870999974
						],
						[
							145.0131835510001,
							-37.78564749099996
						],
						[
							145.04043239600003,
							-37.78975453299995
						],
						[
							145.04020252600003,
							-37.784208682999974
						],
						[
							145.027833621,
							-37.76380765199997
						],
						[
							145.03199641300012,
							-37.737747071999934
						],
						[
							145.03860718300007,
							-37.72731065199997
						],
						[
							145.06078096900012,
							-37.72948950399996
						],
						[
							145.07453157800012,
							-37.716121183999974
						],
						[
							145.0749546090001,
							-37.70877598399994
						],
						[
							145.05133075300012,
							-37.70837113299996
						],
						[
							145.05822524300004,
							-37.69996939299995
						],
						[
							144.97206678800012,
							-37.69098585699993
						],
						[
							144.9825020950001,
							-37.70322784799998
						],
						[
							144.96721695500003,
							-37.728816836999954
						],
						[
							144.98062749200005,
							-37.73936139799997
						],
						[
							144.98687106700004,
							-37.77436482899998
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "208",
				"CED_NAME21": "Cooper",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 59.2107,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/208",
				"SHAPE_Leng": 0.591869885271,
				"SHAPE_Area": 0.00605207469605
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								144.2293449130001,
								-38.39837085199997
							],
							[
								144.25404215900005,
								-38.395444803999965
							],
							[
								144.25663885000006,
								-38.382733823999956
							],
							[
								144.27951609700006,
								-38.37233378499997
							],
							[
								144.30348600500008,
								-38.34824484599994
							],
							[
								144.32744953200006,
								-38.34016391799997
							],
							[
								144.3322922430001,
								-38.32324479799996
							],
							[
								144.4289690500001,
								-38.28151200399998
							],
							[
								144.49989915700007,
								-38.290476558999956
							],
							[
								144.4948835880001,
								-38.28261356899998
							],
							[
								144.50843778700005,
								-38.27477732999995
							],
							[
								144.53871522200006,
								-38.27161799199996
							],
							[
								144.61388516600005,
								-38.29223968699995
							],
							[
								144.62196499700008,
								-38.27514982699995
							],
							[
								144.65987626000003,
								-38.27385915999997
							],
							[
								144.67174003900004,
								-38.26464896999994
							],
							[
								144.63298959500003,
								-38.269775307999964
							],
							[
								144.62386182900002,
								-38.24988078699994
							],
							[
								144.6293410280001,
								-38.25197978799997
							],
							[
								144.66616002600006,
								-38.210048779999966
							],
							[
								144.69340779300012,
								-38.194321850999984
							],
							[
								144.70342174000007,
								-38.20157287199993
							],
							[
								144.69399511000006,
								-38.21704220199996
							],
							[
								144.70074902900012,
								-38.21974117199994
							],
							[
								144.71963618000007,
								-38.17324240299996
							],
							[
								144.7202057930001,
								-38.14661822299996
							],
							[
								144.7063376970001,
								-38.13015821199997
							],
							[
								144.67816682400007,
								-38.11539344999994
							],
							[
								144.6326260730001,
								-38.10735678699996
							],
							[
								144.555425441,
								-38.155728901999964
							],
							[
								144.46966808500008,
								-38.16327882599995
							],
							[
								144.44071012200004,
								-38.14776795399996
							],
							[
								144.42560409700002,
								-38.12379978299998
							],
							[
								144.416906906,
								-38.15512779299996
							],
							[
								144.40667566700006,
								-38.15464807199993
							],
							[
								144.3975143140001,
								-38.200771171999975
							],
							[
								144.38512172600008,
								-38.20158527099994
							],
							[
								144.3583410230001,
								-38.184460798999964
							],
							[
								144.3483906140001,
								-38.19292596799994
							],
							[
								144.3114780190001,
								-38.200712805999956
							],
							[
								144.29065499600006,
								-38.17172879499998
							],
							[
								144.2884230290001,
								-38.147636803999944
							],
							[
								144.26238156400007,
								-38.141256072999965
							],
							[
								144.26815502800002,
								-38.09281880299994
							],
							[
								144.28648718700003,
								-38.07907922399994
							],
							[
								144.2583211640001,
								-38.059790061999934
							],
							[
								144.2393160570001,
								-38.057099790999985
							],
							[
								144.23481404000006,
								-38.041066789999945
							],
							[
								144.21784906300002,
								-38.04118177899994
							],
							[
								144.2106320260001,
								-38.02422279799998
							],
							[
								144.1897356400001,
								-38.01888060699997
							],
							[
								144.19534572200007,
								-37.988866446999964
							],
							[
								144.16351338900006,
								-37.976613414999974
							],
							[
								144.13414907100002,
								-38.00259077299995
							],
							[
								144.11334016500007,
								-38.000143821999984
							],
							[
								144.11099405400012,
								-38.01273580199995
							],
							[
								144.09717081700012,
								-38.00975464099997
							],
							[
								144.09378507200006,
								-38.06546978099993
							],
							[
								144.07834305500012,
								-38.05763278999996
							],
							[
								144.0545871390001,
								-38.06172762899996
							],
							[
								144.04602183200006,
								-38.05155059799995
							],
							[
								144.0156418680001,
								-38.048212285999966
							],
							[
								144.01714723700002,
								-38.052661615999966
							],
							[
								144.00112745900003,
								-38.05489258499995
							],
							[
								143.99493009100001,
								-38.04669376499993
							],
							[
								143.85691296700008,
								-38.030322775999934
							],
							[
								143.8580062840001,
								-38.059766725999964
							],
							[
								143.82316014100002,
								-38.05577875399996
							],
							[
								143.81859766900004,
								-38.08013715399994
							],
							[
								143.8284165660001,
								-38.09218069399998
							],
							[
								143.80987146600012,
								-38.12768561299998
							],
							[
								143.90069249900012,
								-38.138528778999955
							],
							[
								143.91251601400006,
								-38.16001980999994
							],
							[
								144.0624132060001,
								-38.172386159999974
							],
							[
								144.04977306400008,
								-38.21471977899995
							],
							[
								144.05581830200003,
								-38.224262789999955
							],
							[
								144.04771902900006,
								-38.27353077899994
							],
							[
								144.02739006100012,
								-38.28105276799994
							],
							[
								144.01278305100004,
								-38.31372678699995
							],
							[
								144.0826540370001,
								-38.32540279199998
							],
							[
								144.0804520260001,
								-38.338043581999955
							],
							[
								144.10772501200006,
								-38.331601803999945
							],
							[
								144.10874650200003,
								-38.32460333399996
							],
							[
								144.12805900800004,
								-38.33084179499997
							],
							[
								144.150675975,
								-38.32135882599994
							],
							[
								144.149301024,
								-38.33225278599997
							],
							[
								144.1652683100001,
								-38.34269217699995
							],
							[
								144.16671542100005,
								-38.336501296999984
							],
							[
								144.20310803400002,
								-38.34091678999994
							],
							[
								144.19606700300005,
								-38.35955379999996
							],
							[
								144.20407702900002,
								-38.38079878999997
							],
							[
								144.234260005,
								-38.37293379199997
							],
							[
								144.2293449130001,
								-38.39837085199997
							]
						]
					],
					[
						[
							[
								144.66778183100007,
								-38.255060829999934
							],
							[
								144.7020153960001,
								-38.24311549199996
							],
							[
								144.67883373900008,
								-38.25061772099997
							],
							[
								144.6787255910001,
								-38.23758558099996
							],
							[
								144.66319097200005,
								-38.25186286999997
							],
							[
								144.6720250290001,
								-38.26435395999994
							],
							[
								144.66778183100007,
								-38.255060829999934
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "209",
				"CED_NAME21": "Corangamite",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 1507.0578,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/209",
				"SHAPE_Leng": 3.54723611895,
				"SHAPE_Area": 0.154973506582
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							144.2583211640001,
							-38.059790061999934
						],
						[
							144.28648718700003,
							-38.07907922399994
						],
						[
							144.26815502800002,
							-38.09281880299994
						],
						[
							144.26238156400007,
							-38.141256072999965
						],
						[
							144.2884230290001,
							-38.147636803999944
						],
						[
							144.29065499600006,
							-38.17172879499998
						],
						[
							144.3114780190001,
							-38.200712805999956
						],
						[
							144.3483906140001,
							-38.19292596799994
						],
						[
							144.3583410230001,
							-38.184460798999964
						],
						[
							144.38512172600008,
							-38.20158527099994
						],
						[
							144.3975143140001,
							-38.200771171999975
						],
						[
							144.40667566700006,
							-38.15464807199993
						],
						[
							144.38480604300003,
							-38.143241760999956
						],
						[
							144.36857905500005,
							-38.146509839999965
						],
						[
							144.35562298800005,
							-38.13718781899996
						],
						[
							144.36658790900003,
							-38.10989184899995
						],
						[
							144.36161191100007,
							-38.105122878999964
						],
						[
							144.38158116800003,
							-38.09733877999997
						],
						[
							144.38875706900012,
							-38.077116789999934
						],
						[
							144.39794896800004,
							-38.07380321099998
						],
						[
							144.4135262540001,
							-38.08447468199995
						],
						[
							144.44326454800012,
							-38.08625279399996
						],
						[
							144.44494752700007,
							-38.09180299399998
						],
						[
							144.458765147,
							-38.07722784499998
						],
						[
							144.47091822400012,
							-38.08352877599998
						],
						[
							144.47874498300007,
							-38.07668370599998
						],
						[
							144.50685184700012,
							-38.09149476799996
						],
						[
							144.5151749800001,
							-38.04604176899994
						],
						[
							144.55866924300005,
							-38.03752781099996
						],
						[
							144.59158389100003,
							-38.00443240299995
						],
						[
							144.573388055,
							-37.99919417199993
						],
						[
							144.56782965700006,
							-37.98450221199994
						],
						[
							144.5546493600001,
							-37.984772290999956
						],
						[
							144.54755340200006,
							-37.97185809999996
						],
						[
							144.52407455600007,
							-37.973355348999974
						],
						[
							144.51869759600004,
							-37.980999837999946
						],
						[
							144.495644641,
							-37.97426198699998
						],
						[
							144.49646147200008,
							-37.964204406999954
						],
						[
							144.47402449900005,
							-37.93566828499996
						],
						[
							144.48262056900012,
							-37.92325637599998
						],
						[
							144.47811768100007,
							-37.91077933499997
						],
						[
							144.4847784200001,
							-37.90896906599994
						],
						[
							144.4808029520001,
							-37.89031592499998
						],
						[
							144.444067022,
							-37.86402080299996
						],
						[
							144.4218150270001,
							-37.84657380099998
						],
						[
							144.42105904000005,
							-37.82033980099993
						],
						[
							144.40636304500003,
							-37.800920789999964
						],
						[
							144.3991245850001,
							-37.81521903999993
						],
						[
							144.36199380200003,
							-37.81081632699994
						],
						[
							144.35331332900012,
							-37.84529050699996
						],
						[
							144.32283580500007,
							-37.844699814999956
						],
						[
							144.29425474100003,
							-37.828914862999966
						],
						[
							144.29602192200002,
							-37.81955152299997
						],
						[
							144.222451846,
							-37.81018783799993
						],
						[
							144.2106823460001,
							-37.824980696999944
						],
						[
							144.23021415200003,
							-37.83384966899996
						],
						[
							144.23421738800005,
							-37.86664626899994
						],
						[
							144.24846655500005,
							-37.87376978999998
						],
						[
							144.2134373980001,
							-37.90143418799994
						],
						[
							144.20252593600003,
							-37.93824459699994
						],
						[
							144.23684042000002,
							-37.94236930999995
						],
						[
							144.2354840380001,
							-37.964544789999934
						],
						[
							144.24773004300005,
							-37.99131979099997
						],
						[
							144.24071605200004,
							-38.00854478999997
						],
						[
							144.262691205,
							-38.043695011999944
						],
						[
							144.2583211640001,
							-38.059790061999934
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "210",
				"CED_NAME21": "Corio",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 772.5066,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/210",
				"SHAPE_Leng": 2.12604598757,
				"SHAPE_Area": 0.0792229803105
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							145.31797933200005,
							-37.84390566199994
						],
						[
							145.31681352500004,
							-37.81814561199997
						],
						[
							145.30429343700007,
							-37.821524840999984
						],
						[
							145.30788552100012,
							-37.777542850999964
						],
						[
							145.28957843600006,
							-37.76280578999996
						],
						[
							145.2405751540001,
							-37.764749965999954
						],
						[
							145.23597118200007,
							-37.79007326599998
						],
						[
							145.21721197500005,
							-37.79086976499997
						],
						[
							145.21336571300003,
							-37.817208894999965
						],
						[
							145.1541979430001,
							-37.81754792099997
						],
						[
							145.1544009600001,
							-37.845400230999985
						],
						[
							145.16438096800005,
							-37.84679197099996
						],
						[
							145.16923294600008,
							-37.862002201999985
						],
						[
							145.19570971100006,
							-37.865163043999985
						],
						[
							145.21674755000004,
							-37.83814442499994
						],
						[
							145.28728020800008,
							-37.83331421999998
						],
						[
							145.31797933200005,
							-37.84390566199994
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "211",
				"CED_NAME21": "Deakin",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 84.5511,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/211",
				"SHAPE_Leng": 0.576194793764,
				"SHAPE_Area": 0.00865133165925
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							145.06124377700007,
							-38.20142284699995
						],
						[
							145.06332989500004,
							-38.215119836999975
						],
						[
							145.09362168000007,
							-38.216751518999956
						],
						[
							145.09934633800003,
							-38.22488058899995
						],
						[
							145.1335397150001,
							-38.19565497099995
						],
						[
							145.1523933420001,
							-38.194465632999936
						],
						[
							145.15906788200004,
							-38.181557572999964
						],
						[
							145.18182241600005,
							-38.19905120499993
						],
						[
							145.2157726700001,
							-38.20063904699998
						],
						[
							145.23958917900006,
							-38.07766384799993
						],
						[
							145.156259545,
							-38.067382271999975
						],
						[
							145.1486707250001,
							-38.083397221999974
						],
						[
							145.12279277900006,
							-38.084986829999934
						],
						[
							145.11775613300006,
							-38.14386775999998
						],
						[
							145.08755611700008,
							-38.16422445799998
						],
						[
							145.06124377700007,
							-38.20142284699995
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "212",
				"CED_NAME21": "Dunkley",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 152.8058,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/212",
				"SHAPE_Leng": 0.61346323926,
				"SHAPE_Area": 0.0157042996534
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								145.06124377700007,
								-38.20142284699995
							],
							[
								145.0449577290001,
								-38.213391824999974
							],
							[
								145.03242575100012,
								-38.212659894999945
							],
							[
								145.02709645800007,
								-38.25026604399994
							],
							[
								144.98297292000007,
								-38.296169791999944
							],
							[
								144.99445862700009,
								-38.30529172299998
							],
							[
								144.982459908,
								-38.32190485199993
							],
							[
								144.923179795,
								-38.34924279799998
							],
							[
								144.85963297400008,
								-38.36703479399995
							],
							[
								144.82852574000003,
								-38.37018579199997
							],
							[
								144.77455277,
								-38.35945679799994
							],
							[
								144.74572773800003,
								-38.34006713599996
							],
							[
								144.73901105000004,
								-38.32459682499996
							],
							[
								144.68023029300002,
								-38.30520551099994
							],
							[
								144.65170372800003,
								-38.30376548899994
							],
							[
								144.74175496700002,
								-38.35393386599998
							],
							[
								144.83857981100005,
								-38.43031478299997
							],
							[
								144.88665886800004,
								-38.477203815999985
							],
							[
								144.88805674500009,
								-38.499283866999974
							],
							[
								144.89466383500007,
								-38.49144280699994
							],
							[
								144.93741557600003,
								-38.497069299999964
							],
							[
								144.94881916500003,
								-38.488535110999976
							],
							[
								144.97663668000007,
								-38.49032160199994
							],
							[
								145.01100500500002,
								-38.47964884499993
							],
							[
								145.03127086100005,
								-38.48706782599993
							],
							[
								145.02514076300008,
								-38.475318855999944
							],
							[
								145.04716318400006,
								-38.433767546999945
							],
							[
								145.07639001000007,
								-38.425432858999955
							],
							[
								145.0961544590001,
								-38.40249377999993
							],
							[
								145.13411099300004,
								-38.39020020299995
							],
							[
								145.234577843,
								-38.40959946999993
							],
							[
								145.2152047400001,
								-38.38310027799997
							],
							[
								145.1839920660001,
								-38.37457349599998
							],
							[
								145.19641282500004,
								-38.36657324699996
							],
							[
								145.2109287710001,
								-38.37866019799998
							],
							[
								145.22195763900004,
								-38.37778416899994
							],
							[
								145.2134689820001,
								-38.365895887999955
							],
							[
								145.21878645300012,
								-38.34759091799998
							],
							[
								145.19285449000006,
								-38.324494035999976
							],
							[
								145.20051690000003,
								-38.31169698699995
							],
							[
								145.19294019300003,
								-38.29654385599997
							],
							[
								145.1999920620001,
								-38.293064786999935
							],
							[
								145.20620914000006,
								-38.30378685699998
							],
							[
								145.2230259370001,
								-38.30644877799995
							],
							[
								145.22565970000005,
								-38.27241484799998
							],
							[
								145.26173669700006,
								-38.24241283099997
							],
							[
								145.2542258410001,
								-38.22359686999994
							],
							[
								145.2265470960001,
								-38.21893758799996
							],
							[
								145.2157726700001,
								-38.20063904699998
							],
							[
								145.18182241600005,
								-38.19905120499993
							],
							[
								145.15906788200004,
								-38.181557572999964
							],
							[
								145.1523933420001,
								-38.194465632999936
							],
							[
								145.1335397150001,
								-38.19565497099995
							],
							[
								145.09934633800003,
								-38.22488058899995
							],
							[
								145.09362168000007,
								-38.216751518999956
							],
							[
								145.06332989500004,
								-38.215119836999975
							],
							[
								145.06124377700007,
								-38.20142284699995
							]
						]
					],
					[
						[
							[
								145.27658425800007,
								-38.38755550299993
							],
							[
								145.26564378800003,
								-38.402802091999945
							],
							[
								145.27038568700004,
								-38.40909875199998
							],
							[
								145.28134119600008,
								-38.40435900299997
							],
							[
								145.27539833800006,
								-38.39487525299995
							],
							[
								145.28713940500006,
								-38.39563719299997
							],
							[
								145.31106212100008,
								-38.40189705499995
							],
							[
								145.31976867800006,
								-38.412840605999975
							],
							[
								145.3525575010001,
								-38.420035387999974
							],
							[
								145.36146857100005,
								-38.406507578999936
							],
							[
								145.38594929700002,
								-38.406707919999974
							],
							[
								145.39037295800006,
								-38.38511584099996
							],
							[
								145.40609269700008,
								-38.372749831999954
							],
							[
								145.476257765,
								-38.36644183599998
							],
							[
								145.5034158520001,
								-38.353279887999975
							],
							[
								145.47255773000006,
								-38.33229890599995
							],
							[
								145.45237575600004,
								-38.30684284399996
							],
							[
								145.3519987640001,
								-38.31124789699993
							],
							[
								145.3303656590001,
								-38.29235382599995
							],
							[
								145.297266916,
								-38.28200185299994
							],
							[
								145.28938401800008,
								-38.28465190299994
							],
							[
								145.2859608660001,
								-38.30531200299998
							],
							[
								145.2975918730001,
								-38.30932694399996
							],
							[
								145.28723493500001,
								-38.30960901299994
							],
							[
								145.27351596200003,
								-38.35747476199998
							],
							[
								145.27658425800007,
								-38.38755550299993
							]
						]
					],
					[
						[
							[
								145.3660753790001,
								-38.41637562899996
							],
							[
								145.37210904800008,
								-38.41759973899997
							],
							[
								145.36951630900012,
								-38.411414408999974
							],
							[
								145.3660753790001,
								-38.41637562899996
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "213",
				"CED_NAME21": "Flinders",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 871.1895,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/213",
				"SHAPE_Leng": 3.01748526255,
				"SHAPE_Area": 0.0897808950445
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							144.76914349100002,
							-37.81200357399996
						],
						[
							144.8267661000001,
							-37.81688683799996
						],
						[
							144.82742039900006,
							-37.82281840799993
						],
						[
							144.8692338830001,
							-37.81118849099994
						],
						[
							144.88347151100004,
							-37.81281120199998
						],
						[
							144.88213773000007,
							-37.820252051999944
						],
						[
							144.90556845600008,
							-37.82287487399998
						],
						[
							144.91649936600004,
							-37.79820110399993
						],
						[
							144.89721215200007,
							-37.77943350299995
						],
						[
							144.90165420300002,
							-37.76543629299994
						],
						[
							144.8847534260001,
							-37.76149631199996
						],
						[
							144.8852343960001,
							-37.75600221199994
						],
						[
							144.87256261800007,
							-37.76209833099995
						],
						[
							144.87284161700006,
							-37.772231560999955
						],
						[
							144.85244174000002,
							-37.773032669999964
						],
						[
							144.84686494400012,
							-37.748051878999945
						],
						[
							144.8349890170001,
							-37.741603977999944
						],
						[
							144.8373382970001,
							-37.73524274799996
						],
						[
							144.8275603190001,
							-37.73424317799993
						],
						[
							144.8304214090001,
							-37.72458371799996
						],
						[
							144.78201346700007,
							-37.727555534999965
						],
						[
							144.76914349100002,
							-37.81200357399996
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "214",
				"CED_NAME21": "Fraser",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 88.3957,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/214",
				"SHAPE_Leng": 0.523532606277,
				"SHAPE_Area": 0.00904045654867
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							144.74049602200012,
							-37.94126581299997
						],
						[
							144.7991754530001,
							-37.92315731699995
						],
						[
							144.8077408360001,
							-37.880629806999934
						],
						[
							144.81957246500008,
							-37.87251470799998
						],
						[
							144.84022003200005,
							-37.871493588999954
						],
						[
							144.8685874680001,
							-37.85869906099998
						],
						[
							144.8789875550001,
							-37.86816590199993
						],
						[
							144.90291238100008,
							-37.87273982399995
						],
						[
							144.91314509000006,
							-37.86745282399994
						],
						[
							144.89527312500002,
							-37.84875990299997
						],
						[
							144.9055989730001,
							-37.85171887399997
						],
						[
							144.89836795500003,
							-37.841190892999975
						],
						[
							144.90556845600008,
							-37.82287487399998
						],
						[
							144.88213773000007,
							-37.820252051999944
						],
						[
							144.88347151100004,
							-37.81281120199998
						],
						[
							144.8692338830001,
							-37.81118849099994
						],
						[
							144.82742039900006,
							-37.82281840799993
						],
						[
							144.8267661000001,
							-37.81688683799996
						],
						[
							144.76914349100002,
							-37.81200357399996
						],
						[
							144.70852865200004,
							-37.80677463999996
						],
						[
							144.706003978,
							-37.84432882999994
						],
						[
							144.7133179860001,
							-37.85116082099995
						],
						[
							144.75254438900004,
							-37.85443293299994
						],
						[
							144.75783348700008,
							-37.86505193399995
						],
						[
							144.71895800200002,
							-37.878028610999934
						],
						[
							144.71354398900007,
							-37.91485482099995
						],
						[
							144.72830772500004,
							-37.92707043199994
						],
						[
							144.7427709530001,
							-37.92880182299996
						],
						[
							144.74049602200012,
							-37.94126581299997
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "215",
				"CED_NAME21": "Gellibrand",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 145.9642,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/215",
				"SHAPE_Leng": 0.82877058435,
				"SHAPE_Area": 0.0149442561451
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								146.52145570200003,
								-38.68897554399996
							],
							[
								146.54120559900002,
								-38.68536293599993
							],
							[
								146.53916655800003,
								-38.69825599599994
							],
							[
								146.55121465500008,
								-38.70377595699995
							],
							[
								146.552769527,
								-38.689276966999955
							],
							[
								146.56245640400005,
								-38.69803493699993
							],
							[
								146.56675157400002,
								-38.691105927999956
							],
							[
								146.56265149600006,
								-38.68301493699994
							],
							[
								146.54619558800005,
								-38.68480396599995
							],
							[
								146.56254060600008,
								-38.67822693699998
							],
							[
								146.57214543400005,
								-38.68329393799996
							],
							[
								146.57134948500004,
								-38.67752097799996
							],
							[
								146.57682940200004,
								-38.69212996799996
							],
							[
								146.57765847300004,
								-38.68114392799998
							],
							[
								146.58383248200005,
								-38.68140996899996
							],
							[
								146.5826985000001,
								-38.69846199899996
							],
							[
								146.5936756200001,
								-38.68475498999993
							],
							[
								146.58442538200006,
								-38.67707393899997
							],
							[
								146.60064951900006,
								-38.679557959999954
							],
							[
								146.64103465300002,
								-38.66888899299994
							],
							[
								146.65280053200001,
								-38.65872394399997
							],
							[
								146.64593966500001,
								-38.65069792299994
							],
							[
								146.65320554400012,
								-38.642960983999956
							],
							[
								146.67066443900012,
								-38.66289697499997
							],
							[
								146.65755652000007,
								-38.67147793399994
							],
							[
								146.6977134120001,
								-38.67533694699995
							],
							[
								146.69611142300005,
								-38.66998195699995
							],
							[
								146.71639345100004,
								-38.66088593899997
							],
							[
								146.71291836300009,
								-38.64776391799995
							],
							[
								146.7421795260001,
								-38.66491200099995
							],
							[
								146.75352347500007,
								-38.65256993199995
							],
							[
								146.7765595310001,
								-38.654203982999945
							],
							[
								146.76662569300004,
								-38.649939952999944
							],
							[
								146.78591338,
								-38.646228003999965
							],
							[
								146.79495265100002,
								-38.62538299499994
							],
							[
								146.78471242400008,
								-38.62278100399993
							],
							[
								146.79944437000006,
								-38.62864299499995
							],
							[
								146.79810263100012,
								-38.62019594499998
							],
							[
								146.82535750800002,
								-38.60970996699996
							],
							[
								146.842043514,
								-38.616359977999934
							],
							[
								146.84401057500008,
								-38.60482196799995
							],
							[
								146.88255467800002,
								-38.60459400099995
							],
							[
								146.8864293370001,
								-38.61438501099997
							],
							[
								146.89867942500007,
								-38.61220493199994
							],
							[
								146.925522472,
								-38.59421196399995
							],
							[
								146.88715152600003,
								-38.62013997099996
							],
							[
								146.88353962500003,
								-38.63443394099994
							],
							[
								147.06725357200003,
								-38.47510599399993
							],
							[
								147.54257532600002,
								-38.103807718999974
							],
							[
								147.75127570600011,
								-37.97332762499997
							],
							[
								147.9350210240001,
								-37.89972216899997
							],
							[
								148.17918365100002,
								-37.83162246799998
							],
							[
								148.34489778600005,
								-37.80554274199994
							],
							[
								148.52129043700006,
								-37.80144890599996
							],
							[
								148.626581858,
								-37.80820611499996
							],
							[
								148.698129837,
								-37.80157640099998
							],
							[
								148.72334567200005,
								-37.80717720299998
							],
							[
								148.72779079000009,
								-37.81542423399998
							],
							[
								148.74919215900002,
								-37.79702387499998
							],
							[
								148.80873840000004,
								-37.78640422999996
							],
							[
								148.88415577700005,
								-37.78994532699994
							],
							[
								148.9263632410001,
								-37.78138988999996
							],
							[
								149.1242313880001,
								-37.77727380699997
							],
							[
								149.24671576700007,
								-37.78046136699993
							],
							[
								149.26593363300003,
								-37.78930621899997
							],
							[
								149.26539588100002,
								-37.79844408899993
							],
							[
								149.27550275900012,
								-37.80376411999998
							],
							[
								149.29245303800008,
								-37.78744717099994
							],
							[
								149.34038402200008,
								-37.776900474999934
							],
							[
								149.43102683600011,
								-37.77736416299996
							],
							[
								149.46189338200008,
								-37.76928963599994
							],
							[
								149.48496319800006,
								-37.77542829799995
							],
							[
								149.49556093700005,
								-37.768212088999974
							],
							[
								149.49693873900003,
								-37.753353998999955
							],
							[
								149.51642440600006,
								-37.749069679999934
							],
							[
								149.52550604600003,
								-37.73727151099996
							],
							[
								149.5662953110001,
								-37.72456382499996
							],
							[
								149.59584391600004,
								-37.72656345699994
							],
							[
								149.60083360700003,
								-37.71204928699996
							],
							[
								149.616601166,
								-37.70060000899997
							],
							[
								149.67733394800007,
								-37.685069073999955
							],
							[
								149.68239749000008,
								-37.66414487399993
							],
							[
								149.70653569900003,
								-37.64351239599995
							],
							[
								149.73875301100009,
								-37.58502459899995
							],
							[
								149.76542136800003,
								-37.57384229099995
							],
							[
								149.7609993200001,
								-37.56689624099994
							],
							[
								149.77525286900004,
								-37.55782510199998
							],
							[
								149.819719823,
								-37.544815755999934
							],
							[
								149.90661418900004,
								-37.54285219299993
							],
							[
								149.92477549800003,
								-37.526334874999975
							],
							[
								149.96440062300007,
								-37.51794353799994
							],
							[
								149.97619755300002,
								-37.50514655899997
							],
							[
								149.08844964700006,
								-37.15676929999995
							],
							[
								148.1949512110001,
								-36.79624011299995
							],
							[
								148.18247886200004,
								-36.804882771999985
							],
							[
								148.17960061300005,
								-36.79631323199993
							],
							[
								148.15634663800006,
								-36.79002657999996
							],
							[
								148.12677633200008,
								-36.796439007999936
							],
							[
								148.11919966200003,
								-36.80576059699996
							],
							[
								148.09794882800009,
								-36.78728484499993
							],
							[
								148.1344704070001,
								-36.74372618799998
							],
							[
								147.96022089200005,
								-36.612414702999956
							],
							[
								147.54189364500007,
								-36.737555019999945
							],
							[
								147.52659963500003,
								-36.756471028999954
							],
							[
								147.52860961300007,
								-36.769612019999954
							],
							[
								147.47140561100002,
								-36.78305602499995
							],
							[
								147.45849166100004,
								-36.80301300399998
							],
							[
								147.43028165700002,
								-36.79480100199993
							],
							[
								147.40633463300003,
								-36.77761801999998
							],
							[
								147.40763567400006,
								-36.76530500999996
							],
							[
								147.38013567000007,
								-36.750713007999934
							],
							[
								147.32616264900003,
								-36.749528003999956
							],
							[
								147.31611267300002,
								-36.73333800299997
							],
							[
								147.2965996260001,
								-36.733908930999974
							],
							[
								147.28890152600002,
								-36.74027607099998
							],
							[
								147.29007897300005,
								-36.76601022099993
							],
							[
								147.26793256500002,
								-36.779028668999956
							],
							[
								147.29345901700003,
								-36.811030510999956
							],
							[
								147.28293745700012,
								-36.82694885099994
							],
							[
								147.3332899280001,
								-36.829929204999985
							],
							[
								147.3417135730001,
								-36.861805034999975
							],
							[
								147.32431000500003,
								-36.86750560399997
							],
							[
								147.3208274640001,
								-36.882555803999935
							],
							[
								147.30705266600012,
								-36.88285000299993
							],
							[
								147.28925639600004,
								-36.90514946199994
							],
							[
								147.29277867400003,
								-36.91700851199994
							],
							[
								147.2811449950001,
								-36.92642093099994
							],
							[
								147.26330064900003,
								-37.00669199999993
							],
							[
								147.29379764300006,
								-37.006977992999964
							],
							[
								147.34998963100008,
								-37.03640300699993
							],
							[
								147.387459615,
								-37.03013999999996
							],
							[
								147.3922616220001,
								-37.04555701099997
							],
							[
								147.38034466300007,
								-37.05869687999996
							],
							[
								147.38052058800008,
								-37.09869999999995
							],
							[
								147.36505062000003,
								-37.101530998999976
							],
							[
								147.3592186090001,
								-37.11432900799997
							],
							[
								147.3164026170001,
								-37.11385099499995
							],
							[
								147.32548462400007,
								-37.12171901599993
							],
							[
								147.33149159900006,
								-37.153018016999965
							],
							[
								147.3444196060001,
								-37.16062800799995
							],
							[
								147.36879258800002,
								-37.19827201999993
							],
							[
								147.38452258400002,
								-37.20390401099996
							],
							[
								147.3369906040001,
								-37.27552531799995
							],
							[
								146.8263276980001,
								-37.203748977999965
							],
							[
								146.82363868000004,
								-37.191918957999974
							],
							[
								146.7878756870001,
								-37.17762195499995
							],
							[
								146.7634477050001,
								-37.14600797299994
							],
							[
								146.7454667180001,
								-37.14964895199995
							],
							[
								146.744153707,
								-37.15631996099995
							],
							[
								146.71757273100002,
								-37.15875995899995
							],
							[
								146.68455472900007,
								-37.14508296699995
							],
							[
								146.66486071400004,
								-37.12399296499996
							],
							[
								146.65153270700011,
								-37.12003396399996
							],
							[
								146.6385727280001,
								-37.128092952999964
							],
							[
								146.647177703,
								-37.16295496399994
							],
							[
								146.43584170500003,
								-37.618030930999964
							],
							[
								146.45229371300002,
								-37.614899941999965
							],
							[
								146.4730057060001,
								-37.63983594399997
							],
							[
								146.49073670300004,
								-37.644092945999944
							],
							[
								146.5160016640001,
								-37.67802494799997
							],
							[
								146.50234066500002,
								-37.690812956999935
							],
							[
								146.47331864400007,
								-37.99467895599997
							],
							[
								146.49104166200004,
								-37.98376894799998
							],
							[
								146.49724965100006,
								-37.98889794799993
							],
							[
								146.51468664800007,
								-37.98358194899998
							],
							[
								146.52405864900004,
								-37.96365794999997
							],
							[
								146.54699064500005,
								-37.967504951999956
							],
							[
								146.54493266400004,
								-37.97530194199993
							],
							[
								146.5544556530001,
								-37.97147494199993
							],
							[
								146.56380662000004,
								-37.98395795299996
							],
							[
								146.5872646260001,
								-37.97808795499998
							],
							[
								146.575266262,
								-38.03004996399994
							],
							[
								146.5669858440001,
								-38.030679593999935
							],
							[
								146.56951390000006,
								-38.058086343999946
							],
							[
								146.5347922960001,
								-38.056944870999985
							],
							[
								146.52791664400002,
								-38.08423995099997
							],
							[
								146.47572347400012,
								-38.07529503699993
							],
							[
								146.4789828900001,
								-38.10378684799997
							],
							[
								146.4244147400001,
								-38.09652811299998
							],
							[
								146.41743564900003,
								-38.11551294299994
							],
							[
								146.41436965100002,
								-38.105502942999976
							],
							[
								146.37438766900004,
								-38.10005993999994
							],
							[
								146.37656572900005,
								-38.09349837999997
							],
							[
								146.35913366300008,
								-38.087279938999984
							],
							[
								146.34179883700006,
								-38.08176711699997
							],
							[
								146.32690245900005,
								-38.08584346599997
							],
							[
								146.31850577800003,
								-38.10494212599997
							],
							[
								146.3280525660001,
								-38.10905890599997
							],
							[
								146.31298664700012,
								-38.11687192499994
							],
							[
								146.32175762600002,
								-38.11929451599997
							],
							[
								146.3227366640001,
								-38.13094694599994
							],
							[
								146.30672583400008,
								-38.156603924999956
							],
							[
								146.3255776000001,
								-38.164419976999966
							],
							[
								146.33698669800003,
								-38.16090097699998
							],
							[
								146.33723077700006,
								-38.167065976999936
							],
							[
								146.3164826410001,
								-38.169207255999936
							],
							[
								146.323290508,
								-38.184683065999934
							],
							[
								146.3110486700001,
								-38.18530593599996
							],
							[
								146.31273179800007,
								-38.19800576599994
							],
							[
								146.30408953800008,
								-38.20585588499995
							],
							[
								146.29592760000003,
								-38.20346394499995
							],
							[
								146.30303512700004,
								-38.21619997499994
							],
							[
								146.2582393,
								-38.264787241999954
							],
							[
								146.25230290700006,
								-38.298624651999944
							],
							[
								146.23230549800007,
								-38.316349000999935
							],
							[
								146.2285726880001,
								-38.323877109999955
							],
							[
								146.25052045400002,
								-38.32663800199998
							],
							[
								146.24352665100002,
								-38.356108921999976
							],
							[
								146.23150454400002,
								-38.354193340999984
							],
							[
								146.21051357500005,
								-38.37038238899993
							],
							[
								146.2408747490001,
								-38.37915900199994
							],
							[
								146.23439486000007,
								-38.38064608099995
							],
							[
								146.22319768500006,
								-38.43994478099995
							],
							[
								146.27219063500002,
								-38.44640924399994
							],
							[
								146.26927107500012,
								-38.45693968399996
							],
							[
								146.23718575100008,
								-38.45289393199994
							],
							[
								146.23842934900006,
								-38.46795587199995
							],
							[
								146.26257314400004,
								-38.47097681399998
							],
							[
								146.25476316300012,
								-38.49609674299995
							],
							[
								146.29180342600011,
								-38.50010495599997
							],
							[
								146.28361775500002,
								-38.51700289599995
							],
							[
								146.2903936130001,
								-38.52784292599995
							],
							[
								146.31332162900003,
								-38.51955193799995
							],
							[
								146.32731200600006,
								-38.53073671899995
							],
							[
								146.31244942700005,
								-38.54389119799998
							],
							[
								146.31270160500003,
								-38.56183294799996
							],
							[
								146.36762660300008,
								-38.57655094199998
							],
							[
								146.3688106610001,
								-38.59184933199998
							],
							[
								146.4276720890001,
								-38.60497097699994
							],
							[
								146.46313372300006,
								-38.59848740899997
							],
							[
								146.4615586430001,
								-38.60737157899996
							],
							[
								146.4780600690001,
								-38.613973390999945
							],
							[
								146.5256078100001,
								-38.61929586399998
							],
							[
								146.52145570200003,
								-38.68897554399996
							]
						]
					],
					[
						[
							[
								146.46289263000006,
								-38.71367197999996
							],
							[
								146.44609865300004,
								-38.71225197899997
							],
							[
								146.43877840200003,
								-38.72785391799994
							],
							[
								146.46840062800004,
								-38.717307990999984
							],
							[
								146.4933436230001,
								-38.725180931999944
							],
							[
								146.501927442,
								-38.716238972999975
							],
							[
								146.46289263000006,
								-38.71367197999996
							]
						]
					],
					[
						[
							[
								146.56778546700002,
								-38.742306937999956
							],
							[
								146.5461174290001,
								-38.75772996699993
							],
							[
								146.500921607,
								-38.76302997299996
							],
							[
								146.4980837280001,
								-38.75867199299995
							],
							[
								146.5238914140001,
								-38.752641994999976
							],
							[
								146.50825047700005,
								-38.752890933999936
							],
							[
								146.54164950400002,
								-38.727731965999965
							],
							[
								146.50818243900005,
								-38.73721699399994
							],
							[
								146.51559051800007,
								-38.73068495399997
							],
							[
								146.50308160100008,
								-38.72677798299998
							],
							[
								146.50958860100002,
								-38.71852093399997
							],
							[
								146.4950057220001,
								-38.729108982999946
							],
							[
								146.47134869600006,
								-38.728353950999974
							],
							[
								146.46461057600004,
								-38.73910896999996
							],
							[
								146.49476452600004,
								-38.774823942999944
							],
							[
								146.54534555500004,
								-38.79087596699998
							],
							[
								146.59763954000005,
								-38.759470929999964
							],
							[
								146.65600741000003,
								-38.75537395499998
							],
							[
								146.66773836900006,
								-38.747797935999984
							],
							[
								146.62256268600004,
								-38.75821796199995
							],
							[
								146.60135437000008,
								-38.752073920999976
							],
							[
								146.60293551100006,
								-38.74417994099997
							],
							[
								146.5842767140001,
								-38.74785094899994
							],
							[
								146.59197062300007,
								-38.74252096999993
							],
							[
								146.58322660500005,
								-38.742940988999976
							],
							[
								146.58041067600004,
								-38.734988948999955
							],
							[
								146.56778546700002,
								-38.742306937999956
							]
						]
					],
					[
						[
							[
								146.62698564900006,
								-38.72374795199994
							],
							[
								146.6729087020001,
								-38.71500399599995
							],
							[
								146.677616402,
								-38.708261935999985
							],
							[
								146.66285138500007,
								-38.70842797499995
							],
							[
								146.67283669300002,
								-38.703056955999955
							],
							[
								146.6642845550001,
								-38.701538924999966
							],
							[
								146.64827354800002,
								-38.70578494399996
							],
							[
								146.65329050700007,
								-38.70106093399994
							],
							[
								146.64295060900008,
								-38.69962498299998
							],
							[
								146.63029835100008,
								-38.70576595299997
							],
							[
								146.63672652000002,
								-38.69863192299994
							],
							[
								146.6145184940001,
								-38.70121798099996
							],
							[
								146.61844071400003,
								-38.697504941999966
							],
							[
								146.58572069800005,
								-38.71322497899996
							],
							[
								146.60220146300003,
								-38.72681893099997
							],
							[
								146.595558395,
								-38.72011195999994
							],
							[
								146.6011066850001,
								-38.71650798999997
							],
							[
								146.60183573400002,
								-38.72238993099995
							],
							[
								146.62698564900006,
								-38.72374795199994
							]
						]
					],
					[
						[
							[
								146.62972851900008,
								-38.72413099299996
							],
							[
								146.65264142400008,
								-38.72719298399994
							],
							[
								146.66925939200007,
								-38.71830195599995
							],
							[
								146.62972851900008,
								-38.72413099299996
							]
						]
					],
					[
						[
							[
								146.69663666100007,
								-38.687241976999985
							],
							[
								146.69841037000003,
								-38.69312194799994
							],
							[
								146.71574546800002,
								-38.68713199899997
							],
							[
								146.70818365000002,
								-38.67669297799995
							],
							[
								146.69663666100007,
								-38.687241976999985
							]
						]
					],
					[
						[
							[
								146.66875971700006,
								-38.68259294499995
							],
							[
								146.68336956300004,
								-38.689688985999965
							],
							[
								146.67657064500008,
								-38.684123925999984
							],
							[
								146.68540645400003,
								-38.67784597699995
							],
							[
								146.66875971700006,
								-38.68259294499995
							]
						]
					],
					[
						[
							[
								146.7240934880001,
								-38.67727195899994
							],
							[
								146.73946659500007,
								-38.67289797099994
							],
							[
								146.72779860900005,
								-38.66121397999996
							],
							[
								146.7206256180001,
								-38.67644692899995
							],
							[
								146.70989941000005,
								-38.67656194799997
							],
							[
								146.71529147800004,
								-38.68389695899998
							],
							[
								146.7240934880001,
								-38.67727195899994
							]
						]
					],
					[
						[
							[
								146.76332054300008,
								-38.65905793199994
							],
							[
								146.77438260100007,
								-38.65975499299998
							],
							[
								146.75661049500002,
								-38.65389897199998
							],
							[
								146.76332054300008,
								-38.65905793199994
							]
						]
					],
					[
						[
							[
								146.8136013620001,
								-38.67666499599994
							],
							[
								146.75288340100008,
								-38.68964796199998
							],
							[
								146.78891543600002,
								-38.68059495399996
							],
							[
								146.82572256900005,
								-38.68484394699993
							],
							[
								146.80637652300004,
								-38.67993498599998
							],
							[
								146.82213265000007,
								-38.678632956999934
							],
							[
								146.8136013620001,
								-38.67666499599994
							]
						]
					],
					[
						[
							[
								146.86830332600005,
								-38.64614489999997
							],
							[
								146.8789733650001,
								-38.63806895099998
							],
							[
								146.8639394180001,
								-38.63848799999994
							],
							[
								146.8355336310001,
								-38.65415798799995
							],
							[
								146.85809952700004,
								-38.65270997899995
							],
							[
								146.82844232900004,
								-38.67948299699998
							],
							[
								146.86830332600005,
								-38.64614489999997
							]
						]
					],
					[
						[
							[
								146.81536968400007,
								-38.659054975999936
							],
							[
								146.79406342800007,
								-38.65680694499997
							],
							[
								146.78605846800008,
								-38.66917296399998
							],
							[
								146.81536968400007,
								-38.659054975999936
							]
						]
					],
					[
						[
							[
								146.8521123600001,
								-38.63433000899994
							],
							[
								146.87821559600002,
								-38.62647102099993
							],
							[
								146.87979169800008,
								-38.61517098099995
							],
							[
								146.85141252300002,
								-38.61240195899995
							],
							[
								146.8252804870001,
								-38.620725956999934
							],
							[
								146.81912662900004,
								-38.613182965999954
							],
							[
								146.80318153100006,
								-38.62035497499994
							],
							[
								146.80098262900003,
								-38.63297802499994
							],
							[
								146.7910635710001,
								-38.63287901399997
							],
							[
								146.7943046590001,
								-38.64563400499998
							],
							[
								146.81988338400004,
								-38.65062197699996
							],
							[
								146.8521123600001,
								-38.63433000899994
							]
						]
					],
					[
						[
							[
								149.9057916260001,
								-37.564338462999956
							],
							[
								149.91842547400006,
								-37.568488453999976
							],
							[
								149.90490631900002,
								-37.54828727299997
							],
							[
								149.9057916260001,
								-37.564338462999956
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "216",
				"CED_NAME21": "Gippsland",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 33135.976,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/216",
				"SHAPE_Leng": 16.3307244018,
				"SHAPE_Area": 3.38027745298
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							145.04482457400002,
							-37.88972363299996
						],
						[
							144.99227020400008,
							-37.88326035999995
						],
						[
							144.9849958640001,
							-37.89098937899996
						],
						[
							144.9855319710001,
							-37.92622464999994
						],
						[
							145.00938833200007,
							-37.969584821999945
						],
						[
							145.03076849500007,
							-37.99458174299997
						],
						[
							145.05169704200011,
							-37.986806694999984
						],
						[
							145.05527320400006,
							-37.96765900499997
						],
						[
							145.0343793710001,
							-37.932993042999954
						],
						[
							145.04832243900012,
							-37.934677963999945
						],
						[
							145.05345164100004,
							-37.90563289399995
						],
						[
							145.04392383300012,
							-37.90442695399997
						],
						[
							145.04482457400002,
							-37.88972363299996
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "217",
				"CED_NAME21": "Goldstein",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 50.6625,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/217",
				"SHAPE_Leng": 0.370928926364,
				"SHAPE_Area": 0.00519190241326
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							144.80475608000006,
							-37.66950383599993
						],
						[
							144.80114097000012,
							-37.67552880599993
						],
						[
							144.77698746400006,
							-37.67678889399997
						],
						[
							144.77205237600003,
							-37.66398892299998
						],
						[
							144.74441878100004,
							-37.663063921999935
						],
						[
							144.75835739600006,
							-37.68092397299995
						],
						[
							144.7564112450001,
							-37.69340472299996
						],
						[
							144.72476864100008,
							-37.68998106999993
						],
						[
							144.69429238500004,
							-37.70549664899994
						],
						[
							144.67363834900004,
							-37.69932728699996
						],
						[
							144.67808208000008,
							-37.68499448699998
						],
						[
							144.62448501900008,
							-37.682258813999965
						],
						[
							144.61226502400007,
							-37.75166681299993
						],
						[
							144.57523002100004,
							-37.748205810999934
						],
						[
							144.58876888400005,
							-37.79311697199995
						],
						[
							144.70852865200004,
							-37.80677463999996
						],
						[
							144.76914349100002,
							-37.81200357399996
						],
						[
							144.78201346700007,
							-37.727555534999965
						],
						[
							144.8304214090001,
							-37.72458371799996
						],
						[
							144.84996054500004,
							-37.73447348899998
						],
						[
							144.83809495000003,
							-37.70546487799993
						],
						[
							144.80973992600002,
							-37.69808279599994
						],
						[
							144.82048702500003,
							-37.684322866999935
						],
						[
							144.80632498800003,
							-37.683113815999945
						],
						[
							144.80475608000006,
							-37.66950383599993
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "218",
				"CED_NAME21": "Gorton",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 222.6893,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/218",
				"SHAPE_Leng": 0.954641529277,
				"SHAPE_Area": 0.0227635273453
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							144.58876888400005,
							-37.79311697199995
						],
						[
							144.57523002100004,
							-37.748205810999934
						],
						[
							144.61226502400007,
							-37.75166681299993
						],
						[
							144.62448501900008,
							-37.682258813999965
						],
						[
							144.67808208000008,
							-37.68499448699998
						],
						[
							144.67363834900004,
							-37.69932728699996
						],
						[
							144.69429238500004,
							-37.70549664899994
						],
						[
							144.72476864100008,
							-37.68998106999993
						],
						[
							144.7564112450001,
							-37.69340472299996
						],
						[
							144.75835739600006,
							-37.68092397299995
						],
						[
							144.74441878100004,
							-37.663063921999935
						],
						[
							144.77205237600003,
							-37.66398892299998
						],
						[
							144.77698746400006,
							-37.67678889399997
						],
						[
							144.80114097000012,
							-37.67552880599993
						],
						[
							144.80475608000006,
							-37.66950383599993
						],
						[
							144.8088968190001,
							-37.665047845999936
						],
						[
							144.79980898100007,
							-37.660706784999945
						],
						[
							144.8062108910001,
							-37.658888795999985
						],
						[
							144.7979459820001,
							-37.65431884499998
						],
						[
							144.81337497000004,
							-37.65508182599996
						],
						[
							144.81604199100002,
							-37.64099683599994
						],
						[
							144.83392402700008,
							-37.643974887999946
						],
						[
							144.83636915800002,
							-37.62959180799993
						],
						[
							144.8183821120001,
							-37.627608565999935
						],
						[
							144.81973535200007,
							-37.61996279599998
						],
						[
							144.80173282700002,
							-37.60969568499996
						],
						[
							144.81795189500008,
							-37.60070181599997
						],
						[
							144.80614497700003,
							-37.598150844999964
						],
						[
							144.81609896600003,
							-37.59494082599997
						],
						[
							144.80729808800004,
							-37.59072278499997
						],
						[
							144.80900482800007,
							-37.58182483499996
						],
						[
							144.82204799600004,
							-37.57879579599995
						],
						[
							144.81913595800006,
							-37.57215686599994
						],
						[
							144.8324300160001,
							-37.56402482699997
						],
						[
							144.82840596800008,
							-37.55525378699997
						],
						[
							144.84796116400003,
							-37.55688881799995
						],
						[
							144.85807498400004,
							-37.541243848999954
						],
						[
							144.85167383600003,
							-37.53254183799993
						],
						[
							144.87051119500006,
							-37.51552263899998
						],
						[
							144.76689603400007,
							-37.50501047199998
						],
						[
							144.75753637600008,
							-37.49482516099994
						],
						[
							144.7011085270001,
							-37.48189789799994
						],
						[
							144.67948606900006,
							-37.49939334599998
						],
						[
							144.64503453600003,
							-37.49503080399995
						],
						[
							144.638057956,
							-37.49948876299993
						],
						[
							144.63241534400004,
							-37.53010833299993
						],
						[
							144.67165156300007,
							-37.56770851599998
						],
						[
							144.56118232400001,
							-37.55240354899996
						],
						[
							144.55623124400006,
							-37.55888715799995
						],
						[
							144.48370393800008,
							-37.55080755299997
						],
						[
							144.4576852030001,
							-37.54457283199997
						],
						[
							144.46911854300004,
							-37.52123045199994
						],
						[
							144.46989529500001,
							-37.50757227199995
						],
						[
							144.459320917,
							-37.49708780199995
						],
						[
							144.4704735030001,
							-37.42878253199996
						],
						[
							144.450209104,
							-37.450637040999936
						],
						[
							144.4333044970001,
							-37.45037735999995
						],
						[
							144.42640176700002,
							-37.45886753899998
						],
						[
							144.41693969000005,
							-37.44661430799994
						],
						[
							144.3792841070001,
							-37.43877539599998
						],
						[
							144.3472825130001,
							-37.43212445399996
						],
						[
							144.3420534160001,
							-37.42063595299993
						],
						[
							144.30548809100003,
							-37.42462079099994
						],
						[
							144.3003190710001,
							-37.43639978099998
						],
						[
							144.26870532700002,
							-37.42757729899995
						],
						[
							144.26353908600004,
							-37.44627777799997
						],
						[
							144.17393945300012,
							-37.43603902199993
						],
						[
							144.1793421000001,
							-37.45126878299993
						],
						[
							144.1648159130001,
							-37.45443997199993
						],
						[
							144.15828708100003,
							-37.47884195199998
						],
						[
							144.16672207700003,
							-37.50667128199996
						],
						[
							144.19244950000007,
							-37.52693479399994
						],
						[
							144.19872307700007,
							-37.549489774999984
						],
						[
							144.18769507900004,
							-37.551863793999985
						],
						[
							144.18703084800006,
							-37.561613533999946
						],
						[
							144.14366309500008,
							-37.56663777099993
						],
						[
							144.1414141040001,
							-37.57943154099996
						],
						[
							144.1323941160001,
							-37.575802780999936
						],
						[
							144.13013108400003,
							-37.592244790999985
						],
						[
							144.13990413300007,
							-37.59295278099995
						],
						[
							144.13342308100005,
							-37.624431770999934
						],
						[
							144.1562553660001,
							-37.62996239199998
						],
						[
							144.15260412400005,
							-37.65275577199998
						],
						[
							144.178885099,
							-37.66151179399998
						],
						[
							144.16627507900012,
							-37.68275778299994
						],
						[
							144.1740023870001,
							-37.687473473999944
						],
						[
							144.16529610600003,
							-37.71450278399993
						],
						[
							144.15722709700003,
							-37.713222782999935
						],
						[
							144.15189907700005,
							-37.72328878299993
						],
						[
							144.18052124200005,
							-37.72951211499998
						],
						[
							144.1829822200001,
							-37.74448279499995
						],
						[
							144.17012192200002,
							-37.74306277399995
						],
						[
							144.16453709100006,
							-37.759890773999985
						],
						[
							144.19034732500006,
							-37.77783879599997
						],
						[
							144.17324207600007,
							-37.79264678499993
						],
						[
							144.17639589500004,
							-37.80286627499993
						],
						[
							144.222451846,
							-37.81018783799993
						],
						[
							144.29602192200002,
							-37.81955152299997
						],
						[
							144.29425474100003,
							-37.828914862999966
						],
						[
							144.32283580500007,
							-37.844699814999956
						],
						[
							144.35331332900012,
							-37.84529050699996
						],
						[
							144.36199380200003,
							-37.81081632699994
						],
						[
							144.3991245850001,
							-37.81521903999993
						],
						[
							144.40636304500003,
							-37.800920789999964
						],
						[
							144.42105904000005,
							-37.82033980099993
						],
						[
							144.4218150270001,
							-37.84657380099998
						],
						[
							144.444067022,
							-37.86402080299996
						],
						[
							144.4489909140001,
							-37.83704795299997
						],
						[
							144.46685007000008,
							-37.839081583999985
						],
						[
							144.47768392500006,
							-37.780999504999954
						],
						[
							144.53268901400008,
							-37.787259087999985
						],
						[
							144.57741855400002,
							-37.80689708099993
						],
						[
							144.58876888400005,
							-37.79311697199995
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "219",
				"CED_NAME21": "Hawke",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 1835.4968,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/219",
				"SHAPE_Leng": 3.45492754936,
				"SHAPE_Area": 0.187348002594
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							145.05345164100004,
							-37.90563289399995
						],
						[
							145.074172577,
							-37.90812674599994
						],
						[
							145.07818797900006,
							-37.88713838599995
						],
						[
							145.08823201600012,
							-37.89296327599993
						],
						[
							145.093659569,
							-37.861362156999974
						],
						[
							145.08212235100007,
							-37.86017156599996
						],
						[
							145.07849298300005,
							-37.84841601599993
						],
						[
							145.04342297900007,
							-37.84797157299994
						],
						[
							145.02462391400002,
							-37.83448585199994
						],
						[
							144.9879264210001,
							-37.82965915899996
						],
						[
							144.98332756900004,
							-37.85564383899998
						],
						[
							145.03246129900003,
							-37.86833280199994
						],
						[
							145.04964126400012,
							-37.88101266399997
						],
						[
							145.04482457400002,
							-37.88972363299996
						],
						[
							145.04392383300012,
							-37.90442695399997
						],
						[
							145.05345164100004,
							-37.90563289399995
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "220",
				"CED_NAME21": "Higgins",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 39.4802,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/220",
				"SHAPE_Leng": 0.358482633736,
				"SHAPE_Area": 0.00404239300385
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							145.33535027300002,
							-38.07449802499997
						],
						[
							145.29820905000008,
							-38.069887421999965
						],
						[
							145.30145590100005,
							-38.05374654199994
						],
						[
							145.28635027600012,
							-38.035562770999945
						],
						[
							145.2867607170001,
							-38.02162130099998
						],
						[
							145.2489944350001,
							-38.01699776799995
						],
						[
							145.23958917900006,
							-38.07766384799993
						],
						[
							145.2157726700001,
							-38.20063904699998
						],
						[
							145.2265470960001,
							-38.21893758799996
						],
						[
							145.2542258410001,
							-38.22359686999994
						],
						[
							145.27158089800002,
							-38.22295184099994
						],
						[
							145.27731201400002,
							-38.245916731999955
						],
						[
							145.31267273800006,
							-38.24803890399994
						],
						[
							145.34134249500005,
							-38.22955194599996
						],
						[
							145.34620674600012,
							-38.21376689599998
						],
						[
							145.41092261300003,
							-38.228035320999936
						],
						[
							145.42997101100002,
							-38.21515821199995
						],
						[
							145.41832156500004,
							-38.19847808099996
						],
						[
							145.3888656700001,
							-38.192503328999976
						],
						[
							145.3994845840001,
							-38.14298434999995
						],
						[
							145.3835142690001,
							-38.12573205799998
						],
						[
							145.32716887000004,
							-38.11872978399998
						],
						[
							145.33535027300002,
							-38.07449802499997
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "221",
				"CED_NAME21": "Holt",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 257.8691,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/221",
				"SHAPE_Leng": 0.898027947783,
				"SHAPE_Area": 0.0265045566657
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							145.19549158400002,
							-37.92311495399997
						],
						[
							145.1273816470001,
							-37.914552208999964
						],
						[
							145.1244827490001,
							-37.89913889899998
						],
						[
							145.08823201600012,
							-37.89296327599993
						],
						[
							145.07818797900006,
							-37.88713838599995
						],
						[
							145.074172577,
							-37.90812674599994
						],
						[
							145.05345164100004,
							-37.90563289399995
						],
						[
							145.04832243900012,
							-37.934677963999945
						],
						[
							145.08960291100004,
							-37.94020184699997
						],
						[
							145.10314622700002,
							-37.95632515799997
						],
						[
							145.13065106200008,
							-37.959770969999965
						],
						[
							145.14470354600007,
							-37.99084044099993
						],
						[
							145.18167095900003,
							-37.995406653999964
						],
						[
							145.192374147,
							-37.99249793399997
						],
						[
							145.1930601690001,
							-37.97902044399996
						],
						[
							145.19549158400002,
							-37.92311495399997
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "222",
				"CED_NAME21": "Hotham",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 77.5274,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/222",
				"SHAPE_Leng": 0.461792476182,
				"SHAPE_Area": 0.00794593865157
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							146.43584170500003,
							-37.618030930999964
						],
						[
							146.647177703,
							-37.16295496399994
						],
						[
							146.6385727280001,
							-37.128092952999964
						],
						[
							146.65153270700011,
							-37.12003396399996
						],
						[
							146.66486071400004,
							-37.12399296499996
						],
						[
							146.68455472900007,
							-37.14508296699995
						],
						[
							146.71757273100002,
							-37.15875995899995
						],
						[
							146.744153707,
							-37.15631996099995
						],
						[
							146.7454667180001,
							-37.14964895199995
						],
						[
							146.7634477050001,
							-37.14600797299994
						],
						[
							146.7878756870001,
							-37.17762195499995
						],
						[
							146.82363868000004,
							-37.191918957999974
						],
						[
							146.8263276980001,
							-37.203748977999965
						],
						[
							147.3369906040001,
							-37.27552531799995
						],
						[
							147.38452258400002,
							-37.20390401099996
						],
						[
							147.36879258800002,
							-37.19827201999993
						],
						[
							147.3444196060001,
							-37.16062800799995
						],
						[
							147.33149159900006,
							-37.153018016999965
						],
						[
							147.32548462400007,
							-37.12171901599993
						],
						[
							147.3164026170001,
							-37.11385099499995
						],
						[
							147.3592186090001,
							-37.11432900799997
						],
						[
							147.36505062000003,
							-37.101530998999976
						],
						[
							147.38052058800008,
							-37.09869999999995
						],
						[
							147.38034466300007,
							-37.05869687999996
						],
						[
							147.3922616220001,
							-37.04555701099997
						],
						[
							147.387459615,
							-37.03013999999996
						],
						[
							147.34998963100008,
							-37.03640300699993
						],
						[
							147.29379764300006,
							-37.006977992999964
						],
						[
							147.26330064900003,
							-37.00669199999993
						],
						[
							147.2811449950001,
							-36.92642093099994
						],
						[
							147.29277867400003,
							-36.91700851199994
						],
						[
							147.28925639600004,
							-36.90514946199994
						],
						[
							147.30705266600012,
							-36.88285000299993
						],
						[
							147.3208274640001,
							-36.882555803999935
						],
						[
							147.32431000500003,
							-36.86750560399997
						],
						[
							147.3417135730001,
							-36.861805034999975
						],
						[
							147.3332899280001,
							-36.829929204999985
						],
						[
							147.28293745700012,
							-36.82694885099994
						],
						[
							147.29345901700003,
							-36.811030510999956
						],
						[
							147.26793256500002,
							-36.779028668999956
						],
						[
							147.29007897300005,
							-36.76601022099993
						],
						[
							147.28890152600002,
							-36.74027607099998
						],
						[
							147.2965996260001,
							-36.733908930999974
						],
						[
							147.31611267300002,
							-36.73333800299997
						],
						[
							147.32616264900003,
							-36.749528003999956
						],
						[
							147.38013567000007,
							-36.750713007999934
						],
						[
							147.40763567400006,
							-36.76530500999996
						],
						[
							147.40633463300003,
							-36.77761801999998
						],
						[
							147.43028165700002,
							-36.79480100199993
						],
						[
							147.45849166100004,
							-36.80301300399998
						],
						[
							147.47140561100002,
							-36.78305602499995
						],
						[
							147.52860961300007,
							-36.769612019999954
						],
						[
							147.52659963500003,
							-36.756471028999954
						],
						[
							147.54189364500007,
							-36.737555019999945
						],
						[
							147.96022089200005,
							-36.612414702999956
						],
						[
							148.1344704070001,
							-36.74372618799998
						],
						[
							148.1307080690001,
							-36.73467015699998
						],
						[
							148.162581487,
							-36.71151927999995
						],
						[
							148.1696565750001,
							-36.71335903999994
						],
						[
							148.18906153500006,
							-36.68811643199996
						],
						[
							148.18402125700004,
							-36.68314074099993
						],
						[
							148.19926650600007,
							-36.67220506299998
						],
						[
							148.22069018800005,
							-36.62554161399993
						],
						[
							148.21436955100012,
							-36.61057934299998
						],
						[
							148.20278620300007,
							-36.61190302299997
						],
						[
							148.21756930200002,
							-36.59822643399997
						],
						[
							148.205996055,
							-36.586919782999985
						],
						[
							148.19033554800012,
							-36.584878740999955
						],
						[
							148.19013928900006,
							-36.57660790099993
						],
						[
							148.17919884000003,
							-36.58003206999996
						],
						[
							148.169416543,
							-36.57368249999996
						],
						[
							148.16071861400007,
							-36.579762538999944
						],
						[
							148.15049359800003,
							-36.55832286799995
						],
						[
							148.1334156700001,
							-36.56690830699995
						],
						[
							148.124342543,
							-36.55062934599994
						],
						[
							148.139821234,
							-36.52543296699997
						],
						[
							148.11763627100004,
							-36.49546329499998
						],
						[
							148.12623900100004,
							-36.48566862499996
						],
						[
							148.11909879200005,
							-36.481871824999985
						],
						[
							148.124667734,
							-36.46470048499998
						],
						[
							148.08760677100008,
							-36.45188240199997
						],
						[
							148.080285526,
							-36.42208826099994
						],
						[
							148.05995008000002,
							-36.41552531999997
						],
						[
							148.05816896200008,
							-36.40079070899998
						],
						[
							148.03754817700008,
							-36.39012593799998
						],
						[
							148.04597129900003,
							-36.367025067999975
						],
						[
							148.0378409000001,
							-36.36623339799996
						],
						[
							148.04896467900005,
							-36.35561887799997
						],
						[
							148.05124812300005,
							-36.32454457799997
						],
						[
							148.0589461720001,
							-36.32003377899997
						],
						[
							148.03501710700004,
							-36.31056500699998
						],
						[
							148.043933207,
							-36.29946686799997
						],
						[
							148.03523900900007,
							-36.29231629699996
						],
						[
							148.03868227300006,
							-36.25920852699994
						],
						[
							148.0261014890001,
							-36.223028925999984
						],
						[
							148.04062608900006,
							-36.20693906699995
						],
						[
							148.0218248860001,
							-36.17644952499995
						],
						[
							148.03480070500007,
							-36.16296993599997
						],
						[
							148.0229041890001,
							-36.15344489499995
						],
						[
							148.03519651700003,
							-36.15252361599994
						],
						[
							148.0377320880001,
							-36.14078454599996
						],
						[
							148.0043720330001,
							-36.14007897299996
						],
						[
							148.00054203600007,
							-36.12434268299995
						],
						[
							147.99062110800003,
							-36.12107400199994
						],
						[
							147.99922372900005,
							-36.09864219299993
						],
						[
							147.9802357740001,
							-36.086627360999955
						],
						[
							147.99233544300012,
							-36.074602021999965
						],
						[
							147.99969713500002,
							-36.04619064199994
						],
						[
							147.98740881700007,
							-36.05227469099998
						],
						[
							147.98794805800003,
							-36.04312932099998
						],
						[
							147.98130362900008,
							-36.04025602099995
						],
						[
							147.97433421900007,
							-36.046916789999955
						],
						[
							147.9742661800001,
							-36.03849249999996
						],
						[
							147.964966451,
							-36.046844369999974
						],
						[
							147.95878559300002,
							-36.04095198899995
						],
						[
							147.93369877600003,
							-36.047558186999936
						],
						[
							147.92337605800003,
							-36.04183862599996
						],
						[
							147.924004759,
							-36.03552470599993
						],
						[
							147.93158784700006,
							-36.03612033699994
						],
						[
							147.92713888900005,
							-36.03094143599998
						],
						[
							147.9114953620001,
							-36.02658425499993
						],
						[
							147.91257091500006,
							-35.99527415499995
						],
						[
							147.8957036380001,
							-35.993005213999936
						],
						[
							147.897511967,
							-35.99984882399997
						],
						[
							147.88288551900007,
							-36.00178538299997
						],
						[
							147.8731259320001,
							-35.99099400199998
						],
						[
							147.8496317160001,
							-35.98972073999994
						],
						[
							147.85092432700003,
							-35.981569459999946
						],
						[
							147.81750335200002,
							-35.97972762699993
						],
						[
							147.80615885600002,
							-35.965043985999955
						],
						[
							147.7768551800001,
							-35.968601053999976
						],
						[
							147.7668026220001,
							-35.96414495299996
						],
						[
							147.77326659200003,
							-35.95884961399997
						],
						[
							147.74129737700002,
							-35.95647679099994
						],
						[
							147.71819437200008,
							-35.94514114899994
						],
						[
							147.7097891960001,
							-35.928901647999965
						],
						[
							147.6893353380001,
							-35.93771200699996
						],
						[
							147.68001498900003,
							-35.94442616599997
						],
						[
							147.64678269400008,
							-35.94599549299994
						],
						[
							147.63777623300007,
							-35.96209704299997
						],
						[
							147.60144308700012,
							-35.979105619999984
						],
						[
							147.59420894900006,
							-35.96982426899996
						],
						[
							147.58087284200008,
							-35.967988197999944
						],
						[
							147.5748908920001,
							-35.975145547999944
						],
						[
							147.56416119400012,
							-35.969420636999985
						],
						[
							147.56739252400007,
							-35.96482206699994
						],
						[
							147.5491207970001,
							-35.96453659599996
						],
						[
							147.54765939600009,
							-35.978612435999935
						],
						[
							147.5588934650001,
							-35.97247585699995
						],
						[
							147.58143370000005,
							-35.97801360899996
						],
						[
							147.58403296900008,
							-35.98463493899993
						],
						[
							147.55187927200006,
							-36.00408231599994
						],
						[
							147.52111575900005,
							-35.98638427399993
						],
						[
							147.51523588100008,
							-35.97597395299994
						],
						[
							147.5255189610001,
							-35.96319558399995
						],
						[
							147.5117987530001,
							-35.962252812999964
						],
						[
							147.49411754800008,
							-35.94353586099993
						],
						[
							147.48155884000005,
							-35.949209939999946
						],
						[
							147.47884089100012,
							-35.94267598999994
						],
						[
							147.4640780430001,
							-35.94412395899997
						],
						[
							147.4506905830001,
							-35.960790997999936
						],
						[
							147.40502411300008,
							-35.943507103999934
						],
						[
							147.39184543400006,
							-35.94762720299997
						],
						[
							147.39250587100003,
							-35.97333128399998
						],
						[
							147.3836850130001,
							-35.972339312999964
						],
						[
							147.35819871400008,
							-35.991262630999984
						],
						[
							147.34568635300002,
							-36.018759029999956
						],
						[
							147.35283044000005,
							-36.03173614099995
						],
						[
							147.319263502,
							-36.06111386899994
						],
						[
							147.28518255000006,
							-36.03942600599993
						],
						[
							147.24238400700006,
							-36.038469461999966
						],
						[
							147.20630471200002,
							-36.05012310999996
						],
						[
							147.16446185100006,
							-36.030785295999976
						],
						[
							147.14436711300004,
							-36.03775158499997
						],
						[
							147.12739716800002,
							-36.01803366299998
						],
						[
							147.12336301200003,
							-35.99448452299998
						],
						[
							147.1119371630001,
							-36.00090873199997
						],
						[
							147.1162862010001,
							-36.00762174199997
						],
						[
							147.10682529300004,
							-36.00481186199994
						],
						[
							147.10923335200005,
							-36.01253589199996
						],
						[
							147.0980794940001,
							-36.01023307099996
						],
						[
							147.10636945200008,
							-36.01644196199993
						],
						[
							147.09767657300006,
							-36.01581011099995
						],
						[
							147.09910062200004,
							-36.02618119099998
						],
						[
							147.09214576300008,
							-36.02763729099996
						],
						[
							147.10371765000002,
							-36.03284118199997
						],
						[
							147.09700895000003,
							-36.046771400999944
						],
						[
							147.09158797100008,
							-36.043848450999974
						],
						[
							147.09555704900004,
							-36.052557460999935
						],
						[
							147.09040606000008,
							-36.04921253099997
						],
						[
							147.07452947100012,
							-36.06407784999993
						],
						[
							147.0682825030001,
							-36.06056688899997
						],
						[
							147.0668165520001,
							-36.068608978999976
						],
						[
							147.06219660300007,
							-36.06572399899994
						],
						[
							147.05308605000005,
							-36.10767842799993
						],
						[
							147.04235013200002,
							-36.10429150699997
						],
						[
							147.0341463520001,
							-36.11522562699997
						],
						[
							147.0227821850001,
							-36.09988217599994
						],
						[
							147.013478576,
							-36.10470834499995
						],
						[
							147.0163240180001,
							-36.08978466499997
						],
						[
							147.00640088900002,
							-36.08910159499993
						],
						[
							147.00687243000004,
							-36.083577584999944
						],
						[
							146.98130432300002,
							-36.09486331299996
						],
						[
							146.972594565,
							-36.08210022199995
						],
						[
							146.95630056900006,
							-36.078177610999944
						],
						[
							146.95250415500004,
							-36.11077526099996
						],
						[
							146.94371060600008,
							-36.11597698999998
						],
						[
							146.9268095010001,
							-36.09716550799993
						],
						[
							146.92406328000004,
							-36.10830140799993
						],
						[
							146.90776845300002,
							-36.111271416999955
						],
						[
							146.90691554600005,
							-36.084933976999935
						],
						[
							146.88056202000007,
							-36.087511064999944
						],
						[
							146.8729579520001,
							-36.07366841399994
						],
						[
							146.85870991500008,
							-36.07437367299997
						],
						[
							146.85716312400007,
							-36.08490537299997
						],
						[
							146.83670585700008,
							-36.08206026199997
						],
						[
							146.82505488800007,
							-36.08871862099994
						],
						[
							146.82554761000006,
							-36.07083452099994
						],
						[
							146.81630724100012,
							-36.074364369999955
						],
						[
							146.81838602200003,
							-36.06782108999994
						],
						[
							146.80394196600002,
							-36.055181768999944
						],
						[
							146.79457583700002,
							-36.05853224799995
						],
						[
							146.79618700600008,
							-36.06512555799998
						],
						[
							146.7671610420001,
							-36.05565524599996
						],
						[
							146.762824442,
							-36.05950527599998
						],
						[
							146.76232149300006,
							-36.05165221599998
						],
						[
							146.74798913400002,
							-36.06032269499997
						],
						[
							146.75293381500012,
							-36.04210021499995
						],
						[
							146.74463125600005,
							-36.04782440399998
						],
						[
							146.73084830900007,
							-36.04522579299993
						],
						[
							146.73185547100002,
							-36.02378221299995
						],
						[
							146.70888439400005,
							-36.02942163199998
						],
						[
							146.70714688300006,
							-36.036108630999934
						],
						[
							146.68960855700004,
							-36.030432959999985
						],
						[
							146.6950080260001,
							-36.03430261099993
						],
						[
							146.68752884600008,
							-36.04105103999996
						],
						[
							146.67537030900007,
							-36.02858661899995
						],
						[
							146.67965186900005,
							-36.02208787899997
						],
						[
							146.67136704000006,
							-36.025857858999984
						],
						[
							146.66835286200012,
							-36.01777101799996
						],
						[
							146.67022759000008,
							-36.02790029899995
						],
						[
							146.65600189300005,
							-36.026239317999966
						],
						[
							146.65034141500007,
							-36.01839837699998
						],
						[
							146.65857951400005,
							-36.01447553799994
						],
						[
							146.6501839550001,
							-36.01378407699997
						],
						[
							146.65087346600012,
							-36.007722856999976
						],
						[
							146.6421336080001,
							-36.00411549599994
						],
						[
							146.64037896700006,
							-36.00950879599998
						],
						[
							146.6337168990001,
							-35.99978928599995
						],
						[
							146.6130551430001,
							-35.99515156399997
						],
						[
							146.6078261550001,
							-35.986358533999976
						],
						[
							146.6187218540001,
							-35.97592436399998
						],
						[
							146.6125259360001,
							-35.97284540399994
						],
						[
							146.5841528100001,
							-35.97497378199995
						],
						[
							146.58397271900003,
							-35.98385079199994
						],
						[
							146.56238635300008,
							-35.97690406999993
						],
						[
							146.5629526240001,
							-35.96769251999996
						],
						[
							146.54958646400007,
							-35.992444208999984
						],
						[
							146.53229878700006,
							-35.98428636799997
						],
						[
							146.51968685200006,
							-35.96059141699993
						],
						[
							146.5119689930001,
							-35.964165495999964
						],
						[
							146.50259108500006,
							-35.95822156599996
						],
						[
							146.500680213,
							-35.979230635999954
						],
						[
							146.4924863540001,
							-35.98499872499997
						],
						[
							146.50214019200007,
							-35.983174625999936
						],
						[
							146.49973268200006,
							-35.99085709599996
						],
						[
							146.46741265800006,
							-35.984226932999945
						],
						[
							146.469971578,
							-35.976187882999966
						],
						[
							146.45460066200008,
							-35.96223391199993
						],
						[
							146.44331283300005,
							-35.976228040999956
						],
						[
							146.4371648650001,
							-35.967002040999944
						],
						[
							146.4216790170001,
							-35.965818129999946
						],
						[
							146.4251749560001,
							-35.97301409999994
						],
						[
							146.4029679880001,
							-35.98876719799995
						],
						[
							146.3991403560001,
							-36.007186187999935
						],
						[
							146.3806112090001,
							-36.01288171699997
						],
						[
							146.37959918700005,
							-36.028113796999946
						],
						[
							146.38756223500002,
							-36.03562574799997
						],
						[
							146.37626142600004,
							-36.03835155699994
						],
						[
							146.37957418500002,
							-36.04472274699998
						],
						[
							146.36958443600008,
							-36.05072692599998
						],
						[
							146.35002012000007,
							-36.04174432499997
						],
						[
							146.338895244,
							-36.02638202399993
						],
						[
							146.3250280750001,
							-36.033529872999964
						],
						[
							146.32907759300008,
							-36.04313122299993
						],
						[
							146.31588084600003,
							-36.038440281999954
						],
						[
							146.31299203600008,
							-36.04555498199994
						],
						[
							146.3009688290001,
							-36.03657736099996
						],
						[
							146.299015058,
							-36.047846610999954
						],
						[
							146.29140179,
							-36.03893832999995
						],
						[
							146.28302928100004,
							-36.04147433999998
						],
						[
							146.29311027100005,
							-36.02949051099995
						],
						[
							146.28218712300009,
							-36.02617518999995
						],
						[
							146.29113159200006,
							-36.020151089999956
						],
						[
							146.2788097550001,
							-36.01583806899998
						],
						[
							146.28290106400004,
							-36.011035299999946
						],
						[
							146.27503603600007,
							-36.01242753899993
						],
						[
							146.27286490400002,
							-36.02661757899995
						],
						[
							146.25718882800004,
							-36.01204001799994
						],
						[
							146.2445991300001,
							-36.018327746999944
						],
						[
							146.25089481800012,
							-36.02311704699997
						],
						[
							146.24143892000006,
							-36.02351130699998
						],
						[
							146.24321925900006,
							-36.02864194699998
						],
						[
							146.2213307620001,
							-36.03018717499998
						],
						[
							146.21973712200008,
							-36.03685661499998
						],
						[
							146.2101306730001,
							-36.03848375399997
						],
						[
							146.2118145940001,
							-36.02851238499994
						],
						[
							146.19930686500004,
							-36.03746409399997
						],
						[
							146.20087299600004,
							-36.02743129399994
						],
						[
							146.18809513600002,
							-36.04157777299997
						],
						[
							146.1772805490001,
							-36.03402765199996
						],
						[
							146.17923403700001,
							-36.05135261199996
						],
						[
							146.19920472400008,
							-36.046969193999985
						],
						[
							146.1966756700001,
							-36.085582373999955
						],
						[
							146.2152403670001,
							-36.08902897499996
						],
						[
							146.21005244700007,
							-36.09187307499997
						],
						[
							146.21645344600006,
							-36.09731993499997
						],
						[
							146.20484159700004,
							-36.10525717499996
						],
						[
							146.2164014650001,
							-36.10654494499994
						],
						[
							146.21584951400007,
							-36.11450495499997
						],
						[
							146.2059845860001,
							-36.112737154999934
						],
						[
							146.20463365400008,
							-36.125947174999965
						],
						[
							146.23669458900008,
							-36.12868361699998
						],
						[
							146.243590637,
							-36.13855351799998
						],
						[
							146.23625161500001,
							-36.16487762699995
						],
						[
							146.22885263600006,
							-36.16710173699994
						],
						[
							146.245391583,
							-36.16768648799996
						],
						[
							146.2366817720001,
							-36.190544676999934
						],
						[
							146.23406066300004,
							-36.18298367699998
						],
						[
							146.13105786900007,
							-36.186777649999954
						],
						[
							146.1314305620001,
							-36.25510855999994
						],
						[
							146.03690896700004,
							-36.25505015299996
						],
						[
							146.03094373300007,
							-36.29899553299998
						],
						[
							145.7984539910001,
							-36.29895662599995
						],
						[
							145.77543988900004,
							-36.443740625999965
						],
						[
							145.7244333100001,
							-36.42459500199993
						],
						[
							145.73187597000003,
							-36.499023302999944
						],
						[
							145.63156628700006,
							-36.49903319599997
						],
						[
							145.63172864000012,
							-36.56328535599994
						],
						[
							145.61473376200001,
							-36.56327976499995
						],
						[
							145.62627195800007,
							-36.590042865999976
						],
						[
							145.64451093500008,
							-36.59077187699995
						],
						[
							145.64455297100005,
							-36.62307787699996
						],
						[
							145.63471159300002,
							-36.62227891699996
						],
						[
							145.6346609620001,
							-36.631720686999984
						],
						[
							145.58938184400006,
							-36.68192631399995
						],
						[
							145.5970304110001,
							-36.69520132399998
						],
						[
							145.58477671100002,
							-36.70891002399998
						],
						[
							145.572186944,
							-36.70155187299997
						],
						[
							145.51594509400002,
							-36.70163515899998
						],
						[
							145.5134789660001,
							-36.687030868999955
						],
						[
							145.49817765800003,
							-36.68703571699996
						],
						[
							145.49603795400003,
							-36.73020964799997
						],
						[
							145.4532499610001,
							-36.73036186499996
						],
						[
							145.4551259850001,
							-36.778211874999954
						],
						[
							145.46141894400012,
							-36.786424875999955
						],
						[
							145.4863109590001,
							-36.79221387699994
						],
						[
							145.47485295,
							-36.79930486699993
						],
						[
							145.4626395790001,
							-36.82869474599994
						],
						[
							145.46983598600002,
							-36.840065865999975
						],
						[
							145.484321044,
							-36.84027409699996
						],
						[
							145.48450996200006,
							-36.85696886799997
						],
						[
							145.4818309410001,
							-36.870343866999974
						],
						[
							145.4612439540001,
							-36.87551485599994
						],
						[
							145.4550025630001,
							-36.89124836599996
						],
						[
							145.46783596000012,
							-36.90168086699998
						],
						[
							145.41112510900007,
							-36.995189412999935
						],
						[
							145.4259573160001,
							-36.999185043999944
						],
						[
							145.4294999330001,
							-37.02167187499998
						],
						[
							145.3927969570001,
							-37.04373685199994
						],
						[
							145.3927365830001,
							-37.07627323299994
						],
						[
							145.37474887700012,
							-37.07616239099997
						],
						[
							145.3662121860001,
							-37.097620640999935
						],
						[
							145.32104296300008,
							-37.103785107999954
						],
						[
							145.28830243900006,
							-37.099585384999955
						],
						[
							145.27890795500002,
							-37.14304584499996
						],
						[
							145.25720195000008,
							-37.13497085299997
						],
						[
							145.24320796100005,
							-37.14391484299995
						],
						[
							145.22856770500005,
							-37.13461824099994
						],
						[
							145.2317270310001,
							-37.167520441999955
						],
						[
							145.24109190900003,
							-37.168610342999955
						],
						[
							145.2411379780001,
							-37.176966412999946
						],
						[
							145.21944336,
							-37.19107073099997
						],
						[
							145.20202461400004,
							-37.18715690999994
						],
						[
							145.19638686300004,
							-37.20608312999997
						],
						[
							145.1748843460001,
							-37.204897667999944
						],
						[
							145.17202880600007,
							-37.21679053799994
						],
						[
							145.1638125170001,
							-37.21575786699998
						],
						[
							145.1772099430001,
							-37.23592327899996
						],
						[
							145.16777973400008,
							-37.240233107999984
						],
						[
							145.17313545100012,
							-37.261147767999944
						],
						[
							145.16273999100008,
							-37.27704185799996
						],
						[
							145.16810497900008,
							-37.28136584799995
						],
						[
							145.17183119000003,
							-37.26628972799995
						],
						[
							145.18064684900003,
							-37.26440269899996
						],
						[
							145.18692488600004,
							-37.278232558999946
						],
						[
							145.19555552500003,
							-37.278282769999976
						],
						[
							145.19538821300011,
							-37.294106849999935
						],
						[
							145.22732011800008,
							-37.29424867199998
						],
						[
							145.22744900700002,
							-37.305082511999956
						],
						[
							145.25186684200003,
							-37.30493923399996
						],
						[
							145.26197441800002,
							-37.32966853499994
						],
						[
							145.27935567500003,
							-37.33236800599997
						],
						[
							145.2704909260001,
							-37.33889715599997
						],
						[
							145.27137794200007,
							-37.36804786599998
						],
						[
							145.2565157250001,
							-37.36795410499997
						],
						[
							145.26582640300012,
							-37.37269061599994
						],
						[
							145.26562549800008,
							-37.41934075599994
						],
						[
							145.2362711410001,
							-37.43585441399995
						],
						[
							145.2222782890001,
							-37.472586192999984
						],
						[
							145.24104165500012,
							-37.47770964399996
						],
						[
							145.23932465500002,
							-37.48772585399996
						],
						[
							145.25671624100005,
							-37.491967725999984
						],
						[
							145.25170074000005,
							-37.51063109499995
						],
						[
							145.2624484580001,
							-37.51188802599995
						],
						[
							145.2644701590001,
							-37.50132885599993
						],
						[
							145.27631086700012,
							-37.49647571699995
						],
						[
							145.29439482400005,
							-37.49856861799998
						],
						[
							145.29706888200008,
							-37.51368169899996
						],
						[
							145.31383679900011,
							-37.51554656999997
						],
						[
							145.30477896000002,
							-37.52193468899998
						],
						[
							145.32850964500005,
							-37.52911950099997
						],
						[
							145.3413448010001,
							-37.543458561999955
						],
						[
							145.36641766600007,
							-37.545112813999935
						],
						[
							145.39390639200008,
							-37.540880055999935
						],
						[
							145.40345903200011,
							-37.52711884599995
						],
						[
							145.4182307200001,
							-37.526383616999965
						],
						[
							145.4260037570001,
							-37.53498741799996
						],
						[
							145.44053645500003,
							-37.533421128999976
						],
						[
							145.43781800400006,
							-37.545864248999976
						],
						[
							145.4677583990001,
							-37.54980889099994
						],
						[
							145.46992054700002,
							-37.557658910999976
						],
						[
							145.48200931600002,
							-37.55466579199998
						],
						[
							145.4819963550001,
							-37.56011782199994
						],
						[
							145.50876198000003,
							-37.563633693999975
						],
						[
							145.5079828910001,
							-37.55589264399998
						],
						[
							145.52536075700004,
							-37.56368959499997
						],
						[
							145.5314805270001,
							-37.556853494999984
						],
						[
							145.56260318700004,
							-37.59323124799994
						],
						[
							145.57802983700003,
							-37.57204099899997
						],
						[
							145.59987355400006,
							-37.56606418999996
						],
						[
							145.60248031300011,
							-37.57604041999997
						],
						[
							145.61492553100004,
							-37.571031640999934
						],
						[
							145.6406806550001,
							-37.58922506299996
						],
						[
							145.65929586800007,
							-37.61777990499996
						],
						[
							145.67585836500007,
							-37.62418233599993
						],
						[
							145.73734745700006,
							-37.593978609999965
						],
						[
							145.73057839000012,
							-37.58209390999997
						],
						[
							145.73869460000003,
							-37.56637865999994
						],
						[
							145.75536042600004,
							-37.57475145099994
						],
						[
							145.79084995200003,
							-37.56200665399996
						],
						[
							145.80918977800002,
							-37.56437824499994
						],
						[
							145.8263261300001,
							-37.52812325599996
						],
						[
							146.18601071700004,
							-37.53481057199997
						],
						[
							146.1919287500001,
							-37.58751692299995
						],
						[
							146.20771272600007,
							-37.60070193399997
						],
						[
							146.25082075800003,
							-37.610425927999984
						],
						[
							146.29879773200003,
							-37.591061940999964
						],
						[
							146.32194471700006,
							-37.59992993299994
						],
						[
							146.34665773000006,
							-37.62357393499997
						],
						[
							146.3679117150001,
							-37.62941394599994
						],
						[
							146.3765657140001,
							-37.628152926999974
						],
						[
							146.38344472500012,
							-37.609652926999956
						],
						[
							146.39405472400006,
							-37.603986937999935
						],
						[
							146.43584170500003,
							-37.618030930999964
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "223",
				"CED_NAME21": "Indi",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 29189.3342,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/223",
				"SHAPE_Leng": 14.036345533,
				"SHAPE_Area": 2.94488625517
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							145.1930601690001,
							-37.97902044399996
						],
						[
							145.192374147,
							-37.99249793399997
						],
						[
							145.18167095900003,
							-37.995406653999964
						],
						[
							145.14470354600007,
							-37.99084044099993
						],
						[
							145.13065106200008,
							-37.959770969999965
						],
						[
							145.10314622700002,
							-37.95632515799997
						],
						[
							145.08960291100004,
							-37.94020184699997
						],
						[
							145.04832243900012,
							-37.934677963999945
						],
						[
							145.0343793710001,
							-37.932993042999954
						],
						[
							145.05527320400006,
							-37.96765900499997
						],
						[
							145.05169704200011,
							-37.986806694999984
						],
						[
							145.09582911100006,
							-38.02135894799994
						],
						[
							145.11959406100004,
							-38.07320593999998
						],
						[
							145.12561762000007,
							-38.07164332999997
						],
						[
							145.12279277900006,
							-38.084986829999934
						],
						[
							145.1486707250001,
							-38.083397221999974
						],
						[
							145.156259545,
							-38.067382271999975
						],
						[
							145.23958917900006,
							-38.07766384799993
						],
						[
							145.2489944350001,
							-38.01699776799995
						],
						[
							145.251859426,
							-38.00362220799997
						],
						[
							145.22602988000006,
							-38.001782866999974
						],
						[
							145.1930601690001,
							-37.97902044399996
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "224",
				"CED_NAME21": "Isaacs",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 156.2691,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/224",
				"SHAPE_Leng": 0.69044434516,
				"SHAPE_Area": 0.016032324932
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							145.264116886,
							-37.70734013799995
						],
						[
							145.26344153000002,
							-37.676335206999966
						],
						[
							145.24329193500012,
							-37.66260685599997
						],
						[
							145.22005391800008,
							-37.66652486399994
						],
						[
							145.22014793900007,
							-37.65799486399993
						],
						[
							145.2012751420001,
							-37.66315825299995
						],
						[
							145.1917499210001,
							-37.68949684199998
						],
						[
							145.11786437500007,
							-37.67918980699994
						],
						[
							145.10354626700007,
							-37.68293009599995
						],
						[
							145.09964791700008,
							-37.68945484599993
						],
						[
							145.06824427200002,
							-37.68604986399998
						],
						[
							145.05822524300004,
							-37.69996939299995
						],
						[
							145.05133075300012,
							-37.70837113299996
						],
						[
							145.0749546090001,
							-37.70877598399994
						],
						[
							145.07453157800012,
							-37.716121183999974
						],
						[
							145.06078096900012,
							-37.72948950399996
						],
						[
							145.03860718300007,
							-37.72731065199997
						],
						[
							145.03199641300012,
							-37.737747071999934
						],
						[
							145.027833621,
							-37.76380765199997
						],
						[
							145.04020252600003,
							-37.784208682999974
						],
						[
							145.06711849200008,
							-37.78092232399996
						],
						[
							145.08260891300006,
							-37.75136337499998
						],
						[
							145.11290091700005,
							-37.755237146999946
						],
						[
							145.12606474500012,
							-37.75106485799995
						],
						[
							145.1229756470001,
							-37.74040589799995
						],
						[
							145.15538103200004,
							-37.733935549999956
						],
						[
							145.17820779800002,
							-37.73825744199996
						],
						[
							145.1813246480001,
							-37.729828321999946
						],
						[
							145.193817716,
							-37.73177093299995
						],
						[
							145.1891858670001,
							-37.72595459199994
						],
						[
							145.20089291500005,
							-37.72251884299993
						],
						[
							145.20211368600008,
							-37.71092001299996
						],
						[
							145.23508691000006,
							-37.71629285599994
						],
						[
							145.2423754780001,
							-37.72547163599995
						],
						[
							145.264116886,
							-37.70734013799995
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "225",
				"CED_NAME21": "Jagajaga",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 125.9265,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/225",
				"SHAPE_Leng": 0.988766697033,
				"SHAPE_Area": 0.0128679099281
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							145.06711849200008,
							-37.78092232399996
						],
						[
							145.04020252600003,
							-37.784208682999974
						],
						[
							145.04043239600003,
							-37.78975453299995
						],
						[
							145.0131835510001,
							-37.78564749099996
						],
						[
							145.01998761800007,
							-37.803526870999974
						],
						[
							145.00195118200008,
							-37.79664577999995
						],
						[
							145.00767278000012,
							-37.80389089999994
						],
						[
							144.999376911,
							-37.80564297999996
						],
						[
							145.01574467800003,
							-37.810614930999975
						],
						[
							145.02462391400002,
							-37.83448585199994
						],
						[
							145.04342297900007,
							-37.84797157299994
						],
						[
							145.07849298300005,
							-37.84841601599993
						],
						[
							145.08212235100007,
							-37.86017156599996
						],
						[
							145.093659569,
							-37.861362156999974
						],
						[
							145.0982131610001,
							-37.835964926999964
						],
						[
							145.11138855800004,
							-37.83749361799994
						],
						[
							145.11503572000004,
							-37.81688082799997
						],
						[
							145.1187725520001,
							-37.796388597999965
						],
						[
							145.09566093700005,
							-37.78009685599994
						],
						[
							145.06711849200008,
							-37.78092232399996
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "226",
				"CED_NAME21": "Kooyong",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 58.4753,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/226",
				"SHAPE_Leng": 0.481839488826,
				"SHAPE_Area": 0.00598309040209
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							145.76502277800012,
							-37.89856688399993
						],
						[
							145.7481202900001,
							-37.90751870299994
						],
						[
							145.72923041400009,
							-37.90285879199996
						],
						[
							145.72154719700006,
							-37.88522574099994
						],
						[
							145.68685924400006,
							-37.88080175799996
						],
						[
							145.68631817300002,
							-37.88880581799998
						],
						[
							145.670541855,
							-37.89429663699997
						],
						[
							145.67070642300007,
							-37.90712882699995
						],
						[
							145.65796132600008,
							-37.907976805999965
						],
						[
							145.6526115160001,
							-37.91642215599995
						],
						[
							145.6260466000001,
							-37.91757098399995
						],
						[
							145.62793070100008,
							-37.904014883999935
						],
						[
							145.56904854200002,
							-37.897979609999936
						],
						[
							145.5533233980001,
							-37.87357862899995
						],
						[
							145.51913958500006,
							-37.85774095599993
						],
						[
							145.52677243300002,
							-37.86360935699997
						],
						[
							145.52686306100009,
							-37.885306696999976
						],
						[
							145.49405083300007,
							-37.91434087499994
						],
						[
							145.49136681200002,
							-37.92698688499996
						],
						[
							145.4692037960001,
							-37.92843989299996
						],
						[
							145.46885496800007,
							-37.910641312999985
						],
						[
							145.44373246300006,
							-37.90646061099994
						],
						[
							145.42292403500005,
							-37.919173859999944
						],
						[
							145.41968903500003,
							-37.92636460999995
						],
						[
							145.43243286200004,
							-37.93227788099995
						],
						[
							145.4265998730001,
							-37.936928869999974
						],
						[
							145.38352294000003,
							-37.93826016699995
						],
						[
							145.38794874500002,
							-37.97127666799997
						],
						[
							145.36099773,
							-37.972040935999985
						],
						[
							145.34984183900008,
							-38.00077486499998
						],
						[
							145.34713025000008,
							-37.99580774499998
						],
						[
							145.3409774800001,
							-38.007763774999944
						],
						[
							145.33401679200006,
							-37.999381823999954
						],
						[
							145.32899669200003,
							-38.00749367399993
						],
						[
							145.34394894900004,
							-38.011221424999974
						],
						[
							145.34807384600003,
							-38.02756785499997
						],
						[
							145.33535027300002,
							-38.07449802499997
						],
						[
							145.32716887000004,
							-38.11872978399998
						],
						[
							145.3835142690001,
							-38.12573205799998
						],
						[
							145.3994845840001,
							-38.14298434999995
						],
						[
							145.3888656700001,
							-38.192503328999976
						],
						[
							145.41832156500004,
							-38.19847808099996
						],
						[
							145.42997101100002,
							-38.21515821199995
						],
						[
							145.4889939080001,
							-38.23340086699994
						],
						[
							145.49796976200003,
							-38.27406386699994
						],
						[
							145.51795588700008,
							-38.29088090899995
						],
						[
							145.5206747640001,
							-38.30665903899995
						],
						[
							145.54181125000002,
							-38.30937158099994
						],
						[
							145.54578709200007,
							-38.29132352099998
						],
						[
							145.5536725500001,
							-38.29355776099993
						],
						[
							145.5821294430001,
							-38.31266549399993
						],
						[
							145.59362320900004,
							-38.33008559499996
						],
						[
							145.605689266,
							-38.332443524999974
						],
						[
							145.6124537510001,
							-38.28555994599998
						],
						[
							145.6385580660001,
							-38.28249154699995
						],
						[
							145.68028095800003,
							-38.28958393999994
						],
						[
							145.68149760900008,
							-38.282218959999966
						],
						[
							145.69093891700004,
							-38.283075620999966
						],
						[
							145.68964553600006,
							-38.29010601099998
						],
						[
							145.73268585900007,
							-38.289361593999956
						],
						[
							145.73636272300007,
							-38.24896275399993
						],
						[
							145.7128367670001,
							-38.25178788299996
						],
						[
							145.71741788100007,
							-38.20671328299994
						],
						[
							145.7008081240001,
							-38.205912730999955
						],
						[
							145.72973094500003,
							-38.153966742999955
						],
						[
							145.74848340300002,
							-38.142812893999974
						],
						[
							145.76279227400005,
							-38.108932584999934
						],
						[
							145.73921667900004,
							-38.10051695299995
						],
						[
							145.75444830900005,
							-38.07918531399997
						],
						[
							145.76254163800002,
							-37.99070976399997
						],
						[
							145.73106080700006,
							-37.95976089199996
						],
						[
							145.74697980700012,
							-37.93826389299994
						],
						[
							145.74125777900008,
							-37.92710389299998
						],
						[
							145.76502277800012,
							-37.89856688399993
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "227",
				"CED_NAME21": "La Trobe",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 1329.0917,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/227",
				"SHAPE_Leng": 2.20961978695,
				"SHAPE_Area": 0.136482970435
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							144.59158389100003,
							-38.00443240299995
						],
						[
							144.65164532100005,
							-38.001624996999965
						],
						[
							144.74049602200012,
							-37.94126581299997
						],
						[
							144.7427709530001,
							-37.92880182299996
						],
						[
							144.72830772500004,
							-37.92707043199994
						],
						[
							144.71354398900007,
							-37.91485482099995
						],
						[
							144.71895800200002,
							-37.878028610999934
						],
						[
							144.75783348700008,
							-37.86505193399995
						],
						[
							144.75254438900004,
							-37.85443293299994
						],
						[
							144.7133179860001,
							-37.85116082099995
						],
						[
							144.706003978,
							-37.84432882999994
						],
						[
							144.70852865200004,
							-37.80677463999996
						],
						[
							144.58876888400005,
							-37.79311697199995
						],
						[
							144.57741855400002,
							-37.80689708099993
						],
						[
							144.53268901400008,
							-37.787259087999985
						],
						[
							144.47768392500006,
							-37.780999504999954
						],
						[
							144.46685007000008,
							-37.839081583999985
						],
						[
							144.4489909140001,
							-37.83704795299997
						],
						[
							144.444067022,
							-37.86402080299996
						],
						[
							144.4808029520001,
							-37.89031592499998
						],
						[
							144.4847784200001,
							-37.90896906599994
						],
						[
							144.47811768100007,
							-37.91077933499997
						],
						[
							144.48262056900012,
							-37.92325637599998
						],
						[
							144.47402449900005,
							-37.93566828499996
						],
						[
							144.49646147200008,
							-37.964204406999954
						],
						[
							144.495644641,
							-37.97426198699998
						],
						[
							144.51869759600004,
							-37.980999837999946
						],
						[
							144.52407455600007,
							-37.973355348999974
						],
						[
							144.54755340200006,
							-37.97185809999996
						],
						[
							144.5546493600001,
							-37.984772290999956
						],
						[
							144.56782965700006,
							-37.98450221199994
						],
						[
							144.573388055,
							-37.99919417199993
						],
						[
							144.59158389100003,
							-38.00443240299995
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "228",
				"CED_NAME21": "Lalor",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 463.6823,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/228",
				"SHAPE_Leng": 1.12067388463,
				"SHAPE_Area": 0.0474916280362
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							144.9849958640001,
							-37.89098937899996
						],
						[
							144.99227020400008,
							-37.88326035999995
						],
						[
							145.04482457400002,
							-37.88972363299996
						],
						[
							145.04964126400012,
							-37.88101266399997
						],
						[
							145.03246129900003,
							-37.86833280199994
						],
						[
							144.98332756900004,
							-37.85564383899998
						],
						[
							144.9879264210001,
							-37.82965915899996
						],
						[
							144.97162899500006,
							-37.81940586799993
						],
						[
							144.90556845600008,
							-37.82287487399998
						],
						[
							144.89836795500003,
							-37.841190892999975
						],
						[
							144.90721891200008,
							-37.84951283399994
						],
						[
							144.906486394,
							-37.83936294399996
						],
						[
							144.91264439100007,
							-37.84998580399997
						],
						[
							144.91340967200006,
							-37.841953813999964
						],
						[
							144.92691843000011,
							-37.84002169499996
						],
						[
							144.92986240900007,
							-37.84730967499996
						],
						[
							144.935598238,
							-37.84253460599996
						],
						[
							144.9633219220001,
							-37.85545433799996
						],
						[
							144.9849958640001,
							-37.89098937899996
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "229",
				"CED_NAME21": "Macnamara",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 40.1171,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/229",
				"SHAPE_Leng": 0.475316752597,
				"SHAPE_Area": 0.00410694731069
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							144.40854469900012,
							-35.89887767799996
						],
						[
							144.4181889780001,
							-35.89320659899994
						],
						[
							144.40363435200004,
							-35.880653017999975
						],
						[
							144.41094253100005,
							-35.87117560799993
						],
						[
							144.40193228300006,
							-35.868006596999976
						],
						[
							144.4113944820001,
							-35.858990277999965
						],
						[
							144.39864141400005,
							-35.862653586999954
						],
						[
							144.38889092600004,
							-35.85846715599996
						],
						[
							144.39032459700002,
							-35.85053956699994
						],
						[
							144.38143947800006,
							-35.85241028599995
						],
						[
							144.3843199790001,
							-35.84190940599996
						],
						[
							144.37308256100005,
							-35.83726578499994
						],
						[
							144.3866136590001,
							-35.83610967599998
						],
						[
							144.37219584100012,
							-35.83193749499998
						],
						[
							144.38412478100008,
							-35.819552115999954
						],
						[
							144.36481254400007,
							-35.82092379499994
						],
						[
							144.3688741940001,
							-35.81321616499997
						],
						[
							144.37749075200009,
							-35.81433294499993
						],
						[
							144.3667154540001,
							-35.81124001499995
						],
						[
							144.37685573500005,
							-35.792965934999984
						],
						[
							144.36233529700007,
							-35.79582085399994
						],
						[
							144.35534414900008,
							-35.78846524399995
						],
						[
							144.36028868800008,
							-35.78479746399995
						],
						[
							144.35155238900006,
							-35.78505559399997
						],
						[
							144.34911711200004,
							-35.76712886299998
						],
						[
							144.34295432200008,
							-35.77153557299994
						],
						[
							144.34152793300007,
							-35.76388781299994
						],
						[
							144.33640116300012,
							-35.77038104199994
						],
						[
							144.318657217,
							-35.766561500999956
						],
						[
							144.32783814700008,
							-35.75263301199993
						],
						[
							144.29528250200008,
							-35.75436552999997
						],
						[
							144.30128478200004,
							-35.742972409999936
						],
						[
							144.29606707300002,
							-35.737077599999964
						],
						[
							144.27784545600002,
							-35.74074079799993
						],
						[
							144.27050509600008,
							-35.75398681799993
						],
						[
							144.26450160700006,
							-35.75138988799995
						],
						[
							144.2481558720001,
							-35.721020625999984
						],
						[
							144.2159585290001,
							-35.70646356399993
						],
						[
							144.22165364900002,
							-35.69393922399996
						],
						[
							144.21348836100003,
							-35.68665782399995
						],
						[
							144.19514468400007,
							-35.685845212999936
						],
						[
							144.186794017,
							-35.67041778199996
						],
						[
							144.16235635100008,
							-35.671512949999965
						],
						[
							144.15263535500003,
							-35.64266483999995
						],
						[
							144.1429328270001,
							-35.64723910899994
						],
						[
							144.13149394900006,
							-35.64074828799994
						],
						[
							144.11755250300007,
							-35.625912926999945
						],
						[
							144.10502150800005,
							-35.59076754599994
						],
						[
							144.0622915660001,
							-35.576755342999945
						],
						[
							144.0639640070001,
							-35.57053229299993
						],
						[
							144.0468067500001,
							-35.563128871999936
						],
						[
							144.03922172300008,
							-35.549243761999946
						],
						[
							144.0340887530001,
							-35.55595801099997
						],
						[
							144.01270787700003,
							-35.554059809999956
						],
						[
							144.00965165600007,
							-35.56329384999998
						],
						[
							143.9898712800001,
							-35.55465080899995
						],
						[
							143.9992266600001,
							-35.54535403899996
						],
						[
							143.99673630100006,
							-35.53593177899995
						],
						[
							143.9746659550001,
							-35.53254369699994
						],
						[
							143.9624475480001,
							-35.51396746699993
						],
						[
							143.97253900700002,
							-35.509565486999975
						],
						[
							143.97010738900008,
							-35.50006487699994
						],
						[
							143.9333606040001,
							-35.50659697499998
						],
						[
							143.93505143400012,
							-35.499274224999965
						],
						[
							143.91826740700003,
							-35.500748183999974
						],
						[
							143.91222752800002,
							-35.494875252999975
						],
						[
							143.9061894890001,
							-35.499944952999954
						],
						[
							143.90773892900006,
							-35.49414888299998
						],
						[
							143.87659049500007,
							-35.486153410999975
						],
						[
							143.87138710600004,
							-35.47781545999993
						],
						[
							143.85879045800004,
							-35.47996489999997
						],
						[
							143.8554418110001,
							-35.461825568999984
						],
						[
							143.84604162200003,
							-35.46327913899995
						],
						[
							143.81302657900005,
							-35.44625224699996
						],
						[
							143.8180234790001,
							-35.437531856999954
						],
						[
							143.80016813200007,
							-35.433435875999976
						],
						[
							143.79012345500007,
							-35.422464194999975
						],
						[
							143.76285797900005,
							-35.42305343299995
						],
						[
							143.76596837900001,
							-35.41584486299996
						],
						[
							143.7588075100001,
							-35.41541361299994
						],
						[
							143.76883003000012,
							-35.401795542999935
						],
						[
							143.75101034400006,
							-35.38782219199993
						],
						[
							143.73963830500008,
							-35.39358134199995
						],
						[
							143.70918117000008,
							-35.392525589999934
						],
						[
							143.7116910410001,
							-35.38467731999998
						],
						[
							143.70335584200006,
							-35.389395288999935
						],
						[
							143.70235274300012,
							-35.37768598899993
						],
						[
							143.69315505400004,
							-35.383904358999985
						],
						[
							143.6842306970001,
							-35.36816886799994
						],
						[
							143.68263346600008,
							-35.37407783799995
						],
						[
							143.6674952190001,
							-35.37141523699995
						],
						[
							143.66808698800003,
							-35.38572238699993
						],
						[
							143.65714607900009,
							-35.38498638599998
						],
						[
							143.6404176110001,
							-35.40105681499995
						],
						[
							143.62938778300008,
							-35.39235528499995
						],
						[
							143.63302539300003,
							-35.383454204999964
						],
						[
							143.61955841500003,
							-35.38684266399997
						],
						[
							143.61604376700006,
							-35.368871103999936
						],
						[
							143.60302145000003,
							-35.36539419299993
						],
						[
							143.59712452200006,
							-35.351051481999946
						],
						[
							143.57352926700003,
							-35.33722911099994
						],
						[
							143.56627241800004,
							-35.34321511999997
						],
						[
							143.56137961000002,
							-35.32458971999995
						],
						[
							143.5690252810001,
							-35.302434139999946
						],
						[
							143.57794352000008,
							-35.30318354099995
						],
						[
							143.59086651000007,
							-35.28164602099997
						],
						[
							143.58351357200002,
							-35.26499204099997
						],
						[
							143.57169580400011,
							-35.26794632999997
						],
						[
							143.5740826650001,
							-35.25649251999994
						],
						[
							143.56372403700004,
							-35.243532699999946
						],
						[
							143.58099053700005,
							-35.220023089999984
						],
						[
							143.5708340000001,
							-35.206891549999966
						],
						[
							143.54702930400003,
							-35.206159527999944
						],
						[
							143.54834178300007,
							-35.21377728799996
						],
						[
							143.52916145500012,
							-35.21990836699996
						],
						[
							143.51832792800008,
							-35.21160738599997
						],
						[
							143.47148791400002,
							-35.219280253999955
						],
						[
							143.44949254100004,
							-35.18909881199994
						],
						[
							143.41650666500004,
							-35.194875069999966
						],
						[
							143.38816603100008,
							-35.185824597999954
						],
						[
							143.3939683200001,
							-35.17727379899998
						],
						[
							143.3899411120001,
							-35.17108055799997
						],
						[
							143.38207062300012,
							-35.17334794799996
						],
						[
							143.38223609400006,
							-35.15634870799994
						],
						[
							143.3906537040001,
							-35.14509373799996
						],
						[
							143.36197389100005,
							-35.11688685599995
						],
						[
							143.36076861300012,
							-35.10301902599997
						],
						[
							143.3528913340001,
							-35.09961736499997
						],
						[
							143.34810863400003,
							-35.10542737499998
						],
						[
							143.3408642060001,
							-35.09570106499996
						],
						[
							143.3450298360001,
							-35.08700647499995
						],
						[
							143.33745278800006,
							-35.080404563999934
						],
						[
							143.3455267280001,
							-35.07404258499997
						],
						[
							143.33906473900004,
							-35.06817763399994
						],
						[
							143.34966536700006,
							-35.06991536499993
						],
						[
							143.3508437480001,
							-35.06468886499994
						],
						[
							143.3376691300001,
							-35.061280763999946
						],
						[
							143.33677842100008,
							-35.04813480399997
						],
						[
							143.3304986820001,
							-35.05386644399994
						],
						[
							143.3365496120001,
							-35.04320700399995
						],
						[
							143.3286858030001,
							-35.04588675399998
						],
						[
							143.32208759500008,
							-35.036713662999944
						],
						[
							143.33599352200008,
							-35.03736235399998
						],
						[
							143.3381241940001,
							-35.01087855399993
						],
						[
							143.32970074700006,
							-34.99555305299998
						],
						[
							143.3186458990001,
							-34.99295513299995
						],
						[
							143.32378059000007,
							-34.97882911299996
						],
						[
							143.31722647300012,
							-34.95334556199998
						],
						[
							143.32179756300002,
							-34.942518262999954
						],
						[
							143.33284737200006,
							-34.938745652999955
						],
						[
							143.33850228000006,
							-34.94424895399993
						],
						[
							143.34269676100007,
							-34.93286118399993
						],
						[
							143.34025582300012,
							-34.91377140299994
						],
						[
							143.32130011800007,
							-34.88872190199993
						],
						[
							143.3421180260001,
							-34.881238432999965
						],
						[
							143.33840996700008,
							-34.87029973299997
						],
						[
							143.35256945600008,
							-34.85822192399996
						],
						[
							143.34521652800004,
							-34.85345053299994
						],
						[
							143.3549636470001,
							-34.846026423999945
						],
						[
							143.3411971390001,
							-34.84629608299997
						],
						[
							143.35956504900003,
							-34.81688644399998
						],
						[
							143.34756528100002,
							-34.807288692999975
						],
						[
							143.3478831330001,
							-34.79162234299997
						],
						[
							143.33299376500008,
							-34.793193851999945
						],
						[
							143.32909734600003,
							-34.78634426199994
						],
						[
							143.31827607800005,
							-34.790829050999946
						],
						[
							143.30885090000004,
							-34.779925710999976
						],
						[
							143.29429187100004,
							-34.790808959999936
						],
						[
							143.28433343300003,
							-34.78523245899993
						],
						[
							143.28688009200005,
							-34.79497190899997
						],
						[
							143.27674199400008,
							-34.79224754899997
						],
						[
							143.2730116560001,
							-34.776399347999984
						],
						[
							143.2577337880001,
							-34.77852911799994
						],
						[
							143.25213609900004,
							-34.77278976699995
						],
						[
							143.27402238800005,
							-34.75267184799998
						],
						[
							143.26529119000008,
							-34.74854526799993
						],
						[
							143.24893269100005,
							-34.757842806999975
						],
						[
							143.24066711400008,
							-34.74544759599996
						],
						[
							143.2287810050001,
							-34.747775385999944
						],
						[
							143.22439531500004,
							-34.75871199499994
						],
						[
							143.2138532790001,
							-34.73848232499995
						],
						[
							143.2188540190001,
							-34.72945697499995
						],
						[
							143.20091975100001,
							-34.73343373399996
						],
						[
							143.20009222300007,
							-34.71704945399995
						],
						[
							143.17928877600002,
							-34.717315301999975
						],
						[
							143.18099335600004,
							-34.70946826199997
						],
						[
							143.1732040270001,
							-34.719695961999946
						],
						[
							143.16536696800006,
							-34.71812258199998
						],
						[
							143.1616959800001,
							-34.69790262099997
						],
						[
							143.1474057810001,
							-34.71474415999995
						],
						[
							143.13347003400008,
							-34.70056392899994
						],
						[
							143.11803029700002,
							-34.70297907899993
						],
						[
							143.12761473600006,
							-34.69273249899993
						],
						[
							143.1070660580001,
							-34.70153734799993
						],
						[
							143.1114284790001,
							-34.68719891799998
						],
						[
							143.12109494800006,
							-34.68747278899997
						],
						[
							143.1123486790001,
							-34.680889957999966
						],
						[
							143.09283476100006,
							-34.701259756999946
						],
						[
							143.07622881400005,
							-34.695945105999954
						],
						[
							143.07076937600004,
							-34.678366935999975
						],
						[
							143.05482884700007,
							-34.69884140499994
						],
						[
							143.0404282500001,
							-34.68587509399998
						],
						[
							143.03947443900006,
							-34.70259757399998
						],
						[
							143.02943000100004,
							-34.69183800299993
						],
						[
							143.03250819200002,
							-34.68291499299994
						],
						[
							143.01018602400006,
							-34.69364464199998
						],
						[
							143.01728701500008,
							-34.67364706199993
						],
						[
							142.99457971800007,
							-34.67385854099996
						],
						[
							142.98932005000006,
							-34.66256626999996
						],
						[
							142.9752887620001,
							-34.670848329999956
						],
						[
							142.9824339700001,
							-34.682727159999956
						],
						[
							142.97271489000002,
							-34.695193709999955
						],
						[
							142.95926991500005,
							-34.66496879899995
						],
						[
							142.94887369600008,
							-34.66966157799993
						],
						[
							142.93261208,
							-34.65550188699996
						],
						[
							142.9222734210001,
							-34.65646960599997
						],
						[
							142.92385032200002,
							-34.647843275999946
						],
						[
							142.9015336450001,
							-34.654944744999966
						],
						[
							142.89327579500002,
							-34.665665554999975
						],
						[
							142.90018238300001,
							-34.67145109499995
						],
						[
							142.8868219950001,
							-34.67979490399995
						],
						[
							142.88646337500006,
							-34.67207173399993
						],
						[
							142.8758877570001,
							-34.67484607399996
						],
						[
							142.8721579480001,
							-34.66410553299994
						],
						[
							142.8605576000001,
							-34.66514871299995
						],
						[
							142.87187300000005,
							-34.650278912999966
						],
						[
							142.8553881030001,
							-34.63866183199997
						],
						[
							142.86834821200011,
							-34.627441672999964
						],
						[
							142.85247310500006,
							-34.619181451999964
						],
						[
							142.8406859470001,
							-34.625738430999945
						],
						[
							142.82378363100008,
							-34.60048103999998
						],
						[
							142.81826504100002,
							-34.61242901999998
						],
						[
							142.8033501440001,
							-34.60707846899993
						],
						[
							142.8106447240001,
							-34.58929240899994
						],
						[
							142.79792566600008,
							-34.59761544899993
						],
						[
							142.78690269800006,
							-34.589343817999975
						],
						[
							142.81011018700008,
							-34.560841798999945
						],
						[
							142.79143490100012,
							-34.54637560799995
						],
						[
							142.78751082100007,
							-34.55904709799995
						],
						[
							142.77020711300008,
							-34.56794613699998
						],
						[
							142.7837642290001,
							-34.579063477999966
						],
						[
							142.7482975150001,
							-34.576746525999965
						],
						[
							142.74690429400005,
							-34.58776642599997
						],
						[
							142.76341237200006,
							-34.59042318699994
						],
						[
							142.75917981100008,
							-34.60012279599994
						],
						[
							142.74319851400003,
							-34.60279808499996
						],
						[
							142.72362252800008,
							-34.592272193999975
						],
						[
							142.71482799800003,
							-34.60042986399998
						],
						[
							142.69998735100012,
							-34.599366292999946
						],
						[
							142.70397271900003,
							-34.61349378299997
						],
						[
							142.6895103810001,
							-34.618284451999955
						],
						[
							142.70879573700006,
							-34.62265013399997
						],
						[
							142.700794878,
							-34.62450223299993
						],
						[
							142.68921303800005,
							-34.65253315299998
						],
						[
							142.70861426400006,
							-34.66215384399993
						],
						[
							142.71076007200008,
							-34.67575673399995
						],
						[
							142.70592544300007,
							-34.67949421399993
						],
						[
							142.68415064700002,
							-34.67087071199995
						],
						[
							142.67890607700008,
							-34.68083419199996
						],
						[
							142.69107935300008,
							-34.70137675299998
						],
						[
							142.6844798730001,
							-34.714037202999975
						],
						[
							142.69941216000007,
							-34.72446026399996
						],
						[
							142.678652843,
							-34.72233170199996
						],
						[
							142.67656038300004,
							-34.729032761999974
						],
						[
							142.68666338100002,
							-34.73391547299997
						],
						[
							142.6789609320001,
							-34.739188372999934
						],
						[
							142.6674188940001,
							-34.73589493199995
						],
						[
							142.6614187460001,
							-34.72169340099998
						],
						[
							142.6373404090001,
							-34.73503039999997
						],
						[
							142.61832258200002,
							-34.72873853899995
						],
						[
							142.62050419000002,
							-34.75711428899996
						],
						[
							142.64637067500007,
							-34.76330243099994
						],
						[
							142.63932902500005,
							-34.78025831999997
						],
						[
							142.61682757800008,
							-34.78548589899998
						],
						[
							142.567182687,
							-34.76691516599993
						],
						[
							142.55675107800005,
							-34.77536034599996
						],
						[
							142.5335660930001,
							-34.75305398399996
						],
						[
							142.5242214640001,
							-34.75936757399995
						],
						[
							142.50811692800005,
							-34.74949828299998
						],
						[
							142.51169460800008,
							-34.74107080299996
						],
						[
							142.49956538000004,
							-34.73910398199996
						],
						[
							142.51895623000007,
							-34.702932662999956
						],
						[
							142.49975074300005,
							-34.703124801999934
						],
						[
							142.51367532200004,
							-34.69220377299996
						],
						[
							142.49743456600004,
							-34.67428167199995
						],
						[
							142.5158622240001,
							-34.66367013299998
						],
						[
							142.50567877600008,
							-34.65693514199995
						],
						[
							142.4995944860001,
							-34.66483706199995
						],
						[
							142.48695909800006,
							-34.66342745099996
						],
						[
							142.49312395700008,
							-34.672188560999984
						],
						[
							142.47559243900002,
							-34.67260493999993
						],
						[
							142.47166055200012,
							-34.65178297999995
						],
						[
							142.4836511310001,
							-34.63642170999998
						],
						[
							142.47108345300012,
							-34.640122109999936
						],
						[
							142.45233359600002,
							-34.63348498899995
						],
						[
							142.46399543500002,
							-34.626664018999975
						],
						[
							142.45916660700004,
							-34.61627576899997
						],
						[
							142.46826370600002,
							-34.61292051899994
						],
						[
							142.4613137870001,
							-34.60655232899995
						],
						[
							142.47127076700008,
							-34.59266377899996
						],
						[
							142.4583697590001,
							-34.58756175899998
						],
						[
							142.47271130800004,
							-34.57668191899995
						],
						[
							142.46797444000003,
							-34.564282068999944
						],
						[
							142.44885412300005,
							-34.55947000799995
						],
						[
							142.45875407000005,
							-34.58148423899996
						],
						[
							142.45162859100003,
							-34.58425175799994
						],
						[
							142.44492955200008,
							-34.57547658799996
						],
						[
							142.43018429500012,
							-34.57478011699993
						],
						[
							142.42606891600008,
							-34.56233520699993
						],
						[
							142.40769953900008,
							-34.56795863599996
						],
						[
							142.40556472100002,
							-34.541495434999945
						],
						[
							142.39021738300005,
							-34.549105804999954
						],
						[
							142.3767114860001,
							-34.540972023999984
						],
						[
							142.3781894860001,
							-34.53213200399995
						],
						[
							142.36770162800008,
							-34.53043294299994
						],
						[
							142.39995257400005,
							-34.52227686499998
						],
						[
							142.37494881800012,
							-34.515270742999974
						],
						[
							142.39468759700003,
							-34.49347106399995
						],
						[
							142.37773358000004,
							-34.491383062999944
						],
						[
							142.36972844000002,
							-34.50380579299997
						],
						[
							142.359582272,
							-34.498765971999944
						],
						[
							142.36427405300003,
							-34.48470138299996
						],
						[
							142.3841695100001,
							-34.478077783999936
						],
						[
							142.37927375200002,
							-34.46669102299995
						],
						[
							142.35334101600006,
							-34.46956873199997
						],
						[
							142.3679431060001,
							-34.43540149199998
						],
						[
							142.35990385800005,
							-34.43192020199996
						],
						[
							142.36454555800003,
							-34.422690931999966
						],
						[
							142.35184346000005,
							-34.42227452099996
						],
						[
							142.36070097900006,
							-34.41175488199997
						],
						[
							142.35097559200005,
							-34.39661603099995
						],
						[
							142.36390344100005,
							-34.38566669199997
						],
						[
							142.37393403900012,
							-34.388137452999956
						],
						[
							142.36806351200005,
							-34.37063736199997
						],
						[
							142.37827605000007,
							-34.36473744299997
						],
						[
							142.3635372230001,
							-34.36214568199995
						],
						[
							142.37132360200007,
							-34.35783526199998
						],
						[
							142.3897580590001,
							-34.36278607299994
						],
						[
							142.38446483100006,
							-34.34690123299998
						],
						[
							142.39700651900012,
							-34.343788383999936
						],
						[
							142.39657231,
							-34.33773628299997
						],
						[
							142.36775425500002,
							-34.32689472199996
						],
						[
							142.33093136000002,
							-34.33936436999994
						],
						[
							142.29439287700006,
							-34.323437017999936
						],
						[
							142.28387997800007,
							-34.32655413699996
						],
						[
							142.28402998900003,
							-34.31074629699998
						],
						[
							142.298893388,
							-34.30568998799998
						],
						[
							142.2861389200001,
							-34.296523056999945
						],
						[
							142.27367905200003,
							-34.304007765999984
						],
						[
							142.26733894300003,
							-34.29527061599998
						],
						[
							142.25306372500006,
							-34.30612627499994
						],
						[
							142.23590043700005,
							-34.30696032399993
						],
						[
							142.2321335690001,
							-34.29769273399995
						],
						[
							142.24820530700003,
							-34.287312364999934
						],
						[
							142.24957152800005,
							-34.26691491499997
						],
						[
							142.23242617200003,
							-34.25603941399993
						],
						[
							142.24358641100002,
							-34.24575575399996
						],
						[
							142.23534042400001,
							-34.22373445399995
						],
						[
							142.2441863040001,
							-34.21152822399995
						],
						[
							142.23664375600003,
							-34.203777242999934
						],
						[
							142.22947464600009,
							-34.20804165299995
						],
						[
							142.22796855800004,
							-34.18945080299994
						],
						[
							142.21910894000007,
							-34.181050751999976
						],
						[
							142.19858700300006,
							-34.18348274099998
						],
						[
							142.1839063960001,
							-34.17568845999995
						],
						[
							142.17831517600007,
							-34.18372954999995
						],
						[
							142.16615456800002,
							-34.18291005899994
						],
						[
							142.1665357390001,
							-34.17138253899998
						],
						[
							142.1592649700001,
							-34.17116492899993
						],
						[
							142.16663590000007,
							-34.15312105899994
						],
						[
							142.14871073400002,
							-34.14874313799993
						],
						[
							142.1380078640001,
							-34.160118857999976
						],
						[
							142.1201191870001,
							-34.15687758699994
						],
						[
							142.11961979600005,
							-34.17489512699996
						],
						[
							142.08277731200008,
							-34.17353194499998
						],
						[
							142.0775456340001,
							-34.15733284399994
						],
						[
							142.06535247600004,
							-34.15059723299993
						],
						[
							142.07564482600003,
							-34.13140528399998
						],
						[
							142.02958631400008,
							-34.12612531099995
						],
						[
							142.04214867300004,
							-34.10598673199996
						],
						[
							142.0377776150001,
							-34.09980379199993
						],
						[
							142.01331830800007,
							-34.10536788999997
						],
						[
							142.02225229500004,
							-34.12521751099996
						],
						[
							141.97765740300008,
							-34.11268854799994
						],
						[
							141.96974869300004,
							-34.119884757999955
						],
						[
							141.9704435220001,
							-34.136094207999975
						],
						[
							141.945010367,
							-34.11946440599996
						],
						[
							141.93405918700012,
							-34.138243315999944
						],
						[
							141.9256356290001,
							-34.134591444999955
						],
						[
							141.92979042900004,
							-34.12577622599997
						],
						[
							141.922598181,
							-34.11455742499993
						],
						[
							141.90351132400008,
							-34.111137163999956
						],
						[
							141.88475084700008,
							-34.11497142299993
						],
						[
							141.88879627500012,
							-34.12440252299996
						],
						[
							141.87663348600006,
							-34.137404412999956
						],
						[
							141.86776980800005,
							-34.128638371999955
						],
						[
							141.85326411000005,
							-34.13122017099994
						],
						[
							141.85070042100006,
							-34.12429376099993
						],
						[
							141.8413902420001,
							-34.13243850099997
						],
						[
							141.78645219200007,
							-34.111672417999955
						],
						[
							141.7768933330001,
							-34.11686483699998
						],
						[
							141.77790439400007,
							-34.10176135699993
						],
						[
							141.75695373700012,
							-34.112083095999935
						],
						[
							141.75262995800006,
							-34.10622951599993
						],
						[
							141.76184326700002,
							-34.09752398599994
						],
						[
							141.7463493990001,
							-34.10339083499997
						],
						[
							141.73146555200003,
							-34.09094445399995
						],
						[
							141.72547561300007,
							-34.09401020399997
						],
						[
							141.72987834100002,
							-34.10556402399993
						],
						[
							141.71901791200003,
							-34.11488113399997
						],
						[
							141.70829153500006,
							-34.09633814299997
						],
						[
							141.67745632000003,
							-34.10121139199998
						],
						[
							141.654678772,
							-34.116675509999936
						],
						[
							141.63265944500006,
							-34.121471628999984
						],
						[
							141.62798919400007,
							-34.145403948999956
						],
						[
							141.61182460700002,
							-34.139010257999985
						],
						[
							141.61854491400004,
							-34.156274088999965
						],
						[
							141.60458621700002,
							-34.14910176799998
						],
						[
							141.58390898000005,
							-34.15195254699995
						],
						[
							141.60296570600008,
							-34.16224072799997
						],
						[
							141.5893901070001,
							-34.177340526999956
						],
						[
							141.60495407400003,
							-34.18392044799998
						],
						[
							141.60329152400004,
							-34.19121555799995
						],
						[
							141.5897496660001,
							-34.18688028699995
						],
						[
							141.58392851600001,
							-34.19880342699997
						],
						[
							141.56047538000007,
							-34.19088639599994
						],
						[
							141.5477444920001,
							-34.20082803499997
						],
						[
							141.53355317500007,
							-34.19142116399996
						],
						[
							141.53386995300002,
							-34.21068334499995
						],
						[
							141.51007725600005,
							-34.21646599299993
						],
						[
							141.50615511700005,
							-34.21048484299996
						],
						[
							141.51858304600012,
							-34.20314606399995
						],
						[
							141.506676609,
							-34.19060590299995
						],
						[
							141.51875026800008,
							-34.18089689399994
						],
						[
							141.4949727930001,
							-34.15459766199996
						],
						[
							141.4828085150001,
							-34.16341177099997
						],
						[
							141.45064968000008,
							-34.160990509999976
						],
						[
							141.44454630000007,
							-34.168001938999964
						],
						[
							141.4328085420001,
							-34.15992724899996
						],
						[
							141.43390769300004,
							-34.14589086899997
						],
						[
							141.4171623860001,
							-34.150764547999984
						],
						[
							141.4074107670001,
							-34.14638735699998
						],
						[
							141.4082540390001,
							-34.12784267699993
						],
						[
							141.38812499100004,
							-34.134716985999944
						],
						[
							141.38159355300002,
							-34.122129195999946
						],
						[
							141.36970019500006,
							-34.12019026499996
						],
						[
							141.36876522500006,
							-34.12710130499994
						],
						[
							141.3589858680001,
							-34.11071023399995
						],
						[
							141.3485115190001,
							-34.112297773999956
						],
						[
							141.34641417900002,
							-34.12433419399997
						],
						[
							141.32494416100008,
							-34.138768572999936
						],
						[
							141.32592827100007,
							-34.12685258299996
						],
						[
							141.31353630400008,
							-34.12484710199993
						],
						[
							141.31745816400007,
							-34.11240024199998
						],
						[
							141.30079747600007,
							-34.113705110999945
						],
						[
							141.298550717,
							-34.10694678099998
						],
						[
							141.28370840000002,
							-34.10386162999998
						],
						[
							141.259572025,
							-34.07812119899995
						],
						[
							141.2425493170001,
							-34.087328207999974
						],
						[
							141.2418141490001,
							-34.06130124799995
						],
						[
							141.22847520000005,
							-34.073637566999935
						],
						[
							141.22212568200007,
							-34.06166338699995
						],
						[
							141.20591430500008,
							-34.061709495999935
						],
						[
							141.18745554600002,
							-34.07928062499997
						],
						[
							141.19444347500007,
							-34.08759431599998
						],
						[
							141.18623652600002,
							-34.09196316499998
						],
						[
							141.17467520900004,
							-34.07332008399993
						],
						[
							141.16586167900005,
							-34.08319881399996
						],
						[
							141.15367703100003,
							-34.082104852999976
						],
						[
							141.15318727200008,
							-34.06890188299997
						],
						[
							141.1438547240001,
							-34.06778556299997
						],
						[
							141.15344973300012,
							-34.06417566299996
						],
						[
							141.15311819300007,
							-34.05450776299995
						],
						[
							141.14298060400006,
							-34.06352066299996
						],
						[
							141.1373142660001,
							-34.057547641999975
						],
						[
							141.12034472800008,
							-34.064852791999954
						],
						[
							141.09424484300007,
							-34.05064372999993
						],
						[
							141.0872633030001,
							-34.05715999999995
						],
						[
							141.09759396100003,
							-34.07002192999994
						],
						[
							141.08922427200002,
							-34.076683249999974
						],
						[
							141.08491737300005,
							-34.06227489999998
						],
						[
							141.07195768500003,
							-34.06289616899994
						],
						[
							141.06560759700005,
							-34.05004885899996
						],
						[
							141.04247060000012,
							-34.061088077999955
						],
						[
							141.04344646100003,
							-34.042690196999956
						],
						[
							141.03434319300004,
							-34.03572137699996
						],
						[
							141.02347418300008,
							-34.059749496999984
						],
						[
							141.0019413880001,
							-34.03927064499993
						],
						[
							141.00378256800002,
							-34.02759112499996
						],
						[
							141.012372077,
							-34.02472245599995
						],
						[
							141.002962539,
							-34.021878544999936
						],
						[
							140.9872909710001,
							-34.02965977399998
						],
						[
							140.98045996300004,
							-34.01599961399995
						],
						[
							140.98675362200004,
							-34.01022365399996
						],
						[
							140.9753270540001,
							-34.009307493999984
						],
						[
							140.98058169400008,
							-33.99998251399995
						],
						[
							140.96876463600006,
							-33.996699072999945
						],
						[
							140.96368894800003,
							-33.98063640299995
						],
						[
							140.96542467100005,
							-34.86983961899995
						],
						[
							140.96310907400004,
							-35.74850734399996
						],
						[
							140.96853909000004,
							-36.55132211999995
						],
						[
							140.9731800940001,
							-37.35822367499998
						],
						[
							141.0464143480001,
							-37.40184667899996
						],
						[
							141.09726471500005,
							-37.44986824199998
						],
						[
							141.1682441050001,
							-37.41986692499995
						],
						[
							141.26384608700005,
							-37.430076619999966
						],
						[
							141.25970928900006,
							-37.42100615999993
						],
						[
							141.26882629700003,
							-37.421783570999935
						],
						[
							141.28028583800005,
							-37.39408311099993
						],
						[
							141.24847912500002,
							-37.369229408999956
						],
						[
							141.2208876100001,
							-37.364560747999974
						],
						[
							141.2180702820001,
							-37.35086771799996
						],
						[
							141.43153706300006,
							-37.372288638999976
						],
						[
							141.4315126890001,
							-37.29752240899995
						],
						[
							141.53145058200005,
							-37.29762961399996
						],
						[
							141.5183525960001,
							-37.280647612999985
						],
						[
							141.52351658500004,
							-37.274973632999945
						],
						[
							141.48956060400008,
							-37.24667162099996
						],
						[
							141.49698759300009,
							-37.23828563199993
						],
						[
							141.4897685850001,
							-37.235240620999946
						],
						[
							141.49174060500002,
							-37.220149610999954
						],
						[
							141.5761845840001,
							-37.188108615999965
						],
						[
							141.59721183200008,
							-37.16121618699998
						],
						[
							141.6148395780001,
							-37.16943762799997
						],
						[
							141.63170658700005,
							-37.15526762899998
						],
						[
							141.6396665850001,
							-37.165423628999974
						],
						[
							141.64014057500003,
							-37.15915162899995
						],
						[
							141.67237058000012,
							-37.152256620999935
						],
						[
							141.67149756900005,
							-37.160950620999984
						],
						[
							141.69247057500002,
							-37.164979631999984
						],
						[
							141.70565455200006,
							-37.18442363299994
						],
						[
							141.7245755680001,
							-37.18800164399994
						],
						[
							141.72922153800005,
							-37.17859863399997
						],
						[
							141.7434505550001,
							-37.18114164499997
						],
						[
							141.74157854600003,
							-37.17469862499996
						],
						[
							141.77533454000002,
							-37.18027663699996
						],
						[
							141.77334828100004,
							-37.17256883599998
						],
						[
							141.77793954000003,
							-37.17669864699997
						],
						[
							141.7864705390001,
							-37.16877662699994
						],
						[
							141.7854785390001,
							-37.17411563699994
						],
						[
							141.7953915370001,
							-37.175382627999966
						],
						[
							141.80077152700005,
							-37.16666163799994
						],
						[
							141.8109005340001,
							-37.17731563899997
						],
						[
							141.81149855500007,
							-37.168079648999935
						],
						[
							141.821212553,
							-37.17398863899996
						],
						[
							141.8401865200001,
							-37.16814563999998
						],
						[
							141.83447756200007,
							-37.15809663999994
						],
						[
							141.8405445510001,
							-37.15249762999997
						],
						[
							141.908881521,
							-37.134834653999974
						],
						[
							141.90347854300012,
							-37.12355864299997
						],
						[
							141.9110575420001,
							-37.11345164399995
						],
						[
							141.92548051900008,
							-37.12513264499995
						],
						[
							141.9241785270001,
							-37.15231163499993
						],
						[
							141.93498153400003,
							-37.16620463499993
						],
						[
							141.9276025150001,
							-37.16912264499996
						],
						[
							141.93559352300008,
							-37.17078864499996
						],
						[
							141.9117105260001,
							-37.18982564399994
						],
						[
							141.91277851400002,
							-37.20234764399993
						],
						[
							141.93820200000005,
							-37.20005899599994
						],
						[
							141.9450466180001,
							-37.21069841599996
						],
						[
							141.98925249,
							-37.212405658999955
						],
						[
							141.9997710570001,
							-37.224316348999935
						],
						[
							142.0645654870001,
							-37.21852264299997
						],
						[
							142.07938448400012,
							-37.223633663999976
						],
						[
							142.08875140300006,
							-37.212618893999945
						],
						[
							142.0922615060001,
							-37.17087665399998
						],
						[
							142.1091115040001,
							-37.16271965499993
						],
						[
							142.1144941980001,
							-37.11204070499997
						],
						[
							142.16364020000003,
							-37.10582895799996
						],
						[
							142.1875444850001,
							-37.112775658999965
						],
						[
							142.20626150400005,
							-37.08728265999997
						],
						[
							142.2219364980001,
							-37.119893660999935
						],
						[
							142.233913496,
							-37.12432866199998
						],
						[
							142.24102347200005,
							-37.14991167299996
						],
						[
							142.32876430300007,
							-37.19919104799993
						],
						[
							142.35883328500006,
							-37.22549584999996
						],
						[
							142.40346675700005,
							-37.23737237199998
						],
						[
							142.42309605100002,
							-37.26008325399994
						],
						[
							142.45513468500008,
							-37.26542997599995
						],
						[
							142.4656306920001,
							-37.28158395599996
						],
						[
							142.5125150130001,
							-37.29385256899997
						],
						[
							142.5989384180001,
							-37.29289354399998
						],
						[
							142.58080244300004,
							-37.27265466299997
						],
						[
							142.59704093100004,
							-37.26218639399997
						],
						[
							142.59822546400005,
							-37.22439811399994
						],
						[
							142.5427798300001,
							-37.15740466999995
						],
						[
							142.7170888700001,
							-37.157286349999936
						],
						[
							142.71705256100006,
							-37.142878199999984
						],
						[
							142.75643134400002,
							-37.15086313299997
						],
						[
							142.76874552300012,
							-37.14283388299998
						],
						[
							142.768455022,
							-37.154402742999935
						],
						[
							142.7817686090001,
							-37.157662183999946
						],
						[
							142.78366182800005,
							-37.16887381399994
						],
						[
							142.8239074500001,
							-37.17165967699998
						],
						[
							142.8378909260001,
							-37.19162746799998
						],
						[
							142.9539803250001,
							-37.20776507499994
						],
						[
							142.9612883970001,
							-37.16702489499994
						],
						[
							142.9945351010001,
							-37.17733466699997
						],
						[
							142.99352825000005,
							-37.18305869699998
						],
						[
							143.0489163300001,
							-37.18973669999997
						],
						[
							143.0591000490001,
							-37.187187870999935
						],
						[
							143.06694460100005,
							-37.14735472099994
						],
						[
							143.08372137800006,
							-37.14864565199997
						],
						[
							143.11349158200005,
							-37.15755492399995
						],
						[
							143.12710457800006,
							-37.17319332499994
						],
						[
							143.15062773500006,
							-37.17073243599998
						],
						[
							143.18172969800003,
							-37.18860930799997
						],
						[
							143.2024349070001,
							-37.16111800899995
						],
						[
							143.22159846400007,
							-37.15254985099995
						],
						[
							143.2342607500001,
							-37.16871071099996
						],
						[
							143.2637112440001,
							-37.18164506299996
						],
						[
							143.27031526200005,
							-37.19750571399993
						],
						[
							143.28255794000006,
							-37.19531713499998
						],
						[
							143.29361823600004,
							-37.21060975499995
						],
						[
							143.3362782690001,
							-37.20630672799996
						],
						[
							143.33842128700007,
							-37.22266671799997
						],
						[
							143.35149328500006,
							-37.22373172899995
						],
						[
							143.35038828400002,
							-37.23294472899994
						],
						[
							143.35950094300006,
							-37.226528188999964
						],
						[
							143.4017338860001,
							-37.229929951999964
						],
						[
							143.46507725100003,
							-37.26920573599995
						],
						[
							143.47533725000005,
							-37.26089673699994
						],
						[
							143.46766225300007,
							-37.25143372599996
						],
						[
							143.4840732780001,
							-37.169710736999946
						],
						[
							143.52162925100004,
							-37.17596773899993
						],
						[
							143.52076125000008,
							-37.18109573899994
						],
						[
							143.58541802900004,
							-37.184539822999966
						],
						[
							143.58229033800012,
							-37.20172020299998
						],
						[
							143.6406455770001,
							-37.208298026999955
						],
						[
							143.63640588600003,
							-37.23082035699997
						],
						[
							143.66513507000002,
							-37.236641848999966
						],
						[
							143.68703243700008,
							-37.22894828999995
						],
						[
							143.71392107200006,
							-37.230268301999956
						],
						[
							143.72701745200004,
							-37.21365765199994
						],
						[
							143.75890125400008,
							-37.23309331399997
						],
						[
							143.76629023400005,
							-37.228220704999956
						],
						[
							143.82019737400003,
							-37.23520704799995
						],
						[
							143.82206719400006,
							-37.225931757999945
						],
						[
							143.8584431170001,
							-37.23533382099998
						],
						[
							143.87500820900004,
							-37.18638875199997
						],
						[
							143.9494175760001,
							-37.19444682599993
						],
						[
							143.96265626500008,
							-37.17652061699994
						],
						[
							143.9629549880001,
							-37.148713476999944
						],
						[
							143.95518655000012,
							-37.139883735999945
						],
						[
							143.96463833300004,
							-37.10076289699998
						],
						[
							143.97196830200005,
							-37.091553396999984
						],
						[
							143.9797090400001,
							-37.09938203799993
						],
						[
							143.98614979,
							-37.08679598799995
						],
						[
							144.0120589070001,
							-37.07681168999994
						],
						[
							144.01259374800009,
							-37.06674561999995
						],
						[
							143.9915989530001,
							-37.05403378799997
						],
						[
							143.97345082800007,
							-37.02936481699993
						],
						[
							143.8957050020001,
							-37.02355951199996
						],
						[
							143.89970361400003,
							-37.00054227199996
						],
						[
							143.8822938070001,
							-36.99855840099997
						],
						[
							143.884250618,
							-36.986312270999974
						],
						[
							143.83064427700003,
							-36.980718886999966
						],
						[
							143.83641718800004,
							-36.96326206799995
						],
						[
							143.8598884050001,
							-36.94995219899994
						],
						[
							143.84655120000002,
							-36.927952277999964
						],
						[
							143.8629757980001,
							-36.915505818999975
						],
						[
							143.86640146900004,
							-36.90124253899995
						],
						[
							143.89210209500004,
							-36.893916280999974
						],
						[
							143.89170497700002,
							-36.88188821099993
						],
						[
							144.0259053420001,
							-36.89788336899994
						],
						[
							144.04794269900003,
							-36.79223571999995
						],
						[
							144.06231862900006,
							-36.76667606099994
						],
						[
							144.07128550800007,
							-36.766426241999966
						],
						[
							144.07566091,
							-36.74312469199998
						],
						[
							144.05984612300006,
							-36.73073870099995
						],
						[
							144.06207342400012,
							-36.71939637099996
						],
						[
							144.06872697300003,
							-36.720214650999935
						],
						[
							144.0687010690001,
							-36.66199204099996
						],
						[
							144.12581289900004,
							-36.66200797399995
						],
						[
							144.12588812100012,
							-36.64730008399994
						],
						[
							144.14049691800005,
							-36.64729845499994
						],
						[
							144.14040334100002,
							-36.618422764999934
						],
						[
							144.18473444400001,
							-36.618467857999974
						],
						[
							144.16265023300002,
							-36.56555920599993
						],
						[
							144.1704633160001,
							-36.52441281599994
						],
						[
							144.1993443010001,
							-36.52447878799995
						],
						[
							144.209675263,
							-36.48750696899998
						],
						[
							144.34375865100003,
							-36.487082457999975
						],
						[
							144.34409993100007,
							-36.385206506999964
						],
						[
							144.33004448300005,
							-36.38506005599993
						],
						[
							144.33183980900003,
							-36.327704955999934
						],
						[
							144.28173499700006,
							-36.327710071999945
						],
						[
							144.28164320300004,
							-36.262607411999966
						],
						[
							144.26679106000006,
							-36.22478329099994
						],
						[
							144.28909629200007,
							-36.16668603199997
						],
						[
							144.28317577400003,
							-36.15232358099996
						],
						[
							144.2892428450001,
							-36.12917449199995
						],
						[
							144.30226476400003,
							-36.12542014199994
						],
						[
							144.30905938500007,
							-36.105356892999964
						],
						[
							144.31867425300004,
							-36.101185302999966
						],
						[
							144.30393946000004,
							-36.061291181999934
						],
						[
							144.3178480790001,
							-36.04982634299995
						],
						[
							144.30668952200006,
							-36.03187504199997
						],
						[
							144.2799472580001,
							-36.01327041999997
						],
						[
							144.2769492210001,
							-35.99398063999996
						],
						[
							144.2914086190001,
							-35.984414270999935
						],
						[
							144.25931746800006,
							-35.94662127899994
						],
						[
							144.2629704190001,
							-35.93144998899993
						],
						[
							144.2837395370001,
							-35.92363852999995
						],
						[
							144.30620568200004,
							-35.934141791999934
						],
						[
							144.34604185600006,
							-35.928115213999945
						],
						[
							144.35514801600004,
							-35.91067366499993
						],
						[
							144.3424206190001,
							-35.907376333999935
						],
						[
							144.34356792000005,
							-35.894313273999956
						],
						[
							144.36172163800006,
							-35.88628322499994
						],
						[
							144.3819025150001,
							-35.88435676599994
						],
						[
							144.40854469900012,
							-35.89887767799996
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "230",
				"CED_NAME21": "Mallee",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 83412.6591,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/230",
				"SHAPE_Leng": 20.8304003433,
				"SHAPE_Area": 8.32447363411
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							144.90959781900006,
							-37.69400644299998
						],
						[
							144.9054401410001,
							-37.68119286299998
						],
						[
							144.8855989640001,
							-37.680694840999934
						],
						[
							144.88158896400012,
							-37.68890382099994
						],
						[
							144.84416687500004,
							-37.64575451799993
						],
						[
							144.83392402700008,
							-37.643974887999946
						],
						[
							144.81604199100002,
							-37.64099683599994
						],
						[
							144.81337497000004,
							-37.65508182599996
						],
						[
							144.7979459820001,
							-37.65431884499998
						],
						[
							144.8062108910001,
							-37.658888795999985
						],
						[
							144.79980898100007,
							-37.660706784999945
						],
						[
							144.8088968190001,
							-37.665047845999936
						],
						[
							144.80475608000006,
							-37.66950383599993
						],
						[
							144.80632498800003,
							-37.683113815999945
						],
						[
							144.82048702500003,
							-37.684322866999935
						],
						[
							144.80973992600002,
							-37.69808279599994
						],
						[
							144.83809495000003,
							-37.70546487799993
						],
						[
							144.84996054500004,
							-37.73447348899998
						],
						[
							144.8304214090001,
							-37.72458371799996
						],
						[
							144.8275603190001,
							-37.73424317799993
						],
						[
							144.8373382970001,
							-37.73524274799996
						],
						[
							144.8349890170001,
							-37.741603977999944
						],
						[
							144.84686494400012,
							-37.748051878999945
						],
						[
							144.85244174000002,
							-37.773032669999964
						],
						[
							144.87284161700006,
							-37.772231560999955
						],
						[
							144.87256261800007,
							-37.76209833099995
						],
						[
							144.8852343960001,
							-37.75600221199994
						],
						[
							144.8847534260001,
							-37.76149631199996
						],
						[
							144.90165420300002,
							-37.76543629299994
						],
						[
							144.89721215200007,
							-37.77943350299995
						],
						[
							144.91649936600004,
							-37.79820110399993
						],
						[
							144.93590933300004,
							-37.802273164999974
						],
						[
							144.93708011500007,
							-37.777761054999985
						],
						[
							144.93841418700003,
							-37.76091095499993
						],
						[
							144.92672496000012,
							-37.75144883499996
						],
						[
							144.93473400900007,
							-37.743908844999964
						],
						[
							144.89754346900008,
							-37.70925225199994
						],
						[
							144.90429129900008,
							-37.700858822999976
						],
						[
							144.89781160000007,
							-37.69828726199995
						],
						[
							144.90959781900006,
							-37.69400644299998
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "231",
				"CED_NAME21": "Maribyrnong",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 97.1041,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/231",
				"SHAPE_Leng": 0.810781010408,
				"SHAPE_Area": 0.00992348940309
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							144.95263077200002,
							-37.60032903499996
						],
						[
							145.07954693800002,
							-37.61351584399995
						],
						[
							145.0819761990001,
							-37.59895104399993
						],
						[
							145.1052591450001,
							-37.60169985599998
						],
						[
							145.1061079540001,
							-37.61510184599996
						],
						[
							145.1225450290001,
							-37.626562786999955
						],
						[
							145.10192249200009,
							-37.638560955999935
						],
						[
							145.1078046890001,
							-37.65822121599996
						],
						[
							145.08947782100006,
							-37.66390443499995
						],
						[
							145.08346101100005,
							-37.67694268499997
						],
						[
							145.10354626700007,
							-37.68293009599995
						],
						[
							145.11786437500007,
							-37.67918980699994
						],
						[
							145.1917499210001,
							-37.68949684199998
						],
						[
							145.2012751420001,
							-37.66315825299995
						],
						[
							145.22014793900007,
							-37.65799486399993
						],
						[
							145.22005391800008,
							-37.66652486399994
						],
						[
							145.24329193500012,
							-37.66260685599997
						],
						[
							145.26344153000002,
							-37.676335206999966
						],
						[
							145.264116886,
							-37.70734013799995
						],
						[
							145.2722827350001,
							-37.70378504799993
						],
						[
							145.27235891400005,
							-37.71584219799996
						],
						[
							145.28360080200002,
							-37.718843198999934
						],
						[
							145.28273564300002,
							-37.70855203899998
						],
						[
							145.292317442,
							-37.70242995899997
						],
						[
							145.29359753100005,
							-37.71222106999994
						],
						[
							145.31125735700004,
							-37.716104050999945
						],
						[
							145.31417016800003,
							-37.70663096099997
						],
						[
							145.32205106600009,
							-37.707452941999975
						],
						[
							145.31706005900003,
							-37.69198978099996
						],
						[
							145.33103685600008,
							-37.692148661999965
						],
						[
							145.33037171900003,
							-37.67192061199995
						],
						[
							145.3538896880001,
							-37.64389711299998
						],
						[
							145.36641766600007,
							-37.545112813999935
						],
						[
							145.3413448010001,
							-37.543458561999955
						],
						[
							145.32850964500005,
							-37.52911950099997
						],
						[
							145.30477896000002,
							-37.52193468899998
						],
						[
							145.31383679900011,
							-37.51554656999997
						],
						[
							145.29706888200008,
							-37.51368169899996
						],
						[
							145.29439482400005,
							-37.49856861799998
						],
						[
							145.27631086700012,
							-37.49647571699995
						],
						[
							145.2644701590001,
							-37.50132885599993
						],
						[
							145.2624484580001,
							-37.51188802599995
						],
						[
							145.25170074000005,
							-37.51063109499995
						],
						[
							145.25671624100005,
							-37.491967725999984
						],
						[
							145.23932465500002,
							-37.48772585399996
						],
						[
							145.24104165500012,
							-37.47770964399996
						],
						[
							145.2222782890001,
							-37.472586192999984
						],
						[
							145.2362711410001,
							-37.43585441399995
						],
						[
							145.26562549800008,
							-37.41934075599994
						],
						[
							145.26582640300012,
							-37.37269061599994
						],
						[
							145.2565157250001,
							-37.36795410499997
						],
						[
							145.27137794200007,
							-37.36804786599998
						],
						[
							145.2704909260001,
							-37.33889715599997
						],
						[
							145.27935567500003,
							-37.33236800599997
						],
						[
							145.26197441800002,
							-37.32966853499994
						],
						[
							145.25186684200003,
							-37.30493923399996
						],
						[
							145.22744900700002,
							-37.305082511999956
						],
						[
							145.22732011800008,
							-37.29424867199998
						],
						[
							145.19538821300011,
							-37.294106849999935
						],
						[
							145.12527340500003,
							-37.29388388499996
						],
						[
							145.12506195800006,
							-37.269019844999946
						],
						[
							145.1176079700001,
							-37.26320485499997
						],
						[
							145.05613599000003,
							-37.26347383999996
						],
						[
							145.05522498800008,
							-37.28650683999996
						],
						[
							145.05064501100003,
							-37.26592883999996
						],
						[
							145.03101297400008,
							-37.265839838999966
						],
						[
							145.03863096400005,
							-37.252110838999954
						],
						[
							145.01425798100001,
							-37.22776383699994
						],
						[
							144.98775000400008,
							-37.242536825999935
						],
						[
							144.97670500700008,
							-37.234126834999984
						],
						[
							144.98989153800005,
							-37.20108426499996
						],
						[
							144.96364403300004,
							-37.20087784399993
						],
						[
							144.96266101100002,
							-37.21434182399997
						],
						[
							144.930823787,
							-37.20964767099997
						],
						[
							144.93164568600002,
							-37.21588423199995
						],
						[
							144.92106302800005,
							-37.215707830999975
						],
						[
							144.92543200600005,
							-37.22540884099993
						],
						[
							144.88687403300003,
							-37.22105881899995
						],
						[
							144.87426302500012,
							-37.22838481799994
						],
						[
							144.8501061600001,
							-37.22041629599994
						],
						[
							144.8522184510001,
							-37.20893561599996
						],
						[
							144.84543657200004,
							-37.20816516599996
						],
						[
							144.7857269210001,
							-37.21306666199996
						],
						[
							144.777746782,
							-37.21982081099998
						],
						[
							144.76957567400007,
							-37.21510901099998
						],
						[
							144.7688458240001,
							-37.22072909099995
						],
						[
							144.70381747500005,
							-37.21294511599996
						],
						[
							144.69248407600003,
							-37.22152972499998
						],
						[
							144.68334761900007,
							-37.210801464999975
						],
						[
							144.65996192300008,
							-37.20826052299998
						],
						[
							144.660529063,
							-37.214165812999966
						],
						[
							144.63651020600003,
							-37.223224321999965
						],
						[
							144.61737781700003,
							-37.24089954999994
						],
						[
							144.59715675100006,
							-37.24055568899996
						],
						[
							144.59513103900008,
							-37.26292377899995
						],
						[
							144.58394408100003,
							-37.262392777999935
						],
						[
							144.57983323000008,
							-37.27529985799998
						],
						[
							144.56946219200006,
							-37.27355265699998
						],
						[
							144.56460160000006,
							-37.29948077699993
						],
						[
							144.4941212430001,
							-37.29220274299996
						],
						[
							144.49103421200005,
							-37.300660781999966
						],
						[
							144.50101156000005,
							-37.307073672999934
						],
						[
							144.4803946510001,
							-37.332807281999976
						],
						[
							144.460576424,
							-37.338585870999964
						],
						[
							144.44639402100006,
							-37.386059279999984
						],
						[
							144.41526448700006,
							-37.38246997799996
						],
						[
							144.41494748600007,
							-37.39683431799995
						],
						[
							144.38197292200005,
							-37.39331406599996
						],
						[
							144.3792841070001,
							-37.43877539599998
						],
						[
							144.41693969000005,
							-37.44661430799994
						],
						[
							144.42640176700002,
							-37.45886753899998
						],
						[
							144.4333044970001,
							-37.45037735999995
						],
						[
							144.450209104,
							-37.450637040999936
						],
						[
							144.4704735030001,
							-37.42878253199996
						],
						[
							144.459320917,
							-37.49708780199995
						],
						[
							144.46989529500001,
							-37.50757227199995
						],
						[
							144.46911854300004,
							-37.52123045199994
						],
						[
							144.4576852030001,
							-37.54457283199997
						],
						[
							144.48370393800008,
							-37.55080755299997
						],
						[
							144.55623124400006,
							-37.55888715799995
						],
						[
							144.56118232400001,
							-37.55240354899996
						],
						[
							144.67165156300007,
							-37.56770851599998
						],
						[
							144.63241534400004,
							-37.53010833299993
						],
						[
							144.638057956,
							-37.49948876299993
						],
						[
							144.64503453600003,
							-37.49503080399995
						],
						[
							144.67948606900006,
							-37.49939334599998
						],
						[
							144.7011085270001,
							-37.48189789799994
						],
						[
							144.75753637600008,
							-37.49482516099994
						],
						[
							144.76689603400007,
							-37.50501047199998
						],
						[
							144.87051119500006,
							-37.51552263899998
						],
						[
							144.86633588600012,
							-37.50684781899997
						],
						[
							144.87533989500002,
							-37.50210582899996
						],
						[
							144.9772112270001,
							-37.51371547699995
						],
						[
							144.97259923500008,
							-37.53526660599994
						],
						[
							144.9537888870001,
							-37.54504662499994
						],
						[
							144.96535821200007,
							-37.57216812599995
						],
						[
							144.95263077200002,
							-37.60032903499996
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "232",
				"CED_NAME21": "McEwen",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 2678.3109,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/232",
				"SHAPE_Leng": 4.2250821638,
				"SHAPE_Area": 0.272637957696
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							145.02462391400002,
							-37.83448585199994
						],
						[
							145.01574467800003,
							-37.810614930999975
						],
						[
							144.999376911,
							-37.80564297999996
						],
						[
							145.00767278000012,
							-37.80389089999994
						],
						[
							145.00195118200008,
							-37.79664577999995
						],
						[
							145.00809994200006,
							-37.786894839999945
						],
						[
							144.98687106700004,
							-37.77436482899998
						],
						[
							144.93708011500007,
							-37.777761054999985
						],
						[
							144.93590933300004,
							-37.802273164999974
						],
						[
							144.91649936600004,
							-37.79820110399993
						],
						[
							144.90556845600008,
							-37.82287487399998
						],
						[
							144.97162899500006,
							-37.81940586799993
						],
						[
							144.9879264210001,
							-37.82965915899996
						],
						[
							145.02462391400002,
							-37.83448585199994
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "233",
				"CED_NAME21": "Melbourne",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 40.2725,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/233",
				"SHAPE_Leng": 0.399204420602,
				"SHAPE_Area": 0.00412002133585
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							145.264116886,
							-37.70734013799995
						],
						[
							145.2423754780001,
							-37.72547163599995
						],
						[
							145.23508691000006,
							-37.71629285599994
						],
						[
							145.20211368600008,
							-37.71092001299996
						],
						[
							145.20089291500005,
							-37.72251884299993
						],
						[
							145.1891858670001,
							-37.72595459199994
						],
						[
							145.193817716,
							-37.73177093299995
						],
						[
							145.1813246480001,
							-37.729828321999946
						],
						[
							145.17820779800002,
							-37.73825744199996
						],
						[
							145.15538103200004,
							-37.733935549999956
						],
						[
							145.1229756470001,
							-37.74040589799995
						],
						[
							145.12606474500012,
							-37.75106485799995
						],
						[
							145.11290091700005,
							-37.755237146999946
						],
						[
							145.08260891300006,
							-37.75136337499998
						],
						[
							145.06711849200008,
							-37.78092232399996
						],
						[
							145.09566093700005,
							-37.78009685599994
						],
						[
							145.1187725520001,
							-37.796388597999965
						],
						[
							145.11503572000004,
							-37.81688082799997
						],
						[
							145.1541979430001,
							-37.81754792099997
						],
						[
							145.21336571300003,
							-37.817208894999965
						],
						[
							145.21721197500005,
							-37.79086976499997
						],
						[
							145.23597118200007,
							-37.79007326599998
						],
						[
							145.2405751540001,
							-37.764749965999954
						],
						[
							145.28957843600006,
							-37.76280578999996
						],
						[
							145.28167140900007,
							-37.74256713899996
						],
						[
							145.29359753100005,
							-37.71222106999994
						],
						[
							145.292317442,
							-37.70242995899997
						],
						[
							145.28273564300002,
							-37.70855203899998
						],
						[
							145.28360080200002,
							-37.718843198999934
						],
						[
							145.27235891400005,
							-37.71584219799996
						],
						[
							145.2722827350001,
							-37.70378504799993
						],
						[
							145.264116886,
							-37.70734013799995
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "234",
				"CED_NAME21": "Menzies",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 137.316,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/234",
				"SHAPE_Leng": 0.847704308717,
				"SHAPE_Area": 0.0140408240418
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								146.52145570200003,
								-38.68897554399996
							],
							[
								146.5256078100001,
								-38.61929586399998
							],
							[
								146.4780600690001,
								-38.613973390999945
							],
							[
								146.4615586430001,
								-38.60737157899996
							],
							[
								146.46313372300006,
								-38.59848740899997
							],
							[
								146.4276720890001,
								-38.60497097699994
							],
							[
								146.3688106610001,
								-38.59184933199998
							],
							[
								146.36762660300008,
								-38.57655094199998
							],
							[
								146.31270160500003,
								-38.56183294799996
							],
							[
								146.31244942700005,
								-38.54389119799998
							],
							[
								146.32731200600006,
								-38.53073671899995
							],
							[
								146.31332162900003,
								-38.51955193799995
							],
							[
								146.2903936130001,
								-38.52784292599995
							],
							[
								146.28361775500002,
								-38.51700289599995
							],
							[
								146.29180342600011,
								-38.50010495599997
							],
							[
								146.25476316300012,
								-38.49609674299995
							],
							[
								146.26257314400004,
								-38.47097681399998
							],
							[
								146.23842934900006,
								-38.46795587199995
							],
							[
								146.23718575100008,
								-38.45289393199994
							],
							[
								146.26927107500012,
								-38.45693968399996
							],
							[
								146.27219063500002,
								-38.44640924399994
							],
							[
								146.22319768500006,
								-38.43994478099995
							],
							[
								146.23439486000007,
								-38.38064608099995
							],
							[
								146.2408747490001,
								-38.37915900199994
							],
							[
								146.21051357500005,
								-38.37038238899993
							],
							[
								146.23150454400002,
								-38.354193340999984
							],
							[
								146.24352665100002,
								-38.356108921999976
							],
							[
								146.25052045400002,
								-38.32663800199998
							],
							[
								146.2285726880001,
								-38.323877109999955
							],
							[
								146.23230549800007,
								-38.316349000999935
							],
							[
								146.25230290700006,
								-38.298624651999944
							],
							[
								146.2582393,
								-38.264787241999954
							],
							[
								146.30303512700004,
								-38.21619997499994
							],
							[
								146.29592760000003,
								-38.20346394499995
							],
							[
								146.30408953800008,
								-38.20585588499995
							],
							[
								146.31273179800007,
								-38.19800576599994
							],
							[
								146.3110486700001,
								-38.18530593599996
							],
							[
								146.323290508,
								-38.184683065999934
							],
							[
								146.3164826410001,
								-38.169207255999936
							],
							[
								146.33723077700006,
								-38.167065976999936
							],
							[
								146.33698669800003,
								-38.16090097699998
							],
							[
								146.3255776000001,
								-38.164419976999966
							],
							[
								146.30672583400008,
								-38.156603924999956
							],
							[
								146.3227366640001,
								-38.13094694599994
							],
							[
								146.32175762600002,
								-38.11929451599997
							],
							[
								146.31298664700012,
								-38.11687192499994
							],
							[
								146.3280525660001,
								-38.10905890599997
							],
							[
								146.31850577800003,
								-38.10494212599997
							],
							[
								146.32690245900005,
								-38.08584346599997
							],
							[
								146.34179883700006,
								-38.08176711699997
							],
							[
								146.35913366300008,
								-38.087279938999984
							],
							[
								146.37656572900005,
								-38.09349837999997
							],
							[
								146.37438766900004,
								-38.10005993999994
							],
							[
								146.41436965100002,
								-38.105502942999976
							],
							[
								146.41743564900003,
								-38.11551294299994
							],
							[
								146.4244147400001,
								-38.09652811299998
							],
							[
								146.4789828900001,
								-38.10378684799997
							],
							[
								146.47572347400012,
								-38.07529503699993
							],
							[
								146.52791664400002,
								-38.08423995099997
							],
							[
								146.5347922960001,
								-38.056944870999985
							],
							[
								146.56951390000006,
								-38.058086343999946
							],
							[
								146.5669858440001,
								-38.030679593999935
							],
							[
								146.575266262,
								-38.03004996399994
							],
							[
								146.5872646260001,
								-37.97808795499998
							],
							[
								146.56380662000004,
								-37.98395795299996
							],
							[
								146.5544556530001,
								-37.97147494199993
							],
							[
								146.54493266400004,
								-37.97530194199993
							],
							[
								146.54699064500005,
								-37.967504951999956
							],
							[
								146.52405864900004,
								-37.96365794999997
							],
							[
								146.51468664800007,
								-37.98358194899998
							],
							[
								146.49724965100006,
								-37.98889794799993
							],
							[
								146.49104166200004,
								-37.98376894799998
							],
							[
								146.47331864400007,
								-37.99467895599997
							],
							[
								146.50234066500002,
								-37.690812956999935
							],
							[
								146.5160016640001,
								-37.67802494799997
							],
							[
								146.49073670300004,
								-37.644092945999944
							],
							[
								146.4730057060001,
								-37.63983594399997
							],
							[
								146.45229371300002,
								-37.614899941999965
							],
							[
								146.43584170500003,
								-37.618030930999964
							],
							[
								146.39405472400006,
								-37.603986937999935
							],
							[
								146.38344472500012,
								-37.609652926999956
							],
							[
								146.3765657140001,
								-37.628152926999974
							],
							[
								146.3679117150001,
								-37.62941394599994
							],
							[
								146.34665773000006,
								-37.62357393499997
							],
							[
								146.32194471700006,
								-37.59992993299994
							],
							[
								146.29879773200003,
								-37.591061940999964
							],
							[
								146.25082075800003,
								-37.610425927999984
							],
							[
								146.20771272600007,
								-37.60070193399997
							],
							[
								146.1919287500001,
								-37.58751692299995
							],
							[
								146.18640776200004,
								-37.580052912999975
							],
							[
								146.17325575300003,
								-37.58868892199996
							],
							[
								146.17198774200006,
								-37.599471921999964
							],
							[
								146.16130474500005,
								-37.59624792099993
							],
							[
								146.16483075100007,
								-37.62298292099996
							],
							[
								146.15854877100003,
								-37.630279910999946
							],
							[
								146.14416576400004,
								-37.627415929999984
							],
							[
								146.13095276400009,
								-37.64389590899998
							],
							[
								146.13232476000007,
								-37.67688791899997
							],
							[
								146.14267374700012,
								-37.69141591999994
							],
							[
								146.13555376700003,
								-37.70206492999995
							],
							[
								146.15308872200012,
								-37.71806493099996
							],
							[
								146.16322973700005,
								-37.747335921999934
							],
							[
								146.15688172600005,
								-37.76504792199995
							],
							[
								146.1422757370001,
								-37.771868920999964
							],
							[
								146.1337667470001,
								-37.78801292999998
							],
							[
								146.1213297390001,
								-37.78817892899997
							],
							[
								146.08910075900008,
								-37.75377791699998
							],
							[
								146.0677737410001,
								-37.768966914999965
							],
							[
								146.03863875500008,
								-37.774441912999976
							],
							[
								145.94361978300003,
								-37.75821890599997
							],
							[
								145.936776763,
								-37.77156591599993
							],
							[
								145.91747278600008,
								-37.77750990399994
							],
							[
								145.9290117810001,
								-37.79836090499998
							],
							[
								145.92638575800004,
								-37.829632894999975
							],
							[
								145.90547275300003,
								-37.81636989399993
							],
							[
								145.8927497740001,
								-37.82543589299996
							],
							[
								145.84471180600008,
								-37.797612888999936
							],
							[
								145.8292477770001,
								-37.812096887999985
							],
							[
								145.80961779100005,
								-37.80753589699998
							],
							[
								145.7949557720001,
								-37.815095905999954
							],
							[
								145.79376580100006,
								-37.82628089599996
							],
							[
								145.80385779000005,
								-37.82604488599998
							],
							[
								145.81121480700006,
								-37.836120896999944
							],
							[
								145.80455479700004,
								-37.85158689699995
							],
							[
								145.81762077400003,
								-37.857737887999974
							],
							[
								145.8107077840001,
								-37.864450886999975
							],
							[
								145.80325579600003,
								-37.86067389699997
							],
							[
								145.80421578400012,
								-37.87351688699994
							],
							[
								145.76950376900004,
								-37.88088989399995
							],
							[
								145.76502277800012,
								-37.89856688399993
							],
							[
								145.74125777900008,
								-37.92710389299998
							],
							[
								145.74697980700012,
								-37.93826389299994
							],
							[
								145.73106080700006,
								-37.95976089199996
							],
							[
								145.76254163800002,
								-37.99070976399997
							],
							[
								145.75444830900005,
								-38.07918531399997
							],
							[
								145.73921667900004,
								-38.10051695299995
							],
							[
								145.76279227400005,
								-38.108932584999934
							],
							[
								145.74848340300002,
								-38.142812893999974
							],
							[
								145.72973094500003,
								-38.153966742999955
							],
							[
								145.7008081240001,
								-38.205912730999955
							],
							[
								145.71741788100007,
								-38.20671328299994
							],
							[
								145.7128367670001,
								-38.25178788299996
							],
							[
								145.73636272300007,
								-38.24896275399993
							],
							[
								145.73268585900007,
								-38.289361593999956
							],
							[
								145.68964553600006,
								-38.29010601099998
							],
							[
								145.69093891700004,
								-38.283075620999966
							],
							[
								145.68149760900008,
								-38.282218959999966
							],
							[
								145.68028095800003,
								-38.28958393999994
							],
							[
								145.6385580660001,
								-38.28249154699995
							],
							[
								145.6124537510001,
								-38.28555994599998
							],
							[
								145.605689266,
								-38.332443524999974
							],
							[
								145.59362320900004,
								-38.33008559499996
							],
							[
								145.5821294430001,
								-38.31266549399993
							],
							[
								145.5536725500001,
								-38.29355776099993
							],
							[
								145.54578709200007,
								-38.29132352099998
							],
							[
								145.54181125000002,
								-38.30937158099994
							],
							[
								145.5206747640001,
								-38.30665903899995
							],
							[
								145.5153379520001,
								-38.33778691899994
							],
							[
								145.53992595700004,
								-38.33662791099994
							],
							[
								145.5519916840001,
								-38.34946388199995
							],
							[
								145.542200771,
								-38.38675288099995
							],
							[
								145.51436485300007,
								-38.415731868999956
							],
							[
								145.48988160700003,
								-38.415082877999964
							],
							[
								145.48128086000008,
								-38.40711283699994
							],
							[
								145.45356196400007,
								-38.41264684499998
							],
							[
								145.416386901,
								-38.40698188199997
							],
							[
								145.43381885500003,
								-38.434854893999955
							],
							[
								145.41772396400006,
								-38.47135987299998
							],
							[
								145.4325337900001,
								-38.480354863999935
							],
							[
								145.43448591800006,
								-38.49360985399994
							],
							[
								145.4191758190001,
								-38.51317684299994
							],
							[
								145.363412368,
								-38.52096422899996
							],
							[
								145.37201763500002,
								-38.536283899999944
							],
							[
								145.4236938150001,
								-38.53646586399998
							],
							[
								145.48369177200004,
								-38.55598788799995
							],
							[
								145.53751965700008,
								-38.611076871999956
							],
							[
								145.5606305780001,
								-38.651393903999974
							],
							[
								145.60670155600008,
								-38.67876883799994
							],
							[
								145.6385716310001,
								-38.67242285999998
							],
							[
								145.6568798180001,
								-38.67690991099994
							],
							[
								145.67202680600008,
								-38.671581911999965
							],
							[
								145.68894356500005,
								-38.65119591299998
							],
							[
								145.71386572100005,
								-38.64552590499994
							],
							[
								145.72950169800004,
								-38.645096885999976
							],
							[
								145.76555284900007,
								-38.66673870899996
							],
							[
								145.81825449500002,
								-38.71295950299998
							],
							[
								145.86953219800012,
								-38.77613511699997
							],
							[
								145.91492740900003,
								-38.87211991099997
							],
							[
								145.91064369700007,
								-38.89274499099997
							],
							[
								145.92120255300006,
								-38.909596911999984
							],
							[
								145.94001246100004,
								-38.89609998299994
							],
							[
								145.97937383400006,
								-38.89506385599998
							],
							[
								146.00629174100004,
								-38.87790691699996
							],
							[
								145.99790693700004,
								-38.846393356999954
							],
							[
								146.0094636770001,
								-38.82568996699996
							],
							[
								146.03361327400012,
								-38.81317567899998
							],
							[
								146.0839717350001,
								-38.815919442999984
							],
							[
								146.1335395630001,
								-38.83739544699995
							],
							[
								146.18941377900012,
								-38.873531560999936
							],
							[
								146.2339088760001,
								-38.91865574399998
							],
							[
								146.26950235300012,
								-38.97294695699998
							],
							[
								146.2673005910001,
								-38.99117811699995
							],
							[
								146.2489719040001,
								-38.996007255999984
							],
							[
								146.27433464900002,
								-38.99637613799996
							],
							[
								146.29185380400008,
								-39.01310512899994
							],
							[
								146.28392020400008,
								-39.02487415899998
							],
							[
								146.30303302100003,
								-39.02345700999996
							],
							[
								146.30471629800002,
								-39.039350139999954
							],
							[
								146.328589845,
								-39.027798701999984
							],
							[
								146.31403550800007,
								-39.031801910999945
							],
							[
								146.32636714400007,
								-39.04110497199997
							],
							[
								146.3169474350001,
								-39.052242270999955
							],
							[
								146.32933126300009,
								-39.04969314199997
							],
							[
								146.3368003700001,
								-39.059922282999935
							],
							[
								146.3523442170001,
								-39.05884412399996
							],
							[
								146.34298733900005,
								-39.06097425299998
							],
							[
								146.34067056700007,
								-39.07693968299998
							],
							[
								146.32143580100012,
								-39.07796779199998
							],
							[
								146.3214499290001,
								-39.08787405199996
							],
							[
								146.34582338000007,
								-39.12537118399996
							],
							[
								146.3738162840001,
								-39.136727005999944
							],
							[
								146.3878308930001,
								-39.125077716999954
							],
							[
								146.3895500010001,
								-39.13394572699997
							],
							[
								146.41602056800002,
								-39.125508268999965
							],
							[
								146.42651551500012,
								-39.129973149999955
							],
							[
								146.42408429800003,
								-39.11478607999993
							],
							[
								146.4317581260001,
								-39.114808979999964
							],
							[
								146.4268650780001,
								-39.108264979999944
							],
							[
								146.43485690600005,
								-39.107713899999965
							],
							[
								146.44160845700003,
								-39.08974074099996
							],
							[
								146.4252965710001,
								-39.083535799999936
							],
							[
								146.4311252220001,
								-39.065514349999944
							],
							[
								146.45529482900008,
								-39.05410338199994
							],
							[
								146.47977566300005,
								-39.06682074299994
							],
							[
								146.4833555030001,
								-39.061014573999955
							],
							[
								146.47446556600005,
								-39.05492739299996
							],
							[
								146.47773323700005,
								-39.04375200299995
							],
							[
								146.4604443510001,
								-39.03690195199994
							],
							[
								146.47076216900007,
								-39.03570480299993
							],
							[
								146.46400511100012,
								-39.02891870199994
							],
							[
								146.47539788900008,
								-39.02565345299996
							],
							[
								146.437199447,
								-39.02100108999997
							],
							[
								146.43176043900007,
								-39.01096401999996
							],
							[
								146.445696977,
								-39.00369452099994
							],
							[
								146.43611587200007,
								-38.98100846999995
							],
							[
								146.45098700300002,
								-38.94783786099998
							],
							[
								146.47409420300005,
								-38.91623218199993
							],
							[
								146.48930083100004,
								-38.91045088299995
							],
							[
								146.4844775050001,
								-38.88316575299996
							],
							[
								146.46785573900002,
								-38.87103591099998
							],
							[
								146.478641637,
								-38.791767421999964
							],
							[
								146.46706173100006,
								-38.78090256099995
							],
							[
								146.43796509600008,
								-38.77890897899994
							],
							[
								146.4356504540001,
								-38.79589913899997
							],
							[
								146.42073582600005,
								-38.80379439699993
							],
							[
								146.41486650100012,
								-38.85206540699994
							],
							[
								146.39325263500007,
								-38.85047453599998
							],
							[
								146.36871594900003,
								-38.860037413999976
							],
							[
								146.33634056200003,
								-38.88023204199993
							],
							[
								146.3237149910001,
								-38.90330045099995
							],
							[
								146.298549266,
								-38.906232848999935
							],
							[
								146.28721003900012,
								-38.89451191799998
							],
							[
								146.29273373,
								-38.87645263799993
							],
							[
								146.27027645600003,
								-38.86012671699996
							],
							[
								146.26394203200005,
								-38.82343008599997
							],
							[
								146.27281978200006,
								-38.806034816999954
							],
							[
								146.232624159,
								-38.808691203999956
							],
							[
								146.21850290600003,
								-38.77181306199998
							],
							[
								146.18556589500008,
								-38.74335718999998
							],
							[
								146.1886296660001,
								-38.73118607999993
							],
							[
								146.21070446200008,
								-38.73793286199998
							],
							[
								146.20466853300002,
								-38.73539091099997
							],
							[
								146.21067333300005,
								-38.72847278199998
							],
							[
								146.20064152400005,
								-38.733002950999946
							],
							[
								146.19205358600004,
								-38.72623199999998
							],
							[
								146.19953243600003,
								-38.71608279099996
							],
							[
								146.21318621300009,
								-38.719694681999954
							],
							[
								146.2027233760001,
								-38.71333673099997
							],
							[
								146.2290038530001,
								-38.70165934299996
							],
							[
								146.21206496700006,
								-38.69284143099998
							],
							[
								146.23116173300002,
								-38.695166272999984
							],
							[
								146.2276107240001,
								-38.68913127299993
							],
							[
								146.24394633200006,
								-38.68281911399998
							],
							[
								146.24447156100007,
								-38.69589415399997
							],
							[
								146.25394345900008,
								-38.69728009499994
							],
							[
								146.26065616900007,
								-38.68730800499998
							],
							[
								146.2919499520001,
								-38.69524878699997
							],
							[
								146.31973859800007,
								-38.68779958899995
							],
							[
								146.339077534,
								-38.69057147099994
							],
							[
								146.33182641700012,
								-38.681055439999966
							],
							[
								146.35113812400004,
								-38.672972121999976
							],
							[
								146.38099204700006,
								-38.685632013999964
							],
							[
								146.38395749300003,
								-38.719345283999985
							],
							[
								146.4068313780001,
								-38.72236403599993
							],
							[
								146.4103362190001,
								-38.71189790599993
							],
							[
								146.4391057350001,
								-38.69969842799998
							],
							[
								146.4371056760001,
								-38.69444840799997
							],
							[
								146.46306728100012,
								-38.70206711999998
							],
							[
								146.492973666,
								-38.69674669199998
							],
							[
								146.49467456800005,
								-38.679725521999956
							],
							[
								146.4967375870001,
								-38.68726856199993
							],
							[
								146.5046074160001,
								-38.681961412999954
							],
							[
								146.50358848500002,
								-38.69178151299997
							],
							[
								146.52130620100002,
								-38.69444027399993
							],
							[
								146.52145570200003,
								-38.68897554399996
							]
						]
					],
					[
						[
							[
								145.27909567000006,
								-38.457085132999964
							],
							[
								145.30250165600012,
								-38.45375685499994
							],
							[
								145.23997734800002,
								-38.445786949999956
							],
							[
								145.20006256500005,
								-38.451012127999945
							],
							[
								145.1654364090001,
								-38.465344614999935
							],
							[
								145.14713395800004,
								-38.503184843999975
							],
							[
								145.12738976200012,
								-38.50552781299996
							],
							[
								145.11618367200003,
								-38.51844488199998
							],
							[
								145.17066568300004,
								-38.50956188599997
							],
							[
								145.203577977,
								-38.517295857999954
							],
							[
								145.2212089720001,
								-38.529939869999964
							],
							[
								145.24004994100005,
								-38.50681483099993
							],
							[
								145.27113881600008,
								-38.50485283299997
							],
							[
								145.31636091600012,
								-38.52417186599996
							],
							[
								145.34401469800002,
								-38.54936683799997
							],
							[
								145.34485492600004,
								-38.56233690799996
							],
							[
								145.3607118330001,
								-38.566268829999956
							],
							[
								145.3635047040001,
								-38.55130587999997
							],
							[
								145.34094260000006,
								-38.53497462799993
							],
							[
								145.34623528100008,
								-38.52183949799996
							],
							[
								145.36284661900004,
								-38.51196983899996
							],
							[
								145.33281810500011,
								-38.50477657699997
							],
							[
								145.29793959100004,
								-38.507077014999936
							],
							[
								145.305579082,
								-38.48542481499993
							],
							[
								145.29315119400007,
								-38.48852997399996
							],
							[
								145.29074701500008,
								-38.48047697399994
							],
							[
								145.3104175940001,
								-38.46061115499998
							],
							[
								145.280828949,
								-38.46129282299995
							],
							[
								145.28483755900004,
								-38.455859043999965
							],
							[
								145.27326972100002,
								-38.46034222299994
							],
							[
								145.27909567000006,
								-38.457085132999964
							]
						]
					],
					[
						[
							[
								145.33784981500003,
								-38.493806467999946
							],
							[
								145.3329639960001,
								-38.49947956699998
							],
							[
								145.34605698200005,
								-38.508702427999935
							],
							[
								145.33784981500003,
								-38.493806467999946
							]
						]
					],
					[
						[
							[
								146.2314168160001,
								-39.088437934999945
							],
							[
								146.23668690400007,
								-39.09784008599996
							],
							[
								146.24144771400006,
								-39.08883496599998
							],
							[
								146.223207569,
								-39.07086780499998
							],
							[
								146.2314168160001,
								-39.088437934999945
							]
						]
					],
					[
						[
							[
								146.23916946300005,
								-39.019093484999985
							],
							[
								146.2414396910001,
								-39.029634545999954
							],
							[
								146.24624356100003,
								-39.02434346599995
							],
							[
								146.23916946300005,
								-39.019093484999985
							]
						]
					],
					[
						[
							[
								146.32170688200006,
								-39.14455444199996
							],
							[
								146.32914072200003,
								-39.13926638299995
							],
							[
								146.31207781500007,
								-39.13475234099997
							],
							[
								146.32170688200006,
								-39.14455444199996
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "235",
				"CED_NAME21": "Monash",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 8246.9042,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/235",
				"SHAPE_Leng": 10.6440021032,
				"SHAPE_Area": 0.849324525932
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							145.19538821300011,
							-37.294106849999935
						],
						[
							145.19555552500003,
							-37.278282769999976
						],
						[
							145.18692488600004,
							-37.278232558999946
						],
						[
							145.18064684900003,
							-37.26440269899996
						],
						[
							145.17183119000003,
							-37.26628972799995
						],
						[
							145.16810497900008,
							-37.28136584799995
						],
						[
							145.16273999100008,
							-37.27704185799996
						],
						[
							145.17313545100012,
							-37.261147767999944
						],
						[
							145.16777973400008,
							-37.240233107999984
						],
						[
							145.1772099430001,
							-37.23592327899996
						],
						[
							145.1638125170001,
							-37.21575786699998
						],
						[
							145.17202880600007,
							-37.21679053799994
						],
						[
							145.1748843460001,
							-37.204897667999944
						],
						[
							145.19638686300004,
							-37.20608312999997
						],
						[
							145.20202461400004,
							-37.18715690999994
						],
						[
							145.21944336,
							-37.19107073099997
						],
						[
							145.2411379780001,
							-37.176966412999946
						],
						[
							145.24109190900003,
							-37.168610342999955
						],
						[
							145.2317270310001,
							-37.167520441999955
						],
						[
							145.22856770500005,
							-37.13461824099994
						],
						[
							145.24320796100005,
							-37.14391484299995
						],
						[
							145.25720195000008,
							-37.13497085299997
						],
						[
							145.27890795500002,
							-37.14304584499996
						],
						[
							145.28830243900006,
							-37.099585384999955
						],
						[
							145.32104296300008,
							-37.103785107999954
						],
						[
							145.3662121860001,
							-37.097620640999935
						],
						[
							145.37474887700012,
							-37.07616239099997
						],
						[
							145.3927365830001,
							-37.07627323299994
						],
						[
							145.3927969570001,
							-37.04373685199994
						],
						[
							145.4294999330001,
							-37.02167187499998
						],
						[
							145.4259573160001,
							-36.999185043999944
						],
						[
							145.41112510900007,
							-36.995189412999935
						],
						[
							145.46783596000012,
							-36.90168086699998
						],
						[
							145.4550025630001,
							-36.89124836599996
						],
						[
							145.4612439540001,
							-36.87551485599994
						],
						[
							145.4818309410001,
							-36.870343866999974
						],
						[
							145.48450996200006,
							-36.85696886799997
						],
						[
							145.484321044,
							-36.84027409699996
						],
						[
							145.46983598600002,
							-36.840065865999975
						],
						[
							145.4626395790001,
							-36.82869474599994
						],
						[
							145.47485295,
							-36.79930486699993
						],
						[
							145.4863109590001,
							-36.79221387699994
						],
						[
							145.46141894400012,
							-36.786424875999955
						],
						[
							145.4551259850001,
							-36.778211874999954
						],
						[
							145.4532499610001,
							-36.73036186499996
						],
						[
							145.49603795400003,
							-36.73020964799997
						],
						[
							145.49817765800003,
							-36.68703571699996
						],
						[
							145.5134789660001,
							-36.687030868999955
						],
						[
							145.51594509400002,
							-36.70163515899998
						],
						[
							145.572186944,
							-36.70155187299997
						],
						[
							145.58477671100002,
							-36.70891002399998
						],
						[
							145.5970304110001,
							-36.69520132399998
						],
						[
							145.58938184400006,
							-36.68192631399995
						],
						[
							145.6346609620001,
							-36.631720686999984
						],
						[
							145.63471159300002,
							-36.62227891699996
						],
						[
							145.64455297100005,
							-36.62307787699996
						],
						[
							145.64451093500008,
							-36.59077187699995
						],
						[
							145.62627195800007,
							-36.590042865999976
						],
						[
							145.61473376200001,
							-36.56327976499995
						],
						[
							145.63172864000012,
							-36.56328535599994
						],
						[
							145.63156628700006,
							-36.49903319599997
						],
						[
							145.73187597000003,
							-36.499023302999944
						],
						[
							145.7244333100001,
							-36.42459500199993
						],
						[
							145.77543988900004,
							-36.443740625999965
						],
						[
							145.7984539910001,
							-36.29895662599995
						],
						[
							146.03094373300007,
							-36.29899553299998
						],
						[
							146.03690896700004,
							-36.25505015299996
						],
						[
							146.1314305620001,
							-36.25510855999994
						],
						[
							146.13105786900007,
							-36.186777649999954
						],
						[
							146.23406066300004,
							-36.18298367699998
						],
						[
							146.2366817720001,
							-36.190544676999934
						],
						[
							146.245391583,
							-36.16768648799996
						],
						[
							146.22885263600006,
							-36.16710173699994
						],
						[
							146.23625161500001,
							-36.16487762699995
						],
						[
							146.243590637,
							-36.13855351799998
						],
						[
							146.23669458900008,
							-36.12868361699998
						],
						[
							146.20463365400008,
							-36.125947174999965
						],
						[
							146.2059845860001,
							-36.112737154999934
						],
						[
							146.21584951400007,
							-36.11450495499997
						],
						[
							146.2164014650001,
							-36.10654494499994
						],
						[
							146.20484159700004,
							-36.10525717499996
						],
						[
							146.21645344600006,
							-36.09731993499997
						],
						[
							146.21005244700007,
							-36.09187307499997
						],
						[
							146.2152403670001,
							-36.08902897499996
						],
						[
							146.1966756700001,
							-36.085582373999955
						],
						[
							146.19920472400008,
							-36.046969193999985
						],
						[
							146.17923403700001,
							-36.05135261199996
						],
						[
							146.1772805490001,
							-36.03402765199996
						],
						[
							146.1731100610001,
							-36.01928024199998
						],
						[
							146.1546860940001,
							-36.02514615999996
						],
						[
							146.14586910600008,
							-36.01376276999997
						],
						[
							146.13153604800004,
							-36.01952677899993
						],
						[
							146.13169617900007,
							-36.010527568999976
						],
						[
							146.14065530800008,
							-36.00894073899997
						],
						[
							146.1347668090001,
							-36.00253365899994
						],
						[
							146.11872396,
							-36.018001347999984
						],
						[
							146.10768412200002,
							-36.01435544699996
						],
						[
							146.1123839920001,
							-36.00679817699995
						],
						[
							146.10077721400012,
							-36.01304151599993
						],
						[
							146.09147634500005,
							-36.00946357599997
						],
						[
							146.09220540400008,
							-36.02125287599995
						],
						[
							146.07564482700002,
							-36.01816384499995
						],
						[
							146.07355583800006,
							-36.00962364399993
						],
						[
							146.07138590800002,
							-36.01564279399997
						],
						[
							146.05930122000007,
							-36.014534812999955
						],
						[
							146.05235219300005,
							-35.99545238299993
						],
						[
							146.04842732300006,
							-36.00314455199998
						],
						[
							146.0314935670001,
							-35.99470041099994
						],
						[
							146.01614896800004,
							-36.00694878999997
						],
						[
							146.00587211000004,
							-36.00355564899996
						],
						[
							145.97182160400007,
							-36.015659676999974
						],
						[
							145.97131953500002,
							-36.00563889699998
						],
						[
							145.9583423670001,
							-36.00696006599998
						],
						[
							145.96482366700002,
							-35.996757085999946
						],
						[
							145.94574980200002,
							-35.98379610499995
						],
						[
							145.95107715200004,
							-35.97661343499993
						],
						[
							145.9441766440001,
							-35.96686123499995
						],
						[
							145.95372165300012,
							-35.96154240499993
						],
						[
							145.9280059560001,
							-35.973933803999955
						],
						[
							145.9258271970001,
							-35.96455033299998
						],
						[
							145.9138213880001,
							-35.96954878199995
						],
						[
							145.90609000000006,
							-35.96324923199995
						],
						[
							145.90293931000008,
							-35.96884264199997
						],
						[
							145.90076163100002,
							-35.96151573099996
						],
						[
							145.910320801,
							-35.95594836199996
						],
						[
							145.90269934200012,
							-35.95248265199996
						],
						[
							145.8540477690001,
							-35.95991381799996
						],
						[
							145.84791395900004,
							-35.96842863799998
						],
						[
							145.85800298700008,
							-35.97527159799995
						],
						[
							145.84555442900012,
							-35.97344700799994
						],
						[
							145.84859529800008,
							-35.980886477999945
						],
						[
							145.8400265690001,
							-35.98323040699995
						],
						[
							145.82755373200007,
							-35.97542484599995
						],
						[
							145.82825804100003,
							-35.98296925599993
						],
						[
							145.81135862300005,
							-35.98408908499994
						],
						[
							145.81667876200004,
							-35.98839625599993
						],
						[
							145.81004106300009,
							-35.99135417499997
						],
						[
							145.807985894,
							-35.98374898499998
						],
						[
							145.79345057600005,
							-35.98280422399995
						],
						[
							145.79273800800001,
							-35.972788073999936
						],
						[
							145.7768891400001,
							-35.972428312999966
						],
						[
							145.7782172410001,
							-35.96023045299995
						],
						[
							145.76611123300006,
							-35.96667476199997
						],
						[
							145.75790305500004,
							-35.958075390999966
						],
						[
							145.74611519600012,
							-35.964225289999945
						],
						[
							145.73071474900007,
							-35.95847683899996
						],
						[
							145.7341453990001,
							-35.95128876899997
						],
						[
							145.7167713220001,
							-35.95058146799994
						],
						[
							145.72630660200002,
							-35.94229868899998
						],
						[
							145.7202804530001,
							-35.93443634799996
						],
						[
							145.69733335700005,
							-35.93648862699996
						],
						[
							145.69818665800005,
							-35.92096440699993
						],
						[
							145.68585741900006,
							-35.93060282599998
						],
						[
							145.67387059200007,
							-35.925879864999956
						],
						[
							145.6790590820001,
							-35.91681595499995
						],
						[
							145.66912693300003,
							-35.919573224999965
						],
						[
							145.65745441700005,
							-35.900673293999944
						],
						[
							145.6397361710001,
							-35.89422625199995
						],
						[
							145.6295761140001,
							-35.880091851999964
						],
						[
							145.62032720500008,
							-35.883871640999985
						],
						[
							145.62813951500004,
							-35.87539641099994
						],
						[
							145.61486342700005,
							-35.87255751999993
						],
						[
							145.6283265950001,
							-35.86776233099994
						],
						[
							145.62635313600003,
							-35.862745160999964
						],
						[
							145.60175416000004,
							-35.86784378899995
						],
						[
							145.60114103900003,
							-35.87499496899994
						],
						[
							145.59803470100007,
							-35.86144449899996
						],
						[
							145.5867973930001,
							-35.86123167799997
						],
						[
							145.59323663300006,
							-35.84906417899998
						],
						[
							145.56401712900004,
							-35.83417662699998
						],
						[
							145.56684585000005,
							-35.82648412699996
						],
						[
							145.55800270100008,
							-35.82821739599996
						],
						[
							145.5628413720001,
							-35.81343590599994
						],
						[
							145.546747234,
							-35.81288145499997
						],
						[
							145.53876964500012,
							-35.82180003499997
						],
						[
							145.53570214700005,
							-35.80199174399996
						],
						[
							145.5216598080001,
							-35.81864226399995
						],
						[
							145.50256182200008,
							-35.80943549199998
						],
						[
							145.49198266300004,
							-35.81506325099997
						],
						[
							145.472134277,
							-35.809217399999966
						],
						[
							145.46253216600007,
							-35.82685621899998
						],
						[
							145.45066425900006,
							-35.82140495899995
						],
						[
							145.44179938900004,
							-35.83564556799996
						],
						[
							145.41987989300003,
							-35.82816069599994
						],
						[
							145.4136345940001,
							-35.83133467599998
						],
						[
							145.42048261200011,
							-35.83727063699996
						],
						[
							145.4097269240001,
							-35.83654861599996
						],
						[
							145.4106312020001,
							-35.84859980599998
						],
						[
							145.38715630600007,
							-35.85012879399994
						],
						[
							145.355183419,
							-35.86707108199994
						],
						[
							145.32445919600002,
							-35.850673109999946
						],
						[
							145.29654776000007,
							-35.86055333799993
						],
						[
							145.27270456500003,
							-35.84518966599995
						],
						[
							145.26708036500008,
							-35.852432885999974
						],
						[
							145.25835871700008,
							-35.85062970499996
						],
						[
							145.26072233800005,
							-35.835412634999955
						],
						[
							145.24635953100005,
							-35.830330523999976
						],
						[
							145.22503518400003,
							-35.83217098299997
						],
						[
							145.22278963300005,
							-35.84243778299998
						],
						[
							145.18981283900007,
							-35.834254589999944
						],
						[
							145.18101932000002,
							-35.84201338999998
						],
						[
							145.1536446440001,
							-35.84306671799993
						],
						[
							145.15881066500003,
							-35.83076627799994
						],
						[
							145.13958500800004,
							-35.82852553699996
						],
						[
							145.1366421680001,
							-35.834257546999936
						],
						[
							145.12798510100004,
							-35.82080642599993
						],
						[
							145.1256400200001,
							-35.829784125999936
						],
						[
							145.12232741200012,
							-35.82079087599993
						],
						[
							145.11534212200002,
							-35.826025254999934
						],
						[
							145.11423095300006,
							-35.82051791499998
						],
						[
							145.0924976350001,
							-35.83581179399994
						],
						[
							145.09175421600003,
							-35.82594182399998
						],
						[
							145.07648613800006,
							-35.83180907299993
						],
						[
							145.07412638900007,
							-35.82671922199995
						],
						[
							145.06809180900007,
							-35.83537440199996
						],
						[
							145.03891088300009,
							-35.838279099999966
						],
						[
							145.01933506500006,
							-35.85653120899997
						],
						[
							145.000584988,
							-35.849316786999964
						],
						[
							144.9682524420001,
							-35.865400844999954
						],
						[
							144.97496093900008,
							-35.88383179599998
						],
						[
							144.94891382800006,
							-35.93166867399998
						],
						[
							144.95742910400008,
							-35.96088481499993
						],
						[
							144.93101140700003,
							-35.96845650399996
						],
						[
							144.92362193600002,
							-35.98893804299996
						],
						[
							144.94576527100003,
							-36.004298794999954
						],
						[
							144.94550527,
							-36.012172634999956
						],
						[
							144.96183697700008,
							-36.01820249599996
						],
						[
							144.96781426400003,
							-36.04206497699994
						],
						[
							144.98593781900001,
							-36.056496547999984
						],
						[
							144.98164163800004,
							-36.07255940799996
						],
						[
							144.94829604300003,
							-36.08289071499996
						],
						[
							144.932620057,
							-36.06703601399994
						],
						[
							144.86326526900007,
							-36.05913972899998
						],
						[
							144.86149246800005,
							-36.071718568999984
						],
						[
							144.8563176890001,
							-36.06561376899998
						],
						[
							144.8564799090001,
							-36.07353988899996
						],
						[
							144.84718252000005,
							-36.07286837799995
						],
						[
							144.8506163090001,
							-36.08132200899996
						],
						[
							144.84196556000006,
							-36.08296019799997
						],
						[
							144.84192792800002,
							-36.10056352799995
						],
						[
							144.81990962100008,
							-36.10793456699997
						],
						[
							144.8101924330001,
							-36.102249865999966
						],
						[
							144.81636218100004,
							-36.109681386999966
						],
						[
							144.8064046930001,
							-36.10744457599998
						],
						[
							144.81336811100005,
							-36.113899585999945
						],
						[
							144.80849721100003,
							-36.12326585599993
						],
						[
							144.7965823940001,
							-36.11985628499997
						],
						[
							144.7985575240001,
							-36.11318651499994
						],
						[
							144.77798046600003,
							-36.129906183999935
						],
						[
							144.77156097800002,
							-36.116003983999974
						],
						[
							144.7533914400001,
							-36.12245182199996
						],
						[
							144.74066390400003,
							-36.10757411199995
						],
						[
							144.73369408400004,
							-36.11702400099995
						],
						[
							144.71840848700003,
							-36.11355193999998
						],
						[
							144.72603512800004,
							-36.09062191999993
						],
						[
							144.7190310200001,
							-36.08589168999998
						],
						[
							144.68424634400003,
							-36.09551827799993
						],
						[
							144.6887150870001,
							-36.06127215799995
						],
						[
							144.66786191000006,
							-36.068583915999966
						],
						[
							144.66474059900008,
							-36.07651803599998
						],
						[
							144.65802803100007,
							-36.07036610599994
						],
						[
							144.65497146100006,
							-36.075335905999964
						],
						[
							144.65319753400001,
							-36.05322719499998
						],
						[
							144.64392678500008,
							-36.056650814999955
						],
						[
							144.63275022800008,
							-36.048084123999956
						],
						[
							144.62500515800002,
							-36.05206823299994
						],
						[
							144.6262947670001,
							-36.06178753399996
						],
						[
							144.61830609900005,
							-36.05969472299995
						],
						[
							144.6282277570001,
							-36.06524656399995
						],
						[
							144.61675969700002,
							-36.07664633299993
						],
						[
							144.6084383100001,
							-36.06362754199995
						],
						[
							144.615478692,
							-36.03158060299995
						],
						[
							144.60665717200004,
							-36.04255458199998
						],
						[
							144.58328146700012,
							-36.039012140999944
						],
						[
							144.58645096700002,
							-36.027169200999936
						],
						[
							144.57933815900003,
							-36.021013979999964
						],
						[
							144.57113376000007,
							-36.02406596999998
						],
						[
							144.56339120300004,
							-36.00779291899994
						],
						[
							144.55766102300004,
							-36.01409397899994
						],
						[
							144.5536671850001,
							-36.00297110799994
						],
						[
							144.51579175200004,
							-35.994426465999936
						],
						[
							144.5216955730001,
							-35.97201865599993
						],
						[
							144.510816685,
							-35.97387099499997
						],
						[
							144.51516668500005,
							-35.965452665999976
						],
						[
							144.5004728570001,
							-35.97022723499998
						],
						[
							144.5013695980001,
							-35.958069644999966
						],
						[
							144.49365305800006,
							-35.96839152399997
						],
						[
							144.48864421000007,
							-35.95711011399993
						],
						[
							144.48123587100008,
							-35.958595222999975
						],
						[
							144.48758843100006,
							-35.94949862399994
						],
						[
							144.47976406200007,
							-35.95328246299994
						],
						[
							144.47942052300004,
							-35.94526227299997
						],
						[
							144.4669319850001,
							-35.94618908199993
						],
						[
							144.4722388140001,
							-35.94071264299998
						],
						[
							144.46385287600003,
							-35.94057175199998
						],
						[
							144.4662122860001,
							-35.93332975199996
						],
						[
							144.46047082600012,
							-35.93958088199997
						],
						[
							144.44102181000005,
							-35.93263296999993
						],
						[
							144.42343451600004,
							-35.905991868999934
						],
						[
							144.4157794570001,
							-35.90904504899993
						],
						[
							144.4247104860001,
							-35.90046703899998
						],
						[
							144.40972535800006,
							-35.90477754799997
						],
						[
							144.40854469900012,
							-35.89887767799996
						],
						[
							144.3819025150001,
							-35.88435676599994
						],
						[
							144.36172163800006,
							-35.88628322499994
						],
						[
							144.34356792000005,
							-35.894313273999956
						],
						[
							144.3424206190001,
							-35.907376333999935
						],
						[
							144.35514801600004,
							-35.91067366499993
						],
						[
							144.34604185600006,
							-35.928115213999945
						],
						[
							144.30620568200004,
							-35.934141791999934
						],
						[
							144.2837395370001,
							-35.92363852999995
						],
						[
							144.2629704190001,
							-35.93144998899993
						],
						[
							144.25931746800006,
							-35.94662127899994
						],
						[
							144.2914086190001,
							-35.984414270999935
						],
						[
							144.2769492210001,
							-35.99398063999996
						],
						[
							144.2799472580001,
							-36.01327041999997
						],
						[
							144.30668952200006,
							-36.03187504199997
						],
						[
							144.3178480790001,
							-36.04982634299995
						],
						[
							144.30393946000004,
							-36.061291181999934
						],
						[
							144.31867425300004,
							-36.101185302999966
						],
						[
							144.30905938500007,
							-36.105356892999964
						],
						[
							144.30226476400003,
							-36.12542014199994
						],
						[
							144.2892428450001,
							-36.12917449199995
						],
						[
							144.28317577400003,
							-36.15232358099996
						],
						[
							144.28909629200007,
							-36.16668603199997
						],
						[
							144.26679106000006,
							-36.22478329099994
						],
						[
							144.28164320300004,
							-36.262607411999966
						],
						[
							144.28173499700006,
							-36.327710071999945
						],
						[
							144.33183980900003,
							-36.327704955999934
						],
						[
							144.33004448300005,
							-36.38506005599993
						],
						[
							144.34409993100007,
							-36.385206506999964
						],
						[
							144.3583274880001,
							-36.385170047999964
						],
						[
							144.36940505400003,
							-36.407836188999966
						],
						[
							144.399760269,
							-36.40750985099993
						],
						[
							144.4157082480001,
							-36.39631106199994
						],
						[
							144.43021699400003,
							-36.41129103299994
						],
						[
							144.43010538400006,
							-36.406672672999946
						],
						[
							144.6681837750001,
							-36.406579448999935
						],
						[
							144.67426741200006,
							-36.42548709899995
						],
						[
							144.65872513300008,
							-36.44047011799995
						],
						[
							144.6719367810001,
							-36.44309126899998
						],
						[
							144.6715526490001,
							-36.45710462899996
						],
						[
							144.65326933200004,
							-36.46560271799996
						],
						[
							144.65474999100002,
							-36.472629017999964
						],
						[
							144.6206227450001,
							-36.48132255599995
						],
						[
							144.62621392300002,
							-36.49214153599996
						],
						[
							144.61132791500006,
							-36.499131044999956
						],
						[
							144.62354413200012,
							-36.50450547599996
						],
						[
							144.61026087300002,
							-36.516752494999935
						],
						[
							144.62603102000003,
							-36.52737186699994
						],
						[
							144.60843959200008,
							-36.528956594999954
						],
						[
							144.6171217000001,
							-36.537830765999956
						],
						[
							144.60629076100008,
							-36.546791164999945
						],
						[
							144.61054129900003,
							-36.55591725599993
						],
						[
							144.5872251730001,
							-36.557886193999934
						],
						[
							144.59841000900008,
							-36.57450873499994
						],
						[
							144.58343581100007,
							-36.58470230399996
						],
						[
							144.5897253490001,
							-36.59482182499994
						],
						[
							144.5618412120001,
							-36.61342644299998
						],
						[
							144.54574993100005,
							-36.64676559199995
						],
						[
							144.52544487300008,
							-36.65978840099996
						],
						[
							144.53477028800012,
							-36.68802168099995
						],
						[
							144.5224719800001,
							-36.69315421099998
						],
						[
							144.51803879700003,
							-36.72543776099997
						],
						[
							144.66711167200003,
							-36.72538941099998
						],
						[
							144.66616521900005,
							-36.76259867099998
						],
						[
							144.75032205500008,
							-36.757543545999965
						],
						[
							144.76693316400008,
							-36.74724420699994
						],
						[
							144.7946913390001,
							-36.75070975899996
						],
						[
							144.7947474660001,
							-36.770657908999965
						],
						[
							144.78481217800004,
							-36.77064458899997
						],
						[
							144.78477260700004,
							-36.780512888999965
						],
						[
							144.79170869600011,
							-36.780023478999965
						],
						[
							144.787319614,
							-36.805316638999955
						],
						[
							144.79855302900012,
							-36.83260812999998
						],
						[
							144.85356927500004,
							-36.880237223999984
						],
						[
							144.82239185800006,
							-36.89969585199998
						],
						[
							144.80427267900006,
							-36.92587514099995
						],
						[
							144.8063221850001,
							-36.95562967099994
						],
						[
							144.7912734580001,
							-36.95201698999995
						],
						[
							144.79657880600007,
							-36.96552627099993
						],
						[
							144.76599896000005,
							-36.97361860899997
						],
						[
							144.75345690300003,
							-36.962980707999975
						],
						[
							144.7430400610001,
							-36.99770581699994
						],
						[
							144.71464408600002,
							-36.99794281499993
						],
						[
							144.72598507200007,
							-37.018810815999984
						],
						[
							144.72843706700007,
							-37.06601781699993
						],
						[
							144.71535305400005,
							-37.11548681599993
						],
						[
							144.73522360900006,
							-37.12650088799995
						],
						[
							144.72654941700011,
							-37.15961324699998
						],
						[
							144.71025706000012,
							-37.15952780599997
						],
						[
							144.71610399400004,
							-37.208782466999935
						],
						[
							144.70381747500005,
							-37.21294511599996
						],
						[
							144.7688458240001,
							-37.22072909099995
						],
						[
							144.76957567400007,
							-37.21510901099998
						],
						[
							144.777746782,
							-37.21982081099998
						],
						[
							144.7857269210001,
							-37.21306666199996
						],
						[
							144.84543657200004,
							-37.20816516599996
						],
						[
							144.8522184510001,
							-37.20893561599996
						],
						[
							144.8501061600001,
							-37.22041629599994
						],
						[
							144.87426302500012,
							-37.22838481799994
						],
						[
							144.88687403300003,
							-37.22105881899995
						],
						[
							144.92543200600005,
							-37.22540884099993
						],
						[
							144.92106302800005,
							-37.215707830999975
						],
						[
							144.93164568600002,
							-37.21588423199995
						],
						[
							144.930823787,
							-37.20964767099997
						],
						[
							144.96266101100002,
							-37.21434182399997
						],
						[
							144.96364403300004,
							-37.20087784399993
						],
						[
							144.98989153800005,
							-37.20108426499996
						],
						[
							144.97670500700008,
							-37.234126834999984
						],
						[
							144.98775000400008,
							-37.242536825999935
						],
						[
							145.01425798100001,
							-37.22776383699994
						],
						[
							145.03863096400005,
							-37.252110838999954
						],
						[
							145.03101297400008,
							-37.265839838999966
						],
						[
							145.05064501100003,
							-37.26592883999996
						],
						[
							145.05522498800008,
							-37.28650683999996
						],
						[
							145.05613599000003,
							-37.26347383999996
						],
						[
							145.1176079700001,
							-37.26320485499997
						],
						[
							145.12506195800006,
							-37.269019844999946
						],
						[
							145.12527340500003,
							-37.29388388499996
						],
						[
							145.19538821300011,
							-37.294106849999935
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "236",
				"CED_NAME21": "Nicholls",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 14773.7825,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/236",
				"SHAPE_Leng": 10.9335621846,
				"SHAPE_Area": 1.4846186015
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							145.10354626700007,
							-37.68293009599995
						],
						[
							145.08346101100005,
							-37.67694268499997
						],
						[
							145.08947782100006,
							-37.66390443499995
						],
						[
							145.1078046890001,
							-37.65822121599996
						],
						[
							145.10192249200009,
							-37.638560955999935
						],
						[
							145.1225450290001,
							-37.626562786999955
						],
						[
							145.1061079540001,
							-37.61510184599996
						],
						[
							145.1052591450001,
							-37.60169985599998
						],
						[
							145.0819761990001,
							-37.59895104399993
						],
						[
							145.07954693800002,
							-37.61351584399995
						],
						[
							144.95263077200002,
							-37.60032903499996
						],
						[
							144.9464664720001,
							-37.60741247499993
						],
						[
							144.95280103900006,
							-37.623192175999975
						],
						[
							144.97628309200002,
							-37.65006986699996
						],
						[
							144.97206678800012,
							-37.69098585699993
						],
						[
							145.05822524300004,
							-37.69996939299995
						],
						[
							145.06824427200002,
							-37.68604986399998
						],
						[
							145.09964791700008,
							-37.68945484599993
						],
						[
							145.10354626700007,
							-37.68293009599995
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "237",
				"CED_NAME21": "Scullin",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 116.2899,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/237",
				"SHAPE_Leng": 0.721026008395,
				"SHAPE_Area": 0.0118723179607
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								143.66513507000002,
								-37.236641848999966
							],
							[
								143.63640588600003,
								-37.23082035699997
							],
							[
								143.6406455770001,
								-37.208298026999955
							],
							[
								143.58229033800012,
								-37.20172020299998
							],
							[
								143.58541802900004,
								-37.184539822999966
							],
							[
								143.52076125000008,
								-37.18109573899994
							],
							[
								143.52162925100004,
								-37.17596773899993
							],
							[
								143.4840732780001,
								-37.169710736999946
							],
							[
								143.46766225300007,
								-37.25143372599996
							],
							[
								143.47533725000005,
								-37.26089673699994
							],
							[
								143.46507725100003,
								-37.26920573599995
							],
							[
								143.4017338860001,
								-37.229929951999964
							],
							[
								143.35950094300006,
								-37.226528188999964
							],
							[
								143.35038828400002,
								-37.23294472899994
							],
							[
								143.35149328500006,
								-37.22373172899995
							],
							[
								143.33842128700007,
								-37.22266671799997
							],
							[
								143.3362782690001,
								-37.20630672799996
							],
							[
								143.29361823600004,
								-37.21060975499995
							],
							[
								143.28255794000006,
								-37.19531713499998
							],
							[
								143.27031526200005,
								-37.19750571399993
							],
							[
								143.2637112440001,
								-37.18164506299996
							],
							[
								143.2342607500001,
								-37.16871071099996
							],
							[
								143.22159846400007,
								-37.15254985099995
							],
							[
								143.2024349070001,
								-37.16111800899995
							],
							[
								143.18172969800003,
								-37.18860930799997
							],
							[
								143.15062773500006,
								-37.17073243599998
							],
							[
								143.12710457800006,
								-37.17319332499994
							],
							[
								143.11349158200005,
								-37.15755492399995
							],
							[
								143.08372137800006,
								-37.14864565199997
							],
							[
								143.06694460100005,
								-37.14735472099994
							],
							[
								143.0591000490001,
								-37.187187870999935
							],
							[
								143.0489163300001,
								-37.18973669999997
							],
							[
								142.99352825000005,
								-37.18305869699998
							],
							[
								142.9945351010001,
								-37.17733466699997
							],
							[
								142.9612883970001,
								-37.16702489499994
							],
							[
								142.9539803250001,
								-37.20776507499994
							],
							[
								142.8378909260001,
								-37.19162746799998
							],
							[
								142.8239074500001,
								-37.17165967699998
							],
							[
								142.78366182800005,
								-37.16887381399994
							],
							[
								142.7817686090001,
								-37.157662183999946
							],
							[
								142.768455022,
								-37.154402742999935
							],
							[
								142.76874552300012,
								-37.14283388299998
							],
							[
								142.75643134400002,
								-37.15086313299997
							],
							[
								142.71705256100006,
								-37.142878199999984
							],
							[
								142.7170888700001,
								-37.157286349999936
							],
							[
								142.5427798300001,
								-37.15740466999995
							],
							[
								142.59822546400005,
								-37.22439811399994
							],
							[
								142.59704093100004,
								-37.26218639399997
							],
							[
								142.58080244300004,
								-37.27265466299997
							],
							[
								142.5989384180001,
								-37.29289354399998
							],
							[
								142.5125150130001,
								-37.29385256899997
							],
							[
								142.4656306920001,
								-37.28158395599996
							],
							[
								142.45513468500008,
								-37.26542997599995
							],
							[
								142.42309605100002,
								-37.26008325399994
							],
							[
								142.40346675700005,
								-37.23737237199998
							],
							[
								142.35883328500006,
								-37.22549584999996
							],
							[
								142.32876430300007,
								-37.19919104799993
							],
							[
								142.24102347200005,
								-37.14991167299996
							],
							[
								142.233913496,
								-37.12432866199998
							],
							[
								142.2219364980001,
								-37.119893660999935
							],
							[
								142.20626150400005,
								-37.08728265999997
							],
							[
								142.1875444850001,
								-37.112775658999965
							],
							[
								142.16364020000003,
								-37.10582895799996
							],
							[
								142.1144941980001,
								-37.11204070499997
							],
							[
								142.1091115040001,
								-37.16271965499993
							],
							[
								142.0922615060001,
								-37.17087665399998
							],
							[
								142.08875140300006,
								-37.212618893999945
							],
							[
								142.07938448400012,
								-37.223633663999976
							],
							[
								142.0645654870001,
								-37.21852264299997
							],
							[
								141.9997710570001,
								-37.224316348999935
							],
							[
								141.98925249,
								-37.212405658999955
							],
							[
								141.9450466180001,
								-37.21069841599996
							],
							[
								141.93820200000005,
								-37.20005899599994
							],
							[
								141.91277851400002,
								-37.20234764399993
							],
							[
								141.9117105260001,
								-37.18982564399994
							],
							[
								141.93559352300008,
								-37.17078864499996
							],
							[
								141.9276025150001,
								-37.16912264499996
							],
							[
								141.93498153400003,
								-37.16620463499993
							],
							[
								141.9241785270001,
								-37.15231163499993
							],
							[
								141.92548051900008,
								-37.12513264499995
							],
							[
								141.9110575420001,
								-37.11345164399995
							],
							[
								141.90347854300012,
								-37.12355864299997
							],
							[
								141.908881521,
								-37.134834653999974
							],
							[
								141.8405445510001,
								-37.15249762999997
							],
							[
								141.83447756200007,
								-37.15809663999994
							],
							[
								141.8401865200001,
								-37.16814563999998
							],
							[
								141.821212553,
								-37.17398863899996
							],
							[
								141.81149855500007,
								-37.168079648999935
							],
							[
								141.8109005340001,
								-37.17731563899997
							],
							[
								141.80077152700005,
								-37.16666163799994
							],
							[
								141.7953915370001,
								-37.175382627999966
							],
							[
								141.7854785390001,
								-37.17411563699994
							],
							[
								141.7864705390001,
								-37.16877662699994
							],
							[
								141.77793954000003,
								-37.17669864699997
							],
							[
								141.77334828100004,
								-37.17256883599998
							],
							[
								141.77533454000002,
								-37.18027663699996
							],
							[
								141.74157854600003,
								-37.17469862499996
							],
							[
								141.7434505550001,
								-37.18114164499997
							],
							[
								141.72922153800005,
								-37.17859863399997
							],
							[
								141.7245755680001,
								-37.18800164399994
							],
							[
								141.70565455200006,
								-37.18442363299994
							],
							[
								141.69247057500002,
								-37.164979631999984
							],
							[
								141.67149756900005,
								-37.160950620999984
							],
							[
								141.67237058000012,
								-37.152256620999935
							],
							[
								141.64014057500003,
								-37.15915162899995
							],
							[
								141.6396665850001,
								-37.165423628999974
							],
							[
								141.63170658700005,
								-37.15526762899998
							],
							[
								141.6148395780001,
								-37.16943762799997
							],
							[
								141.59721183200008,
								-37.16121618699998
							],
							[
								141.5761845840001,
								-37.188108615999965
							],
							[
								141.49174060500002,
								-37.220149610999954
							],
							[
								141.4897685850001,
								-37.235240620999946
							],
							[
								141.49698759300009,
								-37.23828563199993
							],
							[
								141.48956060400008,
								-37.24667162099996
							],
							[
								141.52351658500004,
								-37.274973632999945
							],
							[
								141.5183525960001,
								-37.280647612999985
							],
							[
								141.53145058200005,
								-37.29762961399996
							],
							[
								141.4315126890001,
								-37.29752240899995
							],
							[
								141.43153706300006,
								-37.372288638999976
							],
							[
								141.2180702820001,
								-37.35086771799996
							],
							[
								141.2208876100001,
								-37.364560747999974
							],
							[
								141.24847912500002,
								-37.369229408999956
							],
							[
								141.28028583800005,
								-37.39408311099993
							],
							[
								141.26882629700003,
								-37.421783570999935
							],
							[
								141.25970928900006,
								-37.42100615999993
							],
							[
								141.26384608700005,
								-37.430076619999966
							],
							[
								141.1682441050001,
								-37.41986692499995
							],
							[
								141.09726471500005,
								-37.44986824199998
							],
							[
								141.0464143480001,
								-37.40184667899996
							],
							[
								140.9731800940001,
								-37.35822367499998
							],
							[
								140.9658026180001,
								-38.055984948999935
							],
							[
								141.02851900500002,
								-38.07157424199994
							],
							[
								141.15013507900005,
								-38.12682758899996
							],
							[
								141.22778243100004,
								-38.17063519299995
							],
							[
								141.29528613500008,
								-38.22062713699995
							],
							[
								141.35761613900002,
								-38.274745260999964
							],
							[
								141.392110569,
								-38.31971545299996
							],
							[
								141.39769991700007,
								-38.33854059299995
							],
							[
								141.3655379500001,
								-38.36530330099998
							],
							[
								141.36409725900012,
								-38.37699742099994
							],
							[
								141.37432531700006,
								-38.38674341199993
							],
							[
								141.41323817900002,
								-38.396274053999946
							],
							[
								141.40707457200006,
								-38.369063833999974
							],
							[
								141.43437722800002,
								-38.36029237499997
							],
							[
								141.46102605300007,
								-38.362083086999974
							],
							[
								141.51924128000007,
								-38.39001560999998
							],
							[
								141.52847245700002,
								-38.40484061999996
							],
							[
								141.52127764800002,
								-38.41469682999997
							],
							[
								141.54279373200006,
								-38.43295470099997
							],
							[
								141.55586749000008,
								-38.42625644199995
							],
							[
								141.55790010200008,
								-38.40567018199994
							],
							[
								141.57308465000006,
								-38.389691752999966
							],
							[
								141.6148523930001,
								-38.39300661499993
							],
							[
								141.62642350900012,
								-38.406330665999974
							],
							[
								141.62797494000006,
								-38.393445035999946
							],
							[
								141.65026366600011,
								-38.39303483699996
							],
							[
								141.6250653830001,
								-38.36197876499995
							],
							[
								141.6236000560001,
								-38.34168765499993
							],
							[
								141.60793746800005,
								-38.34225869399995
							],
							[
								141.6016274320001,
								-38.31317168399994
							],
							[
								141.67953079200004,
								-38.26785075799995
							],
							[
								141.74202093200006,
								-38.25309606099995
							],
							[
								141.88151679600003,
								-38.265797558999964
							],
							[
								141.92951154600007,
								-38.27820207199994
							],
							[
								142.00267658000007,
								-38.310321355999974
							],
							[
								142.0738196630001,
								-38.35588398999994
							],
							[
								142.13645931000008,
								-38.38069954399998
							],
							[
								142.1458063770001,
								-38.39147353499993
							],
							[
								142.24491133900005,
								-38.39645464999995
							],
							[
								142.25504300700004,
								-38.39117621099996
							],
							[
								142.24396416000002,
								-38.38797131999996
							],
							[
								142.24432905100002,
								-38.37801822999995
							],
							[
								142.26153467900008,
								-38.364572890999966
							],
							[
								142.28596638400006,
								-38.36648059299995
							],
							[
								142.30937701100004,
								-38.356308223999974
							],
							[
								142.33448370600001,
								-38.35840790499998
							],
							[
								142.34394848500006,
								-38.351313705999985
							],
							[
								142.37252404000003,
								-38.34946927699997
							],
							[
								142.47165936700003,
								-38.40429708299996
							],
							[
								142.48060420600007,
								-38.401378973999954
							],
							[
								142.47886811700005,
								-38.39501399399995
							],
							[
								142.49218689400004,
								-38.39385781499993
							],
							[
								142.5633250090001,
								-38.421991068999944
							],
							[
								142.68403432000002,
								-38.49511981599994
							],
							[
								142.78766388500003,
								-38.56911088299995
							],
							[
								142.8230036870001,
								-38.57642247499996
							],
							[
								142.8283777250001,
								-38.587029375999975
							],
							[
								142.85233946100004,
								-38.59181410699995
							],
							[
								142.85763750800004,
								-38.60527618699996
							],
							[
								142.90065644000003,
								-38.61015251999993
							],
							[
								142.93703207200008,
								-38.62732270199996
							],
							[
								142.9478903810001,
								-38.61975468299994
							],
							[
								143.01538423800002,
								-38.62448670699996
							],
							[
								143.05503607900005,
								-38.64138473899993
							],
							[
								143.05499610900006,
								-38.64785674999996
							],
							[
								143.0808390840001,
								-38.65100476099997
							],
							[
								143.12298603300007,
								-38.67678076399994
							],
							[
								143.19031719500003,
								-38.740180727999984
							],
							[
								143.23296999500008,
								-38.766422760999944
							],
							[
								143.25970214900008,
								-38.77295072299995
							],
							[
								143.26739316900012,
								-38.76307970299996
							],
							[
								143.3021752940001,
								-38.75016570499997
							],
							[
								143.3275412580001,
								-38.75719470699994
							],
							[
								143.3565950630001,
								-38.75393670899996
							],
							[
								143.40313909200006,
								-38.78097378199993
							],
							[
								143.42770909800004,
								-38.78277379299993
							],
							[
								143.5113460550001,
								-38.85767970899997
							],
							[
								143.5547090970001,
								-38.85547876199996
							],
							[
								143.61603691200003,
								-38.79549575499993
							],
							[
								143.6617479350001,
								-38.78263771799993
							],
							[
								143.66701130600006,
								-38.76790777799994
							],
							[
								143.67994697400002,
								-38.76082477899996
							],
							[
								143.67135918700012,
								-38.74851278799997
							],
							[
								143.685377226,
								-38.73534675899998
							],
							[
								143.7567281460001,
								-38.70669374299996
							],
							[
								143.84041803200012,
								-38.69097975899996
							],
							[
								143.84206794300007,
								-38.67906571899994
							],
							[
								143.86623222000003,
								-38.671654769999975
							],
							[
								143.87029014100005,
								-38.655257759999984
							],
							[
								143.90815994700006,
								-38.62585279299998
							],
							[
								143.9230718780001,
								-38.593094762999954
							],
							[
								143.97435386100005,
								-38.56522373599995
							],
							[
								143.98684190100005,
								-38.54843776699994
							],
							[
								143.9771420630001,
								-38.542538795999974
							],
							[
								143.97973407400002,
								-38.53226277699997
							],
							[
								144.0365035090001,
								-38.47576184999997
							],
							[
								144.104763638,
								-38.46924221399996
							],
							[
								144.13230818700004,
								-38.43528679599996
							],
							[
								144.18402217800008,
								-38.428685738999945
							],
							[
								144.18288600900007,
								-38.416847778999966
							],
							[
								144.2293449130001,
								-38.39837085199997
							],
							[
								144.234260005,
								-38.37293379199997
							],
							[
								144.20407702900002,
								-38.38079878999997
							],
							[
								144.19606700300005,
								-38.35955379999996
							],
							[
								144.20310803400002,
								-38.34091678999994
							],
							[
								144.16671542100005,
								-38.336501296999984
							],
							[
								144.1652683100001,
								-38.34269217699995
							],
							[
								144.149301024,
								-38.33225278599997
							],
							[
								144.150675975,
								-38.32135882599994
							],
							[
								144.12805900800004,
								-38.33084179499997
							],
							[
								144.10874650200003,
								-38.32460333399996
							],
							[
								144.10772501200006,
								-38.331601803999945
							],
							[
								144.0804520260001,
								-38.338043581999955
							],
							[
								144.0826540370001,
								-38.32540279199998
							],
							[
								144.01278305100004,
								-38.31372678699995
							],
							[
								144.02739006100012,
								-38.28105276799994
							],
							[
								144.04771902900006,
								-38.27353077899994
							],
							[
								144.05581830200003,
								-38.224262789999955
							],
							[
								144.04977306400008,
								-38.21471977899995
							],
							[
								144.0624132060001,
								-38.172386159999974
							],
							[
								143.91251601400006,
								-38.16001980999994
							],
							[
								143.90069249900012,
								-38.138528778999955
							],
							[
								143.80987146600012,
								-38.12768561299998
							],
							[
								143.8284165660001,
								-38.09218069399998
							],
							[
								143.81859766900004,
								-38.08013715399994
							],
							[
								143.82316014100002,
								-38.05577875399996
							],
							[
								143.82972072300004,
								-38.02234985399997
							],
							[
								143.76697256400007,
								-38.01975379999993
							],
							[
								143.67241506000005,
								-38.02938694399995
							],
							[
								143.6289192580001,
								-38.02339335099998
							],
							[
								143.63341543800004,
								-38.01265905099996
							],
							[
								143.65625370500004,
								-38.00747611299994
							],
							[
								143.64708085900008,
								-37.98720664199993
							],
							[
								143.62182975400003,
								-37.98184650999997
							],
							[
								143.61177605800003,
								-37.958800519999954
							],
							[
								143.5973227500001,
								-37.962173048999944
							],
							[
								143.59345598100003,
								-37.95465561899994
							],
							[
								143.47941664300004,
								-37.94083673099993
							],
							[
								143.47712345500008,
								-37.92435279099993
							],
							[
								143.44278127300004,
								-37.90565609899994
							],
							[
								143.45250414400005,
								-37.87728989899995
							],
							[
								143.44055933800007,
								-37.85941813799997
							],
							[
								143.4478029500001,
								-37.821387028999936
							],
							[
								143.4407181250001,
								-37.78483621799995
							],
							[
								143.46555094300004,
								-37.65426962899994
							],
							[
								143.48972744000002,
								-37.64679756999993
							],
							[
								143.4879130700001,
								-37.655115629999955
							],
							[
								143.49987549700006,
								-37.656783150999956
							],
							[
								143.49483262800004,
								-37.66086528099993
							],
							[
								143.53578368,
								-37.66669134299997
							],
							[
								143.5365443820001,
								-37.64829831299994
							],
							[
								143.58664266200003,
								-37.65371118599995
							],
							[
								143.59530930200003,
								-37.644294936999984
							],
							[
								143.65164751200007,
								-37.647039579999955
							],
							[
								143.66856501000007,
								-37.538429390999966
							],
							[
								143.62203993900005,
								-37.52513848799998
							],
							[
								143.6060573110001,
								-37.53491160699997
							],
							[
								143.59500475400012,
								-37.527254065999955
							],
							[
								143.6202767740001,
								-37.47378218699998
							],
							[
								143.62150291500006,
								-37.46770763699993
							],
							[
								143.60924406700008,
								-37.467129185999966
							],
							[
								143.62001583500012,
								-37.46494853699994
							],
							[
								143.66513507000002,
								-37.236641848999966
							]
						]
					],
					[
						[
							[
								142.00870118900002,
								-38.41714523699994
							],
							[
								142.01417702900005,
								-38.41229311699993
							],
							[
								141.9934873320001,
								-38.41735839599994
							],
							[
								141.99876742000004,
								-38.42547145699996
							],
							[
								142.00870118900002,
								-38.41714523699994
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "238",
				"CED_NAME21": "Wannon",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 33594.0575,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/238",
				"SHAPE_Leng": 13.0403466499,
				"SHAPE_Area": 3.44089967513
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							144.90959781900006,
							-37.69400644299998
						],
						[
							144.89781160000007,
							-37.69828726199995
						],
						[
							144.90429129900008,
							-37.700858822999976
						],
						[
							144.89754346900008,
							-37.70925225199994
						],
						[
							144.93473400900007,
							-37.743908844999964
						],
						[
							144.92672496000012,
							-37.75144883499996
						],
						[
							144.93841418700003,
							-37.76091095499993
						],
						[
							144.93708011500007,
							-37.777761054999985
						],
						[
							144.98687106700004,
							-37.77436482899998
						],
						[
							144.98062749200005,
							-37.73936139799997
						],
						[
							144.96721695500003,
							-37.728816836999954
						],
						[
							144.9825020950001,
							-37.70322784799998
						],
						[
							144.97206678800012,
							-37.69098585699993
						],
						[
							144.90959781900006,
							-37.69400644299998
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "239",
				"CED_NAME21": "Wills",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 46.8239,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/239",
				"SHAPE_Leng": 0.434455124961,
				"SHAPE_Area": 0.00478549571526
			}
		},
		{
			"type": "Feature",
			"geometry": null,
			"properties": {
				"CED_CODE21": "294",
				"CED_NAME21": "No usual address (Vic.)",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 0,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/294",
				"SHAPE_Leng": 0,
				"SHAPE_Area": 0
			}
		},
		{
			"type": "Feature",
			"geometry": null,
			"properties": {
				"CED_CODE21": "297",
				"CED_NAME21": "Migratory - Offshore - Shipping (Vic.)",
				"STE_CODE21": "2",
				"STE_NAME21": "Victoria",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 0,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/297",
				"SHAPE_Leng": 0,
				"SHAPE_Area": 0
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							152.19172912400006,
							-27.386836351999932
						],
						[
							152.2609754560001,
							-27.392614548999973
						],
						[
							152.26287053300007,
							-27.416136578999954
						],
						[
							152.2913069120001,
							-27.400203361999957
						],
						[
							152.2942580880001,
							-27.42734029199994
						],
						[
							152.3103520960001,
							-27.42930536399996
						],
						[
							152.31542713900012,
							-27.398777243999973
						],
						[
							152.37338011300005,
							-27.40196738999998
						],
						[
							152.4016090980001,
							-27.41496538299998
						],
						[
							152.39950191700007,
							-27.42839404299997
						],
						[
							152.41413812500002,
							-27.43018938399996
						],
						[
							152.40911010500008,
							-27.436577373999967
						],
						[
							152.43556811100007,
							-27.440108375999955
						],
						[
							152.43575709900006,
							-27.457879385999945
						],
						[
							152.4672330940001,
							-27.46922737999995
						],
						[
							152.48031618100003,
							-27.48298940099994
						],
						[
							152.47217110200006,
							-27.48672937999993
						],
						[
							152.47411209900008,
							-27.507904390999954
						],
						[
							152.49934998600008,
							-27.511684512999977
						],
						[
							152.49266307100004,
							-27.55156139299993
						],
						[
							152.51866409900003,
							-27.552007394999976
						],
						[
							152.50779807600009,
							-27.581094393999933
						],
						[
							152.497019087,
							-27.582939392999947
						],
						[
							152.50444394500005,
							-27.595905733999928
						],
						[
							152.48625610500005,
							-27.60566840299998
						],
						[
							152.45785907100003,
							-27.66278338999996
						],
						[
							152.43978908500003,
							-27.649934387999963
						],
						[
							152.43087308500003,
							-27.65679238699994
						],
						[
							152.4208380670001,
							-27.65222538599994
						],
						[
							152.4125610760001,
							-27.66142238599997
						],
						[
							152.4226490850001,
							-27.66365838699994
						],
						[
							152.41745364400003,
							-27.67370486599998
						],
						[
							152.39156806500011,
							-27.69081538399996
						],
						[
							152.39065205400004,
							-27.697755383999947
						],
						[
							152.41350306100003,
							-27.700926395999943
						],
						[
							152.4051320760001,
							-27.749104385999942
						],
						[
							152.39730453700008,
							-27.751130804999946
						],
						[
							152.39537606600004,
							-27.76100338499998
						],
						[
							152.39187567700003,
							-27.756837833999953
						],
						[
							152.38923705600007,
							-27.76974439399993
						],
						[
							152.40876575000004,
							-27.796105675999968
						],
						[
							152.40705805900006,
							-27.80549938599995
						],
						[
							152.38279235200002,
							-27.807217883999954
						],
						[
							152.39949806800007,
							-27.820069385999943
						],
						[
							152.39476504700008,
							-27.834140374999947
						],
						[
							152.402356273,
							-27.863690555999938
						],
						[
							152.4192862100001,
							-27.86545636799997
						],
						[
							152.42847906300005,
							-27.840464388999976
						],
						[
							152.44340406000003,
							-27.844758379999973
						],
						[
							152.4511840350001,
							-27.80198938099994
						],
						[
							152.46233405400005,
							-27.80255239199994
						],
						[
							152.46741106500008,
							-27.78312140199995
						],
						[
							152.4945034420001,
							-27.78341327499993
						],
						[
							152.49900706500011,
							-27.758257404999938
						],
						[
							152.5193310720001,
							-27.761159386999964
						],
						[
							152.52965206700003,
							-27.716928407999944
						],
						[
							152.5806580410001,
							-27.719124402999967
						],
						[
							152.57984150100003,
							-27.72358645299994
						],
						[
							152.60577032800006,
							-27.724974894999946
						],
						[
							152.6076488760001,
							-27.737086475999945
						],
						[
							152.65597706000005,
							-27.738293399999975
						],
						[
							152.66864003800004,
							-27.743320411999946
						],
						[
							152.6675350380001,
							-27.749963411999943
						],
						[
							152.6842950260001,
							-27.752465422999933
						],
						[
							152.68639403600002,
							-27.746845422999968
						],
						[
							152.70436203400004,
							-27.74959141499994
						],
						[
							152.70754702200009,
							-27.758331425999984
						],
						[
							152.75781207600005,
							-27.767263430999947
						],
						[
							152.76072601300007,
							-27.785294420999946
						],
						[
							152.80549402700012,
							-27.79381041599993
						],
						[
							152.81139703100007,
							-27.754895425999962
						],
						[
							152.82226286000002,
							-27.756374796999978
						],
						[
							152.8292640400001,
							-27.74677442799998
						],
						[
							152.83600302900004,
							-27.755730427999936
						],
						[
							152.87333099500006,
							-27.753436431999944
						],
						[
							152.87465579600007,
							-27.746273031999976
						],
						[
							152.88279456500004,
							-27.747345182999936
						],
						[
							152.89065670900004,
							-27.70357751299997
						],
						[
							152.92287718500006,
							-27.708110956999974
						],
						[
							152.92776103800009,
							-27.685255446999975
						],
						[
							152.91474699900004,
							-27.685495445999948
						],
						[
							152.8890471750001,
							-27.66043245299994
						],
						[
							152.88246202400012,
							-27.671430431999966
						],
						[
							152.86721144600006,
							-27.672535100999937
						],
						[
							152.87163502800001,
							-27.64662642099995
						],
						[
							152.8526350310001,
							-27.64359842899995
						],
						[
							152.86081804600008,
							-27.597952419999956
						],
						[
							152.8489870510001,
							-27.564643427999954
						],
						[
							152.85291803300004,
							-27.54486342799993
						],
						[
							152.8411846680001,
							-27.515684936999946
						],
						[
							152.84277125000006,
							-27.496502566999936
						],
						[
							152.81241205600008,
							-27.47810442399998
						],
						[
							152.7992280750001,
							-27.497408432999976
						],
						[
							152.7699750390001,
							-27.488087419999943
						],
						[
							152.7545210500001,
							-27.49513042799998
						],
						[
							152.74429207200012,
							-27.491949426999952
						],
						[
							152.73787782600004,
							-27.460976245999973
						],
						[
							152.74412531600012,
							-27.460120656999948
						],
						[
							152.7474084480001,
							-27.440852236999945
						],
						[
							152.74095390000002,
							-27.42739772599998
						],
						[
							152.74812703100008,
							-27.415523856999982
						],
						[
							152.7420850840001,
							-27.39169742599995
						],
						[
							152.73295201500002,
							-27.39597710499993
						],
						[
							152.73324061800008,
							-27.366620394999927
						],
						[
							152.72201625000002,
							-27.36507289399998
						],
						[
							152.72390396100002,
							-27.353961063999975
						],
						[
							152.70782400300004,
							-27.35179216199998
						],
						[
							152.69225831400001,
							-27.36000231099996
						],
						[
							152.68640718300003,
							-27.37320485999993
						],
						[
							152.67969921300005,
							-27.37225202999997
						],
						[
							152.69083763600008,
							-27.34356379099995
						],
						[
							152.71955681500003,
							-27.32344894299996
						],
						[
							152.74850909300005,
							-27.318742415999964
						],
						[
							152.75629906300003,
							-27.30869441699997
						],
						[
							152.753606095,
							-27.295001425999942
						],
						[
							152.7040120910001,
							-27.292600411999956
						],
						[
							152.70492609300004,
							-27.277328401999966
						],
						[
							152.68546509500004,
							-27.274319409999976
						],
						[
							152.68095610700004,
							-27.259201418999965
						],
						[
							152.70223107900006,
							-27.226338410999972
						],
						[
							152.70354800200005,
							-27.199192250999943
						],
						[
							152.73356549300001,
							-27.171498913999983
						],
						[
							152.72906869400003,
							-27.163759592999952
						],
						[
							152.73933961500006,
							-27.15092149399993
						],
						[
							152.72820058900004,
							-27.122743962999948
						],
						[
							152.73352021100004,
							-27.10741846299993
						],
						[
							152.7344671310001,
							-27.10233248299994
						],
						[
							152.67651141900012,
							-27.089978376999966
						],
						[
							152.68712210900003,
							-27.082362417999946
						],
						[
							152.67768310300005,
							-27.05694640699994
						],
						[
							152.69515813100008,
							-27.05902440899996
						],
						[
							152.68915410300008,
							-27.048269407999953
						],
						[
							152.7035091240001,
							-27.02479240899993
						],
						[
							152.68335616000002,
							-26.992763416999935
						],
						[
							152.68927215000008,
							-26.98453640799994
						],
						[
							152.67985815200007,
							-26.97836340699996
						],
						[
							152.6852001430001,
							-26.965711406999958
						],
						[
							152.66476014500006,
							-26.96904040499993
						],
						[
							152.66773015600006,
							-26.959061404999943
						],
						[
							152.6512701480001,
							-26.95532041399997
						],
						[
							152.66762711800004,
							-26.94360140499998
						],
						[
							152.67298616000005,
							-26.92259241599993
						],
						[
							152.68744913900002,
							-26.913722406999966
						],
						[
							152.66081914300003,
							-26.909907403999966
						],
						[
							152.6674021340001,
							-26.896229394999978
						],
						[
							152.68861914100012,
							-26.896912396999937
						],
						[
							152.68985916200006,
							-26.891451406999977
						],
						[
							152.66648114100008,
							-26.839463403999957
						],
						[
							152.67846215100008,
							-26.830395404999933
						],
						[
							152.67908083200007,
							-26.822176094999975
						],
						[
							152.67181817300002,
							-26.81978539499994
						],
						[
							152.67903016200012,
							-26.81642141499998
						],
						[
							152.67922015400006,
							-26.799864414999945
						],
						[
							152.66898369700004,
							-26.78980119399995
						],
						[
							152.6673091890001,
							-26.77299640399997
						],
						[
							152.65426920100003,
							-26.768185011999947
						],
						[
							152.64433656100005,
							-26.77373479099998
						],
						[
							152.63908819300002,
							-26.761764400999937
						],
						[
							152.60246197700008,
							-26.757867776999944
						],
						[
							152.58331335200012,
							-26.740419504999977
						],
						[
							152.5868261820001,
							-26.733450424999944
						],
						[
							152.57616315600012,
							-26.713097363999964
						],
						[
							152.55087719900007,
							-26.703570381999953
						],
						[
							152.55804821000004,
							-26.689741391999974
						],
						[
							152.55219649200012,
							-26.68085136199994
						],
						[
							152.58320934300002,
							-26.64537138399993
						],
						[
							152.587790207,
							-26.613978404999955
						],
						[
							152.58414819900008,
							-26.59667840399993
						],
						[
							152.57401821000008,
							-26.595461392999937
						],
						[
							152.57520139100006,
							-26.58399448299997
						],
						[
							152.56248968300008,
							-26.583209461999957
						],
						[
							152.55399518500008,
							-26.57256339099996
						],
						[
							152.51149609000004,
							-26.56737637699996
						],
						[
							152.51982301700002,
							-26.588295717999983
						],
						[
							152.4569773940001,
							-26.580878521999978
						],
						[
							152.45086298700005,
							-26.55840744099993
						],
						[
							152.44022780900002,
							-26.556912599999976
						],
						[
							152.44962192100002,
							-26.530901599999936
						],
						[
							152.44342991200006,
							-26.527997639999967
						],
						[
							152.4361414120001,
							-26.537575628999946
						],
						[
							152.44761022700004,
							-26.48414338999993
						],
						[
							152.43861440700005,
							-26.486233828999957
						],
						[
							152.44277219000003,
							-26.46021836899996
						],
						[
							152.4120732130001,
							-26.464477385999942
						],
						[
							152.39007094400006,
							-26.476098583999942
						],
						[
							152.36440951800012,
							-26.463128120999954
						],
						[
							152.3159982210001,
							-26.480860366999934
						],
						[
							152.30459521400007,
							-26.46605137599994
						],
						[
							152.2780912180001,
							-26.452748372999963
						],
						[
							152.25314080700002,
							-26.484561540999948
						],
						[
							152.22921476800002,
							-26.492735048999975
						],
						[
							152.23124605600003,
							-26.50740235899997
						],
						[
							152.22134423800003,
							-26.503846067999973
						],
						[
							152.21361323700012,
							-26.513088056999948
						],
						[
							152.16765825700008,
							-26.475406351999936
						],
						[
							152.15575815800003,
							-26.47476452099994
						],
						[
							152.14989395800012,
							-26.482662540999968
						],
						[
							152.13587324900004,
							-26.480049348999955
						],
						[
							152.13652721800008,
							-26.495020359999955
						],
						[
							152.1257232170001,
							-26.506547358999967
						],
						[
							152.13587784000003,
							-26.560762439999962
						],
						[
							152.13159021800004,
							-26.578459359999954
						],
						[
							152.1431612350001,
							-26.592687350999938
						],
						[
							152.13032720600006,
							-26.600393339999982
						],
						[
							152.13585626300005,
							-26.61420634999996
						],
						[
							152.13081922100002,
							-26.638771349999956
						],
						[
							152.11963522200006,
							-26.637385348999942
						],
						[
							152.07339899300007,
							-26.668397784999968
						],
						[
							152.084456229,
							-26.696890335999967
						],
						[
							152.10233622500004,
							-26.70955334799993
						],
						[
							152.11345051500007,
							-26.70698824899995
						],
						[
							152.13430438000012,
							-26.730586020999965
						],
						[
							152.13311622800006,
							-26.741259360999948
						],
						[
							152.146060228,
							-26.736020361999977
						],
						[
							152.14107519900006,
							-26.727174341999955
						],
						[
							152.15299522800012,
							-26.727592352999977
						],
						[
							152.15097724700001,
							-26.74050385299995
						],
						[
							152.1639040550001,
							-26.742110743999945
						],
						[
							152.1557884230001,
							-26.768807803999948
						],
						[
							152.17905121800004,
							-26.783744355999943
						],
						[
							152.17051919800008,
							-26.79681935499997
						],
						[
							152.174123204,
							-26.82142635599996
						],
						[
							152.1900873830001,
							-26.823599516999934
						],
						[
							152.18103473100007,
							-26.846560546999967
						],
						[
							152.188655196,
							-26.877365357999963
						],
						[
							152.17265220800004,
							-26.875234365999972
						],
						[
							152.16704420000008,
							-26.86708235599997
						],
						[
							152.14698519,
							-26.879104353999935
						],
						[
							152.13792588900003,
							-26.897850742999935
						],
						[
							152.14987620700003,
							-26.904604353999957
						],
						[
							152.14522920500008,
							-26.926677343999984
						],
						[
							152.1254446040001,
							-26.954212711999958
						],
						[
							152.15158428900008,
							-26.97116470499998
						],
						[
							152.167890187,
							-26.96876534599994
						],
						[
							152.16945417600004,
							-26.97932435699994
						],
						[
							152.183177375,
							-26.977575387999934
						],
						[
							152.1747511650001,
							-26.98214134699998
						],
						[
							152.18490418400006,
							-26.985228357999972
						],
						[
							152.1733121840001,
							-26.989247346999946
						],
						[
							152.18875712200008,
							-26.993915158999982
						],
						[
							152.18659220100005,
							-27.006649358999937
						],
						[
							152.22096369500002,
							-27.02219452199995
						],
						[
							152.1930207580001,
							-27.022864548999962
						],
						[
							152.19918476700002,
							-27.02774231999996
						],
						[
							152.19472946400003,
							-27.05652638999993
						],
						[
							152.22739324000008,
							-27.060978102999968
						],
						[
							152.21450626000012,
							-27.069481131999964
						],
						[
							152.21804419900002,
							-27.078261361999978
						],
						[
							152.19132419200002,
							-27.072331368999983
						],
						[
							152.1852421640001,
							-27.06142036899996
						],
						[
							152.18231910100008,
							-27.090055408999945
						],
						[
							152.15363017100003,
							-27.11309735599997
						],
						[
							152.1340416800001,
							-27.141611513999976
						],
						[
							152.18849813100007,
							-27.169136409999965
						],
						[
							152.16161815100008,
							-27.18896935799995
						],
						[
							152.15886006000005,
							-27.206418456999984
						],
						[
							152.1732441570001,
							-27.211294358999965
						],
						[
							152.18002917700005,
							-27.205040358999952
						],
						[
							152.21508315300002,
							-27.20894236299995
						],
						[
							152.22047114400004,
							-27.20129435299998
						],
						[
							152.23615497200012,
							-27.203695124999967
						],
						[
							152.2255144500001,
							-27.228666043999965
						],
						[
							152.20094714100003,
							-27.243390661999968
						],
						[
							152.1909122720001,
							-27.242065390999983
						],
						[
							152.1887337700001,
							-27.254838220999943
						],
						[
							152.17239976200005,
							-27.253782048999938
						],
						[
							152.17698767100012,
							-27.263753479999934
						],
						[
							152.16249531300002,
							-27.25656934799997
						],
						[
							152.15199363300007,
							-27.26939105699995
						],
						[
							152.16440005900006,
							-27.288931368999954
						],
						[
							152.18408234900005,
							-27.270461359999956
						],
						[
							152.19644416800008,
							-27.272150371999942
						],
						[
							152.20619215400006,
							-27.292033352999965
						],
						[
							152.19010616200012,
							-27.32034035099997
						],
						[
							152.20149087100003,
							-27.322009091999973
						],
						[
							152.1914391370001,
							-27.366110351999964
						],
						[
							152.20150013600005,
							-27.35967936299994
						],
						[
							152.19172912400006,
							-27.386836351999932
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "301",
				"CED_NAME21": "Blair",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 6467.756,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/301",
				"SHAPE_Leng": 6.96012685102,
				"SHAPE_Area": 0.588718722476
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								153.10170901900005,
								-27.446746451999957
							],
							[
								153.106761537,
								-27.45573521299997
							],
							[
								153.0985581980001,
								-27.45688045199995
							],
							[
								153.09526994600003,
								-27.47498945199993
							],
							[
								153.10187304300007,
								-27.49144541299995
							],
							[
								153.0945390290001,
								-27.531317461999947
							],
							[
								153.08394614100007,
								-27.52148848099995
							],
							[
								153.07166185200003,
								-27.529353409999942
							],
							[
								153.0634358840001,
								-27.52092444899995
							],
							[
								153.0557804440001,
								-27.52561408799994
							],
							[
								153.0622791610001,
								-27.544910438999977
							],
							[
								153.11115308900003,
								-27.593932174999964
							],
							[
								153.12201000800007,
								-27.595432485999936
							],
							[
								153.12332002900007,
								-27.587298465999936
							],
							[
								153.15574900500008,
								-27.59169345899994
							],
							[
								153.17576801100006,
								-27.60669446099996
							],
							[
								153.17202770300003,
								-27.59051662099995
							],
							[
								153.18192012600002,
								-27.56231403099997
							],
							[
								153.19178720500008,
								-27.55946013199997
							],
							[
								153.18295099800002,
								-27.541581450999956
							],
							[
								153.17195001000005,
								-27.536399459999927
							],
							[
								153.20122403000005,
								-27.51402047299996
							],
							[
								153.18428401300002,
								-27.50227247099997
							],
							[
								153.1971310350001,
								-27.47412246199997
							],
							[
								153.19201603500005,
								-27.47627545199998
							],
							[
								153.19406601800006,
								-27.45227646199993
							],
							[
								153.1715143130001,
								-27.43186131899995
							],
							[
								153.17440803600005,
								-27.408480319999967
							],
							[
								153.16540710800007,
								-27.39885936899998
							],
							[
								153.1834847870001,
								-27.393388329999937
							],
							[
								153.17926078800008,
								-27.385711329999936
							],
							[
								153.20219126000006,
								-27.352880811999967
							],
							[
								153.1888470120001,
								-27.345447469999954
							],
							[
								153.15649782000003,
								-27.392436007999947
							],
							[
								153.16403612800002,
								-27.401674407999963
							],
							[
								153.15470658900006,
								-27.40178109699997
							],
							[
								153.14208484800008,
								-27.421889645999954
							],
							[
								153.10170901900005,
								-27.446746451999957
							]
						]
					],
					[
						[
							[
								153.2354778680001,
								-27.33753950499994
							],
							[
								153.24050647700005,
								-27.347133455999938
							],
							[
								153.25290822500006,
								-27.350624626999945
							],
							[
								153.271013465,
								-27.338047278999966
							],
							[
								153.2476171190001,
								-27.320710565999946
							],
							[
								153.23581378000006,
								-27.32790373499995
							],
							[
								153.2354778680001,
								-27.33753950499994
							]
						]
					],
					[
						[
							[
								153.36587300200006,
								-27.12257961699993
							],
							[
								153.36161721100007,
								-27.135647365999944
							],
							[
								153.37326822400007,
								-27.176272197999936
							],
							[
								153.36550752200003,
								-27.20123217699995
							],
							[
								153.4212244900001,
								-27.331053433999955
							],
							[
								153.418645727,
								-27.355007383999975
							],
							[
								153.42834563500003,
								-27.36360078499996
							],
							[
								153.43729222700006,
								-27.33395235599994
							],
							[
								153.4175861770001,
								-27.274410672999977
							],
							[
								153.41966668600003,
								-27.203557952999972
							],
							[
								153.43404992400008,
								-27.13122204399997
							],
							[
								153.46821568300004,
								-27.027770895999936
							],
							[
								153.4547429150001,
								-27.021952074999945
							],
							[
								153.43776326600005,
								-27.03196225299996
							],
							[
								153.41218165800012,
								-27.033127470999943
							],
							[
								153.43150037600003,
								-27.03370730299997
							],
							[
								153.38873620900006,
								-27.05033250799994
							],
							[
								153.40710778800008,
								-27.040061479999963
							],
							[
								153.38781114900007,
								-27.047606537999968
							],
							[
								153.40240184900006,
								-27.03525450999996
							],
							[
								153.36176760000012,
								-27.06026852599996
							],
							[
								153.36972273600009,
								-27.090466446999983
							],
							[
								153.36587300200006,
								-27.12257961699993
							]
						]
					],
					[
						[
							[
								153.39722702000006,
								-27.343685481999955
							],
							[
								153.40757600900008,
								-27.34623148299994
							],
							[
								153.40468999200004,
								-27.32674948199997
							],
							[
								153.39722702000006,
								-27.343685481999955
							]
						]
					],
					[
						[
							[
								153.18854978500008,
								-27.401023280999937
							],
							[
								153.18370280700003,
								-27.39337532999997
							],
							[
								153.1780668770001,
								-27.39660934999995
							],
							[
								153.18854978500008,
								-27.401023280999937
							]
						]
					],
					[
						[
							[
								153.2321261080001,
								-27.420893874999933
							],
							[
								153.22637683900007,
								-27.420249414999944
							],
							[
								153.23460532700005,
								-27.430495045999976
							],
							[
								153.2321261080001,
								-27.420893874999933
							]
						]
					],
					[
						[
							[
								153.22242528300012,
								-27.390121843999964
							],
							[
								153.23849758000006,
								-27.40236886599996
							],
							[
								153.24408402100005,
								-27.39080947599996
							],
							[
								153.2367950040001,
								-27.371761465999953
							],
							[
								153.22242528300012,
								-27.390121843999964
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "302",
				"CED_NAME21": "Bonner",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 373.7494,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/302",
				"SHAPE_Leng": 2.22225396792,
				"SHAPE_Area": 0.0340834567064
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								153.17384700700006,
								-27.634239460999936
							],
							[
								153.28068099300003,
								-27.657985461999942
							],
							[
								153.28667998700007,
								-27.69434148299996
							],
							[
								153.2925269970001,
								-27.69201947399995
							],
							[
								153.30203191400005,
								-27.706899504999967
							],
							[
								153.32303796300005,
								-27.70029302699993
							],
							[
								153.31587687600006,
								-27.679938155999935
							],
							[
								153.32076276600003,
								-27.67428513599998
							],
							[
								153.30815484000004,
								-27.656434264999973
							],
							[
								153.3126129840001,
								-27.617973484999936
							],
							[
								153.30148260800001,
								-27.600653463999947
							],
							[
								153.31815098800007,
								-27.582009484999958
							],
							[
								153.30508739100003,
								-27.574471503999973
							],
							[
								153.30819700200004,
								-27.564889473999983
							],
							[
								153.28943998400007,
								-27.564619481999955
							],
							[
								153.2778899980001,
								-27.540736460999938
							],
							[
								153.29072136000002,
								-27.510979671999962
							],
							[
								153.26163312300002,
								-27.516168438999955
							],
							[
								153.26059061700005,
								-27.484386898999958
							],
							[
								153.2416439100001,
								-27.48070600699998
							],
							[
								153.2410127920001,
								-27.46501702699993
							],
							[
								153.2280245510001,
								-27.48311515599994
							],
							[
								153.20730697300007,
								-27.481792472999928
							],
							[
								153.1971310350001,
								-27.47412246199997
							],
							[
								153.18428401300002,
								-27.50227247099997
							],
							[
								153.20122403000005,
								-27.51402047299996
							],
							[
								153.17195001000005,
								-27.536399459999927
							],
							[
								153.18295099800002,
								-27.541581450999956
							],
							[
								153.19178720500008,
								-27.55946013199997
							],
							[
								153.18192012600002,
								-27.56231403099997
							],
							[
								153.17202770300003,
								-27.59051662099995
							],
							[
								153.17576801100006,
								-27.60669446099996
							],
							[
								153.18356786900006,
								-27.61281248199998
							],
							[
								153.17384700700006,
								-27.634239460999936
							]
						]
					],
					[
						[
							[
								153.32681199900003,
								-27.567526405999956
							],
							[
								153.31867918000012,
								-27.573458434999964
							],
							[
								153.337454857,
								-27.573432346999937
							],
							[
								153.33818882900005,
								-27.56444833699993
							],
							[
								153.32681199900003,
								-27.567526405999956
							]
						]
					],
					[
						[
							[
								153.42398479200006,
								-27.46569309499995
							],
							[
								153.40913476200012,
								-27.475997553999946
							],
							[
								153.39839146100007,
								-27.496410132999983
							],
							[
								153.4125433470001,
								-27.51162603399996
							],
							[
								153.41353773600008,
								-27.59918981499993
							],
							[
								153.4070829750001,
								-27.610996824999972
							],
							[
								153.42166899000006,
								-27.64204162599998
							],
							[
								153.3988414790001,
								-27.66258970399997
							],
							[
								153.4020806750001,
								-27.69295055499998
							],
							[
								153.39290493400006,
								-27.70711455399993
							],
							[
								153.40690793900012,
								-27.73446036599995
							],
							[
								153.4224467470001,
								-27.740764266999975
							],
							[
								153.43701846600004,
								-27.733834198999944
							],
							[
								153.43216348700003,
								-27.728148247999968
							],
							[
								153.43994926800008,
								-27.715456248999942
							],
							[
								153.44627117700009,
								-27.716501199999982
							],
							[
								153.43844145600008,
								-27.733178188999943
							],
							[
								153.45400318500003,
								-27.728745129999936
							],
							[
								153.47377488900008,
								-27.60395551099998
							],
							[
								153.52255624100007,
								-27.472140604999936
							],
							[
								153.54660755300006,
								-27.436485567999966
							],
							[
								153.54354753400003,
								-27.425518616999966
							],
							[
								153.48317245200008,
								-27.415543930999945
							],
							[
								153.45837264800002,
								-27.39000909799995
							],
							[
								153.44963279900003,
								-27.38926812699998
							],
							[
								153.4395689800001,
								-27.393159165999975
							],
							[
								153.43254885800002,
								-27.41067845599997
							],
							[
								153.43620517800002,
								-27.40549216599993
							],
							[
								153.44045592700002,
								-27.411331486999927
							],
							[
								153.42398479200006,
								-27.46569309499995
							]
						]
					],
					[
						[
							[
								153.34407946500005,
								-27.513079387999937
							],
							[
								153.37393190300008,
								-27.49930926999997
							],
							[
								153.37229184400007,
								-27.490692299999978
							],
							[
								153.35879604600007,
								-27.485750398999983
							],
							[
								153.36011803600002,
								-27.49017337899994
							],
							[
								153.33862143700003,
								-27.495832466999957
							],
							[
								153.34407946500005,
								-27.513079387999937
							]
						]
					],
					[
						[
							[
								153.35385674300005,
								-27.594853958999977
							],
							[
								153.34673694000003,
								-27.622178168999937
							],
							[
								153.36242193700002,
								-27.63239047999997
							],
							[
								153.37633810800003,
								-27.618015501999935
							],
							[
								153.36825610000005,
								-27.605858480999927
							],
							[
								153.36815057900003,
								-27.616060050999977
							],
							[
								153.3603688500001,
								-27.614307509999946
							],
							[
								153.3677848520001,
								-27.59126552099997
							],
							[
								153.36129150400006,
								-27.58033419999998
							],
							[
								153.35385674300005,
								-27.594853958999977
							]
						]
					],
					[
						[
							[
								153.3827523970001,
								-27.617864951999934
							],
							[
								153.372616966,
								-27.63087048099993
							],
							[
								153.3861904050001,
								-27.628012902999956
							],
							[
								153.39037830600012,
								-27.619878892999964
							],
							[
								153.3827523970001,
								-27.617864951999934
							]
						]
					],
					[
						[
							[
								153.3788899640001,
								-27.64607915199997
							],
							[
								153.36500387400008,
								-27.652716950999945
							],
							[
								153.36639798200008,
								-27.67110188099997
							],
							[
								153.3734768710001,
								-27.668466851999938
							],
							[
								153.37863884000012,
								-27.674621801999933
							],
							[
								153.36537521900004,
								-27.696054790999938
							],
							[
								153.38458607500002,
								-27.709394602999964
							],
							[
								153.39758577500004,
								-27.696363573999975
							],
							[
								153.38826462100008,
								-27.65735878299995
							],
							[
								153.4159190700001,
								-27.641563675999976
							],
							[
								153.402871193,
								-27.63416176399994
							],
							[
								153.40106433100004,
								-27.644813753999983
							],
							[
								153.3788899640001,
								-27.64607915199997
							]
						]
					],
					[
						[
							[
								153.37907462400005,
								-27.642673911999964
							],
							[
								153.38648397400004,
								-27.639461512999958
							],
							[
								153.3604568170001,
								-27.635904039999957
							],
							[
								153.37907462400005,
								-27.642673911999964
							]
						]
					],
					[
						[
							[
								153.33521615100005,
								-27.62411921699993
							],
							[
								153.34895599800006,
								-27.638427088999947
							],
							[
								153.35246291800001,
								-27.63221307899994
							],
							[
								153.3394470510001,
								-27.620462197999927
							],
							[
								153.33521615100005,
								-27.62411921699993
							]
						]
					],
					[
						[
							[
								153.32734942000002,
								-27.642328196999983
							],
							[
								153.32294455900012,
								-27.651946175999967
							],
							[
								153.32920905600008,
								-27.67046245699993
							],
							[
								153.34144523700002,
								-27.64855309799998
							],
							[
								153.33186531,
								-27.635882186999936
							],
							[
								153.32734942000002,
								-27.642328196999983
							]
						]
					],
					[
						[
							[
								153.35542211400002,
								-27.660615469999982
							],
							[
								153.3538610060001,
								-27.649209029999952
							],
							[
								153.34957732200007,
								-27.680959938999933
							],
							[
								153.35592628100005,
								-27.687168889999953
							],
							[
								153.3617711710001,
								-27.683943860999932
							],
							[
								153.35542211400002,
								-27.660615469999982
							]
						]
					],
					[
						[
							[
								153.31942884600005,
								-27.681482115999984
							],
							[
								153.3223158840001,
								-27.691785056999947
							],
							[
								153.33926962200007,
								-27.695097947999955
							],
							[
								153.33343261400012,
								-27.681902027999968
							],
							[
								153.32542067600002,
								-27.677063096999973
							],
							[
								153.31942884600005,
								-27.681482115999984
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "303",
				"CED_NAME21": "Bowman",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 537.1672,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/303",
				"SHAPE_Leng": 3.33111129954,
				"SHAPE_Area": 0.0490885428555
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							153.00326403600002,
							-27.475517432999936
						],
						[
							153.01668804500002,
							-27.467623453999977
						],
						[
							153.03039204200002,
							-27.47944645599995
						],
						[
							153.03445704400008,
							-27.462626455999953
						],
						[
							153.04323799200006,
							-27.475227136999933
						],
						[
							153.05278004100012,
							-27.471680447999972
						],
						[
							153.04978661500002,
							-27.440170156999955
						],
						[
							153.09974584000008,
							-27.443092831999934
						],
						[
							153.08274089300005,
							-27.432678469999928
						],
						[
							153.0747520970001,
							-27.406952428999944
						],
						[
							153.0596492080001,
							-27.41041116799994
						],
						[
							153.05010931000004,
							-27.404043266999963
						],
						[
							153.0351970600001,
							-27.41423744599996
						],
						[
							152.99216804600007,
							-27.40693344099998
						],
						[
							152.99241205500005,
							-27.41257344099995
						],
						[
							152.98801015200002,
							-27.43861746099998
						],
						[
							152.97616805400003,
							-27.43688443999997
						],
						[
							152.974584283,
							-27.442885729999944
						],
						[
							153.00326403600002,
							-27.475517432999936
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "304",
				"CED_NAME21": "Brisbane",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 55.0353,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/304",
				"SHAPE_Leng": 0.436292040849,
				"SHAPE_Area": 0.00502338311493
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								150.79064570700007,
								-23.505957208999973
							],
							[
								150.8014163460001,
								-23.50095041999998
							],
							[
								150.85004062100006,
								-23.50687921399998
							],
							[
								150.86092057100007,
								-23.501989244999947
							],
							[
								150.87143257200012,
								-23.480867235999938
							],
							[
								150.81015157600007,
								-23.40683322999996
							],
							[
								150.7909747330001,
								-23.35756119699994
							],
							[
								150.79339468500007,
								-23.336299236999935
							],
							[
								150.7994887640001,
								-23.339689177999958
							],
							[
								150.79232187600007,
								-23.321942166999975
							],
							[
								150.77565170800005,
								-23.323218185999963
							],
							[
								150.76774684100008,
								-23.30278818499994
							],
							[
								150.75933413200005,
								-23.30038964399995
							],
							[
								150.78994477800006,
								-23.309612176999963
							],
							[
								150.80835264900008,
								-23.288044207999974
							],
							[
								150.825011678,
								-23.280182169999932
							],
							[
								150.82983060000004,
								-23.255114189999972
							],
							[
								150.8193456150001,
								-23.221522238999967
							],
							[
								150.80822669500003,
								-23.22970018799998
							],
							[
								150.79869891600003,
								-23.227806206999958
							],
							[
								150.78909663900004,
								-23.208463235999943
							],
							[
								150.79990780100002,
								-23.18289719699993
							],
							[
								150.79226787200002,
								-23.17502617599996
							],
							[
								150.7942266130001,
								-23.162454165999975
							],
							[
								150.78489184400007,
								-23.15920820499997
							],
							[
								150.783112694,
								-23.16673123499993
							],
							[
								150.77482263500008,
								-23.165232173999982
							],
							[
								150.7496536210001,
								-23.12880118199996
							],
							[
								150.77150563700002,
								-23.05590424299993
							],
							[
								150.77735779600005,
								-22.961906332999945
							],
							[
								150.79999888700002,
								-22.93306017499998
							],
							[
								150.78698095000004,
								-22.92220616299994
							],
							[
								150.78970794500003,
								-22.86573316299996
							],
							[
								150.7969396190001,
								-22.825257172999954
							],
							[
								150.8038336290001,
								-22.815843193999967
							],
							[
								150.81079567900008,
								-22.81779520499998
							],
							[
								150.80684970000004,
								-22.80452119399996
							],
							[
								150.81544581000003,
								-22.79837616499998
							],
							[
								150.8059626820001,
								-22.79120622399995
							],
							[
								150.81229076600005,
								-22.749182163999933
							],
							[
								150.82506897700011,
								-22.730945194999947
							],
							[
								150.82185164800012,
								-22.71533622499993
							],
							[
								150.83516480100002,
								-22.68419416599994
							],
							[
								150.81233398300003,
								-22.67968417399993
							],
							[
								150.80441074500004,
								-22.67149021299997
							],
							[
								150.80373681700007,
								-22.64683624299994
							],
							[
								150.78646472800006,
								-22.650008190999927
							],
							[
								150.7777419900001,
								-22.638953809999975
							],
							[
								150.77914487700002,
								-22.577588159999948
							],
							[
								150.78433966900002,
								-22.555661189999967
							],
							[
								150.79064580800002,
								-22.55499421099995
							],
							[
								150.78026266000006,
								-22.54530515999994
							],
							[
								150.78932170000007,
								-22.536844169999938
							],
							[
								150.7839479910001,
								-22.52914618999995
							],
							[
								150.77196467300007,
								-22.528471198999966
							],
							[
								150.76956779400007,
								-22.521766207999974
							],
							[
								150.75443084500012,
								-22.523756196999955
							],
							[
								150.75625496300006,
								-22.539384146999964
							],
							[
								150.7742589500001,
								-22.546840198999973
							],
							[
								150.77415493000012,
								-22.552391218999958
							],
							[
								150.76263381100011,
								-22.552261157999965
							],
							[
								150.75604690900002,
								-22.57693718799993
							],
							[
								150.74840771900006,
								-22.58029814699995
							],
							[
								150.75356290800005,
								-22.589469727999983
							],
							[
								150.74412301900009,
								-22.584909816999982
							],
							[
								150.74820302800003,
								-22.59146981699996
							],
							[
								150.74288307900008,
								-22.58782983699996
							],
							[
								150.74097324800005,
								-22.600559886999974
							],
							[
								150.75297309600012,
								-22.604579787999967
							],
							[
								150.74853320600005,
								-22.61010986699995
							],
							[
								150.74131784700012,
								-22.603818196999953
							],
							[
								150.74365340600002,
								-22.617259926999964
							],
							[
								150.7516477040001,
								-22.621578187999944
							],
							[
								150.74226790500006,
								-22.62501816699995
							],
							[
								150.74157779600012,
								-22.618478206999953
							],
							[
								150.7382795850001,
								-22.624069985999938
							],
							[
								150.74874150300002,
								-22.63359193699995
							],
							[
								150.7588592730001,
								-22.62669283799994
							],
							[
								150.74840355300012,
								-22.63588295699998
							],
							[
								150.73614761600004,
								-22.62355897599997
							],
							[
								150.7283139550001,
								-22.633106175999956
							],
							[
								150.7333089440001,
								-22.64138015599997
							],
							[
								150.7271158750001,
								-22.63379818599998
							],
							[
								150.70725969700004,
								-22.636183193999955
							],
							[
								150.69413415100007,
								-22.606360191999954
							],
							[
								150.7153298070001,
								-22.623429193999982
							],
							[
								150.71455797600004,
								-22.633352153999965
							],
							[
								150.7321806860001,
								-22.623415155999965
							],
							[
								150.71897879000005,
								-22.60018922499995
							],
							[
								150.72483306300012,
								-22.56313995499994
							],
							[
								150.71724307500006,
								-22.553620043999956
							],
							[
								150.69172789700008,
								-22.553569221999965
							],
							[
								150.68141387600008,
								-22.567830270999934
							],
							[
								150.68572393500006,
								-22.57767026099998
							],
							[
								150.67955879600004,
								-22.573439160999953
							],
							[
								150.67706394700008,
								-22.56532027999998
							],
							[
								150.6888734480001,
								-22.544650220999927
							],
							[
								150.6670535720001,
								-22.52253018899995
							],
							[
								150.66496347400005,
								-22.508870138999953
							],
							[
								150.67377789400007,
								-22.501029199999948
							],
							[
								150.6442733890001,
								-22.474270196999953
							],
							[
								150.67430784400005,
								-22.49471921999998
							],
							[
								150.6736630360001,
								-22.48232001899993
							],
							[
								150.6814229350001,
								-22.484739929999932
							],
							[
								150.67191293700012,
								-22.47284000899998
							],
							[
								150.67834284600008,
								-22.473219959999938
							],
							[
								150.68597798400003,
								-22.49242818099998
							],
							[
								150.6962027630001,
								-22.489569821999964
							],
							[
								150.69754293100004,
								-22.506039891999933
							],
							[
								150.72393779800007,
								-22.51858819399996
							],
							[
								150.73096208100003,
								-22.48504954499998
							],
							[
								150.7408869410001,
								-22.473368154999946
							],
							[
								150.74826173000008,
								-22.47748941599997
							],
							[
								150.7585214400001,
								-22.468859346999977
							],
							[
								150.74738569300007,
								-22.452998185999945
							],
							[
								150.75333125300006,
								-22.44627937599995
							],
							[
								150.71656181600008,
								-22.443809642999952
							],
							[
								150.69322204000002,
								-22.43058980099994
							],
							[
								150.6870558060001,
								-22.377098219999937
							],
							[
								150.6784658670001,
								-22.37467818899995
							],
							[
								150.68094139700008,
								-22.366249868999944
							],
							[
								150.66713594100008,
								-22.34652916799996
							],
							[
								150.6594515910001,
								-22.35224001699993
							],
							[
								150.66168171000004,
								-22.362060026999927
							],
							[
								150.6504719300001,
								-22.368980095999973
							],
							[
								150.67231203400002,
								-22.40248994899997
							],
							[
								150.66138243400007,
								-22.419450017999964
							],
							[
								150.66634281900008,
								-22.45409001799993
							],
							[
								150.65031286200008,
								-22.43899010699994
							],
							[
								150.65529697400007,
								-22.422099206999974
							],
							[
								150.62734326400005,
								-22.44166026499994
							],
							[
								150.64629271400008,
								-22.423970125999972
							],
							[
								150.62799296600008,
								-22.42103025499995
							],
							[
								150.65020799400008,
								-22.421509166999954
							],
							[
								150.65778671400005,
								-22.414229156999966
							],
							[
								150.6438767080001,
								-22.391249175999974
							],
							[
								150.6342869990001,
								-22.39152917499996
							],
							[
								150.63070265800002,
								-22.399400214999957
							],
							[
								150.6109428410001,
								-22.38888036299994
							],
							[
								150.61864273000003,
								-22.38963031399993
							],
							[
								150.61522264100006,
								-22.381830342999933
							],
							[
								150.62338262000003,
								-22.38842028399995
							],
							[
								150.64250686900004,
								-22.37962917599998
							],
							[
								150.617512185,
								-22.347680322999963
							],
							[
								150.64007203100005,
								-22.36395016499995
							],
							[
								150.64579694300005,
								-22.345489225999927
							],
							[
								150.62591703600003,
								-22.327659143999938
							],
							[
								150.60414223700002,
								-22.335080411999968
							],
							[
								150.56195262300002,
								-22.31675064799998
							],
							[
								150.53935353100007,
								-22.351880795999932
							],
							[
								150.52995901600002,
								-22.402409165999927
							],
							[
								150.54482418500004,
								-22.408880816999954
							],
							[
								150.54143870300004,
								-22.42267914699994
							],
							[
								150.55642432100012,
								-22.43057074799998
							],
							[
								150.53994902300008,
								-22.426949186999934
							],
							[
								150.53908970100008,
								-22.442949116999955
							],
							[
								150.5755542180001,
								-22.451000619999945
							],
							[
								150.5900289550001,
								-22.464049191999948
							],
							[
								150.53457998200008,
								-22.445169155999963
							],
							[
								150.533079831,
								-22.45000917599998
							],
							[
								150.55628977600009,
								-22.477009178999936
							],
							[
								150.58705898300002,
								-22.48578913199998
							],
							[
								150.59303425300004,
								-22.47579054199997
							],
							[
								150.5907143830001,
								-22.48447058199997
							],
							[
								150.60186422200002,
								-22.486130492999962
							],
							[
								150.5874089030001,
								-22.487489151999966
							],
							[
								150.60782430000006,
								-22.500830503999964
							],
							[
								150.574214664,
								-22.48210068999998
							],
							[
								150.5524650860001,
								-22.48398082799997
							],
							[
								150.56893979200004,
								-22.504719199999954
							],
							[
								150.56959533000008,
								-22.527170799999965
							],
							[
								150.58746521700004,
								-22.544160701999942
							],
							[
								150.58171530700008,
								-22.545400731999962
							],
							[
								150.58528540600003,
								-22.555230751999943
							],
							[
								150.59756524400007,
								-22.55942066299997
							],
							[
								150.58841976500003,
								-22.559079191999956
							],
							[
								150.5918098830001,
								-22.574769172999936
							],
							[
								150.57302589500011,
								-22.577250830999958
							],
							[
								150.56237088700004,
								-22.564309179999952
							],
							[
								150.55154100700008,
								-22.566479168999933
							],
							[
								150.5599408930001,
								-22.60339915999998
							],
							[
								150.54745066700002,
								-22.576030148999962
							],
							[
								150.5373717760001,
								-22.590170137999962
							],
							[
								150.54857173200003,
								-22.617080148999946
							],
							[
								150.5380319950001,
								-22.598400177999963
							],
							[
								150.529846936,
								-22.602291116999936
							],
							[
								150.5440663170001,
								-22.573540987999934
							],
							[
								150.5303966680001,
								-22.58133107699996
							],
							[
								150.53253082800006,
								-22.573110176999933
							],
							[
								150.51577178000002,
								-22.572420165999972
							],
							[
								150.5224919000001,
								-22.56751020599995
							],
							[
								150.51480664200005,
								-22.557431185999974
							],
							[
								150.5378763980001,
								-22.572371027999964
							],
							[
								150.5447761690001,
								-22.56137096799995
							],
							[
								150.50210077500003,
								-22.537940163999963
							],
							[
								150.4917863170001,
								-22.521411072999967
							],
							[
								150.48620638800003,
								-22.52137109299997
							],
							[
								150.48868651700002,
								-22.529161132999945
							],
							[
								150.50167668400002,
								-22.543471213999965
							],
							[
								150.49765190300002,
								-22.56022020399996
							],
							[
								150.49017181500005,
								-22.540210142999968
							],
							[
								150.48305686600008,
								-22.54297121299993
							],
							[
								150.48823672600008,
								-22.540301202999956
							],
							[
								150.48391177700012,
								-22.534300212999938
							],
							[
								150.45073200100012,
								-22.52266013999997
							],
							[
								150.4486771600001,
								-22.534721228999956
							],
							[
								150.43928188300004,
								-22.512430207999955
							],
							[
								150.43073186300012,
								-22.51725013799995
							],
							[
								150.43543200300007,
								-22.508900127999937
							],
							[
								150.42435195500002,
								-22.49889014699994
							],
							[
								150.40502739700003,
								-22.49830147499995
							],
							[
								150.40289736900002,
								-22.481261494999956
							],
							[
								150.38387281200005,
								-22.465430122999976
							],
							[
								150.33191294900007,
								-22.440310127999965
							],
							[
								150.32221274200003,
								-22.42681112699995
							],
							[
								150.3010339540001,
								-22.42133110499998
							],
							[
								150.30054291700003,
								-22.397651104999966
							],
							[
								150.29369281700008,
								-22.403121133999946
							],
							[
								150.21711473400012,
								-22.39391115799998
							],
							[
								150.20584491800003,
								-22.369081135999977
							],
							[
								150.177430371,
								-22.360482873999956
							],
							[
								150.17885011300007,
								-22.34088288399994
							],
							[
								150.19223970300004,
								-22.325232824999944
							],
							[
								150.1574101980001,
								-22.304953071999932
							],
							[
								150.15160480300005,
								-22.25981214099994
							],
							[
								150.11019038000006,
								-22.233023456999945
							],
							[
								150.0888002160001,
								-22.186963703999936
							],
							[
								150.0816229400001,
								-22.15191512399997
							],
							[
								150.0655749120001,
								-22.152913101999957
							],
							[
								150.0599909240001,
								-22.13192813099994
							],
							[
								150.05330992400002,
								-22.134958110999946
							],
							[
								150.04423493600007,
								-22.125450129999933
							],
							[
								150.03459477700005,
								-22.130063088999975
							],
							[
								150.0284758350001,
								-22.14566315899998
							],
							[
								149.99752139800012,
								-22.145614345999945
							],
							[
								149.98683682700005,
								-22.163603114999944
							],
							[
								149.9559425980001,
								-22.185304522999957
							],
							[
								149.93114395200007,
								-22.26428453099993
							],
							[
								149.91750433200002,
								-22.276084569999966
							],
							[
								149.91578456000002,
								-22.29516454999998
							],
							[
								149.922374568,
								-22.30506447099998
							],
							[
								149.91494487700004,
								-22.321224479999955
							],
							[
								149.9290759260001,
								-22.32351312199995
							],
							[
								149.92695009400006,
								-22.34474314099998
							],
							[
								149.91286514500007,
								-22.342674459999955
							],
							[
								149.97679542600008,
								-22.473373796999965
							],
							[
								149.9847556620001,
								-22.506963697999936
							],
							[
								150.0028455380001,
								-22.530103589999953
							],
							[
								150.01052593200006,
								-22.581963490999954
							],
							[
								150.04675601100007,
								-22.661053194999965
							],
							[
								150.01820636600007,
								-22.639623401999927
							],
							[
								150.00392093000005,
								-22.608692089999977
							],
							[
								149.9913765020001,
								-22.60181358899996
							],
							[
								149.99129635400004,
								-22.586693588999935
							],
							[
								149.96283643100003,
								-22.539443795999944
							],
							[
								149.88826734200006,
								-22.49274424899994
							],
							[
								149.86833199700004,
								-22.463593076999928
							],
							[
								149.84990180300008,
								-22.416163094999945
							],
							[
								149.8284817760001,
								-22.403833082999938
							],
							[
								149.81107749000012,
								-22.38205499199995
							],
							[
								149.78431594200003,
								-22.380310158999976
							],
							[
								149.77428556000007,
								-22.415907138999955
							],
							[
								149.75211016900005,
								-22.43637126699997
							],
							[
								149.74359917200002,
								-22.42142533599997
							],
							[
								149.74686402500004,
								-22.386984085999927
							],
							[
								149.7667029150001,
								-22.371334067999953
							],
							[
								149.73106402000008,
								-22.347764063999932
							],
							[
								149.71326381100005,
								-22.35662412299996
							],
							[
								149.71051379000005,
								-22.36972406299998
							],
							[
								149.68422405400008,
								-22.345084129999975
							],
							[
								149.66982480500008,
								-22.355735078999942
							],
							[
								149.65829003600004,
								-22.354875937999964
							],
							[
								149.65628983800002,
								-22.33603600799995
							],
							[
								149.62936511400005,
								-22.297165054999937
							],
							[
								149.59730033800008,
								-22.281456481999953
							],
							[
								149.60321016900002,
								-22.271626452999953
							],
							[
								149.5988050510001,
								-22.253905121999935
							],
							[
								149.57413499500012,
								-22.233195029999933
							],
							[
								149.56227480000007,
								-22.191456107999954
							],
							[
								149.55438504100005,
								-22.18730611799998
							],
							[
								149.56695480200005,
								-22.17192609899996
							],
							[
								149.55894480300003,
								-22.168216107999967
							],
							[
								149.5536650460001,
								-22.14046605699997
							],
							[
								149.5432351380001,
								-22.134166065999977
							],
							[
								149.54381402900003,
								-22.12343608599997
							],
							[
								149.5170593160001,
								-22.075307513999974
							],
							[
								149.52337864000003,
								-22.027097603999948
							],
							[
								149.49009410600002,
								-21.989487090999944
							],
							[
								149.4852629400001,
								-21.958487039999966
							],
							[
								149.46542296500002,
								-21.925667097999963
							],
							[
								149.45983288700006,
								-21.90402705699995
							],
							[
								149.46574299700012,
								-21.90252710799996
							],
							[
								149.4622830200001,
								-21.87591707699994
							],
							[
								149.47169199300004,
								-21.83850704799994
							],
							[
								149.46274314400011,
								-21.839017076999937
							],
							[
								149.45594308500006,
								-21.83008710599995
							],
							[
								149.46311212500007,
								-21.822197056999983
							],
							[
								149.45836190600005,
								-21.81748710599993
							],
							[
								149.4389730680001,
								-21.810387084999945
							],
							[
								149.4343128580001,
								-21.81808704399998
							],
							[
								149.43080215500004,
								-21.74588805299993
							],
							[
								149.42165747400009,
								-21.77167897299995
							],
							[
								149.425222146,
								-21.74342807299996
							],
							[
								149.43972187500003,
								-21.743458043999965
							],
							[
								149.45653206500003,
								-21.729928084999983
							],
							[
								149.44248200700008,
								-21.72358802399998
							],
							[
								149.43272201700006,
								-21.727028092999944
							],
							[
								149.4358320770001,
								-21.721928073999948
							],
							[
								149.45554097500008,
								-21.72632807499997
							],
							[
								149.47971102200006,
								-21.74287710799996
							],
							[
								149.4706412060001,
								-21.70839809599994
							],
							[
								149.44929100700006,
								-21.713158114999942
							],
							[
								149.45819094700005,
								-21.708018014999936
							],
							[
								149.45275098900004,
								-21.68830802499997
							],
							[
								149.44477085000005,
								-21.68790807399995
							],
							[
								149.45594095,
								-21.679608084999927
							],
							[
								149.44536091200007,
								-21.667698023999947
							],
							[
								149.44336111300004,
								-21.659478043999968
							],
							[
								149.44915100200012,
								-21.658648083999935
							],
							[
								149.4386508650001,
								-21.640878012999963
							],
							[
								149.45347997800002,
								-21.602878033999957
							],
							[
								149.47330013700002,
								-21.589328105999982
							],
							[
								149.477754709,
								-21.571599145999983
							],
							[
								149.4861945680001,
								-21.57063908699996
							],
							[
								149.48459912200008,
								-21.531698035999966
							],
							[
								149.468209053,
								-21.53485801499994
							],
							[
								149.45772008200004,
								-21.55308806399995
							],
							[
								149.47236468000006,
								-21.559549224999955
							],
							[
								149.45737986200004,
								-21.55579805399998
							],
							[
								149.46501482100007,
								-21.561179264999964
							],
							[
								149.45332989200006,
								-21.562698093999927
							],
							[
								149.45332989000008,
								-21.581658023999978
							],
							[
								149.44339999900012,
								-21.593348042999935
							],
							[
								149.44968989000006,
								-21.57818806399996
							],
							[
								149.43235561100005,
								-21.584279391999928
							],
							[
								149.43690548100005,
								-21.579859372999977
							],
							[
								149.4220256330001,
								-21.57508952099994
							],
							[
								149.44424537100008,
								-21.57755934299996
							],
							[
								149.43781999400005,
								-21.553768101999935
							],
							[
								149.4142400060001,
								-21.54623805999995
							],
							[
								149.40098568700012,
								-21.549809728999946
							],
							[
								149.40045092600008,
								-21.55894804899998
							],
							[
								149.40870105600004,
								-21.558738089999963
							],
							[
								149.40044577600008,
								-21.560429688999932
							],
							[
								149.3927858180001,
								-21.54997975799995
							],
							[
								149.3989956380001,
								-21.540579768999976
							],
							[
								149.37362602100006,
								-21.535069946999954
							],
							[
								149.39579525300007,
								-21.493089907999945
							],
							[
								149.35006615500004,
								-21.509360173999937
							],
							[
								149.35710116600012,
								-21.496219034999967
							],
							[
								149.33959598900003,
								-21.47454032299993
							],
							[
								149.33473615900004,
								-21.486530322999954
							],
							[
								149.3092211600001,
								-21.496699090999982
							],
							[
								149.32688095800006,
								-21.50507909199996
							],
							[
								149.30188222000004,
								-21.500569079999934
							],
							[
								149.29717195900002,
								-21.51129906999995
							],
							[
								149.2867319830001,
								-21.48721901899995
							],
							[
								149.27426194400005,
								-21.47768999799996
							],
							[
								149.29846114300005,
								-21.47079906999994
							],
							[
								149.28913101500007,
								-21.463059078999947
							],
							[
								149.298264968,
								-21.426391208999974
							],
							[
								149.31541306600002,
								-21.426258040999983
							],
							[
								149.32105107600012,
								-21.418936060999954
							],
							[
								149.33432207400006,
								-21.433417041999974
							],
							[
								149.33822997400011,
								-21.426909042999966
							],
							[
								149.33127008600002,
								-21.410249051999926
							],
							[
								149.2953709190001,
								-21.415730038999982
							],
							[
								149.28219095000009,
								-21.409590057999935
							],
							[
								149.28891107100003,
								-21.401660067999956
							],
							[
								149.2763661020001,
								-21.400710966999952
							],
							[
								149.28320112200004,
								-21.394680037999933
							],
							[
								149.27618112300001,
								-21.389080056999944
							],
							[
								149.28871091200006,
								-21.389350057999934
							],
							[
								149.30216123000002,
								-21.40001001899998
							],
							[
								149.30645100000004,
								-21.39141006999995
							],
							[
								149.31218795900008,
								-21.39657301999995
							],
							[
								149.31729996900003,
								-21.39270903099998
							],
							[
								149.3186099610001,
								-21.36955906099996
							],
							[
								149.31185658100003,
								-21.374236929999938
							],
							[
								149.3085800130001,
								-21.364659019999976
							],
							[
								149.31515005300002,
								-21.354459039999938
							],
							[
								149.29724001600005,
								-21.34065905899996
							],
							[
								149.30154993600001,
								-21.33511902899994
							],
							[
								149.29121003900002,
								-21.318009047999965
							],
							[
								149.29866994200006,
								-21.27327904799995
							],
							[
								149.274000214,
								-21.277580055999977
							],
							[
								149.25588001900007,
								-21.24470007399998
							],
							[
								149.22491100900004,
								-21.26370007199995
							],
							[
								149.193162249,
								-21.297920038999962
							],
							[
								149.2017410300001,
								-21.27768003999995
							],
							[
								149.18522408100011,
								-21.27787002799994
							],
							[
								149.18069706100005,
								-21.286812037999937
							],
							[
								149.17994195200004,
								-21.27788998799997
							],
							[
								149.19928115100004,
								-21.268100069999946
							],
							[
								149.21407606200012,
								-21.24152118099994
							],
							[
								149.20203208600003,
								-21.21311802899993
							],
							[
								149.19021309700008,
								-21.216387037999937
							],
							[
								149.1850010380001,
								-21.203480067999976
							],
							[
								149.17422708000004,
								-21.19830302699995
							],
							[
								149.14930006200007,
								-21.196291044999953
							],
							[
								149.1525903260001,
								-21.145550054999944
							],
							[
								149.1527830870001,
								-21.14381203499994
							],
							[
								149.09522011100012,
								-21.14814002999998
							],
							[
								149.0582300950001,
								-21.13933402699996
							],
							[
								148.9664090230001,
								-21.134023578999972
							],
							[
								148.96755812300012,
								-21.12533900899996
							],
							[
								148.95205310500012,
								-21.124827017999962
							],
							[
								148.9532761160001,
								-21.113144017999957
							],
							[
								148.9295720980001,
								-21.10517802499993
							],
							[
								148.92327611000007,
								-21.092876024999953
							],
							[
								148.90441313200006,
								-21.090428002999943
							],
							[
								148.90322910300006,
								-21.075750012999947
							],
							[
								148.8804251150001,
								-21.076616010999942
							],
							[
								148.87838611600012,
								-21.070981010999958
							],
							[
								148.86276911700008,
								-21.06906301999993
							],
							[
								148.86080972600007,
								-21.082954649999976
							],
							[
								148.82956801900002,
								-21.07752391699995
							],
							[
								148.8233271790001,
								-21.08599293599997
							],
							[
								148.81278814000007,
								-21.084718015999954
							],
							[
								148.81595415100003,
								-21.070004995999966
							],
							[
								148.80747739100002,
								-21.068964094999956
							],
							[
								148.78187848400012,
								-21.06644528299995
							],
							[
								148.78044457300007,
								-21.077475252999932
							],
							[
								148.75761514600003,
								-21.067813000999934
							],
							[
								148.75352414500003,
								-21.080263000999935
							],
							[
								148.7389881360001,
								-21.07912099899994
							],
							[
								148.73116512800004,
								-21.069125998999937
							],
							[
								148.71071213900007,
								-21.07121200699993
							],
							[
								148.7112471490001,
								-21.066671996999958
							],
							[
								148.58065914100007,
								-21.059243985999956
							],
							[
								148.5841601520001,
								-21.045771995999928
							],
							[
								148.60233916100003,
								-21.03143998799993
							],
							[
								148.59789141300007,
								-21.015486866999936
							],
							[
								148.62339717200007,
								-21.003652768999928
							],
							[
								148.62651712000002,
								-21.023803639999983
							],
							[
								148.63745342900006,
								-21.024407939999946
							],
							[
								148.6430559700001,
								-21.00816858099995
							],
							[
								148.63630182500003,
								-20.968196759999955
							],
							[
								148.6410117160001,
								-20.953538769999966
							],
							[
								148.62259815800007,
								-20.947349978999966
							],
							[
								148.61354715000004,
								-20.924889977999953
							],
							[
								148.60043416200006,
								-20.917962986999953
							],
							[
								148.5936451660001,
								-20.879004985999927
							],
							[
								148.59788215700007,
								-20.869628975999944
							],
							[
								148.58830317900004,
								-20.85093199499994
							],
							[
								148.57055319200003,
								-20.834975982999936
							],
							[
								148.56226616300012,
								-20.839155982999955
							],
							[
								148.52927516700004,
								-20.819968979999942
							],
							[
								148.51723053000012,
								-20.795427618999952
							],
							[
								148.50813418000007,
								-20.80517097799998
							],
							[
								148.48490117200004,
								-20.80361397599995
							],
							[
								148.46296919700012,
								-20.771833973999946
							],
							[
								148.46848617700005,
								-20.758842973999947
							],
							[
								148.4570121800001,
								-20.737064982999982
							],
							[
								148.36111621100008,
								-20.807415955999943
							],
							[
								148.30126318700002,
								-20.800643950999927
							],
							[
								148.3030321980001,
								-20.787203960999932
							],
							[
								148.16169220100005,
								-20.769573949999938
							],
							[
								148.15695519200005,
								-20.75866394899998
							],
							[
								148.13993820400003,
								-20.748586957999976
							],
							[
								148.1492832240001,
								-20.741280957999948
							],
							[
								148.1472442270001,
								-20.71612794799995
							],
							[
								148.13143123100008,
								-20.681360955999935
							],
							[
								148.1347002010001,
								-20.67412695699994
							],
							[
								148.1242572330001,
								-20.663383945999954
							],
							[
								148.1325992410001,
								-20.575778955999965
							],
							[
								148.12174523200008,
								-20.568061934999946
							],
							[
								148.11330424200003,
								-20.57269095399994
							],
							[
								148.09689424400005,
								-20.565925942999968
							],
							[
								148.09540023600005,
								-20.54538894199993
							],
							[
								148.07476623800005,
								-20.540444950999927
							],
							[
								148.075949239,
								-20.53242794099998
							],
							[
								148.05358423300004,
								-20.506403948999946
							],
							[
								148.03941022300012,
								-20.519823937999945
							],
							[
								148.020182244,
								-20.523000945999968
							],
							[
								148.0110502330001,
								-20.543139935999932
							],
							[
								147.98283843600007,
								-20.533807432999936
							],
							[
								147.98251367000012,
								-20.494336412999928
							],
							[
								147.96363488100008,
								-20.492353820999938
							],
							[
								147.94605944400007,
								-20.473578909999958
							],
							[
								147.94030583500012,
								-20.476783628999954
							],
							[
								147.9318329460001,
								-20.469384128999934
							],
							[
								147.93567738700006,
								-20.456948068999964
							],
							[
								147.92256994800005,
								-20.45356438799996
							],
							[
								147.90350395200005,
								-20.420982205999962
							],
							[
								147.89123765300008,
								-20.428059304999977
							],
							[
								147.8644543570001,
								-20.39925705299993
							],
							[
								147.85825935700007,
								-20.40996191199997
							],
							[
								147.84853375800003,
								-20.41053414099997
							],
							[
								147.84367377500007,
								-20.444936980999955
							],
							[
								147.82626524500006,
								-20.459354909999945
							],
							[
								147.77604606900002,
								-20.45444854599998
							],
							[
								147.77736675000006,
								-20.442389395999953
							],
							[
								147.74248228300007,
								-20.438976912999976
							],
							[
								147.7422882840001,
								-20.426879912999937
							],
							[
								147.6823811700001,
								-20.420935417999942
							],
							[
								147.68623028100012,
								-20.40284590899995
							],
							[
								147.64164998900003,
								-20.34941241499996
							],
							[
								147.66144276800003,
								-20.34274527599996
							],
							[
								147.67016791000003,
								-20.316553876999933
							],
							[
								147.66271658100004,
								-20.30696246599996
							],
							[
								147.6546022020001,
								-20.30966140499993
							],
							[
								147.64370169300003,
								-20.300507123999978
							],
							[
								147.60938596500011,
								-20.308009631999937
							],
							[
								147.59498061400006,
								-20.330412320999983
							],
							[
								147.57124569600012,
								-20.330936178999934
							],
							[
								147.55154598700005,
								-20.342289706999964
							],
							[
								147.54807899600007,
								-20.35659987699995
							],
							[
								147.55750497400004,
								-20.364688507999972
							],
							[
								147.54951300400012,
								-20.379314087999944
							],
							[
								147.44935139200004,
								-20.369363539999938
							],
							[
								147.45048961400005,
								-20.34877991999997
							],
							[
								147.4343897970001,
								-20.332936837999966
							],
							[
								147.37928191100002,
								-20.329622123999968
							],
							[
								147.3722562810001,
								-20.340915863999953
							],
							[
								147.34424191300002,
								-20.33791699099993
							],
							[
								147.34472430100004,
								-20.36334489199993
							],
							[
								147.33252030000006,
								-20.382438880999928
							],
							[
								147.3472322880001,
								-20.393786881999972
							],
							[
								147.34366232600007,
								-20.41817088199997
							],
							[
								147.33881932600002,
								-20.426905871999963
							],
							[
								147.29782631700004,
								-20.447417878999943
							],
							[
								147.2906053050001,
								-20.476370877999955
							],
							[
								147.30104131200005,
								-20.503785878999963
							],
							[
								147.28482330200006,
								-20.524569867999958
							],
							[
								147.27687227900003,
								-20.556221867999966
							],
							[
								147.2640633000001,
								-20.55980787699997
							],
							[
								147.2413832300001,
								-20.584437864999927
							],
							[
								147.2145593030001,
								-20.576726872999927
							],
							[
								147.20955128200012,
								-20.587098882999953
							],
							[
								147.17969030300003,
								-20.604660880999973
							],
							[
								147.17802214200003,
								-20.618580890999965
							],
							[
								147.15612120100002,
								-20.651713848999975
							],
							[
								147.11177749600006,
								-20.635852005999936
							],
							[
								147.07889110700012,
								-20.652835683999967
							],
							[
								147.0621791100001,
								-20.627108651999947
							],
							[
								147.0363288320001,
								-20.629303679999964
							],
							[
								147.01482303600005,
								-20.606217587999936
							],
							[
								146.97600991800005,
								-20.61968225499993
							],
							[
								146.97263600700012,
								-20.63286725499995
							],
							[
								146.98597791300006,
								-20.662447076999968
							],
							[
								146.96130662300004,
								-20.68439513499993
							],
							[
								146.96120470900007,
								-20.74018336499995
							],
							[
								146.92041709000011,
								-20.757392711999955
							],
							[
								146.90990030900002,
								-20.786706871999968
							],
							[
								146.87460463000002,
								-20.80174360899997
							],
							[
								146.86160132200007,
								-20.796466427999974
							],
							[
								146.8522319110001,
								-20.81131563799994
							],
							[
								146.86281289700003,
								-20.84728797899993
							],
							[
								146.856039806,
								-20.87017666899993
							],
							[
								146.86595981400012,
								-20.885965048999935
							],
							[
								146.85346838200007,
								-20.919189348999964
							],
							[
								146.88367759300002,
								-20.99759962199994
							],
							[
								146.86036001200011,
								-21.03117698999995
							],
							[
								146.8616759790001,
								-21.062220820999983
							],
							[
								146.848814467,
								-21.10093132999998
							],
							[
								146.882615288,
								-21.170278862999965
							],
							[
								146.86599829800002,
								-21.191191851999974
							],
							[
								146.8908858530001,
								-21.221805703999962
							],
							[
								146.94972596700006,
								-21.239565178999953
							],
							[
								146.96051426500003,
								-21.252084869999976
							],
							[
								146.9661332920001,
								-21.278731859999937
							],
							[
								146.95932327100002,
								-21.300400859999968
							],
							[
								146.91783525200003,
								-21.325440856999933
							],
							[
								146.90463827100007,
								-21.35030885599997
							],
							[
								146.87852325100005,
								-21.369613863999973
							],
							[
								146.87488927900006,
								-21.39700085399994
							],
							[
								146.89844626400009,
								-21.43474585599995
							],
							[
								146.9097512630001,
								-21.441130846999954
							],
							[
								146.9118252610001,
								-21.45383285799994
							],
							[
								146.8666602300001,
								-21.509852854999963
							],
							[
								146.87007925800003,
								-21.526659864999942
							],
							[
								146.83473123700003,
								-21.57439186299996
							],
							[
								146.83389125100007,
								-21.64321086299998
							],
							[
								146.75606227900005,
								-21.636683726999934
							],
							[
								146.6510312700001,
								-21.609260828999936
							],
							[
								146.65672567100012,
								-21.582532108999942
							],
							[
								146.4923142870001,
								-21.566465826999945
							],
							[
								146.48389624800006,
								-21.68027882699994
							],
							[
								146.44665829200005,
								-21.66808210499994
							],
							[
								146.39597928700005,
								-21.66317682099998
							],
							[
								146.34071526900004,
								-21.57010481599997
							],
							[
								146.34670230300003,
								-21.518109805999927
							],
							[
								146.15051832100005,
								-21.500043801999936
							],
							[
								146.1323002910001,
								-21.514017799999976
							],
							[
								146.09344531500005,
								-21.50992779799998
							],
							[
								146.0691944020001,
								-21.808795347999933
							],
							[
								146.12672529700012,
								-21.81355180199995
							],
							[
								146.11845946000005,
								-21.90083974299995
							],
							[
								146.21138656200003,
								-21.90848159899997
							],
							[
								146.20139117400004,
								-22.007570958999963
							],
							[
								146.07207555600007,
								-21.997225879999974
							],
							[
								146.06699697400006,
								-22.026519099999973
							],
							[
								146.03948627700004,
								-22.023336797999946
							],
							[
								146.03146229100003,
								-22.104800787999977
							],
							[
								146.07406256600007,
								-22.123363620999953
							],
							[
								146.0645920510001,
								-22.18574819099996
							],
							[
								146.07067126700008,
								-22.226608811999938
							],
							[
								146.0521392600001,
								-22.338488800999983
							],
							[
								146.12207825300004,
								-22.347408795999968
							],
							[
								146.10892773600006,
								-22.445650215999933
							],
							[
								146.27555522000011,
								-22.46272881899995
							],
							[
								146.26930670600007,
								-22.508633218999933
							],
							[
								146.29695220500003,
								-22.49572281999997
							],
							[
								146.32959923200008,
								-22.49480882299997
							],
							[
								146.38298018500006,
								-22.52087582699994
							],
							[
								146.4286022240001,
								-22.48792882999993
							],
							[
								146.45178122100003,
								-22.49929984199997
							],
							[
								146.4393312080001,
								-22.54885183099998
							],
							[
								146.42416720900007,
								-22.547370829999977
							],
							[
								146.40143616300008,
								-22.75549082999993
							],
							[
								146.54840317900005,
								-22.768876830999943
							],
							[
								146.5484271580001,
								-22.77822884099993
							],
							[
								146.52873617900002,
								-22.792797829999927
							],
							[
								146.52478216800012,
								-22.804032849999942
							],
							[
								146.56014313900005,
								-22.878430842999933
							],
							[
								146.57843617600008,
								-22.889543843999945
							],
							[
								146.6108581740001,
								-22.88115483699994
							],
							[
								146.62355017200002,
								-22.886574837999945
							],
							[
								146.646070161,
								-22.883194858999957
							],
							[
								146.664314127,
								-22.906527850999964
							],
							[
								146.66509814500012,
								-22.925149860999966
							],
							[
								146.684240132,
								-22.94575285299993
							],
							[
								146.70228411900007,
								-22.96220686399994
							],
							[
								146.7327821350001,
								-22.970150856999965
							],
							[
								146.75288811200005,
								-22.984248857999944
							],
							[
								146.78756913400002,
								-23.03713486099997
							],
							[
								146.7822191030001,
								-23.053729860999965
							],
							[
								146.78654914100002,
								-23.079223860999946
							],
							[
								146.77887713000007,
								-23.09066685099998
							],
							[
								146.78906211600008,
								-23.12729987199998
							],
							[
								146.81453010200005,
								-23.153612863999967
							],
							[
								146.86417611500008,
								-23.174907867999934
							],
							[
								146.8747120920001,
								-23.19564087899994
							],
							[
								146.87222111100004,
								-23.210708868999973
							],
							[
								146.88446711900008,
								-23.220260879999955
							],
							[
								146.877704106,
								-23.269215879999933
							],
							[
								146.85486809600002,
								-23.29376187799994
							],
							[
								146.85458310500007,
								-23.30473287799998
							],
							[
								146.93271207700002,
								-23.315469873999973
							],
							[
								146.9397300810001,
								-23.260341874999938
							],
							[
								146.9763120870001,
								-23.26326287699993
							],
							[
								147.07906410600003,
								-23.279820774999962
							],
							[
								147.07486105400005,
								-23.306902884999943
							],
							[
								147.15870205500005,
								-23.326242891999982
							],
							[
								147.1618890530001,
								-23.339696901999957
							],
							[
								147.28662173100008,
								-23.351222871999937
							],
							[
								147.2831218230001,
								-23.33069429099993
							],
							[
								147.29510506300005,
								-23.322391901999936
							],
							[
								147.28004907600007,
								-23.298904910999966
							],
							[
								147.28752405700004,
								-23.27908690099997
							],
							[
								147.2737530490001,
								-23.27076089999997
							],
							[
								147.26076507300002,
								-23.244639898999935
							],
							[
								147.26075707600012,
								-23.21011889899995
							],
							[
								147.28654305500004,
								-23.193355899999972
							],
							[
								147.315016043,
								-23.193135902999927
							],
							[
								147.33992506100003,
								-23.18255090499997
							],
							[
								147.35396405900008,
								-23.19037590599993
							],
							[
								147.39458004900007,
								-23.14731289799994
							],
							[
								147.44151007800008,
								-23.119753921999973
							],
							[
								147.46415605800007,
								-23.092209912999976
							],
							[
								147.47853005700006,
								-23.09145091499994
							],
							[
								147.48746003700012,
								-23.078639904999932
							],
							[
								147.48372806100008,
								-23.046647914999937
							],
							[
								147.5084030800001,
								-23.02906991599997
							],
							[
								147.51999707900006,
								-23.02841390699996
							],
							[
								147.49706505400002,
								-23.00088191499998
							],
							[
								147.50416408400008,
								-22.98574791599998
							],
							[
								147.55304104800007,
								-23.009155909999947
							],
							[
								147.5534870790001,
								-22.992648919999965
							],
							[
								147.56099785900005,
								-22.98745279999997
							],
							[
								147.55541606000008,
								-22.97634819999996
							],
							[
								147.56824804100006,
								-22.96167892099993
							],
							[
								147.5822920390001,
								-22.962997911999935
							],
							[
								147.5878640530001,
								-22.92226992199994
							],
							[
								147.5967890720001,
								-22.92343293199997
							],
							[
								147.59898805300008,
								-22.90900093199997
							],
							[
								147.606365062,
								-22.907095932999937
							],
							[
								147.60158207400002,
								-22.894788912999957
							],
							[
								147.61795805200006,
								-22.893873923999934
							],
							[
								147.6206500710001,
								-22.912092923999978
							],
							[
								147.64051307700004,
								-22.926273915999957
							],
							[
								147.66104705600003,
								-22.92105292699995
							],
							[
								147.66386803700004,
								-22.912708927999972
							],
							[
								147.6943390340001,
								-22.914679939999928
							],
							[
								147.70277904600005,
								-22.885801939999965
							],
							[
								147.755001084,
								-22.856085923999956
							],
							[
								147.79407627500007,
								-22.800490026999967
							],
							[
								147.820961075,
								-22.782913938999968
							],
							[
								147.84513104200005,
								-22.785052940999947
							],
							[
								147.87381205100007,
								-22.765643952999937
							],
							[
								147.89512144000003,
								-22.76171978499997
							],
							[
								147.91475903100002,
								-22.73270498599993
							],
							[
								147.91278405200012,
								-22.718737945999976
							],
							[
								147.931477781,
								-22.71818077699993
							],
							[
								147.97095387900004,
								-22.70236361999997
							],
							[
								147.98526107700002,
								-22.704451950999953
							],
							[
								147.99554604800005,
								-22.68963395199995
							],
							[
								147.99521013900005,
								-22.674032661999945
							],
							[
								148.0130932400001,
								-22.65424114299998
							],
							[
								148.02301002500008,
								-22.693102943999975
							],
							[
								148.04781634200003,
								-22.697456295999928
							],
							[
								148.06076654000003,
								-22.70985967799993
							],
							[
								148.06394447700006,
								-22.739481787999978
							],
							[
								148.10967802000005,
								-22.767018961999952
							],
							[
								148.14351402800003,
								-22.764840964999962
							],
							[
								148.14926402600008,
								-22.77931195499997
							],
							[
								148.1761490020001,
								-22.79032696699994
							],
							[
								148.23084099900007,
								-22.777384971999936
							],
							[
								148.23907303200008,
								-22.739751971999965
							],
							[
								148.34314102400003,
								-22.725404990999948
							],
							[
								148.37383101700004,
								-22.767262982999966
							],
							[
								148.37141500500002,
								-22.790542992999974
							],
							[
								148.35709200500003,
								-22.808281971999975
							],
							[
								148.338490986,
								-22.811448990999963
							],
							[
								148.3263929850001,
								-22.83271297999994
							],
							[
								148.2750600060001,
								-22.875584965999963
							],
							[
								148.2904289920001,
								-22.89959297799993
							],
							[
								148.28867199100011,
								-22.907945987999938
							],
							[
								148.29772877000005,
								-22.90948261799997
							],
							[
								148.32505799400008,
								-22.949821980999957
							],
							[
								148.4580749700001,
								-22.867476990999933
							],
							[
								148.5419059720001,
								-22.87729000799993
							],
							[
								148.5401719670001,
								-22.923373007999942
							],
							[
								148.5526959550001,
								-22.941806998999937
							],
							[
								148.54258899400008,
								-22.959401318999937
							],
							[
								148.55030899300004,
								-22.957221998999955
							],
							[
								148.55444897100006,
								-22.974655009999935
							],
							[
								148.5809519490001,
								-22.971671001999937
							],
							[
								148.58496997600002,
								-23.00053599299997
							],
							[
								148.5997129750001,
								-23.002843003999942
							],
							[
								148.58783397900004,
								-23.071455002999983
							],
							[
								148.5622749570001,
								-23.115882991999968
							],
							[
								148.57919496500006,
								-23.11751800299993
							],
							[
								148.62442995800006,
								-23.148967006999953
							],
							[
								148.56522892600003,
								-23.22194299299997
							],
							[
								148.582504964,
								-23.233925003999957
							],
							[
								148.51216792500009,
								-23.28901000899998
							],
							[
								148.502673952,
								-23.330313988999933
							],
							[
								148.55034892600008,
								-23.346816992999948
							],
							[
								148.5704929410001,
								-23.379282004999936
							],
							[
								148.55038995000007,
								-23.406903002999968
							],
							[
								148.57298391200004,
								-23.468946004999964
							],
							[
								148.52268293300006,
								-23.505365791999964
							],
							[
								148.52282495000009,
								-23.53797400199994
							],
							[
								148.53194691700003,
								-23.554869992999954
							],
							[
								148.57198993400004,
								-23.551843005999956
							],
							[
								148.5811919150001,
								-23.531057996999948
							],
							[
								148.5925909030001,
								-23.543297007999968
							],
							[
								148.61867489100007,
								-23.535814999999957
							],
							[
								148.6341539220001,
								-23.509694020999973
							],
							[
								148.63501791500005,
								-23.476587010999936
							],
							[
								148.65424790400004,
								-23.476066011999933
							],
							[
								148.67852091400005,
								-23.449358013999927
							],
							[
								148.70554391300004,
								-23.435312015999955
							],
							[
								148.6723609270001,
								-23.421080022999945
							],
							[
								148.68152494800006,
								-23.404721003999953
							],
							[
								148.712477927,
								-23.386403015999974
							],
							[
								148.70457795000004,
								-23.365822024999943
							],
							[
								148.71345493,
								-23.35262301599994
							],
							[
								148.73605393900004,
								-23.347876027999973
							],
							[
								148.74753792500007,
								-23.37909701899997
							],
							[
								148.75857092400008,
								-23.381177029999947
							],
							[
								148.77544093300003,
								-23.373946020999938
							],
							[
								148.7806639040001,
								-23.35114102199998
							],
							[
								148.7968399030001,
								-23.352385012999946
							],
							[
								148.79965292200006,
								-23.362356012999953
							],
							[
								148.825668908,
								-23.37948102599995
							],
							[
								148.86565089600003,
								-23.356075028999953
							],
							[
								148.8689879100001,
								-23.319128038999963
							],
							[
								148.84530390500004,
								-23.28933002699995
							],
							[
								148.85577590600008,
								-23.265916016999938
							],
							[
								148.873417925,
								-23.26048303899995
							],
							[
								148.87915992600006,
								-23.247794028999976
							],
							[
								148.89803794300008,
								-23.261434030999965
							],
							[
								148.9250949100001,
								-23.261943042999974
							],
							[
								148.92568092200008,
								-23.245601032999957
							],
							[
								148.9481079100001,
								-23.240547034999963
							],
							[
								148.953397923,
								-23.207795044999955
							],
							[
								148.97044791200005,
								-23.20451303599998
							],
							[
								148.966681923,
								-23.197120045999952
							],
							[
								148.9746558920001,
								-23.192805026999963
							],
							[
								148.98544690100005,
								-23.194496037999954
							],
							[
								149.00633990200004,
								-23.166682028999958
							],
							[
								149.00574491400005,
								-23.15020703899995
							],
							[
								148.98731091600007,
								-23.14376804699998
							],
							[
								148.99055390700005,
								-23.129696036999974
							],
							[
								148.97352289900005,
								-23.125074035999944
							],
							[
								148.97616193200008,
								-23.094529035999983
							],
							[
								149.02536789900012,
								-23.08140304999995
							],
							[
								149.04429990900007,
								-23.058834050999963
							],
							[
								149.11143092400005,
								-23.056033036999963
							],
							[
								149.1251089320001,
								-23.062696037999956
							],
							[
								149.17986191800003,
								-23.048225052999953
							],
							[
								149.19921392600008,
								-23.049901053999974
							],
							[
								149.22908891800012,
								-23.00298605699993
							],
							[
								149.23717790000012,
								-22.975981056999956
							],
							[
								149.28725290800003,
								-22.95596705099996
							],
							[
								149.28542590000006,
								-22.941754060999983
							],
							[
								149.30389292900009,
								-22.925797071999966
							],
							[
								149.31252788100005,
								-22.906364062999955
							],
							[
								149.33024290000003,
								-22.89861805399994
							],
							[
								149.3318198920001,
								-22.87513006399996
							],
							[
								149.36551792900002,
								-22.876794076999943
							],
							[
								149.38113492600007,
								-22.894868078999934
							],
							[
								149.4034279130001,
								-22.897783070999935
							],
							[
								149.4144958810001,
								-22.916559071999927
							],
							[
								149.4220569260001,
								-22.95724506299996
							],
							[
								149.41225890300007,
								-22.993693081999936
							],
							[
								149.427468921,
								-23.004379073999928
							],
							[
								149.4281988790001,
								-23.018553063999946
							],
							[
								149.43940288700003,
								-23.03073907499993
							],
							[
								149.48579288000008,
								-23.057800078999946
							],
							[
								149.49153388600007,
								-23.09092107999993
							],
							[
								149.4782358760001,
								-23.108188088999952
							],
							[
								149.50192788200002,
								-23.123897090999947
							],
							[
								149.61704387500004,
								-23.09341010099996
							],
							[
								149.6369218850001,
								-23.074248091999948
							],
							[
								149.67263289100003,
								-23.08204814499993
							],
							[
								149.69736047000004,
								-23.071172416999957
							],
							[
								149.72701011900006,
								-23.05717420999997
							],
							[
								149.7196101410001,
								-23.04152431899996
							],
							[
								149.7312300320001,
								-23.025884239999982
							],
							[
								149.77846952900006,
								-23.014483893999966
							],
							[
								149.82319910800004,
								-22.980923787999927
							],
							[
								149.83564900500005,
								-22.99911366899994
							],
							[
								149.8466288940001,
								-22.998423659999958
							],
							[
								149.85064882500012,
								-22.986783659999958
							],
							[
								149.8662886730001,
								-22.994043561999945
							],
							[
								149.8796685520001,
								-22.988223482999956
							],
							[
								149.9012783400001,
								-22.996253354999965
							],
							[
								149.9102182480001,
								-23.008113205999962
							],
							[
								149.92851806600004,
								-23.01049306699997
							],
							[
								149.932562952,
								-23.03927079799996
							],
							[
								149.925479031,
								-23.056814716999952
							],
							[
								149.99580832200002,
								-23.087175163999973
							],
							[
								150.02413104100003,
								-23.073416055999928
							],
							[
								150.0330669330001,
								-23.044422096999938
							],
							[
								150.06478861100004,
								-23.035031018999973
							],
							[
								150.07815344900007,
								-23.04757781099994
							],
							[
								150.06717960600008,
								-23.08529771999997
							],
							[
								150.13492987900008,
								-23.09626206599995
							],
							[
								150.134052966,
								-23.12228495599993
							],
							[
								150.16242167100006,
								-23.145615628999963
							],
							[
								150.21584395000002,
								-23.10824280299994
							],
							[
								150.250271547,
								-23.11255476699995
							],
							[
								150.29772417000004,
								-23.137939950999964
							],
							[
								150.36760293300006,
								-23.14683958699993
							],
							[
								150.3832117620001,
								-23.142064318999928
							],
							[
								150.39312927900005,
								-23.15810614999998
							],
							[
								150.38243550900006,
								-23.16883194899998
							],
							[
								150.38456995800004,
								-23.18049075899995
							],
							[
								150.40156679500012,
								-23.191749150999954
							],
							[
								150.34416905500007,
								-23.237930495999933
							],
							[
								150.34212125500005,
								-23.246109495999974
							],
							[
								150.36631849000003,
								-23.266540917999976
							],
							[
								150.39710044000003,
								-23.241006610999932
							],
							[
								150.42130339800008,
								-23.244923462999964
							],
							[
								150.4352999020001,
								-23.289226604999953
							],
							[
								150.45233466700006,
								-23.315436555999952
							],
							[
								150.44764970500012,
								-23.33748348599994
							],
							[
								150.45932802400011,
								-23.338551456999937
							],
							[
								150.47882833500012,
								-23.31727456899995
							],
							[
								150.49389411100003,
								-23.340697509999927
							],
							[
								150.49321812900007,
								-23.35855442999997
							],
							[
								150.46713763900004,
								-23.37866583799996
							],
							[
								150.4493686300001,
								-23.384489176999978
							],
							[
								150.43529978300012,
								-23.371728144999963
							],
							[
								150.42942095000012,
								-23.40813318499994
							],
							[
								150.44749128800004,
								-23.40911009699994
							],
							[
								150.46756650400005,
								-23.426778118999948
							],
							[
								150.50683174000005,
								-23.432659161999936
							],
							[
								150.51971076900008,
								-23.42844758299998
							],
							[
								150.54123824600003,
								-23.446757514999945
							],
							[
								150.5477740760001,
								-23.436502765999933
							],
							[
								150.5304559320001,
								-23.39345540399995
							],
							[
								150.55191625200007,
								-23.377609365999945
							],
							[
								150.60472674000005,
								-23.44590317099994
							],
							[
								150.62445972700004,
								-23.455771182999968
							],
							[
								150.6350837430001,
								-23.484545183999955
							],
							[
								150.6617517400001,
								-23.491224186999943
							],
							[
								150.66047470900003,
								-23.49758518699997
							],
							[
								150.63786373000005,
								-23.507431184999973
							],
							[
								150.63797271900012,
								-23.516865184999972
							],
							[
								150.64952372800008,
								-23.517821185999935
							],
							[
								150.68111874700003,
								-23.498064188999933
							],
							[
								150.70575470400001,
								-23.505829200999983
							],
							[
								150.7269747140001,
								-23.491394182999954
							],
							[
								150.77284272800011,
								-23.506615196999974
							],
							[
								150.79064570700007,
								-23.505957208999973
							]
						]
					],
					[
						[
							[
								149.75643392100005,
								-22.41301406699995
							],
							[
								149.7634386420001,
								-22.405665237999983
							],
							[
								149.7567387030001,
								-22.400275286999943
							],
							[
								149.75643392100005,
								-22.41301406699995
							]
						]
					],
					[
						[
							[
								149.87932482700012,
								-22.252324856999962
							],
							[
								149.89289877600004,
								-22.25146308799998
							],
							[
								149.88056458900007,
								-22.234264896999946
							],
							[
								149.8745247590001,
								-22.238124915999947
							],
							[
								149.87932482700012,
								-22.252324856999962
							]
						]
					],
					[
						[
							[
								149.89151889700008,
								-22.242783127999928
							],
							[
								149.90069426700006,
								-22.23598476799998
							],
							[
								149.88894885800005,
								-22.236703086999967
							],
							[
								149.89151889700008,
								-22.242783127999928
							]
						]
					],
					[
						[
							[
								149.91966346900006,
								-22.20047471999993
							],
							[
								149.93171309900004,
								-22.187334670999974
							],
							[
								149.926567771,
								-22.174813149999977
							],
							[
								149.91966346900006,
								-22.20047471999993
							]
						]
					],
					[
						[
							[
								149.93012783200004,
								-22.160473099999933
							],
							[
								149.93536799100002,
								-22.166203120999967
							],
							[
								149.93107786300004,
								-22.15584311999993
							],
							[
								149.93012783200004,
								-22.160473099999933
							]
						]
					],
					[
						[
							[
								149.91390390700008,
								-22.22974469899998
							],
							[
								149.8980888960001,
								-22.24636315799995
							],
							[
								149.89863895500002,
								-22.260243137999964
							],
							[
								149.91132423400006,
								-22.25354466899995
							],
							[
								149.91390390700008,
								-22.22974469899998
							]
						]
					],
					[
						[
							[
								149.87996000600003,
								-22.25919308699997
							],
							[
								149.89319001500007,
								-22.262293157999977
							],
							[
								149.89486003600007,
								-22.25630311799995
							],
							[
								149.87812003700003,
								-22.254234095999948
							],
							[
								149.87996000600003,
								-22.25919308699997
							]
						]
					],
					[
						[
							[
								149.75794864300008,
								-22.398575266999956
							],
							[
								149.76725840300003,
								-22.391095227999983
							],
							[
								149.75756396400004,
								-22.391794146999928
							],
							[
								149.75794864300008,
								-22.398575266999956
							]
						]
					],
					[
						[
							[
								149.90762205200008,
								-22.477863130999935
							],
							[
								149.90854667300005,
								-22.469524200999956
							],
							[
								149.8984267940001,
								-22.46245425999996
							],
							[
								149.90762205200008,
								-22.477863130999935
							]
						]
					],
					[
						[
							[
								150.25161891400012,
								-22.364772399999936
							],
							[
								150.26468872200007,
								-22.369792321999967
							],
							[
								150.2723583940001,
								-22.352332261999948
							],
							[
								150.28124818300012,
								-22.34892221299998
							],
							[
								150.27313832400012,
								-22.347152261999952
							],
							[
								150.25161891400012,
								-22.364772399999936
							]
						]
					],
					[
						[
							[
								150.42147986700002,
								-22.294500144999972
							],
							[
								150.421675036,
								-22.299361414999964
							],
							[
								150.4298947970001,
								-22.288381345999937
							],
							[
								150.43137461800006,
								-22.271821355999975
							],
							[
								150.44098896800006,
								-22.26794016699995
							],
							[
								150.44396871700008,
								-22.274050176999936
							],
							[
								150.44609885800003,
								-22.266170116999945
							],
							[
								150.46337883700005,
								-22.25920016899994
							],
							[
								150.4547439590001,
								-22.247311237999952
							],
							[
								150.46540885800005,
								-22.24840016899998
							],
							[
								150.46281367900008,
								-22.239821217999975
							],
							[
								150.45413872000006,
								-22.23422011699995
							],
							[
								150.4640380310001,
								-22.22516018799996
							],
							[
								150.4398489020001,
								-22.23264018599997
							],
							[
								150.4305844710001,
								-22.25208138499994
							],
							[
								150.44256427900007,
								-22.254541316999962
							],
							[
								150.41554992900012,
								-22.279570133999982
							],
							[
								150.42147986700002,
								-22.294500144999972
							]
						]
					],
					[
						[
							[
								150.2720619170001,
								-22.226191120999943
							],
							[
								150.26090189700005,
								-22.22733114999994
							],
							[
								150.27152189600008,
								-22.23137116099997
							],
							[
								150.2720619170001,
								-22.226191120999943
							]
						]
					],
					[
						[
							[
								150.29734688300005,
								-22.24243224299994
							],
							[
								150.3035768520001,
								-22.249692193999977
							],
							[
								150.32071645100007,
								-22.24420209599998
							],
							[
								150.32335073100012,
								-22.235651125999937
							],
							[
								150.31417072200009,
								-22.233091164999962
							],
							[
								150.29734688300005,
								-22.24243224299994
							]
						]
					],
					[
						[
							[
								149.8618487870001,
								-22.16967414399994
							],
							[
								149.8653243550001,
								-22.18851507499994
							],
							[
								149.8790842620001,
								-22.203694955999936
							],
							[
								149.86620473100004,
								-22.22202499499997
							],
							[
								149.89802878700004,
								-22.234293067999943
							],
							[
								149.91860353900006,
								-22.20499473999996
							],
							[
								149.92065294400004,
								-22.15465482899998
							],
							[
								149.9299968050001,
								-22.133723119999956
							],
							[
								149.9187925870001,
								-22.122734888999958
							],
							[
								149.90465230300003,
								-22.07855505699996
							],
							[
								149.9076868850001,
								-22.052804116999937
							],
							[
								149.88160263600003,
								-22.067935244999944
							],
							[
								149.88320286200008,
								-22.09940516599994
							],
							[
								149.87281314300003,
								-22.104305244999978
							],
							[
								149.8715537390001,
								-22.14673514499998
							],
							[
								149.8618487870001,
								-22.16967414399994
							]
						]
					],
					[
						[
							[
								150.013935811,
								-22.105623136999952
							],
							[
								150.01047587200003,
								-22.10097310699996
							],
							[
								150.00108084200008,
								-22.105234435999932
							],
							[
								150.00108102000002,
								-22.122244405999936
							],
							[
								149.99225109200006,
								-22.11348447499995
							],
							[
								149.97847139300006,
								-22.117614543999935
							],
							[
								149.97008176200006,
								-22.134014563999983
							],
							[
								149.9596518830001,
								-22.13033464299997
							],
							[
								149.93659253300007,
								-22.145104740999955
							],
							[
								149.93323267300002,
								-22.15234474999994
							],
							[
								149.94436798000004,
								-22.171923061999962
							],
							[
								149.97530194900003,
								-22.15881446399993
							],
							[
								150.00870097900008,
								-22.12800432699993
							],
							[
								150.0207007580001,
								-22.126894257999936
							],
							[
								150.02236066900002,
								-22.11992424799996
							],
							[
								150.0110208100001,
								-22.116424346999963
							],
							[
								150.01352070000007,
								-22.10991434699997
							],
							[
								150.04025026800002,
								-22.111984159999963
							],
							[
								150.03741501900004,
								-22.106423158999974
							],
							[
								150.02428049900004,
								-22.110814277999964
							],
							[
								150.013935811,
								-22.105623136999952
							]
						]
					],
					[
						[
							[
								150.29351900500012,
								-22.02743116099998
							],
							[
								150.30298878500003,
								-22.02413113199998
							],
							[
								150.29040895600008,
								-22.02334112099993
							],
							[
								150.29351900500012,
								-22.02743116099998
							]
						]
					],
					[
						[
							[
								150.3617379110001,
								-22.01762116699996
							],
							[
								150.3739080590001,
								-22.02336117799996
							],
							[
								150.36687798100002,
								-22.011351127999944
							],
							[
								150.3617379110001,
								-22.01762116699996
							]
						]
					],
					[
						[
							[
								150.12534177300006,
								-21.99427316599997
							],
							[
								150.12547726200012,
								-22.001363905999938
							],
							[
								150.13959203100012,
								-21.998412076999955
							],
							[
								150.1297420630001,
								-21.98749309599998
							],
							[
								150.12534177300006,
								-21.99427316599997
							]
						]
					],
					[
						[
							[
								150.14142192300005,
								-21.979302116999975
							],
							[
								150.1474220120001,
								-21.97922210799993
							],
							[
								150.1426564950001,
								-21.96083389699993
							],
							[
								150.14991105400009,
								-21.961122107999927
							],
							[
								150.14137078500005,
								-21.95745307699997
							],
							[
								150.14142192300005,
								-21.979302116999975
							]
						]
					],
					[
						[
							[
								150.1853659090001,
								-21.97881359099995
							],
							[
								150.17972593100012,
								-21.97013365099997
							],
							[
								150.15993636200005,
								-21.97755375899993
							],
							[
								150.15155085300012,
								-21.971352147999937
							],
							[
								150.16471103000003,
								-21.98602214999994
							],
							[
								150.16875650800011,
								-22.00413360999994
							],
							[
								150.18027619800012,
								-21.998423570999933
							],
							[
								150.17802609000012,
								-21.98274362099994
							],
							[
								150.1853659090001,
								-21.97881359099995
							]
						]
					],
					[
						[
							[
								150.12455665800007,
								-21.942014065999956
							],
							[
								150.127566558,
								-21.936374065999928
							],
							[
								150.11997671900008,
								-21.93886409499993
							],
							[
								150.12455665800007,
								-21.942014065999956
							]
						]
					],
					[
						[
							[
								150.11101684000005,
								-21.932114163999927
							],
							[
								150.1182866900001,
								-21.931254114999945
							],
							[
								150.11862096100003,
								-21.915173154999934
							],
							[
								150.1083220910001,
								-21.92221312399994
							],
							[
								150.11101684000005,
								-21.932114163999927
							]
						]
					],
					[
						[
							[
								149.79261142600012,
								-21.837756454999976
							],
							[
								149.80417119600008,
								-21.833376375999933
							],
							[
								149.8001261270001,
								-21.82730513599995
							],
							[
								149.79261142600012,
								-21.837756454999976
							]
						]
					],
					[
						[
							[
								149.84611679500006,
								-22.007684121999944
							],
							[
								149.8617570030001,
								-22.013044072999946
							],
							[
								149.8809718130001,
								-21.99426543499993
							],
							[
								149.84914691500012,
								-21.999924061999934
							],
							[
								149.84611679500006,
								-22.007684121999944
							]
						]
					],
					[
						[
							[
								149.80479781000008,
								-21.986575087999938
							],
							[
								149.8195380080001,
								-21.995694068999967
							],
							[
								149.80935794000004,
								-21.982245087999956
							],
							[
								149.80479781000008,
								-21.986575087999938
							]
						]
					],
					[
						[
							[
								149.65783568300003,
								-21.97838691499993
							],
							[
								149.66451558300002,
								-21.981276855999965
							],
							[
								149.65579993500012,
								-21.965756074999945
							],
							[
								149.65783568300003,
								-21.97838691499993
							]
						]
					],
					[
						[
							[
								149.57350392600006,
								-22.125636028999963
							],
							[
								149.58854893300008,
								-22.13915688999998
							],
							[
								149.57820410600004,
								-22.11964607899995
							],
							[
								149.57350392600006,
								-22.125636028999963
							]
						]
					],
					[
						[
							[
								149.56099214100004,
								-21.988226116999954
							],
							[
								149.56622745000004,
								-21.992037426999957
							],
							[
								149.58253700000012,
								-21.974427367999965
							],
							[
								149.57801698100002,
								-21.968597407999937
							],
							[
								149.56099214100004,
								-21.988226116999954
							]
						]
					],
					[
						[
							[
								149.65390518900006,
								-21.92978706399998
							],
							[
								149.651329819,
								-21.925396123999974
							],
							[
								149.64255543900003,
								-21.931907142999933
							],
							[
								149.651315328,
								-21.936467083999958
							],
							[
								149.65390518900006,
								-21.92978706399998
							]
						]
					],
					[
						[
							[
								149.47962731300004,
								-21.833388397999954
							],
							[
								149.498366991,
								-21.83314826999998
							],
							[
								149.49754691200008,
								-21.82142830999993
							],
							[
								149.46962737500007,
								-21.82103849699996
							],
							[
								149.47962731300004,
								-21.833388397999954
							]
						]
					],
					[
						[
							[
								149.68389360600008,
								-21.32814504199996
							],
							[
								149.6940822150001,
								-21.328153672999974
							],
							[
								149.6941933270001,
								-21.313093462999973
							],
							[
								149.6679459600001,
								-21.30157911999993
							],
							[
								149.66505154900005,
								-21.310110149999957
							],
							[
								149.68389360600008,
								-21.32814504199996
							]
						]
					],
					[
						[
							[
								149.8240103400001,
								-21.37436655399995
							],
							[
								149.8390357080001,
								-21.38212419599995
							],
							[
								149.82792489000008,
								-21.37091970499995
							],
							[
								149.8240103400001,
								-21.37436655399995
							]
						]
					],
					[
						[
							[
								149.84068193200005,
								-21.444946065999943
							],
							[
								149.85529682000004,
								-21.447657057999947
							],
							[
								149.84775694100006,
								-21.441067136999948
							],
							[
								149.84068193200005,
								-21.444946065999943
							]
						]
					],
					[
						[
							[
								149.71094334100007,
								-21.454534844999955
							],
							[
								149.71850983000002,
								-21.458643795999933
							],
							[
								149.71335253300003,
								-21.438718214999938
							],
							[
								149.71094334100007,
								-21.454534844999955
							]
						]
					],
					[
						[
							[
								149.48809482500008,
								-21.599968976999946
							],
							[
								149.49332480400005,
								-21.60501895799996
							],
							[
								149.49857463400008,
								-21.597758927999962
							],
							[
								149.49000016500008,
								-21.59486803699997
							],
							[
								149.48809482500008,
								-21.599968976999946
							]
						]
					],
					[
						[
							[
								149.6672980080001,
								-21.726806083999975
							],
							[
								149.67443255700005,
								-21.728347483999983
							],
							[
								149.6628678190001,
								-21.71837605299993
							],
							[
								149.6672980080001,
								-21.726806083999975
							]
						]
					],
					[
						[
							[
								149.83478905000004,
								-21.662186627999972
							],
							[
								149.84248891000004,
								-21.659756567999978
							],
							[
								149.83427389200006,
								-21.646615107999935
							],
							[
								149.83478905000004,
								-21.662186627999972
							]
						]
					],
					[
						[
							[
								149.80119906000004,
								-21.593757013999948
							],
							[
								149.7846140810001,
								-21.60087611299997
							],
							[
								149.78109961000007,
								-21.613107102999948
							],
							[
								149.78865941900006,
								-21.60920704299997
							],
							[
								149.79151385800003,
								-21.616396073999965
							],
							[
								149.81880888700005,
								-21.606816865999974
							],
							[
								149.80872897900008,
								-21.59967695499995
							],
							[
								149.81180413900006,
								-21.592756124999937
							],
							[
								149.80119906000004,
								-21.593757013999948
							]
						]
					],
					[
						[
							[
								149.8887221220001,
								-21.50027511099995
							],
							[
								149.89653655200004,
								-21.498756691999972
							],
							[
								149.89111108300006,
								-21.485255090999942
							],
							[
								149.8887221220001,
								-21.50027511099995
							]
						]
					],
					[
						[
							[
								149.9165361800001,
								-21.49677656299997
							],
							[
								149.90640641100003,
								-21.496526632999974
							],
							[
								149.91711626900008,
								-21.506586523999943
							],
							[
								149.9165361800001,
								-21.49677656299997
							]
						]
					],
					[
						[
							[
								150.27137061200006,
								-21.489534454999955
							],
							[
								150.28055047200007,
								-21.48336444599994
							],
							[
								150.2664949440001,
								-21.47681313399994
							],
							[
								150.26308069300012,
								-21.484254533999945
							],
							[
								150.27137061200006,
								-21.489534454999955
							]
						]
					],
					[
						[
							[
								150.25376111000003,
								-21.52310446399997
							],
							[
								150.25752107900007,
								-21.528494413999965
							],
							[
								150.27646071900006,
								-21.516614345999983
							],
							[
								150.2693958100001,
								-21.51296317499998
							],
							[
								150.25909588000002,
								-21.52191311399997
							],
							[
								150.24539115100004,
								-21.51673452299997
							],
							[
								150.25376111000003,
								-21.52310446399997
							]
						]
					],
					[
						[
							[
								150.24777217500002,
								-21.67637405399995
							],
							[
								150.25344201500002,
								-21.66780404499997
							],
							[
								150.27415182200002,
								-21.68087388699996
							],
							[
								150.2833617120001,
								-21.679223836999938
							],
							[
								150.28662157300005,
								-21.669973857999935
							],
							[
								150.30198131200007,
								-21.664903788999936
							],
							[
								150.2908813350001,
								-21.64377389799995
							],
							[
								150.26389681700005,
								-21.64115312499996
							],
							[
								150.2475168310001,
								-21.618863103999956
							],
							[
								150.25042196700008,
								-21.650984123999933
							],
							[
								150.242592058,
								-21.654264153999975
							],
							[
								150.24203218700006,
								-21.663734113999965
							],
							[
								150.24777217500002,
								-21.67637405399995
							]
						]
					],
					[
						[
							[
								150.33888087800005,
								-21.669563551999943
							],
							[
								150.3505207280001,
								-21.667033492999963
							],
							[
								150.3384560500001,
								-21.656002161999936
							],
							[
								150.32585096000003,
								-21.658603650999964
							],
							[
								150.34005088800006,
								-21.674363522999954
							],
							[
								150.33888087800005,
								-21.669563551999943
							]
						]
					],
					[
						[
							[
								150.3584810000001,
								-21.73352323499995
							],
							[
								150.36205585100004,
								-21.71767213499993
							],
							[
								150.3397858510001,
								-21.741332132999958
							],
							[
								150.31383705300004,
								-21.739382100999933
							],
							[
								150.299511864,
								-21.74547353899993
							],
							[
								150.3319715980001,
								-21.77173326299993
							],
							[
								150.3481659580001,
								-21.763942113999974
							],
							[
								150.34574126000007,
								-21.74297327399995
							],
							[
								150.3584810000001,
								-21.73352323499995
							]
						]
					],
					[
						[
							[
								150.47208397400004,
								-22.285851109999953
							],
							[
								150.45916432400008,
								-22.29661116799997
							],
							[
								150.46288429300012,
								-22.300811128999953
							],
							[
								150.47264406300008,
								-22.294911079999963
							],
							[
								150.4859640100001,
								-22.311010960999965
							],
							[
								150.50004362900006,
								-22.303070871999978
							],
							[
								150.47848876900002,
								-22.320640209999965
							],
							[
								150.4899641180001,
								-22.325050890999933
							],
							[
								150.47568447800006,
								-22.33517095999997
							],
							[
								150.48562896600004,
								-22.35000918099996
							],
							[
								150.50480395600005,
								-22.33426080299995
							],
							[
								150.51057390500011,
								-22.34005078299998
							],
							[
								150.5230035840001,
								-22.333490794999932
							],
							[
								150.51652359600007,
								-22.325780803999976
							],
							[
								150.5291433550001,
								-22.324410774999933
							],
							[
								150.52751326600003,
								-22.316620774999933
							],
							[
								150.5425130540001,
								-22.321120735999955
							],
							[
								150.54426271600005,
								-22.299490685999956
							],
							[
								150.55453257500005,
								-22.305090666999945
							],
							[
								150.56079696500012,
								-22.294969157999958
							],
							[
								150.55255693700008,
								-22.279919166999946
							],
							[
								150.53488265900012,
								-22.27541074499993
							],
							[
								150.51966238600005,
								-22.22502091299998
							],
							[
								150.48939787000006,
								-22.206640179999965
							],
							[
								150.4792177610001,
								-22.206560158999935
							],
							[
								150.47024336000004,
								-22.22161122899996
							],
							[
								150.47548340900005,
								-22.232701178999946
							],
							[
								150.49006303800002,
								-22.227511100999948
							],
							[
								150.4958229570001,
								-22.23522105099994
							],
							[
								150.4972278460001,
								-22.24119018099998
							],
							[
								150.491567937,
								-22.236980160999963
							],
							[
								150.4860532570001,
								-22.24383107999995
							],
							[
								150.4923132250001,
								-22.255461010999966
							],
							[
								150.48151780600006,
								-22.250430119999976
							],
							[
								150.4783135460001,
								-22.255381089999958
							],
							[
								150.50050324300003,
								-22.26962095199997
							],
							[
								150.47547880600007,
								-22.261100159999955
							],
							[
								150.47462375500004,
								-22.26882109999997
							],
							[
								150.4693688860001,
								-22.266910198999938
							],
							[
								150.4721938450001,
								-22.276641118999976
							],
							[
								150.48279369300008,
								-22.278731049999976
							],
							[
								150.47057389400004,
								-22.281251118999933
							],
							[
								150.47208397400004,
								-22.285851109999953
							]
						]
					],
					[
						[
							[
								150.51842411100006,
								-22.37337082399995
							],
							[
								150.52873397000008,
								-22.374010804999955
							],
							[
								150.52091399100004,
								-22.36651081499997
							],
							[
								150.51842411100006,
								-22.37337082399995
							]
						]
					],
					[
						[
							[
								150.66968906700004,
								-22.093940375999978
							],
							[
								150.67692891700005,
								-22.09092034599996
							],
							[
								150.6702089680001,
								-22.082670415999928
							],
							[
								150.66968906700004,
								-22.093940375999978
							]
						]
					],
					[
						[
							[
								150.6842479400001,
								-21.960340695999946
							],
							[
								150.6773880600001,
								-21.965390714999955
							],
							[
								150.69042789800005,
								-21.96720064699997
							],
							[
								150.69142778000003,
								-21.95349068699994
							],
							[
								150.69818768900006,
								-21.95430063699996
							],
							[
								150.68690777100005,
								-21.94566072599997
							],
							[
								150.6842479400001,
								-21.960340695999946
							]
						]
					],
					[
						[
							[
								150.73822341700009,
								-22.611359945999936
							],
							[
								150.7347234670001,
								-22.607169935999934
							],
							[
								150.7375734960001,
								-22.61710994599997
							],
							[
								150.73822341700009,
								-22.611359945999936
							]
						]
					],
					[
						[
							[
								150.9943502320001,
								-22.73169879099993
							],
							[
								150.9988202410001,
								-22.73439874099995
							],
							[
								150.99247022300005,
								-22.726388790999977
							],
							[
								150.9943502320001,
								-22.73169879099993
							]
						]
					],
					[
						[
							[
								150.9066349320001,
								-23.085231045999933
							],
							[
								150.9140848410001,
								-23.08700101599993
							],
							[
								150.914414791,
								-23.07967098599994
							],
							[
								150.89208519600004,
								-23.05446101399997
							],
							[
								150.88462536400004,
								-23.077411173999963
							],
							[
								150.9066349320001,
								-23.085231045999933
							]
						]
					],
					[
						[
							[
								151.07838685900003,
								-23.15409822199996
							],
							[
								151.06902683900012,
								-23.161039200999937
							],
							[
								151.0794121880001,
								-23.163370011999973
							],
							[
								151.07838685900003,
								-23.15409822199996
							]
						]
					],
					[
						[
							[
								150.9702741220001,
								-23.216840882999975
							],
							[
								150.97341878200007,
								-23.209129252999958
							],
							[
								150.9648986620001,
								-23.21481922199996
							],
							[
								150.9702741220001,
								-23.216840882999975
							]
						]
					],
					[
						[
							[
								150.93967489700003,
								-23.19781120999994
							],
							[
								150.97760379500005,
								-23.183267212999965
							],
							[
								150.9881057230001,
								-23.192299253999977
							],
							[
								150.9942588240001,
								-23.177539244999934
							],
							[
								150.97553884600006,
								-23.171189212999934
							],
							[
								150.97554892900007,
								-23.148829242999966
							],
							[
								150.95624678000001,
								-23.15627423099994
							],
							[
								150.95111855800008,
								-23.17117922099993
							],
							[
								150.93283674000008,
								-23.167690208999943
							],
							[
								150.93967489700003,
								-23.19781120999994
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "305",
				"CED_NAME21": "Capricornia",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 90239.2708,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/305",
				"SHAPE_Leng": 35.8343653241,
				"SHAPE_Area": 7.89587035023
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								146.83558345200004,
								-19.269335833999946
							],
							[
								146.82527143100003,
								-19.290302822999934
							],
							[
								146.81430344300009,
								-19.283952831999954
							],
							[
								146.80409037300012,
								-19.286803730999964
							],
							[
								146.81039728200005,
								-19.29939483199996
							],
							[
								146.8037351920001,
								-19.304669480999962
							],
							[
								146.78919231300006,
								-19.30018130999997
							],
							[
								146.76103643500005,
								-19.307740827999964
							],
							[
								146.76682548300005,
								-19.31762840899995
							],
							[
								146.80844245000003,
								-19.318458831999976
							],
							[
								146.80711055900008,
								-19.33079890199997
							],
							[
								146.81452242800003,
								-19.336963842999978
							],
							[
								146.80996744800007,
								-19.341676821999954
							],
							[
								146.82758044700006,
								-19.343598833999977
							],
							[
								146.825791438,
								-19.33569683299993
							],
							[
								146.83081745700008,
								-19.33682982399995
							],
							[
								146.8371234440001,
								-19.36907283499994
							],
							[
								146.8446384330001,
								-19.369570834999934
							],
							[
								146.84384244400007,
								-19.359411834999946
							],
							[
								146.85471144300004,
								-19.36050583599996
							],
							[
								146.85336342200003,
								-19.37247982599996
							],
							[
								146.86363343000005,
								-19.38978883699997
							],
							[
								146.8659034420001,
								-19.36986683699996
							],
							[
								146.8731114210001,
								-19.370524846999956
							],
							[
								146.872283164,
								-19.338173686999937
							],
							[
								146.90054479200012,
								-19.34082436899996
							],
							[
								146.89509242000008,
								-19.35964182899994
							],
							[
								146.90313545000004,
								-19.360296838999943
							],
							[
								146.89952840600006,
								-19.404877849999934
							],
							[
								146.89333643700002,
								-19.404277838999974
							],
							[
								146.89164341600008,
								-19.419512848999943
							],
							[
								146.89257942400002,
								-19.43890283899998
							],
							[
								146.90019543300002,
								-19.43969883999995
							],
							[
								146.90332841200006,
								-19.456805849999967
							],
							[
								146.9098914010001,
								-19.457510850999938
							],
							[
								146.93428501200003,
								-19.42940568199998
							],
							[
								146.95121043100005,
								-19.424788843999977
							],
							[
								146.95278241200003,
								-19.409809843999938
							],
							[
								146.94254551300003,
								-19.403269772999977
							],
							[
								146.9540094340001,
								-19.38733184299997
							],
							[
								147.0191534180001,
								-19.39383984799997
							],
							[
								147.0335639860001,
								-19.41256698999996
							],
							[
								147.03254840500006,
								-19.422186849999946
							],
							[
								147.04228142400007,
								-19.42678185999995
							],
							[
								147.0365084010001,
								-19.472030839999945
							],
							[
								147.01263141200002,
								-19.474994858999935
							],
							[
								147.01069439100002,
								-19.491883858999927
							],
							[
								147.01204840000003,
								-19.49945884899995
							],
							[
								147.02455913900008,
								-19.504513139999972
							],
							[
								147.03396240600011,
								-19.53412685099994
							],
							[
								147.02211841300004,
								-19.579420839999955
							],
							[
								147.00325338300001,
								-19.596587848999945
							],
							[
								147.0194534000001,
								-19.610932859999934
							],
							[
								147.018313389,
								-19.624440849999928
							],
							[
								147.03032039800007,
								-19.624992860999953
							],
							[
								147.02023638100002,
								-19.71568685099993
							],
							[
								146.99258541000006,
								-19.759227859999953
							],
							[
								146.968329411,
								-19.76225883799998
							],
							[
								146.95600339100008,
								-19.776116856999977
							],
							[
								146.93019537200007,
								-19.783107834999953
							],
							[
								146.9239437970001,
								-19.851159064999933
							],
							[
								147.01959539900008,
								-19.86115085199998
							],
							[
								147.02440238400004,
								-19.796027851999952
							],
							[
								147.10297836900008,
								-19.781978847999937
							],
							[
								147.11422335800012,
								-19.790905858999963
							],
							[
								147.15260237500001,
								-19.784648861999926
							],
							[
								147.18578675000003,
								-19.81334516499993
							],
							[
								147.2334092860001,
								-19.819057877999967
							],
							[
								147.23638337300008,
								-19.861223868999957
							],
							[
								147.2191863590001,
								-19.917540867999946
							],
							[
								147.2301503660001,
								-19.94139385899996
							],
							[
								147.24783936400001,
								-19.95543988099996
							],
							[
								147.2636813370001,
								-20.012884871999972
							],
							[
								147.29444335000005,
								-20.06682488499996
							],
							[
								147.2744353270001,
								-20.12430888399996
							],
							[
								147.29455631200005,
								-20.161136865999936
							],
							[
								147.30922134600007,
								-20.221685867999952
							],
							[
								147.31096433200003,
								-20.270565887999965
							],
							[
								147.299598338,
								-20.318255867999937
							],
							[
								147.3144013440001,
								-20.360310888999948
							],
							[
								147.33252030000006,
								-20.382438880999928
							],
							[
								147.34472430100004,
								-20.36334489199993
							],
							[
								147.34424191300002,
								-20.33791699099993
							],
							[
								147.3722562810001,
								-20.340915863999953
							],
							[
								147.37928191100002,
								-20.329622123999968
							],
							[
								147.4343897970001,
								-20.332936837999966
							],
							[
								147.45048961400005,
								-20.34877991999997
							],
							[
								147.44935139200004,
								-20.369363539999938
							],
							[
								147.54951300400012,
								-20.379314087999944
							],
							[
								147.55750497400004,
								-20.364688507999972
							],
							[
								147.54807899600007,
								-20.35659987699995
							],
							[
								147.55154598700005,
								-20.342289706999964
							],
							[
								147.57124569600012,
								-20.330936178999934
							],
							[
								147.59498061400006,
								-20.330412320999983
							],
							[
								147.60938596500011,
								-20.308009631999937
							],
							[
								147.64370169300003,
								-20.300507123999978
							],
							[
								147.6546022020001,
								-20.30966140499993
							],
							[
								147.66271658100004,
								-20.30696246599996
							],
							[
								147.67016791000003,
								-20.316553876999933
							],
							[
								147.66144276800003,
								-20.34274527599996
							],
							[
								147.64164998900003,
								-20.34941241499996
							],
							[
								147.68623028100012,
								-20.40284590899995
							],
							[
								147.6823811700001,
								-20.420935417999942
							],
							[
								147.7422882840001,
								-20.426879912999937
							],
							[
								147.74248228300007,
								-20.438976912999976
							],
							[
								147.77736675000006,
								-20.442389395999953
							],
							[
								147.77604606900002,
								-20.45444854599998
							],
							[
								147.82626524500006,
								-20.459354909999945
							],
							[
								147.84367377500007,
								-20.444936980999955
							],
							[
								147.84853375800003,
								-20.41053414099997
							],
							[
								147.85825935700007,
								-20.40996191199997
							],
							[
								147.8644543570001,
								-20.39925705299993
							],
							[
								147.89123765300008,
								-20.428059304999977
							],
							[
								147.90350395200005,
								-20.420982205999962
							],
							[
								147.92256994800005,
								-20.45356438799996
							],
							[
								147.93567738700006,
								-20.456948068999964
							],
							[
								147.9318329460001,
								-20.469384128999934
							],
							[
								147.94030583500012,
								-20.476783628999954
							],
							[
								147.94605944400007,
								-20.473578909999958
							],
							[
								147.96363488100008,
								-20.492353820999938
							],
							[
								147.98251367000012,
								-20.494336412999928
							],
							[
								147.98283843600007,
								-20.533807432999936
							],
							[
								148.0110502330001,
								-20.543139935999932
							],
							[
								148.020182244,
								-20.523000945999968
							],
							[
								148.03941022300012,
								-20.519823937999945
							],
							[
								148.05358423300004,
								-20.506403948999946
							],
							[
								148.075949239,
								-20.53242794099998
							],
							[
								148.07476623800005,
								-20.540444950999927
							],
							[
								148.09540023600005,
								-20.54538894199993
							],
							[
								148.09689424400005,
								-20.565925942999968
							],
							[
								148.11330424200003,
								-20.57269095399994
							],
							[
								148.12174523200008,
								-20.568061934999946
							],
							[
								148.1325992410001,
								-20.575778955999965
							],
							[
								148.1242572330001,
								-20.663383945999954
							],
							[
								148.1347002010001,
								-20.67412695699994
							],
							[
								148.13143123100008,
								-20.681360955999935
							],
							[
								148.1472442270001,
								-20.71612794799995
							],
							[
								148.1492832240001,
								-20.741280957999948
							],
							[
								148.13993820400003,
								-20.748586957999976
							],
							[
								148.15695519200005,
								-20.75866394899998
							],
							[
								148.16169220100005,
								-20.769573949999938
							],
							[
								148.3030321980001,
								-20.787203960999932
							],
							[
								148.30126318700002,
								-20.800643950999927
							],
							[
								148.36111621100008,
								-20.807415955999943
							],
							[
								148.4570121800001,
								-20.737064982999982
							],
							[
								148.46848617700005,
								-20.758842973999947
							],
							[
								148.46296919700012,
								-20.771833973999946
							],
							[
								148.48490117200004,
								-20.80361397599995
							],
							[
								148.50813418000007,
								-20.80517097799998
							],
							[
								148.51723053000012,
								-20.795427618999952
							],
							[
								148.52927516700004,
								-20.819968979999942
							],
							[
								148.56226616300012,
								-20.839155982999955
							],
							[
								148.57055319200003,
								-20.834975982999936
							],
							[
								148.58830317900004,
								-20.85093199499994
							],
							[
								148.59788215700007,
								-20.869628975999944
							],
							[
								148.5936451660001,
								-20.879004985999927
							],
							[
								148.60043416200006,
								-20.917962986999953
							],
							[
								148.61354715000004,
								-20.924889977999953
							],
							[
								148.62259815800007,
								-20.947349978999966
							],
							[
								148.6410117160001,
								-20.953538769999966
							],
							[
								148.63630182500003,
								-20.968196759999955
							],
							[
								148.6430559700001,
								-21.00816858099995
							],
							[
								148.63745342900006,
								-21.024407939999946
							],
							[
								148.62651712000002,
								-21.023803639999983
							],
							[
								148.62339717200007,
								-21.003652768999928
							],
							[
								148.59789141300007,
								-21.015486866999936
							],
							[
								148.60233916100003,
								-21.03143998799993
							],
							[
								148.5841601520001,
								-21.045771995999928
							],
							[
								148.58065914100007,
								-21.059243985999956
							],
							[
								148.7112471490001,
								-21.066671996999958
							],
							[
								148.71071213900007,
								-21.07121200699993
							],
							[
								148.73116512800004,
								-21.069125998999937
							],
							[
								148.7389881360001,
								-21.07912099899994
							],
							[
								148.75352414500003,
								-21.080263000999935
							],
							[
								148.75761514600003,
								-21.067813000999934
							],
							[
								148.78044457300007,
								-21.077475252999932
							],
							[
								148.78187848400012,
								-21.06644528299995
							],
							[
								148.80747739100002,
								-21.068964094999956
							],
							[
								148.81595415100003,
								-21.070004995999966
							],
							[
								148.81278814000007,
								-21.084718015999954
							],
							[
								148.8233271790001,
								-21.08599293599997
							],
							[
								148.82956801900002,
								-21.07752391699995
							],
							[
								148.86080972600007,
								-21.082954649999976
							],
							[
								148.86276911700008,
								-21.06906301999993
							],
							[
								148.87838611600012,
								-21.070981010999958
							],
							[
								148.8804251150001,
								-21.076616010999942
							],
							[
								148.90322910300006,
								-21.075750012999947
							],
							[
								148.90441313200006,
								-21.090428002999943
							],
							[
								148.92327611000007,
								-21.092876024999953
							],
							[
								148.9295720980001,
								-21.10517802499993
							],
							[
								148.9532761160001,
								-21.113144017999957
							],
							[
								148.95205310500012,
								-21.124827017999962
							],
							[
								148.96755812300012,
								-21.12533900899996
							],
							[
								148.9664090230001,
								-21.134023578999972
							],
							[
								149.0582300950001,
								-21.13933402699996
							],
							[
								149.09522011100012,
								-21.14814002999998
							],
							[
								149.1527830870001,
								-21.14381203499994
							],
							[
								149.16348097700006,
								-21.132010074999982
							],
							[
								149.19925024400004,
								-21.137620048999963
							],
							[
								149.20404003400006,
								-21.132740068999965
							],
							[
								149.19273025500001,
								-21.132230037999932
							],
							[
								149.1969001550001,
								-21.12555005799993
							],
							[
								149.2227600010001,
								-21.147680080999976
							],
							[
								149.2242221240001,
								-21.115920219999964
							],
							[
								149.23541108400002,
								-21.106097030999933
							],
							[
								149.226138955,
								-21.101050089999944
							],
							[
								149.2270389790001,
								-21.062779999999975
							],
							[
								149.20556894900005,
								-21.076750078999964
							],
							[
								149.18672904400012,
								-21.034051016999967
							],
							[
								149.17473926600007,
								-21.03265502599993
							],
							[
								149.1706761250001,
								-21.04218504499994
							],
							[
								149.15754929900004,
								-21.016221033999955
							],
							[
								149.1580792100001,
								-21.000301023999953
							],
							[
								149.13459927200006,
								-20.995031051999945
							],
							[
								149.11551999300002,
								-21.002392069999928
							],
							[
								149.08881312800008,
								-20.97566902799997
							],
							[
								149.06444913000007,
								-20.974385025999936
							],
							[
								149.0489801010001,
								-20.979102043999944
							],
							[
								149.04162101000009,
								-20.989302023999983
							],
							[
								149.01738913200006,
								-20.993430021999927
							],
							[
								149.0205501050001,
								-20.958417031999943
							],
							[
								149.03164610400006,
								-20.958153012999958
							],
							[
								149.01423513800012,
								-20.93576701099994
							],
							[
								149.02830511800005,
								-20.92394102199995
							],
							[
								149.0394800670001,
								-20.924033022999936
							],
							[
								149.04494813600002,
								-20.931523023999944
							],
							[
								149.06068711500006,
								-20.928179024999963
							],
							[
								149.0466502060001,
								-20.920872043999964
							],
							[
								149.04612029800012,
								-20.903002003999973
							],
							[
								149.02904009000008,
								-20.897693001999983
							],
							[
								149.01741031000006,
								-20.912192980999976
							],
							[
								149.00540104100003,
								-20.912333029999957
							],
							[
								148.99541567300002,
								-20.89223428899993
							],
							[
								148.97102104400005,
								-20.90036302699997
							],
							[
								148.95119117800004,
								-20.87557404499995
							],
							[
								148.93847129800008,
								-20.88827403399995
							],
							[
								148.92794129900005,
								-20.883784022999976
							],
							[
								148.91507202000003,
								-20.891964041999927
							],
							[
								148.8901869130001,
								-20.877895139999964
							],
							[
								148.89259218400002,
								-20.862143979999928
							],
							[
								148.8809821960001,
								-20.856034058999967
							],
							[
								148.88483203600003,
								-20.848764039999935
							],
							[
								148.87492232600005,
								-20.86251404899997
							],
							[
								148.87747706400012,
								-20.87523523899995
							],
							[
								148.8662322560001,
								-20.86757401799997
							],
							[
								148.84481226700007,
								-20.875754035999933
							],
							[
								148.84737222800004,
								-20.85721403699995
							],
							[
								148.8418573790001,
								-20.85493554599998
							],
							[
								148.84934217900002,
								-20.845454016999952
							],
							[
								148.83889723200002,
								-20.824525625999968
							],
							[
								148.79509117700002,
								-20.81252301199993
							],
							[
								148.81835740600002,
								-20.801985823999928
							],
							[
								148.81466736700008,
								-20.791005862999953
							],
							[
								148.84079702500003,
								-20.79109568499996
							],
							[
								148.82966703700004,
								-20.77657579399994
							],
							[
								148.8112672090001,
								-20.771355942999946
							],
							[
								148.8026773690001,
								-20.77586600199993
							],
							[
								148.78081756200004,
								-20.762456199999974
							],
							[
								148.7779083360001,
								-20.732109299999934
							],
							[
								148.7668354760001,
								-20.734382378999953
							],
							[
								148.75858399800006,
								-20.724366007999947
							],
							[
								148.73080534100006,
								-20.716644015999975
							],
							[
								148.73258300300006,
								-20.688463035999973
							],
							[
								148.70632425700012,
								-20.67066796299997
							],
							[
								148.73086619700007,
								-20.644573014999935
							],
							[
								148.72717005900006,
								-20.632988034999983
							],
							[
								148.71806710900012,
								-20.64248500399998
							],
							[
								148.6999461700001,
								-20.639717961999963
							],
							[
								148.6868763330001,
								-20.620507980999946
							],
							[
								148.69031660500002,
								-20.599077290999958
							],
							[
								148.66165114900002,
								-20.584156978999943
							],
							[
								148.70093114100007,
								-20.52755203199996
							],
							[
								148.715100333,
								-20.494826961999934
							],
							[
								148.7135711940001,
								-20.48342058199995
							],
							[
								148.69028058800006,
								-20.45747284999993
							],
							[
								148.69195400900003,
								-20.445965109999975
							],
							[
								148.67962923000005,
								-20.44248897899996
							],
							[
								148.6842622910001,
								-20.43599471899995
							],
							[
								148.73593715200002,
								-20.481743023999968
							],
							[
								148.7525727620001,
								-20.472864184999935
							],
							[
								148.76361612000005,
								-20.47968796599997
							],
							[
								148.78218024000012,
								-20.46424296799995
							],
							[
								148.78443635100007,
								-20.451776007999968
							],
							[
								148.7756631740001,
								-20.431733986999973
							],
							[
								148.7584522960001,
								-20.42628196499993
							],
							[
								148.75613709700008,
								-20.418907014999945
							],
							[
								148.78591810300009,
								-20.430380027999945
							],
							[
								148.79385933000003,
								-20.453646998999943
							],
							[
								148.79088827400005,
								-20.415218987999936
							],
							[
								148.8006813730001,
								-20.423663958999953
							],
							[
								148.80913630300006,
								-20.41860596999993
							],
							[
								148.8134541700001,
								-20.439906979999932
							],
							[
								148.82179321900003,
								-20.443018990999974
							],
							[
								148.8225041710001,
								-20.424723970999935
							],
							[
								148.83178822800005,
								-20.45058899199995
							],
							[
								148.82399025900008,
								-20.449220990999947
							],
							[
								148.8172831280001,
								-20.458097960999964
							],
							[
								148.83108622600002,
								-20.474990951999928
							],
							[
								148.82322313600002,
								-20.477723990999948
							],
							[
								148.8242613440001,
								-20.500917981999976
							],
							[
								148.84496206200004,
								-20.503155022999977
							],
							[
								148.84633402100008,
								-20.515298993999977
							],
							[
								148.85039410100012,
								-20.51026304399994
							],
							[
								148.85656920000008,
								-20.51550401399993
							],
							[
								148.8574292190001,
								-20.528176994999967
							],
							[
								148.88481333700008,
								-20.52319801699997
							],
							[
								148.8990322740001,
								-20.545217957999967
							],
							[
								148.90604830400002,
								-20.535441008999953
							],
							[
								148.92789417200004,
								-20.53641300099997
							],
							[
								148.9290371730001,
								-20.52590505099994
							],
							[
								148.88546315000008,
								-20.491115006999962
							],
							[
								148.89051610100012,
								-20.47719597699995
							],
							[
								148.9112373690001,
								-20.479443988999947
							],
							[
								148.90279211100005,
								-20.467031007999935
							],
							[
								148.8926332520001,
								-20.46453701699994
							],
							[
								148.88024712200001,
								-20.472250995999957
							],
							[
								148.8468142580001,
								-20.43172498299998
							],
							[
								148.8386912190001,
								-20.430939011999953
							],
							[
								148.83959018300004,
								-20.391628011999956
							],
							[
								148.82374009400007,
								-20.38678097099995
							],
							[
								148.8200151640001,
								-20.39218502999995
							],
							[
								148.81639104500005,
								-20.38489502999994
							],
							[
								148.83106929400003,
								-20.384390030999953
							],
							[
								148.82789409600002,
								-20.365411990999974
							],
							[
								148.8372191850001,
								-20.366219041999955
							],
							[
								148.8407180360001,
								-20.35193099199995
							],
							[
								148.8257052990001,
								-20.33770899999996
							],
							[
								148.81841423800006,
								-20.354459989999953
							],
							[
								148.816615339,
								-20.343819019999955
							],
							[
								148.80700909000007,
								-20.342603028999974
							],
							[
								148.82235336000008,
								-20.331923999999958
							],
							[
								148.816356121,
								-20.321438988999944
							],
							[
								148.79193229300006,
								-20.321256026999947
							],
							[
								148.7930033140001,
								-20.313705006999953
							],
							[
								148.7691230470001,
								-20.29969499499998
							],
							[
								148.7663830580001,
								-20.286912014999928
							],
							[
								148.7855467060001,
								-20.293324996999957
							],
							[
								148.79419131600002,
								-20.29067302699997
							],
							[
								148.79097829700004,
								-20.278775026999938
							],
							[
								148.79480330600006,
								-20.28296903699993
							],
							[
								148.80185211600008,
								-20.27796898799994
							],
							[
								148.77765506800006,
								-20.274100965999935
							],
							[
								148.7692893830001,
								-20.23594699499995
							],
							[
								148.7523492240001,
								-20.235667012999954
							],
							[
								148.7526872420001,
								-20.262137973999927
							],
							[
								148.7336907140001,
								-20.253762991999963
							],
							[
								148.7386001010001,
								-20.281739982999966
							],
							[
								148.72552526200002,
								-20.276466960999983
							],
							[
								148.72827531300004,
								-20.265759611999954
							],
							[
								148.7155493040001,
								-20.262666020999973
							],
							[
								148.6773820950001,
								-20.283578947999956
							],
							[
								148.67226938600004,
								-20.275216946999933
							],
							[
								148.685120309,
								-20.241386947999956
							],
							[
								148.67898014000002,
								-20.230967026999963
							],
							[
								148.66279024000005,
								-20.24746698599995
							],
							[
								148.6677103610001,
								-20.233336985999927
							],
							[
								148.66065039300008,
								-20.216686985999957
							],
							[
								148.67684033400008,
								-20.19168697699996
							],
							[
								148.6771592650001,
								-20.177237006999974
							],
							[
								148.67614011400008,
								-20.188806966999948
							],
							[
								148.65298020300008,
								-20.216127004999976
							],
							[
								148.6429102940001,
								-20.213877993999972
							],
							[
								148.64627019700004,
								-20.178157993999946
							],
							[
								148.63940030900005,
								-20.170907932999967
							],
							[
								148.6286103980001,
								-20.190967942999976
							],
							[
								148.630050395,
								-20.21950793299993
							],
							[
								148.62283022600002,
								-20.215237981999962
							],
							[
								148.6146513760001,
								-20.22036798199997
							],
							[
								148.60116112800006,
								-20.210917970999958
							],
							[
								148.61994016000006,
								-20.17668802199995
							],
							[
								148.5992412590001,
								-20.20126799999997
							],
							[
								148.5826513600001,
								-20.19762793899997
							],
							[
								148.58278130200006,
								-20.181638008999983
							],
							[
								148.5980201220001,
								-20.166317929999934
							],
							[
								148.57032133400003,
								-20.170267937999938
							],
							[
								148.57695111500004,
								-20.15449796799993
							],
							[
								148.5660013360001,
								-20.149987976999967
							],
							[
								148.5799103170001,
								-20.134407987999964
							],
							[
								148.57840013700002,
								-20.12728799799993
							],
							[
								148.5669812980001,
								-20.132717966999962
							],
							[
								148.567891389,
								-20.118797946999962
							],
							[
								148.55484136000007,
								-20.113858015999938
							],
							[
								148.55273140200006,
								-20.094177995999928
							],
							[
								148.566090292,
								-20.082137976999945
							],
							[
								148.56288016400003,
								-20.066717995999966
							],
							[
								148.5408913550001,
								-20.07630893499993
							],
							[
								148.52987142400002,
								-20.093748953999977
							],
							[
								148.51332111500005,
								-20.093258981999952
							],
							[
								148.50733110600004,
								-20.087078961999964
							],
							[
								148.49505111700012,
								-20.088448940999967
							],
							[
								148.49404732800008,
								-20.079396670999927
							],
							[
								148.48724128800006,
								-20.081468989999962
							],
							[
								148.47452841100005,
								-20.064569808999977
							],
							[
								148.45202101300004,
								-20.059344426999928
							],
							[
								148.4407332830001,
								-20.073573995999936
							],
							[
								148.44362622900007,
								-20.11103991699997
							],
							[
								148.44769240800008,
								-20.116668966999953
							],
							[
								148.4562424180001,
								-20.11099897799994
							],
							[
								148.4789720660001,
								-20.117488969999954
							],
							[
								148.4603723150001,
								-20.143758988999934
							],
							[
								148.43731326600005,
								-20.154058936999945
							],
							[
								148.43486308400009,
								-20.168448956999953
							],
							[
								148.4217832060001,
								-20.16050897499997
							],
							[
								148.3893731380001,
								-20.163658962999932
							],
							[
								148.34202414300012,
								-20.153009978999933
							],
							[
								148.3386541740001,
								-20.139569928999947
							],
							[
								148.32083417600006,
								-20.136089986999934
							],
							[
								148.3034044100001,
								-20.110659934999944
							],
							[
								148.27768421300004,
								-20.099549982999974
							],
							[
								148.27422427400006,
								-20.086559912999974
							],
							[
								148.283524144,
								-20.07745992399998
							],
							[
								148.2368753600001,
								-20.054390939999962
							],
							[
								148.23058546100003,
								-20.045310938999933
							],
							[
								148.2403032620001,
								-20.022624939999957
							],
							[
								148.25860929100008,
								-20.018815940999957
							],
							[
								148.26750415000004,
								-20.023640911999962
							],
							[
								148.26810326300006,
								-19.99241594199998
							],
							[
								148.25976028500008,
								-19.97542895099997
							],
							[
								148.25675228500006,
								-19.98524196099993
							],
							[
								148.23918826600004,
								-19.984328948999973
							],
							[
								148.22013428000002,
								-19.95603093699998
							],
							[
								148.18621545400003,
								-19.944060934999982
							],
							[
								148.16453515400008,
								-19.95794090299995
							],
							[
								148.11318428900006,
								-19.941353938999953
							],
							[
								148.09722635200012,
								-19.924931966999964
							],
							[
								148.0801162470001,
								-19.88185191499997
							],
							[
								148.06317644800004,
								-19.89035198399995
							],
							[
								148.04700632900006,
								-19.885931882999955
							],
							[
								148.02623612000002,
								-19.894001920999926
							],
							[
								148.01756732900003,
								-19.913121960999945
							],
							[
								147.9921873500001,
								-19.927607928999976
							],
							[
								147.950271444,
								-19.91578190499996
							],
							[
								147.9384911850001,
								-19.918463903999964
							],
							[
								147.9178401370001,
								-19.908300932999964
							],
							[
								147.86484634600004,
								-19.85097290799996
							],
							[
								147.84567422400005,
								-19.782057925999936
							],
							[
								147.85246632400003,
								-19.768944915999953
							],
							[
								147.85139822700012,
								-19.73923791599998
							],
							[
								147.8215603220001,
								-19.709093932999963
							],
							[
								147.7523492470001,
								-19.706584907999968
							],
							[
								147.7608983450001,
								-19.726852918999953
							],
							[
								147.74493649200008,
								-19.76896686799995
							],
							[
								147.76887931900012,
								-19.79189589999993
							],
							[
								147.7666523470001,
								-19.81654291999996
							],
							[
								147.77265432500008,
								-19.826763910999944
							],
							[
								147.76459633500008,
								-19.83706590999998
							],
							[
								147.74661730700007,
								-19.833903908999957
							],
							[
								147.71933030800005,
								-19.84280589599996
							],
							[
								147.7000443400001,
								-19.835528904999933
							],
							[
								147.71063532000005,
								-19.823661915999935
							],
							[
								147.7037793400001,
								-19.831966894999937
							],
							[
								147.6713584030001,
								-19.828343462999953
							],
							[
								147.66330541500008,
								-19.809667941999976
							],
							[
								147.62858848000008,
								-19.78663089899993
							],
							[
								147.6013684940001,
								-19.757442915999945
							],
							[
								147.58681120800009,
								-19.725081874999944
							],
							[
								147.59966140000006,
								-19.687026895999963
							],
							[
								147.6169982790001,
								-19.68595186699997
							],
							[
								147.6154445100001,
								-19.673086886999954
							],
							[
								147.6009923040001,
								-19.646394864999934
							],
							[
								147.58544644500012,
								-19.648517883999943
							],
							[
								147.57409921700003,
								-19.629287862999945
							],
							[
								147.58099537700002,
								-19.62487291399998
							],
							[
								147.5537653670001,
								-19.539688900999977
							],
							[
								147.53015155000003,
								-19.516694878999942
							],
							[
								147.50774226600004,
								-19.476304856999946
							],
							[
								147.50025644700008,
								-19.46961784599995
							],
							[
								147.51024244500002,
								-19.48479491699993
							],
							[
								147.5011024050001,
								-19.485037915999953
							],
							[
								147.48700337800005,
								-19.465509904999976
							],
							[
								147.45571649800002,
								-19.37131887199996
							],
							[
								147.4101772470001,
								-19.31056886799996
							],
							[
								147.38458556000012,
								-19.302482895999958
							],
							[
								147.42131634500004,
								-19.321727858999964
							],
							[
								147.41707628500012,
								-19.333194867999964
							],
							[
								147.44605232000004,
								-19.365183920999982
							],
							[
								147.45516822600007,
								-19.39517490199995
							],
							[
								147.44101626500003,
								-19.421147900999927
							],
							[
								147.41045229700012,
								-19.425946868999972
							],
							[
								147.39042941900004,
								-19.41786488699995
							],
							[
								147.3590554110001,
								-19.41956390499996
							],
							[
								147.30418423600008,
								-19.407621869999957
							],
							[
								147.24690839800007,
								-19.432453865999946
							],
							[
								147.23460524100005,
								-19.418616894999957
							],
							[
								147.2128482820001,
								-19.423927893999974
							],
							[
								147.18392550500005,
								-19.411611850999975
							],
							[
								147.169281446,
								-19.413526859999934
							],
							[
								147.16154647700012,
								-19.40542587899995
							],
							[
								147.13506127900007,
								-19.40679287699993
							],
							[
								147.13576364800008,
								-19.417586477999976
							],
							[
								147.12610738800004,
								-19.42245782699996
							],
							[
								147.11022632200002,
								-19.397086824999974
							],
							[
								147.11393541200005,
								-19.387765885999954
							],
							[
								147.06498518900003,
								-19.34216872199994
							],
							[
								147.0480784340001,
								-19.298982859999967
							],
							[
								147.040680435,
								-19.29564684899998
							],
							[
								147.04666095700009,
								-19.274505009999928
							],
							[
								147.06144375500003,
								-19.276685920999967
							],
							[
								147.0605855970001,
								-19.25629693999997
							],
							[
								147.04494670000008,
								-19.23731210899996
							],
							[
								147.0399996430001,
								-19.20692141799998
							],
							[
								147.0155879770001,
								-19.181962805999945
							],
							[
								147.0217819830001,
								-19.215835566999942
							],
							[
								147.00763330300003,
								-19.226382635999983
							],
							[
								147.001853492,
								-19.249366555999927
							],
							[
								146.98004908100006,
								-19.28052758499996
							],
							[
								146.96051852100004,
								-19.293291712999974
							],
							[
								146.95803769000008,
								-19.30874972299995
							],
							[
								146.95315045100006,
								-19.29823983299997
							],
							[
								146.94246982200002,
								-19.295353931999955
							],
							[
								146.8845085160001,
								-19.30422282799998
							],
							[
								146.83558345200004,
								-19.269335833999946
							]
						]
					],
					[
						[
							[
								148.89698131500006,
								-20.85161396099994
							],
							[
								148.91526102300008,
								-20.853573981999943
							],
							[
								148.90243098700012,
								-20.826804040999946
							],
							[
								148.89056658700008,
								-20.83110524999995
							],
							[
								148.89698131500006,
								-20.85161396099994
							]
						]
					],
					[
						[
							[
								148.93293618200005,
								-20.85411490399997
							],
							[
								148.93762099200012,
								-20.851793973999975
							],
							[
								148.93195097300008,
								-20.843634022999936
							],
							[
								148.93293618200005,
								-20.85411490399997
							]
						]
					],
					[
						[
							[
								148.92067112300003,
								-20.855954052999948
							],
							[
								148.92773106200002,
								-20.852084052999942
							],
							[
								148.91891628400003,
								-20.84704500199996
							],
							[
								148.92067112300003,
								-20.855954052999948
							]
						]
					],
					[
						[
							[
								148.87973695000005,
								-20.601536936999935
							],
							[
								148.8813310490001,
								-20.605769976999966
							],
							[
								148.87868217100004,
								-20.590565986999934
							],
							[
								148.87973695000005,
								-20.601536936999935
							]
						]
					],
					[
						[
							[
								148.87321413900008,
								-20.61688605699993
							],
							[
								148.86431530100003,
								-20.607051025999965
							],
							[
								148.86986107000007,
								-20.61201200599993
							],
							[
								148.86543416900008,
								-20.61862503599997
							],
							[
								148.87321413900008,
								-20.61688605699993
							]
						]
					],
					[
						[
							[
								148.8934730200001,
								-20.38139046599997
							],
							[
								148.88281425200012,
								-20.36886702499993
							],
							[
								148.89586105900003,
								-20.38528103699997
							],
							[
								148.8934730200001,
								-20.38139046599997
							]
						]
					],
					[
						[
							[
								148.93637821800007,
								-20.363482209999972
							],
							[
								148.93558526000004,
								-20.339813039999967
							],
							[
								148.92781608100006,
								-20.337293038999974
							],
							[
								148.92812041800005,
								-20.36948523899997
							],
							[
								148.94038430600006,
								-20.380752109999946
							],
							[
								148.93637821800007,
								-20.363482209999972
							]
						]
					],
					[
						[
							[
								148.85074863600005,
								-20.344178341999964
							],
							[
								148.85407408900005,
								-20.315964932999975
							],
							[
								148.84454809800002,
								-20.335613011999953
							],
							[
								148.8516816130001,
								-20.381599752999932
							],
							[
								148.86428754000008,
								-20.395568603999948
							],
							[
								148.87421638000012,
								-20.394674554999938
							],
							[
								148.8722462620001,
								-20.375735624999948
							],
							[
								148.85074863600005,
								-20.344178341999964
							]
						]
					],
					[
						[
							[
								148.84670189400003,
								-20.270596071999933
							],
							[
								148.84937672500007,
								-20.257002091999937
							],
							[
								148.83805405500004,
								-20.26222700099993
							],
							[
								148.83021506600005,
								-20.255826019999972
							],
							[
								148.8267522740001,
								-20.28519517999996
							],
							[
								148.84670189400003,
								-20.270596071999933
							]
						]
					],
					[
						[
							[
								148.90824106900004,
								-20.272494026999937
							],
							[
								148.92129105800007,
								-20.27117299799994
							],
							[
								148.92223932900004,
								-20.252486037999972
							],
							[
								148.91000114000008,
								-20.257537016999947
							],
							[
								148.90824106900004,
								-20.272494026999937
							]
						]
					],
					[
						[
							[
								148.82954291800002,
								-20.241307279999944
							],
							[
								148.825332859,
								-20.224547348999977
							],
							[
								148.81008816200006,
								-20.214125967999962
							],
							[
								148.82954291800002,
								-20.241307279999944
							]
						]
					],
					[
						[
							[
								148.81288270800007,
								-20.255785498999956
							],
							[
								148.8146152070001,
								-20.260754498999972
							],
							[
								148.8144907080001,
								-20.25108599899994
							],
							[
								148.81288270800007,
								-20.255785498999956
							]
						]
					],
					[
						[
							[
								148.948550113,
								-20.083486797999967
							],
							[
								148.95766993300003,
								-20.07869674899996
							],
							[
								148.95727989400007,
								-20.07056678899994
							],
							[
								148.96817974300006,
								-20.070176699999934
							],
							[
								148.95935426500012,
								-20.059786048999968
							],
							[
								148.92739033600003,
								-20.07261697699994
							],
							[
								148.9264403850001,
								-20.081656966999958
							],
							[
								148.9197404470001,
								-20.072517025999957
							],
							[
								148.9226703070001,
								-20.062097045999963
							],
							[
								148.9068252180001,
								-20.071285974999967
							],
							[
								148.9022307770001,
								-20.079567134999934
							],
							[
								148.9118906860001,
								-20.08804704499994
							],
							[
								148.91157076500008,
								-20.10042702499993
							],
							[
								148.90413096400005,
								-20.109897064999927
							],
							[
								148.8893263450001,
								-20.111406003999946
							],
							[
								148.88429131500004,
								-20.122667172999968
							],
							[
								148.88858131400002,
								-20.12903711399997
							],
							[
								148.88170620100004,
								-20.16161599399993
							],
							[
								148.88540150100005,
								-20.158697063999966
							],
							[
								148.88763161000008,
								-20.169147033999934
							],
							[
								148.90241127100012,
								-20.149756984999954
							],
							[
								148.90009122200001,
								-20.139477014999954
							],
							[
								148.90520118100005,
								-20.143216974999973
							],
							[
								148.91558087200008,
								-20.123416945999963
							],
							[
								148.9022313590001,
								-20.166106944999967
							],
							[
								148.9150512870001,
								-20.17418684599994
							],
							[
								148.92053096000006,
								-20.14521687699994
							],
							[
								148.93003074000012,
								-20.132746846999964
							],
							[
								148.9345508670001,
								-20.157626757999935
							],
							[
								148.92628101700006,
								-20.169456786999945
							],
							[
								148.9315510360001,
								-20.178246727999976
							],
							[
								148.95127059600009,
								-20.156536638999967
							],
							[
								148.93660512200006,
								-20.10709598799997
							],
							[
								148.94543020300011,
								-20.093736797999952
							],
							[
								148.95734015100004,
								-20.10624668899993
							],
							[
								148.9593000210001,
								-20.09457669899996
							],
							[
								148.95000015200003,
								-20.09250678899997
							],
							[
								148.948550113,
								-20.083486797999967
							]
						]
					],
					[
						[
							[
								148.88371287000007,
								-20.060147292999943
							],
							[
								148.89466071900006,
								-20.062577223999938
							],
							[
								148.8980605800001,
								-20.050437213999942
							],
							[
								148.88098077300003,
								-20.036987361999934
							],
							[
								148.88371287000007,
								-20.060147292999943
							]
						]
					],
					[
						[
							[
								148.65239450400009,
								-20.106388813999956
							],
							[
								148.65445912500002,
								-20.092448013999956
							],
							[
								148.6455445150001,
								-20.100308862999952
							],
							[
								148.65239450400009,
								-20.106388813999956
							]
						]
					],
					[
						[
							[
								148.60079550400008,
								-20.147879039999964
							],
							[
								148.6005655230001,
								-20.15284902999997
							],
							[
								148.6138453520001,
								-20.151548960999946
							],
							[
								148.61284525400004,
								-20.138368990999936
							],
							[
								148.60079550400008,
								-20.147879039999964
							]
						]
					],
					[
						[
							[
								148.5456901560001,
								-20.05945895499997
							],
							[
								148.54184141700011,
								-20.056519023999954
							],
							[
								148.5358113960001,
								-20.06541892399997
							],
							[
								148.5456901560001,
								-20.05945895499997
							]
						]
					],
					[
						[
							[
								148.2776644380001,
								-20.038019942999938
							],
							[
								148.28609418700012,
								-20.040669992999938
							],
							[
								148.29424423800003,
								-20.03184999399997
							],
							[
								148.28479423800002,
								-20.03362993299993
							],
							[
								148.28263423900012,
								-20.02695994299995
							],
							[
								148.2776644380001,
								-20.038019942999938
							]
						]
					],
					[
						[
							[
								148.47855126600007,
								-20.00176894899994
							],
							[
								148.46740135800007,
								-19.995898977999957
							],
							[
								148.45775120000008,
								-19.974658976999933
							],
							[
								148.44522137100012,
								-19.973938975999943
							],
							[
								148.4380069980001,
								-20.021080465999944
							],
							[
								148.44704227600005,
								-20.035538926999948
							],
							[
								148.444542425,
								-20.04441895599996
							],
							[
								148.45732242300005,
								-20.051808956999935
							],
							[
								148.4760066220001,
								-20.046610138999938
							],
							[
								148.47855126600007,
								-20.00176894899994
							]
						]
					],
					[
						[
							[
								149.00737078800012,
								-20.30890584499997
							],
							[
								149.02208065500008,
								-20.321385706999934
							],
							[
								149.03292038600011,
								-20.300485686999934
							],
							[
								149.0346504160001,
								-20.308685667999953
							],
							[
								149.0433702260001,
								-20.30216559799993
							],
							[
								149.04682524500004,
								-20.309523998999964
							],
							[
								149.063085375,
								-20.294153969999968
							],
							[
								149.0430851970001,
								-20.28707501799994
							],
							[
								149.0253451110001,
								-20.25540501599994
							],
							[
								149.01500042100008,
								-20.26971589599998
							],
							[
								149.02594524300002,
								-20.23489500599993
							],
							[
								149.00448528300012,
								-20.255465044999937
							],
							[
								149.01079022500005,
								-20.232906034999928
							],
							[
								148.9916350640001,
								-20.250358992999963
							],
							[
								148.99590505600008,
								-20.22828505399997
							],
							[
								148.98934048700005,
								-20.223936212999945
							],
							[
								148.99685507800007,
								-20.205325053999957
							],
							[
								148.97618053000008,
								-20.20521634199997
							],
							[
								148.98377519100006,
								-20.18506498199997
							],
							[
								148.97321041300006,
								-20.17435644099993
							],
							[
								148.978325164,
								-20.161914981999928
							],
							[
								148.9582652360001,
								-20.15680496999994
							],
							[
								148.95582087100001,
								-20.206796459999964
							],
							[
								148.9520610400001,
								-20.21938646999996
							],
							[
								148.9398912810001,
								-20.225846538999974
							],
							[
								148.93795137900008,
								-20.239596518999974
							],
							[
								148.94212131900008,
								-20.243346508999934
							],
							[
								148.958480989,
								-20.22762640999997
							],
							[
								148.9548011280001,
								-20.239506409999933
							],
							[
								148.96204104700007,
								-20.24484636099993
							],
							[
								148.94279422600005,
								-20.268172049999976
							],
							[
								148.93630653700006,
								-20.26370948899995
							],
							[
								148.92715478600007,
								-20.28146249799994
							],
							[
								148.9129473370001,
								-20.281886956999926
							],
							[
								148.91270603700002,
								-20.290944576999948
							],
							[
								148.92895905600005,
								-20.28620399899995
							],
							[
								148.923046085,
								-20.295780977999982
							],
							[
								148.93219514500004,
								-20.29443602899994
							],
							[
								148.93756702300004,
								-20.307110988999966
							],
							[
								148.9574023340001,
								-20.280683040999975
							],
							[
								148.9591663430001,
								-20.28798205099997
							],
							[
								148.966301143,
								-20.280202981999935
							],
							[
								148.9684582550001,
								-20.26529304199994
							],
							[
								148.9748741840001,
								-20.268830031999983
							],
							[
								148.9689392130001,
								-20.282056981999972
							],
							[
								148.94990760300004,
								-20.30300828999998
							],
							[
								148.95156025200004,
								-20.307785000999957
							],
							[
								148.9623994320001,
								-20.303581190999978
							],
							[
								148.96319830900006,
								-20.328746001999946
							],
							[
								148.98659217800002,
								-20.322501993999936
							],
							[
								148.97854009900004,
								-20.313647972999945
							],
							[
								148.98889329000008,
								-20.301297003999935
							],
							[
								148.99978188800003,
								-20.311159904999954
							],
							[
								149.00737078800012,
								-20.30890584499997
							]
						]
					],
					[
						[
							[
								148.99604326400004,
								-20.35300901499994
							],
							[
								148.990671345,
								-20.349632043999975
							],
							[
								148.98909311500006,
								-20.356545033999964
							],
							[
								148.99604326400004,
								-20.35300901499994
							]
						]
					],
					[
						[
							[
								148.96101620700006,
								-20.348120841999958
							],
							[
								148.94696119000002,
								-20.33219250999997
							],
							[
								148.94482157700008,
								-20.364186450999966
							],
							[
								148.952736167,
								-20.361645960999965
							],
							[
								148.9530933850001,
								-20.37678908099997
							],
							[
								148.96127146700007,
								-20.356692331999966
							],
							[
								148.96778518700012,
								-20.351950941999974
							],
							[
								148.96659827500002,
								-20.365549001999966
							],
							[
								148.97670549500003,
								-20.364811662999955
							],
							[
								148.98223838600006,
								-20.348196593999944
							],
							[
								148.96101620700006,
								-20.348120841999958
							]
						]
					],
					[
						[
							[
								149.034086257,
								-20.403784067999936
							],
							[
								149.036290967,
								-20.396995337999954
							],
							[
								149.02636106800003,
								-20.392775437999944
							],
							[
								149.02427118800006,
								-20.40129542699998
							],
							[
								149.034086257,
								-20.403784067999936
							]
						]
					],
					[
						[
							[
								149.03633935000005,
								-20.159366035999938
							],
							[
								149.02318954100008,
								-20.15572614499996
							],
							[
								149.02069962000007,
								-20.162796124999943
							],
							[
								149.02855949000002,
								-20.16369607599995
							],
							[
								149.038659477,
								-20.18291596699993
							],
							[
								149.04269421700008,
								-20.17680504699996
							],
							[
								149.03660941900011,
								-20.16486601699995
							],
							[
								149.04423922900003,
								-20.155925986999932
							],
							[
								149.0381392800001,
								-20.15021603699995
							],
							[
								149.03633935000005,
								-20.159366035999938
							]
						]
					],
					[
						[
							[
								149.09465925400002,
								-20.271935311999982
							],
							[
								149.10327895600005,
								-20.250515322999945
							],
							[
								149.0943592650001,
								-20.27085533199994
							],
							[
								149.0894992860001,
								-20.265135371999975
							],
							[
								149.07558950600003,
								-20.27017546099995
							],
							[
								149.0702497740001,
								-20.293095439999945
							],
							[
								149.07713965400012,
								-20.293285380999976
							],
							[
								149.0752397230001,
								-20.301165380999976
							],
							[
								149.0854895430001,
								-20.29471534199996
							],
							[
								149.08494960200005,
								-20.30447529199995
							],
							[
								149.09341946200004,
								-20.30085527199998
							],
							[
								149.08826942400003,
								-20.280955331999962
							],
							[
								149.09465925400002,
								-20.271935311999982
							]
						]
					],
					[
						[
							[
								149.0670498930001,
								-20.304695419999973
							],
							[
								149.0747252230001,
								-20.305493970999976
							],
							[
								149.06833520400005,
								-20.299694019999947
							],
							[
								149.0670498930001,
								-20.304695419999973
							]
						]
					],
					[
						[
							[
								149.08084628100005,
								-20.525613002999933
							],
							[
								149.0902260910001,
								-20.52441304399997
							],
							[
								149.0808913620001,
								-20.514964632999977
							],
							[
								149.08084628100005,
								-20.525613002999933
							]
						]
					],
					[
						[
							[
								149.02924606200008,
								-20.451444007999953
							],
							[
								149.03405599100006,
								-20.460234038999943
							],
							[
								149.05280130100004,
								-20.450545089999935
							],
							[
								149.06462613000008,
								-20.453014070999927
							],
							[
								149.05300606200012,
								-20.436253989999955
							],
							[
								149.04008601300006,
								-20.438124008999978
							],
							[
								149.0334663440001,
								-20.429894038999976
							],
							[
								149.02432155400004,
								-20.44139526799995
							],
							[
								149.02924606200008,
								-20.451444007999953
							]
						]
					],
					[
						[
							[
								149.06694632200004,
								-20.525954011999943
							],
							[
								149.06962144400006,
								-20.504354771999942
							],
							[
								149.0772713340001,
								-20.502544712999963
							],
							[
								149.0740160050001,
								-20.495254021999926
							],
							[
								149.0832662040001,
								-20.49234407299997
							],
							[
								149.08201629500002,
								-20.484323982999967
							],
							[
								149.09829620300002,
								-20.490722993999952
							],
							[
								149.09528623500012,
								-20.480552983999928
							],
							[
								149.10468513400008,
								-20.481163004999928
							],
							[
								149.08425622700008,
								-20.459274002999962
							],
							[
								149.08929512800012,
								-20.448834012999953
							],
							[
								149.07992615900002,
								-20.443524012999944
							],
							[
								149.08326511000007,
								-20.434993992999978
							],
							[
								149.07428599900004,
								-20.451814011999943
							],
							[
								149.0823408880001,
								-20.459764792999977
							],
							[
								149.07427628800008,
								-20.46481405199995
							],
							[
								149.0756460560001,
								-20.481514002999972
							],
							[
								149.06868123700008,
								-20.477354851999962
							],
							[
								149.06537598500006,
								-20.502133991999926
							],
							[
								149.04995721500006,
								-20.50963406099993
							],
							[
								149.0365471870001,
								-20.503734018999978
							],
							[
								149.0468370850001,
								-20.513373999999942
							],
							[
								149.04359201500006,
								-20.52218487999994
							],
							[
								149.0525470340001,
								-20.524414040999943
							],
							[
								149.06518158400002,
								-20.516234741999938
							],
							[
								149.06694632200004,
								-20.525954011999943
							]
						]
					],
					[
						[
							[
								149.07292241100004,
								-20.642314263999936
							],
							[
								149.05619253500004,
								-20.617764481999927
							],
							[
								149.05720256300003,
								-20.629404421999936
							],
							[
								149.08891711800004,
								-20.660983004999935
							],
							[
								149.07292241100004,
								-20.642314263999936
							]
						]
					],
					[
						[
							[
								149.101596308,
								-20.549562994999974
							],
							[
								149.11496600600003,
								-20.55292306599995
							],
							[
								149.1183610170001,
								-20.542234276999977
							],
							[
								149.12442096600012,
								-20.54396425699997
							],
							[
								149.1126461780001,
								-20.537782995999976
							],
							[
								149.09702614800005,
								-20.54528306499998
							],
							[
								149.101596308,
								-20.549562994999974
							]
						]
					],
					[
						[
							[
								149.12296306400003,
								-20.35755701499994
							],
							[
								149.12686221500007,
								-20.348015025999928
							],
							[
								149.1198980160001,
								-20.342976014999977
							],
							[
								149.11629549500003,
								-20.353308934999973
							],
							[
								149.12296306400003,
								-20.35755701499994
							]
						]
					],
					[
						[
							[
								149.13296022300005,
								-20.46782439699996
							],
							[
								149.12351033400012,
								-20.463874475999944
							],
							[
								149.1207104140001,
								-20.469414465999932
							],
							[
								149.13229037200006,
								-20.482004366999945
							],
							[
								149.13296022300005,
								-20.46782439699996
							]
						]
					],
					[
						[
							[
								149.14760177100004,
								-20.685653609999974
							],
							[
								149.13609726200002,
								-20.68596305899996
							],
							[
								149.13851196100006,
								-20.694703639999943
							],
							[
								149.15812603000006,
								-20.68325207099997
							],
							[
								149.1564615210001,
								-20.674433560999944
							],
							[
								149.1666663000001,
								-20.683322001999954
							],
							[
								149.16265141200006,
								-20.66406357099993
							],
							[
								149.15112617300008,
								-20.662842059999946
							],
							[
								149.14760177100004,
								-20.685653609999974
							]
						]
					],
					[
						[
							[
								149.1718931810001,
								-20.250394008999933
							],
							[
								149.17802328000005,
								-20.25041398899998
							],
							[
								149.173583021,
								-20.24107405899997
							],
							[
								149.1718931810001,
								-20.250394008999933
							]
						]
					],
					[
						[
							[
								149.18582127800005,
								-20.687343383999973
							],
							[
								149.1939459990001,
								-20.671602033999932
							],
							[
								149.18158115000006,
								-20.666173482999966
							],
							[
								149.17255134000004,
								-20.672243521999974
							],
							[
								149.18582127800005,
								-20.687343383999973
							]
						]
					],
					[
						[
							[
								149.20125110700008,
								-20.68579329499994
							],
							[
								149.1974912070001,
								-20.691613294999968
							],
							[
								149.20517620500004,
								-20.698462074999952
							],
							[
								149.20909097600008,
								-20.690563185999963
							],
							[
								149.20125110700008,
								-20.68579329499994
							]
						]
					],
					[
						[
							[
								149.28189509900005,
								-20.80276101299995
							],
							[
								149.2743952300001,
								-20.79635103199996
							],
							[
								149.2492863010001,
								-20.805901009999957
							],
							[
								149.26826082000002,
								-20.810082141999942
							],
							[
								149.26587097900006,
								-20.82339213199998
							],
							[
								149.279790659,
								-20.810382062999963
							],
							[
								149.2882605970001,
								-20.81821198299997
							],
							[
								149.28997528800005,
								-20.809961002999955
							],
							[
								149.28189509900005,
								-20.80276101299995
							]
						]
					],
					[
						[
							[
								149.2756652810001,
								-20.79128105199993
							],
							[
								149.30140022800003,
								-20.797901963999948
							],
							[
								149.29349021100006,
								-20.77642209299995
							],
							[
								149.28487515200004,
								-20.77165107299993
							],
							[
								149.27336049200005,
								-20.778862191999963
							],
							[
								149.2756652810001,
								-20.79128105199993
							]
						]
					],
					[
						[
							[
								149.40581318300008,
								-20.76883004299998
							],
							[
								149.39129870400006,
								-20.76823158199994
							],
							[
								149.39032875400005,
								-20.773841581999932
							],
							[
								149.39887314200007,
								-20.779310082999928
							],
							[
								149.41155846200002,
								-20.774531443999933
							],
							[
								149.40581318300008,
								-20.76883004299998
							]
						]
					],
					[
						[
							[
								149.4733375200001,
								-20.747561168999937
							],
							[
								149.48370209900008,
								-20.740990058999955
							],
							[
								149.4662820420001,
								-20.72670004799994
							],
							[
								149.4733375200001,
								-20.747561168999937
							]
						]
					],
					[
						[
							[
								149.61574579500007,
								-20.779220280999937
							],
							[
								149.626405545,
								-20.773370231999934
							],
							[
								149.62273010700005,
								-20.760769111999934
							],
							[
								149.61235575600006,
								-20.77169031099993
							],
							[
								149.61574579500007,
								-20.779220280999937
							]
						]
					],
					[
						[
							[
								149.62373125700003,
								-20.85700909299993
							],
							[
								149.60347117000003,
								-20.846479090999935
							],
							[
								149.60570664800002,
								-20.864970020999976
							],
							[
								149.59153212900003,
								-20.867159089999973
							],
							[
								149.58470221000005,
								-20.86120909899995
							],
							[
								149.57832711900005,
								-20.87035013899998
							],
							[
								149.59673691600005,
								-20.885149989999945
							],
							[
								149.6064411760001,
								-20.879389110999966
							],
							[
								149.6166111650001,
								-20.884469061999937
							],
							[
								149.62586636600008,
								-20.869979882999928
							],
							[
								149.62373125700003,
								-20.85700909299993
							]
						]
					],
					[
						[
							[
								149.39529510900002,
								-20.919629052999937
							],
							[
								149.40015022900002,
								-20.914750973999958
							],
							[
								149.40549492800005,
								-20.92423006399997
							],
							[
								149.40981495800008,
								-20.917940064999982
							],
							[
								149.4230551060001,
								-20.925115065999933
							],
							[
								149.41418499000008,
								-20.89684008499995
							],
							[
								149.38586523100003,
								-20.904100041999982
							],
							[
								149.39529510900002,
								-20.919629052999937
							]
						]
					],
					[
						[
							[
								149.43433524500006,
								-20.93042008699996
							],
							[
								149.42246001500007,
								-20.939170885999943
							],
							[
								149.42649997400008,
								-20.945530865999956
							],
							[
								149.43261518400004,
								-20.93712004699995
							],
							[
								149.44189972300012,
								-20.941240757999935
							],
							[
								149.45936424400008,
								-20.921119028999954
							],
							[
								149.44821397600003,
								-20.903400027999965
							],
							[
								149.42454503800002,
								-20.90771002599996
							],
							[
								149.43111974600004,
								-20.916300815999932
							],
							[
								149.42764501600004,
								-20.926720085999932
							],
							[
								149.43433524500006,
								-20.93042008699996
							]
						]
					],
					[
						[
							[
								149.89516300000003,
								-21.017248047999942
							],
							[
								149.91128274800008,
								-21.01857795899997
							],
							[
								149.90379273100007,
								-21.002848057999927
							],
							[
								149.89420294100012,
								-21.00483807699993
							],
							[
								149.89516300000003,
								-21.017248047999942
							]
						]
					],
					[
						[
							[
								149.46489932200006,
								-20.93062060899996
							],
							[
								149.4669339820001,
								-20.93734909999995
							],
							[
								149.46955920200003,
								-20.928200569999944
							],
							[
								149.46489932200006,
								-20.93062060899996
							]
						]
					],
					[
						[
							[
								149.17422708000004,
								-21.19830302699995
							],
							[
								149.19599111700006,
								-21.211000028999933
							],
							[
								149.19316857,
								-21.183830327999942
							],
							[
								149.19983015100001,
								-21.15895004899994
							],
							[
								149.21517012100003,
								-21.145340069999975
							],
							[
								149.17264116600006,
								-21.134110045999932
							],
							[
								149.1525903260001,
								-21.145550054999944
							],
							[
								149.14930006200007,
								-21.196291044999953
							],
							[
								149.17422708000004,
								-21.19830302699995
							]
						]
					],
					[
						[
							[
								149.2466947270001,
								-21.16296866299996
							],
							[
								149.24691879800002,
								-21.157422992999955
							],
							[
								149.24014976800004,
								-21.161367321999933
							],
							[
								149.2466947270001,
								-21.16296866299996
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "306",
				"CED_NAME21": "Dawson",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 15500.0501,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/306",
				"SHAPE_Leng": 22.03602161,
				"SHAPE_Area": 1.33977936136
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							153.0002308710001,
							-27.358001031999947
						],
						[
							152.97889903500004,
							-27.346868428999983
						],
						[
							153.00196005500004,
							-27.321421440999927
						],
						[
							152.99726506800005,
							-27.302059440999983
						],
						[
							153.01402506700003,
							-27.302201442999944
						],
						[
							153.00862605800012,
							-27.297893441999975
						],
						[
							153.01490204800007,
							-27.288021431999937
						],
						[
							153.01924302700002,
							-27.291208452999967
						],
						[
							153.01809306300004,
							-27.248670432999972
						],
						[
							152.99873887600006,
							-27.240221409999947
						],
						[
							152.99201298600008,
							-27.24570841999997
						],
						[
							152.97544508800001,
							-27.243398427999978
						],
						[
							152.9648903840001,
							-27.20774937699997
						],
						[
							152.94464537600004,
							-27.20413508499996
						],
						[
							152.94577256700006,
							-27.197636514999942
						],
						[
							152.8445411790001,
							-27.182793454999967
						],
						[
							152.85762209200004,
							-27.154382435999935
						],
						[
							152.84832652300008,
							-27.154453214999933
						],
						[
							152.85106508400008,
							-27.139651414999946
						],
						[
							152.82864992800012,
							-27.130733672999952
						],
						[
							152.828847719,
							-27.11575222299996
						],
						[
							152.80729988300004,
							-27.10808622999997
						],
						[
							152.80615728400005,
							-27.099191359999963
						],
						[
							152.81686711300006,
							-27.09721842099998
						],
						[
							152.8143159440001,
							-27.089840460999937
						],
						[
							152.80570311500003,
							-27.08880941999996
						],
						[
							152.80081510500008,
							-27.097525409999946
						],
						[
							152.78357612800005,
							-27.086408407999954
						],
						[
							152.78025710600002,
							-27.10414256799993
						],
						[
							152.76686397800006,
							-27.102142455999967
						],
						[
							152.7653641170001,
							-27.11085242599995
						],
						[
							152.73352021100004,
							-27.10741846299993
						],
						[
							152.72820058900004,
							-27.122743962999948
						],
						[
							152.73933961500006,
							-27.15092149399993
						],
						[
							152.72906869400003,
							-27.163759592999952
						],
						[
							152.73356549300001,
							-27.171498913999983
						],
						[
							152.70354800200005,
							-27.199192250999943
						],
						[
							152.70223107900006,
							-27.226338410999972
						],
						[
							152.68095610700004,
							-27.259201418999965
						],
						[
							152.68546509500004,
							-27.274319409999976
						],
						[
							152.70492609300004,
							-27.277328401999966
						],
						[
							152.7040120910001,
							-27.292600411999956
						],
						[
							152.753606095,
							-27.295001425999942
						],
						[
							152.75629906300003,
							-27.30869441699997
						],
						[
							152.74850909300005,
							-27.318742415999964
						],
						[
							152.7488509110001,
							-27.332287985999983
						],
						[
							152.75570612100012,
							-27.328213456999947
						],
						[
							152.77207505700005,
							-27.34371841899997
						],
						[
							152.76001209600008,
							-27.36388041799995
						],
						[
							152.77290809300007,
							-27.379041408999967
						],
						[
							152.77546925000001,
							-27.40164356899993
						],
						[
							152.7986584670001,
							-27.405093171999965
						],
						[
							152.80210906700006,
							-27.398703421999983
						],
						[
							152.8311630620001,
							-27.416937424999958
						],
						[
							152.86115404800012,
							-27.42236242799993
						],
						[
							152.87215007800012,
							-27.413052688999983
						],
						[
							152.89723484500007,
							-27.417267441999968
						],
						[
							152.8993170660001,
							-27.40355944199996
						],
						[
							152.91504574400005,
							-27.40570790299995
						],
						[
							152.91695207500004,
							-27.394170433999932
						],
						[
							152.92686408400004,
							-27.39345342499996
						],
						[
							152.9488150300001,
							-27.408724436999933
						],
						[
							152.9654810400001,
							-27.396860447999984
						],
						[
							152.97700503800002,
							-27.400769439999976
						],
						[
							152.975291039,
							-27.392023438999956
						],
						[
							153.0002308710001,
							-27.358001031999947
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "307",
				"CED_NAME21": "Dickson",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 724.3048,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/307",
				"SHAPE_Leng": 1.57421022072,
				"SHAPE_Area": 0.0660158423828
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								153.4112736200001,
								-27.955136267999933
							],
							[
								153.40755932700006,
								-27.907022766999944
							],
							[
								153.39664529100003,
								-27.886934425999982
							],
							[
								153.39985207200004,
								-27.871631915999956
							],
							[
								153.39060074300005,
								-27.877514574999964
							],
							[
								153.37921818400002,
								-27.873894993999954
							],
							[
								153.38245657200002,
								-27.890673963999973
							],
							[
								153.3687228230001,
								-27.896869052999932
							],
							[
								153.35845793400006,
								-27.89333215199997
							],
							[
								153.35784513200008,
								-27.91183209199994
							],
							[
								153.3488473320001,
								-27.919277120999936
							],
							[
								153.34318633400005,
								-27.910059200999967
							],
							[
								153.34842324400006,
								-27.901745190999975
							],
							[
								153.34236117600005,
								-27.894870259999948
							],
							[
								153.3523401640001,
								-27.902039160999948
							],
							[
								153.35770095500004,
								-27.890993141999957
							],
							[
								153.35114402500005,
								-27.890004200999954
							],
							[
								153.38079695200008,
								-27.889103473999967
							],
							[
								153.38161495600002,
								-27.85990748399996
							],
							[
								153.36640796900008,
								-27.851288471999965
							],
							[
								153.37958427700005,
								-27.855110113999956
							],
							[
								153.38464237400012,
								-27.873983003999967
							],
							[
								153.39435221300005,
								-27.873874944999955
							],
							[
								153.40193698300004,
								-27.86374991599996
							],
							[
								153.3983700240001,
								-27.857449965999933
							],
							[
								153.39559011400002,
								-27.864177965999943
							],
							[
								153.3947689370001,
								-27.840363044999947
							],
							[
								153.3791419380001,
								-27.842790483999977
							],
							[
								153.38586696000004,
								-27.827164163999953
							],
							[
								153.37107679300004,
								-27.816048902999967
							],
							[
								153.368747105,
								-27.801733491999983
							],
							[
								153.34981529700008,
								-27.80031551999997
							],
							[
								153.36662927600003,
								-27.796290951999936
							],
							[
								153.38154473300006,
								-27.801294303999953
							],
							[
								153.3915595730001,
								-27.793948244999967
							],
							[
								153.38427672500006,
								-27.784366373999944
							],
							[
								153.42664191200004,
								-27.778531087999966
							],
							[
								153.4392894560001,
								-27.735747198999945
							],
							[
								153.4122819380001,
								-27.74091032599995
							],
							[
								153.39250391400003,
								-27.707755563999967
							],
							[
								153.35651049800003,
								-27.711681779999935
							],
							[
								153.34810550100008,
								-27.695108898999933
							],
							[
								153.32923679300006,
								-27.69638800699994
							],
							[
								153.32085602200004,
								-27.71051900699996
							],
							[
								153.30366533300003,
								-27.71446012499996
							],
							[
								153.2925269970001,
								-27.69201947399995
							],
							[
								153.28667998700007,
								-27.69434148299996
							],
							[
								153.23431997300008,
								-27.69402245799995
							],
							[
								153.23353599100005,
								-27.710996467999962
							],
							[
								153.21273599300002,
								-27.715283475999968
							],
							[
								153.2325259900001,
								-27.72328246799998
							],
							[
								153.22080099100003,
								-27.72623247699994
							],
							[
								153.24896599200008,
								-27.76569145999997
							],
							[
								153.264916996,
								-27.804926501999944
							],
							[
								153.30125503800002,
								-27.831202445999963
							],
							[
								153.31447193100007,
								-27.876850476999948
							],
							[
								153.28549396200003,
								-27.895772474999944
							],
							[
								153.2933939510001,
								-27.896873464999942
							],
							[
								153.30870595600004,
								-27.920908486999963
							],
							[
								153.3012009260001,
								-27.927167475999966
							],
							[
								153.29925993300003,
								-27.953559465999945
							],
							[
								153.32423045000007,
								-27.955056678999938
							],
							[
								153.32178593900005,
								-27.96817748899997
							],
							[
								153.34408192500007,
								-27.976880480999966
							],
							[
								153.34524393700008,
								-27.960637480999935
							],
							[
								153.37647392300005,
								-27.964654483999936
							],
							[
								153.3837429340001,
								-27.95389649499998
							],
							[
								153.4112736200001,
								-27.955136267999933
							]
						]
					],
					[
						[
							[
								153.373425934,
								-27.80205435299996
							],
							[
								153.37318795400006,
								-27.80731233299997
							],
							[
								153.38126774300008,
								-27.801704293999933
							],
							[
								153.373425934,
								-27.80205435299996
							]
						]
					],
					[
						[
							[
								153.3955478480001,
								-27.832996064999975
							],
							[
								153.3834340090001,
								-27.831884163999973
							],
							[
								153.38254311900005,
								-27.838110153999935
							],
							[
								153.39562887700004,
								-27.84000203499994
							],
							[
								153.3955478480001,
								-27.832996064999975
							]
						]
					],
					[
						[
							[
								153.38834885000006,
								-27.821236173999978
							],
							[
								153.3821869510001,
								-27.82259620399998
							],
							[
								153.3865311090001,
								-27.828172523999967
							],
							[
								153.39673077800012,
								-27.82903507499998
							],
							[
								153.3973318190001,
								-27.82248451499993
							],
							[
								153.38834885000006,
								-27.821236173999978
							]
						]
					],
					[
						[
							[
								153.38612957500004,
								-27.785952303999977
							],
							[
								153.3919195730001,
								-27.794554234999964
							],
							[
								153.37319295300006,
								-27.81155031299994
							],
							[
								153.38401505100012,
								-27.820388523999952
							],
							[
								153.40289384000005,
								-27.811642495999934
							],
							[
								153.41163325200012,
								-27.790926126999977
							],
							[
								153.4064522330001,
								-27.78295617599997
							],
							[
								153.38612957500004,
								-27.785952303999977
							]
						]
					],
					[
						[
							[
								153.4084499380001,
								-27.82466244699998
							],
							[
								153.4094198130001,
								-27.85724388699998
							],
							[
								153.42374393900002,
								-27.87520849799995
							],
							[
								153.4177909340001,
								-27.92032448799995
							],
							[
								153.42802319100008,
								-27.93400756899996
							],
							[
								153.42600372800007,
								-27.88167674899995
							],
							[
								153.4452695020001,
								-27.758372089999966
							],
							[
								153.44065784400004,
								-27.751275448999934
							],
							[
								153.42663613800005,
								-27.806199007999965
							],
							[
								153.4084499380001,
								-27.82466244699998
							]
						]
					],
					[
						[
							[
								153.40491728200004,
								-27.86731928699993
							],
							[
								153.40115347100004,
								-27.88194253599994
							],
							[
								153.41051386100003,
								-27.872080296999968
							],
							[
								153.40491728200004,
								-27.86731928699993
							]
						]
					],
					[
						[
							[
								153.4178974020001,
								-27.935322627999938
							],
							[
								153.41159104300004,
								-27.93138345799997
							],
							[
								153.41622497200012,
								-27.94013450799997
							],
							[
								153.4178974020001,
								-27.935322627999938
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "308",
				"CED_NAME21": "Fadden",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 388.5349,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/308",
				"SHAPE_Leng": 2.88108486086,
				"SHAPE_Area": 0.0355844511237
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							152.5868261820001,
							-26.733450424999944
						],
						[
							152.6082071200001,
							-26.73313486799998
						],
						[
							152.61640188100012,
							-26.716632777999962
						],
						[
							152.63255057000003,
							-26.708505559999935
						],
						[
							152.63437616200008,
							-26.691553399999975
						],
						[
							152.6486051710001,
							-26.691331400999957
						],
						[
							152.6561361790001,
							-26.699104401999932
						],
						[
							152.66052118200002,
							-26.669826391999948
						],
						[
							152.62464916600004,
							-26.67271440899998
						],
						[
							152.63594117700006,
							-26.651909399999965
						],
						[
							152.6506021660001,
							-26.64548039099998
						],
						[
							152.6456411570001,
							-26.639124400999947
						],
						[
							152.65223616800006,
							-26.629784400999938
						],
						[
							152.66368416700004,
							-26.62909540199996
						],
						[
							152.66615017800007,
							-26.61618041199995
						],
						[
							152.676575167,
							-26.61533041299998
						],
						[
							152.67390117700006,
							-26.621217402999946
						],
						[
							152.6845211750001,
							-26.626669413999934
						],
						[
							152.69693818400003,
							-26.622529404999966
						],
						[
							152.7007001620001,
							-26.633307395999964
						],
						[
							152.71540627100012,
							-26.635061866999933
						],
						[
							152.7302952660001,
							-26.659662408999964
						],
						[
							152.736801645,
							-26.660501369999963
						],
						[
							152.73402717700003,
							-26.648589768999955
						],
						[
							152.74127034600008,
							-26.649259579999978
						],
						[
							152.74642513700007,
							-26.63688671099993
						],
						[
							152.7734571730001,
							-26.64742941299994
						],
						[
							152.77448910400005,
							-26.641463682999984
						],
						[
							152.78890850300002,
							-26.638080384999967
						],
						[
							152.79631266800004,
							-26.668751275999966
						],
						[
							152.79176479800003,
							-26.677567284999952
						],
						[
							152.80639837600006,
							-26.679686146999927
						],
						[
							152.81434669500004,
							-26.680407927999966
						],
						[
							152.81575916600002,
							-26.672740417999933
						],
						[
							152.84501318200012,
							-26.677326440999934
						],
						[
							152.85460418200012,
							-26.66764288199994
						],
						[
							152.87917502900007,
							-26.67191340399995
						],
						[
							152.88582416000008,
							-26.66052343499996
						],
						[
							152.9018780980001,
							-26.66268245599997
						],
						[
							152.90067834900003,
							-26.654975965999938
						],
						[
							152.93865188600012,
							-26.65222892999998
						],
						[
							152.96448019000002,
							-26.676014262999956
						],
						[
							153.00193112600004,
							-26.679274435999957
						],
						[
							153.02223213000002,
							-26.71109243899997
						],
						[
							153.04433436600004,
							-26.72307824099994
						],
						[
							153.06056712600002,
							-26.711138451999943
						],
						[
							153.11354114000005,
							-26.71372643799998
						],
						[
							153.1196391200001,
							-26.707037447999937
						],
						[
							153.0949731170001,
							-26.672644445999936
						],
						[
							153.10621810700002,
							-26.66451044699994
						],
						[
							153.09869331000004,
							-26.642581415999928
						],
						[
							153.1026511220001,
							-26.546528464999938
						],
						[
							153.0927061550001,
							-26.531826423999973
						],
						[
							153.09556509800007,
							-26.498559443999966
						],
						[
							153.08062514000005,
							-26.495555432999936
						],
						[
							153.08298402200012,
							-26.482561112999974
						],
						[
							153.05810716500002,
							-26.47812043999994
						],
						[
							153.03859718900003,
							-26.463113437999937
						],
						[
							153.0307984520001,
							-26.443091486999947
						],
						[
							152.99552522700003,
							-26.43216547399993
						],
						[
							152.96638724000002,
							-26.432031450999943
						],
						[
							152.9649904590001,
							-26.44027607099997
						],
						[
							152.9462616510001,
							-26.437163278999947
						],
						[
							152.9450229910001,
							-26.444587438999974
						],
						[
							152.9218450830001,
							-26.443035135999935
						],
						[
							152.92016707200003,
							-26.452687435999962
						],
						[
							152.91296186300008,
							-26.447457485999962
						],
						[
							152.89241006500004,
							-26.454987563999964
						],
						[
							152.8819311740001,
							-26.469266412999957
						],
						[
							152.8708537860001,
							-26.46545778199993
						],
						[
							152.86934075500005,
							-26.47419339099997
						],
						[
							152.8350728360001,
							-26.488159777999954
						],
						[
							152.82697173600002,
							-26.499392086999933
						],
						[
							152.81333748800012,
							-26.497309445999974
						],
						[
							152.80430320200003,
							-26.471495414999936
						],
						[
							152.7680121960001,
							-26.470252450999965
						],
						[
							152.76547238700005,
							-26.463598210999976
						],
						[
							152.7564701660001,
							-26.473723399999983
						],
						[
							152.76538821500003,
							-26.475767410999936
						],
						[
							152.76555720400006,
							-26.48249440099994
						],
						[
							152.74331502400003,
							-26.50718538899997
						],
						[
							152.7620854710001,
							-26.510636270999953
						],
						[
							152.7596967600001,
							-26.52500287099997
						],
						[
							152.76825509800005,
							-26.52815340199993
						],
						[
							152.7675790070001,
							-26.536878371999933
						],
						[
							152.75850017800008,
							-26.536374380999973
						],
						[
							152.75378616700004,
							-26.549843410999983
						],
						[
							152.72845426100002,
							-26.53696465799993
						],
						[
							152.71225509200008,
							-26.546220795999943
						],
						[
							152.7084431410001,
							-26.55988840599997
						],
						[
							152.68127418100005,
							-26.582496383999967
						],
						[
							152.68049318900012,
							-26.597696353999936
						],
						[
							152.6602661710001,
							-26.597094441999957
						],
						[
							152.62563518700006,
							-26.58196838799995
						],
						[
							152.6063236980001,
							-26.584284055999944
						],
						[
							152.60271318900004,
							-26.57792504599996
						],
						[
							152.59441389900007,
							-26.58471552499998
						],
						[
							152.587946901,
							-26.579734103999954
						],
						[
							152.57520139100006,
							-26.58399448299997
						],
						[
							152.57401821000008,
							-26.595461392999937
						],
						[
							152.58414819900008,
							-26.59667840399993
						],
						[
							152.587790207,
							-26.613978404999955
						],
						[
							152.58320934300002,
							-26.64537138399993
						],
						[
							152.55219649200012,
							-26.68085136199994
						],
						[
							152.55804821000004,
							-26.689741391999974
						],
						[
							152.55087719900007,
							-26.703570381999953
						],
						[
							152.57616315600012,
							-26.713097363999964
						],
						[
							152.5868261820001,
							-26.733450424999944
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "309",
				"CED_NAME21": "Fairfax",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 1003.9847,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/309",
				"SHAPE_Leng": 2.38362560749,
				"SHAPE_Area": 0.0909619164413
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							153.04276808500003,
							-26.96944644299998
						],
						[
							153.060852962,
							-26.97854243499995
						],
						[
							153.06586503200003,
							-26.974958794999964
						],
						[
							153.06582604300002,
							-26.96432492499997
						],
						[
							153.04314122800008,
							-26.946213082999975
						],
						[
							153.06200376800007,
							-26.928285953999932
						],
						[
							153.06108850300006,
							-26.892900993999945
						],
						[
							153.0709060900001,
							-26.909038444999965
						],
						[
							153.0819812100001,
							-26.89571985599997
						],
						[
							153.1088750990001,
							-26.88681345899994
						],
						[
							153.10936610400006,
							-26.841433457999983
						],
						[
							153.11943612400012,
							-26.833279448999974
						],
						[
							153.12456503700002,
							-26.80662640999998
						],
						[
							153.1513591050001,
							-26.802173481999944
						],
						[
							153.13700413000004,
							-26.773406420999947
						],
						[
							153.13940423100007,
							-26.679183449999982
						],
						[
							153.12480803200003,
							-26.682711428999937
						],
						[
							153.10621810700002,
							-26.66451044699994
						],
						[
							153.0949731170001,
							-26.672644445999936
						],
						[
							153.1196391200001,
							-26.707037447999937
						],
						[
							153.11354114000005,
							-26.71372643799998
						],
						[
							153.06056712600002,
							-26.711138451999943
						],
						[
							153.04433436600004,
							-26.72307824099994
						],
						[
							153.02223213000002,
							-26.71109243899997
						],
						[
							153.00193112600004,
							-26.679274435999957
						],
						[
							152.96448019000002,
							-26.676014262999956
						],
						[
							152.93865188600012,
							-26.65222892999998
						],
						[
							152.90067834900003,
							-26.654975965999938
						],
						[
							152.9018780980001,
							-26.66268245599997
						],
						[
							152.88582416000008,
							-26.66052343499996
						],
						[
							152.87917502900007,
							-26.67191340399995
						],
						[
							152.85460418200012,
							-26.66764288199994
						],
						[
							152.84501318200012,
							-26.677326440999934
						],
						[
							152.81575916600002,
							-26.672740417999933
						],
						[
							152.81434669500004,
							-26.680407927999966
						],
						[
							152.80639837600006,
							-26.679686146999927
						],
						[
							152.79176479800003,
							-26.677567284999952
						],
						[
							152.79631266800004,
							-26.668751275999966
						],
						[
							152.78890850300002,
							-26.638080384999967
						],
						[
							152.77448910400005,
							-26.641463682999984
						],
						[
							152.7734571730001,
							-26.64742941299994
						],
						[
							152.74642513700007,
							-26.63688671099993
						],
						[
							152.74127034600008,
							-26.649259579999978
						],
						[
							152.73402717700003,
							-26.648589768999955
						],
						[
							152.736801645,
							-26.660501369999963
						],
						[
							152.7302952660001,
							-26.659662408999964
						],
						[
							152.71540627100012,
							-26.635061866999933
						],
						[
							152.7007001620001,
							-26.633307395999964
						],
						[
							152.69693818400003,
							-26.622529404999966
						],
						[
							152.6845211750001,
							-26.626669413999934
						],
						[
							152.67390117700006,
							-26.621217402999946
						],
						[
							152.676575167,
							-26.61533041299998
						],
						[
							152.66615017800007,
							-26.61618041199995
						],
						[
							152.66368416700004,
							-26.62909540199996
						],
						[
							152.65223616800006,
							-26.629784400999938
						],
						[
							152.6456411570001,
							-26.639124400999947
						],
						[
							152.6506021660001,
							-26.64548039099998
						],
						[
							152.63594117700006,
							-26.651909399999965
						],
						[
							152.62464916600004,
							-26.67271440899998
						],
						[
							152.66052118200002,
							-26.669826391999948
						],
						[
							152.6561361790001,
							-26.699104401999932
						],
						[
							152.6486051710001,
							-26.691331400999957
						],
						[
							152.63437616200008,
							-26.691553399999975
						],
						[
							152.63255057000003,
							-26.708505559999935
						],
						[
							152.61640188100012,
							-26.716632777999962
						],
						[
							152.6082071200001,
							-26.73313486799998
						],
						[
							152.5868261820001,
							-26.733450424999944
						],
						[
							152.58331335200012,
							-26.740419504999977
						],
						[
							152.60246197700008,
							-26.757867776999944
						],
						[
							152.63908819300002,
							-26.761764400999937
						],
						[
							152.64433656100005,
							-26.77373479099998
						],
						[
							152.65426920100003,
							-26.768185011999947
						],
						[
							152.6673091890001,
							-26.77299640399997
						],
						[
							152.66898369700004,
							-26.78980119399995
						],
						[
							152.67922015400006,
							-26.799864414999945
						],
						[
							152.69879816200012,
							-26.80296939699997
						],
						[
							152.69645315100001,
							-26.80911541699993
						],
						[
							152.72223513900008,
							-26.80680241899995
						],
						[
							152.72907614700011,
							-26.816616409999938
						],
						[
							152.73917814700008,
							-26.80801441099993
						],
						[
							152.74860514500006,
							-26.81643041199993
						],
						[
							152.7530811470001,
							-26.797340411999983
						],
						[
							152.75918916600006,
							-26.803038412999967
						],
						[
							152.7611021670001,
							-26.792350402999944
						],
						[
							152.77646212500008,
							-26.795531404999963
						],
						[
							152.7771861430001,
							-26.80950242499995
						],
						[
							152.78937312200003,
							-26.809615425999937
						],
						[
							152.79192114900002,
							-26.827255416999947
						],
						[
							152.81252714700008,
							-26.828046418999975
						],
						[
							152.83206614100004,
							-26.856413420999957
						],
						[
							152.85404212900005,
							-26.855854422999982
						],
						[
							152.85170711800004,
							-26.865183412999954
						],
						[
							152.8694831250001,
							-26.87286443499994
						],
						[
							152.8667881140001,
							-26.88890942499995
						],
						[
							152.85549413500007,
							-26.887369432999947
						],
						[
							152.8553045530001,
							-26.901871762999974
						],
						[
							152.86114973300005,
							-26.902730263999956
						],
						[
							152.8594678820001,
							-26.911291853999955
						],
						[
							152.8754522600001,
							-26.913509415999954
						],
						[
							152.87250210800005,
							-26.93050142499993
						],
						[
							152.86084612800005,
							-26.935899423999956
						],
						[
							152.85801758600007,
							-26.956204283999966
						],
						[
							152.89116119200003,
							-26.960737437999967
						],
						[
							152.91726814000003,
							-26.95469343999997
						],
						[
							152.95190809500002,
							-26.96612943399998
						],
						[
							152.96663909200004,
							-26.978792424999938
						],
						[
							152.97501708200002,
							-26.974367435999966
						],
						[
							152.9755941100001,
							-26.98466743599994
						],
						[
							153.01685910700007,
							-26.97905444999998
						],
						[
							153.0184601080001,
							-26.96634242999994
						],
						[
							153.04276808500003,
							-26.96944644299998
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "310",
				"CED_NAME21": "Fisher",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 1199.293,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/310",
				"SHAPE_Leng": 2.60833471295,
				"SHAPE_Area": 0.108846957414
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								152.38226441400002,
								-24.796742369999947
							],
							[
								152.37763950800002,
								-24.76826536899995
							],
							[
								152.39118052900005,
								-24.747742399999936
							],
							[
								152.39672348800002,
								-24.75061735099996
							],
							[
								152.37888657200006,
								-24.732034338999938
							],
							[
								152.34656432500003,
								-24.73246435599998
							],
							[
								152.36504850300003,
								-24.736671307999927
							],
							[
								152.33365650500002,
								-24.743624344999944
							],
							[
								152.3477832750001,
								-24.738060375999964
							],
							[
								152.2742835250001,
								-24.711915378999947
							],
							[
								152.20626838700002,
								-24.657193390999964
							],
							[
								152.17804655100008,
								-24.64750136899994
							],
							[
								152.14831055600007,
								-24.626546305999966
							],
							[
								152.09616852800002,
								-24.570896329999982
							],
							[
								152.0600184970001,
								-24.518203335999942
							],
							[
								152.0440286480001,
								-24.525037364999946
							],
							[
								152.0575826380001,
								-24.51198331599994
							],
							[
								152.042208511,
								-24.498600323999938
							],
							[
								152.0058636120001,
								-24.433664319999934
							],
							[
								151.94341338000004,
								-24.240135332999955
							],
							[
								151.9204334950001,
								-24.210875339999973
							],
							[
								151.9062105370001,
								-24.20783031899998
							],
							[
								151.88632352600007,
								-24.149425315999963
							],
							[
								151.88282361300003,
								-24.175496325999973
							],
							[
								151.8690136130001,
								-24.189586274999954
							],
							[
								151.8789834810001,
								-24.19366634599993
							],
							[
								151.87023366200003,
								-24.194776324999964
							],
							[
								151.84914451100008,
								-24.218456302999982
							],
							[
								151.8658334040001,
								-24.179306304999955
							],
							[
								151.8758233840001,
								-24.171536325999966
							],
							[
								151.83593468700008,
								-24.17688628199994
							],
							[
								151.82131469000012,
								-24.165356309999936
							],
							[
								151.84062439700006,
								-24.17068629199997
							],
							[
								151.80475472400008,
								-24.14579632899995
							],
							[
								151.79311450700004,
								-24.126246266999942
							],
							[
								151.78475454800002,
								-24.121936336999966
							],
							[
								151.78510447700012,
								-24.129386266999973
							],
							[
								151.78425453800003,
								-24.12430629599993
							],
							[
								151.7714849780001,
								-24.12951626499995
							],
							[
								151.78673456800004,
								-24.117646296999965
							],
							[
								151.7679447370001,
								-24.060156293999967
							],
							[
								151.7646446320001,
								-24.01521631399993
							],
							[
								151.75338453300003,
								-24.018386282999927
							],
							[
								151.7384157360001,
								-24.00324631099994
							],
							[
								151.74490050200006,
								-24.03200813199993
							],
							[
								151.73492556200006,
								-24.04190726099995
							],
							[
								151.74143056100002,
								-24.042278241999952
							],
							[
								151.7383506110001,
								-24.046778290999953
							],
							[
								151.7253157020001,
								-24.049787299999934
							],
							[
								151.73216072000002,
								-24.061898390999943
							],
							[
								151.71585106800012,
								-24.087248559999978
							],
							[
								151.7208254300001,
								-24.06896727999998
							],
							[
								151.71581099200012,
								-24.058128478999947
							],
							[
								151.70279553300009,
								-24.05639724799994
							],
							[
								151.71153103300003,
								-24.052358518999938
							],
							[
								151.7045656350001,
								-24.039807287999963
							],
							[
								151.7199455640001,
								-24.03543732999998
							],
							[
								151.73030565400006,
								-24.022486329999936
							],
							[
								151.69764574900012,
								-24.011567256999967
							],
							[
								151.67305665300012,
								-23.989367304999973
							],
							[
								151.6442919970001,
								-23.97736865199994
							],
							[
								151.61056264,
								-23.979238608999935
							],
							[
								151.60437274700007,
								-24.008828767999944
							],
							[
								151.63016218500002,
								-24.01308882099994
							],
							[
								151.63817203600001,
								-23.996928731999958
							],
							[
								151.64163194500009,
								-24.002618781999956
							],
							[
								151.63537208600007,
								-23.99977875099995
							],
							[
								151.6328721650001,
								-24.011288820999937
							],
							[
								151.63992199400002,
								-24.01188881199994
							],
							[
								151.63568211400002,
								-24.01637884099995
							],
							[
								151.64683644100012,
								-24.02756727299993
							],
							[
								151.63759212200011,
								-24.032858921999946
							],
							[
								151.65197180000007,
								-24.03222894299995
							],
							[
								151.6691116170001,
								-24.05191885499994
							],
							[
								151.67748150600005,
								-24.049568785999952
							],
							[
								151.68566144300007,
								-24.067308736999962
							],
							[
								151.67546652400006,
								-24.066147305999948
							],
							[
								151.67045163600005,
								-24.057448844999954
							],
							[
								151.66466171600007,
								-24.060478864999936
							],
							[
								151.6841215810001,
								-24.088868746999935
							],
							[
								151.68247171000007,
								-24.10409873699996
							],
							[
								151.67826657900002,
								-24.110287265999943
							],
							[
								151.67551652200007,
								-24.088487295999983
							],
							[
								151.67117185100005,
								-24.098538804999976
							],
							[
								151.66531185300005,
								-24.084638824999956
							],
							[
								151.65730200300004,
								-24.090488883999967
							],
							[
								151.65195668600006,
								-24.073637282999982
							],
							[
								151.64504216600005,
								-24.080398942999977
							],
							[
								151.63468222900008,
								-24.05576898199996
							],
							[
								151.62103776100003,
								-24.05503724999994
							],
							[
								151.6103926830001,
								-24.042488918999936
							],
							[
								151.58270324500006,
								-24.04984899699997
							],
							[
								151.57366332700008,
								-24.035708985999975
							],
							[
								151.56492347800008,
								-24.036919014999967
							],
							[
								151.5553237150001,
								-24.069959163999954
							],
							[
								151.5759433620001,
								-24.077589115999956
							],
							[
								151.58009334100007,
								-24.087089126999956
							],
							[
								151.5604736040001,
								-24.07358915499998
							],
							[
								151.56363863,
								-24.111398314999974
							],
							[
								151.55986365100011,
								-24.099769244999948
							],
							[
								151.55515377100005,
								-24.109119274999955
							],
							[
								151.55281379400003,
								-24.081689233999953
							],
							[
								151.5474438320001,
								-24.10107930399994
							],
							[
								151.55207382100002,
								-24.11023928399993
							],
							[
								151.54542392100007,
								-24.11326930399997
							],
							[
								151.54773383400004,
								-24.089339263999932
							],
							[
								151.52474419600003,
								-24.088919381999972
							],
							[
								151.51732433900008,
								-24.07026929099993
							],
							[
								151.52684415900012,
								-24.06025920199994
							],
							[
								151.50106559300002,
								-24.04498820899994
							],
							[
								151.5010655630001,
								-24.039830208999945
							],
							[
								151.52683412200008,
								-24.035089140999958
							],
							[
								151.54439387000002,
								-24.03751907299994
							],
							[
								151.54394382100008,
								-24.029279062999933
							],
							[
								151.4675610920001,
								-23.99471918499995
							],
							[
								151.45493136200002,
								-23.998406143999944
							],
							[
								151.44050765400004,
								-23.992020182999966
							],
							[
								151.4415885620001,
								-24.01580129299998
							],
							[
								151.4703601970001,
								-24.03820223599996
							],
							[
								151.47480906700002,
								-24.033630225999957
							],
							[
								151.4795150430001,
								-24.060659276999957
							],
							[
								151.4937907410001,
								-24.066999317999944
							],
							[
								151.48433093100004,
								-24.074697337999964
							],
							[
								151.48053701300012,
								-24.064521296999942
							],
							[
								151.47190914300006,
								-24.063886305999972
							],
							[
								151.47178613300002,
								-24.072807315999967
							],
							[
								151.46578827300004,
								-24.07194431599993
							],
							[
								151.46680925400005,
								-24.059295275999943
							],
							[
								151.4619563550001,
								-24.05503727499996
							],
							[
								151.46042237400002,
								-24.064982304999944
							],
							[
								151.455323506,
								-24.056806284999936
							],
							[
								151.4572743980001,
								-24.03742323499995
							],
							[
								151.44349868000006,
								-24.026025242999935
							],
							[
								151.44037275000005,
								-24.03518126299997
							],
							[
								151.448241638,
								-24.04724028399994
							],
							[
								151.44232173700004,
								-24.058452303999957
							],
							[
								151.4479836160001,
								-24.06234229399996
							],
							[
								151.44042873500007,
								-24.077259303999938
							],
							[
								151.4245660900001,
								-24.046007311999972
							],
							[
								151.43543882100005,
								-24.02643126299995
							],
							[
								151.42699455600007,
								-23.98764928199995
							],
							[
								151.36849462700002,
								-23.938787265999963
							],
							[
								151.35483074900003,
								-23.935754273999976
							],
							[
								151.31859161900002,
								-23.87388625999995
							],
							[
								151.3167526410001,
								-23.85685025999993
							],
							[
								151.32316763000006,
								-23.85474925099993
							],
							[
								151.2807074740001,
								-23.855560226999955
							],
							[
								151.27453565700011,
								-23.83633025599994
							],
							[
								151.25203763900004,
								-23.832161243999963
							],
							[
								151.23296165300007,
								-23.81550624199997
							],
							[
								151.19282574500005,
								-23.826986097999963
							],
							[
								151.17295707800008,
								-23.81589610599997
							],
							[
								151.16452529100002,
								-23.795555134999972
							],
							[
								151.18423065000002,
								-23.793072226999982
							],
							[
								151.16990667200002,
								-23.785614235999958
							],
							[
								151.16534165500002,
								-23.763432234999982
							],
							[
								151.1557676650001,
								-23.76813924399994
							],
							[
								151.15472767400001,
								-23.779157233999968
							],
							[
								151.14419570600012,
								-23.770010052999965
							],
							[
								151.15941156700012,
								-23.747597024999948
							],
							[
								151.1511327500001,
								-23.728397063999978
							],
							[
								151.13270252400002,
								-23.70729727199995
							],
							[
								151.12375812400012,
								-23.71303414099998
							],
							[
								151.12406410500012,
								-23.704242140999952
							],
							[
								151.10957334600005,
								-23.704081179999946
							],
							[
								151.11770021600012,
								-23.700282159999972
							],
							[
								151.1110602870001,
								-23.696429189999947
							],
							[
								151.1346499450001,
								-23.698374171999944
							],
							[
								151.1217712890001,
								-23.671390199999962
							],
							[
								151.10946349100004,
								-23.661344218999943
							],
							[
								151.08865582300007,
								-23.66023421699998
							],
							[
								151.09721767200006,
								-23.65886619799994
							],
							[
								151.08641085400006,
								-23.65704220699996
							],
							[
								151.08969286400009,
								-23.65040020699996
							],
							[
								151.0811109540001,
								-23.65434120699996
							],
							[
								151.0844469750001,
								-23.647162226999967
							],
							[
								151.0458107810001,
								-23.627848232999952
							],
							[
								151.02655758800006,
								-23.571999180999967
							],
							[
								150.9753987250001,
								-23.555399215999955
							],
							[
								150.9680486000001,
								-23.605109175999928
							],
							[
								150.9253166320001,
								-23.62276024199997
							],
							[
								150.9325385530001,
								-23.609659231999956
							],
							[
								150.95858853100003,
								-23.600409214999956
							],
							[
								150.95699877700008,
								-23.55028919399996
							],
							[
								150.9345596400001,
								-23.543939241999965
							],
							[
								150.8903498210001,
								-23.572209227999963
							],
							[
								150.86849869200012,
								-23.57674920599993
							],
							[
								150.87989976300003,
								-23.562209236999934
							],
							[
								150.87940471500008,
								-23.54219719699995
							],
							[
								150.84602470800007,
								-23.536469203999957
							],
							[
								150.79064570700007,
								-23.505957208999973
							],
							[
								150.77284272800011,
								-23.506615196999974
							],
							[
								150.7269747140001,
								-23.491394182999954
							],
							[
								150.70575470400001,
								-23.505829200999983
							],
							[
								150.68111874700003,
								-23.498064188999933
							],
							[
								150.64952372800008,
								-23.517821185999935
							],
							[
								150.63797271900012,
								-23.516865184999972
							],
							[
								150.63786373000005,
								-23.507431184999973
							],
							[
								150.66047470900003,
								-23.49758518699997
							],
							[
								150.6617517400001,
								-23.491224186999943
							],
							[
								150.6350837430001,
								-23.484545183999955
							],
							[
								150.62445972700004,
								-23.455771182999968
							],
							[
								150.60472674000005,
								-23.44590317099994
							],
							[
								150.55191625200007,
								-23.377609365999945
							],
							[
								150.5304559320001,
								-23.39345540399995
							],
							[
								150.5477740760001,
								-23.436502765999933
							],
							[
								150.54123824600003,
								-23.446757514999945
							],
							[
								150.51971076900008,
								-23.42844758299998
							],
							[
								150.50683174000005,
								-23.432659161999936
							],
							[
								150.46756650400005,
								-23.426778118999948
							],
							[
								150.44749128800004,
								-23.40911009699994
							],
							[
								150.42942095000012,
								-23.40813318499994
							],
							[
								150.43529978300012,
								-23.371728144999963
							],
							[
								150.4493686300001,
								-23.384489176999978
							],
							[
								150.46713763900004,
								-23.37866583799996
							],
							[
								150.49321812900007,
								-23.35855442999997
							],
							[
								150.49389411100003,
								-23.340697509999927
							],
							[
								150.47882833500012,
								-23.31727456899995
							],
							[
								150.45932802400011,
								-23.338551456999937
							],
							[
								150.44764970500012,
								-23.33748348599994
							],
							[
								150.45233466700006,
								-23.315436555999952
							],
							[
								150.4352999020001,
								-23.289226604999953
							],
							[
								150.42130339800008,
								-23.244923462999964
							],
							[
								150.39710044000003,
								-23.241006610999932
							],
							[
								150.36631849000003,
								-23.266540917999976
							],
							[
								150.34212125500005,
								-23.246109495999974
							],
							[
								150.34416905500007,
								-23.237930495999933
							],
							[
								150.40156679500012,
								-23.191749150999954
							],
							[
								150.38456995800004,
								-23.18049075899995
							],
							[
								150.38243550900006,
								-23.16883194899998
							],
							[
								150.39312927900005,
								-23.15810614999998
							],
							[
								150.3832117620001,
								-23.142064318999928
							],
							[
								150.36760293300006,
								-23.14683958699993
							],
							[
								150.29772417000004,
								-23.137939950999964
							],
							[
								150.250271547,
								-23.11255476699995
							],
							[
								150.21584395000002,
								-23.10824280299994
							],
							[
								150.16242167100006,
								-23.145615628999963
							],
							[
								150.134052966,
								-23.12228495599993
							],
							[
								150.13492987900008,
								-23.09626206599995
							],
							[
								150.06717960600008,
								-23.08529771999997
							],
							[
								150.07815344900007,
								-23.04757781099994
							],
							[
								150.06478861100004,
								-23.035031018999973
							],
							[
								150.0330669330001,
								-23.044422096999938
							],
							[
								150.02413104100003,
								-23.073416055999928
							],
							[
								149.99580832200002,
								-23.087175163999973
							],
							[
								149.925479031,
								-23.056814716999952
							],
							[
								149.932562952,
								-23.03927079799996
							],
							[
								149.92851806600004,
								-23.01049306699997
							],
							[
								149.9102182480001,
								-23.008113205999962
							],
							[
								149.9012783400001,
								-22.996253354999965
							],
							[
								149.8796685520001,
								-22.988223482999956
							],
							[
								149.8662886730001,
								-22.994043561999945
							],
							[
								149.85064882500012,
								-22.986783659999958
							],
							[
								149.8466288940001,
								-22.998423659999958
							],
							[
								149.83564900500005,
								-22.99911366899994
							],
							[
								149.82319910800004,
								-22.980923787999927
							],
							[
								149.77846952900006,
								-23.014483893999966
							],
							[
								149.7312300320001,
								-23.025884239999982
							],
							[
								149.7196101410001,
								-23.04152431899996
							],
							[
								149.72701011900006,
								-23.05717420999997
							],
							[
								149.69736047000004,
								-23.071172416999957
							],
							[
								149.67263289100003,
								-23.08204814499993
							],
							[
								149.6369218850001,
								-23.074248091999948
							],
							[
								149.61704387500004,
								-23.09341010099996
							],
							[
								149.50192788200002,
								-23.123897090999947
							],
							[
								149.4782358760001,
								-23.108188088999952
							],
							[
								149.49153388600007,
								-23.09092107999993
							],
							[
								149.48579288000008,
								-23.057800078999946
							],
							[
								149.43940288700003,
								-23.03073907499993
							],
							[
								149.4281988790001,
								-23.018553063999946
							],
							[
								149.427468921,
								-23.004379073999928
							],
							[
								149.41225890300007,
								-22.993693081999936
							],
							[
								149.4220569260001,
								-22.95724506299996
							],
							[
								149.4144958810001,
								-22.916559071999927
							],
							[
								149.4034279130001,
								-22.897783070999935
							],
							[
								149.38113492600007,
								-22.894868078999934
							],
							[
								149.36551792900002,
								-22.876794076999943
							],
							[
								149.3318198920001,
								-22.87513006399996
							],
							[
								149.33024290000003,
								-22.89861805399994
							],
							[
								149.31252788100005,
								-22.906364062999955
							],
							[
								149.30389292900009,
								-22.925797071999966
							],
							[
								149.28542590000006,
								-22.941754060999983
							],
							[
								149.28725290800003,
								-22.95596705099996
							],
							[
								149.23717790000012,
								-22.975981056999956
							],
							[
								149.22908891800012,
								-23.00298605699993
							],
							[
								149.19921392600008,
								-23.049901053999974
							],
							[
								149.17986191800003,
								-23.048225052999953
							],
							[
								149.1251089320001,
								-23.062696037999956
							],
							[
								149.11143092400005,
								-23.056033036999963
							],
							[
								149.04429990900007,
								-23.058834050999963
							],
							[
								149.02536789900012,
								-23.08140304999995
							],
							[
								148.97616193200008,
								-23.094529035999983
							],
							[
								148.97352289900005,
								-23.125074035999944
							],
							[
								148.99055390700005,
								-23.129696036999974
							],
							[
								148.98731091600007,
								-23.14376804699998
							],
							[
								149.00574491400005,
								-23.15020703899995
							],
							[
								149.00633990200004,
								-23.166682028999958
							],
							[
								148.98544690100005,
								-23.194496037999954
							],
							[
								148.9746558920001,
								-23.192805026999963
							],
							[
								148.966681923,
								-23.197120045999952
							],
							[
								148.97044791200005,
								-23.20451303599998
							],
							[
								148.953397923,
								-23.207795044999955
							],
							[
								148.9481079100001,
								-23.240547034999963
							],
							[
								148.92568092200008,
								-23.245601032999957
							],
							[
								148.9250949100001,
								-23.261943042999974
							],
							[
								148.89803794300008,
								-23.261434030999965
							],
							[
								148.87915992600006,
								-23.247794028999976
							],
							[
								148.873417925,
								-23.26048303899995
							],
							[
								148.85577590600008,
								-23.265916016999938
							],
							[
								148.84530390500004,
								-23.28933002699995
							],
							[
								148.8689879100001,
								-23.319128038999963
							],
							[
								148.86565089600003,
								-23.356075028999953
							],
							[
								148.825668908,
								-23.37948102599995
							],
							[
								148.79965292200006,
								-23.362356012999953
							],
							[
								148.7968399030001,
								-23.352385012999946
							],
							[
								148.7806639040001,
								-23.35114102199998
							],
							[
								148.77544093300003,
								-23.373946020999938
							],
							[
								148.75857092400008,
								-23.381177029999947
							],
							[
								148.74753792500007,
								-23.37909701899997
							],
							[
								148.73605393900004,
								-23.347876027999973
							],
							[
								148.71345493,
								-23.35262301599994
							],
							[
								148.70457795000004,
								-23.365822024999943
							],
							[
								148.712477927,
								-23.386403015999974
							],
							[
								148.68152494800006,
								-23.404721003999953
							],
							[
								148.6723609270001,
								-23.421080022999945
							],
							[
								148.70554391300004,
								-23.435312015999955
							],
							[
								148.67852091400005,
								-23.449358013999927
							],
							[
								148.65424790400004,
								-23.476066011999933
							],
							[
								148.63501791500005,
								-23.476587010999936
							],
							[
								148.6341539220001,
								-23.509694020999973
							],
							[
								148.61867489100007,
								-23.535814999999957
							],
							[
								148.5925909030001,
								-23.543297007999968
							],
							[
								148.5811919150001,
								-23.531057996999948
							],
							[
								148.57198993400004,
								-23.551843005999956
							],
							[
								148.53194691700003,
								-23.554869992999954
							],
							[
								148.52282495000009,
								-23.53797400199994
							],
							[
								148.52268293300006,
								-23.505365791999964
							],
							[
								148.57298391200004,
								-23.468946004999964
							],
							[
								148.55038995000007,
								-23.406903002999968
							],
							[
								148.5704929410001,
								-23.379282004999936
							],
							[
								148.55034892600008,
								-23.346816992999948
							],
							[
								148.502673952,
								-23.330313988999933
							],
							[
								148.51216792500009,
								-23.28901000899998
							],
							[
								148.582504964,
								-23.233925003999957
							],
							[
								148.56522892600003,
								-23.22194299299997
							],
							[
								148.62442995800006,
								-23.148967006999953
							],
							[
								148.57919496500006,
								-23.11751800299993
							],
							[
								148.5622749570001,
								-23.115882991999968
							],
							[
								148.58783397900004,
								-23.071455002999983
							],
							[
								148.5997129750001,
								-23.002843003999942
							],
							[
								148.58496997600002,
								-23.00053599299997
							],
							[
								148.5809519490001,
								-22.971671001999937
							],
							[
								148.55444897100006,
								-22.974655009999935
							],
							[
								148.55030899300004,
								-22.957221998999955
							],
							[
								148.54258899400008,
								-22.959401318999937
							],
							[
								148.5526959550001,
								-22.941806998999937
							],
							[
								148.5401719670001,
								-22.923373007999942
							],
							[
								148.5419059720001,
								-22.87729000799993
							],
							[
								148.4580749700001,
								-22.867476990999933
							],
							[
								148.32505799400008,
								-22.949821980999957
							],
							[
								148.29772877000005,
								-22.90948261799997
							],
							[
								148.28867199100011,
								-22.907945987999938
							],
							[
								148.2904289920001,
								-22.89959297799993
							],
							[
								148.2750600060001,
								-22.875584965999963
							],
							[
								148.3263929850001,
								-22.83271297999994
							],
							[
								148.338490986,
								-22.811448990999963
							],
							[
								148.35709200500003,
								-22.808281971999975
							],
							[
								148.37141500500002,
								-22.790542992999974
							],
							[
								148.37383101700004,
								-22.767262982999966
							],
							[
								148.34314102400003,
								-22.725404990999948
							],
							[
								148.23907303200008,
								-22.739751971999965
							],
							[
								148.23084099900007,
								-22.777384971999936
							],
							[
								148.1761490020001,
								-22.79032696699994
							],
							[
								148.14926402600008,
								-22.77931195499997
							],
							[
								148.14351402800003,
								-22.764840964999962
							],
							[
								148.10967802000005,
								-22.767018961999952
							],
							[
								148.06394447700006,
								-22.739481787999978
							],
							[
								148.06076654000003,
								-22.70985967799993
							],
							[
								148.04781634200003,
								-22.697456295999928
							],
							[
								148.02301002500008,
								-22.693102943999975
							],
							[
								148.0130932400001,
								-22.65424114299998
							],
							[
								147.99521013900005,
								-22.674032661999945
							],
							[
								147.99554604800005,
								-22.68963395199995
							],
							[
								147.98526107700002,
								-22.704451950999953
							],
							[
								147.97095387900004,
								-22.70236361999997
							],
							[
								147.931477781,
								-22.71818077699993
							],
							[
								147.91278405200012,
								-22.718737945999976
							],
							[
								147.91475903100002,
								-22.73270498599993
							],
							[
								147.89512144000003,
								-22.76171978499997
							],
							[
								147.87381205100007,
								-22.765643952999937
							],
							[
								147.84513104200005,
								-22.785052940999947
							],
							[
								147.820961075,
								-22.782913938999968
							],
							[
								147.79407627500007,
								-22.800490026999967
							],
							[
								147.755001084,
								-22.856085923999956
							],
							[
								147.70277904600005,
								-22.885801939999965
							],
							[
								147.6943390340001,
								-22.914679939999928
							],
							[
								147.66386803700004,
								-22.912708927999972
							],
							[
								147.66104705600003,
								-22.92105292699995
							],
							[
								147.64051307700004,
								-22.926273915999957
							],
							[
								147.6206500710001,
								-22.912092923999978
							],
							[
								147.61795805200006,
								-22.893873923999934
							],
							[
								147.60158207400002,
								-22.894788912999957
							],
							[
								147.606365062,
								-22.907095932999937
							],
							[
								147.59898805300008,
								-22.90900093199997
							],
							[
								147.5967890720001,
								-22.92343293199997
							],
							[
								147.5878640530001,
								-22.92226992199994
							],
							[
								147.5822920390001,
								-22.962997911999935
							],
							[
								147.56824804100006,
								-22.96167892099993
							],
							[
								147.55541606000008,
								-22.97634819999996
							],
							[
								147.56099785900005,
								-22.98745279999997
							],
							[
								147.5534870790001,
								-22.992648919999965
							],
							[
								147.55304104800007,
								-23.009155909999947
							],
							[
								147.50416408400008,
								-22.98574791599998
							],
							[
								147.49706505400002,
								-23.00088191499998
							],
							[
								147.51999707900006,
								-23.02841390699996
							],
							[
								147.5084030800001,
								-23.02906991599997
							],
							[
								147.48372806100008,
								-23.046647914999937
							],
							[
								147.48746003700012,
								-23.078639904999932
							],
							[
								147.47853005700006,
								-23.09145091499994
							],
							[
								147.46415605800007,
								-23.092209912999976
							],
							[
								147.44151007800008,
								-23.119753921999973
							],
							[
								147.39458004900007,
								-23.14731289799994
							],
							[
								147.35396405900008,
								-23.19037590599993
							],
							[
								147.33992506100003,
								-23.18255090499997
							],
							[
								147.315016043,
								-23.193135902999927
							],
							[
								147.28654305500004,
								-23.193355899999972
							],
							[
								147.26075707600012,
								-23.21011889899995
							],
							[
								147.26076507300002,
								-23.244639898999935
							],
							[
								147.2737530490001,
								-23.27076089999997
							],
							[
								147.28752405700004,
								-23.27908690099997
							],
							[
								147.28004907600007,
								-23.298904910999966
							],
							[
								147.29510506300005,
								-23.322391901999936
							],
							[
								147.2831218230001,
								-23.33069429099993
							],
							[
								147.28662173100008,
								-23.351222871999937
							],
							[
								147.26502348000008,
								-23.384151499999973
							],
							[
								147.25984569500008,
								-23.43805722999997
							],
							[
								147.24940242500008,
								-23.45137859999994
							],
							[
								147.26036884300004,
								-23.46948064099996
							],
							[
								147.2660859130001,
								-23.463283900999954
							],
							[
								147.2792331400001,
								-23.48164639199996
							],
							[
								147.28377946500007,
								-23.52477128299995
							],
							[
								147.25823373600008,
								-23.54307746099994
							],
							[
								147.21944218900012,
								-23.55097763799995
							],
							[
								147.21973915700005,
								-23.56809955799997
							],
							[
								147.21217098700004,
								-23.57605371799997
							],
							[
								147.2200761250001,
								-23.593555928999933
							],
							[
								147.1981550260001,
								-23.609133906999944
							],
							[
								147.21165903200006,
								-23.63948189799993
							],
							[
								147.20057716100007,
								-23.654602077999982
							],
							[
								147.2095370290001,
								-23.67592089799996
							],
							[
								147.1957260490001,
								-23.684486896999942
							],
							[
								147.1936960260001,
								-23.718200897999964
							],
							[
								147.20088302400006,
								-23.733847897999965
							],
							[
								147.19513901400012,
								-23.745558897999956
							],
							[
								147.199784001,
								-23.77329588899994
							],
							[
								147.22956000700003,
								-23.787475900999937
							],
							[
								147.2379670140001,
								-23.810759891999965
							],
							[
								147.22769704300003,
								-23.832098900999938
							],
							[
								147.2365040200001,
								-23.84795091199993
							],
							[
								147.23351400800004,
								-23.881333901999938
							],
							[
								147.2411540050001,
								-23.90318689299994
							],
							[
								147.23899393400006,
								-23.912815792999936
							],
							[
								147.2273827350001,
								-23.914766931999964
							],
							[
								147.2032899950001,
								-23.93980689999995
							],
							[
								147.1786610370001,
								-23.94294890799995
							],
							[
								147.16300582600002,
								-23.972878186999935
							],
							[
								147.17337102400006,
								-23.97804489799995
							],
							[
								147.1838580110001,
								-24.004835898999943
							],
							[
								147.1784090010001,
								-24.016456898999934
							],
							[
								147.18663700800005,
								-24.036039909999943
							],
							[
								147.17417901700003,
								-24.060034908999967
							],
							[
								147.18332299400004,
								-24.085727909999946
							],
							[
								147.16127998500008,
								-24.09297788799995
							],
							[
								147.14152100800004,
								-24.08560889699993
							],
							[
								147.11029500000006,
								-24.09332788399996
							],
							[
								147.07369597100012,
								-24.117682891999948
							],
							[
								147.03741972400007,
								-24.12568413899993
							],
							[
								147.02855500400005,
								-24.140523877999954
							],
							[
								146.98986602500008,
								-24.161298875999933
							],
							[
								146.97367002700003,
								-24.160104883999963
							],
							[
								146.96478399700004,
								-24.167439873999967
							],
							[
								146.9563789980001,
								-24.163580882999952
							],
							[
								146.94974103700008,
								-24.188346872999944
							],
							[
								146.9534250150001,
								-24.206844872999966
							],
							[
								146.94029402500007,
								-24.219254881999973
							],
							[
								146.94370798400007,
								-24.229163882999956
							],
							[
								146.92741901300008,
								-24.256744891999972
							],
							[
								146.92685899100002,
								-24.278972881999948
							],
							[
								146.93512999900008,
								-24.290575871999977
							],
							[
								146.9231000100001,
								-24.294676881999976
							],
							[
								146.89974200900008,
								-24.328542889999937
							],
							[
								146.8737060210001,
								-24.337675867999963
							],
							[
								146.86424400900012,
								-24.36877988799995
							],
							[
								146.81436399300003,
								-24.376695883999957
							],
							[
								146.80210798100006,
								-24.40676687299998
							],
							[
								146.75952602600012,
								-24.403660869999953
							],
							[
								146.7297080070001,
								-24.418538857999977
							],
							[
								146.72193304100006,
								-24.384687876999976
							],
							[
								146.68899500500004,
								-24.374228864999964
							],
							[
								146.65981792600007,
								-24.40332901299996
							],
							[
								146.6417250280001,
								-24.399146860999963
							],
							[
								146.59587103100012,
								-24.417173867999963
							],
							[
								146.57246540300002,
								-24.41283380599998
							],
							[
								146.58689601000003,
								-24.427740866999955
							],
							[
								146.59605801700002,
								-24.452998857999944
							],
							[
								146.60811100500007,
								-24.46130385899994
							],
							[
								146.6212980140001,
								-24.45801285999994
							],
							[
								146.62609200100007,
								-24.493746870999928
							],
							[
								146.63993100900007,
								-24.50019785199993
							],
							[
								146.64588900600006,
								-24.523329872999966
							],
							[
								146.66137000300012,
								-24.54060887399993
							],
							[
								146.66410101100007,
								-24.562418873999945
							],
							[
								146.6796299980001,
								-24.572813854999936
							],
							[
								146.68003299800012,
								-24.58085586599998
							],
							[
								146.66681597800005,
								-24.59080086499995
							],
							[
								146.6895109840001,
								-24.611570856999947
							],
							[
								146.73937399800002,
								-24.62913986999996
							],
							[
								146.74051428600012,
								-24.650327250999965
							],
							[
								146.7579170130001,
								-24.66334587199998
							],
							[
								146.77416298100002,
								-24.66275287299993
							],
							[
								146.78742368300004,
								-24.62627733399995
							],
							[
								146.80011999200008,
								-24.620572874999937
							],
							[
								146.8085504700001,
								-24.63898607599998
							],
							[
								146.81905900000004,
								-24.626009875999955
							],
							[
								146.83394778900004,
								-24.62432558699993
							],
							[
								146.8607170990001,
								-24.587316598999962
							],
							[
								146.87854497600006,
								-24.60132689099993
							],
							[
								146.88700998600007,
								-24.59668788099998
							],
							[
								146.88404935500012,
								-24.61157032099993
							],
							[
								146.89413697100008,
								-24.640281871999946
							],
							[
								146.93325397400008,
								-24.674890884999968
							],
							[
								146.94201897100004,
								-24.70434989599994
							],
							[
								146.92088197200007,
								-24.716623884999933
							],
							[
								146.90947298000003,
								-24.743816883999955
							],
							[
								146.88227993100008,
								-24.76247387199993
							],
							[
								146.88028897100003,
								-24.773392891999947
							],
							[
								146.90338864500006,
								-24.805178643999966
							],
							[
								147.09155393600008,
								-24.814114898999946
							],
							[
								147.089431353,
								-24.846453518999965
							],
							[
								147.13884292800003,
								-24.84898089199993
							],
							[
								147.13663091500007,
								-24.882868902999974
							],
							[
								147.29640092800003,
								-24.89578792499998
							],
							[
								147.30537689800008,
								-24.884951915999977
							],
							[
								147.31734389700011,
								-24.884879916999978
							],
							[
								147.32210290800003,
								-24.87045990699994
							],
							[
								147.36596390300008,
								-24.877424919999953
							],
							[
								147.38096791200007,
								-24.87077993099996
							],
							[
								147.41972546700003,
								-24.88135663399993
							],
							[
								147.48362510100003,
								-24.876969568999982
							],
							[
								147.50897990300007,
								-24.83489193099996
							],
							[
								147.50826990400003,
								-24.820697940999935
							],
							[
								147.5187408820001,
								-24.830183921999947
							],
							[
								147.54244288100006,
								-24.81754792399994
							],
							[
								147.5583338890001,
								-24.81916693499994
							],
							[
								147.560535898,
								-24.834253924999928
							],
							[
								147.57854590600004,
								-24.836023935999947
							],
							[
								147.58960689600008,
								-24.81839793699993
							],
							[
								147.64705486200012,
								-24.79994095199993
							],
							[
								147.64658690500005,
								-24.77319394099993
							],
							[
								147.68045390200007,
								-24.77383193399993
							],
							[
								147.73523288,
								-24.73030795799997
							],
							[
								147.75968287800004,
								-24.72799894999997
							],
							[
								147.7740778860001,
								-24.738968950999947
							],
							[
								147.79130888500003,
								-24.73074694199994
							],
							[
								147.82444186100008,
								-24.735078964999957
							],
							[
								147.8281438690001,
								-24.75180196599996
							],
							[
								147.8480098660001,
								-24.765030966999973
							],
							[
								147.8541938840001,
								-24.779579957999943
							],
							[
								147.8861248400001,
								-24.793772959999956
							],
							[
								147.9008238660001,
								-24.814337961999968
							],
							[
								147.9165428440001,
								-24.821171962999983
							],
							[
								147.9158278420001,
								-24.84605196299998
							],
							[
								147.93793884800004,
								-24.861558954999964
							],
							[
								147.95195184400006,
								-24.883193965999965
							],
							[
								147.97322846300005,
								-24.881520717999933
							],
							[
								147.9950883790001,
								-24.89946170999997
							],
							[
								148.0117695770001,
								-24.89785208099994
							],
							[
								148.02965760400002,
								-24.911351052999976
							],
							[
								148.05614229100001,
								-24.913712634999968
							],
							[
								148.0762091460001,
								-24.945406446999982
							],
							[
								148.07633266300002,
								-24.978561296999942
							],
							[
								148.0957765270001,
								-25.016517378999936
							],
							[
								148.11639526500005,
								-25.022797220999962
							],
							[
								148.12162126200008,
								-25.04200050099996
							],
							[
								148.13384314100006,
								-25.04252557199993
							],
							[
								148.16059679400007,
								-25.084144984999966
							],
							[
								148.20600881000007,
								-25.079229977999944
							],
							[
								148.2346884650001,
								-25.100656150999953
							],
							[
								148.24199178300012,
								-25.12050598199994
							],
							[
								148.2959449430001,
								-25.164857705999964
							],
							[
								148.29291577200001,
								-25.181864995999945
							],
							[
								148.30558378700005,
								-25.21227899799993
							],
							[
								148.3262377750001,
								-25.21027000899994
							],
							[
								148.3477369320001,
								-25.220125030999952
							],
							[
								148.3520477610001,
								-25.229081991999976
							],
							[
								148.3965267650001,
								-25.243454004999933
							],
							[
								148.41219176200002,
								-25.260130016999938
							],
							[
								148.42339175200004,
								-25.24929600799993
							],
							[
								148.45138476800003,
								-25.25472099999996
							],
							[
								148.47303276700006,
								-25.245424011999944
							],
							[
								148.5324327510001,
								-25.244089025999983
							],
							[
								148.55435672800002,
								-25.254081027999973
							],
							[
								148.56846474700012,
								-25.249924018999934
							],
							[
								148.60008673200002,
								-25.27284402199996
							],
							[
								148.64312573600012,
								-25.284112025999946
							],
							[
								148.66631875100006,
								-25.310842007999952
							],
							[
								148.6836807420001,
								-25.281904038999983
							],
							[
								148.69986374100006,
								-25.284549040999934
							],
							[
								148.70837675000007,
								-25.27750303099998
							],
							[
								148.727494717,
								-25.287922032999973
							],
							[
								148.7363387380001,
								-25.27839903399996
							],
							[
								148.74526273700008,
								-25.27970903399995
							],
							[
								148.75916671200002,
								-25.31071004599994
							],
							[
								148.74776473300005,
								-25.314813044999937
							],
							[
								148.7473877220001,
								-25.32416303499997
							],
							[
								148.72668371200007,
								-25.342541022999967
							],
							[
								148.7189857180001,
								-25.386940032999973
							],
							[
								148.72589771600008,
								-25.400838043999954
							],
							[
								148.76178572100002,
								-25.417363036999973
							],
							[
								148.7759547280001,
								-25.434929027999942
							],
							[
								148.80074070400008,
								-25.445908049999957
							],
							[
								148.81093070400004,
								-25.441013040999962
							],
							[
								148.814910692,
								-25.45198204199994
							],
							[
								148.83344768900008,
								-25.459938042999966
							],
							[
								148.8728667050001,
								-25.46122205599994
							],
							[
								148.87685969400002,
								-25.469759046999968
							],
							[
								148.9004427010001,
								-25.472444048999932
							],
							[
								148.93892669800005,
								-25.463758061999954
							],
							[
								148.93805368900007,
								-25.45857504199995
							],
							[
								149.02432470000008,
								-25.559786049999957
							],
							[
								148.98372367100012,
								-25.58866005699997
							],
							[
								148.98565466800005,
								-25.613440066999942
							],
							[
								148.99539669700005,
								-25.617552057999944
							],
							[
								148.9922956590001,
								-25.601277057999937
							],
							[
								149.01969967600007,
								-25.604000059999976
							],
							[
								149.025812695,
								-25.611047060999965
							],
							[
								149.01270068600002,
								-25.612374058999933
							],
							[
								149.03814067100006,
								-25.62928506199995
							],
							[
								149.03255468100008,
								-25.640572060999943
							],
							[
								149.04571066100004,
								-25.62393007199995
							],
							[
								149.05696664000004,
								-25.625126062999982
							],
							[
								149.06154067900002,
								-25.629827053999975
							],
							[
								149.04913965800006,
								-25.64735706299996
							],
							[
								149.06552764700007,
								-25.647210063999978
							],
							[
								149.05425268600004,
								-25.661682062999944
							],
							[
								149.0569336750001,
								-25.669403073999945
							],
							[
								149.03189066800007,
								-25.67283606199993
							],
							[
								149.0086046880001,
								-25.695063069999946
							],
							[
								148.97351964900008,
								-25.71328905699994
							],
							[
								148.95757368300008,
								-25.693092054999966
							],
							[
								148.93887465600005,
								-25.685675053999944
							],
							[
								148.939347665,
								-25.694901053999956
							],
							[
								148.92567465500008,
								-25.70382305299995
							],
							[
								148.92377165200003,
								-25.740471052999965
							],
							[
								148.90072668200003,
								-25.760076050999942
							],
							[
								148.91122966000012,
								-25.76758406199997
							],
							[
								148.94469665600002,
								-25.770985044999975
							],
							[
								148.96116764300007,
								-25.789748066999948
							],
							[
								149.03138563800007,
								-25.76965906199996
							],
							[
								149.02830566400007,
								-25.804461061999973
							],
							[
								149.1083216390001,
								-25.873182079999935
							],
							[
								149.09730162300002,
								-25.947886078999943
							],
							[
								149.12457062900012,
								-25.951111071999946
							],
							[
								149.13802561900002,
								-25.945793082999955
							],
							[
								149.30280659900006,
								-25.96607109699994
							],
							[
								149.3278135910001,
								-25.925237078999942
							],
							[
								149.34631960000002,
								-25.918983079999975
							],
							[
								149.39864260900004,
								-25.876020093999955
							],
							[
								149.4014435780001,
								-25.882473094999966
							],
							[
								149.48353757900009,
								-25.891860101999953
							],
							[
								149.4768415750001,
								-25.93349311199995
							],
							[
								149.57549358400001,
								-25.944152109999948
							],
							[
								149.5849345690001,
								-25.88639711099995
							],
							[
								149.64920059100007,
								-25.894475125999975
							],
							[
								149.68189557000005,
								-25.872268118999955
							],
							[
								149.73590958700004,
								-25.849527122999973
							],
							[
								149.77140655800008,
								-25.90595512699997
							],
							[
								149.78304056800005,
								-25.890688127999965
							],
							[
								149.76632254300011,
								-25.859446125999966
							],
							[
								149.7708885930001,
								-25.852344125999934
							],
							[
								149.78736757100012,
								-25.857958137999958
							],
							[
								149.79734455100004,
								-25.84891812899997
							],
							[
								149.81783356900007,
								-25.85156613099997
							],
							[
								149.82770053900003,
								-25.84316213099993
							],
							[
								149.82155153000008,
								-25.83996513099993
							],
							[
								149.82358557100008,
								-25.828281140999934
							],
							[
								149.85081555700003,
								-25.837466132999964
							],
							[
								149.88249455400012,
								-25.82942814599994
							],
							[
								149.8866844250001,
								-25.820860295999978
							],
							[
								149.89450513400004,
								-25.82365381699998
							],
							[
								149.89730056500002,
								-25.814803136999956
							],
							[
								149.93202252800006,
								-25.839429139999936
							],
							[
								149.9503565560001,
								-25.839641151999956
							],
							[
								149.9649085540001,
								-25.85110915299998
							],
							[
								149.99006555200003,
								-25.847082145999934
							],
							[
								150.0217495160001,
								-25.865164148999952
							],
							[
								150.02703257000007,
								-25.82965514899996
							],
							[
								150.03014452900004,
								-25.83622614899997
							],
							[
								150.04292652800007,
								-25.832346149999978
							],
							[
								150.04988755600004,
								-25.839911150999967
							],
							[
								150.05595253900003,
								-25.81311715099997
							],
							[
								150.08544654600007,
								-25.812034143999938
							],
							[
								150.09626153700003,
								-25.794242164999957
							],
							[
								150.12869853100005,
								-25.81847716799996
							],
							[
								150.15925552700003,
								-25.81909515999996
							],
							[
								150.18059652700003,
								-25.80514216199998
							],
							[
								150.17447154,
								-25.780094160999965
							],
							[
								150.24829752100004,
								-25.795389177999937
							],
							[
								150.24960853200002,
								-25.788171157999955
							],
							[
								150.2578605210001,
								-25.78842016899995
							],
							[
								150.27911753800004,
								-25.796252170999935
							],
							[
								150.28193653900007,
								-25.77883517099997
							],
							[
								150.29510154800005,
								-25.780232161999947
							],
							[
								150.33667551300005,
								-25.790394185999958
							],
							[
								150.34544251900002,
								-25.817671176999966
							],
							[
								150.38876348500003,
								-25.814510180999946
							],
							[
								150.39511452600004,
								-25.795947180999974
							],
							[
								150.417914504,
								-25.789088182999933
							],
							[
								150.4260285250001,
								-25.77396317399996
							],
							[
								150.434154529,
								-25.73361919399997
							],
							[
								150.41849949700008,
								-25.675147181999932
							],
							[
								150.4364705270001,
								-25.66140218399994
							],
							[
								150.44255950000002,
								-25.62174218399997
							],
							[
								150.43674954300002,
								-25.606379183999934
							],
							[
								150.44610953200004,
								-25.598817183999984
							],
							[
								150.4838805280001,
								-25.606102187999966
							],
							[
								150.49549851400002,
								-25.628374188999942
							],
							[
								150.52418751000005,
								-25.64537420199997
							],
							[
								150.5702914960001,
								-25.638185195999938
							],
							[
								150.59124150200012,
								-25.652679207999938
							],
							[
								150.6541670250001,
								-25.659768783999937
							],
							[
								150.66357248100007,
								-25.68426320499998
							],
							[
								150.64315548000002,
								-25.715649192999933
							],
							[
								150.66428247600004,
								-25.732725194999944
							],
							[
								150.668446463,
								-25.75825320599995
							],
							[
								150.64412947200003,
								-25.786186203999932
							],
							[
								150.65688749900005,
								-25.800955194999972
							],
							[
								150.649241479,
								-25.803296203999935
							],
							[
								150.69869545900008,
								-25.855741208999973
							],
							[
								150.6783814570001,
								-25.88901519799998
							],
							[
								150.68499846400005,
								-25.913862218999952
							],
							[
								150.66888645200004,
								-25.942654206999975
							],
							[
								150.67276044900007,
								-25.969574207999983
							],
							[
								150.70206246500004,
								-25.973917210999957
							],
							[
								150.714419463,
								-25.98484320199998
							],
							[
								150.76364145800005,
								-25.981586205999974
							],
							[
								150.77581844300005,
								-26.01222021799998
							],
							[
								150.78598643200007,
								-26.018644208999945
							],
							[
								150.78092147100006,
								-26.028481217999968
							],
							[
								150.78981746800002,
								-26.048910208999928
							],
							[
								150.84957244100008,
								-26.056392224999968
							],
							[
								150.90393342900006,
								-26.01938421899996
							],
							[
								150.91407243000003,
								-26.004078229999948
							],
							[
								150.933091417,
								-26.013208241999962
							],
							[
								150.98398843300004,
								-26.00779323699993
							],
							[
								151.01589234100004,
								-26.077207259999966
							],
							[
								151.05622151600005,
								-26.090469283999937
							],
							[
								151.0673522950001,
								-26.085387224999977
							],
							[
								151.11542537700007,
								-26.11869625999998
							],
							[
								151.13444841600005,
								-26.105276250999964
							],
							[
								151.15166838400012,
								-26.107706262999955
							],
							[
								151.15953738200005,
								-26.120788253999933
							],
							[
								151.15878736800005,
								-26.15452325399997
							],
							[
								151.13929239900006,
								-26.159171261999973
							],
							[
								151.1158733840001,
								-26.140853239999956
							],
							[
								151.0987023550001,
								-26.149881997999955
							],
							[
								151.09983440300005,
								-26.160267258999966
							],
							[
								151.0764344060001,
								-26.161831235999955
							],
							[
								151.0732733850001,
								-26.172754255999962
							],
							[
								151.02286659700007,
								-26.194977111999947
							],
							[
								151.01324939900007,
								-26.191916730999935
							],
							[
								151.01672010100003,
								-26.256209341999977
							],
							[
								151.06590742600008,
								-26.25458855599993
							],
							[
								151.1356593580001,
								-26.263113252999972
							],
							[
								151.114944357,
								-26.37932625199994
							],
							[
								151.07696935100012,
								-26.462803248999933
							],
							[
								151.20773134600006,
								-26.47875425099994
							],
							[
								151.2007884300001,
								-26.44925128999995
							],
							[
								151.28480934800007,
								-26.393613267999967
							],
							[
								151.30530332400008,
								-26.403542279999954
							],
							[
								151.3704773180001,
								-26.402072275999956
							],
							[
								151.3888993480001,
								-26.37946723699997
							],
							[
								151.42804415800003,
								-26.43371412099998
							],
							[
								151.43194867900002,
								-26.42432069199998
							],
							[
								151.4838643370001,
								-26.39348023599996
							],
							[
								151.4840711480001,
								-26.38280417599998
							],
							[
								151.50751513700004,
								-26.37586347799993
							],
							[
								151.67150629800005,
								-26.39416231399997
							],
							[
								151.67087531700008,
								-26.40203629399997
							],
							[
								151.6784332960001,
								-26.40302930499996
							],
							[
								151.69493129600005,
								-26.39081830599997
							],
							[
								151.7209663120001,
								-26.394313308999983
							],
							[
								151.71951229500007,
								-26.37391030899994
							],
							[
								151.7684383190001,
								-26.38029930299996
							],
							[
								151.76724530800004,
								-26.387772302999963
							],
							[
								151.7831673070001,
								-26.389837314999966
							],
							[
								151.78543628800003,
								-26.375247314999967
							],
							[
								151.8305632030001,
								-26.381081348999942
							],
							[
								151.82425027200009,
								-26.392717328999936
							],
							[
								151.82900830100004,
								-26.400338328999965
							],
							[
								151.85009029900004,
								-26.39170133099998
							],
							[
								151.85526829800006,
								-26.401426311999955
							],
							[
								151.86986928700003,
								-26.39148432299993
							],
							[
								151.8915623250001,
								-26.390806304999956
							],
							[
								151.92195028800006,
								-26.42255231799993
							],
							[
								151.92265925900006,
								-26.417610327999967
							],
							[
								151.96320897400005,
								-26.42264912199994
							],
							[
								151.96457717300007,
								-26.428845361999947
							],
							[
								151.98663437000005,
								-26.43416435499995
							],
							[
								152.03854240900012,
								-26.40213830899995
							],
							[
								152.02479436200008,
								-26.388044297999954
							],
							[
								152.0106751730001,
								-26.387233316999982
							],
							[
								152.0163332940001,
								-26.38027731699998
							],
							[
								152.0118040850001,
								-26.375261026999965
							],
							[
								152.0040848850001,
								-26.375480205999963
							],
							[
								152.00103388700006,
								-26.362580154999932
							],
							[
								152.0134706770001,
								-26.353874986999983
							],
							[
								152.00320826900008,
								-26.34914732599998
							],
							[
								152.00880925900003,
								-26.33961533599995
							],
							[
								151.9983362800001,
								-26.339719334999984
							],
							[
								152.00224229100002,
								-26.332530334999944
							],
							[
								151.983050272,
								-26.337261332999958
							],
							[
								151.99246227300011,
								-26.31988234399995
							],
							[
								151.9851642750001,
								-26.31073533299997
							],
							[
								151.98195829400004,
								-26.319126342999937
							],
							[
								151.9778857760001,
								-26.31292393299998
							],
							[
								151.96921775600003,
								-26.31868929199993
							],
							[
								151.96736589700004,
								-26.311684751999962
							],
							[
								151.88645346600003,
								-26.30138812399997
							],
							[
								151.8981323060001,
								-26.293269324999983
							],
							[
								151.9028533280001,
								-26.276865314999952
							],
							[
								151.9149427760001,
								-26.28088973699994
							],
							[
								151.91776806600012,
								-26.274687186999984
							],
							[
								151.9079452190001,
								-26.260303345999944
							],
							[
								151.89331734100006,
								-26.25822137399996
							],
							[
								151.89437142300005,
								-26.23751335399993
							],
							[
								151.87155713900006,
								-26.209178291999933
							],
							[
								151.87922947900006,
								-26.197996341999954
							],
							[
								151.86935645100004,
								-26.193617290999953
							],
							[
								151.84877432200005,
								-26.197182318999978
							],
							[
								151.84776943200006,
								-26.203541318999953
							],
							[
								151.82860737400006,
								-26.202723307999975
							],
							[
								151.8161683290001,
								-26.167449645999966
							],
							[
								151.7982424500001,
								-26.17517330399994
							],
							[
								151.78662742200004,
								-26.17130628299998
							],
							[
								151.75938619800002,
								-26.13876929999998
							],
							[
								151.74618534900003,
								-26.145163338999964
							],
							[
								151.74391133200004,
								-26.121606308999958
							],
							[
								151.7233001840001,
								-26.11886534699994
							],
							[
								151.72614346600005,
								-26.102344306999953
							],
							[
								151.7342182860001,
								-26.097618317999945
							],
							[
								151.71875842800011,
								-26.090791285999956
							],
							[
								151.73044725800003,
								-26.08070228699995
							],
							[
								151.72514950000004,
								-26.07185934699993
							],
							[
								151.73466935900012,
								-26.06715233799997
							],
							[
								151.72510019100002,
								-26.06223131699994
							],
							[
								151.7228544930001,
								-26.046623325999974
							],
							[
								151.75257250100003,
								-26.03469230899998
							],
							[
								151.74207740400004,
								-26.020437297999933
							],
							[
								151.75118327400003,
								-26.010748348999982
							],
							[
								151.744539475,
								-26.006167347999963
							],
							[
								151.74813732000007,
								-25.962288307999984
							],
							[
								151.7566354700001,
								-25.954249318999928
							],
							[
								151.74873421200004,
								-25.94922534799997
							],
							[
								151.75597935100006,
								-25.94573030899994
							],
							[
								151.7527663630001,
								-25.937286317999963
							],
							[
								151.76180336200002,
								-25.937289308999937
							],
							[
								151.78545934200008,
								-25.915361320999978
							],
							[
								151.77657338300003,
								-25.911900319999972
							],
							[
								151.78076934500007,
								-25.896660320999956
							],
							[
								151.76744138100003,
								-25.856970298999954
							],
							[
								151.77284539100003,
								-25.85217130899997
							],
							[
								151.7647773540001,
								-25.826690317999976
							],
							[
								151.7746303550001,
								-25.814448308999943
							],
							[
								151.7567973680001,
								-25.802983307999966
							],
							[
								151.76740236900002,
								-25.788143307999974
							],
							[
								151.7799023770001,
								-25.789349309999977
							],
							[
								151.775924389,
								-25.77675729899994
							],
							[
								151.78983738800002,
								-25.77169730999998
							],
							[
								151.79043438000008,
								-25.758663299999967
							],
							[
								151.8003743490001,
								-25.75696230099993
							],
							[
								151.8104041470001,
								-25.76244158199995
							],
							[
								151.81317354400005,
								-25.784958312999947
							],
							[
								151.8265113430001,
								-25.782792953999945
							],
							[
								151.8316044710001,
								-25.796464024999977
							],
							[
								151.85321735800005,
								-25.806555316999948
							],
							[
								151.86105635800004,
								-25.802027306999946
							],
							[
								151.86109135700008,
								-25.809881317999952
							],
							[
								151.87381237500006,
								-25.81341231899995
							],
							[
								151.8972983660001,
								-25.866460320999977
							],
							[
								151.91288933400006,
								-25.872461332999933
							],
							[
								151.92860835300007,
								-25.867596333999927
							],
							[
								151.95950804400002,
								-25.83315691699994
							],
							[
								151.970376363,
								-25.83058432799993
							],
							[
								151.9720982450001,
								-25.81262887799994
							],
							[
								151.9789148440001,
								-25.813687348999963
							],
							[
								151.98621294500003,
								-25.80127209899996
							],
							[
								151.98633237800004,
								-25.77887432899996
							],
							[
								151.99771336800006,
								-25.770926329999952
							],
							[
								151.9989093700001,
								-25.74770069999994
							],
							[
								151.9953058320001,
								-25.73683159999996
							],
							[
								151.98027852400003,
								-25.73294496799997
							],
							[
								151.98124734600003,
								-25.71273932799994
							],
							[
								151.99700334500005,
								-25.71121131999996
							],
							[
								152.00517536300003,
								-25.717532330999973
							],
							[
								152.0139353630001,
								-25.708871330999955
							],
							[
								152.0175283860001,
								-25.681013331999964
							],
							[
								152.011171589,
								-25.66499294099998
							],
							[
								152.02956601900007,
								-25.64222867199993
							],
							[
								152.0380597090001,
								-25.64274623299997
							],
							[
								152.044138061,
								-25.615113703999953
							],
							[
								152.05264952900006,
								-25.62422969399995
							],
							[
								152.06610671800001,
								-25.621273075999966
							],
							[
								152.09066734400005,
								-25.636315337999974
							],
							[
								152.1152963730001,
								-25.62346034099994
							],
							[
								152.11125881600003,
								-25.598417239999947
							],
							[
								152.1644245340001,
								-25.57457105499998
							],
							[
								152.16362803700008,
								-25.55315205499994
							],
							[
								152.1794363690001,
								-25.523091345999944
							],
							[
								152.21576437500005,
								-25.520173348999947
							],
							[
								152.21494334600004,
								-25.512905348999936
							],
							[
								152.26976616000002,
								-25.521891684999957
							],
							[
								152.27083258400012,
								-25.489836624999953
							],
							[
								152.27637364300006,
								-25.490568434999943
							],
							[
								152.2620858360001,
								-25.47654694399995
							],
							[
								152.26038215800008,
								-25.46190175299995
							],
							[
								152.27361338000003,
								-25.43129336399994
							],
							[
								152.2721753520001,
								-25.41864435399998
							],
							[
								152.2541513660001,
								-25.40222234199996
							],
							[
								152.23423834800008,
								-25.400097339999945
							],
							[
								152.21860537100008,
								-25.387391358999935
							],
							[
								152.1993723920001,
								-25.394539346999977
							],
							[
								152.18173438500003,
								-25.37956734499994
							],
							[
								152.17103839800006,
								-25.367983353999932
							],
							[
								152.1674353720001,
								-25.33593633299995
							],
							[
								152.14144839400012,
								-25.338193330999957
							],
							[
								152.12434336700005,
								-25.327092338999933
							],
							[
								152.10601737900004,
								-25.327903336999952
							],
							[
								152.08966140200005,
								-25.312470335999933
							],
							[
								152.0769333820001,
								-25.321176323999964
							],
							[
								152.0474194090001,
								-25.286153320999972
							],
							[
								152.03077041200004,
								-25.27473632999994
							],
							[
								152.01256042400007,
								-25.27406033799997
							],
							[
								152.00638155800004,
								-25.248881996999955
							],
							[
								152.01162614100008,
								-25.21729180699998
							],
							[
								151.99083942800007,
								-25.171786314999963
							],
							[
								151.98296043300002,
								-25.132729323999968
							],
							[
								152.00210841800003,
								-25.075976314999934
							],
							[
								152.0359674130001,
								-25.088427318999948
							],
							[
								152.0392924240001,
								-25.082581318999928
							],
							[
								152.0278464270001,
								-25.061370327999953
							],
							[
								152.06363843700012,
								-25.03738834099994
							],
							[
								152.07738444500012,
								-25.04109633199994
							],
							[
								152.08739745200012,
								-25.056140332999973
							],
							[
								152.09824404200003,
								-25.05167583399998
							],
							[
								152.1083264440001,
								-25.02670633499997
							],
							[
								152.0930384190001,
								-24.996030332999965
							],
							[
								152.09192743200003,
								-24.973144332999937
							],
							[
								152.10700343100007,
								-24.966847343999973
							],
							[
								152.14229542700002,
								-24.967033347999973
							],
							[
								152.16918843100007,
								-24.996086340999966
							],
							[
								152.17697742100006,
								-24.996253340999942
							],
							[
								152.17805242300005,
								-24.976012340999944
							],
							[
								152.19894842200006,
								-24.968831342999977
							],
							[
								152.18011044700006,
								-24.943338340999958
							],
							[
								152.19277141600003,
								-24.93853334199997
							],
							[
								152.22602642200002,
								-24.94674334599995
							],
							[
								152.2543654200001,
								-24.941878347999932
							],
							[
								152.2524754110001,
								-24.92812835799998
							],
							[
								152.2347184250001,
								-24.91223333599993
							],
							[
								152.23481244700008,
								-24.89693535599997
							],
							[
								152.25727640600007,
								-24.887583347999964
							],
							[
								152.2843074320001,
								-24.896897340999942
							],
							[
								152.29662333400006,
								-24.86912050199993
							],
							[
								152.31740763300002,
								-24.858754433999934
							],
							[
								152.3152734150001,
								-24.846108353999966
							],
							[
								152.3419156330001,
								-24.843648135999956
							],
							[
								152.34446012400008,
								-24.831126885999936
							],
							[
								152.3529523630001,
								-24.832223066999973
							],
							[
								152.35741215400003,
								-24.823861647999934
							],
							[
								152.3575138330001,
								-24.83066460799995
							],
							[
								152.37140442100008,
								-24.832504358999984
							],
							[
								152.3594834160001,
								-24.80423935799996
							],
							[
								152.38226441400002,
								-24.796742369999947
							]
						],
						[
							[
								151.46969844600005,
								-24.04512229599993
							],
							[
								151.4752154240001,
								-24.053705236999974
							],
							[
								151.46440751700004,
								-24.037247304999937
							],
							[
								151.46969844600005,
								-24.04512229599993
							]
						]
					],
					[
						[
							[
								151.2731355950001,
								-23.763378944999943
							],
							[
								151.27502454400008,
								-23.770434274999957
							],
							[
								151.27097450500003,
								-23.76586928499995
							],
							[
								151.26484768400007,
								-23.77807725499997
							],
							[
								151.28527553000004,
								-23.797407276999934
							],
							[
								151.29033676400002,
								-23.761655206999933
							],
							[
								151.30033754400006,
								-23.754151297999954
							],
							[
								151.31528659200012,
								-23.759211268999934
							],
							[
								151.2999757650001,
								-23.74218525799995
							],
							[
								151.2865805230001,
								-23.684096275999934
							],
							[
								151.2722467960001,
								-23.66285024399997
							],
							[
								151.26143958700004,
								-23.66634324299997
							],
							[
								151.24845580900012,
								-23.656925281999975
							],
							[
								151.225624626,
								-23.609479249999936
							],
							[
								151.2381245690001,
								-23.48643926999995
							],
							[
								151.2330845790001,
								-23.483759248999945
							],
							[
								151.23206469800004,
								-23.494609278999974
							],
							[
								151.21853480900006,
								-23.50348921799997
							],
							[
								151.21740476700006,
								-23.518409247999955
							],
							[
								151.18339555800003,
								-23.541299194999965
							],
							[
								151.1931256580001,
								-23.53096928599996
							],
							[
								151.18369580900003,
								-23.531239264999954
							],
							[
								151.19346583800007,
								-23.527459275999945
							],
							[
								151.1826457100001,
								-23.520859214999973
							],
							[
								151.19552574800002,
								-23.523389205999933
							],
							[
								151.19145559900005,
								-23.518669245999945
							],
							[
								151.20014566800012,
								-23.519409225999937
							],
							[
								151.19959557900006,
								-23.510379265999973
							],
							[
								151.15515573300002,
								-23.511299221999934
							],
							[
								151.12307687800012,
								-23.49068922899994
							],
							[
								151.1256965870001,
								-23.498919188999935
							],
							[
								151.0867766030001,
								-23.47991918599996
							],
							[
								151.08498668200002,
								-23.487839204999943
							],
							[
								151.07274779300008,
								-23.48834923399994
							],
							[
								151.0778576130001,
								-23.48278920499996
							],
							[
								151.07193775500002,
								-23.473669233999942
							],
							[
								151.0809478550001,
								-23.46662924499998
							],
							[
								151.06004769900005,
								-23.44900923299997
							],
							[
								151.0523278390001,
								-23.448590191999983
							],
							[
								151.05163773900006,
								-23.456159191999973
							],
							[
								151.0171087020001,
								-23.452250208999942
							],
							[
								151.01391874000012,
								-23.473609198999952
							],
							[
								150.97690271200008,
								-23.490630215999943
							],
							[
								150.9896385400001,
								-23.497599236999974
							],
							[
								151.01261769200005,
								-23.55365925899997
							],
							[
								151.0325476380001,
								-23.570389270999954
							],
							[
								151.047677721,
								-23.622880232999933
							],
							[
								151.09208985400005,
								-23.644782176999968
							],
							[
								151.0967306130001,
								-23.65725619799997
							],
							[
								151.10248951200003,
								-23.65814322899996
							],
							[
								151.1034075230001,
								-23.649574238999946
							],
							[
								151.10423767200007,
								-23.65812017899998
							],
							[
								151.12975051800004,
								-23.66922827099995
							],
							[
								151.18659264200005,
								-23.770152226999983
							],
							[
								151.21554166700002,
								-23.79697423999994
							],
							[
								151.22504461500012,
								-23.798952200999963
							],
							[
								151.2272788260001,
								-23.79031723099996
							],
							[
								151.245219044,
								-23.794127492999962
							],
							[
								151.24196623700004,
								-23.77505414199993
							],
							[
								151.24569066700008,
								-23.767407202999948
							],
							[
								151.24523057600004,
								-23.77967825299993
							],
							[
								151.25890712500006,
								-23.77664647399996
							],
							[
								151.26126802500005,
								-23.769921113999942
							],
							[
								151.2546050960001,
								-23.76802113399998
							],
							[
								151.26114651600005,
								-23.768614273999958
							],
							[
								151.26018904700004,
								-23.75711713399994
							],
							[
								151.25255915800005,
								-23.756847182999934
							],
							[
								151.26210055800004,
								-23.749101203999942
							],
							[
								151.26206058700006,
								-23.757366253999976
							],
							[
								151.27457380600003,
								-23.75251724499998
							],
							[
								151.26251197700003,
								-23.758786833999977
							],
							[
								151.26402256400002,
								-23.776589274999935
							],
							[
								151.2731355950001,
								-23.763378944999943
							]
						]
					],
					[
						[
							[
								151.1551057050001,
								-23.405388220999953
							],
							[
								151.16299580500004,
								-23.39664823199996
							],
							[
								151.14514558700012,
								-23.39843823999996
							],
							[
								151.1551057050001,
								-23.405388220999953
							]
						]
					],
					[
						[
							[
								151.18575091200012,
								-23.49652061499995
							],
							[
								151.17393108300007,
								-23.498450643999945
							],
							[
								151.20698058900007,
								-23.50462056699996
							],
							[
								151.18575091200012,
								-23.49652061499995
							]
						]
					],
					[
						[
							[
								150.8280705410001,
								-23.52421924199996
							],
							[
								150.83739059000004,
								-23.527579212999967
							],
							[
								150.8311208120001,
								-23.519699181999954
							],
							[
								150.82439064200003,
								-23.520509181999955
							],
							[
								150.8280705410001,
								-23.52421924199996
							]
						]
					],
					[
						[
							[
								150.85370076800007,
								-23.533959224999933
							],
							[
								150.8653054680001,
								-23.52784040599994
							],
							[
								150.8378607510001,
								-23.52114917299997
							],
							[
								150.85370076800007,
								-23.533959224999933
							]
						]
					],
					[
						[
							[
								150.85185565000006,
								-23.513160423999977
							],
							[
								150.86453063900012,
								-23.516989184999943
							],
							[
								150.87182538900004,
								-23.505910465999932
							],
							[
								150.85185565000006,
								-23.513160423999977
							]
						]
					],
					[
						[
							[
								151.25608403400008,
								-23.787183073999927
							],
							[
								151.2614669830001,
								-23.793054033999965
							],
							[
								151.25866403400005,
								-23.780421083999954
							],
							[
								151.25608403400008,
								-23.787183073999927
							]
						]
					],
					[
						[
							[
								151.28448558900004,
								-23.805390986999953
							],
							[
								151.28604362800002,
								-23.818753236999953
							],
							[
								151.28845664900007,
								-23.804200246999983
							],
							[
								151.28208269000004,
								-23.801243985999974
							],
							[
								151.28448558900004,
								-23.805390986999953
							]
						]
					],
					[
						[
							[
								151.32576413900006,
								-23.775331729999948
							],
							[
								151.3280485560001,
								-23.798066250999966
							],
							[
								151.33979068400004,
								-23.806128271999967
							],
							[
								151.33642468300002,
								-23.82465928199997
							],
							[
								151.35396965200005,
								-23.818970282999942
							],
							[
								151.3607135000001,
								-23.82404323399993
							],
							[
								151.36420767700008,
								-23.84750622399997
							],
							[
								151.37069379700006,
								-23.842685294999967
							],
							[
								151.36292177600012,
								-23.859731283999963
							],
							[
								151.3663557740001,
								-23.874789264999947
							],
							[
								151.38017978200003,
								-23.880355235999957
							],
							[
								151.39422662300012,
								-23.86457922699998
							],
							[
								151.37408356000003,
								-23.813213254999937
							],
							[
								151.34082677600009,
								-23.78513325199998
							],
							[
								151.332748701,
								-23.754004220999946
							],
							[
								151.32576413900006,
								-23.775331729999948
							]
						]
					],
					[
						[
							[
								151.70668026700002,
								-23.301118411999937
							],
							[
								151.71705667700007,
								-23.29479501299994
							],
							[
								151.70072514900005,
								-23.29517044199997
							],
							[
								151.70668026700002,
								-23.301118411999937
							]
						]
					],
					[
						[
							[
								151.72584211900005,
								-23.53726430599994
							],
							[
								151.7203421900001,
								-23.538484405999952
							],
							[
								151.73179202900008,
								-23.53939424699996
							],
							[
								151.72584211900005,
								-23.53726430599994
							]
						]
					],
					[
						[
							[
								151.33639877200005,
								-23.83040928199995
							],
							[
								151.33772967100003,
								-23.835956241999952
							],
							[
								151.34189848200003,
								-23.82595625199997
							],
							[
								151.33639877200005,
								-23.83040928199995
							]
						]
					],
					[
						[
							[
								151.65592175900008,
								-24.043228943999964
							],
							[
								151.65284178000002,
								-24.036238942999944
							],
							[
								151.64423194100004,
								-24.036698961999946
							],
							[
								151.65592175900008,
								-24.043228943999964
							]
						]
					],
					[
						[
							[
								151.65217181900005,
								-24.046898992999957
							],
							[
								151.66063175700003,
								-24.05267893399997
							],
							[
								151.66409166800008,
								-24.048178913999948
							],
							[
								151.66054167800007,
								-24.042858913999964
							],
							[
								151.65217181900005,
								-24.046898992999957
							]
						]
					],
					[
						[
							[
								151.43404152800008,
								-24.05193430299994
							],
							[
								151.44002759800003,
								-24.047480262999954
							],
							[
								151.43474675000004,
								-24.036151272999973
							],
							[
								151.42681668000012,
								-24.04387724199995
							],
							[
								151.43404152800008,
								-24.05193430299994
							]
						]
					],
					[
						[
							[
								151.45734465600003,
								-24.05004430499997
							],
							[
								151.46072470500008,
								-24.05648129499997
							],
							[
								151.4597854870001,
								-24.039354284999945
							],
							[
								151.45734465600003,
								-24.05004430499997
							]
						]
					],
					[
						[
							[
								151.53706845500005,
								-24.08319824299997
							],
							[
								151.5464187340001,
								-24.082898283999953
							],
							[
								151.5465684950001,
								-24.076688273999935
							],
							[
								151.53706845500005,
								-24.08319824299997
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "311",
				"CED_NAME21": "Flynn",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 132852.1218,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/311",
				"SHAPE_Leng": 33.0377410439,
				"SHAPE_Area": 11.8340485347
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							153.2933939510001,
							-27.896873464999942
						],
						[
							153.28549396200003,
							-27.895772474999944
						],
						[
							153.31447193100007,
							-27.876850476999948
						],
						[
							153.30125503800002,
							-27.831202445999963
						],
						[
							153.264916996,
							-27.804926501999944
						],
						[
							153.24896599200008,
							-27.76569145999997
						],
						[
							153.22080099100003,
							-27.72623247699994
						],
						[
							153.2325259900001,
							-27.72328246799998
						],
						[
							153.21273599300002,
							-27.715283475999968
						],
						[
							153.23353599100005,
							-27.710996467999962
						],
						[
							153.23431997300008,
							-27.69402245799995
						],
						[
							153.28667998700007,
							-27.69434148299996
						],
						[
							153.28068099300003,
							-27.657985461999942
						],
						[
							153.17384700700006,
							-27.634239460999936
						],
						[
							153.157244987,
							-27.649414459999946
						],
						[
							153.16412300600007,
							-27.65519945999995
						],
						[
							153.160901985,
							-27.66673746999993
						],
						[
							153.12165671900004,
							-27.66864503599993
						],
						[
							153.12155385800008,
							-27.677121435999936
						],
						[
							153.09930659700012,
							-27.700154383999973
						],
						[
							153.016602099,
							-27.678919015999952
						],
						[
							153.0061061990001,
							-27.68657907499994
						],
						[
							153.00295277700002,
							-27.706779094999945
						],
						[
							152.98573302700004,
							-27.720195442999966
						],
						[
							153.0307259110001,
							-27.725087747999964
						],
						[
							153.01209732600012,
							-27.78480593599994
						],
						[
							153.0228609940001,
							-27.78817345699997
						],
						[
							153.0331610060001,
							-27.761938457999975
						],
						[
							153.045763974,
							-27.773601448999955
						],
						[
							153.0646069940001,
							-27.750690460999976
						],
						[
							153.0695589820001,
							-27.76287345199995
						],
						[
							153.09721396800012,
							-27.771710454999948
						],
						[
							153.10651299900007,
							-27.75355145499998
						],
						[
							153.13833399600003,
							-27.752616468999975
						],
						[
							153.1389058750001,
							-27.76357345899993
						],
						[
							153.15856097200003,
							-27.769334450999963
						],
						[
							153.1600459770001,
							-27.804805470999952
						],
						[
							153.16924798600007,
							-27.80328547199997
						],
						[
							153.18328095300012,
							-27.819332463999956
						],
						[
							153.17290798200008,
							-27.834403472999952
						],
						[
							153.18107795900005,
							-27.85391745399994
						],
						[
							153.1889459680001,
							-27.85509146399994
						],
						[
							153.1806889730001,
							-27.895066473999975
						],
						[
							153.21209761900002,
							-27.900112366999963
						],
						[
							153.2193259700001,
							-27.89163446799995
						],
						[
							153.22913665800002,
							-27.89299891899998
						],
						[
							153.2296059670001,
							-27.900315458999955
						],
						[
							153.2484577460001,
							-27.89696287099997
						],
						[
							153.2541269630001,
							-27.91228848199995
						],
						[
							153.2674579610001,
							-27.91923946299994
						],
						[
							153.2783999300001,
							-27.916324483999972
						],
						[
							153.2779909510001,
							-27.90515847399996
						],
						[
							153.28966693000007,
							-27.906233474999965
						],
						[
							153.2933939510001,
							-27.896873464999942
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "312",
				"CED_NAME21": "Forde",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 416.9742,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/312",
				"SHAPE_Leng": 1.59942790389,
				"SHAPE_Area": 0.0381704656839
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							153.0557804440001,
							-27.52561408799994
						],
						[
							153.0634358840001,
							-27.52092444899995
						],
						[
							153.07166185200003,
							-27.529353409999942
						],
						[
							153.08394614100007,
							-27.52148848099995
						],
						[
							153.0945390290001,
							-27.531317461999947
						],
						[
							153.10187304300007,
							-27.49144541299995
						],
						[
							153.09526994600003,
							-27.47498945199993
						],
						[
							153.0985581980001,
							-27.45688045199995
						],
						[
							153.106761537,
							-27.45573521299997
						],
						[
							153.10170901900005,
							-27.446746451999957
						],
						[
							153.08676005000007,
							-27.45016745099997
						],
						[
							153.0516572350001,
							-27.443020026999932
						],
						[
							153.055205031,
							-27.47337854799997
						],
						[
							153.0434716310001,
							-27.477650066999956
						],
						[
							153.03504269400003,
							-27.46475010599994
						],
						[
							153.03180904200008,
							-27.48169843599993
						],
						[
							153.01594702500006,
							-27.469441443999983
						],
						[
							152.99655603500003,
							-27.48693745199995
						],
						[
							153.015514133,
							-27.490901203999954
						],
						[
							153.02282205100005,
							-27.50023543499998
						],
						[
							153.03956284900005,
							-27.501732496999978
						],
						[
							153.04059998700006,
							-27.51267946699994
						],
						[
							153.0557804440001,
							-27.52561408799994
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "313",
				"CED_NAME21": "Griffith",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 54.1984,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/313",
				"SHAPE_Leng": 0.434063295628,
				"SHAPE_Area": 0.00494941215414
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							152.05381136800008,
							-27.39201799899996
						],
						[
							152.04856014900008,
							-27.39126234799994
						],
						[
							152.0543261690001,
							-27.382723338999938
						],
						[
							152.04950455100004,
							-27.36978660799997
						],
						[
							152.06760615000007,
							-27.361745319999955
						],
						[
							152.0705552720001,
							-27.34397131999998
						],
						[
							152.04292017700004,
							-27.333786346999943
						],
						[
							152.04838722800002,
							-27.315440317999958
						],
						[
							152.03063417300007,
							-27.288047345999928
						],
						[
							152.01877828400006,
							-27.293916364999973
						],
						[
							152.01627412300002,
							-27.30774629399997
						],
						[
							151.99465434500007,
							-27.30906534199994
						],
						[
							151.993233174,
							-27.317839341999957
						],
						[
							152.01641516100005,
							-27.320859334999966
						],
						[
							152.0062841780001,
							-27.351623333999953
						],
						[
							151.97868715200002,
							-27.345198340999957
						],
						[
							151.95989958300004,
							-27.35262739899997
						],
						[
							151.96782928800008,
							-27.303164299999935
						],
						[
							151.94853017100002,
							-27.30212434799995
						],
						[
							151.94997908100004,
							-27.294018327999936
						],
						[
							151.93520519300012,
							-27.29634432699993
						],
						[
							151.93910919300004,
							-27.286752356999955
						],
						[
							151.9299220050001,
							-27.285533295999983
						],
						[
							151.93279805500003,
							-27.27601031599994
						],
						[
							151.95182010400003,
							-27.27138035799993
						],
						[
							151.958177857,
							-27.239569977999963
						],
						[
							151.9188452090001,
							-27.25460633499995
						],
						[
							151.8918783160001,
							-27.224239341999976
						],
						[
							151.88121517700006,
							-27.227122340999983
						],
						[
							151.8733997610001,
							-27.195296989999974
						],
						[
							151.86215637300006,
							-27.191411308999932
						],
						[
							151.8527013470001,
							-27.168093297999974
						],
						[
							151.8134951730001,
							-27.154883343999984
						],
						[
							151.79263819800008,
							-27.132680351999966
						],
						[
							151.79434790000005,
							-27.113302911999938
						],
						[
							151.774046386,
							-27.078250328999957
						],
						[
							151.7833873190001,
							-27.044148339999936
						],
						[
							151.7659600710001,
							-27.04591828799994
						],
						[
							151.7699981710001,
							-27.03783232899997
						],
						[
							151.75936521300002,
							-27.036283337999976
						],
						[
							151.760982344,
							-27.02587131799993
						],
						[
							151.744239106,
							-27.023700335999933
						],
						[
							151.74308121700005,
							-27.01446432599994
						],
						[
							151.7114502510001,
							-27.010262302999934
						],
						[
							151.6969851550001,
							-26.985793310999952
						],
						[
							151.67540639900005,
							-26.973684268999932
						],
						[
							151.67470834100004,
							-26.958296338999958
						],
						[
							151.6631812280001,
							-26.990853297999934
						],
						[
							151.62752723100004,
							-27.00260030499993
						],
						[
							151.62309225800004,
							-27.030117314999927
						],
						[
							151.60086409000007,
							-27.030493342999932
						],
						[
							151.59674622700004,
							-27.057999301999928
						],
						[
							151.5811862490001,
							-27.055948300999944
						],
						[
							151.5685112120001,
							-27.12477229999996
						],
						[
							151.54623522600002,
							-27.115282297999954
						],
						[
							151.53967424600012,
							-27.12175029699995
						],
						[
							151.52650026800006,
							-27.11952128599995
						],
						[
							151.52548925700012,
							-27.12550629599997
						],
						[
							151.48123724200002,
							-27.12435530199997
						],
						[
							151.48303326300004,
							-27.11320329199998
						],
						[
							151.4649402550001,
							-27.110809279999955
						],
						[
							151.47040623100008,
							-27.139008300999933
						],
						[
							151.46704126100008,
							-27.146977280999977
						],
						[
							151.458096242,
							-27.14580928999993
						],
						[
							151.45252023800003,
							-27.180077299999937
						],
						[
							151.45022125600008,
							-27.201241299999936
						],
						[
							151.46021604500004,
							-27.202732710999953
						],
						[
							151.45053123700006,
							-27.278724289999957
						],
						[
							151.33771125700002,
							-27.207780278999962
						],
						[
							151.3176352150001,
							-27.331531267999935
						],
						[
							151.31256723600006,
							-27.330824277999966
						],
						[
							151.30863843600002,
							-27.41378857799998
						],
						[
							151.19312923100006,
							-27.398833356999944
						],
						[
							151.19742196200002,
							-27.38400904699995
						],
						[
							151.08777126500001,
							-27.376410256999975
						],
						[
							151.07618725500004,
							-27.471606256999962
						],
						[
							151.08174025200003,
							-27.49303325799997
						],
						[
							151.20182483700012,
							-27.51057629899998
						],
						[
							151.20548541800008,
							-27.49143924899994
						],
						[
							151.22128013700012,
							-27.486499159999937
						],
						[
							151.22975923400008,
							-27.509466260999943
						],
						[
							151.26293323800007,
							-27.524927274999982
						],
						[
							151.25921023700005,
							-27.541047283999944
						],
						[
							151.27518431300007,
							-27.556232265999938
						],
						[
							151.2711001020001,
							-27.56646230599995
						],
						[
							151.28787535900005,
							-27.57690527699998
						],
						[
							151.296605386,
							-27.601015297999936
						],
						[
							151.32083912100006,
							-27.61363726099995
						],
						[
							151.32783429900007,
							-27.63123126199997
						],
						[
							151.31831623800008,
							-27.642886260999944
						],
						[
							151.33341931300004,
							-27.670036281999955
						],
						[
							151.34910810200006,
							-27.668832273999953
						],
						[
							151.35174727000003,
							-27.68288326399994
						],
						[
							151.36064826900008,
							-27.68270928499993
						],
						[
							151.36152021600003,
							-27.709807294999962
						],
						[
							151.3772583230001,
							-27.715628316999982
						],
						[
							151.38048316200002,
							-27.72226130699994
						],
						[
							151.3742461920001,
							-27.72543525699996
						],
						[
							151.38600810000003,
							-27.737663277999957
						],
						[
							151.40431013700004,
							-27.741350309999973
						],
						[
							151.41075917500007,
							-27.75605631999997
						],
						[
							151.41905931400004,
							-27.751950260999934
						],
						[
							151.4122441830001,
							-27.770121350999943
						],
						[
							151.421332021,
							-27.77487531099996
						],
						[
							151.4138303210001,
							-27.78042230099993
						],
						[
							151.4405520370001,
							-27.790677252999956
						],
						[
							151.43921500700003,
							-27.796896342999958
						],
						[
							151.44627713600005,
							-27.793802333999963
						],
						[
							151.4499069850001,
							-27.801775333999956
						],
						[
							151.46244006400002,
							-27.797050344999946
						],
						[
							151.46141226500004,
							-27.78910927499993
						],
						[
							151.47114699400004,
							-27.790276305999953
						],
						[
							151.47220505300004,
							-27.79681831599993
						],
						[
							151.47972113200012,
							-27.79595025699996
						],
						[
							151.48118522100003,
							-27.809819266999966
						],
						[
							151.49371321900003,
							-27.81064428899998
						],
						[
							151.4976192370001,
							-27.821557328999972
						],
						[
							151.519775094,
							-27.825716340999975
						],
						[
							151.53405626000006,
							-27.846555292999938
						],
						[
							151.54345910000006,
							-27.83999429299996
						],
						[
							151.54415825900003,
							-27.848404353999967
						],
						[
							151.5596850270001,
							-27.847127334999982
						],
						[
							151.55752900700008,
							-27.851884274999975
						],
						[
							151.57818326400002,
							-27.85629428699997
						],
						[
							151.5735781190001,
							-27.903568306999944
						],
						[
							151.62383482300004,
							-27.90665483199996
						],
						[
							151.65217258200005,
							-27.887375573999975
						],
						[
							151.64005013500002,
							-27.873407312999973
						],
						[
							151.6566871230001,
							-27.87569130399993
						],
						[
							151.65948714500007,
							-27.85855930499997
						],
						[
							151.6738431450001,
							-27.846373325999934
						],
						[
							151.68223712400004,
							-27.84471231699996
						],
						[
							151.6865471530001,
							-27.85218232699998
						],
						[
							151.70511455100007,
							-27.84734009899995
						],
						[
							151.72801578100007,
							-27.82708673099995
						],
						[
							151.7367056700001,
							-27.830595641999935
						],
						[
							151.74151487000006,
							-27.82384665199993
						],
						[
							151.788741124,
							-27.831842326999947
						],
						[
							151.80090817400003,
							-27.822256807999963
						],
						[
							151.82659406000005,
							-27.832144339999957
						],
						[
							151.83248614800004,
							-27.84264031099997
						],
						[
							151.86620626500007,
							-27.83221031399995
						],
						[
							151.90670909900007,
							-27.849366327999974
						],
						[
							151.9654489830001,
							-27.845109153999942
						],
						[
							151.977709881,
							-27.85061305499994
						],
						[
							151.98387064200006,
							-27.83583708499998
						],
						[
							152.0034553690001,
							-27.840399926999964
						],
						[
							152.01512215900004,
							-27.83230090799998
						],
						[
							152.0218601670001,
							-27.844417798999928
						],
						[
							152.05483379100008,
							-27.85955760199994
						],
						[
							152.07189446900009,
							-27.860215523999955
						],
						[
							152.0737553900001,
							-27.849796453999943
						],
						[
							152.14827790100003,
							-27.862841641999978
						],
						[
							152.15310437300002,
							-27.836279711999964
						],
						[
							152.13794110800006,
							-27.81394236999995
						],
						[
							152.14912707700012,
							-27.80684736099994
						],
						[
							152.14739018900002,
							-27.79905464099994
						],
						[
							152.1304670820001,
							-27.78375935899993
						],
						[
							152.13936549200002,
							-27.779693059999943
						],
						[
							152.13032250300012,
							-27.778428838999957
						],
						[
							152.13154671400002,
							-27.771653328999946
						],
						[
							152.1012586180001,
							-27.76519047599993
						],
						[
							152.10477029000003,
							-27.745629175999966
						],
						[
							152.09645971100008,
							-27.74445660599997
						],
						[
							152.09345039900006,
							-27.76110556499998
						],
						[
							152.08531659000005,
							-27.759970314999975
						],
						[
							152.08435171100007,
							-27.74982926399997
						],
						[
							152.07679559200005,
							-27.74876671399994
						],
						[
							152.08400160300005,
							-27.73899331399997
						],
						[
							152.07497599400006,
							-27.73773246299993
						],
						[
							152.0765262650001,
							-27.729169973999944
						],
						[
							152.0318339910001,
							-27.716249388999984
						],
						[
							152.03405432300008,
							-27.702920578999965
						],
						[
							152.001507166,
							-27.702550445999975
						],
						[
							151.9990081190001,
							-27.683940525999958
						],
						[
							151.9874010200001,
							-27.682549954999956
						],
						[
							151.99223011100003,
							-27.673439344999963
						],
						[
							151.9839971350001,
							-27.647167353999976
						],
						[
							151.95612212800006,
							-27.649594340999954
						],
						[
							151.94208514100012,
							-27.632064329999935
						],
						[
							151.94815042200003,
							-27.617558949999932
						],
						[
							151.97802044900004,
							-27.621214532999943
						],
						[
							151.97424993100003,
							-27.609249142999943
						],
						[
							151.98939902900008,
							-27.60804832399998
						],
						[
							151.99722073100008,
							-27.585964204999982
						],
						[
							152.01676214000008,
							-27.57970534699996
						],
						[
							152.00803112100004,
							-27.574959355999965
						],
						[
							151.9962009620001,
							-27.580736344999934
						],
						[
							152.00471173500011,
							-27.548531754999942
						],
						[
							151.99348335600007,
							-27.548655423999946
						],
						[
							151.98824414800004,
							-27.535965343999976
						],
						[
							151.9984682380001,
							-27.525264483999933
						],
						[
							151.97006142200007,
							-27.51800725199996
						],
						[
							151.96398552100004,
							-27.529407850999974
						],
						[
							151.95665617300006,
							-27.519123329999957
						],
						[
							151.96960115500008,
							-27.494766340999945
						],
						[
							151.96128613700012,
							-27.486560340999972
						],
						[
							151.96392515800005,
							-27.47090234099994
						],
						[
							151.9961891470001,
							-27.457031343999972
						],
						[
							152.00284915500004,
							-27.462787343999935
						],
						[
							152.00625715700005,
							-27.446917334999966
						],
						[
							152.01946315500004,
							-27.44869735599997
						],
						[
							152.02352552700006,
							-27.432423675999928
						],
						[
							152.01600353800006,
							-27.431481364999968
						],
						[
							152.01684715900012,
							-27.422102344999928
						],
						[
							152.025337067,
							-27.428049425999973
						],
						[
							152.02785121800002,
							-27.41609419599996
						],
						[
							152.03850494800008,
							-27.40972791699994
						],
						[
							152.0548019460001,
							-27.41257338899993
						],
						[
							152.05381136800008,
							-27.39201799899996
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "314",
				"CED_NAME21": "Groom",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 5570.5887,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/314",
				"SHAPE_Leng": 5.76369733442,
				"SHAPE_Area": 0.508691807941
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								146.80996744800007,
								-19.341676821999954
							],
							[
								146.81452242800003,
								-19.336963842999978
							],
							[
								146.80711055900008,
								-19.33079890199997
							],
							[
								146.80844245000003,
								-19.318458831999976
							],
							[
								146.76682548300005,
								-19.31762840899995
							],
							[
								146.76103643500005,
								-19.307740827999964
							],
							[
								146.78919231300006,
								-19.30018130999997
							],
							[
								146.8037351920001,
								-19.304669480999962
							],
							[
								146.81039728200005,
								-19.29939483199996
							],
							[
								146.80409037300012,
								-19.286803730999964
							],
							[
								146.81430344300009,
								-19.283952831999954
							],
							[
								146.82527143100003,
								-19.290302822999934
							],
							[
								146.83558345200004,
								-19.269335833999946
							],
							[
								146.84678168300002,
								-19.255483253999955
							],
							[
								146.83881545400004,
								-19.24294482399995
							],
							[
								146.83407643400005,
								-19.253025822999973
							],
							[
								146.83324453500006,
								-19.243585872999972
							],
							[
								146.82053143500002,
								-19.252413831999945
							],
							[
								146.8051645370001,
								-19.238525780999964
							],
							[
								146.79115243800004,
								-19.240450839999937
							],
							[
								146.76752045400008,
								-19.18449082799998
							],
							[
								146.73616946700008,
								-19.180318824999972
							],
							[
								146.70597145800002,
								-19.19360481299998
							],
							[
								146.67741458000012,
								-19.190166810999926
							],
							[
								146.6289044460001,
								-19.170391826999946
							],
							[
								146.59543716000007,
								-19.14711175499997
							],
							[
								146.56161229300005,
								-19.142106801999944
							],
							[
								146.518972479,
								-19.100533818999963
							],
							[
								146.50356845900012,
								-19.121007807999945
							],
							[
								146.49631548000002,
								-19.115675806999946
							],
							[
								146.48158249900007,
								-19.136755815999948
							],
							[
								146.45824649000008,
								-19.146412813999973
							],
							[
								146.45201647600004,
								-19.19488681399997
							],
							[
								146.3969178740001,
								-19.152061039999978
							],
							[
								146.38391007400003,
								-19.16230393899997
							],
							[
								146.39388516200006,
								-19.17339168999996
							],
							[
								146.39449095100008,
								-19.186369499999955
							],
							[
								146.41393398900004,
								-19.195529401999977
							],
							[
								146.42229679700006,
								-19.213371431999974
							],
							[
								146.40359546700006,
								-19.23523819099995
							],
							[
								146.40911565600004,
								-19.241204961999927
							],
							[
								146.40045427600012,
								-19.251454880999972
							],
							[
								146.41315357400003,
								-19.258379291999972
							],
							[
								146.42236979200004,
								-19.276878072999978
							],
							[
								146.40483760200004,
								-19.290837351999983
							],
							[
								146.4235471710001,
								-19.288195592999955
							],
							[
								146.42552879000004,
								-19.299889572999973
							],
							[
								146.44473157800007,
								-19.30050575499996
							],
							[
								146.44586297700005,
								-19.31280464499997
							],
							[
								146.46509536500002,
								-19.319821735999938
							],
							[
								146.44388437600003,
								-19.33428083499996
							],
							[
								146.46114957400005,
								-19.341346295999926
							],
							[
								146.45525518300008,
								-19.355445535999934
							],
							[
								146.46462959200005,
								-19.35660898699996
							],
							[
								146.47003447100008,
								-19.373601806999943
							],
							[
								146.499155738,
								-19.376538188999973
							],
							[
								146.5158529460001,
								-19.390680440999972
							],
							[
								146.51829268500012,
								-19.402298550999944
							],
							[
								146.53024435400005,
								-19.402405551999948
							],
							[
								146.5270022750001,
								-19.394493771999976
							],
							[
								146.53520948400012,
								-19.393482021999944
							],
							[
								146.55385445100012,
								-19.41671800399996
							],
							[
								146.56026096100004,
								-19.41477071399993
							],
							[
								146.55655826200007,
								-19.40308704399996
							],
							[
								146.56380175100003,
								-19.400208603999943
							],
							[
								146.56718573800003,
								-19.435156934999952
							],
							[
								146.57897746700007,
								-19.43675581599996
							],
							[
								146.5922706230001,
								-19.359582795999927
							],
							[
								146.58771944500006,
								-19.338302815999953
							],
							[
								146.59620204600003,
								-19.315819485999953
							],
							[
								146.61944955400008,
								-19.32288277799995
							],
							[
								146.65366249200008,
								-19.315237819999936
							],
							[
								146.7026094680001,
								-19.318725823999955
							],
							[
								146.71506245400008,
								-19.357345814999974
							],
							[
								146.70120443300004,
								-19.38230181399996
							],
							[
								146.70566013000007,
								-19.410469314999943
							],
							[
								146.7359224180001,
								-19.41342982699996
							],
							[
								146.7288290150001,
								-19.329715475999933
							],
							[
								146.74195343400004,
								-19.33095483699998
							],
							[
								146.74229244200012,
								-19.350382826999976
							],
							[
								146.8042884570001,
								-19.357113841999933
							],
							[
								146.80996744800007,
								-19.341676821999954
							]
						]
					],
					[
						[
							[
								146.54304848900006,
								-18.837060807999933
							],
							[
								146.5310545200001,
								-18.83495280699998
							],
							[
								146.54980350800008,
								-18.84894480899993
							],
							[
								146.55031450800004,
								-18.83907581899996
							],
							[
								146.54304848900006,
								-18.837060807999933
							]
						]
					],
					[
						[
							[
								146.5154505170001,
								-18.768590814999982
							],
							[
								146.52064351600006,
								-18.77404781599995
							],
							[
								146.52048452600002,
								-18.766739815999927
							],
							[
								146.5154505170001,
								-18.768590814999982
							]
						]
					],
					[
						[
							[
								146.51636849400006,
								-18.681519804999937
							],
							[
								146.5078585230001,
								-18.698344813999938
							],
							[
								146.5197925210001,
								-18.715057804999958
							],
							[
								146.52688703400008,
								-18.67237268499997
							],
							[
								146.520173515,
								-18.66071381499995
							],
							[
								146.506212526,
								-18.658938813999953
							],
							[
								146.51636849400006,
								-18.681519804999937
							]
						]
					],
					[
						[
							[
								146.48544249100007,
								-18.616681831999927
							],
							[
								146.50007694900012,
								-18.633592902999965
							],
							[
								146.48698256800003,
								-18.65012178199993
							],
							[
								146.49131263700008,
								-18.66739179299998
							],
							[
								146.50335712700007,
								-18.65606280399993
							],
							[
								146.50810157900003,
								-18.622821813999963
							],
							[
								146.50024138000003,
								-18.612331782999945
							],
							[
								146.50446162100002,
								-18.600571832999947
							],
							[
								146.49717166300002,
								-18.58172179299993
							],
							[
								146.48432143500008,
								-18.56742277099994
							],
							[
								146.48129675400003,
								-18.58540316099993
							],
							[
								146.49473671200008,
								-18.598923051999975
							],
							[
								146.48544249100007,
								-18.616681831999927
							]
						]
					],
					[
						[
							[
								146.50390594500004,
								-18.546353272999966
							],
							[
								146.49128753700006,
								-18.538113791999933
							],
							[
								146.48815751600011,
								-18.558037791999936
							],
							[
								146.5004162240001,
								-18.56331320299995
							],
							[
								146.50390594500004,
								-18.546353272999966
							]
						]
					],
					[
						[
							[
								146.5529815010001,
								-18.67654080699998
							],
							[
								146.5585695000001,
								-18.68725380799998
							],
							[
								146.56749850100005,
								-18.67048079799997
							],
							[
								146.54498252400003,
								-18.651951806999932
							],
							[
								146.53814352400002,
								-18.659263805999956
							],
							[
								146.5529815010001,
								-18.67654080699998
							]
						]
					],
					[
						[
							[
								146.57978665200005,
								-18.76528228999996
							],
							[
								146.58711651200008,
								-18.75848229099995
							],
							[
								146.6095714910001,
								-18.758013811999945
							],
							[
								146.61716648000004,
								-18.76502381299997
							],
							[
								146.63113597900008,
								-18.76181212399996
							],
							[
								146.64766949700004,
								-18.776691824999943
							],
							[
								146.69480449500008,
								-18.75931081899995
							],
							[
								146.68391048700005,
								-18.73719482799993
							],
							[
								146.64212550900004,
								-18.74961581499997
							],
							[
								146.6171284950001,
								-18.704545811999935
							],
							[
								146.59774250700002,
								-18.697979810999982
							],
							[
								146.5955834980001,
								-18.68251781099997
							],
							[
								146.583256419,
								-18.68493246999998
							],
							[
								146.5738765100001,
								-18.676453798999944
							],
							[
								146.58905641600006,
								-18.712032359999967
							],
							[
								146.5783335960001,
								-18.72514437999996
							],
							[
								146.57723151400012,
								-18.748900799999944
							],
							[
								146.56663150400004,
								-18.74998280899996
							],
							[
								146.56946675300003,
								-18.76408232899996
							],
							[
								146.582280512,
								-18.771635799999956
							],
							[
								146.57978665200005,
								-18.76528228999996
							]
						]
					],
					[
						[
							[
								146.63249824700006,
								-19.02410131599993
							],
							[
								146.6292002570001,
								-19.033235305999938
							],
							[
								146.64288198600002,
								-19.032267286999968
							],
							[
								146.63249824700006,
								-19.02410131599993
							]
						]
					],
					[
						[
							[
								146.6015337990001,
								-19.037137283999982
							],
							[
								146.61649748700006,
								-19.036984274999952
							],
							[
								146.62057844800006,
								-19.02862029499994
							],
							[
								146.6008037690001,
								-19.029797293999934
							],
							[
								146.6015337990001,
								-19.037137283999982
							]
						]
					],
					[
						[
							[
								146.84612845000004,
								-19.17257484399994
							],
							[
								146.85082308000005,
								-19.160124243999974
							],
							[
								146.85586045000002,
								-19.162411823999946
							],
							[
								146.86602759000004,
								-19.150539824999953
							],
							[
								146.8728333890001,
								-19.15306485499997
							],
							[
								146.86899037000012,
								-19.148208824999926
							],
							[
								146.87606042100003,
								-19.12900588499997
							],
							[
								146.88350233100005,
								-19.127041805999966
							],
							[
								146.8775184220001,
								-19.123041844999932
							],
							[
								146.88298141200005,
								-19.111510875999954
							],
							[
								146.8694544330001,
								-19.111030794999976
							],
							[
								146.86210359400002,
								-19.10251987399994
							],
							[
								146.86469144300008,
								-19.114573823999933
							],
							[
								146.8517093040001,
								-19.118296852999947
							],
							[
								146.8324615460001,
								-19.104816851999942
							],
							[
								146.8268225160001,
								-19.114097821999962
							],
							[
								146.79510251800002,
								-19.113969828999927
							],
							[
								146.78133540800002,
								-19.12382385799998
							],
							[
								146.7791113180001,
								-19.129312857999935
							],
							[
								146.79260054600002,
								-19.13876384899993
							],
							[
								146.8042522940001,
								-19.161265819999983
							],
							[
								146.83634944000005,
								-19.181620842999962
							],
							[
								146.84755738900003,
								-19.181011833999946
							],
							[
								146.84612845000004,
								-19.17257484399994
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "315",
				"CED_NAME21": "Herbert",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 1020.2595,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/315",
				"SHAPE_Leng": 4.02267905357,
				"SHAPE_Area": 0.0876451413893
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								152.82374229900006,
								-25.493990768999936
							],
							[
								152.85071882700004,
								-25.484861631999934
							],
							[
								152.87163311000006,
								-25.443514612999934
							],
							[
								152.90809241800002,
								-25.429495406999933
							],
							[
								152.88986968000006,
								-25.426953564999963
							],
							[
								152.8965169910001,
								-25.418889295999975
							],
							[
								152.90944131000003,
								-25.41880344699996
							],
							[
								152.92436323700008,
								-25.430776288999937
							],
							[
								152.9095692840001,
								-25.37816941699998
							],
							[
								152.9179943250001,
								-25.36326344699995
							],
							[
								152.9014552330001,
								-25.314000404999945
							],
							[
								152.91449931400007,
								-25.29332841599995
							],
							[
								152.89963830700003,
								-25.280868444999953
							],
							[
								152.85972618100004,
								-25.28368238099995
							],
							[
								152.83437032400002,
								-25.27633243799994
							],
							[
								152.8278532480001,
								-25.247794406999958
							],
							[
								152.81388635000008,
								-25.243478375999928
							],
							[
								152.8046012200001,
								-25.247596424999983
							],
							[
								152.80617944800008,
								-25.26435838499998
							],
							[
								152.72245031600005,
								-25.269597356999952
							],
							[
								152.7259901960001,
								-25.266298416999973
							],
							[
								152.66354968400003,
								-25.244005460999972
							],
							[
								152.65102876700007,
								-25.22997959999998
							],
							[
								152.64422447800007,
								-25.23389839899994
							],
							[
								152.64972133800006,
								-25.22714542999995
							],
							[
								152.61497447600004,
								-25.183262415999934
							],
							[
								152.5952032680001,
								-25.18735840399995
							],
							[
								152.55704329200012,
								-25.182090339999945
							],
							[
								152.548340262,
								-25.188240398999937
							],
							[
								152.54703637000011,
								-25.204987418999963
							],
							[
								152.54026515300006,
								-25.18999042799993
							],
							[
								152.55545473400002,
								-25.17165535999993
							],
							[
								152.57796844200004,
								-25.16686624199997
							],
							[
								152.61774489700008,
								-25.17325400599998
							],
							[
								152.6330381780001,
								-25.15176934699997
							],
							[
								152.5770704780001,
								-25.118996381999978
							],
							[
								152.546233206,
								-25.07383571799994
							],
							[
								152.5336845050001,
								-25.089596736999965
							],
							[
								152.53609044600012,
								-25.081087756999978
							],
							[
								152.52333157900011,
								-25.069507915999964
							],
							[
								152.50752787900012,
								-25.077518993999945
							],
							[
								152.52343556900007,
								-25.06881091599996
							],
							[
								152.53148651700008,
								-25.079991796999934
							],
							[
								152.54214527700003,
								-25.069311767999977
							],
							[
								152.5506943460001,
								-25.073680388999946
							],
							[
								152.48607545400012,
								-24.970544340999936
							],
							[
								152.48678249900001,
								-24.930437360999974
							],
							[
								152.49455522000005,
								-24.91630836199994
							],
							[
								152.46825727400005,
								-24.816242387999978
							],
							[
								152.42119053300007,
								-24.775314352999942
							],
							[
								152.4128034160001,
								-24.757691361999946
							],
							[
								152.38399641800004,
								-24.76330834999993
							],
							[
								152.38226441400002,
								-24.796742369999947
							],
							[
								152.3594834160001,
								-24.80423935799996
							],
							[
								152.37140442100008,
								-24.832504358999984
							],
							[
								152.3575138330001,
								-24.83066460799995
							],
							[
								152.35741215400003,
								-24.823861647999934
							],
							[
								152.3529523630001,
								-24.832223066999973
							],
							[
								152.34446012400008,
								-24.831126885999936
							],
							[
								152.3419156330001,
								-24.843648135999956
							],
							[
								152.3152734150001,
								-24.846108353999966
							],
							[
								152.31740763300002,
								-24.858754433999934
							],
							[
								152.29662333400006,
								-24.86912050199993
							],
							[
								152.2843074320001,
								-24.896897340999942
							],
							[
								152.25727640600007,
								-24.887583347999964
							],
							[
								152.23481244700008,
								-24.89693535599997
							],
							[
								152.2347184250001,
								-24.91223333599993
							],
							[
								152.2524754110001,
								-24.92812835799998
							],
							[
								152.2543654200001,
								-24.941878347999932
							],
							[
								152.22602642200002,
								-24.94674334599995
							],
							[
								152.19277141600003,
								-24.93853334199997
							],
							[
								152.18011044700006,
								-24.943338340999958
							],
							[
								152.19894842200006,
								-24.968831342999977
							],
							[
								152.17805242300005,
								-24.976012340999944
							],
							[
								152.17697742100006,
								-24.996253340999942
							],
							[
								152.16918843100007,
								-24.996086340999966
							],
							[
								152.14229542700002,
								-24.967033347999973
							],
							[
								152.10700343100007,
								-24.966847343999973
							],
							[
								152.09192743200003,
								-24.973144332999937
							],
							[
								152.0930384190001,
								-24.996030332999965
							],
							[
								152.1083264440001,
								-25.02670633499997
							],
							[
								152.09824404200003,
								-25.05167583399998
							],
							[
								152.08739745200012,
								-25.056140332999973
							],
							[
								152.07738444500012,
								-25.04109633199994
							],
							[
								152.06363843700012,
								-25.03738834099994
							],
							[
								152.0278464270001,
								-25.061370327999953
							],
							[
								152.0392924240001,
								-25.082581318999928
							],
							[
								152.0359674130001,
								-25.088427318999948
							],
							[
								152.00210841800003,
								-25.075976314999934
							],
							[
								151.98296043300002,
								-25.132729323999968
							],
							[
								151.99083942800007,
								-25.171786314999963
							],
							[
								152.01162614100008,
								-25.21729180699998
							],
							[
								152.00638155800004,
								-25.248881996999955
							],
							[
								152.01256042400007,
								-25.27406033799997
							],
							[
								152.03077041200004,
								-25.27473632999994
							],
							[
								152.0474194090001,
								-25.286153320999972
							],
							[
								152.0769333820001,
								-25.321176323999964
							],
							[
								152.08966140200005,
								-25.312470335999933
							],
							[
								152.10601737900004,
								-25.327903336999952
							],
							[
								152.12434336700005,
								-25.327092338999933
							],
							[
								152.14144839400012,
								-25.338193330999957
							],
							[
								152.1674353720001,
								-25.33593633299995
							],
							[
								152.17103839800006,
								-25.367983353999932
							],
							[
								152.18173438500003,
								-25.37956734499994
							],
							[
								152.1993723920001,
								-25.394539346999977
							],
							[
								152.21860537100008,
								-25.387391358999935
							],
							[
								152.23423834800008,
								-25.400097339999945
							],
							[
								152.2541513660001,
								-25.40222234199996
							],
							[
								152.2721753520001,
								-25.41864435399998
							],
							[
								152.27361338000003,
								-25.43129336399994
							],
							[
								152.29908538000007,
								-25.408131366999953
							],
							[
								152.31999636800003,
								-25.407483368999976
							],
							[
								152.32396636900012,
								-25.40162235899993
							],
							[
								152.36446636400012,
								-25.406291352999972
							],
							[
								152.39026835200002,
								-25.40134137499996
							],
							[
								152.3962813610001,
								-25.409516375999942
							],
							[
								152.4035653410001,
								-25.403394376999984
							],
							[
								152.41608133800003,
								-25.412793377999947
							],
							[
								152.40096635400005,
								-25.464656366999975
							],
							[
								152.40970434000008,
								-25.486070377999965
							],
							[
								152.42197334000002,
								-25.475876378999942
							],
							[
								152.45058334700002,
								-25.48084836199996
							],
							[
								152.465221347,
								-25.467503372999943
							],
							[
								152.49249731500004,
								-25.46474038599996
							],
							[
								152.50308133500005,
								-25.454135366999935
							],
							[
								152.54173632000004,
								-25.462476280999965
							],
							[
								152.54365633100008,
								-25.45651738099997
							],
							[
								152.5590983190001,
								-25.462139382999965
							],
							[
								152.56435431700004,
								-25.472832382999968
							],
							[
								152.60318231200006,
								-25.481178386999943
							],
							[
								152.60769733200004,
								-25.47371538699997
							],
							[
								152.6150163110001,
								-25.479558397999938
							],
							[
								152.61998633100006,
								-25.471352388999946
							],
							[
								152.62688530100002,
								-25.473518388999935
							],
							[
								152.64044432100002,
								-25.46023938099995
							],
							[
								152.64999231900003,
								-25.467301391999968
							],
							[
								152.67314934700005,
								-25.46797336399993
							],
							[
								152.68492022400005,
								-25.479312774999983
							],
							[
								152.68945129500003,
								-25.47155539499994
							],
							[
								152.69679531300005,
								-25.477364395999928
							],
							[
								152.71526833200005,
								-25.470543387999953
							],
							[
								152.71612330100004,
								-25.476366397999982
							],
							[
								152.73729432100004,
								-25.466412399999967
							],
							[
								152.75118129500004,
								-25.49849440199995
							],
							[
								152.76474330300005,
								-25.508597392999945
							],
							[
								152.7835982910001,
								-25.505315404999976
							],
							[
								152.80267257200012,
								-25.487646926999957
							],
							[
								152.82374229900006,
								-25.493990768999936
							]
						]
					],
					[
						[
							[
								152.56357635200004,
								-25.178135390999955
							],
							[
								152.58731433900005,
								-25.180456382999978
							],
							[
								152.57434337200004,
								-25.17275738199993
							],
							[
								152.56357635200004,
								-25.178135390999955
							]
						]
					],
					[
						[
							[
								152.98444220500005,
								-25.31058113399996
							],
							[
								152.94301957400012,
								-25.272818478999966
							],
							[
								152.94406562200004,
								-25.28432246899996
							],
							[
								152.95956953900009,
								-25.30332232099994
							],
							[
								152.97778628600008,
								-25.31050419299993
							],
							[
								152.99347526100007,
								-25.335854024999946
							],
							[
								152.98444220500005,
								-25.31058113399996
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "316",
				"CED_NAME21": "Hinkler",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 3816.4157,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/316",
				"SHAPE_Leng": 4.47343888189,
				"SHAPE_Area": 0.341837122463
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								146.518972479,
								-19.100533818999963
							],
							[
								146.49765448100004,
								-19.097139806999962
							],
							[
								146.47292956500007,
								-19.076485814999955
							],
							[
								146.44810036700005,
								-19.06816182299997
							],
							[
								146.39627548600004,
								-18.998490808999975
							],
							[
								146.3801266480001,
								-18.99764076699995
							],
							[
								146.36324150100006,
								-18.96699678599998
							],
							[
								146.3363315140001,
								-18.956309803999943
							],
							[
								146.3173965190001,
								-18.91759479199993
							],
							[
								146.29067144300006,
								-18.893012919999933
							],
							[
								146.27696153600004,
								-18.864343038999948
							],
							[
								146.2763712200001,
								-18.813163157999952
							],
							[
								146.2893225240001,
								-18.745722798999964
							],
							[
								146.3396891310001,
								-18.624223400999938
							],
							[
								146.32932153000002,
								-18.643528800999945
							],
							[
								146.3193355300001,
								-18.645693799999947
							],
							[
								146.33892902200012,
								-18.606823470999927
							],
							[
								146.33986853600004,
								-18.562973790999933
							],
							[
								146.34543861500003,
								-18.55924369099995
							],
							[
								146.33752848900008,
								-18.52581386999998
							],
							[
								146.31347875100005,
								-18.52192398899996
							],
							[
								146.2618515470001,
								-18.49442778499997
							],
							[
								146.22990152900002,
								-18.489542781999944
							],
							[
								146.21511754200003,
								-18.47234679099995
							],
							[
								146.18938011300008,
								-18.473814838999942
							],
							[
								146.1885300240001,
								-18.460034888999928
							],
							[
								146.20046980400002,
								-18.452324849999968
							],
							[
								146.19074981500012,
								-18.44398493899996
							],
							[
								146.16751019700007,
								-18.44532507699995
							],
							[
								146.1735599970001,
								-18.43485507799994
							],
							[
								146.16123007900012,
								-18.42448517699995
							],
							[
								146.15916987100002,
								-18.396915295999975
							],
							[
								146.14112960500006,
								-18.364065654999933
							],
							[
								146.1332098050001,
								-18.36871566399998
							],
							[
								146.10276996900006,
								-18.348525981999956
							],
							[
								146.08512011200003,
								-18.331266149999976
							],
							[
								146.08155001300008,
								-18.314656259999936
							],
							[
								146.06154027600007,
								-18.299426447999963
							],
							[
								146.05004021800005,
								-18.277186616999927
							],
							[
								146.02626544100008,
								-18.262505785999963
							],
							[
								146.01619552300008,
								-18.24500573499995
							],
							[
								146.00803932400004,
								-18.12051778299997
							],
							[
								146.02726887500012,
								-18.091007823999973
							],
							[
								146.0410434270001,
								-18.04364675499994
							],
							[
								146.05507807800007,
								-18.029738015999953
							],
							[
								146.07386750900002,
								-17.989928126999928
							],
							[
								146.0943270790001,
								-17.973768097999937
							],
							[
								146.10139705900008,
								-17.97684802899994
							],
							[
								146.0915359610001,
								-17.955107217999966
							],
							[
								146.097956575,
								-17.896838437999975
							],
							[
								146.11959603700006,
								-17.855788468999947
							],
							[
								146.1065161880001,
								-17.852008547999958
							],
							[
								146.09974617000012,
								-17.833228626999983
							],
							[
								146.10583598100004,
								-17.81561864699995
							],
							[
								146.091268613,
								-17.79924677599996
							],
							[
								146.11262260400008,
								-17.770808777999946
							],
							[
								146.10453552800004,
								-17.727938906999952
							],
							[
								146.11340499000005,
								-17.692938996999942
							],
							[
								146.14905337100004,
								-17.648538798999937
							],
							[
								146.14059344200007,
								-17.639698867999982
							],
							[
								146.14344562300005,
								-17.629677768999954
							],
							[
								146.13267962600003,
								-17.600958757999933
							],
							[
								146.12613335600008,
								-17.601459056999943
							],
							[
								146.1236516460001,
								-17.614176766999947
							],
							[
								146.11528463600007,
								-17.61004776599998
							],
							[
								146.1288226360001,
								-17.59950676699998
							],
							[
								146.1279332370001,
								-17.59252906699993
							],
							[
								146.09212364200005,
								-17.56155928399994
							],
							[
								146.06818409700008,
								-17.510389671999974
							],
							[
								146.06029418800006,
								-17.511269701999936
							],
							[
								146.05861062700012,
								-17.524825761999978
							],
							[
								146.03322359800006,
								-17.525335819999952
							],
							[
								146.0278225070001,
								-17.550257319999957
							],
							[
								146.03271486000006,
								-17.512242079999965
							],
							[
								146.03609457800007,
								-17.523039799999935
							],
							[
								146.05635433700002,
								-17.52091969099996
							],
							[
								146.05754420800008,
								-17.507129730999964
							],
							[
								146.05162423900003,
								-17.505439770999942
							],
							[
								146.07697975700012,
								-17.504538732999947
							],
							[
								146.0779438390001,
								-17.478219732999946
							],
							[
								146.06489381200004,
								-17.45887984199993
							],
							[
								146.07320318600011,
								-17.39470995199997
							],
							[
								146.05096340800003,
								-17.38451005999997
							],
							[
								146.02076353300004,
								-17.34674016699995
							],
							[
								145.99568855000007,
								-17.27323972499994
							],
							[
								145.97207564400003,
								-17.241950762999977
							],
							[
								145.9613484890001,
								-17.19012976199997
							],
							[
								145.96455319100005,
								-17.168450921999977
							],
							[
								145.95293334200005,
								-17.15770102099998
							],
							[
								145.94921322400012,
								-17.13069117999993
							],
							[
								145.92902339700004,
								-17.11732122899997
							],
							[
								145.91602882000007,
								-17.08701071799993
							],
							[
								145.88941360400008,
								-17.057591575999936
							],
							[
								145.90071119900006,
								-16.981667795999954
							],
							[
								145.93433358000004,
								-16.94751489799995
							],
							[
								145.93101551200004,
								-16.922980966999944
							],
							[
								145.94429122200006,
								-16.906514967999954
							],
							[
								145.95618606100004,
								-16.90547491899997
							],
							[
								145.9576579620001,
								-16.89656494899998
							],
							[
								145.92819757600012,
								-16.865859756999953
							],
							[
								145.91921316700007,
								-16.86428041599993
							],
							[
								145.90649671500012,
								-16.897203194999975
							],
							[
								145.86975771700008,
								-16.906627782999976
							],
							[
								145.86237120700002,
								-16.903659491999974
							],
							[
								145.863192098,
								-16.891143541999952
							],
							[
								145.84889067100005,
								-16.871173710999926
							],
							[
								145.81989762000012,
								-16.90150376899993
							],
							[
								145.793103921,
								-16.910544906999974
							],
							[
								145.78187521000007,
								-16.94102487699996
							],
							[
								145.76811846900011,
								-16.95969985599993
							],
							[
								145.77621277700007,
								-16.97487575699995
							],
							[
								145.77155771700006,
								-16.98767173699997
							],
							[
								145.7556897080001,
								-16.98792774499998
							],
							[
								145.73394986800008,
								-17.00368376399996
							],
							[
								145.7266407080001,
								-17.00233472399998
							],
							[
								145.72730581000008,
								-16.986234232999948
							],
							[
								145.72134280000012,
								-16.98565916299998
							],
							[
								145.71571570900005,
								-16.999269742999957
							],
							[
								145.7066296900001,
								-16.998211741999967
							],
							[
								145.700865678,
								-17.032975741999962
							],
							[
								145.68918191800003,
								-17.045002050999926
							],
							[
								145.63680201300008,
								-17.020432786999947
							],
							[
								145.63009758400005,
								-17.00679271699994
							],
							[
								145.63966971500008,
								-16.985703756999953
							],
							[
								145.6548111950001,
								-16.974667917999966
							],
							[
								145.64988522800002,
								-16.945284397999956
							],
							[
								145.66154869800005,
								-16.92872597799993
							],
							[
								145.6612388090001,
								-16.91637052799996
							],
							[
								145.6214467310001,
								-16.918263724999974
							],
							[
								145.60411471400005,
								-16.904177733999973
							],
							[
								145.6013871030001,
								-16.91536018399995
							],
							[
								145.58742993300007,
								-16.923960762999968
							],
							[
								145.56950292500005,
								-16.915113471999973
							],
							[
								145.55795611500002,
								-16.92603078099995
							],
							[
								145.54851250600007,
								-16.91418735999997
							],
							[
								145.5282861060001,
								-16.938591058999975
							],
							[
								145.53821151900001,
								-16.889726398999926
							],
							[
								145.52456961200005,
								-16.86474021799995
							],
							[
								145.52936392200002,
								-16.85924013799996
							],
							[
								145.52048712200008,
								-16.857148027999926
							],
							[
								145.53653668200002,
								-16.851625678999937
							],
							[
								145.55152665000003,
								-16.857387139999958
							],
							[
								145.55586073200004,
								-16.82723070999998
							],
							[
								145.5426807230001,
								-16.82540372899996
							],
							[
								145.54048273500007,
								-16.81181371899993
							],
							[
								145.54807375400003,
								-16.806475708999926
							],
							[
								145.503930727,
								-16.81218871599998
							],
							[
								145.50217171600002,
								-16.82408870599994
							],
							[
								145.49445072600008,
								-16.827095715999974
							],
							[
								145.49526073700008,
								-16.81862870599997
							],
							[
								145.48967572700008,
								-16.818078724999964
							],
							[
								145.49108673600006,
								-16.83490371599993
							],
							[
								145.47723374600002,
								-16.841197714999964
							],
							[
								145.47127873700003,
								-16.831592713999953
							],
							[
								145.48041812400004,
								-16.732932253999934
							],
							[
								145.51263434200007,
								-16.734911345999933
							],
							[
								145.522599022,
								-16.724043776999963
							],
							[
								145.5240666530001,
								-16.707057006999946
							],
							[
								145.51829403400006,
								-16.699873525999976
							],
							[
								145.48396574700007,
								-16.696740733999945
							],
							[
								145.48744168100006,
								-16.641704583999967
							],
							[
								145.46408946100007,
								-16.649253771999952
							],
							[
								145.44716937300007,
								-16.643529350999927
							],
							[
								145.449245345,
								-16.610697990999938
							],
							[
								145.4358597470001,
								-16.60355770999996
							],
							[
								145.44855874600012,
								-16.604459720999955
							],
							[
								145.44146369700002,
								-16.596052849999978
							],
							[
								145.4455947680001,
								-16.575341719999926
							],
							[
								145.4319165390001,
								-16.569451328999946
							],
							[
								145.43322021100005,
								-16.551960678999933
							],
							[
								145.41029726400006,
								-16.527619966999964
							],
							[
								145.41066296400004,
								-16.519964846999926
							],
							[
								145.40414745500004,
								-16.512253846999954
							],
							[
								145.3853811670001,
								-16.51035087599996
							],
							[
								145.38430518600012,
								-16.520177285999978
							],
							[
								145.37356177700008,
								-16.519091704999937
							],
							[
								145.3720597560001,
								-16.532935694999935
							],
							[
								145.35402562500008,
								-16.556519993999927
							],
							[
								145.345617736,
								-16.54746061299994
							],
							[
								145.3258193370001,
								-16.55179437199996
							],
							[
								145.32631080800002,
								-16.541830551999965
							],
							[
								145.30931364000003,
								-16.53110947999994
							],
							[
								145.2957290700001,
								-16.53675458999993
							],
							[
								145.2971864010001,
								-16.53107271999994
							],
							[
								145.2726503340001,
								-16.510417467999957
							],
							[
								145.27642896400005,
								-16.500635357999954
							],
							[
								145.26417708500003,
								-16.49952304699997
							],
							[
								145.2687241850001,
								-16.488643766999928
							],
							[
								145.25845147600012,
								-16.484565886999974
							],
							[
								145.2697488870001,
								-16.466534416999934
							],
							[
								145.2429451490001,
								-16.46431805499998
							],
							[
								145.24040887,
								-16.445581924999942
							],
							[
								145.2285744410001,
								-16.442067033999933
							],
							[
								145.22226337300003,
								-16.42686538399994
							],
							[
								145.20879714400007,
								-16.41997642299998
							],
							[
								145.21400868500007,
								-16.399885352999945
							],
							[
								145.19042877700008,
								-16.393955630999926
							],
							[
								145.15897070200003,
								-16.34905170899998
							],
							[
								145.14030278400003,
								-16.346548216999963
							],
							[
								145.1384643870001,
								-16.308120146999954
							],
							[
								145.12969347700005,
								-16.304051345999937
							],
							[
								145.1336271880001,
								-16.286266095999963
							],
							[
								145.09627700200008,
								-16.26444330399994
							],
							[
								145.0609678840001,
								-16.263986700999965
							],
							[
								145.05520990500008,
								-16.25924595099997
							],
							[
								145.0617461050001,
								-16.248978060999946
							],
							[
								145.054384496,
								-16.24076730099995
							],
							[
								145.02031510900008,
								-16.22901272799993
							],
							[
								145.02616218900005,
								-16.224382178999974
							],
							[
								145.02104985000005,
								-16.220874007999953
							],
							[
								144.99249790900012,
								-16.25304185699997
							],
							[
								144.9949077880001,
								-16.26365876699998
							],
							[
								144.97582072800003,
								-16.279611425999974
							],
							[
								144.99247071600007,
								-16.303626356999928
							],
							[
								144.98967598500008,
								-16.318400636999968
							],
							[
								145.09976778700002,
								-16.33200068399998
							],
							[
								145.1681237690001,
								-16.390777689999936
							],
							[
								145.13356377600007,
								-16.46188468799994
							],
							[
								145.1194547760001,
								-16.461830686999974
							],
							[
								145.10431964800011,
								-16.45054668599994
							],
							[
								145.0932388770001,
								-16.481652894999968
							],
							[
								145.01409392100004,
								-16.484250679999946
							],
							[
								144.99655691100008,
								-16.503088678999973
							],
							[
								144.95151084300005,
								-16.507382675999963
							],
							[
								144.9413188740001,
								-16.514427694999938
							],
							[
								144.91834978600002,
								-16.502719673999934
							],
							[
								144.92158076300007,
								-16.53808464399998
							],
							[
								144.89300363400002,
								-16.545651651999947
							],
							[
								144.884116693,
								-16.575043681999944
							],
							[
								144.8556799040001,
								-16.57724965999995
							],
							[
								144.85360488300012,
								-16.59514362999994
							],
							[
								144.84291176400006,
								-16.597410658999934
							],
							[
								144.84022876200004,
								-16.626152669999954
							],
							[
								144.8048217930001,
								-16.636468666999974
							],
							[
								144.74247978900007,
								-16.75208465399993
							],
							[
								144.66103675500005,
								-16.74355966899998
							],
							[
								144.67021366900008,
								-16.667435678999936
							],
							[
								144.6625377900001,
								-16.66219566799998
							],
							[
								144.64130278100004,
								-16.66766864699997
							],
							[
								144.62932180100006,
								-16.680263655999966
							],
							[
								144.61536577300012,
								-16.66536565499996
							],
							[
								144.61251180500005,
								-16.641836654999963
							],
							[
								144.595900808,
								-16.61027765299997
							],
							[
								144.58961579800007,
								-16.609143652999933
							],
							[
								144.57399879800005,
								-16.625232661999974
							],
							[
								144.5611378100001,
								-16.61334365099998
							],
							[
								144.5444197810001,
								-16.61478564999993
							],
							[
								144.52630381300003,
								-16.60403864899996
							],
							[
								144.5003768150001,
								-16.600378646999957
							],
							[
								144.48323681700003,
								-16.575508655999954
							],
							[
								144.47746379000012,
								-16.541350634999958
							],
							[
								144.44677580300004,
								-16.533914632999938
							],
							[
								144.4358508050001,
								-16.506641641999977
							],
							[
								144.38492480800005,
								-16.514834638999957
							],
							[
								144.37125183000012,
								-16.494404647999943
							],
							[
								144.34050770200008,
								-16.49112566599996
							],
							[
								144.32669198400004,
								-16.47159861399996
							],
							[
								144.3001977660001,
								-16.46542463299994
							],
							[
								144.283211907,
								-16.47541363199997
							],
							[
								144.25080472800005,
								-16.480823619999967
							],
							[
								144.2404046700001,
								-16.46293764899997
							],
							[
								144.22125484200012,
								-16.45649563799998
							],
							[
								144.21044182200012,
								-16.46001562699996
							],
							[
								144.1963078220001,
								-16.48162962599997
							],
							[
								144.16437484300002,
								-16.497453633999953
							],
							[
								144.15301283300005,
								-16.49793962399997
							],
							[
								144.14346385400006,
								-16.48864965299998
							],
							[
								144.12125185500008,
								-16.495000580999942
							],
							[
								144.09258398800011,
								-16.487061609999955
							],
							[
								144.0812609200001,
								-16.469423578999965
							],
							[
								144.05235077200007,
								-16.45965758699998
							],
							[
								144.0545546840001,
								-16.43546658699995
							],
							[
								144.03453183800002,
								-16.394769654999948
							],
							[
								143.98160575200006,
								-16.379217661999974
							],
							[
								143.9681759440001,
								-16.36475761099996
							],
							[
								143.9210047670001,
								-16.36177357799994
							],
							[
								143.91202996700008,
								-16.372084606999977
							],
							[
								143.87607388800006,
								-16.38494858499996
							],
							[
								143.84237684000004,
								-16.376891592999982
							],
							[
								143.81823775100008,
								-16.39412660199997
							],
							[
								143.79908177900006,
								-16.435404650999942
							],
							[
								143.76448398000002,
								-16.451638558999946
							],
							[
								143.76229302900003,
								-16.474046588999954
							],
							[
								143.7516517790001,
								-16.47920655799993
							],
							[
								143.73558678100005,
								-16.470841596999946
							],
							[
								143.71939684100005,
								-16.480016655999975
							],
							[
								143.71452102000012,
								-16.503459575999955
							],
							[
								143.696969931,
								-16.506376564999982
							],
							[
								143.6958488990001,
								-16.531559554999944
							],
							[
								143.68402688000003,
								-16.536488583999926
							],
							[
								143.68383499900006,
								-16.54377660399996
							],
							[
								143.696329858,
								-16.555856584999958
							],
							[
								143.70522293700003,
								-16.550746575999938
							],
							[
								143.7359438950001,
								-16.55894061799995
							],
							[
								143.74575677300004,
								-16.571554558999935
							],
							[
								143.78673988000003,
								-16.58348758099993
							],
							[
								143.78894202700008,
								-16.62020856199996
							],
							[
								143.80435072500006,
								-16.63522265299997
							],
							[
								143.80743701400002,
								-16.649619592999954
							],
							[
								143.82323381300012,
								-16.659263623999948
							],
							[
								143.82393691200002,
								-16.67266256399995
							],
							[
								143.83505474000003,
								-16.686221604999957
							],
							[
								143.829508959,
								-16.715512634999982
							],
							[
								143.83623484700001,
								-16.728897624999945
							],
							[
								143.8251669870001,
								-16.74343261499996
							],
							[
								143.8266019560001,
								-16.76161459499997
							],
							[
								143.83852766400003,
								-16.777964615999963
							],
							[
								143.8402689720001,
								-16.807137585999953
							],
							[
								143.58330785900012,
								-16.785417589999952
							],
							[
								143.56606186400006,
								-16.733915588999935
							],
							[
								143.53917388600007,
								-16.73115958699998
							],
							[
								143.54347986800008,
								-16.687948596999945
							],
							[
								143.4019488680001,
								-16.673613587999967
							],
							[
								143.39051787200003,
								-16.630499576999966
							],
							[
								143.35668387600003,
								-16.58980758499996
							],
							[
								143.33729588000006,
								-16.54954556299998
							],
							[
								143.2224229080001,
								-16.54153455599993
							],
							[
								143.23093989400002,
								-16.433917565999934
							],
							[
								143.21913696500008,
								-16.42757559499995
							],
							[
								143.18460679700001,
								-16.430775532999974
							],
							[
								143.14385086200002,
								-16.39602653999998
							],
							[
								143.20774568500008,
								-16.295437682999932
							],
							[
								143.09799589600004,
								-16.219895545999975
							],
							[
								143.10916671600012,
								-16.20648856699995
							],
							[
								143.05919892200006,
								-16.16201707299996
							],
							[
								142.94059922500003,
								-16.07586721599995
							],
							[
								142.87436544800005,
								-16.08650430199998
							],
							[
								142.77222732500002,
								-16.07456182599998
							],
							[
								142.74552954600006,
								-16.078348753999933
							],
							[
								142.73056564700005,
								-16.08946394399993
							],
							[
								142.69962394000004,
								-16.070624541999962
							],
							[
								142.66030596300004,
								-16.060837538999976
							],
							[
								142.62570294700004,
								-16.01754653699993
							],
							[
								142.5780417200001,
								-16.023035383999968
							],
							[
								142.52391388500007,
								-15.986454980999952
							],
							[
								142.49717491700005,
								-15.98394819899994
							],
							[
								142.47619224900006,
								-15.968721847999973
							],
							[
								142.42605669300008,
								-15.960180224999931
							],
							[
								142.3884550140001,
								-15.978470422999976
							],
							[
								142.37304297800006,
								-15.93251281199997
							],
							[
								142.35206031000007,
								-15.920535979999954
							],
							[
								142.2782889020001,
								-15.953640486999973
							],
							[
								142.24377102500011,
								-15.943454464999945
							],
							[
								142.20426894700006,
								-15.941480491999982
							],
							[
								142.19149079900012,
								-15.930189921999954
							],
							[
								142.1757999890001,
								-15.94809350099996
							],
							[
								142.14951999000004,
								-15.945833498999946
							],
							[
								142.09114511300004,
								-15.956124975999955
							],
							[
								142.07668810400003,
								-15.95172215499997
							],
							[
								142.05102690700005,
								-15.928130933999967
							],
							[
								141.96048789400004,
								-15.901554938999936
							],
							[
								141.9228195060001,
								-15.915678186999969
							],
							[
								141.85548129100005,
								-15.893629872999952
							],
							[
								141.8160330920001,
								-15.908945470999981
							],
							[
								141.80347401400002,
								-15.901435479999975
							],
							[
								141.70240486000012,
								-15.901465474999952
							],
							[
								141.67619727200008,
								-15.893609162999951
							],
							[
								141.65851298400003,
								-15.876290461999929
							],
							[
								141.63707703500006,
								-15.871322420999945
							],
							[
								141.62029699700008,
								-15.85848950999997
							],
							[
								141.59816903800004,
								-15.864992508999933
							],
							[
								141.5899410390001,
								-15.860083427999939
							],
							[
								141.5823830480001,
								-15.87127548799998
							],
							[
								141.56029904100012,
								-15.856841466999981
							],
							[
								141.55026700000008,
								-15.87639149599994
							],
							[
								141.5308130310001,
								-15.873018434999949
							],
							[
								141.520966014,
								-15.844963504999953
							],
							[
								141.50419983400002,
								-15.850461553999935
							],
							[
								141.4963365760001,
								-15.836696002999929
							],
							[
								141.48813603500003,
								-15.854801492999968
							],
							[
								141.48207901600006,
								-15.843443441999966
							],
							[
								141.49161898600005,
								-15.833256422999966
							],
							[
								141.4756130070001,
								-15.835204461999979
							],
							[
								141.46946099800005,
								-15.827267461999952
							],
							[
								141.46232704700003,
								-15.844492440999943
							],
							[
								141.45139699800006,
								-15.838678440999956
							],
							[
								141.4387360080001,
								-15.848969409999938
							],
							[
								141.4307180190001,
								-15.843249509999964
							],
							[
								141.43703902900006,
								-15.833373429999938
							],
							[
								141.4255010500001,
								-15.834704408999926
							],
							[
								141.42575205900005,
								-15.854933419999952
							],
							[
								141.43555904700008,
								-15.870513499999959
							],
							[
								141.4232899980001,
								-15.87094049999996
							],
							[
								141.41561604800006,
								-15.881120488999954
							],
							[
								141.42094704700003,
								-15.894394449999936
							],
							[
								141.4117229960001,
								-15.910012498999947
							],
							[
								141.39756528700002,
								-15.909563738999964
							],
							[
								141.3733869680001,
								-15.916898486999969
							],
							[
								141.3926771450001,
								-15.951188168999977
							],
							[
								141.40966763000006,
								-16.023877669999933
							],
							[
								141.43277792600009,
								-16.074747251999952
							],
							[
								141.41237844500006,
								-16.122757210999964
							],
							[
								141.35108954300006,
								-16.21885730899993
							],
							[
								141.3435300210001,
								-16.27025711899995
							],
							[
								141.3208407080001,
								-16.342437047999965
							],
							[
								141.2860813860001,
								-16.40815712699998
							],
							[
								141.28722153500007,
								-16.42567701699994
							],
							[
								141.30487177300006,
								-16.45710672799993
							],
							[
								141.29649202100006,
								-16.496196707999957
							],
							[
								141.2706626490001,
								-16.557736716999955
							],
							[
								141.25948270000004,
								-16.552976826999952
							],
							[
								141.2513828000001,
								-16.55771688599998
							],
							[
								141.23304316000008,
								-16.58796693599993
							],
							[
								141.221193727,
								-16.656086805999962
							],
							[
								141.2044541260001,
								-16.691976824999927
							],
							[
								141.12882532600008,
								-16.779747141999962
							],
							[
								141.0938858170001,
								-16.803757349999955
							],
							[
								141.08229585700008,
								-16.803147439999975
							],
							[
								141.0786862660001,
								-16.836247329999935
							],
							[
								141.064856705,
								-16.87022727899995
							],
							[
								141.0112278050001,
								-16.94070742699995
							],
							[
								140.97359834500003,
								-16.969827645999942
							],
							[
								140.9580287550001,
								-16.99812766499997
							],
							[
								140.9468992830001,
								-17.04057761499996
							],
							[
								140.95525972000007,
								-17.08619738599998
							],
							[
								140.9622397590001,
								-17.09282728599993
							],
							[
								140.95391988000006,
								-17.098527315999945
							],
							[
								140.94044100600001,
								-17.184597105999956
							],
							[
								140.9255513060001,
								-17.19857716499996
							],
							[
								140.92527145500003,
								-17.21327713499994
							],
							[
								140.91290168500007,
								-17.231757174999927
							],
							[
								140.9096721630001,
								-17.27739708499996
							],
							[
								140.8994024420001,
								-17.302807074999976
							],
							[
								140.89923257100008,
								-17.31501705499994
							],
							[
								140.90500249100012,
								-17.316227024999932
							],
							[
								140.89372279000008,
								-17.34227702499993
							],
							[
								140.90084276900006,
								-17.348636974999977
							],
							[
								140.89341287000002,
								-17.349397004999958
							],
							[
								140.8840030890001,
								-17.37408701399994
							],
							[
								140.88742313900002,
								-17.382296984999982
							],
							[
								140.82882425900004,
								-17.455157141999962
							],
							[
								140.82840424800008,
								-17.46532714199998
							],
							[
								140.7694444110001,
								-17.477687659999958
							],
							[
								140.73550500200008,
								-17.512207787999955
							],
							[
								140.70984528400004,
								-17.50991796699998
							],
							[
								140.5936368770001,
								-17.59781855199998
							],
							[
								140.56594709800004,
								-17.60152870099995
							],
							[
								140.47918821200005,
								-17.64485913699997
							],
							[
								140.46221841300007,
								-17.64885926599993
							],
							[
								140.447928444,
								-17.641669364999927
							],
							[
								140.40213912600007,
								-17.670599572999947
							],
							[
								140.35251970900003,
								-17.68506985099998
							],
							[
								140.24734084500005,
								-17.698490465999953
							],
							[
								140.21669121700006,
								-17.709160614999973
							],
							[
								140.19993128800002,
								-17.702970733999962
							],
							[
								140.0917928550001,
								-17.722641358999965
							],
							[
								140.0292741290001,
								-17.719751705999954
							],
							[
								139.98798482200004,
								-17.70779195399996
							],
							[
								139.94564504700008,
								-17.669152321999945
							],
							[
								139.93774466000002,
								-17.63096251099995
							],
							[
								139.8472157980001,
								-17.596033115999944
							],
							[
								139.84508598700006,
								-17.604733075999945
							],
							[
								139.83389617800003,
								-17.605403125999942
							],
							[
								139.83920587900002,
								-17.58981317599995
							],
							[
								139.8217758510001,
								-17.57060332499998
							],
							[
								139.80893621100006,
								-17.578073364999966
							],
							[
								139.75730721500008,
								-17.57700362199995
							],
							[
								139.75177710600008,
								-17.563663691999977
							],
							[
								139.73728736700002,
								-17.561723770999947
							],
							[
								139.72162740900012,
								-17.548383899999976
							],
							[
								139.7123076890001,
								-17.55345391999998
							],
							[
								139.70748764000007,
								-17.547573969999974
							],
							[
								139.6466984640001,
								-17.538124316999927
							],
							[
								139.6032886590001,
								-17.50540465499995
							],
							[
								139.59095837100006,
								-17.48234481399993
							],
							[
								139.55034873400007,
								-17.468935081999973
							],
							[
								139.55236856400006,
								-17.460465101999944
							],
							[
								139.5353282860001,
								-17.441345270999932
							],
							[
								139.47690800200007,
								-17.40088580799994
							],
							[
								139.45250804400007,
								-17.39549597699994
							],
							[
								139.4364487040001,
								-17.422495976999983
							],
							[
								139.4504979940001,
								-17.393815996999933
							],
							[
								139.41741785800002,
								-17.374586284999964
							],
							[
								139.34151841300002,
								-17.374566761999972
							],
							[
								139.30580857600012,
								-17.364827009999942
							],
							[
								139.23767808200012,
								-17.31976760699996
							],
							[
								139.2011673170001,
								-17.27045804499994
							],
							[
								139.15505504500004,
								-17.163878721999936
							],
							[
								139.14056455000002,
								-17.07867897099993
							],
							[
								139.1579340710001,
								-17.02921896099997
							],
							[
								139.08672461700007,
								-16.99849940799993
							],
							[
								139.0792445290001,
								-16.97777950799997
							],
							[
								139.0432247220001,
								-16.950179755999955
							],
							[
								139.03479468400008,
								-16.927969824999934
							],
							[
								139.03868456400005,
								-16.912429844999963
							],
							[
								138.97921496900005,
								-16.887280232999956
							],
							[
								138.94517529100006,
								-16.88893042099994
							],
							[
								138.91597551400002,
								-16.87600059999994
							],
							[
								138.88380591600003,
								-16.88476075899996
							],
							[
								138.8806558560001,
								-16.877300797999965
							],
							[
								138.84464619900007,
								-16.867971026999953
							],
							[
								138.8228562810001,
								-16.852791175999982
							],
							[
								138.7574367960001,
								-16.833431572999928
							],
							[
								138.74643685700005,
								-16.823591631999932
							],
							[
								138.6811673530001,
								-16.800152069999967
							],
							[
								138.65093746500008,
								-16.778872277999938
							],
							[
								138.65858742500006,
								-16.78416221899994
							],
							[
								138.65742738500012,
								-16.778172237999968
							],
							[
								138.62896760700005,
								-16.767922406999958
							],
							[
								138.5399994830001,
								-16.78194294399998
							],
							[
								138.48644070600005,
								-16.78305327199996
							],
							[
								138.47158085700005,
								-16.77543338099997
							],
							[
								138.4795208160001,
								-16.78359330099994
							],
							[
								138.45060120900007,
								-16.773203499999966
							],
							[
								138.4279117100001,
								-16.777243618999933
							],
							[
								138.36212247600008,
								-16.740324095999938
							],
							[
								138.32908307800005,
								-16.736344274999965
							],
							[
								138.32362348800007,
								-16.75044431499998
							],
							[
								138.272903852,
								-16.719374632999973
							],
							[
								138.19509483800005,
								-16.69630512899994
							],
							[
								138.11836498500008,
								-16.649225645999934
							],
							[
								138.06023202100005,
								-16.597805882999978
							],
							[
								138.0472320030001,
								-16.57830598299995
							],
							[
								137.99465396800008,
								-16.538296570999933
							],
							[
								137.99513568200007,
								-17.422316817999956
							],
							[
								137.9956146500001,
								-18.178286713999967
							],
							[
								137.99617811400003,
								-19.060189830999946
							],
							[
								137.99638107600003,
								-19.951700837999965
							],
							[
								137.99685004000003,
								-20.79196034399996
							],
							[
								137.9974155000001,
								-21.711170850999963
							],
							[
								137.9980149600001,
								-22.612171357999955
							],
							[
								137.99857096900007,
								-23.52090498499996
							],
							[
								138.46439669200004,
								-23.55504201399998
							],
							[
								138.59206244400002,
								-23.462516837999942
							],
							[
								138.6687763430001,
								-23.540069751999965
							],
							[
								138.82556631800003,
								-23.545605758999955
							],
							[
								138.92111152200005,
								-23.47648075199993
							],
							[
								138.89946231500005,
								-23.448319010999967
							],
							[
								139.07636138500004,
								-23.306802046999962
							],
							[
								139.1227089690001,
								-23.352062469999964
							],
							[
								139.17487581600005,
								-23.309955841999965
							],
							[
								139.33900403200005,
								-23.473857859999953
							],
							[
								139.29542986400008,
								-23.509965317999956
							],
							[
								139.4757671760001,
								-23.52076529599998
							],
							[
								139.46373567900002,
								-23.67127987699996
							],
							[
								139.89261672600003,
								-23.693630446999975
							],
							[
								139.86254574300006,
								-23.62966343499994
							],
							[
								139.93623649800008,
								-23.577078557999982
							],
							[
								139.93917712000007,
								-23.550002277999965
							],
							[
								139.93072474000007,
								-23.547789446999957
							],
							[
								139.93792674300005,
								-23.48721745699993
							],
							[
								140.35557631100005,
								-23.52576187699998
							],
							[
								140.34191980800006,
								-23.41825304599996
							],
							[
								140.41324200500003,
								-23.346195988999966
							],
							[
								140.57265709700005,
								-23.231392325999934
							],
							[
								140.66265259300008,
								-23.156644849999964
							],
							[
								140.7193698950001,
								-23.188615682999966
							],
							[
								140.75962829000002,
								-23.223142924999934
							],
							[
								140.82938037600002,
								-23.170178797999938
							],
							[
								140.8221972870001,
								-23.16153191799998
							],
							[
								140.947006471,
								-23.067755662999957
							],
							[
								140.92457306500012,
								-23.044425031999936
							],
							[
								141.04636366900002,
								-22.94763921699996
							],
							[
								141.02274167300004,
								-22.92332249599997
							],
							[
								140.98916364600007,
								-22.913196483999968
							],
							[
								140.98506564800005,
								-22.896255503999953
							],
							[
								140.99908164600004,
								-22.89840150499998
							],
							[
								141.12226454000006,
								-22.80448033999994
							],
							[
								141.11446727300006,
								-22.774491188999946
							],
							[
								141.1228718740001,
								-22.749185589999968
							],
							[
								141.117259267,
								-22.70268182899997
							],
							[
								141.1027824990001,
								-22.690055487999928
							],
							[
								141.0908552840001,
								-22.61821946699996
							],
							[
								141.13389699000004,
								-22.621250988999975
							],
							[
								141.14563706900003,
								-22.633343089999983
							],
							[
								141.19893068600004,
								-22.59754596199997
							],
							[
								141.0797272850001,
								-22.465634844999954
							],
							[
								141.24578607700005,
								-22.33542031299993
							],
							[
								141.25349476700012,
								-22.321351712999956
							],
							[
								141.18285789800007,
								-22.249612018999983
							],
							[
								141.19864148800002,
								-22.055159277999962
							],
							[
								141.29434527900003,
								-22.061871852999957
							],
							[
								141.28455062500007,
								-21.988829431999932
							],
							[
								141.30967799500002,
								-21.93965745299994
							],
							[
								141.48325778000003,
								-21.947160521999933
							],
							[
								141.50783787000012,
								-21.75045430199998
							],
							[
								141.58316397300007,
								-21.75596382599997
							],
							[
								141.58002318100012,
								-21.793180905999975
							],
							[
								141.738286656,
								-21.80701053499996
							],
							[
								141.74048464700002,
								-21.79171353499993
							],
							[
								142.0487116480001,
								-21.815981551999982
							],
							[
								142.06622763400003,
								-21.695135531999938
							],
							[
								142.0645196600001,
								-21.608371530999932
							],
							[
								142.07200665400012,
								-21.540739950999978
							],
							[
								142.23184973900004,
								-21.550855929999955
							],
							[
								142.2281711270001,
								-21.596264349999956
							],
							[
								142.33519663700008,
								-21.607090555999946
							],
							[
								142.3325700150001,
								-21.636308305999933
							],
							[
								142.49123141100006,
								-21.644170904999953
							],
							[
								142.49559809400012,
								-21.597989464999955
							],
							[
								142.65652179900007,
								-21.610347924999928
							],
							[
								142.6513734660001,
								-21.667480694999938
							],
							[
								142.7184758730001,
								-21.61493522799998
							],
							[
								142.69396510700005,
								-21.587849996999978
							],
							[
								142.81540651300008,
								-21.493121222999946
							],
							[
								142.86209920600004,
								-21.545046855999942
							],
							[
								142.9424197830001,
								-21.48164191999996
							],
							[
								142.95333449100008,
								-21.493744380999942
							],
							[
								143.18803758400009,
								-21.30864279399998
							],
							[
								143.35953744900007,
								-21.321997193999948
							],
							[
								143.32877374100008,
								-21.61184577499995
							],
							[
								143.64926393200005,
								-21.641164213999957
							],
							[
								143.63084482200009,
								-21.797408314999927
							],
							[
								143.78184179800007,
								-21.81406633399996
							],
							[
								144.0446283440001,
								-21.830289010999934
							],
							[
								144.0388536800001,
								-21.89469959099995
							],
							[
								144.18430386600005,
								-21.913305169999944
							],
							[
								144.18849917600005,
								-21.908398560999956
							],
							[
								144.18033565100006,
								-21.989545130999943
							],
							[
								144.26344263300007,
								-21.99737784599995
							],
							[
								144.26849744900005,
								-22.04785459699997
							],
							[
								144.41722062500003,
								-22.06171116699994
							],
							[
								144.39778330900003,
								-22.15703816599995
							],
							[
								144.5017834790001,
								-22.165129812999965
							],
							[
								144.50052119800011,
								-22.18564820299997
							],
							[
								144.7235332570001,
								-22.20209443799996
							],
							[
								144.7397893650001,
								-22.21171471899993
							],
							[
								144.75232337300008,
								-22.094786708999948
							],
							[
								144.79636338900002,
								-22.09841770199995
							],
							[
								144.80091337200008,
								-22.04537271199996
							],
							[
								144.9430554490001,
								-22.059136131999935
							],
							[
								144.95631226800003,
								-21.93029778199997
							],
							[
								145.08221367600004,
								-21.942592719999936
							],
							[
								145.08434716800002,
								-21.91024430999994
							],
							[
								145.07520268100006,
								-21.89142911899995
							],
							[
								145.152971653,
								-21.898912854999935
							],
							[
								145.16607557100008,
								-21.78488033499997
							],
							[
								145.25481016300012,
								-21.79378386099995
							],
							[
								145.26204945900008,
								-21.828708321999954
							],
							[
								145.4182412250001,
								-21.846233591999976
							],
							[
								145.43473865600004,
								-21.69203903199997
							],
							[
								145.52940902700004,
								-21.701927638999962
							],
							[
								145.53284036000002,
								-21.658240688999967
							],
							[
								145.67848395700003,
								-21.668175708999968
							],
							[
								145.67474234400004,
								-21.708123758999932
							],
							[
								145.6506083260001,
								-21.707103767999968
							],
							[
								145.64063162200011,
								-21.893972877999943
							],
							[
								145.63017240300007,
								-21.892907957999967
							],
							[
								145.62720473000002,
								-21.926711247999947
							],
							[
								145.66827014600005,
								-21.93202077099994
							],
							[
								145.66117880800005,
								-22.041142890999936
							],
							[
								145.77008519800006,
								-22.048516478999943
							],
							[
								145.7696171870001,
								-22.06657662899994
							],
							[
								146.03146229100003,
								-22.104800787999977
							],
							[
								146.03948627700004,
								-22.023336797999946
							],
							[
								146.06699697400006,
								-22.026519099999973
							],
							[
								146.07207555600007,
								-21.997225879999974
							],
							[
								146.20139117400004,
								-22.007570958999963
							],
							[
								146.21138656200003,
								-21.90848159899997
							],
							[
								146.11845946000005,
								-21.90083974299995
							],
							[
								146.12672529700012,
								-21.81355180199995
							],
							[
								146.0691944020001,
								-21.808795347999933
							],
							[
								146.09344531500005,
								-21.50992779799998
							],
							[
								146.1323002910001,
								-21.514017799999976
							],
							[
								146.15051832100005,
								-21.500043801999936
							],
							[
								146.34670230300003,
								-21.518109805999927
							],
							[
								146.34071526900004,
								-21.57010481599997
							],
							[
								146.39597928700005,
								-21.66317682099998
							],
							[
								146.44665829200005,
								-21.66808210499994
							],
							[
								146.48389624800006,
								-21.68027882699994
							],
							[
								146.4923142870001,
								-21.566465826999945
							],
							[
								146.65672567100012,
								-21.582532108999942
							],
							[
								146.6510312700001,
								-21.609260828999936
							],
							[
								146.75606227900005,
								-21.636683726999934
							],
							[
								146.83389125100007,
								-21.64321086299998
							],
							[
								146.83473123700003,
								-21.57439186299996
							],
							[
								146.87007925800003,
								-21.526659864999942
							],
							[
								146.8666602300001,
								-21.509852854999963
							],
							[
								146.9118252610001,
								-21.45383285799994
							],
							[
								146.9097512630001,
								-21.441130846999954
							],
							[
								146.89844626400009,
								-21.43474585599995
							],
							[
								146.87488927900006,
								-21.39700085399994
							],
							[
								146.87852325100005,
								-21.369613863999973
							],
							[
								146.90463827100007,
								-21.35030885599997
							],
							[
								146.91783525200003,
								-21.325440856999933
							],
							[
								146.95932327100002,
								-21.300400859999968
							],
							[
								146.9661332920001,
								-21.278731859999937
							],
							[
								146.96051426500003,
								-21.252084869999976
							],
							[
								146.94972596700006,
								-21.239565178999953
							],
							[
								146.8908858530001,
								-21.221805703999962
							],
							[
								146.86599829800002,
								-21.191191851999974
							],
							[
								146.882615288,
								-21.170278862999965
							],
							[
								146.848814467,
								-21.10093132999998
							],
							[
								146.8616759790001,
								-21.062220820999983
							],
							[
								146.86036001200011,
								-21.03117698999995
							],
							[
								146.88367759300002,
								-20.99759962199994
							],
							[
								146.85346838200007,
								-20.919189348999964
							],
							[
								146.86595981400012,
								-20.885965048999935
							],
							[
								146.856039806,
								-20.87017666899993
							],
							[
								146.86281289700003,
								-20.84728797899993
							],
							[
								146.8522319110001,
								-20.81131563799994
							],
							[
								146.86160132200007,
								-20.796466427999974
							],
							[
								146.87460463000002,
								-20.80174360899997
							],
							[
								146.90990030900002,
								-20.786706871999968
							],
							[
								146.92041709000011,
								-20.757392711999955
							],
							[
								146.96120470900007,
								-20.74018336499995
							],
							[
								146.96130662300004,
								-20.68439513499993
							],
							[
								146.98597791300006,
								-20.662447076999968
							],
							[
								146.97263600700012,
								-20.63286725499995
							],
							[
								146.97600991800005,
								-20.61968225499993
							],
							[
								147.01482303600005,
								-20.606217587999936
							],
							[
								147.0363288320001,
								-20.629303679999964
							],
							[
								147.0621791100001,
								-20.627108651999947
							],
							[
								147.07889110700012,
								-20.652835683999967
							],
							[
								147.11177749600006,
								-20.635852005999936
							],
							[
								147.15612120100002,
								-20.651713848999975
							],
							[
								147.17802214200003,
								-20.618580890999965
							],
							[
								147.17969030300003,
								-20.604660880999973
							],
							[
								147.20955128200012,
								-20.587098882999953
							],
							[
								147.2145593030001,
								-20.576726872999927
							],
							[
								147.2413832300001,
								-20.584437864999927
							],
							[
								147.2640633000001,
								-20.55980787699997
							],
							[
								147.27687227900003,
								-20.556221867999966
							],
							[
								147.28482330200006,
								-20.524569867999958
							],
							[
								147.30104131200005,
								-20.503785878999963
							],
							[
								147.2906053050001,
								-20.476370877999955
							],
							[
								147.29782631700004,
								-20.447417878999943
							],
							[
								147.33881932600002,
								-20.426905871999963
							],
							[
								147.34366232600007,
								-20.41817088199997
							],
							[
								147.3472322880001,
								-20.393786881999972
							],
							[
								147.33252030000006,
								-20.382438880999928
							],
							[
								147.3144013440001,
								-20.360310888999948
							],
							[
								147.299598338,
								-20.318255867999937
							],
							[
								147.31096433200003,
								-20.270565887999965
							],
							[
								147.30922134600007,
								-20.221685867999952
							],
							[
								147.29455631200005,
								-20.161136865999936
							],
							[
								147.2744353270001,
								-20.12430888399996
							],
							[
								147.29444335000005,
								-20.06682488499996
							],
							[
								147.2636813370001,
								-20.012884871999972
							],
							[
								147.24783936400001,
								-19.95543988099996
							],
							[
								147.2301503660001,
								-19.94139385899996
							],
							[
								147.2191863590001,
								-19.917540867999946
							],
							[
								147.23638337300008,
								-19.861223868999957
							],
							[
								147.2334092860001,
								-19.819057877999967
							],
							[
								147.18578675000003,
								-19.81334516499993
							],
							[
								147.15260237500001,
								-19.784648861999926
							],
							[
								147.11422335800012,
								-19.790905858999963
							],
							[
								147.10297836900008,
								-19.781978847999937
							],
							[
								147.02440238400004,
								-19.796027851999952
							],
							[
								147.01959539900008,
								-19.86115085199998
							],
							[
								146.9239437970001,
								-19.851159064999933
							],
							[
								146.93019537200007,
								-19.783107834999953
							],
							[
								146.95600339100008,
								-19.776116856999977
							],
							[
								146.968329411,
								-19.76225883799998
							],
							[
								146.99258541000006,
								-19.759227859999953
							],
							[
								147.02023638100002,
								-19.71568685099993
							],
							[
								147.03032039800007,
								-19.624992860999953
							],
							[
								147.018313389,
								-19.624440849999928
							],
							[
								147.0194534000001,
								-19.610932859999934
							],
							[
								147.00325338300001,
								-19.596587848999945
							],
							[
								147.02211841300004,
								-19.579420839999955
							],
							[
								147.03396240600011,
								-19.53412685099994
							],
							[
								147.02455913900008,
								-19.504513139999972
							],
							[
								147.01204840000003,
								-19.49945884899995
							],
							[
								147.01069439100002,
								-19.491883858999927
							],
							[
								147.01263141200002,
								-19.474994858999935
							],
							[
								147.0365084010001,
								-19.472030839999945
							],
							[
								147.04228142400007,
								-19.42678185999995
							],
							[
								147.03254840500006,
								-19.422186849999946
							],
							[
								147.0335639860001,
								-19.41256698999996
							],
							[
								147.0191534180001,
								-19.39383984799997
							],
							[
								146.9540094340001,
								-19.38733184299997
							],
							[
								146.94254551300003,
								-19.403269772999977
							],
							[
								146.95278241200003,
								-19.409809843999938
							],
							[
								146.95121043100005,
								-19.424788843999977
							],
							[
								146.93428501200003,
								-19.42940568199998
							],
							[
								146.9098914010001,
								-19.457510850999938
							],
							[
								146.90332841200006,
								-19.456805849999967
							],
							[
								146.90019543300002,
								-19.43969883999995
							],
							[
								146.89257942400002,
								-19.43890283899998
							],
							[
								146.89164341600008,
								-19.419512848999943
							],
							[
								146.89333643700002,
								-19.404277838999974
							],
							[
								146.89952840600006,
								-19.404877849999934
							],
							[
								146.90313545000004,
								-19.360296838999943
							],
							[
								146.89509242000008,
								-19.35964182899994
							],
							[
								146.90054479200012,
								-19.34082436899996
							],
							[
								146.872283164,
								-19.338173686999937
							],
							[
								146.8731114210001,
								-19.370524846999956
							],
							[
								146.8659034420001,
								-19.36986683699996
							],
							[
								146.86363343000005,
								-19.38978883699997
							],
							[
								146.85336342200003,
								-19.37247982599996
							],
							[
								146.85471144300004,
								-19.36050583599996
							],
							[
								146.84384244400007,
								-19.359411834999946
							],
							[
								146.8446384330001,
								-19.369570834999934
							],
							[
								146.8371234440001,
								-19.36907283499994
							],
							[
								146.83081745700008,
								-19.33682982399995
							],
							[
								146.825791438,
								-19.33569683299993
							],
							[
								146.82758044700006,
								-19.343598833999977
							],
							[
								146.80996744800007,
								-19.341676821999954
							],
							[
								146.8042884570001,
								-19.357113841999933
							],
							[
								146.74229244200012,
								-19.350382826999976
							],
							[
								146.74195343400004,
								-19.33095483699998
							],
							[
								146.7288290150001,
								-19.329715475999933
							],
							[
								146.7359224180001,
								-19.41342982699996
							],
							[
								146.70566013000007,
								-19.410469314999943
							],
							[
								146.70120443300004,
								-19.38230181399996
							],
							[
								146.71506245400008,
								-19.357345814999974
							],
							[
								146.7026094680001,
								-19.318725823999955
							],
							[
								146.65366249200008,
								-19.315237819999936
							],
							[
								146.61944955400008,
								-19.32288277799995
							],
							[
								146.59620204600003,
								-19.315819485999953
							],
							[
								146.58771944500006,
								-19.338302815999953
							],
							[
								146.5922706230001,
								-19.359582795999927
							],
							[
								146.57897746700007,
								-19.43675581599996
							],
							[
								146.56718573800003,
								-19.435156934999952
							],
							[
								146.56380175100003,
								-19.400208603999943
							],
							[
								146.55655826200007,
								-19.40308704399996
							],
							[
								146.56026096100004,
								-19.41477071399993
							],
							[
								146.55385445100012,
								-19.41671800399996
							],
							[
								146.53520948400012,
								-19.393482021999944
							],
							[
								146.5270022750001,
								-19.394493771999976
							],
							[
								146.53024435400005,
								-19.402405551999948
							],
							[
								146.51829268500012,
								-19.402298550999944
							],
							[
								146.5158529460001,
								-19.390680440999972
							],
							[
								146.499155738,
								-19.376538188999973
							],
							[
								146.47003447100008,
								-19.373601806999943
							],
							[
								146.46462959200005,
								-19.35660898699996
							],
							[
								146.45525518300008,
								-19.355445535999934
							],
							[
								146.46114957400005,
								-19.341346295999926
							],
							[
								146.44388437600003,
								-19.33428083499996
							],
							[
								146.46509536500002,
								-19.319821735999938
							],
							[
								146.44586297700005,
								-19.31280464499997
							],
							[
								146.44473157800007,
								-19.30050575499996
							],
							[
								146.42552879000004,
								-19.299889572999973
							],
							[
								146.4235471710001,
								-19.288195592999955
							],
							[
								146.40483760200004,
								-19.290837351999983
							],
							[
								146.42236979200004,
								-19.276878072999978
							],
							[
								146.41315357400003,
								-19.258379291999972
							],
							[
								146.40045427600012,
								-19.251454880999972
							],
							[
								146.40911565600004,
								-19.241204961999927
							],
							[
								146.40359546700006,
								-19.23523819099995
							],
							[
								146.42229679700006,
								-19.213371431999974
							],
							[
								146.41393398900004,
								-19.195529401999977
							],
							[
								146.39449095100008,
								-19.186369499999955
							],
							[
								146.39388516200006,
								-19.17339168999996
							],
							[
								146.38391007400003,
								-19.16230393899997
							],
							[
								146.3969178740001,
								-19.152061039999978
							],
							[
								146.45201647600004,
								-19.19488681399997
							],
							[
								146.45824649000008,
								-19.146412813999973
							],
							[
								146.48158249900007,
								-19.136755815999948
							],
							[
								146.49631548000002,
								-19.115675806999946
							],
							[
								146.50356845900012,
								-19.121007807999945
							],
							[
								146.518972479,
								-19.100533818999963
							]
						]
					],
					[
						[
							[
								139.54948081100008,
								-17.12919656899993
							],
							[
								139.55985061100012,
								-17.11384653999994
							],
							[
								139.55221069100003,
								-17.114506568999957
							],
							[
								139.54948081100008,
								-17.12919656899993
							]
						]
					],
					[
						[
							[
								139.60474210600012,
								-17.138187381999956
							],
							[
								139.61494107600004,
								-17.13911638199994
							],
							[
								139.61326809700006,
								-17.118308371999944
							],
							[
								139.63983206700004,
								-17.07764438299995
							],
							[
								139.62943307800003,
								-17.062399381999967
							],
							[
								139.613958098,
								-17.092686371999946
							],
							[
								139.61461608700006,
								-17.106048391999934
							],
							[
								139.59566407800003,
								-17.112011380999945
							],
							[
								139.59708009700012,
								-17.133115390999933
							],
							[
								139.60474210600012,
								-17.138187381999956
							]
						]
					],
					[
						[
							[
								139.48468141500007,
								-17.118376945999955
							],
							[
								139.49527127500005,
								-17.114756906999958
							],
							[
								139.51869109300003,
								-17.123146747999954
							],
							[
								139.51448107400006,
								-17.11184680799994
							],
							[
								139.5227009140001,
								-17.102746787999934
							],
							[
								139.57799034000004,
								-17.093536489999963
							],
							[
								139.55444040300006,
								-17.069716658999937
							],
							[
								139.54928032400005,
								-17.04795675899993
							],
							[
								139.55635019500005,
								-17.034296748999964
							],
							[
								139.543550266,
								-17.031336797999927
							],
							[
								139.4944804710001,
								-16.979607175999945
							],
							[
								139.49264058100005,
								-16.99648716599995
							],
							[
								139.50047052000002,
								-17.002287105999926
							],
							[
								139.49459059000003,
								-17.000967145999937
							],
							[
								139.49058074000004,
								-17.015797135999946
							],
							[
								139.47746089100008,
								-17.019497204999936
							],
							[
								139.47377099000005,
								-17.03036717499998
							],
							[
								139.47545098000012,
								-17.03578715499998
							],
							[
								139.4869608890001,
								-17.03468711599993
							],
							[
								139.49014090800006,
								-17.04455706599998
							],
							[
								139.48608090900007,
								-17.036227105999956
							],
							[
								139.4729910200001,
								-17.035567174999926
							],
							[
								139.46973099100012,
								-17.023837214999958
							],
							[
								139.46164106100002,
								-17.02524726499996
							],
							[
								139.46860102100004,
								-17.02915722499995
							],
							[
								139.45675115100005,
								-17.03126727399996
							],
							[
								139.4504513610001,
								-17.055267253999943
							],
							[
								139.42335179100007,
								-17.07859736299997
							],
							[
								139.3941221130001,
								-17.082957531999966
							],
							[
								139.41118218000008,
								-17.122177362999935
							],
							[
								139.4345620680001,
								-17.139437203999933
							],
							[
								139.43983197700004,
								-17.135677183999974
							],
							[
								139.42553203900002,
								-17.123447303999967
							],
							[
								139.4272918900001,
								-17.10557731399996
							],
							[
								139.47974132700006,
								-17.09440703599995
							],
							[
								139.48076124700003,
								-17.084617055999956
							],
							[
								139.48454125700005,
								-17.092797015999963
							],
							[
								139.472351397,
								-17.096147075999966
							],
							[
								139.4780114460001,
								-17.115776995999965
							],
							[
								139.48468141500007,
								-17.118376945999955
							]
						]
					],
					[
						[
							[
								139.38606211400008,
								-17.071927591999952
							],
							[
								139.36513228600006,
								-17.06968772099998
							],
							[
								139.39182207400006,
								-17.073027541999977
							],
							[
								139.38606211400008,
								-17.071927591999952
							]
						]
					],
					[
						[
							[
								139.23212330600006,
								-17.024098554999966
							],
							[
								139.2133333590001,
								-17.00238871399995
							],
							[
								139.20735341900001,
								-17.003318742999966
							],
							[
								139.21469356700004,
								-17.036388643999942
							],
							[
								139.22289343700004,
								-17.03170860399996
							],
							[
								139.2332334150001,
								-17.046128504999956
							],
							[
								139.24787327400009,
								-17.045368424999936
							],
							[
								139.2507533040001,
								-17.055628395999975
							],
							[
								139.2656831930001,
								-17.058268295999937
							],
							[
								139.23212330600006,
								-17.024098554999966
							]
						]
					],
					[
						[
							[
								139.26596281500008,
								-16.99849842599997
							],
							[
								139.27969265500008,
								-16.99456833599993
							],
							[
								139.27781261500002,
								-16.98993837599994
							],
							[
								139.26383275600006,
								-16.98473847599996
							],
							[
								139.26596281500008,
								-16.99849842599997
							]
						]
					],
					[
						[
							[
								139.06136420400003,
								-16.889289745999974
							],
							[
								139.04622433500003,
								-16.88531984499997
							],
							[
								139.07684414200003,
								-16.905119646999935
							],
							[
								139.0736840830001,
								-16.891099676999943
							],
							[
								139.06136420400003,
								-16.889289745999974
							]
						]
					],
					[
						[
							[
								139.0665440240001,
								-16.86849975599995
							],
							[
								139.0631539850001,
								-16.860579805999976
							],
							[
								139.0589141050001,
								-16.87684979599993
							],
							[
								139.0665440240001,
								-16.86849975599995
							]
						]
					],
					[
						[
							[
								139.13711294300003,
								-16.80457950899995
							],
							[
								139.1325429630001,
								-16.79779955799995
							],
							[
								139.09393341500004,
								-16.81336972699995
							],
							[
								139.09473356400008,
								-16.84308965699995
							],
							[
								139.11326344200006,
								-16.84942955799994
							],
							[
								139.11386335300006,
								-16.837569577999943
							],
							[
								139.1284131320001,
								-16.826049517999934
							],
							[
								139.15047289100005,
								-16.824249408999947
							],
							[
								139.13711294300003,
								-16.80457950899995
							]
						]
					],
					[
						[
							[
								139.28912010600004,
								-16.748695364999946
							],
							[
								139.29560714500008,
								-16.752395364999927
							],
							[
								139.28900513600001,
								-16.743204354999932
							],
							[
								139.28912010600004,
								-16.748695364999946
							]
						]
					],
					[
						[
							[
								139.150032484,
								-16.75666955899993
							],
							[
								139.14218261500002,
								-16.75541958799994
							],
							[
								139.13994264500002,
								-16.76231958799997
							],
							[
								139.150032484,
								-16.75666955899993
							]
						]
					],
					[
						[
							[
								139.82884550300003,
								-16.70342590799993
							],
							[
								139.84021540300012,
								-16.69857584899995
							],
							[
								139.83170542300002,
								-16.697125897999967
							],
							[
								139.82884550300003,
								-16.70342590799993
							]
						]
					],
					[
						[
							[
								139.45607901800008,
								-16.673478030999945
							],
							[
								139.43839933900006,
								-16.69451806099994
							],
							[
								139.44579930700002,
								-16.706378000999962
							],
							[
								139.46455913700004,
								-16.700367911999933
							],
							[
								139.47766884700002,
								-16.679437881999945
							],
							[
								139.46756888800007,
								-16.667017981999948
							],
							[
								139.45607901800008,
								-16.673478030999945
							]
						]
					],
					[
						[
							[
								139.182651845,
								-16.698369469999932
							],
							[
								139.1886416750001,
								-16.679949489999956
							],
							[
								139.17961172600008,
								-16.67180955899994
							],
							[
								139.17129176700007,
								-16.671019588999968
							],
							[
								139.145962187,
								-16.691919707999944
							],
							[
								139.1399722870001,
								-16.706149697999933
							],
							[
								139.14723238500005,
								-16.732259608999982
							],
							[
								139.14136260500004,
								-16.754069607999952
							],
							[
								139.16235233400005,
								-16.74887950899995
							],
							[
								139.16998214400007,
								-16.73067949899996
							],
							[
								139.18476201300007,
								-16.733629399999927
							],
							[
								139.1739721040001,
								-16.72842947999993
							],
							[
								139.1886318930001,
								-16.71926940999998
							],
							[
								139.182651845,
								-16.698369469999932
							]
						]
					],
					[
						[
							[
								139.15856213900008,
								-16.65000436799994
							],
							[
								139.16526214700002,
								-16.667789358999983
							],
							[
								139.19503151600009,
								-16.661919479999938
							],
							[
								139.189940126,
								-16.66697635999998
							],
							[
								139.1976715950001,
								-16.677569439999957
							],
							[
								139.19977173300003,
								-16.707639360999963
							],
							[
								139.22116313200002,
								-16.71202236199997
							],
							[
								139.22926511000003,
								-16.73267735199994
							],
							[
								139.2508981090001,
								-16.72493436299993
							],
							[
								139.28749611600006,
								-16.735278364999942
							],
							[
								139.30508079600008,
								-16.72411875499995
							],
							[
								139.31306074500003,
								-16.73021869599995
							],
							[
								139.32199054500006,
								-16.710168685999975
							],
							[
								139.35057015400002,
								-16.68893858699994
							],
							[
								139.35608008400004,
								-16.691088546999936
							],
							[
								139.35875002400007,
								-16.684558546999938
							],
							[
								139.36570002300004,
								-16.69333847799993
							],
							[
								139.37389989300004,
								-16.686328437999975
							],
							[
								139.36767993400008,
								-16.682938487999934
							],
							[
								139.36860984400005,
								-16.672088507999945
							],
							[
								139.38301964400011,
								-16.656368467999982
							],
							[
								139.37585961500008,
								-16.642018537999945
							],
							[
								139.38007960400012,
								-16.647098507999942
							],
							[
								139.39308940400008,
								-16.637258447999955
							],
							[
								139.40199935300006,
								-16.64041839899994
							],
							[
								139.4173893510001,
								-16.672388249999926
							],
							[
								139.43661814000006,
								-16.674879370999975
							],
							[
								139.45126897900002,
								-16.666248060999976
							],
							[
								139.44711889100006,
								-16.63313815099997
							],
							[
								139.43914890100007,
								-16.630678209999928
							],
							[
								139.46534612000005,
								-16.629100380999944
							],
							[
								139.47241850000012,
								-16.61354806199995
							],
							[
								139.4664284910001,
								-16.600338110999928
							],
							[
								139.4712083810001,
								-16.58811812099998
							],
							[
								139.45527850300005,
								-16.580298230999972
							],
							[
								139.4730783120001,
								-16.583148120999965
							],
							[
								139.4674383030001,
								-16.56856819099994
							],
							[
								139.45830841300005,
								-16.57536824099998
							],
							[
								139.45308843300006,
								-16.569488269999965
							],
							[
								139.48370806200012,
								-16.55600812199998
							],
							[
								139.49566794100008,
								-16.560398041999974
							],
							[
								139.50628612000003,
								-16.57783838299997
							],
							[
								139.51432769100006,
								-16.54513798299996
							],
							[
								139.4855679630001,
								-16.54209813199998
							],
							[
								139.4750279640001,
								-16.526218250999932
							],
							[
								139.49270612300006,
								-16.523822371999927
							],
							[
								139.5067875630001,
								-16.511978081999928
							],
							[
								139.530338131,
								-16.517593372999954
							],
							[
								139.54066708200003,
								-16.488197983999953
							],
							[
								139.56082680100008,
								-16.480257913999935
							],
							[
								139.546636873,
								-16.460518003999937
							],
							[
								139.566586711,
								-16.47448789499998
							],
							[
								139.5579591400001,
								-16.49267936399997
							],
							[
								139.57830678900007,
								-16.50265776499998
							],
							[
								139.57818911800007,
								-16.526683385999945
							],
							[
								139.58827311700009,
								-16.532613375999972
							],
							[
								139.59412311500012,
								-16.555328376999967
							],
							[
								139.65722610300008,
								-16.51938728899995
							],
							[
								139.68157112100005,
								-16.520433389999937
							],
							[
								139.68793212000003,
								-16.53581338099997
							],
							[
								139.71153568900002,
								-16.53220693199995
							],
							[
								139.69943564100004,
								-16.508727050999937
							],
							[
								139.7016155020001,
								-16.486267090999945
							],
							[
								139.69029550300002,
								-16.467987199999982
							],
							[
								139.6806311040001,
								-16.468838379999966
							],
							[
								139.6763955350001,
								-16.450597328999947
							],
							[
								139.65018572700012,
								-16.44948747799998
							],
							[
								139.6052859120001,
								-16.40347782599997
							],
							[
								139.55092011600004,
								-16.39079836299993
							],
							[
								139.53704511600006,
								-16.399136372999976
							],
							[
								139.53525665600012,
								-16.408538202999978
							],
							[
								139.46539755900005,
								-16.446058489999928
							],
							[
								139.36362858500001,
								-16.452378995999936
							],
							[
								139.33313013600002,
								-16.466098373999955
							],
							[
								139.30953515800002,
								-16.461325372999966
							],
							[
								139.24124315000006,
								-16.50531435099998
							],
							[
								139.24129212900004,
								-16.519066360999943
							],
							[
								139.2178981500001,
								-16.53619636999997
							],
							[
								139.21139212900005,
								-16.569344369999953
							],
							[
								139.16046514000004,
								-16.60981735799993
							],
							[
								139.16137512000012,
								-16.620377357999928
							],
							[
								139.15003516000002,
								-16.634456357999966
							],
							[
								139.15856213900008,
								-16.65000436799994
							]
						]
					],
					[
						[
							[
								139.27943715800006,
								-16.268983359999936
							],
							[
								139.2717171490001,
								-16.264803359999974
							],
							[
								139.27253715900008,
								-16.275772359999962
							],
							[
								139.27998114900004,
								-16.26249735999994
							],
							[
								139.27943715800006,
								-16.268983359999936
							]
						]
					],
					[
						[
							[
								139.7257852900001,
								-16.494696941999962
							],
							[
								139.73287526900003,
								-16.50051690199996
							],
							[
								139.73102504100007,
								-16.454977001999964
							],
							[
								139.71772514200006,
								-16.450127100999964
							],
							[
								139.70911534200002,
								-16.471527100999936
							],
							[
								139.7011854220001,
								-16.475307130999965
							],
							[
								139.70954545100005,
								-16.490167050999958
							],
							[
								139.7257852900001,
								-16.494696941999962
							]
						]
					],
					[
						[
							[
								139.8069144850001,
								-16.49677647599998
							],
							[
								139.81362439400004,
								-16.491296465999937
							],
							[
								139.80281451500002,
								-16.48680655499993
							],
							[
								139.8069144850001,
								-16.49677647599998
							]
						]
					],
					[
						[
							[
								139.8698948230001,
								-16.654925789999936
							],
							[
								139.84815506400003,
								-16.66267587899995
							],
							[
								139.85530508300008,
								-16.677075798999965
							],
							[
								139.86080497300009,
								-16.667505809999966
							],
							[
								139.88755462200004,
								-16.653535700999953
							],
							[
								139.87500471300007,
								-16.64490577999993
							],
							[
								139.8698948230001,
								-16.654925789999936
							]
						]
					],
					[
						[
							[
								146.00461421700004,
								-16.92532283299994
							],
							[
								145.9907974680001,
								-16.925311861999944
							],
							[
								145.98299964700004,
								-16.93484278099993
							],
							[
								145.98554559700005,
								-16.942165880999937
							],
							[
								146.00031429600006,
								-16.936660871999948
							],
							[
								146.00461421700004,
								-16.92532283299994
							]
						]
					],
					[
						[
							[
								146.01664211800005,
								-17.155970844999956
							],
							[
								146.00489228900005,
								-17.154380884999966
							],
							[
								146.0118122880001,
								-17.165010794999944
							],
							[
								146.01664211800005,
								-17.155970844999956
							]
						]
					],
					[
						[
							[
								146.24700720300007,
								-18.295865611999943
							],
							[
								146.19634779800003,
								-18.277885977999972
							],
							[
								146.12708828600012,
								-18.234606592999967
							],
							[
								146.1037986980001,
								-18.23441669099998
							],
							[
								146.07081944900006,
								-18.24665670899998
							],
							[
								146.10102932400002,
								-18.285936340999967
							],
							[
								146.15169887900004,
								-18.312975924999932
							],
							[
								146.19130893200008,
								-18.366695377999974
							],
							[
								146.20698913800004,
								-18.397745059999977
							],
							[
								146.200909625,
								-18.43740490999994
							],
							[
								146.22182967100002,
								-18.476804640999944
							],
							[
								146.24790935800002,
								-18.48884450299994
							],
							[
								146.28969878500004,
								-18.48740427699994
							],
							[
								146.30522862400005,
								-18.493694167999934
							],
							[
								146.3284182430001,
								-18.483474158999968
							],
							[
								146.3287877360001,
								-18.447204368999962
							],
							[
								146.33762740600002,
								-18.430904409999982
							],
							[
								146.3456773360001,
								-18.431674399999963
							],
							[
								146.35842697600003,
								-18.418314420999934
							],
							[
								146.32416724000007,
								-18.400204617999975
							],
							[
								146.3273170010001,
								-18.38144475799993
							],
							[
								146.33442691000005,
								-18.38628468899998
							],
							[
								146.33961681000005,
								-18.380734718999975
							],
							[
								146.33060682100006,
								-18.37273480899995
							],
							[
								146.33140665200006,
								-18.36233489899996
							],
							[
								146.3181267440001,
								-18.351974996999957
							],
							[
								146.306066965,
								-18.35573498699995
							],
							[
								146.2900168980001,
								-18.325605234999955
							],
							[
								146.27556702000004,
								-18.31749535399996
							],
							[
								146.2816265020001,
								-18.28279555399996
							],
							[
								146.30564565400005,
								-18.240255785999977
							],
							[
								146.29876573500007,
								-18.231465844999946
							],
							[
								146.27454615600004,
								-18.239875902999927
							],
							[
								146.25053653800012,
								-18.237106021999978
							],
							[
								146.23169681100012,
								-18.219516169999963
							],
							[
								146.231176752,
								-18.197146269999962
							],
							[
								146.22348682300003,
								-18.194216308999955
							],
							[
								146.22447692100002,
								-18.213656218999972
							],
							[
								146.216467071,
								-18.227346198999953
							],
							[
								146.22782686000005,
								-18.234436109999933
							],
							[
								146.2324869570001,
								-18.257475989999932
							],
							[
								146.24421688600012,
								-18.26615585099995
							],
							[
								146.23262703700004,
								-18.265495919999978
							],
							[
								146.23051719600005,
								-18.272285869999962
							],
							[
								146.24700720300007,
								-18.295865611999943
							]
						]
					],
					[
						[
							[
								146.226827296,
								-18.27756585999998
							],
							[
								146.2298373850001,
								-18.28764572999995
							],
							[
								146.24108726400004,
								-18.29282564099998
							],
							[
								146.23786719500004,
								-18.28232576099998
							],
							[
								146.226827296,
								-18.27756585999998
							]
						]
					],
					[
						[
							[
								146.2782053640001,
								-18.140206432999946
							],
							[
								146.28743526300002,
								-18.143246372999954
							],
							[
								146.2820952840001,
								-18.13511643299995
							],
							[
								146.2782053640001,
								-18.140206432999946
							]
						]
					],
					[
						[
							[
								146.18346966800004,
								-18.41405509799995
							],
							[
								146.18312974800006,
								-18.423545067999953
							],
							[
								146.19260967700006,
								-18.429404998999928
							],
							[
								146.19384932900005,
								-18.39584512899995
							],
							[
								146.178899182,
								-18.37304538799998
							],
							[
								146.18346966800004,
								-18.41405509799995
							]
						]
					],
					[
						[
							[
								146.17864991700003,
								-18.435645027999954
							],
							[
								146.18705977700006,
								-18.433134998999947
							],
							[
								146.18443976700007,
								-18.427275037999948
							],
							[
								146.17864991700003,
								-18.435645027999954
							]
						]
					],
					[
						[
							[
								146.18930977600007,
								-18.438104968999937
							],
							[
								146.1768799670001,
								-18.43711505799996
							],
							[
								146.17086008700005,
								-18.445485047999966
							],
							[
								146.18930977600007,
								-18.438104968999937
							]
						]
					],
					[
						[
							[
								146.20876971300004,
								-18.46067476999997
							],
							[
								146.19278994400008,
								-18.459684868999943
							],
							[
								146.18997010300006,
								-18.47076483899997
							],
							[
								146.20606988200007,
								-18.47175472999993
							],
							[
								146.20876971300004,
								-18.46067476999997
							]
						]
					],
					[
						[
							[
								146.17639991700003,
								-18.432365067999967
							],
							[
								146.17885979800008,
								-18.41869510799995
							],
							[
								146.17057991900003,
								-18.423455136999962
							],
							[
								146.17639991700003,
								-18.432365067999967
							]
						]
					],
					[
						[
							[
								146.17860969900005,
								-18.410895147999952
							],
							[
								146.16841981000005,
								-18.407405196999946
							],
							[
								146.17104988900007,
								-18.419605136999962
							],
							[
								146.182169648,
								-18.41405509799995
							],
							[
								146.17860969900005,
								-18.410895147999952
							]
						]
					],
					[
						[
							[
								146.15725736900004,
								-18.176826783999957
							],
							[
								146.17605730700006,
								-18.180976645999976
							],
							[
								146.19222698700003,
								-18.16659663699994
							],
							[
								146.17198716000007,
								-18.151156834999938
							],
							[
								146.1605272910001,
								-18.152186873999938
							],
							[
								146.15240745900007,
								-18.17536682399998
							],
							[
								146.15725736900004,
								-18.176826783999957
							]
						]
					],
					[
						[
							[
								146.17237922300012,
								-18.368315456999937
							],
							[
								146.1450294450001,
								-18.358075674999952
							],
							[
								146.16580984000007,
								-18.40289523699994
							],
							[
								146.1787297090001,
								-18.409655157999964
							],
							[
								146.1791393210001,
								-18.37903531799998
							],
							[
								146.17237922300012,
								-18.368315456999937
							]
						]
					],
					[
						[
							[
								146.17217577500003,
								-17.964897793999967
							],
							[
								146.17830568400007,
								-17.967517743999963
							],
							[
								146.17377560600005,
								-17.94693790399998
							],
							[
								146.151535899,
								-17.927648061999946
							],
							[
								146.13415621000001,
								-17.935388110999952
							],
							[
								146.17217577500003,
								-17.964897793999967
							]
						]
					],
					[
						[
							[
								146.14973462300009,
								-18.009274801999936
							],
							[
								146.1548795120001,
								-18.00934299299996
							],
							[
								146.15170251400002,
								-17.99728591199994
							],
							[
								146.14149241400003,
								-18.003849541999955
							],
							[
								146.14973462300009,
								-18.009274801999936
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "317",
				"CED_NAME21": "Kennedy",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 566332.2394,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/317",
				"SHAPE_Leng": 53.8932130684,
				"SHAPE_Area": 48.7992107062
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								141.39756528700002,
								-15.909563738999964
							],
							[
								141.4117229960001,
								-15.910012498999947
							],
							[
								141.42094704700003,
								-15.894394449999936
							],
							[
								141.41561604800006,
								-15.881120488999954
							],
							[
								141.4232899980001,
								-15.87094049999996
							],
							[
								141.43555904700008,
								-15.870513499999959
							],
							[
								141.42575205900005,
								-15.854933419999952
							],
							[
								141.4255010500001,
								-15.834704408999926
							],
							[
								141.43703902900006,
								-15.833373429999938
							],
							[
								141.4307180190001,
								-15.843249509999964
							],
							[
								141.4387360080001,
								-15.848969409999938
							],
							[
								141.45139699800006,
								-15.838678440999956
							],
							[
								141.46232704700003,
								-15.844492440999943
							],
							[
								141.46946099800005,
								-15.827267461999952
							],
							[
								141.4756130070001,
								-15.835204461999979
							],
							[
								141.49161898600005,
								-15.833256422999966
							],
							[
								141.48207901600006,
								-15.843443441999966
							],
							[
								141.48813603500003,
								-15.854801492999968
							],
							[
								141.4963365760001,
								-15.836696002999929
							],
							[
								141.50419983400002,
								-15.850461553999935
							],
							[
								141.520966014,
								-15.844963504999953
							],
							[
								141.5308130310001,
								-15.873018434999949
							],
							[
								141.55026700000008,
								-15.87639149599994
							],
							[
								141.56029904100012,
								-15.856841466999981
							],
							[
								141.5823830480001,
								-15.87127548799998
							],
							[
								141.5899410390001,
								-15.860083427999939
							],
							[
								141.59816903800004,
								-15.864992508999933
							],
							[
								141.62029699700008,
								-15.85848950999997
							],
							[
								141.63707703500006,
								-15.871322420999945
							],
							[
								141.65851298400003,
								-15.876290461999929
							],
							[
								141.67619727200008,
								-15.893609162999951
							],
							[
								141.70240486000012,
								-15.901465474999952
							],
							[
								141.80347401400002,
								-15.901435479999975
							],
							[
								141.8160330920001,
								-15.908945470999981
							],
							[
								141.85548129100005,
								-15.893629872999952
							],
							[
								141.9228195060001,
								-15.915678186999969
							],
							[
								141.96048789400004,
								-15.901554938999936
							],
							[
								142.05102690700005,
								-15.928130933999967
							],
							[
								142.07668810400003,
								-15.95172215499997
							],
							[
								142.09114511300004,
								-15.956124975999955
							],
							[
								142.14951999000004,
								-15.945833498999946
							],
							[
								142.1757999890001,
								-15.94809350099996
							],
							[
								142.19149079900012,
								-15.930189921999954
							],
							[
								142.20426894700006,
								-15.941480491999982
							],
							[
								142.24377102500011,
								-15.943454464999945
							],
							[
								142.2782889020001,
								-15.953640486999973
							],
							[
								142.35206031000007,
								-15.920535979999954
							],
							[
								142.37304297800006,
								-15.93251281199997
							],
							[
								142.3884550140001,
								-15.978470422999976
							],
							[
								142.42605669300008,
								-15.960180224999931
							],
							[
								142.47619224900006,
								-15.968721847999973
							],
							[
								142.49717491700005,
								-15.98394819899994
							],
							[
								142.52391388500007,
								-15.986454980999952
							],
							[
								142.5780417200001,
								-16.023035383999968
							],
							[
								142.62570294700004,
								-16.01754653699993
							],
							[
								142.66030596300004,
								-16.060837538999976
							],
							[
								142.69962394000004,
								-16.070624541999962
							],
							[
								142.73056564700005,
								-16.08946394399993
							],
							[
								142.74552954600006,
								-16.078348753999933
							],
							[
								142.77222732500002,
								-16.07456182599998
							],
							[
								142.87436544800005,
								-16.08650430199998
							],
							[
								142.94059922500003,
								-16.07586721599995
							],
							[
								143.05919892200006,
								-16.16201707299996
							],
							[
								143.10916671600012,
								-16.20648856699995
							],
							[
								143.09799589600004,
								-16.219895545999975
							],
							[
								143.20774568500008,
								-16.295437682999932
							],
							[
								143.14385086200002,
								-16.39602653999998
							],
							[
								143.18460679700001,
								-16.430775532999974
							],
							[
								143.21913696500008,
								-16.42757559499995
							],
							[
								143.23093989400002,
								-16.433917565999934
							],
							[
								143.2224229080001,
								-16.54153455599993
							],
							[
								143.33729588000006,
								-16.54954556299998
							],
							[
								143.35668387600003,
								-16.58980758499996
							],
							[
								143.39051787200003,
								-16.630499576999966
							],
							[
								143.4019488680001,
								-16.673613587999967
							],
							[
								143.54347986800008,
								-16.687948596999945
							],
							[
								143.53917388600007,
								-16.73115958699998
							],
							[
								143.56606186400006,
								-16.733915588999935
							],
							[
								143.58330785900012,
								-16.785417589999952
							],
							[
								143.8402689720001,
								-16.807137585999953
							],
							[
								143.83852766400003,
								-16.777964615999963
							],
							[
								143.8266019560001,
								-16.76161459499997
							],
							[
								143.8251669870001,
								-16.74343261499996
							],
							[
								143.83623484700001,
								-16.728897624999945
							],
							[
								143.829508959,
								-16.715512634999982
							],
							[
								143.83505474000003,
								-16.686221604999957
							],
							[
								143.82393691200002,
								-16.67266256399995
							],
							[
								143.82323381300012,
								-16.659263623999948
							],
							[
								143.80743701400002,
								-16.649619592999954
							],
							[
								143.80435072500006,
								-16.63522265299997
							],
							[
								143.78894202700008,
								-16.62020856199996
							],
							[
								143.78673988000003,
								-16.58348758099993
							],
							[
								143.74575677300004,
								-16.571554558999935
							],
							[
								143.7359438950001,
								-16.55894061799995
							],
							[
								143.70522293700003,
								-16.550746575999938
							],
							[
								143.696329858,
								-16.555856584999958
							],
							[
								143.68383499900006,
								-16.54377660399996
							],
							[
								143.68402688000003,
								-16.536488583999926
							],
							[
								143.6958488990001,
								-16.531559554999944
							],
							[
								143.696969931,
								-16.506376564999982
							],
							[
								143.71452102000012,
								-16.503459575999955
							],
							[
								143.71939684100005,
								-16.480016655999975
							],
							[
								143.73558678100005,
								-16.470841596999946
							],
							[
								143.7516517790001,
								-16.47920655799993
							],
							[
								143.76229302900003,
								-16.474046588999954
							],
							[
								143.76448398000002,
								-16.451638558999946
							],
							[
								143.79908177900006,
								-16.435404650999942
							],
							[
								143.81823775100008,
								-16.39412660199997
							],
							[
								143.84237684000004,
								-16.376891592999982
							],
							[
								143.87607388800006,
								-16.38494858499996
							],
							[
								143.91202996700008,
								-16.372084606999977
							],
							[
								143.9210047670001,
								-16.36177357799994
							],
							[
								143.9681759440001,
								-16.36475761099996
							],
							[
								143.98160575200006,
								-16.379217661999974
							],
							[
								144.03453183800002,
								-16.394769654999948
							],
							[
								144.0545546840001,
								-16.43546658699995
							],
							[
								144.05235077200007,
								-16.45965758699998
							],
							[
								144.0812609200001,
								-16.469423578999965
							],
							[
								144.09258398800011,
								-16.487061609999955
							],
							[
								144.12125185500008,
								-16.495000580999942
							],
							[
								144.14346385400006,
								-16.48864965299998
							],
							[
								144.15301283300005,
								-16.49793962399997
							],
							[
								144.16437484300002,
								-16.497453633999953
							],
							[
								144.1963078220001,
								-16.48162962599997
							],
							[
								144.21044182200012,
								-16.46001562699996
							],
							[
								144.22125484200012,
								-16.45649563799998
							],
							[
								144.2404046700001,
								-16.46293764899997
							],
							[
								144.25080472800005,
								-16.480823619999967
							],
							[
								144.283211907,
								-16.47541363199997
							],
							[
								144.3001977660001,
								-16.46542463299994
							],
							[
								144.32669198400004,
								-16.47159861399996
							],
							[
								144.34050770200008,
								-16.49112566599996
							],
							[
								144.37125183000012,
								-16.494404647999943
							],
							[
								144.38492480800005,
								-16.514834638999957
							],
							[
								144.4358508050001,
								-16.506641641999977
							],
							[
								144.44677580300004,
								-16.533914632999938
							],
							[
								144.47746379000012,
								-16.541350634999958
							],
							[
								144.48323681700003,
								-16.575508655999954
							],
							[
								144.5003768150001,
								-16.600378646999957
							],
							[
								144.52630381300003,
								-16.60403864899996
							],
							[
								144.5444197810001,
								-16.61478564999993
							],
							[
								144.5611378100001,
								-16.61334365099998
							],
							[
								144.57399879800005,
								-16.625232661999974
							],
							[
								144.58961579800007,
								-16.609143652999933
							],
							[
								144.595900808,
								-16.61027765299997
							],
							[
								144.61251180500005,
								-16.641836654999963
							],
							[
								144.61536577300012,
								-16.66536565499996
							],
							[
								144.62932180100006,
								-16.680263655999966
							],
							[
								144.64130278100004,
								-16.66766864699997
							],
							[
								144.6625377900001,
								-16.66219566799998
							],
							[
								144.67021366900008,
								-16.667435678999936
							],
							[
								144.66103675500005,
								-16.74355966899998
							],
							[
								144.74247978900007,
								-16.75208465399993
							],
							[
								144.8048217930001,
								-16.636468666999974
							],
							[
								144.84022876200004,
								-16.626152669999954
							],
							[
								144.84291176400006,
								-16.597410658999934
							],
							[
								144.85360488300012,
								-16.59514362999994
							],
							[
								144.8556799040001,
								-16.57724965999995
							],
							[
								144.884116693,
								-16.575043681999944
							],
							[
								144.89300363400002,
								-16.545651651999947
							],
							[
								144.92158076300007,
								-16.53808464399998
							],
							[
								144.91834978600002,
								-16.502719673999934
							],
							[
								144.9413188740001,
								-16.514427694999938
							],
							[
								144.95151084300005,
								-16.507382675999963
							],
							[
								144.99655691100008,
								-16.503088678999973
							],
							[
								145.01409392100004,
								-16.484250679999946
							],
							[
								145.0932388770001,
								-16.481652894999968
							],
							[
								145.10431964800011,
								-16.45054668599994
							],
							[
								145.1194547760001,
								-16.461830686999974
							],
							[
								145.13356377600007,
								-16.46188468799994
							],
							[
								145.1681237690001,
								-16.390777689999936
							],
							[
								145.09976778700002,
								-16.33200068399998
							],
							[
								144.98967598500008,
								-16.318400636999968
							],
							[
								144.99247071600007,
								-16.303626356999928
							],
							[
								144.97582072800003,
								-16.279611425999974
							],
							[
								144.9949077880001,
								-16.26365876699998
							],
							[
								144.99249790900012,
								-16.25304185699997
							],
							[
								145.02104985000005,
								-16.220874007999953
							],
							[
								145.02616218900005,
								-16.224382178999974
							],
							[
								145.02031510900008,
								-16.22901272799993
							],
							[
								145.054384496,
								-16.24076730099995
							],
							[
								145.0617461050001,
								-16.248978060999946
							],
							[
								145.05520990500008,
								-16.25924595099997
							],
							[
								145.0609678840001,
								-16.263986700999965
							],
							[
								145.09627700200008,
								-16.26444330399994
							],
							[
								145.1336271880001,
								-16.286266095999963
							],
							[
								145.12969347700005,
								-16.304051345999937
							],
							[
								145.1384643870001,
								-16.308120146999954
							],
							[
								145.14030278400003,
								-16.346548216999963
							],
							[
								145.15897070200003,
								-16.34905170899998
							],
							[
								145.19042877700008,
								-16.393955630999926
							],
							[
								145.21400868500007,
								-16.399885352999945
							],
							[
								145.20879714400007,
								-16.41997642299998
							],
							[
								145.22226337300003,
								-16.42686538399994
							],
							[
								145.2285744410001,
								-16.442067033999933
							],
							[
								145.24040887,
								-16.445581924999942
							],
							[
								145.2429451490001,
								-16.46431805499998
							],
							[
								145.2697488870001,
								-16.466534416999934
							],
							[
								145.25845147600012,
								-16.484565886999974
							],
							[
								145.2687241850001,
								-16.488643766999928
							],
							[
								145.26417708500003,
								-16.49952304699997
							],
							[
								145.27642896400005,
								-16.500635357999954
							],
							[
								145.2726503340001,
								-16.510417467999957
							],
							[
								145.2971864010001,
								-16.53107271999994
							],
							[
								145.2957290700001,
								-16.53675458999993
							],
							[
								145.30931364000003,
								-16.53110947999994
							],
							[
								145.32631080800002,
								-16.541830551999965
							],
							[
								145.3258193370001,
								-16.55179437199996
							],
							[
								145.345617736,
								-16.54746061299994
							],
							[
								145.35402562500008,
								-16.556519993999927
							],
							[
								145.3720597560001,
								-16.532935694999935
							],
							[
								145.37356177700008,
								-16.519091704999937
							],
							[
								145.38430518600012,
								-16.520177285999978
							],
							[
								145.3853811670001,
								-16.51035087599996
							],
							[
								145.40414745500004,
								-16.512253846999954
							],
							[
								145.41066296400004,
								-16.519964846999926
							],
							[
								145.41029726400006,
								-16.527619966999964
							],
							[
								145.43322021100005,
								-16.551960678999933
							],
							[
								145.4319165390001,
								-16.569451328999946
							],
							[
								145.4455947680001,
								-16.575341719999926
							],
							[
								145.44146369700002,
								-16.596052849999978
							],
							[
								145.44855874600012,
								-16.604459720999955
							],
							[
								145.4358597470001,
								-16.60355770999996
							],
							[
								145.449245345,
								-16.610697990999938
							],
							[
								145.44716937300007,
								-16.643529350999927
							],
							[
								145.46408946100007,
								-16.649253771999952
							],
							[
								145.48744168100006,
								-16.641704583999967
							],
							[
								145.48396574700007,
								-16.696740733999945
							],
							[
								145.51829403400006,
								-16.699873525999976
							],
							[
								145.5240666530001,
								-16.707057006999946
							],
							[
								145.522599022,
								-16.724043776999963
							],
							[
								145.51263434200007,
								-16.734911345999933
							],
							[
								145.48041812400004,
								-16.732932253999934
							],
							[
								145.47127873700003,
								-16.831592713999953
							],
							[
								145.47723374600002,
								-16.841197714999964
							],
							[
								145.49108673600006,
								-16.83490371599993
							],
							[
								145.48967572700008,
								-16.818078724999964
							],
							[
								145.49526073700008,
								-16.81862870599997
							],
							[
								145.49445072600008,
								-16.827095715999974
							],
							[
								145.50217171600002,
								-16.82408870599994
							],
							[
								145.503930727,
								-16.81218871599998
							],
							[
								145.54807375400003,
								-16.806475708999926
							],
							[
								145.54048273500007,
								-16.81181371899993
							],
							[
								145.5426807230001,
								-16.82540372899996
							],
							[
								145.55586073200004,
								-16.82723070999998
							],
							[
								145.55152665000003,
								-16.857387139999958
							],
							[
								145.53653668200002,
								-16.851625678999937
							],
							[
								145.52048712200008,
								-16.857148027999926
							],
							[
								145.52936392200002,
								-16.85924013799996
							],
							[
								145.52456961200005,
								-16.86474021799995
							],
							[
								145.53821151900001,
								-16.889726398999926
							],
							[
								145.5282861060001,
								-16.938591058999975
							],
							[
								145.54851250600007,
								-16.91418735999997
							],
							[
								145.55795611500002,
								-16.92603078099995
							],
							[
								145.56950292500005,
								-16.915113471999973
							],
							[
								145.58742993300007,
								-16.923960762999968
							],
							[
								145.6013871030001,
								-16.91536018399995
							],
							[
								145.60411471400005,
								-16.904177733999973
							],
							[
								145.6214467310001,
								-16.918263724999974
							],
							[
								145.6612388090001,
								-16.91637052799996
							],
							[
								145.66154869800005,
								-16.92872597799993
							],
							[
								145.64988522800002,
								-16.945284397999956
							],
							[
								145.6548111950001,
								-16.974667917999966
							],
							[
								145.63966971500008,
								-16.985703756999953
							],
							[
								145.63009758400005,
								-17.00679271699994
							],
							[
								145.63680201300008,
								-17.020432786999947
							],
							[
								145.68918191800003,
								-17.045002050999926
							],
							[
								145.700865678,
								-17.032975741999962
							],
							[
								145.7066296900001,
								-16.998211741999967
							],
							[
								145.71571570900005,
								-16.999269742999957
							],
							[
								145.72134280000012,
								-16.98565916299998
							],
							[
								145.72730581000008,
								-16.986234232999948
							],
							[
								145.7266407080001,
								-17.00233472399998
							],
							[
								145.73394986800008,
								-17.00368376399996
							],
							[
								145.7556897080001,
								-16.98792774499998
							],
							[
								145.77155771700006,
								-16.98767173699997
							],
							[
								145.77621277700007,
								-16.97487575699995
							],
							[
								145.76811846900011,
								-16.95969985599993
							],
							[
								145.78187521000007,
								-16.94102487699996
							],
							[
								145.78343934100008,
								-16.91699813699995
							],
							[
								145.77655084200012,
								-16.918175745999974
							],
							[
								145.76244564400008,
								-16.897869774999947
							],
							[
								145.76862998500008,
								-16.882240224999975
							],
							[
								145.7770368450001,
								-16.880356165999956
							],
							[
								145.7654809060001,
								-16.86923930499995
							],
							[
								145.7748746960001,
								-16.87000271599993
							],
							[
								145.74484399900007,
								-16.845432582999933
							],
							[
								145.72486193400005,
								-16.803867941999954
							],
							[
								145.7149998440001,
								-16.802711690999956
							],
							[
								145.69535175800002,
								-16.77559575899994
							],
							[
								145.69098609800005,
								-16.780402298999945
							],
							[
								145.68271614800005,
								-16.77556539899996
							],
							[
								145.6710039620001,
								-16.73734267699996
							],
							[
								145.6512331140001,
								-16.729475885999932
							],
							[
								145.62153773800003,
								-16.69953073399995
							],
							[
								145.5819445510001,
								-16.68718274099996
							],
							[
								145.5649856760001,
								-16.643152748999967
							],
							[
								145.52299973100003,
								-16.600892715999976
							],
							[
								145.52209117300004,
								-16.586241385999926
							],
							[
								145.5136712730001,
								-16.584392434999927
							],
							[
								145.50004064600012,
								-16.55285574399994
							],
							[
								145.4700508310001,
								-16.514365720999933
							],
							[
								145.46859065400008,
								-16.47988571099995
							],
							[
								145.42688604700004,
								-16.474527077999937
							],
							[
								145.40952616900006,
								-16.45679718699995
							],
							[
								145.4051586610001,
								-16.43339270599995
							],
							[
								145.4198761140001,
								-16.387917266999978
							],
							[
								145.4121362950001,
								-16.376167305999957
							],
							[
								145.41817613700005,
								-16.338287355999967
							],
							[
								145.44926175900002,
								-16.290862697999955
							],
							[
								145.459944768,
								-16.290314708999972
							],
							[
								145.4770851290001,
								-16.275217329999975
							],
							[
								145.48890491800012,
								-16.276667260999943
							],
							[
								145.47894509900004,
								-16.267977349999967
							],
							[
								145.4819449910001,
								-16.241397399999983
							],
							[
								145.47035519200006,
								-16.23582745899995
							],
							[
								145.46926519400006,
								-16.21088753899994
							],
							[
								145.44492071600007,
								-16.20085673699998
							],
							[
								145.4423256770001,
								-16.186277666999956
							],
							[
								145.445675649,
								-16.15348774699993
							],
							[
								145.47689497300007,
								-16.076087837999978
							],
							[
								145.46483526500003,
								-16.066387876999954
							],
							[
								145.4636252570001,
								-16.035967936999953
							],
							[
								145.4556654480001,
								-16.030557985999963
							],
							[
								145.45072558000004,
								-16.009308035999936
							],
							[
								145.43435591200011,
								-15.998078084999975
							],
							[
								145.4138463160001,
								-15.950988262999942
							],
							[
								145.4043265680001,
								-15.940318291999972
							],
							[
								145.39347675800002,
								-15.93980832099993
							],
							[
								145.38212690000012,
								-15.924148379999963
							],
							[
								145.36294181100004,
								-15.921765698999934
							],
							[
								145.35734735300002,
								-15.910458437999978
							],
							[
								145.356858804,
								-15.88995370799995
							],
							[
								145.3773908170001,
								-15.840626688999976
							],
							[
								145.37295679700003,
								-15.833206688999951
							],
							[
								145.35832879800012,
								-15.830947697999932
							],
							[
								145.35190583000008,
								-15.807492686999979
							],
							[
								145.3681398230001,
								-15.76676270799993
							],
							[
								145.36128724600007,
								-15.719578876999947
							],
							[
								145.33550767100007,
								-15.681479034999938
							],
							[
								145.33305760200005,
								-15.662599094999962
							],
							[
								145.31275798500008,
								-15.646789162999937
							],
							[
								145.3191375250001,
								-15.632248832999949
							],
							[
								145.3164218270001,
								-15.605560692999973
							],
							[
								145.32764181700009,
								-15.605402703999971
							],
							[
								145.32959182700006,
								-15.594104693999952
							],
							[
								145.32017080800006,
								-15.58892270299998
							],
							[
								145.3174018100001,
								-15.573717692999935
							],
							[
								145.32283484000004,
								-15.570613692999927
							],
							[
								145.30703632200004,
								-15.552437571999974
							],
							[
								145.287296652,
								-15.559097620999978
							],
							[
								145.27202655500002,
								-15.541277368999943
							],
							[
								145.2725262360001,
								-15.517897088999973
							],
							[
								145.28371523700002,
								-15.497178859999963
							],
							[
								145.2758118280001,
								-15.493645698999956
							],
							[
								145.2628338510001,
								-15.461118737999982
							],
							[
								145.25626600200007,
								-15.456565017999935
							],
							[
								145.24420096200004,
								-15.46586766699994
							],
							[
								145.22855783300008,
								-15.46202769599995
							],
							[
								145.24106485200002,
								-15.46155168699994
							],
							[
								145.2390858540001,
								-15.44087568599997
							],
							[
								145.24816085500004,
								-15.416266686999961
							],
							[
								145.28816583600008,
								-15.375948698999935
							],
							[
								145.28543684700003,
								-15.363861688999975
							],
							[
								145.29806883800006,
								-15.34226069899995
							],
							[
								145.283720839,
								-15.329290697999966
							],
							[
								145.28637085000003,
								-15.316448677999972
							],
							[
								145.3316018700001,
								-15.278315690999932
							],
							[
								145.35710185900007,
								-15.277224692999937
							],
							[
								145.33955584400007,
								-15.22661268099995
							],
							[
								145.31592683300005,
								-15.259366689999979
							],
							[
								145.26703183600011,
								-15.255779686999972
							],
							[
								145.23926987100003,
								-15.198462683999935
							],
							[
								145.24028388500005,
								-15.152531683999939
							],
							[
								145.2338068460001,
								-15.140730682999958
							],
							[
								145.2890088700001,
								-15.043485695999948
							],
							[
								145.34735087100012,
								-14.984663689999934
							],
							[
								145.35532689000001,
								-14.987410699999941
							],
							[
								145.348236874,
								-14.94595868999994
							],
							[
								145.3312238640001,
								-14.956141677999938
							],
							[
								145.31459088500003,
								-14.953232686999968
							],
							[
								145.3071288650001,
								-14.963034686999947
							],
							[
								145.2808768970001,
								-14.954925694999929
							],
							[
								145.26455986000008,
								-14.927162683999939
							],
							[
								145.21934089500007,
								-14.88086968999994
							],
							[
								145.2297128880001,
								-14.831730669999956
							],
							[
								145.17348989100003,
								-14.842670676999944
							],
							[
								145.1177938950001,
								-14.827683682999975
							],
							[
								145.0904868980001,
								-14.803083670999968
							],
							[
								145.02345191200004,
								-14.795336665999969
							],
							[
								145.02217988300004,
								-14.78395966599993
							],
							[
								145.00410892500008,
								-14.772990654999944
							],
							[
								145.001915896,
								-14.760830663999968
							],
							[
								145.00784589600005,
								-14.75580565499996
							],
							[
								144.969854918,
								-14.74832066199997
							],
							[
								144.95379590000005,
								-14.737197670999933
							],
							[
								144.95044991400005,
								-14.67748765999994
							],
							[
								144.9424889060001,
								-14.664082649999955
							],
							[
								144.92386090700006,
								-14.663496667999937
							],
							[
								144.9237499080001,
								-14.641046657999937
							],
							[
								144.90966091100006,
								-14.613701656999979
							],
							[
								144.88831761200004,
								-14.609384844999965
							],
							[
								144.87288797300005,
								-14.616944813999964
							],
							[
								144.86999797300007,
								-14.611404873999959
							],
							[
								144.83878857500008,
								-14.614324931999931
							],
							[
								144.828128536,
								-14.605845010999928
							],
							[
								144.81629881600009,
								-14.608085030999973
							],
							[
								144.8094686070001,
								-14.598705139999936
							],
							[
								144.78267869900003,
								-14.593605317999959
							],
							[
								144.77506593300006,
								-14.546092656999974
							],
							[
								144.7268389940001,
								-14.558985763999942
							],
							[
								144.71605905500007,
								-14.555915823999953
							],
							[
								144.71511921500007,
								-14.561005782999928
							],
							[
								144.68267932700007,
								-14.551245970999958
							],
							[
								144.66511948100003,
								-14.51102617999993
							],
							[
								144.61938592600006,
								-14.476405645999932
							],
							[
								144.62416094000002,
								-14.419431635999956
							],
							[
								144.65112093200003,
								-14.358694637999974
							],
							[
								144.64391496300004,
								-14.348419646999957
							],
							[
								144.62237740400008,
								-14.362027575999946
							],
							[
								144.58752797500006,
								-14.361374632999969
							],
							[
								144.58804795800006,
								-14.328777632999959
							],
							[
								144.58019195000008,
								-14.308047631999955
							],
							[
								144.595799972,
								-14.260267642999963
							],
							[
								144.57606796400012,
								-14.248456631999943
							],
							[
								144.5773819650001,
								-14.234837631999937
							],
							[
								144.55784497600007,
								-14.228750629999979
							],
							[
								144.5162174630001,
								-14.166629196999963
							],
							[
								144.49145773400005,
								-14.166009264999957
							],
							[
								144.46487996100007,
								-14.227494623999974
							],
							[
								144.4354729700001,
								-14.259671612999966
							],
							[
								144.4070049710001,
								-14.273698630999945
							],
							[
								144.39898698100012,
								-14.27128061999997
							],
							[
								144.3383339820001,
								-14.306988616999945
							],
							[
								144.3140159730001,
								-14.308313624999926
							],
							[
								144.29237698500003,
								-14.297901613999954
							],
							[
								144.28034596500004,
								-14.301508612999953
							],
							[
								144.2444619800001,
								-14.26411059999998
							],
							[
								144.23273099000005,
								-14.268848599999956
							],
							[
								144.21635286200012,
								-14.254129227999954
							],
							[
								144.2091479720001,
								-14.261681607999947
							],
							[
								144.1953709830001,
								-14.261393596999937
							],
							[
								144.19850296800007,
								-14.322796617999927
							],
							[
								144.1683144760001,
								-14.381398565999973
							],
							[
								144.1511447260001,
								-14.38969859499997
							],
							[
								144.14191697600006,
								-14.404707604999942
							],
							[
								144.12769508600002,
								-14.405068613999958
							],
							[
								144.0952157060001,
								-14.44512856199998
							],
							[
								144.02985996600012,
								-14.483700598999974
							],
							[
								143.95868198000005,
								-14.48635660399998
							],
							[
								143.9492409600001,
								-14.495660603999966
							],
							[
								143.92966196200007,
								-14.483916601999965
							],
							[
								143.89473997300001,
								-14.485508599999946
							],
							[
								143.86082698600012,
								-14.47450658799994
							],
							[
								143.80563800200002,
								-14.432176583999933
							],
							[
								143.765002997,
								-14.376046580999969
							],
							[
								143.6998290130001,
								-14.195534564999946
							],
							[
								143.70198700700007,
								-14.126789584999926
							],
							[
								143.6795670350001,
								-14.014508572999944
							],
							[
								143.62326703100007,
								-13.964736568999967
							],
							[
								143.6005790360001,
								-13.908576566999955
							],
							[
								143.59138703000008,
								-13.859051565999948
							],
							[
								143.54741103600009,
								-13.803345562999937
							],
							[
								143.53130504900003,
								-13.755009550999944
							],
							[
								143.54325204100007,
								-13.71569556199995
							],
							[
								143.55128504700008,
								-13.617418560999965
							],
							[
								143.56096104900007,
								-13.584915561999935
							],
							[
								143.58609105000005,
								-13.544047562999936
							],
							[
								143.57893606300001,
								-13.500125561999937
							],
							[
								143.59745707700006,
								-13.422791571999937
							],
							[
								143.5817960710001,
								-13.375654570999927
							],
							[
								143.54011208500003,
								-13.352924557999927
							],
							[
								143.52692806700009,
								-13.327360556999963
							],
							[
								143.51670508200004,
								-13.258206555999948
							],
							[
								143.52180708700007,
								-13.178832565999926
							],
							[
								143.5055260890001,
								-13.150626554999974
							],
							[
								143.50215809100007,
								-13.124262553999927
							],
							[
								143.51291310500005,
								-13.05867955399998
							],
							[
								143.5059051060001,
								-13.037045543999966
							],
							[
								143.514580098,
								-13.008117553999966
							],
							[
								143.5040901100001,
								-12.986634562999939
							],
							[
								143.51221209100004,
								-12.961208552999949
							],
							[
								143.50033412200003,
								-12.95804155299993
							],
							[
								143.4977260820001,
								-12.949113541999964
							],
							[
								143.511987115,
								-12.902368562999982
							],
							[
								143.54425311700004,
								-12.843266553999968
							],
							[
								143.53363562800007,
								-12.838959973999977
							],
							[
								143.50011709800003,
								-12.860090541999966
							],
							[
								143.47451011900012,
								-12.865386559999934
							],
							[
								143.44935312100006,
								-12.848919537999961
							],
							[
								143.40512804200011,
								-12.867789885999969
							],
							[
								143.39782811100008,
								-12.887334545999977
							],
							[
								143.40142413,
								-12.900507545999972
							],
							[
								143.39151412,
								-12.896956544999966
							],
							[
								143.39022111100007,
								-12.885051554999961
							],
							[
								143.37549712100008,
								-12.89926255399996
							],
							[
								143.36520412200002,
								-12.89119455399998
							],
							[
								143.3535101020001,
								-12.896071542999948
							],
							[
								143.35770012800003,
								-12.799606542999982
							],
							[
								143.3821182700001,
								-12.74995043399997
							],
							[
								143.39002304200005,
								-12.714820513999939
							],
							[
								143.41886884300004,
								-12.681645344999936
							],
							[
								143.41873718300008,
								-12.676000614999964
							],
							[
								143.4023541240001,
								-12.67903855399993
							],
							[
								143.40247742500003,
								-12.662260643999957
							],
							[
								143.4381720560001,
								-12.623320285999966
							],
							[
								143.438456276,
								-12.611800875999961
							],
							[
								143.41883668700007,
								-12.615940844999955
							],
							[
								143.4217565470001,
								-12.606200884999964
							],
							[
								143.4149776280001,
								-12.593899043999954
							],
							[
								143.39343695900004,
								-12.595540982999978
							],
							[
								143.35528727300004,
								-12.56413122999993
							],
							[
								143.33665756400012,
								-12.566091248999953
							],
							[
								143.30545813600008,
								-12.55066078699997
							],
							[
								143.2985524080001,
								-12.530679716999941
							],
							[
								143.27737015000002,
								-12.513447274999976
							],
							[
								143.275904641,
								-12.49643565499997
							],
							[
								143.27105714100003,
								-12.496411534999936
							],
							[
								143.27735796100012,
								-12.482981644999938
							],
							[
								143.27237793300003,
								-12.467061694999927
							],
							[
								143.2776176540001,
								-12.440401804999965
							],
							[
								143.27013775500006,
								-12.433111843999939
							],
							[
								143.2738675060001,
								-12.40709196399996
							],
							[
								143.2661375770001,
								-12.394342003999952
							],
							[
								143.24980787800007,
								-12.390082002999975
							],
							[
								143.2473779290001,
								-12.37913204199998
							],
							[
								143.23012839000012,
								-12.381991970999934
							],
							[
								143.21504860200002,
								-12.36269206999998
							],
							[
								143.194908993,
								-12.349062058999948
							],
							[
								143.18260948400007,
								-12.350431897999954
							],
							[
								143.18029954400004,
								-12.343091887999947
							],
							[
								143.1280209260001,
								-12.347351664999962
							],
							[
								143.11543714800007,
								-12.33809751399997
							],
							[
								143.0846411880001,
								-12.348211961999937
							],
							[
								143.07962122900005,
								-12.340852001999963
							],
							[
								143.0812612520001,
								-12.28889197199993
							],
							[
								143.09491119300003,
								-12.25905611199994
							],
							[
								143.08605126500004,
								-12.242121900999962
							],
							[
								143.0970512660001,
								-12.218281821999938
							],
							[
								143.09508019700002,
								-12.203951011999948
							],
							[
								143.0876012770001,
								-12.20100187099996
							],
							[
								143.09492127800002,
								-12.173441810999975
							],
							[
								143.0849371390001,
								-12.172761570999967
							],
							[
								143.07871707000004,
								-12.159211519999928
							],
							[
								143.09719727000004,
								-12.151961480999944
							],
							[
								143.16193323400012,
								-12.04356351399997
							],
							[
								143.18559206600003,
								-11.990804504999971
							],
							[
								143.21570317600003,
								-11.974597526999958
							],
							[
								143.22809116400003,
								-11.989073537999957
							],
							[
								143.2440701050001,
								-11.96871454899997
							],
							[
								143.22464126600005,
								-11.954114476999962
							],
							[
								143.21547917600003,
								-11.959655526999939
							],
							[
								143.21194918700007,
								-11.954410535999955
							],
							[
								143.209841277,
								-11.962174515999948
							],
							[
								143.16746211800012,
								-11.973284493999927
							],
							[
								143.1619721190001,
								-11.954344523999964
							],
							[
								143.15079917000003,
								-11.948213532999944
							],
							[
								143.14751235200004,
								-11.919354511999927
							],
							[
								143.12211218400012,
								-11.90512451099994
							],
							[
								143.10947329400005,
								-11.90609453999997
							],
							[
								143.09785417500007,
								-11.892807518999973
							],
							[
								143.09320309500004,
								-11.904074488999981
							],
							[
								143.06648428500012,
								-11.920104547999927
							],
							[
								143.066144075,
								-11.928244517999929
							],
							[
								143.0609240650001,
								-11.923654516999932
							],
							[
								143.01539523600002,
								-11.937634484999933
							],
							[
								142.97460506800007,
								-11.93290355199997
							],
							[
								142.9459062510001,
								-11.900424519999945
							],
							[
								142.92248606300006,
								-11.892644468999947
							],
							[
								142.92897617200003,
								-11.904363558999933
							],
							[
								142.90932628300004,
								-11.89008451799998
							],
							[
								142.90108622500009,
								-11.872114486999976
							],
							[
								142.8818060860001,
								-11.871844475999978
							],
							[
								142.87149604700005,
								-11.854644485999927
							],
							[
								142.85636631800003,
								-11.845504524999967
							],
							[
								142.8530960700001,
								-11.825114493999934
							],
							[
								142.8474963100001,
								-11.82390453399995
							],
							[
								142.85416636000002,
								-11.822644533999949
							],
							[
								142.85038638100002,
								-11.80608454399993
							],
							[
								142.86242620400003,
								-11.750984453999934
							],
							[
								142.8594950810001,
								-11.635875552999948
							],
							[
								142.85226519200012,
								-11.62040553199995
							],
							[
								142.85217522400012,
								-11.586375541999928
							],
							[
								142.83433614600006,
								-11.559675510999966
							],
							[
								142.83967639000002,
								-11.492605530999981
							],
							[
								142.82684113200003,
								-11.47649580999996
							],
							[
								142.83296707400007,
								-11.433515499999942
							],
							[
								142.8686661160001,
								-11.38156552099997
							],
							[
								142.86350622700002,
								-11.35866546099993
							],
							[
								142.84036614000001,
								-11.31944552899995
							],
							[
								142.8288771110001,
								-11.314426497999932
							],
							[
								142.81981733300006,
								-11.291796537999971
							],
							[
								142.80240738400005,
								-11.291436526999973
							],
							[
								142.79355715500003,
								-11.278536475999942
							],
							[
								142.7931773360001,
								-11.24981648599993
							],
							[
								142.78316721800002,
								-11.222656464999943
							],
							[
								142.799367232,
								-11.157216474999927
							],
							[
								142.78768738400004,
								-11.126746533999949
							],
							[
								142.78791634700008,
								-11.080517493999935
							],
							[
								142.77971625800012,
								-11.062537472999963
							],
							[
								142.77566625800011,
								-11.06564750299998
							],
							[
								142.7651672190001,
								-11.055887462999976
							],
							[
								142.7674672590001,
								-11.047327472999939
							],
							[
								142.75571824000008,
								-11.042706481999971
							],
							[
								142.74561172300002,
								-10.99351767099995
							],
							[
								142.72777184500012,
								-10.981977749999942
							],
							[
								142.71634164600005,
								-10.961057988999926
							],
							[
								142.6981422760001,
								-10.97788776799996
							],
							[
								142.68071264700006,
								-10.971567726999979
							],
							[
								142.66785252900002,
								-10.944637955999951
							],
							[
								142.6497929200001,
								-10.93998791499996
							],
							[
								142.6444029600001,
								-10.945747884999946
							],
							[
								142.64601287000005,
								-10.939297954999972
							],
							[
								142.63801276100003,
								-10.937148053999977
							],
							[
								142.62988283100003,
								-10.94516802399994
							],
							[
								142.6147827410001,
								-10.941868192999948
							],
							[
								142.60930274200007,
								-10.933838272999935
							],
							[
								142.61915267300003,
								-10.91644832299994
							],
							[
								142.60429282400003,
								-10.912128371999927
							],
							[
								142.61675268300007,
								-10.915088332999971
							],
							[
								142.61655262400006,
								-10.892248472999938
							],
							[
								142.5892429270001,
								-10.868138570999974
							],
							[
								142.59289289600008,
								-10.87514853099998
							],
							[
								142.5861529870001,
								-10.87050857099996
							],
							[
								142.58546298600004,
								-10.874918540999943
							],
							[
								142.5952829050001,
								-10.891098460999956
							],
							[
								142.58876298500002,
								-10.889498470999968
							],
							[
								142.58337307500005,
								-10.901258430999974
							],
							[
								142.5879629850001,
								-10.888598480999974
							],
							[
								142.59459295500005,
								-10.88927844099993
							],
							[
								142.575063117,
								-10.869588559999954
							],
							[
								142.56899320700006,
								-10.872298569999941
							],
							[
								142.57446312600007,
								-10.886998499999947
							],
							[
								142.57310310700007,
								-10.877388549999978
							],
							[
								142.55823329700002,
								-10.88007855899997
							],
							[
								142.55755333700006,
								-10.874088558999972
							],
							[
								142.5426533760001,
								-10.902218507999976
							],
							[
								142.55579345500007,
								-10.91342833899995
							],
							[
								142.54333344600002,
								-10.90787845899996
							],
							[
								142.52567357500004,
								-10.934868477999942
							],
							[
								142.51240338500008,
								-10.93970868699995
							],
							[
								142.49866306400008,
								-10.968108916999938
							],
							[
								142.48212309400003,
								-10.97835904599998
							],
							[
								142.50007309500006,
								-10.954418936999957
							],
							[
								142.49782320600002,
								-10.939048915999933
							],
							[
								142.48870316600005,
								-10.94406900599995
							],
							[
								142.5033733560001,
								-10.930648805999965
							],
							[
								142.506593457,
								-10.92217872699996
							],
							[
								142.50112345700006,
								-10.91768876599997
							],
							[
								142.51610353700005,
								-10.909428626999954
							],
							[
								142.51045367000006,
								-10.861138685999947
							],
							[
								142.5172236510001,
								-10.843748696999967
							],
							[
								142.5320992600001,
								-10.84340846699996
							],
							[
								142.5492634200001,
								-10.831808677999959
							],
							[
								142.5664628820001,
								-10.795308858999931
							],
							[
								142.57858271100008,
								-10.795768879999969
							],
							[
								142.58753232200002,
								-10.773629099999937
							],
							[
								142.5996620420001,
								-10.764379190999932
							],
							[
								142.59703203300012,
								-10.758379249999962
							],
							[
								142.60928161300012,
								-10.749009410999975
							],
							[
								142.58323204500005,
								-10.73382941899996
							],
							[
								142.58107201500002,
								-10.724789488999932
							],
							[
								142.57397221500003,
								-10.73279939899993
							],
							[
								142.56701228600002,
								-10.722059457999933
							],
							[
								142.5568325060001,
								-10.726449397999943
							],
							[
								142.5517324770001,
								-10.708349496999972
							],
							[
								142.54131277800002,
								-10.70946941699998
							],
							[
								142.54064271800007,
								-10.696239486999957
							],
							[
								142.53094291900004,
								-10.687529445999928
							],
							[
								142.4982140190001,
								-10.716798983999979
							],
							[
								142.45936455000003,
								-10.720268931999954
							],
							[
								142.436104891,
								-10.710188940999956
							],
							[
								142.42315728100004,
								-10.727202469999952
							],
							[
								142.4266972700001,
								-10.738499480999963
							],
							[
								142.3917232660001,
								-10.825763478999932
							],
							[
								142.36652428600007,
								-10.845980477999944
							],
							[
								142.35369025500006,
								-10.881724477999967
							],
							[
								142.32127227500007,
								-10.902216455999962
							],
							[
								142.31502464400012,
								-10.915139505999946
							],
							[
								142.31875479500002,
								-10.90595938599995
							],
							[
								142.31324486500012,
								-10.901129345999948
							],
							[
								142.2846922650001,
								-10.917915463999975
							],
							[
								142.24973428700002,
								-10.909477461999927
							],
							[
								142.22552627700009,
								-10.922309450999933
							],
							[
								142.19364425900005,
								-10.914960848999954
							],
							[
								142.1327939790001,
								-10.948431575999962
							],
							[
								142.125943838,
								-10.981361675999949
							],
							[
								142.14473929400003,
								-11.039061466999954
							],
							[
								142.15294942000003,
								-11.093851497999935
							],
							[
								142.14735933000009,
								-11.098731467999926
							],
							[
								142.15728922800008,
								-11.121761488999937
							],
							[
								142.147508398,
								-11.138291417999937
							],
							[
								142.1376882840001,
								-11.206941437999944
							],
							[
								142.12858821400005,
								-11.221661487999938
							],
							[
								142.11622942400004,
								-11.224651456999936
							],
							[
								142.12680909100004,
								-11.268351507999967
							],
							[
								142.1199690960001,
								-11.368530508999982
							],
							[
								142.09734022300006,
								-11.445020417999956
							],
							[
								142.1005002810001,
								-11.463200428999926
							],
							[
								142.08859044200005,
								-11.464720427999964
							],
							[
								142.0513203280001,
								-11.554830496999955
							],
							[
								142.0257372530001,
								-11.663139455999953
							],
							[
								142.01596113300002,
								-11.673069435999935
							],
							[
								142.00190132900002,
								-11.753259445999959
							],
							[
								141.97743212900002,
								-11.776959494999971
							],
							[
								141.96197225700007,
								-11.820758453999929
							],
							[
								141.94218308100005,
								-11.945498433999944
							],
							[
								141.94342323900003,
								-11.977720463999958
							],
							[
								141.9716832580001,
								-11.980097415999978
							],
							[
								142.00083317500003,
								-12.012877497999966
							],
							[
								142.01224340300007,
								-12.03909744899994
							],
							[
								141.9942030620001,
								-12.059637447999933
							],
							[
								141.95798666500002,
								-12.042309935999981
							],
							[
								141.93235326400008,
								-12.070867464999935
							],
							[
								141.93075522200002,
								-12.115147454999942
							],
							[
								141.94895319900002,
								-12.14989746599997
							],
							[
								141.92450819900012,
								-12.168082444999982
							],
							[
								141.91336224000008,
								-12.164339453999958
							],
							[
								141.9450532090001,
								-12.146367465999958
							],
							[
								141.92542322200006,
								-12.12240746499998
							],
							[
								141.9160342250001,
								-12.074287443999935
							],
							[
								141.9178142170001,
								-12.04134146399997
							],
							[
								141.8865085010001,
								-11.985018210999954
							],
							[
								141.90902787200002,
								-11.955448461999936
							],
							[
								141.8799878530001,
								-11.954398670999979
							],
							[
								141.8504482930001,
								-11.984438698999952
							],
							[
								141.81038837100004,
								-12.04861866799996
							],
							[
								141.73539754500007,
								-12.218198514999926
							],
							[
								141.7148432250001,
								-12.234698433999938
							],
							[
								141.673426779,
								-12.369528362999972
							],
							[
								141.59192647200007,
								-12.558948060999967
							],
							[
								141.60069655100006,
								-12.57177791099997
							],
							[
								141.625716419,
								-12.583247652999944
							],
							[
								141.643246169,
								-12.57758757299996
							],
							[
								141.65449586900002,
								-12.563397613999939
							],
							[
								141.6948155880001,
								-12.556967425999972
							],
							[
								141.69576557900007,
								-12.533787535999977
							],
							[
								141.70201568900006,
								-12.51955753599998
							],
							[
								141.7094256690001,
								-12.51893748599997
							],
							[
								141.76005535600007,
								-12.539127078999968
							],
							[
								141.76251527500006,
								-12.550907009999946
							],
							[
								141.76975526500007,
								-12.552646959999947
							],
							[
								141.7684153140001,
								-12.565646909999941
							],
							[
								141.79351541200003,
								-12.58218672199996
							],
							[
								141.8114652710001,
								-12.58420670299995
							],
							[
								141.81988520000004,
								-12.601446632999966
							],
							[
								141.8315549790001,
								-12.593136673999936
							],
							[
								141.85121460800008,
								-12.595836634999955
							],
							[
								141.8792444180001,
								-12.583886635999932
							],
							[
								141.89367724700003,
								-12.591452576999927
							],
							[
								141.89377025600004,
								-12.60193649699994
							],
							[
								141.88609035600007,
								-12.617276456999946
							],
							[
								141.8592800560001,
								-12.637726425999972
							],
							[
								141.83162443700007,
								-12.641996523999978
							],
							[
								141.82733448700003,
								-12.648536513999943
							],
							[
								141.83954019500004,
								-12.668266484999947
							],
							[
								141.8566681950001,
								-12.661284955999974
							],
							[
								141.8777491630001,
								-12.671296436999967
							],
							[
								141.8631201720001,
								-12.69339645599996
							],
							[
								141.8545302330001,
								-12.686216445999946
							],
							[
								141.83898002400008,
								-12.687726464999969
							],
							[
								141.82110028600005,
								-12.671796463999954
							],
							[
								141.8037849760001,
								-12.67951646299997
							],
							[
								141.7953352940001,
								-12.729126372999929
							],
							[
								141.76246642,
								-12.816596371999935
							],
							[
								141.73990704900007,
								-12.853456420999976
							],
							[
								141.7100275990001,
								-12.878966529999957
							],
							[
								141.67029816000002,
								-12.89411673799998
							],
							[
								141.65275852000002,
								-12.916746786999965
							],
							[
								141.64099866000004,
								-12.918376855999952
							],
							[
								141.635988601,
								-12.908736915999953
							],
							[
								141.59974942000008,
								-12.952057083999932
							],
							[
								141.58317009900009,
								-12.996707053999955
							],
							[
								141.58872028700011,
								-13.01721697399995
							],
							[
								141.60452011600012,
								-13.020386874999929
							],
							[
								141.61778019500002,
								-13.039946715999974
							],
							[
								141.61395072200003,
								-13.09193662599995
							],
							[
								141.62950143700004,
								-13.159416247999957
							],
							[
								141.64508142600005,
								-13.168916088999936
							],
							[
								141.65777174400012,
								-13.204185819999964
							],
							[
								141.67993169200008,
								-13.217525580999961
							],
							[
								141.69077183000002,
								-13.236625381999943
							],
							[
								141.69539834800003,
								-13.270064451999929
							],
							[
								141.682112597,
								-13.302745141999935
							],
							[
								141.63011914600008,
								-13.367654448999929
							],
							[
								141.5932692230001,
								-13.459135447999927
							],
							[
								141.5506102820001,
								-13.50692543599996
							],
							[
								141.52329025000006,
								-13.572115425999982
							],
							[
								141.5032303260001,
								-13.657665454999972
							],
							[
								141.4993700430001,
								-13.712705395999933
							],
							[
								141.46953000700012,
								-13.849325394999937
							],
							[
								141.46660029500003,
								-13.891475464999928
							],
							[
								141.4763191520001,
								-13.94589945599995
							],
							[
								141.51178027700007,
								-13.994535458999962
							],
							[
								141.5725451510001,
								-14.057305461999931
							],
							[
								141.5990391460001,
								-14.116649443999961
							],
							[
								141.59289611400004,
								-14.158710453999959
							],
							[
								141.6024911190001,
								-14.233493444999965
							],
							[
								141.59840538800006,
								-14.258353714999942
							],
							[
								141.55051909400004,
								-14.379725453999981
							],
							[
								141.52561783900012,
								-14.487072762999958
							],
							[
								141.5536086620001,
								-14.592551885999967
							],
							[
								141.55407921900007,
								-14.647041455999954
							],
							[
								141.59027085500009,
								-14.85729983999994
							],
							[
								141.62891112800003,
								-14.944899152999938
							],
							[
								141.65137111500007,
								-14.973598893999963
							],
							[
								141.6644211030001,
								-15.005758734999972
							],
							[
								141.65265113500004,
								-14.97370889399997
							],
							[
								141.65964106400008,
								-14.983088834999933
							],
							[
								141.66745009200008,
								-15.019210474999966
							],
							[
								141.65955609000002,
								-15.05518346499997
							],
							[
								141.6590512900001,
								-15.049928674999933
							],
							[
								141.629664079,
								-15.10528246399997
							],
							[
								141.63932705700006,
								-15.130874454999969
							],
							[
								141.635523056,
								-15.149658474999967
							],
							[
								141.5920422160001,
								-15.196068772999979
							],
							[
								141.58027227600007,
								-15.198738871999979
							],
							[
								141.58597230600003,
								-15.201698822999958
							],
							[
								141.58104107600002,
								-15.20804646199997
							],
							[
								141.57560232600008,
								-15.205388881999966
							],
							[
								141.57971806400008,
								-15.23645245299997
							],
							[
								141.5696026720001,
								-15.292158732999951
							],
							[
								141.54512292100003,
								-15.332528871999955
							],
							[
								141.5232932880001,
								-15.41076887099996
							],
							[
								141.46911407400012,
								-15.532389058999968
							],
							[
								141.4346848990001,
								-15.657578977999947
							],
							[
								141.4157561300001,
								-15.83773846899993
							],
							[
								141.39756528700002,
								-15.909563738999964
							]
						]
					],
					[
						[
							[
								143.2441461630001,
								-11.989364528999943
							],
							[
								143.2519821630001,
								-11.996241528999974
							],
							[
								143.24728516400012,
								-11.985083538999959
							],
							[
								143.2441461630001,
								-11.989364528999943
							]
						]
					],
					[
						[
							[
								143.08360820400003,
								-11.76594151699993
							],
							[
								143.0951642130001,
								-11.77472851799996
							],
							[
								143.09354634300007,
								-11.76722530799998
							],
							[
								143.08360820400003,
								-11.76594151699993
							]
						]
					],
					[
						[
							[
								142.70140424800002,
								-10.942676477999953
							],
							[
								142.70315824800002,
								-10.935335497999972
							],
							[
								142.69018159000007,
								-10.920118356999978
							],
							[
								142.67875176100006,
								-10.913778385999933
							],
							[
								142.65187236200006,
								-10.914778274999946
							],
							[
								142.65117255100006,
								-10.92359815499998
							],
							[
								142.66672242000004,
								-10.936268045999952
							],
							[
								142.68696188900003,
								-10.936958166999943
							],
							[
								142.6923220970001,
								-10.958557956999925
							],
							[
								142.706281267,
								-10.956898487999979
							],
							[
								142.70140424800002,
								-10.942676477999953
							]
						]
					],
					[
						[
							[
								142.63803247200008,
								-10.916238293999982
							],
							[
								142.6248726230001,
								-10.914638322999963
							],
							[
								142.62086265200003,
								-10.922208262999959
							],
							[
								142.63527263100002,
								-10.926978173999942
							],
							[
								142.63803247200008,
								-10.916238293999982
							]
						]
					],
					[
						[
							[
								142.1005562680001,
								-10.987812454999926
							],
							[
								142.10595928700002,
								-10.996747454999934
							],
							[
								142.11609026700012,
								-10.995122454999944
							],
							[
								142.10041927800012,
								-10.985426454999981
							],
							[
								142.10188825900002,
								-10.977605444999938
							],
							[
								142.11346127900003,
								-10.972320464999939
							],
							[
								142.109470299,
								-10.969919454999967
							],
							[
								142.11584527900004,
								-10.971893464999937
							],
							[
								142.111617259,
								-10.967758454999966
							],
							[
								142.101138299,
								-10.973842453999964
							],
							[
								142.1005562680001,
								-10.987812454999926
							]
						]
					],
					[
						[
							[
								142.17781229800005,
								-10.591873454999927
							],
							[
								142.17588228800003,
								-10.584435454999948
							],
							[
								142.14503529900003,
								-10.596246443999974
							],
							[
								142.1690122870001,
								-10.605930444999956
							],
							[
								142.17781229800005,
								-10.591873454999927
							]
						]
					],
					[
						[
							[
								142.220071447,
								-10.57102042799994
							],
							[
								142.20559116700008,
								-10.57832041699993
							],
							[
								142.20940216700012,
								-10.588590506999935
							],
							[
								142.23334127700002,
								-10.575672507999968
							],
							[
								142.220071447,
								-10.57102042799994
							]
						]
					],
					[
						[
							[
								142.19639247700002,
								-10.594180475999963
							],
							[
								142.18692232700005,
								-10.597950505999961
							],
							[
								142.17694238600006,
								-10.618450425999981
							],
							[
								142.15250235700012,
								-10.622840433999954
							],
							[
								142.1422823160001,
								-10.641190453999968
							],
							[
								142.12194232700006,
								-10.642960482999968
							],
							[
								142.11868214600008,
								-10.657900492999943
							],
							[
								142.11024232600005,
								-10.662681461999966
							],
							[
								142.113761285,
								-10.687311492999982
							],
							[
								142.1197214440001,
								-10.690561482999954
							],
							[
								142.1096414650001,
								-10.685071471999947
							],
							[
								142.11911127300004,
								-10.71080150299997
							],
							[
								142.1142314430001,
								-10.722131412999943
							],
							[
								142.13864125100008,
								-10.737080413999934
							],
							[
								142.1500611890001,
								-10.764860444999954
							],
							[
								142.15828138900008,
								-10.761320465999972
							],
							[
								142.17787115800002,
								-10.770860476999928
							],
							[
								142.18632145700008,
								-10.765960416999974
							],
							[
								142.18795117900004,
								-10.746170416999973
							],
							[
								142.19573111800003,
								-10.746260417999963
							],
							[
								142.20686234900006,
								-10.72641946799996
							],
							[
								142.22741220900002,
								-10.720689438999955
							],
							[
								142.23023245700006,
								-10.739449499999978
							],
							[
								142.2473442380001,
								-10.720075699999938
							],
							[
								142.24292247800008,
								-10.711129459999938
							],
							[
								142.2550522680001,
								-10.713799490999975
							],
							[
								142.26482233700006,
								-10.72720949099994
							],
							[
								142.27743133700005,
								-10.706469431999949
							],
							[
								142.24971243100003,
								-10.667009469999925
							],
							[
								142.2454021520001,
								-10.647239449999972
							],
							[
								142.21203228500008,
								-10.618419456999959
							],
							[
								142.20463019600004,
								-10.594816046999938
							],
							[
								142.19639247700002,
								-10.594180475999963
							]
						]
					],
					[
						[
							[
								142.22555245700005,
								-10.739919468999972
							],
							[
								142.22017224800004,
								-10.739259498999957
							],
							[
								142.22409227700007,
								-10.747609438999973
							],
							[
								142.22555245700005,
								-10.739919468999972
							]
						]
					],
					[
						[
							[
								142.24847224500002,
								-10.586849448999942
							],
							[
								142.23973213500005,
								-10.60067947899995
							],
							[
								142.24318236400006,
								-10.606439468999952
							],
							[
								142.236112315,
								-10.608839418999935
							],
							[
								142.26596245200005,
								-10.642069490999972
							],
							[
								142.29588136100006,
								-10.637769461999937
							],
							[
								142.32652128100005,
								-10.612879433999979
							],
							[
								142.30634113400004,
								-10.570569431999957
							],
							[
								142.27036129500004,
								-10.574669479999955
							],
							[
								142.24847224500002,
								-10.586849448999942
							]
						]
					],
					[
						[
							[
								142.21620730000006,
								-10.522175466999954
							],
							[
								142.20283829900006,
								-10.546090455999945
							],
							[
								142.19248030000006,
								-10.54316145599995
							],
							[
								142.18041828900004,
								-10.560894444999974
							],
							[
								142.19524830800003,
								-10.574969455999963
							],
							[
								142.2190852880001,
								-10.563163456999973
							],
							[
								142.2236762990001,
								-10.540351456999929
							],
							[
								142.23130428900004,
								-10.53690845799997
							],
							[
								142.22436630000004,
								-10.523395446999928
							],
							[
								142.21620730000006,
								-10.522175466999954
							]
						]
					],
					[
						[
							[
								142.15379114000007,
								-10.570821433999981
							],
							[
								142.17190131000007,
								-10.554251444999977
							],
							[
								142.14702137000006,
								-10.563381492999952
							],
							[
								142.15379114000007,
								-10.570821433999981
							]
						]
					],
					[
						[
							[
								142.12560931200005,
								-10.362885450999954
							],
							[
								142.12636932100008,
								-10.384814460999962
							],
							[
								142.1356292910001,
								-10.38862446099995
							],
							[
								142.1419793110001,
								-10.375144451999972
							],
							[
								142.13804830200002,
								-10.362494450999975
							],
							[
								142.12591832300006,
								-10.355185449999965
							],
							[
								142.12560931200005,
								-10.362885450999954
							]
						]
					],
					[
						[
							[
								142.04994730500005,
								-10.36683644599998
							],
							[
								142.0605473050001,
								-10.362856456999964
							],
							[
								142.06234730500012,
								-10.354926446999968
							],
							[
								142.05047731500008,
								-10.35575644599993
							],
							[
								142.04994730500005,
								-10.36683644599998
							]
						]
					],
					[
						[
							[
								142.10179631800008,
								-10.277456437999945
							],
							[
								142.107856308,
								-10.28162644899993
							],
							[
								142.0992663280001,
								-10.272606437999968
							],
							[
								142.10179631800008,
								-10.277456437999945
							]
						]
					],
					[
						[
							[
								142.0767833100001,
								-10.259974456999942
							],
							[
								142.06903330000011,
								-10.26531444699998
							],
							[
								142.078863339,
								-10.26641445699994
							],
							[
								142.0767833100001,
								-10.259974456999942
							]
						]
					],
					[
						[
							[
								142.14947551000012,
								-10.204166469999961
							],
							[
								142.14638523100007,
								-10.200446419999935
							],
							[
								142.14219522000008,
								-10.209966429999952
							],
							[
								142.14801532,
								-10.21130643999993
							],
							[
								142.14947551000012,
								-10.204166469999961
							]
						]
					],
					[
						[
							[
								142.11938418400007,
								-10.149327487999926
							],
							[
								142.13432523200004,
								-10.178786468999931
							],
							[
								142.1574313420001,
								-10.173201450999954
							],
							[
								142.16372233100003,
								-10.181476440999973
							],
							[
								142.1700854920001,
								-10.159886460999928
							],
							[
								142.1872303020001,
								-10.151655441999935
							],
							[
								142.19300730400005,
								-10.107118451999952
							],
							[
								142.18193419700003,
								-10.059327490999976
							],
							[
								142.12790320800002,
								-10.072867457999962
							],
							[
								142.1136234590001,
								-10.068948486999943
							],
							[
								142.1127634080001,
								-10.082528416999935
							],
							[
								142.08513451800002,
								-10.113378415999932
							],
							[
								142.09320426600004,
								-10.137537476999967
							],
							[
								142.11938418400007,
								-10.149327487999926
							]
						]
					],
					[
						[
							[
								142.14656895500002,
								-9.231493241999942
							],
							[
								142.15155894500003,
								-9.226163261999943
							],
							[
								142.14467854500003,
								-9.226574401999926
							],
							[
								142.14656895500002,
								-9.231493241999942
							]
						]
					],
					[
						[
							[
								142.15920233500003,
								-9.946318448999932
							],
							[
								142.16536229400003,
								-9.947318448999965
							],
							[
								142.15628236500004,
								-9.94140841899997
							],
							[
								142.15920233500003,
								-9.946318448999932
							]
						]
					],
					[
						[
							[
								142.15783942400003,
								-9.24372346299998
							],
							[
								142.188168334,
								-9.231623403999947
							],
							[
								142.16435829500006,
								-9.223913462999974
							],
							[
								142.15783942400003,
								-9.24372346299998
							]
						]
					],
					[
						[
							[
								142.2346983120001,
								-9.225413406999962
							],
							[
								142.24241927200012,
								-9.234712486999967
							],
							[
								142.25156938200007,
								-9.232982397999933
							],
							[
								142.24379842200005,
								-9.222722416999943
							],
							[
								142.23479843300004,
								-9.220153446999973
							],
							[
								142.2346983120001,
								-9.225413406999962
							]
						]
					],
					[
						[
							[
								142.13342928300005,
								-9.269183451999936
							],
							[
								142.19228925000004,
								-9.286842444999934
							],
							[
								142.27226936800002,
								-9.289771408999968
							],
							[
								142.28499935800005,
								-9.28373143999994
							],
							[
								142.29492918900007,
								-9.262721469999974
							],
							[
								142.2665493400001,
								-9.25067245899993
							],
							[
								142.24255928000002,
								-9.258902396999929
							],
							[
								142.24387941100008,
								-9.252902456999948
							],
							[
								142.22193236300006,
								-9.22927344599998
							],
							[
								142.14112928300005,
								-9.257793411999955
							],
							[
								142.13342928300005,
								-9.269183451999936
							]
						]
					],
					[
						[
							[
								142.1751673230001,
								-9.969304459999933
							],
							[
								142.18374434200007,
								-9.971022439999956
							],
							[
								142.19981234300008,
								-9.946413450999955
							],
							[
								142.1852943240001,
								-9.942666459999941
							],
							[
								142.16545934400006,
								-9.950008458999946
							],
							[
								142.1751673230001,
								-9.969304459999933
							]
						]
					],
					[
						[
							[
								142.16496628900006,
								-10.22593550199997
							],
							[
								142.17272643800004,
								-10.225685471999952
							],
							[
								142.1726551590001,
								-10.20725545199997
							],
							[
								142.1640151690001,
								-10.214405410999973
							],
							[
								142.16496628900006,
								-10.22593550199997
							]
						]
					],
					[
						[
							[
								142.30862029700006,
								-10.513800501999981
							],
							[
								142.28422128700004,
								-10.52713049099998
							],
							[
								142.30028125600006,
								-10.542329421999966
							],
							[
								142.32014137600004,
								-10.537719452999966
							],
							[
								142.312240448,
								-10.505530481999926
							],
							[
								142.30862029700006,
								-10.513800501999981
							]
						]
					],
					[
						[
							[
								142.3148833140001,
								-10.217061459999968
							],
							[
								142.34102231500003,
								-10.184549450999953
							],
							[
								142.34407130600005,
								-10.16901446099996
							],
							[
								142.33234232600012,
								-10.162021469999956
							],
							[
								142.32553635800002,
								-10.135094459999948
							],
							[
								142.31208639800002,
								-10.138544428999978
							],
							[
								142.30015528,
								-10.124004457999945
							],
							[
								142.28864537000004,
								-10.127784477999967
							],
							[
								142.26794538100012,
								-10.11588547599996
							],
							[
								142.2538351710001,
								-10.12543547599995
							],
							[
								142.23693535200005,
								-10.121315444999937
							],
							[
								142.21984543200006,
								-10.128845483999953
							],
							[
								142.20604514100012,
								-10.161685482999928
							],
							[
								142.21075539000003,
								-10.170815453999978
							],
							[
								142.2058353010001,
								-10.16653549299997
							],
							[
								142.1859553600001,
								-10.19035643199993
							],
							[
								142.2159963160001,
								-10.237919443999942
							],
							[
								142.2263963360001,
								-10.230344424999942
							],
							[
								142.24113616600005,
								-10.234244475999958
							],
							[
								142.26285745400003,
								-10.243543446999979
							],
							[
								142.27684743300006,
								-10.259653457999946
							],
							[
								142.3148833140001,
								-10.217061459999968
							]
						]
					],
					[
						[
							[
								142.3185113410001,
								-9.563949493999928
							],
							[
								142.2792612930001,
								-9.549179411999944
							],
							[
								142.2583204330001,
								-9.55390044099994
							],
							[
								142.26827121200006,
								-9.565279421999946
							],
							[
								142.3067011810001,
								-9.574279413999932
							],
							[
								142.31422124000005,
								-9.573799453999982
							],
							[
								142.3185113410001,
								-9.563949493999928
							]
						]
					],
					[
						[
							[
								142.52762130200006,
								-9.421847424999953
							],
							[
								142.53241149100006,
								-9.436317434999978
							],
							[
								142.5519915120001,
								-9.420827465999935
							],
							[
								142.52944149300004,
								-9.410427504999973
							],
							[
								142.52762130200006,
								-9.421847424999953
							]
						]
					],
					[
						[
							[
								142.50576046100002,
								-10.15918242999993
							],
							[
								142.51477052000007,
								-10.160902299999975
							],
							[
								142.51296049100006,
								-10.155352299999947
							],
							[
								142.50576046100002,
								-10.15918242999993
							]
						]
					],
					[
						[
							[
								142.5131202880001,
								-10.19526246099997
							],
							[
								142.5157503690001,
								-10.18724236099996
							],
							[
								142.50412025900005,
								-10.183832589999952
							],
							[
								142.5131202880001,
								-10.19526246099997
							]
						]
					],
					[
						[
							[
								142.48752071600006,
								-10.24938224999994
							],
							[
								142.4891906260001,
								-10.242372339999974
							],
							[
								142.4740610460001,
								-10.251372148999963
							],
							[
								142.48289112600003,
								-10.260941989999935
							],
							[
								142.48752071600006,
								-10.24938224999994
							]
						]
					],
					[
						[
							[
								142.78197629600004,
								-9.901528482999936
							],
							[
								142.78095532700002,
								-9.895681482999976
							],
							[
								142.76512030700007,
								-9.894698481999967
							],
							[
								142.76856733700004,
								-9.905055492999963
							],
							[
								142.77667533600004,
								-9.90762147299995
							],
							[
								142.78197629600004,
								-9.901528482999936
							]
						]
					],
					[
						[
							[
								142.64901221900004,
								-9.76481449499994
							],
							[
								142.6283734000001,
								-9.757764512999927
							],
							[
								142.62200319900012,
								-9.772574462999955
							],
							[
								142.64622222800006,
								-9.77306451499993
							],
							[
								142.64901221900004,
								-9.76481449499994
							]
						]
					],
					[
						[
							[
								142.6697082810001,
								-9.373167511999952
							],
							[
								142.69885821000003,
								-9.377328473999967
							],
							[
								142.72548739900003,
								-9.368268455999953
							],
							[
								142.68893838100007,
								-9.35823849299993
							],
							[
								142.6697082810001,
								-9.373167511999952
							]
						]
					],
					[
						[
							[
								142.68953421000003,
								-9.376488523999967
							],
							[
								142.64464939200002,
								-9.36515751099995
							],
							[
								142.6004903820001,
								-9.385757418999958
							],
							[
								142.59776047100002,
								-9.407577488999948
							],
							[
								142.65157938800007,
								-9.427947451999955
							],
							[
								142.67428928800007,
								-9.423497502999965
							],
							[
								142.70725842600007,
								-9.428307444999973
							],
							[
								142.74215716600008,
								-9.419797506999942
							],
							[
								142.75420639700008,
								-9.40045848799997
							],
							[
								142.78983521600003,
								-9.391948458999934
							],
							[
								142.80086526600007,
								-9.381988499999977
							],
							[
								142.79766523700005,
								-9.372158439999964
							],
							[
								142.75719618800008,
								-9.36687849699996
							],
							[
								142.72537723900007,
								-9.371768465999935
							],
							[
								142.70750720900003,
								-9.381738484999971
							],
							[
								142.68953421000003,
								-9.376488523999967
							]
						]
					],
					[
						[
							[
								142.89944622500002,
								-9.85821550999998
							],
							[
								142.91256640400002,
								-9.866835530999936
							],
							[
								142.94845517400006,
								-9.85389650299993
							],
							[
								142.91726548500003,
								-9.842985530999954
							],
							[
								142.90045635600006,
								-9.84606550999996
							],
							[
								142.89944622500002,
								-9.85821550999998
							]
						]
					],
					[
						[
							[
								142.83526826700006,
								-10.03592447799997
							],
							[
								142.85760735500003,
								-10.05313444899997
							],
							[
								142.86776727500012,
								-10.040814529999977
							],
							[
								142.85729739700002,
								-10.019564448999972
							],
							[
								142.84817714700011,
								-10.017404437999971
							],
							[
								142.82661819800012,
								-10.023714526999981
							],
							[
								142.83526826700006,
								-10.03592447799997
							]
						]
					],
					[
						[
							[
								142.6157192810001,
								-10.600717479999958
							],
							[
								142.62933527100006,
								-10.598644480999951
							],
							[
								142.62145529200006,
								-10.590155479999964
							],
							[
								142.611975292,
								-10.590824469999973
							],
							[
								142.6157192810001,
								-10.600717479999958
							]
						]
					],
					[
						[
							[
								142.63685105900004,
								-10.628529820999972
							],
							[
								142.65078098800007,
								-10.637819731999969
							],
							[
								142.63808114800008,
								-10.649449721999929
							],
							[
								142.64733111700002,
								-10.65658966199993
							],
							[
								142.66713043800007,
								-10.630259912999975
							],
							[
								142.6412009490001,
								-10.617799881999929
							],
							[
								142.63228110900002,
								-10.626269850999961
							],
							[
								142.63685105900004,
								-10.628529820999972
							]
						]
					],
					[
						[
							[
								142.28572602600002,
								-10.72429938199997
							],
							[
								142.2935459350001,
								-10.734109342999943
							],
							[
								142.30504580500008,
								-10.72421933399994
							],
							[
								142.30315587600012,
								-10.708289392999973
							],
							[
								142.29511598700003,
								-10.701659422999967
							],
							[
								142.28169610700002,
								-10.716299411999955
							],
							[
								142.28572602600002,
								-10.72429938199997
							]
						]
					],
					[
						[
							[
								142.38495511100007,
								-10.747509027999968
							],
							[
								142.39895505100003,
								-10.735458998999945
							],
							[
								142.4075252130001,
								-10.708858978999956
							],
							[
								142.3965552830001,
								-10.70923900899993
							],
							[
								142.38973526300003,
								-10.717979027999945
							],
							[
								142.39344512200012,
								-10.730409018999978
							],
							[
								142.38495511100007,
								-10.747509027999968
							]
						]
					],
					[
						[
							[
								142.60381165400008,
								-10.73611946099993
							],
							[
								142.62243125300006,
								-10.746089541999936
							],
							[
								142.61503139400008,
								-10.720869610999955
							],
							[
								142.60885146400005,
								-10.72628956099993
							],
							[
								142.59526160500002,
								-10.712819639999964
							],
							[
								142.5844018360001,
								-10.714389578999942
							],
							[
								142.60381165400008,
								-10.73611946099993
							]
						]
					],
					[
						[
							[
								143.69448705700006,
								-13.667841580999948
							],
							[
								143.6881260570001,
								-13.668958569999972
							],
							[
								143.68941804700012,
								-13.67514056999994
							],
							[
								143.69448705700006,
								-13.667841580999948
							]
						]
					],
					[
						[
							[
								143.77188559700005,
								-14.22058415999993
							],
							[
								143.77917902700005,
								-14.224040570999932
							],
							[
								143.77483398700008,
								-14.213688579999939
							],
							[
								143.77188559700005,
								-14.22058415999993
							]
						]
					],
					[
						[
							[
								143.71944702300004,
								-13.87137357399996
							],
							[
								143.7225340430001,
								-13.862747573999968
							],
							[
								143.71598324400009,
								-13.859225583999944
							],
							[
								143.71944702300004,
								-13.87137357399996
							]
						]
					],
					[
						[
							[
								143.57872807400008,
								-13.183147558999963
							],
							[
								143.578173084,
								-13.172722548999957
							],
							[
								143.57420408300004,
								-13.19197055899997
							],
							[
								143.57872807400008,
								-13.183147558999963
							]
						]
					],
					[
						[
							[
								143.3847971030001,
								-12.865224544999933
							],
							[
								143.37831112300012,
								-12.873818533999952
							],
							[
								143.38810426200007,
								-12.87357951499996
							],
							[
								143.3847971030001,
								-12.865224544999933
							]
						]
					],
					[
						[
							[
								143.38897610200002,
								-12.872299544999976
							],
							[
								143.39667212200004,
								-12.875904545999958
							],
							[
								143.40090711200003,
								-12.869346555999982
							],
							[
								143.38931211300007,
								-12.865352554999959
							],
							[
								143.38897610200002,
								-12.872299544999976
							]
						]
					],
					[
						[
							[
								143.39553109100007,
								-12.88385055599997
							],
							[
								143.39335511100012,
								-12.895069544999956
							],
							[
								143.40069610000012,
								-12.896929555999975
							],
							[
								143.39900411100007,
								-12.876674555999955
							],
							[
								143.39553109100007,
								-12.88385055599997
							]
						]
					],
					[
						[
							[
								143.36455610300004,
								-12.883740553999928
							],
							[
								143.35907610300012,
								-12.888051552999968
							],
							[
								143.37522910100006,
								-12.895606543999975
							],
							[
								143.37745111200002,
								-12.884277553999937
							],
							[
								143.36455610300004,
								-12.883740553999928
							]
						]
					],
					[
						[
							[
								143.40253110900005,
								-12.760013554999944
							],
							[
								143.39757710900005,
								-12.753863534999937
							],
							[
								143.40086812800007,
								-12.76775753499993
							],
							[
								143.40253110900005,
								-12.760013554999944
							]
						]
					],
					[
						[
							[
								143.26638517300012,
								-11.987881529999981
							],
							[
								143.27578918200004,
								-11.986721530999944
							],
							[
								143.26303615400002,
								-11.974934529999928
							],
							[
								143.26638517300012,
								-11.987881529999981
							]
						]
					],
					[
						[
							[
								143.40193532500007,
								-9.749415528999975
							],
							[
								143.40067030500006,
								-9.75734450899995
							],
							[
								143.4237042840001,
								-9.75023651999993
							],
							[
								143.40193532500007,
								-9.749415528999975
							]
						]
					],
					[
						[
							[
								143.77568630400003,
								-9.575551549999943
							],
							[
								143.75736232400004,
								-9.582329538999943
							],
							[
								143.76123730300003,
								-9.599102538999944
							],
							[
								143.77591830300003,
								-9.59761353999994
							],
							[
								143.78314329300008,
								-9.587193540999976
							],
							[
								143.7843053040001,
								-9.577011550999941
							],
							[
								143.77760730400007,
								-9.570806539999978
							],
							[
								143.77568630400003,
								-9.575551549999943
							]
						]
					],
					[
						[
							[
								143.48532315800003,
								-11.92020555299996
							],
							[
								143.4770141580001,
								-11.915135551999981
							],
							[
								143.47815214800005,
								-11.921694541999955
							],
							[
								143.48532315800003,
								-11.92020555299996
							]
						]
					],
					[
						[
							[
								143.46422317000008,
								-11.904376540999976
							],
							[
								143.471197189,
								-11.906629541999962
							],
							[
								143.47072718000004,
								-11.898049541999967
							],
							[
								143.46422317000008,
								-11.904376540999976
							]
						]
					],
					[
						[
							[
								143.40942514800008,
								-12.286469540999974
							],
							[
								143.40363015800006,
								-12.286727550999956
							],
							[
								143.40726715800008,
								-12.292465540999956
							],
							[
								143.4158981270001,
								-12.290782541999931
							],
							[
								143.4137331380001,
								-12.283258540999952
							],
							[
								143.40942514800008,
								-12.286469540999974
							]
						]
					],
					[
						[
							[
								143.49790028900009,
								-12.52773058899993
							],
							[
								143.45437017200004,
								-12.504361555999935
							],
							[
								143.47339007000005,
								-12.52045157699996
							],
							[
								143.49790028900009,
								-12.52773058899993
							]
						]
					],
					[
						[
							[
								144.20236299400005,
								-14.231298616999936
							],
							[
								144.23060600400004,
								-14.21445560899997
							],
							[
								144.22878797500005,
								-14.20607863899994
							],
							[
								144.20236299400005,
								-14.231298616999936
							]
						]
					],
					[
						[
							[
								144.26415997100003,
								-14.234745610999937
							],
							[
								144.27552100000003,
								-14.235812621999969
							],
							[
								144.27762800100004,
								-14.217446611999947
							],
							[
								144.26639198100008,
								-14.225486620999959
							],
							[
								144.24519297300003,
								-14.220492619999959
							],
							[
								144.26415997100003,
								-14.234745610999937
							]
						]
					],
					[
						[
							[
								144.2515549960001,
								-14.168794609999964
							],
							[
								144.2501999650001,
								-14.177240619999964
							],
							[
								144.23220897600004,
								-14.17554660899998
							],
							[
								144.23366999600012,
								-14.187297608999927
							],
							[
								144.28304697200008,
								-14.196395611999947
							],
							[
								144.27330797500008,
								-14.15885162099994
							],
							[
								144.25001199700012,
								-14.16068660999997
							],
							[
								144.2515549960001,
								-14.168794609999964
							]
						]
					],
					[
						[
							[
								144.23596478900004,
								-14.136064648999934
							],
							[
								144.23704397900008,
								-14.129947608999942
							],
							[
								144.20941296700005,
								-14.185082616999978
							],
							[
								144.22025897800006,
								-14.167182607999962
							],
							[
								144.23893227700012,
								-14.16371315899994
							],
							[
								144.245050987,
								-14.151563668999927
							],
							[
								144.26760637600012,
								-14.149921280999934
							],
							[
								144.23596478900004,
								-14.136064648999934
							]
						]
					],
					[
						[
							[
								144.06376928300006,
								-9.911813560999974
							],
							[
								144.0543762640001,
								-9.907048549999956
							],
							[
								144.04143525400002,
								-9.913234559999978
							],
							[
								144.0416882730001,
								-9.925274569999942
							],
							[
								144.05931427300004,
								-9.921561560999976
							],
							[
								144.06376928300006,
								-9.911813560999974
							]
						]
					],
					[
						[
							[
								144.32832266700007,
								-14.097278703999962
							],
							[
								144.32795818600005,
								-14.10367602399998
							],
							[
								144.3370569760001,
								-14.10123161499996
							],
							[
								144.33896198700006,
								-14.086755624999967
							],
							[
								144.33100498700003,
								-14.08630960399995
							],
							[
								144.3355987970001,
								-14.086017414999958
							],
							[
								144.32832266700007,
								-14.097278703999962
							]
						]
					],
					[
						[
							[
								144.52818497500004,
								-14.120936626999935
							],
							[
								144.531577985,
								-14.124981627999944
							],
							[
								144.52551496600006,
								-14.111993636999955
							],
							[
								144.52818497500004,
								-14.120936626999935
							]
						]
					],
					[
						[
							[
								144.80405464900002,
								-14.434022837999976
							],
							[
								144.8137592280001,
								-14.438058628999954
							],
							[
								144.81631371900005,
								-14.425911218999943
							],
							[
								144.80405464900002,
								-14.434022837999976
							]
						]
					],
					[
						[
							[
								144.95666894600004,
								-14.507094668999969
							],
							[
								144.9794809240001,
								-14.512885670999935
							],
							[
								144.98993792400006,
								-14.509827660999974
							],
							[
								144.9901009350001,
								-14.50343467099998
							],
							[
								144.97707996600002,
								-14.492984639999975
							],
							[
								144.95025392700006,
								-14.49889165899998
							],
							[
								144.95666894600004,
								-14.507094668999969
							]
						]
					],
					[
						[
							[
								145.44569787900002,
								-14.667882693999957
							],
							[
								145.4484298980001,
								-14.681238693999944
							],
							[
								145.4620915170001,
								-14.679387424999959
							],
							[
								145.47159389600006,
								-14.686814695999942
							],
							[
								145.4678768770001,
								-14.68130468499993
							],
							[
								145.4775218970001,
								-14.668248705999929
							],
							[
								145.45749190000004,
								-14.64714569399996
							],
							[
								145.45077390000006,
								-14.647118683999963
							],
							[
								145.45462190900002,
								-14.661561693999943
							],
							[
								145.44569787900002,
								-14.667882693999957
							]
						]
					],
					[
						[
							[
								145.24993890000007,
								-14.659223689999976
							],
							[
								145.25769391000006,
								-14.656031680999945
							],
							[
								145.25505390000012,
								-14.64990168099996
							],
							[
								145.24993890000007,
								-14.659223689999976
							]
						]
					],
					[
						[
							[
								144.92542293100007,
								-14.606587667999975
							],
							[
								144.93534593000004,
								-14.612066668999944
							],
							[
								144.92564492100007,
								-14.601721667999982
							],
							[
								144.92542293100007,
								-14.606587667999975
							]
						]
					],
					[
						[
							[
								144.91583442800004,
								-14.509506285999976
							],
							[
								144.9194448180001,
								-14.505431676999933
							],
							[
								144.9101433090001,
								-14.503086865999933
							],
							[
								144.91583442800004,
								-14.509506285999976
							]
						]
					],
					[
						[
							[
								145.50747788,
								-14.744693708999932
							],
							[
								145.51491387900012,
								-14.749282698999934
							],
							[
								145.51467888900004,
								-14.743611698999928
							],
							[
								145.50747788,
								-14.744693708999932
							]
						]
					],
					[
						[
							[
								145.44297581000012,
								-15.749243712999942
							],
							[
								145.4457888290001,
								-15.753588712999942
							],
							[
								145.44319382000003,
								-15.744544712999982
							],
							[
								145.44297581000012,
								-15.749243712999942
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "318",
				"CED_NAME21": "Leichhardt",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 149228.4618,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/318",
				"SHAPE_Leng": 40.2045036698,
				"SHAPE_Area": 12.5086903121
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							153.06621706400006,
							-27.281263447999947
						],
						[
							153.04958606600007,
							-27.27865544599996
						],
						[
							153.04219787300008,
							-27.303856534999966
						],
						[
							153.05118329900006,
							-27.32957014599998
						],
						[
							153.02723305900008,
							-27.353492433999975
						],
						[
							153.0264434170001,
							-27.36524552399993
						],
						[
							153.0002308710001,
							-27.358001031999947
						],
						[
							152.975291039,
							-27.392023438999956
						],
						[
							152.97700503800002,
							-27.400769439999976
						],
						[
							152.99241205500005,
							-27.41257344099995
						],
						[
							152.99216804600007,
							-27.40693344099998
						],
						[
							153.0351970600001,
							-27.41423744599996
						],
						[
							153.05010931000004,
							-27.404043266999963
						],
						[
							153.0596492080001,
							-27.41041116799994
						],
						[
							153.0747520970001,
							-27.406952428999944
						],
						[
							153.08274089300005,
							-27.432678469999928
						],
						[
							153.09974584000008,
							-27.443092831999934
						],
						[
							153.1406530280001,
							-27.417547455999966
						],
						[
							153.15044904,
							-27.394601466999973
						],
						[
							153.14638404200002,
							-27.38817645699993
						],
						[
							153.16053140100007,
							-27.377399537999963
						],
						[
							153.15563442400003,
							-27.36292663699993
						],
						[
							153.13862363600003,
							-27.361139795999975
						],
						[
							153.08256303500002,
							-27.333445449999942
						],
						[
							153.08679820600003,
							-27.32531819999997
						],
						[
							153.06657838,
							-27.307182737999938
						],
						[
							153.06621706400006,
							-27.281263447999947
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "319",
				"CED_NAME21": "Lilley",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 140.5754,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/319",
				"SHAPE_Leng": 0.716475320721,
				"SHAPE_Area": 0.0128245571321
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								153.01809306300004,
								-27.248670432999972
							],
							[
								152.9910140510001,
								-27.209919448999983
							],
							[
								152.97767619900003,
								-27.15207850799993
							],
							[
								153.01537306600005,
								-27.14785744099993
							],
							[
								153.0285187940001,
								-27.151620672999968
							],
							[
								153.02662970400002,
								-27.156138632999955
							],
							[
								153.0414980820001,
								-27.153774443999964
							],
							[
								153.06667706500002,
								-27.111029015999975
							],
							[
								153.10865509300004,
								-27.08747943999998
							],
							[
								153.13288408100004,
								-27.08610445299996
							],
							[
								153.1442086410001,
								-27.07554552399995
							],
							[
								153.12606278500004,
								-27.062769661999937
							],
							[
								153.09890619700002,
								-27.063949848999982
							],
							[
								153.111442086,
								-27.062610449999966
							],
							[
								153.09666513900004,
								-27.05327589899997
							],
							[
								153.112648927,
								-27.054138799999976
							],
							[
								153.10265293100008,
								-27.03504990899995
							],
							[
								153.08370107400003,
								-27.026174456999968
							],
							[
								153.08461204500009,
								-27.015968046999944
							],
							[
								153.0632390300001,
								-26.996134414999972
							],
							[
								153.0682131110001,
								-26.985411444999954
							],
							[
								153.04276808500003,
								-26.96944644299998
							],
							[
								153.0184601080001,
								-26.96634242999994
							],
							[
								153.01685910700007,
								-26.97905444999998
							],
							[
								152.9755941100001,
								-26.98466743599994
							],
							[
								152.97501708200002,
								-26.974367435999966
							],
							[
								152.96663909200004,
								-26.978792424999938
							],
							[
								152.95190809500002,
								-26.96612943399998
							],
							[
								152.91726814000003,
								-26.95469343999997
							],
							[
								152.89116119200003,
								-26.960737437999967
							],
							[
								152.85801758600007,
								-26.956204283999966
							],
							[
								152.86084612800005,
								-26.935899423999956
							],
							[
								152.87250210800005,
								-26.93050142499993
							],
							[
								152.8754522600001,
								-26.913509415999954
							],
							[
								152.8594678820001,
								-26.911291853999955
							],
							[
								152.86114973300005,
								-26.902730263999956
							],
							[
								152.8553045530001,
								-26.901871762999974
							],
							[
								152.85549413500007,
								-26.887369432999947
							],
							[
								152.8667881140001,
								-26.88890942499995
							],
							[
								152.8694831250001,
								-26.87286443499994
							],
							[
								152.85170711800004,
								-26.865183412999954
							],
							[
								152.85404212900005,
								-26.855854422999982
							],
							[
								152.83206614100004,
								-26.856413420999957
							],
							[
								152.81252714700008,
								-26.828046418999975
							],
							[
								152.79192114900002,
								-26.827255416999947
							],
							[
								152.78937312200003,
								-26.809615425999937
							],
							[
								152.7771861430001,
								-26.80950242499995
							],
							[
								152.77646212500008,
								-26.795531404999963
							],
							[
								152.7611021670001,
								-26.792350402999944
							],
							[
								152.75918916600006,
								-26.803038412999967
							],
							[
								152.7530811470001,
								-26.797340411999983
							],
							[
								152.74860514500006,
								-26.81643041199993
							],
							[
								152.73917814700008,
								-26.80801441099993
							],
							[
								152.72907614700011,
								-26.816616409999938
							],
							[
								152.72223513900008,
								-26.80680241899995
							],
							[
								152.69645315100001,
								-26.80911541699993
							],
							[
								152.69879816200012,
								-26.80296939699997
							],
							[
								152.67922015400006,
								-26.799864414999945
							],
							[
								152.67903016200012,
								-26.81642141499998
							],
							[
								152.67181817300002,
								-26.81978539499994
							],
							[
								152.67908083200007,
								-26.822176094999975
							],
							[
								152.67846215100008,
								-26.830395404999933
							],
							[
								152.66648114100008,
								-26.839463403999957
							],
							[
								152.68985916200006,
								-26.891451406999977
							],
							[
								152.68861914100012,
								-26.896912396999937
							],
							[
								152.6674021340001,
								-26.896229394999978
							],
							[
								152.66081914300003,
								-26.909907403999966
							],
							[
								152.68744913900002,
								-26.913722406999966
							],
							[
								152.67298616000005,
								-26.92259241599993
							],
							[
								152.66762711800004,
								-26.94360140499998
							],
							[
								152.6512701480001,
								-26.95532041399997
							],
							[
								152.66773015600006,
								-26.959061404999943
							],
							[
								152.66476014500006,
								-26.96904040499993
							],
							[
								152.6852001430001,
								-26.965711406999958
							],
							[
								152.67985815200007,
								-26.97836340699996
							],
							[
								152.68927215000008,
								-26.98453640799994
							],
							[
								152.68335616000002,
								-26.992763416999935
							],
							[
								152.7035091240001,
								-27.02479240899993
							],
							[
								152.68915410300008,
								-27.048269407999953
							],
							[
								152.69515813100008,
								-27.05902440899996
							],
							[
								152.67768310300005,
								-27.05694640699994
							],
							[
								152.68712210900003,
								-27.082362417999946
							],
							[
								152.67651141900012,
								-27.089978376999966
							],
							[
								152.7344671310001,
								-27.10233248299994
							],
							[
								152.73352021100004,
								-27.10741846299993
							],
							[
								152.7653641170001,
								-27.11085242599995
							],
							[
								152.76686397800006,
								-27.102142455999967
							],
							[
								152.78025710600002,
								-27.10414256799993
							],
							[
								152.78357612800005,
								-27.086408407999954
							],
							[
								152.80081510500008,
								-27.097525409999946
							],
							[
								152.80570311500003,
								-27.08880941999996
							],
							[
								152.8143159440001,
								-27.089840460999937
							],
							[
								152.81686711300006,
								-27.09721842099998
							],
							[
								152.80615728400005,
								-27.099191359999963
							],
							[
								152.80729988300004,
								-27.10808622999997
							],
							[
								152.828847719,
								-27.11575222299996
							],
							[
								152.82864992800012,
								-27.130733672999952
							],
							[
								152.85106508400008,
								-27.139651414999946
							],
							[
								152.84832652300008,
								-27.154453214999933
							],
							[
								152.85762209200004,
								-27.154382435999935
							],
							[
								152.8445411790001,
								-27.182793454999967
							],
							[
								152.94577256700006,
								-27.197636514999942
							],
							[
								152.94464537600004,
								-27.20413508499996
							],
							[
								152.9648903840001,
								-27.20774937699997
							],
							[
								152.97544508800001,
								-27.243398427999978
							],
							[
								152.99201298600008,
								-27.24570841999997
							],
							[
								152.99873887600006,
								-27.240221409999947
							],
							[
								153.01809306300004,
								-27.248670432999972
							]
						]
					],
					[
						[
							[
								153.1388696040001,
								-27.05926260299998
							],
							[
								153.15539607000005,
								-27.072195454999928
							],
							[
								153.16617346600003,
								-27.099666325999976
							],
							[
								153.19685795300006,
								-27.096759168999938
							],
							[
								153.2070827340001,
								-27.08394415999993
							],
							[
								153.16139022100003,
								-26.98510766499993
							],
							[
								153.13865643300005,
								-26.90824046199998
							],
							[
								153.13052912800003,
								-26.872409490999928
							],
							[
								153.1312301160001,
								-26.809547449999968
							],
							[
								153.12486112200008,
								-26.846378449999975
							],
							[
								153.1299541080001,
								-26.87390046099995
							],
							[
								153.0777120990001,
								-26.906943455999965
							],
							[
								153.0752061180001,
								-26.92025644599994
							],
							[
								153.09092301300007,
								-26.944955426999968
							],
							[
								153.07695208000007,
								-26.97857944599997
							],
							[
								153.0947361970001,
								-26.99369528799997
							],
							[
								153.0991710840001,
								-27.014343448999966
							],
							[
								153.13256051700012,
								-27.036267691999967
							],
							[
								153.1388696040001,
								-27.05926260299998
							]
						]
					],
					[
						[
							[
								153.08554797600004,
								-27.00733805699997
							],
							[
								153.0788290170001,
								-27.001728096999955
							],
							[
								153.077634116,
								-27.00978707699994
							],
							[
								153.08554797600004,
								-27.00733805699997
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "320",
				"CED_NAME21": "Longman",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 1245.5602,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/320",
				"SHAPE_Leng": 3.40523906354,
				"SHAPE_Area": 0.113268951178
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							152.14827790100003,
							-27.862841641999978
						],
						[
							152.0737553900001,
							-27.849796453999943
						],
						[
							152.07189446900009,
							-27.860215523999955
						],
						[
							152.05483379100008,
							-27.85955760199994
						],
						[
							152.0218601670001,
							-27.844417798999928
						],
						[
							152.01512215900004,
							-27.83230090799998
						],
						[
							152.0034553690001,
							-27.840399926999964
						],
						[
							151.98387064200006,
							-27.83583708499998
						],
						[
							151.977709881,
							-27.85061305499994
						],
						[
							151.9654489830001,
							-27.845109153999942
						],
						[
							151.90670909900007,
							-27.849366327999974
						],
						[
							151.86620626500007,
							-27.83221031399995
						],
						[
							151.83248614800004,
							-27.84264031099997
						],
						[
							151.82659406000005,
							-27.832144339999957
						],
						[
							151.80090817400003,
							-27.822256807999963
						],
						[
							151.788741124,
							-27.831842326999947
						],
						[
							151.74151487000006,
							-27.82384665199993
						],
						[
							151.7367056700001,
							-27.830595641999935
						],
						[
							151.72801578100007,
							-27.82708673099995
						],
						[
							151.70511455100007,
							-27.84734009899995
						],
						[
							151.6865471530001,
							-27.85218232699998
						],
						[
							151.68223712400004,
							-27.84471231699996
						],
						[
							151.6738431450001,
							-27.846373325999934
						],
						[
							151.65948714500007,
							-27.85855930499997
						],
						[
							151.6566871230001,
							-27.87569130399993
						],
						[
							151.64005013500002,
							-27.873407312999973
						],
						[
							151.65217258200005,
							-27.887375573999975
						],
						[
							151.62383482300004,
							-27.90665483199996
						],
						[
							151.5735781190001,
							-27.903568306999944
						],
						[
							151.57818326400002,
							-27.85629428699997
						],
						[
							151.55752900700008,
							-27.851884274999975
						],
						[
							151.5596850270001,
							-27.847127334999982
						],
						[
							151.54415825900003,
							-27.848404353999967
						],
						[
							151.54345910000006,
							-27.83999429299996
						],
						[
							151.53405626000006,
							-27.846555292999938
						],
						[
							151.519775094,
							-27.825716340999975
						],
						[
							151.4976192370001,
							-27.821557328999972
						],
						[
							151.49371321900003,
							-27.81064428899998
						],
						[
							151.48118522100003,
							-27.809819266999966
						],
						[
							151.47972113200012,
							-27.79595025699996
						],
						[
							151.47220505300004,
							-27.79681831599993
						],
						[
							151.47114699400004,
							-27.790276305999953
						],
						[
							151.46141226500004,
							-27.78910927499993
						],
						[
							151.46244006400002,
							-27.797050344999946
						],
						[
							151.4499069850001,
							-27.801775333999956
						],
						[
							151.44627713600005,
							-27.793802333999963
						],
						[
							151.43921500700003,
							-27.796896342999958
						],
						[
							151.4405520370001,
							-27.790677252999956
						],
						[
							151.4138303210001,
							-27.78042230099993
						],
						[
							151.421332021,
							-27.77487531099996
						],
						[
							151.4122441830001,
							-27.770121350999943
						],
						[
							151.41905931400004,
							-27.751950260999934
						],
						[
							151.41075917500007,
							-27.75605631999997
						],
						[
							151.40431013700004,
							-27.741350309999973
						],
						[
							151.38600810000003,
							-27.737663277999957
						],
						[
							151.3742461920001,
							-27.72543525699996
						],
						[
							151.38048316200002,
							-27.72226130699994
						],
						[
							151.3772583230001,
							-27.715628316999982
						],
						[
							151.36152021600003,
							-27.709807294999962
						],
						[
							151.36064826900008,
							-27.68270928499993
						],
						[
							151.35174727000003,
							-27.68288326399994
						],
						[
							151.34910810200006,
							-27.668832273999953
						],
						[
							151.33341931300004,
							-27.670036281999955
						],
						[
							151.31831623800008,
							-27.642886260999944
						],
						[
							151.32783429900007,
							-27.63123126199997
						],
						[
							151.32083912100006,
							-27.61363726099995
						],
						[
							151.296605386,
							-27.601015297999936
						],
						[
							151.28787535900005,
							-27.57690527699998
						],
						[
							151.2711001020001,
							-27.56646230599995
						],
						[
							151.27518431300007,
							-27.556232265999938
						],
						[
							151.25921023700005,
							-27.541047283999944
						],
						[
							151.26293323800007,
							-27.524927274999982
						],
						[
							151.22975923400008,
							-27.509466260999943
						],
						[
							151.22128013700012,
							-27.486499159999937
						],
						[
							151.20548541800008,
							-27.49143924899994
						],
						[
							151.20182483700012,
							-27.51057629899998
						],
						[
							151.08174025200003,
							-27.49303325799997
						],
						[
							151.07618725500004,
							-27.471606256999962
						],
						[
							151.08777126500001,
							-27.376410256999975
						],
						[
							151.19742196200002,
							-27.38400904699995
						],
						[
							151.19312923100006,
							-27.398833356999944
						],
						[
							151.30863843600002,
							-27.41378857799998
						],
						[
							151.31256723600006,
							-27.330824277999966
						],
						[
							151.3176352150001,
							-27.331531267999935
						],
						[
							151.33771125700002,
							-27.207780278999962
						],
						[
							151.45053123700006,
							-27.278724289999957
						],
						[
							151.46021604500004,
							-27.202732710999953
						],
						[
							151.45022125600008,
							-27.201241299999936
						],
						[
							151.45252023800003,
							-27.180077299999937
						],
						[
							151.458096242,
							-27.14580928999993
						],
						[
							151.46704126100008,
							-27.146977280999977
						],
						[
							151.47040623100008,
							-27.139008300999933
						],
						[
							151.4649402550001,
							-27.110809279999955
						],
						[
							151.48303326300004,
							-27.11320329199998
						],
						[
							151.48123724200002,
							-27.12435530199997
						],
						[
							151.52548925700012,
							-27.12550629599997
						],
						[
							151.52650026800006,
							-27.11952128599995
						],
						[
							151.53967424600012,
							-27.12175029699995
						],
						[
							151.54623522600002,
							-27.115282297999954
						],
						[
							151.5685112120001,
							-27.12477229999996
						],
						[
							151.5811862490001,
							-27.055948300999944
						],
						[
							151.59674622700004,
							-27.057999301999928
						],
						[
							151.60086409000007,
							-27.030493342999932
						],
						[
							151.62309225800004,
							-27.030117314999927
						],
						[
							151.62752723100004,
							-27.00260030499993
						],
						[
							151.6631812280001,
							-26.990853297999934
						],
						[
							151.67470834100004,
							-26.958296338999958
						],
						[
							151.67540639900005,
							-26.973684268999932
						],
						[
							151.6969851550001,
							-26.985793310999952
						],
						[
							151.7114502510001,
							-27.010262302999934
						],
						[
							151.74308121700005,
							-27.01446432599994
						],
						[
							151.744239106,
							-27.023700335999933
						],
						[
							151.760982344,
							-27.02587131799993
						],
						[
							151.75936521300002,
							-27.036283337999976
						],
						[
							151.7699981710001,
							-27.03783232899997
						],
						[
							151.7659600710001,
							-27.04591828799994
						],
						[
							151.7833873190001,
							-27.044148339999936
						],
						[
							151.774046386,
							-27.078250328999957
						],
						[
							151.79434790000005,
							-27.113302911999938
						],
						[
							151.79263819800008,
							-27.132680351999966
						],
						[
							151.8134951730001,
							-27.154883343999984
						],
						[
							151.8527013470001,
							-27.168093297999974
						],
						[
							151.86215637300006,
							-27.191411308999932
						],
						[
							151.8733997610001,
							-27.195296989999974
						],
						[
							151.88121517700006,
							-27.227122340999983
						],
						[
							151.8918783160001,
							-27.224239341999976
						],
						[
							151.9188452090001,
							-27.25460633499995
						],
						[
							151.958177857,
							-27.239569977999963
						],
						[
							151.95182010400003,
							-27.27138035799993
						],
						[
							151.93279805500003,
							-27.27601031599994
						],
						[
							151.9299220050001,
							-27.285533295999983
						],
						[
							151.93910919300004,
							-27.286752356999955
						],
						[
							151.93520519300012,
							-27.29634432699993
						],
						[
							151.94997908100004,
							-27.294018327999936
						],
						[
							151.94853017100002,
							-27.30212434799995
						],
						[
							151.96782928800008,
							-27.303164299999935
						],
						[
							151.95989958300004,
							-27.35262739899997
						],
						[
							151.97868715200002,
							-27.345198340999957
						],
						[
							152.0062841780001,
							-27.351623333999953
						],
						[
							152.01641516100005,
							-27.320859334999966
						],
						[
							151.993233174,
							-27.317839341999957
						],
						[
							151.99465434500007,
							-27.30906534199994
						],
						[
							152.01627412300002,
							-27.30774629399997
						],
						[
							152.01877828400006,
							-27.293916364999973
						],
						[
							152.03063417300007,
							-27.288047345999928
						],
						[
							152.04838722800002,
							-27.315440317999958
						],
						[
							152.04292017700004,
							-27.333786346999943
						],
						[
							152.0705552720001,
							-27.34397131999998
						],
						[
							152.06760615000007,
							-27.361745319999955
						],
						[
							152.04950455100004,
							-27.36978660799997
						],
						[
							152.0543261690001,
							-27.382723338999938
						],
						[
							152.04856014900008,
							-27.39126234799994
						],
						[
							152.05381136800008,
							-27.39201799899996
						],
						[
							152.06039315700002,
							-27.39296510899993
						],
						[
							152.05874737700003,
							-27.402075398999955
						],
						[
							152.069884945,
							-27.403710889999957
						],
						[
							152.083413854,
							-27.40464584199998
						],
						[
							152.08944215400004,
							-27.396963351999943
						],
						[
							152.0996312410001,
							-27.411849872999937
						],
						[
							152.13698142600003,
							-27.423625236999953
						],
						[
							152.14110442300012,
							-27.441431957999953
						],
						[
							152.15630916200007,
							-27.438476358999935
						],
						[
							152.16163472000005,
							-27.44666552999996
						],
						[
							152.1646651420001,
							-27.425221369999974
						],
						[
							152.17728151100005,
							-27.420885560999977
						],
						[
							152.17960105300006,
							-27.407234390999974
						],
						[
							152.19753521100006,
							-27.409284712999977
						],
						[
							152.19172912400006,
							-27.386836351999932
						],
						[
							152.20150013600005,
							-27.35967936299994
						],
						[
							152.1914391370001,
							-27.366110351999964
						],
						[
							152.20149087100003,
							-27.322009091999973
						],
						[
							152.19010616200012,
							-27.32034035099997
						],
						[
							152.20619215400006,
							-27.292033352999965
						],
						[
							152.19644416800008,
							-27.272150371999942
						],
						[
							152.18408234900005,
							-27.270461359999956
						],
						[
							152.16440005900006,
							-27.288931368999954
						],
						[
							152.15199363300007,
							-27.26939105699995
						],
						[
							152.16249531300002,
							-27.25656934799997
						],
						[
							152.17698767100012,
							-27.263753479999934
						],
						[
							152.17239976200005,
							-27.253782048999938
						],
						[
							152.1887337700001,
							-27.254838220999943
						],
						[
							152.1909122720001,
							-27.242065390999983
						],
						[
							152.20094714100003,
							-27.243390661999968
						],
						[
							152.2255144500001,
							-27.228666043999965
						],
						[
							152.23615497200012,
							-27.203695124999967
						],
						[
							152.22047114400004,
							-27.20129435299998
						],
						[
							152.21508315300002,
							-27.20894236299995
						],
						[
							152.18002917700005,
							-27.205040358999952
						],
						[
							152.1732441570001,
							-27.211294358999965
						],
						[
							152.15886006000005,
							-27.206418456999984
						],
						[
							152.16161815100008,
							-27.18896935799995
						],
						[
							152.18849813100007,
							-27.169136409999965
						],
						[
							152.1340416800001,
							-27.141611513999976
						],
						[
							152.15363017100003,
							-27.11309735599997
						],
						[
							152.18231910100008,
							-27.090055408999945
						],
						[
							152.1852421640001,
							-27.06142036899996
						],
						[
							152.19132419200002,
							-27.072331368999983
						],
						[
							152.21804419900002,
							-27.078261361999978
						],
						[
							152.21450626000012,
							-27.069481131999964
						],
						[
							152.22739324000008,
							-27.060978102999968
						],
						[
							152.19472946400003,
							-27.05652638999993
						],
						[
							152.19918476700002,
							-27.02774231999996
						],
						[
							152.1930207580001,
							-27.022864548999962
						],
						[
							152.22096369500002,
							-27.02219452199995
						],
						[
							152.18659220100005,
							-27.006649358999937
						],
						[
							152.18875712200008,
							-26.993915158999982
						],
						[
							152.1733121840001,
							-26.989247346999946
						],
						[
							152.18490418400006,
							-26.985228357999972
						],
						[
							152.1747511650001,
							-26.98214134699998
						],
						[
							152.183177375,
							-26.977575387999934
						],
						[
							152.16945417600004,
							-26.97932435699994
						],
						[
							152.167890187,
							-26.96876534599994
						],
						[
							152.15158428900008,
							-26.97116470499998
						],
						[
							152.1254446040001,
							-26.954212711999958
						],
						[
							152.14522920500008,
							-26.926677343999984
						],
						[
							152.14987620700003,
							-26.904604353999957
						],
						[
							152.13792588900003,
							-26.897850742999935
						],
						[
							152.14698519,
							-26.879104353999935
						],
						[
							152.16704420000008,
							-26.86708235599997
						],
						[
							152.17265220800004,
							-26.875234365999972
						],
						[
							152.188655196,
							-26.877365357999963
						],
						[
							152.18103473100007,
							-26.846560546999967
						],
						[
							152.1900873830001,
							-26.823599516999934
						],
						[
							152.174123204,
							-26.82142635599996
						],
						[
							152.17051919800008,
							-26.79681935499997
						],
						[
							152.17905121800004,
							-26.783744355999943
						],
						[
							152.1557884230001,
							-26.768807803999948
						],
						[
							152.1639040550001,
							-26.742110743999945
						],
						[
							152.15097724700001,
							-26.74050385299995
						],
						[
							152.15299522800012,
							-26.727592352999977
						],
						[
							152.14107519900006,
							-26.727174341999955
						],
						[
							152.146060228,
							-26.736020361999977
						],
						[
							152.13311622800006,
							-26.741259360999948
						],
						[
							152.13430438000012,
							-26.730586020999965
						],
						[
							152.11345051500007,
							-26.70698824899995
						],
						[
							152.10233622500004,
							-26.70955334799993
						],
						[
							152.084456229,
							-26.696890335999967
						],
						[
							152.07339899300007,
							-26.668397784999968
						],
						[
							152.11963522200006,
							-26.637385348999942
						],
						[
							152.13081922100002,
							-26.638771349999956
						],
						[
							152.13585626300005,
							-26.61420634999996
						],
						[
							152.13032720600006,
							-26.600393339999982
						],
						[
							152.1431612350001,
							-26.592687350999938
						],
						[
							152.13159021800004,
							-26.578459359999954
						],
						[
							152.13587784000003,
							-26.560762439999962
						],
						[
							152.1257232170001,
							-26.506547358999967
						],
						[
							152.13652721800008,
							-26.495020359999955
						],
						[
							152.13587324900004,
							-26.480049348999955
						],
						[
							152.14989395800012,
							-26.482662540999968
						],
						[
							152.15575815800003,
							-26.47476452099994
						],
						[
							152.16765825700008,
							-26.475406351999936
						],
						[
							152.17378325100003,
							-26.43807836299993
						],
						[
							152.16719628400006,
							-26.41668335199995
						],
						[
							152.1487372480001,
							-26.40134434999993
						],
						[
							152.1412692780001,
							-26.406678348999947
						],
						[
							152.12188128100001,
							-26.393520346999935
						],
						[
							152.12108715300008,
							-26.377267356999937
						],
						[
							152.09644512600005,
							-26.373530374999973
						],
						[
							152.07272725000007,
							-26.359182301999965
						],
						[
							152.06884127800004,
							-26.38312234199998
						],
						[
							152.0118040850001,
							-26.375261026999965
						],
						[
							152.0163332940001,
							-26.38027731699998
						],
						[
							152.0106751730001,
							-26.387233316999982
						],
						[
							152.02479436200008,
							-26.388044297999954
						],
						[
							152.03854240900012,
							-26.40213830899995
						],
						[
							151.98663437000005,
							-26.43416435499995
						],
						[
							151.96457717300007,
							-26.428845361999947
						],
						[
							151.96320897400005,
							-26.42264912199994
						],
						[
							151.92265925900006,
							-26.417610327999967
						],
						[
							151.92195028800006,
							-26.42255231799993
						],
						[
							151.8915623250001,
							-26.390806304999956
						],
						[
							151.86986928700003,
							-26.39148432299993
						],
						[
							151.85526829800006,
							-26.401426311999955
						],
						[
							151.85009029900004,
							-26.39170133099998
						],
						[
							151.82900830100004,
							-26.400338328999965
						],
						[
							151.82425027200009,
							-26.392717328999936
						],
						[
							151.8305632030001,
							-26.381081348999942
						],
						[
							151.78543628800003,
							-26.375247314999967
						],
						[
							151.7831673070001,
							-26.389837314999966
						],
						[
							151.76724530800004,
							-26.387772302999963
						],
						[
							151.7684383190001,
							-26.38029930299996
						],
						[
							151.71951229500007,
							-26.37391030899994
						],
						[
							151.7209663120001,
							-26.394313308999983
						],
						[
							151.69493129600005,
							-26.39081830599997
						],
						[
							151.6784332960001,
							-26.40302930499996
						],
						[
							151.67087531700008,
							-26.40203629399997
						],
						[
							151.67150629800005,
							-26.39416231399997
						],
						[
							151.50751513700004,
							-26.37586347799993
						],
						[
							151.4840711480001,
							-26.38280417599998
						],
						[
							151.4838643370001,
							-26.39348023599996
						],
						[
							151.43194867900002,
							-26.42432069199998
						],
						[
							151.42804415800003,
							-26.43371412099998
						],
						[
							151.3888993480001,
							-26.37946723699997
						],
						[
							151.3704773180001,
							-26.402072275999956
						],
						[
							151.30530332400008,
							-26.403542279999954
						],
						[
							151.28480934800007,
							-26.393613267999967
						],
						[
							151.2007884300001,
							-26.44925128999995
						],
						[
							151.20773134600006,
							-26.47875425099994
						],
						[
							151.07696935100012,
							-26.462803248999933
						],
						[
							151.114944357,
							-26.37932625199994
						],
						[
							151.1356593580001,
							-26.263113252999972
						],
						[
							151.06590742600008,
							-26.25458855599993
						],
						[
							151.01672010100003,
							-26.256209341999977
						],
						[
							151.01324939900007,
							-26.191916730999935
						],
						[
							151.02286659700007,
							-26.194977111999947
						],
						[
							151.0732733850001,
							-26.172754255999962
						],
						[
							151.0764344060001,
							-26.161831235999955
						],
						[
							151.09983440300005,
							-26.160267258999966
						],
						[
							151.0987023550001,
							-26.149881997999955
						],
						[
							151.1158733840001,
							-26.140853239999956
						],
						[
							151.13929239900006,
							-26.159171261999973
						],
						[
							151.15878736800005,
							-26.15452325399997
						],
						[
							151.15953738200005,
							-26.120788253999933
						],
						[
							151.15166838400012,
							-26.107706262999955
						],
						[
							151.13444841600005,
							-26.105276250999964
						],
						[
							151.11542537700007,
							-26.11869625999998
						],
						[
							151.0673522950001,
							-26.085387224999977
						],
						[
							151.05622151600005,
							-26.090469283999937
						],
						[
							151.01589234100004,
							-26.077207259999966
						],
						[
							150.98398843300004,
							-26.00779323699993
						],
						[
							150.933091417,
							-26.013208241999962
						],
						[
							150.91407243000003,
							-26.004078229999948
						],
						[
							150.90393342900006,
							-26.01938421899996
						],
						[
							150.84957244100008,
							-26.056392224999968
						],
						[
							150.78981746800002,
							-26.048910208999928
						],
						[
							150.78092147100006,
							-26.028481217999968
						],
						[
							150.78598643200007,
							-26.018644208999945
						],
						[
							150.77581844300005,
							-26.01222021799998
						],
						[
							150.76364145800005,
							-25.981586205999974
						],
						[
							150.714419463,
							-25.98484320199998
						],
						[
							150.70206246500004,
							-25.973917210999957
						],
						[
							150.67276044900007,
							-25.969574207999983
						],
						[
							150.66888645200004,
							-25.942654206999975
						],
						[
							150.68499846400005,
							-25.913862218999952
						],
						[
							150.6783814570001,
							-25.88901519799998
						],
						[
							150.69869545900008,
							-25.855741208999973
						],
						[
							150.649241479,
							-25.803296203999935
						],
						[
							150.65688749900005,
							-25.800955194999972
						],
						[
							150.64412947200003,
							-25.786186203999932
						],
						[
							150.668446463,
							-25.75825320599995
						],
						[
							150.66428247600004,
							-25.732725194999944
						],
						[
							150.64315548000002,
							-25.715649192999933
						],
						[
							150.66357248100007,
							-25.68426320499998
						],
						[
							150.6541670250001,
							-25.659768783999937
						],
						[
							150.59124150200012,
							-25.652679207999938
						],
						[
							150.5702914960001,
							-25.638185195999938
						],
						[
							150.52418751000005,
							-25.64537420199997
						],
						[
							150.49549851400002,
							-25.628374188999942
						],
						[
							150.4838805280001,
							-25.606102187999966
						],
						[
							150.44610953200004,
							-25.598817183999984
						],
						[
							150.43674954300002,
							-25.606379183999934
						],
						[
							150.44255950000002,
							-25.62174218399997
						],
						[
							150.4364705270001,
							-25.66140218399994
						],
						[
							150.41849949700008,
							-25.675147181999932
						],
						[
							150.434154529,
							-25.73361919399997
						],
						[
							150.4260285250001,
							-25.77396317399996
						],
						[
							150.417914504,
							-25.789088182999933
						],
						[
							150.39511452600004,
							-25.795947180999974
						],
						[
							150.38876348500003,
							-25.814510180999946
						],
						[
							150.34544251900002,
							-25.817671176999966
						],
						[
							150.33667551300005,
							-25.790394185999958
						],
						[
							150.29510154800005,
							-25.780232161999947
						],
						[
							150.28193653900007,
							-25.77883517099997
						],
						[
							150.27911753800004,
							-25.796252170999935
						],
						[
							150.2578605210001,
							-25.78842016899995
						],
						[
							150.24960853200002,
							-25.788171157999955
						],
						[
							150.24829752100004,
							-25.795389177999937
						],
						[
							150.17447154,
							-25.780094160999965
						],
						[
							150.18059652700003,
							-25.80514216199998
						],
						[
							150.15925552700003,
							-25.81909515999996
						],
						[
							150.12869853100005,
							-25.81847716799996
						],
						[
							150.09626153700003,
							-25.794242164999957
						],
						[
							150.08544654600007,
							-25.812034143999938
						],
						[
							150.05595253900003,
							-25.81311715099997
						],
						[
							150.04988755600004,
							-25.839911150999967
						],
						[
							150.04292652800007,
							-25.832346149999978
						],
						[
							150.03014452900004,
							-25.83622614899997
						],
						[
							150.02703257000007,
							-25.82965514899996
						],
						[
							150.0217495160001,
							-25.865164148999952
						],
						[
							149.99006555200003,
							-25.847082145999934
						],
						[
							149.9649085540001,
							-25.85110915299998
						],
						[
							149.9503565560001,
							-25.839641151999956
						],
						[
							149.93202252800006,
							-25.839429139999936
						],
						[
							149.89730056500002,
							-25.814803136999956
						],
						[
							149.89450513400004,
							-25.82365381699998
						],
						[
							149.8866844250001,
							-25.820860295999978
						],
						[
							149.88249455400012,
							-25.82942814599994
						],
						[
							149.85081555700003,
							-25.837466132999964
						],
						[
							149.82358557100008,
							-25.828281140999934
						],
						[
							149.82155153000008,
							-25.83996513099993
						],
						[
							149.82770053900003,
							-25.84316213099993
						],
						[
							149.81783356900007,
							-25.85156613099997
						],
						[
							149.79734455100004,
							-25.84891812899997
						],
						[
							149.78736757100012,
							-25.857958137999958
						],
						[
							149.7708885930001,
							-25.852344125999934
						],
						[
							149.76632254300011,
							-25.859446125999966
						],
						[
							149.78304056800005,
							-25.890688127999965
						],
						[
							149.77140655800008,
							-25.90595512699997
						],
						[
							149.73590958700004,
							-25.849527122999973
						],
						[
							149.68189557000005,
							-25.872268118999955
						],
						[
							149.64920059100007,
							-25.894475125999975
						],
						[
							149.5849345690001,
							-25.88639711099995
						],
						[
							149.57549358400001,
							-25.944152109999948
						],
						[
							149.4768415750001,
							-25.93349311199995
						],
						[
							149.48353757900009,
							-25.891860101999953
						],
						[
							149.4014435780001,
							-25.882473094999966
						],
						[
							149.39864260900004,
							-25.876020093999955
						],
						[
							149.34631960000002,
							-25.918983079999975
						],
						[
							149.3278135910001,
							-25.925237078999942
						],
						[
							149.30280659900006,
							-25.96607109699994
						],
						[
							149.13802561900002,
							-25.945793082999955
						],
						[
							149.12457062900012,
							-25.951111071999946
						],
						[
							149.09730162300002,
							-25.947886078999943
						],
						[
							149.1083216390001,
							-25.873182079999935
						],
						[
							149.02830566400007,
							-25.804461061999973
						],
						[
							149.03138563800007,
							-25.76965906199996
						],
						[
							148.96116764300007,
							-25.789748066999948
						],
						[
							148.94469665600002,
							-25.770985044999975
						],
						[
							148.91122966000012,
							-25.76758406199997
						],
						[
							148.90072668200003,
							-25.760076050999942
						],
						[
							148.92377165200003,
							-25.740471052999965
						],
						[
							148.92567465500008,
							-25.70382305299995
						],
						[
							148.939347665,
							-25.694901053999956
						],
						[
							148.93887465600005,
							-25.685675053999944
						],
						[
							148.95757368300008,
							-25.693092054999966
						],
						[
							148.97351964900008,
							-25.71328905699994
						],
						[
							149.0086046880001,
							-25.695063069999946
						],
						[
							149.03189066800007,
							-25.67283606199993
						],
						[
							149.0569336750001,
							-25.669403073999945
						],
						[
							149.05425268600004,
							-25.661682062999944
						],
						[
							149.06552764700007,
							-25.647210063999978
						],
						[
							149.04913965800006,
							-25.64735706299996
						],
						[
							149.06154067900002,
							-25.629827053999975
						],
						[
							149.05696664000004,
							-25.625126062999982
						],
						[
							149.04571066100004,
							-25.62393007199995
						],
						[
							149.03255468100008,
							-25.640572060999943
						],
						[
							149.03814067100006,
							-25.62928506199995
						],
						[
							149.01270068600002,
							-25.612374058999933
						],
						[
							149.025812695,
							-25.611047060999965
						],
						[
							149.01969967600007,
							-25.604000059999976
						],
						[
							148.9922956590001,
							-25.601277057999937
						],
						[
							148.99539669700005,
							-25.617552057999944
						],
						[
							148.98565466800005,
							-25.613440066999942
						],
						[
							148.98372367100012,
							-25.58866005699997
						],
						[
							149.02432470000008,
							-25.559786049999957
						],
						[
							148.93805368900007,
							-25.45857504199995
						],
						[
							148.93892669800005,
							-25.463758061999954
						],
						[
							148.9004427010001,
							-25.472444048999932
						],
						[
							148.87685969400002,
							-25.469759046999968
						],
						[
							148.8728667050001,
							-25.46122205599994
						],
						[
							148.83344768900008,
							-25.459938042999966
						],
						[
							148.814910692,
							-25.45198204199994
						],
						[
							148.81093070400004,
							-25.441013040999962
						],
						[
							148.80074070400008,
							-25.445908049999957
						],
						[
							148.7759547280001,
							-25.434929027999942
						],
						[
							148.76178572100002,
							-25.417363036999973
						],
						[
							148.72589771600008,
							-25.400838043999954
						],
						[
							148.7189857180001,
							-25.386940032999973
						],
						[
							148.72668371200007,
							-25.342541022999967
						],
						[
							148.7473877220001,
							-25.32416303499997
						],
						[
							148.74776473300005,
							-25.314813044999937
						],
						[
							148.75916671200002,
							-25.31071004599994
						],
						[
							148.74526273700008,
							-25.27970903399995
						],
						[
							148.7363387380001,
							-25.27839903399996
						],
						[
							148.727494717,
							-25.287922032999973
						],
						[
							148.70837675000007,
							-25.27750303099998
						],
						[
							148.69986374100006,
							-25.284549040999934
						],
						[
							148.6836807420001,
							-25.281904038999983
						],
						[
							148.66631875100006,
							-25.310842007999952
						],
						[
							148.64312573600012,
							-25.284112025999946
						],
						[
							148.60008673200002,
							-25.27284402199996
						],
						[
							148.56846474700012,
							-25.249924018999934
						],
						[
							148.55435672800002,
							-25.254081027999973
						],
						[
							148.5324327510001,
							-25.244089025999983
						],
						[
							148.47303276700006,
							-25.245424011999944
						],
						[
							148.45138476800003,
							-25.25472099999996
						],
						[
							148.42339175200004,
							-25.24929600799993
						],
						[
							148.41219176200002,
							-25.260130016999938
						],
						[
							148.3965267650001,
							-25.243454004999933
						],
						[
							148.3520477610001,
							-25.229081991999976
						],
						[
							148.3477369320001,
							-25.220125030999952
						],
						[
							148.3262377750001,
							-25.21027000899994
						],
						[
							148.30558378700005,
							-25.21227899799993
						],
						[
							148.29291577200001,
							-25.181864995999945
						],
						[
							148.2959449430001,
							-25.164857705999964
						],
						[
							148.24199178300012,
							-25.12050598199994
						],
						[
							148.2346884650001,
							-25.100656150999953
						],
						[
							148.20600881000007,
							-25.079229977999944
						],
						[
							148.16059679400007,
							-25.084144984999966
						],
						[
							148.13384314100006,
							-25.04252557199993
						],
						[
							148.12162126200008,
							-25.04200050099996
						],
						[
							148.11639526500005,
							-25.022797220999962
						],
						[
							148.0957765270001,
							-25.016517378999936
						],
						[
							148.07633266300002,
							-24.978561296999942
						],
						[
							148.0762091460001,
							-24.945406446999982
						],
						[
							148.05614229100001,
							-24.913712634999968
						],
						[
							148.02965760400002,
							-24.911351052999976
						],
						[
							148.0117695770001,
							-24.89785208099994
						],
						[
							147.9950883790001,
							-24.89946170999997
						],
						[
							147.97322846300005,
							-24.881520717999933
						],
						[
							147.95195184400006,
							-24.883193965999965
						],
						[
							147.93793884800004,
							-24.861558954999964
						],
						[
							147.9158278420001,
							-24.84605196299998
						],
						[
							147.9165428440001,
							-24.821171962999983
						],
						[
							147.9008238660001,
							-24.814337961999968
						],
						[
							147.8861248400001,
							-24.793772959999956
						],
						[
							147.8541938840001,
							-24.779579957999943
						],
						[
							147.8480098660001,
							-24.765030966999973
						],
						[
							147.8281438690001,
							-24.75180196599996
						],
						[
							147.82444186100008,
							-24.735078964999957
						],
						[
							147.79130888500003,
							-24.73074694199994
						],
						[
							147.7740778860001,
							-24.738968950999947
						],
						[
							147.75968287800004,
							-24.72799894999997
						],
						[
							147.73523288,
							-24.73030795799997
						],
						[
							147.68045390200007,
							-24.77383193399993
						],
						[
							147.64658690500005,
							-24.77319394099993
						],
						[
							147.64705486200012,
							-24.79994095199993
						],
						[
							147.58960689600008,
							-24.81839793699993
						],
						[
							147.57854590600004,
							-24.836023935999947
						],
						[
							147.560535898,
							-24.834253924999928
						],
						[
							147.5583338890001,
							-24.81916693499994
						],
						[
							147.54244288100006,
							-24.81754792399994
						],
						[
							147.5187408820001,
							-24.830183921999947
						],
						[
							147.50826990400003,
							-24.820697940999935
						],
						[
							147.50897990300007,
							-24.83489193099996
						],
						[
							147.48362510100003,
							-24.876969568999982
						],
						[
							147.41972546700003,
							-24.88135663399993
						],
						[
							147.38096791200007,
							-24.87077993099996
						],
						[
							147.36596390300008,
							-24.877424919999953
						],
						[
							147.32210290800003,
							-24.87045990699994
						],
						[
							147.31734389700011,
							-24.884879916999978
						],
						[
							147.30537689800008,
							-24.884951915999977
						],
						[
							147.29640092800003,
							-24.89578792499998
						],
						[
							147.13663091500007,
							-24.882868902999974
						],
						[
							147.13884292800003,
							-24.84898089199993
						],
						[
							147.089431353,
							-24.846453518999965
						],
						[
							147.09155393600008,
							-24.814114898999946
						],
						[
							146.90338864500006,
							-24.805178643999966
						],
						[
							146.88028897100003,
							-24.773392891999947
						],
						[
							146.88227993100008,
							-24.76247387199993
						],
						[
							146.90947298000003,
							-24.743816883999955
						],
						[
							146.92088197200007,
							-24.716623884999933
						],
						[
							146.94201897100004,
							-24.70434989599994
						],
						[
							146.93325397400008,
							-24.674890884999968
						],
						[
							146.89413697100008,
							-24.640281871999946
						],
						[
							146.88404935500012,
							-24.61157032099993
						],
						[
							146.88700998600007,
							-24.59668788099998
						],
						[
							146.87854497600006,
							-24.60132689099993
						],
						[
							146.8607170990001,
							-24.587316598999962
						],
						[
							146.83394778900004,
							-24.62432558699993
						],
						[
							146.81905900000004,
							-24.626009875999955
						],
						[
							146.8085504700001,
							-24.63898607599998
						],
						[
							146.80011999200008,
							-24.620572874999937
						],
						[
							146.78742368300004,
							-24.62627733399995
						],
						[
							146.77416298100002,
							-24.66275287299993
						],
						[
							146.7579170130001,
							-24.66334587199998
						],
						[
							146.74051428600012,
							-24.650327250999965
						],
						[
							146.73937399800002,
							-24.62913986999996
						],
						[
							146.6895109840001,
							-24.611570856999947
						],
						[
							146.66681597800005,
							-24.59080086499995
						],
						[
							146.68003299800012,
							-24.58085586599998
						],
						[
							146.6796299980001,
							-24.572813854999936
						],
						[
							146.66410101100007,
							-24.562418873999945
						],
						[
							146.66137000300012,
							-24.54060887399993
						],
						[
							146.64588900600006,
							-24.523329872999966
						],
						[
							146.63993100900007,
							-24.50019785199993
						],
						[
							146.62609200100007,
							-24.493746870999928
						],
						[
							146.6212980140001,
							-24.45801285999994
						],
						[
							146.60811100500007,
							-24.46130385899994
						],
						[
							146.59605801700002,
							-24.452998857999944
						],
						[
							146.58689601000003,
							-24.427740866999955
						],
						[
							146.57246540300002,
							-24.41283380599998
						],
						[
							146.59587103100012,
							-24.417173867999963
						],
						[
							146.6417250280001,
							-24.399146860999963
						],
						[
							146.65981792600007,
							-24.40332901299996
						],
						[
							146.68899500500004,
							-24.374228864999964
						],
						[
							146.72193304100006,
							-24.384687876999976
						],
						[
							146.7297080070001,
							-24.418538857999977
						],
						[
							146.75952602600012,
							-24.403660869999953
						],
						[
							146.80210798100006,
							-24.40676687299998
						],
						[
							146.81436399300003,
							-24.376695883999957
						],
						[
							146.86424400900012,
							-24.36877988799995
						],
						[
							146.8737060210001,
							-24.337675867999963
						],
						[
							146.89974200900008,
							-24.328542889999937
						],
						[
							146.9231000100001,
							-24.294676881999976
						],
						[
							146.93512999900008,
							-24.290575871999977
						],
						[
							146.92685899100002,
							-24.278972881999948
						],
						[
							146.92741901300008,
							-24.256744891999972
						],
						[
							146.94370798400007,
							-24.229163882999956
						],
						[
							146.94029402500007,
							-24.219254881999973
						],
						[
							146.9534250150001,
							-24.206844872999966
						],
						[
							146.94974103700008,
							-24.188346872999944
						],
						[
							146.9563789980001,
							-24.163580882999952
						],
						[
							146.96478399700004,
							-24.167439873999967
						],
						[
							146.97367002700003,
							-24.160104883999963
						],
						[
							146.98986602500008,
							-24.161298875999933
						],
						[
							147.02855500400005,
							-24.140523877999954
						],
						[
							147.03741972400007,
							-24.12568413899993
						],
						[
							147.07369597100012,
							-24.117682891999948
						],
						[
							147.11029500000006,
							-24.09332788399996
						],
						[
							147.14152100800004,
							-24.08560889699993
						],
						[
							147.16127998500008,
							-24.09297788799995
						],
						[
							147.18332299400004,
							-24.085727909999946
						],
						[
							147.17417901700003,
							-24.060034908999967
						],
						[
							147.18663700800005,
							-24.036039909999943
						],
						[
							147.1784090010001,
							-24.016456898999934
						],
						[
							147.1838580110001,
							-24.004835898999943
						],
						[
							147.17337102400006,
							-23.97804489799995
						],
						[
							147.16300582600002,
							-23.972878186999935
						],
						[
							147.1786610370001,
							-23.94294890799995
						],
						[
							147.2032899950001,
							-23.93980689999995
						],
						[
							147.2273827350001,
							-23.914766931999964
						],
						[
							147.23899393400006,
							-23.912815792999936
						],
						[
							147.2411540050001,
							-23.90318689299994
						],
						[
							147.23351400800004,
							-23.881333901999938
						],
						[
							147.2365040200001,
							-23.84795091199993
						],
						[
							147.22769704300003,
							-23.832098900999938
						],
						[
							147.2379670140001,
							-23.810759891999965
						],
						[
							147.22956000700003,
							-23.787475900999937
						],
						[
							147.199784001,
							-23.77329588899994
						],
						[
							147.19513901400012,
							-23.745558897999956
						],
						[
							147.20088302400006,
							-23.733847897999965
						],
						[
							147.1936960260001,
							-23.718200897999964
						],
						[
							147.1957260490001,
							-23.684486896999942
						],
						[
							147.2095370290001,
							-23.67592089799996
						],
						[
							147.20057716100007,
							-23.654602077999982
						],
						[
							147.21165903200006,
							-23.63948189799993
						],
						[
							147.1981550260001,
							-23.609133906999944
						],
						[
							147.2200761250001,
							-23.593555928999933
						],
						[
							147.21217098700004,
							-23.57605371799997
						],
						[
							147.21973915700005,
							-23.56809955799997
						],
						[
							147.21944218900012,
							-23.55097763799995
						],
						[
							147.25823373600008,
							-23.54307746099994
						],
						[
							147.28377946500007,
							-23.52477128299995
						],
						[
							147.2792331400001,
							-23.48164639199996
						],
						[
							147.2660859130001,
							-23.463283900999954
						],
						[
							147.26036884300004,
							-23.46948064099996
						],
						[
							147.24940242500008,
							-23.45137859999994
						],
						[
							147.25984569500008,
							-23.43805722999997
						],
						[
							147.26502348000008,
							-23.384151499999973
						],
						[
							147.28662173100008,
							-23.351222871999937
						],
						[
							147.1618890530001,
							-23.339696901999957
						],
						[
							147.15870205500005,
							-23.326242891999982
						],
						[
							147.07486105400005,
							-23.306902884999943
						],
						[
							147.07906410600003,
							-23.279820774999962
						],
						[
							146.9763120870001,
							-23.26326287699993
						],
						[
							146.9397300810001,
							-23.260341874999938
						],
						[
							146.93271207700002,
							-23.315469873999973
						],
						[
							146.85458310500007,
							-23.30473287799998
						],
						[
							146.85486809600002,
							-23.29376187799994
						],
						[
							146.877704106,
							-23.269215879999933
						],
						[
							146.88446711900008,
							-23.220260879999955
						],
						[
							146.87222111100004,
							-23.210708868999973
						],
						[
							146.8747120920001,
							-23.19564087899994
						],
						[
							146.86417611500008,
							-23.174907867999934
						],
						[
							146.81453010200005,
							-23.153612863999967
						],
						[
							146.78906211600008,
							-23.12729987199998
						],
						[
							146.77887713000007,
							-23.09066685099998
						],
						[
							146.78654914100002,
							-23.079223860999946
						],
						[
							146.7822191030001,
							-23.053729860999965
						],
						[
							146.78756913400002,
							-23.03713486099997
						],
						[
							146.75288811200005,
							-22.984248857999944
						],
						[
							146.7327821350001,
							-22.970150856999965
						],
						[
							146.70228411900007,
							-22.96220686399994
						],
						[
							146.684240132,
							-22.94575285299993
						],
						[
							146.66509814500012,
							-22.925149860999966
						],
						[
							146.664314127,
							-22.906527850999964
						],
						[
							146.646070161,
							-22.883194858999957
						],
						[
							146.62355017200002,
							-22.886574837999945
						],
						[
							146.6108581740001,
							-22.88115483699994
						],
						[
							146.57843617600008,
							-22.889543843999945
						],
						[
							146.56014313900005,
							-22.878430842999933
						],
						[
							146.52478216800012,
							-22.804032849999942
						],
						[
							146.52873617900002,
							-22.792797829999927
						],
						[
							146.5484271580001,
							-22.77822884099993
						],
						[
							146.54840317900005,
							-22.768876830999943
						],
						[
							146.40143616300008,
							-22.75549082999993
						],
						[
							146.42416720900007,
							-22.547370829999977
						],
						[
							146.4393312080001,
							-22.54885183099998
						],
						[
							146.45178122100003,
							-22.49929984199997
						],
						[
							146.4286022240001,
							-22.48792882999993
						],
						[
							146.38298018500006,
							-22.52087582699994
						],
						[
							146.32959923200008,
							-22.49480882299997
						],
						[
							146.29695220500003,
							-22.49572281999997
						],
						[
							146.26930670600007,
							-22.508633218999933
						],
						[
							146.27555522000011,
							-22.46272881899995
						],
						[
							146.10892773600006,
							-22.445650215999933
						],
						[
							146.12207825300004,
							-22.347408795999968
						],
						[
							146.0521392600001,
							-22.338488800999983
						],
						[
							146.07067126700008,
							-22.226608811999938
						],
						[
							146.0645920510001,
							-22.18574819099996
						],
						[
							146.07406256600007,
							-22.123363620999953
						],
						[
							146.03146229100003,
							-22.104800787999977
						],
						[
							145.7696171870001,
							-22.06657662899994
						],
						[
							145.77008519800006,
							-22.048516478999943
						],
						[
							145.66117880800005,
							-22.041142890999936
						],
						[
							145.66827014600005,
							-21.93202077099994
						],
						[
							145.62720473000002,
							-21.926711247999947
						],
						[
							145.63017240300007,
							-21.892907957999967
						],
						[
							145.64063162200011,
							-21.893972877999943
						],
						[
							145.6506083260001,
							-21.707103767999968
						],
						[
							145.67474234400004,
							-21.708123758999932
						],
						[
							145.67848395700003,
							-21.668175708999968
						],
						[
							145.53284036000002,
							-21.658240688999967
						],
						[
							145.52940902700004,
							-21.701927638999962
						],
						[
							145.43473865600004,
							-21.69203903199997
						],
						[
							145.4182412250001,
							-21.846233591999976
						],
						[
							145.26204945900008,
							-21.828708321999954
						],
						[
							145.25481016300012,
							-21.79378386099995
						],
						[
							145.16607557100008,
							-21.78488033499997
						],
						[
							145.152971653,
							-21.898912854999935
						],
						[
							145.07520268100006,
							-21.89142911899995
						],
						[
							145.08434716800002,
							-21.91024430999994
						],
						[
							145.08221367600004,
							-21.942592719999936
						],
						[
							144.95631226800003,
							-21.93029778199997
						],
						[
							144.9430554490001,
							-22.059136131999935
						],
						[
							144.80091337200008,
							-22.04537271199996
						],
						[
							144.79636338900002,
							-22.09841770199995
						],
						[
							144.75232337300008,
							-22.094786708999948
						],
						[
							144.7397893650001,
							-22.21171471899993
						],
						[
							144.7235332570001,
							-22.20209443799996
						],
						[
							144.50052119800011,
							-22.18564820299997
						],
						[
							144.5017834790001,
							-22.165129812999965
						],
						[
							144.39778330900003,
							-22.15703816599995
						],
						[
							144.41722062500003,
							-22.06171116699994
						],
						[
							144.26849744900005,
							-22.04785459699997
						],
						[
							144.26344263300007,
							-21.99737784599995
						],
						[
							144.18033565100006,
							-21.989545130999943
						],
						[
							144.18849917600005,
							-21.908398560999956
						],
						[
							144.18430386600005,
							-21.913305169999944
						],
						[
							144.0388536800001,
							-21.89469959099995
						],
						[
							144.0446283440001,
							-21.830289010999934
						],
						[
							143.78184179800007,
							-21.81406633399996
						],
						[
							143.63084482200009,
							-21.797408314999927
						],
						[
							143.64926393200005,
							-21.641164213999957
						],
						[
							143.32877374100008,
							-21.61184577499995
						],
						[
							143.35953744900007,
							-21.321997193999948
						],
						[
							143.18803758400009,
							-21.30864279399998
						],
						[
							142.95333449100008,
							-21.493744380999942
						],
						[
							142.9424197830001,
							-21.48164191999996
						],
						[
							142.86209920600004,
							-21.545046855999942
						],
						[
							142.81540651300008,
							-21.493121222999946
						],
						[
							142.69396510700005,
							-21.587849996999978
						],
						[
							142.7184758730001,
							-21.61493522799998
						],
						[
							142.6513734660001,
							-21.667480694999938
						],
						[
							142.65652179900007,
							-21.610347924999928
						],
						[
							142.49559809400012,
							-21.597989464999955
						],
						[
							142.49123141100006,
							-21.644170904999953
						],
						[
							142.3325700150001,
							-21.636308305999933
						],
						[
							142.33519663700008,
							-21.607090555999946
						],
						[
							142.2281711270001,
							-21.596264349999956
						],
						[
							142.23184973900004,
							-21.550855929999955
						],
						[
							142.07200665400012,
							-21.540739950999978
						],
						[
							142.0645196600001,
							-21.608371530999932
						],
						[
							142.06622763400003,
							-21.695135531999938
						],
						[
							142.0487116480001,
							-21.815981551999982
						],
						[
							141.74048464700002,
							-21.79171353499993
						],
						[
							141.738286656,
							-21.80701053499996
						],
						[
							141.58002318100012,
							-21.793180905999975
						],
						[
							141.58316397300007,
							-21.75596382599997
						],
						[
							141.50783787000012,
							-21.75045430199998
						],
						[
							141.48325778000003,
							-21.947160521999933
						],
						[
							141.30967799500002,
							-21.93965745299994
						],
						[
							141.28455062500007,
							-21.988829431999932
						],
						[
							141.29434527900003,
							-22.061871852999957
						],
						[
							141.19864148800002,
							-22.055159277999962
						],
						[
							141.18285789800007,
							-22.249612018999983
						],
						[
							141.25349476700012,
							-22.321351712999956
						],
						[
							141.24578607700005,
							-22.33542031299993
						],
						[
							141.0797272850001,
							-22.465634844999954
						],
						[
							141.19893068600004,
							-22.59754596199997
						],
						[
							141.14563706900003,
							-22.633343089999983
						],
						[
							141.13389699000004,
							-22.621250988999975
						],
						[
							141.0908552840001,
							-22.61821946699996
						],
						[
							141.1027824990001,
							-22.690055487999928
						],
						[
							141.117259267,
							-22.70268182899997
						],
						[
							141.1228718740001,
							-22.749185589999968
						],
						[
							141.11446727300006,
							-22.774491188999946
						],
						[
							141.12226454000006,
							-22.80448033999994
						],
						[
							140.99908164600004,
							-22.89840150499998
						],
						[
							140.98506564800005,
							-22.896255503999953
						],
						[
							140.98916364600007,
							-22.913196483999968
						],
						[
							141.02274167300004,
							-22.92332249599997
						],
						[
							141.04636366900002,
							-22.94763921699996
						],
						[
							140.92457306500012,
							-23.044425031999936
						],
						[
							140.947006471,
							-23.067755662999957
						],
						[
							140.8221972870001,
							-23.16153191799998
						],
						[
							140.82938037600002,
							-23.170178797999938
						],
						[
							140.75962829000002,
							-23.223142924999934
						],
						[
							140.7193698950001,
							-23.188615682999966
						],
						[
							140.66265259300008,
							-23.156644849999964
						],
						[
							140.57265709700005,
							-23.231392325999934
						],
						[
							140.41324200500003,
							-23.346195988999966
						],
						[
							140.34191980800006,
							-23.41825304599996
						],
						[
							140.35557631100005,
							-23.52576187699998
						],
						[
							139.93792674300005,
							-23.48721745699993
						],
						[
							139.93072474000007,
							-23.547789446999957
						],
						[
							139.93917712000007,
							-23.550002277999965
						],
						[
							139.93623649800008,
							-23.577078557999982
						],
						[
							139.86254574300006,
							-23.62966343499994
						],
						[
							139.89261672600003,
							-23.693630446999975
						],
						[
							139.46373567900002,
							-23.67127987699996
						],
						[
							139.4757671760001,
							-23.52076529599998
						],
						[
							139.29542986400008,
							-23.509965317999956
						],
						[
							139.33900403200005,
							-23.473857859999953
						],
						[
							139.17487581600005,
							-23.309955841999965
						],
						[
							139.1227089690001,
							-23.352062469999964
						],
						[
							139.07636138500004,
							-23.306802046999962
						],
						[
							138.89946231500005,
							-23.448319010999967
						],
						[
							138.92111152200005,
							-23.47648075199993
						],
						[
							138.82556631800003,
							-23.545605758999955
						],
						[
							138.6687763430001,
							-23.540069751999965
						],
						[
							138.59206244400002,
							-23.462516837999942
						],
						[
							138.46439669200004,
							-23.55504201399998
						],
						[
							137.99857096900007,
							-23.52090498499996
						],
						[
							137.99887185900002,
							-24.834774874999937
						],
						[
							137.99906130500005,
							-25.996849173999976
						],
						[
							139.39152065200005,
							-25.99661194099997
						],
						[
							140.1145179030001,
							-25.996522984999956
						],
						[
							140.99939597700006,
							-25.996378017999973
						],
						[
							140.99944342900005,
							-26.75569802399997
						],
						[
							140.9995638800001,
							-27.515807029999962
						],
						[
							140.9994210210001,
							-28.269981104999943
						],
						[
							140.9992722830001,
							-28.999086879999936
						],
						[
							141.9999976590001,
							-28.999024593999934
						],
						[
							143.00086103500007,
							-28.998892651999938
						],
						[
							143.94811041900005,
							-28.99916670999994
						],
						[
							144.92550629900006,
							-28.99907927499993
						],
						[
							145.9164726790001,
							-28.999063843999977
						],
						[
							146.94501658500008,
							-28.999119419999943
						],
						[
							147.94549673500012,
							-28.999134897999966
						],
						[
							148.95809518400006,
							-28.999051080999948
						],
						[
							148.97172331500008,
							-28.978277581999976
						],
						[
							148.99713130200007,
							-28.972739083999954
						],
						[
							149.0116263120001,
							-28.955466084999955
						],
						[
							149.03188481000007,
							-28.95658558699995
						],
						[
							149.04562981100003,
							-28.934567087999937
						],
						[
							149.04499431200009,
							-28.92054358799993
						],
						[
							149.0584318120001,
							-28.910959588999958
						],
						[
							149.05766881400007,
							-28.89362258899996
						],
						[
							149.06403781300003,
							-28.889100588999952
						],
						[
							149.05502681500002,
							-28.884371588999954
						],
						[
							149.08004481500006,
							-28.858159589999957
						],
						[
							149.0805353170001,
							-28.84198558999998
						],
						[
							149.09678681600008,
							-28.83154959199993
						],
						[
							149.10323031400003,
							-28.83857659199998
						],
						[
							149.11191531400004,
							-28.830008592999945
						],
						[
							149.12787981200006,
							-28.83552209399994
						],
						[
							149.14352531100008,
							-28.82232709599998
						],
						[
							149.13957381300008,
							-28.806721094999943
						],
						[
							149.16002431100003,
							-28.81084059699998
						],
						[
							149.179199809,
							-28.80301759799994
						],
						[
							149.19238081000003,
							-28.78072859899993
						],
						[
							149.188625311,
							-28.775100598999984
						],
						[
							149.2246253080001,
							-28.76464360199998
						],
						[
							149.24535330800006,
							-28.738946603999977
						],
						[
							149.2535823070001,
							-28.742227103999937
						],
						[
							149.26209380700004,
							-28.734111604999953
						],
						[
							149.26932530500005,
							-28.74324910599995
						],
						[
							149.2718908060001,
							-28.73322260599997
						],
						[
							149.28572330400004,
							-28.731866606999972
						],
						[
							149.29675630600002,
							-28.70973510799996
						],
						[
							149.31842580300008,
							-28.71388510999998
						],
						[
							149.33062730300003,
							-28.697334110999975
						],
						[
							149.34660680100012,
							-28.696815111999967
						],
						[
							149.358581801,
							-28.684053112999948
						],
						[
							149.38749779700004,
							-28.696159114999944
						],
						[
							149.39382729800002,
							-28.67747661599998
						],
						[
							149.40538629700006,
							-28.675392116999944
						],
						[
							149.417066298,
							-28.65465061799995
						],
						[
							149.42335629700005,
							-28.655110117999982
						],
						[
							149.41682179800011,
							-28.651319117999947
						],
						[
							149.42853229700006,
							-28.64691211899998
						],
						[
							149.42818979900005,
							-28.629405617999964
						],
						[
							149.44310679800003,
							-28.620196119999946
						],
						[
							149.43903880000005,
							-28.61164661899994
						],
						[
							149.45181879900008,
							-28.604200119999973
						],
						[
							149.45249080000008,
							-28.59484261999995
						],
						[
							149.47535929800006,
							-28.59376162199993
						],
						[
							149.48121529800005,
							-28.582709122999972
						],
						[
							149.50285779600006,
							-28.580711624999935
						],
						[
							149.50365679700008,
							-28.574273124999934
						],
						[
							149.5137642940001,
							-28.581922624999947
						],
						[
							149.52945229400007,
							-28.574387626999965
						],
						[
							149.55285929000001,
							-28.58090012899993
						],
						[
							149.56837178900003,
							-28.571578629999976
						],
						[
							149.58724778700002,
							-28.573364131999938
						],
						[
							149.59833428500008,
							-28.57983563299996
						],
						[
							149.5977452840001,
							-28.588874632999932
						],
						[
							149.60597878300007,
							-28.587735633999955
						],
						[
							149.61096928100005,
							-28.60107713399998
						],
						[
							149.62545078000005,
							-28.59354263499995
						],
						[
							149.64209427800006,
							-28.599186136999947
						],
						[
							149.64756677600008,
							-28.612282636999964
						],
						[
							149.65632977400003,
							-28.615914637999936
						],
						[
							149.66179827400003,
							-28.61042163899998
						],
						[
							149.6732027710001,
							-28.623910139999964
						],
						[
							149.6667362710001,
							-28.63211863899994
						],
						[
							149.67845876900003,
							-28.635021139999935
						],
						[
							149.68947176900008,
							-28.628378140999928
						],
						[
							149.69112676800012,
							-28.634307140999965
						],
						[
							149.70397126700004,
							-28.63390014199996
						],
						[
							149.71021526700008,
							-28.62036464299996
						],
						[
							149.7040352690001,
							-28.61665714199995
						],
						[
							149.72119376700005,
							-28.609412143999975
						],
						[
							149.744995764,
							-28.618709645999957
						],
						[
							149.7546897630001,
							-28.609843146999935
						],
						[
							149.75988826200012,
							-28.61547064699994
						],
						[
							149.77258976100006,
							-28.61450464799998
						],
						[
							149.7724857610001,
							-28.609240647999968
						],
						[
							149.78376376000006,
							-28.61441464899997
						],
						[
							149.8116757570001,
							-28.606055151999954
						],
						[
							149.81938225500005,
							-28.61681465199996
						],
						[
							149.83141225500003,
							-28.60379665299996
						],
						[
							149.84494475300005,
							-28.61057665499993
						],
						[
							149.8621327520001,
							-28.602402155999982
						],
						[
							149.8679652510001,
							-28.607486156999983
						],
						[
							149.87412475000008,
							-28.603503156999977
						],
						[
							149.87748874900012,
							-28.611974656999962
						],
						[
							149.89050574700002,
							-28.612678158999984
						],
						[
							149.8895532470001,
							-28.61891565899998
						],
						[
							149.8996512450001,
							-28.62218865899996
						],
						[
							149.91733774500005,
							-28.608130160999963
						],
						[
							149.93606524200004,
							-28.610376162999955
						],
						[
							149.94209924100005,
							-28.61837466299994
						],
						[
							149.95092074100012,
							-28.608315663999974
						],
						[
							149.97725573700006,
							-28.613551665999978
						],
						[
							150.01536873700002,
							-28.580534168999975
						],
						[
							150.04569223300007,
							-28.582286171999954
						],
						[
							150.0488382320001,
							-28.589431671999932
						],
						[
							150.05810523200012,
							-28.57897017299996
						],
						[
							150.07263573000012,
							-28.57662867399995
						],
						[
							150.0800492290001,
							-28.58426717499998
						],
						[
							150.08089622900002,
							-28.57744567499998
						],
						[
							150.09277022800006,
							-28.578414675999966
						],
						[
							150.09221623000008,
							-28.564046175999977
						],
						[
							150.11115022700005,
							-28.570331177999947
						],
						[
							150.12158472700003,
							-28.55963067899995
						],
						[
							150.1384712240001,
							-28.565437179999947
						],
						[
							150.152537724,
							-28.550182680999967
						],
						[
							150.15426522300004,
							-28.55739318199994
						],
						[
							150.1686582220001,
							-28.55058218299996
						],
						[
							150.17049372100007,
							-28.563498682999978
						],
						[
							150.18257872000004,
							-28.55645868399995
						],
						[
							150.17731672000002,
							-28.563368683999954
						],
						[
							150.1858497190001,
							-28.565095183999972
						],
						[
							150.181085219,
							-28.569131183999957
						],
						[
							150.18638821800005,
							-28.573003683999957
						],
						[
							150.19182321800008,
							-28.566648184999963
						],
						[
							150.21259271400004,
							-28.57428568699993
						],
						[
							150.21373421500004,
							-28.56722168699997
						],
						[
							150.22845921300006,
							-28.56774768799994
						],
						[
							150.22994421500005,
							-28.55572168799995
						],
						[
							150.23858271300003,
							-28.559962688999974
						],
						[
							150.23562721400003,
							-28.553912688999958
						],
						[
							150.29136571000004,
							-28.537286193999932
						],
						[
							150.32016270400004,
							-28.556942695999965
						],
						[
							150.32787870200002,
							-28.571096196999974
						],
						[
							150.3505811980001,
							-28.575043198999936
						],
						[
							150.35153269700004,
							-28.586731698999984
						],
						[
							150.36823469400008,
							-28.598262700999953
						],
						[
							150.363311693,
							-28.60736770099993
						],
						[
							150.37015169100005,
							-28.621123200999932
						],
						[
							150.38670068800002,
							-28.626021202999937
						],
						[
							150.3875236870001,
							-28.63379420299998
						],
						[
							150.401611687,
							-28.62716370399994
						],
						[
							150.41531668400012,
							-28.63460820499995
						],
						[
							150.41438618200004,
							-28.65198470599995
						],
						[
							150.4246331810001,
							-28.650613205999946
						],
						[
							150.45893167500003,
							-28.668947209999942
						],
						[
							150.48383809300003,
							-28.66224669199994
						],
						[
							150.48632867300012,
							-28.657346211999936
						],
						[
							150.51385066900002,
							-28.662294214999974
						],
						[
							150.530699668,
							-28.655309715999977
						],
						[
							150.5392921670001,
							-28.660035216999972
						],
						[
							150.52747216700004,
							-28.669317715999966
						],
						[
							150.5510296640001,
							-28.671586717999958
						],
						[
							150.5526946660001,
							-28.653626217999943
						],
						[
							150.56089616400004,
							-28.66229121899994
						],
						[
							150.58063116300002,
							-28.655820220999942
						],
						[
							150.60045815800004,
							-28.671314722999966
						],
						[
							150.625400656,
							-28.669033724999963
						],
						[
							150.63223565400006,
							-28.677077224999948
						],
						[
							150.64152615400008,
							-28.66534572599994
						],
						[
							150.67342715200004,
							-28.650449228999946
						],
						[
							150.68137765000006,
							-28.661661229999936
						],
						[
							150.7095576480001,
							-28.652144231999955
						],
						[
							150.72729064800012,
							-28.635550733999935
						],
						[
							150.75126514500005,
							-28.634237235999933
						],
						[
							150.79633963800006,
							-28.656115239999963
						],
						[
							150.8186031350001,
							-28.657540241999982
						],
						[
							150.81878063400006,
							-28.666680741999983
						],
						[
							150.84905412900002,
							-28.67370574499995
						],
						[
							150.87407062400007,
							-28.694380747999958
						],
						[
							150.9074426210001,
							-28.688511750999965
						],
						[
							150.93062061600006,
							-28.705095752999966
						],
						[
							150.93842661200006,
							-28.731234253999958
						],
						[
							151.0099291030001,
							-28.74093426099995
						],
						[
							151.0282310980001,
							-28.76196226199994
						],
						[
							151.02853959700008,
							-28.770519262999983
						],
						[
							151.01859359800005,
							-28.773097761999963
						],
						[
							151.024093095,
							-28.79347076199997
						],
						[
							151.04270959200005,
							-28.80158376399993
						],
						[
							151.03657609000004,
							-28.82568026399997
						],
						[
							151.04440858700002,
							-28.843878764999943
						],
						[
							151.053696585,
							-28.84980476499993
						],
						[
							151.0826695830001,
							-28.83450176799994
						],
						[
							151.103334581,
							-28.83657126999998
						],
						[
							151.10449758000004,
							-28.844055769999954
						],
						[
							151.1251555760001,
							-28.85054327199998
						],
						[
							151.13190407500008,
							-28.860049772999957
						],
						[
							151.1610715700001,
							-28.865367275999972
						],
						[
							151.1729910670001,
							-28.880289276999974
						],
						[
							151.1995955640001,
							-28.88424177899998
						],
						[
							151.21497206000004,
							-28.90428628099994
						],
						[
							151.23464755700002,
							-28.904790282999954
						],
						[
							151.24232405400005,
							-28.923360283999955
						],
						[
							151.274172549,
							-28.937899286999937
						],
						[
							151.28153354500012,
							-28.958478786999933
						],
						[
							151.27194504500005,
							-28.97271978699996
						],
						[
							151.28209304200004,
							-28.98094728799998
						],
						[
							151.27639754200004,
							-28.98705028699993
						],
						[
							151.28410853900004,
							-29.006808787999944
						],
						[
							151.2716820380001,
							-29.03037878699996
						],
						[
							151.2865160350001,
							-29.036728788999937
						],
						[
							151.29055103300004,
							-29.051082788999963
						],
						[
							151.27513753200003,
							-29.076411287999974
						],
						[
							151.28047352800002,
							-29.102144287999977
						],
						[
							151.29035252500012,
							-29.113873789999957
						],
						[
							151.30107902400005,
							-29.11399979099997
						],
						[
							151.31801451900003,
							-29.13804429199996
						],
						[
							151.30931651900005,
							-29.146574791999967
						],
						[
							151.315602516,
							-29.166079791999948
						],
						[
							151.33843351200005,
							-29.179253294999967
						],
						[
							151.35847551000006,
							-29.172266295999975
						],
						[
							151.3941220050001,
							-29.17801529999997
						],
						[
							151.4098995070001,
							-29.15392030099997
						],
						[
							151.4527500050001,
							-29.126238804999957
						],
						[
							151.46294750700008,
							-29.098300305999942
						],
						[
							151.48534650600004,
							-29.089322307999964
						],
						[
							151.49343450700007,
							-29.07175830799997
						],
						[
							151.50278150600002,
							-29.069853808999937
						],
						[
							151.49009750900007,
							-29.05656180799997
						],
						[
							151.49780451200002,
							-29.020866807999937
						],
						[
							151.53729451300012,
							-28.979790811999976
						],
						[
							151.54483451500005,
							-28.953273311999965
						],
						[
							151.56671151400008,
							-28.941823813999974
						],
						[
							151.57894601200007,
							-28.94410681499994
						],
						[
							151.5884750130001,
							-28.93204931599996
						],
						[
							151.60978751100004,
							-28.92344481799995
						],
						[
							151.63519050800005,
							-28.92956482099993
						],
						[
							151.6441970080001,
							-28.917346820999967
						],
						[
							151.6660185070001,
							-28.905599822999932
						],
						[
							151.67477750600005,
							-28.90773582399993
						],
						[
							151.70637350700008,
							-28.87170582699997
						],
						[
							151.71649800500006,
							-28.874939327999982
						],
						[
							151.72642200500002,
							-28.866942328999983
						],
						[
							151.7338680030001,
							-28.87144232999998
						],
						[
							151.74244499700012,
							-28.91849033099993
						],
						[
							151.77334499100004,
							-28.938063333999935
						],
						[
							151.77063598900008,
							-28.955752333999953
						],
						[
							151.77690348800002,
							-28.95898833399997
						],
						[
							151.80690598600006,
							-28.945284836999974
						],
						[
							151.81332098300004,
							-28.959798837999983
						],
						[
							151.8306654810001,
							-28.961734338999975
						],
						[
							151.83990848200006,
							-28.942765839999936
						],
						[
							151.83822948600005,
							-28.916349839999953
						],
						[
							151.84978098600004,
							-28.90761084099995
						],
						[
							151.90033947900008,
							-28.91465184599997
						],
						[
							151.91369647700003,
							-28.92010734699994
						],
						[
							151.91632197500007,
							-28.929328846999965
						],
						[
							151.96849697100004,
							-28.916669851999984
						],
						[
							151.99631647,
							-28.894776854999975
						],
						[
							152.0016219680001,
							-28.908478354999943
						],
						[
							152.0107024670001,
							-28.906671855999946
						],
						[
							152.03754946900006,
							-28.864342358999977
						],
						[
							152.03756797100004,
							-28.85162785899996
						],
						[
							152.02598947100012,
							-28.858226356999978
						],
						[
							152.01492097400012,
							-28.85021885599997
						],
						[
							152.0169304750001,
							-28.83791885599993
						],
						[
							152.0333859740001,
							-28.828057357999967
						],
						[
							152.0366084750001,
							-28.81777885799994
						],
						[
							152.03209947900007,
							-28.79088085799998
						],
						[
							152.04049297900008,
							-28.782176857999957
						],
						[
							152.0360784830001,
							-28.757258357999945
						],
						[
							152.04770398300002,
							-28.740418358999932
						],
						[
							152.04229648500007,
							-28.73181535799995
						],
						[
							152.0760409840001,
							-28.708331860999976
						],
						[
							152.06608098700008,
							-28.69757335999998
						],
						[
							152.0664514890001,
							-28.681177859999934
						],
						[
							152.0525489900001,
							-28.682216358999938
						],
						[
							152.03906149400007,
							-28.66456435699996
						],
						[
							152.01050049700007,
							-28.66497385399998
						],
						[
							151.99099250400002,
							-28.624572351999973
						],
						[
							151.98594351000008,
							-28.582117850999964
						],
						[
							151.95733851600005,
							-28.564733848999936
						],
						[
							151.9553575210001,
							-28.51917784799997
						],
						[
							151.98263152000004,
							-28.50331535099997
						],
						[
							151.98880001700002,
							-28.52560385099997
						],
						[
							152.01671351400012,
							-28.52522035399994
						],
						[
							152.0455590140001,
							-28.495205856999974
						],
						[
							152.06712451300007,
							-28.48513935899996
						],
						[
							152.0696880150001,
							-28.468521858999964
						],
						[
							152.12124501000005,
							-28.462636363999934
						],
						[
							152.16008150900007,
							-28.43325136699997
						],
						[
							152.18427200500003,
							-28.439031369999952
						],
						[
							152.19022500500012,
							-28.43402686999997
						],
						[
							152.21724050000012,
							-28.449100872999963
						],
						[
							152.2666825020001,
							-28.390729376999957
						],
						[
							152.2886145000001,
							-28.391490378999947
						],
						[
							152.30937300100004,
							-28.362826880999933
						],
						[
							152.34185899700003,
							-28.367956883999966
						],
						[
							152.35663749600008,
							-28.36117388599996
						],
						[
							152.38797699100007,
							-28.36745088899994
						],
						[
							152.41636749200006,
							-28.334989890999964
						],
						[
							152.4105764950001,
							-28.320394890999978
						],
						[
							152.4151789970001,
							-28.29806039099998
						],
						[
							152.44295099400006,
							-28.29841489399996
						],
						[
							152.46187749700005,
							-28.260315894999962
						],
						[
							152.48764139500008,
							-28.253481767999972
						],
						[
							152.49264250500005,
							-28.242512777999934
						],
						[
							152.4823585580001,
							-28.22949371699997
						],
						[
							152.47411700800012,
							-28.234025395999936
						],
						[
							152.45859611100002,
							-28.22658651499995
						],
						[
							152.473166772,
							-28.205287775999977
						],
						[
							152.47086369400006,
							-28.194950695999978
						],
						[
							152.4476211870001,
							-28.18931545299995
						],
						[
							152.43405035600006,
							-28.13099675199993
						],
						[
							152.41172531000007,
							-28.11386622899994
						],
						[
							152.41631581500008,
							-28.06974133899996
						],
						[
							152.38996282000005,
							-28.05928360699994
						],
						[
							152.3903173430001,
							-28.030852395999943
						],
						[
							152.37487664700006,
							-28.01247728499993
						],
						[
							152.38776604100008,
							-27.971860395999954
						],
						[
							152.38228203200003,
							-27.96561937499996
						],
						[
							152.3430640570001,
							-27.961003380999955
						],
						[
							152.31478105000008,
							-27.965315378999946
						],
						[
							152.29352736300007,
							-27.955970845999957
						],
						[
							152.2698907240001,
							-27.969015153999976
						],
						[
							152.25143475800007,
							-27.95477280199998
						],
						[
							152.216309173,
							-27.945946698999933
						],
						[
							152.210202255,
							-27.931849537999938
						],
						[
							152.18846037900005,
							-27.92416335599995
						],
						[
							152.17565709200005,
							-27.90447536499994
						],
						[
							152.17590109500009,
							-27.88739436399993
						],
						[
							152.15122724900004,
							-27.876621391999947
						],
						[
							152.14827790100003,
							-27.862841641999978
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "321",
				"CED_NAME21": "Maranoa",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 729961.6808,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/321",
				"SHAPE_Leng": 60.0574624411,
				"SHAPE_Area": 65.7420740643
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							153.29684115700002,
							-28.23426928799995
						],
						[
							153.304766405,
							-28.239682478999953
						],
						[
							153.3297714030001,
							-28.236861481999938
						],
						[
							153.33910990000004,
							-28.25053348299997
						],
						[
							153.36472889800007,
							-28.247341484999936
						],
						[
							153.3897293970001,
							-28.234818987999972
						],
						[
							153.4057193980001,
							-28.211009988999933
						],
						[
							153.43576239800007,
							-28.187159991999977
						],
						[
							153.4570553960001,
							-28.180504993999932
						],
						[
							153.4769523970001,
							-28.15687949599993
						],
						[
							153.5346548880001,
							-28.177630001999944
						],
						[
							153.55217713800005,
							-28.164395983999952
						],
						[
							153.52950834000012,
							-28.167218401999946
						],
						[
							153.51432357200008,
							-28.161006499999928
						],
						[
							153.48698789000002,
							-28.124594506999983
						],
						[
							153.47553587200002,
							-28.12259987599998
						],
						[
							153.4475868510001,
							-28.076048071999935
						],
						[
							153.41989889500007,
							-28.069421489999968
						],
						[
							153.40315194100003,
							-28.03215249799996
						],
						[
							153.38440590300002,
							-28.032847475999972
						],
						[
							153.35570862400004,
							-28.049487472999942
						],
						[
							153.35061767100012,
							-28.08012604299995
						],
						[
							153.3382658920001,
							-28.084654520999948
						],
						[
							153.35545190900007,
							-28.087335492999955
						],
						[
							153.35970208000003,
							-28.082332513999972
						],
						[
							153.36615005800002,
							-28.09030444399997
						],
						[
							153.37020192500006,
							-28.10647348499998
						],
						[
							153.36059789400008,
							-28.125714483999957
						],
						[
							153.3479038150001,
							-28.13144147299994
						],
						[
							153.3629603920001,
							-28.13813490399997
						],
						[
							153.36059523100005,
							-28.14544293399996
						],
						[
							153.353096412,
							-28.14428718299996
						],
						[
							153.34777756000005,
							-28.168584452999937
						],
						[
							153.31966395000006,
							-28.187653499999954
						],
						[
							153.31729107800004,
							-28.207002129999978
						],
						[
							153.30130422800005,
							-28.222729238999932
						],
						[
							153.29647994900006,
							-28.21913251799998
						],
						[
							153.29684115700002,
							-28.23426928799995
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "322",
				"CED_NAME21": "McPherson",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 231.0089,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/322",
				"SHAPE_Leng": 0.96179385596,
				"SHAPE_Area": 0.0212211615244
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							153.4475868510001,
							-28.076048071999935
						],
						[
							153.43107969300002,
							-27.99889245999998
						],
						[
							153.4336519310001,
							-27.935130989999948
						],
						[
							153.4212874110001,
							-27.94088858899994
						],
						[
							153.4272035460001,
							-27.97216751999997
						],
						[
							153.4245856550001,
							-27.983179518999975
						],
						[
							153.41845402600006,
							-27.983028218999948
						],
						[
							153.42175822500008,
							-27.99176123899997
						],
						[
							153.42811600400012,
							-27.988813449999952
						],
						[
							153.42601590300012,
							-27.998591499999975
						],
						[
							153.41859885500003,
							-27.991025518999948
						],
						[
							153.41497593400004,
							-27.99895048899998
						],
						[
							153.42140942700007,
							-27.97404698899993
						],
						[
							153.4112736200001,
							-27.955136267999933
						],
						[
							153.3837429340001,
							-27.95389649499998
						],
						[
							153.37647392300005,
							-27.964654483999936
						],
						[
							153.34524393700008,
							-27.960637480999935
						],
						[
							153.34408192500007,
							-27.976880480999966
						],
						[
							153.33674852500008,
							-27.985061849999965
						],
						[
							153.3164920170001,
							-27.984493527999973
						],
						[
							153.2859809370001,
							-28.009956475999957
						],
						[
							153.32440371200005,
							-28.013601328999982
						],
						[
							153.3239563310001,
							-28.022215908999954
						],
						[
							153.3511657580001,
							-28.026674451999952
						],
						[
							153.35570862400004,
							-28.049487472999942
						],
						[
							153.38440590300002,
							-28.032847475999972
						],
						[
							153.40315194100003,
							-28.03215249799996
						],
						[
							153.41989889500007,
							-28.069421489999968
						],
						[
							153.4475868510001,
							-28.076048071999935
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "323",
				"CED_NAME21": "Moncrieff",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 100.3511,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/323",
				"SHAPE_Leng": 0.79909116871,
				"SHAPE_Area": 0.00920665772419
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							153.0557804440001,
							-27.52561408799994
						],
						[
							153.04059998700006,
							-27.51267946699994
						],
						[
							153.03956284900005,
							-27.501732496999978
						],
						[
							153.02282205100005,
							-27.50023543499998
						],
						[
							153.0016750420001,
							-27.50899744299994
						],
						[
							153.00022304100003,
							-27.514537452999946
						],
						[
							153.01167236000003,
							-27.518579183999975
						],
						[
							153.00669408900012,
							-27.523913453999967
						],
						[
							152.99517407100006,
							-27.52469234199998
						],
						[
							152.97139034500003,
							-27.506371549999983
						],
						[
							152.9751280800001,
							-27.542814290999956
						],
						[
							152.96541905100003,
							-27.54461742999996
						],
						[
							152.96322195900007,
							-27.560025398999983
						],
						[
							152.97744809800008,
							-27.557190400999957
						],
						[
							152.97983909700008,
							-27.566389250999976
						],
						[
							152.98986502600007,
							-27.564262431999964
						],
						[
							152.98925401400004,
							-27.58311845199995
						],
						[
							152.99821502100008,
							-27.594101442999943
						],
						[
							152.99437401000012,
							-27.609694442999967
						],
						[
							153.02528403600002,
							-27.612861435999946
						],
						[
							153.032571006,
							-27.60447402699998
						],
						[
							153.02916500800006,
							-27.597495455999933
						],
						[
							153.05113610400008,
							-27.61122748899993
						],
						[
							153.10107601700008,
							-27.61807846399995
						],
						[
							153.1058417900001,
							-27.59317156399993
						],
						[
							153.11115308900003,
							-27.593932174999964
						],
						[
							153.0622791610001,
							-27.544910438999977
						],
						[
							153.0557804440001,
							-27.52561408799994
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "324",
				"CED_NAME21": "Moreton",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 108.7014,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/324",
				"SHAPE_Leng": 0.600401832976,
				"SHAPE_Area": 0.00993320451056
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							152.96541905100003,
							-27.54461742999996
						],
						[
							152.95180378500004,
							-27.52992663799995
						],
						[
							152.92899113700003,
							-27.528892775999964
						],
						[
							152.9258062560001,
							-27.541770775999964
						],
						[
							152.9044786180001,
							-27.544797932999984
						],
						[
							152.90709164600003,
							-27.55607690399995
						],
						[
							152.8952540470001,
							-27.56069844299998
						],
						[
							152.90241081500005,
							-27.566544902999965
						],
						[
							152.8947610340001,
							-27.580012902999954
						],
						[
							152.90662901000007,
							-27.60144278399997
						],
						[
							152.89609003100009,
							-27.601968442999976
						],
						[
							152.88892603400006,
							-27.59025744199994
						],
						[
							152.87271602700002,
							-27.579241430999957
						],
						[
							152.86081804600008,
							-27.597952419999956
						],
						[
							152.8526350310001,
							-27.64359842899995
						],
						[
							152.87163502800001,
							-27.64662642099995
						],
						[
							152.86721144600006,
							-27.672535100999937
						],
						[
							152.88246202400012,
							-27.671430431999966
						],
						[
							152.8890471750001,
							-27.66043245299994
						],
						[
							152.91474699900004,
							-27.685495445999948
						],
						[
							152.92776103800009,
							-27.685255446999975
						],
						[
							152.93156211000007,
							-27.66613341699997
						],
						[
							152.9247247510001,
							-27.65771876599996
						],
						[
							152.94166301300004,
							-27.626475437999943
						],
						[
							152.98928101500007,
							-27.65146144299996
						],
						[
							153.01935259100003,
							-27.65738102599994
						],
						[
							153.01489999400007,
							-27.642182444999946
						],
						[
							153.02528403600002,
							-27.612861435999946
						],
						[
							152.99437401000012,
							-27.609694442999967
						],
						[
							152.99821502100008,
							-27.594101442999943
						],
						[
							152.98925401400004,
							-27.58311845199995
						],
						[
							152.98986502600007,
							-27.564262431999964
						],
						[
							152.97983909700008,
							-27.566389250999976
						],
						[
							152.97744809800008,
							-27.557190400999957
						],
						[
							152.96322195900007,
							-27.560025398999983
						],
						[
							152.96541905100003,
							-27.54461742999996
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "325",
				"CED_NAME21": "Oxley",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 156.9771,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/325",
				"SHAPE_Leng": 0.794702640209,
				"SHAPE_Area": 0.0143504775225
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							153.06621706400006,
							-27.281263447999947
						],
						[
							153.0786260440001,
							-27.26449245899994
						],
						[
							153.05397808100008,
							-27.230033445999936
						],
						[
							153.07572115900007,
							-27.22797247799997
						],
						[
							153.06841696800007,
							-27.247122487999945
						],
						[
							153.077533925,
							-27.262628398999937
						],
						[
							153.09315304400002,
							-27.25595844999998
						],
						[
							153.1038185220001,
							-27.26344329099993
						],
						[
							153.11953105700002,
							-27.212390451999966
						],
						[
							153.11269891000006,
							-27.190421361999938
						],
						[
							153.08933307100006,
							-27.206192448999957
						],
						[
							153.0374871670001,
							-27.196631863999983
						],
						[
							153.02949808000005,
							-27.178948452999975
						],
						[
							153.0414980820001,
							-27.153774443999964
						],
						[
							153.02662970400002,
							-27.156138632999955
						],
						[
							153.0285187940001,
							-27.151620672999968
						],
						[
							153.01537306600005,
							-27.14785744099993
						],
						[
							152.97767619900003,
							-27.15207850799993
						],
						[
							152.9910140510001,
							-27.209919448999983
						],
						[
							153.01809306300004,
							-27.248670432999972
						],
						[
							153.01924302700002,
							-27.291208452999967
						],
						[
							153.01490204800007,
							-27.288021431999937
						],
						[
							153.00862605800012,
							-27.297893441999975
						],
						[
							153.01402506700003,
							-27.302201442999944
						],
						[
							152.99726506800005,
							-27.302059440999983
						],
						[
							153.00196005500004,
							-27.321421440999927
						],
						[
							152.97889903500004,
							-27.346868428999983
						],
						[
							153.0002308710001,
							-27.358001031999947
						],
						[
							153.0264434170001,
							-27.36524552399993
						],
						[
							153.02723305900008,
							-27.353492433999975
						],
						[
							153.05118329900006,
							-27.32957014599998
						],
						[
							153.04219787300008,
							-27.303856534999966
						],
						[
							153.04958606600007,
							-27.27865544599996
						],
						[
							153.06621706400006,
							-27.281263447999947
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "326",
				"CED_NAME21": "Petrie",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 149.9755,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/326",
				"SHAPE_Leng": 1.00834687492,
				"SHAPE_Area": 0.0136663962655
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							153.016602099,
							-27.678919015999952
						],
						[
							153.09930659700012,
							-27.700154383999973
						],
						[
							153.12155385800008,
							-27.677121435999936
						],
						[
							153.12165671900004,
							-27.66864503599993
						],
						[
							153.160901985,
							-27.66673746999993
						],
						[
							153.16412300600007,
							-27.65519945999995
						],
						[
							153.157244987,
							-27.649414459999946
						],
						[
							153.17384700700006,
							-27.634239460999936
						],
						[
							153.18356786900006,
							-27.61281248199998
						],
						[
							153.17576801100006,
							-27.60669446099996
						],
						[
							153.15574900500008,
							-27.59169345899994
						],
						[
							153.12332002900007,
							-27.587298465999936
						],
						[
							153.12201000800007,
							-27.595432485999936
						],
						[
							153.11115308900003,
							-27.593932174999964
						],
						[
							153.1058417900001,
							-27.59317156399993
						],
						[
							153.10107601700008,
							-27.61807846399995
						],
						[
							153.05113610400008,
							-27.61122748899993
						],
						[
							153.02916500800006,
							-27.597495455999933
						],
						[
							153.032571006,
							-27.60447402699998
						],
						[
							153.02528403600002,
							-27.612861435999946
						],
						[
							153.01489999400007,
							-27.642182444999946
						],
						[
							153.01935259100003,
							-27.65738102599994
						],
						[
							153.016602099,
							-27.678919015999952
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "327",
				"CED_NAME21": "Rankin",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 131.0405,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/327",
				"SHAPE_Leng": 0.561869558916,
				"SHAPE_Area": 0.0119827788986
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							152.88892603400006,
							-27.59025744199994
						],
						[
							152.89604802200006,
							-27.601320442999963
						],
						[
							152.9059940200001,
							-27.60124644399997
						],
						[
							152.89397603500004,
							-27.579286422999928
						],
						[
							152.9018740450001,
							-27.56675543299997
						],
						[
							152.89446002700004,
							-27.560703432999958
						],
						[
							152.90630102600005,
							-27.556028433999984
						],
						[
							152.90415204800001,
							-27.544482432999928
						],
						[
							152.92574201600007,
							-27.54090344599996
						],
						[
							152.92971606700007,
							-27.527582465999956
						],
						[
							152.95002685500003,
							-27.527255397999966
						],
						[
							152.96968301100003,
							-27.543657449999955
						],
						[
							152.9706131160001,
							-27.50454444999997
						],
						[
							152.99695402100008,
							-27.521654362999982
						],
						[
							153.00893581000003,
							-27.520544293999933
						],
						[
							152.9978749610001,
							-27.51493135299995
						],
						[
							152.9997288620001,
							-27.508101352999972
						],
						[
							153.02062106100004,
							-27.50055043499998
						],
						[
							153.01510587200005,
							-27.49248147399993
						],
						[
							152.9946318650001,
							-27.489857451999967
						],
						[
							153.00326403600002,
							-27.475517432999936
						],
						[
							152.974584283,
							-27.442885729999944
						],
						[
							152.97616805400003,
							-27.43688443999997
						],
						[
							152.98801015200002,
							-27.43861746099998
						],
						[
							152.99241205500005,
							-27.41257344099995
						],
						[
							152.97700503800002,
							-27.400769439999976
						],
						[
							152.9654810400001,
							-27.396860447999984
						],
						[
							152.9488150300001,
							-27.408724436999933
						],
						[
							152.92686408400004,
							-27.39345342499996
						],
						[
							152.91695207500004,
							-27.394170433999932
						],
						[
							152.91504574400005,
							-27.40570790299995
						],
						[
							152.8993170660001,
							-27.40355944199996
						],
						[
							152.89723484500007,
							-27.417267441999968
						],
						[
							152.87215007800012,
							-27.413052688999983
						],
						[
							152.86115404800012,
							-27.42236242799993
						],
						[
							152.8311630620001,
							-27.416937424999958
						],
						[
							152.80210906700006,
							-27.398703421999983
						],
						[
							152.7986584670001,
							-27.405093171999965
						],
						[
							152.77546925000001,
							-27.40164356899993
						],
						[
							152.77290809300007,
							-27.379041408999967
						],
						[
							152.76001209600008,
							-27.36388041799995
						],
						[
							152.77207505700005,
							-27.34371841899997
						],
						[
							152.75570612100012,
							-27.328213456999947
						],
						[
							152.7488509110001,
							-27.332287985999983
						],
						[
							152.74850909300005,
							-27.318742415999964
						],
						[
							152.71955681500003,
							-27.32344894299996
						],
						[
							152.69083763600008,
							-27.34356379099995
						],
						[
							152.67969921300005,
							-27.37225202999997
						],
						[
							152.68640718300003,
							-27.37320485999993
						],
						[
							152.69225831400001,
							-27.36000231099996
						],
						[
							152.70782400300004,
							-27.35179216199998
						],
						[
							152.72390396100002,
							-27.353961063999975
						],
						[
							152.72201625000002,
							-27.36507289399998
						],
						[
							152.73324061800008,
							-27.366620394999927
						],
						[
							152.73295201500002,
							-27.39597710499993
						],
						[
							152.7420850840001,
							-27.39169742599995
						],
						[
							152.74812703100008,
							-27.415523856999982
						],
						[
							152.74095390000002,
							-27.42739772599998
						],
						[
							152.7474084480001,
							-27.440852236999945
						],
						[
							152.74412531600012,
							-27.460120656999948
						],
						[
							152.73787782600004,
							-27.460976245999973
						],
						[
							152.74429207200012,
							-27.491949426999952
						],
						[
							152.7545210500001,
							-27.49513042799998
						],
						[
							152.7699750390001,
							-27.488087419999943
						],
						[
							152.7992280750001,
							-27.497408432999976
						],
						[
							152.81241205600008,
							-27.47810442399998
						],
						[
							152.84277125000006,
							-27.496502566999936
						],
						[
							152.8411846680001,
							-27.515684936999946
						],
						[
							152.85291803300004,
							-27.54486342799993
						],
						[
							152.8489870510001,
							-27.564643427999954
						],
						[
							152.86081804600008,
							-27.597952419999956
						],
						[
							152.87271602700002,
							-27.579241430999957
						],
						[
							152.88892603400006,
							-27.59025744199994
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "328",
				"CED_NAME21": "Ryan",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 367.836,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/328",
				"SHAPE_Leng": 1.58774717909,
				"SHAPE_Area": 0.0335817412553
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								153.09556509800007,
								-26.498559443999966
							],
							[
								153.1199531310001,
								-26.379236485999968
							],
							[
								153.1077210320001,
								-26.37689549499993
							],
							[
								153.09120215300004,
								-26.386170452999977
							],
							[
								153.0711803370001,
								-26.367593450999948
							],
							[
								153.06129932300007,
								-26.330486089999965
							],
							[
								153.06639469000004,
								-26.27175221999994
							],
							[
								153.11319526600005,
								-26.10349744299998
							],
							[
								153.15216311400002,
								-26.006313465999938
							],
							[
								153.19223109900008,
								-25.932386468999937
							],
							[
								153.1822681000001,
								-25.928326497999933
							],
							[
								153.17652215900011,
								-25.94583039799994
							],
							[
								153.16198534000011,
								-25.94978841699998
							],
							[
								153.1198991660001,
								-25.93355846199995
							],
							[
								153.0859123150001,
								-25.888735487999952
							],
							[
								153.07225537600004,
								-25.811762445999932
							],
							[
								153.04552320900007,
								-25.808245403999933
							],
							[
								153.07081321500004,
								-25.81955841599995
							],
							[
								153.07140827400008,
								-25.826089455999977
							],
							[
								153.0542812760001,
								-25.827026444999944
							],
							[
								153.04645811400007,
								-25.849365433999935
							],
							[
								153.0473293020001,
								-25.86186939399994
							],
							[
								153.06109712900002,
								-25.871065415999965
							],
							[
								153.06613033700012,
								-25.885584395999956
							],
							[
								153.05734127800008,
								-25.88748447599994
							],
							[
								153.05299212600005,
								-25.90618242499994
							],
							[
								153.05828808400008,
								-25.914434425999957
							],
							[
								153.05027736600005,
								-25.908865404999972
							],
							[
								153.0514063070001,
								-25.89814641499993
							],
							[
								153.03730832700012,
								-25.91227839399994
							],
							[
								153.02975410800002,
								-25.91131845299998
							],
							[
								153.03473325800007,
								-25.90503448299995
							],
							[
								153.0246471790001,
								-25.90774843199995
							],
							[
								153.02765929600002,
								-25.922303402999944
							],
							[
								153.056782203,
								-25.92954147599994
							],
							[
								153.04619209300006,
								-25.931717404999972
							],
							[
								153.049089352,
								-25.944110404999947
							],
							[
								153.04071103400008,
								-25.93595847399996
							],
							[
								153.03225610300012,
								-25.946132432999946
							],
							[
								153.04230010100002,
								-25.951047424999956
							],
							[
								153.03909536000003,
								-25.969599393999943
							],
							[
								153.03005614200003,
								-25.955808412999943
							],
							[
								153.02398834200005,
								-25.95903339299997
							],
							[
								153.03117033900003,
								-25.978035443999943
							],
							[
								153.01478640100004,
								-25.97685942199996
							],
							[
								153.0266771890001,
								-25.98796047299993
							],
							[
								153.01870207900004,
								-25.986740431999976
							],
							[
								153.0165071880001,
								-25.99729842199997
							],
							[
								153.017725089,
								-25.99048948199993
							],
							[
								153.0112050900001,
								-25.989993401999982
							],
							[
								153.01628505000008,
								-25.982733441999983
							],
							[
								153.005562961,
								-25.981319300999928
							],
							[
								153.007308103,
								-25.96810538099993
							],
							[
								152.99914516400008,
								-25.96901080999993
							],
							[
								153.00878014400007,
								-25.95597843099995
							],
							[
								153.00336540400008,
								-25.961133450999966
							],
							[
								153.003336245,
								-25.952366450999932
							],
							[
								152.9980481660001,
								-25.954095439999946
							],
							[
								153.031304255,
								-25.933987482999953
							],
							[
								153.01788634600007,
								-25.93101046199996
							],
							[
								153.0118102660001,
								-25.93944039099995
							],
							[
								153.00344136700005,
								-25.93496343099997
							],
							[
								153.01565937700002,
								-25.930910471999937
							],
							[
								153.0067138490001,
								-25.917674010999974
							],
							[
								153.01642442000002,
								-25.903830441999958
							],
							[
								153.00095411100006,
								-25.90660442999996
							],
							[
								153.01982136100003,
								-25.89130948199994
							],
							[
								153.01945812000008,
								-25.897102421999932
							],
							[
								153.02643633000002,
								-25.89622041299998
							],
							[
								153.03184717200008,
								-25.877717402999963
							],
							[
								153.02189712400002,
								-25.86626445199994
							],
							[
								153.00926042300011,
								-25.88543445099998
							],
							[
								153.01036126400004,
								-25.87735147099994
							],
							[
								152.99359524500005,
								-25.881092428999978
							],
							[
								153.01659323500007,
								-25.865524440999934
							],
							[
								153.01502223600005,
								-25.85377644099998
							],
							[
								153.0258992350001,
								-25.852125421999972
							],
							[
								153.02050724900005,
								-25.829541440999947
							],
							[
								152.98717325500002,
								-25.803409427999952
							],
							[
								152.98331225300012,
								-25.824526437999964
							],
							[
								152.9783072250001,
								-25.80947043699996
							],
							[
								152.94427024800007,
								-25.810482413999978
							],
							[
								152.9492032270001,
								-25.818415423999966
							],
							[
								152.94111624800007,
								-25.819743422999977
							],
							[
								152.93961924100006,
								-25.795908432999965
							],
							[
								152.9649692580001,
								-25.800848435999967
							],
							[
								152.97612428000002,
								-25.772338435999927
							],
							[
								152.9732962610001,
								-25.762287415999936
							],
							[
								152.95667627400007,
								-25.757450423999956
							],
							[
								152.93623923500002,
								-25.75977543199997
							],
							[
								152.941924254,
								-25.76534141299993
							],
							[
								152.93687524400002,
								-25.768077412999958
							],
							[
								152.93631125700006,
								-25.743579421999982
							],
							[
								152.9121983000001,
								-25.73844742999995
							],
							[
								152.91680325100003,
								-25.733537419999948
							],
							[
								152.90720627200005,
								-25.728010428999937
							],
							[
								152.92025042400007,
								-25.70632740999997
							],
							[
								152.87825327000007,
								-25.683666425999945
							],
							[
								152.8836672110001,
								-25.67366484599995
							],
							[
								152.91148783800008,
								-25.674786668999957
							],
							[
								152.89645484200003,
								-25.65806179799995
							],
							[
								152.90116772300007,
								-25.646849777999932
							],
							[
								152.89211655700012,
								-25.617959906999943
							],
							[
								152.87494127000002,
								-25.609392424999953
							],
							[
								152.87792617500008,
								-25.56129018499996
							],
							[
								152.8619193180001,
								-25.553424332999953
							],
							[
								152.87529919600001,
								-25.55637421499995
							],
							[
								152.9025786750001,
								-25.541578066999932
							],
							[
								152.897270627,
								-25.53384210699994
							],
							[
								152.9099563860001,
								-25.52943003799993
							],
							[
								152.9032142200001,
								-25.500961206999932
							],
							[
								152.89578439000002,
								-25.50478624599998
							],
							[
								152.89660126100011,
								-25.498866265999936
							],
							[
								152.92637854200007,
								-25.469678148999947
							],
							[
								152.94658319100006,
								-25.461235030999944
							],
							[
								152.9417052220001,
								-25.451843099999962
							],
							[
								152.94835709200004,
								-25.45183203099998
							],
							[
								152.94523506300004,
								-25.446615090999956
							],
							[
								152.95259397200005,
								-25.44592204099996
							],
							[
								152.95635077300005,
								-25.433636041999932
							],
							[
								152.93423710600007,
								-25.431851199999983
							],
							[
								152.92798735400004,
								-25.447923198999945
							],
							[
								152.88525509700003,
								-25.46192246499993
							],
							[
								152.8485459860001,
								-25.498298580999972
							],
							[
								152.82374229900006,
								-25.493990768999936
							],
							[
								152.80267257200012,
								-25.487646926999957
							],
							[
								152.7835982910001,
								-25.505315404999976
							],
							[
								152.76474330300005,
								-25.508597392999945
							],
							[
								152.75118129500004,
								-25.49849440199995
							],
							[
								152.73729432100004,
								-25.466412399999967
							],
							[
								152.71612330100004,
								-25.476366397999982
							],
							[
								152.71526833200005,
								-25.470543387999953
							],
							[
								152.69679531300005,
								-25.477364395999928
							],
							[
								152.68945129500003,
								-25.47155539499994
							],
							[
								152.68492022400005,
								-25.479312774999983
							],
							[
								152.67314934700005,
								-25.46797336399993
							],
							[
								152.64999231900003,
								-25.467301391999968
							],
							[
								152.64044432100002,
								-25.46023938099995
							],
							[
								152.62688530100002,
								-25.473518388999935
							],
							[
								152.61998633100006,
								-25.471352388999946
							],
							[
								152.6150163110001,
								-25.479558397999938
							],
							[
								152.60769733200004,
								-25.47371538699997
							],
							[
								152.60318231200006,
								-25.481178386999943
							],
							[
								152.56435431700004,
								-25.472832382999968
							],
							[
								152.5590983190001,
								-25.462139382999965
							],
							[
								152.54365633100008,
								-25.45651738099997
							],
							[
								152.54173632000004,
								-25.462476280999965
							],
							[
								152.50308133500005,
								-25.454135366999935
							],
							[
								152.49249731500004,
								-25.46474038599996
							],
							[
								152.465221347,
								-25.467503372999943
							],
							[
								152.45058334700002,
								-25.48084836199996
							],
							[
								152.42197334000002,
								-25.475876378999942
							],
							[
								152.40970434000008,
								-25.486070377999965
							],
							[
								152.40096635400005,
								-25.464656366999975
							],
							[
								152.41608133800003,
								-25.412793377999947
							],
							[
								152.4035653410001,
								-25.403394376999984
							],
							[
								152.3962813610001,
								-25.409516375999942
							],
							[
								152.39026835200002,
								-25.40134137499996
							],
							[
								152.36446636400012,
								-25.406291352999972
							],
							[
								152.32396636900012,
								-25.40162235899993
							],
							[
								152.31999636800003,
								-25.407483368999976
							],
							[
								152.29908538000007,
								-25.408131366999953
							],
							[
								152.27361338000003,
								-25.43129336399994
							],
							[
								152.26038215800008,
								-25.46190175299995
							],
							[
								152.2620858360001,
								-25.47654694399995
							],
							[
								152.27637364300006,
								-25.490568434999943
							],
							[
								152.27083258400012,
								-25.489836624999953
							],
							[
								152.26976616000002,
								-25.521891684999957
							],
							[
								152.21494334600004,
								-25.512905348999936
							],
							[
								152.21576437500005,
								-25.520173348999947
							],
							[
								152.1794363690001,
								-25.523091345999944
							],
							[
								152.16362803700008,
								-25.55315205499994
							],
							[
								152.1644245340001,
								-25.57457105499998
							],
							[
								152.11125881600003,
								-25.598417239999947
							],
							[
								152.1152963730001,
								-25.62346034099994
							],
							[
								152.09066734400005,
								-25.636315337999974
							],
							[
								152.06610671800001,
								-25.621273075999966
							],
							[
								152.05264952900006,
								-25.62422969399995
							],
							[
								152.044138061,
								-25.615113703999953
							],
							[
								152.0380597090001,
								-25.64274623299997
							],
							[
								152.02956601900007,
								-25.64222867199993
							],
							[
								152.011171589,
								-25.66499294099998
							],
							[
								152.0175283860001,
								-25.681013331999964
							],
							[
								152.0139353630001,
								-25.708871330999955
							],
							[
								152.00517536300003,
								-25.717532330999973
							],
							[
								151.99700334500005,
								-25.71121131999996
							],
							[
								151.98124734600003,
								-25.71273932799994
							],
							[
								151.98027852400003,
								-25.73294496799997
							],
							[
								151.9953058320001,
								-25.73683159999996
							],
							[
								151.9989093700001,
								-25.74770069999994
							],
							[
								151.99771336800006,
								-25.770926329999952
							],
							[
								151.98633237800004,
								-25.77887432899996
							],
							[
								151.98621294500003,
								-25.80127209899996
							],
							[
								151.9789148440001,
								-25.813687348999963
							],
							[
								151.9720982450001,
								-25.81262887799994
							],
							[
								151.970376363,
								-25.83058432799993
							],
							[
								151.95950804400002,
								-25.83315691699994
							],
							[
								151.92860835300007,
								-25.867596333999927
							],
							[
								151.91288933400006,
								-25.872461332999933
							],
							[
								151.8972983660001,
								-25.866460320999977
							],
							[
								151.87381237500006,
								-25.81341231899995
							],
							[
								151.86109135700008,
								-25.809881317999952
							],
							[
								151.86105635800004,
								-25.802027306999946
							],
							[
								151.85321735800005,
								-25.806555316999948
							],
							[
								151.8316044710001,
								-25.796464024999977
							],
							[
								151.8265113430001,
								-25.782792953999945
							],
							[
								151.81317354400005,
								-25.784958312999947
							],
							[
								151.8104041470001,
								-25.76244158199995
							],
							[
								151.8003743490001,
								-25.75696230099993
							],
							[
								151.79043438000008,
								-25.758663299999967
							],
							[
								151.78983738800002,
								-25.77169730999998
							],
							[
								151.775924389,
								-25.77675729899994
							],
							[
								151.7799023770001,
								-25.789349309999977
							],
							[
								151.76740236900002,
								-25.788143307999974
							],
							[
								151.7567973680001,
								-25.802983307999966
							],
							[
								151.7746303550001,
								-25.814448308999943
							],
							[
								151.7647773540001,
								-25.826690317999976
							],
							[
								151.77284539100003,
								-25.85217130899997
							],
							[
								151.76744138100003,
								-25.856970298999954
							],
							[
								151.78076934500007,
								-25.896660320999956
							],
							[
								151.77657338300003,
								-25.911900319999972
							],
							[
								151.78545934200008,
								-25.915361320999978
							],
							[
								151.76180336200002,
								-25.937289308999937
							],
							[
								151.7527663630001,
								-25.937286317999963
							],
							[
								151.75597935100006,
								-25.94573030899994
							],
							[
								151.74873421200004,
								-25.94922534799997
							],
							[
								151.7566354700001,
								-25.954249318999928
							],
							[
								151.74813732000007,
								-25.962288307999984
							],
							[
								151.744539475,
								-26.006167347999963
							],
							[
								151.75118327400003,
								-26.010748348999982
							],
							[
								151.74207740400004,
								-26.020437297999933
							],
							[
								151.75257250100003,
								-26.03469230899998
							],
							[
								151.7228544930001,
								-26.046623325999974
							],
							[
								151.72510019100002,
								-26.06223131699994
							],
							[
								151.73466935900012,
								-26.06715233799997
							],
							[
								151.72514950000004,
								-26.07185934699993
							],
							[
								151.73044725800003,
								-26.08070228699995
							],
							[
								151.71875842800011,
								-26.090791285999956
							],
							[
								151.7342182860001,
								-26.097618317999945
							],
							[
								151.72614346600005,
								-26.102344306999953
							],
							[
								151.7233001840001,
								-26.11886534699994
							],
							[
								151.74391133200004,
								-26.121606308999958
							],
							[
								151.74618534900003,
								-26.145163338999964
							],
							[
								151.75938619800002,
								-26.13876929999998
							],
							[
								151.78662742200004,
								-26.17130628299998
							],
							[
								151.7982424500001,
								-26.17517330399994
							],
							[
								151.8161683290001,
								-26.167449645999966
							],
							[
								151.82860737400006,
								-26.202723307999975
							],
							[
								151.84776943200006,
								-26.203541318999953
							],
							[
								151.84877432200005,
								-26.197182318999978
							],
							[
								151.86935645100004,
								-26.193617290999953
							],
							[
								151.87922947900006,
								-26.197996341999954
							],
							[
								151.87155713900006,
								-26.209178291999933
							],
							[
								151.89437142300005,
								-26.23751335399993
							],
							[
								151.89331734100006,
								-26.25822137399996
							],
							[
								151.9079452190001,
								-26.260303345999944
							],
							[
								151.91776806600012,
								-26.274687186999984
							],
							[
								151.9149427760001,
								-26.28088973699994
							],
							[
								151.9028533280001,
								-26.276865314999952
							],
							[
								151.8981323060001,
								-26.293269324999983
							],
							[
								151.88645346600003,
								-26.30138812399997
							],
							[
								151.96736589700004,
								-26.311684751999962
							],
							[
								151.96921775600003,
								-26.31868929199993
							],
							[
								151.9778857760001,
								-26.31292393299998
							],
							[
								151.98195829400004,
								-26.319126342999937
							],
							[
								151.9851642750001,
								-26.31073533299997
							],
							[
								151.99246227300011,
								-26.31988234399995
							],
							[
								151.983050272,
								-26.337261332999958
							],
							[
								152.00224229100002,
								-26.332530334999944
							],
							[
								151.9983362800001,
								-26.339719334999984
							],
							[
								152.00880925900003,
								-26.33961533599995
							],
							[
								152.00320826900008,
								-26.34914732599998
							],
							[
								152.0134706770001,
								-26.353874986999983
							],
							[
								152.00103388700006,
								-26.362580154999932
							],
							[
								152.0040848850001,
								-26.375480205999963
							],
							[
								152.0118040850001,
								-26.375261026999965
							],
							[
								152.06884127800004,
								-26.38312234199998
							],
							[
								152.07272725000007,
								-26.359182301999965
							],
							[
								152.09644512600005,
								-26.373530374999973
							],
							[
								152.12108715300008,
								-26.377267356999937
							],
							[
								152.12188128100001,
								-26.393520346999935
							],
							[
								152.1412692780001,
								-26.406678348999947
							],
							[
								152.1487372480001,
								-26.40134434999993
							],
							[
								152.16719628400006,
								-26.41668335199995
							],
							[
								152.17378325100003,
								-26.43807836299993
							],
							[
								152.16765825700008,
								-26.475406351999936
							],
							[
								152.21361323700012,
								-26.513088056999948
							],
							[
								152.22134423800003,
								-26.503846067999973
							],
							[
								152.23124605600003,
								-26.50740235899997
							],
							[
								152.22921476800002,
								-26.492735048999975
							],
							[
								152.25314080700002,
								-26.484561540999948
							],
							[
								152.2780912180001,
								-26.452748372999963
							],
							[
								152.30459521400007,
								-26.46605137599994
							],
							[
								152.3159982210001,
								-26.480860366999934
							],
							[
								152.36440951800012,
								-26.463128120999954
							],
							[
								152.39007094400006,
								-26.476098583999942
							],
							[
								152.4120732130001,
								-26.464477385999942
							],
							[
								152.44277219000003,
								-26.46021836899996
							],
							[
								152.43861440700005,
								-26.486233828999957
							],
							[
								152.44761022700004,
								-26.48414338999993
							],
							[
								152.4361414120001,
								-26.537575628999946
							],
							[
								152.44342991200006,
								-26.527997639999967
							],
							[
								152.44962192100002,
								-26.530901599999936
							],
							[
								152.44022780900002,
								-26.556912599999976
							],
							[
								152.45086298700005,
								-26.55840744099993
							],
							[
								152.4569773940001,
								-26.580878521999978
							],
							[
								152.51982301700002,
								-26.588295717999983
							],
							[
								152.51149609000004,
								-26.56737637699996
							],
							[
								152.55399518500008,
								-26.57256339099996
							],
							[
								152.56248968300008,
								-26.583209461999957
							],
							[
								152.57520139100006,
								-26.58399448299997
							],
							[
								152.587946901,
								-26.579734103999954
							],
							[
								152.59441389900007,
								-26.58471552499998
							],
							[
								152.60271318900004,
								-26.57792504599996
							],
							[
								152.6063236980001,
								-26.584284055999944
							],
							[
								152.62563518700006,
								-26.58196838799995
							],
							[
								152.6602661710001,
								-26.597094441999957
							],
							[
								152.68049318900012,
								-26.597696353999936
							],
							[
								152.68127418100005,
								-26.582496383999967
							],
							[
								152.7084431410001,
								-26.55988840599997
							],
							[
								152.71225509200008,
								-26.546220795999943
							],
							[
								152.72845426100002,
								-26.53696465799993
							],
							[
								152.75378616700004,
								-26.549843410999983
							],
							[
								152.75850017800008,
								-26.536374380999973
							],
							[
								152.7675790070001,
								-26.536878371999933
							],
							[
								152.76825509800005,
								-26.52815340199993
							],
							[
								152.7596967600001,
								-26.52500287099997
							],
							[
								152.7620854710001,
								-26.510636270999953
							],
							[
								152.74331502400003,
								-26.50718538899997
							],
							[
								152.76555720400006,
								-26.48249440099994
							],
							[
								152.76538821500003,
								-26.475767410999936
							],
							[
								152.7564701660001,
								-26.473723399999983
							],
							[
								152.76547238700005,
								-26.463598210999976
							],
							[
								152.7680121960001,
								-26.470252450999965
							],
							[
								152.80430320200003,
								-26.471495414999936
							],
							[
								152.81333748800012,
								-26.497309445999974
							],
							[
								152.82697173600002,
								-26.499392086999933
							],
							[
								152.8350728360001,
								-26.488159777999954
							],
							[
								152.86934075500005,
								-26.47419339099997
							],
							[
								152.8708537860001,
								-26.46545778199993
							],
							[
								152.8819311740001,
								-26.469266412999957
							],
							[
								152.89241006500004,
								-26.454987563999964
							],
							[
								152.91296186300008,
								-26.447457485999962
							],
							[
								152.92016707200003,
								-26.452687435999962
							],
							[
								152.9218450830001,
								-26.443035135999935
							],
							[
								152.9450229910001,
								-26.444587438999974
							],
							[
								152.9462616510001,
								-26.437163278999947
							],
							[
								152.9649904590001,
								-26.44027607099997
							],
							[
								152.96638724000002,
								-26.432031450999943
							],
							[
								152.99552522700003,
								-26.43216547399993
							],
							[
								153.0307984520001,
								-26.443091486999947
							],
							[
								153.03859718900003,
								-26.463113437999937
							],
							[
								153.05810716500002,
								-26.47812043999994
							],
							[
								153.08298402200012,
								-26.482561112999974
							],
							[
								153.08062514000005,
								-26.495555432999936
							],
							[
								153.09556509800007,
								-26.498559443999966
							]
						]
					],
					[
						[
							[
								152.87973117500007,
								-25.56316515499998
							],
							[
								152.87402633500005,
								-25.57008717499997
							],
							[
								152.88346822300002,
								-25.575347095999973
							],
							[
								152.87973117500007,
								-25.56316515499998
							]
						]
					],
					[
						[
							[
								152.87141112000006,
								-25.445664602999955
							],
							[
								152.8726761690001,
								-25.45097958399998
							],
							[
								152.88099400900012,
								-25.447225523999975
							],
							[
								152.87141112000006,
								-25.445664602999955
							]
						]
					],
					[
						[
							[
								152.885154015,
								-25.555309155999964
							],
							[
								152.8944159240001,
								-25.558022066999968
							],
							[
								152.89785677500004,
								-25.550308066999946
							],
							[
								152.885154015,
								-25.555309155999964
							]
						]
					],
					[
						[
							[
								152.88929212300002,
								-25.569390075999934
							],
							[
								152.90381394200006,
								-25.571669937999957
							],
							[
								152.89852388300005,
								-25.560067036999953
							],
							[
								152.88929212300002,
								-25.569390075999934
							]
						]
					],
					[
						[
							[
								152.888121242,
								-25.58187102599993
							],
							[
								152.8914013100001,
								-25.594437966999976
							],
							[
								152.89995424900007,
								-25.597377896999944
							],
							[
								152.8989790810001,
								-25.57842595699998
							],
							[
								152.888121242,
								-25.58187102599993
							]
						]
					],
					[
						[
							[
								152.90852959400002,
								-25.54849498799996
							],
							[
								152.90209081400008,
								-25.556654006999963
							],
							[
								152.90669280200007,
								-25.56373995799993
							],
							[
								152.90852959400002,
								-25.54849498799996
							]
						]
					],
					[
						[
							[
								152.9412172000001,
								-25.555526380999936
							],
							[
								152.94557920900002,
								-25.56033770199997
							],
							[
								152.9496242900001,
								-25.548346461999984
							],
							[
								152.9412172000001,
								-25.555526380999936
							]
						]
					],
					[
						[
							[
								152.91445730600003,
								-25.526038007999944
							],
							[
								152.92135723500007,
								-25.52951696899993
							],
							[
								152.94508675400004,
								-25.51405885099996
							],
							[
								152.95585538600005,
								-25.495222841999976
							],
							[
								152.9513553480001,
								-25.48173294199995
							],
							[
								152.93158461000007,
								-25.482465049999973
							],
							[
								152.90927212000008,
								-25.49984115799998
							],
							[
								152.91445730600003,
								-25.526038007999944
							]
						]
					],
					[
						[
							[
								152.9612062860001,
								-25.49143182299997
							],
							[
								152.9699670560001,
								-25.481500782999944
							],
							[
								152.96569104700006,
								-25.473569832999942
							],
							[
								152.9612062860001,
								-25.49143182299997
							]
						]
					],
					[
						[
							[
								152.95587955400003,
								-25.506528801999934
							],
							[
								152.95288363400005,
								-25.51328480199993
							],
							[
								152.9663173140001,
								-25.500756742999954
							],
							[
								152.95587955400003,
								-25.506528801999934
							]
						]
					],
					[
						[
							[
								152.94619543600004,
								-25.581569611999953
							],
							[
								152.94854311900008,
								-25.55685768199993
							],
							[
								152.9379693290001,
								-25.562772740999947
							],
							[
								152.93963649700004,
								-25.58066267099997
							],
							[
								152.9453743670001,
								-25.576774631999967
							],
							[
								152.94619543600004,
								-25.581569611999953
							]
						]
					],
					[
						[
							[
								152.9254337970001,
								-25.58984872999997
							],
							[
								152.92104771000004,
								-25.574206808999975
							],
							[
								152.92419192600005,
								-25.598058699999967
							],
							[
								152.9254337970001,
								-25.58984872999997
							]
						]
					],
					[
						[
							[
								152.93693480500008,
								-25.602075620999983
							],
							[
								152.93118568700004,
								-25.58629370999995
							],
							[
								152.9289308660001,
								-25.59896367999994
							],
							[
								152.93799381300005,
								-25.611278590999973
							],
							[
								152.93693480500008,
								-25.602075620999983
							]
						]
					],
					[
						[
							[
								152.95322223300002,
								-25.60529188299995
							],
							[
								152.9555055610001,
								-25.61305648299998
							],
							[
								152.96062446100007,
								-25.61084044399996
							],
							[
								152.95957042300006,
								-25.600296482999966
							],
							[
								152.95322223300002,
								-25.60529188299995
							]
						]
					],
					[
						[
							[
								152.95507981900005,
								-25.63289745299994
							],
							[
								152.9582017780001,
								-25.637494413999946
							],
							[
								152.9606315410001,
								-25.616066453999963
							],
							[
								152.95281766100004,
								-25.616176492999955
							],
							[
								152.95507981900005,
								-25.63289745299994
							]
						]
					],
					[
						[
							[
								152.9810452360001,
								-25.800570436999976
							],
							[
								152.97683525600007,
								-25.80336443699997
							],
							[
								152.9874122650001,
								-25.801737427999967
							],
							[
								152.9810452360001,
								-25.800570436999976
							]
						]
					],
					[
						[
							[
								153.26260092300004,
								-24.86008985799998
							],
							[
								153.26690747200007,
								-24.704347456999983
							],
							[
								153.2646283030001,
								-24.697076436999964
							],
							[
								153.25293337400012,
								-24.696983475999957
							],
							[
								153.182187246,
								-24.738653458999977
							],
							[
								153.1189301920001,
								-24.81504547299994
							],
							[
								153.14414424000006,
								-24.816740445999983
							],
							[
								153.1691112960001,
								-24.832021447999978
							],
							[
								153.22622926100007,
								-24.91199843499993
							],
							[
								153.23401028600006,
								-24.942452445999947
							],
							[
								153.2222642910001,
								-24.995643514999983
							],
							[
								153.16029191600012,
								-25.083589718999974
							],
							[
								153.07684762600002,
								-25.152838041999928
							],
							[
								153.02953953700012,
								-25.17629029699998
							],
							[
								152.99230745500006,
								-25.220692373999952
							],
							[
								152.99535951400003,
								-25.23031031399995
							],
							[
								153.03867975100002,
								-25.22314906799994
							],
							[
								153.05154070700007,
								-25.244646899999964
							],
							[
								153.04575684700012,
								-25.247592908999934
							],
							[
								153.05135889500002,
								-25.26265886999994
							],
							[
								153.03999714400004,
								-25.27668689899997
							],
							[
								153.05142860500007,
								-25.345307660999936
							],
							[
								153.03413815200008,
								-25.384762658999932
							],
							[
								153.00795082100012,
								-25.411248756999953
							],
							[
								152.98680848800007,
								-25.448283774999936
							],
							[
								152.98383774600006,
								-25.468550724999943
							],
							[
								152.993440243,
								-25.484523425999953
							],
							[
								152.98870626000007,
								-25.51209447599996
							],
							[
								152.9510102590001,
								-25.55192243199997
							],
							[
								152.9595361470001,
								-25.560814422999954
							],
							[
								152.94993026800012,
								-25.561243461999936
							],
							[
								152.95021937700005,
								-25.57556839199998
							],
							[
								152.9587232560001,
								-25.573698382999964
							],
							[
								152.9519023570001,
								-25.57123544199993
							],
							[
								152.9425113860001,
								-25.58584640199996
							],
							[
								152.95268210400002,
								-25.59440944299996
							],
							[
								152.95243120500004,
								-25.58450639299997
							],
							[
								152.9561193840001,
								-25.58912140299998
							],
							[
								152.9642403050001,
								-25.57666739399997
							],
							[
								152.95528816400008,
								-25.59551239299998
							],
							[
								152.96423632200003,
								-25.600059383999962
							],
							[
								152.96235135100005,
								-25.613856383999973
							],
							[
								152.9746813380001,
								-25.62466745499995
							],
							[
								152.96990524700004,
								-25.64020344499994
							],
							[
								152.983052433,
								-25.660234465999963
							],
							[
								152.98033515200007,
								-25.670673385999976
							],
							[
								152.987176201,
								-25.67197946699997
							],
							[
								152.98246240100002,
								-25.676556425999934
							],
							[
								152.9956121030001,
								-25.731849447999934
							],
							[
								153.02238926500002,
								-25.77818640099997
							],
							[
								153.04925026000012,
								-25.79616039399997
							],
							[
								153.07688207700005,
								-25.793298386999936
							],
							[
								153.0893143410001,
								-25.758068437999952
							],
							[
								153.0777453920001,
								-25.67323740599994
							],
							[
								153.11545928500004,
								-25.53998643899996
							],
							[
								153.1911022590001,
								-25.364023454999938
							],
							[
								153.36034435600004,
								-25.006550468999933
							],
							[
								153.3523372080001,
								-24.999864457999934
							],
							[
								153.35036048300003,
								-24.962982447999934
							],
							[
								153.32478427500007,
								-24.96375842499998
							],
							[
								153.28833644200006,
								-24.93215644099996
							],
							[
								153.26260092300004,
								-24.86008985799998
							]
						]
					],
					[
						[
							[
								153.04861921500003,
								-25.83535144399997
							],
							[
								153.05014524600006,
								-25.82492141399996
							],
							[
								153.04476430500006,
								-25.842719473999978
							],
							[
								153.04861921500003,
								-25.83535144399997
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "329",
				"CED_NAME21": "Wide Bay",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 14216.512,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/329",
				"SHAPE_Leng": 13.7331477584,
				"SHAPE_Area": 1.28093008928
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							153.35570862400004,
							-28.049487472999942
						],
						[
							153.3511657580001,
							-28.026674451999952
						],
						[
							153.3239563310001,
							-28.022215908999954
						],
						[
							153.32440371200005,
							-28.013601328999982
						],
						[
							153.2859809370001,
							-28.009956475999957
						],
						[
							153.3164920170001,
							-27.984493527999973
						],
						[
							153.33674852500008,
							-27.985061849999965
						],
						[
							153.34408192500007,
							-27.976880480999966
						],
						[
							153.32178593900005,
							-27.96817748899997
						],
						[
							153.32423045000007,
							-27.955056678999938
						],
						[
							153.29925993300003,
							-27.953559465999945
						],
						[
							153.3012009260001,
							-27.927167475999966
						],
						[
							153.30870595600004,
							-27.920908486999963
						],
						[
							153.2933939510001,
							-27.896873464999942
						],
						[
							153.28966693000007,
							-27.906233474999965
						],
						[
							153.2779909510001,
							-27.90515847399996
						],
						[
							153.2783999300001,
							-27.916324483999972
						],
						[
							153.2674579610001,
							-27.91923946299994
						],
						[
							153.2541269630001,
							-27.91228848199995
						],
						[
							153.2484577460001,
							-27.89696287099997
						],
						[
							153.2296059670001,
							-27.900315458999955
						],
						[
							153.22913665800002,
							-27.89299891899998
						],
						[
							153.2193259700001,
							-27.89163446799995
						],
						[
							153.21209761900002,
							-27.900112366999963
						],
						[
							153.1806889730001,
							-27.895066473999975
						],
						[
							153.1889459680001,
							-27.85509146399994
						],
						[
							153.18107795900005,
							-27.85391745399994
						],
						[
							153.17290798200008,
							-27.834403472999952
						],
						[
							153.18328095300012,
							-27.819332463999956
						],
						[
							153.16924798600007,
							-27.80328547199997
						],
						[
							153.1600459770001,
							-27.804805470999952
						],
						[
							153.15856097200003,
							-27.769334450999963
						],
						[
							153.1389058750001,
							-27.76357345899993
						],
						[
							153.13833399600003,
							-27.752616468999975
						],
						[
							153.10651299900007,
							-27.75355145499998
						],
						[
							153.09721396800012,
							-27.771710454999948
						],
						[
							153.0695589820001,
							-27.76287345199995
						],
						[
							153.0646069940001,
							-27.750690460999976
						],
						[
							153.045763974,
							-27.773601448999955
						],
						[
							153.0331610060001,
							-27.761938457999975
						],
						[
							153.0228609940001,
							-27.78817345699997
						],
						[
							153.01209732600012,
							-27.78480593599994
						],
						[
							153.0307259110001,
							-27.725087747999964
						],
						[
							152.98573302700004,
							-27.720195442999966
						],
						[
							153.00295277700002,
							-27.706779094999945
						],
						[
							153.0061061990001,
							-27.68657907499994
						],
						[
							153.016602099,
							-27.678919015999952
						],
						[
							153.01935259100003,
							-27.65738102599994
						],
						[
							152.98928101500007,
							-27.65146144299996
						],
						[
							152.94166301300004,
							-27.626475437999943
						],
						[
							152.9247247510001,
							-27.65771876599996
						],
						[
							152.93156211000007,
							-27.66613341699997
						],
						[
							152.92776103800009,
							-27.685255446999975
						],
						[
							152.92287718500006,
							-27.708110956999974
						],
						[
							152.89065670900004,
							-27.70357751299997
						],
						[
							152.88279456500004,
							-27.747345182999936
						],
						[
							152.87465579600007,
							-27.746273031999976
						],
						[
							152.87333099500006,
							-27.753436431999944
						],
						[
							152.83600302900004,
							-27.755730427999936
						],
						[
							152.8292640400001,
							-27.74677442799998
						],
						[
							152.82226286000002,
							-27.756374796999978
						],
						[
							152.81139703100007,
							-27.754895425999962
						],
						[
							152.80549402700012,
							-27.79381041599993
						],
						[
							152.76072601300007,
							-27.785294420999946
						],
						[
							152.75781207600005,
							-27.767263430999947
						],
						[
							152.70754702200009,
							-27.758331425999984
						],
						[
							152.70436203400004,
							-27.74959141499994
						],
						[
							152.68639403600002,
							-27.746845422999968
						],
						[
							152.6842950260001,
							-27.752465422999933
						],
						[
							152.6675350380001,
							-27.749963411999943
						],
						[
							152.66864003800004,
							-27.743320411999946
						],
						[
							152.65597706000005,
							-27.738293399999975
						],
						[
							152.6076488760001,
							-27.737086475999945
						],
						[
							152.60577032800006,
							-27.724974894999946
						],
						[
							152.57984150100003,
							-27.72358645299994
						],
						[
							152.5806580410001,
							-27.719124402999967
						],
						[
							152.52965206700003,
							-27.716928407999944
						],
						[
							152.5193310720001,
							-27.761159386999964
						],
						[
							152.49900706500011,
							-27.758257404999938
						],
						[
							152.4945034420001,
							-27.78341327499993
						],
						[
							152.46741106500008,
							-27.78312140199995
						],
						[
							152.46233405400005,
							-27.80255239199994
						],
						[
							152.4511840350001,
							-27.80198938099994
						],
						[
							152.44340406000003,
							-27.844758379999973
						],
						[
							152.42847906300005,
							-27.840464388999976
						],
						[
							152.4192862100001,
							-27.86545636799997
						],
						[
							152.402356273,
							-27.863690555999938
						],
						[
							152.39476504700008,
							-27.834140374999947
						],
						[
							152.39949806800007,
							-27.820069385999943
						],
						[
							152.38279235200002,
							-27.807217883999954
						],
						[
							152.40705805900006,
							-27.80549938599995
						],
						[
							152.40876575000004,
							-27.796105675999968
						],
						[
							152.38923705600007,
							-27.76974439399993
						],
						[
							152.39187567700003,
							-27.756837833999953
						],
						[
							152.39537606600004,
							-27.76100338499998
						],
						[
							152.39730453700008,
							-27.751130804999946
						],
						[
							152.4051320760001,
							-27.749104385999942
						],
						[
							152.41350306100003,
							-27.700926395999943
						],
						[
							152.39065205400004,
							-27.697755383999947
						],
						[
							152.39156806500011,
							-27.69081538399996
						],
						[
							152.41745364400003,
							-27.67370486599998
						],
						[
							152.4226490850001,
							-27.66365838699994
						],
						[
							152.4125610760001,
							-27.66142238599997
						],
						[
							152.4208380670001,
							-27.65222538599994
						],
						[
							152.43087308500003,
							-27.65679238699994
						],
						[
							152.43978908500003,
							-27.649934387999963
						],
						[
							152.45785907100003,
							-27.66278338999996
						],
						[
							152.48625610500005,
							-27.60566840299998
						],
						[
							152.50444394500005,
							-27.595905733999928
						],
						[
							152.497019087,
							-27.582939392999947
						],
						[
							152.50779807600009,
							-27.581094393999933
						],
						[
							152.51866409900003,
							-27.552007394999976
						],
						[
							152.49266307100004,
							-27.55156139299993
						],
						[
							152.49934998600008,
							-27.511684512999977
						],
						[
							152.47411209900008,
							-27.507904390999954
						],
						[
							152.47217110200006,
							-27.48672937999993
						],
						[
							152.48031618100003,
							-27.48298940099994
						],
						[
							152.4672330940001,
							-27.46922737999995
						],
						[
							152.43575709900006,
							-27.457879385999945
						],
						[
							152.43556811100007,
							-27.440108375999955
						],
						[
							152.40911010500008,
							-27.436577373999967
						],
						[
							152.41413812500002,
							-27.43018938399996
						],
						[
							152.39950191700007,
							-27.42839404299997
						],
						[
							152.4016090980001,
							-27.41496538299998
						],
						[
							152.37338011300005,
							-27.40196738999998
						],
						[
							152.31542713900012,
							-27.398777243999973
						],
						[
							152.3103520960001,
							-27.42930536399996
						],
						[
							152.2942580880001,
							-27.42734029199994
						],
						[
							152.2913069120001,
							-27.400203361999957
						],
						[
							152.26287053300007,
							-27.416136578999954
						],
						[
							152.2609754560001,
							-27.392614548999973
						],
						[
							152.19172912400006,
							-27.386836351999932
						],
						[
							152.19753521100006,
							-27.409284712999977
						],
						[
							152.17960105300006,
							-27.407234390999974
						],
						[
							152.17728151100005,
							-27.420885560999977
						],
						[
							152.1646651420001,
							-27.425221369999974
						],
						[
							152.16163472000005,
							-27.44666552999996
						],
						[
							152.15630916200007,
							-27.438476358999935
						],
						[
							152.14110442300012,
							-27.441431957999953
						],
						[
							152.13698142600003,
							-27.423625236999953
						],
						[
							152.0996312410001,
							-27.411849872999937
						],
						[
							152.08944215400004,
							-27.396963351999943
						],
						[
							152.083413854,
							-27.40464584199998
						],
						[
							152.069884945,
							-27.403710889999957
						],
						[
							152.05874737700003,
							-27.402075398999955
						],
						[
							152.06039315700002,
							-27.39296510899993
						],
						[
							152.05381136800008,
							-27.39201799899996
						],
						[
							152.0548019460001,
							-27.41257338899993
						],
						[
							152.03850494800008,
							-27.40972791699994
						],
						[
							152.02785121800002,
							-27.41609419599996
						],
						[
							152.025337067,
							-27.428049425999973
						],
						[
							152.01684715900012,
							-27.422102344999928
						],
						[
							152.01600353800006,
							-27.431481364999968
						],
						[
							152.02352552700006,
							-27.432423675999928
						],
						[
							152.01946315500004,
							-27.44869735599997
						],
						[
							152.00625715700005,
							-27.446917334999966
						],
						[
							152.00284915500004,
							-27.462787343999935
						],
						[
							151.9961891470001,
							-27.457031343999972
						],
						[
							151.96392515800005,
							-27.47090234099994
						],
						[
							151.96128613700012,
							-27.486560340999972
						],
						[
							151.96960115500008,
							-27.494766340999945
						],
						[
							151.95665617300006,
							-27.519123329999957
						],
						[
							151.96398552100004,
							-27.529407850999974
						],
						[
							151.97006142200007,
							-27.51800725199996
						],
						[
							151.9984682380001,
							-27.525264483999933
						],
						[
							151.98824414800004,
							-27.535965343999976
						],
						[
							151.99348335600007,
							-27.548655423999946
						],
						[
							152.00471173500011,
							-27.548531754999942
						],
						[
							151.9962009620001,
							-27.580736344999934
						],
						[
							152.00803112100004,
							-27.574959355999965
						],
						[
							152.01676214000008,
							-27.57970534699996
						],
						[
							151.99722073100008,
							-27.585964204999982
						],
						[
							151.98939902900008,
							-27.60804832399998
						],
						[
							151.97424993100003,
							-27.609249142999943
						],
						[
							151.97802044900004,
							-27.621214532999943
						],
						[
							151.94815042200003,
							-27.617558949999932
						],
						[
							151.94208514100012,
							-27.632064329999935
						],
						[
							151.95612212800006,
							-27.649594340999954
						],
						[
							151.9839971350001,
							-27.647167353999976
						],
						[
							151.99223011100003,
							-27.673439344999963
						],
						[
							151.9874010200001,
							-27.682549954999956
						],
						[
							151.9990081190001,
							-27.683940525999958
						],
						[
							152.001507166,
							-27.702550445999975
						],
						[
							152.03405432300008,
							-27.702920578999965
						],
						[
							152.0318339910001,
							-27.716249388999984
						],
						[
							152.0765262650001,
							-27.729169973999944
						],
						[
							152.07497599400006,
							-27.73773246299993
						],
						[
							152.08400160300005,
							-27.73899331399997
						],
						[
							152.07679559200005,
							-27.74876671399994
						],
						[
							152.08435171100007,
							-27.74982926399997
						],
						[
							152.08531659000005,
							-27.759970314999975
						],
						[
							152.09345039900006,
							-27.76110556499998
						],
						[
							152.09645971100008,
							-27.74445660599997
						],
						[
							152.10477029000003,
							-27.745629175999966
						],
						[
							152.1012586180001,
							-27.76519047599993
						],
						[
							152.13154671400002,
							-27.771653328999946
						],
						[
							152.13032250300012,
							-27.778428838999957
						],
						[
							152.13936549200002,
							-27.779693059999943
						],
						[
							152.1304670820001,
							-27.78375935899993
						],
						[
							152.14739018900002,
							-27.79905464099994
						],
						[
							152.14912707700012,
							-27.80684736099994
						],
						[
							152.13794110800006,
							-27.81394236999995
						],
						[
							152.15310437300002,
							-27.836279711999964
						],
						[
							152.14827790100003,
							-27.862841641999978
						],
						[
							152.15122724900004,
							-27.876621391999947
						],
						[
							152.17590109500009,
							-27.88739436399993
						],
						[
							152.17565709200005,
							-27.90447536499994
						],
						[
							152.18846037900005,
							-27.92416335599995
						],
						[
							152.210202255,
							-27.931849537999938
						],
						[
							152.216309173,
							-27.945946698999933
						],
						[
							152.25143475800007,
							-27.95477280199998
						],
						[
							152.2698907240001,
							-27.969015153999976
						],
						[
							152.29352736300007,
							-27.955970845999957
						],
						[
							152.31478105000008,
							-27.965315378999946
						],
						[
							152.3430640570001,
							-27.961003380999955
						],
						[
							152.38228203200003,
							-27.96561937499996
						],
						[
							152.38776604100008,
							-27.971860395999954
						],
						[
							152.37487664700006,
							-28.01247728499993
						],
						[
							152.3903173430001,
							-28.030852395999943
						],
						[
							152.38996282000005,
							-28.05928360699994
						],
						[
							152.41631581500008,
							-28.06974133899996
						],
						[
							152.41172531000007,
							-28.11386622899994
						],
						[
							152.43405035600006,
							-28.13099675199993
						],
						[
							152.4476211870001,
							-28.18931545299995
						],
						[
							152.47086369400006,
							-28.194950695999978
						],
						[
							152.473166772,
							-28.205287775999977
						],
						[
							152.45859611100002,
							-28.22658651499995
						],
						[
							152.47411700800012,
							-28.234025395999936
						],
						[
							152.4823585580001,
							-28.22949371699997
						],
						[
							152.49264250500005,
							-28.242512777999934
						],
						[
							152.48764139500008,
							-28.253481767999972
						],
						[
							152.5093109930001,
							-28.249170899999967
						],
						[
							152.53398098800005,
							-28.26268140199994
						],
						[
							152.52513298400004,
							-28.304191401999958
						],
						[
							152.54701874900002,
							-28.320474133999937
						],
						[
							152.55495197900007,
							-28.318956904999936
						],
						[
							152.55468097800008,
							-28.325523404999956
						],
						[
							152.57230497600005,
							-28.32674140699993
						],
						[
							152.57951147300003,
							-28.339185406999945
						],
						[
							152.59757760500008,
							-28.314538738999943
						],
						[
							152.59962997800005,
							-28.283668408999972
						],
						[
							152.6142479780001,
							-28.269463909999956
						],
						[
							152.62412947400003,
							-28.29828491199993
						],
						[
							152.63975297000002,
							-28.312173412999982
						],
						[
							152.66752246700003,
							-28.311689915999978
						],
						[
							152.67949946300007,
							-28.33057191699993
						],
						[
							152.70764295800006,
							-28.344274419999977
						],
						[
							152.72305895700003,
							-28.34411942199995
						],
						[
							152.75095495100004,
							-28.363866924999968
						],
						[
							152.77739095000004,
							-28.345953926999982
						],
						[
							152.8042649460001,
							-28.353557429999967
						],
						[
							152.83137494800008,
							-28.31965693199993
						],
						[
							152.84021144700012,
							-28.32159893299996
						],
						[
							152.8494299470001,
							-28.311172933999956
						],
						[
							152.88042994400007,
							-28.30979993699998
						],
						[
							152.89992043900008,
							-28.32536493899994
						],
						[
							152.93427143400004,
							-28.337641942999937
						],
						[
							152.97318543000006,
							-28.331809446999955
						],
						[
							152.99609792700005,
							-28.339952448999952
						],
						[
							153.04490742100006,
							-28.338998953999976
						],
						[
							153.08068041500007,
							-28.354394456999955
						],
						[
							153.1085534120001,
							-28.356314959999963
						],
						[
							153.13024591300007,
							-28.33026596199994
						],
						[
							153.12501041500002,
							-28.317751461999933
						],
						[
							153.14328741400004,
							-28.312190962999978
						],
						[
							153.1551514150001,
							-28.296108464999975
						],
						[
							153.1677419130001,
							-28.295463965999943
						],
						[
							153.16120891600008,
							-28.279388464999954
						],
						[
							153.17517741500012,
							-28.27419346599993
						],
						[
							153.17667241800007,
							-28.249590465999972
						],
						[
							153.18817241700003,
							-28.247498966999956
						],
						[
							153.23284391000004,
							-28.265062971999953
						],
						[
							153.24393091100012,
							-28.247286972999973
						],
						[
							153.2779439090001,
							-28.233839475999957
						],
						[
							153.29684115700002,
							-28.23426928799995
						],
						[
							153.29647994900006,
							-28.21913251799998
						],
						[
							153.30130422800005,
							-28.222729238999932
						],
						[
							153.31729107800004,
							-28.207002129999978
						],
						[
							153.31966395000006,
							-28.187653499999954
						],
						[
							153.34777756000005,
							-28.168584452999937
						],
						[
							153.353096412,
							-28.14428718299996
						],
						[
							153.36059523100005,
							-28.14544293399996
						],
						[
							153.3629603920001,
							-28.13813490399997
						],
						[
							153.3479038150001,
							-28.13144147299994
						],
						[
							153.36059789400008,
							-28.125714483999957
						],
						[
							153.37020192500006,
							-28.10647348499998
						],
						[
							153.36615005800002,
							-28.09030444399997
						],
						[
							153.35970208000003,
							-28.082332513999972
						],
						[
							153.35545190900007,
							-28.087335492999955
						],
						[
							153.3382658920001,
							-28.084654520999948
						],
						[
							153.35061767100012,
							-28.08012604299995
						],
						[
							153.35570862400004,
							-28.049487472999942
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "330",
				"CED_NAME21": "Wright",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 7580.5962,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/330",
				"SHAPE_Leng": 7.10669167169,
				"SHAPE_Area": 0.694924759752
			}
		},
		{
			"type": "Feature",
			"geometry": null,
			"properties": {
				"CED_CODE21": "394",
				"CED_NAME21": "No usual address (Qld)",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 0,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/394",
				"SHAPE_Leng": 0,
				"SHAPE_Area": 0
			}
		},
		{
			"type": "Feature",
			"geometry": null,
			"properties": {
				"CED_CODE21": "397",
				"CED_NAME21": "Migratory - Offshore - Shipping (Qld)",
				"STE_CODE21": "3",
				"STE_NAME21": "Queensland",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 0,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/397",
				"SHAPE_Leng": 0,
				"SHAPE_Area": 0
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							138.6264462470001,
							-34.964545199999975
						],
						[
							138.62357140000006,
							-34.927889909999976
						],
						[
							138.6128331330001,
							-34.90949115899997
						],
						[
							138.6138962330001,
							-34.89969285899997
						],
						[
							138.6352022310001,
							-34.88735590999994
						],
						[
							138.62645106200011,
							-34.87933831899994
						],
						[
							138.63817224100012,
							-34.87040056999996
						],
						[
							138.6353472830001,
							-34.84683474999997
						],
						[
							138.56454675400005,
							-34.84974375699994
						],
						[
							138.5467225970001,
							-34.85056909599996
						],
						[
							138.55499881800006,
							-34.96722314699997
						],
						[
							138.5850914250001,
							-34.95197194799994
						],
						[
							138.59729746200003,
							-34.96600665899996
						],
						[
							138.6264462470001,
							-34.964545199999975
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "401",
				"CED_NAME21": "Adelaide",
				"STE_CODE21": "4",
				"STE_NAME21": "South Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 86.4597,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/401",
				"SHAPE_Leng": 0.453969889709,
				"SHAPE_Area": 0.00852714156671
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							138.8475557800001,
							-34.68052441799995
						],
						[
							138.86175325600004,
							-34.70396606799994
						],
						[
							138.88505299200006,
							-34.699859378999975
						],
						[
							138.91052414800004,
							-34.70884044999997
						],
						[
							138.9174680850001,
							-34.73469438099994
						],
						[
							138.9267129540001,
							-34.734904100999984
						],
						[
							138.92685661300004,
							-34.74375415099996
						],
						[
							138.9189146540001,
							-34.74554848099996
						],
						[
							138.92924736200007,
							-34.75269475199997
						],
						[
							138.92413356200007,
							-34.75850334099994
						],
						[
							138.94857216800006,
							-34.765389341999935
						],
						[
							138.95302024700004,
							-34.77567693299994
						],
						[
							138.9898872110001,
							-34.76983345399998
						],
						[
							138.9880806010001,
							-34.78137221399993
						],
						[
							139.00489896700003,
							-34.79417070499994
						],
						[
							139.00245849700002,
							-34.80035998499994
						],
						[
							139.04397253000002,
							-34.81589504699997
						],
						[
							139.0019008150001,
							-34.83237495499998
						],
						[
							139.00948091200007,
							-34.86467050599998
						],
						[
							138.98943215400004,
							-34.878989504999936
						],
						[
							138.9751671570001,
							-34.87756391399995
						],
						[
							138.98076800600006,
							-34.88295939499994
						],
						[
							138.9752155860001,
							-34.894886973999974
						],
						[
							139.03496421400007,
							-34.928673826999955
						],
						[
							139.01937919500006,
							-34.95261138699993
						],
						[
							139.04120320000004,
							-34.97660913799996
						],
						[
							139.03124289000004,
							-35.00183042799995
						],
						[
							139.03738718800003,
							-35.021123417999945
						],
						[
							139.02901616600002,
							-35.06146974799998
						],
						[
							139.04403726100008,
							-35.11159945899993
						],
						[
							139.02741104200004,
							-35.138717447999966
						],
						[
							139.06669426400003,
							-35.16592224999994
						],
						[
							139.06644373000006,
							-35.21485106999995
						],
						[
							139.08607915700009,
							-35.21661532099995
						],
						[
							139.15831925300006,
							-35.25347195499995
						],
						[
							139.14471565100007,
							-35.47169001499998
						],
						[
							139.04673571500007,
							-35.50093574099998
						],
						[
							139.03346621600008,
							-35.513256490999936
						],
						[
							138.98103222500004,
							-35.51824545899996
						],
						[
							138.96595915600005,
							-35.52879349799997
						],
						[
							138.96301714600008,
							-35.54535848799998
						],
						[
							138.93154214000003,
							-35.56242749699993
						],
						[
							138.89940414600005,
							-35.55486748499993
						],
						[
							138.87809614900004,
							-35.55885347399993
						],
						[
							138.98695196800008,
							-35.61038217899994
						],
						[
							139.12368047000007,
							-35.69332201599997
						],
						[
							139.26845615900004,
							-35.79819354299997
						],
						[
							139.37702709500002,
							-35.89222049799997
						],
						[
							139.55940700100007,
							-36.08768952799994
						],
						[
							139.64901710700008,
							-36.21215755299994
						],
						[
							139.70933006000007,
							-36.31244951599996
						],
						[
							139.78752201600003,
							-36.46891551099998
						],
						[
							139.83195106900007,
							-36.58734552399994
						],
						[
							139.8614697370001,
							-36.68873383599998
						],
						[
							139.86252904200012,
							-36.76019313599994
						],
						[
							139.85008099900006,
							-36.82489556599995
						],
						[
							139.81879591100005,
							-36.86851055499994
						],
						[
							139.7797318260001,
							-36.89898544299996
						],
						[
							139.73239698300006,
							-36.91679555099995
						],
						[
							139.6991689570001,
							-36.93923652999996
						],
						[
							139.69605992800007,
							-36.93423451899997
						],
						[
							139.696281117,
							-36.940476528999966
						],
						[
							139.67591587100003,
							-36.94204253899994
						],
						[
							139.67005543000005,
							-36.95820313799993
						],
						[
							139.74054199400007,
							-37.02129051199995
						],
						[
							139.7439378690001,
							-37.07417650299993
						],
						[
							139.7684229040001,
							-37.08156549399996
						],
						[
							139.79105899800004,
							-37.11153549499994
						],
						[
							139.7958250160001,
							-37.137454514999945
						],
						[
							139.78846588500005,
							-37.157785514999944
						],
						[
							139.77652191700008,
							-37.165205524999976
						],
						[
							139.7430677430001,
							-37.155835552999974
						],
						[
							139.73997498200004,
							-37.18194950299994
						],
						[
							139.76163404700003,
							-37.19969356399997
						],
						[
							139.84075587400002,
							-37.32217653899994
						],
						[
							139.86552097900005,
							-37.335598509999954
						],
						[
							139.890447762,
							-37.37586056099997
						],
						[
							139.94673374800004,
							-37.42931649399998
						],
						[
							139.94923067600007,
							-37.441806533999966
						],
						[
							139.9601127840001,
							-37.44334957499996
						],
						[
							139.9965829150001,
							-37.476729596999974
						],
						[
							139.9962927350001,
							-37.488311496999984
						],
						[
							140.01135369200006,
							-37.49311156799996
						],
						[
							140.02505495100002,
							-37.475435577999974
						],
						[
							140.04982979600004,
							-37.47860356899997
						],
						[
							140.11880971000005,
							-37.52863052299995
						],
						[
							140.13131865600008,
							-37.55621057399998
						],
						[
							140.12075924700002,
							-37.56934278299997
						],
						[
							140.1078000990001,
							-37.56515246299995
						],
						[
							140.1127199770001,
							-37.578403582999954
						],
						[
							140.1787158630001,
							-37.617209515999946
						],
						[
							140.24789670500002,
							-37.686099559999946
						],
						[
							140.29329663200008,
							-37.747886552999944
						],
						[
							140.37589468600004,
							-37.89783258799997
						],
						[
							140.3886825630001,
							-37.901487577999944
						],
						[
							140.39617229100008,
							-37.91980862899993
						],
						[
							140.40324019000002,
							-37.91696824899998
						],
						[
							140.4212207050001,
							-37.93100088999995
						],
						[
							140.45402185900002,
							-37.93583257199998
						],
						[
							140.4911705600001,
							-37.96085652399995
						],
						[
							140.51701281400005,
							-37.98994661499995
						],
						[
							140.56729761300005,
							-38.008582557999944
						],
						[
							140.57939180900007,
							-38.02968753899995
						],
						[
							140.59311193700012,
							-38.02458187899998
						],
						[
							140.61760580200007,
							-38.03228261099997
						],
						[
							140.62094263100005,
							-38.040242570999965
						],
						[
							140.64203178700006,
							-38.04115157199993
						],
						[
							140.66244886200002,
							-38.06146061299995
						],
						[
							140.71770860300012,
							-38.051671855999984
						],
						[
							140.77048482300006,
							-38.05969454899997
						],
						[
							140.78300454100008,
							-38.045506588999956
						],
						[
							140.80761882700006,
							-38.04899462999998
						],
						[
							140.83784549200004,
							-38.04103754199997
						],
						[
							140.87307977500006,
							-38.051000553999984
						],
						[
							140.90014167000004,
							-38.04795658499995
						],
						[
							140.9658026180001,
							-38.055984948999935
						],
						[
							140.9731800940001,
							-37.35822367499998
						],
						[
							140.96853909000004,
							-36.55132211999995
						],
						[
							140.96310907400004,
							-35.74850734399996
						],
						[
							140.96542467100005,
							-34.86983961899995
						],
						[
							140.96368894800003,
							-33.98063640299995
						],
						[
							140.96876463600006,
							-33.996699072999945
						],
						[
							140.98058169400008,
							-33.99998251399995
						],
						[
							140.9753270540001,
							-34.009307493999984
						],
						[
							140.98675362200004,
							-34.01022365399996
						],
						[
							140.98045996300004,
							-34.01599961399995
						],
						[
							140.9872909710001,
							-34.02965977399998
						],
						[
							141.002962539,
							-34.021878544999936
						],
						[
							141.0024129400001,
							-33.33000950099995
						],
						[
							140.43659407500002,
							-33.32420455199997
						],
						[
							140.43376305200002,
							-33.52013655299993
						],
						[
							140.69918900200003,
							-33.519311555999934
						],
						[
							140.702818986,
							-33.73416755799997
						],
						[
							140.6894489970001,
							-33.74173855699996
						],
						[
							140.85150696300002,
							-33.74205756599997
						],
						[
							140.8578969770001,
							-33.80175456599994
						],
						[
							140.84926395800005,
							-33.80826955599997
						],
						[
							140.8625399650001,
							-33.82608056699996
						],
						[
							140.8847032660001,
							-33.897263297999984
						],
						[
							140.87892366500012,
							-33.928799037999966
						],
						[
							140.86763896600007,
							-33.937454137999964
						],
						[
							140.82799252200005,
							-33.935808745999964
						],
						[
							140.81295795200003,
							-33.96834928499993
						],
						[
							140.72187499300003,
							-34.00306562099996
						],
						[
							140.689280606,
							-34.04110405899996
						],
						[
							140.69333031300005,
							-34.06448633999997
						],
						[
							140.63526918200012,
							-34.064247756999976
						],
						[
							140.65784220700004,
							-34.08531925799997
						],
						[
							140.65728221400002,
							-34.12924856799998
						],
						[
							140.4061709120001,
							-34.13344394599994
						],
						[
							140.3741607080001,
							-34.11941445399998
						],
						[
							140.3551747900001,
							-34.13287231299995
						],
						[
							140.35465700600002,
							-34.05332253299997
						],
						[
							140.0552640520001,
							-34.05714252799993
						],
						[
							140.05326104900007,
							-33.959652527999936
						],
						[
							140.04480010100008,
							-33.952413526999976
						],
						[
							139.99711807800009,
							-33.94853252499996
						],
						[
							139.98361111200006,
							-33.93192052399996
						],
						[
							139.98004422100007,
							-33.94429746399993
						],
						[
							139.916662631,
							-33.943956990999936
						],
						[
							139.9165648070001,
							-34.00786638099993
						],
						[
							139.90085608800007,
							-34.02427452099994
						],
						[
							139.85742109500006,
							-34.024347518999946
						],
						[
							139.85708380500012,
							-33.87530311799998
						],
						[
							139.69923512900004,
							-33.87518050999995
						],
						[
							139.69999115400003,
							-33.80058151999998
						],
						[
							139.3559411860001,
							-33.80299948399994
						],
						[
							139.3580455020001,
							-34.175425136999934
						],
						[
							139.35079078400008,
							-34.319331716999955
						],
						[
							139.26424736700005,
							-34.319351092999966
						],
						[
							139.26438139900006,
							-34.29581889299993
						],
						[
							139.19964627800005,
							-34.31210779099996
						],
						[
							139.15584249300002,
							-34.33518696899995
						],
						[
							139.10504508100007,
							-34.33001596599996
						],
						[
							139.12739662900003,
							-34.315009086999964
						],
						[
							139.03408435400002,
							-34.30671559299998
						],
						[
							139.04855262500007,
							-34.244772282999975
						],
						[
							139.00808271200003,
							-34.242825581999966
						],
						[
							138.9977931830001,
							-34.255932360999964
						],
						[
							138.97808785600012,
							-34.254379419999964
						],
						[
							138.96583754100004,
							-34.20181734999994
						],
						[
							138.97161104100007,
							-34.19362548999993
						],
						[
							138.9091329800001,
							-34.197804546999976
						],
						[
							138.90295087200002,
							-34.18754906699996
						],
						[
							138.8383831010001,
							-34.19347916399994
						],
						[
							138.83582066100007,
							-34.212409183999966
						],
						[
							138.82817916200008,
							-34.21175868399996
						],
						[
							138.84086958900002,
							-34.22097925399993
						],
						[
							138.83900845900007,
							-34.231678113999976
						],
						[
							138.8278858110001,
							-34.23121350399998
						],
						[
							138.82722724000007,
							-34.238270513999964
						],
						[
							138.83885533700004,
							-34.26909573499995
						],
						[
							138.8370261350001,
							-34.300583364999966
						],
						[
							138.77943305400004,
							-34.298270971999955
						],
						[
							138.78466675100003,
							-34.34142859299993
						],
						[
							138.76059639300001,
							-34.365570091999984
						],
						[
							138.7397207260001,
							-34.361613330999944
						],
						[
							138.7384336660001,
							-34.368610470999954
						],
						[
							138.7215573090001,
							-34.369235439999954
						],
						[
							138.71830026800012,
							-34.392254469999955
						],
						[
							138.73747725500004,
							-34.39414047099996
						],
						[
							138.74675223100007,
							-34.437277481999956
						],
						[
							138.7531202350001,
							-34.512732461999974
						],
						[
							138.74747222300005,
							-34.55823447299997
						],
						[
							138.7460662430001,
							-34.568335472999934
						],
						[
							138.76245974000005,
							-34.57195287299993
						],
						[
							138.7733252390001,
							-34.56059246399997
						],
						[
							138.79026922600008,
							-34.56273846399995
						],
						[
							138.79405924600007,
							-34.55108948399993
						],
						[
							138.80423522400008,
							-34.55131048499993
						],
						[
							138.8021962240001,
							-34.560986484999944
						],
						[
							138.8212622110001,
							-34.56202347599998
						],
						[
							138.82479522900007,
							-34.59094847599994
						],
						[
							138.81543221000004,
							-34.60085947599998
						],
						[
							138.800450242,
							-34.60189247499994
						],
						[
							138.8148012370001,
							-34.64298347599998
						],
						[
							138.8090782170001,
							-34.651028475999965
						],
						[
							138.78650020100008,
							-34.65671648499995
						],
						[
							138.79813934800006,
							-34.66545647499993
						],
						[
							138.83101814300005,
							-34.66900851699995
						],
						[
							138.8475557800001,
							-34.68052441799995
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "402",
				"CED_NAME21": "Barker",
				"STE_CODE21": "4",
				"STE_NAME21": "South Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 62242.5938,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/402",
				"SHAPE_Leng": 16.9927063603,
				"SHAPE_Area": 6.19148168364
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							138.50369351100005,
							-35.056530504999955
						],
						[
							138.55965522200006,
							-35.053699467999934
						],
						[
							138.556067094,
							-35.03128640799997
						],
						[
							138.5629663640001,
							-35.02328093799997
						],
						[
							138.5712493410001,
							-35.03798950799995
						],
						[
							138.5863179590001,
							-35.03794102899997
						],
						[
							138.6254682230001,
							-35.03060647999996
						],
						[
							138.62037621500008,
							-35.016060779999975
						],
						[
							138.64542532100006,
							-35.01495849099996
						],
						[
							138.67164480600002,
							-35.02599228199995
						],
						[
							138.68139424600008,
							-35.00744452299995
						],
						[
							138.67375888800007,
							-34.98526277199994
						],
						[
							138.66517792000002,
							-34.98164891199997
						],
						[
							138.67534561900004,
							-34.97447274199993
						],
						[
							138.66977944000007,
							-34.967191071999935
						],
						[
							138.653324332,
							-34.97298945099993
						],
						[
							138.644081324,
							-34.96331184099995
						],
						[
							138.6264462470001,
							-34.964545199999975
						],
						[
							138.59729746200003,
							-34.96600665899996
						],
						[
							138.5850914250001,
							-34.95197194799994
						],
						[
							138.55499881800006,
							-34.96722314699997
						],
						[
							138.53242481200004,
							-34.975601325999946
						],
						[
							138.52305114400008,
							-34.96496109599997
						],
						[
							138.5085856060001,
							-34.96437971499995
						],
						[
							138.51762125000005,
							-35.03211648599995
						],
						[
							138.50369351100005,
							-35.056530504999955
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "403",
				"CED_NAME21": "Boothby",
				"STE_CODE21": "4",
				"STE_NAME21": "South Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 115.8516,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/403",
				"SHAPE_Leng": 0.657113329182,
				"SHAPE_Area": 0.0114394935535
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								135.61774954100008,
								-34.993347262999976
							],
							[
								135.6182455700001,
								-35.00191426299995
							],
							[
								135.62407940000003,
								-34.97950213399997
							],
							[
								135.61736749200008,
								-34.98018325299995
							],
							[
								135.61774954100008,
								-34.993347262999976
							]
						]
					],
					[
						[
							[
								129.00192754400007,
								-31.686990624999964
							],
							[
								129.05281874700006,
								-31.674165754999933
							],
							[
								129.52779266900006,
								-31.62267041599995
							],
							[
								129.8431035330001,
								-31.607732796999983
							],
							[
								129.918223183,
								-31.590281946999937
							],
							[
								130.1204123540001,
								-31.58640005799998
							],
							[
								130.152195709,
								-31.576524217999975
							],
							[
								130.22217465900007,
								-31.579783217999932
							],
							[
								130.27507148200004,
								-31.573648488999936
							],
							[
								130.48881260100006,
								-31.593030239999962
							],
							[
								130.56793160000007,
								-31.58571926099995
							],
							[
								130.73448052600008,
								-31.606038291999937
							],
							[
								130.80614067600004,
								-31.60561629299997
							],
							[
								131.0264062750001,
								-31.537612543999956
							],
							[
								131.05756611100003,
								-31.521531883999955
							],
							[
								131.08180669800004,
								-31.490884283999947
							],
							[
								131.12851556100009,
								-31.464703294999936
							],
							[
								131.1486451290001,
								-31.463640114999976
							],
							[
								131.24478443400005,
								-31.492263255999944
							],
							[
								131.4421846150001,
								-31.571811298999933
							],
							[
								131.7585853280001,
								-31.720246242999963
							],
							[
								132.0730054490001,
								-31.917726737999942
							],
							[
								132.11278365200008,
								-31.946529408999936
							],
							[
								132.15118645600012,
								-32.00302129999994
							],
							[
								132.16622730400002,
								-32.00469528999997
							],
							[
								132.17641737200006,
								-32.018299010999954
							],
							[
								132.2006223080001,
								-32.02726668099996
							],
							[
								132.22557790400003,
								-32.02495031099994
							],
							[
								132.27120997800012,
								-32.03373979199995
							],
							[
								132.28562590600006,
								-32.022465471999965
							],
							[
								132.33520490800004,
								-32.029074872999956
							],
							[
								132.3431959280001,
								-32.01448457299995
							],
							[
								132.38046833200008,
								-32.00985296299996
							],
							[
								132.38392320200012,
								-32.01572899399997
							],
							[
								132.39341619100003,
								-32.00173366399997
							],
							[
								132.41545981700006,
								-31.998792283999933
							],
							[
								132.4494119620001,
								-32.02269006499995
							],
							[
								132.47324043800006,
								-32.03007777499994
							],
							[
								132.46161486100004,
								-32.01062069499994
							],
							[
								132.44397419300003,
								-32.00839995399997
							],
							[
								132.43793436400006,
								-32.00097196399997
							],
							[
								132.4464253540001,
								-31.970711293999955
							],
							[
								132.47845526900005,
								-31.94627126499995
							],
							[
								132.52853012200012,
								-31.935332854999956
							],
							[
								132.59521203300005,
								-31.934313875999976
							],
							[
								132.65551229400012,
								-31.948142116999975
							],
							[
								132.66058933300008,
								-31.95717101799994
							],
							[
								132.686935059,
								-31.950648657999977
							],
							[
								132.73427471200011,
								-31.956564958999934
							],
							[
								132.74659657100005,
								-31.94932781899996
							],
							[
								132.82649527800004,
								-31.981552249999936
							],
							[
								132.9037805060001,
								-32.036218951999956
							],
							[
								132.96364264600004,
								-32.06522482299994
							],
							[
								132.98157867300006,
								-32.081985533999955
							],
							[
								132.97957687300004,
								-32.106499603999964
							],
							[
								133.00663048,
								-32.08338722399998
							],
							[
								133.0883502470001,
								-32.12700727599997
							],
							[
								133.13814054800002,
								-32.17486391699998
							],
							[
								133.12576459900004,
								-32.20876962699998
							],
							[
								133.1475434560001,
								-32.19450314699998
							],
							[
								133.14662547700004,
								-32.17482082699996
							],
							[
								133.16467038500002,
								-32.17003853799997
							],
							[
								133.2300368340001,
								-32.19083017899993
							],
							[
								133.25320065100004,
								-32.21085625999996
							],
							[
								133.2752535080001,
								-32.19488762999998
							],
							[
								133.27824646800002,
								-32.18351641999993
							],
							[
								133.32280015100002,
								-32.179861710999944
							],
							[
								133.37144482400004,
								-32.18882405199997
							],
							[
								133.38979275100007,
								-32.20019282199996
							],
							[
								133.39515270000004,
								-32.195098721999955
							],
							[
								133.4235004960001,
								-32.19795948299998
							],
							[
								133.42562045600005,
								-32.18467441299998
							],
							[
								133.44624817300007,
								-32.178506252999966
							],
							[
								133.485635967,
								-32.19623304399994
							],
							[
								133.48773705600001,
								-32.20609408399997
							],
							[
								133.4918119560001,
								-32.195602013999974
							],
							[
								133.46431705100008,
								-32.17214408299998
							],
							[
								133.41176048800003,
								-32.17773848199994
							],
							[
								133.414851418,
								-32.169885421999936
							],
							[
								133.40087353,
								-32.16903951199998
							],
							[
								133.39234056200007,
								-32.15934758199995
							],
							[
								133.397235431,
								-32.13914144199998
							],
							[
								133.43809600600002,
								-32.12302608299996
							],
							[
								133.45146095400003,
								-32.135994032999974
							],
							[
								133.45105580400002,
								-32.112643942999966
							],
							[
								133.4727985620001,
								-32.100093742999945
							],
							[
								133.48948744900008,
								-32.10980667299998
							],
							[
								133.48003961000006,
								-32.115954762999934
							],
							[
								133.48315060900006,
								-32.12627877299997
							],
							[
								133.50293444600004,
								-32.13107266399993
							],
							[
								133.4967946370001,
								-32.15059578399996
							],
							[
								133.5113125150001,
								-32.153293693999956
							],
							[
								133.51903839400006,
								-32.143519613999956
							],
							[
								133.5047785060001,
								-32.14191370399993
							],
							[
								133.52530526300006,
								-32.127425493999965
							],
							[
								133.51908234400003,
								-32.13571557399996
							],
							[
								133.52092135300006,
								-32.140742573999944
							],
							[
								133.52512035300003,
								-32.13711853399997
							],
							[
								133.52211344300008,
								-32.15528762399998
							],
							[
								133.55346525800007,
								-32.16956848499996
							],
							[
								133.555860208,
								-32.15898442499997
							],
							[
								133.5846908640001,
								-32.140978135999944
							],
							[
								133.572521767,
								-32.11744010499996
							],
							[
								133.5922643250001,
								-32.08724385499994
							],
							[
								133.61362715100006,
								-32.08600868599996
							],
							[
								133.6282280590001,
								-32.09060060599995
							],
							[
								133.6305581790001,
								-32.10006559599998
							],
							[
								133.64378300700002,
								-32.09589948599995
							],
							[
								133.6675459930001,
								-32.10440221699997
							],
							[
								133.67049618200008,
								-32.13497181699995
							],
							[
								133.64272636600003,
								-32.144562736999944
							],
							[
								133.64777310500006,
								-32.15215607699997
							],
							[
								133.67472105100012,
								-32.142624266999974
							],
							[
								133.6929159780001,
								-32.15522646799997
							],
							[
								133.6791213890001,
								-32.20262883799995
							],
							[
								133.71493999400002,
								-32.19497858899996
							],
							[
								133.73321379100003,
								-32.198661528999935
							],
							[
								133.73607583000012,
								-32.20758256899995
							],
							[
								133.74506369900007,
								-32.20153947899996
							],
							[
								133.756733617,
								-32.205832449999946
							],
							[
								133.76222267600008,
								-32.224299549999955
							],
							[
								133.7553608170001,
								-32.23531165999998
							],
							[
								133.76973886400003,
								-32.26381275999995
							],
							[
								133.80834931900006,
								-32.24310146099998
							],
							[
								133.80602222900006,
								-32.23115138099996
							],
							[
								133.8214150770001,
								-32.23395635099996
							],
							[
								133.82716211600007,
								-32.242821370999934
							],
							[
								133.81818022700008,
								-32.24722042099995
							],
							[
								133.82841318500004,
								-32.25608344099993
							],
							[
								133.84287401300003,
								-32.256299371999944
							],
							[
								133.85978394000006,
								-32.27841141199997
							],
							[
								133.86936789900005,
								-32.280491361999964
							],
							[
								133.88010392600006,
								-32.306159442999956
							],
							[
								133.90199684300012,
								-32.31820337299996
							],
							[
								133.9310218170001,
								-32.36179043399994
							],
							[
								133.93271691600012,
								-32.37986552399997
							],
							[
								133.95109382300006,
								-32.38849945499993
							],
							[
								133.94693793300007,
								-32.41156371499994
							],
							[
								133.9193249970001,
								-32.42830446399995
							],
							[
								133.90810617900001,
								-32.42432623399998
							],
							[
								133.90133217900006,
								-32.42947737399993
							],
							[
								133.90255919900005,
								-32.42275425399998
							],
							[
								133.89376522100008,
								-32.428825433999975
							],
							[
								133.88745426200012,
								-32.42311239399993
							],
							[
								133.90558723900006,
								-32.41339795399995
							],
							[
								133.88902014200005,
								-32.411495843999944
							],
							[
								133.89367316100004,
								-32.40858547399995
							],
							[
								133.88675725200005,
								-32.40233702399996
							],
							[
								133.8971937010001,
								-32.399560303999976
							],
							[
								133.86682635500006,
								-32.39917212299997
							],
							[
								133.8674903650001,
								-32.42043552299998
							],
							[
								133.85062842600007,
								-32.46140349299998
							],
							[
								133.862414424,
								-32.48352277399994
							],
							[
								133.84700047500007,
								-32.50368235299993
							],
							[
								133.8571284530001,
								-32.51947057399997
							],
							[
								133.84900848400002,
								-32.54171212399996
							],
							[
								133.86106041200003,
								-32.53189874399993
							],
							[
								133.89370338700007,
								-32.54120533499997
							],
							[
								133.89619800700007,
								-32.52332793399995
							],
							[
								133.9088022960001,
								-32.517531694999946
							],
							[
								133.90743427600012,
								-32.508780574999946
							],
							[
								133.92274719400007,
								-32.49483612499995
							],
							[
								133.9549641000001,
								-32.49434766599995
							],
							[
								133.9915720240001,
								-32.50533921599998
							],
							[
								133.99508091400003,
								-32.484436975999984
							],
							[
								134.03698553900006,
								-32.45979948699994
							],
							[
								134.08622414100012,
								-32.47077228799998
							],
							[
								134.06193229500002,
								-32.45630731799997
							],
							[
								134.05713327600006,
								-32.44069424799994
							],
							[
								134.0628402750001,
								-32.45578130799993
							],
							[
								134.0812261220001,
								-32.457296217999954
							],
							[
								134.07391721300007,
								-32.460672287999955
							],
							[
								134.082357182,
								-32.46556427799993
							],
							[
								134.08104114200012,
								-32.45536822799994
							],
							[
								134.10284462900006,
								-32.45010249899997
							],
							[
								134.0921890410001,
								-32.45785515799997
							],
							[
								134.12128274600002,
								-32.45405899899998
							],
							[
								134.16310952000003,
								-32.46903888999998
							],
							[
								134.21423141100001,
								-32.51113409199996
							],
							[
								134.2663502910001,
								-32.57379535299998
							],
							[
								134.2778101980001,
								-32.60864235399998
							],
							[
								134.27939615700006,
								-32.64819338399997
							],
							[
								134.29431498400004,
								-32.661941283999965
							],
							[
								134.28375403500002,
								-32.68492635399997
							],
							[
								134.29038995400003,
								-32.69285130399993
							],
							[
								134.26048028700006,
								-32.73475402399998
							],
							[
								134.2409584090001,
								-32.74804241399994
							],
							[
								134.22186654100005,
								-32.78983130299997
							],
							[
								134.19665475400006,
								-32.795291722999934
							],
							[
								134.18924886600007,
								-32.76968733299998
							],
							[
								134.200142765,
								-32.74667779299995
							],
							[
								134.16465411100012,
								-32.73697397199993
							],
							[
								134.15282224300006,
								-32.72396279099996
							],
							[
								134.21509568400006,
								-32.73076837299993
							],
							[
								134.20494273500003,
								-32.72518838299993
							],
							[
								134.17429103000006,
								-32.71793349199993
							],
							[
								134.10707753000008,
								-32.721271669999965
							],
							[
								134.08060265400002,
								-32.709558999999956
							],
							[
								134.0603307770001,
								-32.72248461899994
							],
							[
								134.1189093260001,
								-32.78337260099994
							],
							[
								134.13850606200003,
								-32.839701411999954
							],
							[
								134.13196114200002,
								-32.856483751999974
							],
							[
								134.11686820400007,
								-32.86809407199996
							],
							[
								134.0993092970001,
								-32.867184280999936
							],
							[
								134.09612730700007,
								-32.87862945099994
							],
							[
								134.07153543000004,
								-32.883800830999974
							],
							[
								134.078654389,
								-32.89910593099995
							],
							[
								134.07039247000012,
								-32.90938318099995
							],
							[
								134.0605384910001,
								-32.90792030099993
							],
							[
								134.0811064280001,
								-32.91861217099995
							],
							[
								134.08090939700003,
								-32.92650325099993
							],
							[
								134.09134138600007,
								-32.92629311099995
							],
							[
								134.10645026400005,
								-32.91236673199995
							],
							[
								134.11918924200006,
								-32.914583611999944
							],
							[
								134.12927820000004,
								-32.92641961199996
							],
							[
								134.12365421100003,
								-32.93210375199993
							],
							[
								134.14119220800012,
								-32.944253652999976
							],
							[
								134.14406810800006,
								-32.92815441299996
							],
							[
								134.16740106500004,
								-32.926754942999935
							],
							[
								134.18909096100003,
								-32.94235555399996
							],
							[
								134.20188694800004,
								-32.96376939399994
							],
							[
								134.20484508700008,
								-32.99529552399997
							],
							[
								134.19354950800005,
								-33.01351789399996
							],
							[
								134.16729440200004,
								-33.009268643999974
							],
							[
								134.1385337260001,
								-33.01807333299996
							],
							[
								134.165254311,
								-33.04134576399997
							],
							[
								134.16792969000005,
								-33.05567369399995
							],
							[
								134.192046107,
								-33.035152953999955
							],
							[
								134.2302913110001,
								-33.043298824999965
							],
							[
								134.24721362700006,
								-33.08725633599994
							],
							[
								134.26175700500005,
								-33.098188895999954
							],
							[
								134.2667812630001,
								-33.13849775699998
							],
							[
								134.26023258300006,
								-33.15261696699997
							],
							[
								134.32837515100005,
								-33.19946291799994
							],
							[
								134.35134164800002,
								-33.19028696899994
							],
							[
								134.3448453000001,
								-33.16220085899994
							],
							[
								134.3527920790001,
								-33.15734486899993
							],
							[
								134.34494327000004,
								-33.161221858999966
							],
							[
								134.35847786800002,
								-33.148283868999954
							],
							[
								134.3513367500001,
								-33.13896382899998
							],
							[
								134.3165547760001,
								-33.12524070799998
							],
							[
								134.321631485,
								-33.11827471799995
							],
							[
								134.3126024170001,
								-33.11199668799998
							],
							[
								134.29235067900004,
								-33.11855094699996
							],
							[
								134.2787893320001,
								-33.10741736699998
							],
							[
								134.28424414100004,
								-33.10038218699998
							],
							[
								134.2661446740001,
								-33.08800675599997
							],
							[
								134.26100923600006,
								-33.07307790599998
							],
							[
								134.2624408060001,
								-33.05999187599997
							],
							[
								134.28174652300004,
								-33.050423285999955
							],
							[
								134.2715452550001,
								-33.04230859599994
							],
							[
								134.27854306400002,
								-33.03621539599993
							],
							[
								134.26402095700007,
								-33.03211081599994
							],
							[
								134.27554875500005,
								-33.02476946599995
							],
							[
								134.28408581400004,
								-33.02849221599996
							],
							[
								134.28149215400003,
								-33.03940629599998
							],
							[
								134.29334520200007,
								-33.03996895699993
							],
							[
								134.2996905110001,
								-33.04920274699998
							],
							[
								134.28999085200007,
								-33.06035904699996
							],
							[
								134.29257432100007,
								-33.07590594699997
							],
							[
								134.30705474800004,
								-33.088968686999976
							],
							[
								134.324373626,
								-33.09061172799994
							],
							[
								134.35848224900008,
								-33.125326848999975
							],
							[
								134.36889317600003,
								-33.17588497899993
							],
							[
								134.38855787300008,
								-33.177331049999964
							],
							[
								134.39189565300012,
								-33.16607703999995
							],
							[
								134.41547104000006,
								-33.148849079999934
							],
							[
								134.4508925350001,
								-33.14464322099997
							],
							[
								134.5062116360001,
								-33.16139358199996
							],
							[
								134.54767397800003,
								-33.189856143999975
							],
							[
								134.57349801400005,
								-33.191994843999964
							],
							[
								134.59576816100002,
								-33.20340360499995
							],
							[
								134.6308462940001,
								-33.24514939599993
							],
							[
								134.64247979300012,
								-33.22432327599995
							],
							[
								134.66378437000003,
								-33.22306311699998
							],
							[
								134.63122575500006,
								-33.21373735599997
							],
							[
								134.6231556470001,
								-33.197887365999975
							],
							[
								134.64745215300002,
								-33.195376195999984
							],
							[
								134.6407610550001,
								-33.18270523599995
							],
							[
								134.62554755600001,
								-33.19509934599995
							],
							[
								134.6134806980001,
								-33.18908042499993
							],
							[
								134.59819205100007,
								-33.19654254499994
							],
							[
								134.57636994400002,
								-33.189301813999975
							],
							[
								134.558358558,
								-33.16133297399995
							],
							[
								134.59515916300006,
								-33.13877648499994
							],
							[
								134.6324259170001,
								-33.16218425599993
							],
							[
								134.6666621810001,
								-33.160988025999984
							],
							[
								134.7021557160001,
								-33.17465680699996
							],
							[
								134.71740881300002,
								-33.19566372799994
							],
							[
								134.71830109200005,
								-33.20735772799998
							],
							[
								134.70964438300007,
								-33.214774777999935
							],
							[
								134.72244625100006,
								-33.21876067799997
							],
							[
								134.71910449100005,
								-33.22997071799995
							],
							[
								134.70892979200005,
								-33.23306078799993
							],
							[
								134.71126860200002,
								-33.22759377799997
							],
							[
								134.69850772400002,
								-33.221816857999954
							],
							[
								134.69135401500012,
								-33.22947291699995
							],
							[
								134.6583016300001,
								-33.23357016699998
							],
							[
								134.68801445500003,
								-33.25018496799993
							],
							[
								134.69662958300012,
								-33.263465907999944
							],
							[
								134.71931623000012,
								-33.26392572799995
							],
							[
								134.73678212700008,
								-33.27383558899993
							],
							[
								134.7606910820001,
								-33.30903240999993
							],
							[
								134.80205532500008,
								-33.32876810099998
							],
							[
								134.8450743940001,
								-33.43647597299997
							],
							[
								134.86340939800004,
								-33.54657770399996
							],
							[
								134.8404917790001,
								-33.59288681399994
							],
							[
								134.8427020680001,
								-33.62138390399997
							],
							[
								134.8302544400001,
								-33.62630403299994
							],
							[
								134.8607698940001,
								-33.64396579399994
							],
							[
								134.87914538200005,
								-33.636095584999964
							],
							[
								134.88610677100007,
								-33.64302331499994
							],
							[
								134.8789247410001,
								-33.65389432499995
							],
							[
								135.04027891300007,
								-33.75498934999996
							],
							[
								135.08224371400001,
								-33.80411333099994
							],
							[
								135.14585393200002,
								-33.85235234299995
							],
							[
								135.161754749,
								-33.87750229399995
							],
							[
								135.1703817880001,
								-33.87254834399994
							],
							[
								135.18215992600005,
								-33.87775737399994
							],
							[
								135.1940348720001,
								-33.91978735499998
							],
							[
								135.25218159100007,
								-33.98132015699997
							],
							[
								135.27155851600003,
								-34.01957707799994
							],
							[
								135.2647799570001,
								-34.03213419799994
							],
							[
								135.28112651300012,
								-34.070243087999984
							],
							[
								135.27274893300012,
								-34.09458024799994
							],
							[
								135.27948522100007,
								-34.11972416799995
							],
							[
								135.25160349500004,
								-34.14177677799995
							],
							[
								135.2440484660001,
								-34.14077292799993
							],
							[
								135.24124453600007,
								-34.15011703799996
							],
							[
								135.25569277300008,
								-34.15520333799998
							],
							[
								135.26788691100012,
								-34.17726954899996
							],
							[
								135.27097981000009,
								-34.170078358999945
							],
							[
								135.28003789900004,
								-34.17028923899994
							],
							[
								135.3035198450001,
								-34.184074349999946
							],
							[
								135.34623176500008,
								-34.26754496099994
							],
							[
								135.35984768900005,
								-34.34403723199995
							],
							[
								135.3573727690001,
								-34.36614745199995
							],
							[
								135.34986475000005,
								-34.36860465199993
							],
							[
								135.36560486700012,
								-34.38498032299998
							],
							[
								135.35894200600012,
								-34.41868963299993
							],
							[
								135.38868519100004,
								-34.44285009399994
							],
							[
								135.3954324780001,
								-34.49519021399993
							],
							[
								135.3768733600001,
								-34.51599284399998
							],
							[
								135.39833119500008,
								-34.55565684399994
							],
							[
								135.38924316400005,
								-34.59505142399996
							],
							[
								135.422162909,
								-34.60181880499994
							],
							[
								135.39634913300006,
								-34.59306327499996
							],
							[
								135.4136450210001,
								-34.58783887499993
							],
							[
								135.40639214300006,
								-34.555034674999945
							],
							[
								135.42219814100008,
								-34.54884333499996
							],
							[
								135.391451307,
								-34.53401077399997
							],
							[
								135.40125225500003,
								-34.53335757399998
							],
							[
								135.39523829600012,
								-34.524248573999955
							],
							[
								135.40509332500005,
								-34.507221253999944
							],
							[
								135.41459427300003,
								-34.52078719499997
							],
							[
								135.4103561830001,
								-34.53882045499995
							],
							[
								135.4203481720001,
								-34.53922327499998
							],
							[
								135.42866619100005,
								-34.52737398499994
							],
							[
								135.44579209800008,
								-34.537174755999956
							],
							[
								135.43575010900008,
								-34.54162899499994
							],
							[
								135.44403889700004,
								-34.57001308599996
							],
							[
								135.4317018170001,
								-34.60341862599995
							],
							[
								135.47297342000002,
								-34.61663585699995
							],
							[
								135.44314471600012,
								-34.600543355999946
							],
							[
								135.45807773400009,
								-34.586425935999955
							],
							[
								135.47824150000008,
								-34.59734661699997
							],
							[
								135.5080472850001,
								-34.594971957999974
							],
							[
								135.5167680830001,
								-34.612953897999944
							],
							[
								135.5104359940001,
								-34.620941107999954
							],
							[
								135.49402387700002,
								-34.61327833799993
							],
							[
								135.47403093000003,
								-34.622805366999955
							],
							[
								135.45153668400008,
								-34.614391345999934
							],
							[
								135.45107371300003,
								-34.62676932599993
							],
							[
								135.43827959500004,
								-34.633619745999965
							],
							[
								135.36576428600006,
								-34.64207742399998
							],
							[
								135.36485831700008,
								-34.63702439399998
							],
							[
								135.37686718400005,
								-34.640732183999944
							],
							[
								135.37430521500005,
								-34.62880110399993
							],
							[
								135.39037506300008,
								-34.63005176499996
							],
							[
								135.39205304200004,
								-34.63764880499997
							],
							[
								135.40220395100005,
								-34.633388554999954
							],
							[
								135.3911471130001,
								-34.623020674999964
							],
							[
								135.36163036800008,
								-34.62072228399995
							],
							[
								135.35047141000007,
								-34.603496322999945
							],
							[
								135.35469541100008,
								-34.58005397299996
							],
							[
								135.30949852800006,
								-34.563676741999984
							],
							[
								135.29759354100008,
								-34.55228087199998
							],
							[
								135.31625642900008,
								-34.52064513199997
							],
							[
								135.35390741300012,
								-34.522049332999984
							],
							[
								135.2213922850001,
								-34.49861596899996
							],
							[
								135.2125623170001,
								-34.481438958999945
							],
							[
								135.21738531800008,
								-34.43333930899996
							],
							[
								135.2063272800001,
								-34.42929345799996
							],
							[
								135.19498542200006,
								-34.434046717999934
							],
							[
								135.18658746200003,
								-34.459919207999974
							],
							[
								135.1732346340001,
								-34.46475451799995
							],
							[
								135.1595717350001,
								-34.48888204699995
							],
							[
								135.13899000800006,
								-34.50328259699995
							],
							[
								135.14360908700007,
								-34.51975967699997
							],
							[
								135.1298772780001,
								-34.52778401699993
							],
							[
								135.1342484070001,
								-34.54433712699995
							],
							[
								135.12329759800002,
								-34.55738747699996
							],
							[
								135.12535269700004,
								-34.57651963699993
							],
							[
								135.10920494900006,
								-34.58822008699997
							],
							[
								135.14350564400002,
								-34.59182446799997
							],
							[
								135.14989942400007,
								-34.56887008799998
							],
							[
								135.17373508000003,
								-34.55498850799995
							],
							[
								135.20881577500006,
								-34.55861984899997
							],
							[
								135.20661873500012,
								-34.549942818999966
							],
							[
								135.22524960300007,
								-34.54360432999994
							],
							[
								135.25243760800004,
								-34.55185682999996
							],
							[
								135.28370668200012,
								-34.576021440999966
							],
							[
								135.2971096990001,
								-34.60315846199995
							],
							[
								135.32138460500005,
								-34.60798298299994
							],
							[
								135.34169451100001,
								-34.62909481299994
							],
							[
								135.34728240800007,
								-34.66603211399996
							],
							[
								135.32938149100005,
								-34.66936955299997
							],
							[
								135.32082447200003,
								-34.680283852999935
							],
							[
								135.3250294510001,
								-34.68636184299993
							],
							[
								135.35049925700002,
								-34.68045823399996
							],
							[
								135.37970600200003,
								-34.687103674999946
							],
							[
								135.47434822500009,
								-34.74409438799995
							],
							[
								135.4941172010001,
								-34.76566225799996
							],
							[
								135.4959002700001,
								-34.782569448999936
							],
							[
								135.54065758100012,
								-34.814117109999984
							],
							[
								135.6045100780001,
								-34.878653121999946
							],
							[
								135.6049389970001,
								-34.89165938199994
							],
							[
								135.61446384600004,
								-34.892711212999984
							],
							[
								135.6240515940001,
								-34.90634529299996
							],
							[
								135.61472756400008,
								-34.92446082299995
							],
							[
								135.6217265030001,
								-34.922257642999966
							],
							[
								135.618834353,
								-34.94445213299997
							],
							[
								135.65356891800002,
								-34.93634931399998
							],
							[
								135.66867363500012,
								-34.94670922499995
							],
							[
								135.68588368200005,
								-34.94484238499996
							],
							[
								135.68841156200006,
								-34.92329638499996
							],
							[
								135.67921972400006,
								-34.91369240499995
							],
							[
								135.70574548000002,
								-34.90572273499998
							],
							[
								135.71271869100008,
								-34.86508781499998
							],
							[
								135.75184022500002,
								-34.85613588699994
							],
							[
								135.79209760800006,
								-34.86094222799994
							],
							[
								135.85376277700004,
								-34.88663576999994
							],
							[
								135.85606964500005,
								-34.927274129999944
							],
							[
								135.8677556340001,
								-34.91988080999994
							],
							[
								135.9288843920001,
								-34.94828147199996
							],
							[
								135.93167646100005,
								-34.97079055299997
							],
							[
								135.94856241800005,
								-34.98068822299996
							],
							[
								135.94134749900002,
								-34.98567041299998
							],
							[
								135.943389528,
								-35.00294051299994
							],
							[
								135.95447044600007,
								-35.00633828399998
							],
							[
								135.96094233500003,
								-35.004755133999936
							],
							[
								135.96026434500004,
								-34.991897053999935
							],
							[
								135.97658714300007,
								-34.994642693999936
							],
							[
								135.9872166020001,
								-34.98169136399997
							],
							[
								136.00263784900005,
								-34.98584008499995
							],
							[
								136.0045317590001,
								-34.980329024999946
							],
							[
								135.99797980100004,
								-34.95922008499997
							],
							[
								135.98729993300003,
								-34.958667283999944
							],
							[
								135.99299276200009,
								-34.944900133999965
							],
							[
								135.9864628040001,
								-34.933785333999936
							],
							[
								135.99317070300003,
								-34.92988322399998
							],
							[
								135.96267766000005,
								-34.87543617299997
							],
							[
								135.95996049200005,
								-34.84858738299994
							],
							[
								135.99353008700007,
								-34.82777684399997
							],
							[
								136.0084748260001,
								-34.80568064399995
							],
							[
								136.00431382700003,
								-34.79879677399998
							],
							[
								136.01579074500012,
								-34.79420252399996
							],
							[
								136.001934838,
								-34.78724874399995
							],
							[
								136.0143397170001,
								-34.75650028399997
							],
							[
								136.00653876,
								-34.735925262999956
							],
							[
								135.99509985200007,
								-34.72531237299995
							],
							[
								135.97925096400002,
								-34.73048767299997
							],
							[
								135.99126767100006,
								-34.750334392999946
							],
							[
								135.98061000200005,
								-34.784604152999975
							],
							[
								135.96087212500004,
								-34.78380254199993
							],
							[
								135.95640411700003,
								-34.757134331999964
							],
							[
								135.94963121700005,
								-34.765645511999935
							],
							[
								135.9289025810001,
								-34.768810550999945
							],
							[
								135.89350127500006,
								-34.80558489999993
							],
							[
								135.86061985000003,
								-34.807444948999944
							],
							[
								135.83438022300004,
								-34.818994148999934
							],
							[
								135.78573905200005,
								-34.80931636699995
							],
							[
								135.846381134,
								-34.75286829899994
							],
							[
								135.8634558320001,
								-34.754859418999956
							],
							[
								135.86472778100006,
								-34.769652538999935
							],
							[
								135.89141664700003,
								-34.75143338999993
							],
							[
								135.89210784800002,
								-34.74408334999998
							],
							[
								135.87006255100005,
								-34.74441634899995
							],
							[
								135.8848694300001,
								-34.72492201999995
							],
							[
								135.8538655650001,
								-34.71548325899994
							],
							[
								135.85396981700012,
								-34.66536736799998
							],
							[
								135.8617728170001,
								-34.63356094799997
							],
							[
								135.89115217300002,
								-34.61571878899997
							],
							[
								135.9131437100001,
								-34.62049841999993
							],
							[
								135.91263081900001,
								-34.631467949999944
							],
							[
								135.937420405,
								-34.649006190999955
							],
							[
								135.93343026700006,
								-34.609812689999956
							],
							[
								135.91389470000001,
								-34.61129536999994
							],
							[
								135.9021348430001,
								-34.59257053899995
							],
							[
								135.92275862100007,
								-34.54997036999998
							],
							[
								135.93483479000008,
								-34.54394879999995
							],
							[
								135.9282459210001,
								-34.53807774999996
							],
							[
								135.93231779100006,
								-34.52850760999996
							],
							[
								135.9741348450001,
								-34.50468510099995
							],
							[
								135.99315076100004,
								-34.51854626199997
							],
							[
								136.0083135100001,
								-34.50773512199993
							],
							[
								136.0218104070001,
								-34.516192212999954
							],
							[
								136.01549531900002,
								-34.498997061999944
							],
							[
								136.0250280680001,
								-34.484034092999934
							],
							[
								136.0563336030001,
								-34.47900610299996
							],
							[
								136.08290748800005,
								-34.49529210399993
							],
							[
								136.0732327290001,
								-34.506189123999945
							],
							[
								136.0912886960001,
								-34.520827174999965
							],
							[
								136.08352087600008,
								-34.53221024499993
							],
							[
								136.09218089500007,
								-34.54272025499995
							],
							[
								136.09628663500007,
								-34.52458119499994
							],
							[
								136.11252639300005,
								-34.51580307499995
							],
							[
								136.11754398300002,
								-34.489250004999974
							],
							[
								136.10992489500006,
								-34.47842008499998
							],
							[
								136.12177663300008,
								-34.467407014999935
							],
							[
								136.1140965950001,
								-34.45904007499996
							],
							[
								136.1166951360001,
								-34.42572511499998
							],
							[
								136.10457534800003,
								-34.43256916499996
							],
							[
								136.09180846000004,
								-34.42955818399997
							],
							[
								136.11636685700012,
								-34.40840814499995
							],
							[
								136.1301556850001,
								-34.40709709499998
							],
							[
								136.1037878300001,
								-34.38251438399993
							],
							[
								136.1122522500001,
								-34.35937023399998
							],
							[
								136.13854582600004,
								-34.34112734499996
							],
							[
								136.18784903900007,
								-34.33482606699994
							],
							[
								136.23359159400002,
								-34.296122397999966
							],
							[
								136.26058079100005,
								-34.26769041899996
							],
							[
								136.2780139900001,
								-34.22082140899994
							],
							[
								136.3243972350001,
								-34.18158882999995
							],
							[
								136.33138556500012,
								-34.14811235999997
							],
							[
								136.35685880200003,
								-34.122744420999936
							],
							[
								136.34669563500006,
								-34.099482389999935
							],
							[
								136.36314366400006,
								-34.06933536099996
							],
							[
								136.43475702500007,
								-34.01158123299996
							],
							[
								136.49748558600004,
								-33.99260136399994
							],
							[
								136.55609643900004,
								-33.94970034599993
							],
							[
								136.57475778700007,
								-33.94342436699998
							],
							[
								136.57220249800002,
								-33.92302434599998
							],
							[
								136.5926915560001,
								-33.899548376999974
							],
							[
								136.6683696550001,
								-33.87867540899998
							],
							[
								136.73046789800003,
								-33.83496416099996
							],
							[
								136.77849131100004,
								-33.830998672999954
							],
							[
								136.79963662900002,
								-33.80331656299995
							],
							[
								136.85722592000002,
								-33.79837301499998
							],
							[
								136.95149701800005,
								-33.75528501799994
							],
							[
								136.99168198300003,
								-33.724779618999946
							],
							[
								137.02551841800005,
								-33.71970825099993
							],
							[
								137.03728802700005,
								-33.70799616099998
							],
							[
								137.06974134200004,
								-33.69872986199994
							],
							[
								137.12433555400003,
								-33.70073222399998
							],
							[
								137.1685157280001,
								-33.69028080499993
							],
							[
								137.1820992060001,
								-33.673139755999955
							],
							[
								137.21331359200008,
								-33.66106850699998
							],
							[
								137.25240432900011,
								-33.60826340799997
							],
							[
								137.2639237290001,
								-33.57767354799995
							],
							[
								137.278840327,
								-33.565001508999956
							],
							[
								137.2952902180001,
								-33.50739990899996
							],
							[
								137.3146214960001,
								-33.47151510899994
							],
							[
								137.36052885100003,
								-33.43915215099997
							],
							[
								137.3607485120001,
								-33.414824230999955
							],
							[
								137.38559282100005,
								-33.37215227099995
							],
							[
								137.37722848400006,
								-33.344197390999966
							],
							[
								137.38453381500005,
								-33.29849351099995
							],
							[
								137.37444178700002,
								-33.29271252999996
							],
							[
								137.38537575500004,
								-33.298324510999976
							],
							[
								137.38349870500008,
								-33.29087852099997
							],
							[
								137.393693664,
								-33.28987650099998
							],
							[
								137.3897456850001,
								-33.285304500999985
							],
							[
								137.39754164400006,
								-33.285286490999965
							],
							[
								137.43406920100006,
								-33.23007455199996
							],
							[
								137.44227184400006,
								-33.15216370199994
							],
							[
								137.45198661300003,
								-33.13068783199998
							],
							[
								137.45760768200012,
								-33.135558841999966
							],
							[
								137.46203462200003,
								-33.12866637299993
							],
							[
								137.48608348900007,
								-33.12464436299996
							],
							[
								137.49975937700003,
								-33.10960841399998
							],
							[
								137.53603066300002,
								-33.09480442499995
							],
							[
								137.53869253300002,
								-33.08210940499998
							],
							[
								137.55729914100004,
								-33.06589430599996
							],
							[
								137.5529684920001,
								-33.05804540499997
							],
							[
								137.56101367100007,
								-33.05933640599994
							],
							[
								137.5657218010001,
								-33.048201295999945
							],
							[
								137.59698667700002,
								-33.03613638699994
							],
							[
								137.58574347900003,
								-33.02207237599998
							],
							[
								137.59974947700005,
								-33.02107524699994
							],
							[
								137.5957964480001,
								-33.01209440699995
							],
							[
								137.60323730800008,
								-33.00177232699997
							],
							[
								137.5963433280001,
								-33.00676839699997
							],
							[
								137.5952050090001,
								-32.99853715699993
							],
							[
								137.6114651680001,
								-32.97454781699997
							],
							[
								137.64142564400004,
								-32.95530450799998
							],
							[
								137.6610503820001,
								-32.95094536899995
							],
							[
								137.69150316700006,
								-32.95954631999996
							],
							[
								137.71327570300002,
								-32.97446905099997
							],
							[
								137.72127533100002,
								-32.99049804099997
							],
							[
								137.76033850400006,
								-32.99536957299995
							],
							[
								137.75917623500004,
								-32.98895853299996
							],
							[
								137.78651874000002,
								-32.99990168399995
							],
							[
								137.75013449000005,
								-32.922192421999966
							],
							[
								137.75868549900008,
								-32.90793241199998
							],
							[
								137.79002449400002,
								-32.915701412999965
							],
							[
								137.79915249400005,
								-32.89364742399994
							],
							[
								137.79260950600008,
								-32.87104141299994
							],
							[
								137.80130048500007,
								-32.86834041399993
							],
							[
								137.81146846500008,
								-32.845128433999946
							],
							[
								137.7963535010001,
								-32.77920542299995
							],
							[
								137.81041348000008,
								-32.748669432999975
							],
							[
								137.7821854760001,
								-32.71354642199998
							],
							[
								137.75315981000006,
								-32.721224810999956
							],
							[
								137.750277621,
								-32.71007562099993
							],
							[
								137.7580274810001,
								-32.69403643099997
							],
							[
								137.7512325030001,
								-32.67339641999996
							],
							[
								137.76557751500002,
								-32.601482429999976
							],
							[
								137.7501605010001,
								-32.533850418999975
							],
							[
								137.76242950000005,
								-32.50934341999994
							],
							[
								137.7530078320001,
								-32.492982808999955
							],
							[
								137.76613852100002,
								-32.474792409999964
							],
							[
								137.75399052400007,
								-32.45921540899997
							],
							[
								137.76440350300004,
								-32.442765408999946
							],
							[
								137.76049150400002,
								-32.43291242899994
							],
							[
								137.7652355130001,
								-32.44133341899993
							],
							[
								137.75728052400007,
								-32.45567441899993
							],
							[
								137.77041851100012,
								-32.47641341999997
							],
							[
								137.75738750200003,
								-32.49342140899995
							],
							[
								137.7696594990001,
								-32.50645541999995
							],
							[
								137.76635948900002,
								-32.523997419999944
							],
							[
								137.78389551600003,
								-32.529635420999966
							],
							[
								137.78448651400004,
								-32.554774420999934
							],
							[
								137.8185544790001,
								-32.558960421999984
							],
							[
								137.83454250600005,
								-32.57514942299997
							],
							[
								137.83027349600002,
								-32.59188243299997
							],
							[
								137.82210749800004,
								-32.57940641199997
							],
							[
								137.8037094990001,
								-32.60770842199997
							],
							[
								137.83090348300004,
								-32.63552243299995
							],
							[
								137.8457054710001,
								-32.64413342399996
							],
							[
								137.85361648000003,
								-32.64031041399994
							],
							[
								137.8676524760001,
								-32.663913424999976
							],
							[
								137.86002847600002,
								-32.68938042499997
							],
							[
								137.83757449900008,
								-32.69579041399993
							],
							[
								137.88746748100004,
								-32.71542742599996
							],
							[
								137.94446046000007,
								-32.75763342799996
							],
							[
								137.93665749100012,
								-32.76663143799993
							],
							[
								137.916823474,
								-32.759392426999966
							],
							[
								137.92159448300004,
								-32.77185242799993
							],
							[
								137.90598347500008,
								-32.77098542699997
							],
							[
								137.90089246500008,
								-32.77762742699997
							],
							[
								137.9123292700001,
								-32.85347269799996
							],
							[
								137.95663974600006,
								-32.981377289999955
							],
							[
								137.95208899500005,
								-33.00599656999998
							],
							[
								137.96431003300006,
								-33.01646718099994
							],
							[
								137.98881645900008,
								-33.01907049199997
							],
							[
								138.01879120400008,
								-33.03560753299996
							],
							[
								138.045949897,
								-33.08668638399996
							],
							[
								138.03925955700004,
								-33.10114346399996
							],
							[
								138.0306417590001,
								-33.098356733999935
							],
							[
								138.02463721900006,
								-33.10576687399998
							],
							[
								138.036712727,
								-33.102951523999934
							],
							[
								138.05441555400012,
								-33.11508242499997
							],
							[
								138.04805145400007,
								-33.13582347499994
							],
							[
								138.020925497,
								-33.14901747399995
							],
							[
								138.02829936600006,
								-33.15499643399994
							],
							[
								138.0182704870001,
								-33.15933947399998
							],
							[
								138.01410032700005,
								-33.178075433999936
							],
							[
								138.03629666400002,
								-33.16948588499997
							],
							[
								138.02423589500006,
								-33.181870103999984
							],
							[
								138.0118614170001,
								-33.17801352399994
							],
							[
								138.0130386080001,
								-33.15370548399994
							],
							[
								138.0013443800001,
								-33.144013462999965
							],
							[
								138.00707955000007,
								-33.13337339299994
							],
							[
								138.0008144410001,
								-33.13163540299996
							],
							[
								137.98764243200003,
								-33.14393740299994
							],
							[
								137.95437158700008,
								-33.15469943099998
							],
							[
								137.96354042500002,
								-33.16049146199998
							],
							[
								137.9583135460001,
								-33.16775142199998
							],
							[
								137.93999354900006,
								-33.15813645099996
							],
							[
								137.9254913000001,
								-33.17648239999994
							],
							[
								137.91178262200003,
								-33.17734619999993
							],
							[
								137.9078235830001,
								-33.17142745999996
							],
							[
								137.85360828000012,
								-33.19682040799995
							],
							[
								137.85296528900005,
								-33.20957558799995
							],
							[
								137.83798934100002,
								-33.20722441699996
							],
							[
								137.82126950200006,
								-33.244917406999946
							],
							[
								137.82675734100008,
								-33.24857941699997
							],
							[
								137.81128131200012,
								-33.26542345699994
							],
							[
								137.81721734000007,
								-33.28639642699994
							],
							[
								137.84345160500004,
								-33.30818543799995
							],
							[
								137.83961256600003,
								-33.30069742799998
							],
							[
								137.8442976350001,
								-33.30374139799994
							],
							[
								137.8425336250001,
								-33.31649143799996
							],
							[
								137.85183747300005,
								-33.32616643799997
							],
							[
								137.87351050900008,
								-33.330265408999935
							],
							[
								137.85883656200008,
								-33.32076237899997
							],
							[
								137.86560746100008,
								-33.31734239899998
							],
							[
								137.87863441900004,
								-33.32987039999995
							],
							[
								137.87414740000008,
								-33.31607841899995
							],
							[
								137.8812505190001,
								-33.32314441999995
							],
							[
								137.88369459700004,
								-33.35238640999995
							],
							[
								137.89122359500004,
								-33.35396445999993
							],
							[
								137.88287845600007,
								-33.35774842999996
							],
							[
								137.89095144500004,
								-33.36682745999997
							],
							[
								137.883265466,
								-33.35939244999997
							],
							[
								137.87550745700003,
								-33.36237244999995
							],
							[
								137.87050345600005,
								-33.39652646999997
							],
							[
								137.90665030900004,
								-33.43411847099998
							],
							[
								137.93289906100006,
								-33.49967089299997
							],
							[
								137.94907545800004,
								-33.51243043299996
							],
							[
								137.94143768900005,
								-33.518093542999964
							],
							[
								137.93943346700007,
								-33.54790427299997
							],
							[
								137.96298385400007,
								-33.55075984399997
							],
							[
								137.97112875300002,
								-33.53941277399997
							],
							[
								137.97747048100007,
								-33.55882051499998
							],
							[
								137.96480268200003,
								-33.574304593999955
							],
							[
								137.95178900400003,
								-33.57328883399998
							],
							[
								137.94677325600003,
								-33.55453508399995
							],
							[
								137.93535951800004,
								-33.55266131299993
							],
							[
								137.93560428600006,
								-33.580087022999976
							],
							[
								137.91755441600003,
								-33.62496475299997
							],
							[
								137.89323776000003,
								-33.62559907199994
							],
							[
								137.90629976000002,
								-33.59643332199994
							],
							[
								137.90357670900005,
								-33.61447212199994
							],
							[
								137.91380451800012,
								-33.61290099299998
							],
							[
								137.92424537700003,
								-33.59739804299994
							],
							[
								137.91966656800003,
								-33.58731621299995
							],
							[
								137.8924690020001,
								-33.587888601999964
							],
							[
								137.87744198400003,
								-33.59810861099993
							],
							[
								137.8572839850001,
								-33.63130738099994
							],
							[
								137.83453411800008,
								-33.64244348999995
							],
							[
								137.800554411,
								-33.68309938899995
							],
							[
								137.75515192600005,
								-33.714208636999956
							],
							[
								137.73643826800003,
								-33.73782278699997
							],
							[
								137.72547866800005,
								-33.76990891599996
							],
							[
								137.643798607,
								-33.83042364399995
							],
							[
								137.60036558100012,
								-33.87678041199996
							],
							[
								137.6254672870001,
								-33.89514841399995
							],
							[
								137.63064732400005,
								-33.92180839399998
							],
							[
								137.60027053800002,
								-33.936299392999956
							],
							[
								137.57572936000008,
								-33.96715444199998
							],
							[
								137.56371363200003,
								-33.97162240199998
							],
							[
								137.55863944200007,
								-33.98883841199995
							],
							[
								137.53871340500007,
								-33.99243741099997
							],
							[
								137.5271325760001,
								-34.00437439099994
							],
							[
								137.5329696550001,
								-34.00166142099994
							],
							[
								137.5523304510001,
								-34.01441038199994
							],
							[
								137.56740385800003,
								-34.04359733199993
							],
							[
								137.52600829000005,
								-34.10827642099997
							],
							[
								137.5222805100001,
								-34.12923742099997
							],
							[
								137.50676451200002,
								-34.137611370999934
							],
							[
								137.4498636510001,
								-34.13550438899995
							],
							[
								137.499911558,
								-34.22649042099994
							],
							[
								137.5003064440001,
								-34.31198638099994
							],
							[
								137.48367047400006,
								-34.34311045099997
							],
							[
								137.4760874530001,
								-34.39244945099995
							],
							[
								137.4651243940001,
								-34.40067445099993
							],
							[
								137.4466642970001,
								-34.39802537999998
							],
							[
								137.4381265070001,
								-34.42793939999996
							],
							[
								137.41694056000006,
								-34.44466139899998
							],
							[
								137.4151563690001,
								-34.45957944899993
							],
							[
								137.42703240600008,
								-34.472583449999945
							],
							[
								137.4460123350001,
								-34.43687739999996
							],
							[
								137.46317642300005,
								-34.42665844099997
							],
							[
								137.4831963790001,
								-34.43926140199994
							],
							[
								137.486644457,
								-34.48165141199996
							],
							[
								137.47382448700012,
								-34.51128939199998
							],
							[
								137.50674827800003,
								-34.582001412999944
							],
							[
								137.50944756600006,
								-34.61794138399995
							],
							[
								137.45961458300008,
								-34.80761638299998
							],
							[
								137.45773249900003,
								-34.88448438399996
							],
							[
								137.44876560900002,
								-34.91030441299995
							],
							[
								137.41535760300007,
								-34.93864541199997
							],
							[
								137.3749522590001,
								-34.953731380999955
							],
							[
								137.35642957200002,
								-34.94657043999996
							],
							[
								137.34696231500004,
								-34.92978641999997
							],
							[
								137.3092522710001,
								-34.927811377999944
							],
							[
								137.29101829500007,
								-34.90100641799995
							],
							[
								137.27648651800007,
								-34.89388640699997
							],
							[
								137.22450541600006,
								-34.904469424999945
							],
							[
								137.19442132100005,
								-34.90100343399996
							],
							[
								137.1460715280001,
								-34.918186411999955
							],
							[
								137.0933833460001,
								-34.91993439099997
							],
							[
								137.020139609,
								-34.90001036799998
							],
							[
								137.01362141000004,
								-34.892965437999976
							],
							[
								137.01256049900007,
								-34.92046636799995
							],
							[
								136.97639239400007,
								-34.94122639699998
							],
							[
								136.96824665200006,
								-35.00040040699997
							],
							[
								136.9436856650001,
								-35.01262844599995
							],
							[
								136.9440935450001,
								-35.02201939599996
							],
							[
								136.930294397,
								-35.02903642599995
							],
							[
								136.96107943900006,
								-35.08228843699993
							],
							[
								136.94179565100012,
								-35.10566035599993
							],
							[
								136.9411303600001,
								-35.12909745699994
							],
							[
								136.913132463,
								-35.153580405999946
							],
							[
								136.897617555,
								-35.15665940499997
							],
							[
								136.88834465500008,
								-35.185238364999975
							],
							[
								136.86597967900002,
								-35.19410939399995
							],
							[
								136.845747662,
								-35.19008738399998
							],
							[
								136.84643240000003,
								-35.22880943399997
							],
							[
								136.82935869300002,
								-35.23321241299993
							],
							[
								136.83411464100004,
								-35.24193143399998
							],
							[
								136.8219344030001,
								-35.24526639299995
							],
							[
								136.84857261700006,
								-35.28209239399996
							],
							[
								136.8705106430001,
								-35.28687239499993
							],
							[
								136.8827383900001,
								-35.30034836599998
							],
							[
								136.899757388,
								-35.28579742599993
							],
							[
								136.9440294410001,
								-35.28213938799996
							],
							[
								136.94525055200006,
								-35.26932140799994
							],
							[
								136.96686244800003,
								-35.26701641799997
							],
							[
								136.96976262900012,
								-35.25206641799997
							],
							[
								136.9827074970001,
								-35.24953643899994
							],
							[
								136.98298650700008,
								-35.23552739899998
							],
							[
								137.001396515,
								-35.223193428999934
							],
							[
								137.0766944730001,
								-35.22634345199998
							],
							[
								137.11143556600007,
								-35.24291739299997
							],
							[
								137.1185765350001,
								-35.23757545299998
							],
							[
								137.14056242100003,
								-35.24382639399994
							],
							[
								137.17399958600004,
								-35.23734540499993
							],
							[
								137.1905815340001,
								-35.22916142599996
							],
							[
								137.190406595,
								-35.20892746599998
							],
							[
								137.20351848400003,
								-35.191908455999965
							],
							[
								137.23774837000008,
								-35.16450139699998
							],
							[
								137.26470839600006,
								-35.15902741799994
							],
							[
								137.2981175000001,
								-35.168294438999965
							],
							[
								137.33489434400008,
								-35.16784444099994
							],
							[
								137.34781545200008,
								-35.16299037099998
							],
							[
								137.334586574,
								-35.163864460999946
							],
							[
								137.342816523,
								-35.16170644099998
							],
							[
								137.3407555440001,
								-35.149448450999955
							],
							[
								137.35227443300005,
								-35.13394639099994
							],
							[
								137.4243514530001,
								-35.09786342399997
							],
							[
								137.46411060700007,
								-35.099204414999974
							],
							[
								137.5107053580001,
								-35.11900243699995
							],
							[
								137.52584227600005,
								-35.11291439699994
							],
							[
								137.55482447100007,
								-35.117441388999964
							],
							[
								137.6375052850001,
								-35.168187441999976
							],
							[
								137.67789438800003,
								-35.16772844299993
							],
							[
								137.69732143600004,
								-35.14152341399995
							],
							[
								137.759116478,
								-35.11434143599996
							],
							[
								137.7434784510001,
								-35.103463405999946
							],
							[
								137.74837230200012,
								-35.08217247599998
							],
							[
								137.724737247,
								-35.053729404999956
							],
							[
								137.73381424600007,
								-35.04414539499993
							],
							[
								137.7639974010001,
								-35.040585455999974
							],
							[
								137.75731148500006,
								-34.99655645499996
							],
							[
								137.79029755400006,
								-34.92228341599997
							],
							[
								137.80503125200005,
								-34.91217343699998
							],
							[
								137.79608021400009,
								-34.906178455999964
							],
							[
								137.80007043500007,
								-34.877532445999975
							],
							[
								137.8317072430001,
								-34.812705456999936
							],
							[
								137.86503028000004,
								-34.777897407999944
							],
							[
								137.85779536200005,
								-34.77118647799995
							],
							[
								137.864954871,
								-34.76606622799994
							],
							[
								137.8688585530001,
								-34.72261940799996
							],
							[
								137.88076554200006,
								-34.695249417999946
							],
							[
								137.87681741400002,
								-34.66839647799998
							],
							[
								137.90768345200001,
								-34.61585448899996
							],
							[
								137.88590346600006,
								-34.608968397999945
							],
							[
								137.8758162890001,
								-34.59766944799998
							],
							[
								137.88759043200002,
								-34.50734840699994
							],
							[
								137.89884655100002,
								-34.49382239799996
							],
							[
								137.91754423200007,
								-34.428142477999984
							],
							[
								138.00710321200006,
								-34.34901842099998
							],
							[
								138.021743323,
								-34.28505643099993
							],
							[
								138.00151024800005,
								-34.26159242999995
							],
							[
								138.00536548800005,
								-34.24426742999998
							],
							[
								138.02935554600003,
								-34.22107246099995
							],
							[
								138.03741054700004,
								-34.18532039099995
							],
							[
								138.07742239300012,
								-34.133537451999985
							],
							[
								138.10327541900006,
								-34.13961344399996
							],
							[
								138.16356029500002,
								-34.21612145599994
							],
							[
								138.16753145300004,
								-34.24532143699997
							],
							[
								138.14621042500005,
								-34.26560446599996
							],
							[
								138.1588863930001,
								-34.272357426999974
							],
							[
								138.1924084970001,
								-34.272159417999944
							],
							[
								138.22236050000004,
								-34.309990478999964
							],
							[
								138.2308655070001,
								-34.34389446999995
							],
							[
								138.22522980700012,
								-34.365894469999944
							],
							[
								138.24698533100002,
								-34.40088363099994
							],
							[
								138.26563930400005,
								-34.47678818199995
							],
							[
								138.34439267800008,
								-34.53119883599993
							],
							[
								138.3495228160001,
								-34.557515025999976
							],
							[
								138.36431677200005,
								-34.57813503699998
							],
							[
								138.40843906400005,
								-34.600246538999954
							],
							[
								138.41325020200009,
								-34.620838628999934
							],
							[
								138.42647433000002,
								-34.62161549999996
							],
							[
								138.4457883350001,
								-34.65337946099993
							],
							[
								138.43625012600012,
								-34.65387248999997
							],
							[
								138.42984243700005,
								-34.66423960999998
							],
							[
								138.43565228500006,
								-34.67274546999994
							],
							[
								138.46443629100008,
								-34.67334446099994
							],
							[
								138.4886992580001,
								-34.65844746199997
							],
							[
								138.4919512680001,
								-34.647435471999984
							],
							[
								138.52048926400005,
								-34.63695646399998
							],
							[
								138.5908512530001,
								-34.63884046599998
							],
							[
								138.60002424200002,
								-34.632519456999944
							],
							[
								138.617559249,
								-34.63373846799993
							],
							[
								138.62559825800008,
								-34.62562946799994
							],
							[
								138.64643223500002,
								-34.63044146899995
							],
							[
								138.65288025400002,
								-34.62216846899997
							],
							[
								138.66797026200004,
								-34.61999246999994
							],
							[
								138.66856123200012,
								-34.613001459999964
							],
							[
								138.68396825000002,
								-34.61190845999994
							],
							[
								138.68245124200007,
								-34.58653147999996
							],
							[
								138.69614822900007,
								-34.59324247099994
							],
							[
								138.71551026600002,
								-34.59177947099994
							],
							[
								138.70331124000006,
								-34.56494947099998
							],
							[
								138.7219042270001,
								-34.56679239199997
							],
							[
								138.72355326700006,
								-34.555925471999956
							],
							[
								138.74747222300005,
								-34.55823447299997
							],
							[
								138.7531202350001,
								-34.512732461999974
							],
							[
								138.74675223100007,
								-34.437277481999956
							],
							[
								138.73747725500004,
								-34.39414047099996
							],
							[
								138.71830026800012,
								-34.392254469999955
							],
							[
								138.7215573090001,
								-34.369235439999954
							],
							[
								138.7384336660001,
								-34.368610470999954
							],
							[
								138.7397207260001,
								-34.361613330999944
							],
							[
								138.76059639300001,
								-34.365570091999984
							],
							[
								138.78466675100003,
								-34.34142859299993
							],
							[
								138.77943305400004,
								-34.298270971999955
							],
							[
								138.8370261350001,
								-34.300583364999966
							],
							[
								138.83885533700004,
								-34.26909573499995
							],
							[
								138.82722724000007,
								-34.238270513999964
							],
							[
								138.8278858110001,
								-34.23121350399998
							],
							[
								138.83900845900007,
								-34.231678113999976
							],
							[
								138.84086958900002,
								-34.22097925399993
							],
							[
								138.82817916200008,
								-34.21175868399996
							],
							[
								138.83582066100007,
								-34.212409183999966
							],
							[
								138.8383831010001,
								-34.19347916399994
							],
							[
								138.90295087200002,
								-34.18754906699996
							],
							[
								138.9091329800001,
								-34.197804546999976
							],
							[
								138.97161104100007,
								-34.19362548999993
							],
							[
								138.96583754100004,
								-34.20181734999994
							],
							[
								138.97808785600012,
								-34.254379419999964
							],
							[
								138.9977931830001,
								-34.255932360999964
							],
							[
								139.00808271200003,
								-34.242825581999966
							],
							[
								139.04855262500007,
								-34.244772282999975
							],
							[
								139.03408435400002,
								-34.30671559299998
							],
							[
								139.12739662900003,
								-34.315009086999964
							],
							[
								139.10504508100007,
								-34.33001596599996
							],
							[
								139.15584249300002,
								-34.33518696899995
							],
							[
								139.19964627800005,
								-34.31210779099996
							],
							[
								139.26438139900006,
								-34.29581889299993
							],
							[
								139.26424736700005,
								-34.319351092999966
							],
							[
								139.35079078400008,
								-34.319331716999955
							],
							[
								139.3580455020001,
								-34.175425136999934
							],
							[
								139.3559411860001,
								-33.80299948399994
							],
							[
								139.69999115400003,
								-33.80058151999998
							],
							[
								139.69923512900004,
								-33.87518050999995
							],
							[
								139.85708380500012,
								-33.87530311799998
							],
							[
								139.85742109500006,
								-34.024347518999946
							],
							[
								139.90085608800007,
								-34.02427452099994
							],
							[
								139.9165648070001,
								-34.00786638099993
							],
							[
								139.916662631,
								-33.943956990999936
							],
							[
								139.98004422100007,
								-33.94429746399993
							],
							[
								139.98361111200006,
								-33.93192052399996
							],
							[
								139.99711807800009,
								-33.94853252499996
							],
							[
								140.04480010100008,
								-33.952413526999976
							],
							[
								140.05326104900007,
								-33.959652527999936
							],
							[
								140.0552640520001,
								-34.05714252799993
							],
							[
								140.35465700600002,
								-34.05332253299997
							],
							[
								140.3551747900001,
								-34.13287231299995
							],
							[
								140.3741607080001,
								-34.11941445399998
							],
							[
								140.4061709120001,
								-34.13344394599994
							],
							[
								140.65728221400002,
								-34.12924856799998
							],
							[
								140.65784220700004,
								-34.08531925799997
							],
							[
								140.63526918200012,
								-34.064247756999976
							],
							[
								140.69333031300005,
								-34.06448633999997
							],
							[
								140.689280606,
								-34.04110405899996
							],
							[
								140.72187499300003,
								-34.00306562099996
							],
							[
								140.81295795200003,
								-33.96834928499993
							],
							[
								140.82799252200005,
								-33.935808745999964
							],
							[
								140.86763896600007,
								-33.937454137999964
							],
							[
								140.87892366500012,
								-33.928799037999966
							],
							[
								140.8847032660001,
								-33.897263297999984
							],
							[
								140.8625399650001,
								-33.82608056699996
							],
							[
								140.84926395800005,
								-33.80826955599997
							],
							[
								140.8578969770001,
								-33.80175456599994
							],
							[
								140.85150696300002,
								-33.74205756599997
							],
							[
								140.6894489970001,
								-33.74173855699996
							],
							[
								140.702818986,
								-33.73416755799997
							],
							[
								140.69918900200003,
								-33.519311555999934
							],
							[
								140.43376305200002,
								-33.52013655299993
							],
							[
								140.43659407500002,
								-33.32420455199997
							],
							[
								141.0024129400001,
								-33.33000950099995
							],
							[
								141.00241215000005,
								-33.329009550999956
							],
							[
								141.00153704100012,
								-32.21805605299994
							],
							[
								141.00060143300004,
								-31.199954385999945
							],
							[
								141.00033710200012,
								-30.050610947999928
							],
							[
								140.9992722830001,
								-28.999086879999936
							],
							[
								140.9994210210001,
								-28.269981104999943
							],
							[
								140.9995638800001,
								-27.515807029999962
							],
							[
								140.99944342900005,
								-26.75569802399997
							],
							[
								140.99939597700006,
								-25.996378017999973
							],
							[
								140.1145179030001,
								-25.996522984999956
							],
							[
								139.39152065200005,
								-25.99661194099997
							],
							[
								137.99906130500005,
								-25.996849173999976
							],
							[
								136.91591723400006,
								-25.997755943999948
							],
							[
								135.73128661500004,
								-25.998515186999953
							],
							[
								134.60529752000002,
								-25.998528676999968
							],
							[
								133.50330305300008,
								-25.998534522999933
							],
							[
								132.37372427900004,
								-25.99856034399994
							],
							[
								131.2573457730001,
								-25.998576500999945
							],
							[
								130.1053245920001,
								-25.99856399199996
							],
							[
								129.0018469360001,
								-25.998591869999927
							],
							[
								129.0018590960001,
								-26.74500413399994
							],
							[
								129.00188186600008,
								-28.11589847299996
							],
							[
								129.00189741600002,
								-29.033055028999968
							],
							[
								129.00191947500002,
								-30.305436806999978
							],
							[
								129.00192754400007,
								-31.686990624999964
							]
						]
					],
					[
						[
							[
								135.15859352600012,
								-34.72933690899998
							],
							[
								135.1666305750001,
								-34.71935759899998
							],
							[
								135.1505095870001,
								-34.732363118999956
							],
							[
								135.15859352600012,
								-34.72933690899998
							]
						]
					],
					[
						[
							[
								136.11504529400008,
								-35.33794161099996
							],
							[
								136.1264411420001,
								-35.34007250099995
							],
							[
								136.11105533500006,
								-35.33276355999993
							],
							[
								136.11504529400008,
								-35.33794161099996
							]
						]
					],
					[
						[
							[
								136.1127312750001,
								-35.322356329999934
							],
							[
								136.1151602750001,
								-35.32961942999998
							],
							[
								136.11826215500002,
								-35.31687310999996
							],
							[
								136.1127312750001,
								-35.322356329999934
							]
						]
					],
					[
						[
							[
								136.85858715100005,
								-35.374275584999964
							],
							[
								136.86698502900003,
								-35.37239248499998
							],
							[
								136.8609350810001,
								-35.36558454499993
							],
							[
								136.85858715100005,
								-35.374275584999964
							]
						]
					],
					[
						[
							[
								136.05552753900008,
								-35.23529421799998
							],
							[
								136.07232833600006,
								-35.23749671899998
							],
							[
								136.07251328600012,
								-35.226446668999984
							],
							[
								136.06371232800007,
								-35.22293090799997
							],
							[
								136.05552753900008,
								-35.23529421799998
							]
						]
					],
					[
						[
							[
								135.97580028100003,
								-35.024974903999976
							],
							[
								135.9656233830001,
								-35.02203514399997
							],
							[
								135.97502531100008,
								-35.03754199399998
							],
							[
								135.98307024000007,
								-35.03359178499994
							],
							[
								135.97861122100005,
								-35.01977781399995
							],
							[
								135.97580028100003,
								-35.024974903999976
							]
						]
					],
					[
						[
							[
								136.1455289050001,
								-34.99811546899997
							],
							[
								136.15746779300002,
								-35.00793431999995
							],
							[
								136.15920085200003,
								-35.02083024999996
							],
							[
								136.14679308400002,
								-35.02657932999995
							],
							[
								136.15579405100004,
								-35.04718415999997
							],
							[
								136.16790791900007,
								-35.05879599999997
							],
							[
								136.1769218170001,
								-35.06147891099994
							],
							[
								136.18782458600003,
								-35.05201289099995
							],
							[
								136.2032994430001,
								-35.06405970199995
							],
							[
								136.20431535300008,
								-35.05208474199998
							],
							[
								136.19250844500004,
								-35.04431085099998
							],
							[
								136.18971524800008,
								-35.00443507099993
							],
							[
								136.17609345000005,
								-35.00574016999997
							],
							[
								136.14995076500009,
								-34.987881468999944
							],
							[
								136.12953891000006,
								-34.95236079899996
							],
							[
								136.1040143250001,
								-34.93242812799997
							],
							[
								136.07940569800007,
								-34.95014246699998
							],
							[
								136.08919057600008,
								-34.95599425699993
							],
							[
								136.08401871700005,
								-34.966670326999974
							],
							[
								136.1099095820001,
								-34.96872641799996
							],
							[
								136.11189233200002,
								-34.97701284799996
							],
							[
								136.1455289050001,
								-34.99811546899997
							]
						]
					],
					[
						[
							[
								136.0513721320001,
								-34.97027299599995
							],
							[
								136.06548196900007,
								-34.96831669699998
							],
							[
								136.06756386000006,
								-34.959196676999966
							],
							[
								136.05990598100004,
								-34.95738282599996
							],
							[
								136.0513721320001,
								-34.97027299599995
							]
						]
					],
					[
						[
							[
								136.4522210780001,
								-35.14580195999997
							],
							[
								136.44152826000004,
								-35.14868502999997
							],
							[
								136.44436824900004,
								-35.16030201999996
							],
							[
								136.45307809700012,
								-35.16605895999993
							],
							[
								136.46870889500008,
								-35.163422870999966
							],
							[
								136.49153555100008,
								-35.17564373199997
							],
							[
								136.49304151100011,
								-35.15977373199996
							],
							[
								136.45278701900008,
								-35.13411596999998
							],
							[
								136.4522210780001,
								-35.14580195999997
							]
						]
					],
					[
						[
							[
								136.03150712800004,
								-34.908701614999984
							],
							[
								136.0324031570001,
								-34.918053534999956
							],
							[
								136.03822403700008,
								-34.90734948599993
							],
							[
								136.03150712800004,
								-34.908701614999984
							]
						]
					],
					[
						[
							[
								136.00145131400006,
								-34.87861737399993
							],
							[
								136.0107012520001,
								-34.89132611499997
							],
							[
								136.0118231130001,
								-34.86609124399996
							],
							[
								136.00145131400006,
								-34.87861737399993
							]
						]
					],
					[
						[
							[
								136.27868520900006,
								-34.681067301999974
							],
							[
								136.26693239100007,
								-34.67314534099995
							],
							[
								136.26918152000007,
								-34.68331636099998
							],
							[
								136.27868520900006,
								-34.681067301999974
							]
						]
					],
					[
						[
							[
								135.92120674400007,
								-34.712869900999976
							],
							[
								135.92949257200007,
								-34.73320413099998
							],
							[
								135.9372704210001,
								-34.719724000999975
							],
							[
								135.95281018900005,
								-34.724640041999976
							],
							[
								135.93987240100012,
								-34.711583910999934
							],
							[
								135.93858139300005,
								-34.68743362099997
							],
							[
								135.92104676600002,
								-34.682831560999944
							],
							[
								135.91788181700008,
								-34.67292243999998
							],
							[
								135.91138992700007,
								-34.69545569999997
							],
							[
								135.92340867400003,
								-34.70185577099994
							],
							[
								135.92120674400007,
								-34.712869900999976
							]
						]
					],
					[
						[
							[
								137.35018429800004,
								-34.48154638699998
							],
							[
								137.33854263000012,
								-34.488114406999955
							],
							[
								137.33728552900004,
								-34.49928438699993
							],
							[
								137.34099063700012,
								-34.52631642699998
							],
							[
								137.35203758500006,
								-34.534116446999974
							],
							[
								137.36605960300005,
								-34.528740407999976
							],
							[
								137.37148551300004,
								-34.505894437999984
							],
							[
								137.38177431200006,
								-34.497287367999945
							],
							[
								137.37486844500006,
								-34.46883342799998
							],
							[
								137.36350037700004,
								-34.462441456999954
							],
							[
								137.35018429800004,
								-34.48154638699998
							]
						]
					],
					[
						[
							[
								136.355578357,
								-34.65557204399994
							],
							[
								136.33537418100002,
								-34.650827052999944
							],
							[
								136.32990028100005,
								-34.65835007299995
							],
							[
								136.34449206800002,
								-34.68259197399993
							],
							[
								136.34589198800006,
								-34.67123897399995
							],
							[
								136.35886178600003,
								-34.66445393399994
							],
							[
								136.355578357,
								-34.65557204399994
							]
						]
					],
					[
						[
							[
								136.28566828500004,
								-34.52336092099995
							],
							[
								136.28631217500003,
								-34.51305198099993
							],
							[
								136.3034108930001,
								-34.50245194099995
							],
							[
								136.2886971250001,
								-34.507791990999976
							],
							[
								136.27994318700007,
								-34.50387605099996
							],
							[
								136.27057859600006,
								-34.54212889099995
							],
							[
								136.27557354500004,
								-34.54959482099997
							],
							[
								136.2865303740001,
								-34.54539481099994
							],
							[
								136.27858943500007,
								-34.53764088099996
							],
							[
								136.28566828500004,
								-34.52336092099995
							]
						]
					],
					[
						[
							[
								136.2513107200001,
								-34.52659105999993
							],
							[
								136.261030569,
								-34.52343902999996
							],
							[
								136.25562163000006,
								-34.518989089999934
							],
							[
								136.2513107200001,
								-34.52659105999993
							]
						]
					],
					[
						[
							[
								135.95246672500002,
								-34.591308380999976
							],
							[
								135.95936566400007,
								-34.58813627099994
							],
							[
								135.95894157400005,
								-34.57486310099995
							],
							[
								135.9462127070001,
								-34.56830906099998
							],
							[
								135.95246672500002,
								-34.591308380999976
							]
						]
					],
					[
						[
							[
								134.26875596500008,
								-33.96528233199996
							],
							[
								134.27413898400005,
								-33.96505931199994
							],
							[
								134.264328986,
								-33.95740433199995
							],
							[
								134.2769019640001,
								-33.944166321999944
							],
							[
								134.26445797700012,
								-33.93704632199996
							],
							[
								134.25990599600004,
								-33.96250531199996
							],
							[
								134.26875596500008,
								-33.96528233199996
							]
						]
					],
					[
						[
							[
								134.24157799800003,
								-34.00919432099994
							],
							[
								134.251034956,
								-34.00598131199996
							],
							[
								134.24466596800005,
								-33.996688320999965
							],
							[
								134.24157799800003,
								-34.00919432099994
							]
						]
					],
					[
						[
							[
								134.45107406300008,
								-33.762570954999944
							],
							[
								134.44877715300004,
								-33.773657914999944
							],
							[
								134.49609045700004,
								-33.74579822599998
							],
							[
								134.50482687600004,
								-33.72438599599997
							],
							[
								134.5176589250001,
								-33.71791074599997
							],
							[
								134.54701258000011,
								-33.72448026699993
							],
							[
								134.5275699550001,
								-33.67767141599995
							],
							[
								134.48340445100007,
								-33.69399924499993
							],
							[
								134.47002913300003,
								-33.69226645499998
							],
							[
								134.467855632,
								-33.73341965499998
							],
							[
								134.45385569400003,
								-33.74055293499998
							],
							[
								134.45814506300007,
								-33.75073187499993
							],
							[
								134.45107406300008,
								-33.762570954999944
							]
						]
					],
					[
						[
							[
								134.6113582800001,
								-33.716472187999955
							],
							[
								134.61689722900007,
								-33.716318128999944
							],
							[
								134.61057721100008,
								-33.71195217799993
							],
							[
								134.6113582800001,
								-33.716472187999955
							]
						]
					],
					[
						[
							[
								134.808833724,
								-33.60702114299994
							],
							[
								134.80961249400002,
								-33.59077609299993
							],
							[
								134.77605931900007,
								-33.595025411999984
							],
							[
								134.808833724,
								-33.60702114299994
							]
						]
					],
					[
						[
							[
								134.6662961500001,
								-33.21397408699994
							],
							[
								134.6768100480001,
								-33.216985016999956
							],
							[
								134.68179674700002,
								-33.20804597699998
							],
							[
								134.67076783900006,
								-33.20241306699995
							],
							[
								134.6662961500001,
								-33.21397408699994
							]
						]
					],
					[
						[
							[
								134.2758721560001,
								-32.675349403999974
							],
							[
								134.25974126900007,
								-32.67863749399993
							],
							[
								134.27699711600008,
								-32.68178338399997
							],
							[
								134.2758721560001,
								-32.675349403999974
							]
						]
					],
					[
						[
							[
								133.28557729600004,
								-32.579961271999935
							],
							[
								133.27773326700003,
								-32.58728727199997
							],
							[
								133.28940300500005,
								-32.58646233299993
							],
							[
								133.28557729600004,
								-32.579961271999935
							]
						]
					],
					[
						[
							[
								133.2802622470001,
								-32.567539291999935
							],
							[
								133.29166414600002,
								-32.56749132199997
							],
							[
								133.2987090150001,
								-32.556310252999936
							],
							[
								133.28370926700006,
								-32.554063321999934
							],
							[
								133.2860481460001,
								-32.564114261999975
							],
							[
								133.27581409800007,
								-32.56251125199998
							],
							[
								133.2802622470001,
								-32.567539291999935
							]
						]
					],
					[
						[
							[
								133.3338561710001,
								-32.49334329299995
							],
							[
								133.3364301910001,
								-32.48354733299993
							],
							[
								133.33047828200006,
								-32.48415628299995
							],
							[
								133.3338561710001,
								-32.49334329299995
							]
						]
					],
					[
						[
							[
								133.28703134700004,
								-32.52330430199993
							],
							[
								133.28762421700003,
								-32.528462281999964
							],
							[
								133.30301316500004,
								-32.523038251999935
							],
							[
								133.31106816400006,
								-32.51044428299997
							],
							[
								133.3101170550001,
								-32.49927033199998
							],
							[
								133.2922340570001,
								-32.502099301999976
							],
							[
								133.28856131800012,
								-32.490537261999975
							],
							[
								133.26777600100002,
								-32.50047633199995
							],
							[
								133.28002210900002,
								-32.50650526199996
							],
							[
								133.277387319,
								-32.51759432199998
							],
							[
								133.28765016700004,
								-32.517262321999965
							],
							[
								133.28703134700004,
								-32.52330430199993
							]
						]
					],
					[
						[
							[
								133.66996904300004,
								-32.43861429899994
							],
							[
								133.65850198400005,
								-32.45561627899997
							],
							[
								133.68350827100005,
								-32.44063730899995
							],
							[
								133.67851325200002,
								-32.43433829899993
							],
							[
								133.66996904300004,
								-32.43861429899994
							]
						]
					],
					[
						[
							[
								133.64844104600002,
								-32.452529298999934
							],
							[
								133.6340630080001,
								-32.44997930899996
							],
							[
								133.62551623900004,
								-32.45714332799997
							],
							[
								133.63965593700004,
								-32.463205278999965
							],
							[
								133.65495702500004,
								-32.45108325899997
							],
							[
								133.64844104600002,
								-32.452529298999934
							]
						]
					],
					[
						[
							[
								133.50346906100003,
								-32.315323304999936
							],
							[
								133.51573929900007,
								-32.31590631499995
							],
							[
								133.53073510700005,
								-32.304589275999945
							],
							[
								133.51499806000004,
								-32.30125233499996
							],
							[
								133.50346906100003,
								-32.315323304999936
							]
						]
					],
					[
						[
							[
								133.60929962600005,
								-32.28967891699995
							],
							[
								133.62840201400002,
								-32.27134632699995
							],
							[
								133.6151010860001,
								-32.27032725699996
							],
							[
								133.6143522870001,
								-32.25680132699995
							],
							[
								133.64431006300003,
								-32.23758634699993
							],
							[
								133.6740050290001,
								-32.23248026799996
							],
							[
								133.62383111600002,
								-32.23927833699997
							],
							[
								133.5817370210001,
								-32.26843031599998
							],
							[
								133.57542296200006,
								-32.26445024599997
							],
							[
								133.59358715000008,
								-32.25102927599994
							],
							[
								133.56722397300007,
								-32.266859275999934
							],
							[
								133.5510801360001,
								-32.263595245999966
							],
							[
								133.55138001500006,
								-32.27312030599995
							],
							[
								133.54026320700007,
								-32.27873433599996
							],
							[
								133.54973696500008,
								-32.30808432599997
							],
							[
								133.5712739710001,
								-32.319082315999935
							],
							[
								133.58032330000003,
								-32.30656728699995
							],
							[
								133.6006632870001,
								-32.30763729699993
							],
							[
								133.60929962600005,
								-32.28967891699995
							]
						]
					],
					[
						[
							[
								133.36837115900005,
								-32.39622933299995
							],
							[
								133.3666993490001,
								-32.40291830299998
							],
							[
								133.37441806800007,
								-32.40317832299996
							],
							[
								133.381926227,
								-32.39473325299997
							],
							[
								133.36837115900005,
								-32.39622933299995
							]
						]
					],
					[
						[
							[
								133.47589809300007,
								-32.379090264999945
							],
							[
								133.48387210200008,
								-32.38259929499998
							],
							[
								133.48616098200011,
								-32.367563254999936
							],
							[
								133.47589809300007,
								-32.379090264999945
							]
						]
					],
					[
						[
							[
								133.83130300200003,
								-32.35840234199998
							],
							[
								133.8299631220001,
								-32.35227127199994
							],
							[
								133.8162370440001,
								-32.35470631199996
							],
							[
								133.83130300200003,
								-32.35840234199998
							]
						]
					],
					[
						[
							[
								133.7680431010001,
								-32.362505270999975
							],
							[
								133.75957412200012,
								-32.36466527099998
							],
							[
								133.77486404,
								-32.36190128099997
							],
							[
								133.7680431010001,
								-32.362505270999975
							]
						]
					],
					[
						[
							[
								133.78851594800005,
								-32.359428340999955
							],
							[
								133.85752502700007,
								-32.387558302999935
							],
							[
								133.84077208000008,
								-32.371945281999956
							],
							[
								133.80694107500005,
								-32.35893632199998
							],
							[
								133.81453599400004,
								-32.35543728199997
							],
							[
								133.78851594800005,
								-32.359428340999955
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "404",
				"CED_NAME21": "Grey",
				"STE_CODE21": "4",
				"STE_NAME21": "South Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 911570.4245,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/404",
				"SHAPE_Leng": 70.1602362903,
				"SHAPE_Area": 84.9937800157
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								138.55499881800006,
								-34.96722314699997
							],
							[
								138.5467225970001,
								-34.85056909599996
							],
							[
								138.56454675400005,
								-34.84974375699994
							],
							[
								138.56337232500005,
								-34.83273537699995
							],
							[
								138.575394253,
								-34.83182846699998
							],
							[
								138.5662002350001,
								-34.825380466999945
							],
							[
								138.54573917900007,
								-34.81059620599996
							],
							[
								138.53082930100004,
								-34.82255948499994
							],
							[
								138.53289640100002,
								-34.81501244499998
							],
							[
								138.51616721400012,
								-34.81082149399998
							],
							[
								138.5108043030001,
								-34.842290453999965
							],
							[
								138.4982644050001,
								-34.84379247399994
							],
							[
								138.497121665,
								-34.85053799399998
							],
							[
								138.5115528440001,
								-34.81807168399996
							],
							[
								138.51576513700002,
								-34.771595443999956
							],
							[
								138.50484739900003,
								-34.76304248399998
							],
							[
								138.48763039100004,
								-34.77057646299994
							],
							[
								138.47800468200012,
								-34.782926172999964
							],
							[
								138.48992324800008,
								-34.81493648299994
							],
							[
								138.47606718800012,
								-34.856752462999964
							],
							[
								138.5085856060001,
								-34.96437971499995
							],
							[
								138.52305114400008,
								-34.96496109599997
							],
							[
								138.53242481200004,
								-34.975601325999946
							],
							[
								138.55499881800006,
								-34.96722314699997
							]
						]
					],
					[
						[
							[
								138.52722021500006,
								-34.76869348499997
							],
							[
								138.5146224980001,
								-34.75689053399998
							],
							[
								138.52250967600003,
								-34.76965444399997
							],
							[
								138.5160981150001,
								-34.79690749399998
							],
							[
								138.52355226300006,
								-34.809025464999934
							],
							[
								138.54625595000005,
								-34.800118175999955
							],
							[
								138.52722021500006,
								-34.76869348499997
							]
						]
					],
					[
						[
							[
								138.5247214630001,
								-34.81027848499997
							],
							[
								138.54407909000008,
								-34.80595620599996
							],
							[
								138.53772809100008,
								-34.80139328499996
							],
							[
								138.5247214630001,
								-34.81027848499997
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "405",
				"CED_NAME21": "Hindmarsh",
				"STE_CODE21": "4",
				"STE_NAME21": "South Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 122.4967,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/405",
				"SHAPE_Leng": 0.988329569348,
				"SHAPE_Area": 0.0120762878237
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							138.46198648600011,
							-35.247347814999955
						],
						[
							138.4942814310001,
							-35.243009805999975
						],
						[
							138.49008736400003,
							-35.21190515599994
						],
						[
							138.50383107200003,
							-35.20051655599997
						],
						[
							138.49496646500006,
							-35.18521322599997
						],
						[
							138.50371230400003,
							-35.17759346599996
						],
						[
							138.53575196000008,
							-35.161120806999975
						],
						[
							138.5793133530001,
							-35.16060343899994
						],
						[
							138.59525414100005,
							-35.14311150999998
						],
						[
							138.59466755200003,
							-35.13384740999993
						],
						[
							138.58563102300002,
							-35.13234566899996
						],
						[
							138.5953488230001,
							-35.108630339999934
						],
						[
							138.58535924600005,
							-35.09684546899996
						],
						[
							138.61926833100006,
							-35.08611664999995
						],
						[
							138.62813476000008,
							-35.068939530999955
						],
						[
							138.60995324400005,
							-35.052237469999966
						],
						[
							138.61284126400005,
							-35.04677143999993
						],
						[
							138.5991281460001,
							-35.04942248899994
						],
						[
							138.5863179590001,
							-35.03794102899997
						],
						[
							138.5712493410001,
							-35.03798950799995
						],
						[
							138.5629663640001,
							-35.02328093799997
						],
						[
							138.556067094,
							-35.03128640799997
						],
						[
							138.55965522200006,
							-35.053699467999934
						],
						[
							138.50369351100005,
							-35.056530504999955
						],
						[
							138.49357542100006,
							-35.08459546499995
						],
						[
							138.46907023400001,
							-35.10941747399994
						],
						[
							138.46993709600008,
							-35.239143464999984
						],
						[
							138.46198648600011,
							-35.247347814999955
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "406",
				"CED_NAME21": "Kingston",
				"STE_CODE21": "4",
				"STE_NAME21": "South Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 164.3511,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/406",
				"SHAPE_Leng": 0.838944449395,
				"SHAPE_Area": 0.0162512286324
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							138.6353472830001,
							-34.84683474999997
						],
						[
							138.7274672090001,
							-34.83711146299993
						],
						[
							138.73155520800003,
							-34.84314848399998
						],
						[
							138.74703518600006,
							-34.84066030399998
						],
						[
							138.75610540500008,
							-34.82105920499998
						],
						[
							138.7508585270001,
							-34.80696529399995
						],
						[
							138.7617600860001,
							-34.79422807499998
						],
						[
							138.75377399800004,
							-34.784220173999984
						],
						[
							138.76961269600008,
							-34.78089692499998
						],
						[
							138.78019704500002,
							-34.76701287499998
						],
						[
							138.76848112800008,
							-34.75346286499996
						],
						[
							138.77577393800004,
							-34.73483366499994
						],
						[
							138.7518118700001,
							-34.749074753999935
						],
						[
							138.73636584400003,
							-34.73566396299998
						],
						[
							138.7200243950001,
							-34.75545045299998
						],
						[
							138.67933938200008,
							-34.75385845099993
						],
						[
							138.6470455750001,
							-34.79178209999998
						],
						[
							138.60741632200006,
							-34.76771004799997
						],
						[
							138.5932927240001,
							-34.77114889699993
						],
						[
							138.5775822160001,
							-34.78926953699994
						],
						[
							138.5491292600001,
							-34.78618145599995
						],
						[
							138.55594224800006,
							-34.80112046599993
						],
						[
							138.54671226900007,
							-34.80996346599994
						],
						[
							138.5662002350001,
							-34.825380466999945
						],
						[
							138.575394253,
							-34.83182846699998
						],
						[
							138.56337232500005,
							-34.83273537699995
						],
						[
							138.56454675400005,
							-34.84974375699994
						],
						[
							138.6353472830001,
							-34.84683474999997
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "407",
				"CED_NAME21": "Makin",
				"STE_CODE21": "4",
				"STE_NAME21": "South Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 162.6622,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/407",
				"SHAPE_Leng": 0.775821015087,
				"SHAPE_Area": 0.0160235125686
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								137.58655666100003,
								-35.732733853999946
							],
							[
								137.57730351300006,
								-35.723415442999965
							],
							[
								137.580118394,
								-35.70760145299994
							],
							[
								137.60335637100002,
								-35.69266442399993
							],
							[
								137.61207052100008,
								-35.672755423999945
							],
							[
								137.64417655600005,
								-35.65420158499995
							],
							[
								137.6412244180001,
								-35.63887745499994
							],
							[
								137.5806515170001,
								-35.64161445299993
							],
							[
								137.5698454300001,
								-35.63258447199996
							],
							[
								137.569121461,
								-35.61973346199994
							],
							[
								137.60679328600008,
								-35.590989442999955
							],
							[
								137.618878504,
								-35.589837443999954
							],
							[
								137.6266843620001,
								-35.59714742399996
							],
							[
								137.63314924300005,
								-35.56425846399998
							],
							[
								137.6216684950001,
								-35.561174413999936
							],
							[
								137.60402632800003,
								-35.57166645299998
							],
							[
								137.5917441900001,
								-35.56407440299995
							],
							[
								137.56437522400006,
								-35.57111141199994
							],
							[
								137.54579131600008,
								-35.587207460999934
							],
							[
								137.51881651000008,
								-35.595517419999965
							],
							[
								137.49100544600003,
								-35.57975338899996
							],
							[
								137.44693926200011,
								-35.59620943699997
							],
							[
								137.31349630500006,
								-35.579226432999974
							],
							[
								137.28515026900004,
								-35.59802239199996
							],
							[
								137.23946340600003,
								-35.60417738999996
							],
							[
								137.20347350100008,
								-35.62470143899998
							],
							[
								137.1849622740001,
								-35.62119540799995
							],
							[
								137.16347749700003,
								-35.63309745699996
							],
							[
								137.1411963710001,
								-35.629748366999934
							],
							[
								137.12178731300003,
								-35.65171944599996
							],
							[
								137.06965933000004,
								-35.669141373999935
							],
							[
								136.95272956000008,
								-35.67409343999998
							],
							[
								136.86171759400008,
								-35.693830436999974
							],
							[
								136.78367143600008,
								-35.700199374999954
							],
							[
								136.77842332700004,
								-35.71219638399998
							],
							[
								136.75879362900002,
								-35.722702433999984
							],
							[
								136.72029952600008,
								-35.72027242299998
							],
							[
								136.6972656590001,
								-35.73945441199993
							],
							[
								136.58744338600002,
								-35.74884337799995
							],
							[
								136.57379541800003,
								-35.76587641799995
							],
							[
								136.5793685960001,
								-35.79236034799993
							],
							[
								136.56048546700003,
								-35.828305367999974
							],
							[
								136.5639155550001,
								-35.849521427999946
							],
							[
								136.54057135900007,
								-35.85935042699998
							],
							[
								136.53441753800007,
								-35.88646137699993
							],
							[
								136.5499943860001,
								-35.88481041799997
							],
							[
								136.5388606470001,
								-35.899315367999975
							],
							[
								136.55077449500004,
								-35.901916367999945
							],
							[
								136.5797865190001,
								-35.93071439899995
							],
							[
								136.58037259800005,
								-35.94892237899995
							],
							[
								136.59527440400007,
								-35.96092541999997
							],
							[
								136.6248066600001,
								-35.954356400999984
							],
							[
								136.66562745200008,
								-35.97573139199994
							],
							[
								136.70844256200007,
								-36.03691241399997
							],
							[
								136.7056414110001,
								-36.051268413999935
							],
							[
								136.69626342300012,
								-36.05464538399997
							],
							[
								136.70524363100003,
								-36.064050373999976
							],
							[
								136.72709562800003,
								-36.045057404999966
							],
							[
								136.75799762300005,
								-36.04971742599997
							],
							[
								136.77498351000008,
								-36.04361740599995
							],
							[
								136.78184442000008,
								-36.031394416999944
							],
							[
								136.81674746300007,
								-36.038831407999965
							],
							[
								136.83169359200008,
								-36.019751387999975
							],
							[
								136.85405246800008,
								-36.01656143899993
							],
							[
								136.91546052600006,
								-36.04356243099994
							],
							[
								136.94216932300003,
								-36.026674371999945
							],
							[
								136.99728636400005,
								-36.01732438399995
							],
							[
								137.03608931700012,
								-36.02763739499994
							],
							[
								137.05762738400006,
								-36.02008637599994
							],
							[
								137.09238825800003,
								-36.02509136699996
							],
							[
								137.10259533600004,
								-36.01815742799994
							],
							[
								137.13095434100012,
								-36.033971408999946
							],
							[
								137.14581045900002,
								-36.02069243899996
							],
							[
								137.16268940600003,
								-36.02472543999994
							],
							[
								137.16132357700008,
								-36.016465419999975
							],
							[
								137.1897794130001,
								-35.99706439099998
							],
							[
								137.17996941500007,
								-35.993944459999966
							],
							[
								137.18085647500004,
								-35.983971459999964
							],
							[
								137.20949733100008,
								-35.97397445099995
							],
							[
								137.2579522320001,
								-35.98220747299996
							],
							[
								137.278371428,
								-35.99424442399993
							],
							[
								137.29619937500001,
								-35.990308453999944
							],
							[
								137.32472324000003,
								-35.99794442499996
							],
							[
								137.33264826900006,
								-35.99301341599994
							],
							[
								137.37102535200006,
								-35.998402426999974
							],
							[
								137.3794515200001,
								-36.01387847799998
							],
							[
								137.40681329500012,
								-36.03239839899993
							],
							[
								137.405612334,
								-36.038777418999985
							],
							[
								137.42024453200008,
								-36.04140243899997
							],
							[
								137.46073050300004,
								-36.07495741099996
							],
							[
								137.48278734000007,
								-36.06566140199993
							],
							[
								137.48540129000003,
								-36.05701546199998
							],
							[
								137.50400931700005,
								-36.05585942199997
							],
							[
								137.5359801730001,
								-36.02585046299998
							],
							[
								137.58664730500004,
								-36.01954542499993
							],
							[
								137.60265036300007,
								-36.00927642599993
							],
							[
								137.6204513020001,
								-35.97857841599995
							],
							[
								137.60510919500007,
								-35.96484439599993
							],
							[
								137.59817919800003,
								-35.94267947499998
							],
							[
								137.6119852070001,
								-35.913097455999946
							],
							[
								137.66029664000007,
								-35.884885476999955
							],
							[
								137.72612248000007,
								-35.87672847999994
							],
							[
								137.74110422900003,
								-35.853101409999965
							],
							[
								137.80323948900002,
								-35.85060246199998
							],
							[
								137.85609034900006,
								-35.85974143499993
							],
							[
								137.8742703360001,
								-35.87055545499993
							],
							[
								137.9111412100001,
								-35.859775456999955
							],
							[
								137.9575671220001,
								-35.872399488999974
							],
							[
								138.020237349,
								-35.902415460999975
							],
							[
								138.04082936600003,
								-35.904260471999976
							],
							[
								138.1109000880001,
								-35.84839550399994
							],
							[
								138.1348984340001,
								-35.84151642499995
							],
							[
								138.11907824800005,
								-35.81986243499995
							],
							[
								138.12573208800006,
								-35.80233646499994
							],
							[
								138.10652433100006,
								-35.809462493999945
							],
							[
								138.07695717600006,
								-35.79588445299993
							],
							[
								138.06398636100005,
								-35.75553745199994
							],
							[
								138.00558827200007,
								-35.72628744999997
							],
							[
								137.97332037800004,
								-35.71978845799998
							],
							[
								137.90159614000004,
								-35.719044414999985
							],
							[
								137.89364918100011,
								-35.72815243499997
							],
							[
								137.89254216900008,
								-35.75793143499993
							],
							[
								137.852166344,
								-35.79493646399993
							],
							[
								137.82256137800005,
								-35.80016845299997
							],
							[
								137.77735836700003,
								-35.78443141099996
							],
							[
								137.77809927600003,
								-35.796189450999975
							],
							[
								137.76281147800012,
								-35.79800942099996
							],
							[
								137.7583802690001,
								-35.80602843999998
							],
							[
								137.77074336600003,
								-35.81407146099997
							],
							[
								137.7766401550001,
								-35.80831848099996
							],
							[
								137.7983042520001,
								-35.81019047199993
							],
							[
								137.81476523800006,
								-35.82201945299994
							],
							[
								137.7966694910001,
								-35.83427340199995
							],
							[
								137.77240838500006,
								-35.82278248099993
							],
							[
								137.75384926800007,
								-35.83433144999998
							],
							[
								137.76221531600004,
								-35.83884945099993
							],
							[
								137.7568524070001,
								-35.84345845099995
							],
							[
								137.749244169,
								-35.83421839999994
							],
							[
								137.75398139800006,
								-35.82566345999993
							],
							[
								137.7458824900001,
								-35.82255845999998
							],
							[
								137.74608517100012,
								-35.80093243999994
							],
							[
								137.77275830700012,
								-35.787991430999966
							],
							[
								137.77195439800005,
								-35.78090843099994
							],
							[
								137.80345944400005,
								-35.75759142199996
							],
							[
								137.78034130000003,
								-35.72391846099998
							],
							[
								137.69626732300003,
								-35.739777457999935
							],
							[
								137.58655666100003,
								-35.732733853999946
							]
						]
					],
					[
						[
							[
								138.87809614900004,
								-35.55885347399993
							],
							[
								138.89940414600005,
								-35.55486748499993
							],
							[
								138.93154214000003,
								-35.56242749699993
							],
							[
								138.96301714600008,
								-35.54535848799998
							],
							[
								138.96595915600005,
								-35.52879349799997
							],
							[
								138.98103222500004,
								-35.51824545899996
							],
							[
								139.03346621600008,
								-35.513256490999936
							],
							[
								139.04673571500007,
								-35.50093574099998
							],
							[
								139.14471565100007,
								-35.47169001499998
							],
							[
								139.15831925300006,
								-35.25347195499995
							],
							[
								139.08607915700009,
								-35.21661532099995
							],
							[
								139.06644373000006,
								-35.21485106999995
							],
							[
								139.06669426400003,
								-35.16592224999994
							],
							[
								139.02741104200004,
								-35.138717447999966
							],
							[
								139.04403726100008,
								-35.11159945899993
							],
							[
								139.02901616600002,
								-35.06146974799998
							],
							[
								139.03738718800003,
								-35.021123417999945
							],
							[
								139.03124289000004,
								-35.00183042799995
							],
							[
								139.04120320000004,
								-34.97660913799996
							],
							[
								139.01937919500006,
								-34.95261138699993
							],
							[
								139.03496421400007,
								-34.928673826999955
							],
							[
								138.9752155860001,
								-34.894886973999974
							],
							[
								138.98076800600006,
								-34.88295939499994
							],
							[
								138.9751671570001,
								-34.87756391399995
							],
							[
								138.98943215400004,
								-34.878989504999936
							],
							[
								139.00948091200007,
								-34.86467050599998
							],
							[
								139.0019008150001,
								-34.83237495499998
							],
							[
								139.04397253000002,
								-34.81589504699997
							],
							[
								139.00245849700002,
								-34.80035998499994
							],
							[
								139.00489896700003,
								-34.79417070499994
							],
							[
								138.9880806010001,
								-34.78137221399993
							],
							[
								138.9898872110001,
								-34.76983345399998
							],
							[
								138.95302024700004,
								-34.77567693299994
							],
							[
								138.94857216800006,
								-34.765389341999935
							],
							[
								138.92413356200007,
								-34.75850334099994
							],
							[
								138.92924736200007,
								-34.75269475199997
							],
							[
								138.9189146540001,
								-34.74554848099996
							],
							[
								138.92685661300004,
								-34.74375415099996
							],
							[
								138.9267129540001,
								-34.734904100999984
							],
							[
								138.9174680850001,
								-34.73469438099994
							],
							[
								138.91052414800004,
								-34.70884044999997
							],
							[
								138.88505299200006,
								-34.699859378999975
							],
							[
								138.86175325600004,
								-34.70396606799994
							],
							[
								138.8475557800001,
								-34.68052441799995
							],
							[
								138.8335719700001,
								-34.71610712699993
							],
							[
								138.81199285200012,
								-34.738471785999934
							],
							[
								138.81444735900004,
								-34.77490035699998
							],
							[
								138.78019704500002,
								-34.76701287499998
							],
							[
								138.76961269600008,
								-34.78089692499998
							],
							[
								138.75377399800004,
								-34.784220173999984
							],
							[
								138.7617600860001,
								-34.79422807499998
							],
							[
								138.7508585270001,
								-34.80696529399995
							],
							[
								138.75610540500008,
								-34.82105920499998
							],
							[
								138.74703518600006,
								-34.84066030399998
							],
							[
								138.7545450230001,
								-34.868742304999955
							],
							[
								138.73134785700006,
								-34.85588976399998
							],
							[
								138.72270158800006,
								-34.859185552999975
							],
							[
								138.7197955680001,
								-34.873962432999974
							],
							[
								138.7069753090001,
								-34.881859892999955
							],
							[
								138.71274223800003,
								-34.89422448299996
							],
							[
								138.70179325900006,
								-34.902839462999964
							],
							[
								138.69075956100005,
								-34.89525872199994
							],
							[
								138.69576323900003,
								-34.91045048299998
							],
							[
								138.6850768810001,
								-34.91290215199996
							],
							[
								138.70100496700002,
								-34.92823593299994
							],
							[
								138.67176369100002,
								-34.942099481999946
							],
							[
								138.68595152700004,
								-34.97461867299995
							],
							[
								138.67534561900004,
								-34.97447274199993
							],
							[
								138.66517792000002,
								-34.98164891199997
							],
							[
								138.67375888800007,
								-34.98526277199994
							],
							[
								138.68139424600008,
								-35.00744452299995
							],
							[
								138.67164480600002,
								-35.02599228199995
							],
							[
								138.64542532100006,
								-35.01495849099996
							],
							[
								138.62037621500008,
								-35.016060779999975
							],
							[
								138.6254682230001,
								-35.03060647999996
							],
							[
								138.5863179590001,
								-35.03794102899997
							],
							[
								138.5991281460001,
								-35.04942248899994
							],
							[
								138.61284126400005,
								-35.04677143999993
							],
							[
								138.60995324400005,
								-35.052237469999966
							],
							[
								138.62813476000008,
								-35.068939530999955
							],
							[
								138.61926833100006,
								-35.08611664999995
							],
							[
								138.58535924600005,
								-35.09684546899996
							],
							[
								138.5953488230001,
								-35.108630339999934
							],
							[
								138.58563102300002,
								-35.13234566899996
							],
							[
								138.59466755200003,
								-35.13384740999993
							],
							[
								138.59525414100005,
								-35.14311150999998
							],
							[
								138.5793133530001,
								-35.16060343899994
							],
							[
								138.53575196000008,
								-35.161120806999975
							],
							[
								138.50371230400003,
								-35.17759346599996
							],
							[
								138.49496646500006,
								-35.18521322599997
							],
							[
								138.50383107200003,
								-35.20051655599997
							],
							[
								138.49008736400003,
								-35.21190515599994
							],
							[
								138.4942814310001,
								-35.243009805999975
							],
							[
								138.46198648600011,
								-35.247347814999955
							],
							[
								138.46029631600004,
								-35.26103444499995
							],
							[
								138.44309510800008,
								-35.27260647399993
							],
							[
								138.44753606400002,
								-35.32003142499997
							],
							[
								138.44036129300002,
								-35.35104848499998
							],
							[
								138.41045826700008,
								-35.36639150399998
							],
							[
								138.37282637300007,
								-35.37390542199995
							],
							[
								138.34126015700008,
								-35.392850420999935
							],
							[
								138.29432514000007,
								-35.46816944899996
							],
							[
								138.24454724600002,
								-35.50083448799995
							],
							[
								138.19386930300004,
								-35.52363643599995
							],
							[
								138.16549522800005,
								-35.51936342499994
							],
							[
								138.1274374520001,
								-35.555357482999966
							],
							[
								138.10869331300012,
								-35.59243845299994
							],
							[
								138.09392038500005,
								-35.60338947199995
							],
							[
								138.100281192,
								-35.62930949299994
							],
							[
								138.1628563800001,
								-35.66059943499994
							],
							[
								138.19136513500007,
								-35.66507646699995
							],
							[
								138.2320613590001,
								-35.65957549799998
							],
							[
								138.27596333300005,
								-35.63936148999994
							],
							[
								138.41003310100007,
								-35.64056246499996
							],
							[
								138.43110315800004,
								-35.62926044599993
							],
							[
								138.49452938700006,
								-35.633516458999964
							],
							[
								138.52236709200008,
								-35.64295449999997
							],
							[
								138.5659433070001,
								-35.60851545199995
							],
							[
								138.60378109200008,
								-35.59426944299997
							],
							[
								138.5982273630001,
								-35.579455432999964
							],
							[
								138.62601109000002,
								-35.55789747399996
							],
							[
								138.63138801000002,
								-35.54391245399995
							],
							[
								138.68443908200004,
								-35.538094505999936
							],
							[
								138.69413928100005,
								-35.52179047599998
							],
							[
								138.71149918900005,
								-35.51341443699994
							],
							[
								138.78600107600005,
								-35.526615869999944
							],
							[
								138.87809614900004,
								-35.55885347399993
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "408",
				"CED_NAME21": "Mayo",
				"STE_CODE21": "4",
				"STE_NAME21": "South Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 9135.788,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/408",
				"SHAPE_Leng": 10.2846289219,
				"SHAPE_Area": 0.908001023947
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							138.5491292600001,
							-34.78618145599995
						],
						[
							138.5775822160001,
							-34.78926953699994
						],
						[
							138.5932927240001,
							-34.77114889699993
						],
						[
							138.60741632200006,
							-34.76771004799997
						],
						[
							138.6470455750001,
							-34.79178209999998
						],
						[
							138.67933938200008,
							-34.75385845099993
						],
						[
							138.7200243950001,
							-34.75545045299998
						],
						[
							138.73636584400003,
							-34.73566396299998
						],
						[
							138.7518118700001,
							-34.749074753999935
						],
						[
							138.77577393800004,
							-34.73483366499994
						],
						[
							138.76848112800008,
							-34.75346286499996
						],
						[
							138.78019704500002,
							-34.76701287499998
						],
						[
							138.81444735900004,
							-34.77490035699998
						],
						[
							138.81199285200012,
							-34.738471785999934
						],
						[
							138.8335719700001,
							-34.71610712699993
						],
						[
							138.8475557800001,
							-34.68052441799995
						],
						[
							138.83101814300005,
							-34.66900851699995
						],
						[
							138.79813934800006,
							-34.66545647499993
						],
						[
							138.78650020100008,
							-34.65671648499995
						],
						[
							138.8090782170001,
							-34.651028475999965
						],
						[
							138.8148012370001,
							-34.64298347599998
						],
						[
							138.800450242,
							-34.60189247499994
						],
						[
							138.81543221000004,
							-34.60085947599998
						],
						[
							138.82479522900007,
							-34.59094847599994
						],
						[
							138.8212622110001,
							-34.56202347599998
						],
						[
							138.8021962240001,
							-34.560986484999944
						],
						[
							138.80423522400008,
							-34.55131048499993
						],
						[
							138.79405924600007,
							-34.55108948399993
						],
						[
							138.79026922600008,
							-34.56273846399995
						],
						[
							138.7733252390001,
							-34.56059246399997
						],
						[
							138.76245974000005,
							-34.57195287299993
						],
						[
							138.7460662430001,
							-34.568335472999934
						],
						[
							138.74747222300005,
							-34.55823447299997
						],
						[
							138.72355326700006,
							-34.555925471999956
						],
						[
							138.7219042270001,
							-34.56679239199997
						],
						[
							138.70331124000006,
							-34.56494947099998
						],
						[
							138.71551026600002,
							-34.59177947099994
						],
						[
							138.69614822900007,
							-34.59324247099994
						],
						[
							138.68245124200007,
							-34.58653147999996
						],
						[
							138.68396825000002,
							-34.61190845999994
						],
						[
							138.66856123200012,
							-34.613001459999964
						],
						[
							138.66797026200004,
							-34.61999246999994
						],
						[
							138.65288025400002,
							-34.62216846899997
						],
						[
							138.64643223500002,
							-34.63044146899995
						],
						[
							138.62559825800008,
							-34.62562946799994
						],
						[
							138.617559249,
							-34.63373846799993
						],
						[
							138.60002424200002,
							-34.632519456999944
						],
						[
							138.5908512530001,
							-34.63884046599998
						],
						[
							138.52048926400005,
							-34.63695646399998
						],
						[
							138.4919512680001,
							-34.647435471999984
						],
						[
							138.4886992580001,
							-34.65844746199997
						],
						[
							138.46443629100008,
							-34.67334446099994
						],
						[
							138.43565228500006,
							-34.67274546999994
						],
						[
							138.4633432590001,
							-34.69753547199997
						],
						[
							138.4753432870001,
							-34.698987461999934
						],
						[
							138.49327825300008,
							-34.72138846299998
						],
						[
							138.5264492670001,
							-34.73838347399993
						],
						[
							138.53031227600002,
							-34.74493946499996
						],
						[
							138.5231042570001,
							-34.747996453999974
						],
						[
							138.5306332660001,
							-34.74541147499997
						],
						[
							138.539465274,
							-34.75599045499996
						],
						[
							138.5491292600001,
							-34.78618145599995
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "409",
				"CED_NAME21": "Spence",
				"STE_CODE21": "4",
				"STE_NAME21": "South Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 533.1794,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/409",
				"SHAPE_Leng": 1.64993258953,
				"SHAPE_Area": 0.0524470690986
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							138.74703518600006,
							-34.84066030399998
						],
						[
							138.73155520800003,
							-34.84314848399998
						],
						[
							138.7274672090001,
							-34.83711146299993
						],
						[
							138.6353472830001,
							-34.84683474999997
						],
						[
							138.63817224100012,
							-34.87040056999996
						],
						[
							138.62645106200011,
							-34.87933831899994
						],
						[
							138.6352022310001,
							-34.88735590999994
						],
						[
							138.6138962330001,
							-34.89969285899997
						],
						[
							138.6128331330001,
							-34.90949115899997
						],
						[
							138.62357140000006,
							-34.927889909999976
						],
						[
							138.6264462470001,
							-34.964545199999975
						],
						[
							138.644081324,
							-34.96331184099995
						],
						[
							138.653324332,
							-34.97298945099993
						],
						[
							138.66977944000007,
							-34.967191071999935
						],
						[
							138.67534561900004,
							-34.97447274199993
						],
						[
							138.68595152700004,
							-34.97461867299995
						],
						[
							138.67176369100002,
							-34.942099481999946
						],
						[
							138.70100496700002,
							-34.92823593299994
						],
						[
							138.6850768810001,
							-34.91290215199996
						],
						[
							138.69576323900003,
							-34.91045048299998
						],
						[
							138.69075956100005,
							-34.89525872199994
						],
						[
							138.70179325900006,
							-34.902839462999964
						],
						[
							138.71274223800003,
							-34.89422448299996
						],
						[
							138.7069753090001,
							-34.881859892999955
						],
						[
							138.7197955680001,
							-34.873962432999974
						],
						[
							138.72270158800006,
							-34.859185552999975
						],
						[
							138.73134785700006,
							-34.85588976399998
						],
						[
							138.7545450230001,
							-34.868742304999955
						],
						[
							138.74703518600006,
							-34.84066030399998
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "410",
				"CED_NAME21": "Sturt",
				"STE_CODE21": "4",
				"STE_NAME21": "South Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 97.6132,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/410",
				"SHAPE_Leng": 0.663850010114,
				"SHAPE_Area": 0.00962655173291
			}
		},
		{
			"type": "Feature",
			"geometry": null,
			"properties": {
				"CED_CODE21": "494",
				"CED_NAME21": "No usual address (SA)",
				"STE_CODE21": "4",
				"STE_NAME21": "South Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 0,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/494",
				"SHAPE_Leng": 0,
				"SHAPE_Area": 0
			}
		},
		{
			"type": "Feature",
			"geometry": null,
			"properties": {
				"CED_CODE21": "497",
				"CED_NAME21": "Migratory - Offshore - Shipping (SA)",
				"STE_CODE21": "4",
				"STE_NAME21": "South Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 0,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/497",
				"SHAPE_Leng": 0,
				"SHAPE_Area": 0
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								115.74782673000004,
								-32.45562965499994
							],
							[
								115.8014337620001,
								-32.45256272199998
							],
							[
								115.8274948290001,
								-32.458138660999964
							],
							[
								115.83151760700002,
								-32.444565430999944
							],
							[
								115.85773558300002,
								-32.44456222899993
							],
							[
								115.85766477100003,
								-32.406211638999935
							],
							[
								115.8300107340001,
								-32.40544060999997
							],
							[
								115.83559976200002,
								-32.378887599999985
							],
							[
								115.85221875800005,
								-32.36866860899994
							],
							[
								115.85517572600008,
								-32.34633460899994
							],
							[
								115.87522375200001,
								-32.33258860799998
							],
							[
								115.8897407070001,
								-32.292124616999956
							],
							[
								115.87225428900001,
								-32.27819135799996
							],
							[
								115.88580604600008,
								-32.26573784699997
							],
							[
								115.88281705100007,
								-32.20477159699993
							],
							[
								115.89714395900012,
								-32.202068355999984
							],
							[
								115.89855694700009,
								-32.18022747599997
							],
							[
								115.7749343050001,
								-32.18137553299994
							],
							[
								115.77265831700004,
								-32.20038377299994
							],
							[
								115.75570772100002,
								-32.22365216399993
							],
							[
								115.7584951130001,
								-32.24479531399993
							],
							[
								115.74058964700009,
								-32.26642157499998
							],
							[
								115.72241177000001,
								-32.27691764599996
							],
							[
								115.68475760500007,
								-32.26596760799998
							],
							[
								115.70198177400005,
								-32.28239956699997
							],
							[
								115.70156516500003,
								-32.30526265699996
							],
							[
								115.72985511200011,
								-32.30978629599997
							],
							[
								115.74190325100005,
								-32.326153244999944
							],
							[
								115.7390878540001,
								-32.35876870499993
							],
							[
								115.71286910900005,
								-32.37016089699995
							],
							[
								115.74414555700002,
								-32.40399088499993
							],
							[
								115.74782673000004,
								-32.45562965499994
							]
						]
					],
					[
						[
							[
								115.6698986020001,
								-32.19610194799998
							],
							[
								115.68081831400002,
								-32.24414739799994
							],
							[
								115.7000992510001,
								-32.24453912699994
							],
							[
								115.68723409200004,
								-32.234003177999966
							],
							[
								115.70039894900003,
								-32.226346916999944
							],
							[
								115.68332972000007,
								-32.20584989799994
							],
							[
								115.67464815800008,
								-32.165175517999955
							],
							[
								115.66912888900004,
								-32.156006607999984
							],
							[
								115.66054471000007,
								-32.156211618999976
							],
							[
								115.6698986020001,
								-32.19610194799998
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "501",
				"CED_NAME21": "Brand",
				"STE_CODE21": "5",
				"STE_NAME21": "Western Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 377.703,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/501",
				"SHAPE_Leng": 1.39615790967,
				"SHAPE_Area": 0.0361663014615
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							115.89863859700006,
							-32.18022658599995
						],
						[
							115.99235572400005,
							-32.180203250999966
						],
						[
							115.99863394300007,
							-32.18683827999996
						],
						[
							116.01582872100005,
							-32.18654306899998
						],
						[
							116.01885668800003,
							-32.152701598999954
						],
						[
							116.0534247710001,
							-32.128094576999956
						],
						[
							116.04209970200009,
							-32.11615460799993
						],
						[
							116.03095811300011,
							-32.116266347999954
						],
						[
							116.04848817900006,
							-32.09550886699998
						],
						[
							116.01581313400004,
							-32.09331189899996
						],
						[
							116.01501144100007,
							-32.05478863899998
						],
						[
							116.03637985800003,
							-32.06049563799996
						],
						[
							116.05628414500006,
							-32.050553916999945
						],
						[
							116.05614890400011,
							-32.04043487599995
						],
						[
							116.04156467500002,
							-32.030344886999956
						],
						[
							116.02144635800005,
							-32.01944015799995
						],
						[
							116.01440969800001,
							-32.01348108899998
						],
						[
							116.00253603100009,
							-32.02359673899997
						],
						[
							115.994662661,
							-32.009443389999944
						],
						[
							115.98940202200004,
							-32.01393843999995
						],
						[
							115.975709703,
							-32.00401660099993
						],
						[
							115.94116644000007,
							-32.029606282999964
						],
						[
							115.93029269300007,
							-32.05407460299995
						],
						[
							115.95162902200002,
							-32.082754041999976
						],
						[
							115.91618388000006,
							-32.115323623999984
						],
						[
							115.89692480400004,
							-32.13612393599993
						],
						[
							115.89863859700006,
							-32.18022658599995
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "502",
				"CED_NAME21": "Burt",
				"STE_CODE21": "5",
				"STE_NAME21": "Western Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 190.0523,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/502",
				"SHAPE_Leng": 0.76921933153,
				"SHAPE_Area": 0.0181583353995
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							115.74782673000004,
							-32.45562965499994
						],
						[
							115.73692579600004,
							-32.50383196599995
						],
						[
							115.71137726100005,
							-32.52375154799995
						],
						[
							115.72094226000002,
							-32.52721344699995
						],
						[
							115.71906576300012,
							-32.56519193699995
						],
						[
							115.75531474800005,
							-32.56480248499997
						],
						[
							115.76626076700006,
							-32.58157260499996
						],
						[
							115.76289904900011,
							-32.59075676499998
						],
						[
							115.77715791700007,
							-32.59444564399996
						],
						[
							115.77545570900008,
							-32.62443498399995
						],
						[
							115.76730869100004,
							-32.62700712499998
						],
						[
							115.77371688000005,
							-32.635887114999946
						],
						[
							115.74480122600005,
							-32.64656062599994
						],
						[
							115.7214149880001,
							-32.631937766999954
						],
						[
							115.71791214900009,
							-32.64024091799996
						],
						[
							115.70413614100005,
							-32.64373810799998
						],
						[
							115.67688904300007,
							-32.61643511999995
						],
						[
							115.66636404500002,
							-32.61571526999995
						],
						[
							115.66717621600003,
							-32.63457145099994
						],
						[
							115.6847084750001,
							-32.65336444999997
						],
						[
							115.68606182700012,
							-32.682896839999955
						],
						[
							115.69736200600005,
							-32.69060376899995
						],
						[
							115.71391066700005,
							-32.728866007999954
						],
						[
							115.71024686800001,
							-32.74134419899997
						],
						[
							115.7268460470001,
							-32.753333157999975
						],
						[
							115.725356669,
							-32.78216470799998
						],
						[
							115.71469881000007,
							-32.77253162799997
						],
						[
							115.71244191100004,
							-32.787706868999976
						],
						[
							115.70349295200003,
							-32.78375751899995
						],
						[
							115.69272946300009,
							-32.76767576999998
						],
						[
							115.69662916100003,
							-32.75426757899993
						],
						[
							115.68266309300009,
							-32.749516609999944
						],
						[
							115.64101629900006,
							-32.61849160199995
						],
						[
							115.64516911700002,
							-32.60818444199998
						],
						[
							115.67285663200005,
							-32.593887879999954
						],
						[
							115.6659995220001,
							-32.58641387999995
						],
						[
							115.67110926100008,
							-32.57516167999995
						],
						[
							115.71761960300012,
							-32.557595866999975
						],
						[
							115.71039117100008,
							-32.52045850799993
						],
						[
							115.70175776200006,
							-32.51782861799995
						],
						[
							115.66786277100005,
							-32.56547361999998
						],
						[
							115.6278220590001,
							-32.59953454299995
						],
						[
							115.60844998700009,
							-32.66567850399997
						],
						[
							115.63264788700008,
							-32.833873892999975
						],
						[
							115.65847073100008,
							-32.93303826199997
						],
						[
							115.70027833400002,
							-32.93170490999995
						],
						[
							115.71977378100007,
							-32.92192262899994
						],
						[
							115.76378255400004,
							-32.92196996599995
						],
						[
							115.76379741500011,
							-32.92996336599998
						],
						[
							115.78080721200001,
							-32.930011804999936
						],
						[
							115.78078736300006,
							-32.936542834999955
						],
						[
							115.81309288800003,
							-32.93649668399996
						],
						[
							115.81288705700001,
							-32.925903353999956
						],
						[
							115.8238434860001,
							-32.925925982999956
						],
						[
							115.83866879400011,
							-32.93567381199995
						],
						[
							115.85300340200001,
							-32.93135310099996
						],
						[
							115.86804698000003,
							-32.94220714099998
						],
						[
							115.8745562790001,
							-32.93493865999994
						],
						[
							115.92443400200011,
							-32.94104452799996
						],
						[
							115.94269220900003,
							-32.93619301699994
						],
						[
							115.95134953800004,
							-32.94226874599997
						],
						[
							115.95638908600006,
							-32.93292700599994
						],
						[
							115.99347381100006,
							-32.93331859399996
						],
						[
							115.98934723200011,
							-32.93842620399994
						],
						[
							116.00034099100003,
							-32.94239282299998
						],
						[
							116.02162968700009,
							-32.93580728199993
						],
						[
							116.15065432800009,
							-32.93548147499996
						],
						[
							116.17190294400007,
							-32.92646011399995
						],
						[
							116.16525114600006,
							-32.941710324999974
						],
						[
							116.1799638540001,
							-32.94309662399996
						],
						[
							116.17823487400005,
							-32.803230852999945
						],
						[
							116.18753493200006,
							-32.80319676299996
						],
						[
							116.18759223100005,
							-32.78172636299996
						],
						[
							116.2258497360001,
							-32.79186332099994
						],
						[
							116.22598716300001,
							-32.755885949999936
						],
						[
							116.20599271600008,
							-32.75542260199995
						],
						[
							116.20636023000009,
							-32.675186560999975
						],
						[
							116.26451589100009,
							-32.67506982799995
						],
						[
							116.25968969100006,
							-32.38987158699996
						],
						[
							116.18956509300006,
							-32.28741410999993
						],
						[
							116.22491183400007,
							-32.23587188799996
						],
						[
							116.35809056500011,
							-32.23633647099996
						],
						[
							116.34380950700006,
							-32.231754631999934
						],
						[
							116.31244746700008,
							-32.17107887299994
						],
						[
							116.28244965100009,
							-32.17001741499996
						],
						[
							116.28497953700003,
							-32.11313726399993
						],
						[
							116.28888966200009,
							-32.06214058399996
						],
						[
							116.25067909500001,
							-32.019611675999954
						],
						[
							116.2365306370001,
							-32.02601957699994
						],
						[
							116.23590864800008,
							-32.03378058699997
						],
						[
							116.21859563900011,
							-32.01912159799997
						],
						[
							116.18963964300008,
							-32.01321158899998
						],
						[
							116.1058856950001,
							-32.00961759399996
						],
						[
							116.08844767800008,
							-32.01593258499997
						],
						[
							116.06004276100009,
							-32.00932575599995
						],
						[
							116.05084414400005,
							-32.02640155699993
						],
						[
							116.05725168300012,
							-32.03010259599995
						],
						[
							116.04156467500002,
							-32.030344886999956
						],
						[
							116.05614890400011,
							-32.04043487599995
						],
						[
							116.05628414500006,
							-32.050553916999945
						],
						[
							116.03637985800003,
							-32.06049563799996
						],
						[
							116.01501144100007,
							-32.05478863899998
						],
						[
							116.01581313400004,
							-32.09331189899996
						],
						[
							116.04848817900006,
							-32.09550886699998
						],
						[
							116.03095811300011,
							-32.116266347999954
						],
						[
							116.04209970200009,
							-32.11615460799993
						],
						[
							116.0534247710001,
							-32.128094576999956
						],
						[
							116.01885668800003,
							-32.152701598999954
						],
						[
							116.01582872100005,
							-32.18654306899998
						],
						[
							115.99863394300007,
							-32.18683827999996
						],
						[
							115.99235572400005,
							-32.180203250999966
						],
						[
							115.89863859700006,
							-32.18022658599995
						],
						[
							115.89855694700009,
							-32.18022747599997
						],
						[
							115.89714395900012,
							-32.202068355999984
						],
						[
							115.88281705100007,
							-32.20477159699993
						],
						[
							115.88580604600008,
							-32.26573784699997
						],
						[
							115.87225428900001,
							-32.27819135799996
						],
						[
							115.8897407070001,
							-32.292124616999956
						],
						[
							115.87522375200001,
							-32.33258860799998
						],
						[
							115.85517572600008,
							-32.34633460899994
						],
						[
							115.85221875800005,
							-32.36866860899994
						],
						[
							115.83559976200002,
							-32.378887599999985
						],
						[
							115.8300107340001,
							-32.40544060999997
						],
						[
							115.85766477100003,
							-32.406211638999935
						],
						[
							115.85773558300002,
							-32.44456222899993
						],
						[
							115.83151760700002,
							-32.444565430999944
						],
						[
							115.8274948290001,
							-32.458138660999964
						],
						[
							115.8014337620001,
							-32.45256272199998
						],
						[
							115.74782673000004,
							-32.45562965499994
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "503",
				"CED_NAME21": "Canning",
				"STE_CODE21": "5",
				"STE_NAME21": "Western Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 4248.5207,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/503",
				"SHAPE_Leng": 4.93705466893,
				"SHAPE_Area": 0.407839221764
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							115.95595480700001,
							-31.887644620999936
						],
						[
							115.95339826500003,
							-31.861621800999956
						],
						[
							115.91751169100007,
							-31.866504602999953
						],
						[
							115.91709467900012,
							-31.843160602999944
						],
						[
							115.88058421300002,
							-31.82130882499996
						],
						[
							115.8208631010001,
							-31.820089157999973
						],
						[
							115.78176492600005,
							-31.81719708099996
						],
						[
							115.80118569800004,
							-31.867966499999966
						],
						[
							115.80280837900011,
							-31.892055399999947
						],
						[
							115.82066534700004,
							-31.90174873899997
						],
						[
							115.8283150850001,
							-31.888878947999956
						],
						[
							115.95595480700001,
							-31.887644620999936
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "504",
				"CED_NAME21": "Cowan",
				"STE_CODE21": "5",
				"STE_NAME21": "Western Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 95.0457,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/504",
				"SHAPE_Leng": 0.484310768459,
				"SHAPE_Area": 0.00905727277105
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							115.75888907600006,
							-32.024019032999945
						],
						[
							115.77379462300007,
							-32.025052941999945
						],
						[
							115.78135669200003,
							-32.016594630999975
						],
						[
							115.77163732300005,
							-32.00960376199998
						],
						[
							115.77353390100006,
							-31.989385511999956
						],
						[
							115.7866155690001,
							-31.991019600999948
						],
						[
							115.79179057900001,
							-32.00492361099998
						],
						[
							115.8072561670001,
							-32.00215443999997
						],
						[
							115.8190746140001,
							-31.98754964899996
						],
						[
							115.828930893,
							-31.98709509899993
						],
						[
							115.82110583300005,
							-31.98132409899995
						],
						[
							115.82726302200001,
							-31.972835798999938
						],
						[
							115.81803823300004,
							-31.973724378999975
						],
						[
							115.8186195620001,
							-31.963930588999972
						],
						[
							115.84399950700004,
							-31.941407607999963
						],
						[
							115.82519641800002,
							-31.921190128999967
						],
						[
							115.82066534700004,
							-31.90174873899997
						],
						[
							115.80280837900011,
							-31.892055399999947
						],
						[
							115.80118569800004,
							-31.867966499999966
						],
						[
							115.79181001900008,
							-31.86997796999998
						],
						[
							115.79071158800002,
							-31.859435089999977
						],
						[
							115.7721165910001,
							-31.85750540099997
						],
						[
							115.76553579300003,
							-31.87397802199996
						],
						[
							115.75182146500003,
							-31.873382651999975
						],
						[
							115.75088174600012,
							-32.021589182999946
						],
						[
							115.75888907600006,
							-32.024019032999945
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "505",
				"CED_NAME21": "Curtin",
				"STE_CODE21": "5",
				"STE_NAME21": "Western Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 97.948,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/505",
				"SHAPE_Leng": 0.551719303434,
				"SHAPE_Area": 0.00934197527937
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								129.00149340000007,
								-14.879594592999979
							],
							[
								128.932327804,
								-14.87078212299997
							],
							[
								128.90806880500008,
								-14.856064132999961
							],
							[
								128.8448658090001,
								-14.861046132999945
							],
							[
								128.76799882300008,
								-14.836908122999944
							],
							[
								128.73823679500003,
								-14.839065132999963
							],
							[
								128.72062781600005,
								-14.817830132999973
							],
							[
								128.7022738270001,
								-14.806609142999946
							],
							[
								128.69539080700008,
								-14.812264132999928
							],
							[
								128.69860779700002,
								-14.804062132999945
							],
							[
								128.68130680800004,
								-14.796007122999981
							],
							[
								128.62082083100006,
								-14.787445142999957
							],
							[
								128.61207682200006,
								-14.790129142999945
							],
							[
								128.62788318100002,
								-14.798938412999973
							],
							[
								128.62345303100005,
								-14.803908512999953
							],
							[
								128.59604310300006,
								-14.800678562999963
							],
							[
								128.58708293300003,
								-14.807668132999936
							],
							[
								128.58850278300008,
								-14.797388152999929
							],
							[
								128.55415347500002,
								-14.780808132999937
							],
							[
								128.5504637250001,
								-14.76791811299995
							],
							[
								128.52848397700006,
								-14.77994812299994
							],
							[
								128.53590391600005,
								-14.786978122999926
							],
							[
								128.52532387700012,
								-14.78954816299995
							],
							[
								128.50664383800006,
								-14.78102813299995
							],
							[
								128.4851338090001,
								-14.79136760299997
							],
							[
								128.47527391000006,
								-14.786137462999932
							],
							[
								128.46594382,
								-14.799677482999982
							],
							[
								128.4364039720001,
								-14.812137182999948
							],
							[
								128.41855397300003,
								-14.795247142999926
							],
							[
								128.3934349750001,
								-14.804436153999973
							],
							[
								128.37992434500006,
								-14.816266493999933
							],
							[
								128.38095427500002,
								-14.823386553999967
							],
							[
								128.39547418400002,
								-14.821736643999941
							],
							[
								128.4274838130001,
								-14.841047173999982
							],
							[
								128.46698331100004,
								-14.889077993999933
							],
							[
								128.47714312000005,
								-14.911598083999934
							],
							[
								128.47035302100005,
								-14.931248083999947
							],
							[
								128.5077924190001,
								-14.973728153999957
							],
							[
								128.51899211800003,
								-15.014738394999938
							],
							[
								128.51143215800005,
								-15.013598354999942
							],
							[
								128.50173239900005,
								-14.978458123999928
							],
							[
								128.4738928600001,
								-14.956688093999958
							],
							[
								128.42167363300007,
								-14.881717453999954
							],
							[
								128.40239378400008,
								-14.878947193999977
							],
							[
								128.41777360300011,
								-14.90430766399993
							],
							[
								128.41922353400003,
								-14.927707833999932
							],
							[
								128.43803311300007,
								-14.974438144999965
							],
							[
								128.45588278200012,
								-14.99562823499997
							],
							[
								128.4486228620001,
								-15.002038244999937
							],
							[
								128.42999318300008,
								-14.98051815499997
							],
							[
								128.41892343400002,
								-14.950307983999949
							],
							[
								128.40105365500006,
								-14.938497803999951
							],
							[
								128.3686641060001,
								-14.889917153999932
							],
							[
								128.35821422700008,
								-14.885017063999953
							],
							[
								128.34911415800002,
								-14.967947974999959
							],
							[
								128.38750368600006,
								-14.997788214999957
							],
							[
								128.41038338400006,
								-15.032058414999938
							],
							[
								128.37861378600007,
								-15.00055824499998
							],
							[
								128.3581140670001,
								-14.991258194999943
							],
							[
								128.3641240170001,
								-15.040848424999979
							],
							[
								128.37398393700005,
								-15.061428514999932
							],
							[
								128.36186418700004,
								-15.066588515999968
							],
							[
								128.3280543090001,
								-14.974087974999975
							],
							[
								128.3230743590001,
								-14.933157454999957
							],
							[
								128.31392447000007,
								-14.925667284999975
							],
							[
								128.29586460100006,
								-14.937357334999945
							],
							[
								128.292504591,
								-14.966737794999972
							],
							[
								128.31472444000008,
								-14.995858264999981
							],
							[
								128.33120440900007,
								-15.035388454999975
							],
							[
								128.3246844890001,
								-15.03605844499998
							],
							[
								128.3072944700001,
								-14.99458823499998
							],
							[
								128.28922467100006,
								-14.97406790499997
							],
							[
								128.2654748430001,
								-14.982568004999962
							],
							[
								128.22817513500001,
								-15.003138435999972
							],
							[
								128.19403577700007,
								-15.093499135999934
							],
							[
								128.22107581600005,
								-15.13083908699997
							],
							[
								128.22024645600004,
								-15.20373948699995
							],
							[
								128.23959664500012,
								-15.24750981699998
							],
							[
								128.278116403,
								-15.27854005699993
							],
							[
								128.30076633200008,
								-15.319710047999934
							],
							[
								128.29230698300012,
								-15.36366077799994
							],
							[
								128.29527742300002,
								-15.401301357999955
							],
							[
								128.30726724200008,
								-15.413981057999933
							],
							[
								128.2991475230001,
								-15.46019094899998
							],
							[
								128.32429733100003,
								-15.483840348999934
							],
							[
								128.32963739100012,
								-15.501030088999983
							],
							[
								128.3416473200001,
								-15.501270088999945
							],
							[
								128.32737742100005,
								-15.50510012899997
							],
							[
								128.32149734200004,
								-15.48780028899995
							],
							[
								128.29227760300012,
								-15.459841078999943
							],
							[
								128.29628749300002,
								-15.43103126799997
							],
							[
								128.28131756400012,
								-15.390551567999978
							],
							[
								128.28161697300004,
								-15.34590077799993
							],
							[
								128.2560373350001,
								-15.316361147999942
							],
							[
								128.25802717500005,
								-15.306310997999958
							],
							[
								128.1881773780001,
								-15.228770096999938
							],
							[
								128.1283077820001,
								-15.183669856999927
							],
							[
								128.1100887030001,
								-15.20962009799996
							],
							[
								128.1151489130001,
								-15.234610437999947
							],
							[
								128.1006887840001,
								-15.24305015799996
							],
							[
								128.1002093940001,
								-15.25017063799993
							],
							[
								128.1161391930001,
								-15.260040797999977
							],
							[
								128.128179412,
								-15.291711247999956
							],
							[
								128.12471896300008,
								-15.375341868999953
							],
							[
								128.11433854400002,
								-15.427981928999941
							],
							[
								128.0964086150001,
								-15.467151979999926
							],
							[
								128.0681289270001,
								-15.492061989999968
							],
							[
								128.01842929000009,
								-15.501762059999976
							],
							[
								127.99878904100001,
								-15.518091949999928
							],
							[
								127.99553908200005,
								-15.514131949999978
							],
							[
								128.01949921000005,
								-15.494311979999964
							],
							[
								128.05241888800003,
								-15.479481989999954
							],
							[
								128.07736864600008,
								-15.433881818999964
							],
							[
								128.0893687150001,
								-15.390291508999951
							],
							[
								128.08663898500004,
								-15.366211428999975
							],
							[
								128.06713940600002,
								-15.335311138999941
							],
							[
								128.06603984600008,
								-15.312251058999948
							],
							[
								128.04036822800003,
								-15.292757828999981
							],
							[
								128.0447801670001,
								-15.288240808999944
							],
							[
								128.06595005600002,
								-15.30117101899998
							],
							[
								128.09278981400007,
								-15.28101100799995
							],
							[
								128.08192979500006,
								-15.258490687999938
							],
							[
								128.08777946400005,
								-15.237600487999941
							],
							[
								128.0802495150001,
								-15.233030447999965
							],
							[
								128.09167901400008,
								-15.214210227999956
							],
							[
								128.09888783300005,
								-15.167329966999944
							],
							[
								128.0835575440001,
								-15.152380156999982
							],
							[
								128.07495690500002,
								-15.103979976999938
							],
							[
								128.09213588300008,
								-15.070910136999942
							],
							[
								128.10309614300002,
								-15.064489656999967
							],
							[
								128.0944160030001,
								-15.044699646999959
							],
							[
								128.1014159030001,
								-15.037249565999957
							],
							[
								128.10007576300006,
								-15.011139485999934
							],
							[
								128.1133656720001,
								-14.99325919599994
							],
							[
								128.10787545200003,
								-14.94689862599995
							],
							[
								128.13910499000008,
								-14.870755434999978
							],
							[
								128.12295513000004,
								-14.871025974999952
							],
							[
								128.11851516100012,
								-14.861326074999965
							],
							[
								128.1511950690001,
								-14.841874914999948
							],
							[
								128.19245495600012,
								-14.83864428499993
							],
							[
								128.19400503600002,
								-14.82803419499993
							],
							[
								128.175215277,
								-14.79179454399997
							],
							[
								128.18388552600004,
								-14.744245083999942
							],
							[
								128.20063552500005,
								-14.737534753999967
							],
							[
								128.2184456540001,
								-14.754554523999957
							],
							[
								128.2251195340001,
								-14.74026250399993
							],
							[
								128.21659569400003,
								-14.74066454399997
							],
							[
								128.21423567500005,
								-14.73317448399996
							],
							[
								128.2217157340001,
								-14.721224293999967
							],
							[
								128.20121568500008,
								-14.706454133999955
							],
							[
								128.1842256660001,
								-14.714635133999934
							],
							[
								128.16114573700008,
								-14.707995593999954
							],
							[
								128.15021577800007,
								-14.685565543999928
							],
							[
								128.13127551900004,
								-14.687076703999935
							],
							[
								128.13724560900005,
								-14.677605963999952
							],
							[
								128.13091577900002,
								-14.66412612399995
							],
							[
								128.1019258010001,
								-14.656327573999931
							],
							[
								128.10345573000006,
								-14.650907203999964
							],
							[
								128.08679546100007,
								-14.638966603999961
							],
							[
								128.08594559100004,
								-14.64687655399996
							],
							[
								128.06938518200002,
								-14.650215603999982
							],
							[
								128.06934495200005,
								-14.620697483999948
							],
							[
								128.0278648640001,
								-14.579261383999949
							],
							[
								128.014104835,
								-14.569811173999938
							],
							[
								128.000524906,
								-14.57054117399997
							],
							[
								127.99305492600001,
								-14.556150163999973
							],
							[
								127.98481482700004,
								-14.579621093999947
							],
							[
								127.96271590800006,
								-14.590362143999982
							],
							[
								127.95264598900008,
								-14.586022173999936
							],
							[
								127.95353589800004,
								-14.57054117399997
							],
							[
								127.92737577000003,
								-14.557981133999931
							],
							[
								127.94023569900003,
								-14.54336010399993
							],
							[
								127.93888567900001,
								-14.530120113999942
							],
							[
								127.95257466800001,
								-14.529400113999941
							],
							[
								127.9493548580001,
								-14.524190173999955
							],
							[
								127.92927478900003,
								-14.502840123999931
							],
							[
								127.92077591000009,
								-14.508220123999934
							],
							[
								127.90210594100006,
								-14.505050153999946
							],
							[
								127.88227571200002,
								-14.484740133999935
							],
							[
								127.88025573200002,
								-14.47083009399995
							],
							[
								127.85014571400006,
								-14.48446013399996
							],
							[
								127.83466569400002,
								-14.45194016399995
							],
							[
								127.82446581500005,
								-14.450310163999973
							],
							[
								127.81976603500004,
								-14.440560113999936
							],
							[
								127.82843591400001,
								-14.402530163999927
							],
							[
								127.81931602500003,
								-14.39581013399993
							],
							[
								127.81047587500007,
								-14.40209015399995
							],
							[
								127.80652595600009,
								-14.38252010399998
							],
							[
								127.7970860260001,
								-14.390940153999964
							],
							[
								127.78828584700011,
								-14.388410153999928
							],
							[
								127.78212584700009,
								-14.350520152999934
							],
							[
								127.76070622800012,
								-14.367120473999933
							],
							[
								127.76588626800003,
								-14.352120433999971
							],
							[
								127.78012568700001,
								-14.344400142999973
							],
							[
								127.77967571700003,
								-14.333210092999934
							],
							[
								127.76268587700008,
								-14.303171152999937
							],
							[
								127.73762588900001,
								-14.287771162999945
							],
							[
								127.73824583900011,
								-14.281332112999962
							],
							[
								127.71935698000004,
								-14.276632132999964
							],
							[
								127.71060684000008,
								-14.25269313299998
							],
							[
								127.68320684100001,
								-14.243383172999927
							],
							[
								127.68463676100009,
								-14.23661309299996
							],
							[
								127.68459683100002,
								-14.24271312299993
							],
							[
								127.69120680100002,
								-14.242753152999967
							],
							[
								127.69219679100001,
								-14.231913112999962
							],
							[
								127.6837367810001,
								-14.212313092999977
							],
							[
								127.67178694200004,
								-14.22155311299997
							],
							[
								127.6772567920001,
								-14.211593182999934
							],
							[
								127.6653368420001,
								-14.209713172999955
							],
							[
								127.66985700200007,
								-14.190533092999942
							],
							[
								127.6342367640001,
								-14.179422772999942
							],
							[
								127.64843701300003,
								-14.169603132999953
							],
							[
								127.62463704400011,
								-14.160533122999936
							],
							[
								127.61593690400002,
								-14.143643182999938
							],
							[
								127.58913670600009,
								-14.144243112999959
							],
							[
								127.57932671600008,
								-14.128383142999951
							],
							[
								127.56730700700007,
								-14.125253122999936
							],
							[
								127.56680699700007,
								-14.11338409299998
							],
							[
								127.55678675700005,
								-14.104624122999951
							],
							[
								127.54957702800004,
								-14.110454162999929
							],
							[
								127.54350670800011,
								-14.099794112999973
							],
							[
								127.5239270190001,
								-14.119774113999938
							],
							[
								127.53757676800001,
								-14.086304092999967
							],
							[
								127.52102686900002,
								-14.08540418299998
							],
							[
								127.5148370600001,
								-14.094174142999975
							],
							[
								127.50850679000007,
								-14.08781412299993
							],
							[
								127.52367683900002,
								-14.069264132999933
							],
							[
								127.51443671900006,
								-14.066264152999963
							],
							[
								127.51520675900008,
								-14.073054112999955
							],
							[
								127.50462669000001,
								-14.07465412299996
							],
							[
								127.49340696000002,
								-14.060705122999934
							],
							[
								127.48291693100009,
								-14.085055163999982
							],
							[
								127.47755687100005,
								-14.062295143999961
							],
							[
								127.45251779300008,
								-14.05876518399998
							],
							[
								127.44912804300009,
								-14.05404512399997
							],
							[
								127.45927679200008,
								-14.035085183999968
							],
							[
								127.44854700300004,
								-14.024765153999965
							],
							[
								127.46721693100005,
								-14.00087511299995
							],
							[
								127.45969691200003,
								-13.98845509299997
							],
							[
								127.45426702200007,
								-13.990055122999934
							],
							[
								127.45548670200003,
								-13.980225152999935
							],
							[
								127.43963702300005,
								-13.980175102999965
							],
							[
								127.44445703200006,
								-13.97247514299994
							],
							[
								127.42498679300002,
								-13.966685092999967
							],
							[
								127.43007687300008,
								-13.942935082999952
							],
							[
								127.42324691300007,
								-13.942845172999967
							],
							[
								127.4107668040001,
								-13.961375092999958
							],
							[
								127.39557696500003,
								-13.939465132999942
							],
							[
								127.37411700600012,
								-13.939135093999937
							],
							[
								127.37746679600002,
								-13.928015152999933
							],
							[
								127.36058678600011,
								-13.918905182999936
							],
							[
								127.35979692600006,
								-13.908655162999935
							],
							[
								127.34740681700009,
								-13.90656518399993
							],
							[
								127.32186805800006,
								-13.914686163999932
							],
							[
								127.3295878880001,
								-13.933645113999944
							],
							[
								127.34528784700001,
								-13.939535153999941
							],
							[
								127.34576697800003,
								-13.95493515399994
							],
							[
								127.3344169080001,
								-13.963235123999937
							],
							[
								127.31813772900011,
								-13.961146133999932
							],
							[
								127.29070790000003,
								-13.933796123999969
							],
							[
								127.27579776100004,
								-13.937956113999974
							],
							[
								127.28277780100007,
								-13.91924609399996
							],
							[
								127.26558780100004,
								-13.901916143999927
							],
							[
								127.24905804200012,
								-13.90683616399997
							],
							[
								127.2467180320001,
								-13.900406123999971
							],
							[
								127.23517790300002,
								-13.90779611399995
							],
							[
								127.22663799400004,
								-13.942506144999982
							],
							[
								127.21044875500002,
								-13.94460612499995
							],
							[
								127.20702877500003,
								-13.95659610499996
							],
							[
								127.21430906500007,
								-13.966476114999978
							],
							[
								127.20775884500006,
								-13.973576124999965
							],
							[
								127.19875885500005,
								-13.944756134999977
							],
							[
								127.19522905600002,
								-13.959456104999958
							],
							[
								127.18989888600004,
								-13.95721610499993
							],
							[
								127.1862387760001,
								-13.938816134999968
							],
							[
								127.19554799500008,
								-13.922286114999963
							],
							[
								127.19073805500011,
								-13.903996144999951
							],
							[
								127.16981881700008,
								-13.910626174999948
							],
							[
								127.16625878700006,
								-13.917866124999932
							],
							[
								127.17878894600005,
								-13.925846154999931
							],
							[
								127.15764901700004,
								-13.933716114999982
							],
							[
								127.14823899800001,
								-13.956116115999976
							],
							[
								127.1531389380001,
								-13.967056165999963
							],
							[
								127.14503892800008,
								-13.966856185999973
							],
							[
								127.14288903900001,
								-13.982237105999957
							],
							[
								127.127208859,
								-13.96567710599993
							],
							[
								127.11750903000006,
								-13.970567155999959
							],
							[
								127.11377905000006,
								-13.962777115999927
							],
							[
								127.1227488190001,
								-13.94817713599997
							],
							[
								127.10769903000005,
								-13.944607105999978
							],
							[
								127.11147901000004,
								-13.934427125999946
							],
							[
								127.10461887000008,
								-13.925297155999942
							],
							[
								127.09386889100006,
								-13.927367155999946
							],
							[
								127.10076903000004,
								-13.914007105999929
							],
							[
								127.10932875000003,
								-13.913867145999973
							],
							[
								127.0986489600001,
								-13.903287115999944
							],
							[
								127.10285884000007,
								-13.884287125999947
							],
							[
								127.06935903200008,
								-13.896147145999976
							],
							[
								127.06058906200008,
								-13.90790717599998
							],
							[
								127.0766688110001,
								-13.869797135999931
							],
							[
								127.06787903200006,
								-13.870497135999926
							],
							[
								127.0650890820001,
								-13.864177165999934
							],
							[
								127.08112885100002,
								-13.854527175999976
							],
							[
								127.08142874100008,
								-13.839957174999938
							],
							[
								127.06857888100001,
								-13.83592714599996
							],
							[
								127.05751898200003,
								-13.847817155999962
							],
							[
								127.04432893300009,
								-13.848877165999966
							],
							[
								127.04578875200002,
								-13.83339716599994
							],
							[
								127.05582877200004,
								-13.828167175999965
							],
							[
								127.0470879720001,
								-13.805708125999956
							],
							[
								127.03664904300001,
								-13.832067145999929
							],
							[
								127.02598874300008,
								-13.827018145999943
							],
							[
								127.03046894300007,
								-13.816948125999943
							],
							[
								127.00607894400002,
								-13.823768155999971
							],
							[
								127.01784877400007,
								-13.812688175999938
							],
							[
								127.01770799400003,
								-13.803538145999937
							],
							[
								127.03077783300012,
								-13.803948175999949
							],
							[
								127.01837798400004,
								-13.797438125999975
							],
							[
								127.01348775400004,
								-13.785358135999957
							],
							[
								127.01235804400005,
								-13.795758175999936
							],
							[
								127.00206781400004,
								-13.79397815599998
							],
							[
								127.00597776400002,
								-13.787978125999928
							],
							[
								126.99828780400003,
								-13.768677175999926
							],
							[
								126.99627793500008,
								-13.790828165999926
							],
							[
								126.98574793500006,
								-13.787468105999949
							],
							[
								126.98452792500007,
								-13.766458135999926
							],
							[
								126.97791791500003,
								-13.761398155999927
							],
							[
								126.98402677500007,
								-13.754147125999964
							],
							[
								126.96956701600004,
								-13.75248815599997
							],
							[
								126.96329799600005,
								-13.74165817599993
							],
							[
								126.95429800600004,
								-13.74755814599996
							],
							[
								126.91439883800001,
								-13.741218175999961
							],
							[
								126.92507785800001,
								-13.75723817599993
							],
							[
								126.93732794700009,
								-13.757888155999979
							],
							[
								126.94440807700005,
								-13.767578175999972
							],
							[
								126.92177774800007,
								-13.77610812699993
							],
							[
								126.92047885800002,
								-13.768318156999953
							],
							[
								126.89758898000002,
								-13.76633815699995
							],
							[
								126.89779885000007,
								-13.758658106999974
							],
							[
								126.88100882000003,
								-13.748648126999967
							],
							[
								126.8704990110001,
								-13.751378096999929
							],
							[
								126.86843906100012,
								-13.761328136999964
							],
							[
								126.85132793200012,
								-13.758198126999957
							],
							[
								126.85159898200004,
								-13.774468136999928
							],
							[
								126.8729487810001,
								-13.798988186999964
							],
							[
								126.84737907300007,
								-13.797748166999952
							],
							[
								126.84232897300001,
								-13.816968107999969
							],
							[
								126.82623984400004,
								-13.808528097999954
							],
							[
								126.83180492300005,
								-13.786526137999942
							],
							[
								126.82099990400002,
								-13.779275137999946
							],
							[
								126.81907492400012,
								-13.768605137999941
							],
							[
								126.79369691500006,
								-13.775716147999958
							],
							[
								126.7884919060001,
								-13.790851147999945
							],
							[
								126.77771291600004,
								-13.781005147999963
							],
							[
								126.76321292700004,
								-13.790986137999937
							],
							[
								126.76743191700007,
								-13.786189147999949
							],
							[
								126.75768192700002,
								-13.785933137999962
							],
							[
								126.76652190700008,
								-13.774826147999931
							],
							[
								126.74315792800007,
								-13.792278138999961
							],
							[
								126.76046104700004,
								-13.808199148999961
							],
							[
								126.75841083800003,
								-13.826049118999947
							],
							[
								126.77281983700004,
								-13.86070910899997
							],
							[
								126.79958009600011,
								-13.883019128999933
							],
							[
								126.80948977600008,
								-13.916779108999947
							],
							[
								126.8055798260001,
								-13.930459098999961
							],
							[
								126.82083985500003,
								-13.924779118999936
							],
							[
								126.8394698840001,
								-13.92767910799995
							],
							[
								126.84006998500001,
								-13.937509168999952
							],
							[
								126.86507993300006,
								-13.945568117999926
							],
							[
								126.90538012200011,
								-13.985218437999947
							],
							[
								126.88215039300007,
								-13.998558688999935
							],
							[
								126.87870016300008,
								-13.982048647999932
							],
							[
								126.83829984500005,
								-13.971059178999951
							],
							[
								126.81738096600009,
								-13.982059168999967
							],
							[
								126.81001106700012,
								-13.99788917899997
							],
							[
								126.8103210270001,
								-13.984109098999966
							],
							[
								126.8013210370001,
								-13.992599158999951
							],
							[
								126.79344098800004,
								-13.989329098999974
							],
							[
								126.80720093700006,
								-13.986369168999943
							],
							[
								126.79804107700011,
								-13.975999108999929
							],
							[
								126.7918108880001,
								-13.983799128999976
							],
							[
								126.78913105800007,
								-13.973079138999935
							],
							[
								126.77355099900001,
								-13.982769179999934
							],
							[
								126.79699096700006,
								-13.972499188999961
							],
							[
								126.78681086800009,
								-13.970259098999975
							],
							[
								126.77214089900008,
								-13.983159139999941
							],
							[
								126.76807107900004,
								-13.975369109999974
							],
							[
								126.75071080000009,
								-13.972129109999969
							],
							[
								126.75156183000001,
								-13.991779159999965
							],
							[
								126.72712392100004,
								-13.998347149999972
							],
							[
								126.7053449120001,
								-13.97391313999998
							],
							[
								126.69385190300011,
								-14.000602150999953
							],
							[
								126.70165093300011,
								-14.009103140999969
							],
							[
								126.69526993300008,
								-14.009392150999929
							],
							[
								126.70080690300006,
								-14.021555140999965
							],
							[
								126.72172991200011,
								-14.030479149999962
							],
							[
								126.73572492100004,
								-14.015669139999943
							],
							[
								126.75330194000003,
								-14.011909139999943
							],
							[
								126.75799193000012,
								-14.017419149999967
							],
							[
								126.74144392100004,
								-14.01716713999997
							],
							[
								126.74884291000001,
								-14.016920149999976
							],
							[
								126.74833191100004,
								-14.034100129999956
							],
							[
								126.76274091000005,
								-14.050079099999948
							],
							[
								126.7494508210001,
								-14.050250099999971
							],
							[
								126.74513185100011,
								-14.059200159999932
							],
							[
								126.72314202200005,
								-14.065190110999936
							],
							[
								126.73717193200002,
								-14.07043018099995
							],
							[
								126.72975195200002,
								-14.092170120999981
							],
							[
								126.71817182300003,
								-14.090190120999978
							],
							[
								126.71023201300011,
								-14.100280110999961
							],
							[
								126.71789175300012,
								-14.104090170999939
							],
							[
								126.71967197300012,
								-14.120590130999972
							],
							[
								126.6938430350001,
								-14.134710151999968
							],
							[
								126.6863028350001,
								-14.131020151999962
							],
							[
								126.69290199400007,
								-14.105450160999965
							],
							[
								126.68936175500005,
								-14.09123017099995
							],
							[
								126.68560192500001,
								-14.103680130999976
							],
							[
								126.66326176600012,
								-14.078120130999935
							],
							[
								126.6515520260001,
								-14.072980141999949
							],
							[
								126.64485208700012,
								-14.077081171999964
							],
							[
								126.6609919760001,
								-14.114750131999926
							],
							[
								126.6473227670001,
								-14.137531121999928
							],
							[
								126.65142281800001,
								-14.173441121999929
							],
							[
								126.63362296900004,
								-14.191201172999968
							],
							[
								126.6190328990001,
								-14.179911122999954
							],
							[
								126.60699305000003,
								-14.180081142999938
							],
							[
								126.61042277000001,
								-14.19837111299995
							],
							[
								126.60306291100005,
								-14.209471162999932
							],
							[
								126.60167405100003,
								-14.235811112999954
							],
							[
								126.59353407100002,
								-14.22873118299998
							],
							[
								126.57547394200003,
								-14.228691133999973
							],
							[
								126.56500410300009,
								-14.216751103999968
							],
							[
								126.57047282200006,
								-14.194581122999978
							],
							[
								126.56262302200003,
								-14.16998214299997
							],
							[
								126.57493291200001,
								-14.154561182999942
							],
							[
								126.56978308200007,
								-14.13978111299997
							],
							[
								126.56168308200006,
								-14.13992213299997
							],
							[
								126.55582300300011,
								-14.151022112999954
							],
							[
								126.53786299300009,
								-14.147142132999932
							],
							[
								126.51545404500007,
								-14.15740212399993
							],
							[
								126.51726305500006,
								-14.147222123999939
							],
							[
								126.499162995,
								-14.130272163999962
							],
							[
								126.49949310500006,
								-14.100172113999974
							],
							[
								126.5251528230001,
								-14.092392152999935
							],
							[
								126.52545307300011,
								-14.08165218299996
							],
							[
								126.51374299400004,
								-14.075482142999931
							],
							[
								126.51187277400004,
								-14.08601213299994
							],
							[
								126.5118029140001,
								-14.081482172999927
							],
							[
								126.4921929950001,
								-14.098732103999964
							],
							[
								126.48131311600002,
								-14.097412173999942
							],
							[
								126.47881289600002,
								-14.109632103999957
							],
							[
								126.45690293700011,
								-14.09931215399996
							],
							[
								126.4546838770001,
								-14.103512103999947
							],
							[
								126.4494739480001,
								-14.08372219399996
							],
							[
								126.45251380700006,
								-14.073442113999931
							],
							[
								126.45947406700009,
								-14.07365217399996
							],
							[
								126.48355300500009,
								-14.04735218299993
							],
							[
								126.49720276400001,
								-14.045832092999945
							],
							[
								126.48742302500011,
								-14.028462192999939
							],
							[
								126.491042074,
								-14.008562112999982
							],
							[
								126.50897186300006,
								-14.008832092999967
							],
							[
								126.5392320410001,
								-13.964361131999965
							],
							[
								126.56594080000002,
								-13.954741111999965
							],
							[
								126.56523087900007,
								-13.944121111999948
							],
							[
								126.57739095900001,
								-13.953821121999965
							],
							[
								126.57124107900006,
								-13.940501121999944
							],
							[
								126.55437074000008,
								-13.951811151999948
							],
							[
								126.53700075100005,
								-13.93443216199995
							],
							[
								126.51149164300011,
								-13.964711961999967
							],
							[
								126.49527209300004,
								-13.957622102999949
							],
							[
								126.49586175400009,
								-13.97715210299998
							],
							[
								126.4852320440001,
								-13.99568211299993
							],
							[
								126.4703118650001,
								-13.995122132999938
							],
							[
								126.46489278600006,
								-14.005612172999975
							],
							[
								126.45436275600002,
								-14.005202142999963
							],
							[
								126.44602301700002,
								-14.002292163999982
							],
							[
								126.44392276700012,
								-13.984182182999973
							],
							[
								126.43837301700012,
								-13.98271213299995
							],
							[
								126.42704308800012,
								-13.99706217399995
							],
							[
								126.42535291800004,
								-14.012052113999971
							],
							[
								126.39656299900003,
								-14.01490215399997
							],
							[
								126.38762382000004,
								-14.037872144999938
							],
							[
								126.39433387000008,
								-14.051762104999966
							],
							[
								126.3719137810001,
								-14.045153134999964
							],
							[
								126.33433484300008,
								-14.050022124999941
							],
							[
								126.34384495300003,
								-14.058802174999926
							],
							[
								126.34501493300002,
								-14.09799312499996
							],
							[
								126.31446607500004,
								-14.097312175999946
							],
							[
								126.31522603500002,
								-14.119002185999932
							],
							[
								126.30620692600007,
								-14.122302125999965
							],
							[
								126.2975770170001,
								-14.138823165999952
							],
							[
								126.30405700600011,
								-14.138803185999961
							],
							[
								126.30549700600011,
								-14.15473318599993
							],
							[
								126.32089602500002,
								-14.140963165999949
							],
							[
								126.32309598500001,
								-14.15818315599995
							],
							[
								126.3537060540001,
								-14.17729311599993
							],
							[
								126.36080705400002,
								-14.18992317599998
							],
							[
								126.3394068550001,
								-14.192703105999954
							],
							[
								126.3238581060001,
								-14.207473165999943
							],
							[
								126.31869788600011,
								-14.197853165999959
							],
							[
								126.31268801700003,
								-14.20126317699993
							],
							[
								126.30085876800001,
								-14.23360314699994
							],
							[
								126.28217908800002,
								-14.216713126999935
							],
							[
								126.27816908900002,
								-14.23231317699998
							],
							[
								126.26972886900012,
								-14.236523106999982
							],
							[
								126.2725390390001,
								-14.20713315699993
							],
							[
								126.2706090690001,
								-14.221043106999957
							],
							[
								126.25363905000006,
								-14.239163167999948
							],
							[
								126.24978881000004,
								-14.226973117999933
							],
							[
								126.24097891100007,
								-14.223383117999958
							],
							[
								126.23071891200004,
								-14.237074187999951
							],
							[
								126.22433900200008,
								-14.232344147999981
							],
							[
								126.21600893200002,
								-14.236554147999982
							],
							[
								126.23340812100002,
								-14.203633147999938
							],
							[
								126.24812886000007,
								-14.210703106999972
							],
							[
								126.24010806100011,
								-14.198073137999927
							],
							[
								126.24805794000008,
								-14.185623156999952
							],
							[
								126.23312802100008,
								-14.186794147999933
							],
							[
								126.2432879800001,
								-14.175704176999943
							],
							[
								126.20465780200004,
								-14.18517413799998
							],
							[
								126.20787798200001,
								-14.177034097999979
							],
							[
								126.19643793300008,
								-14.18271417799997
							],
							[
								126.19733791300007,
								-14.175594187999934
							],
							[
								126.18597809300002,
								-14.166924127999948
							],
							[
								126.20893710100006,
								-14.13647416799995
							],
							[
								126.18568689300002,
								-14.140374127999962
							],
							[
								126.17940703300007,
								-14.130345157999955
							],
							[
								126.21652592100008,
								-14.120864106999932
							],
							[
								126.21200609100003,
								-14.115904126999965
							],
							[
								126.2217059300001,
								-14.110464166999975
							],
							[
								126.20580580100011,
								-14.091525106999939
							],
							[
								126.21421507000002,
								-14.076474136999934
							],
							[
								126.17815603200006,
								-14.091365167999982
							],
							[
								126.16571588300008,
								-14.114225157999954
							],
							[
								126.16255582300005,
								-14.098976107999931
							],
							[
								126.17038507300003,
								-14.08212612799997
							],
							[
								126.19186480100007,
								-14.06625517699996
							],
							[
								126.15913507300002,
								-14.06871611799994
							],
							[
								126.15083490400002,
								-14.080146127999967
							],
							[
								126.14953495400005,
								-14.067496177999942
							],
							[
								126.16026511300004,
								-14.057526157999973
							],
							[
								126.21748386000002,
								-14.04291511699995
							],
							[
								126.22472381900002,
								-14.026405136999927
							],
							[
								126.22042396900008,
								-14.017484166999964
							],
							[
								126.20225406000009,
								-14.012564146999978
							],
							[
								126.20071397000004,
								-14.000935156999958
							],
							[
								126.18524407100006,
								-14.008995106999976
							],
							[
								126.18503383100006,
								-14.015795126999933
							],
							[
								126.17333383200003,
								-14.00970618699995
							],
							[
								126.15415410300011,
								-14.01913611699996
							],
							[
								126.14431388300011,
								-14.014976137999952
							],
							[
								126.15776384200001,
								-13.997786136999935
							],
							[
								126.19339412000011,
								-13.98008511699993
							],
							[
								126.22103381900001,
								-13.987894155999982
							],
							[
								126.21583398900009,
								-13.967565135999962
							],
							[
								126.18704407000007,
								-13.968115116999968
							],
							[
								126.11726384500002,
								-14.018656157999942
							],
							[
								126.12679410400006,
								-14.027026147999948
							],
							[
								126.10977510500004,
								-14.028276157999926
							],
							[
								126.11008400500009,
								-14.013816127999974
							],
							[
								126.12867403400003,
								-14.000896177999948
							],
							[
								126.13579409300007,
								-13.98941612699997
							],
							[
								126.13094382300005,
								-13.986926107999977
							],
							[
								126.1587037920001,
								-13.970126156999982
							],
							[
								126.14136403300006,
								-13.959836106999944
							],
							[
								126.12621379300003,
								-13.963996186999964
							],
							[
								126.13686401300004,
								-13.94955611699993
							],
							[
								126.14843408200011,
								-13.949676186999966
							],
							[
								126.16162412100005,
								-13.924286106999944
							],
							[
								126.1528440410001,
								-13.926536106999947
							],
							[
								126.15839383100001,
								-13.915026186999967
							],
							[
								126.13423390200012,
								-13.918956126999944
							],
							[
								126.13236404300005,
								-13.944476166999948
							],
							[
								126.11213380400011,
								-13.935086106999961
							],
							[
								126.11584399300011,
								-13.927296166999952
							],
							[
								126.1049737840001,
								-13.925586156999941
							],
							[
								126.08564396500003,
								-13.94566614799993
							],
							[
								126.10787392400005,
								-13.919046126999945
							],
							[
								126.08532390500011,
								-13.920936127999937
							],
							[
								126.10071390400003,
								-13.900066126999945
							],
							[
								126.09482397400006,
								-13.895326186999966
							],
							[
								126.06508399600011,
								-13.927247097999953
							],
							[
								126.0687739660001,
								-13.933907097999963
							],
							[
								126.06275408700003,
								-13.942937177999966
							],
							[
								126.05027503700012,
								-13.941677177999964
							],
							[
								126.03873380800007,
								-13.920997157999977
							],
							[
								126.01121503900004,
								-13.92570810899997
							],
							[
								126.02113485900009,
								-13.939267148999932
							],
							[
								126.02392484800009,
								-13.931817118999959
							],
							[
								126.03132499800006,
								-13.932167138999944
							],
							[
								126.03604495800005,
								-13.943467178999981
							],
							[
								126.05142485700003,
								-13.947997147999956
							],
							[
								126.04655476800008,
								-13.954317137999965
							],
							[
								126.08227396600012,
								-13.969596157999945
							],
							[
								126.08387492600002,
								-13.982016167999973
							],
							[
								126.10042413500003,
								-13.972776117999956
							],
							[
								126.10724397500007,
								-13.976736117999963
							],
							[
								126.08641506600009,
								-13.987666177999927
							],
							[
								126.09665383600009,
								-13.998566177999976
							],
							[
								126.08995494600003,
								-14.007536107999954
							],
							[
								126.0956350460001,
								-14.014756167999963
							],
							[
								126.08639492600003,
								-14.019066187999954
							],
							[
								126.1026247960001,
								-14.040826117999927
							],
							[
								126.10078482600011,
								-14.045466157999954
							],
							[
								126.08306491700012,
								-14.034656158999951
							],
							[
								126.07475503700005,
								-14.041456108999967
							],
							[
								126.06536478700002,
								-13.988207177999982
							],
							[
								126.03819488800002,
								-13.98151710899998
							],
							[
								126.03853506900009,
								-13.991567148999934
							],
							[
								126.03171489900001,
								-13.98839714899998
							],
							[
								126.02187607000008,
								-13.996847178999928
							],
							[
								126.04334609800003,
								-14.003227178999964
							],
							[
								126.05599578800002,
								-14.026586148999968
							],
							[
								126.03477596900007,
								-14.038286138999979
							],
							[
								126.04003590900004,
								-14.025146138999958
							],
							[
								126.0267158900001,
								-14.01670710899998
							],
							[
								126.02929604000008,
								-14.034657158999948
							],
							[
								126.01198687100009,
								-14.05570715999994
							],
							[
								126.01530680100007,
								-14.066127199999926
							],
							[
								126.01015697100001,
								-14.065417189999948
							],
							[
								126.00536613100007,
								-14.040017109999951
							],
							[
								126.01436612000009,
								-14.025427118999971
							],
							[
								125.9841358320001,
								-14.006127159999949
							],
							[
								125.98385613100004,
								-13.98979818999993
							],
							[
								125.97292581200008,
								-13.998658159999934
							],
							[
								125.9829658220001,
								-14.016387149999957
							],
							[
								125.97623709300001,
								-14.039627149999944
							],
							[
								125.9920669920001,
								-14.050147159999938
							],
							[
								125.99308687200005,
								-14.068197109999971
							],
							[
								126.00414678200002,
								-14.069497159999969
							],
							[
								126.00983694100012,
								-14.081347179999966
							],
							[
								126.03252706,
								-14.09508612999997
							],
							[
								126.06406589800008,
								-14.073336178999966
							],
							[
								126.08780612700002,
								-14.086156148999976
							],
							[
								126.10443595600009,
								-14.07573612799996
							],
							[
								126.12622605500007,
								-14.096916187999966
							],
							[
								126.13333713500003,
								-14.118025147999958
							],
							[
								126.15220686400005,
								-14.125665147999939
							],
							[
								126.15328686400005,
								-14.140114117999929
							],
							[
								126.16972701400005,
								-14.146174177999967
							],
							[
								126.14128807500003,
								-14.157764118999978
							],
							[
								126.16019777500003,
								-14.176474127999938
							],
							[
								126.14776806600003,
								-14.209154188999946
							],
							[
								126.1366480160001,
								-14.204324178999968
							],
							[
								126.13980810600003,
								-14.219784108999932
							],
							[
								126.13322912700005,
								-14.231434148999938
							],
							[
								126.0939408590001,
								-14.243985109999926
							],
							[
								126.09655086900011,
								-14.239225179999949
							],
							[
								126.08406101000003,
								-14.240245139999956
							],
							[
								126.0812699600001,
								-14.234145119999937
							],
							[
								126.053409912,
								-14.254195139999979
							],
							[
								126.07305009100003,
								-14.297755149999944
							],
							[
								126.0829000110001,
								-14.303495159999954
							],
							[
								126.08049992100007,
								-14.320895140999937
							],
							[
								126.0902299810001,
								-14.323135149999928
							],
							[
								126.08642011100005,
								-14.330605160999937
							],
							[
								126.07391010200001,
								-14.325655150999978
							],
							[
								126.07289996200006,
								-14.343735160999927
							],
							[
								126.0842399710001,
								-14.342805190999968
							],
							[
								126.08844006100003,
								-14.35119518099998
							],
							[
								126.08191112200007,
								-14.358895120999932
							],
							[
								126.07545989200003,
								-14.35219516099994
							],
							[
								126.0693409920001,
								-14.362265170999933
							],
							[
								126.0458211240001,
								-14.359146130999932
							],
							[
								126.02791185500007,
								-14.381986151999968
							],
							[
								126.02176197500012,
								-14.377596141999959
							],
							[
								126.00985205600011,
								-14.387776111999926
							],
							[
								126.00616278600012,
								-14.399756201999935
							],
							[
								125.99614291700004,
								-14.396356171999969
							],
							[
								125.99243312700003,
								-14.402556191999963
							],
							[
								125.9766831280001,
								-14.393286191999948
							],
							[
								125.9854728680001,
								-14.419516162999969
							],
							[
								126.01961310600007,
								-14.41136611199994
							],
							[
								126.02477190600007,
								-14.457786131999967
							],
							[
								126.03151185600007,
								-14.470536161999974
							],
							[
								126.04634205500008,
								-14.47220619199993
							],
							[
								126.0429018960001,
								-14.494346101999952
							],
							[
								126.05346211500012,
								-14.503936151999937
							],
							[
								126.0433821260001,
								-14.503386171999978
							],
							[
								126.0422319060001,
								-14.50869617199993
							],
							[
								126.0513021160001,
								-14.528786151999952
							],
							[
								126.04192194600012,
								-14.536706152999955
							],
							[
								126.0154720380001,
								-14.519466112999964
							],
							[
								126.00574193800003,
								-14.525016132999951
							],
							[
								126.01387183800011,
								-14.534156162999977
							],
							[
								126.00030197900003,
								-14.554976142999976
							],
							[
								125.98838207000006,
								-14.551616172999957
							],
							[
								125.98190204000002,
								-14.540446182999972
							],
							[
								125.97253304000003,
								-14.545726123999941
							],
							[
								125.97287183000003,
								-14.529266112999949
							],
							[
								125.96476281100001,
								-14.51921617399995
							],
							[
								125.95560295100006,
								-14.53127617399997
							],
							[
								125.94923312100002,
								-14.523486143999946
							],
							[
								125.94568280200008,
								-14.538716123999961
							],
							[
								125.93549299200004,
								-14.53768615399997
							],
							[
								125.93252302300004,
								-14.53059613399995
							],
							[
								125.9205929630001,
								-14.537226163999946
							],
							[
								125.92069304400002,
								-14.552086163999945
							],
							[
								125.90387315500004,
								-14.56440616499998
							],
							[
								125.90270310500011,
								-14.576476154999966
							],
							[
								125.91915296400009,
								-14.582796124999959
							],
							[
								125.93304285400006,
								-14.609236154999962
							],
							[
								125.93052285400006,
								-14.633156174999954
							],
							[
								125.93631310400008,
								-14.646316154999965
							],
							[
								125.92100303500001,
								-14.650906154999973
							],
							[
								125.92849280500002,
								-14.645796134999955
							],
							[
								125.92131295500008,
								-14.63980618499994
							],
							[
								125.90830293600004,
								-14.660896154999932
							],
							[
								125.89477304600007,
								-14.623076174999937
							],
							[
								125.8813029370001,
								-14.623316124999974
							],
							[
								125.87624312700007,
								-14.606246174999967
							],
							[
								125.85142294800005,
								-14.612117145999946
							],
							[
								125.84927301800008,
								-14.591666175999933
							],
							[
								125.8305829090001,
								-14.585076195999932
							],
							[
								125.83559300900004,
								-14.568046135999964
							],
							[
								125.85020289800002,
								-14.564006125999981
							],
							[
								125.82867311900009,
								-14.54275613599998
							],
							[
								125.84989293700005,
								-14.535896144999981
							],
							[
								125.8364631280001,
								-14.524826154999971
							],
							[
								125.82445389800012,
								-14.498396114999935
							],
							[
								125.81721393900011,
								-14.497576115999948
							],
							[
								125.82806400800007,
								-14.480906134999941
							],
							[
								125.85913411600006,
								-14.474966134999931
							],
							[
								125.85208388600006,
								-14.456676164999976
							],
							[
								125.80257382900004,
								-14.479066185999955
							],
							[
								125.8162941380001,
								-14.450346194999952
							],
							[
								125.80356308800003,
								-14.444186154999954
							],
							[
								125.79799281900011,
								-14.445306194999944
							],
							[
								125.79460415900007,
								-14.466406155999948
							],
							[
								125.78115380000008,
								-14.467746165999927
							],
							[
								125.77441390100012,
								-14.479696185999956
							],
							[
								125.76539409100008,
								-14.472226175999936
							],
							[
								125.74068406300012,
								-14.48561512699996
							],
							[
								125.73102383300011,
								-14.476975126999946
							],
							[
								125.7067249050001,
								-14.489382176999982
							],
							[
								125.70213492500011,
								-14.520973156999958
							],
							[
								125.64853486100003,
								-14.650212168999929
							],
							[
								125.6520240000001,
								-14.602036168999973
							],
							[
								125.6752839180001,
								-14.556706137999981
							],
							[
								125.68067383700009,
								-14.529404187999944
							],
							[
								125.6762638670001,
								-14.52344411799993
							],
							[
								125.68068394700003,
								-14.525114147999943
							],
							[
								125.68873496600008,
								-14.499392157999978
							],
							[
								125.6824238260001,
								-14.469355186999962
							],
							[
								125.6750038560001,
								-14.470015157999967
							],
							[
								125.67759297600003,
								-14.451967176999972
							],
							[
								125.65930279700001,
								-14.44165912799997
							],
							[
								125.66085298600001,
								-14.424730126999975
							],
							[
								125.67071302600004,
								-14.420350176999932
							],
							[
								125.65120282600003,
								-14.387571196999943
							],
							[
								125.65458286600006,
								-14.379792136999981
							],
							[
								125.66614282500007,
								-14.38382215699994
							],
							[
								125.6663131250001,
								-14.366952116999926
							],
							[
								125.67803287400011,
								-14.356713156999945
							],
							[
								125.67387311400012,
								-14.350943176999976
							],
							[
								125.66830318500001,
								-14.357252896999967
							],
							[
								125.67296302400007,
								-14.345183186999975
							],
							[
								125.66418295400001,
								-14.334983116999979
							],
							[
								125.68271287300001,
								-14.334253125999965
							],
							[
								125.70214280300002,
								-14.347953115999928
							],
							[
								125.70586306200005,
								-14.340963165999938
							],
							[
								125.72636289100001,
								-14.341801155999974
							],
							[
								125.71757314100012,
								-14.334102195999947
							],
							[
								125.72570304100009,
								-14.324531155999978
							],
							[
								125.70460305200004,
								-14.333632135999949
							],
							[
								125.6972129720001,
								-14.325372195999933
							],
							[
								125.71087284200007,
								-14.327662165999982
							],
							[
								125.71269298100003,
								-14.315142155999979
							],
							[
								125.7237619010001,
								-14.31222112599994
							],
							[
								125.7215821210001,
								-14.298451125999975
							],
							[
								125.71453185100006,
								-14.296621165999966
							],
							[
								125.73007198000005,
								-14.280971144999967
							],
							[
								125.71792197100001,
								-14.277441155999952
							],
							[
								125.71813185100007,
								-14.288621155999977
							],
							[
								125.70328186200004,
								-14.304051185999981
							],
							[
								125.69531183200002,
								-14.292411135999942
							],
							[
								125.66672207400006,
								-14.288172135999957
							],
							[
								125.66504084300004,
								-14.263102175999961
							],
							[
								125.65508113400006,
								-14.266802175999942
							],
							[
								125.6582210040001,
								-14.259592195999971
							],
							[
								125.64857088400004,
								-14.243412165999928
							],
							[
								125.6491507940001,
								-14.259582205999948
							],
							[
								125.64153105500009,
								-14.265872206999973
							],
							[
								125.64097088400001,
								-14.247492136999938
							],
							[
								125.62630088500009,
								-14.244842176999953
							],
							[
								125.63315098500004,
								-14.236052146999953
							],
							[
								125.62008084500007,
								-14.234442146999982
							],
							[
								125.60905112600005,
								-14.243662196999935
							],
							[
								125.59761107700001,
								-14.236632196999949
							],
							[
								125.60593103600002,
								-14.242982156999972
							],
							[
								125.60826199600001,
								-14.26236212699996
							],
							[
								125.59215093700004,
								-14.24373212699993
							],
							[
								125.57369193800002,
								-14.261633117999963
							],
							[
								125.58393215800004,
								-14.260113187999934
							],
							[
								125.59879185700004,
								-14.273772126999972
							],
							[
								125.5822620990001,
								-14.305343157999971
							],
							[
								125.58279309900001,
								-14.321822137999959
							],
							[
								125.6037029680001,
								-14.343552107999926
							],
							[
								125.5879130290001,
								-14.357842127999959
							],
							[
								125.58857287900003,
								-14.36992112799993
							],
							[
								125.6080229580001,
								-14.37494113799994
							],
							[
								125.61042308800006,
								-14.390411147999941
							],
							[
								125.62271314800012,
								-14.385701177999977
							],
							[
								125.61689300800003,
								-14.395841127999972
							],
							[
								125.62195281800007,
								-14.412900177999973
							],
							[
								125.60127298000009,
								-14.433509177999952
							],
							[
								125.59946291000006,
								-14.46160815899998
							],
							[
								125.59449311000003,
								-14.458768138999972
							],
							[
								125.60066387100005,
								-14.494005198999957
							],
							[
								125.59104393100006,
								-14.493645208999965
							],
							[
								125.59798404100002,
								-14.496704118999958
							],
							[
								125.5882240520001,
								-14.505715198999951
							],
							[
								125.59459392100007,
								-14.507535168999937
							],
							[
								125.60238393100008,
								-14.498294138999938
							],
							[
								125.60630400100001,
								-14.509254168999973
							],
							[
								125.61371386000008,
								-14.510624148999966
							],
							[
								125.6001339610001,
								-14.517485118999957
							],
							[
								125.59649506200003,
								-14.536545128999933
							],
							[
								125.58098409200011,
								-14.527815148999935
							],
							[
								125.57247514300002,
								-14.547665189999975
							],
							[
								125.59933509200005,
								-14.562626158999933
							],
							[
								125.56943494400002,
								-14.558266189999927
							],
							[
								125.55735406400004,
								-14.565916199999947
							],
							[
								125.55042407500002,
								-14.556526129999952
							],
							[
								125.5347950260001,
								-14.563897119999979
							],
							[
								125.5299245760001,
								-14.546086769999931
							],
							[
								125.54800415500006,
								-14.548395179999943
							],
							[
								125.5446849550001,
								-14.534946199999979
							],
							[
								125.55779506400006,
								-14.530695139999978
							],
							[
								125.56061494300002,
								-14.514785119999942
							],
							[
								125.54138484400005,
								-14.509877139999958
							],
							[
								125.52906489500003,
								-14.522268159999953
							],
							[
								125.52955486500002,
								-14.511879189999945
							],
							[
								125.51994503600008,
								-14.509150129999966
							],
							[
								125.52877511500003,
								-14.502739159999976
							],
							[
								125.52031511500002,
								-14.500231129999975
							],
							[
								125.51529490600001,
								-14.512970179999968
							],
							[
								125.50612500600005,
								-14.517581150999945
							],
							[
								125.49628511700007,
								-14.512362140999926
							],
							[
								125.48861493700008,
								-14.519220140999948
							],
							[
								125.49565508700005,
								-14.530420190999962
							],
							[
								125.49139488800006,
								-14.560318190999965
							],
							[
								125.48046488800003,
								-14.532178150999982
							],
							[
								125.46653506900009,
								-14.535517160999973
							],
							[
								125.46739511900012,
								-14.55922721099995
							],
							[
								125.48343492900005,
								-14.568017150999935
							],
							[
								125.47120498900006,
								-14.564437140999928
							],
							[
								125.46664486000009,
								-14.576047131999928
							],
							[
								125.45237482100003,
								-14.579167151999968
							],
							[
								125.46342505000007,
								-14.605277151999928
							],
							[
								125.43725590200006,
								-14.594587131999958
							],
							[
								125.45003590100009,
								-14.623748121999938
							],
							[
								125.42995586300003,
								-14.64147821299997
							],
							[
								125.42716584300001,
								-14.630568152999956
							],
							[
								125.43823585200005,
								-14.61377719199993
							],
							[
								125.42677595300006,
								-14.60730719199995
							],
							[
								125.42725585200003,
								-14.600767161999954
							],
							[
								125.41345593300002,
								-14.600497152999935
							],
							[
								125.4249860220001,
								-14.586417121999943
							],
							[
								125.41549606300009,
								-14.579167151999968
							],
							[
								125.42037589200004,
								-14.576357191999932
							],
							[
								125.41519585200001,
								-14.563927191999937
							],
							[
								125.41066598300006,
								-14.566617201999975
							],
							[
								125.4153560420001,
								-14.550377161999961
							],
							[
								125.41027608200011,
								-14.54561714199997
							],
							[
								125.39960604300006,
								-14.547167202999958
							],
							[
								125.40009601300005,
								-14.572797142999946
							],
							[
								125.39443607400005,
								-14.565097182999978
							],
							[
								125.39161586400007,
								-14.576147122999942
							],
							[
								125.38584612400007,
								-14.568227122999929
							],
							[
								125.37445608500002,
								-14.575757162999935
							],
							[
								125.3746760350001,
								-14.585487142999966
							],
							[
								125.35459595600003,
								-14.58404814399995
							],
							[
								125.36893586500003,
								-14.563547122999978
							],
							[
								125.35505604600007,
								-14.551757132999967
							],
							[
								125.36004599500006,
								-14.550527172999978
							],
							[
								125.35513594500003,
								-14.53007820299996
							],
							[
								125.36419607500011,
								-14.525029202999974
							],
							[
								125.36414497400006,
								-14.505729152999947
							],
							[
								125.34206616600011,
								-14.521569142999965
							],
							[
								125.34258599600003,
								-14.53895812299993
							],
							[
								125.35010602600005,
								-14.54383820299995
							],
							[
								125.3445159360001,
								-14.549917152999967
							],
							[
								125.34759609600007,
								-14.564718123999967
							],
							[
								125.3356761870001,
								-14.55575816399994
							],
							[
								125.32824613700006,
								-14.559228203999965
							],
							[
								125.3257160280001,
								-14.584398143999977
							],
							[
								125.30041594900001,
								-14.55821812399995
							],
							[
								125.29769618900002,
								-14.571878153999933
							],
							[
								125.3035861190001,
								-14.57956820399994
							],
							[
								125.2949061590001,
								-14.574688143999936
							],
							[
								125.28746604000003,
								-14.578498194999952
							],
							[
								125.2904659400001,
								-14.583368194999935
							],
							[
								125.28248616000008,
								-14.57858820499996
							],
							[
								125.2745060210001,
								-14.59507817499997
							],
							[
								125.26550603100009,
								-14.589478184999962
							],
							[
								125.25538714200002,
								-14.59767818499995
							],
							[
								125.26087718200006,
								-14.615538134999952
							],
							[
								125.24902705300008,
								-14.611118155999975
							],
							[
								125.25687685300011,
								-14.630518205999977
							],
							[
								125.28035715100009,
								-14.640198144999943
							],
							[
								125.28845712100008,
								-14.623208124999962
							],
							[
								125.30842704000008,
								-14.649928144999933
							],
							[
								125.27929690200006,
								-14.653658184999927
							],
							[
								125.27369714200006,
								-14.66131818499997
							],
							[
								125.27139706200012,
								-14.655208174999927
							],
							[
								125.2608368430001,
								-14.65776812599995
							],
							[
								125.26101686300001,
								-14.67063813599998
							],
							[
								125.25429707300009,
								-14.668468135999944
							],
							[
								125.26824707300011,
								-14.690988205999929
							],
							[
								125.26211701300008,
								-14.693068195999956
							],
							[
								125.2455671140001,
								-14.675548165999942
							],
							[
								125.24565708400007,
								-14.682208165999953
							],
							[
								125.23436712400007,
								-14.661168145999966
							],
							[
								125.21875716600005,
								-14.675218145999963
							],
							[
								125.21844684500002,
								-14.666858115999958
							],
							[
								125.2128668360001,
								-14.668648146999942
							],
							[
								125.21056715600002,
								-14.69223812699994
							],
							[
								125.21747700600008,
								-14.70569816699998
							],
							[
								125.21148695700003,
								-14.721698186999959
							],
							[
								125.20114704700006,
								-14.697958176999975
							],
							[
								125.19925704700006,
								-14.70652815699998
							],
							[
								125.17985700800011,
								-14.709839156999976
							],
							[
								125.18291701900012,
								-14.726899206999974
							],
							[
								125.19529704800004,
								-14.738358176999952
							],
							[
								125.18774786900008,
								-14.738659136999956
							],
							[
								125.18898805900005,
								-14.747019137999928
							],
							[
								125.17881802900001,
								-14.736259187999963
							],
							[
								125.15980788000002,
								-14.732109217999948
							],
							[
								125.14671796100004,
								-14.752159147999976
							],
							[
								125.14143816100011,
								-14.747659127999952
							],
							[
								125.15079819100004,
								-14.775089157999957
							],
							[
								125.15466817100003,
								-14.766529167999977
							],
							[
								125.16970789000004,
								-14.778789157999938
							],
							[
								125.16679800100007,
								-14.790499137999973
							],
							[
								125.1900381690001,
								-14.775369147999982
							],
							[
								125.18160101000001,
								-14.79231017799998
							],
							[
								125.19467786900009,
								-14.776179157999934
							],
							[
								125.19298802900005,
								-14.79118916799996
							],
							[
								125.20171801900005,
								-14.78511920799997
							],
							[
								125.20517796900003,
								-14.791009157999952
							],
							[
								125.20515817900002,
								-14.797109187999979
							],
							[
								125.18950790000008,
								-14.803759197999966
							],
							[
								125.19527796000011,
								-14.827549157999954
							],
							[
								125.18412805000003,
								-14.826939137999943
							],
							[
								125.18957812000008,
								-14.829679197999951
							],
							[
								125.18617789100006,
								-14.837339197999938
							],
							[
								125.1968781600001,
								-14.833319157999938
							],
							[
								125.20054802000004,
								-14.844059137999977
							],
							[
								125.20891800900006,
								-14.842849157999979
							],
							[
								125.21010821000004,
								-14.864869187999943
							],
							[
								125.22356786900002,
								-14.866599177999944
							],
							[
								125.2245780080001,
								-14.847989157999962
							],
							[
								125.23174810800003,
								-14.854449176999935
							],
							[
								125.24414795700011,
								-14.83168818699994
							],
							[
								125.24912786700008,
								-14.834528206999948
							],
							[
								125.23552811800005,
								-14.86755919799998
							],
							[
								125.25095808700007,
								-14.872249196999974
							],
							[
								125.25428809700009,
								-14.852508156999932
							],
							[
								125.26410819600005,
								-14.865408206999973
							],
							[
								125.2716980460001,
								-14.85369813699998
							],
							[
								125.27395812600003,
								-14.870078126999942
							],
							[
								125.28667800500011,
								-14.852958146999981
							],
							[
								125.29589798500001,
								-14.875268146999929
							],
							[
								125.30566801400005,
								-14.869618135999929
							],
							[
								125.30504809400009,
								-14.881478155999957
							],
							[
								125.33398704300009,
								-14.881298155999957
							],
							[
								125.3167480940001,
								-14.887608145999934
							],
							[
								125.31892791400003,
								-14.896988135999948
							],
							[
								125.3114078540001,
								-14.900038135999978
							],
							[
								125.30709793400001,
								-14.891188155999942
							],
							[
								125.30808792500011,
								-14.908688126999948
							],
							[
								125.30335788500008,
								-14.898178196999936
							],
							[
								125.29462789500008,
								-14.903568216999929
							],
							[
								125.30769803500004,
								-14.920208126999967
							],
							[
								125.29568807600003,
								-14.928718166999943
							],
							[
								125.29469811600006,
								-14.937958196999944
							],
							[
								125.2872179960001,
								-14.928718166999943
							],
							[
								125.26990812700001,
								-14.933268736999935
							],
							[
								125.27133804700009,
								-14.927289156999962
							],
							[
								125.26133795800001,
								-14.923089206999975
							],
							[
								125.2636081170001,
								-14.904589166999926
							],
							[
								125.25630803800004,
								-14.899819166999976
							],
							[
								125.25504805800006,
								-14.926569147999942
							],
							[
								125.24454792900008,
								-14.913939187999972
							],
							[
								125.2392681990001,
								-14.923239147999936
							],
							[
								125.23071818900007,
								-14.919119127999977
							],
							[
								125.23298797000007,
								-14.931559197999945
							],
							[
								125.22576820000006,
								-14.92398912799996
							],
							[
								125.21879787000012,
								-14.92925916799993
							],
							[
								125.22057805100007,
								-14.94856920799998
							],
							[
								125.21490807100008,
								-14.942789207999965
							],
							[
								125.21359801100004,
								-14.951819187999945
							],
							[
								125.20781787100009,
								-14.947159168999974
							],
							[
								125.21372795100001,
								-14.969799208999973
							],
							[
								125.22246805100008,
								-14.970479157999932
							],
							[
								125.22211813100012,
								-14.963659137999969
							],
							[
								125.22770788100001,
								-14.968919187999973
							],
							[
								125.23156812000002,
								-14.960579167999981
							],
							[
								125.23422817000005,
								-14.965329187999941
							],
							[
								125.2395882290001,
								-14.94230880799995
							],
							[
								125.25765802800004,
								-14.943738817999929
							],
							[
								125.26241799800005,
								-14.945898807999981
							],
							[
								125.25037813900008,
								-14.965509177999934
							],
							[
								125.25439788900007,
								-14.978389167999978
							],
							[
								125.26507800800005,
								-14.976129167999943
							],
							[
								125.27120810800011,
								-14.959579167999948
							],
							[
								125.28859787700003,
								-14.965979166999944
							],
							[
								125.30464812600007,
								-14.961628206999933
							],
							[
								125.29599802700011,
								-14.976619146999951
							],
							[
								125.27809813800002,
								-14.978809197999965
							],
							[
								125.28550803700011,
								-14.98470915699994
							],
							[
								125.28560808800012,
								-14.999179177999963
							],
							[
								125.29546812700005,
								-14.995919196999978
							],
							[
								125.30166804700002,
								-15.00333915699997
							],
							[
								125.30359802700002,
								-14.996289176999937
							],
							[
								125.31875796600002,
								-15.005859156999975
							],
							[
								125.33951811400004,
								-14.986798136999937
							],
							[
								125.33733792500004,
								-15.002618156999972
							],
							[
								125.34720804400001,
								-15.000878196999963
							],
							[
								125.35293817400009,
								-15.008868115999974
							],
							[
								125.36349802300003,
								-15.00576814599998
							],
							[
								125.365377953,
								-14.99140820599996
							],
							[
								125.38594800200008,
								-15.03253820599997
							],
							[
								125.40937754100003,
								-15.025088345999961
							],
							[
								125.40898764000008,
								-14.998568334999959
							],
							[
								125.42098815000008,
								-15.021638294999946
							],
							[
								125.44394722900006,
								-15.01383818499994
							],
							[
								125.44138726900007,
								-14.99942819499995
							],
							[
								125.44843753800001,
								-15.00703813499996
							],
							[
								125.44990742800007,
								-14.999918154999932
							],
							[
								125.47150706700006,
								-14.992498093999927
							],
							[
								125.47427701700008,
								-15.001178163999953
							],
							[
								125.48160719600003,
								-14.998568053999975
							],
							[
								125.47479706700005,
								-15.004758083999945
							],
							[
								125.46245736700007,
								-15.000188064999975
							],
							[
								125.45928722800011,
								-15.014888134999978
							],
							[
								125.42844744000001,
								-15.026798284999927
							],
							[
								125.41148786100007,
								-15.047438155999942
							],
							[
								125.40192803200011,
								-15.042518125999948
							],
							[
								125.38431795300005,
								-15.052198175999933
							],
							[
								125.38701793300004,
								-15.056478205999952
							],
							[
								125.37548787300011,
								-15.052698205999945
							],
							[
								125.36740801400003,
								-15.062448176999965
							],
							[
								125.37013788400009,
								-15.073728136999932
							],
							[
								125.39627783200001,
								-15.070558165999955
							],
							[
								125.40215809200004,
								-15.06374812599995
							],
							[
								125.40192803200011,
								-15.08464820599994
							],
							[
								125.37308807400007,
								-15.103308176999974
							],
							[
								125.37753804400006,
								-15.108828156999948
							],
							[
								125.36797789500008,
								-15.103788146999932
							],
							[
								125.35765813500007,
								-15.108359156999938
							],
							[
								125.38046808400009,
								-15.11230816699998
							],
							[
								125.37595799400003,
								-15.11696818699994
							],
							[
								125.39319804400009,
								-15.123428136999962
							],
							[
								125.39709795300007,
								-15.13168813699997
							],
							[
								125.4793078890001,
								-15.134018154999978
							],
							[
								125.48133793900001,
								-15.154788184999973
							],
							[
								125.44309799100006,
								-15.148708135999982
							],
							[
								125.41187812300006,
								-15.15755818599996
							],
							[
								125.37830808500007,
								-15.142599196999981
							],
							[
								125.36820791600007,
								-15.155849176999936
							],
							[
								125.34598802700009,
								-15.143089176999979
							],
							[
								125.33158906800008,
								-15.146439157999964
							],
							[
								125.33493889800002,
								-15.162909147999926
							],
							[
								125.32534884800009,
								-15.152449177999927
							],
							[
								125.30679910900005,
								-15.151619187999927
							],
							[
								125.30586887900006,
								-15.142149207999978
							],
							[
								125.28230904100008,
								-15.14360918899996
							],
							[
								125.27919902000008,
								-15.132099178999965
							],
							[
								125.2897290090001,
								-15.099639147999937
							],
							[
								125.28110917000004,
								-15.097529187999953
							],
							[
								125.27102919100003,
								-15.113719208999953
							],
							[
								125.26504885100007,
								-15.112659168999926
							],
							[
								125.26600898100003,
								-15.099969168999962
							],
							[
								125.24196891200006,
								-15.104249128999982
							],
							[
								125.2444590120001,
								-15.112939168999958
							],
							[
								125.2375790530001,
								-15.108569208999938
							],
							[
								125.2405389920001,
								-15.102499178999949
							],
							[
								125.22545894300004,
								-15.103419148999933
							],
							[
								125.22701917300003,
								-15.113809208999953
							],
							[
								125.22198888300011,
								-15.106259188999957
							],
							[
								125.22340910300011,
								-15.113029168999958
							],
							[
								125.21653885400008,
								-15.109899158999951
							],
							[
								125.2194688940001,
								-15.11496920899998
							],
							[
								125.21249896400002,
								-15.11634917999993
							],
							[
								125.22426915400001,
								-15.121159148999936
							],
							[
								125.21203884400006,
								-15.11827913999997
							],
							[
								125.18772914600004,
								-15.132299159999945
							],
							[
								125.17430904700007,
								-15.130059149999965
							],
							[
								125.1753991170001,
								-15.137969149999947
							],
							[
								125.16324914800009,
								-15.151349190999952
							],
							[
								125.14502918800008,
								-15.134699190999982
							],
							[
								125.13847896800007,
								-15.102919200999963
							],
							[
								125.12205900900005,
								-15.09162915099995
							],
							[
								125.12562914800003,
								-15.058969140999977
							],
							[
								125.13341915800004,
								-15.058939170999963
							],
							[
								125.12567918800005,
								-15.043489140999952
							],
							[
								125.10552888900008,
								-15.033169210999972
							],
							[
								125.09655912000005,
								-15.056249160999982
							],
							[
								125.10080893000008,
								-15.06445914099993
							],
							[
								125.07237901100007,
								-15.064890161999926
							],
							[
								125.08347891000005,
								-15.040599160999932
							],
							[
								125.06732894100003,
								-15.041450201999965
							],
							[
								125.05901909200009,
								-15.028260161999981
							],
							[
								125.08170917000007,
								-15.005469170999959
							],
							[
								125.08398903900002,
								-14.99148921099993
							],
							[
								125.0928389390001,
								-14.988139130999969
							],
							[
								125.08821901900001,
								-14.982139200999939
							],
							[
								125.07472910000001,
								-14.984219190999966
							],
							[
								125.07429891000004,
								-14.975749200999928
							],
							[
								125.05448919100002,
								-14.988080191999927
							],
							[
								125.05565916100011,
								-14.999770191999971
							],
							[
								125.04462915200008,
								-14.984430141999951
							],
							[
								125.03306920200009,
								-14.99600019199994
							],
							[
								125.0280090230001,
								-14.984240171999943
							],
							[
								125.01197895300004,
								-14.983150161999959
							],
							[
								125.02517907300012,
								-14.992360151999947
							],
							[
								125.01895899400006,
								-15.00794013199993
							],
							[
								125.02354901400008,
								-15.022050151999963
							],
							[
								125.0141900540001,
								-15.035070172999951
							],
							[
								125.02621012400004,
								-15.031330141999945
							],
							[
								125.02028018400006,
								-15.047030182999947
							],
							[
								125.02577018400007,
								-15.05390016299998
							],
							[
								125.03552006300004,
								-15.051950131999945
							],
							[
								125.02941989400006,
								-15.066200202999937
							],
							[
								125.04771001300003,
								-15.077100181999981
							],
							[
								125.02986986500002,
								-15.113270192999948
							],
							[
								125.01114985600009,
								-15.093490182999972
							],
							[
								125.00863993600001,
								-15.104680142999939
							],
							[
								124.99759010700006,
								-15.104830182999933
							],
							[
								124.997079987,
								-15.122800213999938
							],
							[
								124.98774014700007,
								-15.114240203999941
							],
							[
								124.98505995800008,
								-15.13327017399996
							],
							[
								124.98116007800002,
								-15.126460143999964
							],
							[
								124.97445002900008,
								-15.135300213999926
							],
							[
								124.961479929,
								-15.118730133999975
							],
							[
								124.94947001000003,
								-15.123530203999962
							],
							[
								124.95169012000008,
								-15.113220153999976
							],
							[
								124.94324990000007,
								-15.12556015499996
							],
							[
								124.92645015100004,
								-15.108670204999953
							],
							[
								124.92205993100004,
								-15.116700184999956
							],
							[
								124.91039019200002,
								-15.106790204999982
							],
							[
								124.90682009200009,
								-15.115840144999936
							],
							[
								124.8930911330001,
								-15.114300144999959
							],
							[
								124.8779109940001,
								-15.13060014599995
							],
							[
								124.87069119500006,
								-15.126220195999963
							],
							[
								124.8690010250001,
								-15.144870175999927
							],
							[
								124.83392116700009,
								-15.157951136999941
							],
							[
								124.845801187,
								-15.16269019699996
							],
							[
								124.83772095800009,
								-15.183141166999974
							],
							[
								124.8446711470001,
								-15.17318120699997
							],
							[
								124.84747120700001,
								-15.17792114699995
							],
							[
								124.86155115600002,
								-15.169030145999955
							],
							[
								124.85482095700002,
								-15.183551196999929
							],
							[
								124.8963811640001,
								-15.173430165999946
							],
							[
								124.87741094600005,
								-15.191510155999936
							],
							[
								124.8642810560001,
								-15.194931156999928
							],
							[
								124.86768088600002,
								-15.204071195999973
							],
							[
								124.88115099600009,
								-15.208420175999947
							],
							[
								124.86750087700011,
								-15.221591136999962
							],
							[
								124.8688508570001,
								-15.24362115699995
							],
							[
								124.89183111500006,
								-15.23032014599994
							],
							[
								124.87578089700003,
								-15.261901136999938
							],
							[
								124.90795119500001,
								-15.245650205999937
							],
							[
								124.90991102500004,
								-15.238980215999959
							],
							[
								124.90099097500001,
								-15.240210145999981
							],
							[
								124.91755094400003,
								-15.228230155999938
							],
							[
								124.91716109400011,
								-15.215120135999939
							],
							[
								124.92301109300001,
								-15.225720155999966
							],
							[
								124.94379098200011,
								-15.213120154999956
							],
							[
								124.93591095200009,
								-15.209720134999941
							],
							[
								124.94283088200007,
								-15.205100164999976
							],
							[
								124.93518088200005,
								-15.18740014499997
							],
							[
								124.93990121200011,
								-15.197090164999963
							],
							[
								124.97111101000007,
								-15.208290214999977
							],
							[
								124.96106091100012,
								-15.195560154999953
							],
							[
								124.97125000000005,
								-15.182980133999934
							],
							[
								124.97015017900003,
								-15.16424015399997
							],
							[
								124.97829015900004,
								-15.168160193999938
							],
							[
								124.97611000900008,
								-15.176300153999932
							],
							[
								124.98537998900008,
								-15.166110193999941
							],
							[
								124.98482989900003,
								-15.17594016399994
							],
							[
								124.99492035800006,
								-15.16199026399994
							],
							[
								124.99467989800007,
								-15.173840193999979
							],
							[
								124.98198015900005,
								-15.190970163999964
							],
							[
								124.99283018900007,
								-15.197830143999965
							],
							[
								125.01425991700012,
								-15.175840173999973
							],
							[
								125.00583987700008,
								-15.163330173999952
							],
							[
								125.01383005700006,
								-15.154490192999958
							],
							[
								125.02279011600001,
								-15.15615016299995
							],
							[
								125.02017003700007,
								-15.169490142999962
							],
							[
								125.04582004500003,
								-15.157660172999954
							],
							[
								125.04864999500012,
								-15.16635021299993
							],
							[
								125.05604007400007,
								-15.164420162999932
							],
							[
								125.06022005400007,
								-15.180770202999952
							],
							[
								125.0414899750001,
								-15.178570142999945
							],
							[
								125.04681003500002,
								-15.188700192999931
							],
							[
								125.02852995700005,
								-15.197030132999942
							],
							[
								125.02199017700002,
								-15.218520153999975
							],
							[
								125.019870147,
								-15.213560153999936
							],
							[
								125.01816012800009,
								-15.220570173999931
							],
							[
								125.00456007900004,
								-15.224450163999961
							],
							[
								125.00565084900006,
								-15.241920153999956
							],
							[
								124.98152117000006,
								-15.224190143999976
							],
							[
								124.97211111100012,
								-15.227230174999931
							],
							[
								124.97918116000005,
								-15.219900214999939
							],
							[
								124.96950110000012,
								-15.212140154999929
							],
							[
								124.951511202,
								-15.225070174999928
							],
							[
								124.92744087300002,
								-15.229210175999981
							],
							[
								124.93338088300004,
								-15.231120154999928
							],
							[
								124.91866120400005,
								-15.245280225999977
							],
							[
								124.93193114300004,
								-15.247390185999961
							],
							[
								124.91881096400004,
								-15.254550225999935
							],
							[
								124.92282100400007,
								-15.270470135999972
							],
							[
								124.9140611150001,
								-15.27118014599995
							],
							[
								124.91299118500001,
								-15.256370195999978
							],
							[
								124.90461111500008,
								-15.255490165999959
							],
							[
								124.90465108600006,
								-15.275711205999926
							],
							[
								124.90326112600007,
								-15.268941125999959
							],
							[
								124.89385109600005,
								-15.271791145999941
							],
							[
								124.87614089800002,
								-15.30201117699994
							],
							[
								124.88013111800001,
								-15.310471166999946
							],
							[
								124.89524105700002,
								-15.305341176999946
							],
							[
								124.88306118800006,
								-15.315891156999953
							],
							[
								124.89148118700007,
								-15.327731186999927
							],
							[
								124.9067909360001,
								-15.317411166999932
							],
							[
								124.90242089700007,
								-15.329621206999946
							],
							[
								124.90780106700004,
								-15.335021186999938
							],
							[
								124.89824091700007,
								-15.33211113699997
							],
							[
								124.89792088700005,
								-15.339911166999968
							],
							[
								124.9200911260001,
								-15.356451186999948
							],
							[
								124.93092100500007,
								-15.346221165999964
							],
							[
								124.97913112200001,
								-15.329380164999975
							],
							[
								124.98421108200012,
								-15.319960154999933
							],
							[
								125.0263810990001,
								-15.30030018399998
							],
							[
								125.03068093800005,
								-15.274780133999968
							],
							[
								125.03495092800006,
								-15.288180143999966
							],
							[
								125.04495999700009,
								-15.283850163999944
							],
							[
								125.03602117800006,
								-15.295520193999948
							],
							[
								125.03965106800001,
								-15.301380173999974
							],
							[
								125.05215100700002,
								-15.30238017399995
							],
							[
								125.06544003700003,
								-15.316200213999934
							],
							[
								125.081259896,
								-15.314340182999956
							],
							[
								125.094309855,
								-15.292030182999952
							],
							[
								125.07977018500003,
								-15.290840192999951
							],
							[
								125.08755016500004,
								-15.290140162999933
							],
							[
								125.08683016500004,
								-15.28375017299993
							],
							[
								125.09499999400009,
								-15.289660202999926
							],
							[
								125.09566995400007,
								-15.283100192999939
							],
							[
								125.08101001500006,
								-15.255590162999965
							],
							[
								125.07342988500011,
								-15.253910132999977
							],
							[
								125.07972014500001,
								-15.253220192999947
							],
							[
								125.07746006500008,
								-15.247660172999929
							],
							[
								125.08662999400008,
								-15.264380192999965
							],
							[
								125.09001004400011,
								-15.247790132999967
							],
							[
								125.08814989400003,
								-15.266750172999934
							],
							[
								125.09430985400002,
								-15.265030172999957
							],
							[
								125.09119012400004,
								-15.27069019299995
							],
							[
								125.09912018400007,
								-15.273370212999964
							],
							[
								125.10033016400007,
								-15.285910182999942
							],
							[
								125.10510987300006,
								-15.26138014199995
							],
							[
								125.1189299020001,
								-15.255600151999943
							],
							[
								125.10767991300008,
								-15.263060161999931
							],
							[
								125.10819003400002,
								-15.284070202999942
							],
							[
								125.10186987400004,
								-15.290420162999965
							],
							[
								125.10249016400007,
								-15.299340162999954
							],
							[
								125.11001992400008,
								-15.292430132999982
							],
							[
								125.10191992400007,
								-15.302620212999955
							],
							[
								125.11553007300006,
								-15.302010192999944
							],
							[
								125.10285986400004,
								-15.305440162999957
							],
							[
								125.09917993500005,
								-15.314160182999956
							],
							[
								125.11035003400002,
								-15.314570142999969
							],
							[
								125.11014012400005,
								-15.32022015299998
							],
							[
								125.09838004500011,
								-15.318450212999949
							],
							[
								125.08857000600005,
								-15.337690142999975
							],
							[
								125.11878985400006,
								-15.328880132999927
							],
							[
								125.11701004400004,
								-15.319280202999948
							],
							[
								125.12066007400006,
								-15.328760152999962
							],
							[
								125.1265799030001,
								-15.32659018299995
							],
							[
								125.12478998300003,
								-15.31654014299994
							],
							[
								125.12865996300002,
								-15.323980182999946
							],
							[
								125.1312401130001,
								-15.31571016199996
							],
							[
								125.13678012200012,
								-15.31684020199998
							],
							[
								125.1305398930001,
								-15.32782021199995
							],
							[
								125.1443700420001,
								-15.323130211999967
							],
							[
								125.14345995200006,
								-15.31787017199997
							],
							[
								125.149600082,
								-15.322090161999938
							],
							[
								125.14655018200006,
								-15.314100141999972
							],
							[
								125.15252008200002,
								-15.322420201999932
							],
							[
								125.15775013100006,
								-15.306130191999955
							],
							[
								125.15478013100005,
								-15.31741016199993
							],
							[
								125.16036985100004,
								-15.310080201999938
							],
							[
								125.16257018100009,
								-15.316950181999971
							],
							[
								125.15506998100011,
								-15.321390141999927
							],
							[
								125.16297989100008,
								-15.321020161999968
							],
							[
								125.15639007100003,
								-15.323450151999964
							],
							[
								125.1641001810001,
								-15.330560171999934
							],
							[
								125.15913002100001,
								-15.335250161999966
							],
							[
								125.15601996100008,
								-15.324550151999972
							],
							[
								125.14426995200006,
								-15.326520151999944
							],
							[
								125.13881992300003,
								-15.33129016199996
							],
							[
								125.15209993200006,
								-15.332480131999944
							],
							[
								125.14453994200005,
								-15.333860201999983
							],
							[
								125.14383002300008,
								-15.347900201999948
							],
							[
								125.14209014200003,
								-15.333530161999931
							],
							[
								125.13735003300008,
								-15.339430191999952
							],
							[
								125.1230101640001,
								-15.335420152999973
							],
							[
								125.09085998600005,
								-15.354970142999946
							],
							[
								125.0888310260001,
								-15.36944015399996
							],
							[
								125.09501116600006,
								-15.371290192999936
							],
							[
								125.08432093700003,
								-15.377700183999934
							],
							[
								125.08254108800008,
								-15.41228016399998
							],
							[
								125.07004118900011,
								-15.440230203999931
							],
							[
								125.07984147800005,
								-15.445730363999928
							],
							[
								125.08771109800011,
								-15.441500283999972
							],
							[
								125.08171129800007,
								-15.446400343999926
							],
							[
								125.10193141700006,
								-15.463380273999974
							],
							[
								125.1415058450001,
								-15.481932072999939
							],
							[
								125.1373165660001,
								-15.484591832999968
							],
							[
								125.14610521500003,
								-15.497092282999972
							],
							[
								125.18847470300011,
								-15.521952272999954
							],
							[
								125.21663303200012,
								-15.55341217299997
							],
							[
								125.2240270210001,
								-15.54072518199996
							],
							[
								125.22448502200007,
								-15.553200171999947
							],
							[
								125.25486806000004,
								-15.58088023199997
							],
							[
								125.27145722900002,
								-15.58804054199993
							],
							[
								125.28762552800004,
								-15.583551240999952
							],
							[
								125.2766966590001,
								-15.588120721999928
							],
							[
								125.30072632800011,
								-15.613760810999963
							],
							[
								125.42119453200007,
								-15.69601117999997
							],
							[
								125.30540700800009,
								-15.62279044099995
							],
							[
								125.29101637800011,
								-15.604710871999941
							],
							[
								125.22530740200011,
								-15.57228072199996
							],
							[
								125.20224473300004,
								-15.543852232999939
							],
							[
								125.18114474400011,
								-15.531552402999978
							],
							[
								125.17472486400004,
								-15.534252402999982
							],
							[
								125.14093597600004,
								-15.509072103999927
							],
							[
								125.13736660600011,
								-15.495431893999978
							],
							[
								125.12124867700004,
								-15.491521193999972
							],
							[
								125.12310842600004,
								-15.48419123399998
							],
							[
								125.08866147800006,
								-15.463200363999931
							],
							[
								125.06263096000009,
								-15.46092021499993
							],
							[
								125.04921195100007,
								-15.472610214999975
							],
							[
								125.05228204100001,
								-15.482540184999948
							],
							[
								125.04689212100004,
								-15.473750174999964
							],
							[
								125.0417020110001,
								-15.486420194999937
							],
							[
								125.05480204100002,
								-15.498580164999964
							],
							[
								125.04501219100007,
								-15.49703020499993
							],
							[
								125.04425190200004,
								-15.511490134999974
							],
							[
								125.03988219200005,
								-15.497840184999973
							],
							[
								125.03094195200003,
								-15.504430184999933
							],
							[
								125.03344217300003,
								-15.517860145999975
							],
							[
								125.04428212200003,
								-15.518840164999972
							],
							[
								125.03952219200005,
								-15.521790194999937
							],
							[
								125.03013194300001,
								-15.513800175999961
							],
							[
								125.02938205300006,
								-15.522170165999967
							],
							[
								125.02678216300001,
								-15.51111016599998
							],
							[
								125.02206220300002,
								-15.514750205999974
							],
							[
								125.0189021440001,
								-15.52119014599998
							],
							[
								125.02556214300012,
								-15.525800145999938
							],
							[
								125.01785199400001,
								-15.522100145999957
							],
							[
								125.01302188400007,
								-15.530531165999946
							],
							[
								125.01942197400001,
								-15.535190185999966
							],
							[
								125.01424189400007,
								-15.533371215999978
							],
							[
								125.01711221400001,
								-15.544651185999953
							],
							[
								125.011352224,
								-15.528561155999967
							],
							[
								125.00460220500008,
								-15.528471155999966
							],
							[
								125.01412202400002,
								-15.521770215999936
							],
							[
								125.00211206400002,
								-15.517741175999959
							],
							[
								125.01528196400011,
								-15.519850155999961
							],
							[
								125.02291213300009,
								-15.505920205999928
							],
							[
								125.0176119030001,
								-15.505310195999982
							],
							[
								125.02597215200001,
								-15.485690204999969
							],
							[
								125.01834197300002,
								-15.471480184999962
							],
							[
								125.01136189300007,
								-15.472520145999965
							],
							[
								125.01129207300005,
								-15.480130175999932
							],
							[
								125.00950215300008,
								-15.473210175999952
							],
							[
								125.00404204400002,
								-15.476620165999975
							],
							[
								124.9998019840001,
								-15.49504021599995
							],
							[
								125.01017210400005,
								-15.496480215999952
							],
							[
								125.00140217400008,
								-15.503611165999928
							],
							[
								124.997832044,
								-15.496291195999959
							],
							[
								124.99952188400005,
								-15.510431195999956
							],
							[
								124.99598200500009,
								-15.50082118599994
							],
							[
								124.98691215500003,
								-15.505821215999958
							],
							[
								124.99573216400006,
								-15.495621145999962
							],
							[
								124.99624191400005,
								-15.476981155999965
							],
							[
								124.98299212500001,
								-15.484261165999953
							],
							[
								124.98175192500003,
								-15.494991145999961
							],
							[
								124.98135196500004,
								-15.483471165999958
							],
							[
								124.97323213600009,
								-15.491181185999949
							],
							[
								124.9618021660001,
								-15.488731216999952
							],
							[
								124.98447209500011,
								-15.476001155999938
							],
							[
								124.96025200600002,
								-15.479931186999977
							],
							[
								124.95295193700008,
								-15.489211176999959
							],
							[
								124.95804196600011,
								-15.479711136999981
							],
							[
								124.95220204700001,
								-15.475211136999974
							],
							[
								124.98409190500001,
								-15.46957118599994
							],
							[
								125.00299193300009,
								-15.448380155999928
							],
							[
								125.00378212300006,
								-15.440130215999943
							],
							[
								124.97995120400003,
								-15.42179118599995
							],
							[
								124.97885101400004,
								-15.409591155999976
							],
							[
								124.9713320940001,
								-15.420921165999971
							],
							[
								124.94592112500004,
								-15.383711185999971
							],
							[
								124.94058087600001,
								-15.383611195999947
							],
							[
								124.94520112600003,
								-15.395771195999941
							],
							[
								124.92675113700011,
								-15.393831156999966
							],
							[
								124.92533092700012,
								-15.388861186999975
							],
							[
								124.93709104600009,
								-15.389841185999956
							],
							[
								124.93238119600005,
								-15.374721185999931
							],
							[
								124.91526101700003,
								-15.373301166999966
							],
							[
								124.90707099700012,
								-15.360221206999938
							],
							[
								124.88863214800006,
								-15.356421216999934
							],
							[
								124.87570201900007,
								-15.343481206999968
							],
							[
								124.86814202900007,
								-15.344971156999975
							],
							[
								124.87259200900007,
								-15.353201196999976
							],
							[
								124.86467198000003,
								-15.352211207999972
							],
							[
								124.86234208000008,
								-15.359101137999971
							],
							[
								124.86094204000005,
								-15.351761187999955
							],
							[
								124.84767210100006,
								-15.35316114799997
							],
							[
								124.84053223100011,
								-15.340631167999959
							],
							[
								124.84948218000011,
								-15.33541116799995
							],
							[
								124.84771207000006,
								-15.328521217999935
							],
							[
								124.83638214100006,
								-15.316351157999975
							],
							[
								124.84680198000001,
								-15.299041187999933
							],
							[
								124.82217222100007,
								-15.311871217999965
							],
							[
								124.83699195100007,
								-15.324711157999957
							],
							[
								124.83130218100007,
								-15.32590113799995
							],
							[
								124.81720205200008,
								-15.323521187999972
							],
							[
								124.81040203200007,
								-15.30874119799995
							],
							[
								124.78324216300007,
								-15.294451168999956
							],
							[
								124.78386207400001,
								-15.311871218999954
							],
							[
								124.75937200600004,
								-15.33326115899996
							],
							[
								124.75326208600006,
								-15.354411149999976
							],
							[
								124.7361322370001,
								-15.343151169999942
							],
							[
								124.76180202500007,
								-15.326141168999982
							],
							[
								124.77058202400008,
								-15.302051138999957
							],
							[
								124.70504189700011,
								-15.25338120999993
							],
							[
								124.70661223700006,
								-15.275071199999957
							],
							[
								124.70138215800011,
								-15.278361169999982
							],
							[
								124.67877197900009,
								-15.264052160999938
							],
							[
								124.68177223900011,
								-15.25399213999998
							],
							[
								124.6746820090001,
								-15.255022180999958
							],
							[
								124.67285211900003,
								-15.269032210999967
							],
							[
								124.67890191900005,
								-15.270152160999942
							],
							[
								124.67275207000012,
								-15.27898216099993
							],
							[
								124.67929217900007,
								-15.288572210999973
							],
							[
								124.66732218000004,
								-15.296622170999967
							],
							[
								124.696892219,
								-15.296451149999939
							],
							[
								124.69249192900008,
								-15.309111180999935
							],
							[
								124.70720189800011,
								-15.320791209999982
							],
							[
								124.6910422200001,
								-15.333182140999952
							],
							[
								124.67425215000003,
								-15.32451217099998
							],
							[
								124.66648192100001,
								-15.334242160999963
							],
							[
								124.66192219100003,
								-15.324872170999981
							],
							[
								124.65647212200008,
								-15.336862150999934
							],
							[
								124.67236218100004,
								-15.346232140999973
							],
							[
								124.66209319200004,
								-15.34793216099996
							],
							[
								124.66199307200009,
								-15.354932171999963
							],
							[
								124.66678290200002,
								-15.361932200999945
							],
							[
								124.68877207000003,
								-15.357482130999927
							],
							[
								124.7053421490001,
								-15.343541150999954
							],
							[
								124.704731949,
								-15.359822140999938
							],
							[
								124.72349191800004,
								-15.352791159999981
							],
							[
								124.72665197800006,
								-15.360481209999932
							],
							[
								124.74478193700008,
								-15.36177116999994
							],
							[
								124.72721214800004,
								-15.363391179999951
							],
							[
								124.72375216900002,
								-15.376731159999963
							],
							[
								124.68373313100005,
								-15.391392150999934
							],
							[
								124.67618322200008,
								-15.400672141999962
							],
							[
								124.67819309200001,
								-15.411622181999974
							],
							[
								124.687093032,
								-15.413702170999954
							],
							[
								124.68100289200004,
								-15.420212141999968
							],
							[
								124.67506288200002,
								-15.417282181999951
							],
							[
								124.66891304300009,
								-15.428592211999955
							],
							[
								124.67165298300006,
								-15.452882141999964
							],
							[
								124.67656300300007,
								-15.462812201999952
							],
							[
								124.68667291200006,
								-15.455792211999949
							],
							[
								124.6907830020001,
								-15.46801222199997
							],
							[
								124.68206311300003,
								-15.473202171999958
							],
							[
								124.68611308300001,
								-15.480902201999982
							],
							[
								124.67987322300007,
								-15.480322151999928
							],
							[
								124.67420320400004,
								-15.498072221999962
							],
							[
								124.67707312400012,
								-15.47818222199993
							],
							[
								124.6675331240001,
								-15.483732171999975
							],
							[
								124.66635307400009,
								-15.476622151999948
							],
							[
								124.65723318500011,
								-15.477592181999967
							],
							[
								124.65037304500004,
								-15.468062172999964
							],
							[
								124.64898305500003,
								-15.474732162999942
							],
							[
								124.64220318500008,
								-15.46310219299994
							],
							[
								124.64995289400008,
								-15.437782221999953
							],
							[
								124.64568294500009,
								-15.434122181999953
							],
							[
								124.65379302400004,
								-15.435172221999949
							],
							[
								124.6446832040001,
								-15.424792151999952
							],
							[
								124.63271321500008,
								-15.43826218299995
							],
							[
								124.6330930360001,
								-15.45239219299998
							],
							[
								124.62982314600004,
								-15.446292162999953
							],
							[
								124.62576303600008,
								-15.454212162999966
							],
							[
								124.62822295600006,
								-15.462792222999951
							],
							[
								124.61786319700002,
								-15.466082172999961
							],
							[
								124.6263930560001,
								-15.472412152999937
							],
							[
								124.62155323700006,
								-15.500652152999976
							],
							[
								124.63880298600009,
								-15.503902142999948
							],
							[
								124.62437311700012,
								-15.512742222999975
							],
							[
								124.6321530570001,
								-15.516292182999962
							],
							[
								124.6287730470001,
								-15.525652192999928
							],
							[
								124.6144529280001,
								-15.51956215399997
							],
							[
								124.62065321800003,
								-15.514442152999948
							],
							[
								124.61748304800005,
								-15.503832142999954
							],
							[
								124.59907302900001,
								-15.506462213999953
							],
							[
								124.59583303900001,
								-15.523392193999939
							],
							[
								124.58034295000004,
								-15.520042213999943
							],
							[
								124.5799530600001,
								-15.499592143999962
							],
							[
								124.55468323200012,
								-15.502782194999952
							],
							[
								124.55170315100008,
								-15.490792214999942
							],
							[
								124.52898318300004,
								-15.484423184999969
							],
							[
								124.52981297200006,
								-15.477183224999976
							],
							[
								124.52150312300012,
								-15.485113214999956
							],
							[
								124.51721299300004,
								-15.468613154999957
							],
							[
								124.50860322400001,
								-15.470313154999928
							],
							[
								124.50739401400006,
								-15.483723164999958
							],
							[
								124.4980739240001,
								-15.474953195999944
							],
							[
								124.47665393600005,
								-15.477883155999962
							],
							[
								124.44579402800002,
								-15.505133176999948
							],
							[
								124.46160414700012,
								-15.498173196999971
							],
							[
								124.45583408800007,
								-15.508473166999977
							],
							[
								124.46595403700007,
								-15.505383205999976
							],
							[
								124.49254399500012,
								-15.486163165999926
							],
							[
								124.49858408500006,
								-15.505793145999974
							],
							[
								124.5058139350001,
								-15.504073165999955
							],
							[
								124.50027389500008,
								-15.516403155999967
							],
							[
								124.51043421500003,
								-15.525113175999934
							],
							[
								124.49619402500002,
								-15.516533205999963
							],
							[
								124.48653415600006,
								-15.497263215999965
							],
							[
								124.47305394700004,
								-15.503543225999977
							],
							[
								124.47269394700004,
								-15.51235315599996
							],
							[
								124.47015416700003,
								-15.506383185999937
							],
							[
								124.46170423700005,
								-15.511693186999935
							],
							[
								124.46579420800003,
								-15.536883186999944
							],
							[
								124.4620041180001,
								-15.532053176999966
							],
							[
								124.45860392800012,
								-15.539493186999948
							],
							[
								124.44601401900002,
								-15.528803186999937
							],
							[
								124.4363242500001,
								-15.546973186999935
							],
							[
								124.42545404000009,
								-15.540583187999971
							],
							[
								124.41756395100003,
								-15.548883157999967
							],
							[
								124.43008399000007,
								-15.560773167999969
							],
							[
								124.42466418100003,
								-15.559343157999933
							],
							[
								124.43004403100008,
								-15.574453157999926
							],
							[
								124.41381416200011,
								-15.591923147999978
							],
							[
								124.40565403300002,
								-15.617714188999969
							],
							[
								124.41604398300001,
								-15.620154167999942
							],
							[
								124.4095841730001,
								-15.609443167999927
							],
							[
								124.43060419100004,
								-15.588073207999969
							],
							[
								124.43347411100001,
								-15.608433197999943
							],
							[
								124.45069401,
								-15.601123216999952
							],
							[
								124.4538839600001,
								-15.59186320699996
							],
							[
								124.45959391000008,
								-15.608543176999945
							],
							[
								124.45437390000006,
								-15.613533226999948
							],
							[
								124.48739420800007,
								-15.619823236999935
							],
							[
								124.49713401800011,
								-15.615673156999947
							],
							[
								124.48822432800011,
								-15.621513256999947
							],
							[
								124.5006342580001,
								-15.636673296999959
							],
							[
								124.48296438800003,
								-15.618823246999966
							],
							[
								124.45247419000009,
								-15.616193167999938
							],
							[
								124.45046395000008,
								-15.60275319699997
							],
							[
								124.4337840720001,
								-15.623003207999943
							],
							[
								124.43651504200011,
								-15.64348414799997
							],
							[
								124.45720495100011,
								-15.656324187999928
							],
							[
								124.44466509200004,
								-15.654814157999965
							],
							[
								124.44369521200008,
								-15.669724177999967
							],
							[
								124.42966494300003,
								-15.664254177999965
							],
							[
								124.43073523300006,
								-15.673874177999949
							],
							[
								124.42152500300006,
								-15.66734422899998
							],
							[
								124.41437505300007,
								-15.637214207999932
							],
							[
								124.4126751440001,
								-15.68141419899996
							],
							[
								124.4024752150001,
								-15.685164228999952
							],
							[
								124.39024494500006,
								-15.662394218999964
							],
							[
								124.38572514600003,
								-15.669304158999978
							],
							[
								124.37927504600009,
								-15.660184198999957
							],
							[
								124.36882495700002,
								-15.671864209999967
							],
							[
								124.37598497600004,
								-15.680084179999938
							],
							[
								124.38636524600008,
								-15.672164178999935
							],
							[
								124.39322505500002,
								-15.677294178999944
							],
							[
								124.40254507500003,
								-15.69860419899993
							],
							[
								124.39735495600007,
								-15.72601414899998
							],
							[
								124.4090351750001,
								-15.710984228999962
							],
							[
								124.41783499500002,
								-15.711394188999975
							],
							[
								124.4114849450001,
								-15.715054208999959
							],
							[
								124.4168651550001,
								-15.720384188999958
							],
							[
								124.43726493300005,
								-15.71145422799998
							],
							[
								124.41922495500012,
								-15.723944148999976
							],
							[
								124.42380523500003,
								-15.732554178999976
							],
							[
								124.40766500500001,
								-15.720044178999956
							],
							[
								124.39593514600006,
								-15.731164218999936
							],
							[
								124.38595520700005,
								-15.71754416999994
							],
							[
								124.41029515700006,
								-15.80588419999998
							],
							[
								124.40548522800009,
								-15.815624169999978
							],
							[
								124.40929505800011,
								-15.863834209999936
							],
							[
								124.41286519900007,
								-15.87793414999993
							],
							[
								124.41752504800002,
								-15.876784209999983
							],
							[
								124.42485500700002,
								-15.847604239999953
							],
							[
								124.42954507700006,
								-15.867374189999964
							],
							[
								124.43906493700001,
								-15.870354168999938
							],
							[
								124.44464494500005,
								-15.829034178999962
							],
							[
								124.45126494500005,
								-15.831334228999935
							],
							[
								124.45828495400008,
								-15.811424158999955
							],
							[
								124.44522525500008,
								-15.813964218999956
							],
							[
								124.44338492500003,
								-15.809184228999982
							],
							[
								124.44685498500007,
								-15.813164208999979
							],
							[
								124.4625649840001,
								-15.802484178999975
							],
							[
								124.45774493400006,
								-15.782924198999979
							],
							[
								124.46249515300008,
								-15.784864167999956
							],
							[
								124.46028512400005,
								-15.816004158999931
							],
							[
								124.47665504300005,
								-15.820244227999979
							],
							[
								124.45935524400011,
								-15.817694178999943
							],
							[
								124.46095507500002,
								-15.854104228999972
							],
							[
								124.47762524400002,
								-15.863364138999941
							],
							[
								124.47526508400006,
								-15.868384158999959
							],
							[
								124.48426507400006,
								-15.866614228999936
							],
							[
								124.47517507500004,
								-15.873694158999967
							],
							[
								124.48995524400004,
								-15.886044148999929
							],
							[
								124.48366494400011,
								-15.889804158999937
							],
							[
								124.49941498300007,
								-15.889764197999966
							],
							[
								124.47891512500007,
								-15.89336420899997
							],
							[
								124.47489501500002,
								-15.88566415899993
							],
							[
								124.48048509500006,
								-15.896934228999953
							],
							[
								124.47670508600004,
								-15.94156413899998
							],
							[
								124.48731501500004,
								-15.920394168999962
							],
							[
								124.4924349050001,
								-15.935954188999972
							],
							[
								124.49802498400004,
								-15.928304178999952
							],
							[
								124.49932497400005,
								-15.93569416899993
							],
							[
								124.50612499400006,
								-15.927854177999961
							],
							[
								124.50648499400006,
								-15.934854188999964
							],
							[
								124.51246497400007,
								-15.934404197999982
							],
							[
								124.50827491400003,
								-15.946354218999943
							],
							[
								124.49701517500012,
								-15.94323419899996
							],
							[
								124.49197518500011,
								-15.959114148999959
							],
							[
								124.49808510500009,
								-15.977234218999968
							],
							[
								124.49213502600003,
								-15.975484148999954
							],
							[
								124.49025512600008,
								-15.987474228999929
							],
							[
								124.49649501600004,
								-15.997044198999959
							],
							[
								124.51638499400008,
								-15.979704168999945
							],
							[
								124.5135550440001,
								-15.96806418899996
							],
							[
								124.52033492400005,
								-15.972354228999961
							],
							[
								124.52942491300007,
								-15.961154177999958
							],
							[
								124.57202409800004,
								-15.861213216999943
							],
							[
								124.58232402700003,
								-15.854623145999938
							],
							[
								124.60790417500004,
								-15.810853185999974
							],
							[
								124.62949410300007,
								-15.79562320499997
							],
							[
								124.6256939430001,
								-15.78607321499993
							],
							[
								124.63177400300003,
								-15.790473144999964
							],
							[
								124.63279422300002,
								-15.778943144999971
							],
							[
								124.63387421300001,
								-15.79046315499994
							],
							[
								124.66045410100003,
								-15.781603183999948
							],
							[
								124.69047308800009,
								-15.751252213999976
							],
							[
								124.688702938,
								-15.745612173999973
							],
							[
								124.70479312700002,
								-15.741052142999933
							],
							[
								124.6789739400001,
								-15.769692223999982
							],
							[
								124.67782412000008,
								-15.775462223999966
							],
							[
								124.68283421900003,
								-15.774322173999963
							],
							[
								124.67539410000006,
								-15.784732223999981
							],
							[
								124.69359390900001,
								-15.782992143999934
							],
							[
								124.69787392800004,
								-15.769202173999929
							],
							[
								124.69120424900007,
								-15.76515217399998
							],
							[
								124.70078418800006,
								-15.76773220399997
							],
							[
								124.69644294800003,
								-15.759032163999962
							],
							[
								124.70170398800008,
								-15.763882182999964
							],
							[
								124.70435322800006,
								-15.75020219299995
							],
							[
								124.70299422800008,
								-15.766482192999945
							],
							[
								124.70916392800007,
								-15.762282152999944
							],
							[
								124.71901352700002,
								-15.770052132999979
							],
							[
								124.70428409800002,
								-15.76896222299996
							],
							[
								124.70082415800005,
								-15.78445222399995
							],
							[
								124.71652411800005,
								-15.793472212999973
							],
							[
								124.71331397800009,
								-15.802772183999934
							],
							[
								124.73555404700005,
								-15.810472212999969
							],
							[
								124.74159414700011,
								-15.82226220299998
							],
							[
								124.70452422900007,
								-15.814042153999935
							],
							[
								124.71194416900005,
								-15.839452223999956
							],
							[
								124.6820141710001,
								-15.849502163999944
							],
							[
								124.68654401100002,
								-15.856572193999966
							],
							[
								124.67583403200001,
								-15.862802184999964
							],
							[
								124.67785401200001,
								-15.877262204999965
							],
							[
								124.68685400100003,
								-15.881872184999963
							],
							[
								124.6815839520001,
								-15.888902164999934
							],
							[
								124.66847421200009,
								-15.862713164999946
							],
							[
								124.65456413300001,
								-15.85358320499995
							],
							[
								124.62942392500008,
								-15.881543145999956
							],
							[
								124.60785417700004,
								-15.891303195999967
							],
							[
								124.60530391700001,
								-15.898423195999953
							],
							[
								124.62119393600005,
								-15.906083175999981
							],
							[
								124.6160740470001,
								-15.91298321599993
							],
							[
								124.62601401600011,
								-15.920873145999963
							],
							[
								124.61050410700011,
								-15.92734315599995
							],
							[
								124.60599402800005,
								-15.944413176999944
							],
							[
								124.59687416800011,
								-15.942963206999934
							],
							[
								124.59845418900011,
								-15.967593146999945
							],
							[
								124.61555454800009,
								-15.96449335699998
							],
							[
								124.6055843480001,
								-15.969953386999975
							],
							[
								124.62429424700008,
								-15.981323355999962
							],
							[
								124.63902440700008,
								-15.980883175999963
							],
							[
								124.64264454600004,
								-15.988403195999979
							],
							[
								124.63404989700007,
								-15.998556385999962
							],
							[
								124.6371444770001,
								-15.984123255999975
							],
							[
								124.6162443180001,
								-15.982473376999963
							],
							[
								124.61989435800001,
								-15.996253456999966
							],
							[
								124.61519454800009,
								-15.983713396999974
							],
							[
								124.58889403,
								-15.973483186999943
							],
							[
								124.58497809000005,
								-15.987721176999969
							],
							[
								124.5905461000001,
								-15.996788196999944
							],
							[
								124.58355310000002,
								-15.994456196999977
							],
							[
								124.57946492100007,
								-16.000514146999933
							],
							[
								124.59549499000002,
								-16.027404156999978
							],
							[
								124.58054491100006,
								-16.023214227999972
							],
							[
								124.58678514100006,
								-16.039384147999954
							],
							[
								124.58904525300011,
								-16.11334416799997
							],
							[
								124.60938524100004,
								-16.111614197999927
							],
							[
								124.61811524000007,
								-16.08974419699996
							],
							[
								124.62298496000005,
								-16.09969414699998
							],
							[
								124.63411398900007,
								-16.09183418699996
							],
							[
								124.64695410800005,
								-16.098094216999982
							],
							[
								124.62869491000004,
								-16.10344417699997
							],
							[
								124.59926492200009,
								-16.127384177999943
							],
							[
								124.5607251240001,
								-16.11944419899993
							],
							[
								124.54144495700007,
								-16.157605178999972
							],
							[
								124.52698522800006,
								-16.16199520999993
							],
							[
								124.52581521800005,
								-16.171155229999954
							],
							[
								124.53669513700004,
								-16.184225199999958
							],
							[
								124.52541524800006,
								-16.18118518999995
							],
							[
								124.53262494800003,
								-16.189345229999958
							],
							[
								124.52514525800007,
								-16.188185199999964
							],
							[
								124.52640523800005,
								-16.194745229999967
							],
							[
								124.51884524800005,
								-16.17880514999996
							],
							[
								124.5081752100001,
								-16.206015209999975
							],
							[
								124.51678496900001,
								-16.177425179999943
							],
							[
								124.50150512000005,
								-16.189225159999978
							],
							[
								124.50144501000011,
								-16.18267523999998
							],
							[
								124.51703517800001,
								-16.17358521999995
							],
							[
								124.51414506800006,
								-16.16465515999994
							],
							[
								124.48662523900009,
								-16.122185159999958
							],
							[
								124.45843509100007,
								-16.102505210999936
							],
							[
								124.47997497900008,
								-16.094125229999975
							],
							[
								124.47724510900002,
								-16.07852515999997
							],
							[
								124.46407521000003,
								-16.071795229999964
							],
							[
								124.46274501000005,
								-16.079465219999975
							],
							[
								124.45328494000012,
								-16.07841517099996
							],
							[
								124.44435514100007,
								-16.06537517099997
							],
							[
								124.44311490200005,
								-16.102205160999972
							],
							[
								124.44892497100011,
								-16.11026518099993
							],
							[
								124.44329492200006,
								-16.113515190999976
							],
							[
								124.44968494200009,
								-16.122015230999978
							],
							[
								124.43466501400007,
								-16.17879516199997
							],
							[
								124.42770512400011,
								-16.182795211999974
							],
							[
								124.42591519400003,
								-16.176495201999955
							],
							[
								124.3985861860001,
								-16.16946522199993
							],
							[
								124.40097620600011,
								-16.182706191999955
							],
							[
								124.38949615700005,
								-16.18479617299994
							],
							[
								124.38876608700002,
								-16.190896192999958
							],
							[
								124.39857611600007,
								-16.193876171999932
							],
							[
								124.4001759470001,
								-16.20168621299996
							],
							[
								124.38664605800011,
								-16.21676615299998
							],
							[
								124.37904609800012,
								-16.216616212999952
							],
							[
								124.37875595900005,
								-16.227006182999958
							],
							[
								124.40267612700006,
								-16.237976182999944
							],
							[
								124.40787598700001,
								-16.25065619299994
							],
							[
								124.39897604800001,
								-16.27400615299996
							],
							[
								124.38516608900011,
								-16.276086232999944
							],
							[
								124.40295618900007,
								-16.298096182999927
							],
							[
								124.41071601800002,
								-16.293616162999967
							],
							[
								124.40103595900007,
								-16.306226152999955
							],
							[
								124.39455597000006,
								-16.33851617399995
							],
							[
								124.40594564900005,
								-16.334196532999954
							],
							[
								124.40822591900007,
								-16.341976572999954
							],
							[
								124.41228562900005,
								-16.33921656299998
							],
							[
								124.40691585900004,
								-16.34727658299994
							],
							[
								124.41166570900009,
								-16.357246602999965
							],
							[
								124.4241756890001,
								-16.35956654299997
							],
							[
								124.45744543600006,
								-16.352826361999973
							],
							[
								124.46429553600001,
								-16.341216261999932
							],
							[
								124.47069562500008,
								-16.347686261999968
							],
							[
								124.47759536500007,
								-16.34495622199995
							],
							[
								124.4804854350001,
								-16.356426261999957
							],
							[
								124.5066052730001,
								-16.342836080999973
							],
							[
								124.5709649480001,
								-16.329275689999974
							],
							[
								124.67343464200007,
								-16.350375197999938
							],
							[
								124.69349457100009,
								-16.344704927999942
							],
							[
								124.71519425000008,
								-16.355824876999975
							],
							[
								124.7252044490001,
								-16.37218497699996
							],
							[
								124.7876741550001,
								-16.385844635999945
							],
							[
								124.81447362400002,
								-16.41639524599998
							],
							[
								124.83053289300005,
								-16.40905573499998
							],
							[
								124.87440283000001,
								-16.416205434999938
							],
							[
								124.88189336000005,
								-16.40876485399997
							],
							[
								124.90127357900008,
								-16.416034343999968
							],
							[
								124.91774430700002,
								-16.388063233999958
							],
							[
								124.94395408500009,
								-16.383942942999965
							],
							[
								124.95334396400006,
								-16.371312882999973
							],
							[
								124.94896421500005,
								-16.39207301299996
							],
							[
								124.92229436700006,
								-16.39112314299996
							],
							[
								124.9171935280001,
								-16.42080451399994
							],
							[
								124.84052287300005,
								-16.434306124999978
							],
							[
								124.74542416800011,
								-16.389964936999945
							],
							[
								124.70336468100004,
								-16.40130538799997
							],
							[
								124.62671490600007,
								-16.40482572899998
							],
							[
								124.5997548680001,
								-16.414285909999933
							],
							[
								124.5604752910001,
								-16.407096070999955
							],
							[
								124.5136555040001,
								-16.40854625199995
							],
							[
								124.5012855440001,
								-16.400786351999955
							],
							[
								124.4945456050001,
								-16.411666371999956
							],
							[
								124.4944253650001,
								-16.404286371999945
							],
							[
								124.44923566800003,
								-16.41089660299997
							],
							[
								124.44954558800009,
								-16.38860649299994
							],
							[
								124.43126587900008,
								-16.394066602999942
							],
							[
								124.4254356990001,
								-16.389066662999937
							],
							[
								124.43192576800004,
								-16.377456562999953
							],
							[
								124.42624570900011,
								-16.36680659299998
							],
							[
								124.4073860100001,
								-16.37327669399997
							],
							[
								124.40176571000006,
								-16.369516673999954
							],
							[
								124.40255590000004,
								-16.352226592999955
							],
							[
								124.38749600100004,
								-16.345606203999978
							],
							[
								124.36566597300009,
								-16.37871718399998
							],
							[
								124.34887597400007,
								-16.38914721499998
							],
							[
								124.34427620500003,
								-16.41636716499994
							],
							[
								124.33653619600011,
								-16.418807154999968
							],
							[
								124.34645602500007,
								-16.424737154999946
							],
							[
								124.38880605200006,
								-16.41520716399998
							],
							[
								124.4019060920001,
								-16.428997223999943
							],
							[
								124.40278592200002,
								-16.46964716399998
							],
							[
								124.41910620200008,
								-16.485207183999933
							],
							[
								124.44138624000004,
								-16.475397172999976
							],
							[
								124.44007618000012,
								-16.482817223999973
							],
							[
								124.46822603900011,
								-16.49853717299993
							],
							[
								124.44805596000003,
								-16.49606720299994
							],
							[
								124.44924608000008,
								-16.501167152999926
							],
							[
								124.44353612000009,
								-16.49492717399994
							],
							[
								124.44937605000007,
								-16.506727163999926
							],
							[
								124.44466620000003,
								-16.50272720399994
							],
							[
								124.44264622100002,
								-16.508897153999953
							],
							[
								124.44117600100003,
								-16.497517193999954
							],
							[
								124.42981618100009,
								-16.49847723399995
							],
							[
								124.43553693100012,
								-16.525517183999966
							],
							[
								124.4276072020001,
								-16.51790722399994
							],
							[
								124.42625724200002,
								-16.531687233999946
							],
							[
								124.41030704400009,
								-16.543237184999953
							],
							[
								124.40406718400004,
								-16.540737174999947
							],
							[
								124.40644716400004,
								-16.533857204999947
							],
							[
								124.39227717500012,
								-16.532997174999934
							],
							[
								124.40753723300008,
								-16.525497204999965
							],
							[
								124.41522716200006,
								-16.509937183999966
							],
							[
								124.40905713300003,
								-16.503577163999978
							],
							[
								124.39907723300007,
								-16.506407224999975
							],
							[
								124.40589707300012,
								-16.503567173999954
							],
							[
								124.40088693300004,
								-16.49732720399993
							],
							[
								124.39162703400007,
								-16.50456715499996
							],
							[
								124.4073060820001,
								-16.478597203999982
							],
							[
								124.39030620300002,
								-16.458967223999935
							],
							[
								124.39014597300002,
								-16.445177163999972
							],
							[
								124.3734059740001,
								-16.44272717499996
							],
							[
								124.36108606500011,
								-16.448657174999937
							],
							[
								124.36368595500005,
								-16.45821716499995
							],
							[
								124.35344723500009,
								-16.454157174999978
							],
							[
								124.34498722600006,
								-16.465557204999982
							],
							[
								124.34381721600005,
								-16.459757164999928
							],
							[
								124.33234723700002,
								-16.458457205999935
							],
							[
								124.31916694800009,
								-16.468677235999962
							],
							[
								124.30810704800001,
								-16.455407185999945
							],
							[
								124.32220713700008,
								-16.448797225999954
							],
							[
								124.3151072280001,
								-16.441527205999932
							],
							[
								124.33185620600011,
								-16.439467195999953
							],
							[
								124.33425596600011,
								-16.428517174999968
							],
							[
								124.32270609700004,
								-16.421447215999933
							],
							[
								124.32496620600011,
								-16.414907185999937
							],
							[
								124.31123614700005,
								-16.420147165999936
							],
							[
								124.30014595800003,
								-16.41489719599997
							],
							[
								124.29470602800006,
								-16.42390719599996
							],
							[
								124.2829361690001,
								-16.414467185999968
							],
							[
								124.2611072410001,
								-16.419407176999982
							],
							[
								124.26408695000009,
								-16.413797226999975
							],
							[
								124.25673716100005,
								-16.409577206999927
							],
							[
								124.22272727300003,
								-16.418427177999945
							],
							[
								124.21149709300005,
								-16.398477147999927
							],
							[
								124.20185697400007,
								-16.40474716799997
							],
							[
								124.21009703300001,
								-16.396997187999943
							],
							[
								124.20488709300002,
								-16.38690719799996
							],
							[
								124.19586692400003,
								-16.389007167999978
							],
							[
								124.20584722300009,
								-16.383867187999954
							],
							[
								124.19970705300011,
								-16.372527187999935
							],
							[
								124.19698725400008,
								-16.377027177999935
							],
							[
								124.19931719300007,
								-16.36054719799995
							],
							[
								124.19354709400011,
								-16.366387197999927
							],
							[
								124.19465698300007,
								-16.35655722799993
							],
							[
								124.1856670740001,
								-16.352667227999973
							],
							[
								124.19486722300007,
								-16.342547197999977
							],
							[
								124.1750571440001,
								-16.328197227999965
							],
							[
								124.17973713300012,
								-16.309567227999935
							],
							[
								124.13096722600005,
								-16.286338238999974
							],
							[
								124.12454701600007,
								-16.288888208999936
							],
							[
								124.12445697600003,
								-16.28041819899994
							],
							[
								124.1078469570001,
								-16.278628198999968
							],
							[
								124.10143715800007,
								-16.28537819899998
							],
							[
								124.10481716700008,
								-16.27781818899996
							],
							[
								124.07548725900006,
								-16.270958229999962
							],
							[
								124.0569969500001,
								-16.271408219999955
							],
							[
								124.06826709000006,
								-16.284138179999957
							],
							[
								124.05243828100004,
								-16.271948220999946
							],
							[
								124.04197811100005,
								-16.27831816099996
							],
							[
								124.04238815100007,
								-16.268938180999953
							],
							[
								124.02621803200009,
								-16.25572816099998
							],
							[
								124.01495796300003,
								-16.25937819099994
							],
							[
								124.01782821300003,
								-16.268328160999943
							],
							[
								124.00994819300001,
								-16.25742816099995
							],
							[
								123.99982824400001,
								-16.264708171999928
							],
							[
								124.0028281430001,
								-16.25454825199995
							],
							[
								123.99674808400005,
								-16.254168181999944
							],
							[
								123.99552803400002,
								-16.261618211999973
							],
							[
								123.9799382650001,
								-16.24828822199993
							],
							[
								123.9759080450001,
								-16.255838211999958
							],
							[
								123.97007822600006,
								-16.25364817199994
							],
							[
								123.97212802500007,
								-16.245298231999982
							],
							[
								123.93991812700006,
								-16.23354917299997
							],
							[
								123.90991823800005,
								-16.210279232999937
							],
							[
								123.91595795800004,
								-16.231459192999978
							],
							[
								123.92142817800004,
								-16.235339202999967
							],
							[
								123.92590800800008,
								-16.229609152999956
							],
							[
								123.92446800800008,
								-16.23547922299997
							],
							[
								123.93602795700008,
								-16.237479202999964
							],
							[
								123.94167815700007,
								-16.249159232999943
							],
							[
								123.95199827600004,
								-16.246179232999964
							],
							[
								123.95147808700005,
								-16.252389242999982
							],
							[
								123.94575805700003,
								-16.250889212999937
							],
							[
								123.95073826700002,
								-16.257699242999934
							],
							[
								123.96247823600004,
								-16.252809171999957
							],
							[
								123.9502479570001,
								-16.260519212999952
							],
							[
								123.9533781670001,
								-16.26472922299996
							],
							[
								123.96382822600003,
								-16.260169191999978
							],
							[
								123.96118799600004,
								-16.268619222999973
							],
							[
								123.9876382650001,
								-16.28383820199997
							],
							[
								123.99374818500007,
								-16.281388231999927
							],
							[
								124.00008815400008,
								-16.29181823199997
							],
							[
								123.960988197,
								-16.27980918299994
							],
							[
								123.93358895900008,
								-16.297709192999946
							],
							[
								123.949338968,
								-16.304369192999957
							],
							[
								123.95515906800006,
								-16.324989182999957
							],
							[
								123.97728898700007,
								-16.340399162999972
							],
							[
								123.9875990270001,
								-16.370419202999926
							],
							[
								123.9838492780001,
								-16.37948922299995
							],
							[
								123.97571904800009,
								-16.37892924299996
							],
							[
								123.94131926000011,
								-16.359819183999946
							],
							[
								123.90580921200001,
								-16.33514919399994
							],
							[
								123.89536919200009,
								-16.30737923399994
							],
							[
								123.88380928200002,
								-16.304019194999967
							],
							[
								123.8928189720001,
								-16.33369920499996
							],
							[
								123.91702898100004,
								-16.35218916399998
							],
							[
								123.88572914300005,
								-16.342809174999957
							],
							[
								123.90897902200004,
								-16.36290924399998
							],
							[
								123.88435897400007,
								-16.353649234999978
							],
							[
								123.8950401830001,
								-16.365029194999977
							],
							[
								123.89939007300006,
								-16.392189214999974
							],
							[
								123.88955014400005,
								-16.394489174999933
							],
							[
								123.89997903400001,
								-16.42281918499998
							],
							[
								123.88837908500011,
								-16.409520164999947
							],
							[
								123.88304927500008,
								-16.416710164999927
							],
							[
								123.875609155,
								-16.410100204999935
							],
							[
								123.86703902600004,
								-16.41286024599998
							],
							[
								123.87568908600008,
								-16.44473023599994
							],
							[
								123.87110917700011,
								-16.447041255999977
							],
							[
								123.85409919800009,
								-16.435151175999977
							],
							[
								123.85708898700011,
								-16.427601245999938
							],
							[
								123.84204025700001,
								-16.38282022599998
							],
							[
								123.85058019600001,
								-16.376460185999974
							],
							[
								123.8364699870001,
								-16.354359245999945
							],
							[
								123.851440206,
								-16.37172023599993
							],
							[
								123.87609011500001,
								-16.37766023499995
							],
							[
								123.87884017400006,
								-16.371239204999938
							],
							[
								123.86580025500007,
								-16.362219214999982
							],
							[
								123.8787300140001,
								-16.355189234999955
							],
							[
								123.87645011400002,
								-16.34703918499997
							],
							[
								123.86548022400007,
								-16.342429204999974
							],
							[
								123.86763014500002,
								-16.35171918499998
							],
							[
								123.86015005500008,
								-16.35030924499995
							],
							[
								123.86460002400008,
								-16.33609922499994
							],
							[
								123.85847028500007,
								-16.340569184999936
							],
							[
								123.85667999500004,
								-16.33015923499994
							],
							[
								123.86594928400007,
								-16.32785920499998
							],
							[
								123.84393025500003,
								-16.315029245999938
							],
							[
								123.83523011600005,
								-16.31959917599994
							],
							[
								123.8429801960001,
								-16.326209225999946
							],
							[
								123.82537007700012,
								-16.32280919599998
							],
							[
								123.79954008800007,
								-16.30395916699996
							],
							[
								123.81006000800005,
								-16.32065920599996
							],
							[
								123.79638002800004,
								-16.316109236999978
							],
							[
								123.7844499690001,
								-16.303049166999926
							],
							[
								123.79583030800006,
								-16.29974922699995
							],
							[
								123.78320005800003,
								-16.284049186999937
							],
							[
								123.78272015900006,
								-16.29763917699995
							],
							[
								123.77804016900006,
								-16.285819206999975
							],
							[
								123.77159006900001,
								-16.28712924699994
							],
							[
								123.76058018000003,
								-16.274949186999947
							],
							[
								123.75731029000008,
								-16.278649186999928
							],
							[
								123.74066030100005,
								-16.26325917799994
							],
							[
								123.74296900000002,
								-16.25310924799993
							],
							[
								123.76947901900007,
								-16.259529206999957
							],
							[
								123.77714916800005,
								-16.251789216999953
							],
							[
								123.78349921800009,
								-16.262129216999938
							],
							[
								123.78330912700005,
								-16.243019165999954
							],
							[
								123.79109917700009,
								-16.263539255999945
							],
							[
								123.7969491770001,
								-16.263019235999934
							],
							[
								123.79680912700007,
								-16.25126920599996
							],
							[
								123.80122919600001,
								-16.254919235999978
							],
							[
								123.79503901600003,
								-16.238819215999968
							],
							[
								123.78833904700002,
								-16.228249165999955
							],
							[
								123.78502918700008,
								-16.23342922599994
							],
							[
								123.77569908700002,
								-16.22882921699994
							],
							[
								123.77159904700011,
								-16.216139216999977
							],
							[
								123.78907922600001,
								-16.223629195999933
							],
							[
								123.78861910600006,
								-16.209489205999944
							],
							[
								123.7985691560001,
								-16.222909195999932
							],
							[
								123.80037925600004,
								-16.21613921599993
							],
							[
								123.81461904500009,
								-16.219639235999978
							],
							[
								123.80665908500009,
								-16.206129165999982
							],
							[
								123.79680912600008,
								-16.20921921599995
							],
							[
								123.80316924500005,
								-16.20349918599993
							],
							[
								123.79055919600012,
								-16.20045924599998
							],
							[
								123.7705680360001,
								-16.17057924599993
							],
							[
								123.75091810700007,
								-16.157429176999926
							],
							[
								123.74724828800004,
								-16.16275924699994
							],
							[
								123.74182814800008,
								-16.153509226999972
							],
							[
								123.73790918800012,
								-16.16059923699993
							],
							[
								123.72661812800004,
								-16.14049917699998
							],
							[
								123.70309826000005,
								-16.12866921799997
							],
							[
								123.72846925900001,
								-16.156799176999982
							],
							[
								123.7131692700001,
								-16.154069207999953
							],
							[
								123.7234389790001,
								-16.170879206999928
							],
							[
								123.70897921000005,
								-16.152229227999953
							],
							[
								123.70311914000001,
								-16.15388018799996
							],
							[
								123.7136390600001,
								-16.167529227999978
							],
							[
								123.70214930100008,
								-16.171160207999947
							],
							[
								123.70141922100004,
								-16.190250187999936
							],
							[
								123.70098900100004,
								-16.16946018799996
							],
							[
								123.6960491210001,
								-16.173260247999963
							],
							[
								123.6898491610001,
								-16.159990207999954
							],
							[
								123.69683928100005,
								-16.162230217999934
							],
							[
								123.69342901100003,
								-16.15109020799997
							],
							[
								123.67977925200012,
								-16.160580237999966
							],
							[
								123.68346925100002,
								-16.153600207999943
							],
							[
								123.66535908300011,
								-16.151190198999927
							],
							[
								123.67575914200006,
								-16.163200228999926
							],
							[
								123.66642901300008,
								-16.162850228999957
							],
							[
								123.6598493030001,
								-16.153410218999966
							],
							[
								123.65526902400006,
								-16.168290188999947
							],
							[
								123.64064906500005,
								-16.168960238999944
							],
							[
								123.62842919500008,
								-16.16174017999998
							],
							[
								123.63336913500007,
								-16.158610229999965
							],
							[
								123.62043905600001,
								-16.157680179999943
							],
							[
								123.63577897500011,
								-16.176150249999978
							],
							[
								123.61334918600005,
								-16.16048017999998
							],
							[
								123.59433903800004,
								-16.167890220999936
							],
							[
								123.5841891880001,
								-16.16441021099996
							],
							[
								123.57070896900007,
								-16.180791200999977
							],
							[
								123.56926897900007,
								-16.172301210999933
							],
							[
								123.56569924000007,
								-16.17849124099996
							],
							[
								123.55846899000005,
								-16.175941180999928
							],
							[
								123.5736890500001,
								-16.199591190999968
							],
							[
								123.56494898000005,
								-16.196571250999966
							],
							[
								123.56387906100008,
								-16.210351241999945
							],
							[
								123.58169908900004,
								-16.20587022099994
							],
							[
								123.60112898800003,
								-16.216350200999955
							],
							[
								123.56370915100001,
								-16.21623120199996
							],
							[
								123.58225922000008,
								-16.23369023099997
							],
							[
								123.58919928900002,
								-16.22990022099998
							],
							[
								123.58655906000001,
								-16.224910180999927
							],
							[
								123.60192928900005,
								-16.23239018099997
							],
							[
								123.58010929000011,
								-16.239210180999976
							],
							[
								123.59090931000003,
								-16.24767020099995
							],
							[
								123.60966928900007,
								-16.243760220999945
							],
							[
								123.60351903900005,
								-16.250940260999982
							],
							[
								123.61663921900004,
								-16.261790190999932
							],
							[
								123.57607009100002,
								-16.245280240999932
							],
							[
								123.59929910000005,
								-16.264070170999958
							],
							[
								123.58388931100001,
								-16.260600220999947
							],
							[
								123.58213899100008,
								-16.272010241999965
							],
							[
								123.56607001200007,
								-16.27628021199996
							],
							[
								123.54958022300002,
								-16.262791171999936
							],
							[
								123.55021025300005,
								-16.283140171999946
							],
							[
								123.5987601710001,
								-16.322789220999937
							],
							[
								123.59337025100001,
								-16.31121920099997
							],
							[
								123.62445014900004,
								-16.31724920099998
							],
							[
								123.61137924000002,
								-16.28707020099995
							],
							[
								123.62715012900003,
								-16.29048021099993
							],
							[
								123.64033009800005,
								-16.30867921999993
							],
							[
								123.66240025700006,
								-16.31349924999995
							],
							[
								123.68000029600012,
								-16.335569229999976
							],
							[
								123.69743007500006,
								-16.337519158999953
							],
							[
								123.70012001500004,
								-16.35098919899997
							],
							[
								123.71063018500001,
								-16.35401921899995
							],
							[
								123.69901011600007,
								-16.35408924899997
							],
							[
								123.69888014600008,
								-16.35911916899994
							],
							[
								123.71691110500001,
								-16.372378228999935
							],
							[
								123.68141113700005,
								-16.375368219999928
							],
							[
								123.66297122800006,
								-16.36797920999993
							],
							[
								123.67303106800011,
								-16.383098219999965
							],
							[
								123.6635410990001,
								-16.38335921999993
							],
							[
								123.65137130900007,
								-16.369469159999937
							],
							[
								123.65869119800004,
								-16.362859209999954
							],
							[
								123.62924103000012,
								-16.356739200999982
							],
							[
								123.64795130000005,
								-16.385379180999962
							],
							[
								123.68829109800004,
								-16.404818209999974
							],
							[
								123.68007121800008,
								-16.407908169999928
							],
							[
								123.68954103800002,
								-16.409007249999945
							],
							[
								123.6797612680001,
								-16.416157209999938
							],
							[
								123.69722198700003,
								-16.41483717999995
							],
							[
								123.68149216900008,
								-16.43267616999998
							],
							[
								123.67169220900007,
								-16.428307209999957
							],
							[
								123.676572039,
								-16.433546209999975
							],
							[
								123.66553225000007,
								-16.436616190999928
							],
							[
								123.62958121200006,
								-16.42297821099993
							],
							[
								123.62140200300007,
								-16.429957171999945
							],
							[
								123.608002123,
								-16.425738251999974
							],
							[
								123.59181112400006,
								-16.41711823199995
							],
							[
								123.60517107300007,
								-16.415538201999937
							],
							[
								123.59800130300005,
								-16.40564817199993
							],
							[
								123.57193121500006,
								-16.400789172999964
							],
							[
								123.57174112500002,
								-16.408359252999958
							],
							[
								123.55692099600003,
								-16.403479182999945
							],
							[
								123.56617118600002,
								-16.40344920299998
							],
							[
								123.5636411160001,
								-16.398109242999965
							],
							[
								123.53589122700009,
								-16.39798018299996
							],
							[
								123.50913099900004,
								-16.38022120399995
							],
							[
								123.51864110800011,
								-16.389240193999967
							],
							[
								123.51125102900005,
								-16.391321253999934
							],
							[
								123.56308131600008,
								-16.407939212999963
							],
							[
								123.54785114700007,
								-16.40849020299993
							],
							[
								123.57889107500012,
								-16.420179222999934
							],
							[
								123.58222213500005,
								-16.42766820299994
							],
							[
								123.50278132000005,
								-16.407071173999952
							],
							[
								123.4979512000001,
								-16.40985119399994
							],
							[
								123.50535099000001,
								-16.41998121399996
							],
							[
								123.54014103800012,
								-16.431480173999944
							],
							[
								123.54299113800005,
								-16.42721020299996
							],
							[
								123.56824227600009,
								-16.44551917299998
							],
							[
								123.57191209600012,
								-16.441249202999927
							],
							[
								123.59924223500002,
								-16.44871723199998
							],
							[
								123.6198320640001,
								-16.464717251999957
							],
							[
								123.65137204200005,
								-16.474935220999953
							],
							[
								123.64828213200008,
								-16.47987522099993
							],
							[
								123.66294312100001,
								-16.491076180999983
							],
							[
								123.63288209400002,
								-16.498625191999963
							],
							[
								123.62522198400006,
								-16.49042620199998
							],
							[
								123.60585220500002,
								-16.495237231999965
							],
							[
								123.60273207500006,
								-16.490687201999947
							],
							[
								123.5829720270001,
								-16.498548252999967
							],
							[
								123.5884922570001,
								-16.510458222999944
							],
							[
								123.60763205500007,
								-16.504857251999965
							],
							[
								123.63704225400011,
								-16.517996171999982
							],
							[
								123.64303226400011,
								-16.53002621199994
							],
							[
								123.58432201700009,
								-16.517438182999967
							],
							[
								123.59455216700007,
								-16.52588818299995
							],
							[
								123.54636110900003,
								-16.504219243999955
							],
							[
								123.53414128000009,
								-16.508630233999952
							],
							[
								123.54402113000003,
								-16.504539183999952
							],
							[
								123.47347120300003,
								-16.469991254999968
							],
							[
								123.46145222400003,
								-16.47700117599993
							],
							[
								123.46956230400008,
								-16.47504125599994
							],
							[
								123.47251216400002,
								-16.484001185999944
							],
							[
								123.4951410330001,
								-16.49404123499994
							],
							[
								123.50208114200007,
								-16.504050234999966
							],
							[
								123.49296121300006,
								-16.50171122499995
							],
							[
								123.49659110300001,
								-16.51452119499993
							],
							[
								123.44531126600009,
								-16.509861245999957
							],
							[
								123.43109126700006,
								-16.502952216999972
							],
							[
								123.44224227600012,
								-16.50045122599994
							],
							[
								123.4285511270001,
								-16.498852196999962
							],
							[
								123.42854105700007,
								-16.511182186999974
							],
							[
								123.46808128500004,
								-16.518211185999974
							],
							[
								123.46040102600011,
								-16.524591185999952
							],
							[
								123.46370117600009,
								-16.53479125599995
							],
							[
								123.48209104500006,
								-16.547281175999956
							],
							[
								123.49101112400001,
								-16.54600120599997
							],
							[
								123.50312117400006,
								-16.56601117499997
							],
							[
								123.51345100300011,
								-16.568401224999945
							],
							[
								123.49809125400009,
								-16.565061234999973
							],
							[
								123.49428101500007,
								-16.57079125599995
							],
							[
								123.51161103400011,
								-16.597742204999975
							],
							[
								123.51775121300011,
								-16.566121244999977
							],
							[
								123.54221106200009,
								-16.572011203999978
							],
							[
								123.53386118200001,
								-16.55046025499996
							],
							[
								123.52076114200008,
								-16.54816020499993
							],
							[
								123.52606105200005,
								-16.54440019499998
							],
							[
								123.57863112900009,
								-16.549829252999928
							],
							[
								123.58859127800008,
								-16.53828819299997
							],
							[
								123.61515097600011,
								-16.554318192999972
							],
							[
								123.61944111600008,
								-16.573769252999966
							],
							[
								123.58925112800011,
								-16.567440202999933
							],
							[
								123.60201097800007,
								-16.582131252999943
							],
							[
								123.58840118900002,
								-16.58281120299995
							],
							[
								123.58115010000006,
								-16.59450220399998
							],
							[
								123.56339019100005,
								-16.58824117399996
							],
							[
								123.56304026100008,
								-16.60079220399996
							],
							[
								123.57246003000012,
								-16.60799222399993
							],
							[
								123.56076003100009,
								-16.606312183999933
							],
							[
								123.55566025200005,
								-16.61259221399996
							],
							[
								123.5738802510001,
								-16.62522217399993
							],
							[
								123.50660020600003,
								-16.643132175999938
							],
							[
								123.52056025500008,
								-16.650052194999944
							],
							[
								123.50281011600009,
								-16.658812245999968
							],
							[
								123.52301009500002,
								-16.667812255999934
							],
							[
								123.54186004400003,
								-16.65806217499994
							],
							[
								123.54683017400009,
								-16.66610323499998
							],
							[
								123.55217009300009,
								-16.659703234999938
							],
							[
								123.55574920300012,
								-16.66572324499998
							],
							[
								123.5698190820001,
								-16.66596319399997
							],
							[
								123.57138902200006,
								-16.672753243999978
							],
							[
								123.58761929100001,
								-16.667583203999982
							],
							[
								123.59994928100002,
								-16.678993223999953
							],
							[
								123.61776926900006,
								-16.679483172999937
							],
							[
								123.68151808700009,
								-16.75167324199998
							],
							[
								123.71153813500007,
								-16.752704191999953
							],
							[
								123.7175979750001,
								-16.784854181999947
							],
							[
								123.75834817400005,
								-16.837734230999956
							],
							[
								123.76096825500008,
								-16.875844170999926
							],
							[
								123.79612910300011,
								-16.911824190999937
							],
							[
								123.88396802700004,
								-16.877883217999965
							],
							[
								123.89333703500006,
								-16.857213187999946
							],
							[
								123.90363700500006,
								-16.863763207999966
							],
							[
								123.92097713300006,
								-16.85206221699997
							],
							[
								123.92590729300002,
								-16.85681223699993
							],
							[
								123.94213716200011,
								-16.85206221699997
							],
							[
								123.94223728100008,
								-16.82279223699993
							],
							[
								123.95142696100004,
								-16.818102245999967
							],
							[
								123.94929722100005,
								-16.83640222699995
							],
							[
								123.95927712100001,
								-16.85240224599994
							],
							[
								123.95151697200004,
								-16.86750216699994
							],
							[
								123.92838695300009,
								-16.87129224699993
							],
							[
								123.91584709500012,
								-16.886492247999968
							],
							[
								123.90259799600005,
								-16.887482167999963
							],
							[
								123.89439830700007,
								-16.90741321799993
							],
							[
								123.82687922200012,
								-16.957263229999967
							],
							[
								123.80256807500007,
								-16.986363190999953
							],
							[
								123.82161819400005,
								-16.992822220999926
							],
							[
								123.82039814400002,
								-16.99788220099998
							],
							[
								123.79645815600009,
								-17.003993210999965
							],
							[
								123.83425204600007,
								-17.118035260999932
							],
							[
								123.82961201700004,
								-17.13463521099993
							],
							[
								123.88553220400001,
								-17.18656520999997
							],
							[
								123.88771312400002,
								-17.20250421999998
							],
							[
								123.91487222300009,
								-17.205634239999938
							],
							[
								123.91250198300008,
								-17.211844239999948
							],
							[
								123.88871318500003,
								-17.221714179999935
							],
							[
								123.86250304600003,
								-17.21655519099994
							],
							[
								123.85198312700004,
								-17.195395210999948
							],
							[
								123.83624319800003,
								-17.19161521099994
							],
							[
								123.8299331180001,
								-17.17837523199995
							],
							[
								123.78922324000007,
								-17.152275221999957
							],
							[
								123.78610202000004,
								-17.138795201999926
							],
							[
								123.77308228000004,
								-17.12902526299996
							],
							[
								123.76113208000004,
								-17.08773524299994
							],
							[
								123.74087202100009,
								-17.06833519299994
							],
							[
								123.70443206300001,
								-17.042665203999945
							],
							[
								123.6892022940001,
								-17.060015223999926
							],
							[
								123.68026202500005,
								-17.059215233999964
							],
							[
								123.67915216500012,
								-17.045055253999976
							],
							[
								123.66004230600004,
								-17.039635184999952
							],
							[
								123.65933128500001,
								-17.010165223999934
							],
							[
								123.64798120600005,
								-16.999724224999966
							],
							[
								123.6007020290001,
								-17.010605245999955
							],
							[
								123.58355309100011,
								-17.033246175999977
							],
							[
								123.5906440220001,
								-17.10097720699997
							],
							[
								123.60809499200002,
								-17.13936724699994
							],
							[
								123.6462352310001,
								-17.183937215999947
							],
							[
								123.64171507100002,
								-17.19363725599993
							],
							[
								123.6238151120001,
								-17.19864718699995
							],
							[
								123.61665508500005,
								-17.280357206999952
							],
							[
								123.60452632600004,
								-17.300858207999966
							],
							[
								123.60293729800003,
								-17.33938720799995
							],
							[
								123.59378714900004,
								-17.36151722799997
							],
							[
								123.5809970790001,
								-17.35013824899994
							],
							[
								123.56448824200004,
								-17.40578822899994
							],
							[
								123.58276828100009,
								-17.42473825899998
							],
							[
								123.57965720300001,
								-17.48360724899993
							],
							[
								123.59560627200005,
								-17.49983722899998
							],
							[
								123.60012713200001,
								-17.51556723899995
							],
							[
								123.59134818300004,
								-17.52942725899993
							],
							[
								123.5970592330001,
								-17.542677238999943
							],
							[
								123.58993914400003,
								-17.55259720999993
							],
							[
								123.59314924400007,
								-17.57373821999994
							],
							[
								123.58035917600012,
								-17.584178209999948
							],
							[
								123.57239925500005,
								-17.55582819999995
							],
							[
								123.57687834400008,
								-17.523827179999955
							],
							[
								123.56271627500007,
								-17.50387723999995
							],
							[
								123.54355709600009,
								-17.501067259999957
							],
							[
								123.54521813500003,
								-17.46921724999993
							],
							[
								123.5410083050001,
								-17.46377819999998
							],
							[
								123.53386806600008,
								-17.481887180999934
							],
							[
								123.53751915500004,
								-17.454378239999983
							],
							[
								123.52315914600001,
								-17.452278520999982
							],
							[
								123.52419917600002,
								-17.433188189999953
							],
							[
								123.51557933600009,
								-17.437158180999973
							],
							[
								123.51479922600004,
								-17.429528240999957
							],
							[
								123.51229900600003,
								-17.435508200999948
							],
							[
								123.51426931600008,
								-17.41844826099998
							],
							[
								123.48328913700004,
								-17.397049210999967
							],
							[
								123.45928830800005,
								-17.35059923199998
							],
							[
								123.44271821900008,
								-17.345429181999975
							],
							[
								123.42517724000004,
								-17.325449181999943
							],
							[
								123.40520732100003,
								-17.327499202999945
							],
							[
								123.39273724200007,
								-17.316239222999968
							],
							[
								123.3943572610001,
								-17.28064925299998
							],
							[
								123.38341722000007,
								-17.240019202999974
							],
							[
								123.34458728100003,
								-17.16271821299995
							],
							[
								123.2906110130001,
								-17.107707233999975
							],
							[
								123.27818524200006,
								-17.035530213999948
							],
							[
								123.26336332200003,
								-17.01181926399994
							],
							[
								123.23484412300002,
								-16.969934244999934
							],
							[
								123.16864301600003,
								-16.924934255999972
							],
							[
								123.149113037,
								-16.924704206999934
							],
							[
								123.15355325600001,
								-16.878424235999944
							],
							[
								123.1634021650001,
								-16.858972265999967
							],
							[
								123.17777319400011,
								-16.857719215999964
							],
							[
								123.16213207400006,
								-16.846632265999972
							],
							[
								123.16541203400004,
								-16.837062215999936
							],
							[
								123.15291209400004,
								-16.801542265999956
							],
							[
								123.12726212500002,
								-16.78714325599998
							],
							[
								123.10993207600006,
								-16.794183246999978
							],
							[
								123.10988202600004,
								-16.77824323699997
							],
							[
								123.10254235700006,
								-16.783703276999972
							],
							[
								123.10783218600011,
								-16.77257324699997
							],
							[
								123.1034621550001,
								-16.745283266999934
							],
							[
								123.1187520740001,
								-16.731543245999944
							],
							[
								123.13264233300004,
								-16.738023235999947
							],
							[
								123.14506229200003,
								-16.708423214999982
							],
							[
								123.13884222100012,
								-16.68846319499994
							],
							[
								123.1266220230001,
								-16.711053195999966
							],
							[
								123.09403230500004,
								-16.709113256999956
							],
							[
								123.08489226500001,
								-16.69827321699995
							],
							[
								123.08376332400007,
								-16.664804276999973
							],
							[
								123.07874311600006,
								-16.693234206999932
							],
							[
								123.05062314700001,
								-16.690774217999945
							],
							[
								123.03619327800004,
								-16.671514227999978
							],
							[
								123.041763177,
								-16.65676420799997
							],
							[
								123.03265302700004,
								-16.644455277999953
							],
							[
								123.0386733360001,
								-16.621345257999963
							],
							[
								123.02711334700007,
								-16.61703525799993
							],
							[
								123.02328329700003,
								-16.604555217999973
							],
							[
								122.99575303000006,
								-16.64083520899993
							],
							[
								122.98832335000009,
								-16.625595248999957
							],
							[
								122.99590315900002,
								-16.618105258999947
							],
							[
								122.99651335800002,
								-16.60183522899996
							],
							[
								122.98657301900005,
								-16.607075228999975
							],
							[
								122.98474316900001,
								-16.59307625899993
							],
							[
								122.96070416000009,
								-16.59059622999996
							],
							[
								122.95443404100001,
								-16.58012623999997
							],
							[
								122.96874331900005,
								-16.561866238999983
							],
							[
								122.98502322800005,
								-16.558736228999976
							],
							[
								122.98108301800005,
								-16.55244620899998
							],
							[
								122.98979323700007,
								-16.53249626799993
							],
							[
								123.00803334600005,
								-16.52841522799997
							],
							[
								123.00670313500007,
								-16.522186217999945
							],
							[
								122.97107322800002,
								-16.516096208999954
							],
							[
								122.99750334500004,
								-16.485796257999937
							],
							[
								122.99570334500004,
								-16.477556207999953
							],
							[
								122.97910300600006,
								-16.477076247999946
							],
							[
								122.98299320500007,
								-16.46511623799995
							],
							[
								123.01541334300009,
								-16.451736196999946
							],
							[
								123.02383302300007,
								-16.462686236999957
							],
							[
								123.0428532410001,
								-16.458945206999942
							],
							[
								123.04502335200004,
								-16.473775236999927
							],
							[
								123.04725273100007,
								-16.46295561599993
							],
							[
								123.07669220900004,
								-16.440325194999957
							],
							[
								123.04308290100005,
								-16.43984615599993
							],
							[
								123.03101279100008,
								-16.430546006999975
							],
							[
								123.03406273100006,
								-16.420746075999944
							],
							[
								123.02399282100009,
								-16.419956146999937
							],
							[
								123.01476317200002,
								-16.40575618699995
							],
							[
								123.02450276100001,
								-16.39791633699997
							],
							[
								123.03489285,
								-16.40018598599994
							],
							[
								123.03413226000009,
								-16.385596205999946
							],
							[
								123.0202823300001,
								-16.378196226999933
							],
							[
								123.03573208900002,
								-16.369216195999968
							],
							[
								123.03890225900011,
								-16.359196225999938
							],
							[
								122.99164327200003,
								-16.38007622699996
							],
							[
								122.9937031830001,
								-16.393396226999982
							],
							[
								122.98242329400011,
								-16.405886247999945
							],
							[
								122.99203316300009,
								-16.387536246999957
							],
							[
								122.98766312300006,
								-16.38088623699997
							],
							[
								122.97404322400007,
								-16.395306207999965
							],
							[
								122.95523324500004,
								-16.401727257999937
							],
							[
								122.92530317700005,
								-16.389437218999944
							],
							[
								122.90153310000005,
								-16.434967229999927
							],
							[
								122.91109324900003,
								-16.437677219999955
							],
							[
								122.90178331000004,
								-16.43665723999993
							],
							[
								122.89808429000004,
								-16.447187259999964
							],
							[
								122.89585414100009,
								-16.468207200999927
							],
							[
								122.90571417100011,
								-16.473587219999956
							],
							[
								122.90438430100005,
								-16.48850724999994
							],
							[
								122.88410409300002,
								-16.50802725099993
							],
							[
								122.8672341240001,
								-16.509348281999962
							],
							[
								122.86308403400005,
								-16.499088271999938
							],
							[
								122.85389432500006,
								-16.512678281999968
							],
							[
								122.86126425500004,
								-16.50993822199996
							],
							[
								122.88423403400009,
								-16.530237270999976
							],
							[
								122.86142409500007,
								-16.51908825199996
							],
							[
								122.84773509700005,
								-16.54648821199993
							],
							[
								122.81649536900011,
								-16.556108232999975
							],
							[
								122.83341534800002,
								-16.56068824299996
							],
							[
								122.8115853590001,
								-16.558279202999927
							],
							[
								122.79476506100002,
								-16.57167922399998
							],
							[
								122.81793536800001,
								-16.539158252999982
							],
							[
								122.81011509900009,
								-16.54528923299995
							],
							[
								122.77129629300009,
								-16.590299234999975
							],
							[
								122.7790060420001,
								-16.584929194999972
							],
							[
								122.77111627400006,
								-16.628599264999934
							],
							[
								122.74180725800011,
								-16.68338919599995
							],
							[
								122.7438772380001,
								-16.70010921599993
							],
							[
								122.76279632700005,
								-16.710319255999934
							],
							[
								122.77376625600004,
								-16.693999204999955
							],
							[
								122.78414615500003,
								-16.695959224999967
							],
							[
								122.78530605500009,
								-16.704139234999957
							],
							[
								122.77309629600006,
								-16.70450922499998
							],
							[
								122.77569622700003,
								-16.735459245999948
							],
							[
								122.79081624600008,
								-16.733708194999963
							],
							[
								122.8009563060001,
								-16.744738234999943
							],
							[
								122.806576285,
								-16.742788204999954
							],
							[
								122.81002619500009,
								-16.752828244999932
							],
							[
								122.83842621300005,
								-16.74446824399996
							],
							[
								122.82676618400001,
								-16.747338233999926
							],
							[
								122.82141623500002,
								-16.75696824399995
							],
							[
								122.83339630400008,
								-16.758268203999933
							],
							[
								122.82347611500006,
								-16.76983825399998
							],
							[
								122.83342615400011,
								-16.772398203999956
							],
							[
								122.82759630500004,
								-16.773548223999967
							],
							[
								122.84557616400002,
								-16.79201721399994
							],
							[
								122.83200634500008,
								-16.788668213999927
							],
							[
								122.81362618600008,
								-16.770098254999937
							],
							[
								122.8098562460001,
								-16.774288204999948
							],
							[
								122.81019609600003,
								-16.766158234999978
							],
							[
								122.80061612600002,
								-16.76700819499996
							],
							[
								122.80302632600001,
								-16.76212821499996
							],
							[
								122.78160634700009,
								-16.74740926499993
							],
							[
								122.79210607700008,
								-16.760588234999943
							],
							[
								122.7866463370001,
								-16.771678205999933
							],
							[
								122.7889560970001,
								-16.76353824499995
							],
							[
								122.77353622800001,
								-16.751399225999933
							],
							[
								122.77721612800008,
								-16.760869215999946
							],
							[
								122.7696662080001,
								-16.752659225999935
							],
							[
								122.77164727800005,
								-16.761549255999967
							],
							[
								122.76674733800007,
								-16.754359225999963
							],
							[
								122.7619571890001,
								-16.76549926599995
							],
							[
								122.7427072700001,
								-16.772189236999964
							],
							[
								122.76497723800003,
								-16.751999255999976
							],
							[
								122.75743739900008,
								-16.746039275999976
							],
							[
								122.73446722100005,
								-16.777639256999976
							],
							[
								122.70658735300003,
								-16.787460247999945
							],
							[
								122.69351721400005,
								-16.77723022799995
							],
							[
								122.66507831600006,
								-16.79416120899998
							],
							[
								122.63741916800006,
								-16.800691239999935
							],
							[
								122.62014922900005,
								-16.79465222999994
							],
							[
								122.60994827900004,
								-16.765641269999946
							],
							[
								122.57943935100002,
								-16.76212228099996
							],
							[
								122.56949938200012,
								-16.771412261999956
							],
							[
								122.57749930200009,
								-16.777272240999935
							],
							[
								122.5741193020001,
								-16.785752241999944
							],
							[
								122.55329937400006,
								-16.805352251999977
							],
							[
								122.57130909300008,
								-16.82259228199996
							],
							[
								122.57123926400004,
								-16.836142241999937
							],
							[
								122.56781929400006,
								-16.829042241999957
							],
							[
								122.56537919400012,
								-16.837972201999946
							],
							[
								122.56429919400011,
								-16.82927226199996
							],
							[
								122.55114912500005,
								-16.82886223299994
							],
							[
								122.56055914400008,
								-16.83550225199997
							],
							[
								122.55104940500007,
								-16.83451224299995
							],
							[
								122.54575920500008,
								-16.829442282999935
							],
							[
								122.54935919500008,
								-16.81982228299995
							],
							[
								122.5338100560001,
								-16.836933242999976
							],
							[
								122.5435102560001,
								-16.861413262999974
							],
							[
								122.55150010600005,
								-16.864443282999957
							],
							[
								122.55654009700004,
								-16.896403272999976
							],
							[
								122.56947022600002,
								-16.903253261999964
							],
							[
								122.57038031700006,
								-16.929353272999947
							],
							[
								122.57792015600012,
								-16.936563261999936
							],
							[
								122.58221025600005,
								-16.933203291999973
							],
							[
								122.58559033600011,
								-16.94806326199995
							],
							[
								122.59748039600004,
								-16.954913261999934
							],
							[
								122.59137011600001,
								-16.95493324199998
							],
							[
								122.59563104600011,
								-16.96429324199994
							],
							[
								122.61217018500008,
								-16.965243191999946
							],
							[
								122.60151130600002,
								-16.96631320199998
							],
							[
								122.60211107600003,
								-16.971283281999945
							],
							[
								122.58762108600001,
								-16.957203221999976
							],
							[
								122.57235131700008,
								-16.95566323299994
							],
							[
								122.55401112900006,
								-16.962383262999936
							],
							[
								122.55556127900002,
								-16.958083232999968
							],
							[
								122.53654139000002,
								-16.95701323399993
							],
							[
								122.52758137000001,
								-16.94766322399994
							],
							[
								122.50796138200008,
								-16.954353284999968
							],
							[
								122.51979132000008,
								-16.933673263999935
							],
							[
								122.50309129100003,
								-16.923663284999975
							],
							[
								122.50330007100001,
								-16.91597324399993
							],
							[
								122.48969134200001,
								-16.91849323499997
							],
							[
								122.48023021200004,
								-16.89457321499998
							],
							[
								122.47690126300006,
								-16.92169327499994
							],
							[
								122.48552110300011,
								-16.937263284999972
							],
							[
								122.47689119400002,
								-16.957164244999944
							],
							[
								122.4855610730001,
								-16.951613234999968
							],
							[
								122.47504115400011,
								-16.968134265999936
							],
							[
								122.4810611040001,
								-16.98133420599993
							],
							[
								122.47213130500006,
								-16.976944285999934
							],
							[
								122.47338120500001,
								-16.987844265999968
							],
							[
								122.46875122500012,
								-16.986334255999964
							],
							[
								122.46144107600003,
								-16.977764255999944
							],
							[
								122.46764136500008,
								-16.968824205999965
							],
							[
								122.45450136600004,
								-16.973264265999944
							],
							[
								122.44444222700008,
								-16.987744266999982
							],
							[
								122.43104233800011,
								-16.983374236999964
							],
							[
								122.44348139700003,
								-16.980514206999942
							],
							[
								122.44721136600003,
								-16.969774235999978
							],
							[
								122.4407410870001,
								-16.96708422699993
							],
							[
								122.46056124500001,
								-16.956864295999935
							],
							[
								122.46966131400006,
								-16.936284265999973
							],
							[
								122.36636223300002,
								-16.997625288999927
							],
							[
								122.36978221300001,
								-17.00807526899996
							],
							[
								122.35105212500002,
								-17.036935219999975
							],
							[
								122.2955332900001,
								-17.06721626199993
							],
							[
								122.25320413400004,
								-17.119836292999935
							],
							[
								122.25381434500002,
								-17.131706202999965
							],
							[
								122.26722433400005,
								-17.136996222999926
							],
							[
								122.30349325100008,
								-17.11240625199997
							],
							[
								122.30163314100002,
								-17.120886241999926
							],
							[
								122.2932833220001,
								-17.119206291999944
							],
							[
								122.2926043220001,
								-17.130276281999954
							],
							[
								122.30600317100004,
								-17.132746261999955
							],
							[
								122.31199322100008,
								-17.12707625099995
							],
							[
								122.31787308000003,
								-17.129666270999962
							],
							[
								122.31330434100005,
								-17.136456230999954
							],
							[
								122.31941316000007,
								-17.13531629099998
							],
							[
								122.288154383,
								-17.139556271999936
							],
							[
								122.31721429100003,
								-17.151256280999974
							],
							[
								122.31899411100005,
								-17.158936240999935
							],
							[
								122.28204410300009,
								-17.14510622199998
							],
							[
								122.27983443400001,
								-17.157426242999975
							],
							[
								122.27465438400009,
								-17.150426212999946
							],
							[
								122.26526414500006,
								-17.160386242999948
							],
							[
								122.25491412600002,
								-17.160626272999934
							],
							[
								122.2574042660001,
								-17.16898628299998
							],
							[
								122.24657438600002,
								-17.16391729399993
							],
							[
								122.25878415500006,
								-17.15564630299997
							],
							[
								122.25162412600002,
								-17.15758624299997
							],
							[
								122.2410541270001,
								-17.169237283999962
							],
							[
								122.24706432700009,
								-17.173297283999943
							],
							[
								122.23943411700009,
								-17.184157223999932
							],
							[
								122.24310433800008,
								-17.19601724399996
							],
							[
								122.23403412800008,
								-17.18574726399993
							],
							[
								122.22934441900009,
								-17.19818723399993
							],
							[
								122.22569438900007,
								-17.19231725399993
							],
							[
								122.23437433800007,
								-17.181007223999927
							],
							[
								122.22638415800009,
								-17.186437293999973
							],
							[
								122.20657518100006,
								-17.229177284999935
							],
							[
								122.20471539200003,
								-17.240367274999983
							],
							[
								122.21492532100001,
								-17.22815723499997
							],
							[
								122.21106544100007,
								-17.24035728499996
							],
							[
								122.20166512200001,
								-17.245907304999946
							],
							[
								122.18730544300001,
								-17.24039724599993
							],
							[
								122.17321538500005,
								-17.263578265999968
							],
							[
								122.16201616800004,
								-17.34155822699995
							],
							[
								122.1500263590001,
								-17.355358277999926
							],
							[
								122.15226735300007,
								-17.465639237999937
							],
							[
								122.14239724400011,
								-17.488819298999942
							],
							[
								122.14517824600011,
								-17.560339228999965
							],
							[
								122.17255839600011,
								-17.60121930899993
							],
							[
								122.18407841700002,
								-17.66764928899994
							],
							[
								122.18571821700004,
								-17.661319238999965
							],
							[
								122.19384844600006,
								-17.661849237999945
							],
							[
								122.18677839700001,
								-17.664259258999948
							],
							[
								122.19965811700001,
								-17.68480921799994
							],
							[
								122.19870886000001,
								-17.774300258999972
							],
							[
								122.21287944200003,
								-17.873720288999948
							],
							[
								122.20494018500005,
								-17.94526082999994
							],
							[
								122.18974030700008,
								-17.97070096999994
							],
							[
								122.17534032800006,
								-17.97399103099997
							],
							[
								122.20715058700011,
								-18.008861089999982
							],
							[
								122.21078036600011,
								-17.98921095999998
							],
							[
								122.23761023300005,
								-17.97102175899994
							],
							[
								122.25065011200002,
								-17.952320697999937
							],
							[
								122.30170149900005,
								-17.97360062699994
							],
							[
								122.33595874600007,
								-17.979870435999942
							],
							[
								122.35189749500012,
								-17.975209715999938
							],
							[
								122.37070517400002,
								-17.99098960499998
							],
							[
								122.37807843400003,
								-17.98980023499996
							],
							[
								122.37260642400008,
								-17.993699294999942
							],
							[
								122.38096744600011,
								-18.070650284999942
							],
							[
								122.37027542800001,
								-18.116431225999975
							],
							[
								122.31506046400011,
								-18.172312227999953
							],
							[
								122.261544318,
								-18.18446223999996
							],
							[
								122.24217125000007,
								-18.19938224999993
							],
							[
								122.21462225300002,
								-18.204022290999944
							],
							[
								122.20492241400007,
								-18.217362271999946
							],
							[
								122.21202232400003,
								-18.22855223099998
							],
							[
								122.19983238500004,
								-18.249682271999973
							],
							[
								122.18505221600003,
								-18.24787128199995
							],
							[
								122.19912245500007,
								-18.24312224199997
							],
							[
								122.20066217500005,
								-18.23759230199994
							],
							[
								122.19061241600002,
								-18.241202271999953
							],
							[
								122.20161223500008,
								-18.23533230199996
							],
							[
								122.19830237500003,
								-18.230692261999934
							],
							[
								122.1830423460001,
								-18.239402281999958
							],
							[
								122.17215235800006,
								-18.262901282999962
							],
							[
								122.17795231700006,
								-18.266061282999942
							],
							[
								122.16813111800002,
								-18.27341129299998
							],
							[
								122.16624114800004,
								-18.266631252999957
							],
							[
								122.1300312520001,
								-18.30741222399996
							],
							[
								122.0994914150001,
								-18.315202264999982
							],
							[
								122.08339144600006,
								-18.327622275999943
							],
							[
								122.0635223480001,
								-18.32580228699993
							],
							[
								122.01742438300005,
								-18.390513287999966
							],
							[
								122.00036216500007,
								-18.402753278999967
							],
							[
								121.98260228600009,
								-18.404833268999937
							],
							[
								121.94668148000005,
								-18.43925331099996
							],
							[
								121.90365250400009,
								-18.464043281999977
							],
							[
								121.87202215700006,
								-18.471673302999932
							],
							[
								121.85167318800006,
								-18.461693303999937
							],
							[
								121.83999223800004,
								-18.443713273999947
							],
							[
								121.81522316100006,
								-18.451124234999952
							],
							[
								121.78898349400004,
								-18.484174295999935
							],
							[
								121.8032542630001,
								-18.50804429599998
							],
							[
								121.81241339200005,
								-18.492354314999943
							],
							[
								121.81018317200005,
								-18.481054274999963
							],
							[
								121.81703323200009,
								-18.49180423499996
							],
							[
								121.7943431540001,
								-18.519434245999946
							],
							[
								121.79834348500003,
								-18.52995424599993
							],
							[
								121.7881331960001,
								-18.537724305999973
							],
							[
								121.79839319400003,
								-18.509844285999975
							],
							[
								121.79094332400007,
								-18.503834265999956
							],
							[
								121.76476341800003,
								-18.552814256999966
							],
							[
								121.72939451100001,
								-18.57566425899995
							],
							[
								121.75579438000011,
								-18.58499428799996
							],
							[
								121.7835341980001,
								-18.604654256999936
							],
							[
								121.78191417900007,
								-18.61002428699993
							],
							[
								121.79083426800003,
								-18.609244246999936
							],
							[
								121.783814258,
								-18.61082427699995
							],
							[
								121.79246541900011,
								-18.658184266999967
							],
							[
								121.78819547000012,
								-18.660774276999973
							],
							[
								121.78690523000012,
								-18.653874266999935
							],
							[
								121.7669353120001,
								-18.673035247999962
							],
							[
								121.75187651300007,
								-18.674815277999983
							],
							[
								121.74112437500003,
								-18.70472424899998
							],
							[
								121.73734440500004,
								-18.696805248999965
							],
							[
								121.71728232700002,
								-18.706354249999947
							],
							[
								121.69809142800011,
								-18.69862324999997
							],
							[
								121.67776221000008,
								-18.71562425099995
							],
							[
								121.6811822200001,
								-18.72060430099998
							],
							[
								121.66502327100011,
								-18.720244311999977
							],
							[
								121.65727319100006,
								-18.707094321999932
							],
							[
								121.63936428300008,
								-18.709975311999926
							],
							[
								121.63547448300005,
								-18.704205231999936
							],
							[
								121.62940453400006,
								-18.708815312999945
							],
							[
								121.63078441400012,
								-18.72192524299993
							],
							[
								121.6288443630001,
								-18.70023525299996
							],
							[
								121.61815450400002,
								-18.706295292999982
							],
							[
								121.61980550600003,
								-18.742005322999944
							],
							[
								121.634505364,
								-18.74329529299996
							],
							[
								121.65553546400008,
								-18.767195241999957
							],
							[
								121.64547529600009,
								-18.795866282999953
							],
							[
								121.65491518500005,
								-18.81317525199995
							],
							[
								121.65319548600007,
								-18.835915282999963
							],
							[
								121.65145523600006,
								-18.819045322999955
							],
							[
								121.64265541700001,
								-18.82263524299998
							],
							[
								121.64267520700002,
								-18.817995292999967
							],
							[
								121.63132548800002,
								-18.839995252999927
							],
							[
								121.6377053980001,
								-18.84769529299996
							],
							[
								121.62811535900005,
								-18.841565292999974
							],
							[
								121.61818549000009,
								-18.86435528399994
							],
							[
								121.60273643100004,
								-18.86916524399993
							],
							[
								121.60071648300004,
								-18.903165264999927
							],
							[
								121.57596649600009,
								-18.947366245999945
							],
							[
								121.60009620400001,
								-18.940665304999982
							],
							[
								121.57821646600007,
								-18.95087624599995
							],
							[
								121.5531864080001,
								-18.94344629699998
							],
							[
								121.5646063480001,
								-18.96924632599996
							],
							[
								121.54075740200005,
								-19.021277316999942
							],
							[
								121.51802735400008,
								-19.04280728799995
							],
							[
								121.52536743400003,
								-19.053107247999947
							],
							[
								121.50708841700009,
								-19.10107832899996
							],
							[
								121.33323040000005,
								-19.34163925599995
							],
							[
								121.21014139400006,
								-19.46628826099993
							],
							[
								121.1139313750001,
								-19.53855727499996
							],
							[
								120.95080855200001,
								-19.63863035099996
							],
							[
								120.85287059100006,
								-19.67334930499993
							],
							[
								120.63101233300006,
								-19.77003134399996
							],
							[
								120.56800330800002,
								-19.786202295999942
							],
							[
								120.32298445200001,
								-19.87572232599996
							],
							[
								120.19594551400007,
								-19.91389430099997
							],
							[
								120.13321552900004,
								-19.912415342999964
							],
							[
								120.08030560400005,
								-19.92123532499994
							],
							[
								120.0874066130001,
								-19.925265354999965
							],
							[
								120.08124555400002,
								-19.926465314999973
							],
							[
								120.07500569400008,
								-19.92239535599998
							],
							[
								120.02474571900007,
								-19.932616477999943
							],
							[
								119.97277556300003,
								-19.932986919999962
							],
							[
								119.90267603900008,
								-19.949038451999968
							],
							[
								119.87252667200005,
								-19.959518723999963
							],
							[
								119.86623703300006,
								-19.969578833999947
							],
							[
								119.86155689300006,
								-19.962148833999947
							],
							[
								119.7877675100001,
								-19.973289526999963
							],
							[
								119.79151744900003,
								-19.96810945699997
							],
							[
								119.76415745100007,
								-19.95554969799997
							],
							[
								119.7725473810001,
								-19.969739397999945
							],
							[
								119.76520767200009,
								-19.976419847999978
							],
							[
								119.75536727200006,
								-19.97170992799994
							],
							[
								119.75737747200003,
								-19.963580347999937
							],
							[
								119.73007682500008,
								-19.976170259999947
							],
							[
								119.75275409300002,
								-19.98370216899997
							],
							[
								119.74131740400003,
								-19.984380338999927
							],
							[
								119.74651759500011,
								-20.00320033899993
							],
							[
								119.74114749500006,
								-20.005900338999936
							],
							[
								119.75390778500002,
								-20.021590318999927
							],
							[
								119.74627745500004,
								-20.01087039899994
							],
							[
								119.73301751600002,
								-20.013340409999955
							],
							[
								119.72489740700007,
								-20.026190559999975
							],
							[
								119.71450723800001,
								-20.022450659999947
							],
							[
								119.70268755900008,
								-20.02989052099997
							],
							[
								119.70482730000003,
								-20.037220780999974
							],
							[
								119.69276744000001,
								-20.03394136099996
							],
							[
								119.69682752000006,
								-20.037891370999944
							],
							[
								119.6910876710001,
								-20.04104136099994
							],
							[
								119.69205719000001,
								-20.032690930999934
							],
							[
								119.70005744000002,
								-20.034170320999976
							],
							[
								119.70937712900002,
								-20.021320720999938
							],
							[
								119.70087660800004,
								-19.995090750999964
							],
							[
								119.68051720000005,
								-20.003801031999956
							],
							[
								119.6731974920001,
								-20.03199133199996
							],
							[
								119.65550747400005,
								-20.04652138299997
							],
							[
								119.56934865300002,
								-20.08033338699994
							],
							[
								119.56984834200011,
								-20.070972836999943
							],
							[
								119.51294064600006,
								-20.046493398999928
							],
							[
								119.48851141700004,
								-20.02500275999995
							],
							[
								119.49032144600005,
								-20.01800235999997
							],
							[
								119.47101338700008,
								-20.005662419999965
							],
							[
								119.46610274800003,
								-20.01332249099994
							],
							[
								119.44305198000006,
								-20.017212651999955
							],
							[
								119.4151707310001,
								-19.994493382999963
							],
							[
								119.38549955400003,
								-19.99881437399995
							],
							[
								119.37168058600002,
								-20.008094593999942
							],
							[
								119.381259494,
								-19.996434413999964
							],
							[
								119.3733804950001,
								-19.991474423999932
							],
							[
								119.3382704170001,
								-19.986174415999983
							],
							[
								119.320789579,
								-19.990355376999958
							],
							[
								119.24262852400011,
								-19.964499349999983
							],
							[
								119.24155900400001,
								-19.971049189999974
							],
							[
								119.2484592940001,
								-19.970579658999952
							],
							[
								119.23996847500007,
								-19.97168937999993
							],
							[
								119.23809861400002,
								-19.961339369999962
							],
							[
								119.21827846600002,
								-19.953199410999957
							],
							[
								119.18532925800002,
								-19.95136944199993
							],
							[
								119.17159941900002,
								-19.956559392999964
							],
							[
								119.17215959200007,
								-20.00771942299997
							],
							[
								119.2105694490001,
								-20.01723936099995
							],
							[
								119.20707961000005,
								-20.023659411999972
							],
							[
								119.16842965300009,
								-20.015149382999937
							],
							[
								119.15868941300005,
								-20.00404965299998
							],
							[
								119.16063971300002,
								-20.01210973299993
							],
							[
								119.1470992730001,
								-19.97855967399994
							],
							[
								119.11869913400005,
								-19.961699584999963
							],
							[
								119.09971906500004,
								-19.95930964599995
							],
							[
								119.08835876700005,
								-19.970359565999956
							],
							[
								119.09370890700006,
								-19.988439855999957
							],
							[
								119.06835896100006,
								-20.01537974699994
							],
							[
								119.04311892300007,
								-20.021919778999973
							],
							[
								119.04200903300011,
								-20.02740977899998
							],
							[
								118.99383972800001,
								-20.03578036099998
							],
							[
								118.97642102200007,
								-20.09550077199998
							],
							[
								118.95915086500008,
								-20.127010992999942
							],
							[
								118.94088159800003,
								-20.144741393999936
							],
							[
								118.89651176200005,
								-20.167742475999944
							],
							[
								118.86028263800006,
								-20.225433417999966
							],
							[
								118.86263246800002,
								-20.221423537999954
							],
							[
								118.86428259800005,
								-20.235503637999955
							],
							[
								118.87822380800003,
								-20.242502886999944
							],
							[
								118.87146408900003,
								-20.253712976999964
							],
							[
								118.88266425800009,
								-20.261112846999936
							],
							[
								118.86955377900006,
								-20.253363156999967
							],
							[
								118.87453369800005,
								-20.242332976999933
							],
							[
								118.8513125390001,
								-20.225493427999936
							],
							[
								118.84207283,
								-20.23063389899994
							],
							[
								118.83528310100007,
								-20.245264048999957
							],
							[
								118.83980311100004,
								-20.248334028999977
							],
							[
								118.82980361200009,
								-20.258884438999928
							],
							[
								118.84727313100007,
								-20.262313998999957
							],
							[
								118.83241336200001,
								-20.26228417899995
							],
							[
								118.82780377300003,
								-20.272644458999935
							],
							[
								118.84935352200011,
								-20.28947410899997
							],
							[
								118.860283331,
								-20.28208394799998
							],
							[
								118.85484348200009,
								-20.290634057999966
							],
							[
								118.82263358400007,
								-20.275994329999946
							],
							[
								118.82088381500012,
								-20.287834459999942
							],
							[
								118.82071361400006,
								-20.278014379999945
							],
							[
								118.8059737850001,
								-20.28108452999993
							],
							[
								118.80592388600007,
								-20.28808460999994
							],
							[
								118.79785377600001,
								-20.278894590999982
							],
							[
								118.76823384900001,
								-20.28171484199993
							],
							[
								118.6902647070001,
								-20.31578548599998
							],
							[
								118.67677481800001,
								-20.32664544599993
							],
							[
								118.6873349980001,
								-20.327145965999932
							],
							[
								118.67866482800002,
								-20.330265505999932
							],
							[
								118.67835464900008,
								-20.340305865999937
							],
							[
								118.66569477000007,
								-20.342846436999935
							],
							[
								118.67446451900003,
								-20.332266206999975
							],
							[
								118.65514459000008,
								-20.33110636699996
							],
							[
								118.66733452900007,
								-20.325335406999955
							],
							[
								118.6418193510001,
								-20.312441057999933
							],
							[
								118.64037826000003,
								-20.298481987999935
							],
							[
								118.59819945400011,
								-20.30824745999996
							],
							[
								118.59800421300008,
								-20.286542319999967
							],
							[
								118.59102548500005,
								-20.30807851999998
							],
							[
								118.57841754600008,
								-20.308457660999977
							],
							[
								118.57304262700006,
								-20.31617339099995
							],
							[
								118.5917747960001,
								-20.32965668999998
							],
							[
								118.60678461400005,
								-20.324576479999962
							],
							[
								118.62956463300009,
								-20.334356318999937
							],
							[
								118.60851471400008,
								-20.331586499999958
							],
							[
								118.61729479400003,
								-20.34241647899995
							],
							[
								118.60564468500002,
								-20.33122652999998
							],
							[
								118.58742490600002,
								-20.33537678099998
							],
							[
								118.60287521600003,
								-20.34903677999995
							],
							[
								118.61285493500009,
								-20.347536568999942
							],
							[
								118.60309523600006,
								-20.351526779999972
							],
							[
								118.59668506600008,
								-20.34492677999998
							],
							[
								118.59594528700006,
								-20.354476869999928
							],
							[
								118.58022495700004,
								-20.337246860999983
							],
							[
								118.5785753780001,
								-20.357666950999942
							],
							[
								118.57603497700006,
								-20.337776900999927
							],
							[
								118.57130508800003,
								-20.345196930999975
							],
							[
								118.57443481700011,
								-20.327946830999963
							],
							[
								118.55625530000009,
								-20.34974699199995
							],
							[
								118.55202520000012,
								-20.34629702199993
							],
							[
								118.56329486800007,
								-20.329556921999938
							],
							[
								118.55849471800002,
								-20.316656911999928
							],
							[
								118.56643477800003,
								-20.325746890999937
							],
							[
								118.56545468700006,
								-20.31803686099994
							],
							[
								118.57043470700012,
								-20.320126810999966
							],
							[
								118.56372158700003,
								-20.310805820999974
							],
							[
								118.5737544860001,
								-20.301586630999964
							],
							[
								118.56197144600003,
								-20.294382690999953
							],
							[
								118.52627467000002,
								-20.305347402999928
							],
							[
								118.5473445880001,
								-20.304836931999944
							],
							[
								118.55732463800007,
								-20.313596901999972
							],
							[
								118.5481346680001,
								-20.310596961999977
							],
							[
								118.54684482900007,
								-20.320857041999943
							],
							[
								118.54049485000007,
								-20.321707122999953
							],
							[
								118.54335507000008,
								-20.33843716299998
							],
							[
								118.54508495000005,
								-20.33145713199997
							],
							[
								118.5339550010001,
								-20.33114722299996
							],
							[
								118.53664491000006,
								-20.324387172999934
							],
							[
								118.53090492000001,
								-20.323897202999945
							],
							[
								118.53956483000002,
								-20.319217092999963
							],
							[
								118.53675462900003,
								-20.311637402999963
							],
							[
								118.50621500300008,
								-20.327647473999946
							],
							[
								118.51791504200003,
								-20.33079737399993
							],
							[
								118.50639524400003,
								-20.348767583999972
							],
							[
								118.51073502200006,
								-20.330627453999966
							],
							[
								118.49105506400008,
								-20.33425763499997
							],
							[
								118.48659476400007,
								-20.330447404999973
							],
							[
								118.49496501400006,
								-20.328127584999947
							],
							[
								118.48752500400008,
								-20.32595764499996
							],
							[
								118.479405025,
								-20.32913773499996
							],
							[
								118.49592518400004,
								-20.34362764499997
							],
							[
								118.48927528500008,
								-20.35097772499995
							],
							[
								118.49304471500011,
								-20.34361757499994
							],
							[
								118.47752520600011,
								-20.34947782599994
							],
							[
								118.45585471700008,
								-20.335058456999946
							],
							[
								118.44892504800009,
								-20.337138246999928
							],
							[
								118.45031467800004,
								-20.346728406999944
							],
							[
								118.42802544000006,
								-20.344708397999966
							],
							[
								118.43959553900004,
								-20.338438396999948
							],
							[
								118.4168655310001,
								-20.339548517999958
							],
							[
								118.40890576200002,
								-20.34913862899998
							],
							[
								118.4116359620001,
								-20.36106862899993
							],
							[
								118.40385547300002,
								-20.36428886899995
							],
							[
								118.40944570200008,
								-20.358508418999975
							],
							[
								118.40063577300009,
								-20.348628708999968
							],
							[
								118.37909581500003,
								-20.35135858999996
							],
							[
								118.37920593500007,
								-20.369608909999954
							],
							[
								118.36867571500011,
								-20.35141846099998
							],
							[
								118.36360583700002,
								-20.37394944099998
							],
							[
								118.35914575700008,
								-20.358709380999983
							],
							[
								118.34406573800004,
								-20.360039401999927
							],
							[
								118.3536156770001,
								-20.355239000999973
							],
							[
								118.3447855170001,
								-20.342308731999935
							],
							[
								118.34613550600011,
								-20.32987848199997
							],
							[
								118.32788554800004,
								-20.34093943199997
							],
							[
								118.28877584200006,
								-20.348619413999927
							],
							[
								118.31540554000003,
								-20.35467927299993
							],
							[
								118.31834554000011,
								-20.365389452999977
							],
							[
								118.31481567000003,
								-20.35603944299993
							],
							[
								118.3084055710001,
								-20.364329443999964
							],
							[
								118.30762549100007,
								-20.356189293999932
							],
							[
								118.29777579100005,
								-20.351619503999927
							],
							[
								118.2835057530001,
								-20.36739957499998
							],
							[
								118.28102561300011,
								-20.35340952499996
							],
							[
								118.25734554500002,
								-20.358839715999977
							],
							[
								118.25237577600001,
								-20.36959993599993
							],
							[
								118.25722578600005,
								-20.377709815999935
							],
							[
								118.24423558700005,
								-20.369760396999936
							],
							[
								118.23600560800003,
								-20.37522043699994
							],
							[
								118.24017583700004,
								-20.37193039699997
							],
							[
								118.23272673800011,
								-20.368130416999975
							],
							[
								118.21549661900008,
								-20.37092989799993
							],
							[
								118.2247167380001,
								-20.37053945699995
							],
							[
								118.21394664900004,
								-20.37318991799998
							],
							[
								118.19616764300008,
								-20.40374044899994
							],
							[
								118.20546682000008,
								-20.376399437999964
							],
							[
								118.16513735400008,
								-20.382929849999982
							],
							[
								118.16953666300003,
								-20.36896939999997
							],
							[
								118.19823657100005,
								-20.36943946899993
							],
							[
								118.18008684100005,
								-20.358119448999958
							],
							[
								118.19983677000005,
								-20.368929438999942
							],
							[
								118.19758717000002,
								-20.361189818999947
							],
							[
								118.18413659100008,
								-20.355989868999927
							],
							[
								118.18372640100006,
								-20.34669989899993
							],
							[
								118.17599690200007,
								-20.354869589999964
							],
							[
								118.1821067510001,
								-20.355969818999938
							],
							[
								118.17230672200003,
								-20.359109859999933
							],
							[
								118.17297682200001,
								-20.35092943999996
							],
							[
								118.18479673000002,
								-20.345559408999975
							],
							[
								118.20021644000008,
								-20.36004947899994
							],
							[
								118.19673568900009,
								-20.33790985899998
							],
							[
								118.1815761900001,
								-20.33639988899995
							],
							[
								118.16091686300001,
								-20.357879819999937
							],
							[
								118.11029785900007,
								-20.387710882999954
							],
							[
								118.10976814000003,
								-20.401039912999977
							],
							[
								118.10325778000004,
								-20.394751432999954
							],
							[
								118.05008878600006,
								-20.42209037599997
							],
							[
								118.01778877000004,
								-20.458701477999966
							],
							[
								117.99231867300011,
								-20.47214172899993
							],
							[
								117.95302766700001,
								-20.47873243099997
							],
							[
								117.96530856700008,
								-20.49110264999996
							],
							[
								117.94810786700009,
								-20.477842410999926
							],
							[
								117.94092791800006,
								-20.479902481999943
							],
							[
								117.9421782600001,
								-20.510894011999937
							],
							[
								117.93153811100001,
								-20.526583621999976
							],
							[
								117.94294841100009,
								-20.53049354199993
							],
							[
								117.94941825900003,
								-20.51042309099995
							],
							[
								117.961698608,
								-20.50663242099995
							],
							[
								117.9513788590001,
								-20.511603480999952
							],
							[
								117.94841852000002,
								-20.51997329099993
							],
							[
								117.95919875800007,
								-20.51699340099998
							],
							[
								117.94842867000011,
								-20.522563400999957
							],
							[
								117.94272879100004,
								-20.536823461999973
							],
							[
								117.95968874000005,
								-20.546803470999976
							],
							[
								117.97097872800009,
								-20.525193249999973
							],
							[
								117.96412867000004,
								-20.54690354099995
							],
							[
								117.97285858900011,
								-20.54167347999993
							],
							[
								117.9750586990001,
								-20.550473869999962
							],
							[
								117.9705886590001,
								-20.544393769999942
							],
							[
								117.95933881000008,
								-20.549404480999954
							],
							[
								117.96023883100008,
								-20.56194444099998
							],
							[
								117.95776854000007,
								-20.547833940999965
							],
							[
								117.94540862100007,
								-20.54618444199997
							],
							[
								117.94951874100002,
								-20.551814401999934
							],
							[
								117.94042875200012,
								-20.55896445199994
							],
							[
								117.9417886330001,
								-20.566974521999953
							],
							[
								117.93454841300002,
								-20.55853430199994
							],
							[
								117.9437785020001,
								-20.556804201999967
							],
							[
								117.94133840200004,
								-20.546654081999975
							],
							[
								117.91985782300003,
								-20.543564492999963
							],
							[
								117.91226823400007,
								-20.555514382999945
							],
							[
								117.92457866400002,
								-20.561034452999934
							],
							[
								117.9146588750001,
								-20.562674442999935
							],
							[
								117.930288614,
								-20.570864422999932
							],
							[
								117.92030867400001,
								-20.56671448299994
							],
							[
								117.91217891600002,
								-20.576584842999978
							],
							[
								117.91590830500002,
								-20.567284582999946
							],
							[
								117.90037766600005,
								-20.56193445399998
							],
							[
								117.90334767500008,
								-20.55367443399996
							],
							[
								117.89014802600002,
								-20.55816456399998
							],
							[
								117.8953077760001,
								-20.551784433999956
							],
							[
								117.8817479170001,
								-20.55194449499993
							],
							[
								117.87103871900001,
								-20.57174538499993
							],
							[
								117.87838864900004,
								-20.581095244999972
							],
							[
								117.89142866700001,
								-20.57303501399997
							],
							[
								117.88473891800004,
								-20.578255414999944
							],
							[
								117.89799877700011,
								-20.585245443999952
							],
							[
								117.88845866800011,
								-20.57936545499996
							],
							[
								117.86747872000001,
								-20.58192543599995
							],
							[
								117.8593791610001,
								-20.597425485999963
							],
							[
								117.86457964100009,
								-20.607455465999976
							],
							[
								117.8600497320001,
								-20.611315695999963
							],
							[
								117.8541298020001,
								-20.606025625999962
							],
							[
								117.81415084700006,
								-20.632126437999943
							],
							[
								117.79419079000002,
								-20.655566239999928
							],
							[
								117.7827908910001,
								-20.654356449999966
							],
							[
								117.77429091200008,
								-20.663526460999947
							],
							[
								117.79486082100004,
								-20.675326259999963
							],
							[
								117.80974084000002,
								-20.674156448999952
							],
							[
								117.79343067100001,
								-20.679286459999958
							],
							[
								117.7742009420001,
								-20.67007647099996
							],
							[
								117.77019087300005,
								-20.676316450999934
							],
							[
								117.76947087300005,
								-20.666066430999933
							],
							[
								117.74732114500011,
								-20.674106481999956
							],
							[
								117.74625114500009,
								-20.68227656199997
							],
							[
								117.74481096500006,
								-20.67568653199993
							],
							[
								117.73929117600005,
								-20.677626561999944
							],
							[
								117.73740120600007,
								-20.686556662999976
							],
							[
								117.73629084600009,
								-20.67887668299994
							],
							[
								117.71398160800004,
								-20.682206813999983
							],
							[
								117.70355165900003,
								-20.68776649399996
							],
							[
								117.70412132000001,
								-20.69453690399996
							],
							[
								117.70066133000012,
								-20.686756893999927
							],
							[
								117.6881913310001,
								-20.69152711499993
							],
							[
								117.69730133000007,
								-20.686986933999947
							],
							[
								117.68683130000011,
								-20.677297024999973
							],
							[
								117.68945127000006,
								-20.66870694499994
							],
							[
								117.68044179000003,
								-20.666587454999956
							],
							[
								117.66679171200008,
								-20.679377445999933
							],
							[
								117.67537136200008,
								-20.69901726599994
							],
							[
								117.66416137300007,
								-20.684127305999937
							],
							[
								117.66737162200002,
								-20.67226745599993
							],
							[
								117.65433174400005,
								-20.688897476999955
							],
							[
								117.65632154500008,
								-20.71545757699994
							],
							[
								117.65137152500006,
								-20.703917456999932
							],
							[
								117.64399184600006,
								-20.71163748699996
							],
							[
								117.6283014070001,
								-20.709077327999978
							],
							[
								117.64656140500006,
								-20.70212726699998
							],
							[
								117.64508165400002,
								-20.68942755699993
							],
							[
								117.63717130500004,
								-20.693337216999964
							],
							[
								117.64170077400001,
								-20.677967416999934
							],
							[
								117.62597091500004,
								-20.677087477999976
							],
							[
								117.61658081700011,
								-20.687257727999963
							],
							[
								117.61888071600004,
								-20.678837457999975
							],
							[
								117.64834015300005,
								-20.661976826999933
							],
							[
								117.63074095400009,
								-20.66375748799993
							],
							[
								117.58997100900001,
								-20.679757369999948
							],
							[
								117.59888119900006,
								-20.69475731899996
							],
							[
								117.59070067900007,
								-20.68799746999997
							],
							[
								117.58502113000009,
								-20.694157339999947
							],
							[
								117.59492113900001,
								-20.703627839999967
							],
							[
								117.5733108710001,
								-20.694017480999946
							],
							[
								117.55256113300004,
								-20.70398750199996
							],
							[
								117.5482717650001,
								-20.72567749199993
							],
							[
								117.55571134400009,
								-20.730827621999936
							],
							[
								117.54756177500008,
								-20.72816757199996
							],
							[
								117.54229164600008,
								-20.73618762199993
							],
							[
								117.55281065300005,
								-20.710877461999928
							],
							[
								117.54453084400006,
								-20.707727551999938
							],
							[
								117.51049102800005,
								-20.71990758399994
							],
							[
								117.44258194400004,
								-20.730588456999953
							],
							[
								117.43457154500004,
								-20.74048826799998
							],
							[
								117.46113127400008,
								-20.75164826699995
							],
							[
								117.45741126400003,
								-20.757208326999944
							],
							[
								117.4414313850001,
								-20.74533830699994
							],
							[
								117.44107135500008,
								-20.753588397999977
							],
							[
								117.42979146700009,
								-20.757998387999976
							],
							[
								117.43650147500011,
								-20.74647830799995
							],
							[
								117.42700136500002,
								-20.731118297999956
							],
							[
								117.39518121800006,
								-20.73057861999996
							],
							[
								117.38745076900011,
								-20.744768669999928
							],
							[
								117.4038516490001,
								-20.76004835899994
							],
							[
								117.3883507600001,
								-20.75271874999993
							],
							[
								117.38609086000008,
								-20.76042880999995
							],
							[
								117.39736139900003,
								-20.75881849999996
							],
							[
								117.3979714300001,
								-20.77100925999997
							],
							[
								117.3901609400001,
								-20.760968769999977
							],
							[
								117.38177152200001,
								-20.78434914099995
							],
							[
								117.38295095100011,
								-20.764698890999966
							],
							[
								117.37706098100011,
								-20.758828800999936
							],
							[
								117.38282104000007,
								-20.750698789999944
							],
							[
								117.36984146000009,
								-20.73420885099995
							],
							[
								117.3627615910001,
								-20.73431874099998
							],
							[
								117.36673155100004,
								-20.745728860999975
							],
							[
								117.35231164300001,
								-20.757109041999968
							],
							[
								117.35072177400002,
								-20.77161898199995
							],
							[
								117.35788140400007,
								-20.775758951999933
							],
							[
								117.34971164500007,
								-20.778968971999973
							],
							[
								117.34966178400009,
								-20.76301898199995
							],
							[
								117.34048174500003,
								-20.764269242999944
							],
							[
								117.33731193500012,
								-20.77419901299993
							],
							[
								117.34031161400003,
								-20.75827933299996
							],
							[
								117.33199180600002,
								-20.77055924299998
							],
							[
								117.3326217550001,
								-20.761209342999962
							],
							[
								117.32025198600002,
								-20.758509053999944
							],
							[
								117.34668170400005,
								-20.759289121999927
							],
							[
								117.35784150200004,
								-20.74301902199994
							],
							[
								117.34754157200007,
								-20.73563894199998
							],
							[
								117.30268219600009,
								-20.726788603999978
							],
							[
								117.29800216700005,
								-20.738018694999937
							],
							[
								117.29334177700002,
								-20.735808464999934
							],
							[
								117.3016318760001,
								-20.734218513999963
							],
							[
								117.29993192600011,
								-20.726488563999965
							],
							[
								117.28794236700003,
								-20.73489863499998
							],
							[
								117.29202171600002,
								-20.723608584999965
							],
							[
								117.28374223700007,
								-20.726878564999936
							],
							[
								117.28393276800011,
								-20.735308974999953
							],
							[
								117.2846917170001,
								-20.720238454999958
							],
							[
								117.26381170900004,
								-20.728488495999954
							],
							[
								117.27749168800005,
								-20.72382846599993
							],
							[
								117.24477217900005,
								-20.704298576999975
							],
							[
								117.24502184000005,
								-20.714188476999936
							],
							[
								117.24229195900011,
								-20.70251845699994
							],
							[
								117.22310202100005,
								-20.695128497999974
							],
							[
								117.21194218200003,
								-20.697718608999935
							],
							[
								117.22898224100004,
								-20.70551846799998
							],
							[
								117.21643234300006,
								-20.724828828999932
							],
							[
								117.21729231200004,
								-20.71330864899994
							],
							[
								117.22730222100006,
								-20.706758487999934
							],
							[
								117.21446225200009,
								-20.705968608999967
							],
							[
								117.1936118430001,
								-20.68643887999997
							],
							[
								117.19518182200011,
								-20.68031887999996
							],
							[
								117.18588224400003,
								-20.697928899999965
							],
							[
								117.20029229300008,
								-20.706188778999945
							],
							[
								117.18676229400012,
								-20.701388899999927
							],
							[
								117.18265202400005,
								-20.69182896999996
							],
							[
								117.1719521650001,
								-20.70057916099995
							],
							[
								117.20043161100011,
								-20.66653865899997
							],
							[
								117.18914176200008,
								-20.665068719999965
							],
							[
								117.190101862,
								-20.673308899999938
							],
							[
								117.17522175300007,
								-20.664148859999955
							],
							[
								117.17557179300002,
								-20.673868970999933
							],
							[
								117.18385178300002,
								-20.67269891999996
							],
							[
								117.16801191400009,
								-20.68221915099997
							],
							[
								117.1673016630001,
								-20.657368910999935
							],
							[
								117.17199161300005,
								-20.654658790999974
							],
							[
								117.17329178400007,
								-20.67397901099997
							],
							[
								117.18137146100003,
								-20.64504857999998
							],
							[
								117.1569916840001,
								-20.65767910099993
							],
							[
								117.18160144100011,
								-20.63964851999998
							],
							[
								117.17488136100008,
								-20.63048853999993
							],
							[
								117.16540139200004,
								-20.63454873099994
							],
							[
								117.16564134200007,
								-20.62833864099997
							],
							[
								117.19295882000006,
								-20.63841846899993
							],
							[
								117.20002280900007,
								-20.63251646899994
							],
							[
								117.19064281800001,
								-20.61133346899993
							],
							[
								117.18066069000008,
								-20.616108449999956
							],
							[
								117.18666979900001,
								-20.614042479999966
							],
							[
								117.17536680900002,
								-20.60223648999994
							],
							[
								117.18235881800001,
								-20.59179047999993
							],
							[
								117.17241880900008,
								-20.59197047999993
							],
							[
								117.14164581300008,
								-20.622548491999964
							],
							[
								117.12820183600002,
								-20.65437951299998
							],
							[
								117.10534185800009,
								-20.654769493999936
							],
							[
								117.09590145800007,
								-20.641829823999956
							],
							[
								117.10156184700008,
								-20.630089513999962
							],
							[
								117.09436119700001,
								-20.62397974399994
							],
							[
								117.08451155900002,
								-20.636049884999977
							],
							[
								117.06638165100003,
								-20.639529885999934
							],
							[
								117.03881188500009,
								-20.667560847999937
							],
							[
								117.03803173400001,
								-20.659480567999935
							],
							[
								117.02951172500002,
								-20.65823073799993
							],
							[
								117.03680482400011,
								-20.64763249799995
							],
							[
								116.98813682800005,
								-20.658535489999963
							],
							[
								116.97578782000005,
								-20.669690490999983
							],
							[
								116.9971120990001,
								-20.67516138999997
							],
							[
								116.9873118490001,
								-20.670011709999983
							],
							[
								116.9869020000001,
								-20.678931819999946
							],
							[
								116.98612183900002,
								-20.670471749999933
							],
							[
								116.9791618800001,
								-20.671081990999937
							],
							[
								116.97926203100008,
								-20.68743214099993
							],
							[
								116.98076193000009,
								-20.67637199099994
							],
							[
								116.97364198000002,
								-20.671002530999942
							],
							[
								116.9654519720001,
								-20.683252530999937
							],
							[
								116.95633186200007,
								-20.683312411999964
							],
							[
								116.94558217400004,
								-20.698182582999948
							],
							[
								116.95682187300008,
								-20.701212771999963
							],
							[
								116.92643259700003,
								-20.71319304399998
							],
							[
								116.95268284500003,
								-20.724322711999946
							],
							[
								116.92708280700003,
								-20.72007300399997
							],
							[
								116.93166315700012,
								-20.730912992999947
							],
							[
								116.92792296700009,
								-20.725673013999938
							],
							[
								116.91991329900009,
								-20.74067320399996
							],
							[
								116.92754296700002,
								-20.725073023999983
							],
							[
								116.9236626170001,
								-20.71231307399995
							],
							[
								116.8987828700001,
								-20.72409341499997
							],
							[
								116.82820271500009,
								-20.70870451899998
							],
							[
								116.81322271500005,
								-20.69846414899996
							],
							[
								116.79585082500012,
								-20.666805499999953
							],
							[
								116.78669885700003,
								-20.686113510999974
							],
							[
								116.79258685600007,
								-20.676343489999965
							],
							[
								116.7883818360001,
								-20.665333490999956
							],
							[
								116.80220383300002,
								-20.639934489999973
							],
							[
								116.79735083300011,
								-20.628061509999952
							],
							[
								116.81228484100006,
								-20.61435549899994
							],
							[
								116.80817286000001,
								-20.60480348899995
							],
							[
								116.81862882900009,
								-20.60462150899997
							],
							[
								116.82323782900005,
								-20.596404487999962
							],
							[
								116.82360684800005,
								-20.58867450799994
							],
							[
								116.8147548290001,
								-20.58869649899998
							],
							[
								116.81911182800002,
								-20.580781498999954
							],
							[
								116.86736782100002,
								-20.525966495999967
							],
							[
								116.84908683200001,
								-20.521655496999927
							],
							[
								116.80874783600007,
								-20.529252508999946
							],
							[
								116.80400583700009,
								-20.54119948899995
							],
							[
								116.81488282600003,
								-20.538101498999936
							],
							[
								116.81274685700009,
								-20.549958498999956
							],
							[
								116.790020819,
								-20.55818949999997
							],
							[
								116.77789884100002,
								-20.57656450099995
							],
							[
								116.79842184900008,
								-20.56560350999996
							],
							[
								116.79932485900008,
								-20.57489150999993
							],
							[
								116.78638885100008,
								-20.58845649999995
							],
							[
								116.78157483100006,
								-20.58279251099998
							],
							[
								116.77060385200002,
								-20.588068500999952
							],
							[
								116.74636182600011,
								-20.620513512999935
							],
							[
								116.75052282700005,
								-20.632100501999957
							],
							[
								116.7645218560001,
								-20.63250850199995
							],
							[
								116.73994184800006,
								-20.641075502999968
							],
							[
								116.7216673900001,
								-20.637927323999975
							],
							[
								116.69436587400003,
								-20.68074050599995
							],
							[
								116.66806393700006,
								-20.68482546699994
							],
							[
								116.64248379000003,
								-20.704705478999927
							],
							[
								116.64494382100008,
								-20.714515528999982
							],
							[
								116.65283388000012,
								-20.708945417999928
							],
							[
								116.66680391900002,
								-20.711695366999948
							],
							[
								116.6539238800001,
								-20.709955407999928
							],
							[
								116.65023387000008,
								-20.71584552799993
							],
							[
								116.66122394900003,
								-20.713875427999938
							],
							[
								116.65660393000007,
								-20.717845507999982
							],
							[
								116.66671383900007,
								-20.722195486999965
							],
							[
								116.6875939570001,
								-20.712945155999932
							],
							[
								116.68889390600009,
								-20.705765175999943
							],
							[
								116.68475403800005,
								-20.723015145999966
							],
							[
								116.68263382700002,
								-20.714215235999973
							],
							[
								116.66638396000008,
								-20.72829547699996
							],
							[
								116.67394404900006,
								-20.726795366999966
							],
							[
								116.68586443900006,
								-20.73716513599993
							],
							[
								116.68476432900002,
								-20.75044504699997
							],
							[
								116.68273445900002,
								-20.744335126999943
							],
							[
								116.67814499000008,
								-20.748105186999965
							],
							[
								116.68373440900007,
								-20.738485126999933
							],
							[
								116.67322401900003,
								-20.727585356999953
							],
							[
								116.64208404100009,
								-20.721925598999974
							],
							[
								116.65585400100008,
								-20.73387566799994
							],
							[
								116.66352400000005,
								-20.73203548799995
							],
							[
								116.663784211,
								-20.741355547999945
							],
							[
								116.66295401000002,
								-20.733235517999958
							],
							[
								116.65214395100008,
								-20.735475787999974
							],
							[
								116.65757410100002,
								-20.740305657999954
							],
							[
								116.64703399200005,
								-20.74487580899995
							],
							[
								116.65364418200011,
								-20.749065667999957
							],
							[
								116.64703403200008,
								-20.746455798999932
							],
							[
								116.65404396100007,
								-20.73230568799994
							],
							[
								116.63960409200001,
								-20.72593565899996
							],
							[
								116.63364408300004,
								-20.734825848999947
							],
							[
								116.63954397200007,
								-20.736775928999975
							],
							[
								116.63993408300007,
								-20.75320600899994
							],
							[
								116.62977394400002,
								-20.75115614999993
							],
							[
								116.63811394300001,
								-20.73825594899995
							],
							[
								116.62991410300003,
								-20.732075768999948
							],
							[
								116.63612411200006,
								-20.72618567899997
							],
							[
								116.63063396200005,
								-20.710715578999952
							],
							[
								116.624044174,
								-20.734025759999952
							],
							[
								116.61609418400008,
								-20.729095789999974
							],
							[
								116.62309415300001,
								-20.715175629999976
							],
							[
								116.5917540160001,
								-20.73449648099995
							],
							[
								116.6052141560001,
								-20.75380611099996
							],
							[
								116.59756419700011,
								-20.74565605099997
							],
							[
								116.58740420800007,
								-20.75240618199996
							],
							[
								116.59450421700001,
								-20.744656060999944
							],
							[
								116.59021419700002,
								-20.740406061999977
							],
							[
								116.58135418800009,
								-20.74550618199993
							],
							[
								116.58307417800006,
								-20.751706191999972
							],
							[
								116.57919418800009,
								-20.745176171999958
							],
							[
								116.56058229000007,
								-20.746796572999926
							],
							[
								116.57833391800011,
								-20.741676491999954
							],
							[
								116.55337803000009,
								-20.746417513999972
							],
							[
								116.55186675100003,
								-20.754997473999936
							],
							[
								116.54978701100003,
								-20.74834756399997
							],
							[
								116.52591901300002,
								-20.75284748499996
							],
							[
								116.53210758300008,
								-20.767837344999975
							],
							[
								116.54242697300003,
								-20.76632735399994
							],
							[
								116.5421183630001,
								-20.77839714399994
							],
							[
								116.5402869830001,
								-20.76554736399993
							],
							[
								116.53151785400007,
								-20.76873733499997
							],
							[
								116.52413744400008,
								-20.758047424999972
							],
							[
								116.51340002500001,
								-20.771746485999927
							],
							[
								116.54446772400001,
								-20.79100722399994
							],
							[
								116.53579908400002,
								-20.785437084999955
							],
							[
								116.52783957500003,
								-20.791507174999936
							],
							[
								116.52773908500001,
								-20.782757154999956
							],
							[
								116.52117955500012,
								-20.778967154999975
							],
							[
								116.51823996600001,
								-20.78462722599994
							],
							[
								116.51378991600006,
								-20.778517545999932
							],
							[
								116.4892998790001,
								-20.79715738699997
							],
							[
								116.50065999800006,
								-20.79848755699993
							],
							[
								116.50228073800008,
								-20.80780750699995
							],
							[
								116.49243004900006,
								-20.799497566999946
							],
							[
								116.48316076000003,
								-20.80426752799997
							],
							[
								116.48816188,
								-20.815427546999956
							],
							[
								116.48054105000006,
								-20.807997497999963
							],
							[
								116.4668700520001,
								-20.81493747899998
							],
							[
								116.4644108230001,
								-20.82769744899997
							],
							[
								116.4810603410001,
								-20.826017407999927
							],
							[
								116.47439014200006,
								-20.83093738799994
							],
							[
								116.45946007300006,
								-20.82263747899998
							],
							[
								116.44241089500008,
								-20.824167579999937
							],
							[
								116.45317211500003,
								-20.840157569999974
							],
							[
								116.47772245300007,
								-20.85068754799994
							],
							[
								116.4852507920001,
								-20.84218747799997
							],
							[
								116.49487215200008,
								-20.850967426999944
							],
							[
								116.48526112200011,
								-20.843547487999956
							],
							[
								116.47761247300002,
								-20.85158755799995
							],
							[
								116.464251794,
								-20.840867508999963
							],
							[
								116.453801225,
								-20.844457598999952
							],
							[
								116.43978110500007,
								-20.82665757999996
							],
							[
								116.40018061900003,
								-20.830288061999966
							],
							[
								116.3990409380001,
								-20.822167991999947
							],
							[
								116.36692072200003,
								-20.841908503999946
							],
							[
								116.34540094400006,
								-20.838808644999972
							],
							[
								116.32904025700009,
								-20.867989145999957
							],
							[
								116.30264000000011,
								-20.876299677999953
							],
							[
								116.29591998100011,
								-20.881959827999935
							],
							[
								116.29950987100005,
								-20.88862983799993
							],
							[
								116.29734998000004,
								-20.877099747999978
							],
							[
								116.2860100910001,
								-20.881309888999965
							],
							[
								116.28930005100005,
								-20.87700985899994
							],
							[
								116.27245099200002,
								-20.86891948999994
							],
							[
								116.27147119200004,
								-20.87535952999997
							],
							[
								116.26260140300008,
								-20.86962959999994
							],
							[
								116.25558128400007,
								-20.88016977099994
							],
							[
								116.2595712430001,
								-20.86761962999998
							],
							[
								116.25298156300005,
								-20.866149580999945
							],
							[
								116.24135113500006,
								-20.876560050999956
							],
							[
								116.24673149400007,
								-20.865939770999944
							],
							[
								116.24144129400008,
								-20.865719920999936
							],
							[
								116.25618159300006,
								-20.85775954999997
							],
							[
								116.2363812540001,
								-20.860319930999935
							],
							[
								116.20459994500004,
								-20.833740562999935
							],
							[
								116.19104031000006,
								-20.888411263999956
							],
							[
								116.20702044900008,
								-20.88959095299998
							],
							[
								116.21403048800005,
								-20.879840712999965
							],
							[
								116.21014046800008,
								-20.888480872999935
							],
							[
								116.22675073700009,
								-20.88344048199997
							],
							[
								116.18975105100003,
								-20.901281533999963
							],
							[
								116.1881119950001,
								-20.96788251499993
							],
							[
								116.17683173700004,
								-20.977612514999976
							],
							[
								116.16454193700008,
								-20.968722655999954
							],
							[
								116.14031189100001,
								-20.991903526999977
							],
							[
								116.14615207200006,
								-21.01271332699997
							],
							[
								116.13046196200003,
								-20.997003457999938
							],
							[
								116.10323190500003,
								-21.00111389999995
							],
							[
								116.09553226700007,
								-21.024484189999953
							],
							[
								116.10647248700002,
								-21.039614179999944
							],
							[
								116.09891268800004,
								-21.051664389999928
							],
							[
								116.10563247700009,
								-21.03837417999995
							],
							[
								116.0937222770001,
								-21.024254239999948
							],
							[
								116.09710191500005,
								-21.00043396999996
							],
							[
								116.0694319590001,
								-21.017024551999953
							],
							[
								115.9893924370001,
								-21.040095795999946
							],
							[
								115.927672185,
								-21.077397679999933
							],
							[
								115.92379252600006,
								-21.095677729999977
							],
							[
								115.9169424260001,
								-21.09261780099996
							],
							[
								115.91192250800009,
								-21.101568020999935
							],
							[
								115.91501241700007,
								-21.092727830999934
							],
							[
								115.92343248600002,
								-21.093537649999973
							],
							[
								115.92574224500004,
								-21.077847319999933
							],
							[
								115.91816232600002,
								-21.07873744999995
							],
							[
								115.88935241000001,
								-21.11266834199995
							],
							[
								115.90099266000004,
								-21.126008671999955
							],
							[
								115.89404251000008,
								-21.117078421999963
							],
							[
								115.88151243100003,
								-21.121128372999976
							],
							[
								115.88755263200005,
								-21.138798641999927
							],
							[
								115.87799288300005,
								-21.135348592999947
							],
							[
								115.86905301400009,
								-21.151698533999934
							],
							[
								115.87655273500002,
								-21.16412851299998
							],
							[
								115.8700030650001,
								-21.15734837399998
							],
							[
								115.85456305700006,
								-21.176058573999967
							],
							[
								115.85703290900005,
								-21.201008393999928
							],
							[
								115.86535286700007,
								-21.19334839399994
							],
							[
								115.86040316900005,
								-21.204178573999968
							],
							[
								115.85221293900008,
								-21.202918404999934
							],
							[
								115.85644273800006,
								-21.194908243999976
							],
							[
								115.85031325900002,
								-21.19184811499997
							],
							[
								115.83354297100004,
								-21.205588545999944
							],
							[
								115.84488480100003,
								-21.227879564999967
							],
							[
								115.83892391200004,
								-21.22219958599993
							],
							[
								115.83097403200009,
								-21.225229515999956
							],
							[
								115.82925506400011,
								-21.239789535999932
							],
							[
								115.81935454500001,
								-21.247439766999946
							],
							[
								115.83668580400001,
								-21.25324027599993
							],
							[
								115.8398453530001,
								-21.243870215999948
							],
							[
								115.8443962130001,
								-21.25291049499998
							],
							[
								115.80887408600006,
								-21.24888946699997
							],
							[
								115.81666519600003,
								-21.26560972699997
							],
							[
								115.8046637760001,
								-21.245829527999945
							],
							[
								115.79190395700005,
								-21.24647959799995
							],
							[
								115.78755410800011,
								-21.25154957899997
							],
							[
								115.79906412800005,
								-21.270319437999945
							],
							[
								115.79615412900012,
								-21.277189487999976
							],
							[
								115.79607382800009,
								-21.262069407999945
							],
							[
								115.78787413900011,
								-21.265659418999974
							],
							[
								115.77928431100008,
								-21.28853960899994
							],
							[
								115.78380358900006,
								-21.256729338999946
							],
							[
								115.76743403000012,
								-21.254099549999978
							],
							[
								115.76931386100011,
								-21.268329449999953
							],
							[
								115.77702390000002,
								-21.267669428999966
							],
							[
								115.76173376100007,
								-21.26807944999996
							],
							[
								115.77035414200009,
								-21.28458958999994
							],
							[
								115.76232385100002,
								-21.271809469999937
							],
							[
								115.75262394300012,
								-21.283999580999932
							],
							[
								115.75906382200003,
								-21.27202946999995
							],
							[
								115.75635398100007,
								-21.25384951999996
							],
							[
								115.74411389300008,
								-21.277299550999942
							],
							[
								115.74859405400002,
								-21.28941962099998
							],
							[
								115.7387140840001,
								-21.28546961199993
							],
							[
								115.74748394300002,
								-21.28023957099998
							],
							[
								115.73798390400009,
								-21.27490953199998
							],
							[
								115.73586412500003,
								-21.283819601999937
							],
							[
								115.71997458600003,
								-21.288709922999942
							],
							[
								115.71629403600002,
								-21.276659672999926
							],
							[
								115.70510514800003,
								-21.299559753999972
							],
							[
								115.70937483800003,
								-21.293909722999956
							],
							[
								115.7031543270001,
								-21.279449623999938
							],
							[
								115.67895611100005,
								-21.309970574999966
							],
							[
								115.68323581100003,
								-21.319300604999967
							],
							[
								115.65255591400012,
								-21.315640566999946
							],
							[
								115.64839612500009,
								-21.33166052699994
							],
							[
								115.66827643400006,
								-21.33375034599993
							],
							[
								115.64970636600003,
								-21.336630556999978
							],
							[
								115.66221666500007,
								-21.34220047599996
							],
							[
								115.64873630600005,
								-21.337420576999932
							],
							[
								115.65292679600009,
								-21.34635058699996
							],
							[
								115.64033604600002,
								-21.327120607999973
							],
							[
								115.61809382900003,
								-21.34567059899996
							],
							[
								115.62746424900001,
								-21.35473082799996
							],
							[
								115.63742542700004,
								-21.34554070799993
							],
							[
								115.62796400900004,
								-21.36317087799995
							],
							[
								115.62108375900004,
								-21.351660858999935
							],
							[
								115.60877261000007,
								-21.35625106899994
							],
							[
								115.61920336000003,
								-21.36684097899996
							],
							[
								115.61797316100001,
								-21.377331038999955
							],
							[
								115.60502245100008,
								-21.36109104999997
							],
							[
								115.588793054,
								-21.37988158099995
							],
							[
								115.59574302400006,
								-21.38950133999998
							],
							[
								115.60217267300004,
								-21.37937119999998
							],
							[
								115.60904292200007,
								-21.382031149999932
							],
							[
								115.59308312400003,
								-21.391641360999927
							],
							[
								115.59747436500004,
								-21.41084141999994
							],
							[
								115.59270326500007,
								-21.397851410999976
							],
							[
								115.5857939660001,
								-21.406171520999976
							],
							[
								115.58087368600002,
								-21.401871550999942
							],
							[
								115.59101324500011,
								-21.397391420999952
							],
							[
								115.58359286400002,
								-21.384831590999966
							],
							[
								115.5509239490001,
								-21.413051622999944
							],
							[
								115.55076484000006,
								-21.42286198299996
							],
							[
								115.5575346390001,
								-21.418151922999982
							],
							[
								115.55243487000007,
								-21.42716199299997
							],
							[
								115.56216569000003,
								-21.43589192299993
							],
							[
								115.57270539800004,
								-21.427531811999927
							],
							[
								115.56335581000008,
								-21.43894192299996
							],
							[
								115.57163689000004,
								-21.448791881999966
							],
							[
								115.5610658700001,
								-21.438821952999945
							],
							[
								115.56545679100009,
								-21.457242072999975
							],
							[
								115.55865567000001,
								-21.43768202299998
							],
							[
								115.54926542100009,
								-21.43471210299998
							],
							[
								115.53487588300004,
								-21.443462273999955
							],
							[
								115.54069563200005,
								-21.43750220399994
							],
							[
								115.5333462420001,
								-21.43578210399994
							],
							[
								115.5185858640001,
								-21.446562574999973
							],
							[
								115.5181570950001,
								-21.46145254499993
							],
							[
								115.51697595500002,
								-21.454682554999977
							],
							[
								115.50972589600008,
								-21.45792255599997
							],
							[
								115.50627711700008,
								-21.47439273599997
							],
							[
								115.52636653400009,
								-21.459452474999978
							],
							[
								115.50843711700008,
								-21.475982775999967
							],
							[
								115.51529725700004,
								-21.48119268599993
							],
							[
								115.52827672500007,
								-21.464772454999945
							],
							[
								115.51648744700003,
								-21.483462764999956
							],
							[
								115.50662704700005,
								-21.477322785999945
							],
							[
								115.50575728800004,
								-21.48330283599995
							],
							[
								115.49275693900006,
								-21.485752556999955
							],
							[
								115.49256688000003,
								-21.49242361699993
							],
							[
								115.5089681180001,
								-21.493362585999932
							],
							[
								115.49761694900008,
								-21.490012606999983
							],
							[
								115.49113696000006,
								-21.495483536999927
							],
							[
								115.4951675100001,
								-21.501443146999975
							],
							[
								115.50134764900008,
								-21.498122965999983
							],
							[
								115.50663784900007,
								-21.50136296599993
							],
							[
								115.49941768000008,
								-21.50469312699994
							],
							[
								115.52031819800004,
								-21.509162894999974
							],
							[
								115.5108786400001,
								-21.524833335999972
							],
							[
								115.51070799900003,
								-21.50951308599997
							],
							[
								115.49993787000005,
								-21.508863196999982
							],
							[
								115.49373831100002,
								-21.518963436999968
							],
							[
								115.49324907200003,
								-21.534323746999974
							],
							[
								115.50826936100009,
								-21.539523575999965
							],
							[
								115.49952926200001,
								-21.533833606999963
							],
							[
								115.49243979300002,
								-21.545793966999952
							],
							[
								115.4914692530001,
								-21.537383836999936
							],
							[
								115.47728849300006,
								-21.530023997999933
							],
							[
								115.47558967500004,
								-21.547174307999967
							],
							[
								115.47617824300005,
								-21.527093967999974
							],
							[
								115.46775710300005,
								-21.514723817999936
							],
							[
								115.46039837500007,
								-21.53171428899998
							],
							[
								115.46387956600006,
								-21.547214528999973
							],
							[
								115.45906817500008,
								-21.53104432899994
							],
							[
								115.44507819600005,
								-21.53282461999993
							],
							[
								115.45635881600003,
								-21.539764528999967
							],
							[
								115.45569965700008,
								-21.54846472899993
							],
							[
								115.45526874600012,
								-21.53988456899998
							],
							[
								115.44350825700008,
								-21.532834609999952
							],
							[
								115.45867791500007,
								-21.527544218999935
							],
							[
								115.4573265040001,
								-21.508463878999976
							],
							[
								115.43817845700005,
								-21.529594609999947
							],
							[
								115.43956877700009,
								-21.538174769999955
							],
							[
								115.44885857600002,
								-21.53777460999993
							],
							[
								115.44653910700004,
								-21.54377482999996
							],
							[
								115.44377861700002,
								-21.535884709999948
							],
							[
								115.43532904800009,
								-21.542004990999942
							],
							[
								115.43660848700006,
								-21.530174659999943
							],
							[
								115.42814920900003,
								-21.545355230999974
							],
							[
								115.4333483370001,
								-21.529174660999956
							],
							[
								115.41291903900003,
								-21.52478456199998
							],
							[
								115.40810909900006,
								-21.52786462199998
							],
							[
								115.41634911900007,
								-21.532554611999956
							],
							[
								115.40472906000002,
								-21.528224541999975
							],
							[
								115.38117897300003,
								-21.543275603999973
							],
							[
								115.38470873300002,
								-21.547205993999967
							],
							[
								115.41416897900001,
								-21.534675101999937
							],
							[
								115.41830895900011,
								-21.539865221999946
							],
							[
								115.4014588010001,
								-21.546995752999976
							],
							[
								115.39912890200003,
								-21.556045972999982
							],
							[
								115.3816991330001,
								-21.548126603999947
							],
							[
								115.33117816900005,
								-21.57597656699994
							],
							[
								115.32761742000002,
								-21.585256736999952
							],
							[
								115.34163761000002,
								-21.59597681599996
							],
							[
								115.33384720100003,
								-21.596066916999973
							],
							[
								115.32722752000006,
								-21.580286746999946
							],
							[
								115.29821696400006,
								-21.59411758899995
							],
							[
								115.24468712800001,
								-21.588187581999932
							],
							[
								115.24595721800006,
								-21.595877551999934
							],
							[
								115.24311714800001,
								-21.587057551999976
							],
							[
								115.25215710700002,
								-21.584987551999973
							],
							[
								115.24232695700005,
								-21.576787571999944
							],
							[
								115.22998686000005,
								-21.592547552999974
							],
							[
								115.23442711900009,
								-21.59620757299996
							],
							[
								115.21978591100003,
								-21.60253755399998
							],
							[
								115.21986621200006,
								-21.616197563999947
							],
							[
								115.21105592200001,
								-21.597727593999934
							],
							[
								115.18687580500011,
								-21.612407865999955
							],
							[
								115.21014586400008,
								-21.62787822399997
							],
							[
								115.20445566400008,
								-21.62497815499995
							],
							[
								115.20545576400002,
								-21.630958204999956
							],
							[
								115.19379569500006,
								-21.620278004999932
							],
							[
								115.19493584500003,
								-21.628298164999933
							],
							[
								115.18602619500007,
								-21.61229760599997
							],
							[
								115.17853602500008,
								-21.611317605999943
							],
							[
								115.16158604800012,
								-21.625058446999958
							],
							[
								115.17659597700003,
								-21.63659824599995
							],
							[
								115.16062606800006,
								-21.62619802699993
							],
							[
								115.14717611000003,
								-21.640598557999965
							],
							[
								115.13221593200001,
								-21.64483864899995
							],
							[
								115.14219619200003,
								-21.659028217999946
							],
							[
								115.13348602200006,
								-21.65511825899995
							],
							[
								115.13169609300007,
								-21.65982822899997
							],
							[
								115.1303230420001,
								-21.642021598999975
							],
							[
								115.10881906300006,
								-21.631554609999966
							],
							[
								115.05712606100008,
								-21.675868573999935
							],
							[
								115.0559661210001,
								-21.686038923999945
							],
							[
								115.05471622100004,
								-21.67756859399998
							],
							[
								115.03070604400011,
								-21.68511958499994
							],
							[
								115.04374629200004,
								-21.682469003999927
							],
							[
								115.03711617300007,
								-21.68486911499997
							],
							[
								115.0404062130001,
								-21.692199074999962
							],
							[
								115.0346370630001,
								-21.68614861499998
							],
							[
								115.0278562740001,
								-21.694869294999933
							],
							[
								115.02613617400004,
								-21.68817922599993
							],
							[
								115.016726145,
								-21.692849335999938
							],
							[
								115.02901616400004,
								-21.684669594999946
							],
							[
								114.98405579700011,
								-21.67952959799993
							],
							[
								114.97472563800011,
								-21.67153966899997
							],
							[
								114.96797565800011,
								-21.675399768999966
							],
							[
								114.97382601800007,
								-21.681779698999947
							],
							[
								114.96628580900006,
								-21.677219738999952
							],
							[
								114.95870604000004,
								-21.683679939999934
							],
							[
								114.9703261090001,
								-21.68939980899995
							],
							[
								114.96305589000008,
								-21.684569868999972
							],
							[
								114.96299614000009,
								-21.692599938999933
							],
							[
								114.95835575000001,
								-21.686159999999973
							],
							[
								114.94520604200011,
								-21.690380089999962
							],
							[
								114.97230575800006,
								-21.670759628999974
							],
							[
								114.9883862370001,
								-21.673979577999944
							],
							[
								114.97314598800006,
								-21.66962959899996
							],
							[
								114.93614590200002,
								-21.69075062099995
							],
							[
								114.91426620400011,
								-21.68833060199995
							],
							[
								114.90345610600002,
								-21.705300652999938
							],
							[
								114.85896623200006,
								-21.73264165599994
							],
							[
								114.86091598200005,
								-21.73803157599997
							],
							[
								114.85716623200005,
								-21.734451665999927
							],
							[
								114.842106005,
								-21.751091576999954
							],
							[
								114.82484613700001,
								-21.755761587999928
							],
							[
								114.7784061430001,
								-21.79053264099997
							],
							[
								114.73769590800009,
								-21.80100260399996
							],
							[
								114.72089615900006,
								-21.798772604999954
							],
							[
								114.69880622200003,
								-21.81371259599996
							],
							[
								114.683366535,
								-21.828983086999983
							],
							[
								114.69339651400003,
								-21.830802965999965
							],
							[
								114.69765672400001,
								-21.843073105999963
							],
							[
								114.68525687700003,
								-21.86781349699993
							],
							[
								114.69317653400003,
								-21.839353056999983
							],
							[
								114.68614645500008,
								-21.832933096999966
							],
							[
								114.67549622500007,
								-21.827642607999962
							],
							[
								114.64808618900008,
								-21.84450365899994
							],
							[
								114.64251698400005,
								-21.90931465999995
							],
							[
								114.64760706400011,
								-21.919914769999934
							],
							[
								114.66430708200005,
								-21.91052433899995
							],
							[
								114.65164728400009,
								-21.92250478899996
							],
							[
								114.63937707500008,
								-21.91733464999993
							],
							[
								114.62150704800001,
								-21.935865640999964
							],
							[
								114.61933766900006,
								-21.94476574199996
							],
							[
								114.63713751700004,
								-21.944565480999927
							],
							[
								114.61522827900001,
								-21.947615601999928
							],
							[
								114.62615788000005,
								-21.973566190999975
							],
							[
								114.61331776000009,
								-21.961165901999948
							],
							[
								114.61575819100005,
								-21.976176641999928
							],
							[
								114.60487827300005,
								-21.987476682999954
							],
							[
								114.60591830400006,
								-22.00684703299993
							],
							[
								114.60136828300006,
								-21.98770663299996
							],
							[
								114.58657841600007,
								-22.003797283999972
							],
							[
								114.58938854700011,
								-22.01946754399995
							],
							[
								114.5850385550001,
								-21.99686704399994
							],
							[
								114.5706080970001,
								-22.001767594999933
							],
							[
								114.57544828800008,
								-22.015767634999975
							],
							[
								114.56419862900009,
								-22.02682819499995
							],
							[
								114.57436866,
								-22.04364847499994
							],
							[
								114.55898802900003,
								-22.020287635999978
							],
							[
								114.54785896300007,
								-22.052119636999976
							],
							[
								114.55160908300002,
								-22.066449615999943
							],
							[
								114.54252916400003,
								-22.060809586999937
							],
							[
								114.54531915400003,
								-22.064869676999933
							],
							[
								114.51734898600012,
								-22.066450608999958
							],
							[
								114.52024912700006,
								-22.08270063799995
							],
							[
								114.53574929600006,
								-22.078750636999928
							],
							[
								114.52315901800011,
								-22.09342063799994
							],
							[
								114.52581906800003,
								-22.10031067799997
							],
							[
								114.53139907700006,
								-22.095330607999927
							],
							[
								114.52775911800006,
								-22.10178065799994
							],
							[
								114.51806898900008,
								-22.10584162899994
							],
							[
								114.52848952000011,
								-22.129771817999938
							],
							[
								114.52633960100002,
								-22.14156227799998
							],
							[
								114.5193993800001,
								-22.123221658999967
							],
							[
								114.51612930100009,
								-22.12796164899993
							],
							[
								114.50486920200001,
								-22.123552639999957
							],
							[
								114.50135020200003,
								-22.129872629999966
							],
							[
								114.51490999300006,
								-22.156632678999927
							],
							[
								114.5069201440001,
								-22.15290262999997
							],
							[
								114.50583003400004,
								-22.158203619999938
							],
							[
								114.50086026400004,
								-22.150303599999972
							],
							[
								114.50800050600003,
								-22.18349380999996
							],
							[
								114.49953005500004,
								-22.162943489999975
							],
							[
								114.49070034600004,
								-22.17104393099993
							],
							[
								114.4894702250001,
								-22.157633660999977
							],
							[
								114.45567016900009,
								-22.159534642999972
							],
							[
								114.45361028900004,
								-22.166084662999936
							],
							[
								114.48183029800009,
								-22.18821467099997
							],
							[
								114.49019021700008,
								-22.185964670999965
							],
							[
								114.4717701290001,
								-22.190354611999965
							],
							[
								114.5004707390001,
								-22.220484539999973
							],
							[
								114.48900043000003,
								-22.21910429099995
							],
							[
								114.47843011000009,
								-22.204804641999942
							],
							[
								114.46643022100011,
								-22.204234671999927
							],
							[
								114.46933004200002,
								-22.21793367199996
							],
							[
								114.45321032200002,
								-22.207954642999937
							],
							[
								114.45223012400004,
								-22.235031942999967
							],
							[
								114.48188034300006,
								-22.25148323199994
							],
							[
								114.44398028600006,
								-22.242031623999935
							],
							[
								114.44870024600004,
								-22.253540633999933
							],
							[
								114.47258011500003,
								-22.264392661999977
							],
							[
								114.45039004600005,
								-22.25964164399994
							],
							[
								114.46094022600005,
								-22.27188263299996
							],
							[
								114.43984026800001,
								-22.26493166399996
							],
							[
								114.42976999900009,
								-22.27542260499996
							],
							[
								114.43726991000005,
								-22.289313014999948
							],
							[
								114.46139994800001,
								-22.292602882999972
							],
							[
								114.44902965900008,
								-22.300043183999946
							],
							[
								114.46088982000003,
								-22.32928302299996
							],
							[
								114.44695963000004,
								-22.304213173999983
							],
							[
								114.4336302700001,
								-22.294953444999976
							],
							[
								114.43968953100011,
								-22.30398364499996
							],
							[
								114.42306954200001,
								-22.300583545999928
							],
							[
								114.416520203,
								-22.310513605999972
							],
							[
								114.42645007300007,
								-22.319773614999974
							],
							[
								114.41469031400004,
								-22.31615362599996
							],
							[
								114.40873015500006,
								-22.331153676999975
							],
							[
								114.42314974500005,
								-22.34595352599996
							],
							[
								114.4432896730001,
								-22.34292318499996
							],
							[
								114.4309097150001,
								-22.351713384999982
							],
							[
								114.45164970400003,
								-22.36256306399997
							],
							[
								114.43660969500002,
								-22.357133274999967
							],
							[
								114.44569969400004,
								-22.36369313399996
							],
							[
								114.44083968500001,
								-22.367523224999957
							],
							[
								114.42302976600001,
								-22.351483505999965
							],
							[
								114.4070100670001,
								-22.35090362699998
							],
							[
								114.40881973800003,
								-22.362073686999963
							],
							[
								114.41702974700002,
								-22.36351355599993
							],
							[
								114.4012999680001,
								-22.359583826999938
							],
							[
								114.39641963000008,
								-22.382943607999948
							],
							[
								114.42333968900004,
								-22.395723355999962
							],
							[
								114.39337958100009,
								-22.390953587999945
							],
							[
								114.39481958200008,
								-22.401673527999947
							],
							[
								114.40209957100001,
								-22.40303347699995
							],
							[
								114.3904490320001,
								-22.40257362799997
							],
							[
								114.39237032300002,
								-22.42153364799998
							],
							[
								114.4078897930001,
								-22.429223426999954
							],
							[
								114.38605016400004,
								-22.426603628999942
							],
							[
								114.38627982500009,
								-22.43405361899994
							],
							[
								114.40530986300007,
								-22.438933436999946
							],
							[
								114.39173985500008,
								-22.439023547999966
							],
							[
								114.39298991500004,
								-22.446243527999968
							],
							[
								114.38821987500012,
								-22.439013597999974
							],
							[
								114.38032006600008,
								-22.441263618999983
							],
							[
								114.3900101260001,
								-22.461023427999976
							],
							[
								114.403840306,
								-22.469393667999952
							],
							[
								114.3835701370001,
								-22.46474363899995
							],
							[
								114.37712029900001,
								-22.47613358899997
							],
							[
								114.38609024900006,
								-22.484603148999952
							],
							[
								114.37262021000004,
								-22.483013269999958
							],
							[
								114.38378030900003,
								-22.490773098999966
							],
							[
								114.36459021100006,
								-22.490333609999936
							],
							[
								114.37709037000002,
								-22.498133028999973
							],
							[
								114.36786039100002,
								-22.500153059999946
							],
							[
								114.36277007100011,
								-22.49281364999996
							],
							[
								114.35875043200008,
								-22.503883090999977
							],
							[
								114.35766021200004,
								-22.494273630999942
							],
							[
								114.35486037300007,
								-22.50059312099995
							],
							[
								114.34504034300005,
								-22.490193380999983
							],
							[
								114.34033056500004,
								-22.516293391999966
							],
							[
								114.33897035300004,
								-22.492103431999965
							],
							[
								114.32719020400009,
								-22.489713602999927
							],
							[
								114.3240502540001,
								-22.47955368299995
							],
							[
								114.32280034600001,
								-22.50369367299993
							],
							[
								114.31744992200004,
								-22.44060362299996
							],
							[
								114.28237973400007,
								-22.433773084999928
							],
							[
								114.26197995700011,
								-22.440612965999946
							],
							[
								114.24117982000007,
								-22.459193917999983
							],
							[
								114.225640311,
								-22.457354648999967
							],
							[
								114.23070012200003,
								-22.47327465899997
							],
							[
								114.21622013400008,
								-22.48599485999995
							],
							[
								114.21862023500012,
								-22.49717512899997
							],
							[
								114.18881049900006,
								-22.520795670999973
							],
							[
								114.16074029200001,
								-22.523765812999955
							],
							[
								114.16181047300006,
								-22.53403590299996
							],
							[
								114.15105016300004,
								-22.517085813999927
							],
							[
								114.14382039500003,
								-22.538046013999974
							],
							[
								114.14886016300011,
								-22.518545853999967
							],
							[
								114.14392003300009,
								-22.50668581399998
							],
							[
								114.13550996300012,
								-22.50055584499995
							],
							[
								114.12522006500001,
								-22.511636004999957
							],
							[
								114.13859990200001,
								-22.49752574499996
							],
							[
								114.12180910200004,
								-22.47265465499993
							],
							[
								114.12833916900001,
								-22.44164262499993
							],
							[
								114.12210886800005,
								-22.415793004999955
							],
							[
								114.12819878700009,
								-22.407792644999972
							],
							[
								114.14093914600005,
								-22.409181623999928
							],
							[
								114.14704833400003,
								-22.39679167299994
							],
							[
								114.12992818600003,
								-22.39990270499993
							],
							[
								114.140128075,
								-22.39801170399994
							],
							[
								114.13552834500001,
								-22.393151633999935
							],
							[
								114.14584810400004,
								-22.390241653999965
							],
							[
								114.15962827100009,
								-22.366920292999964
							],
							[
								114.1782281180001,
								-22.35342892099993
							],
							[
								114.17847803500001,
								-22.30536084099998
							],
							[
								114.14950823700008,
								-22.30144962299994
							],
							[
								114.13271799000006,
								-22.31980101399995
							],
							[
								114.12469810100004,
								-22.324401704999957
							],
							[
								114.12204809100001,
								-22.319431704999943
							],
							[
								114.11582809200002,
								-22.331142704999934
							],
							[
								114.11708807100001,
								-22.31490166499998
							],
							[
								114.12642802000005,
								-22.31391137399993
							],
							[
								114.12374770800011,
								-22.27926137399993
							],
							[
								114.1330173560001,
								-22.261570673999927
							],
							[
								114.08476672500001,
								-22.19126199599998
							],
							[
								114.08027587200002,
								-22.154121656999962
							],
							[
								114.13199175400007,
								-21.97201923199998
							],
							[
								114.13840794300006,
								-21.95601419199994
							],
							[
								114.14397557200004,
								-21.958077120999974
							],
							[
								114.13874403000011,
								-21.92519882199997
							],
							[
								114.1488835450001,
								-21.86663822099996
							],
							[
								114.19102391800004,
								-21.814567247999946
							],
							[
								114.1612248880001,
								-21.786197449999975
							],
							[
								114.1315824720001,
								-21.80555794199995
							],
							[
								114.1080301940001,
								-21.803258202999928
							],
							[
								114.07875916800003,
								-21.815948614999968
							],
							[
								114.07208922900008,
								-21.827558754999927
							],
							[
								114.02393252500008,
								-21.851139358999944
							],
							[
								113.9950945700001,
								-21.87544976099997
							],
							[
								113.96395518700001,
								-21.93799070299997
							],
							[
								113.93360613200002,
								-21.973211554999978
							],
							[
								113.93325577400003,
								-21.998871744999974
							],
							[
								113.88622692600006,
								-22.09829321899997
							],
							[
								113.81620943900009,
								-22.315695793999964
							],
							[
								113.78031994600008,
								-22.376746756999978
							],
							[
								113.7654800680001,
								-22.38433695799995
							],
							[
								113.74939025200001,
								-22.408407738999983
							],
							[
								113.73775105800007,
								-22.47101766999998
							],
							[
								113.72299108100003,
								-22.496198670999945
							],
							[
								113.7079312620001,
								-22.496688681999956
							],
							[
								113.71377148300007,
								-22.517948711999964
							],
							[
								113.69314182700009,
								-22.54093916399995
							],
							[
								113.66531222000003,
								-22.55010967499993
							],
							[
								113.65409223300003,
								-22.578759815999945
							],
							[
								113.67362240300008,
								-22.596849814999928
							],
							[
								113.66827270600004,
								-22.628710085999955
							],
							[
								113.68643310700008,
								-22.664400264999983
							],
							[
								113.67102335100003,
								-22.69895070599995
							],
							[
								113.67050348200007,
								-22.71712092599995
							],
							[
								113.67713320200005,
								-22.723030724999944
							],
							[
								113.70940357900008,
								-22.715270532999966
							],
							[
								113.75526436700011,
								-22.756210659999965
							],
							[
								113.79381461000003,
								-22.84265090799994
							],
							[
								113.8011947330001,
								-22.886791237999944
							],
							[
								113.81666525300011,
								-22.906921686999965
							],
							[
								113.82619518600006,
								-22.956002646999934
							],
							[
								113.81976527800009,
								-22.977042986999948
							],
							[
								113.82949544900009,
								-22.99487360699993
							],
							[
								113.82943625100006,
								-23.030894716999967
							],
							[
								113.81250543700003,
								-23.08275570799998
							],
							[
								113.78967538100005,
								-23.106726739999942
							],
							[
								113.76048524500004,
								-23.12128674199994
							],
							[
								113.77086536400009,
								-23.130636670999934
							],
							[
								113.76383638900006,
								-23.17775771199996
							],
							[
								113.77444627900002,
								-23.194547730999943
							],
							[
								113.770386271,
								-23.21782791199996
							],
							[
								113.794457265,
								-23.296038530999965
							],
							[
								113.7881183510001,
								-23.36513968099996
							],
							[
								113.77694829300003,
								-23.378920661999928
							],
							[
								113.78347847500004,
								-23.41606113199998
							],
							[
								113.77812940000001,
								-23.47804210299995
							],
							[
								113.75326998700007,
								-23.528222983999967
							],
							[
								113.72588025000005,
								-23.54499362599995
							],
							[
								113.7004803750001,
								-23.57518771799994
							],
							[
								113.65086834200008,
								-23.59957315099996
							],
							[
								113.63620111500006,
								-23.618907941999964
							],
							[
								113.61322319800001,
								-23.63089466399998
							],
							[
								113.61416347900001,
								-23.64667424399994
							],
							[
								113.59662431200002,
								-23.66334470499993
							],
							[
								113.5917052850001,
								-23.69892468599994
							],
							[
								113.56728650200012,
								-23.75221574799997
							],
							[
								113.55496633400003,
								-23.765545798999938
							],
							[
								113.54023642600009,
								-23.764125958999955
							],
							[
								113.5269967480001,
								-23.78333600999997
							],
							[
								113.51383755500001,
								-23.847316681999928
							],
							[
								113.47031876300002,
								-23.898547864999955
							],
							[
								113.46500943600006,
								-23.925558724999973
							],
							[
								113.47091977800005,
								-23.966438594999943
							],
							[
								113.45871064300002,
								-24.013629175999938
							],
							[
								113.44695151600001,
								-24.03215967699998
							],
							[
								113.43000127800008,
								-24.032639737999943
							],
							[
								113.42216155900007,
								-24.042919728999948
							],
							[
								113.42813252200006,
								-24.080719717999955
							],
							[
								113.41943238300007,
								-24.090319738999938
							],
							[
								113.44239252500006,
								-24.13677029799993
							],
							[
								113.4433533880001,
								-24.18168058799995
							],
							[
								113.40912526500006,
								-24.223491749999937
							],
							[
								113.39017556700003,
								-24.22398173199997
							],
							[
								113.40620651100005,
								-24.303051970999945
							],
							[
								113.39953845100001,
								-24.411392681999928
							],
							[
								113.40696872600006,
								-24.484162951999963
							],
							[
								113.41918884500001,
								-24.491693060999978
							],
							[
								113.42762929600008,
								-24.515602679999972
							],
							[
								113.44927941600008,
								-24.542863228999977
							],
							[
								113.48994939400006,
								-24.575943336999956
							],
							[
								113.6232525040001,
								-24.74602053899997
							],
							[
								113.63273348700011,
								-24.797430747999954
							],
							[
								113.62022352200006,
								-24.849711748999937
							],
							[
								113.62089355100011,
								-24.831771188999937
							],
							[
								113.61587367300001,
								-24.844531359999962
							],
							[
								113.6175438030001,
								-24.858631469999978
							],
							[
								113.64699386100006,
								-24.864501307999944
							],
							[
								113.6764736670001,
								-24.848710985999958
							],
							[
								113.70689962400002,
								-24.850693313999955
							],
							[
								113.66614383900003,
								-24.861951155999975
							],
							[
								113.64421599200011,
								-24.879061457999967
							],
							[
								113.65520004100006,
								-24.882149826999978
							],
							[
								113.64690418400005,
								-24.89914161799993
							],
							[
								113.65037710400009,
								-24.906801987999927
							],
							[
								113.6514741630001,
								-24.897651587999974
							],
							[
								113.65236425300009,
								-24.90510166799993
							],
							[
								113.6651559710001,
								-24.89587784699995
							],
							[
								113.67781449200004,
								-24.924971725999967
							],
							[
								113.69193445100007,
								-24.928521684999964
							],
							[
								113.67417457400006,
								-24.939421685999946
							],
							[
								113.66217432700012,
								-24.966662696999947
							],
							[
								113.6646453410001,
								-25.01817266699993
							],
							[
								113.67425626200009,
								-25.043012746999977
							],
							[
								113.69771638300006,
								-25.08658274499993
							],
							[
								113.72468758200012,
								-25.115493713999967
							],
							[
								113.7696375490001,
								-25.136292700999945
							],
							[
								113.81707729700008,
								-25.17355269799998
							],
							[
								113.83962728800009,
								-25.21698364699995
							],
							[
								113.84816833000002,
								-25.256913675999954
							],
							[
								113.84209834100011,
								-25.255893706999927
							],
							[
								113.8425883220001,
								-25.264583656999946
							],
							[
								113.87148949100003,
								-25.29030368499997
							],
							[
								113.8649194510001,
								-25.28759369599993
							],
							[
								113.86863935200006,
								-25.299323654999966
							],
							[
								113.8567294720001,
								-25.292443685999956
							],
							[
								113.89134961200011,
								-25.33699370399995
							],
							[
								113.89669957300009,
								-25.35740371399993
							],
							[
								113.89111955500005,
								-25.372974703999944
							],
							[
								113.91385029500009,
								-25.40093473299993
							],
							[
								113.9081403460001,
								-25.406694732999938
							],
							[
								113.9136105660001,
								-25.413454722999973
							],
							[
								113.90206032700007,
								-25.410074683999937
							],
							[
								113.944189316,
								-25.45866468099996
							],
							[
								113.94843156700006,
								-25.47715466099993
							],
							[
								113.94122040700006,
								-25.473214711999958
							],
							[
								113.93974150800011,
								-25.480214651999972
							],
							[
								113.93923031700001,
								-25.470624691999944
							],
							[
								113.93402038800002,
								-25.475474711999937
							],
							[
								113.9545335680001,
								-25.493394700999943
							],
							[
								113.99165026900005,
								-25.56486666899997
							],
							[
								113.99167046000002,
								-25.575126658999977
							],
							[
								113.9822013700001,
								-25.560815668999965
							],
							[
								113.9901994710001,
								-25.589906638999935
							],
							[
								113.99679937100007,
								-25.599026718999937
							],
							[
								113.99690952000003,
								-25.59057669899994
							],
							[
								114.01526953100006,
								-25.61686471699994
							],
							[
								113.99954041100011,
								-25.60218669799997
							],
							[
								114.00033132100009,
								-25.60718673799994
							],
							[
								114.01537031100008,
								-25.620474686999955
							],
							[
								114.00419339200005,
								-25.618505677999963
							],
							[
								114.01966045100005,
								-25.632333726999946
							],
							[
								114.01920938100011,
								-25.62410366699993
							],
							[
								114.04843741100001,
								-25.66731069599996
							],
							[
								114.03539928200007,
								-25.662511725999934
							],
							[
								114.09110134800005,
								-25.696358722999946
							],
							[
								114.11956546800002,
								-25.728171660999976
							],
							[
								114.1135963380001,
								-25.725441691999947
							],
							[
								114.12225540800011,
								-25.735961690999943
							],
							[
								114.11412442000005,
								-25.743151721999936
							],
							[
								114.11941429000001,
								-25.75524267199995
							],
							[
								114.14631456900008,
								-25.780155659999934
							],
							[
								114.13253447000011,
								-25.77232466099997
							],
							[
								114.13449434000006,
								-25.778085660999977
							],
							[
								114.17210531800004,
								-25.806426657999964
							],
							[
								114.17555555800004,
								-25.812636657999974
							],
							[
								114.16796530900001,
								-25.811256688999947
							],
							[
								114.19875539800012,
								-25.835616716999937
							],
							[
								114.2054053280001,
								-25.853006696999955
							],
							[
								114.22705537600007,
								-25.86198672499995
							],
							[
								114.2321054470001,
								-25.875656634999928
							],
							[
								114.26684544400007,
								-25.88772671299995
							],
							[
								114.24704650000001,
								-25.93648772399996
							],
							[
								114.252877452,
								-25.972937643999956
							],
							[
								114.2575776320001,
								-25.98332768399996
							],
							[
								114.2653176010001,
								-25.982117632999973
							],
							[
								114.2450575150001,
								-25.99253765499998
							],
							[
								114.2236173760001,
								-25.98738767599997
							],
							[
								114.22567729500008,
								-25.973637665999945
							],
							[
								114.21845748600003,
								-25.968877645999953
							],
							[
								114.19467733900001,
								-25.98355764799993
							],
							[
								114.20915762100003,
								-26.031598646999953
							],
							[
								114.23928855100007,
								-26.072688674999938
							],
							[
								114.23602946500012,
								-26.117768705999936
							],
							[
								114.25471958500009,
								-26.144878674999973
							],
							[
								114.25384946600002,
								-26.15535863499997
							],
							[
								114.24134952800011,
								-26.16584966599993
							],
							[
								114.22535943000003,
								-26.16502967699995
							],
							[
								114.21990939900002,
								-26.13949965699993
							],
							[
								114.23069930600002,
								-26.124598695999964
							],
							[
								114.22351945700007,
								-26.119008726999937
							],
							[
								114.2106894210001,
								-26.157789717999947
							],
							[
								114.19118933400011,
								-26.168319718999953
							],
							[
								114.18830029500009,
								-26.18024965899997
							],
							[
								114.19190028700007,
								-26.203630688999965
							],
							[
								114.20554037700003,
								-26.224050687999977
							],
							[
								114.20404058800011,
								-26.244781657999965
							],
							[
								114.23799036800006,
								-26.283891696999945
							],
							[
								114.23166160000005,
								-26.30086162699996
							],
							[
								114.23766136000006,
								-26.31275170699996
							],
							[
								114.21591160500009,
								-26.34153264799994
							],
							[
								114.21986152500006,
								-26.357242677999977
							],
							[
								114.21029238800008,
								-26.37204263899997
							],
							[
								114.16636264400006,
								-26.39000268199993
							],
							[
								114.15647238700001,
								-26.410093651999944
							],
							[
								114.08957249800005,
								-26.45847370699994
							],
							[
								114.094822367,
								-26.45931365599995
							],
							[
								114.08957249900004,
								-26.467603656999984
							],
							[
								114.07680257000004,
								-26.466573687999983
							],
							[
								114.07260247900001,
								-26.452323727999953
							],
							[
								114.07514262000007,
								-26.45926370799998
							],
							[
								114.07437257900006,
								-26.45121367799993
							],
							[
								114.08125253900005,
								-26.458833696999932
							],
							[
								114.07842258900007,
								-26.451913676999936
							],
							[
								114.0825726380001,
								-26.45453368699998
							],
							[
								114.05387238900005,
								-26.41920364899994
							],
							[
								113.97287240200001,
								-26.342493673999968
							],
							[
								113.96726143900003,
								-26.293912663999947
							],
							[
								113.95049154800006,
								-26.267583704999936
							],
							[
								113.95952142600004,
								-26.24421366399997
							],
							[
								113.93432032500004,
								-26.203933734999964
							],
							[
								113.94756941900005,
								-26.142992653999954
							],
							[
								113.93888942900003,
								-26.12983268499994
							],
							[
								113.9245294210001,
								-26.133372735999956
							],
							[
								113.91085951100001,
								-26.122362676999956
							],
							[
								113.90459836900004,
								-26.088892666999982
							],
							[
								113.9084683860001,
								-26.05448270599993
							],
							[
								113.89352839600008,
								-26.035132706999946
							],
							[
								113.90249739300009,
								-25.99873165599996
							],
							[
								113.91443752000009,
								-25.982421665999937
							],
							[
								113.90642751900009,
								-25.960101675999965
							],
							[
								113.88746742100011,
								-25.959091686999955
							],
							[
								113.87722760100007,
								-25.945111717999964
							],
							[
								113.86525757300001,
								-25.95595168899996
							],
							[
								113.8852584770001,
								-26.02929269799995
							],
							[
								113.879028661,
								-26.068102667999938
							],
							[
								113.88374862,
								-26.06020273799993
							],
							[
								113.83765964100007,
								-26.138643680999962
							],
							[
								113.83633950900003,
								-26.116713750999963
							],
							[
								113.84557962800011,
								-26.113643740999976
							],
							[
								113.835209469,
								-26.11559368099995
							],
							[
								113.8300895430001,
								-26.15383370199993
							],
							[
								113.78025041300009,
								-26.213395714999933
							],
							[
								113.76223065500005,
								-26.212195726999937
							],
							[
								113.75352942400002,
								-26.18503571699995
							],
							[
								113.75281051500008,
								-26.197895726999946
							],
							[
								113.74233056700007,
								-26.206825697999932
							],
							[
								113.72819050800001,
								-26.206735718999937
							],
							[
								113.72103044800008,
								-26.196715748999964
							],
							[
								113.70322053100006,
								-26.199755669999945
							],
							[
								113.72491053800002,
								-26.194675718999974
							],
							[
								113.7282697070001,
								-26.187225688999945
							],
							[
								113.70112856500009,
								-26.131896739999945
							],
							[
								113.70609547900006,
								-26.061968718999935
							],
							[
								113.6999344190001,
								-26.04494873999994
							],
							[
								113.73433745200009,
								-26.013644666999937
							],
							[
								113.73892747100001,
								-25.999653726999952
							],
							[
								113.73081666200005,
								-26.00395373799995
							],
							[
								113.73164860700001,
								-25.949512736999964
							],
							[
								113.75848734100009,
								-25.905081724999945
							],
							[
								113.76186734900011,
								-25.87858175499997
							],
							[
								113.72172735200002,
								-25.868072737999967
							],
							[
								113.721936776,
								-25.79317516699996
							],
							[
								113.69200308900008,
								-25.789337708999938
							],
							[
								113.6590355290001,
								-25.748561740999946
							],
							[
								113.6264256720001,
								-25.733521742999983
							],
							[
								113.60666559200001,
								-25.714311693999946
							],
							[
								113.59277537100002,
								-25.683611704999976
							],
							[
								113.5891145280001,
								-25.635900724999942
							],
							[
								113.58688433900011,
								-25.641520684999932
							],
							[
								113.58132447800006,
								-25.620760745999974
							],
							[
								113.57469436000008,
								-25.636880745999974
							],
							[
								113.5586444710001,
								-25.635491766999962
							],
							[
								113.53776450300006,
								-25.62575169799993
							],
							[
								113.52524332300004,
								-25.60778075899998
							],
							[
								113.51109245600003,
								-25.503289689999974
							],
							[
								113.49974237800006,
								-25.513759749999963
							],
							[
								113.48896254200008,
								-25.54780071099998
							],
							[
								113.47276253400003,
								-25.55825071199996
							],
							[
								113.44909360100007,
								-25.610871733999943
							],
							[
								113.43199361400002,
								-25.625711744999933
							],
							[
								113.41524464100007,
								-25.683772716999954
							],
							[
								113.41963556200005,
								-25.71221273699996
							],
							[
								113.41411566400006,
								-25.723473706999982
							],
							[
								113.45818543300004,
								-25.772553683999945
							],
							[
								113.45778547400005,
								-25.779893723999976
							],
							[
								113.46935659300004,
								-25.785443743999963
							],
							[
								113.46714545200007,
								-25.77382376399993
							],
							[
								113.45421537300001,
								-25.764873704999957
							],
							[
								113.46434539100005,
								-25.75113268399997
							],
							[
								113.44963545300004,
								-25.756403714999976
							],
							[
								113.45948542100007,
								-25.752592753999977
							],
							[
								113.46027561000005,
								-25.73973274399998
							],
							[
								113.44649551000009,
								-25.723002724999958
							],
							[
								113.4568656990001,
								-25.71310273399996
							],
							[
								113.44467536000002,
								-25.70946268499995
							],
							[
								113.45863434700004,
								-25.702842743999952
							],
							[
								113.47244539700012,
								-25.709302752999974
							],
							[
								113.46993547700004,
								-25.715732702999958
							],
							[
								113.46409554800005,
								-25.71097271399998
							],
							[
								113.4594756680001,
								-25.715592683999944
							],
							[
								113.47141543800001,
								-25.720132732999957
							],
							[
								113.47325536800008,
								-25.73051269299998
							],
							[
								113.46230562900007,
								-25.725752773999943
							],
							[
								113.46053552000001,
								-25.733752683999967
							],
							[
								113.47926561000008,
								-25.764032742999973
							],
							[
								113.4662955120001,
								-25.768063753999968
							],
							[
								113.47870654200005,
								-25.783323692999943
							],
							[
								113.46106652600008,
								-25.80934368399994
							],
							[
								113.51292737400001,
								-25.85210368099996
							],
							[
								113.5253175150001,
								-25.88416374999997
							],
							[
								113.51762754900005,
								-25.919564710999964
							],
							[
								113.55911866600002,
								-25.94638470899997
							],
							[
								113.56058638000002,
								-25.998735728999975
							],
							[
								113.57534851000003,
								-26.014534697999977
							],
							[
								113.56725967300008,
								-26.044315697999934
							],
							[
								113.58002960400006,
								-26.071825717999957
							],
							[
								113.58590949300003,
								-26.07103568699995
							],
							[
								113.5735507060001,
								-26.086265757999968
							],
							[
								113.58031039600007,
								-26.09720571799994
							],
							[
								113.62081941200006,
								-26.100885734999963
							],
							[
								113.61482939300004,
								-26.10867567599996
							],
							[
								113.63946850100001,
								-26.121955713999967
							],
							[
								113.66313955200008,
								-26.16537567299997
							],
							[
								113.68748961100005,
								-26.186175740999943
							],
							[
								113.68806058400003,
								-26.21752571099995
							],
							[
								113.75353051800005,
								-26.233305696999935
							],
							[
								113.79776048400004,
								-26.25225572399995
							],
							[
								113.8366516320001,
								-26.280804711999963
							],
							[
								113.88357151200012,
								-26.340995718999977
							],
							[
								113.88545250400011,
								-26.371435688999952
							],
							[
								113.87414239700001,
								-26.394366699999978
							],
							[
								113.87024251700007,
								-26.39132668999997
							],
							[
								113.88739438000005,
								-26.449686739999947
							],
							[
								113.885224644,
								-26.502466699999957
							],
							[
								113.86366460900001,
								-26.53670774099993
							],
							[
								113.83311539400006,
								-26.55123769399995
							],
							[
								113.8115063790001,
								-26.577228714999933
							],
							[
								113.81273759100009,
								-26.60677867499993
							],
							[
								113.80609846200002,
								-26.611188685999934
							],
							[
								113.78762756300011,
								-26.605039716999954
							],
							[
								113.7674873840001,
								-26.58715868799993
							],
							[
								113.7384566400001,
								-26.617569699999933
							],
							[
								113.71419662200003,
								-26.606789670999945
							],
							[
								113.69701669400001,
								-26.61145067299998
							],
							[
								113.68681644500009,
								-26.60165968299998
							],
							[
								113.69615664500009,
								-26.619230742999946
							],
							[
								113.68640749800011,
								-26.637860742999976
							],
							[
								113.69074763800006,
								-26.64389074299993
							],
							[
								113.69756747600002,
								-26.632540752999944
							],
							[
								113.69996757600006,
								-26.63930074299998
							],
							[
								113.68894763800006,
								-26.64902073299993
							],
							[
								113.70492839700012,
								-26.66207172199995
							],
							[
								113.69903842800011,
								-26.666141702999937
							],
							[
								113.69486856800006,
								-26.656901682999944
							],
							[
								113.6809387400001,
								-26.658401693999963
							],
							[
								113.66401942300001,
								-26.674442674999966
							],
							[
								113.65781774200002,
								-26.654151724999963
							],
							[
								113.66642640900011,
								-26.630340694999973
							],
							[
								113.6570966490001,
								-26.61615075499998
							],
							[
								113.66370551700004,
								-26.59617975499998
							],
							[
								113.65391567800009,
								-26.594609704999982
							],
							[
								113.64203638100003,
								-26.61944069599997
							],
							[
								113.62562543900003,
								-26.57119970699995
							],
							[
								113.633515568,
								-26.56362973699993
							],
							[
								113.62870559600003,
								-26.540179686999977
							],
							[
								113.638163512,
								-26.50283967599995
							],
							[
								113.63710369000012,
								-26.471258675999934
							],
							[
								113.63056355000003,
								-26.46325875599996
							],
							[
								113.61807442300005,
								-26.489669706999962
							],
							[
								113.61850464600002,
								-26.52045970699993
							],
							[
								113.62628462500004,
								-26.52427974699998
							],
							[
								113.621545577,
								-26.538719706999927
							],
							[
								113.61409464400003,
								-26.489409696999928
							],
							[
								113.609834406,
								-26.51471967799995
							],
							[
								113.59340469800009,
								-26.51191967899996
							],
							[
								113.59922557000004,
								-26.544620748999932
							],
							[
								113.58921541200004,
								-26.560200718999965
							],
							[
								113.5882455740001,
								-26.58557073999998
							],
							[
								113.60711570400008,
								-26.606190727999945
							],
							[
								113.59809663600004,
								-26.614180748999956
							],
							[
								113.596305615,
								-26.60192067899993
							],
							[
								113.58375567600001,
								-26.60017070999993
							],
							[
								113.57179571600011,
								-26.578150680999954
							],
							[
								113.55899556700001,
								-26.57624071099997
							],
							[
								113.55983543400009,
								-26.547140740999964
							],
							[
								113.57720471900006,
								-26.504609699999946
							],
							[
								113.5755645590001,
								-26.49580969999994
							],
							[
								113.56302359000006,
								-26.493909690999942
							],
							[
								113.55233339900008,
								-26.469099680999932
							],
							[
								113.56172364700001,
								-26.461309710999956
							],
							[
								113.567082604,
								-26.433329699999945
							],
							[
								113.5487225920001,
								-26.38089869099997
							],
							[
								113.5594927190001,
								-26.35346875999994
							],
							[
								113.54052253900011,
								-26.32473768099993
							],
							[
								113.54550164600005,
								-26.302736740999933
							],
							[
								113.53722165500005,
								-26.27950675099993
							],
							[
								113.530461607,
								-26.284367741999972
							],
							[
								113.51155149800002,
								-26.276817722999965
							],
							[
								113.51832166800011,
								-26.284487712999976
							],
							[
								113.51370252000004,
								-26.302088742999956
							],
							[
								113.49392270300007,
								-26.31032870399997
							],
							[
								113.5070824820001,
								-26.323968733999948
							],
							[
								113.5159726710001,
								-26.32204876299994
							],
							[
								113.51247240300006,
								-26.336488722999945
							],
							[
								113.52828252300003,
								-26.362198761999935
							],
							[
								113.50601365900002,
								-26.40912971399996
							],
							[
								113.50330357400003,
								-26.46880070499998
							],
							[
								113.4865034280001,
								-26.484820705999937
							],
							[
								113.47697353800004,
								-26.477040735999935
							],
							[
								113.4853435330001,
								-26.43057076599996
							],
							[
								113.50226354100005,
								-26.420299693999937
							],
							[
								113.48469266000006,
								-26.383539734999943
							],
							[
								113.49646248800002,
								-26.378119754999943
							],
							[
								113.50224262900008,
								-26.400219703999937
							],
							[
								113.5066025860001,
								-26.36389976399994
							],
							[
								113.48781238700008,
								-26.357029694999937
							],
							[
								113.49882264400003,
								-26.336039703999973
							],
							[
								113.48278246500001,
								-26.32070875499994
							],
							[
								113.47988158100009,
								-26.27107871499993
							],
							[
								113.46222142200008,
								-26.25336868599993
							],
							[
								113.45958155900007,
								-26.221788755999967
							],
							[
								113.4483214600001,
								-26.21253873699993
							],
							[
								113.44469050600003,
								-26.16324772699994
							],
							[
								113.43694046700011,
								-26.16752775799995
							],
							[
								113.42443041800004,
								-26.16098773799996
							],
							[
								113.42918063600007,
								-26.13853768799993
							],
							[
								113.39673060700011,
								-26.113937719999967
							],
							[
								113.40031041600002,
								-26.105707759999973
							],
							[
								113.38556948700011,
								-26.092167720999953
							],
							[
								113.38632945400002,
								-26.060806759999934
							],
							[
								113.36374956300006,
								-26.017466721999938
							],
							[
								113.35698947500009,
								-26.033256691999952
							],
							[
								113.36758965600006,
								-26.054137771999933
							],
							[
								113.35870957800012,
								-26.06507770199994
							],
							[
								113.37794941700008,
								-26.078627750999942
							],
							[
								113.37343965900004,
								-26.097117710999953
							],
							[
								113.38731046800001,
								-26.11145769099994
							],
							[
								113.38055041000007,
								-26.119577740999944
							],
							[
								113.37852072400005,
								-26.165028750999966
							],
							[
								113.38651166700004,
								-26.212638740999978
							],
							[
								113.37588155700007,
								-26.205188711999938
							],
							[
								113.36461141900008,
								-26.210708692999958
							],
							[
								113.36635167100007,
								-26.237558752999973
							],
							[
								113.35746143300003,
								-26.245338712999967
							],
							[
								113.3541825750001,
								-26.276359733999982
							],
							[
								113.3363924790001,
								-26.300339694999934
							],
							[
								113.35467251700004,
								-26.300839733999965
							],
							[
								113.37070372000005,
								-26.357550722999974
							],
							[
								113.38257362900003,
								-26.360980711999957
							],
							[
								113.38231367100002,
								-26.385230751999927
							],
							[
								113.39797367000006,
								-26.39550075099993
							],
							[
								113.39990368200006,
								-26.41823070099997
							],
							[
								113.39433374000009,
								-26.392160760999957
							],
							[
								113.39258342100004,
								-26.402260741999953
							],
							[
								113.38331344100004,
								-26.38748076199994
							],
							[
								113.38042370300002,
								-26.398760721999963
							],
							[
								113.36839360400006,
								-26.39921172299995
							],
							[
								113.3699034220001,
								-26.383640712999977
							],
							[
								113.3571334930001,
								-26.373490713999956
							],
							[
								113.36528354100005,
								-26.35409075299998
							],
							[
								113.35602254000003,
								-26.33096076399994
							],
							[
								113.33873245300003,
								-26.34742076499998
							],
							[
								113.32671242300012,
								-26.337260755999978
							],
							[
								113.33122247200004,
								-26.329140774999928
							],
							[
								113.32434255200008,
								-26.318980775999933
							],
							[
								113.33349266100004,
								-26.311430754999947
							],
							[
								113.31778152700008,
								-26.241699745999938
							],
							[
								113.32545170300011,
								-26.204818734999947
							],
							[
								113.31990048700004,
								-26.126188704999947
							],
							[
								113.31431941500011,
								-26.089858774999982
							],
							[
								113.3064494350001,
								-26.08138769599998
							],
							[
								113.308989612,
								-26.046307755999976
							],
							[
								113.2992786000001,
								-26.015947705999963
							],
							[
								113.2846294740001,
								-26.040067706999935
							],
							[
								113.29161958400005,
								-26.047747766999976
							],
							[
								113.28420972700007,
								-26.07628874699998
							],
							[
								113.29156958700003,
								-26.08542869699994
							],
							[
								113.29114046000007,
								-26.125708746999976
							],
							[
								113.28220055500003,
								-26.17318976799993
							],
							[
								113.27305153700001,
								-26.182649768999966
							],
							[
								113.28038150900011,
								-26.22157969799997
							],
							[
								113.26997175200006,
								-26.24175977899995
							],
							[
								113.26090152900008,
								-26.19120974899994
							],
							[
								113.1972607240001,
								-26.173969713999952
							],
							[
								113.19340048400011,
								-26.164259793999975
							],
							[
								113.16255060600008,
								-26.143550705999928
							],
							[
								113.15628049700001,
								-26.15166079599993
							],
							[
								113.23643161500001,
								-26.23348077099996
							],
							[
								113.27753247500004,
								-26.294000728999947
							],
							[
								113.29964260700001,
								-26.34242171699998
							],
							[
								113.29423359900011,
								-26.363851717999978
							],
							[
								113.30824372000006,
								-26.387441686999978
							],
							[
								113.29670355200005,
								-26.400181737999958
							],
							[
								113.54964745300003,
								-26.633321681999973
							],
							[
								113.71851554000011,
								-26.841692741999964
							],
							[
								113.81628072000001,
								-26.97945571699995
							],
							[
								113.8338725110001,
								-27.019334725999954
							],
							[
								113.96643657300001,
								-27.23200068799997
							],
							[
								114.10306158800006,
								-27.49937769099995
							],
							[
								114.14359061300001,
								-27.62085068899995
							],
							[
								114.163396938,
								-27.706967317999954
							],
							[
								114.17246663500009,
								-27.68760700699994
							],
							[
								114.1655763440001,
								-27.668086867999932
							],
							[
								114.17346615300005,
								-27.658866666999984
							],
							[
								114.16998642400006,
								-27.67463689699997
							],
							[
								114.18167650300006,
								-27.68029686699998
							],
							[
								114.16585696700008,
								-27.708277317999944
							],
							[
								114.15798161800001,
								-27.70846668799993
							],
							[
								114.15226762100008,
								-27.732752688999938
							],
							[
								114.12630962700007,
								-27.76875268999993
							],
							[
								114.10510360600006,
								-27.849478701999942
							],
							[
								114.13886961900005,
								-27.944203689999938
							],
							[
								114.17511664800008,
								-28.110886698999934
							],
							[
								114.1960976470001,
								-28.12603669799995
							],
							[
								114.23953162700002,
								-28.18683168499996
							],
							[
								114.32251364000001,
								-28.23174967999995
							],
							[
								114.34179662100007,
								-28.267670668999983
							],
							[
								114.40540261800004,
								-28.33547468599994
							],
							[
								114.43299507900008,
								-28.394228813999973
							],
							[
								114.45177651800009,
								-28.410357682999972
							],
							[
								114.4656495160001,
								-28.40729264199996
							],
							[
								114.45465147800007,
								-28.41024663299993
							],
							[
								114.53100688500001,
								-28.496028888999945
							],
							[
								114.59553060600001,
								-28.610989664999977
							],
							[
								114.61243586800003,
								-28.663520853999955
							],
							[
								114.60573422100003,
								-28.68666217499998
							],
							[
								114.6189866420001,
								-28.719292193999934
							],
							[
								114.61466062600005,
								-28.762551664999933
							],
							[
								114.60242962900008,
								-28.775916665999944
							],
							[
								114.59267464000004,
								-28.776839665999944
							],
							[
								114.599541638,
								-28.76923066599994
							],
							[
								114.59036364000008,
								-28.776335665999966
							],
							[
								114.58741364000002,
								-28.770856675999937
							],
							[
								114.57607564200009,
								-28.784355656999935
							],
							[
								114.61225319900007,
								-28.79533366499993
							],
							[
								114.62867338000001,
								-28.830521893999958
							],
							[
								114.62395842100011,
								-28.843269074999967
							],
							[
								114.63453262200005,
								-28.87486167399993
							],
							[
								114.6967536200001,
								-28.94203165099998
							],
							[
								114.83199480200005,
								-29.06600421299993
							],
							[
								114.87209432100008,
								-29.116727310999977
							],
							[
								114.92080397600012,
								-29.25547279899996
							],
							[
								114.92206713700011,
								-29.270169928999962
							],
							[
								114.91444625800011,
								-29.27740211899993
							],
							[
								114.92688476900003,
								-29.312719047999963
							],
							[
								114.95425805900004,
								-29.352171496999972
							],
							[
								114.9563505320001,
								-29.39739182699998
							],
							[
								114.99757961400007,
								-29.493534344999944
							],
							[
								114.99723498600008,
								-29.51358151499994
							],
							[
								114.97714353200001,
								-29.55737710699998
							],
							[
								114.95795943400003,
								-29.683690497999976
							],
							[
								114.95930863100011,
								-29.770474408999974
							],
							[
								114.96484111300003,
								-29.808741787999963
							],
							[
								114.98099083400007,
								-29.845391967999944
							],
							[
								114.98275280900009,
								-29.911010637999937
							],
							[
								114.97779892200003,
								-29.94506417799994
							],
							[
								114.96284713600005,
								-29.97391549899993
							],
							[
								114.96953254800007,
								-30.007570648999945
							],
							[
								114.95485678300008,
								-30.04883763999993
							],
							[
								114.96531983200009,
								-30.05450960999997
							],
							[
								114.9630475240001,
								-30.072145659999933
							],
							[
								114.98404915200001,
								-30.07907334899994
							],
							[
								115.00178173300003,
								-30.13219966799994
							],
							[
								115.00623078500007,
								-30.159229487999937
							],
							[
								114.99869649800007,
								-30.182574647999957
							],
							[
								114.99190380900006,
								-30.18394929899995
							],
							[
								114.99430884200001,
								-30.23127564899994
							],
							[
								115.00316666100002,
								-30.22793861799994
							],
							[
								115.02750714800004,
								-30.236918506999928
							],
							[
								115.0410847490001,
								-30.267978625999945
							],
							[
								115.039717171,
								-30.298263175999978
							],
							[
								115.02047579500004,
								-30.317024656999934
							],
							[
								115.04201065400002,
								-30.33780061599998
							],
							[
								115.0505826100001,
								-30.424325635999935
							],
							[
								115.07120668100004,
								-30.478045644999952
							],
							[
								115.06885871300005,
								-30.491630654999938
							],
							[
								115.0539647060001,
								-30.50506265599995
							],
							[
								115.07402879400001,
								-30.517437064999967
							],
							[
								115.09419372400009,
								-30.54826165399993
							],
							[
								115.0876738070001,
								-30.578351734999956
							],
							[
								115.10361280600011,
								-30.591534743999944
							],
							[
								115.10201586700009,
								-30.601738763999947
							],
							[
								115.18326960900004,
								-30.77187465999998
							],
							[
								115.18971617200009,
								-30.824844079999934
							],
							[
								115.20451469000011,
								-30.82336763899997
							],
							[
								115.2198017290001,
								-30.832672637999963
							],
							[
								115.3128196770001,
								-30.97313386299993
							],
							[
								115.32833954800003,
								-31.01063467299997
							],
							[
								115.32643764900001,
								-31.027842672999952
							],
							[
								115.38323700900003,
								-31.121387269999957
							],
							[
								115.39924661100008,
								-31.180355648999978
							],
							[
								115.4405273430001,
								-31.27666871699995
							],
							[
								115.53913420900005,
								-31.40827692199997
							],
							[
								115.56075568000006,
								-31.45520616099998
							],
							[
								115.67010582500006,
								-31.455115434999982
							],
							[
								115.67839596500005,
								-31.47698739499998
							],
							[
								115.85579017000009,
								-31.474311874999955
							],
							[
								115.85958418100006,
								-31.627155324999933
							],
							[
								115.88348316800011,
								-31.627509703999976
							],
							[
								115.88862214900007,
								-31.652701123999975
							],
							[
								115.90508101700004,
								-31.652587922999942
							],
							[
								115.91201068600003,
								-31.662796602999947
							],
							[
								115.92520668400005,
								-31.66059760199994
							],
							[
								115.93754397400005,
								-31.682949880999956
							],
							[
								115.95536966200007,
								-31.682985599999938
							],
							[
								115.95732467300002,
								-31.70168259999997
							],
							[
								115.96432022200008,
								-31.701634799999965
							],
							[
								115.94857201500008,
								-31.717386550999947
							],
							[
								115.95711136600005,
								-31.741793600999983
							],
							[
								115.98284868200005,
								-31.741872598999976
							],
							[
								116.0207365870001,
								-31.74198688699994
							],
							[
								116.02422463700009,
								-31.748339606999934
							],
							[
								116.03269260600007,
								-31.748342065999964
							],
							[
								116.03271220500005,
								-31.74211738599996
							],
							[
								116.0942449160001,
								-31.742265922999934
							],
							[
								116.095591764,
								-31.712041212999964
							],
							[
								116.11159066200003,
								-31.70890259199996
							],
							[
								116.09904484200001,
								-31.695831012999975
							],
							[
								116.14072196500001,
								-31.67271434999998
							],
							[
								116.14061475500012,
								-31.680412849999982
							],
							[
								116.14931427400006,
								-31.682052099999964
							],
							[
								116.20545864500002,
								-31.670454586999938
							],
							[
								116.28805411400003,
								-31.671091081999975
							],
							[
								116.28767068600007,
								-31.706450531999963
							],
							[
								116.34724312800006,
								-31.70656465899998
							],
							[
								116.3480162410001,
								-31.748438378999936
							],
							[
								116.33815438300007,
								-31.75351650999994
							],
							[
								116.33819205300006,
								-31.762687409999955
							],
							[
								116.3458359120001,
								-31.762663009999983
							],
							[
								116.34523355400006,
								-31.779980689999945
							],
							[
								116.35620571200002,
								-31.78361051899998
							],
							[
								116.3378298670001,
								-31.805607779999946
							],
							[
								116.37098678200005,
								-31.81333548899994
							],
							[
								116.3582919050001,
								-31.81946684899998
							],
							[
								116.35832121600004,
								-31.838602068999933
							],
							[
								116.34612459900006,
								-31.85643345999995
							],
							[
								116.34618559300009,
								-31.906776839999964
							],
							[
								116.41513569300002,
								-31.90931971699996
							],
							[
								116.40907564100007,
								-32.01230625699998
							],
							[
								116.30281214600006,
								-32.00501500299998
							],
							[
								116.30257040800007,
								-32.02319085299996
							],
							[
								116.323750184,
								-32.02342826199998
							],
							[
								116.32346570700008,
								-32.062547621999954
							],
							[
								116.28888966200009,
								-32.06214058399996
							],
							[
								116.28497953700003,
								-32.11313726399993
							],
							[
								116.34417580800005,
								-32.11308605099998
							],
							[
								116.34403867700007,
								-32.09355787099997
							],
							[
								116.39207771000008,
								-32.09353779899993
							],
							[
								116.39231951900001,
								-32.082561838999936
							],
							[
								116.44545548100007,
								-32.08313215599998
							],
							[
								116.44511034300001,
								-32.11168627599994
							],
							[
								116.50924951400009,
								-32.11166559299994
							],
							[
								116.50937588600004,
								-32.139760912999975
							],
							[
								116.61421876100007,
								-32.13981536699998
							],
							[
								116.61533116900011,
								-32.11167183699996
							],
							[
								116.67338098100004,
								-32.11096297399996
							],
							[
								116.68287218000012,
								-32.12678831399995
							],
							[
								116.7102115560001,
								-32.11502675199995
							],
							[
								116.7010737060001,
								-32.09966948299996
							],
							[
								116.7286698900001,
								-32.07949650099994
							],
							[
								116.7180225510001,
								-32.06174355099995
							],
							[
								116.73947877700004,
								-32.05226688999994
							],
							[
								116.75601265600005,
								-32.08050922999996
							],
							[
								116.82005558500009,
								-32.052793565999934
							],
							[
								116.81163105600001,
								-32.04009049699994
							],
							[
								116.92143321600008,
								-31.99175908099994
							],
							[
								116.93370911500006,
								-31.999335839999958
							],
							[
								116.98701476600002,
								-31.979164176999973
							],
							[
								117.0108847030001,
								-31.977684065999938
							],
							[
								117.04255837700009,
								-31.961874114999944
							],
							[
								117.05615396600001,
								-31.979381183999976
							],
							[
								117.06117848500003,
								-31.97719318399993
							],
							[
								117.05380658600006,
								-31.96898255399998
							],
							[
								117.06433172400011,
								-31.964416512999946
							],
							[
								117.0931958110001,
								-31.98430283199997
							],
							[
								117.09961546000011,
								-31.981817261999936
							],
							[
								117.08764521,
								-31.959493031999955
							],
							[
								117.10510578700007,
								-31.94501275099998
							],
							[
								117.09642970700008,
								-31.93051909199994
							],
							[
								117.14178397900002,
								-31.910563448999937
							],
							[
								117.12622607000003,
								-31.89102859999997
							],
							[
								117.11844799100004,
								-31.894551319999948
							],
							[
								117.11099035200004,
								-31.88530222099996
							],
							[
								117.141407877,
								-31.87177818899994
							],
							[
								117.13563437700009,
								-31.862575308999965
							],
							[
								117.15832456300006,
								-31.85662816799993
							],
							[
								117.12376924400007,
								-31.79992201999994
							],
							[
								117.10666797700003,
								-31.80723772099998
							],
							[
								117.10314802700009,
								-31.801231050999945
							],
							[
								117.09092180900006,
								-31.80442666099998
							],
							[
								117.07530711100003,
								-31.79777421199998
							],
							[
								117.05765775200007,
								-31.77007383299997
							],
							[
								117.01417326900003,
								-31.783919614999945
							],
							[
								117.00493372900007,
								-31.767202035999958
							],
							[
								116.98934728100005,
								-31.761247965999928
							],
							[
								116.94355913200002,
								-31.69069536799998
							],
							[
								116.96146211900009,
								-31.68296672699995
							],
							[
								116.95615855900007,
								-31.673889317999965
							],
							[
								116.94626360100006,
								-31.67481298799993
							],
							[
								116.94346619900011,
								-31.647332437999978
							],
							[
								116.91278572100009,
								-31.606456118999972
							],
							[
								116.87488540100003,
								-31.53371669099994
							],
							[
								116.86226188300009,
								-31.538981471999932
							],
							[
								116.84494978500004,
								-31.525670932999958
							],
							[
								116.86035041200012,
								-31.51920364199998
							],
							[
								116.85516971100003,
								-31.489548941999942
							],
							[
								116.87182300800009,
								-31.482533110999952
							],
							[
								116.87763249800003,
								-31.491231440999968
							],
							[
								116.9658341820001,
								-31.44826081599996
							],
							[
								116.99103001900005,
								-31.448218544999975
							],
							[
								116.99116174700009,
								-31.42687833499997
							],
							[
								117.03276357200002,
								-31.426918532999935
							],
							[
								117.03290011000001,
								-31.404376571999933
							],
							[
								117.05715869700009,
								-31.403478550999978
							],
							[
								117.05798414600008,
								-31.394338140999935
							],
							[
								117.13307449500007,
								-31.38795870699994
							],
							[
								117.13313552500006,
								-31.396387396999955
							],
							[
								117.14262146400006,
								-31.396389286999977
							],
							[
								117.14258318300006,
								-31.38040414699998
							],
							[
								117.17215101900001,
								-31.376299764999942
							],
							[
								117.17210703800004,
								-31.37048579499998
							],
							[
								117.20852556300008,
								-31.376279503999967
							],
							[
								117.20850885300001,
								-31.36898825299994
							],
							[
								117.22314889100005,
								-31.368947702999947
							],
							[
								117.23214891200007,
								-31.40268555199998
							],
							[
								117.27023913700009,
								-31.402593150999962
							],
							[
								117.2802283100001,
								-31.327614919999974
							],
							[
								117.26461872200002,
								-31.32763584099996
							],
							[
								117.26262330000009,
								-31.288079289999928
							],
							[
								117.253237291,
								-31.282466360999933
							],
							[
								117.25333646000001,
								-31.275244250999947
							],
							[
								117.261755289,
								-31.275236459999974
							],
							[
								117.261795258,
								-31.259220419999963
							],
							[
								117.24857138000004,
								-31.259210620999966
							],
							[
								117.2485874790001,
								-31.249360440999965
							],
							[
								117.26640958700011,
								-31.24936404999994
							],
							[
								117.27253249500006,
								-31.230507529999954
							],
							[
								117.26821016300005,
								-31.199570259999973
							],
							[
								117.2569230150001,
								-31.19959153999997
							],
							[
								117.2503928750001,
								-31.18574825099995
							],
							[
								117.23963070700006,
								-31.18970749099998
							],
							[
								117.23960354400003,
								-31.146936470999947
							],
							[
								117.24097532200005,
								-31.12961662099997
							],
							[
								117.24727325200001,
								-31.129621999999983
							],
							[
								117.24244492100001,
								-31.113069680999956
							],
							[
								117.2518651690001,
								-31.104657619999955
							],
							[
								117.2485512180001,
								-31.087286929999948
							],
							[
								117.25744104700004,
								-31.087188899999944
							],
							[
								117.24664686800008,
								-31.07053553999998
							],
							[
								117.24781118300007,
								-31.001868599999966
							],
							[
								117.27895709800009,
								-30.99869932799993
							],
							[
								117.27457810600004,
								-30.806580527999984
							],
							[
								117.21108753500005,
								-30.805795650999983
							],
							[
								117.24181037700009,
								-30.757228878999967
							],
							[
								117.24160141400012,
								-30.702690338999957
							],
							[
								117.25777131200005,
								-30.70278794799998
							],
							[
								117.25776759100006,
								-30.689712347999944
							],
							[
								117.24832759200001,
								-30.689720937999937
							],
							[
								117.2475364610001,
								-30.665068867999935
							],
							[
								117.23808453200002,
								-30.661361428999953
							],
							[
								117.238023569,
								-30.62319084899997
							],
							[
								117.24537802800012,
								-30.623189257999968
							],
							[
								117.24523111200006,
								-30.528084597999964
							],
							[
								117.23383887300008,
								-30.528114037999956
							],
							[
								117.23380858100006,
								-30.499856527999953
							],
							[
								117.24170575000005,
								-30.497901497999976
							],
							[
								117.24437597800011,
								-30.462742336999952
							],
							[
								117.24967194700002,
								-30.46272831699997
							],
							[
								117.24347085400007,
								-30.40864784699994
							],
							[
								117.25044264200005,
								-30.390319836999936
							],
							[
								117.25098038100009,
								-30.22633820599998
							],
							[
								117.39937987100006,
								-30.22602067899993
							],
							[
								117.40165072000002,
								-30.21814158899997
							],
							[
								117.42125972800011,
								-30.21744237799993
							],
							[
								117.41654560800009,
								-30.209923387999936
							],
							[
								117.42927074600004,
								-30.209443216999944
							],
							[
								117.42232672700004,
								-30.206176306999964
							],
							[
								117.55367593900007,
								-30.205780490999928
							],
							[
								117.5331991490001,
								-30.162230561999934
							],
							[
								117.52226703100007,
								-30.162154071999964
							],
							[
								117.54269125700012,
								-30.150457760999984
							],
							[
								117.53134118800006,
								-30.13979428199997
							],
							[
								117.52965313700008,
								-30.122210181999947
							],
							[
								117.53084941200007,
								-30.04066531099994
							],
							[
								117.5219923200001,
								-29.996795521999957
							],
							[
								117.52922132800006,
								-29.97213851099997
							],
							[
								117.52233333900006,
								-29.97307652099994
							],
							[
								117.52915533700002,
								-29.966455520999943
							],
							[
								117.50761234900006,
								-29.95201751199994
							],
							[
								117.5049843490001,
								-29.940819511999962
							],
							[
								117.5121073570001,
								-29.927812511999946
							],
							[
								117.52215733600008,
								-29.926489500999935
							],
							[
								117.56752132100007,
								-29.948830508999947
							],
							[
								117.58430434900004,
								-29.94460149799994
							],
							[
								117.63692033200005,
								-29.950182505999976
							],
							[
								117.65820131800001,
								-29.936697504999984
							],
							[
								117.65778430800003,
								-29.92755150499994
							],
							[
								117.66022130800002,
								-29.93261651499995
							],
							[
								117.66449132700006,
								-29.928975513999944
							],
							[
								117.66159030600011,
								-29.91489451399997
							],
							[
								117.67120429400006,
								-29.897939503999964
							],
							[
								117.6646163050001,
								-29.895493503999944
							],
							[
								117.6661173230001,
								-29.869653503999928
							],
							[
								117.63486529600004,
								-29.84527649499995
							],
							[
								117.63577331600004,
								-29.85134951499998
							],
							[
								117.6270513070001,
								-29.844984515999954
							],
							[
								117.5993523410001,
								-29.850499506999938
							],
							[
								117.57342431500001,
								-29.867458518999968
							],
							[
								117.52731529100004,
								-29.871200160999933
							],
							[
								117.50931134500001,
								-29.884409511999934
							],
							[
								117.49430933600001,
								-29.875878521999937
							],
							[
								117.49611932200003,
								-29.81488152199995
							],
							[
								117.509434338,
								-29.776691510999967
							],
							[
								117.54272733300002,
								-29.76820951999997
							],
							[
								117.5519353310001,
								-29.755936498999972
							],
							[
								117.56953931900011,
								-29.75615150799996
							],
							[
								117.55531531000008,
								-29.753428518999954
							],
							[
								117.5550403200001,
								-29.74289449899993
							],
							[
								117.55057133000003,
								-29.747684508999953
							],
							[
								117.55167231000007,
								-29.73753451899995
							],
							[
								117.56940032700004,
								-29.737145517999977
							],
							[
								117.55060731800006,
								-29.704391508999947
							],
							[
								117.56757032100006,
								-29.63591049799993
							],
							[
								117.58144129900006,
								-29.635888506999947
							],
							[
								117.57326931900002,
								-29.620535496999935
							],
							[
								117.58330031800006,
								-29.61759449699997
							],
							[
								117.60347131700007,
								-29.644044505999943
							],
							[
								117.61743632500009,
								-29.64206949499993
							],
							[
								117.63443630400002,
								-29.65459350499998
							],
							[
								117.67259529900002,
								-29.662573512999984
							],
							[
								117.67582130900007,
								-29.669342512999947
							],
							[
								117.66897231000007,
								-29.672578492999946
							],
							[
								117.70325730600007,
								-29.67548149099997
							],
							[
								117.72164830200006,
								-29.654643499999963
							],
							[
								117.71092828300004,
								-29.65240750099997
							],
							[
								117.71054029200002,
								-29.630419510999957
							],
							[
								117.70188329300004,
								-29.62258350099995
							],
							[
								117.69668029400009,
								-29.625545500999976
							],
							[
								117.69523978300003,
								-29.612420010999983
							],
							[
								118.50322217700011,
								-29.612415453999972
							],
							[
								118.43571016700002,
								-29.279364475999955
							],
							[
								118.43575417700004,
								-29.10507946499996
							],
							[
								118.72034515000007,
								-29.106909461999976
							],
							[
								118.72034855100003,
								-29.292270452999958
							],
							[
								119.20065129900001,
								-29.290927532999945
							],
							[
								119.34441605100005,
								-29.11092343599995
							],
							[
								119.66305166000006,
								-29.11297301299993
							],
							[
								119.77579396500005,
								-28.915108406999934
							],
							[
								119.7757702020001,
								-28.847813676999976
							],
							[
								119.80262397900003,
								-28.847797415999935
							],
							[
								119.80261994900002,
								-28.46407540399997
							],
							[
								120.04519675900008,
								-28.46399358499997
							],
							[
								120.04498593100004,
								-28.291130403999944
							],
							[
								120.19618789200001,
								-28.291129397999953
							],
							[
								120.19618489000004,
								-28.04719139699995
							],
							[
								120.15429333600002,
								-28.04759319799996
							],
							[
								120.15751374400008,
								-27.61260885599995
							],
							[
								120.07470269400005,
								-27.612609878999933
							],
							[
								120.07470188900004,
								-27.50225938799997
							],
							[
								120.05840588100011,
								-27.50225938899996
							],
							[
								120.0584038610001,
								-27.290259377999973
							],
							[
								119.58496690700008,
								-27.290265405999946
							],
							[
								119.58496654500004,
								-27.24215471599996
							],
							[
								119.33254425400003,
								-27.242158055999937
							],
							[
								119.20109396900011,
								-27.231038411999975
							],
							[
								119.20136278600012,
								-27.169370741999955
							],
							[
								119.23655819600003,
								-27.06281983899993
							],
							[
								119.2732497400001,
								-27.01491238799997
							],
							[
								119.28787652800008,
								-27.008641996999984
							],
							[
								119.33953544400003,
								-26.863774553999974
							],
							[
								119.41137812200009,
								-26.78513535099995
							],
							[
								119.44751997700007,
								-26.76883266899995
							],
							[
								119.48584592000009,
								-26.722004476999928
							],
							[
								119.50188821600011,
								-26.68087187699996
							],
							[
								119.52846882100005,
								-26.644423864999965
							],
							[
								119.57667137400006,
								-26.605713332999983
							],
							[
								119.58343468200007,
								-26.57767301299998
							],
							[
								119.60244449900006,
								-26.57108834199994
							],
							[
								119.61388205700007,
								-26.55270872099993
							],
							[
								119.80465177000008,
								-26.44027901299995
							],
							[
								119.80802928600008,
								-26.37077714299994
							],
							[
								119.86730794400012,
								-26.256932259999928
							],
							[
								119.89446634800004,
								-26.213600507999956
							],
							[
								119.92177381400006,
								-26.18763423699994
							],
							[
								119.96108040500008,
								-26.085730204999948
							],
							[
								120.0078901070001,
								-26.027020512999968
							],
							[
								120.11885899200001,
								-25.75438548699998
							],
							[
								120.1072662570001,
								-25.631853546999935
							],
							[
								120.09945678800011,
								-25.621887396999966
							],
							[
								120.08643450600005,
								-25.551875396999947
							],
							[
								120.08505062600011,
								-25.338538765999942
							],
							[
								120.13700581600006,
								-25.23238556399997
							],
							[
								120.16733260100011,
								-25.200327111999968
							],
							[
								120.20219535700005,
								-25.192064840999933
							],
							[
								120.20236850600008,
								-25.182595670999945
							],
							[
								120.19503244600003,
								-25.14869159099993
							],
							[
								120.11539181700005,
								-24.99753947299996
							],
							[
								120.1054183760001,
								-24.940142152999954
							],
							[
								120.0553185870001,
								-24.84495140499996
							],
							[
								120.05604004100007,
								-24.73351611399994
							],
							[
								120.04285901100002,
								-24.707370373999936
							],
							[
								120.09249038900009,
								-24.540128410999955
							],
							[
								120.06666324900004,
								-24.492998661999934
							],
							[
								120.07814833700002,
								-24.476114561999964
							],
							[
								120.11141629300005,
								-24.45628352999995
							],
							[
								120.13247123700012,
								-24.370654368999965
							],
							[
								120.1583667430001,
								-24.344484437999938
							],
							[
								120.18346739000003,
								-24.33088894699995
							],
							[
								120.21287072500002,
								-24.285776444999954
							],
							[
								120.21956529200008,
								-24.246088614999962
							],
							[
								120.3211317460001,
								-24.10858109999998
							],
							[
								120.36492750900004,
								-24.071995648999973
							],
							[
								120.41012950200002,
								-24.01722254699996
							],
							[
								120.43642927700012,
								-23.95363098499996
							],
							[
								120.50787772500007,
								-23.85048162199996
							],
							[
								120.53733512200006,
								-23.85273063099993
							],
							[
								120.61001621300011,
								-23.812335557999972
							],
							[
								120.67101569400006,
								-23.727936444999955
							],
							[
								121.0047853100001,
								-23.727933823999933
							],
							[
								121.00478135800006,
								-23.440299141999958
							],
							[
								121.9109674990001,
								-23.441013871999928
							],
							[
								122.79163043200003,
								-23.44206627699998
							],
							[
								123.79335933200002,
								-23.443930251999973
							],
							[
								124.78533122400006,
								-23.44143823199994
							],
							[
								126.00133809300007,
								-23.449066202999973
							],
							[
								127.8159379330001,
								-23.44030120599996
							],
							[
								129.00054424600012,
								-23.440298172999974
							],
							[
								129.000481766,
								-22.24680618499997
							],
							[
								129.00052181500007,
								-21.231994907999933
							],
							[
								129.00049298400006,
								-19.10635916299998
							],
							[
								129.0004812730001,
								-18.240764026999955
							],
							[
								129.00047358200004,
								-16.98012857799995
							],
							[
								129.0004656110001,
								-15.940396259999943
							],
							[
								129.00149340000007,
								-14.879594592999979
							]
						],
						[
							[
								113.84014166800011,
								-28.706725742999936
							],
							[
								113.83642176900003,
								-28.723025722999978
							],
							[
								113.83990156700008,
								-28.700645702999964
							],
							[
								113.84014166800011,
								-28.706725742999936
							]
						],
						[
							[
								113.89581653000005,
								-25.95469168699998
							],
							[
								113.90156750900007,
								-25.957391685999937
							],
							[
								113.88720750100003,
								-25.951881706999927
							],
							[
								113.89581653000005,
								-25.95469168699998
							]
						],
						[
							[
								123.40557124100008,
								-16.604452247999973
							],
							[
								123.39635127200006,
								-16.600062237999964
							],
							[
								123.41305133100002,
								-16.606552217999933
							],
							[
								123.40557124100008,
								-16.604452247999973
							]
						],
						[
							[
								123.96075711500009,
								-16.20045817199997
							],
							[
								123.95151804500006,
								-16.200508191999972
							],
							[
								123.97425612400002,
								-16.19855420199997
							],
							[
								123.96075711500009,
								-16.20045817199997
							]
						]
					],
					[
						[
							[
								113.96351368300009,
								-28.95619772599997
							],
							[
								113.954084566,
								-28.977137666999965
							],
							[
								113.962034775,
								-28.98506774599997
							],
							[
								113.95746461400006,
								-28.967077736999954
							],
							[
								113.96723358100007,
								-28.938497695999956
							],
							[
								114.00478371300005,
								-28.90007669299996
							],
							[
								113.9666636710001,
								-28.932817695999972
							],
							[
								113.96351368300009,
								-28.95619772599997
							]
						]
					],
					[
						[
							[
								113.85935165400008,
								-28.691645711999968
							],
							[
								113.86959183200008,
								-28.685965710999938
							],
							[
								113.8597717340001,
								-28.68608568199994
							],
							[
								113.85935165400008,
								-28.691645711999968
							]
						]
					],
					[
						[
							[
								113.78789167500008,
								-28.713936735999937
							],
							[
								113.77992160500003,
								-28.709266726999942
							],
							[
								113.78410158600002,
								-28.722896676999937
							],
							[
								113.78789167500008,
								-28.713936735999937
							]
						]
					],
					[
						[
							[
								113.71966082100005,
								-28.44548373899994
							],
							[
								113.73016059000008,
								-28.443833688999973
							],
							[
								113.7446707260001,
								-28.426343707999933
							],
							[
								113.7361308180001,
								-28.432003707999968
							],
							[
								113.71809088000009,
								-28.430003728999964
							],
							[
								113.71966082100005,
								-28.44548373899994
							]
						]
					],
					[
						[
							[
								113.68624062800006,
								-28.482584711999948
							],
							[
								113.69611073700003,
								-28.48398476099993
							],
							[
								113.69630078600005,
								-28.469764750999957
							],
							[
								113.70834064400003,
								-28.464673709999943
							],
							[
								113.70063089300004,
								-28.440283720999957
							],
							[
								113.68208078600003,
								-28.453993681999975
							],
							[
								113.68624062800006,
								-28.482584711999948
							]
						]
					],
					[
						[
							[
								113.58909963500003,
								-28.30221275699995
							],
							[
								113.59826956400002,
								-28.307982736999975
							],
							[
								113.6030996830001,
								-28.300742685999978
							],
							[
								113.59520954300001,
								-28.289302696999982
							],
							[
								113.58909963500003,
								-28.30221275699995
							]
						]
					],
					[
						[
							[
								113.3382525500001,
								-26.31583076499993
							],
							[
								113.3369227500001,
								-26.309689704999982
							],
							[
								113.3319925510001,
								-26.31684075499993
							],
							[
								113.33950250100008,
								-26.32350075499994
							],
							[
								113.3382525500001,
								-26.31583076499993
							]
						]
					],
					[
						[
							[
								113.70578767200004,
								-26.094447749999972
							],
							[
								113.72108657800004,
								-26.06329668799998
							],
							[
								113.71695666800008,
								-26.05766770899993
							],
							[
								113.70578767200004,
								-26.094447749999972
							]
						]
					],
					[
						[
							[
								113.64178410300008,
								-24.888671557999942
							],
							[
								113.65339406200007,
								-24.88625144699995
							],
							[
								113.64496402200007,
								-24.88087147799996
							],
							[
								113.64178410300008,
								-24.888671557999942
							]
						]
					],
					[
						[
							[
								113.10300787200003,
								-25.17181086499994
							],
							[
								113.11072695600001,
								-25.10675020399998
							],
							[
								113.12824633100001,
								-25.060009682999976
							],
							[
								113.1172758890001,
								-25.031059453999944
							],
							[
								113.12457570700008,
								-25.01236933299998
							],
							[
								113.1183754860001,
								-24.99214924299997
							],
							[
								113.11649573800003,
								-25.016159393999942
							],
							[
								113.10165582100001,
								-25.032669534999968
							],
							[
								113.08766618600009,
								-25.06982976599994
							],
							[
								113.09477700900004,
								-25.121100325999976
							],
							[
								113.08737824600007,
								-25.192041135999943
							],
							[
								113.06930899100007,
								-25.23141164799995
							],
							[
								113.07605952400002,
								-25.273231987999964
							],
							[
								113.08882893900011,
								-25.237531556999954
							],
							[
								113.09112817500011,
								-25.18789108599998
							],
							[
								113.10300787200003,
								-25.17181086499994
							]
						]
					],
					[
						[
							[
								113.01245254000003,
								-25.516734732999964
							],
							[
								113.02166243800002,
								-25.49782475199993
							],
							[
								112.99181266100004,
								-25.499124713999947
							],
							[
								112.970682452,
								-25.48037474599994
							],
							[
								112.9281736800001,
								-25.528525728999966
							],
							[
								112.92246446800004,
								-25.60940674999995
							],
							[
								112.92980448000003,
								-25.643186708999963
							],
							[
								112.94251465000002,
								-25.65793672799998
							],
							[
								112.97960544300008,
								-25.749457725999946
							],
							[
								112.97694543500006,
								-25.77313772699995
							],
							[
								112.96642547700003,
								-25.780298736999953
							],
							[
								113.02297646800002,
								-25.86039874399995
							],
							[
								113.04859764100001,
								-25.931059731999937
							],
							[
								113.13597863900009,
								-26.022329786999933
							],
							[
								113.15750951900009,
								-26.055879725999944
							],
							[
								113.18086057200003,
								-26.12259978399993
							],
							[
								113.20859065000002,
								-26.134839702999955
							],
							[
								113.21629072100006,
								-26.16248976199995
							],
							[
								113.2290904680001,
								-26.143559780999965
							],
							[
								113.22312063800007,
								-26.125499771999955
							],
							[
								113.23663070600003,
								-26.118859750999945
							],
							[
								113.22766057500007,
								-26.105309700999953
							],
							[
								113.23791047400005,
								-26.10633876099996
							],
							[
								113.21974956200006,
								-26.05836876199993
							],
							[
								113.21978953100006,
								-26.036708720999968
							],
							[
								113.21090941200009,
								-26.038158721999935
							],
							[
								113.20380841200006,
								-26.030018751999933
							],
							[
								113.20398839000006,
								-26.00327878199994
							],
							[
								113.16700849200004,
								-25.979808754999965
							],
							[
								113.1680675990001,
								-25.943258773999958
							],
							[
								113.15073759000006,
								-25.941268785999966
							],
							[
								113.15757864200009,
								-25.968938734999938
							],
							[
								113.15128870300009,
								-25.976918765999983
							],
							[
								113.1366885650001,
								-25.97741870699997
							],
							[
								113.12650739100002,
								-25.92241872699998
							],
							[
								113.15601767500004,
								-25.887807774999942
							],
							[
								113.12113765900006,
								-25.880417716999943
							],
							[
								113.10973643900002,
								-25.86795774799998
							],
							[
								113.11476672600008,
								-25.838637717999973
							],
							[
								113.09723650400008,
								-25.789136738999957
							],
							[
								113.076795704,
								-25.768606749999947
							],
							[
								113.06371548200002,
								-25.728256770999963
							],
							[
								113.071115641,
								-25.72039670999993
							],
							[
								113.05408437100004,
								-25.69547671099997
							],
							[
								113.03889347600011,
								-25.618325741999968
							],
							[
								113.00941344400007,
								-25.56117474299998
							],
							[
								113.00560353300011,
								-25.53598474399996
							],
							[
								113.01245254000003,
								-25.516734732999964
							]
						]
					],
					[
						[
							[
								113.641214794,
								-24.89709673799996
							],
							[
								113.64380394200009,
								-24.871061397999938
							],
							[
								113.6284739030001,
								-24.870891508999932
							],
							[
								113.62838400400005,
								-24.877541578999967
							],
							[
								113.61994393400005,
								-24.871711579999953
							],
							[
								113.63472409400003,
								-24.88655160899998
							],
							[
								113.6383742050001,
								-24.901771707999956
							],
							[
								113.641214794,
								-24.89709673799996
							]
						]
					],
					[
						[
							[
								113.1261442770001,
								-24.892728331999933
							],
							[
								113.13060454900005,
								-24.91653851199993
							],
							[
								113.11899543600009,
								-24.986849192999955
							],
							[
								113.1335849510001,
								-24.95219880199994
							],
							[
								113.14979467800003,
								-24.935038530999975
							],
							[
								113.14100455800008,
								-24.921158481999953
							],
							[
								113.13777398400009,
								-24.871058061999975
							],
							[
								113.16507312600004,
								-24.80446724899997
							],
							[
								113.15825258300003,
								-24.75424683999995
							],
							[
								113.14022304800005,
								-24.791267280999932
							],
							[
								113.125523885,
								-24.859998021999957
							],
							[
								113.1261442770001,
								-24.892728331999933
							]
						]
					],
					[
						[
							[
								113.62066341400009,
								-24.86449172899995
							],
							[
								113.61610391400006,
								-24.868341559999976
							],
							[
								113.62869352300004,
								-24.864341638999974
							],
							[
								113.62066341400009,
								-24.86449172899995
							]
						]
					],
					[
						[
							[
								114.30602376000002,
								-21.71163484999994
							],
							[
								114.33453375500005,
								-21.67519423799996
							],
							[
								114.35156374300004,
								-21.666623956999956
							],
							[
								114.3502337220001,
								-21.660183926999935
							],
							[
								114.31762385700006,
								-21.685574508999935
							],
							[
								114.30602376000002,
								-21.71163484999994
							]
						]
					],
					[
						[
							[
								114.35904372100003,
								-21.650933755999972
							],
							[
								114.36979374000009,
								-21.65184367599994
							],
							[
								114.39200365700003,
								-21.63288326399993
							],
							[
								114.39152357600005,
								-21.62611319399997
							],
							[
								114.37534359800009,
								-21.62802337499994
							],
							[
								114.35904372100003,
								-21.650933755999972
							]
						]
					],
					[
						[
							[
								114.55035521500008,
								-21.80904368499995
							],
							[
								114.5555449740001,
								-21.807233674999964
							],
							[
								114.55083508500002,
								-21.803733584999975
							],
							[
								114.55035521500008,
								-21.80904368499995
							]
						]
					],
					[
						[
							[
								114.5152890390001,
								-22.09365067899995
							],
							[
								114.50668902000007,
								-22.106061688999944
							],
							[
								114.51261928000008,
								-22.106061688999944
							],
							[
								114.5152890390001,
								-22.09365067899995
							]
						]
					],
					[
						[
							[
								114.491419242,
								-22.11858264999995
							],
							[
								114.48426929400011,
								-22.13528260099997
							],
							[
								114.490210004,
								-22.13540267099995
							],
							[
								114.491419242,
								-22.11858264999995
							]
						]
					],
					[
						[
							[
								114.4891102250001,
								-22.153123670999946
							],
							[
								114.4859602350001,
								-22.145783630999972
							],
							[
								114.48268998600008,
								-22.150293610999938
							],
							[
								114.4891102250001,
								-22.153123670999946
							]
						]
					],
					[
						[
							[
								114.50355811400004,
								-22.01587862899993
							],
							[
								114.53683899400005,
								-22.061479646999942
							],
							[
								114.54555928200011,
								-22.044438686999968
							],
							[
								114.54228797100006,
								-22.028408596999952
							],
							[
								114.53231814200001,
								-22.02284866699995
							],
							[
								114.54082819000007,
								-22.00741762699994
							],
							[
								114.51035813200008,
								-21.993748608999965
							],
							[
								114.50064822400009,
								-22.008088658999952
							],
							[
								114.50355811400004,
								-22.01587862899993
							]
						]
					],
					[
						[
							[
								114.57072796700004,
								-22.000977594999938
							],
							[
								114.58249815500005,
								-21.992916643999934
							],
							[
								114.57921818500006,
								-21.983886583999947
							],
							[
								114.56614804600008,
								-21.986717624999983
							],
							[
								114.57072796700004,
								-22.000977594999938
							]
						]
					],
					[
						[
							[
								114.54071909400011,
								-22.06012964699994
							],
							[
								114.54809910300003,
								-22.05922963699993
							],
							[
								114.5455592830001,
								-22.04849867699994
							],
							[
								114.54071909400011,
								-22.06012964699994
							]
						]
					],
					[
						[
							[
								114.44623964000004,
								-22.29800314399995
							],
							[
								114.45028963900006,
								-22.295003003999966
							],
							[
								114.44150960000002,
								-22.29360305399996
							],
							[
								114.44623964000004,
								-22.29800314399995
							]
						]
					],
					[
						[
							[
								114.38692926300007,
								-22.40222360799993
							],
							[
								114.38232920200005,
								-22.39533364899995
							],
							[
								114.3772291030001,
								-22.39905362899998
							],
							[
								114.38692926300007,
								-22.40222360799993
							]
						]
					],
					[
						[
							[
								114.16956941600006,
								-22.45507366199996
							],
							[
								114.14761003100011,
								-22.48942524399996
							],
							[
								114.16659922800011,
								-22.473794682999937
							],
							[
								114.1687491560001,
								-22.44548365199995
							],
							[
								114.16956941600006,
								-22.45507366199996
							]
						]
					],
					[
						[
							[
								113.91717640000002,
								-25.859160734999932
							],
							[
								113.90941660800002,
								-25.817429714999946
							],
							[
								113.88074654900004,
								-25.800759736999964
							],
							[
								113.8558363630001,
								-25.81069070899997
							],
							[
								113.85372637600005,
								-25.846220708999965
							],
							[
								113.87356634600008,
								-25.87102066799997
							],
							[
								113.86146637700006,
								-25.86415068799994
							],
							[
								113.85835636700006,
								-25.868210678999958
							],
							[
								113.88005644600003,
								-25.886920696999937
							],
							[
								113.91958660300008,
								-25.89739067499994
							],
							[
								113.91853645900005,
								-25.846299744999953
							],
							[
								113.91717640000002,
								-25.859160734999932
							]
						]
					],
					[
						[
							[
								113.87918848900006,
								-26.040932657999974
							],
							[
								113.88277841700005,
								-26.032232717999932
							],
							[
								113.86885866800003,
								-26.016822738999963
							],
							[
								113.85873834900008,
								-26.014822658999947
							],
							[
								113.85645848800004,
								-26.006372658999965
							],
							[
								113.84684861900007,
								-26.007632659999956
							],
							[
								113.84469759900003,
								-26.000542739999958
							],
							[
								113.83733741000003,
								-26.002132660999962
							],
							[
								113.88039846800007,
								-26.030212667999933
							],
							[
								113.87918848900006,
								-26.040932657999974
							]
						]
					],
					[
						[
							[
								113.86214250600005,
								-26.368465710999942
							],
							[
								113.86842237700012,
								-26.384116699999936
							],
							[
								113.86526158400011,
								-26.34871573099997
							],
							[
								113.86160252600007,
								-26.358655690999967
							],
							[
								113.85845250600005,
								-26.35494572099998
							],
							[
								113.86214250600005,
								-26.368465710999942
							]
						]
					],
					[
						[
							[
								113.76258670100003,
								-26.543977677999976
							],
							[
								113.77575660000002,
								-26.545407686999965
							],
							[
								113.77283553900008,
								-26.531657666999934
							],
							[
								113.75941547100001,
								-26.53518872799998
							],
							[
								113.76258670100003,
								-26.543977677999976
							]
						]
					],
					[
						[
							[
								113.8777383900001,
								-26.05570273799998
							],
							[
								113.87783850900007,
								-26.048432717999958
							],
							[
								113.86567842300008,
								-26.08284268899996
							],
							[
								113.87765849100003,
								-26.068112647999953
							],
							[
								113.87189850100003,
								-26.064292698999964
							],
							[
								113.8777383900001,
								-26.05570273799998
							]
						]
					],
					[
						[
							[
								115.21242105100009,
								-21.598146603999965
							],
							[
								115.22024600100008,
								-21.59880758299994
							],
							[
								115.2479670460001,
								-21.570657581999967
							],
							[
								115.2450370460001,
								-21.564917641999955
							],
							[
								115.22886104800011,
								-21.56926458299995
							],
							[
								115.21242105100009,
								-21.598146603999965
							]
						]
					],
					[
						[
							[
								115.47670781300008,
								-21.51737376799997
							],
							[
								115.48090864300002,
								-21.530113907999976
							],
							[
								115.49168920300008,
								-21.53501377699996
							],
							[
								115.49620794100008,
								-21.510923296999977
							],
							[
								115.48313703100007,
								-21.505813547999935
							],
							[
								115.47786702200005,
								-21.511043537999967
							],
							[
								115.47576714200011,
								-21.505183547999934
							],
							[
								115.47670781300008,
								-21.51737376799997
							]
						]
					],
					[
						[
							[
								115.42583835800008,
								-21.525724620999938
							],
							[
								115.4374383070001,
								-21.52813453999994
							],
							[
								115.46529616200007,
								-21.49339355899997
							],
							[
								115.43508712500011,
								-21.503183569999976
							],
							[
								115.41998798800012,
								-21.518414550999978
							],
							[
								115.42583835800008,
								-21.525724620999938
							]
						]
					],
					[
						[
							[
								115.41272897800002,
								-21.515184611999928
							],
							[
								115.42832812600011,
								-21.502773540999954
							],
							[
								115.41399903800004,
								-21.507494571999928
							],
							[
								115.41272897800002,
								-21.515184611999928
							]
						]
					],
					[
						[
							[
								115.37602698700005,
								-21.44526460299994
							],
							[
								115.36264685900005,
								-21.46341455399994
							],
							[
								115.37322688800009,
								-21.459064583999975
							],
							[
								115.37602698700005,
								-21.44526460299994
							]
						]
					],
					[
						[
							[
								115.35556816100006,
								-21.487064584999928
							],
							[
								115.36146783100003,
								-21.485104564999972
							],
							[
								115.35604696000007,
								-21.468314604999932
							],
							[
								115.35556816100006,
								-21.487064584999928
							]
						]
					],
					[
						[
							[
								114.68343423100009,
								-21.630840605999936
							],
							[
								114.6974241690001,
								-21.625850644999957
							],
							[
								114.68555425900001,
								-21.604980645999944
							],
							[
								114.66500398900007,
								-21.591240596999967
							],
							[
								114.687754229,
								-21.620220605999975
							],
							[
								114.68343423100009,
								-21.630840605999936
							]
						]
					],
					[
						[
							[
								114.97541379300003,
								-21.461726686999953
							],
							[
								115.01679417000003,
								-21.465186594999977
							],
							[
								115.024974068,
								-21.458266573999936
							],
							[
								114.99032411100006,
								-21.450946605999945
							],
							[
								114.97622398300007,
								-21.45472660699994
							],
							[
								114.97541379300003,
								-21.461726686999953
							]
						]
					],
					[
						[
							[
								114.75813420700001,
								-21.528408640999942
							],
							[
								114.7666610760001,
								-21.530214629999932
							],
							[
								114.76583424600005,
								-21.52104861999993
							],
							[
								114.75813420700001,
								-21.528408640999942
							]
						]
					],
					[
						[
							[
								115.32590801000003,
								-20.97394957399996
							],
							[
								115.33757300800005,
								-20.965961592999975
							],
							[
								115.31630799900006,
								-20.947352593999938
							],
							[
								115.32590801000003,
								-20.97394957399996
							]
						]
					],
					[
						[
							[
								115.5422469880001,
								-21.386855582999942
							],
							[
								115.54318900900012,
								-21.393995562999976
							],
							[
								115.54510000800008,
								-21.38093558299994
							],
							[
								115.5422469880001,
								-21.386855582999942
							]
						]
					],
					[
						[
							[
								115.32155040900011,
								-20.80825734299998
							],
							[
								115.30683098400004,
								-20.860427604999927
							],
							[
								115.32104094400006,
								-20.89156761399994
							],
							[
								115.33376072200008,
								-20.876097512999934
							],
							[
								115.32066076400008,
								-20.878137613999968
							],
							[
								115.32174072300006,
								-20.87373757399996
							],
							[
								115.34768065000003,
								-20.864797341999974
							],
							[
								115.36884093900005,
								-20.873467380999955
							],
							[
								115.37428086000011,
								-20.894797380999933
							],
							[
								115.39494077800009,
								-20.886417178999977
							],
							[
								115.40873079500011,
								-20.86697665899993
							],
							[
								115.42074054400007,
								-20.86368677799993
							],
							[
								115.425369982,
								-20.83703660699996
							],
							[
								115.44745992000003,
								-20.828876565999963
							],
							[
								115.44758985800001,
								-20.80218661599997
							],
							[
								115.45353994800007,
								-20.805606615999977
							],
							[
								115.470660124,
								-20.777585553999927
							],
							[
								115.46919993400002,
								-20.766975543999934
							],
							[
								115.4759200630001,
								-20.76605557399995
							],
							[
								115.47093985200001,
								-20.74133554399998
							],
							[
								115.4769288110001,
								-20.73353461399995
							],
							[
								115.4583488500001,
								-20.692364564999934
							],
							[
								115.46868907800001,
								-20.680224533999933
							],
							[
								115.44077909900011,
								-20.666084655999953
							],
							[
								115.43105919000004,
								-20.66836475599996
							],
							[
								115.38097009900002,
								-20.740975539999965
							],
							[
								115.35474985300004,
								-20.758326560999933
							],
							[
								115.35185003400011,
								-20.772366560999956
							],
							[
								115.32155040900011,
								-20.80825734299998
							]
						]
					],
					[
						[
							[
								115.32444117600005,
								-20.921828363999964
							],
							[
								115.31654129800006,
								-20.93825841399996
							],
							[
								115.3360809940001,
								-20.906577632999927
							],
							[
								115.32224092500007,
								-20.894957723999937
							],
							[
								115.32444117600005,
								-20.921828363999964
							]
						]
					],
					[
						[
							[
								115.52581465800006,
								-20.447131689999935
							],
							[
								115.53814515700003,
								-20.44940172899993
							],
							[
								115.53150567000012,
								-20.48077215899997
							],
							[
								115.53223548900007,
								-20.47174212899995
							],
							[
								115.53918500800012,
								-20.470962568999937
							],
							[
								115.53356502800011,
								-20.465312558999983
							],
							[
								115.5406447580001,
								-20.467622398999936
							],
							[
								115.54580504700004,
								-20.454611547999946
							],
							[
								115.54378521600006,
								-20.44343197799998
							],
							[
								115.53395470700002,
								-20.445561778999945
							],
							[
								115.53948470600005,
								-20.433492138999952
							],
							[
								115.53783410500012,
								-20.422092878999933
							],
							[
								115.53157453600011,
								-20.43063210899993
							],
							[
								115.53323382500002,
								-20.413622578999934
							],
							[
								115.52450492700007,
								-20.43776158999998
							],
							[
								115.5306147770001,
								-20.44093203899996
							],
							[
								115.51719477800009,
								-20.441472559999966
							],
							[
								115.52115668200008,
								-20.506032279999943
							],
							[
								115.52501586100004,
								-20.493292089999954
							],
							[
								115.53218592100006,
								-20.504932218999954
							],
							[
								115.53591571000004,
								-20.492742328999952
							],
							[
								115.53028577000009,
								-20.490702298999963
							],
							[
								115.5365156900001,
								-20.491392248999944
							],
							[
								115.53221578000012,
								-20.486082198999952
							],
							[
								115.54157506800004,
								-20.474132478999934
							],
							[
								115.52143594100005,
								-20.48335261999995
							],
							[
								115.52912546900006,
								-20.470502108999938
							],
							[
								115.52436487800003,
								-20.45423157999994
							],
							[
								115.5316649880001,
								-20.457521528999962
							],
							[
								115.53323419800006,
								-20.45120155899997
							],
							[
								115.52581465800006,
								-20.447131689999935
							]
						]
					],
					[
						[
							[
								115.53186405500003,
								-20.40741259899994
							],
							[
								115.52647377500011,
								-20.41101257899993
							],
							[
								115.52169406500002,
								-20.404682529999945
							],
							[
								115.51652412700003,
								-20.415842229999953
							],
							[
								115.54085378400009,
								-20.40234248799993
							],
							[
								115.53186405500003,
								-20.40741259899994
							]
						]
					],
					[
						[
							[
								115.52356432700003,
								-20.427762059999964
							],
							[
								115.52981345600006,
								-20.423022508999964
							],
							[
								115.52622393600006,
								-20.415752518999966
							],
							[
								115.52356432700003,
								-20.427762059999964
							]
						]
					],
					[
						[
							[
								115.51381093400005,
								-20.374390579999954
							],
							[
								115.52216994300011,
								-20.36974657899998
							],
							[
								115.51428992400008,
								-20.368296569999927
							],
							[
								115.51381093400005,
								-20.374390579999954
							]
						]
					],
					[
						[
							[
								115.515893043,
								-20.363021989999936
							],
							[
								115.53951263200008,
								-20.37169229799997
							],
							[
								115.53254266200008,
								-20.361022528999968
							],
							[
								115.515893043,
								-20.363021989999936
							]
						]
					],
					[
						[
							[
								115.52495343400005,
								-20.38866221899997
							],
							[
								115.51774417600006,
								-20.401062319999937
							],
							[
								115.52656367500003,
								-20.40066240899995
							],
							[
								115.52039367500004,
								-20.394752179999955
							],
							[
								115.52495343400005,
								-20.38866221899997
							]
						]
					],
					[
						[
							[
								115.54404501500005,
								-20.43000258799998
							],
							[
								115.54307484600008,
								-20.436881557999982
							],
							[
								115.54933481500007,
								-20.43339243799994
							],
							[
								115.54395395400002,
								-20.415332587999956
							],
							[
								115.54404501500005,
								-20.43000258799998
							]
						]
					],
					[
						[
							[
								115.55020483500005,
								-20.43649181799998
							],
							[
								115.54317515600007,
								-20.44035185799993
							],
							[
								115.54845505600008,
								-20.446981007999966
							],
							[
								115.55020483500005,
								-20.43649181799998
							]
						]
					],
					[
						[
							[
								115.55811314200002,
								-20.391872466999928
							],
							[
								115.58298405100004,
								-20.420351525999934
							],
							[
								115.58301285000005,
								-20.399472515999946
							],
							[
								115.5693728010001,
								-20.395842546999972
							],
							[
								115.55993182100008,
								-20.37799257699993
							],
							[
								115.54999294100003,
								-20.37775253799998
							],
							[
								115.54603299200005,
								-20.381472517999953
							],
							[
								115.55811314200002,
								-20.391872466999928
							]
						]
					],
					[
						[
							[
								115.56851813700007,
								-20.64697310799994
							],
							[
								115.5828983670001,
								-20.661443216999942
							],
							[
								115.58146807700007,
								-20.651283606999982
							],
							[
								115.56586786700007,
								-20.640983567999967
							],
							[
								115.56851813700007,
								-20.64697310799994
							]
						]
					],
					[
						[
							[
								115.86566094400007,
								-20.97961556299998
							],
							[
								115.86506008300012,
								-20.97419585299997
							],
							[
								115.85869039400006,
								-20.977576032999934
							],
							[
								115.86566094400007,
								-20.97961556299998
							]
						]
					],
					[
						[
							[
								115.8534508570001,
								-21.012026523999964
							],
							[
								115.84780083700002,
								-21.012806633999958
							],
							[
								115.85259095700007,
								-21.021616593999966
							],
							[
								115.8534508570001,
								-21.012026523999964
							]
						]
					],
					[
						[
							[
								115.82251186400003,
								-21.081617515999937
							],
							[
								115.83009167300008,
								-21.08129787499996
							],
							[
								115.82625161300007,
								-21.076997825999968
							],
							[
								115.82251186400003,
								-21.081617515999937
							]
						]
					],
					[
						[
							[
								116.59667377300002,
								-20.688875480999968
							],
							[
								116.59350397300011,
								-20.684555470999953
							],
							[
								116.57827383500012,
								-20.69296553199996
							],
							[
								116.57372378600007,
								-20.708285511999975
							],
							[
								116.59075391500005,
								-20.71718551099997
							],
							[
								116.57779393800001,
								-20.733306481999932
							],
							[
								116.60192401500001,
								-20.72836548099997
							],
							[
								116.63706398000011,
								-20.70021547899995
							],
							[
								116.64800401800005,
								-20.68232552799998
							],
							[
								116.6368036990001,
								-20.674695518999954
							],
							[
								116.62839373000008,
								-20.683595538999953
							],
							[
								116.60650786200006,
								-20.685385509999946
							],
							[
								116.59292402500012,
								-20.70593551099995
							],
							[
								116.59667377300002,
								-20.688875480999968
							]
						]
					],
					[
						[
							[
								116.65326687800007,
								-20.67493449799997
							],
							[
								116.6570248380001,
								-20.680099517999963
							],
							[
								116.66154083700008,
								-20.67573149699996
							],
							[
								116.65326687800007,
								-20.67493449799997
							]
						]
					],
					[
						[
							[
								116.43632187500009,
								-20.65936753899996
							],
							[
								116.45173177400011,
								-20.66561753899998
							],
							[
								116.44853200300008,
								-20.651647528999945
							],
							[
								116.4341123150001,
								-20.655307609999966
							],
							[
								116.43632187500009,
								-20.65936753899996
							]
						]
					],
					[
						[
							[
								116.63611486200011,
								-20.55477450799998
							],
							[
								116.64740687100004,
								-20.55704550799993
							],
							[
								116.64935885000011,
								-20.547973516999946
							],
							[
								116.63611486200011,
								-20.55477450799998
							]
						]
					],
					[
						[
							[
								116.61139184600006,
								-20.593355519999932
							],
							[
								116.59709884800009,
								-20.600975519999963
							],
							[
								116.5959188380001,
								-20.606430500999977
							],
							[
								116.60541486700004,
								-20.60363549999994
							],
							[
								116.60011287800012,
								-20.61220555999995
							],
							[
								116.63380273500002,
								-20.60900451899994
							],
							[
								116.64531987300006,
								-20.583243507999953
							],
							[
								116.66956185000004,
								-20.56520450599993
							],
							[
								116.66482386000007,
								-20.55791950699995
							],
							[
								116.67526585900009,
								-20.556049505999965
							],
							[
								116.674811868,
								-20.547167505999937
							],
							[
								116.65860685000007,
								-20.55299950699998
							],
							[
								116.64840985100011,
								-20.566585517999954
							],
							[
								116.64306683200004,
								-20.559644497999955
							],
							[
								116.62425302400004,
								-20.572354538999946
							],
							[
								116.61139184600006,
								-20.593355519999932
							]
						]
					],
					[
						[
							[
								116.54993100200011,
								-20.60474652299996
							],
							[
								116.55911173000004,
								-20.586506501999963
							],
							[
								116.57591183900001,
								-20.59469551199993
							],
							[
								116.5741917790001,
								-20.586236501999963
							],
							[
								116.58509293800012,
								-20.58381549099994
							],
							[
								116.5861319170001,
								-20.575525510999967
							],
							[
								116.57357182900012,
								-20.583076511999934
							],
							[
								116.56622174900008,
								-20.575996491999945
							],
							[
								116.55547177000005,
								-20.585416522999935
							],
							[
								116.55227174000004,
								-20.568375472999946
							],
							[
								116.54246102100001,
								-20.572936482999978
							],
							[
								116.53311180300011,
								-20.59814655399998
							],
							[
								116.52376188400001,
								-20.60112655399996
							],
							[
								116.51270198500004,
								-20.594616504999976
							],
							[
								116.5128809140001,
								-20.582646504999957
							],
							[
								116.49133138600007,
								-20.589396895999982
							],
							[
								116.48591160600006,
								-20.585126815999956
							],
							[
								116.46323186000006,
								-20.609597547999954
							],
							[
								116.50143071700006,
								-20.621526485999937
							],
							[
								116.5300708740001,
								-20.615436543999976
							],
							[
								116.54893093300007,
								-20.621676522999962
							],
							[
								116.56087070100011,
								-20.609325551999973
							],
							[
								116.56075084100007,
								-20.60292547199998
							],
							[
								116.54993100200011,
								-20.60474652299996
							]
						]
					],
					[
						[
							[
								116.54785684800004,
								-20.541195512999934
							],
							[
								116.5497218480001,
								-20.536132522999935
							],
							[
								116.54316684900004,
								-20.537171522999927
							],
							[
								116.54785684800004,
								-20.541195512999934
							]
						]
					],
					[
						[
							[
								116.61008196800003,
								-20.45511352899996
							],
							[
								116.60002175900001,
								-20.45651454999995
							],
							[
								116.58275182200009,
								-20.478724480999972
							],
							[
								116.56607194300011,
								-20.48573449099996
							],
							[
								116.58090182300009,
								-20.491374530999963
							],
							[
								116.58645194300004,
								-20.501314479999962
							],
							[
								116.60237079100011,
								-20.493314469999973
							],
							[
								116.60888173900003,
								-20.477254508999977
							],
							[
								116.61656198900005,
								-20.480034528999965
							],
							[
								116.61916188800001,
								-20.47381452899998
							],
							[
								116.60606185900008,
								-20.466084528999943
							],
							[
								116.61008196800003,
								-20.45511352899996
							]
						]
					],
					[
						[
							[
								116.62755684700005,
								-20.460223497999948
							],
							[
								116.63425685600009,
								-20.458613497999977
							],
							[
								116.62608684700001,
								-20.45334349799998
							],
							[
								116.62755684700005,
								-20.460223497999948
							]
						]
					],
					[
						[
							[
								116.65805085200009,
								-20.593752506999977
							],
							[
								116.64856585300004,
								-20.598221517999946
							],
							[
								116.63516086700008,
								-20.63193550899996
							],
							[
								116.64994369500005,
								-20.621234537999953
							],
							[
								116.66702083400003,
								-20.628245516999982
							],
							[
								116.67711484100005,
								-20.59944450599994
							],
							[
								116.66953587100011,
								-20.596454506999976
							],
							[
								116.68054284000004,
								-20.583147505999932
							],
							[
								116.66818285200009,
								-20.596651506999933
							],
							[
								116.65805085200009,
								-20.593752506999977
							]
						]
					],
					[
						[
							[
								116.65968586800011,
								-20.52324450699996
							],
							[
								116.67068583700006,
								-20.51765351599994
							],
							[
								116.65564585800007,
								-20.51689451699997
							],
							[
								116.65968586800011,
								-20.52324450699996
							]
						]
					],
					[
						[
							[
								116.67479583600004,
								-20.518957505999936
							],
							[
								116.6797358560001,
								-20.523677505999956
							],
							[
								116.68929582500004,
								-20.51843750499995
							],
							[
								116.69064483400007,
								-20.503407514999935
							],
							[
								116.6850458450001,
								-20.508627514999944
							],
							[
								116.67929482500006,
								-20.501057515999946
							],
							[
								116.67479583600004,
								-20.518957505999936
							]
						]
					],
					[
						[
							[
								116.67470386500008,
								-20.660219506999965
							],
							[
								116.68318384400004,
								-20.66169251599996
							],
							[
								116.69661186200005,
								-20.644731514999933
							],
							[
								116.67477186400004,
								-20.650959496999974
							],
							[
								116.67470386500008,
								-20.660219506999965
							]
						]
					],
					[
						[
							[
								116.78659481700004,
								-20.51110148999993
							],
							[
								116.79820784600008,
								-20.518585498999983
							],
							[
								116.82744083000011,
								-20.46567549699995
							],
							[
								116.802598063,
								-20.474632998999937
							],
							[
								116.78659481700004,
								-20.51110148999993
							]
						]
					],
					[
						[
							[
								116.30880305300002,
								-20.778288506999957
							],
							[
								116.31422242300005,
								-20.78166856699994
							],
							[
								116.30881487300007,
								-20.770613526999966
							],
							[
								116.30880305300002,
								-20.778288506999957
							]
						]
					],
					[
						[
							[
								116.2433417310001,
								-20.812549530999945
							],
							[
								116.24792190100004,
								-20.818519460999937
							],
							[
								116.24502989000007,
								-20.801959540999974
							],
							[
								116.2433417310001,
								-20.812549530999945
							]
						]
					],
					[
						[
							[
								116.06630962600002,
								-20.821782320999944
							],
							[
								116.07138937600007,
								-20.82234269999998
							],
							[
								116.06133978700007,
								-20.818052490999946
							],
							[
								116.06630962600002,
								-20.821782320999944
							]
						]
					],
					[
						[
							[
								115.88200042000005,
								-20.94992504199996
							],
							[
								115.90196073900006,
								-20.955784490999974
							],
							[
								115.90087051800003,
								-20.937614400999962
							],
							[
								115.89089017900005,
								-20.93445462099993
							],
							[
								115.88200042000005,
								-20.94992504199996
							]
						]
					],
					[
						[
							[
								116.15665088600008,
								-20.93487249599997
							],
							[
								116.14680099700001,
								-20.935902486999964
							],
							[
								116.15238119700007,
								-20.948312486999953
							],
							[
								116.15903083600006,
								-20.945742525999947
							],
							[
								116.15665088600008,
								-20.93487249599997
							]
						]
					],
					[
						[
							[
								123.0842222980001,
								-16.447765234999963
							],
							[
								123.08970222800008,
								-16.44951518499994
							],
							[
								123.08287227800008,
								-16.44322518499996
							],
							[
								123.0842222980001,
								-16.447765234999963
							]
						]
					],
					[
						[
							[
								123.10111205700002,
								-16.426015184999926
							],
							[
								123.09079229700001,
								-16.427035254999964
							],
							[
								123.10385203600003,
								-16.431355244999963
							],
							[
								123.10413210700005,
								-16.437465264999958
							],
							[
								123.12992216500004,
								-16.435595243999956
							],
							[
								123.10111205700002,
								-16.426015184999926
							]
						]
					],
					[
						[
							[
								123.12046205500008,
								-16.413675203999958
							],
							[
								123.12717619500006,
								-16.42287422399994
							],
							[
								123.12497214400003,
								-16.408525233999967
							],
							[
								123.13649916300005,
								-16.40086523399998
							],
							[
								123.12506218400006,
								-16.398477213999968
							],
							[
								123.12046205500008,
								-16.413675203999958
							]
						]
					],
					[
						[
							[
								123.13238200300009,
								-16.384975193999935
							],
							[
								123.12349221400007,
								-16.384885193999935
							],
							[
								123.13680211300004,
								-16.387735223999982
							],
							[
								123.13238200300009,
								-16.384975193999935
							]
						]
					],
					[
						[
							[
								123.34919129800005,
								-16.346053237999968
							],
							[
								123.34937127800004,
								-16.339723187999937
							],
							[
								123.3346912290001,
								-16.332803267999964
							],
							[
								123.33967106900002,
								-16.33805322799998
							],
							[
								123.3315912490001,
								-16.338083197999936
							],
							[
								123.33594113900006,
								-16.358703187999936
							],
							[
								123.35742123800003,
								-16.361393197999973
							],
							[
								123.34919129800005,
								-16.346053237999968
							]
						]
					],
					[
						[
							[
								123.15237210200007,
								-16.387905242999977
							],
							[
								123.14346212300006,
								-16.389395272999934
							],
							[
								123.1456321930001,
								-16.394395222999947
							],
							[
								123.15811227200004,
								-16.39814525299994
							],
							[
								123.15237210200007,
								-16.387905242999977
							]
						]
					],
					[
						[
							[
								123.15244229300004,
								-16.422725242999945
							],
							[
								123.16706226200006,
								-16.404005232999964
							],
							[
								123.15937229200006,
								-16.400645262999944
							],
							[
								123.15244229300004,
								-16.422725242999945
							]
						]
					],
					[
						[
							[
								123.20177203900005,
								-16.389444241999968
							],
							[
								123.19115204000002,
								-16.397024201999955
							],
							[
								123.1871722200001,
								-16.386354251999933
							],
							[
								123.16758213100002,
								-16.389655192999953
							],
							[
								123.1788720510001,
								-16.40604527299996
							],
							[
								123.16614209200009,
								-16.423095242999977
							],
							[
								123.17384213200012,
								-16.43301421299998
							],
							[
								123.18385229100011,
								-16.421244202999958
							],
							[
								123.18536215100005,
								-16.43245424299994
							],
							[
								123.19250203100012,
								-16.43275422199997
							],
							[
								123.19264204000001,
								-16.421004251999932
							],
							[
								123.21145205800008,
								-16.39305421199998
							],
							[
								123.20177203900005,
								-16.389444241999968
							]
						]
					],
					[
						[
							[
								123.22231219800005,
								-16.406504180999946
							],
							[
								123.22280516800004,
								-16.396614220999936
							],
							[
								123.21331417800002,
								-16.392457221999962
							],
							[
								123.19939206000004,
								-16.424694261999946
							],
							[
								123.21335213900011,
								-16.42257422199998
							],
							[
								123.22231219800005,
								-16.406504180999946
							]
						]
					],
					[
						[
							[
								123.3447312510001,
								-16.425482217999956
							],
							[
								123.34590122100008,
								-16.447312248999935
							],
							[
								123.35969107000005,
								-16.439082197999937
							],
							[
								123.35581130000003,
								-16.42977223799994
							],
							[
								123.36193117900007,
								-16.42673821799997
							],
							[
								123.34774119000008,
								-16.416922227999976
							],
							[
								123.3447312510001,
								-16.425482217999956
							]
						]
					],
					[
						[
							[
								123.39965104600003,
								-16.380562216999976
							],
							[
								123.40254111500008,
								-16.37177217699997
							],
							[
								123.38333116700005,
								-16.37317222699994
							],
							[
								123.39965104600003,
								-16.380562216999976
							]
						]
					],
					[
						[
							[
								123.42155126300008,
								-16.344822225999962
							],
							[
								123.4188710630001,
								-16.332362255999954
							],
							[
								123.41477106400009,
								-16.343522175999965
							],
							[
								123.42155126300008,
								-16.344822225999962
							]
						]
					],
					[
						[
							[
								123.42265108400011,
								-16.36371222599996
							],
							[
								123.43354217300009,
								-16.365873215999954
							],
							[
								123.4174121640001,
								-16.361085215999935
							],
							[
								123.42265108400011,
								-16.36371222599996
							]
						]
					],
					[
						[
							[
								123.38738117100002,
								-16.526612237999927
							],
							[
								123.40048121000007,
								-16.52832223799993
							],
							[
								123.39829131900001,
								-16.513042217999953
							],
							[
								123.3800911410001,
								-16.51716223799997
							],
							[
								123.38738117100002,
								-16.526612237999927
							]
						]
					],
					[
						[
							[
								123.38310115000002,
								-16.509282197999937
							],
							[
								123.38806121000005,
								-16.50548222799995
							],
							[
								123.37998102000006,
								-16.504732257999933
							],
							[
								123.38310115000002,
								-16.509282197999937
							]
						]
					],
					[
						[
							[
								123.36346134400003,
								-16.584042238999928
							],
							[
								123.38798131300007,
								-16.604622177999943
							],
							[
								123.39023128200006,
								-16.579542217999972
							],
							[
								123.36469109300003,
								-16.556012188999944
							],
							[
								123.35862115300006,
								-16.53097219899996
							],
							[
								123.35242122300008,
								-16.53012224899993
							],
							[
								123.34905125400007,
								-16.549302228999977
							],
							[
								123.36346134400003,
								-16.584042238999928
							]
						]
					],
					[
						[
							[
								123.45306102600011,
								-16.53198117599993
							],
							[
								123.44144128700009,
								-16.521811196999977
							],
							[
								123.42934131800007,
								-16.52486217699993
							],
							[
								123.45306102600011,
								-16.53198117599993
							]
						]
					],
					[
						[
							[
								123.51792111400005,
								-16.58750217499994
							],
							[
								123.52466033400003,
								-16.605882264999934
							],
							[
								123.53798035200009,
								-16.597402194999972
							],
							[
								123.52725124300002,
								-16.579561214999956
							],
							[
								123.51834123300011,
								-16.58027123499994
							],
							[
								123.51792111400005,
								-16.58750217499994
							]
						]
					],
					[
						[
							[
								123.47947132700006,
								-16.61112223599997
							],
							[
								123.49341125500007,
								-16.60028218599996
							],
							[
								123.48299105600006,
								-16.59861224599996
							],
							[
								123.47947132700006,
								-16.61112223599997
							]
						]
					],
					[
						[
							[
								123.48153124100008,
								-16.412981204999937
							],
							[
								123.50104107000004,
								-16.415521183999942
							],
							[
								123.47128131200009,
								-16.407351244999973
							],
							[
								123.48153124100008,
								-16.412981204999937
							]
						]
					],
					[
						[
							[
								123.55833219700003,
								-16.452549172999966
							],
							[
								123.56422216700003,
								-16.453259252999942
							],
							[
								123.55250128800003,
								-16.450239222999926
							],
							[
								123.55833219700003,
								-16.452549172999966
							]
						]
					],
					[
						[
							[
								123.55389015200001,
								-16.603712173999952
							],
							[
								123.55262006200007,
								-16.60878222399998
							],
							[
								123.55959003100008,
								-16.605852193999965
							],
							[
								123.55287027100007,
								-16.597202203999927
							],
							[
								123.55389015200001,
								-16.603712173999952
							]
						]
					],
					[
						[
							[
								123.60980212300001,
								-16.421568201999946
							],
							[
								123.62145208300001,
								-16.428338261999954
							],
							[
								123.62749107200011,
								-16.421378200999982
							],
							[
								123.613141143,
								-16.414478171999974
							],
							[
								123.60980212300001,
								-16.421568201999946
							]
						]
					],
					[
						[
							[
								124.39987712400011,
								-16.534727154999928
							],
							[
								124.40540709400011,
								-16.531027174999963
							],
							[
								124.39521695400003,
								-16.529167214999973
							],
							[
								124.39987712400011,
								-16.534727154999928
							]
						]
					],
					[
						[
							[
								124.27330611900004,
								-16.39591419599998
							],
							[
								124.28574111800003,
								-16.397676195999964
							],
							[
								124.27139709900007,
								-16.391687185999956
							],
							[
								124.27330611900004,
								-16.39591419599998
							]
						]
					],
					[
						[
							[
								123.63450097100008,
								-16.41024818099993
							],
							[
								123.66560312900003,
								-16.418808199999944
							],
							[
								123.62217098200006,
								-16.400538250999944
							],
							[
								123.63450097100008,
								-16.41024818099993
							]
						]
					],
					[
						[
							[
								124.24156211100001,
								-16.375538206999977
							],
							[
								124.23086812100007,
								-16.370675206999977
							],
							[
								124.22496720100003,
								-16.35831716699994
							],
							[
								124.23106704100007,
								-16.355297226999937
							],
							[
								124.2216371610001,
								-16.347557216999974
							],
							[
								124.22205695200012,
								-16.355137196999976
							],
							[
								124.21609715200009,
								-16.354307216999928
							],
							[
								124.22342708200006,
								-16.380907166999975
							],
							[
								124.23968721200004,
								-16.402477206999947
							],
							[
								124.24806312100009,
								-16.40372119699998
							],
							[
								124.25991511000007,
								-16.38482520699995
							],
							[
								124.24743696000007,
								-16.378787216999967
							],
							[
								124.24514699100007,
								-16.38905720699995
							],
							[
								124.24156211100001,
								-16.375538206999977
							]
						]
					],
					[
						[
							[
								124.3510762630001,
								-16.34892719499993
							],
							[
								124.35446412300007,
								-16.359627184999965
							],
							[
								124.3593111020001,
								-16.34229520399998
							],
							[
								124.3510762630001,
								-16.34892719499993
							]
						]
					],
					[
						[
							[
								124.35166409300007,
								-16.36457519499993
							],
							[
								124.34204601400006,
								-16.35294722499998
							],
							[
								124.3410661040001,
								-16.359837184999947
							],
							[
								124.35166409300007,
								-16.36457519499993
							]
						]
					],
					[
						[
							[
								124.35915612300005,
								-16.371227224999927
							],
							[
								124.3586560330001,
								-16.37597722499993
							],
							[
								124.36771909200002,
								-16.364526183999942
							],
							[
								124.35915612300005,
								-16.371227224999927
							]
						]
					],
					[
						[
							[
								124.71150461000002,
								-16.381005166999955
							],
							[
								124.7207544800001,
								-16.37820507699996
							],
							[
								124.71085448000008,
								-16.36025493699998
							],
							[
								124.6965743610001,
								-16.369555187999936
							],
							[
								124.67949452200003,
								-16.368595237999955
							],
							[
								124.68882465200011,
								-16.37720528799997
							],
							[
								124.71150461000002,
								-16.381005166999955
							]
						]
					],
					[
						[
							[
								124.69190444100002,
								-16.364685187999953
							],
							[
								124.70318466000003,
								-16.356864996999946
							],
							[
								124.69289443100001,
								-16.349334977999945
							],
							[
								124.67298463200007,
								-16.356155267999952
							],
							[
								124.69190444100002,
								-16.364685187999953
							]
						]
					],
					[
						[
							[
								124.56773502900012,
								-16.34653579999997
							],
							[
								124.65013472400005,
								-16.350265397999976
							],
							[
								124.60757481600001,
								-16.341645548999963
							],
							[
								124.56773502900012,
								-16.34653579999997
							]
						]
					],
					[
						[
							[
								124.44398576800006,
								-16.37728647299997
							],
							[
								124.45477567700004,
								-16.37382641299996
							],
							[
								124.46468542600007,
								-16.35579635199997
							],
							[
								124.44449552700007,
								-16.36847645299997
							],
							[
								124.43326571800003,
								-16.36807657299994
							],
							[
								124.44398576800006,
								-16.37728647299997
							]
						]
					],
					[
						[
							[
								123.65864414800001,
								-16.345221209999977
							],
							[
								123.64816010800007,
								-16.335649239999952
							],
							[
								123.62267114000008,
								-16.330258210999943
							],
							[
								123.65048015900004,
								-16.347833209999976
							],
							[
								123.65864414800001,
								-16.345221209999977
							]
						]
					],
					[
						[
							[
								123.62213105100011,
								-16.35328925099998
							],
							[
								123.62914131000002,
								-16.35458921099996
							],
							[
								123.62782009000011,
								-16.345079170999952
							],
							[
								123.60047016100009,
								-16.32743925099993
							],
							[
								123.60642025100003,
								-16.342869220999944
							],
							[
								123.62213105100011,
								-16.35328925099998
							]
						]
					],
					[
						[
							[
								123.65924019800002,
								-16.35325918999996
							],
							[
								123.67268004700009,
								-16.355629239999928
							],
							[
								123.66888024700006,
								-16.34881919999998
							],
							[
								123.65391002800004,
								-16.34744922999994
							],
							[
								123.65924019800002,
								-16.35325918999996
							]
						]
					],
					[
						[
							[
								123.69225002600001,
								-16.353529178999963
							],
							[
								123.67875002700009,
								-16.344939219999958
							],
							[
								123.68825006600002,
								-16.356209198999977
							],
							[
								123.69843013600007,
								-16.356409178999968
							],
							[
								123.69225002600001,
								-16.353529178999963
							]
						]
					],
					[
						[
							[
								123.60457130200007,
								-16.378678241999978
							],
							[
								123.61006130200008,
								-16.379968211999937
							],
							[
								123.60265107200007,
								-16.371089171999927
							],
							[
								123.60457130200007,
								-16.378678241999978
							]
						]
					],
					[
						[
							[
								123.60660614200003,
								-16.37234921199996
							],
							[
								123.61558120200004,
								-16.378329220999944
							],
							[
								123.5925781730001,
								-16.35655520199998
							],
							[
								123.60660614200003,
								-16.37234921199996
							]
						]
					],
					[
						[
							[
								123.77377021900008,
								-16.279009176999978
							],
							[
								123.78147999800001,
								-16.279749246999927
							],
							[
								123.76868017900006,
								-16.27138922699993
							],
							[
								123.77377021900008,
								-16.279009176999978
							]
						]
					],
					[
						[
							[
								123.74718997000002,
								-16.266369216999976
							],
							[
								123.76013017000002,
								-16.271779206999952
							],
							[
								123.76518022900007,
								-16.269669246999968
							],
							[
								123.75402996000003,
								-16.262979186999928
							],
							[
								123.7661590890001,
								-16.26549917699998
							],
							[
								123.74562003000005,
								-16.258669186999953
							],
							[
								123.74718997000002,
								-16.266369216999976
							]
						]
					],
					[
						[
							[
								123.81756813600009,
								-16.26954720599997
							],
							[
								123.8240911150001,
								-16.261912215999928
							],
							[
								123.82021514500002,
								-16.255106205999937
							],
							[
								123.82642314500004,
								-16.25839319599993
							],
							[
								123.82596911500002,
								-16.24809920599995
							],
							[
								123.83037912400005,
								-16.252539184999932
							],
							[
								123.83544900400011,
								-16.24748918499995
							],
							[
								123.83107897400009,
								-16.223659174999966
							],
							[
								123.83133925400011,
								-16.235019244999933
							],
							[
								123.8226290340001,
								-16.22749919499995
							],
							[
								123.82767910400003,
								-16.239739204999978
							],
							[
								123.81513923500006,
								-16.241909195999938
							],
							[
								123.81050928500008,
								-16.23610922599994
							],
							[
								123.81566918500005,
								-16.24903917599994
							],
							[
								123.80411926600004,
								-16.245219215999953
							],
							[
								123.81109894600002,
								-16.25012924599997
							],
							[
								123.80876903600006,
								-16.263109235999934
							],
							[
								123.81756813600009,
								-16.26954720599997
							]
						]
					],
					[
						[
							[
								123.82211927600008,
								-16.276209175999952
							],
							[
								123.8293192650001,
								-16.267789235999942
							],
							[
								123.82181906500011,
								-16.269319245999952
							],
							[
								123.82211927600008,
								-16.276209175999952
							]
						]
					],
					[
						[
							[
								123.87773929200011,
								-16.286799204999966
							],
							[
								123.88633894200007,
								-16.284509163999928
							],
							[
								123.88322929200001,
								-16.273269153999934
							],
							[
								123.85740901300005,
								-16.25318916499998
							],
							[
								123.86355926300007,
								-16.273579204999976
							],
							[
								123.87773929200011,
								-16.286799204999966
							]
						]
					],
					[
						[
							[
								123.84750900400002,
								-16.277079214999958
							],
							[
								123.85636898400003,
								-16.280989174999945
							],
							[
								123.85152911400007,
								-16.270669244999965
							],
							[
								123.84750900400002,
								-16.277079214999958
							]
						]
					],
					[
						[
							[
								123.8747790330001,
								-16.305309164999926
							],
							[
								123.88518912300003,
								-16.319709244999956
							],
							[
								123.87283895300004,
								-16.299419184999977
							],
							[
								123.87662903300009,
								-16.293799234999938
							],
							[
								123.86483906300009,
								-16.289869204999945
							],
							[
								123.8747790330001,
								-16.305309164999926
							]
						]
					],
					[
						[
							[
								124.22049599000002,
								-16.283927226999936
							],
							[
								124.22490212000002,
								-16.281056186999933
							],
							[
								124.21456609000006,
								-16.277787236999927
							],
							[
								124.22049599000002,
								-16.283927226999936
							]
						]
					],
					[
						[
							[
								124.39052612000012,
								-16.324486153999942
							],
							[
								124.39603594000005,
								-16.322366202999945
							],
							[
								124.39256625000007,
								-16.31601617299998
							],
							[
								124.3861060800001,
								-16.32084621399997
							],
							[
								124.39052612000012,
								-16.324486153999942
							]
						]
					],
					[
						[
							[
								124.21008411100001,
								-16.27815318699993
							],
							[
								124.21464011000012,
								-16.27473320699994
							],
							[
								124.20653627100012,
								-16.270167196999978
							],
							[
								124.21008411100001,
								-16.27815318699993
							]
						]
					],
					[
						[
							[
								124.14184717500007,
								-16.26865719799997
							],
							[
								124.14666718400008,
								-16.265747217999944
							],
							[
								124.13663724500009,
								-16.26522818899997
							],
							[
								124.14184717500007,
								-16.26865719799997
							]
						]
					],
					[
						[
							[
								124.10471010700007,
								-16.257691188999956
							],
							[
								124.11382309600003,
								-16.256836198999963
							],
							[
								124.1131771260001,
								-16.250848168999937
							],
							[
								124.14538910400006,
								-16.24976819799997
							],
							[
								124.1345211150001,
								-16.24529618899993
							],
							[
								124.13954012400006,
								-16.24094219799997
							],
							[
								124.12345727500008,
								-16.235428198999955
							],
							[
								124.11796511600005,
								-16.239887198999952
							],
							[
								124.11995812500004,
								-16.230988198999967
							],
							[
								124.11308711600009,
								-16.229148168999927
							],
							[
								124.11348707600007,
								-16.240228168999977
							],
							[
								124.10107510700004,
								-16.236756198999956
							],
							[
								124.10540722600001,
								-16.24108821899995
							],
							[
								124.09761717700007,
								-16.251098198999955
							],
							[
								124.10471010700007,
								-16.257691188999956
							]
						]
					],
					[
						[
							[
								123.90834899000004,
								-16.277299183999958
							],
							[
								123.94005814800005,
								-16.278199162999954
							],
							[
								123.8805980410001,
								-16.234369173999937
							],
							[
								123.87628812100002,
								-16.232419233999963
							],
							[
								123.88495800100009,
								-16.246379223999952
							],
							[
								123.86186799200004,
								-16.23569919499994
							],
							[
								123.89715806000004,
								-16.25697924399998
							],
							[
								123.90043908000007,
								-16.271819163999965
							],
							[
								123.91202819000011,
								-16.27064917399997
							],
							[
								123.9034591200001,
								-16.273869183999977
							],
							[
								123.90834899000004,
								-16.277299183999958
							]
						]
					],
					[
						[
							[
								124.06569113900002,
								-16.242872189999957
							],
							[
								124.0604871490001,
								-16.240238159999933
							],
							[
								124.07447912900011,
								-16.25545520999998
							],
							[
								124.08219110800007,
								-16.25074419999993
							],
							[
								124.06569113900002,
								-16.242872189999957
							]
						]
					],
					[
						[
							[
								124.0942472370001,
								-16.230618238999966
							],
							[
								124.07428710800002,
								-16.230230199999937
							],
							[
								124.08589702800009,
								-16.237908239999967
							],
							[
								124.0942472370001,
								-16.230618238999966
							]
						]
					],
					[
						[
							[
								124.09471596500009,
								-16.143928158999927
							],
							[
								124.08780611500003,
								-16.144558178999944
							],
							[
								124.07924602600008,
								-16.131618238999977
							],
							[
								124.08135598600006,
								-16.14689816899994
							],
							[
								124.07488606600009,
								-16.135548178999954
							],
							[
								124.06925601600005,
								-16.13833817899996
							],
							[
								124.07009310600006,
								-16.12910220899994
							],
							[
								124.06280511700004,
								-16.13998020899993
							],
							[
								124.07200110600002,
								-16.141908198999943
							],
							[
								124.06530718700003,
								-16.152328238999928
							],
							[
								124.09485309500008,
								-16.165381208999975
							],
							[
								124.0996610950001,
								-16.157306198999947
							],
							[
								124.09218622500009,
								-16.15475822899998
							],
							[
								124.09471596500009,
								-16.143928158999927
							]
						]
					],
					[
						[
							[
								124.07345723700007,
								-16.17408815899995
							],
							[
								124.0848472460001,
								-16.167938178999975
							],
							[
								124.08032708600001,
								-16.16146817899994
							],
							[
								124.06824693700003,
								-16.16636823899995
							],
							[
								124.07345723700007,
								-16.17408815899995
							]
						]
					],
					[
						[
							[
								123.94652805600003,
								-16.226698202999955
							],
							[
								123.96569807500009,
								-16.228758211999946
							],
							[
								123.93943826700001,
								-16.22065821299998
							],
							[
								123.94652805600003,
								-16.226698202999955
							]
						]
					],
					[
						[
							[
								123.87724822000007,
								-16.19907918399997
							],
							[
								123.87039815100002,
								-16.20750920399996
							],
							[
								123.87522831100011,
								-16.218729163999967
							],
							[
								123.89066798900001,
								-16.20290921399993
							],
							[
								123.8839982390001,
								-16.18872919399996
							],
							[
								123.88164818000007,
								-16.197789213999954
							],
							[
								123.8707880500001,
								-16.187839173999976
							],
							[
								123.8675980910001,
								-16.191889173999982
							],
							[
								123.87724822000007,
								-16.19907918399997
							]
						]
					],
					[
						[
							[
								123.8810381190001,
								-16.172592193999947
							],
							[
								123.87602821000007,
								-16.176119203999974
							],
							[
								123.8909021390001,
								-16.191778213999953
							],
							[
								123.89371511900003,
								-16.187042213999973
							],
							[
								123.8810381190001,
								-16.172592193999947
							]
						]
					],
					[
						[
							[
								123.84147829300002,
								-16.211019214999965
							],
							[
								123.84142825200001,
								-16.18807921499996
							],
							[
								123.8308982530001,
								-16.203029194999942
							],
							[
								123.83327820300008,
								-16.212879234999946
							],
							[
								123.84147829300002,
								-16.211019214999965
							]
						]
					],
					[
						[
							[
								123.86664803100007,
								-16.209059193999963
							],
							[
								123.85983827200005,
								-16.21138921399995
							],
							[
								123.86998815100003,
								-16.214509233999934
							],
							[
								123.86664803100007,
								-16.209059193999963
							]
						]
					],
					[
						[
							[
								123.84416414300006,
								-16.23186921499996
							],
							[
								123.83691926300003,
								-16.225339214999963
							],
							[
								123.84245813300004,
								-16.24331120499994
							],
							[
								123.84416414300006,
								-16.23186921499996
							]
						]
					],
					[
						[
							[
								123.81823922400008,
								-16.206329224999934
							],
							[
								123.81158928400009,
								-16.20401920599994
							],
							[
								123.81871908400001,
								-16.218649244999938
							],
							[
								123.81823922400008,
								-16.206329224999934
							]
						]
					],
					[
						[
							[
								123.81338822400005,
								-16.198999174999926
							],
							[
								123.80784818400002,
								-16.188499235999927
							],
							[
								123.79698804500003,
								-16.187059235999982
							],
							[
								123.81338822400005,
								-16.198999174999926
							]
						]
					],
					[
						[
							[
								123.78043814600005,
								-16.18014922599997
							],
							[
								123.79207908600006,
								-16.20080924599995
							],
							[
								123.8084590850001,
								-16.200599195999928
							],
							[
								123.78421811600003,
								-16.18039923599997
							],
							[
								123.7772582660001,
								-16.16353918599998
							],
							[
								123.7723680260001,
								-16.16505918599995
							],
							[
								123.78043814600005,
								-16.18014922599997
							]
						]
					],
					[
						[
							[
								123.82850820200008,
								-16.15101918499994
							],
							[
								123.83297795200008,
								-16.152969204999977
							],
							[
								123.82443805200012,
								-16.148049194999942
							],
							[
								123.82850820200008,
								-16.15101918499994
							]
						]
					],
					[
						[
							[
								123.76637797600006,
								-16.154829165999956
							],
							[
								123.7765980160001,
								-16.160249215999954
							],
							[
								123.75917794600002,
								-16.149009215999968
							],
							[
								123.77805815500005,
								-16.14237918599997
							],
							[
								123.77449813500004,
								-16.14811921599994
							],
							[
								123.78903816500008,
								-16.159819205999952
							],
							[
								123.78279830500003,
								-16.148629235999977
							],
							[
								123.79742797400002,
								-16.147499205999964
							],
							[
								123.78445825400001,
								-16.132249225999942
							],
							[
								123.79080830400005,
								-16.128119235999975
							],
							[
								123.78534815400008,
								-16.123439235999967
							],
							[
								123.79180800400002,
								-16.120559224999965
							],
							[
								123.78870805400004,
								-16.11363920599996
							],
							[
								123.77760818400009,
								-16.11252924599995
							],
							[
								123.77690797500009,
								-16.125639175999936
							],
							[
								123.7363179670001,
								-16.113789246999943
							],
							[
								123.73207826700002,
								-16.117829166999968
							],
							[
								123.72730823800009,
								-16.11529917699994
							],
							[
								123.73200804700002,
								-16.112399196999945
							],
							[
								123.71065824800007,
								-16.106239226999946
							],
							[
								123.7017781290001,
								-16.106389167999964
							],
							[
								123.70745821900005,
								-16.111859196999944
							],
							[
								123.68289828000002,
								-16.111999237999953
							],
							[
								123.70540801900006,
								-16.118969187999937
							],
							[
								123.70918802900007,
								-16.113909216999957
							],
							[
								123.70936800900006,
								-16.120019226999943
							],
							[
								123.76637797600006,
								-16.154829165999956
							]
						]
					],
					[
						[
							[
								123.57312815900002,
								-16.15891820099995
							],
							[
								123.58504313800006,
								-16.162630210999964
							],
							[
								123.58869927800004,
								-16.15755022099995
							],
							[
								123.59521915700009,
								-16.164878219999935
							],
							[
								123.59127715700004,
								-16.145233219999966
							],
							[
								123.57541213800005,
								-16.146630210999945
							],
							[
								123.57900914800007,
								-16.15566022099995
							],
							[
								123.57091515900004,
								-16.153800220999926
							],
							[
								123.57312815900002,
								-16.15891820099995
							]
						]
					],
					[
						[
							[
								123.50811001300008,
								-16.158761182999967
							],
							[
								123.50875011300002,
								-16.164761212999963
							],
							[
								123.52010019200009,
								-16.164411191999932
							],
							[
								123.51782033200004,
								-16.158731211999964
							],
							[
								123.52315009200004,
								-16.162961191999955
							],
							[
								123.52550920100009,
								-16.14908122199995
							],
							[
								123.51938917200005,
								-16.14089121199993
							],
							[
								123.50811001300008,
								-16.158761182999967
							]
						]
					],
					[
						[
							[
								123.46062997600006,
								-16.15776118399998
							],
							[
								123.45930017600006,
								-16.150401253999974
							],
							[
								123.44277903700004,
								-16.14154121399997
							],
							[
								123.45002004600008,
								-16.154271243999972
							],
							[
								123.46062997600006,
								-16.15776118399998
							]
						]
					],
					[
						[
							[
								123.55942011100001,
								-16.22410118199997
							],
							[
								123.56397012100001,
								-16.22618124199994
							],
							[
								123.55702899100004,
								-16.217191241999956
							],
							[
								123.55942011100001,
								-16.22410118199997
							]
						]
					],
					[
						[
							[
								123.56213016100003,
								-16.235211221999975
							],
							[
								123.5645302910001,
								-16.241331231999936
							],
							[
								123.58008915000005,
								-16.24135021099994
							],
							[
								123.54765028200006,
								-16.219371231999958
							],
							[
								123.56213016100003,
								-16.235211221999975
							]
						]
					],
					[
						[
							[
								123.5743802510001,
								-16.258180211999957
							],
							[
								123.56673025200007,
								-16.268820191999964
							],
							[
								123.57539006100001,
								-16.268670251999936
							],
							[
								123.5743802510001,
								-16.258180211999957
							]
						]
					],
					[
						[
							[
								123.55454031200009,
								-16.25831125199994
							],
							[
								123.56750033200001,
								-16.261590231999946
							],
							[
								123.57299030100012,
								-16.249660191999965
							],
							[
								123.56426034100002,
								-16.245061181999972
							],
							[
								123.55992016200003,
								-16.257801221999955
							],
							[
								123.56708018200004,
								-16.255270241999938
							],
							[
								123.56459008200011,
								-16.25987023199997
							],
							[
								123.54653032300007,
								-16.251461251999956
							],
							[
								123.55454031200009,
								-16.25831125199994
							]
						]
					],
					[
						[
							[
								123.53670017400009,
								-16.263581202999944
							],
							[
								123.503400166,
								-16.25842123299998
							],
							[
								123.52445515500006,
								-16.277839222999944
							],
							[
								123.5292402340001,
								-16.27233118299995
							],
							[
								123.54666996300011,
								-16.273501171999953
							],
							[
								123.54044916300006,
								-16.255429211999967
							],
							[
								123.53670017400009,
								-16.263581202999944
							]
						]
					],
					[
						[
							[
								123.51507027600007,
								-16.29866123299996
							],
							[
								123.52172021500007,
								-16.275881242999958
							],
							[
								123.51253013600001,
								-16.28247121299995
							],
							[
								123.51507027600007,
								-16.29866123299996
							]
						]
					],
					[
						[
							[
								123.45789003800007,
								-16.23325120399994
							],
							[
								123.47979028700001,
								-16.24408118399998
							],
							[
								123.4787199970001,
								-16.257631213999957
							],
							[
								123.48910023700012,
								-16.27242118399994
							],
							[
								123.48308032800003,
								-16.278251203999957
							],
							[
								123.48980004700002,
								-16.284751193999966
							],
							[
								123.50664016600001,
								-16.274281212999938
							],
							[
								123.5057801160001,
								-16.266361212999982
							],
							[
								123.49134016700009,
								-16.259101183999974
							],
							[
								123.49705011600008,
								-16.249661172999936
							],
							[
								123.53168033400004,
								-16.259741172999952
							],
							[
								123.52127016400004,
								-16.24954119299997
							],
							[
								123.49068024600001,
								-16.243271173999972
							],
							[
								123.47808026700011,
								-16.22688117399997
							],
							[
								123.48805012600008,
								-16.22482125399995
							],
							[
								123.47384020700008,
								-16.220131193999975
							],
							[
								123.47972006600003,
								-16.215361193999968
							],
							[
								123.46826019700006,
								-16.21492126399994
							],
							[
								123.46667007700012,
								-16.209141193999926
							],
							[
								123.4525001180001,
								-16.211271223999972
							],
							[
								123.446430168,
								-16.221391194999967
							],
							[
								123.45789003800007,
								-16.23325120399994
							]
						]
					],
					[
						[
							[
								123.43826034100005,
								-16.27828216499995
							],
							[
								123.44761215000005,
								-16.274518214999944
							],
							[
								123.44280999000011,
								-16.267702224999937
							],
							[
								123.46013814900004,
								-16.269987214999958
							],
							[
								123.43865614000003,
								-16.261924214999965
							],
							[
								123.43826034100005,
								-16.27828216499995
							]
						]
					],
					[
						[
							[
								123.42211000200007,
								-16.278022245999978
							],
							[
								123.4293521510001,
								-16.28195621499998
							],
							[
								123.43605417100002,
								-16.276453224999955
							],
							[
								123.4332301610001,
								-16.269822214999976
							],
							[
								123.42211000200007,
								-16.278022245999978
							]
						]
					],
					[
						[
							[
								123.42052024200007,
								-16.27314225599997
							],
							[
								123.41550003200007,
								-16.28361224599996
							],
							[
								123.42987716100004,
								-16.287054224999963
							],
							[
								123.42052024200007,
								-16.27314225599997
							]
						]
					],
					[
						[
							[
								123.31233126000006,
								-16.321843258999934
							],
							[
								123.31912120900006,
								-16.321793207999974
							],
							[
								123.30898107000007,
								-16.30699324899996
							],
							[
								123.31233126000006,
								-16.321843258999934
							]
						]
					],
					[
						[
							[
								123.30106108000007,
								-16.314153188999967
							],
							[
								123.30645100000004,
								-16.31409324899994
							],
							[
								123.30524103000005,
								-16.306623178999928
							],
							[
								123.29998108000007,
								-16.30622320899994
							],
							[
								123.30106108000007,
								-16.314153188999967
							]
						]
					],
					[
						[
							[
								123.29588104000004,
								-16.30607325899996
							],
							[
								123.29746109000007,
								-16.300773248999974
							],
							[
								123.29161109100005,
								-16.30071321899993
							],
							[
								123.29588104000004,
								-16.30607325899996
							]
						]
					],
					[
						[
							[
								123.4252402090001,
								-16.17597125499998
							],
							[
								123.43170004800004,
								-16.173881174999963
							],
							[
								123.42296033900004,
								-16.17007121499995
							],
							[
								123.4252402090001,
								-16.17597125499998
							]
						]
					],
					[
						[
							[
								123.43416025800002,
								-16.161471173999928
							],
							[
								123.42831028800003,
								-16.162211224999965
							],
							[
								123.46109009600002,
								-16.17031123399994
							],
							[
								123.45537014600006,
								-16.154791213999943
							],
							[
								123.43902026700005,
								-16.155071173999943
							],
							[
								123.43416025800002,
								-16.161471173999928
							]
						]
					],
					[
						[
							[
								123.33228025400001,
								-16.161732176999976
							],
							[
								123.34600024400004,
								-16.169552176999957
							],
							[
								123.34236028300006,
								-16.16059221699993
							],
							[
								123.35199514300007,
								-16.16411620699995
							],
							[
								123.34408216300005,
								-16.14847621699994
							],
							[
								123.33388012400007,
								-16.154402216999927
							],
							[
								123.32252034400005,
								-16.144902256999956
							],
							[
								123.32725001400001,
								-16.150832176999927
							],
							[
								123.3198602550001,
								-16.15290217699993
							],
							[
								123.33228025400001,
								-16.161732176999976
							]
						]
					],
					[
						[
							[
								123.31439215500006,
								-16.143857216999947
							],
							[
								123.32947015400009,
								-16.14054321699996
							],
							[
								123.30868417500005,
								-16.13523321699995
							],
							[
								123.31439215500006,
								-16.143857216999947
							]
						]
					],
					[
						[
							[
								123.30745000500008,
								-16.132772236999926
							],
							[
								123.2899701560001,
								-16.12528822799993
							],
							[
								123.30256217500005,
								-16.137789217999966
							],
							[
								123.31736216400009,
								-16.134777206999956
							],
							[
								123.30745000500008,
								-16.132772236999926
							]
						]
					],
					[
						[
							[
								123.29490903300007,
								-16.03723220699993
							],
							[
								123.27753905400004,
								-16.043392237999967
							],
							[
								123.29492918300002,
								-16.045942226999955
							],
							[
								123.313769062,
								-16.03335121699996
							],
							[
								123.29490903300007,
								-16.03723220699993
							]
						]
					],
					[
						[
							[
								123.36415898900009,
								-16.054761225999982
							],
							[
								123.3581790500001,
								-16.05674122599993
							],
							[
								123.36115913000003,
								-16.06197121599996
							],
							[
								123.37626902900001,
								-16.058841204999965
							],
							[
								123.36162927900011,
								-16.050031185999956
							],
							[
								123.36415898900009,
								-16.054761225999982
							]
						]
					],
					[
						[
							[
								123.40777911700002,
								-16.087061234999965
							],
							[
								123.41937903700011,
								-16.08457120399993
							],
							[
								123.38924919800002,
								-16.06981120499995
							],
							[
								123.40777911700002,
								-16.087061234999965
							]
						]
					],
					[
						[
							[
								123.38410911800008,
								-16.058231184999954
							],
							[
								123.37802905800004,
								-16.058971234999944
							],
							[
								123.42417925600012,
								-16.072411203999934
							],
							[
								123.38410911800008,
								-16.058231184999954
							]
						]
					],
					[
						[
							[
								123.44212922600002,
								-16.113611223999953
							],
							[
								123.44677914500005,
								-16.111762203999945
							],
							[
								123.43509914600008,
								-16.09128124399996
							],
							[
								123.4414531750001,
								-16.093460213999947
							],
							[
								123.43897923500003,
								-16.088831183999957
							],
							[
								123.44638516500004,
								-16.086106223999934
							],
							[
								123.43254614500006,
								-16.07593821399996
							],
							[
								123.43232930600004,
								-16.08741125399996
							],
							[
								123.42449928600001,
								-16.087781233999976
							],
							[
								123.44212922600002,
								-16.113611223999953
							]
						]
					],
					[
						[
							[
								123.40027923900004,
								-16.134471254999937
							],
							[
								123.40807899800006,
								-16.126401224999938
							],
							[
								123.41459216800001,
								-16.137476204999928
							],
							[
								123.42252901800009,
								-16.13174119499996
							],
							[
								123.39576915900011,
								-16.107521214999963
							],
							[
								123.39997898900003,
								-16.118191254999942
							],
							[
								123.38990907900006,
								-16.119451254999944
							],
							[
								123.39536918900001,
								-16.12390120499998
							],
							[
								123.38877904000003,
								-16.127801174999945
							],
							[
								123.40027923900004,
								-16.134471254999937
							]
						]
					],
					[
						[
							[
								123.59838115500008,
								-16.088333209999973
							],
							[
								123.58514814600005,
								-16.08112921999998
							],
							[
								123.61456514500003,
								-16.10328420999997
							],
							[
								123.62722013400003,
								-16.107135208999978
							],
							[
								123.64068213300004,
								-16.100143198999945
							],
							[
								123.60387615500008,
								-16.084422219999965
							],
							[
								123.59838115500008,
								-16.088333209999973
							]
						]
					],
					[
						[
							[
								124.10069310400002,
								-16.125212187999978
							],
							[
								124.10252612400006,
								-16.116135207999946
							],
							[
								124.09601511400001,
								-16.12067419899995
							],
							[
								124.10069310400002,
								-16.125212187999978
							]
						]
					],
					[
						[
							[
								124.07039616600002,
								-16.108508228999938
							],
							[
								124.06254713600003,
								-16.11315420899996
							],
							[
								124.06515710600002,
								-16.11987219899993
							],
							[
								124.0789162850001,
								-16.11104819899998
							],
							[
								124.07805620500005,
								-16.116578238999978
							],
							[
								124.08589596500008,
								-16.11674815899994
							],
							[
								124.08937605400001,
								-16.099508218999972
							],
							[
								124.09223626400001,
								-16.112828218999937
							],
							[
								124.1003860940001,
								-16.116159197999934
							],
							[
								124.1006361530001,
								-16.09671723799994
							],
							[
								124.06915596500005,
								-16.081418218999943
							],
							[
								124.07641607500011,
								-16.09313820899996
							],
							[
								124.05781111600004,
								-16.10542819899996
							],
							[
								124.06282110600011,
								-16.10978820899993
							],
							[
								124.06649628600007,
								-16.10281823899993
							],
							[
								124.07039616600002,
								-16.108508228999938
							]
						]
					],
					[
						[
							[
								124.06411911500004,
								-16.088570198999946
							],
							[
								124.06695600500007,
								-16.08192823899998
							],
							[
								124.06110709600011,
								-16.083987198999978
							],
							[
								124.06411911500004,
								-16.088570198999946
							]
						]
					],
					[
						[
							[
								123.55109799800005,
								-16.064870200999962
							],
							[
								123.56286818700005,
								-16.06870023099998
							],
							[
								123.55545828700008,
								-16.061400240999944
							],
							[
								123.55109799800005,
								-16.064870200999962
							]
						]
					],
					[
						[
							[
								123.54795913900011,
								-16.09988021099997
							],
							[
								123.5571092880001,
								-16.096570190999955
							],
							[
								123.55027827800006,
								-16.077070240999944
							],
							[
								123.56406804700009,
								-16.07809021099996
							],
							[
								123.52999800900011,
								-16.05835024099997
							],
							[
								123.52240816000005,
								-16.069810211999936
							],
							[
								123.52563914000007,
								-16.08668026199996
							],
							[
								123.53852929900006,
								-16.095730210999932
							],
							[
								123.53544912900009,
								-16.087560190999966
							],
							[
								123.54032928900006,
								-16.091000170999962
							],
							[
								123.54388898900004,
								-16.085380200999964
							],
							[
								123.55243896800005,
								-16.095960240999943
							],
							[
								123.54795913900011,
								-16.09988021099997
							]
						]
					],
					[
						[
							[
								124.2291352310001,
								-15.93357522399998
							],
							[
								124.2124550320001,
								-15.918635214999938
							],
							[
								124.21928494200006,
								-15.943035214999952
							],
							[
								124.2291352310001,
								-15.93357522399998
							]
						]
					],
					[
						[
							[
								124.45576496900003,
								-16.026324169999953
							],
							[
								124.4703550380001,
								-16.006384219999973
							],
							[
								124.46361512800001,
								-15.999124189999975
							],
							[
								124.45576496900003,
								-16.026324169999953
							]
						]
					],
					[
						[
							[
								124.45100506800009,
								-15.963494169999933
							],
							[
								124.44901497900003,
								-15.984624209999936
							],
							[
								124.45608499800005,
								-15.97521415999995
							],
							[
								124.45551511800011,
								-15.955454199999963
							],
							[
								124.46884521600009,
								-15.936074228999928
							],
							[
								124.46327490600004,
								-15.897134208999944
							],
							[
								124.46076498600007,
								-15.908094148999965
							],
							[
								124.4529450770001,
								-15.907794168999942
							],
							[
								124.45440526700008,
								-15.91976416999995
							],
							[
								124.46026497600008,
								-15.91859416899996
							],
							[
								124.45087505700008,
								-15.938644199999942
							],
							[
								124.45100506800009,
								-15.963494169999933
							]
						]
					],
					[
						[
							[
								124.20952499300006,
								-15.945556194999938
							],
							[
								124.21445519300005,
								-15.951946204999956
							],
							[
								124.22010499200007,
								-15.946475174999932
							],
							[
								124.21216522200007,
								-15.935235164999938
							],
							[
								124.20952499300006,
								-15.945556194999938
							]
						]
					],
					[
						[
							[
								123.696536175,
								-15.933899226999927
							],
							[
								123.68442613600007,
								-15.958889166999938
							],
							[
								123.68922708600007,
								-15.967129196999963
							],
							[
								123.69166608600005,
								-15.957859206999956
							],
							[
								123.70159598500004,
								-15.959319186999949
							],
							[
								123.69352623600003,
								-15.95683923699994
							],
							[
								123.7029661250001,
								-15.939999245999957
							],
							[
								123.69150625500004,
								-15.926229256999932
							],
							[
								123.696536175,
								-15.933899226999927
							]
						]
					],
					[
						[
							[
								124.18564508500003,
								-15.957386234999944
							],
							[
								124.1769050150001,
								-15.937966235999966
							],
							[
								124.17484510500003,
								-15.948366175999979
							],
							[
								124.18564508500003,
								-15.957386234999944
							]
						]
					],
					[
						[
							[
								124.19418499300002,
								-15.920666164999943
							],
							[
								124.19002523300003,
								-15.91667619499998
							],
							[
								124.19281522400001,
								-15.933726234999938
							],
							[
								124.1853351640001,
								-15.924536154999942
							],
							[
								124.20107506400007,
								-15.964986204999946
							],
							[
								124.2339149820001,
								-15.971195214999966
							],
							[
								124.23314494200008,
								-15.952675193999937
							],
							[
								124.21130517300003,
								-15.954336234999971
							],
							[
								124.20492526300006,
								-15.923485224999979
							],
							[
								124.19418499300002,
								-15.920666164999943
							]
						]
					],
					[
						[
							[
								124.07203523200008,
								-15.975357177999967
							],
							[
								124.0791650320001,
								-15.975337197999977
							],
							[
								124.06547494300003,
								-15.968937217999951
							],
							[
								124.07203523200008,
								-15.975357177999967
							]
						]
					],
					[
						[
							[
								123.51709813900004,
								-16.026800200999958
							],
							[
								123.50843796900006,
								-16.024290191999967
							],
							[
								123.53019816900007,
								-16.050430250999966
							],
							[
								123.53857827800005,
								-16.053900200999976
							],
							[
								123.54273806800006,
								-16.046250190999956
							],
							[
								123.55197815700001,
								-16.046450170999947
							],
							[
								123.54489806700008,
								-16.04039020099998
							],
							[
								123.54042831800007,
								-16.044080190999978
							],
							[
								123.54236799700004,
								-16.036750240999936
							],
							[
								123.53661807800006,
								-16.038740220999955
							],
							[
								123.53354799800002,
								-16.030000230999974
							],
							[
								123.527067998,
								-16.035030250999966
							],
							[
								123.52200818800009,
								-16.026850240999977
							],
							[
								123.52939826800002,
								-16.02364021099993
							],
							[
								123.52209815800006,
								-16.01724023099996
							],
							[
								123.51709813900004,
								-16.026800200999958
							]
						]
					],
					[
						[
							[
								123.15801315700003,
								-15.52181922699998
							],
							[
								123.15857514700008,
								-15.509183226999937
							],
							[
								123.15246314700005,
								-15.51189121699997
							],
							[
								123.1560339780001,
								-15.535615216999929
							],
							[
								123.16732316700006,
								-15.52770322699996
							],
							[
								123.15927013700002,
								-15.51609121699994
							],
							[
								123.16292404700005,
								-15.523305196999956
							],
							[
								123.15801315700003,
								-15.52181922699998
							]
						]
					],
					[
						[
							[
								124.36912304000009,
								-15.377483217999952
							],
							[
								124.36686296000005,
								-15.366314207999949
							],
							[
								124.3528629110001,
								-15.360724207999965
							],
							[
								124.33767307200003,
								-15.376034197999957
							],
							[
								124.37167399000009,
								-15.399163217999956
							],
							[
								124.36674416100004,
								-15.391724177999947
							],
							[
								124.37489420000009,
								-15.39079322799995
							],
							[
								124.36346419100005,
								-15.38677417799994
							],
							[
								124.36912304000009,
								-15.377483217999952
							]
						]
					],
					[
						[
							[
								124.29592894400002,
								-15.363766218999956
							],
							[
								124.3077109940001,
								-15.36959614899996
							],
							[
								124.30549018400006,
								-15.36309616899996
							],
							[
								124.29592894400002,
								-15.363766218999956
							]
						]
					],
					[
						[
							[
								124.18857803000003,
								-15.33726816099994
							],
							[
								124.20686817900003,
								-15.337748210999962
							],
							[
								124.20827791900001,
								-15.330328160999954
							],
							[
								124.18857803000003,
								-15.33726816099994
							]
						]
					],
					[
						[
							[
								124.22134809800002,
								-15.318968179999956
							],
							[
								124.2135580480001,
								-15.318018150999933
							],
							[
								124.22950817700007,
								-15.32311816999993
							],
							[
								124.2271480170001,
								-15.314208169999972
							],
							[
								124.22134809800002,
								-15.318968179999956
							]
						]
					],
					[
						[
							[
								124.28166715300006,
								-15.29355722899993
							],
							[
								124.27637695300007,
								-15.279687148999926
							],
							[
								124.25439716500011,
								-15.28620718999997
							],
							[
								124.23046798700011,
								-15.300298219999945
							],
							[
								124.23125207700002,
								-15.319371179999962
							],
							[
								124.24231307600007,
								-15.32015918999997
							],
							[
								124.24912714600009,
								-15.308138199999973
							],
							[
								124.25819308500002,
								-15.307999199999927
							],
							[
								124.25687722500004,
								-15.301658209999971
							],
							[
								124.26113206500008,
								-15.30870318999996
							],
							[
								124.26580698500004,
								-15.304917208999939
							],
							[
								124.26182210500008,
								-15.311341179999943
							],
							[
								124.27209907400004,
								-15.30636218899997
							],
							[
								124.28064409400008,
								-15.31210219899998
							],
							[
								124.28694691300007,
								-15.302577198999927
							],
							[
								124.28166715300006,
								-15.29355722899993
							]
						]
					],
					[
						[
							[
								124.38502605600002,
								-15.23892722599993
							],
							[
								124.3925759650001,
								-15.234147225999948
							],
							[
								124.38890611600004,
								-15.245577235999974
							],
							[
								124.39578606600003,
								-15.249617145999935
							],
							[
								124.39975613500008,
								-15.227796195999929
							],
							[
								124.39465602500002,
								-15.23221717599995
							],
							[
								124.3850962460001,
								-15.227177165999933
							],
							[
								124.38502605600002,
								-15.23892722599993
							]
						]
					],
					[
						[
							[
								124.30509708300008,
								-15.353620198999977
							],
							[
								124.3163999630001,
								-15.358346148999942
							],
							[
								124.32822020200001,
								-15.343895207999935
							],
							[
								124.33467409100001,
								-15.346875187999956
							],
							[
								124.34005408100006,
								-15.333047197999974
							],
							[
								124.34981009000012,
								-15.332834187999936
							],
							[
								124.34438926000007,
								-15.31297615799997
							],
							[
								124.30509708300008,
								-15.353620198999977
							]
						]
					],
					[
						[
							[
								124.37808017800012,
								-15.322435146999965
							],
							[
								124.38366018800002,
								-15.320285156999944
							],
							[
								124.39188115800005,
								-15.332444146999933
							],
							[
								124.39756807700007,
								-15.30710617699998
							],
							[
								124.40282910700012,
								-15.312846196999942
							],
							[
								124.41278707600009,
								-15.292847205999976
							],
							[
								124.41875803500011,
								-15.307296175999966
							],
							[
								124.42748803500001,
								-15.305566185999965
							],
							[
								124.41823908600009,
								-15.316347185999973
							],
							[
								124.4433179340001,
								-15.306566185999941
							],
							[
								124.43303023500005,
								-15.322875175999968
							],
							[
								124.4419081640001,
								-15.311785175999944
							],
							[
								124.46196308300011,
								-15.305783184999939
							],
							[
								124.45769598300001,
								-15.295766174999926
							],
							[
								124.45044708300009,
								-15.30187219499993
							],
							[
								124.44919600300011,
								-15.295016204999968
							],
							[
								124.44187724400001,
								-15.298216155999967
							],
							[
								124.44986600300001,
								-15.290386154999965
							],
							[
								124.44215625300001,
								-15.272206144999927
							],
							[
								124.4528359730001,
								-15.278956154999946
							],
							[
								124.4571761520001,
								-15.26964619499995
							],
							[
								124.44175592300007,
								-15.249756194999975
							],
							[
								124.41749623500004,
								-15.26386621599994
							],
							[
								124.41603714500002,
								-15.274146185999939
							],
							[
								124.39969711600008,
								-15.289477155999975
							],
							[
								124.39093722700011,
								-15.284767186999943
							],
							[
								124.37957707800001,
								-15.294417156999941
							],
							[
								124.37814715700006,
								-15.28605715699996
							],
							[
								124.36930699800007,
								-15.288357206999933
							],
							[
								124.36706816900005,
								-15.308356186999958
							],
							[
								124.35948798900006,
								-15.306016196999963
							],
							[
								124.36046717900001,
								-15.291447166999944
							],
							[
								124.35001711900009,
								-15.295667187999982
							],
							[
								124.3428581500001,
								-15.30981616799994
							],
							[
								124.35257997000008,
								-15.322205217999965
							],
							[
								124.37380124900005,
								-15.329345176999936
							],
							[
								124.37808017800012,
								-15.322435146999965
							]
						]
					],
					[
						[
							[
								124.39134296800012,
								-15.346213166999974
							],
							[
								124.40122314700011,
								-15.34244422699993
							],
							[
								124.39212201800001,
								-15.337964216999978
							],
							[
								124.39134296800012,
								-15.346213166999974
							]
						]
					],
					[
						[
							[
								124.44731108700012,
								-15.888110188999974
							],
							[
								124.45587807600009,
								-15.876906178999945
							],
							[
								124.45325503600009,
								-15.86917417899997
							],
							[
								124.44197708700005,
								-15.87455118899993
							],
							[
								124.44731108700012,
								-15.888110188999974
							]
						]
					],
					[
						[
							[
								124.45162494600004,
								-15.85505416899997
							],
							[
								124.45349517600005,
								-15.863364138999941
							],
							[
								124.45170524500008,
								-15.834634158999961
							],
							[
								124.45162494600004,
								-15.85505416899997
							]
						]
					],
					[
						[
							[
								124.49815601000012,
								-15.286766163999971
							],
							[
								124.49929616000009,
								-15.28134620399993
							],
							[
								124.49233590100005,
								-15.285216203999937
							],
							[
								124.49815601000012,
								-15.286766163999971
							]
						]
					],
					[
						[
							[
								124.56925599600004,
								-15.266265172999965
							],
							[
								124.57694599500007,
								-15.269195202999981
							],
							[
								124.5679560850001,
								-15.25553518299995
							],
							[
								124.56925599600004,
								-15.266265172999965
							]
						]
					],
					[
						[
							[
								124.61258704300008,
								-15.283045201999983
							],
							[
								124.60793106400001,
								-15.286929181999938
							],
							[
								124.61404708300006,
								-15.284832171999938
							],
							[
								124.61641907300009,
								-15.291744181999945
							],
							[
								124.63003915200011,
								-15.281203181999956
							],
							[
								124.63948604200004,
								-15.282068180999943
							],
							[
								124.62057306200006,
								-15.265880181999933
							],
							[
								124.61258704300008,
								-15.283045201999983
							]
						]
					],
					[
						[
							[
								124.53557624700011,
								-15.239536142999953
							],
							[
								124.54627614600008,
								-15.233866152999951
							],
							[
								124.54509606600004,
								-15.227426212999944
							],
							[
								124.53557624700011,
								-15.239536142999953
							]
						]
					],
					[
						[
							[
								124.50471592800011,
								-15.221716153999978
							],
							[
								124.51622620800003,
								-15.21548616399997
							],
							[
								124.50910614800011,
								-15.205436153999926
							],
							[
								124.49813622900001,
								-15.21221619399995
							],
							[
								124.50471592800011,
								-15.221716153999978
							]
						]
					],
					[
						[
							[
								124.67191289300001,
								-14.945054178999953
							],
							[
								124.66974315300001,
								-14.938714208999954
							],
							[
								124.65871310300008,
								-14.93786414899995
							],
							[
								124.6653731130001,
								-14.949984188999963
							],
							[
								124.67191289300001,
								-14.945054178999953
							]
						]
					],
					[
						[
							[
								124.64529088900008,
								-15.174513210999976
							],
							[
								124.65063222900005,
								-15.169072179999944
							],
							[
								124.64387213900011,
								-15.161972170999945
							],
							[
								124.64529088900008,
								-15.174513210999976
							]
						]
					],
					[
						[
							[
								124.74555305800004,
								-14.951484216999972
							],
							[
								124.76261487800002,
								-14.954523156999926
							],
							[
								124.7565431380001,
								-14.94059313699995
							],
							[
								124.74667302800003,
								-14.939294166999957
							],
							[
								124.74555305800004,
								-14.951484216999972
							]
						]
					],
					[
						[
							[
								124.77619590600011,
								-14.938903205999964
							],
							[
								124.77129519700009,
								-14.941353196999955
							],
							[
								124.77552700700005,
								-14.953572226999938
							],
							[
								124.77619590600011,
								-14.938903205999964
							]
						]
					],
					[
						[
							[
								124.69415405200004,
								-14.955924187999926
							],
							[
								124.68393292200005,
								-14.937334147999934
							],
							[
								124.6857030320001,
								-14.950224227999968
							],
							[
								124.69415405200004,
								-14.955924187999926
							]
						]
					],
					[
						[
							[
								124.7179230380001,
								-14.872154166999962
							],
							[
								124.73216211700003,
								-14.860374166999975
							],
							[
								124.71486195800003,
								-14.859594216999938
							],
							[
								124.7179230380001,
								-14.872154166999962
							]
						]
					],
					[
						[
							[
								124.73301209700003,
								-14.855414166999935
							],
							[
								124.7379322270001,
								-14.848104186999933
							],
							[
								124.73060189700004,
								-14.850544166999953
							],
							[
								124.73301209700003,
								-14.855414166999935
							]
						]
					],
					[
						[
							[
								124.7357829980001,
								-14.915064196999936
							],
							[
								124.73887289900006,
								-14.941964196999947
							],
							[
								124.74791322700003,
								-14.90700415699996
							],
							[
								124.73465295800008,
								-14.909524146999956
							],
							[
								124.7357829980001,
								-14.915064196999936
							]
						]
					],
					[
						[
							[
								124.81999995500007,
								-14.979911175999973
							],
							[
								124.8285499640001,
								-14.969341215999975
							],
							[
								124.82262006400003,
								-14.969421205999936
							],
							[
								124.81999995500007,
								-14.979911175999973
							]
						]
					],
					[
						[
							[
								124.78026101800003,
								-15.015941146999978
							],
							[
								124.7729511980001,
								-15.017871196999977
							],
							[
								124.77485094800011,
								-15.035381216999951
							],
							[
								124.78990106700007,
								-15.01309019699994
							],
							[
								124.78026101800003,
								-15.015941146999978
							]
						]
					],
					[
						[
							[
								124.8664100630001,
								-15.023070204999954
							],
							[
								124.85986996300005,
								-15.011111194999955
							],
							[
								124.84445006400006,
								-15.024601215999951
							],
							[
								124.85446996400003,
								-15.03113015599996
							],
							[
								124.85723006300009,
								-15.021401154999978
							],
							[
								124.8664100630001,
								-15.023070204999954
							]
						]
					],
					[
						[
							[
								124.80154096100011,
								-15.22255115799993
							],
							[
								124.80757098000004,
								-15.216431177999937
							],
							[
								124.7994209310001,
								-15.214421207999976
							],
							[
								124.80546102000005,
								-15.211801197999932
							],
							[
								124.79997099000002,
								-15.203791197999976
							],
							[
								124.78349200200012,
								-15.218861167999933
							],
							[
								124.80154096100011,
								-15.22255115799993
							]
						]
					],
					[
						[
							[
								124.80856097100002,
								-15.237781157999962
							],
							[
								124.7997521320001,
								-15.260111137999957
							],
							[
								124.7926921620001,
								-15.260531157999935
							],
							[
								124.79079207300003,
								-15.287321198999962
							],
							[
								124.81179195200002,
								-15.306131197999946
							],
							[
								124.81232189100001,
								-15.289521157999957
							],
							[
								124.83814217000008,
								-15.281321167999977
							],
							[
								124.83410119000007,
								-15.272491167999931
							],
							[
								124.8422011890001,
								-15.280071156999952
							],
							[
								124.85044120900011,
								-15.270901146999961
							],
							[
								124.84797085900004,
								-15.262541226999929
							],
							[
								124.85368120800001,
								-15.264791136999975
							],
							[
								124.85737117800011,
								-15.256191186999956
							],
							[
								124.83637096900009,
								-15.237711136999962
							],
							[
								124.8304410390001,
								-15.237621226999977
							],
							[
								124.83360321900011,
								-15.246369706999928
							],
							[
								124.82790089000002,
								-15.245311177999952
							],
							[
								124.81145104000007,
								-15.228621217999944
							],
							[
								124.80856097100002,
								-15.237781157999962
							]
						]
					],
					[
						[
							[
								124.85379209900009,
								-15.30026113699995
							],
							[
								124.84173209000005,
								-15.314531167999974
							],
							[
								124.86232192900002,
								-15.310631196999964
							],
							[
								124.85990091800011,
								-15.283301166999934
							],
							[
								124.8490019090001,
								-15.29338116699995
							],
							[
								124.85379209900009,
								-15.30026113699995
							]
						]
					],
					[
						[
							[
								124.84380208100004,
								-15.342091147999952
							],
							[
								124.84859190000009,
								-15.349201147999963
							],
							[
								124.85917194000001,
								-15.34442114799998
							],
							[
								124.85229005000008,
								-15.33699817799993
							],
							[
								124.84380208100004,
								-15.342091147999952
							]
						]
					],
					[
						[
							[
								124.63141290400006,
								-15.375102161999962
							],
							[
								124.63571307400002,
								-15.369892161999928
							],
							[
								124.629763034,
								-15.367422181999927
							],
							[
								124.63141290400006,
								-15.375102161999962
							]
						]
					],
					[
						[
							[
								124.50364408200005,
								-15.384641194999972
							],
							[
								124.50078007200011,
								-15.393379184999958
							],
							[
								124.51064408200011,
								-15.401064184999939
							],
							[
								124.51580208100006,
								-15.38371919499997
							],
							[
								124.53430506000007,
								-15.385374183999943
							],
							[
								124.53322806000006,
								-15.378647193999939
							],
							[
								124.52255108100007,
								-15.37964819399997
							],
							[
								124.5287500500001,
								-15.375982173999944
							],
							[
								124.52728290000005,
								-15.35955314399996
							],
							[
								124.53662307000002,
								-15.377140183999927
							],
							[
								124.54518406900002,
								-15.361436183999956
							],
							[
								124.54747005900003,
								-15.372955183999977
							],
							[
								124.55197207900005,
								-15.369735183999978
							],
							[
								124.54706406900004,
								-15.38755118399996
							],
							[
								124.55360205900001,
								-15.38912019399993
							],
							[
								124.56594606800002,
								-15.383823173999929
							],
							[
								124.56747293800004,
								-15.371062153999958
							],
							[
								124.57273291800004,
								-15.37870215299995
							],
							[
								124.59105292600009,
								-15.36901222299997
							],
							[
								124.58981308700004,
								-15.381912202999956
							],
							[
								124.5576128990001,
								-15.391492153999934
							],
							[
								124.56019304900008,
								-15.400522223999928
							],
							[
								124.53890300100011,
								-15.412872193999931
							],
							[
								124.54736297000011,
								-15.425012203999927
							],
							[
								124.54300301100011,
								-15.423262163999937
							],
							[
								124.54115297100009,
								-15.433212203999972
							],
							[
								124.54043297100009,
								-15.420662223999955
							],
							[
								124.53693306100001,
								-15.416602163999926
							],
							[
								124.53240319100007,
								-15.425083214999972
							],
							[
								124.52947312100002,
								-15.413223194999944
							],
							[
								124.51377319200003,
								-15.426353194999933
							],
							[
								124.5204130520001,
								-15.431083154999953
							],
							[
								124.5107531430001,
								-15.43426320499998
							],
							[
								124.5176331020001,
								-15.441153164999946
							],
							[
								124.52390322200006,
								-15.435643174999939
							],
							[
								124.5246430420001,
								-15.448373234999963
							],
							[
								124.56656321000003,
								-15.44424214399993
							],
							[
								124.60868322600004,
								-15.420902172999945
							],
							[
								124.61557289600012,
								-15.427332212999943
							],
							[
								124.65475312300009,
								-15.399692141999935
							],
							[
								124.62451312500002,
								-15.393562152999948
							],
							[
								124.61952317500004,
								-15.381592152999929
							],
							[
								124.62617311400004,
								-15.374772221999933
							],
							[
								124.60502201500003,
								-15.341812152999978
							],
							[
								124.58004200700009,
								-15.342673182999931
							],
							[
								124.58941096600006,
								-15.336413222999965
							],
							[
								124.58994810500008,
								-15.312235192999935
							],
							[
								124.57143800600011,
								-15.313165142999935
							],
							[
								124.56679903700001,
								-15.320174172999941
							],
							[
								124.55621790700002,
								-15.314265142999943
							],
							[
								124.56872608600008,
								-15.295316182999954
							],
							[
								124.56905623600005,
								-15.281296162999979
							],
							[
								124.56253590600011,
								-15.280406142999936
							],
							[
								124.56832615600001,
								-15.266946192999967
							],
							[
								124.55806615600011,
								-15.255216232999942
							],
							[
								124.57131594500004,
								-15.245365182999933
							],
							[
								124.55805608600008,
								-15.249786162999953
							],
							[
								124.55174599700001,
								-15.264396222999949
							],
							[
								124.54178620700009,
								-15.264616192999938
							],
							[
								124.53714617800006,
								-15.27275622299993
							],
							[
								124.54187625700001,
								-15.28008618299998
							],
							[
								124.52760617800004,
								-15.272996173999957
							],
							[
								124.52249599900006,
								-15.282826143999955
							],
							[
								124.52236601900006,
								-15.274916143999974
							],
							[
								124.51166607900007,
								-15.277526233999936
							],
							[
								124.4948159710001,
								-15.292206223999926
							],
							[
								124.50438689000009,
								-15.30431617399995
							],
							[
								124.51658620900002,
								-15.298766223999962
							],
							[
								124.51589720000004,
								-15.303966173999981
							],
							[
								124.52344601900006,
								-15.293906143999948
							],
							[
								124.52066716900003,
								-15.305545223999957
							],
							[
								124.5355672280001,
								-15.303605183999935
							],
							[
								124.51521823000007,
								-15.31357520399996
							],
							[
								124.51391718000002,
								-15.306795223999927
							],
							[
								124.49838822100003,
								-15.307665174999954
							],
							[
								124.49995889100012,
								-15.31951520499996
							],
							[
								124.5171111200001,
								-15.333794143999967
							],
							[
								124.50028111100005,
								-15.336573164999947
							],
							[
								124.50494023100009,
								-15.326704203999952
							],
							[
								124.49076921100004,
								-15.321035194999979
							],
							[
								124.48078106200012,
								-15.33633819499994
							],
							[
								124.49588907200007,
								-15.350062174999948
							],
							[
								124.49212314200008,
								-15.358213224999929
							],
							[
								124.48103609300006,
								-15.34549018499996
							],
							[
								124.47338006300004,
								-15.355242174999944
							],
							[
								124.46083009400002,
								-15.355816175999962
							],
							[
								124.46099306400004,
								-15.369767195999941
							],
							[
								124.46774008400007,
								-15.374630175999982
							],
							[
								124.48262307300001,
								-15.364958194999929
							],
							[
								124.47993006400009,
								-15.387030194999966
							],
							[
								124.46492309500002,
								-15.405062175999944
							],
							[
								124.48643308400005,
								-15.405605194999964
							],
							[
								124.48440708300006,
								-15.38674817499998
							],
							[
								124.49887108200005,
								-15.383262184999978
							],
							[
								124.49976307200006,
								-15.372153234999928
							],
							[
								124.51003307100007,
								-15.366658174999941
							],
							[
								124.50364408200005,
								-15.384641194999972
							]
						]
					],
					[
						[
							[
								124.47200708300011,
								-15.319307184999957
							],
							[
								124.4894460920001,
								-15.320137184999965
							],
							[
								124.47685808200004,
								-15.310255194999968
							],
							[
								124.47014708300003,
								-15.312720184999932
							],
							[
								124.47200708300011,
								-15.319307184999957
							]
						]
					],
					[
						[
							[
								124.48009508500002,
								-15.446110185999942
							],
							[
								124.48908507400006,
								-15.438779185999977
							],
							[
								124.50482321300001,
								-15.441273224999975
							],
							[
								124.49291008400007,
								-15.434052174999977
							],
							[
								124.4709200750001,
								-15.445147185999929
							],
							[
								124.48009508500002,
								-15.446110185999942
							]
						]
					],
					[
						[
							[
								124.48777399500011,
								-15.465403225999978
							],
							[
								124.50077324400002,
								-15.456873204999965
							],
							[
								124.49795296400009,
								-15.451693144999979
							],
							[
								124.48777399500011,
								-15.465403225999978
							]
						]
					],
					[
						[
							[
								124.60595298700002,
								-15.452212182999972
							],
							[
								124.60581293700011,
								-15.443052162999948
							],
							[
								124.61409292700012,
								-15.447672222999927
							],
							[
								124.62023310600011,
								-15.43207216299993
							],
							[
								124.59498309800006,
								-15.43979219299996
							],
							[
								124.60595298700002,
								-15.452212182999972
							]
						]
					],
					[
						[
							[
								124.58592402900001,
								-15.95111322699995
							],
							[
								124.58507408900005,
								-15.938683156999957
							],
							[
								124.59671393800011,
								-15.923073206999959
							],
							[
								124.58982393800011,
								-15.92173319699998
							],
							[
								124.59410396800001,
								-15.90534319699998
							],
							[
								124.5805639990001,
								-15.917203216999951
							],
							[
								124.58139415900007,
								-15.911233146999962
							],
							[
								124.57345401900011,
								-15.910683166999945
							],
							[
								124.57464413900004,
								-15.922093186999973
							],
							[
								124.5456051110001,
								-15.936834187999978
							],
							[
								124.53153523300011,
								-15.965784227999961
							],
							[
								124.53797489200008,
								-15.961814147999974
							],
							[
								124.54917521200002,
								-15.96756415799996
							],
							[
								124.56536515100004,
								-15.953303206999976
							],
							[
								124.58592402900001,
								-15.95111322699995
							]
						]
					],
					[
						[
							[
								124.47137491700005,
								-15.994574159999956
							],
							[
								124.4773052170001,
								-15.989124198999946
							],
							[
								124.47096523700009,
								-15.98384416999994
							],
							[
								124.47137491700005,
								-15.994574159999956
							]
						]
					],
					[
						[
							[
								124.47658521700009,
								-15.981194218999974
							],
							[
								124.48418513600006,
								-15.966154218999975
							],
							[
								124.47430495700007,
								-15.97512415899996
							],
							[
								124.47658521700009,
								-15.981194218999974
							]
						]
					],
					[
						[
							[
								124.62947392300009,
								-15.804593224999962
							],
							[
								124.64847403200008,
								-15.799023234999936
							],
							[
								124.65568410100002,
								-15.788503224999943
							],
							[
								124.63971414200012,
								-15.792263144999936
							],
							[
								124.62947392300009,
								-15.804593224999962
							]
						]
					],
					[
						[
							[
								125.13512702000003,
								-14.670019197999977
							],
							[
								125.14756716900001,
								-14.663749157999973
							],
							[
								125.12980693100008,
								-14.665369167999927
							],
							[
								125.13512702000003,
								-14.670019197999977
							]
						]
					],
					[
						[
							[
								125.1891471670001,
								-14.680748176999941
							],
							[
								125.1928771370001,
								-14.676698176999935
							],
							[
								125.18474690800008,
								-14.679488186999947
							],
							[
								125.1891471670001,
								-14.680748176999941
							]
						]
					],
					[
						[
							[
								125.2490968730001,
								-14.622388135999927
							],
							[
								125.2438369030001,
								-14.614348165999957
							],
							[
								125.23212682400003,
								-14.623068175999947
							],
							[
								125.23499714400009,
								-14.631108145999974
							],
							[
								125.22777697400011,
								-14.627498145999937
							],
							[
								125.22556693500007,
								-14.640818145999958
							],
							[
								125.21799687500004,
								-14.636668175999944
							],
							[
								125.21888714500005,
								-14.643828215999974
							],
							[
								125.21169686500002,
								-14.642558125999926
							],
							[
								125.20435718600004,
								-14.65223816699995
							],
							[
								125.21429715600004,
								-14.659508185999982
							],
							[
								125.22834684500003,
								-14.658438175999947
							],
							[
								125.23610700400002,
								-14.632798155999978
							],
							[
								125.2479769140001,
								-14.652978145999953
							],
							[
								125.26702706200001,
								-14.646158214999957
							],
							[
								125.2490968730001,
								-14.622388135999927
							]
						]
					],
					[
						[
							[
								125.30215692000002,
								-14.652838194999958
							],
							[
								125.3064668400001,
								-14.647438184999942
							],
							[
								125.29951703000006,
								-14.643798144999948
							],
							[
								125.30215692000002,
								-14.652838194999958
							]
						]
					],
					[
						[
							[
								125.44208602100002,
								-14.568407131999948
							],
							[
								125.43473590200006,
								-14.582837181999935
							],
							[
								125.44239601100003,
								-14.580377131999967
							],
							[
								125.44208602100002,
								-14.568407131999948
							]
						]
					],
					[
						[
							[
								125.42134610200003,
								-14.563607151999975
							],
							[
								125.43377508100002,
								-14.558107161999942
							],
							[
								125.43425494100006,
								-14.551226121999946
							],
							[
								125.42185585200002,
								-14.550957211999958
							],
							[
								125.42134610200003,
								-14.563607151999975
							]
						]
					],
					[
						[
							[
								125.42837508100001,
								-14.54172717199998
							],
							[
								125.43809507100002,
								-14.547056151999982
							],
							[
								125.44171488000006,
								-14.539616211999942
							],
							[
								125.43420490100004,
								-14.531127151999954
							],
							[
								125.42837508100001,
								-14.54172717199998
							]
						]
					],
					[
						[
							[
								125.40668616300002,
								-14.542897161999974
							],
							[
								125.41435489200012,
								-14.539877201999957
							],
							[
								125.41088483200008,
								-14.535457131999976
							],
							[
								125.40668616300002,
								-14.542897161999974
							]
						]
					],
					[
						[
							[
								125.33547601600003,
								-14.515109132999953
							],
							[
								125.34139584600007,
								-14.514909142999954
							],
							[
								125.33526504600002,
								-14.509240132999935
							],
							[
								125.33547601600003,
								-14.515109132999953
							]
						]
					],
					[
						[
							[
								125.32106592800005,
								-14.556268193999927
							],
							[
								125.33012603700001,
								-14.553478183999971
							],
							[
								125.32155590700006,
								-14.550508193999974
							],
							[
								125.32106592800005,
								-14.556268193999927
							]
						]
					],
					[
						[
							[
								125.27618615100005,
								-14.587938214999951
							],
							[
								125.2772859700001,
								-14.572138154999948
							],
							[
								125.26525586100001,
								-14.563738194999928
							],
							[
								125.26683587100001,
								-14.57615818499994
							],
							[
								125.2544158720001,
								-14.579278134999981
							],
							[
								125.27618615100005,
								-14.587938214999951
							]
						]
					],
					[
						[
							[
								125.13429687000007,
								-14.64652919799994
							],
							[
								125.13508705000004,
								-14.651949177999938
							],
							[
								125.15212692900002,
								-14.655529207999962
							],
							[
								125.1475768790001,
								-14.63585915699997
							],
							[
								125.15499685900011,
								-14.636568186999966
							],
							[
								125.16736717800006,
								-14.619798206999974
							],
							[
								125.18087688700007,
								-14.634418166999978
							],
							[
								125.18527717600011,
								-14.609938176999947
							],
							[
								125.19760716500002,
								-14.601858145999927
							],
							[
								125.19980713600012,
								-14.612868205999973
							],
							[
								125.2142870450001,
								-14.60722818599993
							],
							[
								125.21043684500012,
								-14.591418155999975
							],
							[
								125.20782684500011,
								-14.597158165999929
							],
							[
								125.19610705500008,
								-14.590238155999941
							],
							[
								125.20858717400006,
								-14.583048145999953
							],
							[
								125.19732710500011,
								-14.583448185999941
							],
							[
								125.20431685500012,
								-14.57613820599994
							],
							[
								125.19962711500011,
								-14.562458125999967
							],
							[
								125.18718696500002,
								-14.569518165999966
							],
							[
								125.18049706600004,
								-14.559668125999963
							],
							[
								125.18424685500008,
								-14.551108135999982
							],
							[
								125.19454715500001,
								-14.556338125999957
							],
							[
								125.20107612400011,
								-14.547788125999944
							],
							[
								125.20151606400009,
								-14.525548125999933
							],
							[
								125.2089360330001,
								-14.526478195999971
							],
							[
								125.21175588300002,
								-14.517348155999969
							],
							[
								125.20766594300005,
								-14.496549134999952
							],
							[
								125.21613602200011,
								-14.495689204999962
							],
							[
								125.20814617300005,
								-14.49271919499995
							],
							[
								125.2047560530001,
								-14.499698155999965
							],
							[
								125.20782614300003,
								-14.487859184999934
							],
							[
								125.19026603300006,
								-14.47300019599993
							],
							[
								125.18013600400002,
								-14.48390917599994
							],
							[
								125.18499492400008,
								-14.459201135999933
							],
							[
								125.1653659540001,
								-14.439920155999971
							],
							[
								125.16274583500001,
								-14.456389165999951
							],
							[
								125.15117617500005,
								-14.45272814599997
							],
							[
								125.16047604500011,
								-14.47117914599994
							],
							[
								125.15203586600012,
								-14.467408145999968
							],
							[
								125.15581587500003,
								-14.476239205999946
							],
							[
								125.14818602600008,
								-14.471568195999964
							],
							[
								125.13587617700011,
								-14.47603814699994
							],
							[
								125.1166269580001,
								-14.502599206999946
							],
							[
								125.13165699800004,
								-14.512149206999936
							],
							[
								125.13262716800011,
								-14.529089196999962
							],
							[
								125.14222692700002,
								-14.515848206999976
							],
							[
								125.14204694700004,
								-14.522918146999928
							],
							[
								125.149826157,
								-14.519568166999932
							],
							[
								125.14666714700002,
								-14.525648116999946
							],
							[
								125.15315688700002,
								-14.527038176999952
							],
							[
								125.1496670470001,
								-14.533928126999967
							],
							[
								125.1438670870001,
								-14.530158196999935
							],
							[
								125.1441370770001,
								-14.546138166999981
							],
							[
								125.14150692700002,
								-14.53883815699993
							],
							[
								125.13442716800012,
								-14.545149156999969
							],
							[
								125.1515970270001,
								-14.565758156999948
							],
							[
								125.14290695800003,
								-14.564138146999937
							],
							[
								125.13409705900006,
								-14.576709176999941
							],
							[
								125.13884691800001,
								-14.564119166999944
							],
							[
								125.13217716800011,
								-14.551669206999975
							],
							[
								125.12008693900009,
								-14.557379156999957
							],
							[
								125.11942705900003,
								-14.54833920699997
							],
							[
								125.11280701900012,
								-14.551249157999962
							],
							[
								125.11086696900009,
								-14.545369197999946
							],
							[
								125.10744695000005,
								-14.55675914799997
							],
							[
								125.10031719000006,
								-14.543959167999958
							],
							[
								125.09612714000002,
								-14.546199177999938
							],
							[
								125.10251716000005,
								-14.568359167999972
							],
							[
								125.09422706100008,
								-14.567269167999939
							],
							[
								125.094777152,
								-14.61281915799998
							],
							[
								125.10100693100003,
								-14.619399147999957
							],
							[
								125.09262686200009,
								-14.625909207999939
							],
							[
								125.10177697100005,
								-14.629219127999932
							],
							[
								125.10809717100005,
								-14.642799147999938
							],
							[
								125.11268715100005,
								-14.627919177999956
							],
							[
								125.13016693000009,
								-14.637369177999972
							],
							[
								125.1363571490001,
								-14.628359197999941
							],
							[
								125.13429687000007,
								-14.64652919799994
							]
						]
					],
					[
						[
							[
								124.93203193900001,
								-14.521341180999968
							],
							[
								124.93149086900007,
								-14.514002130999927
							],
							[
								124.92476102900002,
								-14.515092210999967
							],
							[
								124.93203193900001,
								-14.521341180999968
							]
						]
					],
					[
						[
							[
								124.99172714600002,
								-14.528989209999963
							],
							[
								124.99990708500002,
								-14.516719138999974
							],
							[
								124.99044518500011,
								-14.484490138999945
							],
							[
								124.98998703500001,
								-14.497381178999944
							],
							[
								124.97638403600001,
								-14.505768169999953
							],
							[
								124.97956490600006,
								-14.524190209999972
							],
							[
								124.98476618600012,
								-14.528050149999956
							],
							[
								124.98541603600006,
								-14.52032517999993
							],
							[
								124.99172714600002,
								-14.528989209999963
							]
						]
					],
					[
						[
							[
								125.25630519000003,
								-14.481171124999946
							],
							[
								125.25161508000008,
								-14.476651124999933
							],
							[
								125.25657514000011,
								-14.487711154999943
							],
							[
								125.25630519000003,
								-14.481171124999946
							]
						]
					],
					[
						[
							[
								125.26836518900006,
								-14.48122114399996
							],
							[
								125.27301491900005,
								-14.478301193999982
							],
							[
								125.26588511900002,
								-14.464042133999953
							],
							[
								125.24860515000012,
								-14.464541174999965
							],
							[
								125.24811517000012,
								-14.471991204999938
							],
							[
								125.2648148290001,
								-14.470702133999964
							],
							[
								125.26836518900006,
								-14.48122114399996
							]
						]
					],
					[
						[
							[
								124.97822316500003,
								-14.448290148999945
							],
							[
								124.9774930850001,
								-14.454950148999956
							],
							[
								124.99481485400008,
								-14.446010188999935
							],
							[
								124.98459193400004,
								-14.427321138999957
							],
							[
								124.9724909150001,
								-14.437201178999942
							],
							[
								124.97822316500003,
								-14.448290148999945
							]
						]
					],
					[
						[
							[
								124.97780987400006,
								-14.417571178999935
							],
							[
								124.98403107400009,
								-14.42404118899998
							],
							[
								124.97991986400007,
								-14.413411198999938
							],
							[
								124.98591816300006,
								-14.395141208999974
							],
							[
								124.97346794400005,
								-14.38345118899997
							],
							[
								124.95934802500005,
								-14.401672128999962
							],
							[
								124.97327785400012,
								-14.397561208999946
							],
							[
								124.97780987400006,
								-14.417571178999935
							]
						]
					],
					[
						[
							[
								125.21157410900003,
								-14.31478315399994
							],
							[
								125.22830402800003,
								-14.304133183999966
							],
							[
								125.22235394800009,
								-14.28672413399994
							],
							[
								125.21157410900003,
								-14.31478315399994
							]
						]
					],
					[
						[
							[
								125.24980500900006,
								-14.428421123999954
							],
							[
								125.26812504800012,
								-14.424881153999934
							],
							[
								125.27164514800006,
								-14.414611153999942
							],
							[
								125.24742502900006,
								-14.415200123999966
							],
							[
								125.24624497900004,
								-14.420051213999955
							],
							[
								125.25632496900005,
								-14.418961133999971
							],
							[
								125.24980500900006,
								-14.428421123999954
							]
						]
					],
					[
						[
							[
								125.23682484000005,
								-14.42622116399997
							],
							[
								125.24156499000003,
								-14.429621183999927
							],
							[
								125.24402483000006,
								-14.422411203999957
							],
							[
								125.23757510000007,
								-14.413581203999968
							],
							[
								125.23682484000005,
								-14.42622116399997
							]
						]
					],
					[
						[
							[
								125.19705700300005,
								-14.472329154999954
							],
							[
								125.20631300200012,
								-14.466344164999953
							],
							[
								125.20155402300009,
								-14.460798164999972
							],
							[
								125.19705700300005,
								-14.472329154999954
							]
						]
					],
					[
						[
							[
								125.31624299300006,
								-14.297483171999943
							],
							[
								125.31031306400007,
								-14.304343161999952
							],
							[
								125.32145290300002,
								-14.299643181999954
							],
							[
								125.31624299300006,
								-14.297483171999943
							]
						]
					],
					[
						[
							[
								125.28933300400001,
								-14.277954172999955
							],
							[
								125.2985331640001,
								-14.29414318299996
							],
							[
								125.30993291300001,
								-14.283004171999949
							],
							[
								125.31019283300009,
								-14.274764121999965
							],
							[
								125.29307305400005,
								-14.269734121999932
							],
							[
								125.28933300400001,
								-14.277954172999955
							]
						]
					],
					[
						[
							[
								125.31611302300007,
								-14.273324121999963
							],
							[
								125.3198530620001,
								-14.264194161999967
							],
							[
								125.3136031030001,
								-14.261344131999977
							],
							[
								125.31611302300007,
								-14.273324121999963
							]
						]
					],
					[
						[
							[
								125.4066638590001,
								-14.344093180999948
							],
							[
								125.40936310900008,
								-14.333833200999948
							],
							[
								125.40403297900002,
								-14.33437319099994
							],
							[
								125.4066638590001,
								-14.344093180999948
							]
						]
					],
					[
						[
							[
								125.55560983700002,
								-14.10862312699993
							],
							[
								125.55979988600006,
								-14.100283176999937
							],
							[
								125.5515800170001,
								-14.102513116999944
							],
							[
								125.55560983700002,
								-14.10862312699993
							]
						]
					],
					[
						[
							[
								125.5822179700001,
								-14.364106147999962
							],
							[
								125.5860149990001,
								-14.358675157999926
							],
							[
								125.57747297000003,
								-14.348320157999979
							],
							[
								125.57315097000003,
								-14.359512157999973
							],
							[
								125.58557096900006,
								-14.369682157999932
							],
							[
								125.5822179700001,
								-14.364106147999962
							]
						]
					],
					[
						[
							[
								125.427984089,
								-14.411331190999931
							],
							[
								125.43194408900001,
								-14.405421170999944
							],
							[
								125.42382392900004,
								-14.409181200999967
							],
							[
								125.427984089,
								-14.411331190999931
							]
						]
					],
					[
						[
							[
								125.3413249250001,
								-14.501920162999966
							],
							[
								125.34541489500009,
								-14.49290117299995
							],
							[
								125.33785490600008,
								-14.498070152999958
							],
							[
								125.3413249250001,
								-14.501920162999966
							]
						]
					],
					[
						[
							[
								125.45204507900007,
								-14.497547150999935
							],
							[
								125.47333512800003,
								-14.51194912099993
							],
							[
								125.49713509700007,
								-14.499713190999955
							],
							[
								125.49506506700004,
								-14.49373314099995
							],
							[
								125.49551507700005,
								-14.499483140999928
							],
							[
								125.48509487700005,
								-14.494372130999977
							],
							[
								125.48830800700011,
								-14.488098170999933
							],
							[
								125.48116513700006,
								-14.491541180999945
							],
							[
								125.48408506700002,
								-14.484781190999968
							],
							[
								125.47442482800011,
								-14.497390200999973
							],
							[
								125.44491490900009,
								-14.48081814099993
							],
							[
								125.45204507900007,
								-14.497547150999935
							]
						]
					],
					[
						[
							[
								125.49953482700005,
								-14.510782200999927
							],
							[
								125.50580497600004,
								-14.50854217999995
							],
							[
								125.49955496700011,
								-14.505823180999926
							],
							[
								125.50397508600008,
								-14.49985313999997
							],
							[
								125.49178514700009,
								-14.506362200999945
							],
							[
								125.49953482700005,
								-14.510782200999927
							]
						]
					],
					[
						[
							[
								125.492534997,
								-14.486832120999964
							],
							[
								125.49809482600006,
								-14.489443189999974
							],
							[
								125.49301489700008,
								-14.481412140999964
							],
							[
								125.492534997,
								-14.486832120999964
							]
						]
					],
					[
						[
							[
								125.5050189850001,
								-14.435096159999944
							],
							[
								125.51698798400002,
								-14.434937159999947
							],
							[
								125.52217000400003,
								-14.42266116999997
							],
							[
								125.50392098500004,
								-14.424595159999967
							],
							[
								125.5050189850001,
								-14.435096159999944
							]
						]
					],
					[
						[
							[
								125.53025398400007,
								-14.428350199999954
							],
							[
								125.5298040130001,
								-14.422590199999945
							],
							[
								125.51143393500001,
								-14.444439149999937
							],
							[
								125.51733397500004,
								-14.449879179999982
							],
							[
								125.51129384500007,
								-14.45494014999997
							],
							[
								125.52353495500006,
								-14.467280149999965
							],
							[
								125.52348491500004,
								-14.485000149999962
							],
							[
								125.55928513300012,
								-14.494236129999933
							],
							[
								125.56266514300012,
								-14.486236118999955
							],
							[
								125.55642488300009,
								-14.479327188999946
							],
							[
								125.53812503400002,
								-14.474538199999927
							],
							[
								125.54431415300007,
								-14.45581919999995
							],
							[
								125.53031410400001,
								-14.44753918999993
							],
							[
								125.53809407300002,
								-14.444289199999957
							],
							[
								125.53025398400007,
								-14.428350199999954
							]
						]
					],
					[
						[
							[
								125.68066992100012,
								-14.164941154999951
							],
							[
								125.67826005100005,
								-14.157601114999977
							],
							[
								125.66931981100004,
								-14.166721195999969
							],
							[
								125.68260994100001,
								-14.177251184999932
							],
							[
								125.68066992100012,
								-14.164941154999951
							]
						]
					],
					[
						[
							[
								125.70189908900011,
								-14.143991144999973
							],
							[
								125.70438886900001,
								-14.116231174999939
							],
							[
								125.69214884900009,
								-14.107631134999963
							],
							[
								125.69778896900004,
								-14.11972110499994
							],
							[
								125.6942688800001,
								-14.139801194999961
							],
							[
								125.70189908900011,
								-14.143991144999973
							]
						]
					],
					[
						[
							[
								126.28563797800007,
								-14.171283186999972
							],
							[
								126.29649810700005,
								-14.166963186999965
							],
							[
								126.29682784700003,
								-14.16029319699993
							],
							[
								126.28563797800007,
								-14.171283186999972
							]
						]
					],
					[
						[
							[
								125.78654911500007,
								-14.17036016399993
							],
							[
								125.7941991140001,
								-14.16067011399997
							],
							[
								125.78009902500003,
								-14.155220163999957
							],
							[
								125.78654911500007,
								-14.17036016399993
							]
						]
					],
					[
						[
							[
								126.23873683000011,
								-14.16204414699996
							],
							[
								126.24379697000006,
								-14.148584186999926
							],
							[
								126.2376568300001,
								-14.146004166999944
							],
							[
								126.23048706000009,
								-14.150314176999927
							],
							[
								126.23873683000011,
								-14.16204414699996
							]
						]
					],
					[
						[
							[
								126.37315292100004,
								-13.999312183999962
							],
							[
								126.38926289000005,
								-14.011202173999948
							],
							[
								126.40379284900007,
								-13.989052173999937
							],
							[
								126.37070308000011,
								-13.976292153999964
							],
							[
								126.36249295100004,
								-13.98262213399994
							],
							[
								126.37315292100004,
								-13.999312183999962
							]
						]
					],
					[
						[
							[
								125.62802711000006,
								-13.961201134999953
							],
							[
								125.64439702900006,
								-13.951381153999932
							],
							[
								125.6426268890001,
								-13.944721153999978
							],
							[
								125.63290690000008,
								-13.94495111499998
							],
							[
								125.63039698000011,
								-13.931001114999958
							],
							[
								125.62309687000004,
								-13.940031164999937
							],
							[
								125.62802711000006,
								-13.961201134999953
							]
						]
					],
					[
						[
							[
								126.30880996300004,
								-13.928387144999931
							],
							[
								126.30028593400004,
								-13.968484154999942
							],
							[
								126.31496094300007,
								-13.96208715499995
							],
							[
								126.32112093300009,
								-13.943072144999974
							],
							[
								126.30880996300004,
								-13.928387144999931
							]
						]
					],
					[
						[
							[
								126.27243095500012,
								-13.930633154999953
							],
							[
								126.28373595500011,
								-13.946062154999936
							],
							[
								126.2951779440001,
								-13.942103154999927
							],
							[
								126.27243095500012,
								-13.930633154999953
							]
						]
					],
					[
						[
							[
								126.16241394100007,
								-13.964256186999933
							],
							[
								126.1946940690001,
								-13.935935165999979
							],
							[
								126.18972389900011,
								-13.927355105999936
							],
							[
								126.16971405100003,
								-13.936826156999928
							],
							[
								126.16855412100006,
								-13.946986176999928
							],
							[
								126.15524384200012,
								-13.956796166999936
							],
							[
								126.16241394100007,
								-13.964256186999933
							]
						]
					],
					[
						[
							[
								126.15248192900003,
								-13.752426155999956
							],
							[
								126.14543201900005,
								-13.748586125999964
							],
							[
								126.15039211900012,
								-13.759656115999974
							],
							[
								126.15248192900003,
								-13.752426155999956
							]
						]
					],
					[
						[
							[
								126.30709493300003,
								-13.88924214399998
							],
							[
								126.31400095200001,
								-13.89522715399994
							],
							[
								126.31910193200008,
								-13.886808153999937
							],
							[
								126.30477893200009,
								-13.866237153999975
							],
							[
								126.30089895300011,
								-13.881680134999954
							],
							[
								126.30709493300003,
								-13.88924214399998
							]
						]
					],
					[
						[
							[
								126.30330294300006,
								-13.924388144999966
							],
							[
								126.31618095300007,
								-13.915601144999982
							],
							[
								126.3126079320001,
								-13.900752133999958
							],
							[
								126.30304394300003,
								-13.904508134999958
							],
							[
								126.30330294300006,
								-13.924388144999966
							]
						]
					],
					[
						[
							[
								126.53993692000006,
								-13.897579141999927
							],
							[
								126.56358391900005,
								-13.890936150999948
							],
							[
								126.5680199090001,
								-13.898450140999955
							],
							[
								126.55904090900003,
								-13.903437130999976
							],
							[
								126.59480090700004,
								-13.898539150999966
							],
							[
								126.60830590700004,
								-13.913688150999974
							],
							[
								126.61900592600011,
								-13.90545014099996
							],
							[
								126.61170493600002,
								-13.89637013099997
							],
							[
								126.6204999360001,
								-13.889874130999942
							],
							[
								126.59745993700005,
								-13.896332130999951
							],
							[
								126.58872891700003,
								-13.885149140999943
							],
							[
								126.57467094800006,
								-13.88649215099997
							],
							[
								126.54885894900008,
								-13.871647140999926
							],
							[
								126.50418795200005,
								-13.868766131999962
							],
							[
								126.50352693200011,
								-13.89273314199994
							],
							[
								126.51345993200005,
								-13.907038141999976
							],
							[
								126.5262329310001,
								-13.90177515199997
							],
							[
								126.5361419510001,
								-13.907860151999955
							],
							[
								126.53993692000006,
								-13.897579141999927
							]
						]
					],
					[
						[
							[
								126.45316179600002,
								-13.957982112999957
							],
							[
								126.45004206600004,
								-13.963962162999962
							],
							[
								126.45663184500006,
								-13.954362122999953
							],
							[
								126.45316179600002,
								-13.957982112999957
							]
						]
					],
					[
						[
							[
								126.6029299380001,
								-13.950184130999958
							],
							[
								126.60771690700005,
								-13.943505130999938
							],
							[
								126.60054991700008,
								-13.935628150999946
							],
							[
								126.5952279280001,
								-13.942568150999932
							],
							[
								126.6029299380001,
								-13.950184130999958
							]
						]
					],
					[
						[
							[
								126.81754985600003,
								-13.954839118999928
							],
							[
								126.81246988600003,
								-13.958689138999944
							],
							[
								126.81778994600006,
								-13.960819168999933
							],
							[
								126.81754985600003,
								-13.954839118999928
							]
						]
					],
					[
						[
							[
								126.81751995600007,
								-13.942859128999942
							],
							[
								126.81857980600012,
								-13.949519128999952
							],
							[
								126.82435994600007,
								-13.946689168999967
							],
							[
								126.81751995600007,
								-13.942859128999942
							]
						]
					],
					[
						[
							[
								126.70470091200002,
								-13.950105139999948
							],
							[
								126.70660891200009,
								-13.954474139999945
							],
							[
								126.70259792200011,
								-13.940871139999956
							],
							[
								126.70470091200002,
								-13.950105139999948
							]
						]
					],
					[
						[
							[
								126.69230992200005,
								-13.930993139999941
							],
							[
								126.67568490400004,
								-13.961458150999931
							],
							[
								126.68752393300008,
								-13.957081139999957
							],
							[
								126.69085193300009,
								-13.943389139999965
							],
							[
								126.69918992200007,
								-13.943754149999961
							],
							[
								126.69230992200005,
								-13.930993139999941
							]
						]
					],
					[
						[
							[
								126.62020793600004,
								-13.871435150999957
							],
							[
								126.62006493600006,
								-13.881908150999948
							],
							[
								126.62695791500005,
								-13.874187129999939
							],
							[
								126.63453491500002,
								-13.87594914999994
							],
							[
								126.62523190500008,
								-13.852758139999935
							],
							[
								126.61433892600007,
								-13.861206150999976
							],
							[
								126.62020793600004,
								-13.871435150999957
							]
						]
					],
					[
						[
							[
								127.2711469300001,
								-13.821896153999944
							],
							[
								127.27992697000002,
								-13.81869611299993
							],
							[
								127.26604682100003,
								-13.819086173999949
							],
							[
								127.2711469300001,
								-13.821896153999944
							]
						]
					],
					[
						[
							[
								127.15627691700001,
								-13.898974134999946
							],
							[
								127.17524588600008,
								-13.904005134999977
							],
							[
								127.1629959070001,
								-13.88302912499995
							],
							[
								127.15627691700001,
								-13.898974134999946
							]
						]
					],
					[
						[
							[
								126.87132690300007,
								-13.980377128999976
							],
							[
								126.88160030300003,
								-13.983398647999934
							],
							[
								126.87530091300005,
								-13.97609813799994
							],
							[
								126.87132690300007,
								-13.980377128999976
							]
						]
					],
					[
						[
							[
								126.86491035400002,
								-13.972478758999955
							],
							[
								126.88066032300003,
								-13.976168677999965
							],
							[
								126.88324047300011,
								-13.99253867799996
							],
							[
								126.90127033200008,
								-13.98526856799998
							],
							[
								126.86649025300005,
								-13.955868907999957
							],
							[
								126.86949997300007,
								-13.967969127999936
							],
							[
								126.8549300840001,
								-13.957579178999936
							],
							[
								126.81985997600009,
								-13.95392912899996
							],
							[
								126.81929980600012,
								-13.96024910899996
							],
							[
								126.83225978500002,
								-13.961469148999981
							],
							[
								126.81929980600012,
								-13.96205909899993
							],
							[
								126.82001005600011,
								-13.96679912899998
							],
							[
								126.84567985500007,
								-13.96369915899993
							],
							[
								126.86491035400002,
								-13.972478758999955
							]
						]
					],
					[
						[
							[
								126.57657993200007,
								-14.211828142999934
							],
							[
								126.57880994200002,
								-14.21972814299994
							],
							[
								126.59097995100001,
								-14.223638152999968
							],
							[
								126.59280995100005,
								-14.216398142999935
							],
							[
								126.57825893200004,
								-14.196908142999973
							],
							[
								126.57657993200007,
								-14.211828142999934
							]
						]
					],
					[
						[
							[
								127.70428486000003,
								-14.23914014299993
							],
							[
								127.70364987000005,
								-14.244572132999963
							],
							[
								127.71212487000003,
								-14.244278122999958
							],
							[
								127.71573286000012,
								-14.233559132999972
							],
							[
								127.70428486000003,
								-14.23914014299993
							]
						]
					],
					[
						[
							[
								127.73093675900009,
								-14.263552172999937
							],
							[
								127.73432683900012,
								-14.25905217299993
							],
							[
								127.72517672900005,
								-14.256962102999978
							],
							[
								127.73093675900009,
								-14.263552172999937
							]
						]
					],
					[
						[
							[
								126.57434193200004,
								-14.226738143999967
							],
							[
								126.58638193200011,
								-14.224768152999957
							],
							[
								126.57407194200005,
								-14.217028132999928
							],
							[
								126.57483195200007,
								-14.20424815299998
							],
							[
								126.56920193300004,
								-14.213988143999927
							],
							[
								126.57434193200004,
								-14.226738143999967
							]
						]
					],
					[
						[
							[
								125.99423093600001,
								-14.32164611199994
							],
							[
								125.97640086700005,
								-14.328176141999961
							],
							[
								125.97627202700005,
								-14.337886151999953
							],
							[
								125.99423093600001,
								-14.32164611199994
							]
						]
					],
					[
						[
							[
								126.0088800640001,
								-14.281946110999968
							],
							[
								125.98661984600005,
								-14.289256181999974
							],
							[
								125.99240002600004,
								-14.302016111999933
							],
							[
								125.985090936,
								-14.313286181999956
							],
							[
								125.99723086600011,
								-14.321206181999969
							],
							[
								125.99364094600003,
								-14.336886171999936
							],
							[
								126.02219106500002,
								-14.353306121999935
							],
							[
								126.02342082400003,
								-14.328456120999931
							],
							[
								126.0410399540001,
								-14.337916120999978
							],
							[
								126.04681006300007,
								-14.327965190999976
							],
							[
								126.0235000240001,
								-14.300446140999952
							],
							[
								126.01806981400011,
								-14.307006170999955
							],
							[
								126.00428000500006,
								-14.302736110999945
							],
							[
								126.0088800640001,
								-14.281946110999968
							]
						]
					],
					[
						[
							[
								126.00880881400008,
								-14.235746150999944
							],
							[
								125.99349009500008,
								-14.24367614099998
							],
							[
								126.00651990400002,
								-14.249306170999944
							],
							[
								126.01217984400012,
								-14.243426110999962
							],
							[
								126.03637003200004,
								-14.242365190999976
							],
							[
								126.04317980200005,
								-14.233425139999952
							],
							[
								126.01839886300002,
								-14.225226120999935
							],
							[
								126.00880881400008,
								-14.235746150999944
							]
						]
					],
					[
						[
							[
								125.73094998800002,
								-14.192820194999967
							],
							[
								125.73987981800008,
								-14.183920174999969
							],
							[
								125.73017997800002,
								-14.174650184999962
							],
							[
								125.72252998900001,
								-14.182870154999932
							],
							[
								125.73094998800002,
								-14.192820194999967
							]
						]
					],
					[
						[
							[
								125.66629006200003,
								-14.17890114599993
							],
							[
								125.6597999920001,
								-14.181711135999933
							],
							[
								125.66755007200004,
								-14.182971125999927
							],
							[
								125.67070006100005,
								-14.170561125999939
							],
							[
								125.66629006200003,
								-14.17890114599993
							]
						]
					],
					[
						[
							[
								125.77144209800008,
								-14.325630144999934
							],
							[
								125.76740180800005,
								-14.319530114999964
							],
							[
								125.76138189900007,
								-14.323770184999944
							],
							[
								125.77144209800008,
								-14.325630144999934
							]
						]
					],
					[
						[
							[
								125.92005896000012,
								-14.326407162999942
							],
							[
								125.93428194900002,
								-14.329148152999949
							],
							[
								125.92865898000002,
								-14.321839152999928
							],
							[
								125.92005896000012,
								-14.326407162999942
							]
						]
					],
					[
						[
							[
								125.71440297200002,
								-14.355432195999981
							],
							[
								125.72078291200012,
								-14.352061145999926
							],
							[
								125.7088629320001,
								-14.347182165999982
							],
							[
								125.71440297200002,
								-14.355432195999981
							]
						]
					],
					[
						[
							[
								125.67546287400012,
								-14.36810212699993
							],
							[
								125.66908293500012,
								-14.369552126999963
							],
							[
								125.67323301500005,
								-14.38153211699995
							],
							[
								125.68111303400008,
								-14.375902156999928
							],
							[
								125.67546287400012,
								-14.36810212699993
							]
						]
					],
					[
						[
							[
								125.65519199000005,
								-14.620150168999942
							],
							[
								125.65454999000008,
								-14.62688014899993
							],
							[
								125.65869598900008,
								-14.61298015899996
							],
							[
								125.65519199000005,
								-14.620150168999942
							]
						]
					],
					[
						[
							[
								125.71775385400008,
								-14.476994206999962
							],
							[
								125.7352538130001,
								-14.477365186999975
							],
							[
								125.75510386100007,
								-14.459796195999957
							],
							[
								125.75035401200012,
								-14.455496185999948
							],
							[
								125.75604308100003,
								-14.447946165999952
							],
							[
								125.74908392200007,
								-14.451996165999958
							],
							[
								125.73881384200001,
								-14.429176125999959
							],
							[
								125.75401412100007,
								-14.422326125999973
							],
							[
								125.74858391100008,
								-14.411586175999958
							],
							[
								125.73156385200002,
								-14.408058165999932
							],
							[
								125.72251415300002,
								-14.414818165999975
							],
							[
								125.72283381300008,
								-14.42790713599993
							],
							[
								125.72932388200002,
								-14.42757718599995
							],
							[
								125.72153383300008,
								-14.440996176999931
							],
							[
								125.72719414300002,
								-14.44980619699993
							],
							[
								125.71814407300008,
								-14.453745136999942
							],
							[
								125.71775385400008,
								-14.476994206999962
							]
						]
					],
					[
						[
							[
								125.92988312400007,
								-14.643086144999927
							],
							[
								125.9319729340001,
								-14.64771619499993
							],
							[
								125.92803312400008,
								-14.63890618499994
							],
							[
								125.92988312400007,
								-14.643086144999927
							]
						]
					],
					[
						[
							[
								125.9058709740001,
								-14.517811153999958
							],
							[
								125.90106998400006,
								-14.523389143999964
							],
							[
								125.90934796400006,
								-14.523718153999937
							],
							[
								125.9058709740001,
								-14.517811153999958
							]
						]
					],
					[
						[
							[
								125.95010181900011,
								-14.336726141999975
							],
							[
								125.9431620690001,
								-14.33604717299994
							],
							[
								125.94905313900006,
								-14.34563615299993
							],
							[
								125.93479281000009,
								-14.36085712299996
							],
							[
								125.9430130390001,
								-14.365837192999948
							],
							[
								125.92354278100004,
								-14.375407142999961
							],
							[
								125.94125301000008,
								-14.388967182999977
							],
							[
								125.95655300900012,
								-14.374196122999933
							],
							[
								125.96016307800005,
								-14.350956141999973
							],
							[
								125.97047202800002,
								-14.34791611199995
							],
							[
								125.96170100800009,
								-14.32330615199993
							],
							[
								125.95266210800003,
								-14.326576121999949
							],
							[
								125.95890200800011,
								-14.335046191999936
							],
							[
								125.95010181900011,
								-14.336726141999975
							]
						]
					],
					[
						[
							[
								125.99534192700003,
								-14.376496151999959
							],
							[
								125.99038182700008,
								-14.360916171999975
							],
							[
								125.97775198800002,
								-14.368916181999964
							],
							[
								125.9710131380001,
								-14.388206152999942
							],
							[
								125.98430289700002,
								-14.388816171999963
							],
							[
								125.98330279700008,
								-14.377496151999935
							],
							[
								125.99534192700003,
								-14.376496151999959
							]
						]
					],
					[
						[
							[
								125.98440294800002,
								-14.446676172999958
							],
							[
								125.9947118980001,
								-14.448146152999982
							],
							[
								126.0047030070001,
								-14.438166141999943
							],
							[
								125.98801301800006,
								-14.43567619299995
							],
							[
								125.98440294800002,
								-14.446676172999958
							]
						]
					],
					[
						[
							[
								127.81164584500004,
								-14.377570112999933
							],
							[
								127.81966595500012,
								-14.373890092999943
							],
							[
								127.81751602500003,
								-14.365290142999982
							],
							[
								127.82330587500007,
								-14.366680102999965
							],
							[
								127.81085601500001,
								-14.35293009299994
							],
							[
								127.80508595600008,
								-14.369510162999973
							],
							[
								127.81164584500004,
								-14.377570112999933
							]
						]
					],
					[
						[
							[
								127.84004587400011,
								-14.464070093999965
							],
							[
								127.8526160340001,
								-14.479050143999928
							],
							[
								127.86139570300008,
								-14.462710103999939
							],
							[
								127.8749856720001,
								-14.458830123999974
							],
							[
								127.87243582200006,
								-14.437230112999941
							],
							[
								127.86330586300005,
								-14.430400092999946
							],
							[
								127.85435591300006,
								-14.434530113999926
							],
							[
								127.85229596300007,
								-14.451020183999958
							],
							[
								127.83869591400003,
								-14.456490113999962
							],
							[
								127.84004587400011,
								-14.464070093999965
							]
						]
					],
					[
						[
							[
								128.774246822,
								-14.772002131999955
							],
							[
								128.77881381200007,
								-14.768305131999966
							],
							[
								128.76944480300006,
								-14.767467131999979
							],
							[
								128.774246822,
								-14.772002131999955
							]
						]
					],
					[
						[
							[
								128.30335519900007,
								-14.751135373999944
							],
							[
								128.310054669,
								-14.76279513399993
							],
							[
								128.3342240180001,
								-14.759375862999946
							],
							[
								128.31988484800002,
								-14.741356122999946
							],
							[
								128.31684464900002,
								-14.74575557299994
							],
							[
								128.30933470900004,
								-14.735676142999978
							],
							[
								128.29528498000002,
								-14.73460614299995
							],
							[
								128.29710582000007,
								-14.745685123999976
							],
							[
								128.30848498900002,
								-14.74595519299993
							],
							[
								128.30335519900007,
								-14.751135373999944
							]
						]
					],
					[
						[
							[
								128.4328535830001,
								-14.87428754399997
							],
							[
								128.44002349200002,
								-14.885947743999964
							],
							[
								128.4409935220001,
								-14.874197653999943
							],
							[
								128.4281236930001,
								-14.863197353999965
							],
							[
								128.4328535830001,
								-14.87428754399997
							]
						]
					],
					[
						[
							[
								125.35440806400004,
								-15.023318156999949
							],
							[
								125.36106803400003,
								-15.029948185999956
							],
							[
								125.36677798300002,
								-15.010378125999978
							],
							[
								125.35552803400003,
								-15.014498155999945
							],
							[
								125.35440806400004,
								-15.023318156999949
							]
						]
					],
					[
						[
							[
								125.35047603500004,
								-15.078077176999955
							],
							[
								125.34683201600001,
								-15.084237156999961
							],
							[
								125.35772901500002,
								-15.086097166999934
							],
							[
								125.36668100400004,
								-15.07865716699996
							],
							[
								125.35978791500008,
								-15.071748136999929
							],
							[
								125.35047603500004,
								-15.078077176999955
							]
						]
					],
					[
						[
							[
								128.4452333920001,
								-14.895117873999936
							],
							[
								128.46722311100007,
								-14.92829807399994
							],
							[
								128.47319312000002,
								-14.912038093999968
							],
							[
								128.46695323100005,
								-14.898578063999935
							],
							[
								128.44608348200006,
								-14.879867753999974
							],
							[
								128.4452333920001,
								-14.895117873999936
							]
						]
					],
					[
						[
							[
								128.12743711200005,
								-15.15698976699997
							],
							[
								128.19814669800007,
								-15.193299526999965
							],
							[
								128.19388637800012,
								-15.166389416999948
							],
							[
								128.2007059670001,
								-15.131369206999977
							],
							[
								128.1635359390001,
								-15.097389336999981
							],
							[
								128.15234577,
								-15.051709295999956
							],
							[
								128.12479583100003,
								-15.04034941599997
							],
							[
								128.12524627200003,
								-15.095509566999965
							],
							[
								128.11401668200006,
								-15.121589736999965
							],
							[
								128.12743711200005,
								-15.15698976699997
							]
						]
					],
					[
						[
							[
								125.4447680510001,
								-15.134918145999961
							],
							[
								125.45545787000003,
								-15.134408125999983
							],
							[
								125.43917796100004,
								-15.133818175999977
							],
							[
								125.4447680510001,
								-15.134918145999961
							]
						]
					],
					[
						[
							[
								125.44990812000003,
								-15.140088115999959
							],
							[
								125.48065787900009,
								-15.149518144999945
							],
							[
								125.47779802900004,
								-15.13733816499996
							],
							[
								125.44990812000003,
								-15.140088115999959
							]
						]
					],
					[
						[
							[
								128.18932482800005,
								-15.20432713699995
							],
							[
								128.17815184900007,
								-15.188725126999941
							],
							[
								128.15294284000004,
								-15.180111136999926
							],
							[
								128.18887985800006,
								-15.212203146999968
							],
							[
								128.18932482800005,
								-15.20432713699995
							]
						]
					],
					[
						[
							[
								128.1031598730001,
								-15.172075126999971
							],
							[
								128.09980285400002,
								-15.196618137999963
							],
							[
								128.11428386300008,
								-15.171448146999978
							],
							[
								128.106975873,
								-15.164576136999926
							],
							[
								128.1031598730001,
								-15.172075126999971
							]
						]
					],
					[
						[
							[
								125.37298802500004,
								-15.127028216999975
							],
							[
								125.3838178640001,
								-15.130258126999934
							],
							[
								125.36959787500007,
								-15.122869136999952
							],
							[
								125.37298802500004,
								-15.127028216999975
							]
						]
					],
					[
						[
							[
								125.33473799700005,
								-15.10507920699996
							],
							[
								125.33688792600003,
								-15.094229156999972
							],
							[
								125.33081797700004,
								-15.089509196999927
							],
							[
								125.33473799700005,
								-15.10507920699996
							]
						]
					],
					[
						[
							[
								125.2477389820001,
								-15.09462919899994
							],
							[
								125.25455915100008,
								-15.086579168999947
							],
							[
								125.24776887100006,
								-15.077799118999963
							],
							[
								125.23062891200004,
								-15.084979138999927
							],
							[
								125.22786914300002,
								-15.09606920899995
							],
							[
								125.2477389820001,
								-15.09462919899994
							]
						]
					],
					[
						[
							[
								125.1775090750001,
								-15.050239139999974
							],
							[
								125.17352893500004,
								-15.03471916999996
							],
							[
								125.16385898500005,
								-15.029449129999932
							],
							[
								125.16660904500009,
								-15.020519169999943
							],
							[
								125.15640915600011,
								-15.02608915999997
							],
							[
								125.15661899600002,
								-15.048229169999956
							],
							[
								125.14450898700011,
								-15.041729189999955
							],
							[
								125.16444900600004,
								-15.082769189999965
							],
							[
								125.17488903600008,
								-15.078889199999935
							],
							[
								125.1699188660001,
								-15.084779159999982
							],
							[
								125.1753188560001,
								-15.097649159999946
							],
							[
								125.164869167,
								-15.099259159999974
							],
							[
								125.16830892700011,
								-15.114949139999965
							],
							[
								125.18729895600006,
								-15.12334919999995
							],
							[
								125.21662886400009,
								-15.105379168999946
							],
							[
								125.21287910400008,
								-15.098389138999948
							],
							[
								125.21871899400003,
								-15.104579168999976
							],
							[
								125.22886888300002,
								-15.09955913899995
							],
							[
								125.21659896400001,
								-15.097809188999975
							],
							[
								125.22987901300007,
								-15.084249148999959
							],
							[
								125.23087911200003,
								-15.070639158999938
							],
							[
								125.20222888400008,
								-15.057649198999968
							],
							[
								125.19132914400006,
								-15.063569129999962
							],
							[
								125.18850889400005,
								-15.057819119999976
							],
							[
								125.18076889500003,
								-15.06824912999997
							],
							[
								125.17552909500012,
								-15.065099129999965
							],
							[
								125.1775090750001,
								-15.050239139999974
							]
						]
					],
					[
						[
							[
								125.229373011,
								-14.995100167999965
							],
							[
								125.24119814000005,
								-14.999379137999938
							],
							[
								125.25120794000009,
								-14.99248919799993
							],
							[
								125.24917801900006,
								-14.967998167999951
							],
							[
								125.229373011,
								-14.995100167999965
							]
						]
					],
					[
						[
							[
								125.19528103200003,
								-14.944924168999933
							],
							[
								125.18668002300001,
								-14.962598158999981
							],
							[
								125.19722903200011,
								-14.967489168999975
							],
							[
								125.20694811200008,
								-14.958799128999942
							],
							[
								125.20104807200005,
								-14.95301915899995
							],
							[
								125.2084781210001,
								-14.952699128999939
							],
							[
								125.20116793200009,
								-14.94050915899993
							],
							[
								125.19528103200003,
								-14.944924168999933
							]
						]
					],
					[
						[
							[
								125.18146804100002,
								-14.85289918799998
							],
							[
								125.17621814100005,
								-14.859429157999955
							],
							[
								125.18648785100004,
								-14.875499177999927
							],
							[
								125.18146804100002,
								-14.85289918799998
							]
						]
					],
					[
						[
							[
								125.17100601300001,
								-14.939401178999958
							],
							[
								125.17630402300006,
								-14.944167168999968
							],
							[
								125.17489801300007,
								-14.925929168999971
							],
							[
								125.17100601300001,
								-14.939401178999958
							]
						]
					],
					[
						[
							[
								125.17407201100002,
								-14.837859177999974
							],
							[
								125.1774690310001,
								-14.841000177999945
							],
							[
								125.1783250310001,
								-14.833623167999974
							],
							[
								125.17407201100002,
								-14.837859177999974
							]
						]
					],
					[
						[
							[
								125.14015804200005,
								-14.76515816799997
							],
							[
								125.14541904200007,
								-14.764706177999926
							],
							[
								125.13700002200005,
								-14.74900516799994
							],
							[
								125.14015804200005,
								-14.76515816799997
							]
						]
					],
					[
						[
							[
								125.12676002300009,
								-14.761163168999929
							],
							[
								125.13356402200009,
								-14.756374168999969
							],
							[
								125.12969301200008,
								-14.747269168999935
							],
							[
								125.12676002300009,
								-14.761163168999929
							]
						]
					],
					[
						[
							[
								125.02729909900006,
								-14.79260919099994
							],
							[
								125.03203814800008,
								-14.782019160999937
							],
							[
								125.02580795800009,
								-14.765279160999967
							],
							[
								125.01702795900007,
								-14.780139160999965
							],
							[
								125.02381790900006,
								-14.77998921099993
							],
							[
								125.02047892900009,
								-14.786929190999956
							],
							[
								125.02729909900006,
								-14.79260919099994
							]
						]
					],
					[
						[
							[
								124.94225019900011,
								-15.071790183999951
							],
							[
								124.95084985900007,
								-15.072440163999943
							],
							[
								124.95911005800008,
								-15.04123014399994
							],
							[
								124.94359011900008,
								-15.057100203999937
							],
							[
								124.95116988900008,
								-15.064420173999963
							],
							[
								124.94025003900003,
								-15.066600153999957
							],
							[
								124.94225019900011,
								-15.071790183999951
							]
						]
					],
					[
						[
							[
								124.96425987800001,
								-15.082680183999969
							],
							[
								124.95233992900012,
								-15.098530173999961
							],
							[
								124.97124999800008,
								-15.086840173999974
							],
							[
								124.98418011700005,
								-15.062730152999961
							],
							[
								124.97677996700008,
								-15.040500152999982
							],
							[
								124.96911014700004,
								-15.041990192999947
							],
							[
								124.95687987800011,
								-15.066660183999943
							],
							[
								124.95840987800011,
								-15.072080163999942
							],
							[
								124.96223018800004,
								-15.066980213999955
							],
							[
								124.96425987800001,
								-15.082680183999969
							]
						]
					],
					[
						[
							[
								124.88061999000001,
								-14.94636016499993
							],
							[
								124.88929994000011,
								-14.955800153999974
							],
							[
								124.88146996000012,
								-14.940040173999932
							],
							[
								124.88061999000001,
								-14.94636016499993
							]
						]
					],
					[
						[
							[
								124.91104000000007,
								-15.021260133999931
							],
							[
								124.92644008000002,
								-15.038050173999977
							],
							[
								124.93188003900002,
								-15.032730183999945
							],
							[
								124.94143011900007,
								-15.03812019399993
							],
							[
								124.93973020900012,
								-15.049200183999972
							],
							[
								124.95943012700002,
								-15.030720213999928
							],
							[
								124.94850012800009,
								-15.027400203999946
							],
							[
								124.94544015800011,
								-15.018900163999945
							],
							[
								124.95863990700002,
								-15.005420132999973
							],
							[
								124.94840008800008,
								-15.001380213999937
							],
							[
								124.93927011800008,
								-15.015520213999935
							],
							[
								124.93899001800003,
								-15.002540133999958
							],
							[
								124.93028991900007,
								-15.007650163999926
							],
							[
								124.94279992800011,
								-14.988570153999945
							],
							[
								124.9363501580001,
								-14.977930173999937
							],
							[
								124.94616916700011,
								-14.965440152999975
							],
							[
								124.93503903800001,
								-14.961090173999935
							],
							[
								124.93832907700005,
								-14.947910132999937
							],
							[
								124.931389007,
								-14.947980153999936
							],
							[
								124.9266189970001,
								-14.926610193999977
							],
							[
								124.91722908800011,
								-14.922380203999978
							],
							[
								124.9171290380001,
								-14.941350213999954
							],
							[
								124.93010920800009,
								-14.94831019399993
							],
							[
								124.9222990080001,
								-14.954030133999936
							],
							[
								124.92002019900008,
								-14.970140133999962
							],
							[
								124.89813002000005,
								-14.974800153999979
							],
							[
								124.89773006000007,
								-14.961810173999936
							],
							[
								124.89005020000002,
								-14.965380213999936
							],
							[
								124.88937988000009,
								-14.959390173999964
							],
							[
								124.87680004100002,
								-14.986321144999977
							],
							[
								124.88169999200011,
								-15.004620214999932
							],
							[
								124.89143005100004,
								-14.987860144999956
							],
							[
								124.89405987100008,
								-14.996340134999969
							],
							[
								124.90146006000009,
								-14.983170143999928
							],
							[
								124.92111998900009,
								-14.980540173999941
							],
							[
								124.91211999900008,
								-14.988980203999972
							],
							[
								124.91381990900004,
								-14.996110173999966
							],
							[
								124.90580992000002,
								-14.994260143999952
							],
							[
								124.89774013100009,
								-15.00446018499997
							],
							[
								124.92052995900008,
								-15.008920153999952
							],
							[
								124.91104000000007,
								-15.021260133999931
							]
						]
					],
					[
						[
							[
								124.88942090600005,
								-15.27079116699997
							],
							[
								124.90023100600001,
								-15.265561175999949
							],
							[
								124.89835110600006,
								-15.260821145999955
							],
							[
								124.88942090600005,
								-15.27079116699997
							]
						]
					],
					[
						[
							[
								124.97130110000012,
								-15.195190173999947
							],
							[
								124.97161000000006,
								-15.184790143999976
							],
							[
								124.96477110000001,
								-15.191250154999977
							],
							[
								124.97130110000012,
								-15.195190173999947
							]
						]
					],
					[
						[
							[
								125.00799987800008,
								-15.212130163999973
							],
							[
								125.0155598980001,
								-15.211540193999951
							],
							[
								125.0124998880001,
								-15.201830193999967
							],
							[
								125.00541001800002,
								-15.20479019399994
							],
							[
								125.00799987800008,
								-15.212130163999973
							]
						]
					],
					[
						[
							[
								125.04373096800009,
								-15.318050153999934
							],
							[
								125.04905102800001,
								-15.323270173999958
							],
							[
								125.0519011670001,
								-15.30834015399995
							],
							[
								125.04341093800008,
								-15.309280213999955
							],
							[
								125.04373096800009,
								-15.318050153999934
							]
						]
					],
					[
						[
							[
								125.0109911300001,
								-15.323060194999982
							],
							[
								125.01636090000011,
								-15.325870184999928
							],
							[
								125.02027118000001,
								-15.319650183999954
							],
							[
								125.0109911300001,
								-15.323060194999982
							]
						]
					],
					[
						[
							[
								125.0228711090001,
								-15.323470133999933
							],
							[
								124.99320103200012,
								-15.35633013499995
							],
							[
								124.99549096200008,
								-15.375760144999958
							],
							[
								125.01944106100007,
								-15.369580204999977
							],
							[
								125.03639092900005,
								-15.328730183999937
							],
							[
								125.03264116900004,
								-15.322190163999949
							],
							[
								125.0228711090001,
								-15.323470133999933
							]
						]
					],
					[
						[
							[
								124.95249112400006,
								-15.364831185999947
							],
							[
								124.9803810630001,
								-15.352200214999982
							],
							[
								124.98430108200012,
								-15.343030204999934
							],
							[
								124.97649085300009,
								-15.339780214999962
							],
							[
								124.95360101400001,
								-15.352061165999942
							],
							[
								124.95249112400006,
								-15.364831185999947
							]
						]
					],
					[
						[
							[
								128.26411584400012,
								-15.316085137999949
							],
							[
								128.281180833,
								-15.338500127999964
							],
							[
								128.27413984400005,
								-15.315256137999938
							],
							[
								128.2622418640001,
								-15.308886147999942
							],
							[
								128.26411584400012,
								-15.316085137999949
							]
						]
					],
					[
						[
							[
								128.25095682500012,
								-15.293411137999954
							],
							[
								128.265820834,
								-15.298626137999975
							],
							[
								128.24379585500003,
								-15.282181137999942
							],
							[
								128.25095682500012,
								-15.293411137999954
							]
						]
					],
					[
						[
							[
								128.27116684400005,
								-15.28223513699993
							],
							[
								128.26125285400008,
								-15.278128136999953
							],
							[
								128.27337085400006,
								-15.289910137999982
							],
							[
								128.27116684400005,
								-15.28223513699993
							]
						]
					],
					[
						[
							[
								128.27157984400003,
								-15.296341147999954
							],
							[
								128.2885328430001,
								-15.316751137999972
							],
							[
								128.28169983300006,
								-15.30065314799998
							],
							[
								128.27157984400003,
								-15.296341147999954
							]
						]
					],
					[
						[
							[
								123.70524819600007,
								-16.761364171999958
							],
							[
								123.71087824500012,
								-16.76185424199997
							],
							[
								123.70847811500005,
								-16.754714261999936
							],
							[
								123.70524819600007,
								-16.761364171999958
							]
						]
					],
					[
						[
							[
								123.67611233500008,
								-17.043345243999966
							],
							[
								123.68274099400003,
								-17.03127518399998
							],
							[
								123.67749112400008,
								-17.02165525399994
							],
							[
								123.66973129500002,
								-17.022415213999977
							],
							[
								123.66427228500004,
								-17.035725224999965
							],
							[
								123.67611233500008,
								-17.043345243999966
							]
						]
					],
					[
						[
							[
								123.42317707000007,
								-17.324089191999974
							],
							[
								123.39953734100004,
								-17.30067920299996
							],
							[
								123.40167715100006,
								-17.31741920299993
							],
							[
								123.42317707000007,
								-17.324089191999974
							]
						]
					],
					[
						[
							[
								123.4496881880001,
								-17.340039261999948
							],
							[
								123.45615810800007,
								-17.34221925199995
							],
							[
								123.45790732800003,
								-17.335859211999946
							],
							[
								123.44424713800004,
								-17.32396922199996
							],
							[
								123.4496881880001,
								-17.340039261999948
							]
						]
					],
					[
						[
							[
								123.53129733200001,
								-17.332178209999938
							],
							[
								123.53523714200003,
								-17.321238178999977
							],
							[
								123.52824629200006,
								-17.307078199999978
							],
							[
								123.53129733200001,
								-17.332178209999938
							]
						]
					],
					[
						[
							[
								123.51967722400002,
								-17.349978239999928
							],
							[
								123.52445803400008,
								-17.35836820999998
							],
							[
								123.52617703300007,
								-17.344358179999972
							],
							[
								123.51574709400006,
								-17.33594822999993
							],
							[
								123.51967722400002,
								-17.349978239999928
							]
						]
					],
					[
						[
							[
								123.54086609100011,
								-17.30113819899998
							],
							[
								123.54641621000007,
								-17.297328238999967
							],
							[
								123.53856605100009,
								-17.291298238999957
							],
							[
								123.54086609100011,
								-17.30113819899998
							]
						]
					],
					[
						[
							[
								123.5459572210001,
								-17.318458248999946
							],
							[
								123.55187635000004,
								-17.311478198999964
							],
							[
								123.5482860300001,
								-17.30026825899995
							],
							[
								123.54224634100001,
								-17.306798198999957
							],
							[
								123.5459572210001,
								-17.318458248999946
							]
						]
					],
					[
						[
							[
								123.54177618000006,
								-17.284528258999956
							],
							[
								123.54963606000001,
								-17.289658248999956
							],
							[
								123.55382610900006,
								-17.273628258999963
							],
							[
								123.55186627900002,
								-17.24140817899996
							],
							[
								123.54367625900011,
								-17.232548208999958
							],
							[
								123.53845624900009,
								-17.242018198999972
							],
							[
								123.54177618000006,
								-17.284528258999956
							]
						]
					],
					[
						[
							[
								123.54070011300007,
								-16.632812224999952
							],
							[
								123.54635031300006,
								-16.62958222499998
							],
							[
								123.53508017400009,
								-16.631522264999944
							],
							[
								123.54070011300007,
								-16.632812224999952
							]
						]
					],
					[
						[
							[
								123.47518009800001,
								-16.63019224599998
							],
							[
								123.51438018500005,
								-16.63891225599997
							],
							[
								123.53253517300004,
								-16.60932020499996
							],
							[
								123.51288003400009,
								-16.61120224499996
							],
							[
								123.50233025600005,
								-16.623542235999935
							],
							[
								123.50823029500009,
								-16.63139220599993
							],
							[
								123.48919025600003,
								-16.615472195999928
							],
							[
								123.45655122800008,
								-16.61713225699998
							],
							[
								123.47518009800001,
								-16.63019224599998
							]
						]
					],
					[
						[
							[
								122.10199226600002,
								-16.855846235999934
							],
							[
								122.1265119840001,
								-16.85255630499995
							],
							[
								122.09260267700006,
								-16.85461692599995
							],
							[
								122.10199226600002,
								-16.855846235999934
							]
						]
					],
					[
						[
							[
								122.13637227400011,
								-16.858086234999973
							],
							[
								122.14377133300002,
								-16.859096224999973
							],
							[
								122.12851236400002,
								-16.85323621499998
							],
							[
								122.13637227400011,
								-16.858086234999973
							]
						]
					],
					[
						[
							[
								118.89761568900008,
								-19.89244843399996
							],
							[
								118.9021562580001,
								-19.890648833999933
							],
							[
								118.8960791180001,
								-19.88544883399993
							],
							[
								118.89761568900008,
								-19.89244843399996
							]
						]
					],
					[
						[
							[
								118.50268458300002,
								-20.32119738399996
							],
							[
								118.51175479200003,
								-20.323297453999942
							],
							[
								118.5268348400001,
								-20.310207392999928
							],
							[
								118.50516464200007,
								-20.31116742399996
							],
							[
								118.50268458300002,
								-20.32119738399996
							]
						]
					],
					[
						[
							[
								116.92180883900005,
								-20.41031050199996
							],
							[
								116.92989861900003,
								-20.418380301999946
							],
							[
								116.95290836700008,
								-20.420039840999948
							],
							[
								116.85128689200008,
								-20.36523063599998
							],
							[
								116.83909381300009,
								-20.35146448599994
							],
							[
								116.83181892300001,
								-20.35406157699998
							],
							[
								116.84934805300009,
								-20.37879120599996
							],
							[
								116.92180883900005,
								-20.41031050199996
							]
						]
					],
					[
						[
							[
								116.82175482800005,
								-20.411835506999978
							],
							[
								116.82195582700001,
								-20.405658496999934
							],
							[
								116.81063582900003,
								-20.41476249799996
							],
							[
								116.82109771800003,
								-20.41689249799998
							],
							[
								116.82175482800005,
								-20.411835506999978
							]
						]
					],
					[
						[
							[
								117.07467881800005,
								-20.44152845399998
							],
							[
								117.07596869000008,
								-20.46558846499994
							],
							[
								117.08461874800003,
								-20.450698143999944
							],
							[
								117.08020878700006,
								-20.42990845399993
							],
							[
								117.0686989080001,
								-20.43090852499995
							],
							[
								117.07467881800005,
								-20.44152845399998
							]
						]
					],
					[
						[
							[
								117.0683215900001,
								-20.625749755999948
							],
							[
								117.08104183900002,
								-20.625769504999937
							],
							[
								117.0894507370001,
								-20.61628951499995
							],
							[
								117.07253141900003,
								-20.616269965999948
							],
							[
								117.03785193300007,
								-20.635970486999952
							],
							[
								117.05833198100004,
								-20.63877946599996
							],
							[
								117.0683215900001,
								-20.625749755999948
							]
						]
					],
					[
						[
							[
								116.96794851600009,
								-20.427739739999936
							],
							[
								116.9588958270001,
								-20.43030048999998
							],
							[
								116.97382881700003,
								-20.445309519999967
							],
							[
								116.96794851600009,
								-20.427739739999936
							]
						]
					],
					[
						[
							[
								116.82408882300001,
								-20.497902497999974
							],
							[
								116.81562684400001,
								-20.516120497999964
							],
							[
								116.82223984400002,
								-20.520004507999943
							],
							[
								116.85576983100009,
								-20.510893495999937
							],
							[
								116.86468083000011,
								-20.517918495999936
							],
							[
								116.87366183900008,
								-20.510914484999944
							],
							[
								116.88635890600005,
								-20.48052248399995
							],
							[
								116.86611881900001,
								-20.495066505999944
							],
							[
								116.85996882900008,
								-20.49070149599993
							],
							[
								116.86974381800007,
								-20.48152450499998
							],
							[
								116.87043844700008,
								-20.465722674999938
							],
							[
								116.86418880800011,
								-20.468863485999975
							],
							[
								116.86175283700004,
								-20.46096648599996
							],
							[
								116.87312780600007,
								-20.456562504999965
							],
							[
								116.88571092300003,
								-20.42362447399995
							],
							[
								116.85277281700007,
								-20.445834505999983
							],
							[
								116.82408882300001,
								-20.497902497999974
							]
						]
					],
					[
						[
							[
								116.81700682900009,
								-20.42386549799994
							],
							[
								116.81427583000004,
								-20.44208449799993
							],
							[
								116.83463380700005,
								-20.415876496999942
							],
							[
								116.81724783800007,
								-20.416237507999938
							],
							[
								116.81700682900009,
								-20.42386549799994
							]
						]
					],
					[
						[
							[
								116.81130582100002,
								-20.447247497999967
							],
							[
								116.79864182200004,
								-20.45121249899995
							],
							[
								116.79791084300007,
								-20.473012508999943
							],
							[
								116.82508797000003,
								-20.458312457999966
							],
							[
								116.8387679870001,
								-20.426282536999963
							],
							[
								116.82946081800003,
								-20.42666950699993
							],
							[
								116.81130582100002,
								-20.447247497999967
							]
						]
					],
					[
						[
							[
								117.69291077800005,
								-20.640696443999957
							],
							[
								117.69404044700002,
								-20.63583654399997
							],
							[
								117.68751103800003,
								-20.63863667499993
							],
							[
								117.69291077800005,
								-20.640696443999957
							]
						]
					],
					[
						[
							[
								117.77512993800008,
								-20.589775429999975
							],
							[
								117.7813598670001,
								-20.586925489999942
							],
							[
								117.77186989800009,
								-20.58243547999996
							],
							[
								117.77512993800008,
								-20.589775429999975
							]
						]
					],
					[
						[
							[
								117.71138094600008,
								-20.642966413999943
							],
							[
								117.73418088500011,
								-20.65369641199993
							],
							[
								117.7430206030001,
								-20.64011646199998
							],
							[
								117.74442063300012,
								-20.627466401999982
							],
							[
								117.73397090300011,
								-20.626586411999938
							],
							[
								117.71832064400007,
								-20.60765644299994
							],
							[
								117.71138094600008,
								-20.642966413999943
							]
						]
					],
					[
						[
							[
								117.84584772900007,
								-20.53918443599997
							],
							[
								117.86236758700011,
								-20.53213425599995
							],
							[
								117.87417756600007,
								-20.51616388499997
							],
							[
								117.84584772900007,
								-20.53918443599997
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "506",
				"CED_NAME21": "Durack",
				"STE_CODE21": "5",
				"STE_NAME21": "Western Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 1383928.2424,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/506",
				"SHAPE_Leng": 205.757348707,
				"SHAPE_Area": 121.588292527
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							115.3371041910001,
							-34.31483390599993
						],
						[
							115.3372080580001,
							-34.16006462599995
						],
						[
							115.40181582800005,
							-34.15647025199996
						],
						[
							115.40292472300007,
							-34.09325329199993
						],
						[
							115.39139583300005,
							-34.07910210199998
						],
						[
							115.40421984900001,
							-34.05003539099994
						],
						[
							115.38996134700005,
							-34.00048426199993
						],
						[
							115.4151321810001,
							-33.975833619999946
						],
						[
							115.41959977600004,
							-33.91982518999998
						],
						[
							115.53601514800005,
							-33.91387869299996
						],
						[
							115.66960913900004,
							-33.811797714999955
						],
						[
							115.73617749800007,
							-33.81155792199996
						],
						[
							115.73628122700006,
							-33.79668277199994
						],
						[
							115.80682878700009,
							-33.797683897999946
						],
						[
							115.80692569500002,
							-33.78389275799998
						],
						[
							115.81333406400006,
							-33.78391717699998
						],
						[
							115.81329870500008,
							-33.79118874699998
						],
						[
							115.83762533100003,
							-33.791069525999944
						],
						[
							115.83693194500006,
							-33.837031155999966
						],
						[
							115.81771512800003,
							-33.83695430699993
						],
						[
							115.81759905900003,
							-33.85413218699995
						],
						[
							115.86591122200002,
							-33.85524937499997
						],
						[
							115.86919794100004,
							-33.84723873399997
						],
						[
							115.88444321800011,
							-33.84305355399994
						],
						[
							115.90192222900009,
							-33.88539494299994
						],
						[
							115.94057178300011,
							-33.891558490999955
						],
						[
							115.93578186000002,
							-33.96119762099994
						],
						[
							115.96344067500002,
							-33.96397738999997
						],
						[
							115.96344385500004,
							-33.95759307999998
						],
						[
							115.9779218330001,
							-33.95759795899994
						],
						[
							115.97791927200001,
							-33.943817698999965
						],
						[
							115.99428075900005,
							-33.94382172799993
						],
						[
							115.99416289800001,
							-33.934241637999946
						],
						[
							115.98266489000002,
							-33.93416457899997
						],
						[
							115.96717137100006,
							-33.91678536899997
						],
						[
							115.97624790000009,
							-33.91683964899994
						],
						[
							115.97038593000002,
							-33.90672295899998
						],
						[
							115.99826973500001,
							-33.90273228799998
						],
						[
							116.00192590400002,
							-33.895034806999945
						],
						[
							116.00007727700006,
							-33.80129730699997
						],
						[
							116.08289988400008,
							-33.80116287299995
						],
						[
							116.09995265100008,
							-33.79027313199998
						],
						[
							116.10026542000003,
							-33.780579871999976
						],
						[
							116.1962549650001,
							-33.78074834599994
						],
						[
							116.19614520500011,
							-33.77111004599993
						],
						[
							116.21796771100003,
							-33.77108542499997
						],
						[
							116.21845447800001,
							-33.73505857499998
						],
						[
							116.22818296700007,
							-33.734998564999955
						],
						[
							116.23977992300001,
							-33.70652290399994
						],
						[
							116.21581241600006,
							-33.70141429499995
						],
						[
							116.21545971400008,
							-33.669771684999944
						],
						[
							116.20111441600011,
							-33.669836145999966
						],
						[
							116.20603947400002,
							-33.64626701499998
						],
						[
							116.19523674400011,
							-33.63471072599998
						],
						[
							116.20377774200006,
							-33.62788310499997
						],
						[
							116.20645119000005,
							-33.59635989499998
						],
						[
							116.19697009100003,
							-33.592504335999934
						],
						[
							116.19684711500008,
							-33.51348172499996
						],
						[
							116.13285160500004,
							-33.51332433899995
						],
						[
							116.13282558200001,
							-33.486796038999955
						],
						[
							116.06526328300004,
							-33.48539268199994
						],
						[
							116.0641900390001,
							-33.440342071999964
						],
						[
							116.0236606950001,
							-33.44046762399995
						],
						[
							116.02329908900003,
							-33.36087727399996
						],
						[
							116.0578723540001,
							-33.360723331999964
						],
						[
							116.05797889300004,
							-33.347699131999946
						],
						[
							116.04982775500002,
							-33.35437470299996
						],
						[
							116.02333485800011,
							-33.347390563999966
						],
						[
							116.0007075630001,
							-33.36335603499998
						],
						[
							116.0170694520001,
							-33.38527993399998
						],
						[
							116.00912741400009,
							-33.39599745499993
						],
						[
							116.0200823130001,
							-33.40323709399996
						],
						[
							116.0050873460001,
							-33.405705454999975
						],
						[
							116.00554728700001,
							-33.42196843499994
						],
						[
							116.0181119660001,
							-33.430364734999955
						],
						[
							116.00519206800004,
							-33.431718614999966
						],
						[
							115.99259321700004,
							-33.399046935999934
						],
						[
							115.98316496900009,
							-33.41176712599997
						],
						[
							115.97981656900004,
							-33.40163464699998
						],
						[
							115.93919988400012,
							-33.38884361899994
						],
						[
							115.93700306400001,
							-33.378064148999954
						],
						[
							115.91921008600002,
							-33.37861172999993
						],
						[
							115.91900557400004,
							-33.34893282999997
						],
						[
							115.92787149300011,
							-33.348933288999945
						],
						[
							115.927871202,
							-33.34166659899995
						],
						[
							115.91893676300003,
							-33.33905175999996
						],
						[
							115.91859585000009,
							-33.28998791899994
						],
						[
							115.94699514500007,
							-33.28984223799995
						],
						[
							115.94658678000008,
							-33.22172859799997
						],
						[
							116.00240378100011,
							-33.21081060499995
						],
						[
							116.01471178800011,
							-33.20175161399993
						],
						[
							116.01578076700002,
							-33.18295259399997
						],
						[
							116.03122676500004,
							-33.19118359299995
						],
						[
							116.03121099700002,
							-33.21294640299993
						],
						[
							116.0085448320001,
							-33.23192459399996
						],
						[
							116.14477175100001,
							-33.23186558699996
						],
						[
							116.14690976000009,
							-33.08487178599995
						],
						[
							116.20907579000004,
							-33.085040042999935
						],
						[
							116.20887021300007,
							-32.98419336199993
						],
						[
							116.19965900300008,
							-32.967064112999935
						],
						[
							116.18911210500005,
							-32.97132315299996
						],
						[
							116.1799638540001,
							-32.94309662399996
						],
						[
							116.16525114600006,
							-32.941710324999974
						],
						[
							116.17190294400007,
							-32.92646011399995
						],
						[
							116.15065432800009,
							-32.93548147499996
						],
						[
							116.02162968700009,
							-32.93580728199993
						],
						[
							116.00034099100003,
							-32.94239282299998
						],
						[
							115.98934723200011,
							-32.93842620399994
						],
						[
							115.99347381100006,
							-32.93331859399996
						],
						[
							115.95638908600006,
							-32.93292700599994
						],
						[
							115.95134953800004,
							-32.94226874599997
						],
						[
							115.94269220900003,
							-32.93619301699994
						],
						[
							115.92443400200011,
							-32.94104452799996
						],
						[
							115.8745562790001,
							-32.93493865999994
						],
						[
							115.86804698000003,
							-32.94220714099998
						],
						[
							115.85300340200001,
							-32.93135310099996
						],
						[
							115.83866879400011,
							-32.93567381199995
						],
						[
							115.8238434860001,
							-32.925925982999956
						],
						[
							115.81288705700001,
							-32.925903353999956
						],
						[
							115.81309288800003,
							-32.93649668399996
						],
						[
							115.78078736300006,
							-32.936542834999955
						],
						[
							115.78080721200001,
							-32.930011804999936
						],
						[
							115.76379741500011,
							-32.92996336599998
						],
						[
							115.76378255400004,
							-32.92196996599995
						],
						[
							115.71977378100007,
							-32.92192262899994
						],
						[
							115.70027833400002,
							-32.93170490999995
						],
						[
							115.65847073100008,
							-32.93303826199997
						],
						[
							115.68877585100006,
							-33.12055346099993
						],
						[
							115.67885060600008,
							-33.28798401299997
						],
						[
							115.65759815100012,
							-33.31792256399996
						],
						[
							115.6641458900001,
							-33.31670663399996
						],
						[
							115.66237790100001,
							-33.32524864399994
						],
						[
							115.6398081640001,
							-33.31871673499995
						],
						[
							115.64615884200009,
							-33.30097347499998
						],
						[
							115.6358289740001,
							-33.308746714999984
						],
						[
							115.59897051700011,
							-33.40960305799996
						],
						[
							115.57405135500005,
							-33.45324183899993
						],
						[
							115.42755133900005,
							-33.60828980799994
						],
						[
							115.38630996800009,
							-33.632600630999946
						],
						[
							115.31992742900002,
							-33.65185352399993
						],
						[
							115.21647760500002,
							-33.65306784999996
						],
						[
							115.12326526700008,
							-33.62387097599998
						],
						[
							115.1047519980001,
							-33.60589197699994
						],
						[
							115.1025545870001,
							-33.58617872699995
						],
						[
							115.08884657800002,
							-33.568275736999965
						],
						[
							115.06509643000004,
							-33.558388968999964
						],
						[
							115.05470415100001,
							-33.54387688899993
						],
						[
							115.03335110400008,
							-33.54329365099994
						],
						[
							115.03153096300002,
							-33.53371064099997
						],
						[
							115.0035110770001,
							-33.531590681999944
						],
						[
							115.01133207800001,
							-33.55642168199995
						],
						[
							115.00385309,
							-33.56105767199995
						],
						[
							115.02827907200003,
							-33.63413866099995
						],
						[
							115.01940687500007,
							-33.65648171199996
						],
						[
							114.99479296000004,
							-33.669369692999965
						],
						[
							114.9904971630001,
							-33.69623208399997
						],
						[
							114.97509044600008,
							-33.698039224999945
						],
						[
							115.00011201000007,
							-33.79415813399993
						],
						[
							114.99399030500001,
							-33.848468673999946
						],
						[
							114.98694649800007,
							-33.86378984499993
						],
						[
							114.97596055000008,
							-33.86416998499993
						],
						[
							114.99223798300011,
							-33.932659274999935
						],
						[
							114.99191335500007,
							-33.95352751499996
						],
						[
							114.97988850700006,
							-33.96141478499993
						],
						[
							115.00080606800009,
							-34.01538370399993
						],
						[
							114.99715388400011,
							-34.06887070499994
						],
						[
							115.00415082400002,
							-34.08143570499993
						],
						[
							114.99110802700011,
							-34.09845470499994
						],
						[
							115.01923697600012,
							-34.13914469399998
						],
						[
							115.03914283800009,
							-34.198180632999936
						],
						[
							115.02442100200005,
							-34.22278968399996
						],
						[
							115.03290115200002,
							-34.237249632999976
						],
						[
							115.02376111500007,
							-34.25301565399997
						],
						[
							115.0340070740001,
							-34.259098653999956
						],
						[
							115.0340668550001,
							-34.270412643999975
						],
						[
							115.05056708300003,
							-34.27541169299997
						],
						[
							115.118975008,
							-34.34074169899998
						],
						[
							115.12401715800002,
							-34.355618628999935
						],
						[
							115.13703692700005,
							-34.36429767799996
						],
						[
							115.13636083800009,
							-34.376727657999936
						],
						[
							115.13766691700005,
							-34.36979766799993
						],
						[
							115.15787517400008,
							-34.36902266699997
						],
						[
							115.17010545000005,
							-34.345620405999966
						],
						[
							115.17298780800002,
							-34.322962185999984
						],
						[
							115.16468281900006,
							-34.322826315999976
						],
						[
							115.16008447800004,
							-34.29800103599996
						],
						[
							115.14845659900004,
							-34.29860619699997
						],
						[
							115.14385861900007,
							-34.28946906699997
						],
						[
							115.16043443700005,
							-34.294755975999976
						],
						[
							115.15600220600004,
							-34.27529682599993
						],
						[
							115.1725017330001,
							-34.26600365499996
						],
						[
							115.16912610500003,
							-34.279540775999976
						],
						[
							115.1713949440001,
							-34.27455079599997
						],
						[
							115.20195500900002,
							-34.27762249399996
						],
						[
							115.18525710200004,
							-34.282664634999946
						],
						[
							115.18683328300006,
							-34.29166367499994
						],
						[
							115.1653005070001,
							-34.301363005999974
						],
						[
							115.16908282800011,
							-34.321800235999945
						],
						[
							115.26133845200002,
							-34.30682379099994
						],
						[
							115.3371041910001,
							-34.31483390599993
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "507",
				"CED_NAME21": "Forrest",
				"STE_CODE21": "5",
				"STE_NAME21": "Western Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 8013.0052,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/507",
				"SHAPE_Leng": 7.96946940236,
				"SHAPE_Area": 0.77859223153
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								115.7749343050001,
								-32.18137553299994
							],
							[
								115.89855694700009,
								-32.18022747599997
							],
							[
								115.89863859700006,
								-32.18022658599995
							],
							[
								115.89692480400004,
								-32.13612393599993
							],
							[
								115.91618388000006,
								-32.115323623999984
							],
							[
								115.8906350520001,
								-32.09207351599997
							],
							[
								115.88437369100006,
								-32.07507460599993
							],
							[
								115.85821290600006,
								-32.08731048799996
							],
							[
								115.84909349700001,
								-32.085646907999944
							],
							[
								115.84922171700009,
								-32.07865059799997
							],
							[
								115.83413487900009,
								-32.07934081899998
							],
							[
								115.82397799000012,
								-32.06852232899996
							],
							[
								115.80328486200005,
								-32.065806349999946
							],
							[
								115.80321592200005,
								-32.05642347999998
							],
							[
								115.79363127300007,
								-32.056628520999936
							],
							[
								115.79361831100005,
								-32.03413761099995
							],
							[
								115.77605751400006,
								-32.038310001999946
							],
							[
								115.7761727730001,
								-32.028812941999945
							],
							[
								115.76192066500005,
								-32.02664464299994
							],
							[
								115.76031761700006,
								-32.04052760299993
							],
							[
								115.73213137200003,
								-32.05589873399998
							],
							[
								115.74090568100007,
								-32.05696664399994
							],
							[
								115.73956839100003,
								-32.06354274399996
							],
							[
								115.74758368000005,
								-32.060690653999984
							],
							[
								115.74935948000007,
								-32.070510712999976
							],
							[
								115.742615451,
								-32.06496972399998
							],
							[
								115.76276601100005,
								-32.109279982999965
							],
							[
								115.75595832400006,
								-32.12953528299994
							],
							[
								115.73735040700001,
								-32.13493856399998
							],
							[
								115.765391453,
								-32.13959798299993
							],
							[
								115.76270271600004,
								-32.16156860299998
							],
							[
								115.7749343050001,
								-32.18137553299994
							]
						]
					],
					[
						[
							[
								115.75088174600012,
								-32.021589182999946
							],
							[
								115.72438443300007,
								-32.054042814999946
							],
							[
								115.75839665700005,
								-32.03886458299996
							],
							[
								115.75888907600006,
								-32.024019032999945
							],
							[
								115.75088174600012,
								-32.021589182999946
							]
						]
					],
					[
						[
							[
								115.5410638940001,
								-31.99402999499995
							],
							[
								115.53966379400003,
								-31.988169934999974
							],
							[
								115.51135359800003,
								-31.987600185999952
							],
							[
								115.47725413500007,
								-32.013750828999946
							],
							[
								115.45690410800012,
								-32.015721079999935
							],
							[
								115.44979424000007,
								-32.02617124999995
							],
							[
								115.50760395100008,
								-32.01295043699997
							],
							[
								115.52765416900002,
								-32.02762038599997
							],
							[
								115.53166390700005,
								-32.01494020499996
							],
							[
								115.55118388400001,
								-32.01246002399995
							],
							[
								115.55838398300011,
								-32.00456992399995
							],
							[
								115.5410638940001,
								-31.99402999499995
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "508",
				"CED_NAME21": "Fremantle",
				"STE_CODE21": "5",
				"STE_NAME21": "Western Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 194.5588,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/508",
				"SHAPE_Leng": 1.25400559434,
				"SHAPE_Area": 0.0185891177242
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							116.28888966200009,
							-32.06214058399996
						],
						[
							116.32346570700008,
							-32.062547621999954
						],
						[
							116.323750184,
							-32.02342826199998
						],
						[
							116.30257040800007,
							-32.02319085299996
						],
						[
							116.30281214600006,
							-32.00501500299998
						],
						[
							116.40907564100007,
							-32.01230625699998
						],
						[
							116.41513569300002,
							-31.90931971699996
						],
						[
							116.34618559300009,
							-31.906776839999964
						],
						[
							116.34612459900006,
							-31.85643345999995
						],
						[
							116.35832121600004,
							-31.838602068999933
						],
						[
							116.3582919050001,
							-31.81946684899998
						],
						[
							116.37098678200005,
							-31.81333548899994
						],
						[
							116.3378298670001,
							-31.805607779999946
						],
						[
							116.35620571200002,
							-31.78361051899998
						],
						[
							116.34523355400006,
							-31.779980689999945
						],
						[
							116.3458359120001,
							-31.762663009999983
						],
						[
							116.33819205300006,
							-31.762687409999955
						],
						[
							116.33815438300007,
							-31.75351650999994
						],
						[
							116.3480162410001,
							-31.748438378999936
						],
						[
							116.34724312800006,
							-31.70656465899998
						],
						[
							116.28767068600007,
							-31.706450531999963
						],
						[
							116.28805411400003,
							-31.671091081999975
						],
						[
							116.20545864500002,
							-31.670454586999938
						],
						[
							116.14931427400006,
							-31.682052099999964
						],
						[
							116.14061475500012,
							-31.680412849999982
						],
						[
							116.14072196500001,
							-31.67271434999998
						],
						[
							116.09904484200001,
							-31.695831012999975
						],
						[
							116.11159066200003,
							-31.70890259199996
						],
						[
							116.095591764,
							-31.712041212999964
						],
						[
							116.0942449160001,
							-31.742265922999934
						],
						[
							116.03271220500005,
							-31.74211738599996
						],
						[
							116.03269260600007,
							-31.748342065999964
						],
						[
							116.02422463700009,
							-31.748339606999934
						],
						[
							116.0207365870001,
							-31.74198688699994
						],
						[
							115.98284868200005,
							-31.741872598999976
						],
						[
							115.97662138400005,
							-31.759483429999932
						],
						[
							115.9546645580001,
							-31.766204390999974
						],
						[
							115.95719569000005,
							-31.795650600999977
						],
						[
							115.91799768500005,
							-31.79567559299994
						],
						[
							115.91709467900012,
							-31.843160602999944
						],
						[
							115.91751169100007,
							-31.866504602999953
						],
						[
							115.95339826500003,
							-31.861621800999956
						],
						[
							115.95595480700001,
							-31.887644620999936
						],
						[
							115.96432965600002,
							-31.88768061099995
						],
						[
							115.95953395700008,
							-31.894338130999984
						],
						[
							115.97403387500003,
							-31.89370890999993
						],
						[
							115.95864693700003,
							-31.89531914099996
						],
						[
							115.96533139700011,
							-31.904337580999936
						],
						[
							115.95378134000009,
							-31.920354361999955
						],
						[
							115.99891468300007,
							-31.917535588999954
						],
						[
							116.00388466300001,
							-31.92624159899998
						],
						[
							116.03183176000005,
							-31.937079186999938
						],
						[
							116.03627735100008,
							-31.955233146999944
						],
						[
							116.02875795200009,
							-31.961429377999934
						],
						[
							116.04101035200006,
							-31.987430656999948
						],
						[
							116.03220866400011,
							-31.989850587999968
						],
						[
							116.03394168400007,
							-32.00227959799997
						],
						[
							116.02402573600011,
							-32.00513343799997
						],
						[
							116.02144635800005,
							-32.01944015799995
						],
						[
							116.04156467500002,
							-32.030344886999956
						],
						[
							116.05725168300012,
							-32.03010259599995
						],
						[
							116.05084414400005,
							-32.02640155699993
						],
						[
							116.06004276100009,
							-32.00932575599995
						],
						[
							116.08844767800008,
							-32.01593258499997
						],
						[
							116.1058856950001,
							-32.00961759399996
						],
						[
							116.18963964300008,
							-32.01321158899998
						],
						[
							116.21859563900011,
							-32.01912159799997
						],
						[
							116.23590864800008,
							-32.03378058699997
						],
						[
							116.2365306370001,
							-32.02601957699994
						],
						[
							116.25067909500001,
							-32.019611675999954
						],
						[
							116.28888966200009,
							-32.06214058399996
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "509",
				"CED_NAME21": "Hasluck",
				"STE_CODE21": "5",
				"STE_NAME21": "Western Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 1317.9683,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/509",
				"SHAPE_Leng": 2.15325852658,
				"SHAPE_Area": 0.125597230754
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							115.75182146500003,
							-31.873382651999975
						],
						[
							115.76553579300003,
							-31.87397802199996
						],
						[
							115.7721165910001,
							-31.85750540099997
						],
						[
							115.79071158800002,
							-31.859435089999977
						],
						[
							115.79181001900008,
							-31.86997796999998
						],
						[
							115.80118569800004,
							-31.867966499999966
						],
						[
							115.78176492600005,
							-31.81719708099996
						],
						[
							115.8208631010001,
							-31.820089157999973
						],
						[
							115.81028241000001,
							-31.78354810899998
						],
						[
							115.79612716100007,
							-31.77670347999998
						],
						[
							115.7877847210001,
							-31.751871709999932
						],
						[
							115.79226475900009,
							-31.74297022999997
						],
						[
							115.7737586400001,
							-31.717235200999937
						],
						[
							115.74976117400001,
							-31.722348281999984
						],
						[
							115.74804531300003,
							-31.711976551999953
						],
						[
							115.7066207690001,
							-31.712013773999956
						],
						[
							115.72462972900007,
							-31.747539622999966
						],
						[
							115.73312788100009,
							-31.78541658299997
						],
						[
							115.72745399300004,
							-31.80605225399995
						],
						[
							115.73349432400005,
							-31.82370105299998
						],
						[
							115.74087599300003,
							-31.82442856299997
						],
						[
							115.73185210400004,
							-31.82388523299994
						],
						[
							115.74215918300001,
							-31.826109302999953
						],
						[
							115.75026733300001,
							-31.839796341999943
						],
						[
							115.75182146500003,
							-31.873382651999975
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "510",
				"CED_NAME21": "Moore",
				"STE_CODE21": "5",
				"STE_NAME21": "Western Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 101.9704,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/510",
				"SHAPE_Leng": 0.602260443744,
				"SHAPE_Area": 0.00970944671599
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								115.3371041910001,
								-34.31483390599993
							],
							[
								115.43844226800002,
								-34.352409430999955
							],
							[
								115.47886660500001,
								-34.381726227999934
							],
							[
								115.5214093190001,
								-34.39756533599996
							],
							[
								115.54227497700003,
								-34.41422786499993
							],
							[
								115.54087012800005,
								-34.42307407499993
							],
							[
								115.5587849850001,
								-34.415094453999984
							],
							[
								115.57787309200012,
								-34.42207421299997
							],
							[
								115.73514876600007,
								-34.53238065499994
							],
							[
								115.95381196700009,
								-34.72781255399997
							],
							[
								115.96243720700011,
								-34.743897542999946
							],
							[
								115.96042890900003,
								-34.762400612999954
							],
							[
								116.00267516600002,
								-34.81237908099996
							],
							[
								115.99674424900002,
								-34.830882301999964
							],
							[
								116.00193491900006,
								-34.842290600999945
							],
							[
								116.02961892400003,
								-34.836920609999936
							],
							[
								116.09644887400009,
								-34.849320595999984
							],
							[
								116.13705562700011,
								-34.84473093399998
							],
							[
								116.25073997200002,
								-34.87604117799998
							],
							[
								116.4363446100001,
								-34.97403314899998
							],
							[
								116.47857652500011,
								-35.00396984699995
							],
							[
								116.48167471500005,
								-35.01614295699994
							],
							[
								116.49844300300003,
								-35.015437745999975
							],
							[
								116.51788595900007,
								-35.002203264999935
							],
							[
								116.53285796600005,
								-35.00442507399998
							],
							[
								116.57485654100003,
								-35.02436175199995
							],
							[
								116.57230570200011,
								-35.03300489199995
							],
							[
								116.57802656100012,
								-35.02810975199998
							],
							[
								116.61032325600002,
								-35.033267259999946
							],
							[
								116.62986845400007,
								-35.04628709899998
							],
							[
								116.63038496500008,
								-35.06082124899996
							],
							[
								116.64551141100003,
								-35.04714584799996
							],
							[
								116.65808952000009,
								-35.05142465799997
							],
							[
								116.70720855000002,
								-35.02894291499996
							],
							[
								116.72648762800009,
								-35.041384963999974
							],
							[
								116.74541791400009,
								-35.03738783299997
							],
							[
								116.73737750500004,
								-35.030409702999975
							],
							[
								116.74193208400004,
								-35.022492462999935
							],
							[
								116.76828423900008,
								-35.014707201999954
							],
							[
								116.81046466300006,
								-35.02575333999994
							],
							[
								116.82694791200004,
								-35.04327862899993
							],
							[
								116.8443639190001,
								-35.04027704799995
							],
							[
								116.84637583900007,
								-35.04937495799993
							],
							[
								116.86199765700007,
								-35.056608266999945
							],
							[
								116.86593446600011,
								-35.04847605699996
							],
							[
								116.88456217300006,
								-35.04779569599998
							],
							[
								116.9212387880001,
								-35.06433592399998
							],
							[
								116.93679811300001,
								-35.032392432999984
							],
							[
								116.96635489700009,
								-35.01911194199994
							],
							[
								117.01893598000004,
								-35.03549833899996
							],
							[
								117.03351378700006,
								-35.02505254799996
							],
							[
								117.06023058300002,
								-35.02870307699993
							],
							[
								117.07086179200007,
								-35.038291966999964
							],
							[
								117.07338864100007,
								-35.031824865999965
							],
							[
								117.09795748700003,
								-35.03242054499998
							],
							[
								117.15047985100011,
								-35.061466242999984
							],
							[
								117.15362354900003,
								-35.04778303299997
							],
							[
								117.16430943700004,
								-35.044756881999945
							],
							[
								117.16472411600012,
								-35.02694463199998
							],
							[
								117.19525216000011,
								-35.01709024999997
							],
							[
								117.2476101630001,
								-35.02931016799994
							],
							[
								117.2721335980001,
								-35.02106110699998
							],
							[
								117.31665074200009,
								-35.04281226499995
							],
							[
								117.33124253000005,
								-35.04264305399994
							],
							[
								117.33704937900006,
								-35.03447190399993
							],
							[
								117.32643433900012,
								-35.01545680399994
							],
							[
								117.33708321600011,
								-35.00488763299995
							],
							[
								117.33423723600004,
								-34.99369844299997
							],
							[
								117.34881296300011,
								-34.98699025299993
							],
							[
								117.35476403300004,
								-34.993036321999966
							],
							[
								117.36916586900008,
								-34.96947358199998
							],
							[
								117.40489637300004,
								-34.97348866999994
							],
							[
								117.42907433000005,
								-34.98605750899998
							],
							[
								117.45520996500011,
								-34.96694397799996
							],
							[
								117.4718780930001,
								-34.975843976999954
							],
							[
								117.479573533,
								-34.99351487599995
							],
							[
								117.46889776500007,
								-35.00648722699998
							],
							[
								117.46057466600007,
								-35.00356141699996
							],
							[
								117.45156869800007,
								-35.01005259799996
							],
							[
								117.46577690700008,
								-35.02053037699994
							],
							[
								117.42849190300001,
								-35.02160596899995
							],
							[
								117.39864377700007,
								-35.00812711999998
							],
							[
								117.395713666,
								-34.99812804099997
							],
							[
								117.35686212300004,
								-35.00513843199997
							],
							[
								117.33307930800004,
								-35.02391486399995
							],
							[
								117.36284509300003,
								-35.019556481999984
							],
							[
								117.3974884490001,
								-35.03196424099997
							],
							[
								117.47914126800003,
								-35.07355516699994
							],
							[
								117.48527038800012,
								-35.08895605699996
							],
							[
								117.51235951400008,
								-35.08310401499995
							],
							[
								117.5143687630001,
								-35.07459998499996
							],
							[
								117.54864357800011,
								-35.082521963999966
							],
							[
								117.6055995910001,
								-35.11529406099993
							],
							[
								117.61124629100004,
								-35.13332387099996
							],
							[
								117.62398076900001,
								-35.13420026999995
							],
							[
								117.6293937580001,
								-35.127733939999985
							],
							[
								117.63970584700007,
								-35.134467918999974
							],
							[
								117.64173462600002,
								-35.12557075899997
							],
							[
								117.62842792700008,
								-35.11282874999995
							],
							[
								117.63717164400009,
								-35.08859535899995
							],
							[
								117.65140051100002,
								-35.08375799899994
							],
							[
								117.64461224100012,
								-35.06210877899997
							],
							[
								117.6856065830001,
								-35.04333212699993
							],
							[
								117.69985764100011,
								-35.051851935999935
							],
							[
								117.70939045900002,
								-35.04483279599998
							],
							[
								117.7621622910001,
								-35.05450111299996
							],
							[
								117.83890795100001,
								-35.087306919999946
							],
							[
								117.86589710800001,
								-35.10924105899994
							],
							[
								117.88554910500011,
								-35.11007392799996
							],
							[
								117.89881820400001,
								-35.12343393699996
							],
							[
								117.90443902200002,
								-35.11466682699995
							],
							[
								117.9244620390001,
								-35.12182576599997
							],
							[
								117.94087386600006,
								-35.11468560499998
							],
							[
								117.95019702600007,
								-35.12798069499996
							],
							[
								117.96925775200009,
								-35.11456442399998
							],
							[
								117.9685976510001,
								-35.10137527399996
							],
							[
								118.00534861500012,
								-35.09870901199997
							],
							[
								118.02084367300006,
								-35.10853708199994
							],
							[
								118.01471652300006,
								-35.09549704199998
							],
							[
								118.00093142500009,
								-35.087313921999964
							],
							[
								117.9791253090001,
								-35.096371432999945
							],
							[
								117.94360362400005,
								-35.09165032499993
							],
							[
								117.93468452400009,
								-35.075474164999946
							],
							[
								117.9389362930001,
								-35.05929893499996
							],
							[
								117.91898243500009,
								-35.05109797599994
							],
							[
								117.9203642540001,
								-35.04085683599993
							],
							[
								117.91040362700005,
								-35.05354905599995
							],
							[
								117.92776539500005,
								-35.06243706599997
							],
							[
								117.92786449500011,
								-35.07287119599994
							],
							[
								117.91051465900011,
								-35.08435244699996
							],
							[
								117.88789904200007,
								-35.077527517999954
							],
							[
								117.84825764600009,
								-35.045555528999955
							],
							[
								117.8596067630001,
								-35.02684253899997
							],
							[
								117.90866356600009,
								-35.039068475999954
							],
							[
								117.91954745400005,
								-35.035771515999954
							],
							[
								117.91868989300008,
								-35.01656450599995
							],
							[
								117.94868945700011,
								-34.99815804399998
							],
							[
								117.93939749800006,
								-34.985840964999966
							],
							[
								117.94619825600012,
								-34.97999087399995
							],
							[
								117.94894108300002,
								-34.94363670399997
							],
							[
								117.9769389490001,
								-34.952010272999985
							],
							[
								117.97385268900007,
								-34.93853910299998
							],
							[
								117.98146972800009,
								-34.94001006299993
							],
							[
								117.97343101000001,
								-34.960248372999956
							],
							[
								117.97972032100006,
								-34.990915712999936
							],
							[
								117.94881252700009,
								-35.001875093999956
							],
							[
								117.96188555600008,
								-35.01311614399998
							],
							[
								117.99884968000003,
								-35.00999550199998
							],
							[
								118.00401567000006,
								-35.02079255199993
							],
							[
								118.0231965260001,
								-35.01568495099997
							],
							[
								118.03481151500011,
								-35.02041259099997
							],
							[
								118.05222541100011,
								-35.01408434999996
							],
							[
								118.07183017700004,
								-34.99389422899998
							],
							[
								118.10876879000011,
								-34.98588844699998
							],
							[
								118.16746377100003,
								-34.99521560399995
							],
							[
								118.17699013100003,
								-35.013803853999946
							],
							[
								118.1921270790001,
								-35.013476622999974
							],
							[
								118.1874653000001,
								-35.02460984399994
							],
							[
								118.194656269,
								-35.023108642999944
							],
							[
								118.20591093600001,
								-35.009202432999984
							],
							[
								118.19993986700001,
								-35.00348641299996
							],
							[
								118.21213246400009,
								-34.98907913199997
							],
							[
								118.21071035300008,
								-34.978831001999936
							],
							[
								118.19040310600008,
								-34.96735906299995
							],
							[
								118.18261732700012,
								-34.97293422399997
							],
							[
								118.17256821900003,
								-34.96773226399995
							],
							[
								118.1753336060001,
								-34.94007988399994
							],
							[
								118.2110098710001,
								-34.94393551199994
							],
							[
								118.20682065100004,
								-34.934976441999936
							],
							[
								118.22366503700005,
								-34.91984412199997
							],
							[
								118.23917023400008,
								-34.91445302099993
							],
							[
								118.2549722120001,
								-34.91799576999995
							],
							[
								118.25988402100006,
								-34.90853860999994
							],
							[
								118.29970145400011,
								-34.911844257999974
							],
							[
								118.2986923840001,
								-34.90362520799994
							],
							[
								118.32092033000004,
								-34.90425000699997
							],
							[
								118.33404915800008,
								-34.89142380699997
							],
							[
								118.33127420800008,
								-34.898047876999954
							],
							[
								118.3391712770001,
								-34.902676835999955
							],
							[
								118.37862612100002,
								-34.90278053499998
							],
							[
								118.3905891490001,
								-34.907645473999935
							],
							[
								118.38972424000008,
								-34.91498653399998
							],
							[
								118.4034353180001,
								-34.91669051399998
							],
							[
								118.40261114700002,
								-34.90514736399996
							],
							[
								118.42775796300009,
								-34.89873099199997
							],
							[
								118.42241662300012,
								-34.88144581299997
							],
							[
								118.39708562600003,
								-34.87663107399993
							],
							[
								118.40043873200011,
								-34.82384038299995
							],
							[
								118.44015412200008,
								-34.760743040999955
							],
							[
								118.51984783600005,
								-34.71743775799996
							],
							[
								118.56192842900009,
								-34.703675085999976
							],
							[
								118.57921496600011,
								-34.70570192499997
							],
							[
								118.58636287400009,
								-34.69714970499996
							],
							[
								118.60129476200007,
								-34.697990553999944
							],
							[
								118.6200849280001,
								-34.68658604299998
							],
							[
								118.64520779500003,
								-34.69120782199997
							],
							[
								118.66609225000002,
								-34.66778734099995
							],
							[
								118.70140165300006,
								-34.65482286899993
							],
							[
								118.72239546000003,
								-34.65687967899993
							],
							[
								118.74596767500009,
								-34.638309326999945
							],
							[
								118.75200130300004,
								-34.622434116999955
							],
							[
								118.78171922800004,
								-34.60898750599995
							],
							[
								118.75648306100004,
								-34.60367384699998
							],
							[
								118.74545097200007,
								-34.593655886999954
							],
							[
								118.73964105200002,
								-34.57355060699996
							],
							[
								118.75536159800004,
								-34.54555945699997
							],
							[
								118.81160881700009,
								-34.50945917399997
							],
							[
								118.85617449900008,
								-34.501164641999935
							],
							[
								118.91417821000005,
								-34.503164039999945
							],
							[
								118.90579219100005,
								-34.49684506999995
							],
							[
								118.91294582900002,
								-34.48802287999996
							],
							[
								118.90096868,
								-34.47642683999993
							],
							[
								118.91180107800005,
								-34.462864569999965
							],
							[
								118.96091498900012,
								-34.451263876999974
							],
							[
								119.0580698340001,
								-34.463498942999934
							],
							[
								119.06911984200008,
								-34.45879900299997
							],
							[
								119.1175137250001,
								-34.47010655099996
							],
							[
								119.14529205200006,
								-34.48364010999995
							],
							[
								119.15224034100004,
								-34.49449697999995
							],
							[
								119.1735501280001,
								-34.49441147899995
							],
							[
								119.18072193600005,
								-34.48587520899997
							],
							[
								119.2178937110001,
								-34.49794782699996
							],
							[
								119.23937082900011,
								-34.51616375599997
							],
							[
								119.22225517200002,
								-34.53131814699998
							],
							[
								119.25450003700007,
								-34.53458675599995
							],
							[
								119.2578187260001,
								-34.518856555999946
							],
							[
								119.2668295840001,
								-34.515390414999956
							],
							[
								119.27887071300006,
								-34.523519464999936
							],
							[
								119.27720153300004,
								-34.51552332499995
							],
							[
								119.28485748100002,
								-34.51307134399997
							],
							[
								119.28860209000004,
								-34.493421963999936
							],
							[
								119.27747908100002,
								-34.49021404499996
							],
							[
								119.2798478200001,
								-34.47681188399997
							],
							[
								119.27115173100003,
								-34.46904788499995
							],
							[
								119.2898614070001,
								-34.45196653399995
							],
							[
								119.31479032300001,
								-34.44487330299995
							],
							[
								119.34640226800002,
								-34.44621027199997
							],
							[
								119.3662005650001,
								-34.46246924099995
							],
							[
								119.3557438680001,
								-34.47469147099997
							],
							[
								119.3821528840001,
								-34.485351299999934
							],
							[
								119.3902003710001,
								-34.45958188999998
							],
							[
								119.4186282070001,
								-34.45890733899995
							],
							[
								119.40242713900011,
								-34.45248654899996
							],
							[
								119.39725792900003,
								-34.44017145999993
							],
							[
								119.40324235700007,
								-34.42647298899993
							],
							[
								119.39085228900001,
								-34.41943203999995
							],
							[
								119.40799681500005,
								-34.39580945899996
							],
							[
								119.3986846460001,
								-34.38685949899997
							],
							[
								119.41574437200006,
								-34.37327510899996
							],
							[
								119.44194512800004,
								-34.366457656999955
							],
							[
								119.4534443770001,
								-34.37879267699998
							],
							[
								119.48252217200002,
								-34.37521433599994
							],
							[
								119.49247853100007,
								-34.393032405999975
							],
							[
								119.47811866400002,
								-34.40214689599998
							],
							[
								119.502728821,
								-34.41145947499996
							],
							[
								119.51634572800003,
								-34.41005142499995
							],
							[
								119.54745033200004,
								-34.38963362299995
							],
							[
								119.57628809800008,
								-34.38716740199993
							],
							[
								119.56989804800003,
								-34.37661128199994
							],
							[
								119.54185028300003,
								-34.382820643999935
							],
							[
								119.52882511400003,
								-34.36424766399995
							],
							[
								119.50745794700003,
								-34.35911396499995
							],
							[
								119.49915868700009,
								-34.32999158499996
							],
							[
								119.50321711400011,
								-34.29033603499994
							],
							[
								119.48666403700008,
								-34.29523043499995
							],
							[
								119.46983786900012,
								-34.28883261599998
							],
							[
								119.46175195000001,
								-34.29524268599994
							],
							[
								119.45739086100002,
								-34.287994605999984
							],
							[
								119.48211975600009,
								-34.27951433499993
							],
							[
								119.50373220300003,
								-34.288001004999956
							],
							[
								119.53492567500007,
								-34.22136883299993
							],
							[
								119.5878348230001,
								-34.17083264099995
							],
							[
								119.57841406500006,
								-34.16666699099994
							],
							[
								119.58269756300001,
								-34.150962790999984
							],
							[
								119.60875008800008,
								-34.126184889999934
							],
							[
								119.64027969200004,
								-34.11261622799998
							],
							[
								119.6334468230001,
								-34.10478128899996
							],
							[
								119.64283980000005,
								-34.09270509799995
							],
							[
								119.66641251600004,
								-34.08039947699996
							],
							[
								119.68758952300004,
								-34.07855087599995
							],
							[
								119.71092214800001,
								-34.06168823499996
							],
							[
								119.73385987400002,
								-34.06072807499993
							],
							[
								119.75044448100005,
								-34.04081450399997
							],
							[
								119.78174213500006,
								-34.02671896299995
							],
							[
								119.78799564300004,
								-34.00542084199998
							],
							[
								119.80322825000007,
								-33.99089761199997
							],
							[
								119.85062360100005,
								-33.96983282999997
							],
							[
								119.92046521000009,
								-33.96831876699997
							],
							[
								119.92895032900003,
								-33.97664988699995
							],
							[
								119.9444054170001,
								-33.977873185999954
							],
							[
								119.96750794200011,
								-33.95605691499998
							],
							[
								119.98419083900001,
								-33.95458221399997
							],
							[
								119.99137867700006,
								-33.935884743999964
							],
							[
								120.01135246400008,
								-33.93675915299997
							],
							[
								120.04407002800008,
								-33.923119321999934
							],
							[
								120.12660224700005,
								-33.95447342899996
							],
							[
								120.13379004500007,
								-33.94671841899998
							],
							[
								120.17673560800006,
								-33.93481113699994
							],
							[
								120.23107526900003,
								-33.93239240499997
							],
							[
								120.31547570700002,
								-33.94225316199993
							],
							[
								120.43658009900003,
								-33.97186798799993
							],
							[
								120.44719089700004,
								-33.963534797999955
							],
							[
								120.46935800400001,
								-33.96672056699998
							],
							[
								120.47128575300007,
								-33.95676743699994
							],
							[
								120.49472067900001,
								-33.95318815599995
							],
							[
								120.5180242450001,
								-33.93539869499995
							],
							[
								120.55838787800008,
								-33.92639913299996
							],
							[
								120.55338003800011,
								-33.90315739399995
							],
							[
								120.59348200000011,
								-33.886232261999965
							],
							[
								120.63900997400003,
								-33.891715439999984
							],
							[
								120.6718841280001,
								-33.88503038899995
							],
							[
								120.71269298200002,
								-33.89320843799993
							],
							[
								120.77976311100008,
								-33.88592843599997
							],
							[
								120.81348395600003,
								-33.89263640399997
							],
							[
								120.81137400600005,
								-33.88638338399994
							],
							[
								120.8400170110001,
								-33.87335005299997
							],
							[
								120.8411048910001,
								-33.865682972999934
							],
							[
								120.86854595600005,
								-33.85624642199997
							],
							[
								120.90615638000008,
								-33.86143409099998
							],
							[
								120.91812852900011,
								-33.870524100999944
							],
							[
								120.93977517500002,
								-33.862250409999945
							],
							[
								121.00793114500004,
								-33.87273501799996
							],
							[
								121.01392389400007,
								-33.86093295799998
							],
							[
								121.04892319800001,
								-33.85696038599997
							],
							[
								121.07943609300003,
								-33.86228640499996
							],
							[
								121.08349704200009,
								-33.85111722499994
							],
							[
								121.0998453200001,
								-33.84849491499995
							],
							[
								121.17277679900008,
								-33.86707188199995
							],
							[
								121.1771451190001,
								-33.87759441199995
							],
							[
								121.19870599400008,
								-33.84456728099997
							],
							[
								121.26850190300001,
								-33.85069736899993
							],
							[
								121.27591001200005,
								-33.84222737899995
							],
							[
								121.29634902900011,
								-33.840185367999936
							],
							[
								121.29900253700009,
								-33.82503125799997
							],
							[
								121.32382888300003,
								-33.82156139699998
							],
							[
								121.34946090000005,
								-33.830238375999954
							],
							[
								121.35020607900003,
								-33.820236405999935
							],
							[
								121.36149205700008,
								-33.81542803599996
							],
							[
								121.3993228810001,
								-33.818801124999936
							],
							[
								121.42856123700005,
								-33.83021739399993
							],
							[
								121.4355339760001,
								-33.82006641399994
							],
							[
								121.46000894200006,
								-33.82834433299996
							],
							[
								121.46774212100001,
								-33.822845332999975
							],
							[
								121.50484618600001,
								-33.83958715199998
							],
							[
								121.53161291100002,
								-33.82571534099998
							],
							[
								121.54659429900005,
								-33.82797592999998
							],
							[
								121.62767604800001,
								-33.86929640799997
							],
							[
								121.64656377600011,
								-33.88735436699994
							],
							[
								121.64469420700004,
								-33.89816492799997
							],
							[
								121.67482345100007,
								-33.874470996999946
							],
							[
								121.67669353000008,
								-33.863104635999946
							],
							[
								121.69509394700003,
								-33.86119639599997
							],
							[
								121.76315299800001,
								-33.886894353999935
							],
							[
								121.75694314900011,
								-33.88595454399996
							],
							[
								121.78988348400003,
								-33.90903543299993
							],
							[
								121.8037628620001,
								-33.899315092999984
							],
							[
								121.82366261900006,
								-33.897285771999975
							],
							[
								121.82928237700003,
								-33.88886549199998
							],
							[
								121.86484209200012,
								-33.890635240999984
							],
							[
								121.8634121020001,
								-33.881945160999976
							],
							[
								121.87454204000005,
								-33.87682510099995
							],
							[
								121.8873518580001,
								-33.88263515999995
							],
							[
								121.9004919360001,
								-33.878985229999955
							],
							[
								121.90810601400005,
								-33.86749415999998
							],
							[
								121.90181399500011,
								-33.87256621999995
							],
							[
								121.89398204600002,
								-33.863505059999966
							],
							[
								121.91511211200009,
								-33.838244918999976
							],
							[
								121.95611197500011,
								-33.83347508799994
							],
							[
								121.98297181100008,
								-33.83912516699996
							],
							[
								121.98628181000004,
								-33.82921501699997
							],
							[
								122.00101170800008,
								-33.82928496699998
							],
							[
								122.03079161400001,
								-33.84496504599997
							],
							[
								122.08539166800006,
								-33.90278483499998
							],
							[
								122.11899210600006,
								-33.98001535399993
							],
							[
								122.10986232800008,
								-33.99250555399993
							],
							[
								122.09320245000004,
								-33.993915724999965
							],
							[
								122.0933025710001,
								-34.00282583499995
							],
							[
								122.1125324080001,
								-34.000355603999935
							],
							[
								122.1135827380001,
								-34.017185773999984
							],
							[
								122.13675253400004,
								-34.00658540399996
							],
							[
								122.14486264300001,
								-34.01438539299994
							],
							[
								122.15657261100012,
								-34.01354538299995
							],
							[
								122.165312459,
								-34.00242520299997
							],
							[
								122.17146197900001,
								-34.01140545299995
							],
							[
								122.19326182600003,
								-34.01717547199996
							],
							[
								122.18900176600005,
								-34.00814538199995
							],
							[
								122.20077158400011,
								-34.00848537199994
							],
							[
								122.1978015840001,
								-34.00029526199995
							],
							[
								122.20944146200009,
								-34.00074523099994
							],
							[
								122.21154153200007,
								-34.00871533099996
							],
							[
								122.22703117900005,
								-33.98799503099997
							],
							[
								122.24380120700005,
								-33.994125029999964
							],
							[
								122.24944173600011,
								-34.00458514999997
							],
							[
								122.2641113740001,
								-33.99586494999994
							],
							[
								122.27732153200009,
								-34.00073495999993
							],
							[
								122.28065135100007,
								-33.98980480899996
							],
							[
								122.26825215200006,
								-33.96813468999994
							],
							[
								122.274511501,
								-33.95946441899997
							],
							[
								122.32629105100011,
								-33.928893907999964
							],
							[
								122.3414509590001,
								-33.92654383699994
							],
							[
								122.35416090700005,
								-33.93310386699994
							],
							[
								122.3493108670001,
								-33.92182376699998
							],
							[
								122.36421074500004,
								-33.913503626999955
							],
							[
								122.44444036200002,
								-33.91921321499996
							],
							[
								122.49112027600006,
								-33.938973132999934
							],
							[
								122.5007302140001,
								-33.93649306299994
							],
							[
								122.50967030300001,
								-33.953403152999954
							],
							[
								122.5360600890001,
								-33.93525298199995
							],
							[
								122.5575800150001,
								-33.93660293199997
							],
							[
								122.5608300450001,
								-33.94483299199993
							],
							[
								122.57504997300009,
								-33.94832299099994
							],
							[
								122.57154009400006,
								-33.96140310099997
							],
							[
								122.58264003200009,
								-33.95802304099993
							],
							[
								122.57654001300011,
								-33.95520303099994
							],
							[
								122.58072995200007,
								-33.94516295099993
							],
							[
								122.59736982900006,
								-33.93726284099995
							],
							[
								122.58558989100004,
								-33.93287283099994
							],
							[
								122.58165983100002,
								-33.91630273099997
							],
							[
								122.59165972900007,
								-33.90964267099997
							],
							[
								122.6014096770001,
								-33.91335265999993
							],
							[
								122.598019668,
								-33.90242261999998
							],
							[
								122.61869951400001,
								-33.892822509999974
							],
							[
								122.64927938900007,
								-33.89742243899997
							],
							[
								122.65346932800003,
								-33.88930236899995
							],
							[
								122.66982924600006,
								-33.888602307999975
							],
							[
								122.7477689640001,
								-33.89581193599997
							],
							[
								122.75462888200002,
								-33.88126178599998
							],
							[
								122.77382878900005,
								-33.87772165599995
							],
							[
								122.81268865300001,
								-33.88937159499994
							],
							[
								122.82939865200001,
								-33.90996171399996
							],
							[
								122.93509817400002,
								-33.886090931999945
							],
							[
								122.97001789900003,
								-33.89003089099998
							],
							[
								122.97589790800009,
								-33.90230098099994
							],
							[
								122.9790678170001,
								-33.88740083999994
							],
							[
								123.00226769400001,
								-33.885500659999934
							],
							[
								123.0048575830001,
								-33.87080050999998
							],
							[
								123.02272732900008,
								-33.85663035899995
							],
							[
								123.08312719000003,
								-33.87151991799993
							],
							[
								123.13389714400012,
								-33.90436000699998
							],
							[
								123.13977715300007,
								-33.911500056999955
							],
							[
								123.13416710400008,
								-33.917670216999966
							],
							[
								123.161077051,
								-33.94592049599993
							],
							[
								123.16244719100007,
								-33.968550695999966
							],
							[
								123.14846729400006,
								-33.97628084699994
							],
							[
								123.1556572830001,
								-33.97464078699994
							],
							[
								123.1721573210001,
								-33.98952084599995
							],
							[
								123.16540745200007,
								-34.00839109699996
							],
							[
								123.15199749400006,
								-34.01062119699998
							],
							[
								123.1630775430001,
								-34.01662120699996
							],
							[
								123.21295727500001,
								-34.00184077499995
							],
							[
								123.22726709200003,
								-33.98891058499993
							],
							[
								123.25196703800009,
								-33.99747055399996
							],
							[
								123.27543679400003,
								-33.975850253999965
							],
							[
								123.28690673200003,
								-33.97986024299996
							],
							[
								123.3030365190001,
								-33.96112997299997
							],
							[
								123.29997646900006,
								-33.953669902999934
							],
							[
								123.32868601400003,
								-33.93465969199997
							],
							[
								123.33029588300008,
								-33.918769561999966
							],
							[
								123.37145542600001,
								-33.895879150999974
							],
							[
								123.4123052000001,
								-33.89381893999996
							],
							[
								123.47402505000002,
								-33.90616868899997
							],
							[
								123.50801511500003,
								-33.92208865799995
							],
							[
								123.51209534500003,
								-33.94250884799993
							],
							[
								123.53429519200006,
								-33.940118677999976
							],
							[
								123.55303501900005,
								-33.92777834699996
							],
							[
								123.5580147070001,
								-33.90603805699993
							],
							[
								123.573384454,
								-33.88771765599995
							],
							[
								123.63914357300007,
								-33.876986614999964
							],
							[
								123.65630310000006,
								-33.84693599399998
							],
							[
								123.69366324300006,
								-33.83147698299996
							],
							[
								123.70763307100003,
								-33.81640677299998
							],
							[
								123.74237325500008,
								-33.80915714199995
							],
							[
								123.76416317100006,
								-33.79522653199996
							],
							[
								123.74920302300006,
								-33.78312664199996
							],
							[
								123.74750285300001,
								-33.765316601999984
							],
							[
								123.75694336000004,
								-33.72305540199994
							],
							[
								123.7744268570001,
								-33.69817251099994
							],
							[
								123.81024284000011,
								-33.664755369999966
							],
							[
								123.87772139900005,
								-33.633164618999956
							],
							[
								123.86683144000006,
								-33.61872447899998
							],
							[
								123.87508113800004,
								-33.59900414799995
							],
							[
								123.9307403790001,
								-33.58664421699996
							],
							[
								123.93574025800001,
								-33.57684416699993
							],
							[
								123.9502900660001,
								-33.57560410699995
							],
							[
								123.97602964100008,
								-33.55859268599994
							],
							[
								123.9980098640001,
								-33.426361404999966
							],
							[
								124.07911966600011,
								-33.24921110199995
							],
							[
								124.10119829100006,
								-33.17614017099993
							],
							[
								124.15431666000006,
								-33.096048819999965
							],
							[
								124.23866478500008,
								-33.017577107999955
							],
							[
								124.3053937840001,
								-32.98089599599996
							],
							[
								124.39358270000002,
								-32.94906466499998
							],
							[
								124.74100971600001,
								-32.90013014799996
							],
							[
								124.81404883500011,
								-32.87284904699993
							],
							[
								124.89458768200006,
								-32.83281774499994
							],
							[
								124.92805678600007,
								-32.79414702399998
							],
							[
								124.99308586500001,
								-32.76268600299994
							],
							[
								125.02619508900011,
								-32.72884530199997
							],
							[
								125.10242440800005,
								-32.71538431099998
							],
							[
								125.23035236700002,
								-32.64322218899997
							],
							[
								125.31528124300007,
								-32.60790091699994
							],
							[
								125.37070064500006,
								-32.591680115999964
							],
							[
								125.43903002400009,
								-32.582879254999966
							],
							[
								125.48507936700003,
								-32.559628533999955
							],
							[
								125.5320688700001,
								-32.54921789399998
							],
							[
								125.80123464700011,
								-32.366710988999955
							],
							[
								125.87082247600006,
								-32.33661285799997
							],
							[
								125.95101938300002,
								-32.290528636999966
							],
							[
								126.03706137000006,
								-32.268577284999935
							],
							[
								126.0811807340001,
								-32.27510601499995
							],
							[
								126.16069827100011,
								-32.23772450399997
							],
							[
								126.20314846500003,
								-32.23226300299996
							],
							[
								126.42203429400001,
								-32.28407042099997
							],
							[
								126.67279768700007,
								-32.30835679899997
							],
							[
								126.73424874800003,
								-32.30586944799995
							],
							[
								126.77258758200003,
								-32.29232750799997
							],
							[
								126.9565318550001,
								-32.29758509599998
							],
							[
								127.08932150500004,
								-32.28055482499997
							],
							[
								127.21338038700003,
								-32.27637353399996
							],
							[
								127.3259690000001,
								-32.256512242999975
							],
							[
								127.45208692100005,
								-32.22228019199997
							],
							[
								127.51882646100012,
								-32.21410981199995
							],
							[
								127.54860593700005,
								-32.19073930199994
							],
							[
								127.58538512100006,
								-32.17503887099997
							],
							[
								127.7057141030001,
								-32.13668808999995
							],
							[
								128.02238049700009,
								-32.073965708999935
							],
							[
								128.31427778400007,
								-31.97935367699995
							],
							[
								128.41102761900004,
								-31.938223006999976
							],
							[
								128.49483595700008,
								-31.911891646999948
							],
							[
								128.55175915900008,
								-31.878147145999947
							],
							[
								128.590241353,
								-31.87164215599995
							],
							[
								128.59660184200004,
								-31.863071315999946
							],
							[
								128.64234363600008,
								-31.850920865999967
							],
							[
								128.70671177600002,
								-31.808638835999943
							],
							[
								128.89637064900012,
								-31.71702894499998
							],
							[
								129.00192754400007,
								-31.686990624999964
							],
							[
								129.00191947500002,
								-30.305436806999978
							],
							[
								129.00189741600002,
								-29.033055028999968
							],
							[
								129.00188186600008,
								-28.11589847299996
							],
							[
								129.0018590960001,
								-26.74500413399994
							],
							[
								129.0018469360001,
								-25.998591869999927
							],
							[
								129.00057414600008,
								-25.661145266999938
							],
							[
								129.00055232600005,
								-24.13743811699993
							],
							[
								129.00054424600012,
								-23.440298172999974
							],
							[
								127.8159379330001,
								-23.44030120599996
							],
							[
								126.00133809300007,
								-23.449066202999973
							],
							[
								124.78533122400006,
								-23.44143823199994
							],
							[
								123.79335933200002,
								-23.443930251999973
							],
							[
								122.79163043200003,
								-23.44206627699998
							],
							[
								121.9109674990001,
								-23.441013871999928
							],
							[
								121.00478135800006,
								-23.440299141999958
							],
							[
								121.0047853100001,
								-23.727933823999933
							],
							[
								120.67101569400006,
								-23.727936444999955
							],
							[
								120.61001621300011,
								-23.812335557999972
							],
							[
								120.53733512200006,
								-23.85273063099993
							],
							[
								120.50787772500007,
								-23.85048162199996
							],
							[
								120.43642927700012,
								-23.95363098499996
							],
							[
								120.41012950200002,
								-24.01722254699996
							],
							[
								120.36492750900004,
								-24.071995648999973
							],
							[
								120.3211317460001,
								-24.10858109999998
							],
							[
								120.21956529200008,
								-24.246088614999962
							],
							[
								120.21287072500002,
								-24.285776444999954
							],
							[
								120.18346739000003,
								-24.33088894699995
							],
							[
								120.1583667430001,
								-24.344484437999938
							],
							[
								120.13247123700012,
								-24.370654368999965
							],
							[
								120.11141629300005,
								-24.45628352999995
							],
							[
								120.07814833700002,
								-24.476114561999964
							],
							[
								120.06666324900004,
								-24.492998661999934
							],
							[
								120.09249038900009,
								-24.540128410999955
							],
							[
								120.04285901100002,
								-24.707370373999936
							],
							[
								120.05604004100007,
								-24.73351611399994
							],
							[
								120.0553185870001,
								-24.84495140499996
							],
							[
								120.1054183760001,
								-24.940142152999954
							],
							[
								120.11539181700005,
								-24.99753947299996
							],
							[
								120.19503244600003,
								-25.14869159099993
							],
							[
								120.20236850600008,
								-25.182595670999945
							],
							[
								120.20219535700005,
								-25.192064840999933
							],
							[
								120.16733260100011,
								-25.200327111999968
							],
							[
								120.13700581600006,
								-25.23238556399997
							],
							[
								120.08505062600011,
								-25.338538765999942
							],
							[
								120.08643450600005,
								-25.551875396999947
							],
							[
								120.09945678800011,
								-25.621887396999966
							],
							[
								120.1072662570001,
								-25.631853546999935
							],
							[
								120.11885899200001,
								-25.75438548699998
							],
							[
								120.0078901070001,
								-26.027020512999968
							],
							[
								119.96108040500008,
								-26.085730204999948
							],
							[
								119.92177381400006,
								-26.18763423699994
							],
							[
								119.89446634800004,
								-26.213600507999956
							],
							[
								119.86730794400012,
								-26.256932259999928
							],
							[
								119.80802928600008,
								-26.37077714299994
							],
							[
								119.80465177000008,
								-26.44027901299995
							],
							[
								119.61388205700007,
								-26.55270872099993
							],
							[
								119.60244449900006,
								-26.57108834199994
							],
							[
								119.58343468200007,
								-26.57767301299998
							],
							[
								119.57667137400006,
								-26.605713332999983
							],
							[
								119.52846882100005,
								-26.644423864999965
							],
							[
								119.50188821600011,
								-26.68087187699996
							],
							[
								119.48584592000009,
								-26.722004476999928
							],
							[
								119.44751997700007,
								-26.76883266899995
							],
							[
								119.41137812200009,
								-26.78513535099995
							],
							[
								119.33953544400003,
								-26.863774553999974
							],
							[
								119.28787652800008,
								-27.008641996999984
							],
							[
								119.2732497400001,
								-27.01491238799997
							],
							[
								119.23655819600003,
								-27.06281983899993
							],
							[
								119.20136278600012,
								-27.169370741999955
							],
							[
								119.20109396900011,
								-27.231038411999975
							],
							[
								119.33254425400003,
								-27.242158055999937
							],
							[
								119.58496654500004,
								-27.24215471599996
							],
							[
								119.58496690700008,
								-27.290265405999946
							],
							[
								120.0584038610001,
								-27.290259377999973
							],
							[
								120.05840588100011,
								-27.50225938899996
							],
							[
								120.07470188900004,
								-27.50225938799997
							],
							[
								120.07470269400005,
								-27.612609878999933
							],
							[
								120.15751374400008,
								-27.61260885599995
							],
							[
								120.15429333600002,
								-28.04759319799996
							],
							[
								120.19618489000004,
								-28.04719139699995
							],
							[
								120.19618789200001,
								-28.291129397999953
							],
							[
								120.04498593100004,
								-28.291130403999944
							],
							[
								120.04519675900008,
								-28.46399358499997
							],
							[
								119.80261994900002,
								-28.46407540399997
							],
							[
								119.80262397900003,
								-28.847797415999935
							],
							[
								119.7757702020001,
								-28.847813676999976
							],
							[
								119.77579396500005,
								-28.915108406999934
							],
							[
								119.66305166000006,
								-29.11297301299993
							],
							[
								119.34441605100005,
								-29.11092343599995
							],
							[
								119.20065129900001,
								-29.290927532999945
							],
							[
								118.72034855100003,
								-29.292270452999958
							],
							[
								118.72034515000007,
								-29.106909461999976
							],
							[
								118.43575417700004,
								-29.10507946499996
							],
							[
								118.43571016700002,
								-29.279364475999955
							],
							[
								118.50322217700011,
								-29.612415453999972
							],
							[
								117.69523978300003,
								-29.612420010999983
							],
							[
								117.69668029400009,
								-29.625545500999976
							],
							[
								117.70188329300004,
								-29.62258350099995
							],
							[
								117.71054029200002,
								-29.630419510999957
							],
							[
								117.71092828300004,
								-29.65240750099997
							],
							[
								117.72164830200006,
								-29.654643499999963
							],
							[
								117.70325730600007,
								-29.67548149099997
							],
							[
								117.66897231000007,
								-29.672578492999946
							],
							[
								117.67582130900007,
								-29.669342512999947
							],
							[
								117.67259529900002,
								-29.662573512999984
							],
							[
								117.63443630400002,
								-29.65459350499998
							],
							[
								117.61743632500009,
								-29.64206949499993
							],
							[
								117.60347131700007,
								-29.644044505999943
							],
							[
								117.58330031800006,
								-29.61759449699997
							],
							[
								117.57326931900002,
								-29.620535496999935
							],
							[
								117.58144129900006,
								-29.635888506999947
							],
							[
								117.56757032100006,
								-29.63591049799993
							],
							[
								117.55060731800006,
								-29.704391508999947
							],
							[
								117.56940032700004,
								-29.737145517999977
							],
							[
								117.55167231000007,
								-29.73753451899995
							],
							[
								117.55057133000003,
								-29.747684508999953
							],
							[
								117.5550403200001,
								-29.74289449899993
							],
							[
								117.55531531000008,
								-29.753428518999954
							],
							[
								117.56953931900011,
								-29.75615150799996
							],
							[
								117.5519353310001,
								-29.755936498999972
							],
							[
								117.54272733300002,
								-29.76820951999997
							],
							[
								117.509434338,
								-29.776691510999967
							],
							[
								117.49611932200003,
								-29.81488152199995
							],
							[
								117.49430933600001,
								-29.875878521999937
							],
							[
								117.50931134500001,
								-29.884409511999934
							],
							[
								117.52731529100004,
								-29.871200160999933
							],
							[
								117.57342431500001,
								-29.867458518999968
							],
							[
								117.5993523410001,
								-29.850499506999938
							],
							[
								117.6270513070001,
								-29.844984515999954
							],
							[
								117.63577331600004,
								-29.85134951499998
							],
							[
								117.63486529600004,
								-29.84527649499995
							],
							[
								117.6661173230001,
								-29.869653503999928
							],
							[
								117.6646163050001,
								-29.895493503999944
							],
							[
								117.67120429400006,
								-29.897939503999964
							],
							[
								117.66159030600011,
								-29.91489451399997
							],
							[
								117.66449132700006,
								-29.928975513999944
							],
							[
								117.66022130800002,
								-29.93261651499995
							],
							[
								117.65778430800003,
								-29.92755150499994
							],
							[
								117.65820131800001,
								-29.936697504999984
							],
							[
								117.63692033200005,
								-29.950182505999976
							],
							[
								117.58430434900004,
								-29.94460149799994
							],
							[
								117.56752132100007,
								-29.948830508999947
							],
							[
								117.52215733600008,
								-29.926489500999935
							],
							[
								117.5121073570001,
								-29.927812511999946
							],
							[
								117.5049843490001,
								-29.940819511999962
							],
							[
								117.50761234900006,
								-29.95201751199994
							],
							[
								117.52915533700002,
								-29.966455520999943
							],
							[
								117.52233333900006,
								-29.97307652099994
							],
							[
								117.52922132800006,
								-29.97213851099997
							],
							[
								117.5219923200001,
								-29.996795521999957
							],
							[
								117.53084941200007,
								-30.04066531099994
							],
							[
								117.52965313700008,
								-30.122210181999947
							],
							[
								117.53134118800006,
								-30.13979428199997
							],
							[
								117.54269125700012,
								-30.150457760999984
							],
							[
								117.52226703100007,
								-30.162154071999964
							],
							[
								117.5331991490001,
								-30.162230561999934
							],
							[
								117.55367593900007,
								-30.205780490999928
							],
							[
								117.42232672700004,
								-30.206176306999964
							],
							[
								117.42927074600004,
								-30.209443216999944
							],
							[
								117.41654560800009,
								-30.209923387999936
							],
							[
								117.42125972800011,
								-30.21744237799993
							],
							[
								117.40165072000002,
								-30.21814158899997
							],
							[
								117.39937987100006,
								-30.22602067899993
							],
							[
								117.25098038100009,
								-30.22633820599998
							],
							[
								117.25044264200005,
								-30.390319836999936
							],
							[
								117.24347085400007,
								-30.40864784699994
							],
							[
								117.24967194700002,
								-30.46272831699997
							],
							[
								117.24437597800011,
								-30.462742336999952
							],
							[
								117.24170575000005,
								-30.497901497999976
							],
							[
								117.23380858100006,
								-30.499856527999953
							],
							[
								117.23383887300008,
								-30.528114037999956
							],
							[
								117.24523111200006,
								-30.528084597999964
							],
							[
								117.24537802800012,
								-30.623189257999968
							],
							[
								117.238023569,
								-30.62319084899997
							],
							[
								117.23808453200002,
								-30.661361428999953
							],
							[
								117.2475364610001,
								-30.665068867999935
							],
							[
								117.24832759200001,
								-30.689720937999937
							],
							[
								117.25776759100006,
								-30.689712347999944
							],
							[
								117.25777131200005,
								-30.70278794799998
							],
							[
								117.24160141400012,
								-30.702690338999957
							],
							[
								117.24181037700009,
								-30.757228878999967
							],
							[
								117.21108753500005,
								-30.805795650999983
							],
							[
								117.27457810600004,
								-30.806580527999984
							],
							[
								117.27895709800009,
								-30.99869932799993
							],
							[
								117.24781118300007,
								-31.001868599999966
							],
							[
								117.24664686800008,
								-31.07053553999998
							],
							[
								117.25744104700004,
								-31.087188899999944
							],
							[
								117.2485512180001,
								-31.087286929999948
							],
							[
								117.2518651690001,
								-31.104657619999955
							],
							[
								117.24244492100001,
								-31.113069680999956
							],
							[
								117.24727325200001,
								-31.129621999999983
							],
							[
								117.24097532200005,
								-31.12961662099997
							],
							[
								117.23960354400003,
								-31.146936470999947
							],
							[
								117.23963070700006,
								-31.18970749099998
							],
							[
								117.2503928750001,
								-31.18574825099995
							],
							[
								117.2569230150001,
								-31.19959153999997
							],
							[
								117.26821016300005,
								-31.199570259999973
							],
							[
								117.27253249500006,
								-31.230507529999954
							],
							[
								117.26640958700011,
								-31.24936404999994
							],
							[
								117.2485874790001,
								-31.249360440999965
							],
							[
								117.24857138000004,
								-31.259210620999966
							],
							[
								117.261795258,
								-31.259220419999963
							],
							[
								117.261755289,
								-31.275236459999974
							],
							[
								117.25333646000001,
								-31.275244250999947
							],
							[
								117.253237291,
								-31.282466360999933
							],
							[
								117.26262330000009,
								-31.288079289999928
							],
							[
								117.26461872200002,
								-31.32763584099996
							],
							[
								117.2802283100001,
								-31.327614919999974
							],
							[
								117.27023913700009,
								-31.402593150999962
							],
							[
								117.23214891200007,
								-31.40268555199998
							],
							[
								117.22314889100005,
								-31.368947702999947
							],
							[
								117.20850885300001,
								-31.36898825299994
							],
							[
								117.20852556300008,
								-31.376279503999967
							],
							[
								117.17210703800004,
								-31.37048579499998
							],
							[
								117.17215101900001,
								-31.376299764999942
							],
							[
								117.14258318300006,
								-31.38040414699998
							],
							[
								117.14262146400006,
								-31.396389286999977
							],
							[
								117.13313552500006,
								-31.396387396999955
							],
							[
								117.13307449500007,
								-31.38795870699994
							],
							[
								117.05798414600008,
								-31.394338140999935
							],
							[
								117.05715869700009,
								-31.403478550999978
							],
							[
								117.03290011000001,
								-31.404376571999933
							],
							[
								117.03276357200002,
								-31.426918532999935
							],
							[
								116.99116174700009,
								-31.42687833499997
							],
							[
								116.99103001900005,
								-31.448218544999975
							],
							[
								116.9658341820001,
								-31.44826081599996
							],
							[
								116.87763249800003,
								-31.491231440999968
							],
							[
								116.87182300800009,
								-31.482533110999952
							],
							[
								116.85516971100003,
								-31.489548941999942
							],
							[
								116.86035041200012,
								-31.51920364199998
							],
							[
								116.84494978500004,
								-31.525670932999958
							],
							[
								116.86226188300009,
								-31.538981471999932
							],
							[
								116.87488540100003,
								-31.53371669099994
							],
							[
								116.91278572100009,
								-31.606456118999972
							],
							[
								116.94346619900011,
								-31.647332437999978
							],
							[
								116.94626360100006,
								-31.67481298799993
							],
							[
								116.95615855900007,
								-31.673889317999965
							],
							[
								116.96146211900009,
								-31.68296672699995
							],
							[
								116.94355913200002,
								-31.69069536799998
							],
							[
								116.98934728100005,
								-31.761247965999928
							],
							[
								117.00493372900007,
								-31.767202035999958
							],
							[
								117.01417326900003,
								-31.783919614999945
							],
							[
								117.05765775200007,
								-31.77007383299997
							],
							[
								117.07530711100003,
								-31.79777421199998
							],
							[
								117.09092180900006,
								-31.80442666099998
							],
							[
								117.10314802700009,
								-31.801231050999945
							],
							[
								117.10666797700003,
								-31.80723772099998
							],
							[
								117.12376924400007,
								-31.79992201999994
							],
							[
								117.15832456300006,
								-31.85662816799993
							],
							[
								117.13563437700009,
								-31.862575308999965
							],
							[
								117.141407877,
								-31.87177818899994
							],
							[
								117.11099035200004,
								-31.88530222099996
							],
							[
								117.11844799100004,
								-31.894551319999948
							],
							[
								117.12622607000003,
								-31.89102859999997
							],
							[
								117.14178397900002,
								-31.910563448999937
							],
							[
								117.09642970700008,
								-31.93051909199994
							],
							[
								117.10510578700007,
								-31.94501275099998
							],
							[
								117.08764521,
								-31.959493031999955
							],
							[
								117.09961546000011,
								-31.981817261999936
							],
							[
								117.0931958110001,
								-31.98430283199997
							],
							[
								117.06433172400011,
								-31.964416512999946
							],
							[
								117.05380658600006,
								-31.96898255399998
							],
							[
								117.06117848500003,
								-31.97719318399993
							],
							[
								117.05615396600001,
								-31.979381183999976
							],
							[
								117.04255837700009,
								-31.961874114999944
							],
							[
								117.0108847030001,
								-31.977684065999938
							],
							[
								116.98701476600002,
								-31.979164176999973
							],
							[
								116.93370911500006,
								-31.999335839999958
							],
							[
								116.92143321600008,
								-31.99175908099994
							],
							[
								116.81163105600001,
								-32.04009049699994
							],
							[
								116.82005558500009,
								-32.052793565999934
							],
							[
								116.75601265600005,
								-32.08050922999996
							],
							[
								116.73947877700004,
								-32.05226688999994
							],
							[
								116.7180225510001,
								-32.06174355099995
							],
							[
								116.7286698900001,
								-32.07949650099994
							],
							[
								116.7010737060001,
								-32.09966948299996
							],
							[
								116.7102115560001,
								-32.11502675199995
							],
							[
								116.68287218000012,
								-32.12678831399995
							],
							[
								116.67338098100004,
								-32.11096297399996
							],
							[
								116.61533116900011,
								-32.11167183699996
							],
							[
								116.61421876100007,
								-32.13981536699998
							],
							[
								116.50937588600004,
								-32.139760912999975
							],
							[
								116.50924951400009,
								-32.11166559299994
							],
							[
								116.44511034300001,
								-32.11168627599994
							],
							[
								116.44545548100007,
								-32.08313215599998
							],
							[
								116.39231951900001,
								-32.082561838999936
							],
							[
								116.39207771000008,
								-32.09353779899993
							],
							[
								116.34403867700007,
								-32.09355787099997
							],
							[
								116.34417580800005,
								-32.11308605099998
							],
							[
								116.28497953700003,
								-32.11313726399993
							],
							[
								116.28244965100009,
								-32.17001741499996
							],
							[
								116.31244746700008,
								-32.17107887299994
							],
							[
								116.34380950700006,
								-32.231754631999934
							],
							[
								116.35809056500011,
								-32.23633647099996
							],
							[
								116.22491183400007,
								-32.23587188799996
							],
							[
								116.18956509300006,
								-32.28741410999993
							],
							[
								116.25968969100006,
								-32.38987158699996
							],
							[
								116.26451589100009,
								-32.67506982799995
							],
							[
								116.20636023000009,
								-32.675186560999975
							],
							[
								116.20599271600008,
								-32.75542260199995
							],
							[
								116.22598716300001,
								-32.755885949999936
							],
							[
								116.2258497360001,
								-32.79186332099994
							],
							[
								116.18759223100005,
								-32.78172636299996
							],
							[
								116.18753493200006,
								-32.80319676299996
							],
							[
								116.17823487400005,
								-32.803230852999945
							],
							[
								116.1799638540001,
								-32.94309662399996
							],
							[
								116.18911210500005,
								-32.97132315299996
							],
							[
								116.19965900300008,
								-32.967064112999935
							],
							[
								116.20887021300007,
								-32.98419336199993
							],
							[
								116.20907579000004,
								-33.085040042999935
							],
							[
								116.14690976000009,
								-33.08487178599995
							],
							[
								116.14477175100001,
								-33.23186558699996
							],
							[
								116.0085448320001,
								-33.23192459399996
							],
							[
								116.03121099700002,
								-33.21294640299993
							],
							[
								116.03122676500004,
								-33.19118359299995
							],
							[
								116.01578076700002,
								-33.18295259399997
							],
							[
								116.01471178800011,
								-33.20175161399993
							],
							[
								116.00240378100011,
								-33.21081060499995
							],
							[
								115.94658678000008,
								-33.22172859799997
							],
							[
								115.94699514500007,
								-33.28984223799995
							],
							[
								115.91859585000009,
								-33.28998791899994
							],
							[
								115.91893676300003,
								-33.33905175999996
							],
							[
								115.927871202,
								-33.34166659899995
							],
							[
								115.92787149300011,
								-33.348933288999945
							],
							[
								115.91900557400004,
								-33.34893282999997
							],
							[
								115.91921008600002,
								-33.37861172999993
							],
							[
								115.93700306400001,
								-33.378064148999954
							],
							[
								115.93919988400012,
								-33.38884361899994
							],
							[
								115.97981656900004,
								-33.40163464699998
							],
							[
								115.98316496900009,
								-33.41176712599997
							],
							[
								115.99259321700004,
								-33.399046935999934
							],
							[
								116.00519206800004,
								-33.431718614999966
							],
							[
								116.0181119660001,
								-33.430364734999955
							],
							[
								116.00554728700001,
								-33.42196843499994
							],
							[
								116.0050873460001,
								-33.405705454999975
							],
							[
								116.0200823130001,
								-33.40323709399996
							],
							[
								116.00912741400009,
								-33.39599745499993
							],
							[
								116.0170694520001,
								-33.38527993399998
							],
							[
								116.0007075630001,
								-33.36335603499998
							],
							[
								116.02333485800011,
								-33.347390563999966
							],
							[
								116.04982775500002,
								-33.35437470299996
							],
							[
								116.05797889300004,
								-33.347699131999946
							],
							[
								116.0578723540001,
								-33.360723331999964
							],
							[
								116.02329908900003,
								-33.36087727399996
							],
							[
								116.0236606950001,
								-33.44046762399995
							],
							[
								116.0641900390001,
								-33.440342071999964
							],
							[
								116.06526328300004,
								-33.48539268199994
							],
							[
								116.13282558200001,
								-33.486796038999955
							],
							[
								116.13285160500004,
								-33.51332433899995
							],
							[
								116.19684711500008,
								-33.51348172499996
							],
							[
								116.19697009100003,
								-33.592504335999934
							],
							[
								116.20645119000005,
								-33.59635989499998
							],
							[
								116.20377774200006,
								-33.62788310499997
							],
							[
								116.19523674400011,
								-33.63471072599998
							],
							[
								116.20603947400002,
								-33.64626701499998
							],
							[
								116.20111441600011,
								-33.669836145999966
							],
							[
								116.21545971400008,
								-33.669771684999944
							],
							[
								116.21581241600006,
								-33.70141429499995
							],
							[
								116.23977992300001,
								-33.70652290399994
							],
							[
								116.22818296700007,
								-33.734998564999955
							],
							[
								116.21845447800001,
								-33.73505857499998
							],
							[
								116.21796771100003,
								-33.77108542499997
							],
							[
								116.19614520500011,
								-33.77111004599993
							],
							[
								116.1962549650001,
								-33.78074834599994
							],
							[
								116.10026542000003,
								-33.780579871999976
							],
							[
								116.09995265100008,
								-33.79027313199998
							],
							[
								116.08289988400008,
								-33.80116287299995
							],
							[
								116.00007727700006,
								-33.80129730699997
							],
							[
								116.00192590400002,
								-33.895034806999945
							],
							[
								115.99826973500001,
								-33.90273228799998
							],
							[
								115.97038593000002,
								-33.90672295899998
							],
							[
								115.97624790000009,
								-33.91683964899994
							],
							[
								115.96717137100006,
								-33.91678536899997
							],
							[
								115.98266489000002,
								-33.93416457899997
							],
							[
								115.99416289800001,
								-33.934241637999946
							],
							[
								115.99428075900005,
								-33.94382172799993
							],
							[
								115.97791927200001,
								-33.943817698999965
							],
							[
								115.9779218330001,
								-33.95759795899994
							],
							[
								115.96344385500004,
								-33.95759307999998
							],
							[
								115.96344067500002,
								-33.96397738999997
							],
							[
								115.93578186000002,
								-33.96119762099994
							],
							[
								115.94057178300011,
								-33.891558490999955
							],
							[
								115.90192222900009,
								-33.88539494299994
							],
							[
								115.88444321800011,
								-33.84305355399994
							],
							[
								115.86919794100004,
								-33.84723873399997
							],
							[
								115.86591122200002,
								-33.85524937499997
							],
							[
								115.81759905900003,
								-33.85413218699995
							],
							[
								115.81771512800003,
								-33.83695430699993
							],
							[
								115.83693194500006,
								-33.837031155999966
							],
							[
								115.83762533100003,
								-33.791069525999944
							],
							[
								115.81329870500008,
								-33.79118874699998
							],
							[
								115.81333406400006,
								-33.78391717699998
							],
							[
								115.80692569500002,
								-33.78389275799998
							],
							[
								115.80682878700009,
								-33.797683897999946
							],
							[
								115.73628122700006,
								-33.79668277199994
							],
							[
								115.73617749800007,
								-33.81155792199996
							],
							[
								115.66960913900004,
								-33.811797714999955
							],
							[
								115.53601514800005,
								-33.91387869299996
							],
							[
								115.41959977600004,
								-33.91982518999998
							],
							[
								115.4151321810001,
								-33.975833619999946
							],
							[
								115.38996134700005,
								-34.00048426199993
							],
							[
								115.40421984900001,
								-34.05003539099994
							],
							[
								115.39139583300005,
								-34.07910210199998
							],
							[
								115.40292472300007,
								-34.09325329199993
							],
							[
								115.40181582800005,
								-34.15647025199996
							],
							[
								115.3372080580001,
								-34.16006462599995
							],
							[
								115.3371041910001,
								-34.31483390599993
							]
						]
					],
					[
						[
							[
								116.49121903500009,
								-35.03390308599995
							],
							[
								116.49890093400006,
								-35.036304005999966
							],
							[
								116.50509501300007,
								-35.027802804999965
							],
							[
								116.49121903500009,
								-35.03390308599995
							]
						]
					],
					[
						[
							[
								124.1465585730001,
								-33.84401129399998
							],
							[
								124.13088857500009,
								-33.842671303999964
							],
							[
								124.13697856500005,
								-33.85281130399994
							],
							[
								124.1311895560001,
								-33.863981303999935
							],
							[
								124.1406495540001,
								-33.862731303999965
							],
							[
								124.1465585730001,
								-33.84401129399998
							]
						]
					],
					[
						[
							[
								123.64168364300008,
								-33.88884631499997
							],
							[
								123.65430965100006,
								-33.88538432499996
							],
							[
								123.63382373500008,
								-33.88745682499996
							],
							[
								123.64168364300008,
								-33.88884631499997
							]
						]
					],
					[
						[
							[
								121.99177491300009,
								-33.92320735699997
							],
							[
								121.9989728920001,
								-33.916356356999984
							],
							[
								121.98605792400008,
								-33.91939535699993
							],
							[
								121.99177491300009,
								-33.92320735699997
							]
						]
					],
					[
						[
							[
								121.89949690800006,
								-33.92316435999993
							],
							[
								121.90749493700002,
								-33.92439434999994
							],
							[
								121.90970237600004,
								-33.916685419999965
							],
							[
								121.89949690800006,
								-33.92316435999993
							]
						]
					],
					[
						[
							[
								121.87265693200004,
								-33.92566136099998
							],
							[
								121.8840299200001,
								-33.92067135999997
							],
							[
								121.87672993100011,
								-33.916820360999964
							],
							[
								121.87265693200004,
								-33.92566136099998
							]
						]
					],
					[
						[
							[
								121.79021092500011,
								-33.92590536299997
							],
							[
								121.80492692300004,
								-33.92614136299994
							],
							[
								121.7947219240001,
								-33.917603362999955
							],
							[
								121.79021092500011,
								-33.92590536299997
							]
						]
					],
					[
						[
							[
								117.89394461900008,
								-35.18530150799995
							],
							[
								117.89967362700008,
								-35.18147751699996
							],
							[
								117.89414562800005,
								-35.178582517999985
							],
							[
								117.87274363200004,
								-35.18246451899995
							],
							[
								117.89394461900008,
								-35.18530150799995
							]
						]
					],
					[
						[
							[
								118.04424596600006,
								-35.06507528999998
							],
							[
								118.06997390200002,
								-35.06501947899994
							],
							[
								118.04018191600005,
								-35.05950020999995
							],
							[
								118.04424596600006,
								-35.06507528999998
							]
						]
					],
					[
						[
							[
								118.02921982700002,
								-35.04695510099998
							],
							[
								118.05075877400009,
								-35.04389069999996
							],
							[
								118.03883673500002,
								-35.03992786999993
							],
							[
								118.02921982700002,
								-35.04695510099998
							]
						]
					],
					[
						[
							[
								118.46241350900004,
								-34.93280111099995
							],
							[
								118.47793363700009,
								-34.93683596999995
							],
							[
								118.48648477500001,
								-34.92123656999996
							],
							[
								118.45681611900011,
								-34.90493073099998
							],
							[
								118.44155503100001,
								-34.90403690199997
							],
							[
								118.43764216200009,
								-34.91269307199997
							],
							[
								118.46241350900004,
								-34.93280111099995
							]
						]
					],
					[
						[
							[
								119.60437966200004,
								-34.374401010999975
							],
							[
								119.61359259100004,
								-34.37716473099994
							],
							[
								119.59869172300012,
								-34.36840997099995
							],
							[
								119.60437966200004,
								-34.374401010999975
							]
						]
					],
					[
						[
							[
								119.5786309660001,
								-34.37319713199997
							],
							[
								119.5726250680001,
								-34.37652726199997
							],
							[
								119.5883398850001,
								-34.37196706199995
							],
							[
								119.5786309660001,
								-34.37319713199997
							]
						]
					],
					[
						[
							[
								121.60024693000003,
								-34.03540039999996
							],
							[
								121.61270678800008,
								-34.03468037899995
							],
							[
								121.6143666160001,
								-34.01199041899997
							],
							[
								121.60451687800003,
								-34.01628034899994
							],
							[
								121.6055770590001,
								-34.028820408999934
							],
							[
								121.59305701100004,
								-34.02813945999998
							],
							[
								121.60024693000003,
								-34.03540039999996
							]
						]
					],
					[
						[
							[
								122.13814278500001,
								-34.03330569399998
							],
							[
								122.14883271300005,
								-34.036865672999966
							],
							[
								122.15154258300004,
								-34.031445592999944
							],
							[
								122.1286027760001,
								-34.02905571399998
							],
							[
								122.13814278500001,
								-34.03330569399998
							]
						]
					],
					[
						[
							[
								122.30615086800003,
								-34.01648034899995
							],
							[
								122.31427185600012,
								-34.01359035899998
							],
							[
								122.3078418770001,
								-34.010380348999945
							],
							[
								122.30615086800003,
								-34.01648034899995
							]
						]
					],
					[
						[
							[
								122.58753034300003,
								-34.00643340099998
							],
							[
								122.59097025200003,
								-34.003033380999966
							],
							[
								122.5835203040001,
								-34.00311339099994
							],
							[
								122.58753034300003,
								-34.00643340099998
							]
						]
					],
					[
						[
							[
								122.24198088800006,
								-34.00730435099996
							],
							[
								122.24015088800002,
								-34.01227436099998
							],
							[
								122.24841086700008,
								-34.006514349999975
							],
							[
								122.24198088800006,
								-34.00730435099996
							]
						]
					],
					[
						[
							[
								121.66891585700012,
								-34.00207928699996
							],
							[
								121.68952562400011,
								-34.00623865699998
							],
							[
								121.67892598600008,
								-33.99411937699995
							],
							[
								121.67012579700008,
								-33.99439935699996
							],
							[
								121.66891585700012,
								-34.00207928699996
							]
						]
					],
					[
						[
							[
								121.99128588600001,
								-33.99215635799993
							],
							[
								122.00413352400005,
								-33.986126646999935
							],
							[
								121.99538790500003,
								-33.98083834799996
							],
							[
								121.99128588600001,
								-33.99215635799993
							]
						]
					],
					[
						[
							[
								121.98326392700005,
								-33.97501536799996
							],
							[
								121.97664490800003,
								-33.97283635799994
							],
							[
								121.98163591700006,
								-33.98042835799998
							],
							[
								121.9944098850001,
								-33.973809347999975
							],
							[
								121.98326392700005,
								-33.97501536799996
							]
						]
					],
					[
						[
							[
								122.00380090300007,
								-33.96921435699994
							],
							[
								122.02650890000007,
								-33.96063235699995
							],
							[
								122.01002991200005,
								-33.953471356999955
							],
							[
								121.9998689040001,
								-33.95770635699995
							],
							[
								122.00380090300007,
								-33.96921435699994
							]
						]
					],
					[
						[
							[
								122.52185032200009,
								-33.96197320299996
							],
							[
								122.52970026100002,
								-33.96118321199998
							],
							[
								122.51684033200002,
								-33.960173202999954
							],
							[
								122.52185032200009,
								-33.96197320299996
							]
						]
					],
					[
						[
							[
								122.83540279400006,
								-33.989211334999936
							],
							[
								122.81480876700005,
								-34.00441034499994
							],
							[
								122.86307375900003,
								-33.98279633399994
							],
							[
								122.84309377200009,
								-33.98256334399997
							],
							[
								122.83540279400006,
								-33.989211334999936
							]
						]
					],
					[
						[
							[
								122.63434381600007,
								-33.99883533999997
							],
							[
								122.62834379600008,
								-33.99829533999997
							],
							[
								122.63323581600002,
								-34.00473733999996
							],
							[
								122.63434381600007,
								-33.99883533999997
							]
						]
					],
					[
						[
							[
								122.79948577000005,
								-34.01353234599998
							],
							[
								122.81313578800007,
								-34.01092234499998
							],
							[
								122.80820576800011,
								-34.001632324999946
							],
							[
								122.7988857900001,
								-34.005402335999975
							],
							[
								122.79948577000005,
								-34.01353234599998
							]
						]
					],
					[
						[
							[
								123.24236371100005,
								-34.02743332499995
							],
							[
								123.24532671000009,
								-34.03147331499997
							],
							[
								123.2582977080001,
								-34.018447323999965
							],
							[
								123.24236371100005,
								-34.02743332499995
							]
						]
					],
					[
						[
							[
								123.5301866750001,
								-34.019069317999936
							],
							[
								123.52881365600001,
								-34.023688327999935
							],
							[
								123.5371246740001,
								-34.00891431799994
							],
							[
								123.52693668500001,
								-34.00488331799994
							],
							[
								123.5301866750001,
								-34.019069317999936
							]
						]
					],
					[
						[
							[
								123.20532837000007,
								-34.116501755999934
							],
							[
								123.2153882880001,
								-34.10761164599995
							],
							[
								123.2080782490001,
								-34.10388167599996
							],
							[
								123.21518796700002,
								-34.08089147599998
							],
							[
								123.20173812900009,
								-34.092931635999946
							],
							[
								123.18098817300006,
								-34.095701806999955
							],
							[
								123.17029812400006,
								-34.09038183699994
							],
							[
								123.15748834700003,
								-34.11031210699997
							],
							[
								123.16112844700001,
								-34.116862106999974
							],
							[
								123.17062837500009,
								-34.11372198699996
							],
							[
								123.17316852500005,
								-34.12444205699995
							],
							[
								123.18257833300004,
								-34.10676186699993
							],
							[
								123.19382832100007,
								-34.10858179599995
							],
							[
								123.1929884220001,
								-34.11738186599996
							],
							[
								123.20589828900006,
								-34.107711705999975
							],
							[
								123.20532837000007,
								-34.116501755999934
							]
						]
					],
					[
						[
							[
								123.18862798100008,
								-34.07903161599995
							],
							[
								123.18009800200002,
								-34.07777167699993
							],
							[
								123.18318809200002,
								-34.08714172699996
							],
							[
								123.18862798100008,
								-34.07903161599995
							]
						]
					],
					[
						[
							[
								122.09773400300003,
								-34.064206474999935
							],
							[
								122.11017488100003,
								-34.06468336499995
							],
							[
								122.10424381100006,
								-34.059026304999975
							],
							[
								122.09773400300003,
								-34.064206474999935
							]
						]
					],
					[
						[
							[
								122.00933430500004,
								-34.02280720699997
							],
							[
								121.98248491000004,
								-34.03670770799994
							],
							[
								121.99004503900005,
								-34.04292775799996
							],
							[
								122.00251478700011,
								-34.03815752799994
							],
							[
								121.9972447770001,
								-34.03610754799996
							],
							[
								122.00933430500004,
								-34.02280720699997
							]
						]
					],
					[
						[
							[
								121.95339546500009,
								-34.04923826899994
							],
							[
								121.95451492500001,
								-34.057988438999985
							],
							[
								121.96097546400006,
								-34.050158188999944
							],
							[
								121.97973536100005,
								-34.049457977999964
							],
							[
								121.96756524200009,
								-34.043677988999946
							],
							[
								121.95339546500009,
								-34.04923826899994
							]
						]
					],
					[
						[
							[
								121.99114565900004,
								-34.061398097999984
							],
							[
								121.97576547200003,
								-34.06430833899998
							],
							[
								121.98949495000011,
								-34.06861824799995
							],
							[
								121.99627547900002,
								-34.06524807799997
							],
							[
								121.99114565900004,
								-34.061398097999984
							]
						]
					],
					[
						[
							[
								122.00020565800003,
								-34.06722803799994
							],
							[
								122.02303530400002,
								-34.066137466999976
							],
							[
								122.00780546700003,
								-34.061707757999955
							],
							[
								122.00020565800003,
								-34.06722803799994
							]
						]
					],
					[
						[
							[
								121.97362756400003,
								-34.11805956899997
							],
							[
								121.98391749300004,
								-34.12236934899994
							],
							[
								121.98041729300007,
								-34.11349931899997
							],
							[
								121.97362756400003,
								-34.11805956899997
							]
						]
					],
					[
						[
							[
								122.00824707900006,
								-34.122758697999984
							],
							[
								121.99844701000006,
								-34.11381880799996
							],
							[
								121.98725724200006,
								-34.11537913799998
							],
							[
								122.00824707900006,
								-34.122758697999984
							]
						]
					],
					[
						[
							[
								122.11525988100004,
								-34.10259535499995
							],
							[
								122.1247509000001,
								-34.094265363999966
							],
							[
								122.11652464100007,
								-34.09472667499995
							],
							[
								122.11525988100004,
								-34.10259535499995
							]
						]
					],
					[
						[
							[
								122.16303789300002,
								-34.076412362999974
							],
							[
								122.16126790300007,
								-34.08200236299996
							],
							[
								122.16827787200009,
								-34.07403935299993
							],
							[
								122.16303789300002,
								-34.076412362999974
							]
						]
					],
					[
						[
							[
								122.05347703300004,
								-34.14106788699996
							],
							[
								122.03783689500005,
								-34.14262134699993
							],
							[
								122.06018288200005,
								-34.14611934599998
							],
							[
								122.05347703300004,
								-34.14106788699996
							]
						]
					],
					[
						[
							[
								122.02405591800004,
								-34.151507367999955
							],
							[
								122.0301179170001,
								-34.149098366999965
							],
							[
								122.0138428890001,
								-34.14684835799994
							],
							[
								122.02405591800004,
								-34.151507367999955
							]
						]
					],
					[
						[
							[
								121.98654193700008,
								-34.47250435999996
							],
							[
								121.99785193600007,
								-34.47139435999998
							],
							[
								121.99010192700007,
								-34.46657434999997
							],
							[
								121.98654193700008,
								-34.47250435999996
							]
						]
					],
					[
						[
							[
								122.23739353300004,
								-34.134526980999965
							],
							[
								122.23542432500005,
								-34.15852744199998
							],
							[
								122.24478427300005,
								-34.16202753099998
							],
							[
								122.25617428100009,
								-34.14294716099994
							],
							[
								122.25257490100012,
								-34.12786689099994
							],
							[
								122.26111461900007,
								-34.12413681099997
							],
							[
								122.23224389300003,
								-34.10843660099994
							],
							[
								122.23739353300004,
								-34.134526980999965
							]
						]
					],
					[
						[
							[
								123.53929705500002,
								-34.365312339999946
							],
							[
								123.53400725600011,
								-34.37805238999994
							],
							[
								123.55954699200004,
								-34.359992208999984
							],
							[
								123.56201768000005,
								-34.33714830899993
							],
							[
								123.53929705500002,
								-34.365312339999946
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "511",
				"CED_NAME21": "O'Connor",
				"STE_CODE21": "5",
				"STE_NAME21": "Western Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 1126947.2626,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/511",
				"SHAPE_Leng": 66.4408400104,
				"SHAPE_Area": 104.515341224
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							115.56075568000006,
							-31.45520616099998
						],
						[
							115.57980963000011,
							-31.496310669999957
						],
						[
							115.63523268800009,
							-31.565621637999982
						],
						[
							115.68523454800004,
							-31.65263760499994
						],
						[
							115.7066207690001,
							-31.712013773999956
						],
						[
							115.74804531300003,
							-31.711976551999953
						],
						[
							115.74976117400001,
							-31.722348281999984
						],
						[
							115.7737586400001,
							-31.717235200999937
						],
						[
							115.79226475900009,
							-31.74297022999997
						],
						[
							115.7877847210001,
							-31.751871709999932
						],
						[
							115.79612716100007,
							-31.77670347999998
						],
						[
							115.81028241000001,
							-31.78354810899998
						],
						[
							115.8208631010001,
							-31.820089157999973
						],
						[
							115.88058421300002,
							-31.82130882499996
						],
						[
							115.91709467900012,
							-31.843160602999944
						],
						[
							115.91799768500005,
							-31.79567559299994
						],
						[
							115.95719569000005,
							-31.795650600999977
						],
						[
							115.9546645580001,
							-31.766204390999974
						],
						[
							115.97662138400005,
							-31.759483429999932
						],
						[
							115.98284868200005,
							-31.741872598999976
						],
						[
							115.95711136600005,
							-31.741793600999983
						],
						[
							115.94857201500008,
							-31.717386550999947
						],
						[
							115.96432022200008,
							-31.701634799999965
						],
						[
							115.95732467300002,
							-31.70168259999997
						],
						[
							115.95536966200007,
							-31.682985599999938
						],
						[
							115.93754397400005,
							-31.682949880999956
						],
						[
							115.92520668400005,
							-31.66059760199994
						],
						[
							115.91201068600003,
							-31.662796602999947
						],
						[
							115.90508101700004,
							-31.652587922999942
						],
						[
							115.88862214900007,
							-31.652701123999975
						],
						[
							115.88348316800011,
							-31.627509703999976
						],
						[
							115.85958418100006,
							-31.627155324999933
						],
						[
							115.85579017000009,
							-31.474311874999955
						],
						[
							115.67839596500005,
							-31.47698739499998
						],
						[
							115.67010582500006,
							-31.455115434999982
						],
						[
							115.56075568000006,
							-31.45520616099998
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "512",
				"CED_NAME21": "Pearce",
				"STE_CODE21": "5",
				"STE_NAME21": "Western Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 787.62,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/512",
				"SHAPE_Leng": 1.53090762745,
				"SHAPE_Area": 0.0748719197335
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							115.82726302200001,
							-31.972835798999938
						],
						[
							115.85310340700005,
							-31.958765606999975
						],
						[
							115.8766515640001,
							-31.969034565999948
						],
						[
							115.88486570300006,
							-31.966151595999975
						],
						[
							115.8814140820001,
							-31.944395155999928
						],
						[
							115.88745892000009,
							-31.93660506499998
						],
						[
							115.89766296900007,
							-31.94094903499996
						],
						[
							115.89947107000012,
							-31.951364044999934
						],
						[
							115.91408299800003,
							-31.950306943999976
						],
						[
							115.90885572700006,
							-31.93488965399996
						],
						[
							115.93621167300012,
							-31.929966542999978
						],
						[
							115.94117249200008,
							-31.919756461999953
						],
						[
							115.9507854200001,
							-31.92234639199995
						],
						[
							115.96165825800006,
							-31.911313250999967
						],
						[
							115.95953395700008,
							-31.894338130999984
						],
						[
							115.96432965600002,
							-31.88768061099995
						],
						[
							115.95595480700001,
							-31.887644620999936
						],
						[
							115.8283150850001,
							-31.888878947999956
						],
						[
							115.82066534700004,
							-31.90174873899997
						],
						[
							115.82519641800002,
							-31.921190128999967
						],
						[
							115.84399950700004,
							-31.941407607999963
						],
						[
							115.8186195620001,
							-31.963930588999972
						],
						[
							115.81803823300004,
							-31.973724378999975
						],
						[
							115.82726302200001,
							-31.972835798999938
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "513",
				"CED_NAME21": "Perth",
				"STE_CODE21": "5",
				"STE_NAME21": "Western Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 79.8666,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/513",
				"SHAPE_Leng": 0.538555393453,
				"SHAPE_Area": 0.0076156314184
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							116.02144635800005,
							-32.01944015799995
						],
						[
							116.02402573600011,
							-32.00513343799997
						],
						[
							116.03394168400007,
							-32.00227959799997
						],
						[
							116.03220866400011,
							-31.989850587999968
						],
						[
							116.04101035200006,
							-31.987430656999948
						],
						[
							116.02875795200009,
							-31.961429377999934
						],
						[
							116.03627735100008,
							-31.955233146999944
						],
						[
							116.03183176000005,
							-31.937079186999938
						],
						[
							116.00388466300001,
							-31.92624159899998
						],
						[
							115.99891468300007,
							-31.917535588999954
						],
						[
							115.95378134000009,
							-31.920354361999955
						],
						[
							115.91036773700012,
							-31.935774613999968
						],
						[
							115.91900294700008,
							-31.944256843999938
						],
						[
							115.9130760380001,
							-31.951813933999972
						],
						[
							115.89874114000008,
							-31.95366204499993
						],
						[
							115.88593453100009,
							-31.940542644999937
						],
						[
							115.89110881200008,
							-31.962309594999965
						],
						[
							115.88127469400001,
							-31.97024857599996
						],
						[
							115.86318576700012,
							-31.974581626999964
						],
						[
							115.84509362900008,
							-31.96521361799995
						],
						[
							115.8572634620001,
							-32.03117012699994
						],
						[
							115.86572635000005,
							-32.02645310699995
						],
						[
							115.87357469000005,
							-32.03110557599996
						],
						[
							115.87805053800002,
							-32.02095259599997
						],
						[
							115.89759270500008,
							-32.01842360499995
						],
						[
							115.89907771500009,
							-32.013439594999966
						],
						[
							115.92293469100002,
							-32.012910603999956
						],
						[
							115.94116644000007,
							-32.029606282999964
						],
						[
							115.975709703,
							-32.00401660099993
						],
						[
							115.98940202200004,
							-32.01393843999995
						],
						[
							115.994662661,
							-32.009443389999944
						],
						[
							116.00253603100009,
							-32.02359673899997
						],
						[
							116.01440969800001,
							-32.01348108899998
						],
						[
							116.02144635800005,
							-32.01944015799995
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "514",
				"CED_NAME21": "Swan",
				"STE_CODE21": "5",
				"STE_NAME21": "Western Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 150.8416,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/514",
				"SHAPE_Leng": 0.748123273163,
				"SHAPE_Area": 0.0143920350062
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							115.91618388000006,
							-32.115323623999984
						],
						[
							115.95162902200002,
							-32.082754041999976
						],
						[
							115.93029269300007,
							-32.05407460299995
						],
						[
							115.94116644000007,
							-32.029606282999964
						],
						[
							115.92293469100002,
							-32.012910603999956
						],
						[
							115.89907771500009,
							-32.013439594999966
						],
						[
							115.89759270500008,
							-32.01842360499995
						],
						[
							115.90290072500011,
							-32.02662660499993
						],
						[
							115.89356727600011,
							-32.02034274499994
						],
						[
							115.88336431800008,
							-32.024196865999954
						],
						[
							115.86074067200002,
							-32.03773858699998
						],
						[
							115.86163660200009,
							-32.04581137699995
						],
						[
							115.8461821410001,
							-32.001648047999936
						],
						[
							115.82873320400006,
							-32.006463208999946
						],
						[
							115.82689539600005,
							-32.021246118999954
						],
						[
							115.8165035180001,
							-32.02851641999996
						],
						[
							115.78671529100006,
							-32.01094364099998
						],
						[
							115.7761727730001,
							-32.028812941999945
						],
						[
							115.77605751400006,
							-32.038310001999946
						],
						[
							115.79361831100005,
							-32.03413761099995
						],
						[
							115.79363127300007,
							-32.056628520999936
						],
						[
							115.80321592200005,
							-32.05642347999998
						],
						[
							115.80328486200005,
							-32.065806349999946
						],
						[
							115.82397799000012,
							-32.06852232899996
						],
						[
							115.83413487900009,
							-32.07934081899998
						],
						[
							115.84922171700009,
							-32.07865059799997
						],
						[
							115.84909349700001,
							-32.085646907999944
						],
						[
							115.85821290600006,
							-32.08731048799996
						],
						[
							115.88437369100006,
							-32.07507460599993
						],
						[
							115.8906350520001,
							-32.09207351599997
						],
						[
							115.91618388000006,
							-32.115323623999984
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "515",
				"CED_NAME21": "Tangney",
				"STE_CODE21": "5",
				"STE_NAME21": "Western Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 101.8769,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/515",
				"SHAPE_Leng": 0.653458822832,
				"SHAPE_Area": 0.00972842841807
			}
		},
		{
			"type": "Feature",
			"geometry": null,
			"properties": {
				"CED_CODE21": "594",
				"CED_NAME21": "No usual address (WA)",
				"STE_CODE21": "5",
				"STE_NAME21": "Western Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 0,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/594",
				"SHAPE_Leng": 0,
				"SHAPE_Area": 0
			}
		},
		{
			"type": "Feature",
			"geometry": null,
			"properties": {
				"CED_CODE21": "597",
				"CED_NAME21": "Migratory - Offshore - Shipping (WA)",
				"STE_CODE21": "5",
				"STE_NAME21": "Western Australia",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 0,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/597",
				"SHAPE_Leng": 0,
				"SHAPE_Area": 0
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								148.25786353,
								-40.90415718299994
							],
							[
								148.26191719100007,
								-40.89244002399994
							],
							[
								148.23723366700005,
								-40.885962191999965
							],
							[
								148.2219577620001,
								-40.869553189999976
							],
							[
								148.2236652350001,
								-40.84692488999997
							],
							[
								148.19759986100007,
								-40.83941810799996
							],
							[
								148.17844711700002,
								-40.82093512599994
							],
							[
								148.17173067600004,
								-40.83914240599995
							],
							[
								148.11402834800003,
								-40.83051899099996
							],
							[
								148.10812141100007,
								-40.82058296099996
							],
							[
								148.1172440790001,
								-40.82057285199994
							],
							[
								148.11528005000002,
								-40.81394780099998
							],
							[
								148.12139404800007,
								-40.82578686199997
							],
							[
								148.14817132100006,
								-40.83469862399994
							],
							[
								148.17532140700007,
								-40.830131275999975
							],
							[
								148.1543231400001,
								-40.83488053499997
							],
							[
								148.13560065500008,
								-40.82748969299996
							],
							[
								148.07927836400006,
								-40.769046397999944
							],
							[
								148.05785417700008,
								-40.77161178599994
							],
							[
								148.03752773200006,
								-40.76210302499993
							],
							[
								148.0441017490001,
								-40.774587064999935
							],
							[
								148.0306647550001,
								-40.750228023999966
							],
							[
								148.01903125700005,
								-40.75355526299995
							],
							[
								148.00666352100006,
								-40.743726401999936
							],
							[
								147.97470850800005,
								-40.73758794899993
							],
							[
								147.94991644100003,
								-40.746407397999974
							],
							[
								147.93960259400012,
								-40.73913345699998
							],
							[
								147.94275674200003,
								-40.752704516999984
							],
							[
								147.95880232800005,
								-40.754965347999985
							],
							[
								147.95885049700007,
								-40.76475743799995
							],
							[
								147.95299984700011,
								-40.77633660799995
							],
							[
								147.94355305800002,
								-40.77590468699998
							],
							[
								147.9478371360001,
								-40.79103773799994
							],
							[
								147.93290531500008,
								-40.81523592699995
							],
							[
								147.88707832700004,
								-40.86354345299998
							],
							[
								147.88504855500003,
								-40.87778149299993
							],
							[
								147.90337812200005,
								-40.87716837499994
							],
							[
								147.9125578710001,
								-40.868895264999935
							],
							[
								147.90416017200005,
								-40.877656344999934
							],
							[
								147.87388379700008,
								-40.88289961199996
							],
							[
								147.88262349700005,
								-40.86812150299994
							],
							[
								147.82202777600003,
								-40.88691599799995
							],
							[
								147.78000723500008,
								-40.879808314999934
							],
							[
								147.7564769720001,
								-40.86510358299995
							],
							[
								147.7519630910001,
								-40.87594466199994
							],
							[
								147.7574608330001,
								-40.85759256299997
							],
							[
								147.7064654820001,
								-40.86029892899995
							],
							[
								147.66969006400006,
								-40.82101417599995
							],
							[
								147.62682537900002,
								-40.845007341999974
							],
							[
								147.5948200350001,
								-40.84912345999993
							],
							[
								147.59893121300001,
								-40.85620641999998
							],
							[
								147.5934424930001,
								-40.86413440999996
							],
							[
								147.5836226350001,
								-40.86339444899994
							],
							[
								147.59071079300008,
								-40.87158839999995
							],
							[
								147.5755299330001,
								-40.89078140799995
							],
							[
								147.58283986100002,
								-40.89315038899997
							],
							[
								147.56809250300012,
								-40.89859341799996
							],
							[
								147.525584094,
								-40.950677404999965
							],
							[
								147.4907328070001,
								-40.97933635199996
							],
							[
								147.4414872330001,
								-41.00290219899995
							],
							[
								147.3970592920001,
								-41.00288780499994
							],
							[
								147.40519630900008,
								-41.00992873599995
							],
							[
								147.43454584300002,
								-41.01188646799994
							],
							[
								147.39896536100002,
								-41.00851280499995
							],
							[
								147.38427112700003,
								-40.98043289399993
							],
							[
								147.36746726100012,
								-40.976073052999936
							],
							[
								147.35543550300008,
								-40.982267201999946
							],
							[
								147.36054937200004,
								-40.97531412199993
							],
							[
								147.34562285000004,
								-40.93946227099997
							],
							[
								147.3025657060001,
								-40.95768078699996
							],
							[
								147.28480875000002,
								-40.951916995999966
							],
							[
								147.27984862300002,
								-40.94167904599993
							],
							[
								147.24945197700004,
								-40.953466522999975
							],
							[
								147.22475549700005,
								-40.98913006199996
							],
							[
								147.19969277000007,
								-40.99969952999993
							],
							[
								147.20575468900006,
								-40.99982444999995
							],
							[
								147.2026771180001,
								-41.00899498999996
							],
							[
								147.20324972900005,
								-40.99992447999995
							],
							[
								147.19441089100008,
								-40.999104588999955
							],
							[
								147.176459173,
								-41.00929901799998
							],
							[
								147.1617185760001,
								-41.007956096999976
							],
							[
								147.15789389400004,
								-41.03138732699995
							],
							[
								147.15431283600003,
								-41.02203230599997
							],
							[
								147.13442909800006,
								-41.034888714999965
							],
							[
								147.15900268600012,
								-41.013677186999985
							],
							[
								147.12303161400007,
								-41.003037683999935
							],
							[
								147.1160415070001,
								-40.99456374299996
							],
							[
								147.07278018500006,
								-40.99967001999994
							],
							[
								147.0586666590001,
								-40.988004598999964
							],
							[
								147.03197417400008,
								-40.990352246999976
							],
							[
								147.02090317700004,
								-40.980252005999944
							],
							[
								146.9943460820001,
								-40.98654735399998
							],
							[
								146.94768123500012,
								-41.02556378999998
							],
							[
								146.95926819300007,
								-41.02747899099995
							],
							[
								146.89374143500004,
								-41.02966543599996
							],
							[
								146.87480721000009,
								-41.01882599499993
							],
							[
								146.83361294600002,
								-41.03952031199998
							],
							[
								146.807120918,
								-41.06298154999996
							],
							[
								146.78664421300005,
								-41.05409097799998
							],
							[
								146.80396998700007,
								-41.069719619999944
							],
							[
								146.81604002000006,
								-41.10871046099993
							],
							[
								146.82691029800003,
								-41.10806549199998
							],
							[
								146.81763342700003,
								-41.12378966099993
							],
							[
								146.82737673500003,
								-41.131367541999964
							],
							[
								146.83387150400006,
								-41.125198531999956
							],
							[
								146.8277998740001,
								-41.136292681999976
							],
							[
								146.8509270390001,
								-41.139959473999966
							],
							[
								146.87729554500004,
								-41.130612155999984
							],
							[
								146.90033452000011,
								-41.13697402699995
							],
							[
								146.9654255700001,
								-41.19004651299997
							],
							[
								146.93730031600012,
								-41.181768949999935
							],
							[
								146.92211493800005,
								-41.194544158999975
							],
							[
								146.9324577550001,
								-41.199942129999954
							],
							[
								146.91200154700005,
								-41.21195838899996
							],
							[
								146.92148333400007,
								-41.22029643999997
							],
							[
								146.94466466200004,
								-41.20654713099998
							],
							[
								146.9456720280001,
								-41.22885439099997
							],
							[
								146.96915411200007,
								-41.23945026299998
							],
							[
								146.97659201200008,
								-41.23323419399998
							],
							[
								146.97676608000006,
								-41.243405233999965
							],
							[
								147.01539572900003,
								-41.27637386699996
							],
							[
								147.01375585800008,
								-41.283566906999965
							],
							[
								146.9787668130001,
								-41.29873721399997
							],
							[
								146.97817066100004,
								-41.30876690399998
							],
							[
								147.0399988680001,
								-41.318657508999934
							],
							[
								147.04588022400003,
								-41.33660919999994
							],
							[
								147.07240251000007,
								-41.330678441999964
							],
							[
								147.08260052600008,
								-41.34463735299994
							],
							[
								147.07519588600007,
								-41.354150441999934
							],
							[
								147.08894360400006,
								-41.353660342999945
							],
							[
								147.0752849060001,
								-41.35452645199996
							],
							[
								147.07977108400007,
								-41.366818431999945
							],
							[
								147.12786623800002,
								-41.41093919599996
							],
							[
								147.11804773900008,
								-41.420143295999935
							],
							[
								147.127024806,
								-41.43212829699996
							],
							[
								147.142105323,
								-41.42934819799996
							],
							[
								147.14442300400003,
								-41.41735811799998
							],
							[
								147.15109892200007,
								-41.42104010799994
							],
							[
								147.1546727120001,
								-41.41600406899994
							],
							[
								147.17322875600007,
								-41.43452597999993
							],
							[
								147.1567487220001,
								-41.41737105899995
							],
							[
								147.14593797400005,
								-41.417199117999985
							],
							[
								147.143220293,
								-41.429285197999945
							],
							[
								147.12185720500008,
								-41.44362439599996
							],
							[
								147.12781791500004,
								-41.43757632699993
							],
							[
								147.11222494000003,
								-41.42192834499997
							],
							[
								147.12305842900003,
								-41.40955259599997
							],
							[
								147.11575463000008,
								-41.41370629599993
							],
							[
								147.11198009300006,
								-41.40104198499995
							],
							[
								147.0824913890001,
								-41.39594967299996
							],
							[
								147.07393177300003,
								-41.383955481999976
							],
							[
								147.06896901800008,
								-41.354353481999965
							],
							[
								147.0768645180001,
								-41.34098136199998
							],
							[
								147.05844078200005,
								-41.33567579099997
							],
							[
								147.0362532050001,
								-41.34701267899993
							],
							[
								147.0337767840001,
								-41.35578677899997
							],
							[
								147.00492774400004,
								-41.32121201599995
							],
							[
								146.98703708800008,
								-41.32118415499997
							],
							[
								146.9706351630001,
								-41.309207293999975
							],
							[
								146.96205704600004,
								-41.294378362999964
							],
							[
								146.969999045,
								-41.296252023999955
							],
							[
								146.97725699400007,
								-41.288186043999985
							],
							[
								146.978299396,
								-41.273226213999976
							],
							[
								146.96758947000012,
								-41.263299322999956
							],
							[
								146.97473521000006,
								-41.25167625399996
							],
							[
								146.94578382400005,
								-41.26018751199996
							],
							[
								146.93382223000003,
								-41.231362470999954
							],
							[
								146.8975098510001,
								-41.202539427999966
							],
							[
								146.90724465900007,
								-41.206202377999944
							],
							[
								146.91561125900012,
								-41.19777425899997
							],
							[
								146.9086143510001,
								-41.18879426799998
							],
							[
								146.92878939800005,
								-41.17889001999998
							],
							[
								146.92315544100006,
								-41.16975900899996
							],
							[
								146.8778193920001,
								-41.149976365999976
							],
							[
								146.86012163300006,
								-41.17212359499996
							],
							[
								146.83407750900005,
								-41.16311779299997
							],
							[
								146.85758397000006,
								-41.19301671399995
							],
							[
								146.8449938440001,
								-41.18632980299998
							],
							[
								146.83901416300012,
								-41.20001995299998
							],
							[
								146.829895877,
								-41.18660195199993
							],
							[
								146.83793171600007,
								-41.176506822999954
							],
							[
								146.82111960100008,
								-41.17013394199995
							],
							[
								146.82505029200001,
								-41.152255811999964
							],
							[
								146.81798911400006,
								-41.145450850999964
							],
							[
								146.80696658700003,
								-41.14056173999995
							],
							[
								146.7984520880001,
								-41.148591059999944
							],
							[
								146.7901549500001,
								-41.14608211899997
							],
							[
								146.77341320100004,
								-41.16482041799998
							],
							[
								146.7677130720001,
								-41.16005848699996
							],
							[
								146.76375176400006,
								-41.14941443699996
							],
							[
								146.77828037100005,
								-41.15146495799996
							],
							[
								146.80085823900004,
								-41.13427921999994
							],
							[
								146.8200938450001,
								-41.13764276099994
							],
							[
								146.8103095880001,
								-41.130732800999965
							],
							[
								146.8065532710001,
								-41.11282172999995
							],
							[
								146.81403131000002,
								-41.11311166099995
							],
							[
								146.80419026200002,
								-41.11076774999998
							],
							[
								146.79758332200004,
								-41.11707084899996
							],
							[
								146.7881488050001,
								-41.112031928999954
							],
							[
								146.79866105300005,
								-41.10682702999998
							],
							[
								146.77524412100001,
								-41.08236798799993
							],
							[
								146.76151476400003,
								-41.07839313699998
							],
							[
								146.74452759700011,
								-41.08476237499997
							],
							[
								146.70820499700005,
								-41.06360277199997
							],
							[
								146.7136411140001,
								-41.074811712999974
							],
							[
								146.69681706500012,
								-41.089830921999976
							],
							[
								146.6780171580001,
								-41.101028929999984
							],
							[
								146.66141722100008,
								-41.09610785899997
							],
							[
								146.65842454000006,
								-41.110282488999985
							],
							[
								146.6956922700001,
								-41.13293200199996
							],
							[
								146.6956315750001,
								-41.17025740199995
							],
							[
								146.76206482600003,
								-41.28716406799998
							],
							[
								146.75164195800005,
								-41.28750216699996
							],
							[
								146.74948228800008,
								-41.29750717699994
							],
							[
								146.71981951300006,
								-41.299668484999984
							],
							[
								146.71844470300005,
								-41.305930494999984
							],
							[
								146.7051834560001,
								-41.297768633999965
							],
							[
								146.70359088200007,
								-41.33267657399995
							],
							[
								146.69751155000006,
								-41.35523660299998
							],
							[
								146.77157788300008,
								-41.375684828999965
							],
							[
								146.7985763370001,
								-41.38036866099998
							],
							[
								146.80953703500006,
								-41.37538957199996
							],
							[
								146.82524353100007,
								-41.385195592999935
							],
							[
								146.87283331100002,
								-41.39120307699994
							],
							[
								146.89999485600003,
								-41.38651887899994
							],
							[
								146.91026172500005,
								-41.377819999999986
							],
							[
								146.92820128000005,
								-41.389401720999956
							],
							[
								146.9343086770001,
								-41.40848264199997
							],
							[
								146.97200747600004,
								-41.429028924999955
							],
							[
								146.9961427610001,
								-41.431797105999976
							],
							[
								146.9940051100001,
								-41.443423165999945
							],
							[
								147.00799091700003,
								-41.44520606699996
							],
							[
								147.03046520500004,
								-41.42568488899997
							],
							[
								147.0318462140001,
								-41.43732388899997
							],
							[
								147.06552928400004,
								-41.45887548199994
							],
							[
								147.08021334300008,
								-41.44465122299994
							],
							[
								147.10174796600006,
								-41.465551654999956
							],
							[
								147.1336506780001,
								-41.47635450699994
							],
							[
								147.14009606600007,
								-41.48300703799998
							],
							[
								147.12601191800002,
								-41.490500606999944
							],
							[
								147.13635740400002,
								-41.501268367999955
							],
							[
								147.16936766900005,
								-41.49287996999993
							],
							[
								147.17414489700002,
								-41.50200021099994
							],
							[
								147.19803049100005,
								-41.510147021999956
							],
							[
								147.22228550800003,
								-41.493608173999974
							],
							[
								147.23607005300005,
								-41.51090602499994
							],
							[
								147.2307830630001,
								-41.51988501499994
							],
							[
								147.23692404200006,
								-41.516423025999984
							],
							[
								147.2485020590001,
								-41.52804301599997
							],
							[
								147.25528404800002,
								-41.52433902699994
							],
							[
								147.26271431600003,
								-41.53003913799995
							],
							[
								147.27815144400006,
								-41.52167108899994
							],
							[
								147.2858506010001,
								-41.529675828999984
							],
							[
								147.3028294190001,
								-41.52041496099997
							],
							[
								147.3127901160001,
								-41.52938355099997
							],
							[
								147.346764462,
								-41.512027933999946
							],
							[
								147.38799842700007,
								-41.556059877999985
							],
							[
								147.40082364600005,
								-41.54978008799998
							],
							[
								147.40645734400005,
								-41.556165488999966
							],
							[
								147.43200993000005,
								-41.543001740999955
							],
							[
								147.42811765200008,
								-41.53871887099996
							],
							[
								147.47614926500012,
								-41.51803786399995
							],
							[
								147.4863636020001,
								-41.52862586499998
							],
							[
								147.49873335000007,
								-41.52200267599994
							],
							[
								147.50654065800006,
								-41.530427766999935
							],
							[
								147.53993461400012,
								-41.507437668999955
							],
							[
								147.56215522900004,
								-41.51119850099997
							],
							[
								147.57193857800007,
								-41.50601837199997
							],
							[
								147.57891291600004,
								-41.51357889199994
							],
							[
								147.6480638370001,
								-41.478411507999965
							],
							[
								147.62736586500012,
								-41.45146235599998
							],
							[
								147.62873443800004,
								-41.428161915999965
							],
							[
								147.61583256100005,
								-41.42638884499996
							],
							[
								147.61926002200005,
								-41.409212594999985
							],
							[
								147.60635625500004,
								-41.407435593999935
							],
							[
								147.6087179860001,
								-41.39772546399996
							],
							[
								147.59057501200004,
								-41.38084306199994
							],
							[
								147.83396897600005,
								-41.37241107199998
							],
							[
								147.88953396400007,
								-41.164944454999954
							],
							[
								147.93482180500007,
								-41.168457298999954
							],
							[
								148.08230032200004,
								-41.13212613999997
							],
							[
								148.06522482800005,
								-41.11292315899993
							],
							[
								148.06223957200007,
								-41.08704803899997
							],
							[
								148.0821013420001,
								-41.06023566999994
							],
							[
								148.06875825800012,
								-41.03374046899995
							],
							[
								148.08116752900003,
								-41.01347131999995
							],
							[
								148.07421837300012,
								-40.99533630899998
							],
							[
								148.08741961900012,
								-40.93608786999994
							],
							[
								148.11201766300007,
								-40.94221073199998
							],
							[
								148.11676430500006,
								-40.92353960199995
							],
							[
								148.2109219450001,
								-40.93724409999993
							],
							[
								148.2153658960001,
								-40.919597719999956
							],
							[
								148.25786353,
								-40.90415718299994
							]
						]
					],
					[
						[
							[
								146.38792797100007,
								-39.22475747799996
							],
							[
								146.38414825000007,
								-39.23563258699994
							],
							[
								146.39524099900007,
								-39.231094447999965
							],
							[
								146.38792797100007,
								-39.22475747799996
							]
						]
					],
					[
						[
							[
								146.6383040940001,
								-39.47577587799998
							],
							[
								146.6472150620001,
								-39.47890881899997
							],
							[
								146.6579625920001,
								-39.46314756899994
							],
							[
								146.6383040940001,
								-39.47577587799998
							]
						]
					],
					[
						[
							[
								146.98322373400003,
								-39.21540595199997
							],
							[
								146.98088905200007,
								-39.23263012199993
							],
							[
								146.99629464100008,
								-39.22127587299997
							],
							[
								146.9856535450001,
								-39.206694882999955
							],
							[
								146.98322373400003,
								-39.21540595199997
							]
						]
					],
					[
						[
							[
								147.07895826300012,
								-41.37516544199997
							],
							[
								147.08396157000004,
								-41.38514841299997
							],
							[
								147.08729621100008,
								-41.37747039299995
							],
							[
								147.07895826300012,
								-41.37516544199997
							]
						]
					],
					[
						[
							[
								147.2728453090001,
								-39.47101796599998
							],
							[
								147.26048462000006,
								-39.479606194999974
							],
							[
								147.27939329700007,
								-39.47495494699996
							],
							[
								147.28441964500007,
								-39.480675986999984
							],
							[
								147.29454503500006,
								-39.47270274799996
							],
							[
								147.2959467060001,
								-39.456229607999944
							],
							[
								147.30484266500002,
								-39.45457150899995
							],
							[
								147.3017193280001,
								-39.438121397999964
							],
							[
								147.27314483200007,
								-39.44499275599998
							],
							[
								147.29339082600006,
								-39.46214467799996
							],
							[
								147.2814041570001,
								-39.46932687699996
							],
							[
								147.27034828000012,
								-39.466807975999984
							],
							[
								147.2728453090001,
								-39.47101796599998
							]
						]
					],
					[
						[
							[
								147.31840346700005,
								-39.49596031999994
							],
							[
								147.32586264500003,
								-39.50506526099997
							],
							[
								147.330260306,
								-39.490410130999976
							],
							[
								147.34057517400004,
								-39.48876998199995
							],
							[
								147.35137924100002,
								-39.49738084299997
							],
							[
								147.3492819930001,
								-39.48552983199994
							],
							[
								147.35789580200003,
								-39.48107568299997
							],
							[
								147.34577266500003,
								-39.47174080199994
							],
							[
								147.36133637300009,
								-39.46520756299998
							],
							[
								147.3432119370001,
								-39.46053067199995
							],
							[
								147.34088195900006,
								-39.44965850199998
							],
							[
								147.32715270000006,
								-39.45826457099997
							],
							[
								147.32091869200008,
								-39.45239638999993
							],
							[
								147.31262530100003,
								-39.47334387899997
							],
							[
								147.30387355200003,
								-39.47544880899994
							],
							[
								147.30606589100012,
								-39.48416709899993
							],
							[
								147.31628248900006,
								-39.48317009999994
							],
							[
								147.31840346700005,
								-39.49596031999994
							]
						]
					],
					[
						[
							[
								147.63603269500004,
								-40.78810840299997
							],
							[
								147.61575154600007,
								-40.809743450999974
							],
							[
								147.61968967500002,
								-40.81476344199996
							],
							[
								147.6342042230001,
								-40.80708339299997
							],
							[
								147.64162639500012,
								-40.779848382999944
							],
							[
								147.63603269500004,
								-40.78810840299997
							]
						]
					],
					[
						[
							[
								147.84024800400005,
								-40.297750005999944
							],
							[
								147.83666811400008,
								-40.304768095999975
							],
							[
								147.85664481900005,
								-40.30918900699993
							],
							[
								147.8467602190001,
								-40.32394619699994
							],
							[
								147.86432861600008,
								-40.31951217799997
							],
							[
								147.88117098200007,
								-40.32594134999994
							],
							[
								147.9047396190001,
								-40.317076930999974
							],
							[
								147.90327984300006,
								-40.29145848099995
							],
							[
								147.88990109400004,
								-40.30380574999998
							],
							[
								147.87555736600007,
								-40.305647918999966
							],
							[
								147.8681085190001,
								-40.29727877799996
							],
							[
								147.8397959450001,
								-40.29209894599995
							],
							[
								147.84024800400005,
								-40.297750005999944
							]
						]
					],
					[
						[
							[
								147.79927854200002,
								-40.29541834299994
							],
							[
								147.787190774,
								-40.29990648199998
							],
							[
								147.80217375900008,
								-40.31508647299995
							],
							[
								147.79927854200002,
								-40.29541834299994
							]
						]
					],
					[
						[
							[
								147.91459746300006,
								-40.278676271999984
							],
							[
								147.92978811000012,
								-40.280409212999984
							],
							[
								147.93773791900003,
								-40.270558033999976
							],
							[
								147.93395287200008,
								-40.258584922999944
							],
							[
								147.9180433240001,
								-40.26588010199998
							],
							[
								147.91459746300006,
								-40.278676271999984
							]
						]
					],
					[
						[
							[
								148.02375313200002,
								-40.35045813099998
							],
							[
								148.0051605860001,
								-40.35159980999998
							],
							[
								147.981352108,
								-40.36935251799997
							],
							[
								148.01524290200007,
								-40.36204818099998
							],
							[
								148.02375313200002,
								-40.35045813099998
							]
						]
					],
					[
						[
							[
								148.06368629700012,
								-40.482611574999964
							],
							[
								148.08204305200002,
								-40.48881749699996
							],
							[
								148.05766084000004,
								-40.46785029499995
							],
							[
								148.0487522100001,
								-40.47671148399996
							],
							[
								148.06368629700012,
								-40.482611574999964
							]
						]
					],
					[
						[
							[
								148.0333196690001,
								-40.36148885199998
							],
							[
								147.98727105400008,
								-40.38708320799998
							],
							[
								147.98713023000005,
								-40.41898631899994
							],
							[
								147.99743184700003,
								-40.42367713899995
							],
							[
								148.01844868400008,
								-40.41441663099994
							],
							[
								148.0341982100001,
								-40.42449180199998
							],
							[
								148.024289091,
								-40.42991362199996
							],
							[
								148.0428150570001,
								-40.43210585299994
							],
							[
								148.04612502500004,
								-40.44878312399993
							],
							[
								148.06186462100004,
								-40.45360405499997
							],
							[
								148.08670344600012,
								-40.45731062699997
							],
							[
								148.09107753600006,
								-40.45003192699994
							],
							[
								148.1277212000001,
								-40.43967664999997
							],
							[
								148.14204010600008,
								-40.45000087099993
							],
							[
								148.1401373550001,
								-40.46057136099995
							],
							[
								148.15125558400007,
								-40.453795501999934
							],
							[
								148.14249525700006,
								-40.44809080099998
							],
							[
								148.16430364200005,
								-40.45031173299998
							],
							[
								148.19597377800005,
								-40.43549878599998
							],
							[
								148.22677932800002,
								-40.466070737999985
							],
							[
								148.27401955300002,
								-40.43629188199998
							],
							[
								148.27342424500011,
								-40.42897251199997
							],
							[
								148.29377051000006,
								-40.43423450399996
							],
							[
								148.30910312800006,
								-40.42655987499995
							],
							[
								148.33603015800009,
								-40.464895886999955
							],
							[
								148.33802082500006,
								-40.485165337999945
							],
							[
								148.35111819100007,
								-40.492840788999956
							],
							[
								148.377990188,
								-40.47654700099997
							],
							[
								148.397959323,
								-40.48944326299994
							],
							[
								148.400894955,
								-40.47299036299995
							],
							[
								148.4138194940001,
								-40.462014143999966
							],
							[
								148.4308767000001,
								-40.46524254499997
							],
							[
								148.43731352200007,
								-40.43994579499997
							],
							[
								148.4506405400001,
								-40.43653890699994
							],
							[
								148.4728689650001,
								-40.44285619799996
							],
							[
								148.481882605,
								-40.435031108999965
							],
							[
								148.46482385900003,
								-40.427076787999965
							],
							[
								148.45852195300006,
								-40.40934063699996
							],
							[
								148.44851453500007,
								-40.40551150599998
							],
							[
								148.45149501900005,
								-40.37667993599996
							],
							[
								148.42417426500003,
								-40.37143174399995
							],
							[
								148.4070835770001,
								-40.37798424299996
							],
							[
								148.4105405670001,
								-40.37191348299996
							],
							[
								148.39825813100003,
								-40.35774585199994
							],
							[
								148.3709534090001,
								-40.34143176899994
							],
							[
								148.3630194430001,
								-40.322222238999984
							],
							[
								148.32979467300004,
								-40.290749425999934
							],
							[
								148.33100906200002,
								-40.299864395999975
							],
							[
								148.3172454930001,
								-40.31155123499997
							],
							[
								148.30013900500012,
								-40.32174972399997
							],
							[
								148.28224987800002,
								-40.31962511199998
							],
							[
								148.26686965800002,
								-40.340690250999955
							],
							[
								148.24354280500006,
								-40.32537176899996
							],
							[
								148.22823886700007,
								-40.330333447999976
							],
							[
								148.22617366800011,
								-40.32212682699998
							],
							[
								148.21251602200005,
								-40.317537365999954
							],
							[
								148.20676069900003,
								-40.34333427599995
							],
							[
								148.19186151000008,
								-40.35620569499997
							],
							[
								148.1838997330001,
								-40.34486278399993
							],
							[
								148.16613934600002,
								-40.34789719299994
							],
							[
								148.14505411100004,
								-40.342969230999984
							],
							[
								148.1438032520001,
								-40.33615772099995
							],
							[
								148.089715371,
								-40.34573225599996
							],
							[
								148.0815286830001,
								-40.33920079599994
							],
							[
								148.06049818400004,
								-40.35875187399995
							],
							[
								148.04808157700006,
								-40.35546943299994
							],
							[
								148.0333196690001,
								-40.36148885199998
							]
						]
					],
					[
						[
							[
								148.0140952260001,
								-40.12188583899996
							],
							[
								148.01763195800004,
								-40.17054727999994
							],
							[
								148.04195518900008,
								-40.20476270199998
							],
							[
								148.04036517800012,
								-40.215614871999946
							],
							[
								148.02445081100007,
								-40.21188585999994
							],
							[
								148.02561577900008,
								-40.226802100999976
							],
							[
								148.04034410600002,
								-40.230092121999974
							],
							[
								148.04611479200003,
								-40.249493421999944
							],
							[
								148.05998016,
								-40.247752393999974
							],
							[
								148.088963561,
								-40.269042695999985
							],
							[
								148.09837621100007,
								-40.26075755699998
							],
							[
								148.12149921500009,
								-40.274054658999944
							],
							[
								148.15343773100005,
								-40.25997844099993
							],
							[
								148.15573599000004,
								-40.26501436099994
							],
							[
								148.16799830900004,
								-40.252450211999985
							],
							[
								148.18540128600011,
								-40.24984125399993
							],
							[
								148.19320856900003,
								-40.21889591399997
							],
							[
								148.2102876770001,
								-40.21068184599994
							],
							[
								148.2338956530001,
								-40.20918077699997
							],
							[
								148.24233832000004,
								-40.21480081799996
							],
							[
								148.25893351800005,
								-40.209849738999935
							],
							[
								148.27225167400002,
								-40.217143920999945
							],
							[
								148.271754793,
								-40.23079901099993
							],
							[
								148.2832959100001,
								-40.23136513199995
							],
							[
								148.33417245400005,
								-40.20910450599996
							],
							[
								148.3148331530001,
								-40.174071793999985
							],
							[
								148.28765684100006,
								-40.08077120099995
							],
							[
								148.27916365700003,
								-40.116414910999936
							],
							[
								148.23378354400006,
								-40.12772140699997
							],
							[
								148.22328592700012,
								-40.121032525999965
							],
							[
								148.23831140700008,
								-40.10151611699996
							],
							[
								148.24615623500006,
								-40.10375794799995
							],
							[
								148.26925194300009,
								-40.09076902999993
							],
							[
								148.28626196300002,
								-40.06791011099995
							],
							[
								148.279272772,
								-40.00858438999995
							],
							[
								148.291139906,
								-39.965105360999985
							],
							[
								148.26019970100003,
								-39.966856597999936
							],
							[
								148.20498087500005,
								-39.945220492999965
							],
							[
								148.17725040900007,
								-39.95204596099995
							],
							[
								148.17098284100007,
								-39.94257645099998
							],
							[
								148.18600503800008,
								-39.946491941999966
							],
							[
								148.1240893060001,
								-39.89851272699997
							],
							[
								148.10797845900004,
								-39.894895934999965
							],
							[
								148.12247731600007,
								-39.89743472599997
							],
							[
								147.96067611900003,
								-39.73011871199998
							],
							[
								147.96232091700006,
								-39.743276252999976
							],
							[
								147.99071053700004,
								-39.77926186499997
							],
							[
								147.9675175640001,
								-39.75914092299996
							],
							[
								147.9667404820001,
								-39.77285140299995
							],
							[
								147.95596316800004,
								-39.744927261999976
							],
							[
								147.95579325900007,
								-39.73200973199994
							],
							[
								147.964062989,
								-39.72761864299997
							],
							[
								147.94184398400012,
								-39.719533050999985
							],
							[
								147.91958354400003,
								-39.74433181899997
							],
							[
								147.88419165900007,
								-39.76131007599997
							],
							[
								147.8627080540001,
								-39.747142904999976
							],
							[
								147.8479835170001,
								-39.75065694299997
							],
							[
								147.86972144800006,
								-39.78671439499993
							],
							[
								147.84091138000008,
								-39.808798872999944
							],
							[
								147.85084047600003,
								-39.822633853999946
							],
							[
								147.84384491600008,
								-39.83704302399997
							],
							[
								147.80366251300006,
								-39.835349519999966
							],
							[
								147.79275204300006,
								-39.85241574999998
							],
							[
								147.77737718600008,
								-39.849550927999985
							],
							[
								147.76951563600005,
								-39.866372127999966
							],
							[
								147.74819112800003,
								-39.87430344599994
							],
							[
								147.75722834500004,
								-39.89060542699997
							],
							[
								147.7940930860001,
								-39.90194903999998
							],
							[
								147.80455120200008,
								-39.91656400099998
							],
							[
								147.84781114700002,
								-39.89801834399998
							],
							[
								147.87995187,
								-39.90723400699994
							],
							[
								147.90675588500005,
								-39.97614129999994
							],
							[
								147.89725055400004,
								-39.999001618999955
							],
							[
								147.885868726,
								-40.00056776799994
							],
							[
								147.88047303500002,
								-40.01208494799994
							],
							[
								147.8693141880001,
								-40.00945905699996
							],
							[
								147.859075608,
								-40.02347032599994
							],
							[
								147.87475432500003,
								-40.021269106999966
							],
							[
								147.8951443190001,
								-40.037033088999976
							],
							[
								147.91722787600008,
								-40.02981165099993
							],
							[
								147.93414974200005,
								-40.03481747199993
							],
							[
								147.95170806500005,
								-40.061188613999946
							],
							[
								147.95365493000008,
								-40.098992013999975
							],
							[
								147.96453050900004,
								-40.08845580499997
							],
							[
								147.9556894420001,
								-40.08057781399998
							],
							[
								147.96662517100003,
								-40.07570462499996
							],
							[
								147.9702133390001,
								-40.086627704999955
							],
							[
								148.00626889900002,
								-40.10449778799995
							],
							[
								148.0140952260001,
								-40.12188583899996
							]
						]
					],
					[
						[
							[
								147.97372235300008,
								-40.194163895999964
							],
							[
								147.9866348920001,
								-40.18599170699997
							],
							[
								147.97544694600003,
								-40.174619665999955
							],
							[
								147.97372235300008,
								-40.194163895999964
							]
						]
					],
					[
						[
							[
								147.90264719800007,
								-40.179215349999936
							],
							[
								147.8939093900001,
								-40.18200446999998
							],
							[
								147.89405863800005,
								-40.19424759999998
							],
							[
								147.90254831800007,
								-40.18501840999994
							],
							[
								147.9171691250001,
								-40.18648030199995
							],
							[
								147.90264719800007,
								-40.179215349999936
							]
						]
					],
					[
						[
							[
								147.77719178300003,
								-40.02603531899996
							],
							[
								147.7642170150001,
								-40.02863053799996
							],
							[
								147.7473167830001,
								-40.06661227699993
							],
							[
								147.75101588100006,
								-40.07616136799993
							],
							[
								147.72565254300002,
								-40.09118678599998
							],
							[
								147.72629884200012,
								-40.10312483599995
							],
							[
								147.75655627700007,
								-40.09474239799994
							],
							[
								147.75963466000007,
								-40.068311147999964
							],
							[
								147.78744695800003,
								-40.04234737999997
							],
							[
								147.77719178300003,
								-40.02603531899996
							]
						]
					],
					[
						[
							[
								147.77762041800008,
								-39.907869278999954
							],
							[
								147.77329739000004,
								-39.90362531799997
							],
							[
								147.76912960000004,
								-39.90934140799993
							],
							[
								147.77762041800008,
								-39.907869278999954
							]
						]
					],
					[
						[
							[
								147.96652353700006,
								-39.658503791999976
							],
							[
								147.96680947700008,
								-39.663681001999976
							],
							[
								147.99138361200005,
								-39.663369183999976
							],
							[
								148.01114208100012,
								-39.648614635999934
							],
							[
								147.9827540670001,
								-39.63691805399998
							],
							[
								147.9771222270001,
								-39.64344927299993
							],
							[
								147.9851829150001,
								-39.652255673999946
							],
							[
								147.96652353700006,
								-39.658503791999976
							]
						]
					],
					[
						[
							[
								147.88835036700004,
								-39.691062285999976
							],
							[
								147.89204449500005,
								-39.70190341699998
							],
							[
								147.90290247300004,
								-39.70521214799993
							],
							[
								147.91196337200006,
								-39.69905678799995
							],
							[
								147.9188220200001,
								-39.70433315899993
							],
							[
								147.9462589860001,
								-39.699468260999936
							],
							[
								147.92970676000004,
								-39.68603250999996
							],
							[
								147.90719768400004,
								-39.68928031799993
							],
							[
								147.90064896600006,
								-39.68145495699997
							],
							[
								147.88896235800007,
								-39.683988055999976
							],
							[
								147.88835036700004,
								-39.691062285999976
							]
						]
					],
					[
						[
							[
								148.31822140300005,
								-39.95269583299995
							],
							[
								148.3229014410001,
								-39.95952170299995
							],
							[
								148.34236363700006,
								-39.95880673499994
							],
							[
								148.3477338470001,
								-39.95090938499993
							],
							[
								148.3285688640001,
								-39.931969753999965
							],
							[
								148.31822140300005,
								-39.95269583299995
							]
						]
					],
					[
						[
							[
								148.35878801600006,
								-39.94992170599994
							],
							[
								148.35189385700005,
								-39.950709175999975
							],
							[
								148.3614820350001,
								-39.95355457599993
							],
							[
								148.3628821750001,
								-39.946555355999976
							],
							[
								148.35878801600006,
								-39.94992170599994
							]
						]
					],
					[
						[
							[
								148.2888054340001,
								-40.27279046199993
							],
							[
								148.281978653,
								-40.28837831199996
							],
							[
								148.3062796580001,
								-40.29280840399997
							],
							[
								148.32589263500006,
								-40.28752343499997
							],
							[
								148.3123664000001,
								-40.26624643399998
							],
							[
								148.2954280350001,
								-40.257428352999966
							],
							[
								148.2888054340001,
								-40.27279046199993
							]
						]
					],
					[
						[
							[
								148.24563744800002,
								-40.22818985799995
							],
							[
								148.26193242500005,
								-40.22845492999994
							],
							[
								148.2568396570001,
								-40.221942868999975
							],
							[
								148.24563744800002,
								-40.22818985799995
							]
						]
					],
					[
						[
							[
								148.20159169300007,
								-40.25053017499994
							],
							[
								148.2056838210001,
								-40.25847777499996
							],
							[
								148.21498701000007,
								-40.25532676599994
							],
							[
								148.21193532100006,
								-40.24838598599996
							],
							[
								148.20159169300007,
								-40.25053017499994
							]
						]
					],
					[
						[
							[
								148.24789610400012,
								-40.25394076899994
							],
							[
								148.26580862000003,
								-40.25677400999996
							],
							[
								148.26326172200004,
								-40.24497292999996
							],
							[
								148.22798180900008,
								-40.240477736999935
							],
							[
								148.23341005600003,
								-40.25452761799994
							],
							[
								148.23889848600004,
								-40.24861370799994
							],
							[
								148.24789610400012,
								-40.25394076899994
							]
						]
					],
					[
						[
							[
								148.11598655300008,
								-40.51261772999993
							],
							[
								148.0958120140001,
								-40.53161755799994
							],
							[
								148.0988430120001,
								-40.53690223799998
							],
							[
								148.1215333780001,
								-40.53709921999996
							],
							[
								148.11346179600002,
								-40.56509197999998
							],
							[
								148.12676772200007,
								-40.57238026099998
							],
							[
								148.13169592200006,
								-40.56575682099998
							],
							[
								148.14920864900012,
								-40.56535588299994
							],
							[
								148.17829150900002,
								-40.59417237499997
							],
							[
								148.19847035600003,
								-40.590108906999944
							],
							[
								148.19243596,
								-40.573989395999945
							],
							[
								148.23511175700003,
								-40.53275331899994
							],
							[
								148.23177004100012,
								-40.50862001899998
							],
							[
								148.2467365000001,
								-40.497025349999944
							],
							[
								148.24800056200002,
								-40.48021069999993
							],
							[
								148.22770197500006,
								-40.48533145899995
							],
							[
								148.21447889500007,
								-40.50274641799996
							],
							[
								148.18805458200006,
								-40.489548034999984
							],
							[
								148.17363464400012,
								-40.497681833999934
							],
							[
								148.13113539100004,
								-40.502093860999935
							],
							[
								148.11598655300008,
								-40.51261772999993
							]
						]
					],
					[
						[
							[
								148.13361971900008,
								-40.299367899999936
							],
							[
								148.16605927400008,
								-40.29192207199998
							],
							[
								148.1407764590001,
								-40.29054742999995
							],
							[
								148.13361971900008,
								-40.299367899999936
							]
						]
					],
					[
						[
							[
								148.10819233400002,
								-40.29650708799994
							],
							[
								148.097403804,
								-40.308258286999944
							],
							[
								148.10680577200003,
								-40.31262586799994
							],
							[
								148.11607877200004,
								-40.30272190799997
							],
							[
								148.10819233400002,
								-40.29650708799994
							]
						]
					],
					[
						[
							[
								148.30546629800006,
								-40.505021554999985
							],
							[
								148.30420854600004,
								-40.52095304499994
							],
							[
								148.31325010400008,
								-40.52191802599998
							],
							[
								148.3170125270001,
								-40.497758085999976
							],
							[
								148.30546629800006,
								-40.505021554999985
							]
						]
					],
					[
						[
							[
								148.34350517200005,
								-40.49830102799996
							],
							[
								148.33473914400008,
								-40.49449379699996
							],
							[
								148.3278789740001,
								-40.501521096999966
							],
							[
								148.3470100080001,
								-40.52250309899995
							],
							[
								148.34350517200005,
								-40.49830102799996
							]
						]
					],
					[
						[
							[
								148.09318624500008,
								-40.74282776899997
							],
							[
								148.11705129000006,
								-40.739919260999955
							],
							[
								148.12648662100003,
								-40.72708081199994
							],
							[
								148.09388201600007,
								-40.734319598999946
							],
							[
								148.09318624500008,
								-40.74282776899997
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "601",
				"CED_NAME21": "Bass",
				"STE_CODE21": "6",
				"STE_NAME21": "Tasmania",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 7985.4067,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/601",
				"SHAPE_Leng": 19.3373034495,
				"SHAPE_Area": 0.853513596367
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								146.66141722100008,
								-41.09610785899997
							],
							[
								146.64228256500007,
								-41.09667306799997
							],
							[
								146.64796032200002,
								-41.11013146799996
							],
							[
								146.61635202500008,
								-41.13580598599998
							],
							[
								146.58521843900007,
								-41.14717736399996
							],
							[
								146.56444081400002,
								-41.14648141199996
							],
							[
								146.5667122110001,
								-41.16375347199994
							],
							[
								146.60166197600006,
								-41.15187308499998
							],
							[
								146.60959116300012,
								-41.15843705599997
							],
							[
								146.604139045,
								-41.15556709499998
							],
							[
								146.59502674500004,
								-41.164361493999934
							],
							[
								146.6078824120001,
								-41.168578124999954
							],
							[
								146.5847733170001,
								-41.16788334399996
							],
							[
								146.5783596860001,
								-41.184670482999934
							],
							[
								146.57806005400005,
								-41.197667542999966
							],
							[
								146.59548536900002,
								-41.20930942499996
							],
							[
								146.5878724900001,
								-41.21425751399994
							],
							[
								146.6092334860001,
								-41.21202731599993
							],
							[
								146.59936980600003,
								-41.225770454999974
							],
							[
								146.60887122300005,
								-41.23373540599994
							],
							[
								146.59956704500007,
								-41.233019474999935
							],
							[
								146.59504451400005,
								-41.25064055499996
							],
							[
								146.6068770400001,
								-41.259311525999976
							],
							[
								146.59391954400007,
								-41.251418574999946
							],
							[
								146.5961826580001,
								-41.21971847499998
							],
							[
								146.58622357000002,
								-41.216460533999964
							],
							[
								146.5850362220001,
								-41.20507649399997
							],
							[
								146.58342372000004,
								-41.22274059399996
							],
							[
								146.56877803100008,
								-41.23303475299997
							],
							[
								146.57793524900012,
								-41.240560683999945
							],
							[
								146.56517256000006,
								-41.251016842999945
							],
							[
								146.57299319000003,
								-41.23932573299993
							],
							[
								146.56110219200002,
								-41.238430851999965
							],
							[
								146.57572865200007,
								-41.220157642999936
							],
							[
								146.56241206700008,
								-41.19729769199995
							],
							[
								146.57298881600002,
								-41.18913255299998
							],
							[
								146.56892454900003,
								-41.177825532999975
							],
							[
								146.55364342200005,
								-41.17147263099997
							],
							[
								146.54037910400007,
								-41.179124989999934
							],
							[
								146.54798734400003,
								-41.16844766099996
							],
							[
								146.5585324110001,
								-41.17247259199996
							],
							[
								146.56199929100012,
								-41.16737053199995
							],
							[
								146.541782097,
								-41.155042649999984
							],
							[
								146.54572124900005,
								-41.12953596099993
							],
							[
								146.53189932400005,
								-41.11841557899993
							],
							[
								146.51935599400008,
								-41.13617238899997
							],
							[
								146.46528205100003,
								-41.15955546499998
							],
							[
								146.42438719900008,
								-41.16232574199995
							],
							[
								146.39360818300008,
								-41.17287510899996
							],
							[
								146.368822388,
								-41.17221635799996
							],
							[
								146.3698193890001,
								-41.16745998799996
							],
							[
								146.36233892600012,
								-41.20067399699997
							],
							[
								146.40034056500008,
								-41.22823936999998
							],
							[
								146.4004932040001,
								-41.23343096999997
							],
							[
								146.39180364700007,
								-41.22779546999993
							],
							[
								146.38885090600002,
								-41.23592953899998
							],
							[
								146.3863556980001,
								-41.228346518999956
							],
							[
								146.3885669760001,
								-41.238228558999936
							],
							[
								146.38473075800005,
								-41.22883952899997
							],
							[
								146.36817782100002,
								-41.22739569799995
							],
							[
								146.37112754200007,
								-41.21739261799996
							],
							[
								146.35981104400003,
								-41.22213569699994
							],
							[
								146.36797255300007,
								-41.21667364799998
							],
							[
								146.36418779500002,
								-41.20841987699998
							],
							[
								146.34774023700004,
								-41.21733898599996
							],
							[
								146.3556552670001,
								-41.20124268699993
							],
							[
								146.34848837800007,
								-41.20379777599993
							],
							[
								146.36683492600002,
								-41.19261950799995
							],
							[
								146.36680923000006,
								-41.16523532699995
							],
							[
								146.35686517200008,
								-41.15846537699997
							],
							[
								146.33651536600007,
								-41.16026663499997
							],
							[
								146.31603894700004,
								-41.18283043399998
							],
							[
								146.33269531700012,
								-41.15661295499996
							],
							[
								146.28731483600006,
								-41.16066904199994
							],
							[
								146.25542392300008,
								-41.151807238999936
							],
							[
								146.25248390800004,
								-41.19387601899996
							],
							[
								146.24984712200012,
								-41.17150968899995
							],
							[
								146.24360525200007,
								-41.17720390799997
							],
							[
								146.2484521240001,
								-41.15710633899994
							],
							[
								146.22727493800005,
								-41.16001317699994
							],
							[
								146.20046040400007,
								-41.150910814999975
							],
							[
								146.16916677000006,
								-41.15019514299996
							],
							[
								146.16931467100005,
								-41.14533306299995
							],
							[
								146.16852830900007,
								-41.157456932999935
							],
							[
								146.14417540300008,
								-41.164061610999966
							],
							[
								146.1519135100001,
								-41.17692975199998
							],
							[
								146.14463118300012,
								-41.16147794099993
							],
							[
								146.129433467,
								-41.15898171999993
							],
							[
								146.1253722570001,
								-41.16489016999998
							],
							[
								146.12077142900011,
								-41.15569290899998
							],
							[
								146.1317663970001,
								-41.15725366999993
							],
							[
								146.12898878800002,
								-41.15228500999996
							],
							[
								146.15224625200005,
								-41.16228399199997
							],
							[
								146.1543861020001,
								-41.154318271999955
							],
							[
								146.16766294,
								-41.156264232999945
							],
							[
								146.16743974100007,
								-41.14660309299995
							],
							[
								146.1288115100001,
								-41.13530032999995
							],
							[
								146.11966132400005,
								-41.11893492899998
							],
							[
								146.07735969200007,
								-41.115554445999976
							],
							[
								146.06433945700007,
								-41.102685674999975
							],
							[
								146.0465615500001,
								-41.101913072999935
							],
							[
								145.98584936600002,
								-41.07409493899996
							],
							[
								145.9737677160001,
								-41.08773681799994
							],
							[
								145.98452233600005,
								-41.07478857899997
							],
							[
								145.95810433200006,
								-41.06302307699997
							],
							[
								145.92490535800005,
								-41.06616892399995
							],
							[
								145.92326315700006,
								-41.078002613999956
							],
							[
								145.9249522980001,
								-41.06767676399994
							],
							[
								145.90934494300006,
								-41.05386279299995
							],
							[
								145.92141699100011,
								-41.051376783999956
							],
							[
								145.8847232490001,
								-41.04466807099993
							],
							[
								145.877094241,
								-41.036845160999974
							],
							[
								145.84102607800003,
								-41.03868936799995
							],
							[
								145.83005750900008,
								-41.05004738799994
							],
							[
								145.83607948700012,
								-41.05695635799998
							],
							[
								145.82982948900008,
								-41.050000377999936
							],
							[
								145.83887111900003,
								-41.03884637799996
							],
							[
								145.80087389800008,
								-41.026171414999965
							],
							[
								145.7685384880001,
								-40.99686761299995
							],
							[
								145.69646593400012,
								-40.974720927999954
							],
							[
								145.74127602400006,
								-40.98536181099996
							],
							[
								145.7245773200001,
								-40.968968908999955
							],
							[
								145.73311609000007,
								-40.95626682999995
							],
							[
								145.72934509200002,
								-40.944938829999955
							],
							[
								145.65370867700005,
								-40.94029454399998
							],
							[
								145.62180527400005,
								-40.93209078199993
							],
							[
								145.61974321500009,
								-40.92528673199996
							],
							[
								145.59521383000003,
								-40.923977709999974
							],
							[
								145.5838878840001,
								-40.91378777899996
							],
							[
								145.56047744800003,
								-40.91680403699996
							],
							[
								145.54615353200006,
								-40.90911118599996
							],
							[
								145.5377472550001,
								-40.891469195999946
							],
							[
								145.52232841900002,
								-40.88763538499995
							],
							[
								145.5116039950001,
								-40.853559193999956
							],
							[
								145.50263309700006,
								-40.851691322999955
							],
							[
								145.48161858900005,
								-40.86880291199998
							],
							[
								145.4472558550001,
								-40.87402388899994
							],
							[
								145.44802206300005,
								-40.887246008999966
							],
							[
								145.43537529500009,
								-40.89425537899996
							],
							[
								145.4466920440001,
								-40.88609102899994
							],
							[
								145.44605482600002,
								-40.87121688899998
							],
							[
								145.40378987600002,
								-40.85498059599996
							],
							[
								145.39538009700004,
								-40.86323585599996
							],
							[
								145.3918988790001,
								-40.849700774999974
							],
							[
								145.34387035800012,
								-40.851025661999984
							],
							[
								145.31559940500006,
								-40.83767502999996
							],
							[
								145.32146356200008,
								-40.84968805999995
							],
							[
								145.3114505950001,
								-40.84264314999996
							],
							[
								145.28764200900002,
								-40.850927587999934
							],
							[
								145.30790768600002,
								-40.846409248999976
							],
							[
								145.31288340600008,
								-40.83520003999996
							],
							[
								145.28008600700002,
								-40.793710046999934
							],
							[
								145.2936075010001,
								-40.82689127799995
							],
							[
								145.28075767300004,
								-40.82990450699998
							],
							[
								145.28477946300006,
								-40.820540337999944
							],
							[
								145.2690774670001,
								-40.81104144599993
							],
							[
								145.26614625900004,
								-40.79789731599993
							],
							[
								145.27114923800002,
								-40.801120295999965
							],
							[
								145.28893156900006,
								-40.76629587799994
							],
							[
								145.3058025150001,
								-40.769151878999935
							],
							[
								145.30867755500003,
								-40.76415886899997
							],
							[
								145.29478408900002,
								-40.75481416799994
							],
							[
								145.29597778100003,
								-40.738646837999966
							],
							[
								145.27591903500002,
								-40.735549085999935
							],
							[
								145.26045482100005,
								-40.71233485499994
							],
							[
								145.25088128100003,
								-40.72996235499994
							],
							[
								145.26944652400005,
								-40.75823163599995
							],
							[
								145.2589945200001,
								-40.80574651599994
							],
							[
								145.24139192200005,
								-40.813686863999976
							],
							[
								145.21611622800003,
								-40.81092514299996
							],
							[
								145.25692523200007,
								-40.78983733499996
							],
							[
								145.1878035840001,
								-40.80406840099994
							],
							[
								145.11043667,
								-40.794275004999974
							],
							[
								145.11278876900008,
								-40.80138505499997
							],
							[
								145.13384542500012,
								-40.80283991699997
							],
							[
								145.16716316600002,
								-40.81898575899993
							],
							[
								145.16415235600005,
								-40.82557985899996
							],
							[
								145.14850247000004,
								-40.817870927999934
							],
							[
								145.1316117330001,
								-40.81928108699998
							],
							[
								145.119699523,
								-40.84102891599997
							],
							[
								145.09138001700012,
								-40.84768754399994
							],
							[
								145.1216766230001,
								-40.83859729599993
							],
							[
								145.1186112040001,
								-40.828976215999944
							],
							[
								145.11152538500005,
								-40.83164828599996
							],
							[
								145.1085480480001,
								-40.81440917499998
							],
							[
								145.0967413200001,
								-40.814451273999964
							],
							[
								145.0998557580001,
								-40.82667742499996
							],
							[
								145.08570569100004,
								-40.824391513999956
							],
							[
								145.09036437200007,
								-40.813028343999974
							],
							[
								145.0772785050001,
								-40.808338522999975
							],
							[
								145.0652909160001,
								-40.819221761999984
							],
							[
								145.070141626,
								-40.80944162299994
							],
							[
								145.05265948200008,
								-40.78685876099996
							],
							[
								145.0388475960001,
								-40.780584929999975
							],
							[
								145.02759602600008,
								-40.791355169999974
							],
							[
								145.01876510800003,
								-40.78945328899994
							],
							[
								145.02356683900007,
								-40.778006138999956
							],
							[
								145.01564097000005,
								-40.77927527899993
							],
							[
								145.02419164000003,
								-40.770565088999945
							],
							[
								145.00759414200002,
								-40.778450377999945
							],
							[
								145.01624968200008,
								-40.766557208999984
							],
							[
								145.01018473300007,
								-40.76670633799995
							],
							[
								145.00061315400012,
								-40.77507647799996
							],
							[
								145.00175666500002,
								-40.76217757799998
							],
							[
								144.97960935100002,
								-40.74344005599994
							],
							[
								144.96738878300005,
								-40.75182822499994
							],
							[
								144.9279756200001,
								-40.75870188299996
							],
							[
								144.9291270770001,
								-40.77540588299996
							],
							[
								144.90781262400003,
								-40.75077785099995
							],
							[
								144.84890765700004,
								-40.738752846999944
							],
							[
								144.84024562800005,
								-40.743465845999935
							],
							[
								144.84225658700007,
								-40.75332279699995
							],
							[
								144.83654964200002,
								-40.71869085599997
							],
							[
								144.8106026360001,
								-40.72729690399996
							],
							[
								144.80467762900003,
								-40.71367383399996
							],
							[
								144.78552265300004,
								-40.708464842999945
							],
							[
								144.7660215730001,
								-40.74361386099997
							],
							[
								144.7717596660001,
								-40.705908851999936
							],
							[
								144.73635365500002,
								-40.69010784899996
							],
							[
								144.73813463500005,
								-40.68223283899994
							],
							[
								144.74880066200012,
								-40.68951883999995
							],
							[
								144.7263806620001,
								-40.64147484799997
							],
							[
								144.68475066700012,
								-40.67472183599995
							],
							[
								144.69772666200004,
								-40.689577836999945
							],
							[
								144.67836768300003,
								-40.71693082499996
							],
							[
								144.691271636,
								-40.755068835999964
							],
							[
								144.7001546350001,
								-40.75029383699996
							],
							[
								144.7086296430001,
								-40.75485582799996
							],
							[
								144.70957568000006,
								-40.77163382799995
							],
							[
								144.69744564100006,
								-40.78303284699996
							],
							[
								144.70602364800004,
								-40.79584383799994
							],
							[
								144.69719264800005,
								-40.80911482699997
							],
							[
								144.71302463200004,
								-40.835507837999955
							],
							[
								144.7131916500001,
								-40.85329182899994
							],
							[
								144.6987696320001,
								-40.86231183799998
							],
							[
								144.7056356390001,
								-40.87192983799997
							],
							[
								144.6858286590001,
								-40.90558982699997
							],
							[
								144.6769846410001,
								-40.90977083599995
							],
							[
								144.64920365700004,
								-40.90013482399996
							],
							[
								144.6558086540001,
								-40.913855834999936
							],
							[
								144.61175265000008,
								-40.935703831999945
							],
							[
								144.61225463900007,
								-40.94463883199995
							],
							[
								144.63089952500002,
								-40.95246479399998
							],
							[
								144.63284562900003,
								-40.99382883399994
							],
							[
								144.6258306200001,
								-41.004972822999946
							],
							[
								144.60734563300002,
								-41.00876882199998
							],
							[
								144.63891363200003,
								-41.045331834999956
							],
							[
								144.65982462700003,
								-41.05326883599997
							],
							[
								144.68001970400007,
								-41.049571836999974
							],
							[
								144.68247057500002,
								-41.037421836999954
							],
							[
								144.69562174100008,
								-41.04782188799993
							],
							[
								144.74569378,
								-41.055602841999985
							],
							[
								144.77234457300005,
								-41.07452183399994
							],
							[
								144.7823676920001,
								-41.06551183399995
							],
							[
								144.79117759000007,
								-41.06867686499993
							],
							[
								144.79387256100006,
								-41.05396581499997
							],
							[
								144.8006254290001,
								-41.06185586599997
							],
							[
								144.79117075800002,
								-41.086267814999985
							],
							[
								144.7991275060001,
								-41.08951582599997
							],
							[
								144.79073370800006,
								-41.086818894999965
							],
							[
								144.8007737680001,
								-41.063760885999955
							],
							[
								144.79541155100003,
								-41.05428586499994
							],
							[
								144.7915905100001,
								-41.06885182499997
							],
							[
								144.77452545300002,
								-41.07032079399994
							],
							[
								144.7713956120001,
								-41.078031813999985
							],
							[
								144.7812664500001,
								-41.079839843999935
							],
							[
								144.7752155510001,
								-41.08427980399995
							],
							[
								144.7801464810001,
								-41.07854787399998
							],
							[
								144.74616069,
								-41.056395821999956
							],
							[
								144.69527364100009,
								-41.04847284799996
							],
							[
								144.68396565400008,
								-41.03847187799994
							],
							[
								144.6812257030001,
								-41.05019382699993
							],
							[
								144.659340637,
								-41.05735484599995
							],
							[
								144.67807860000005,
								-41.07976485699993
							],
							[
								144.67654570600007,
								-41.116997857999934
							],
							[
								144.66458260800005,
								-41.12054684699996
							],
							[
								144.67138361500008,
								-41.138687836999964
							],
							[
								144.68048554300003,
								-41.13929381799994
							],
							[
								144.68314271300005,
								-41.132441867999944
							],
							[
								144.67261461200007,
								-41.15932983799996
							],
							[
								144.69485744300005,
								-41.19998083899998
							],
							[
								144.68674561000012,
								-41.243213838999964
							],
							[
								144.70592960400006,
								-41.25474086999998
							],
							[
								144.71136759,
								-41.28210483099997
							],
							[
								144.722636447,
								-41.28512586199997
							],
							[
								144.71975459600003,
								-41.30147084099997
							],
							[
								144.74200951000012,
								-41.31167281299997
							],
							[
								144.7380775900001,
								-41.325564852999946
							],
							[
								144.7705596610001,
								-41.34150584499997
							],
							[
								144.75949154400007,
								-41.34118085399996
							],
							[
								144.77782552600002,
								-41.36974980599996
							],
							[
								144.78298144600012,
								-41.36740981599996
							],
							[
								144.7818665420001,
								-41.39701584599993
							],
							[
								144.7898927110001,
								-41.39508887699998
							],
							[
								144.74589258700007,
								-41.42147784399998
							],
							[
								144.78528556600008,
								-41.44570083699995
							],
							[
								144.79249256200012,
								-41.46311984699997
							],
							[
								144.81358648600008,
								-41.477448858999935
							],
							[
								144.8213165620001,
								-41.50075985899997
							],
							[
								144.83957666800006,
								-41.50555387099996
							],
							[
								144.83201255900008,
								-41.50860684999998
							],
							[
								144.88830838900003,
								-41.58318085399998
							],
							[
								144.9058775100001,
								-41.62880685599998
							],
							[
								144.89712353000004,
								-41.63949485499995
							],
							[
								144.90666852800007,
								-41.64200484599996
							],
							[
								144.91824950300008,
								-41.66756385699995
							],
							[
								144.974749416,
								-41.628720870999985
							],
							[
								144.9931054430001,
								-41.62631086199997
							],
							[
								145.00470142200004,
								-41.61648384299997
							],
							[
								145.03405759600003,
								-41.61670488499993
							],
							[
								145.05057943400004,
								-41.60128987599995
							],
							[
								145.03492162500004,
								-41.61704086499998
							],
							[
								145.0683507660001,
								-41.63648160699995
							],
							[
								145.0806403150001,
								-41.62630849799996
							],
							[
								145.06852767700002,
								-41.634578586999965
							],
							[
								145.0656200850001,
								-41.64901870699998
							],
							[
								145.082204111,
								-41.65616272799997
							],
							[
								145.10405840800001,
								-41.643731539999976
							],
							[
								145.09035985000003,
								-41.65103964899998
							],
							[
								145.10378082700004,
								-41.65588163999996
							],
							[
								145.0812371510001,
								-41.657102727999984
							],
							[
								145.06209812600002,
								-41.64796971699997
							],
							[
								145.05901668900003,
								-41.62746357599997
							],
							[
								145.05107484100006,
								-41.63004862599996
							],
							[
								145.03472806500008,
								-41.618382794999945
							],
							[
								145.00525757100002,
								-41.61780865299994
							],
							[
								144.9249177920001,
								-41.665595086999986
							],
							[
								144.9263879,
								-41.67285711799997
							],
							[
								144.94185105700012,
								-41.67762060899997
							],
							[
								144.92752185000006,
								-41.67139507799993
							],
							[
								144.91122529100005,
								-41.69121534699997
							],
							[
								144.9270262440001,
								-41.72091983799993
							],
							[
								144.93806030200005,
								-41.724395768999955
							],
							[
								144.95494695900004,
								-41.71675862999996
							],
							[
								144.97858245200007,
								-41.73808982199995
							],
							[
								144.9850583110001,
								-41.73552478199997
							],
							[
								144.98012348100008,
								-41.73954882199996
							],
							[
								144.999136506,
								-41.755088102999935
							],
							[
								144.9949533460001,
								-41.76215036299993
							],
							[
								145.01014997200002,
								-41.767357543999935
							],
							[
								145.01064078900004,
								-41.790161903999945
							],
							[
								145.0337304630001,
								-41.80642186599994
							],
							[
								145.0283664630001,
								-41.81289986499996
							],
							[
								145.05679334600006,
								-41.82406319699993
							],
							[
								145.07146593900006,
								-41.854698508999945
							],
							[
								145.109207469,
								-41.87709374099995
							],
							[
								145.1244408130001,
								-41.90048603199995
							],
							[
								145.19497839200005,
								-41.94823788799994
							],
							[
								145.2041201520001,
								-41.93680221799997
							],
							[
								145.19693439200012,
								-41.948647877999974
							],
							[
								145.20257142000003,
								-41.95891488799998
							],
							[
								145.19056467400003,
								-41.946119426999985
							],
							[
								145.25197928700004,
								-42.060076831999936
							],
							[
								145.24564603200008,
								-42.02767994199996
							],
							[
								145.25330286200006,
								-42.018604841999945
							],
							[
								145.26758438800005,
								-42.02277289299997
							],
							[
								145.2532528920001,
								-42.01947486199998
							],
							[
								145.24588507200008,
								-42.03111093199993
							],
							[
								145.2639983680001,
								-42.10848389299997
							],
							[
								145.25941436100004,
								-42.175091882999936
							],
							[
								145.2231416830001,
								-42.21869192099996
							],
							[
								145.24922180700003,
								-42.22091264299996
							],
							[
								145.26808105200007,
								-42.23209181399994
							],
							[
								145.28968707800004,
								-42.227279575999944
							],
							[
								145.29016348200003,
								-42.196633615999986
							],
							[
								145.2850427510001,
								-42.21008400499994
							],
							[
								145.2681545360001,
								-42.20237487399993
							],
							[
								145.2937671630001,
								-42.17915398599996
							],
							[
								145.3181690890001,
								-42.17617182699996
							],
							[
								145.30782861400007,
								-42.148893096999984
							],
							[
								145.32306575000007,
								-42.15655514799994
							],
							[
								145.33393161900005,
								-42.151746937999974
							],
							[
								145.3291390170001,
								-42.17328571799993
							],
							[
								145.3469049140001,
								-42.16857148899993
							],
							[
								145.35966301000008,
								-42.177338729999974
							],
							[
								145.3563013590001,
								-42.191227169999934
							],
							[
								145.37756841400005,
								-42.19656120199994
							],
							[
								145.4195793560001,
								-42.196826974999965
							],
							[
								145.43383607400006,
								-42.18827468599994
							],
							[
								145.44907134900006,
								-42.199415846999955
							],
							[
								145.4640690870001,
								-42.19224259799995
							],
							[
								145.46967318500003,
								-42.196656667999946
							],
							[
								145.47156779700003,
								-42.18492440799997
							],
							[
								145.48700276300008,
								-42.18652635899997
							],
							[
								145.49995836200003,
								-42.17630612999994
							],
							[
								145.48702882300006,
								-42.186903368999936
							],
							[
								145.47151380700006,
								-42.185360437999975
							],
							[
								145.47012523500007,
								-42.19704767799993
							],
							[
								145.46390209700007,
								-42.19255561799997
							],
							[
								145.44949339900006,
								-42.19976584699998
							],
							[
								145.43402806400002,
								-42.18869268599997
							],
							[
								145.41122439700007,
								-42.19840505399998
							],
							[
								145.35590343900003,
								-42.194241259999956
							],
							[
								145.350676818,
								-42.21054073999994
							],
							[
								145.35739559800004,
								-42.201989469999944
							],
							[
								145.372359565,
								-42.20228937099995
							],
							[
								145.36400081500005,
								-42.20985263099993
							],
							[
								145.3718161920001,
								-42.22434790099993
							],
							[
								145.3609144830001,
								-42.23378519099998
							],
							[
								145.36483199000008,
								-42.251663520999955
							],
							[
								145.37744006700007,
								-42.25173136199993
							],
							[
								145.39970301900007,
								-42.27745748399997
							],
							[
								145.42299574300011,
								-42.28996141499994
							],
							[
								145.43247135800004,
								-42.314290795999966
							],
							[
								145.46338272100002,
								-42.323446487999945
							],
							[
								145.48109061200012,
								-42.36459962999993
							],
							[
								145.49264746000006,
								-42.355914420999966
							],
							[
								145.48493848200008,
								-42.35664455999995
							],
							[
								145.4898594110001,
								-42.35247747099993
							],
							[
								145.4805453040001,
								-42.34722760999995
							],
							[
								145.49787321100007,
								-42.34237121099994
							],
							[
								145.49412276400005,
								-42.32185394099997
							],
							[
								145.49946497200006,
								-42.332330010999954
							],
							[
								145.51751209700012,
								-42.33975481199997
							],
							[
								145.5267414530001,
								-42.36052578299996
							],
							[
								145.51961260300004,
								-42.368073952999964
							],
							[
								145.50259356700008,
								-42.36399925099994
							],
							[
								145.51237169400008,
								-42.37418309199995
							],
							[
								145.53018358100007,
								-42.37260277299998
							],
							[
								145.54375030000006,
								-42.352110453999956
							],
							[
								145.55761927700007,
								-42.35701520499998
							],
							[
								145.54256546800002,
								-42.36918152399994
							],
							[
								145.54989080500002,
								-42.38794646499997
							],
							[
								145.53623983700004,
								-42.38711574399997
							],
							[
								145.53483221500005,
								-42.40546683399998
							],
							[
								145.51306084600003,
								-42.43448932299998
							],
							[
								145.52548398200008,
								-42.444144103999975
							],
							[
								145.5342429200001,
								-42.447433553999986
							],
							[
								145.5561985370001,
								-42.43597984599995
							],
							[
								145.58141868000007,
								-42.448101777999966
							],
							[
								145.60141260700004,
								-42.44555136899993
							],
							[
								145.6082996440001,
								-42.45069023899998
							],
							[
								145.61641954300012,
								-42.44545608999994
							],
							[
								145.612919346,
								-42.43435318999997
							],
							[
								145.6257714620001,
								-42.444466930999965
							],
							[
								145.64578809900001,
								-42.434258581999984
							],
							[
								145.67327204200012,
								-42.442716803999986
							],
							[
								145.67875506300004,
								-42.50198928499998
							],
							[
								145.66710153200006,
								-42.527725723999936
							],
							[
								145.67407255000012,
								-42.53410374499998
							],
							[
								145.66735965100008,
								-42.53799189399996
							],
							[
								145.67184816700012,
								-42.56070410499996
							],
							[
								145.7011802500001,
								-42.57163351699995
							],
							[
								145.71866466400002,
								-42.589445797999986
							],
							[
								145.72929572200007,
								-42.58201767899993
							],
							[
								145.74136421900005,
								-42.59112548999997
							],
							[
								145.72970269200005,
								-42.582781668999985
							],
							[
								145.71817858400004,
								-42.59002181799997
							],
							[
								145.69861032000006,
								-42.57086855699998
							],
							[
								145.6709881170001,
								-42.56235015499993
							],
							[
								145.66615665100005,
								-42.53821391399998
							],
							[
								145.6725475500001,
								-42.53433277399995
							],
							[
								145.66529054300008,
								-42.52748376399995
							],
							[
								145.677128153,
								-42.50407534499993
							],
							[
								145.6719961120001,
								-42.44485277399997
							],
							[
								145.6482260780001,
								-42.43576252199995
							],
							[
								145.62630849100003,
								-42.44587591099997
							],
							[
								145.6114953760001,
								-42.435798199999965
							],
							[
								145.61820950300012,
								-42.445468079999955
							],
							[
								145.60815569400006,
								-42.45303224899993
							],
							[
								145.5547456170001,
								-42.44039666599997
							],
							[
								145.53106198000012,
								-42.44951972399997
							],
							[
								145.49195366200001,
								-42.422243710999965
							],
							[
								145.45803290700007,
								-42.43477541899995
							],
							[
								145.45418003700001,
								-42.44259349799995
							],
							[
								145.47388204300012,
								-42.44054811999996
							],
							[
								145.464048025,
								-42.44258230899993
							],
							[
								145.48020660800012,
								-42.47536598999994
							],
							[
								145.47231994600008,
								-42.50098097999995
							],
							[
								145.48180165100007,
								-42.52568464099994
							],
							[
								145.47391466200008,
								-42.52582976999997
							],
							[
								145.44664490900004,
								-42.43742863799997
							],
							[
								145.45328429200003,
								-42.40441937799994
							],
							[
								145.41559429400002,
								-42.37172978499996
							],
							[
								145.39351793800006,
								-42.374258173999976
							],
							[
								145.340419794,
								-42.337042629999985
							],
							[
								145.33796688300004,
								-42.344396769999946
							],
							[
								145.3309775770001,
								-42.33038162899993
							],
							[
								145.31004118200008,
								-42.320443747999946
							],
							[
								145.31751262500006,
								-42.28533577799993
							],
							[
								145.29957769700002,
								-42.296640286999946
							],
							[
								145.2895913010001,
								-42.28288215599997
							],
							[
								145.25347707800006,
								-42.288458813999966
							],
							[
								145.25606774000005,
								-42.267312093999976
							],
							[
								145.23705952400007,
								-42.263342171999966
							],
							[
								145.23578717700002,
								-42.24406854199998
							],
							[
								145.22101205,
								-42.24200368099997
							],
							[
								145.2248648110001,
								-42.22840720099998
							],
							[
								145.20730433800009,
								-42.20007954999994
							],
							[
								145.20875940700012,
								-42.207385759999966
							],
							[
								145.19976942900007,
								-42.20789888899998
							],
							[
								145.19796027100006,
								-42.19768561899997
							],
							[
								145.17711490500005,
								-42.19307171799994
							],
							[
								145.16590878700003,
								-42.19923191699996
							],
							[
								145.17394830400008,
								-42.20991425799997
							],
							[
								145.19011540100007,
								-42.20799902899995
							],
							[
								145.18917190700006,
								-42.242602138999985
							],
							[
								145.20588517200008,
								-42.25440929999996
							],
							[
								145.21373164700003,
								-42.27771599099998
							],
							[
								145.21381603500004,
								-42.29835472099995
							],
							[
								145.19401310700005,
								-42.312123449999945
							],
							[
								145.19613434500002,
								-42.32782188999994
							],
							[
								145.22318597600008,
								-42.35528210199993
							],
							[
								145.21530007600006,
								-42.36588149099998
							],
							[
								145.2285012530001,
								-42.37061936199996
							],
							[
								145.22432448100005,
								-42.386377771999946
							],
							[
								145.23552570800007,
								-42.39470072299997
							],
							[
								145.23756167800002,
								-42.39007259299996
							],
							[
								145.23587289700004,
								-42.40440991299994
							],
							[
								145.24496500500004,
								-42.40614375399997
							],
							[
								145.23463309500005,
								-42.417466152999964
							],
							[
								145.25389567800005,
								-42.44349515399995
							],
							[
								145.23601698800007,
								-42.472289762999935
							],
							[
								145.24448940500008,
								-42.48668459399994
							],
							[
								145.25503446200003,
								-42.48873541499995
							],
							[
								145.26120281900012,
								-42.50397534499996
							],
							[
								145.25283124800012,
								-42.522074514999986
							],
							[
								145.2674744640001,
								-42.528580225999974
							],
							[
								145.27774832800003,
								-42.56319396699996
							],
							[
								145.30441756100004,
								-42.571198418999984
							],
							[
								145.29536815000006,
								-42.59520951799993
							],
							[
								145.30171925800005,
								-42.59903836899997
							],
							[
								145.2808356710001,
								-42.61491373699994
							],
							[
								145.26298663500006,
								-42.61273711599995
							],
							[
								145.2629528340001,
								-42.621610085999976
							],
							[
								145.28538813800003,
								-42.63235856799997
							],
							[
								145.29003385800002,
								-42.62250051799998
							],
							[
								145.31181581400006,
								-42.620645078999985
							],
							[
								145.33578564700008,
								-42.632558280999945
							],
							[
								145.32777615700002,
								-42.64608213099996
							],
							[
								145.3336423940001,
								-42.65775876099997
							],
							[
								145.338308234,
								-42.65101170099996
							],
							[
								145.3662153580001,
								-42.656499302999975
							],
							[
								145.3658211940001,
								-42.68914826399998
							],
							[
								145.38327255500008,
								-42.72821201499994
							],
							[
								145.3941816040001,
								-42.72127486599993
							],
							[
								145.39670426100008,
								-42.73639184599995
							],
							[
								145.38879413300003,
								-42.73557094499995
							],
							[
								145.39133749100006,
								-42.743014905999985
							],
							[
								145.38059488300007,
								-42.74815403499997
							],
							[
								145.38264257000003,
								-42.768691014999945
							],
							[
								145.41458714200007,
								-42.78078563799994
							],
							[
								145.40720041300006,
								-42.78455872699993
							],
							[
								145.426327355,
								-42.81490181899994
							],
							[
								145.41973249600005,
								-42.814795867999976
							],
							[
								145.42085659300005,
								-42.83707608799995
							],
							[
								145.43687343700003,
								-42.85446204899995
							],
							[
								145.44374138400008,
								-42.86908108999995
							],
							[
								145.43603251500008,
								-42.87343518999995
							],
							[
								145.45197439900005,
								-42.897804220999944
							],
							[
								145.47605413100007,
								-42.914203182999984
							],
							[
								145.4876260090001,
								-42.91337506299993
							],
							[
								145.48156712800005,
								-42.93106628299995
							],
							[
								145.49046702600003,
								-42.92922120399993
							],
							[
								145.492957014,
								-42.946908373999975
							],
							[
								145.50440290100005,
								-42.948699284999975
							],
							[
								145.49220205300003,
								-42.95595045399995
							],
							[
								145.49360106000006,
								-42.97394865399997
							],
							[
								145.50350401800006,
								-42.97643259499995
							],
							[
								145.49488409700007,
								-42.99150983399994
							],
							[
								145.56137044600007,
								-42.97108713899996
							],
							[
								145.59064224000008,
								-42.97250598099998
							],
							[
								145.59992625600012,
								-42.99048413199995
							],
							[
								145.60752723400003,
								-42.99066709199997
							],
							[
								145.60993331100008,
								-43.00916602299998
							],
							[
								145.6439620420001,
								-43.024758144999964
							],
							[
								145.63778010200008,
								-43.032374224999955
							],
							[
								145.6476380580001,
								-43.04849338499997
							],
							[
								145.66003100600005,
								-43.04380327599995
							],
							[
								145.68223290000003,
								-43.05045528799997
							],
							[
								145.68453472700003,
								-43.06853641799995
							],
							[
								145.69120273600004,
								-43.067487368999934
							],
							[
								145.67485281900008,
								-43.07045045799998
							],
							[
								145.6697566890001,
								-43.08117056699996
							],
							[
								145.6768385160001,
								-43.091157607999946
							],
							[
								145.66495652800006,
								-43.09623368699994
							],
							[
								145.6733812750001,
								-43.10671371799998
							],
							[
								145.6833613230001,
								-43.100373617999935
							],
							[
								145.6942688690001,
								-43.11848063899998
							],
							[
								145.70847802600008,
								-43.11847013999994
							],
							[
								145.71616331600012,
								-43.10600411099995
							],
							[
								145.7154287950001,
								-43.11174994099997
							],
							[
								145.73623120000002,
								-43.116718091999985
							],
							[
								145.72497445200008,
								-43.12246382099994
							],
							[
								145.7216484610001,
								-43.13633897099993
							],
							[
								145.7335521980001,
								-43.137461851999944
							],
							[
								145.757946499,
								-43.164879293999945
							],
							[
								145.7615677650001,
								-43.19323876399994
							],
							[
								145.76873574400008,
								-43.18560763499994
							],
							[
								145.78773395000007,
								-43.188250755999945
							],
							[
								145.79527010800007,
								-43.19239184699995
							],
							[
								145.78987306800002,
								-43.20081789599993
							],
							[
								145.80789665300006,
								-43.20944328799993
							],
							[
								145.79668951400004,
								-43.21904226699996
							],
							[
								145.81112003900012,
								-43.23480659799998
							],
							[
								145.80412405000004,
								-43.235489677999965
							],
							[
								145.80648584800008,
								-43.248859477999986
							],
							[
								145.82056689500007,
								-43.250085308999985
							],
							[
								145.8156716520001,
								-43.27850304899994
							],
							[
								145.8392175450001,
								-43.294682610999985
							],
							[
								145.8505095820001,
								-43.29259152099996
							],
							[
								145.85336954100012,
								-43.30014544199997
							],
							[
								145.841235481,
								-43.31525341099996
							],
							[
								145.85055053100007,
								-43.306765380999934
							],
							[
								145.87054256400006,
								-43.32260107299993
							],
							[
								145.8786856040001,
								-43.310787122999955
							],
							[
								145.89518469000006,
								-43.314521954999975
							],
							[
								145.89918177100003,
								-43.30028702499993
							],
							[
								145.92663794500004,
								-43.30047383699997
							],
							[
								145.92395304000001,
								-43.267420125999934
							],
							[
								145.90108791500006,
								-43.26544730499995
							],
							[
								145.89757683400012,
								-43.28172119499993
							],
							[
								145.88070069600008,
								-43.28967125299994
							],
							[
								145.86249370300004,
								-43.273013601999935
							],
							[
								145.87567480000007,
								-43.27317247299993
							],
							[
								145.87180185300008,
								-43.25865963299998
							],
							[
								145.8971509160001,
								-43.26412636499998
							],
							[
								145.9074950160001,
								-43.24833839499996
							],
							[
								145.92846809200012,
								-43.24517724699996
							],
							[
								145.92484613600004,
								-43.224928415999955
							],
							[
								145.91961812800002,
								-43.215568545999986
							],
							[
								145.91392712900006,
								-43.217819575999954
							],
							[
								145.9158052030001,
								-43.18826678499994
							],
							[
								145.9086532450001,
								-43.187000884999975
							],
							[
								145.9271071700001,
								-43.18939963599996
							],
							[
								145.92047698500005,
								-43.16136928599997
							],
							[
								145.9404588330001,
								-43.150426256999936
							],
							[
								145.96038911200003,
								-43.12822418799993
							],
							[
								145.98267074600005,
								-43.13484052999996
							],
							[
								145.99270580900009,
								-43.10063307099995
							],
							[
								145.97170038600007,
								-43.07660946899995
							],
							[
								145.9820095550001,
								-43.07238903999996
							],
							[
								145.974506108,
								-43.06130890899993
							],
							[
								145.97814626000002,
								-43.03915843899995
							],
							[
								145.97816436300002,
								-43.01748614899998
							],
							[
								145.9914418620001,
								-43.00450250999995
							],
							[
								145.99503762400002,
								-42.98034752999996
							],
							[
								145.94061957200006,
								-42.93071873599996
							],
							[
								145.93428715700009,
								-42.905176584999936
							],
							[
								145.9494669940001,
								-42.90588533599998
							],
							[
								145.8495587980001,
								-42.73320462799995
							],
							[
								145.83250596300002,
								-42.71751619699995
							],
							[
								145.8709066250001,
								-42.71658363999995
							],
							[
								145.86704365000003,
								-42.69196224899997
							],
							[
								145.8931692430001,
								-42.698034150999945
							],
							[
								145.90469116300005,
								-42.68407764199998
							],
							[
								145.92804889800004,
								-42.682016283999985
							],
							[
								145.93428568900003,
								-42.66940418399997
							],
							[
								145.9657563840001,
								-42.65854187599996
							],
							[
								145.9620604370001,
								-42.63864323599995
							],
							[
								145.9669083670001,
								-42.63331606599996
							],
							[
								145.97050430500008,
								-42.638966266999944
							],
							[
								145.9720842470001,
								-42.624320816999955
							],
							[
								145.98482610400004,
								-42.626292916999944
							],
							[
								146.00097538700004,
								-42.57992438799994
							],
							[
								146.017875064,
								-42.57297522999994
							],
							[
								146.02976253400004,
								-42.55412461999998
							],
							[
								146.02930022700002,
								-42.53822804999993
							],
							[
								146.05336664300012,
								-42.528539921999936
							],
							[
								146.08119555100006,
								-42.50326866399996
							],
							[
								146.08974809100005,
								-42.489973343999964
							],
							[
								146.07800903300006,
								-42.48710747399997
							],
							[
								146.0877697520001,
								-42.48373166399995
							],
							[
								146.07525430500004,
								-42.47790677299997
							],
							[
								146.08618572300009,
								-42.47589104399998
							],
							[
								146.10903527300002,
								-42.44508791599998
							],
							[
								146.1257915100001,
								-42.436721776999946
							],
							[
								146.13386016200002,
								-42.414598696999974
							],
							[
								146.12769911400005,
								-42.406200086999945
							],
							[
								146.10633814800008,
								-42.40791899499993
							],
							[
								146.0995356100001,
								-42.40254383499996
							],
							[
								146.11495551000007,
								-42.380624685999976
							],
							[
								146.09846032500002,
								-42.370765183999936
							],
							[
								146.0970865370001,
								-42.358738313999936
							],
							[
								146.10695486200007,
								-42.305292634999944
							],
							[
								146.08864708800002,
								-42.287777812999934
							],
							[
								146.07533322100005,
								-42.21045700199994
							],
							[
								145.9997584350001,
								-42.06688649599994
							],
							[
								146.02342733400008,
								-42.03943360699998
							],
							[
								146.01492167000004,
								-42.005307665999965
							],
							[
								146.05048890700004,
								-41.974542988999985
							],
							[
								145.95133675400007,
								-41.684649399999955
							],
							[
								145.8530233470001,
								-41.58300993199998
							],
							[
								145.85283677200005,
								-41.465850021999984
							],
							[
								145.95407034400012,
								-41.451792988999955
							],
							[
								146.0872086270001,
								-41.458133147999945
							],
							[
								146.09469444700005,
								-41.44400738899998
							],
							[
								146.08525887200005,
								-41.42099086799993
							],
							[
								146.11745114000007,
								-41.38425188999997
							],
							[
								146.1142593620001,
								-41.371656919999964
							],
							[
								146.1351656490001,
								-41.36849477099997
							],
							[
								146.13478945000008,
								-41.36256511099998
							],
							[
								146.17697712400002,
								-41.34125744399995
							],
							[
								146.18469950600002,
								-41.31626668499996
							],
							[
								146.2050409520001,
								-41.31183177599996
							],
							[
								146.19426144600004,
								-41.303000054999984
							],
							[
								146.19692258600003,
								-41.295620155999984
							],
							[
								146.20344758400006,
								-41.29753517599994
							],
							[
								146.19645202700008,
								-41.29073962599995
							],
							[
								146.22617076300003,
								-41.27154830799998
							],
							[
								146.23613665100004,
								-41.27827373799994
							],
							[
								146.26568952600007,
								-41.265579970999966
							],
							[
								146.3211254250001,
								-41.271849514999985
							],
							[
								146.32338097600007,
								-41.25492841499994
							],
							[
								146.3494769030001,
								-41.242134516999954
							],
							[
								146.3701073960001,
								-41.26678868799996
							],
							[
								146.35753215700004,
								-41.27262012699998
							],
							[
								146.35892641600003,
								-41.28418919799998
							],
							[
								146.3841854000001,
								-41.28692688899997
							],
							[
								146.38372762000006,
								-41.29292321899993
							],
							[
								146.3901696490001,
								-41.28784128999996
							],
							[
								146.4005128660001,
								-41.295252550999976
							],
							[
								146.44445440700008,
								-41.29782344399996
							],
							[
								146.44680825400008,
								-41.315006703999984
							],
							[
								146.459689281,
								-41.32014656499996
							],
							[
								146.45978501800005,
								-41.347244674999956
							],
							[
								146.4894635280001,
								-41.37793538799997
							],
							[
								146.5280735120001,
								-41.36496933099994
							],
							[
								146.54558492800004,
								-41.367380641999944
							],
							[
								146.54822157900003,
								-41.35499260199998
							],
							[
								146.5899274200001,
								-41.36173344499997
							],
							[
								146.58086451400004,
								-41.346862313999964
							],
							[
								146.58957877400007,
								-41.334781454999984
							],
							[
								146.6174775080001,
								-41.33788746699997
							],
							[
								146.61995019900007,
								-41.32446351699997
							],
							[
								146.70359088200007,
								-41.33267657399995
							],
							[
								146.7051834560001,
								-41.297768633999965
							],
							[
								146.71844470300005,
								-41.305930494999984
							],
							[
								146.71981951300006,
								-41.299668484999984
							],
							[
								146.74948228800008,
								-41.29750717699994
							],
							[
								146.75164195800005,
								-41.28750216699996
							],
							[
								146.76206482600003,
								-41.28716406799998
							],
							[
								146.6956315750001,
								-41.17025740199995
							],
							[
								146.6956922700001,
								-41.13293200199996
							],
							[
								146.65842454000006,
								-41.110282488999985
							],
							[
								146.66141722100008,
								-41.09610785899997
							]
						]
					],
					[
						[
							[
								144.68369268200001,
								-40.63122683499995
							],
							[
								144.6876256600001,
								-40.638786825999944
							],
							[
								144.69828767900003,
								-40.63388684599994
							],
							[
								144.6799106630001,
								-40.626308834999975
							],
							[
								144.68369268200001,
								-40.63122683499995
							]
						]
					],
					[
						[
							[
								144.68638167900008,
								-40.56679783499993
							],
							[
								144.686456689,
								-40.56119884499998
							],
							[
								144.6785666610001,
								-40.56257683499996
							],
							[
								144.68638167900008,
								-40.56679783499993
							]
						]
					],
					[
						[
							[
								143.8380469010001,
								-39.93312977599993
							],
							[
								143.8790339100001,
								-39.96721477899996
							],
							[
								143.891677135,
								-39.99349803999996
							],
							[
								143.884042872,
								-40.02817576899997
							],
							[
								143.89003189800007,
								-40.053937779999956
							],
							[
								143.8799319090001,
								-40.062680788999955
							],
							[
								143.85808790400006,
								-40.062358777999975
							],
							[
								143.8720438890001,
								-40.08344477899993
							],
							[
								143.87528089400007,
								-40.11675077899997
							],
							[
								143.9044318980001,
								-40.12138079099998
							],
							[
								143.90083588700008,
								-40.13936978099997
							],
							[
								143.9159588540001,
								-40.14345878199998
							],
							[
								143.92573085000004,
								-40.15795077299998
							],
							[
								143.92977486100006,
								-40.146110772999975
							],
							[
								143.92105188400012,
								-40.13406777199998
							],
							[
								143.949704891,
								-40.11290979399996
							],
							[
								143.9626408890001,
								-40.10913479499993
							],
							[
								143.97109388600006,
								-40.116720794999935
							],
							[
								143.98966887500012,
								-40.09822678599994
							],
							[
								144.02695686800007,
								-40.09484977899996
							],
							[
								144.04933483700006,
								-40.06767978999994
							],
							[
								144.06299185500006,
								-40.06302179099998
							],
							[
								144.06274186400003,
								-40.06920980099994
							],
							[
								144.07039285500002,
								-40.05142679099998
							],
							[
								144.0938938500001,
								-40.05224378299994
							],
							[
								144.10620185900007,
								-40.04367479399997
							],
							[
								144.100812861,
								-40.028798792999964
							],
							[
								144.11624884900004,
								-40.01813180399995
							],
							[
								144.11355694100007,
								-40.00803354399994
							],
							[
								144.1280184300001,
								-39.99323011499996
							],
							[
								144.1382359150001,
								-39.93387623499996
							],
							[
								144.1356517160001,
								-39.92437019499994
							],
							[
								144.11139261200003,
								-39.91380255299998
							],
							[
								144.10501920600007,
								-39.89128144299997
							],
							[
								144.1065896980001,
								-39.86618412299998
							],
							[
								144.1279237990001,
								-39.82212524399995
							],
							[
								144.10179616000005,
								-39.76446825199997
							],
							[
								144.10966293900003,
								-39.66996544199998
							],
							[
								144.05148400400003,
								-39.625448337999956
							],
							[
								144.01259632400001,
								-39.60882791499995
							],
							[
								144.0053863060001,
								-39.59662398499995
							],
							[
								143.98439567000003,
								-39.60097031299995
							],
							[
								143.9497680180001,
								-39.579247720999945
							],
							[
								143.93543537900007,
								-39.594837009999935
							],
							[
								143.924214591,
								-39.595274178999944
							],
							[
								143.9346237950001,
								-39.63819626999998
							],
							[
								143.92227135400003,
								-39.66943860999993
							],
							[
								143.8913343270001,
								-39.69830517799994
							],
							[
								143.84433266400004,
								-39.71508676499997
							],
							[
								143.85467868900002,
								-39.73750979599998
							],
							[
								143.85020335700005,
								-39.77024403599995
							],
							[
								143.86303237200002,
								-39.78960304699996
							],
							[
								143.85908394000012,
								-39.816146765999974
							],
							[
								143.86727194700006,
								-39.83129177699993
							],
							[
								143.84421193600008,
								-39.87685077599997
							],
							[
								143.8470489340001,
								-39.89475678599996
							],
							[
								143.83508890500002,
								-39.90265678499998
							],
							[
								143.83377892300007,
								-39.92137376499994
							],
							[
								143.845199911,
								-39.92561977599996
							],
							[
								143.8380469010001,
								-39.93312977599993
							]
						]
					],
					[
						[
							[
								143.81925571300008,
								-39.67500573299998
							],
							[
								143.83748217000004,
								-39.66802953399997
							],
							[
								143.82675434200007,
								-39.66500161299996
							],
							[
								143.81925571300008,
								-39.67500573299998
							]
						]
					],
					[
						[
							[
								144.71636265900008,
								-40.60429083699995
							],
							[
								144.72259966700005,
								-40.60874282799995
							],
							[
								144.72012065900003,
								-40.598812847999966
							],
							[
								144.71636265900008,
								-40.60429083699995
							]
						]
					],
					[
						[
							[
								144.7866536790001,
								-40.400746830999935
							],
							[
								144.78439267700003,
								-40.420527850999974
							],
							[
								144.76650767800004,
								-40.44408083999997
							],
							[
								144.77255368400006,
								-40.46462083999995
							],
							[
								144.7559626850001,
								-40.485628848999966
							],
							[
								144.73075669900004,
								-40.48918084799993
							],
							[
								144.72478267100007,
								-40.47912283699998
							],
							[
								144.71063969400006,
								-40.48458583599995
							],
							[
								144.71828268000002,
								-40.50047783699995
							],
							[
								144.70954768100012,
								-40.510017835999975
							],
							[
								144.7222246780001,
								-40.51703283699993
							],
							[
								144.73317164200012,
								-40.55004883799995
							],
							[
								144.72581065000008,
								-40.57458683799996
							],
							[
								144.7354946360001,
								-40.59286882899994
							],
							[
								144.75754067000003,
								-40.60597084999995
							],
							[
								144.7759676600001,
								-40.58121785099996
							],
							[
								144.77128967600004,
								-40.53346383099995
							],
							[
								144.79104767600006,
								-40.507268831999966
							],
							[
								144.7866536790001,
								-40.400746830999935
							]
						]
					],
					[
						[
							[
								144.83571466400008,
								-40.44431183399996
							],
							[
								144.85093067000003,
								-40.45244684599993
							],
							[
								144.858057647,
								-40.46882084599997
							],
							[
								144.89491764800005,
								-40.48385984899994
							],
							[
								144.91302963500004,
								-40.48110084999996
							],
							[
								144.95223862000012,
								-40.459007861999964
							],
							[
								144.94791863300009,
								-40.43859085199995
							],
							[
								144.969892651,
								-40.42629986399993
							],
							[
								144.95622066500005,
								-40.41243285199994
							],
							[
								144.96196664500008,
								-40.40111085299998
							],
							[
								144.95436263800002,
								-40.39117485199995
							],
							[
								144.94364364900002,
								-40.397734861999936
							],
							[
								144.92618866300006,
								-40.39169284999997
							],
							[
								144.91390264500012,
								-40.397438859999966
							],
							[
								144.8868706510001,
								-40.388739837999935
							],
							[
								144.879025672,
								-40.39276684699996
							],
							[
								144.88441569000008,
								-40.39944184799998
							],
							[
								144.87449966200006,
								-40.40131184699993
							],
							[
								144.88567365900008,
								-40.40835884799998
							],
							[
								144.88163267900006,
								-40.41806585699993
							],
							[
								144.86522666000008,
								-40.43205485599998
							],
							[
								144.8407896550001,
								-40.430024844999934
							],
							[
								144.83571466400008,
								-40.44431183399996
							]
						]
					],
					[
						[
							[
								144.86845563500003,
								-40.723887857999955
							],
							[
								144.89374260800003,
								-40.74046685999997
							],
							[
								144.91942060500003,
								-40.728464851999945
							],
							[
								144.94307260000005,
								-40.731334852999964
							],
							[
								144.97694361600009,
								-40.70767285599993
							],
							[
								145.00444059000006,
								-40.71414785799993
							],
							[
								145.0140625690001,
								-40.70662886799994
							],
							[
								145.032812615,
								-40.71063585899998
							],
							[
								145.03879460400003,
								-40.70559386999997
							],
							[
								145.03913259400008,
								-40.713120869999955
							],
							[
								145.0511125810001,
								-40.71226486099994
							],
							[
								145.0411505630001,
								-40.71742385999994
							],
							[
								145.06788556800007,
								-40.714351861999944
							],
							[
								145.04432158500003,
								-40.68916084999995
							],
							[
								145.04931758500004,
								-40.68033484999995
							],
							[
								145.02665360900005,
								-40.68491785899994
							],
							[
								144.99157660800006,
								-40.66999085599997
							],
							[
								144.9547626100001,
								-40.62946084399994
							],
							[
								144.9679886340001,
								-40.65872585499994
							],
							[
								144.9373856210001,
								-40.64975986299993
							],
							[
								144.9293956250001,
								-40.62230686199996
							],
							[
								144.91937061700003,
								-40.62492984099998
							],
							[
								144.9031336260001,
								-40.65711584999997
							],
							[
								144.8718356500001,
								-40.67858585799996
							],
							[
								144.87644661500008,
								-40.71075485899996
							],
							[
								144.86845563500003,
								-40.723887857999955
							]
						]
					],
					[
						[
							[
								144.9232046510001,
								-40.58403585099995
							],
							[
								144.91991964800002,
								-40.61296785099995
							],
							[
								144.9370066030001,
								-40.62932385199997
							],
							[
								144.9499386320001,
								-40.62106184299995
							],
							[
								144.92899362100002,
								-40.577659851999954
							],
							[
								144.9232046510001,
								-40.58403585099995
							]
						]
					],
					[
						[
							[
								144.8310556660001,
								-40.69164285599993
							],
							[
								144.82783062600004,
								-40.70181184499995
							],
							[
								144.84132661400008,
								-40.69612684599997
							],
							[
								144.8310556660001,
								-40.69164285599993
							]
						]
					],
					[
						[
							[
								145.04308108700002,
								-40.75746168999996
							],
							[
								145.0465375240001,
								-40.782970820999935
							],
							[
								145.07742523600007,
								-40.794903432999945
							],
							[
								145.10384981100003,
								-40.79493405499994
							],
							[
								145.04835485700005,
								-40.75151255099996
							],
							[
								145.04308108700002,
								-40.75746168999996
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "602",
				"CED_NAME21": "Braddon",
				"STE_CODE21": "6",
				"STE_NAME21": "Tasmania",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 21368.6009,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/602",
				"SHAPE_Leng": 30.9824706578,
				"SHAPE_Area": 2.30938073669
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							147.15037280400009,
							-42.91333759699995
						],
						[
							147.15730112100005,
							-42.91967708699997
						],
						[
							147.15154266000002,
							-42.93912041699997
						],
						[
							147.1742589040001,
							-42.94535702899998
						],
						[
							147.1672368840001,
							-42.95771802799993
						],
						[
							147.17684288100008,
							-42.96122902899998
						],
						[
							147.16107386400006,
							-42.96719601799998
						],
						[
							147.18149385700008,
							-42.985667028999956
						],
						[
							147.2204668700001,
							-42.97762403199994
						],
						[
							147.21793588900005,
							-42.98722403199997
						],
						[
							147.23495984400006,
							-42.99716303399998
						],
						[
							147.257106872,
							-42.981158034999964
						],
						[
							147.2483568460001,
							-42.96670603399997
						],
						[
							147.26579190100006,
							-42.97338829599994
						],
						[
							147.2970117760001,
							-42.96517919799993
						],
						[
							147.3160733410001,
							-42.97366827999997
						],
						[
							147.32158312900003,
							-42.979513199999985
						],
						[
							147.33856774600008,
							-42.97441397099993
						],
						[
							147.34453691800002,
							-42.954754581999964
						],
						[
							147.35585468600004,
							-42.951095462999945
						],
						[
							147.36096798000005,
							-42.914114482999935
						],
						[
							147.33224361800012,
							-42.90020661099993
						],
						[
							147.339452369,
							-42.88678245099993
						],
						[
							147.33153245000005,
							-42.88492551999997
						],
						[
							147.34120112000005,
							-42.87705038099995
						],
						[
							147.3367939320001,
							-42.86457637099994
						],
						[
							147.31966820700006,
							-42.85511842899996
						],
						[
							147.3278538070001,
							-42.84459719999995
						],
						[
							147.3130617490001,
							-42.849193268999954
						],
						[
							147.3221167800001,
							-42.832076178999955
						],
						[
							147.30527101400003,
							-42.82639027799996
						],
						[
							147.30189527400012,
							-42.833821257999944
						],
						[
							147.29501224600006,
							-42.82921729699996
						],
						[
							147.30672692400003,
							-42.82353327799996
						],
						[
							147.29802294700005,
							-42.81872331699998
						],
						[
							147.27931065000007,
							-42.82598345599996
						],
						[
							147.255964306,
							-42.81513252399998
						],
						[
							147.262350125,
							-42.81135652499995
						],
						[
							147.2536334880001,
							-42.80619041399996
						],
						[
							147.26586102700003,
							-42.79651449499994
						],
						[
							147.25895912900012,
							-42.791821443999936
						],
						[
							147.27224885500004,
							-42.79577045499997
						],
						[
							147.2832115540001,
							-42.78998130599996
						],
						[
							147.25282326100012,
							-42.786738353999965
						],
						[
							147.253509064,
							-42.76577422399998
						],
						[
							147.22690842100008,
							-42.750407381999935
						],
						[
							147.20185920200004,
							-42.783831849999956
						],
						[
							147.20083949900004,
							-42.806451719999984
						],
						[
							147.17880021200006,
							-42.81459617799993
						],
						[
							147.17386311100006,
							-42.82973339799997
						],
						[
							147.136236477,
							-42.84419665499996
						],
						[
							147.1510516720001,
							-42.85576026599995
						],
						[
							147.15037280400009,
							-42.91333759699995
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "603",
				"CED_NAME21": "Clark",
				"STE_CODE21": "6",
				"STE_NAME21": "Tasmania",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 292.8821,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/603",
				"SHAPE_Leng": 1.33036942722,
				"SHAPE_Area": 0.0322751060554
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								146.27499415500006,
								-43.63710517399994
							],
							[
								146.26859723300004,
								-43.65854913399994
							],
							[
								146.28641635100007,
								-43.65142230499998
							],
							[
								146.27499415500006,
								-43.63710517399994
							]
						]
					],
					[
						[
							[
								146.28603357500003,
								-43.61988641499994
							],
							[
								146.29518744300003,
								-43.622401295999964
							],
							[
								146.2927084050001,
								-43.612977254999976
							],
							[
								146.28603357500003,
								-43.61988641499994
							]
						]
					],
					[
						[
							[
								145.9404588330001,
								-43.150426256999936
							],
							[
								145.92134287500005,
								-43.16317821599995
							],
							[
								145.9373471680001,
								-43.19146752699993
							],
							[
								145.91629017200012,
								-43.192160755999964
							],
							[
								145.92813215800004,
								-43.20464551599997
							],
							[
								145.91612413000007,
								-43.21124959599996
							],
							[
								145.93247517600003,
								-43.21253743699998
							],
							[
								145.94641317100002,
								-43.229991187999985
							],
							[
								145.9689022760001,
								-43.22805005999993
							],
							[
								145.97995834300002,
								-43.23479193999998
							],
							[
								145.96816629400007,
								-43.247566949999964
							],
							[
								145.97315539900012,
								-43.27297876999995
							],
							[
								145.95342120200007,
								-43.28105283899998
							],
							[
								145.96355831000005,
								-43.285654748999946
							],
							[
								145.9578782100001,
								-43.290447728999936
							],
							[
								145.96845032600004,
								-43.302941629999964
							],
							[
								145.983110473,
								-43.30477955099997
							],
							[
								145.98348047000002,
								-43.322621450999975
							],
							[
								146.0060147260001,
								-43.320733392999955
							],
							[
								145.9972016260001,
								-43.33062936199997
							],
							[
								146.00377464400003,
								-43.335331322999934
							],
							[
								146.02873896800008,
								-43.34237926499998
							],
							[
								146.03904816700003,
								-43.33269431499997
							],
							[
								146.0589774230001,
								-43.33354931699995
							],
							[
								146.04918031700004,
								-43.32108036599993
							],
							[
								146.06447242800004,
								-43.28937449699998
							],
							[
								146.057126368,
								-43.30079147599997
							],
							[
								146.0698115340001,
								-43.30953743699996
							],
							[
								146.07183162100011,
								-43.32744136799994
							],
							[
								146.0842872070001,
								-43.340209698999956
							],
							[
								146.08744190800007,
								-43.32544246899994
							],
							[
								146.09111664500006,
								-43.33930799899997
							],
							[
								146.11187102000008,
								-43.34838095099997
							],
							[
								146.1364127050001,
								-43.34561063199993
							],
							[
								146.1411414270001,
								-43.32241552299996
							],
							[
								146.1576251150001,
								-43.311336273999984
							],
							[
								146.15335698800004,
								-43.29874031299994
							],
							[
								146.16844969600004,
								-43.29103809399993
							],
							[
								146.1759510290001,
								-43.32643708499995
							],
							[
								146.18906069800005,
								-43.31519787599996
							],
							[
								146.20862056200008,
								-43.33048766799993
							],
							[
								146.21922932100006,
								-43.32108749799994
							],
							[
								146.2178424000001,
								-43.32608751799995
							],
							[
								146.2319521280001,
								-43.32386331899994
							],
							[
								146.2228363580001,
								-43.33251544899997
							],
							[
								146.2266834940001,
								-43.36108941899994
							],
							[
								146.2128977760001,
								-43.36404161799993
							],
							[
								146.22543559200005,
								-43.37593341899998
							],
							[
								146.22332151000012,
								-43.389067248999936
							],
							[
								146.20907490500008,
								-43.37562067799996
							],
							[
								146.21026878700002,
								-43.36356266799993
							],
							[
								146.1553806080001,
								-43.362800413999935
							],
							[
								146.17677143100002,
								-43.382133135999936
							],
							[
								146.16437161400006,
								-43.38196729499998
							],
							[
								146.15694678400007,
								-43.39207841399997
							],
							[
								146.147367808,
								-43.37783252299994
							],
							[
								146.1346309810001,
								-43.376531701999966
							],
							[
								146.14386898500004,
								-43.408125592999966
							],
							[
								146.15224193200004,
								-43.41531247399996
							],
							[
								146.1686355390001,
								-43.41106110499993
							],
							[
								146.16641553800002,
								-43.418739064999954
							],
							[
								146.14006203600002,
								-43.40662065299995
							],
							[
								146.12670402300012,
								-43.373693801999934
							],
							[
								146.1371769010001,
								-43.37306665299997
							],
							[
								146.13054587500005,
								-43.35545073199995
							],
							[
								146.11387205800008,
								-43.35487593099998
							],
							[
								146.10127693200002,
								-43.34592890999994
							],
							[
								146.09507463300008,
								-43.35174370899995
							],
							[
								146.08619239600011,
								-43.342021828999975
							],
							[
								146.0896180640001,
								-43.35031029899994
							],
							[
								146.05831341200008,
								-43.344485256999974
							],
							[
								146.09160198200004,
								-43.36446691899994
							],
							[
								146.08351136200008,
								-43.37151321899995
							],
							[
								146.07115717600004,
								-43.36607443799994
							],
							[
								146.07783491500004,
								-43.35848818799997
							],
							[
								146.0680108780001,
								-43.35312852699997
							],
							[
								146.00310162300002,
								-43.344945252999935
							],
							[
								146.00672472300005,
								-43.339669292999986
							],
							[
								145.986822479,
								-43.32930938099997
							],
							[
								145.9750833180001,
								-43.349142290999964
							],
							[
								145.98925045600004,
								-43.34787928199995
							],
							[
								145.99313946200004,
								-43.365311161999955
							],
							[
								146.00190559100008,
								-43.365462142999945
							],
							[
								145.99365735800006,
								-43.39423898199993
							],
							[
								145.98373228100002,
								-43.38823303099997
							],
							[
								145.99348843100006,
								-43.37393011199998
							],
							[
								145.9774713270001,
								-43.355560250999986
							],
							[
								145.96875921800006,
								-43.35983724999994
							],
							[
								145.9757952860001,
								-43.36308121099995
							],
							[
								145.970761207,
								-43.36968618999998
							],
							[
								145.95324603200004,
								-43.359374308999975
							],
							[
								145.9463449310001,
								-43.37176624899996
							],
							[
								145.93210282500002,
								-43.36994932799996
							],
							[
								145.92147172500006,
								-43.38128329699998
							],
							[
								145.93426179100004,
								-43.39087118799995
							],
							[
								145.9480659500001,
								-43.38127717899994
							],
							[
								145.9645301060001,
								-43.38259912999996
							],
							[
								145.97637716200006,
								-43.39521299099994
							],
							[
								145.9712420520001,
								-43.403432960999965
							],
							[
								145.9973843260001,
								-43.40693189299998
							],
							[
								146.00093716100002,
								-43.43769271299993
							],
							[
								146.0180361250001,
								-43.45508121399996
							],
							[
								146.0057467260001,
								-43.463882902999956
							],
							[
								146.01485602500009,
								-43.459424103999936
							],
							[
								146.02915924100012,
								-43.46429382499997
							],
							[
								146.02746023800012,
								-43.488191694999955
							],
							[
								146.04282524200005,
								-43.50853457599993
							],
							[
								146.031124276,
								-43.570939555999985
							],
							[
								146.04617589500003,
								-43.55236218699997
							],
							[
								146.0699567700001,
								-43.55648594899998
							],
							[
								146.07945637000012,
								-43.54095956899994
							],
							[
								146.09073533700007,
								-43.54247552999993
							],
							[
								146.09486053500007,
								-43.556609659999936
							],
							[
								146.10988440100004,
								-43.55706152199997
							],
							[
								146.1104410360001,
								-43.52361419099998
							],
							[
								146.1290498620001,
								-43.525865032999945
							],
							[
								146.13649768100004,
								-43.51828288299998
							],
							[
								146.1471586770001,
								-43.52826687399994
							],
							[
								146.14800935100004,
								-43.50147361399996
							],
							[
								146.15913720900005,
								-43.49994749499996
							],
							[
								146.16154740600007,
								-43.51640561499994
							],
							[
								146.17757014300003,
								-43.51136142599995
							],
							[
								146.193096286,
								-43.53997156799994
							],
							[
								146.20962304300008,
								-43.534823348999964
							],
							[
								146.20978671700004,
								-43.50695607899996
							],
							[
								146.22448836600006,
								-43.491124799999966
							],
							[
								146.211039539,
								-43.492161918999955
							],
							[
								146.21601237900006,
								-43.48555183899998
							],
							[
								146.27290954500006,
								-43.49843690299997
							],
							[
								146.26665592200004,
								-43.52862413299994
							],
							[
								146.27644281000005,
								-43.52879398399995
							],
							[
								146.29014173500002,
								-43.544646874999955
							],
							[
								146.31781618000002,
								-43.53623444699997
							],
							[
								146.3257139000001,
								-43.52059524699996
							],
							[
								146.34472951800012,
								-43.51281795899996
							],
							[
								146.36757720200012,
								-43.520222719999936
							],
							[
								146.36872031000007,
								-43.53047575099998
							],
							[
								146.3694091310001,
								-43.51895369099998
							],
							[
								146.37264525800003,
								-43.53502573099996
							],
							[
								146.39154287500003,
								-43.530257491999976
							],
							[
								146.4055697110001,
								-43.539803382999935
							],
							[
								146.45267784200007,
								-43.534419956999955
							],
							[
								146.46932789700008,
								-43.54256765799994
							],
							[
								146.47403876700002,
								-43.53456675799998
							],
							[
								146.48646070300003,
								-43.543843858999935
							],
							[
								146.5087449010001,
								-43.52405345099993
							],
							[
								146.531675575,
								-43.531351332999975
							],
							[
								146.54218020400003,
								-43.52325517299994
							],
							[
								146.59589151000011,
								-43.54354793799996
							],
							[
								146.551415764,
								-43.51037999399995
							],
							[
								146.54868320000003,
								-43.47542067399996
							],
							[
								146.55939378900007,
								-43.46487049399997
							],
							[
								146.57828673200004,
								-43.48512155599997
							],
							[
								146.57519254700003,
								-43.524612925999975
							],
							[
								146.60755340600008,
								-43.550193897999975
							],
							[
								146.5993657570001,
								-43.56191906799995
							],
							[
								146.61004251500003,
								-43.55978794899994
							],
							[
								146.60851871400007,
								-43.56907003899994
							],
							[
								146.62366530100007,
								-43.56236985999993
							],
							[
								146.64496830400003,
								-43.580352810999955
							],
							[
								146.640133514,
								-43.58742289099996
							],
							[
								146.65825097200002,
								-43.57851568199993
							],
							[
								146.65278145000002,
								-43.59616385199996
							],
							[
								146.6601225070001,
								-43.607706872999984
							],
							[
								146.67023008700005,
								-43.59439567299995
							],
							[
								146.6860958730001,
								-43.59668755499996
							],
							[
								146.70537921400012,
								-43.63335960599994
							],
							[
								146.71125100400002,
								-43.626061506999974
							],
							[
								146.72344886000008,
								-43.63191946799998
							],
							[
								146.746122989,
								-43.60997724899994
							],
							[
								146.76236373400002,
								-43.61532921099996
							],
							[
								146.7807092810001,
								-43.609443031999945
							],
							[
								146.78514918200005,
								-43.60027698199997
							],
							[
								146.83128265000005,
								-43.61510370599996
							],
							[
								146.8387148160001,
								-43.63074772599998
							],
							[
								146.8266291870001,
								-43.64307892599993
							],
							[
								146.84481173400002,
								-43.63303869699996
							],
							[
								146.86338038000008,
								-43.63201351799995
							],
							[
								146.87092835800001,
								-43.638624498999945
							],
							[
								146.87361709000004,
								-43.62335436899997
							],
							[
								146.92155505300002,
								-43.59922221299996
							],
							[
								146.91679432800004,
								-43.56877516199995
							],
							[
								146.8725961550001,
								-43.58970275899998
							],
							[
								146.89262998100003,
								-43.582567479999966
							],
							[
								146.8870296450001,
								-43.56601546999997
							],
							[
								146.9037363120001,
								-43.562030300999936
							],
							[
								146.89154823600006,
								-43.55344538999998
							],
							[
								146.877374518,
								-43.55801754899994
							],
							[
								146.8892002660001,
								-43.55317241999995
							],
							[
								146.90078824900002,
								-43.51593718099997
							],
							[
								146.91085308700008,
								-43.51413605099998
							],
							[
								146.9030912190001,
								-43.516871150999975
							],
							[
								146.911376495,
								-43.531846100999985
							],
							[
								146.90367379500003,
								-43.538928220999935
							],
							[
								146.91726175100007,
								-43.54628310199996
							],
							[
								146.92410532200006,
								-43.53028798199995
							],
							[
								146.92143856200005,
								-43.53928904199995
							],
							[
								146.9528299760001,
								-43.53297469499995
							],
							[
								146.95416244900002,
								-43.511796654999955
							],
							[
								146.9778882060001,
								-43.49400354599993
							],
							[
								146.97675415700007,
								-43.487578515999985
							],
							[
								146.94370863100005,
								-43.512011703999974
							],
							[
								146.9437902830001,
								-43.49812902399998
							],
							[
								146.9289966560001,
								-43.496661492999976
							],
							[
								146.94203299600008,
								-43.478107972999965
							],
							[
								146.97255002100007,
								-43.46862455599995
							],
							[
								146.98258991800003,
								-43.47501542699996
							],
							[
								146.98078207700007,
								-43.487243476999936
							],
							[
								147.00179866300005,
								-43.47963923799995
							],
							[
								146.9964505370001,
								-43.46185922799998
							],
							[
								146.98322867100012,
								-43.454693376999955
							],
							[
								146.96998191300008,
								-43.45562355599998
							],
							[
								146.95968909700002,
								-43.44768964499997
							],
							[
								146.94867241800011,
								-43.453084813999965
							],
							[
								146.93710969100005,
								-43.447441872999946
							],
							[
								146.9461624600001,
								-43.446002773999965
							],
							[
								146.94180049200008,
								-43.43994674299995
							],
							[
								146.9156401460001,
								-43.44705400099997
							],
							[
								146.92064093600004,
								-43.43815888199998
							],
							[
								146.90760602000012,
								-43.43237996099998
							],
							[
								146.90587873200002,
								-43.42078591999996
							],
							[
								146.90829595000002,
								-43.43214294099994
							],
							[
								146.92363590500008,
								-43.439823881999985
							],
							[
								146.92364335900004,
								-43.41556977199997
							],
							[
								146.94760830100006,
								-43.43432666399997
							],
							[
								146.95055734900006,
								-43.447366743999964
							],
							[
								146.97302667600002,
								-43.43189236599994
							],
							[
								146.98691353200002,
								-43.44078622699993
							],
							[
								147.00307106000002,
								-43.43397899799993
							],
							[
								147.0176288250001,
								-43.44344193899997
							],
							[
								147.02643653400003,
								-43.43580376999995
							],
							[
								147.0124465990001,
								-43.42205689899998
							],
							[
								147.02545019800004,
								-43.411420729999975
							],
							[
								147.01666625100006,
								-43.40326381899996
							],
							[
								147.0460163780001,
								-43.37998825099993
							],
							[
								147.05931047900003,
								-43.35304985199997
							],
							[
								147.03271581600006,
								-43.34793714999995
							],
							[
								147.01932404100012,
								-43.333883198999956
							],
							[
								147.00771745200007,
								-43.34347142799993
							],
							[
								146.98544259800008,
								-43.333180625999944
							],
							[
								146.97881576800012,
								-43.33945174599995
							],
							[
								146.98259048900002,
								-43.32970861599995
							],
							[
								146.9716994810001,
								-43.32742071499996
							],
							[
								147.00416435400007,
								-43.33548438799994
							],
							[
								147.00262106600007,
								-43.32272429699998
							],
							[
								147.01192064500003,
								-43.31582009799996
							],
							[
								147.04504664800004,
								-43.31228952099997
							],
							[
								147.06533466100007,
								-43.33280051199995
							],
							[
								147.08057757400002,
								-43.29241384299996
							],
							[
								147.10013817000004,
								-43.29020450499996
							],
							[
								147.09761905200003,
								-43.28017546399997
							],
							[
								147.06800906,
								-43.263624841999956
							],
							[
								147.0645485330001,
								-43.249088711999946
							],
							[
								147.03707981000002,
								-43.24381291999998
							],
							[
								147.00170533100004,
								-43.21449925699994
							],
							[
								146.9903225930001,
								-43.21713937599998
							],
							[
								146.99539525400007,
								-43.206452325999976
							],
							[
								146.97190042900002,
								-43.20398659399996
							],
							[
								146.96415809300004,
								-43.19028859399998
							],
							[
								146.97445922400004,
								-43.16930432399994
							],
							[
								146.96215898800006,
								-43.15791143299998
							],
							[
								146.94997430000012,
								-43.16382697199998
							],
							[
								146.95954098900006,
								-43.15611647299994
							],
							[
								146.98069481400012,
								-43.15890421499995
							],
							[
								146.9724551280001,
								-43.13857125399994
							],
							[
								146.99301243600007,
								-43.12864219599993
							],
							[
								146.9913520870001,
								-43.11872218499997
							],
							[
								147.0296915780001,
								-43.05863962799998
							],
							[
								147.05468874500002,
								-43.03998237999997
							],
							[
								147.03568090200008,
								-43.025023457999964
							],
							[
								147.03302370400002,
								-43.01140233799998
							],
							[
								147.0016678400001,
								-43.01736499599997
							],
							[
								147.03404570400005,
								-43.010878307999974
							],
							[
								147.03478184300002,
								-43.01911644799998
							],
							[
								147.0413708110001,
								-43.01773475899995
							],
							[
								147.03651088100003,
								-43.02464842799998
							],
							[
								147.056265735,
								-43.03967632999996
							],
							[
								147.04509402700012,
								-43.04555155899993
							],
							[
								147.04093445400008,
								-43.06974962899994
							],
							[
								147.02180922500008,
								-43.091946417999964
							],
							[
								146.9844137990001,
								-43.18941945499995
							],
							[
								147.01035255300008,
								-43.19028212699993
							],
							[
								147.0277759270001,
								-43.20963395899997
							],
							[
								147.06193017700002,
								-43.225087420999955
							],
							[
								147.0833272760001,
								-43.20668815299996
							],
							[
								147.07181229900004,
								-43.20231936199997
							],
							[
								147.08648277700001,
								-43.19281496299993
							],
							[
								147.08251475200007,
								-43.16293687299998
							],
							[
								147.096414868,
								-43.17167659399996
							],
							[
								147.0930472970001,
								-43.18147372399994
							],
							[
								147.10902323300002,
								-43.185278324999956
							],
							[
								147.09444951600005,
								-43.18802874399995
							],
							[
								147.10562581200008,
								-43.19845145499994
							],
							[
								147.10198903200012,
								-43.20677666399996
							],
							[
								147.117829808,
								-43.210587345999954
							],
							[
								147.09245048200012,
								-43.218551023999964
							],
							[
								147.09930189800002,
								-43.23790699399996
							],
							[
								147.08957420900003,
								-43.24447623399993
							],
							[
								147.1028751650001,
								-43.252013104999946
							],
							[
								147.12312317200008,
								-43.24281767599996
							],
							[
								147.14397401700012,
								-43.249981487999946
							],
							[
								147.1511700960001,
								-43.24111168799993
							],
							[
								147.14364770300006,
								-43.27253270799997
							],
							[
								147.1677541570001,
								-43.283373439999934
							],
							[
								147.18900127300003,
								-43.27623614099997
							],
							[
								147.21948979600006,
								-43.28102285399996
							],
							[
								147.24250720300006,
								-43.26810437599994
							],
							[
								147.24045287500007,
								-43.25659125499993
							],
							[
								147.2609786160001,
								-43.22350368699995
							],
							[
								147.25544233200003,
								-43.18835518599997
							],
							[
								147.24092625600008,
								-43.18194217499996
							],
							[
								147.24841152700003,
								-43.16627796499995
							],
							[
								147.23858920100008,
								-43.15443469499996
							],
							[
								147.24799392900002,
								-43.15171358499998
							],
							[
								147.2416330110001,
								-43.14866349499994
							],
							[
								147.256251689,
								-43.138563045999945
							],
							[
								147.25276565100012,
								-43.13231896599996
							],
							[
								147.2627746390001,
								-43.13081887599998
							],
							[
								147.24638965400004,
								-43.122298884999964
							],
							[
								147.26939256900005,
								-43.12193065699995
							],
							[
								147.27149625000004,
								-43.11478656699995
							],
							[
								147.2576761140001,
								-43.10649960599994
							],
							[
								147.2742917800001,
								-43.10443838699996
							],
							[
								147.2852949270001,
								-43.11097830799997
							],
							[
								147.3012379370001,
								-43.087894938999966
							],
							[
								147.27904156400007,
								-43.07490596699995
							],
							[
								147.2556455890001,
								-43.07315057599993
							],
							[
								147.27992082100002,
								-43.02675466699998
							],
							[
								147.26570031400001,
								-43.024737785999946
							],
							[
								147.28493895200006,
								-43.008292076999965
							],
							[
								147.31409783900006,
								-43.05948350999995
							],
							[
								147.33344681500012,
								-43.05862627199997
							],
							[
								147.34515360400007,
								-43.04911401199996
							],
							[
								147.324154474,
								-43.00615233099995
							],
							[
								147.3295589170001,
								-42.977801100999955
							],
							[
								147.3160733410001,
								-42.97366827999997
							],
							[
								147.2970117760001,
								-42.96517919799993
							],
							[
								147.26579190100006,
								-42.97338829599994
							],
							[
								147.2483568460001,
								-42.96670603399997
							],
							[
								147.257106872,
								-42.981158034999964
							],
							[
								147.23495984400006,
								-42.99716303399998
							],
							[
								147.21793588900005,
								-42.98722403199997
							],
							[
								147.2204668700001,
								-42.97762403199994
							],
							[
								147.18149385700008,
								-42.985667028999956
							],
							[
								147.16107386400006,
								-42.96719601799998
							],
							[
								147.17684288100008,
								-42.96122902899998
							],
							[
								147.1672368840001,
								-42.95771802799993
							],
							[
								147.1742589040001,
								-42.94535702899998
							],
							[
								147.15154266000002,
								-42.93912041699997
							],
							[
								147.15730112100005,
								-42.91967708699997
							],
							[
								147.15037280400009,
								-42.91333759699995
							],
							[
								147.0512756160001,
								-42.90037143899997
							],
							[
								147.03978381700006,
								-42.91007855799995
							],
							[
								147.03302003900012,
								-42.90410634699998
							],
							[
								147.01651620200005,
								-42.907034635999935
							],
							[
								147.00582622600007,
								-42.900111624999965
							],
							[
								147.008884017,
								-42.88779744499993
							],
							[
								146.97087759400006,
								-42.88879287299994
							],
							[
								146.9523727190001,
								-42.88205987099997
							],
							[
								146.92389451300005,
								-42.89929411899993
							],
							[
								146.9412786150001,
								-42.92662133999994
							],
							[
								146.91194024900005,
								-42.94009647799993
							],
							[
								146.88056682700005,
								-42.93435439599995
							],
							[
								146.87389736500006,
								-42.95461732499996
							],
							[
								146.85581939100007,
								-42.94038148399994
							],
							[
								146.84506777800004,
								-42.90707547299996
							],
							[
								146.8090038570001,
								-42.89370201999998
							],
							[
								146.78849662000005,
								-42.90384201899997
							],
							[
								146.76498935900008,
								-42.87378606699997
							],
							[
								146.73943603500004,
								-42.871182224999984
							],
							[
								146.72086003000004,
								-42.857526132999965
							],
							[
								146.6985274650001,
								-42.85805940199998
							],
							[
								146.69725639600006,
								-42.85035235199996
							],
							[
								146.6565752150001,
								-42.84762082799995
							],
							[
								146.64630769500002,
								-42.86067906799997
							],
							[
								146.6586264770001,
								-42.89975918899995
							],
							[
								146.64841129600006,
								-42.92169147799996
							],
							[
								146.45881271300004,
								-43.08726374499997
							],
							[
								146.22219654800006,
								-43.11879125699994
							],
							[
								146.0890750950001,
								-43.053890346999935
							],
							[
								145.97814626000002,
								-43.03915843899995
							],
							[
								145.974506108,
								-43.06130890899993
							],
							[
								145.9820095550001,
								-43.07238903999996
							],
							[
								145.97170038600007,
								-43.07660946899995
							],
							[
								145.99270580900009,
								-43.10063307099995
							],
							[
								145.98267074600005,
								-43.13484052999996
							],
							[
								145.96038911200003,
								-43.12822418799993
							],
							[
								145.9404588330001,
								-43.150426256999936
							]
						]
					],
					[
						[
							[
								146.52026954100006,
								-43.57524385199997
							],
							[
								146.51515378200008,
								-43.58206096199996
							],
							[
								146.53421809000008,
								-43.56348962299995
							],
							[
								146.52026954100006,
								-43.57524385199997
							]
						]
					],
					[
						[
							[
								146.3452602970001,
								-43.588330388999964
							],
							[
								146.33678546800002,
								-43.59185652799994
							],
							[
								146.344601505,
								-43.60559652899997
							],
							[
								146.37643190900008,
								-43.59861608099993
							],
							[
								146.37585878100003,
								-43.586998000999984
							],
							[
								146.3452602970001,
								-43.588330388999964
							]
						]
					],
					[
						[
							[
								147.09640884400005,
								-43.40371047499997
							],
							[
								147.10097484200003,
								-43.40938845499994
							],
							[
								147.1004225360001,
								-43.38918338499997
							],
							[
								147.09640884400005,
								-43.40371047499997
							]
						]
					],
					[
						[
							[
								147.2812230500001,
								-43.16792365799995
							],
							[
								147.30095906600002,
								-43.16844936999996
							],
							[
								147.29949337400012,
								-43.18085258999997
							],
							[
								147.33648053800005,
								-43.16942199199997
							],
							[
								147.34360357600008,
								-43.17364194299995
							],
							[
								147.33179404700002,
								-43.18528432199997
							],
							[
								147.3549598620001,
								-43.186556903999985
							],
							[
								147.36438441100006,
								-43.17585568499993
							],
							[
								147.3839761060001,
								-43.18234748599997
							],
							[
								147.37648203300012,
								-43.21439394599997
							],
							[
								147.36427216700008,
								-43.208598044999974
							],
							[
								147.3411617600001,
								-43.21906952299997
							],
							[
								147.3561237250001,
								-43.230037393999964
							],
							[
								147.3483690060001,
								-43.23704860399994
							],
							[
								147.3584500820001,
								-43.246661604999986
							],
							[
								147.35490145100005,
								-43.26140484399997
							],
							[
								147.3288269420001,
								-43.28840260199996
							],
							[
								147.30581979600004,
								-43.29700304099998
							],
							[
								147.2917693070001,
								-43.240989558999956
							],
							[
								147.2861090350001,
								-43.26592485899994
							],
							[
								147.27160181600004,
								-43.27602816799998
							],
							[
								147.27108453300002,
								-43.29550637799997
							],
							[
								147.2467851770001,
								-43.30431375599994
							],
							[
								147.240421695,
								-43.32915311599993
							],
							[
								147.22234123700002,
								-43.339833443999964
							],
							[
								147.23426742100003,
								-43.36449457499998
							],
							[
								147.21802974500008,
								-43.36232074399993
							],
							[
								147.2191669020001,
								-43.376410903999954
							],
							[
								147.20525131400007,
								-43.38273609299995
							],
							[
								147.1956141500001,
								-43.36125402199997
							],
							[
								147.18518731200004,
								-43.35768712199996
							],
							[
								147.18857910300005,
								-43.349091011999974
							],
							[
								147.17910137400008,
								-43.35254218099993
							],
							[
								147.18585879800003,
								-43.38764438199996
							],
							[
								147.1678915980001,
								-43.40872479099994
							],
							[
								147.1742816850001,
								-43.42350082099995
							],
							[
								147.18487741400008,
								-43.41808069199993
							],
							[
								147.19242152000004,
								-43.42874368299994
							],
							[
								147.17427299300005,
								-43.43779591099997
							],
							[
								147.18038105100004,
								-43.443251921999945
							],
							[
								147.171420301,
								-43.45171206099997
							],
							[
								147.17967232900003,
								-43.458420011999976
							],
							[
								147.1593650420001,
								-43.46378937999998
							],
							[
								147.11589863900008,
								-43.41136433699995
							],
							[
								147.0998789020001,
								-43.411361504999945
							],
							[
								147.09174027300003,
								-43.41972468499995
							],
							[
								147.09791344000007,
								-43.433009734999985
							],
							[
								147.11461430600002,
								-43.43728061699994
							],
							[
								147.13565439800004,
								-43.45808957799994
							],
							[
								147.13355425400005,
								-43.486879887999976
							],
							[
								147.1391880230001,
								-43.48438179899995
							],
							[
								147.13745230300003,
								-43.493330878999984
							],
							[
								147.14641528000004,
								-43.49677781899993
							],
							[
								147.1554607800001,
								-43.48379358999995
							],
							[
								147.18284216400002,
								-43.488850241999955
							],
							[
								147.17956165700002,
								-43.47124316199995
							],
							[
								147.20352383400007,
								-43.45318468399995
							],
							[
								147.20286311000007,
								-43.41808648299997
							],
							[
								147.22726346500008,
								-43.41255714499994
							],
							[
								147.23618352300002,
								-43.41953508599994
							],
							[
								147.241718342,
								-43.413891975999945
							],
							[
								147.2403756110001,
								-43.426667075999944
							],
							[
								147.22590993300003,
								-43.43389634499994
							],
							[
								147.2045822980001,
								-43.42982156299996
							],
							[
								147.201504547,
								-43.43700365299998
							],
							[
								147.24586889700004,
								-43.440383106999946
							],
							[
								147.25580116300011,
								-43.457708097999955
							],
							[
								147.2403825450001,
								-43.46589037599995
							],
							[
								147.24636306000002,
								-43.49252158699994
							],
							[
								147.26315072700004,
								-43.487874327999975
							],
							[
								147.2717772730001,
								-43.50055084899998
							],
							[
								147.29102090800006,
								-43.505031660999975
							],
							[
								147.29472401600003,
								-43.516151710999964
							],
							[
								147.3239261320001,
								-43.50263019299996
							],
							[
								147.32087944700004,
								-43.46909646299997
							],
							[
								147.33128767900007,
								-43.44161205299997
							],
							[
								147.34445541700006,
								-43.43760985399996
							],
							[
								147.34628216800002,
								-43.42914675499998
							],
							[
								147.33791714100005,
								-43.42323979399998
							],
							[
								147.36450191000006,
								-43.39210808599995
							],
							[
								147.37894583700006,
								-43.39028095699996
							],
							[
								147.3814905380001,
								-43.378283816999954
							],
							[
								147.38138327000001,
								-43.364773696999976
							],
							[
								147.36769705500012,
								-43.35042076599996
							],
							[
								147.34864766600003,
								-43.368517123999936
							],
							[
								147.3344358490001,
								-43.36772233299996
							],
							[
								147.32704671200008,
								-43.35855639299996
							],
							[
								147.32382629200004,
								-43.30069483199998
							],
							[
								147.36863503900008,
								-43.25650760499997
							],
							[
								147.40969100200005,
								-43.24080791799997
							],
							[
								147.4262350570001,
								-43.25347081999996
							],
							[
								147.43291163800006,
								-43.23951553999996
							],
							[
								147.42668080400006,
								-43.20623925999996
							],
							[
								147.4107758980001,
								-43.20053442799997
							],
							[
								147.40912409300006,
								-43.16887911799995
							],
							[
								147.39247447700006,
								-43.16241823699994
							],
							[
								147.4007183010001,
								-43.12708173699997
							],
							[
								147.38960343400004,
								-43.121049735999975
							],
							[
								147.38798754700008,
								-43.10264943599998
							],
							[
								147.36267640500012,
								-43.08690143399997
							],
							[
								147.3676358460001,
								-43.07181113399997
							],
							[
								147.35706081900003,
								-43.06353312299996
							],
							[
								147.33711145100006,
								-43.082819531999974
							],
							[
								147.32252466300008,
								-43.08441969099994
							],
							[
								147.31713759100012,
								-43.10941397099998
							],
							[
								147.306636872,
								-43.113369139999975
							],
							[
								147.31474100000003,
								-43.11892118999998
							],
							[
								147.33008668700006,
								-43.11486801199993
							],
							[
								147.32263528700003,
								-43.12647228099996
							],
							[
								147.32841331500003,
								-43.130985341999974
							],
							[
								147.33838182500006,
								-43.11941209199995
							],
							[
								147.35323214100003,
								-43.128048202999935
							],
							[
								147.36116257100002,
								-43.11356193399996
							],
							[
								147.35591247800005,
								-43.14074531399996
							],
							[
								147.35286922000012,
								-43.131165212999974
							],
							[
								147.3372224730001,
								-43.13654337199995
							],
							[
								147.3294010720001,
								-43.15227068199994
							],
							[
								147.30963475800002,
								-43.13987167999994
							],
							[
								147.31190556800004,
								-43.13436354999993
							],
							[
								147.2823060830001,
								-43.14422907799997
							],
							[
								147.29616464800006,
								-43.15665619899994
							],
							[
								147.2830856810001,
								-43.15843641799995
							],
							[
								147.2812230500001,
								-43.16792365799995
							]
						]
					],
					[
						[
							[
								147.13798031200008,
								-43.290242887999966
							],
							[
								147.14454023000008,
								-43.294253837999975
							],
							[
								147.14808686100002,
								-43.28510569799994
							],
							[
								147.13798031200008,
								-43.290242887999966
							]
						]
					],
					[
						[
							[
								147.127714759,
								-43.257333846999984
							],
							[
								147.13028490700003,
								-43.26482884699993
							],
							[
								147.13419934800004,
								-43.25279868699994
							],
							[
								147.127714759,
								-43.257333846999984
							]
						]
					],
					[
						[
							[
								147.02295802600008,
								-43.07882885799995
							],
							[
								147.01581632600005,
								-43.08982544699995
							],
							[
								147.0293378550001,
								-43.07635076799994
							],
							[
								147.02295802600008,
								-43.07882885799995
							]
						]
					],
					[
						[
							[
								147.0039899940001,
								-43.12300110599995
							],
							[
								147.00308340300012,
								-43.13155309599995
							],
							[
								147.00794662500005,
								-43.11272709699995
							],
							[
								147.0039899940001,
								-43.12300110599995
							]
						]
					],
					[
						[
							[
								147.00110787500012,
								-43.11741413599998
							],
							[
								147.01858437400006,
								-43.10442584699996
							],
							[
								147.01925626600007,
								-43.09036238699997
							],
							[
								147.00110787500012,
								-43.11741413599998
							]
						]
					],
					[
						[
							[
								147.29257073200006,
								-42.79087041699995
							],
							[
								147.28333557200006,
								-42.80278234599996
							],
							[
								147.31993941300004,
								-42.816662178999934
							],
							[
								147.31737769200004,
								-42.82489019899998
							],
							[
								147.33505748700009,
								-42.83369299999998
							],
							[
								147.33378162600002,
								-42.84106806999995
							],
							[
								147.34705229400004,
								-42.83518682099998
							],
							[
								147.33780155500006,
								-42.84502507099995
							],
							[
								147.34427946300002,
								-42.850819040999966
							],
							[
								147.35861425000007,
								-42.848640871999976
							],
							[
								147.35240690700005,
								-42.87576426199996
							],
							[
								147.365668636,
								-42.87014616299996
							],
							[
								147.36655076400007,
								-42.88254112299995
							],
							[
								147.40469588500002,
								-42.88427837599994
							],
							[
								147.4173318490001,
								-42.90883902699994
							],
							[
								147.40898068700005,
								-42.938833116999945
							],
							[
								147.42140557400012,
								-42.93973504799993
							],
							[
								147.4350740960001,
								-42.90866357899995
							],
							[
								147.48427356500008,
								-42.91037538299997
							],
							[
								147.49142862100007,
								-42.92713342299993
							],
							[
								147.476995686,
								-42.91857738199997
							],
							[
								147.46475592700006,
								-42.923437530999934
							],
							[
								147.44606463500008,
								-42.96451407999996
							],
							[
								147.4453837630001,
								-42.97837814999997
							],
							[
								147.4653364500001,
								-42.970157890999985
							],
							[
								147.4784865160001,
								-42.98209485299998
							],
							[
								147.46883383500005,
								-42.99927606199998
							],
							[
								147.46934629100008,
								-43.02632410199993
							],
							[
								147.45223053400002,
								-43.032621260999974
							],
							[
								147.43009671900006,
								-43.02755843899996
							],
							[
								147.41787408800008,
								-42.98435935799995
							],
							[
								147.40376209200008,
								-42.97756541699994
							],
							[
								147.40870386300003,
								-42.96281420699995
							],
							[
								147.3918671450001,
								-42.97593752599994
							],
							[
								147.40407519100006,
								-42.98452646699997
							],
							[
								147.3970406190001,
								-43.006669655999985
							],
							[
								147.4154797530001,
								-43.02036951799994
							],
							[
								147.4041302930001,
								-43.03693164699996
							],
							[
								147.41883737800003,
								-43.05048055799995
							],
							[
								147.44121279600006,
								-43.03693535999997
							],
							[
								147.52137506100007,
								-43.020818615999985
							],
							[
								147.5288048220001,
								-43.00602334699994
							],
							[
								147.5237515450001,
								-42.99271126599996
							],
							[
								147.5540596400001,
								-42.98569978799998
							],
							[
								147.54180575600003,
								-42.95930479699996
							],
							[
								147.52766419900001,
								-42.961996015999944
							],
							[
								147.53920568400008,
								-42.97489693699998
							],
							[
								147.52867221500003,
								-42.98516112599998
							],
							[
								147.509150932,
								-42.96730238499998
							],
							[
								147.51820256000008,
								-42.96348922599998
							],
							[
								147.51646538300008,
								-42.95211623499995
							],
							[
								147.53867296700002,
								-42.96163084699998
							],
							[
								147.53051164300007,
								-42.931298985999945
							],
							[
								147.49497244300005,
								-42.91127038299993
							],
							[
								147.51108204500008,
								-42.87605740499998
							],
							[
								147.5036317480001,
								-42.864277123999955
							],
							[
								147.52916550500004,
								-42.847288875999936
							],
							[
								147.56456600900003,
								-42.837855838999985
							],
							[
								147.61338802800003,
								-42.84597253199996
							],
							[
								147.5785825480001,
								-42.825100919999954
							],
							[
								147.522247299,
								-42.82796552499997
							],
							[
								147.51315912400003,
								-42.81131047399998
							],
							[
								147.4912015660001,
								-42.82793994299993
							],
							[
								147.48119064800005,
								-42.82676606199993
							],
							[
								147.47170368100012,
								-42.82070213099996
							],
							[
								147.477553531,
								-42.81288296199995
							],
							[
								147.489820408,
								-42.81501982299994
							],
							[
								147.4854124200001,
								-42.807931801999985
							],
							[
								147.45934872500004,
								-42.809119169999974
							],
							[
								147.4341323750001,
								-42.775527257999954
							],
							[
								147.42550684700007,
								-42.77533505699995
							],
							[
								147.41777026700004,
								-42.78830673699997
							],
							[
								147.39217720400006,
								-42.77250200499998
							],
							[
								147.377408467,
								-42.773599012999966
							],
							[
								147.3812031970001,
								-42.76836701399998
							],
							[
								147.36853054100004,
								-42.76120140299997
							],
							[
								147.34758425300004,
								-42.77743374099998
							],
							[
								147.33259089700005,
								-42.766628039999944
							],
							[
								147.32597289700004,
								-42.78089658899995
							],
							[
								147.30630802000007,
								-42.786901987999954
							],
							[
								147.30733826800008,
								-42.79806506799997
							],
							[
								147.29257073200006,
								-42.79087041699995
							]
						]
					],
					[
						[
							[
								147.49038758200004,
								-43.05730410399997
							],
							[
								147.48484878500005,
								-43.044833052999934
							],
							[
								147.47268454800007,
								-43.045248061999985
							],
							[
								147.48788467200006,
								-43.06535616399998
							],
							[
								147.49038758200004,
								-43.05730410399997
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "604",
				"CED_NAME21": "Franklin",
				"STE_CODE21": "6",
				"STE_NAME21": "Tasmania",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 6404.9117,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/604",
				"SHAPE_Leng": 19.9668435512,
				"SHAPE_Area": 0.709720734704
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								147.4341323750001,
								-42.775527257999954
							],
							[
								147.44513147200007,
								-42.78329617899993
							],
							[
								147.448447202,
								-42.775921118999975
							],
							[
								147.45898311000008,
								-42.77693204999997
							],
							[
								147.44892951500003,
								-42.756075058999954
							],
							[
								147.45400389200006,
								-42.76806904899996
							],
							[
								147.46781172900012,
								-42.768879950999974
							],
							[
								147.45288531000006,
								-42.78128310899996
							],
							[
								147.46634836600003,
								-42.792316040999935
							],
							[
								147.48727538000003,
								-42.803093771999954
							],
							[
								147.5166225470001,
								-42.78331257399998
							],
							[
								147.52783205200012,
								-42.805169314999944
							],
							[
								147.53972696000005,
								-42.80115732599995
							],
							[
								147.5302898530001,
								-42.790579485999956
							],
							[
								147.5343584750001,
								-42.77524282599995
							],
							[
								147.55484784700002,
								-42.79592304799996
							],
							[
								147.56550672600008,
								-42.788365057999954
							],
							[
								147.5651447560001,
								-42.79425149799994
							],
							[
								147.59185402900005,
								-42.801074159999985
							],
							[
								147.59519779100003,
								-42.78450853099997
							],
							[
								147.58538991400007,
								-42.77824872999997
							],
							[
								147.59418762100006,
								-42.78155949099994
							],
							[
								147.60334830700003,
								-42.79810374099998
							],
							[
								147.59673458600003,
								-42.81334143099997
							],
							[
								147.62124676700012,
								-42.84249532299998
							],
							[
								147.6059781660001,
								-42.86921247199996
							],
							[
								147.65333584500002,
								-42.87875719599998
							],
							[
								147.68413538100003,
								-42.86269385799994
							],
							[
								147.70095526600005,
								-42.87158813999997
							],
							[
								147.6842023910001,
								-42.86436384799998
							],
							[
								147.6801913700001,
								-42.87273783799998
							],
							[
								147.65613174400005,
								-42.881982095999945
							],
							[
								147.6419031380001,
								-42.87776352499998
							],
							[
								147.64185900600012,
								-42.890001404999964
							],
							[
								147.64947677400005,
								-42.89312213599993
							],
							[
								147.6595446330001,
								-42.886592005999944
							],
							[
								147.6690744880001,
								-42.90188278699998
							],
							[
								147.6802754260001,
								-42.90360957799993
							],
							[
								147.68950120600005,
								-42.89223346899996
							],
							[
								147.70423807200007,
								-42.89445120999994
							],
							[
								147.72199890000002,
								-42.886544940999954
							],
							[
								147.72832609700004,
								-42.89884200199998
							],
							[
								147.74244710400012,
								-42.89499765299996
							],
							[
								147.7669322480001,
								-42.90683345499997
							],
							[
								147.7708952380001,
								-42.899186294999936
							],
							[
								147.79024775300002,
								-42.90316307699993
							],
							[
								147.79144776500004,
								-42.89260708699993
							],
							[
								147.8147869500001,
								-42.88851699899993
							],
							[
								147.8324429500001,
								-42.86572617999997
							],
							[
								147.84276302600006,
								-42.87633639099994
							],
							[
								147.83511968000005,
								-42.860927119999985
							],
							[
								147.84316033900006,
								-42.85988014099996
							],
							[
								147.8440429410001,
								-42.84576194099998
							],
							[
								147.85554671800003,
								-42.84911710199998
							],
							[
								147.8645624410001,
								-42.81464361199994
							],
							[
								147.87048109700004,
								-42.83685695299994
							],
							[
								147.8841028930001,
								-42.84550685399995
							],
							[
								147.86902022100003,
								-42.80818067299998
							],
							[
								147.8823945150001,
								-42.763819232999936
							],
							[
								147.90000591400008,
								-42.74384119499996
							],
							[
								147.94655672700003,
								-42.72799699799998
							],
							[
								147.93876745300008,
								-42.70067864799995
							],
							[
								147.96216742100012,
								-42.679579468999975
							],
							[
								147.96299714300005,
								-42.669529308999984
							],
							[
								147.95348856600003,
								-42.66105739899996
							],
							[
								147.95706052600008,
								-42.65316930899996
							],
							[
								147.93992976900006,
								-42.654497667999976
							],
							[
								147.92975510300005,
								-42.64488794699997
							],
							[
								147.95771653600002,
								-42.65257529899998
							],
							[
								147.9316168250001,
								-42.63154606699993
							],
							[
								147.945506345,
								-42.60630564799993
							],
							[
								147.91726474400002,
								-42.589999804999934
							],
							[
								147.90250761000004,
								-42.565943543999936
							],
							[
								147.88181197400002,
								-42.56692767199996
							],
							[
								147.87898603700012,
								-42.55414171199993
							],
							[
								147.85075628200002,
								-42.558604799999955
							],
							[
								147.87161515800005,
								-42.55722671099994
							],
							[
								147.88845084600007,
								-42.545246592999945
							],
							[
								147.91337505,
								-42.54849930499995
							],
							[
								147.91328694300012,
								-42.53063785499995
							],
							[
								147.89731151700005,
								-42.52401586299993
							],
							[
								147.90941922600007,
								-42.51454949399994
							],
							[
								147.90518620800003,
								-42.50613347399997
							],
							[
								147.91429197600007,
								-42.51118216499998
							],
							[
								147.9237376960001,
								-42.49677310499993
							],
							[
								147.91421305500012,
								-42.51627548499994
							],
							[
								147.93036281000002,
								-42.53079008599997
							],
							[
								147.9323567660001,
								-42.55010898599994
							],
							[
								147.9408187350001,
								-42.54690980699996
							],
							[
								147.9489747330001,
								-42.553216747999954
							],
							[
								147.9687325530001,
								-42.52031875899996
							],
							[
								147.98324546100002,
								-42.51598549999994
							],
							[
								147.99482814700002,
								-42.526524510999934
							],
							[
								147.99585525800012,
								-42.51777438099998
							],
							[
								148.01103691600008,
								-42.509536071999946
							],
							[
								147.99704680000002,
								-42.50155610099995
							],
							[
								147.99440665300006,
								-42.48993996099995
							],
							[
								147.9885280730001,
								-42.49833218099997
							],
							[
								148.01025776400002,
								-42.46233352199994
							],
							[
								148.00987677700004,
								-42.44026709199994
							],
							[
								147.9769606430001,
								-42.44102568899996
							],
							[
								147.9975072200001,
								-42.438556440999946
							],
							[
								147.98050775800004,
								-42.40533831899995
							],
							[
								148.02687016700008,
								-42.34962742299996
							],
							[
								148.01848977400005,
								-42.31499409199995
							],
							[
								147.99032473900002,
								-42.31496011999997
							],
							[
								147.97574798900007,
								-42.333867048999934
							],
							[
								147.985855667,
								-42.337231068999984
							],
							[
								147.96014376100004,
								-42.34142704699997
							],
							[
								147.96204274900003,
								-42.35732509799993
							],
							[
								147.95498675200008,
								-42.34388908699998
							],
							[
								147.94387392400006,
								-42.34957807599994
							],
							[
								147.93109465700002,
								-42.34357508499994
							],
							[
								147.93579483700012,
								-42.336646094999935
							],
							[
								147.94369150400007,
								-42.34315979599995
							],
							[
								147.93897124700004,
								-42.33278954599996
							],
							[
								147.9440691650001,
								-42.34236447599994
							],
							[
								147.94474897500004,
								-42.33608841599994
							],
							[
								147.9589967930001,
								-42.33498619699998
							],
							[
								147.95366479400002,
								-42.33249021699993
							],
							[
								147.97044162100008,
								-42.33294807799996
							],
							[
								147.9775642630001,
								-42.30738638899993
							],
							[
								148.0003512080001,
								-42.309920569999974
							],
							[
								148.01561952800012,
								-42.28545497199997
							],
							[
								148.01481211100008,
								-42.26822429099997
							],
							[
								148.0281557400001,
								-42.260597461999964
							],
							[
								148.01317136400007,
								-42.24944925099993
							],
							[
								148.01358827600006,
								-42.23933730099998
							],
							[
								148.08388712200008,
								-42.167901995999955
							],
							[
								148.071294297,
								-42.15417751499996
							],
							[
								148.08509673800006,
								-42.12549831599995
							],
							[
								148.0700388130001,
								-42.11206259499994
							],
							[
								148.04667111700007,
								-42.118404762999944
							],
							[
								148.12393729500002,
								-42.092412508999985
							],
							[
								148.23507463200008,
								-42.09810117799998
							],
							[
								148.2077067900001,
								-42.08425190599996
							],
							[
								148.16751299800012,
								-42.08495031299998
							],
							[
								148.15073410200011,
								-42.07447672099994
							],
							[
								148.095335212,
								-42.08254249699996
							],
							[
								148.07352869900012,
								-42.06523230499994
							],
							[
								148.0639652210001,
								-42.068353513999966
							],
							[
								148.0795522190001,
								-42.060901015999946
							],
							[
								148.07622663000006,
								-42.05381664499998
							],
							[
								148.07580125800007,
								-42.072212744999945
							],
							[
								148.10332601100004,
								-42.08178432799997
							],
							[
								148.12725160700006,
								-42.07371531899997
							],
							[
								148.1146507200001,
								-42.073621077999974
							],
							[
								148.12953274900008,
								-42.06109870999995
							],
							[
								148.15280562400005,
								-42.06206809099996
							],
							[
								148.16502914300008,
								-42.05174207199997
							],
							[
								148.1573308950001,
								-42.048955141999954
							],
							[
								148.16236296500006,
								-42.038655081999934
							],
							[
								148.14736066900002,
								-42.03403907099994
							],
							[
								148.15071373700005,
								-42.044652060999965
							],
							[
								148.14284090700005,
								-42.051588100999936
							],
							[
								148.13326867000012,
								-42.04393593999998
							],
							[
								148.14605220800001,
								-42.04152445099993
							],
							[
								148.14431405200003,
								-42.017049690999954
							],
							[
								148.16586660100006,
								-41.996273601999974
							],
							[
								148.17360992700003,
								-42.00911365299993
							],
							[
								148.19740880100005,
								-42.020790244999944
							],
							[
								148.21754957000007,
								-42.00296938599996
							],
							[
								148.21521168300012,
								-41.985362135999935
							],
							[
								148.22217591100002,
								-41.99025004699996
							],
							[
								148.2370163380001,
								-41.98477555799997
							],
							[
								148.245684535,
								-41.995507488999976
							],
							[
								148.21408093500008,
								-42.03582207599993
							],
							[
								148.17246671300006,
								-42.04356208299998
							],
							[
								148.17460477100008,
								-42.05433407299995
							],
							[
								148.1594037630001,
								-42.060081121999985
							],
							[
								148.1581659310001,
								-42.07583353199993
							],
							[
								148.18697526500011,
								-42.07782269399996
							],
							[
								148.19764936400009,
								-42.067172924999966
							],
							[
								148.2215723390001,
								-42.069015546999935
							],
							[
								148.22465158700004,
								-42.076873586999966
							],
							[
								148.21323384000004,
								-42.07142112599996
							],
							[
								148.20844749000003,
								-42.077377755999976
							],
							[
								148.24167897200005,
								-42.09102059899993
							],
							[
								148.23679772100002,
								-42.10106013899997
							],
							[
								148.24757988700003,
								-42.116827839999985
							],
							[
								148.2684310940001,
								-42.109974000999955
							],
							[
								148.28339725800004,
								-42.128055512999936
							],
							[
								148.29471480600012,
								-42.12457303299993
							],
							[
								148.3018038340001,
								-42.13172378399997
							],
							[
								148.2593570370001,
								-42.16544558099997
							],
							[
								148.27791878200003,
								-42.17312893199994
							],
							[
								148.2919008670001,
								-42.19167044399995
							],
							[
								148.26967539600003,
								-42.227013531999944
							],
							[
								148.25097283900004,
								-42.230909699999984
							],
							[
								148.25421881600005,
								-42.24798551099997
							],
							[
								148.2847503690001,
								-42.25702628299996
							],
							[
								148.29156688400008,
								-42.28079774399998
							],
							[
								148.30280866100009,
								-42.28224134499993
							],
							[
								148.31457505000003,
								-42.27595700599994
							],
							[
								148.3083471330001,
								-42.26624857499996
							],
							[
								148.32058989000006,
								-42.26403182599995
							],
							[
								148.3276491040001,
								-42.23020579699994
							],
							[
								148.34682039100005,
								-42.22257488799994
							],
							[
								148.34290216400007,
								-42.21113873799993
							],
							[
								148.3568188060001,
								-42.179471718999935
							],
							[
								148.3454471970001,
								-42.18358222799998
							],
							[
								148.315596636,
								-42.16918639499994
							],
							[
								148.30668406600012,
								-42.175605804999975
							],
							[
								148.29770101000008,
								-42.165971113999944
							],
							[
								148.32420774700006,
								-42.149300955999934
							],
							[
								148.31966631000012,
								-42.13239002599994
							],
							[
								148.33811183600005,
								-42.132976216999964
							],
							[
								148.34277161900002,
								-42.106632736999984
							],
							[
								148.32809570300003,
								-42.10017420599996
							],
							[
								148.3107874430001,
								-42.05872530399995
							],
							[
								148.29678268600003,
								-42.05607575299996
							],
							[
								148.283530132,
								-42.03414588199996
							],
							[
								148.290746699,
								-41.97849494199994
							],
							[
								148.30980458700003,
								-41.96139830399994
							],
							[
								148.3025289420001,
								-41.93688731299994
							],
							[
								148.32359473100007,
								-41.917188574999955
							],
							[
								148.30402427900003,
								-41.89128674299997
							],
							[
								148.31094252000003,
								-41.87326940299994
							],
							[
								148.28745083600006,
								-41.86579611099995
							],
							[
								148.2725655910001,
								-41.848873949999984
							],
							[
								148.26448340900004,
								-41.80999801899998
							],
							[
								148.28430028200012,
								-41.75778471099994
							],
							[
								148.30477452000002,
								-41.74816317199998
							],
							[
								148.28407800800005,
								-41.719986209999945
							],
							[
								148.29523474000007,
								-41.693159640999966
							],
							[
								148.29318786500005,
								-41.658948350999935
							],
							[
								148.3203003550001,
								-41.62137928299995
							],
							[
								148.31665755300003,
								-41.57536498199994
							],
							[
								148.29926764900006,
								-41.55802454099995
							],
							[
								148.2880229110001,
								-41.55818194999995
							],
							[
								148.27562551100004,
								-41.50348655799996
							],
							[
								148.26713474200005,
								-41.50635381799998
							],
							[
								148.2625077450001,
								-41.49145905699993
							],
							[
								148.24927806900007,
								-41.48601252599997
							],
							[
								148.25310790900005,
								-41.477839425999946
							],
							[
								148.26200276600002,
								-41.48938009699998
							],
							[
								148.2643086160001,
								-41.481922046999955
							],
							[
								148.27096965200008,
								-41.50244472799994
							],
							[
								148.26648150900007,
								-41.46215808699998
							],
							[
								148.24961902300004,
								-41.45663163599994
							],
							[
								148.24205622300008,
								-41.46721082499994
							],
							[
								148.23022960700007,
								-41.45776021399996
							],
							[
								148.23239748800006,
								-41.44290822399995
							],
							[
								148.22225881000008,
								-41.441868503999956
							],
							[
								148.21622302000003,
								-41.45131366299995
							],
							[
								148.2196578600001,
								-41.44689157299996
							],
							[
								148.20154637300004,
								-41.448124071999985
							],
							[
								148.2051292540001,
								-41.441070011999955
							],
							[
								148.19788648500003,
								-41.44234419199995
							],
							[
								148.20543424400012,
								-41.440969001999974
							],
							[
								148.20235839300005,
								-41.44802506199994
							],
							[
								148.22893060900003,
								-41.44430133399993
							],
							[
								148.2276346010001,
								-41.43159941399995
							],
							[
								148.23291552600006,
								-41.46038512499996
							],
							[
								148.24440317200003,
								-41.46655675599993
							],
							[
								148.23657443500008,
								-41.458869024999956
							],
							[
								148.26296061000005,
								-41.46022121699997
							],
							[
								148.26618053000004,
								-41.451911156999984
							],
							[
								148.2672344990001,
								-41.46168507699997
							],
							[
								148.295709256,
								-41.37167991899997
							],
							[
								148.28910651600006,
								-41.38045004899993
							],
							[
								148.2794088280001,
								-41.37876130799998
							],
							[
								148.27912876900007,
								-41.371720377999964
							],
							[
								148.2937452970001,
								-41.36930399899995
							],
							[
								148.28880542900004,
								-41.363244178999935
							],
							[
								148.29577524600006,
								-41.37031393899997
							],
							[
								148.30134503600004,
								-41.36616981999998
							],
							[
								148.32730877000006,
								-41.30644067099996
							],
							[
								148.35895053700006,
								-41.28146016399995
							],
							[
								148.35640652900008,
								-41.27393724399997
							],
							[
								148.3393911810001,
								-41.28203157199994
							],
							[
								148.3320133630001,
								-41.276475741999946
							],
							[
								148.3094784110001,
								-41.31696002999996
							],
							[
								148.2715848460001,
								-41.339559786999985
							],
							[
								148.23576783500005,
								-41.322745693999934
							],
							[
								148.24852225200004,
								-41.32798480499997
							],
							[
								148.27699651800003,
								-41.315187796999965
							],
							[
								148.26863174000005,
								-41.31407400699993
							],
							[
								148.27613850900002,
								-41.31226783699998
							],
							[
								148.28160603300012,
								-41.27654281799994
							],
							[
								148.295446609,
								-41.28269349899995
							],
							[
								148.29061798700002,
								-41.30402450799994
							],
							[
								148.307781384,
								-41.30221211999998
							],
							[
								148.3098902050001,
								-41.28850014999995
							],
							[
								148.3304944130001,
								-41.27554378199994
							],
							[
								148.33882893400005,
								-41.25740466199994
							],
							[
								148.32925418700006,
								-41.24856989099993
							],
							[
								148.31576272900008,
								-41.25452415999996
							],
							[
								148.31211572100005,
								-41.24672623999993
							],
							[
								148.2876176540001,
								-41.256921717999944
							],
							[
								148.28799262500002,
								-41.250233727999955
							],
							[
								148.30385008200005,
								-41.25146438899998
							],
							[
								148.27929570000003,
								-41.230422886999975
							],
							[
								148.2852908320001,
								-41.20923822699996
							],
							[
								148.26912311500007,
								-41.21017021599994
							],
							[
								148.26201284700005,
								-41.20332092599995
							],
							[
								148.275613764,
								-41.20773408699995
							],
							[
								148.27194606800003,
								-41.18059946599993
							],
							[
								148.2528746710001,
								-41.190925704999984
							],
							[
								148.2849045580001,
								-41.168588306999936
							],
							[
								148.2759856020001,
								-41.151397395999936
							],
							[
								148.26804776300003,
								-41.15178142599996
							],
							[
								148.2695194470001,
								-41.12601330599995
							],
							[
								148.29815717000008,
								-41.06381649799994
							],
							[
								148.28219539500003,
								-41.05221655599996
							],
							[
								148.24950195100007,
								-41.05108453399998
							],
							[
								148.29386991600006,
								-41.02893620699996
							],
							[
								148.28633026400007,
								-41.04842447699997
							],
							[
								148.296832181,
								-41.061932497999976
							],
							[
								148.30158375400003,
								-41.02919315799994
							],
							[
								148.33058793300006,
								-40.99999060999994
							],
							[
								148.3496795100001,
								-40.993320360999974
							],
							[
								148.32383784600006,
								-40.98783451899993
							],
							[
								148.29848079600004,
								-40.95472436699998
							],
							[
								148.30197946700002,
								-40.94165120699995
							],
							[
								148.27433849500005,
								-40.920659204999936
							],
							[
								148.26738721900006,
								-40.90049205399998
							],
							[
								148.25786353,
								-40.90415718299994
							],
							[
								148.2153658960001,
								-40.919597719999956
							],
							[
								148.2109219450001,
								-40.93724409999993
							],
							[
								148.11676430500006,
								-40.92353960199995
							],
							[
								148.11201766300007,
								-40.94221073199998
							],
							[
								148.08741961900012,
								-40.93608786999994
							],
							[
								148.07421837300012,
								-40.99533630899998
							],
							[
								148.08116752900003,
								-41.01347131999995
							],
							[
								148.06875825800012,
								-41.03374046899995
							],
							[
								148.0821013420001,
								-41.06023566999994
							],
							[
								148.06223957200007,
								-41.08704803899997
							],
							[
								148.06522482800005,
								-41.11292315899993
							],
							[
								148.08230032200004,
								-41.13212613999997
							],
							[
								147.93482180500007,
								-41.168457298999954
							],
							[
								147.88953396400007,
								-41.164944454999954
							],
							[
								147.83396897600005,
								-41.37241107199998
							],
							[
								147.59057501200004,
								-41.38084306199994
							],
							[
								147.6087179860001,
								-41.39772546399996
							],
							[
								147.60635625500004,
								-41.407435593999935
							],
							[
								147.61926002200005,
								-41.409212594999985
							],
							[
								147.61583256100005,
								-41.42638884499996
							],
							[
								147.62873443800004,
								-41.428161915999965
							],
							[
								147.62736586500012,
								-41.45146235599998
							],
							[
								147.6480638370001,
								-41.478411507999965
							],
							[
								147.57891291600004,
								-41.51357889199994
							],
							[
								147.57193857800007,
								-41.50601837199997
							],
							[
								147.56215522900004,
								-41.51119850099997
							],
							[
								147.53993461400012,
								-41.507437668999955
							],
							[
								147.50654065800006,
								-41.530427766999935
							],
							[
								147.49873335000007,
								-41.52200267599994
							],
							[
								147.4863636020001,
								-41.52862586499998
							],
							[
								147.47614926500012,
								-41.51803786399995
							],
							[
								147.42811765200008,
								-41.53871887099996
							],
							[
								147.43200993000005,
								-41.543001740999955
							],
							[
								147.40645734400005,
								-41.556165488999966
							],
							[
								147.40082364600005,
								-41.54978008799998
							],
							[
								147.38799842700007,
								-41.556059877999985
							],
							[
								147.346764462,
								-41.512027933999946
							],
							[
								147.3127901160001,
								-41.52938355099997
							],
							[
								147.3028294190001,
								-41.52041496099997
							],
							[
								147.2858506010001,
								-41.529675828999984
							],
							[
								147.27815144400006,
								-41.52167108899994
							],
							[
								147.26271431600003,
								-41.53003913799995
							],
							[
								147.25528404800002,
								-41.52433902699994
							],
							[
								147.2485020590001,
								-41.52804301599997
							],
							[
								147.23692404200006,
								-41.516423025999984
							],
							[
								147.2307830630001,
								-41.51988501499994
							],
							[
								147.23607005300005,
								-41.51090602499994
							],
							[
								147.22228550800003,
								-41.493608173999974
							],
							[
								147.19803049100005,
								-41.510147021999956
							],
							[
								147.17414489700002,
								-41.50200021099994
							],
							[
								147.16936766900005,
								-41.49287996999993
							],
							[
								147.13635740400002,
								-41.501268367999955
							],
							[
								147.12601191800002,
								-41.490500606999944
							],
							[
								147.14009606600007,
								-41.48300703799998
							],
							[
								147.1336506780001,
								-41.47635450699994
							],
							[
								147.10174796600006,
								-41.465551654999956
							],
							[
								147.08021334300008,
								-41.44465122299994
							],
							[
								147.06552928400004,
								-41.45887548199994
							],
							[
								147.0318462140001,
								-41.43732388899997
							],
							[
								147.03046520500004,
								-41.42568488899997
							],
							[
								147.00799091700003,
								-41.44520606699996
							],
							[
								146.9940051100001,
								-41.443423165999945
							],
							[
								146.9961427610001,
								-41.431797105999976
							],
							[
								146.97200747600004,
								-41.429028924999955
							],
							[
								146.9343086770001,
								-41.40848264199997
							],
							[
								146.92820128000005,
								-41.389401720999956
							],
							[
								146.91026172500005,
								-41.377819999999986
							],
							[
								146.89999485600003,
								-41.38651887899994
							],
							[
								146.87283331100002,
								-41.39120307699994
							],
							[
								146.82524353100007,
								-41.385195592999935
							],
							[
								146.80953703500006,
								-41.37538957199996
							],
							[
								146.7985763370001,
								-41.38036866099998
							],
							[
								146.77157788300008,
								-41.375684828999965
							],
							[
								146.69751155000006,
								-41.35523660299998
							],
							[
								146.70359088200007,
								-41.33267657399995
							],
							[
								146.61995019900007,
								-41.32446351699997
							],
							[
								146.6174775080001,
								-41.33788746699997
							],
							[
								146.58957877400007,
								-41.334781454999984
							],
							[
								146.58086451400004,
								-41.346862313999964
							],
							[
								146.5899274200001,
								-41.36173344499997
							],
							[
								146.54822157900003,
								-41.35499260199998
							],
							[
								146.54558492800004,
								-41.367380641999944
							],
							[
								146.5280735120001,
								-41.36496933099994
							],
							[
								146.4894635280001,
								-41.37793538799997
							],
							[
								146.45978501800005,
								-41.347244674999956
							],
							[
								146.459689281,
								-41.32014656499996
							],
							[
								146.44680825400008,
								-41.315006703999984
							],
							[
								146.44445440700008,
								-41.29782344399996
							],
							[
								146.4005128660001,
								-41.295252550999976
							],
							[
								146.3901696490001,
								-41.28784128999996
							],
							[
								146.38372762000006,
								-41.29292321899993
							],
							[
								146.3841854000001,
								-41.28692688899997
							],
							[
								146.35892641600003,
								-41.28418919799998
							],
							[
								146.35753215700004,
								-41.27262012699998
							],
							[
								146.3701073960001,
								-41.26678868799996
							],
							[
								146.3494769030001,
								-41.242134516999954
							],
							[
								146.32338097600007,
								-41.25492841499994
							],
							[
								146.3211254250001,
								-41.271849514999985
							],
							[
								146.26568952600007,
								-41.265579970999966
							],
							[
								146.23613665100004,
								-41.27827373799994
							],
							[
								146.22617076300003,
								-41.27154830799998
							],
							[
								146.19645202700008,
								-41.29073962599995
							],
							[
								146.20344758400006,
								-41.29753517599994
							],
							[
								146.19692258600003,
								-41.295620155999984
							],
							[
								146.19426144600004,
								-41.303000054999984
							],
							[
								146.2050409520001,
								-41.31183177599996
							],
							[
								146.18469950600002,
								-41.31626668499996
							],
							[
								146.17697712400002,
								-41.34125744399995
							],
							[
								146.13478945000008,
								-41.36256511099998
							],
							[
								146.1351656490001,
								-41.36849477099997
							],
							[
								146.1142593620001,
								-41.371656919999964
							],
							[
								146.11745114000007,
								-41.38425188999997
							],
							[
								146.08525887200005,
								-41.42099086799993
							],
							[
								146.09469444700005,
								-41.44400738899998
							],
							[
								146.0872086270001,
								-41.458133147999945
							],
							[
								145.95407034400012,
								-41.451792988999955
							],
							[
								145.85283677200005,
								-41.465850021999984
							],
							[
								145.8530233470001,
								-41.58300993199998
							],
							[
								145.95133675400007,
								-41.684649399999955
							],
							[
								146.05048890700004,
								-41.974542988999985
							],
							[
								146.01492167000004,
								-42.005307665999965
							],
							[
								146.02342733400008,
								-42.03943360699998
							],
							[
								145.9997584350001,
								-42.06688649599994
							],
							[
								146.07533322100005,
								-42.21045700199994
							],
							[
								146.08864708800002,
								-42.287777812999934
							],
							[
								146.10695486200007,
								-42.305292634999944
							],
							[
								146.0970865370001,
								-42.358738313999936
							],
							[
								146.09846032500002,
								-42.370765183999936
							],
							[
								146.11495551000007,
								-42.380624685999976
							],
							[
								146.0995356100001,
								-42.40254383499996
							],
							[
								146.10633814800008,
								-42.40791899499993
							],
							[
								146.12769911400005,
								-42.406200086999945
							],
							[
								146.13386016200002,
								-42.414598696999974
							],
							[
								146.1257915100001,
								-42.436721776999946
							],
							[
								146.10903527300002,
								-42.44508791599998
							],
							[
								146.08618572300009,
								-42.47589104399998
							],
							[
								146.07525430500004,
								-42.47790677299997
							],
							[
								146.0877697520001,
								-42.48373166399995
							],
							[
								146.07800903300006,
								-42.48710747399997
							],
							[
								146.08974809100005,
								-42.489973343999964
							],
							[
								146.08119555100006,
								-42.50326866399996
							],
							[
								146.05336664300012,
								-42.528539921999936
							],
							[
								146.02930022700002,
								-42.53822804999993
							],
							[
								146.02976253400004,
								-42.55412461999998
							],
							[
								146.017875064,
								-42.57297522999994
							],
							[
								146.00097538700004,
								-42.57992438799994
							],
							[
								145.98482610400004,
								-42.626292916999944
							],
							[
								145.9720842470001,
								-42.624320816999955
							],
							[
								145.97050430500008,
								-42.638966266999944
							],
							[
								145.9669083670001,
								-42.63331606599996
							],
							[
								145.9620604370001,
								-42.63864323599995
							],
							[
								145.9657563840001,
								-42.65854187599996
							],
							[
								145.93428568900003,
								-42.66940418399997
							],
							[
								145.92804889800004,
								-42.682016283999985
							],
							[
								145.90469116300005,
								-42.68407764199998
							],
							[
								145.8931692430001,
								-42.698034150999945
							],
							[
								145.86704365000003,
								-42.69196224899997
							],
							[
								145.8709066250001,
								-42.71658363999995
							],
							[
								145.83250596300002,
								-42.71751619699995
							],
							[
								145.8495587980001,
								-42.73320462799995
							],
							[
								145.9494669940001,
								-42.90588533599998
							],
							[
								145.93428715700009,
								-42.905176584999936
							],
							[
								145.94061957200006,
								-42.93071873599996
							],
							[
								145.99503762400002,
								-42.98034752999996
							],
							[
								145.9914418620001,
								-43.00450250999995
							],
							[
								145.97816436300002,
								-43.01748614899998
							],
							[
								145.97814626000002,
								-43.03915843899995
							],
							[
								146.0890750950001,
								-43.053890346999935
							],
							[
								146.22219654800006,
								-43.11879125699994
							],
							[
								146.45881271300004,
								-43.08726374499997
							],
							[
								146.64841129600006,
								-42.92169147799996
							],
							[
								146.6586264770001,
								-42.89975918899995
							],
							[
								146.64630769500002,
								-42.86067906799997
							],
							[
								146.6565752150001,
								-42.84762082799995
							],
							[
								146.69725639600006,
								-42.85035235199996
							],
							[
								146.6985274650001,
								-42.85805940199998
							],
							[
								146.72086003000004,
								-42.857526132999965
							],
							[
								146.73943603500004,
								-42.871182224999984
							],
							[
								146.76498935900008,
								-42.87378606699997
							],
							[
								146.78849662000005,
								-42.90384201899997
							],
							[
								146.8090038570001,
								-42.89370201999998
							],
							[
								146.84506777800004,
								-42.90707547299996
							],
							[
								146.85581939100007,
								-42.94038148399994
							],
							[
								146.87389736500006,
								-42.95461732499996
							],
							[
								146.88056682700005,
								-42.93435439599995
							],
							[
								146.91194024900005,
								-42.94009647799993
							],
							[
								146.9412786150001,
								-42.92662133999994
							],
							[
								146.92389451300005,
								-42.89929411899993
							],
							[
								146.9523727190001,
								-42.88205987099997
							],
							[
								146.97087759400006,
								-42.88879287299994
							],
							[
								147.008884017,
								-42.88779744499993
							],
							[
								147.00582622600007,
								-42.900111624999965
							],
							[
								147.01651620200005,
								-42.907034635999935
							],
							[
								147.03302003900012,
								-42.90410634699998
							],
							[
								147.03978381700006,
								-42.91007855799995
							],
							[
								147.0512756160001,
								-42.90037143899997
							],
							[
								147.15037280400009,
								-42.91333759699995
							],
							[
								147.1510516720001,
								-42.85576026599995
							],
							[
								147.136236477,
								-42.84419665499996
							],
							[
								147.17386311100006,
								-42.82973339799997
							],
							[
								147.17880021200006,
								-42.81459617799993
							],
							[
								147.20083949900004,
								-42.806451719999984
							],
							[
								147.20185920200004,
								-42.783831849999956
							],
							[
								147.22690842100008,
								-42.750407381999935
							],
							[
								147.1960493890001,
								-42.74089961899995
							],
							[
								147.1545394860001,
								-42.752791155999944
							],
							[
								147.13996517600003,
								-42.76962045499994
							],
							[
								147.11163684100006,
								-42.77557466299993
							],
							[
								147.1398801370001,
								-42.76705946499993
							],
							[
								147.15001151700005,
								-42.751787165999986
							],
							[
								147.18598459100008,
								-42.740904727999975
							],
							[
								147.1791056930001,
								-42.73983075799998
							],
							[
								147.18397538300007,
								-42.732277617999955
							],
							[
								147.1989958910001,
								-42.72530642899994
							],
							[
								147.25692302400012,
								-42.75694310399996
							],
							[
								147.2626016170001,
								-42.73018501399997
							],
							[
								147.25608899600002,
								-42.74862298399995
							],
							[
								147.26668786200003,
								-42.75564205499995
							],
							[
								147.2641918800001,
								-42.77751641499998
							],
							[
								147.27667874700012,
								-42.78234835599994
							],
							[
								147.2841565760001,
								-42.77773619599998
							],
							[
								147.29257073200006,
								-42.79087041699995
							],
							[
								147.30733826800008,
								-42.79806506799997
							],
							[
								147.30630802000007,
								-42.786901987999954
							],
							[
								147.32597289700004,
								-42.78089658899995
							],
							[
								147.33259089700005,
								-42.766628039999944
							],
							[
								147.34758425300004,
								-42.77743374099998
							],
							[
								147.36853054100004,
								-42.76120140299997
							],
							[
								147.3812031970001,
								-42.76836701399998
							],
							[
								147.377408467,
								-42.773599012999966
							],
							[
								147.39217720400006,
								-42.77250200499998
							],
							[
								147.41777026700004,
								-42.78830673699997
							],
							[
								147.42550684700007,
								-42.77533505699995
							],
							[
								147.4341323750001,
								-42.775527257999954
							]
						]
					],
					[
						[
							[
								148.34400557000004,
								-41.35308995299994
							],
							[
								148.3475044600001,
								-41.347775902999956
							],
							[
								148.33872169200004,
								-41.34533213299994
							],
							[
								148.34400557000004,
								-41.35308995299994
							]
						]
					],
					[
						[
							[
								148.0689653400001,
								-42.67487653799998
							],
							[
								148.0834845290001,
								-42.66081912899995
							],
							[
								148.1121028240001,
								-42.659717730999944
							],
							[
								148.11959076100004,
								-42.66867878199997
							],
							[
								148.13328230900004,
								-42.66010146299993
							],
							[
								148.146113226,
								-42.66698942399995
							],
							[
								148.1529915760001,
								-42.65354706499994
							],
							[
								148.169018864,
								-42.64866666599994
							],
							[
								148.14067739200004,
								-42.63115523399995
							],
							[
								148.13855327600004,
								-42.608428412999956
							],
							[
								148.12014673300007,
								-42.584997801999975
							],
							[
								148.0895505090001,
								-42.58496016899994
							],
							[
								148.07269649500006,
								-42.56927542799997
							],
							[
								148.05286334700008,
								-42.58495060599995
							],
							[
								148.04873975400005,
								-42.60642758599994
							],
							[
								148.02470968600005,
								-42.62930380399996
							],
							[
								148.03789195000002,
								-42.64918362499998
							],
							[
								148.00932698400004,
								-42.66117373299994
							],
							[
								148.0254829700001,
								-42.66817474399994
							],
							[
								148.04971648700007,
								-42.655668505999984
							],
							[
								148.06651973100008,
								-42.67365642799996
							],
							[
								148.05949786100007,
								-42.68485054699994
							],
							[
								148.03874834500004,
								-42.68409273599997
							],
							[
								148.02554461300008,
								-42.712930074999974
							],
							[
								148.0127189950001,
								-42.72032322399997
							],
							[
								148.01456315100006,
								-42.74251636399998
							],
							[
								148.0479701370001,
								-42.722644886999944
							],
							[
								148.06789066300007,
								-42.72636967799997
							],
							[
								148.06528671500007,
								-42.71732465799994
							],
							[
								148.07940539100002,
								-42.72436455899998
							],
							[
								148.09309408800004,
								-42.72079837999996
							],
							[
								148.0871222940001,
								-42.68946128999994
							],
							[
								148.07052965800005,
								-42.68508142799993
							],
							[
								148.0689653400001,
								-42.67487653799998
							]
						]
					],
					[
						[
							[
								148.29515263500002,
								-42.33309308499997
							],
							[
								148.30464741200012,
								-42.34377075499998
							],
							[
								148.34598131400003,
								-42.34171330899994
							],
							[
								148.32630683900004,
								-42.333723996999936
							],
							[
								148.33171964000007,
								-42.322608807999984
							],
							[
								148.31763805200012,
								-42.323319295999966
							],
							[
								148.3193347240001,
								-42.30585914599993
							],
							[
								148.29848706100006,
								-42.29244838499994
							],
							[
								148.27924513300002,
								-42.30220010299996
							],
							[
								148.25583597900004,
								-42.29325085099998
							],
							[
								148.23876358100006,
								-42.30244634999997
							],
							[
								148.23657003900007,
								-42.317665319999946
							],
							[
								148.24829635600008,
								-42.32732402099998
							],
							[
								148.27707313000008,
								-42.32463070299997
							],
							[
								148.29515263500002,
								-42.33309308499997
							]
						]
					],
					[
						[
							[
								147.4584729810001,
								-42.77228902999997
							],
							[
								147.46480284900008,
								-42.77148398999998
							],
							[
								147.45240095200006,
								-42.770003058999976
							],
							[
								147.4584729810001,
								-42.77228902999997
							]
						]
					],
					[
						[
							[
								147.64451849500006,
								-42.95884275599997
							],
							[
								147.6414939980001,
								-42.94298274499994
							],
							[
								147.63523124800008,
								-42.94920602499997
							],
							[
								147.64451849500006,
								-42.95884275599997
							]
						]
					],
					[
						[
							[
								147.85783673700007,
								-43.05673108299993
							],
							[
								147.84544072300002,
								-43.03066907199997
							],
							[
								147.83592659300007,
								-43.04110228099995
							],
							[
								147.84436010000002,
								-43.04991899199996
							],
							[
								147.84070571900008,
								-43.060387091999985
							],
							[
								147.82660774300007,
								-43.05522409099996
							],
							[
								147.81379872500008,
								-43.06059707999998
							],
							[
								147.80669075900005,
								-43.046412068999985
							],
							[
								147.77383371400003,
								-43.05492508599997
							],
							[
								147.76673975900007,
								-43.03265907599996
							],
							[
								147.75904172900005,
								-43.044124084999964
							],
							[
								147.7493837610001,
								-43.043366083999956
							],
							[
								147.74043275700012,
								-43.014103072999944
							],
							[
								147.71845816000007,
								-43.02796242199997
							],
							[
								147.72691680900004,
								-43.018701231999955
							],
							[
								147.70804299500003,
								-43.00354214099997
							],
							[
								147.73602667500006,
								-42.97000938299993
							],
							[
								147.72629555700007,
								-42.964215441999954
							],
							[
								147.73136733700005,
								-42.957152321999956
							],
							[
								147.72553315000005,
								-42.94938134199998
							],
							[
								147.70536336300006,
								-42.95660663999996
							],
							[
								147.6994780660001,
								-42.944243589999985
							],
							[
								147.6789839820001,
								-42.934553807999976
							],
							[
								147.6659913640001,
								-42.938737086999936
							],
							[
								147.6758276390001,
								-42.95757705799997
							],
							[
								147.66875083900004,
								-42.963113256999975
							],
							[
								147.68516199400005,
								-42.974681128999975
							],
							[
								147.6839812930001,
								-42.98377625899997
							],
							[
								147.6686639940001,
								-42.99961869799995
							],
							[
								147.6418782610001,
								-42.99331924499995
							],
							[
								147.62215282300008,
								-43.00234093399996
							],
							[
								147.62267126400002,
								-43.06514419399997
							],
							[
								147.65071755500003,
								-43.08942089699997
							],
							[
								147.6741417600001,
								-43.08889005899994
							],
							[
								147.684190746,
								-43.102425068999935
							],
							[
								147.70088274300008,
								-43.097496080999974
							],
							[
								147.70850675100007,
								-43.10245608099996
							],
							[
								147.73276501700002,
								-43.091083552999976
							],
							[
								147.74083231500003,
								-43.096025493999946
							],
							[
								147.74752017100002,
								-43.11211139499994
							],
							[
								147.73018373600007,
								-43.10031907299998
							],
							[
								147.7163837390001,
								-43.10519507199996
							],
							[
								147.73410872400007,
								-43.11079608299997
							],
							[
								147.73114674300007,
								-43.124903072999984
							],
							[
								147.703400729,
								-43.122132060999945
							],
							[
								147.68514073000006,
								-43.13870006999997
							],
							[
								147.69817075600008,
								-43.145677070999966
							],
							[
								147.70129671100005,
								-43.176969060999966
							],
							[
								147.71552273800012,
								-43.178345071999956
							],
							[
								147.71158273600008,
								-43.19426908199995
							],
							[
								147.746039719,
								-43.197556074999966
							],
							[
								147.75071970600004,
								-43.209020074999955
							],
							[
								147.76176873400004,
								-43.206270065999945
							],
							[
								147.77640373000008,
								-43.21314407699998
							],
							[
								147.7811336860001,
								-43.23297907799997
							],
							[
								147.7995646910001,
								-43.24234606899995
							],
							[
								147.797433715,
								-43.21744406899995
							],
							[
								147.82202273300004,
								-43.19795808099997
							],
							[
								147.8383856800001,
								-43.19565609199998
							],
							[
								147.84455871000011,
								-43.18751609299994
							],
							[
								147.86084270300012,
								-43.20820708399998
							],
							[
								147.86294167300002,
								-43.20358608399994
							],
							[
								147.87239670100007,
								-43.20788509499994
							],
							[
								147.86647867400006,
								-43.19791609499998
							],
							[
								147.87625767200007,
								-43.19169709499994
							],
							[
								147.85299969900007,
								-43.17950107299998
							],
							[
								147.8706947180001,
								-43.16427507499998
							],
							[
								147.87033472000007,
								-43.15182707499997
							],
							[
								147.86135473000002,
								-43.164936083999976
							],
							[
								147.84555768400003,
								-43.15433408299998
							],
							[
								147.86006267300002,
								-43.14245908399994
							],
							[
								147.85567924500003,
								-43.134769312999936
							],
							[
								147.86610013300003,
								-43.13726816399998
							],
							[
								147.8503887180001,
								-43.12408608299995
							],
							[
								147.85798418600007,
								-43.12440833299996
							],
							[
								147.8538112880001,
								-43.117808482999976
							],
							[
								147.86405413800003,
								-43.10787540399997
							],
							[
								147.86729514400008,
								-43.12926819399996
							],
							[
								147.8864279710001,
								-43.12325110599994
							],
							[
								147.89468605700006,
								-43.13819598599997
							],
							[
								147.88816916700011,
								-43.14266308599997
							],
							[
								147.89663492800003,
								-43.190981386999965
							],
							[
								147.9165105940001,
								-43.18955009899997
							],
							[
								147.93176460000007,
								-43.19884097999994
							],
							[
								147.94506139800012,
								-43.194626780999954
							],
							[
								147.94946497400008,
								-43.21571796099994
							],
							[
								148.002989801,
								-43.22745960599997
							],
							[
								148.01031462000003,
								-43.21933945599994
							],
							[
								147.97270233100005,
								-43.203038542999934
							],
							[
								147.96355193500005,
								-43.18539542199994
							],
							[
								148.00579166400007,
								-43.13891865499994
							],
							[
								147.97224138100012,
								-43.134817392999935
							],
							[
								147.96339148200002,
								-43.142716391999954
							],
							[
								147.9543596750001,
								-43.13658554099993
							],
							[
								147.9545854260001,
								-43.125706710999964
							],
							[
								147.9806170710001,
								-43.12329538299997
							],
							[
								147.98109366300002,
								-43.107360322999966
							],
							[
								147.94507050800007,
								-43.059215619999975
							],
							[
								147.954045317,
								-43.052057340999966
							],
							[
								147.95022125100002,
								-43.034751419999964
							],
							[
								147.93552843400005,
								-43.03495961899995
							],
							[
								147.92639620800003,
								-43.02068873799993
							],
							[
								147.93051070800004,
								-43.00988053899994
							],
							[
								147.95316483500005,
								-43.00128502999996
							],
							[
								147.96133061600005,
								-42.98405269099993
							],
							[
								147.9950736510001,
								-42.97135416399993
							],
							[
								147.9965913640001,
								-42.951384933999975
							],
							[
								147.98688126600007,
								-42.950939002999974
							],
							[
								147.98343621800007,
								-42.94120995299994
							],
							[
								147.9988662290001,
								-42.91455252399993
							],
							[
								147.98406500500005,
								-42.890419401999964
							],
							[
								147.95798836200004,
								-42.882455499999935
							],
							[
								147.97134495000012,
								-42.87423551099994
							],
							[
								147.97089264200008,
								-42.864210380999964
							],
							[
								147.93822521700008,
								-42.87659656899996
							],
							[
								147.92036041300003,
								-42.86127932699998
							],
							[
								147.9199270160001,
								-42.84294415699998
							],
							[
								147.91302124600008,
								-42.847858335999945
							],
							[
								147.89147866100006,
								-42.84261152499994
							],
							[
								147.8796351420001,
								-42.85363203399993
							],
							[
								147.88524724,
								-42.861871263999944
							],
							[
								147.8611282930001,
								-42.87492353199997
							],
							[
								147.9039619130001,
								-42.88234562599996
							],
							[
								147.90041725100002,
								-42.89983278599993
							],
							[
								147.90780980800002,
								-42.90874103599998
							],
							[
								147.89500718300008,
								-42.89441963499996
							],
							[
								147.87641981800004,
								-42.88865860399994
							],
							[
								147.87384338700008,
								-42.89461565299996
							],
							[
								147.84083962500006,
								-42.88863669099993
							],
							[
								147.8028898120001,
								-42.89326701799996
							],
							[
								147.82182940600012,
								-42.907871228999966
							],
							[
								147.81489560300008,
								-42.93785590899995
							],
							[
								147.82160959300006,
								-42.93186363999996
							],
							[
								147.83326875000012,
								-42.934643679999965
							],
							[
								147.82949712900006,
								-42.94666112999994
							],
							[
								147.83705303700003,
								-42.94783412099997
							],
							[
								147.8577490450001,
								-42.93544547199997
							],
							[
								147.86587810100002,
								-42.947030852999944
							],
							[
								147.85380346400007,
								-42.94586394199996
							],
							[
								147.84800376400005,
								-42.95162510199998
							],
							[
								147.85480776200006,
								-42.95819212199996
							],
							[
								147.83085062600003,
								-42.96523344999997
							],
							[
								147.81131612000001,
								-42.96224149899996
							],
							[
								147.82260647600003,
								-42.97608857999995
							],
							[
								147.83238559500012,
								-42.97054350099995
							],
							[
								147.8365474320001,
								-42.980543430999944
							],
							[
								147.85678335800003,
								-42.98250421299997
							],
							[
								147.83790348000002,
								-42.99154842099995
							],
							[
								147.8468643650001,
								-43.01304462199994
							],
							[
								147.87016425100012,
								-43.01085550399995
							],
							[
								147.89420000500002,
								-43.01939438599993
							],
							[
								147.92500004900012,
								-43.01587572799997
							],
							[
								147.87244753800007,
								-43.023349603999975
							],
							[
								147.85783673700007,
								-43.05673108299993
							]
						]
					],
					[
						[
							[
								147.78221226800008,
								-42.94769817599996
							],
							[
								147.78959833700003,
								-42.949385216999985
							],
							[
								147.7817160200001,
								-42.93995392599993
							],
							[
								147.78221226800008,
								-42.94769817599996
							]
						]
					],
					[
						[
							[
								147.99762719000012,
								-43.23757980499994
							],
							[
								147.99873141900002,
								-43.24639189499993
							],
							[
								148.0073561470001,
								-43.24374272599994
							],
							[
								148.0064249290001,
								-43.232596625999975
							],
							[
								147.99762719000012,
								-43.23757980499994
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "605",
				"CED_NAME21": "Lyons",
				"STE_CODE21": "6",
				"STE_NAME21": "Tasmania",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 31965.7379,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/605",
				"SHAPE_Leng": 24.916236078,
				"SHAPE_Area": 3.47979492897
			}
		},
		{
			"type": "Feature",
			"geometry": null,
			"properties": {
				"CED_CODE21": "694",
				"CED_NAME21": "No usual address (Tas.)",
				"STE_CODE21": "6",
				"STE_NAME21": "Tasmania",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 0,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/694",
				"SHAPE_Leng": 0,
				"SHAPE_Area": 0
			}
		},
		{
			"type": "Feature",
			"geometry": null,
			"properties": {
				"CED_CODE21": "697",
				"CED_NAME21": "Migratory - Offshore - Shipping (Tas.)",
				"STE_CODE21": "6",
				"STE_NAME21": "Tasmania",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 0,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/697",
				"SHAPE_Leng": 0,
				"SHAPE_Area": 0
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								137.99465396800008,
								-16.538296570999933
							],
							[
								137.93681882300007,
								-16.49027623799998
							],
							[
								137.9367287440001,
								-16.481776267999976
							],
							[
								137.86202909100007,
								-16.42269679499998
							],
							[
								137.82980908500008,
								-16.371767052999928
							],
							[
								137.78985921900005,
								-16.32598735099998
							],
							[
								137.768859162,
								-16.285707539999976
							],
							[
								137.74089928500007,
								-16.261757758999977
							],
							[
								137.72967922700002,
								-16.232237857999962
							],
							[
								137.68062958000007,
								-16.222308165999948
							],
							[
								137.5737803290001,
								-16.174808861999963
							],
							[
								137.53432066200003,
								-16.16421909099995
							],
							[
								137.55695047000006,
								-16.174278950999962
							],
							[
								137.49850178400004,
								-16.16800294899997
							],
							[
								137.42573213900005,
								-16.139244106999968
							],
							[
								137.4092023500001,
								-16.144304355999964
							],
							[
								137.388402422,
								-16.12660464499993
							],
							[
								137.3569326050001,
								-16.11561510399997
							],
							[
								137.38381248200005,
								-16.131884704999948
							],
							[
								137.38135256200007,
								-16.137004764999972
							],
							[
								137.37356255300006,
								-16.126404864999927
							],
							[
								137.37261264300002,
								-16.133334884999954
							],
							[
								137.35435263500005,
								-16.114985143999945
							],
							[
								137.29493287000003,
								-16.08110598099995
							],
							[
								137.308962779,
								-16.085105771999963
							],
							[
								137.25442262500007,
								-16.012336319999974
							],
							[
								137.20409295800005,
								-15.999327027999982
							],
							[
								137.15794312200012,
								-15.969447595999952
							],
							[
								137.08358357800012,
								-15.944148342999938
							],
							[
								137.04810372100007,
								-15.922238641999968
							],
							[
								137.00353379500007,
								-15.873088929999938
							],
							[
								136.9979338160001,
								-15.869478989999948
							],
							[
								137.0058638050001,
								-15.87930892999998
							],
							[
								136.99933377500008,
								-15.875118999999927
							],
							[
								136.99874386500005,
								-15.88065901999994
							],
							[
								136.98731388600004,
								-15.875119198999982
							],
							[
								136.9779938380001,
								-15.85093921899994
							],
							[
								136.96631401800005,
								-15.861549448999938
							],
							[
								136.97039405700002,
								-15.874879478999958
							],
							[
								136.9394643290001,
								-15.880159997999954
							],
							[
								136.91271461000008,
								-15.899670596999954
							],
							[
								136.918764699,
								-15.917070606999971
							],
							[
								136.9532546060001,
								-15.938320138999927
							],
							[
								136.94431462700004,
								-15.932900267999969
							],
							[
								136.93885470700002,
								-15.938290387999928
							],
							[
								136.93065468800012,
								-15.933230507999951
							],
							[
								136.90462492900008,
								-15.936480996999933
							],
							[
								136.90813484900002,
								-15.928460876999964
							],
							[
								136.89295490000006,
								-15.924831136999956
							],
							[
								136.88877499000012,
								-15.932271266999976
							],
							[
								136.88782493100007,
								-15.922341185999926
							],
							[
								136.87171507100004,
								-15.923561485999926
							],
							[
								136.86647502200003,
								-15.91362150599997
							],
							[
								136.84937813300007,
								-15.916242804999968
							],
							[
								136.8563250730001,
								-15.907511624999927
							],
							[
								136.83519514400007,
								-15.908271974999934
							],
							[
								136.82295516500005,
								-15.899222043999941
							],
							[
								136.79586526700007,
								-15.90449251299998
							],
							[
								136.79578529700007,
								-15.911782562999974
							],
							[
								136.78605527700006,
								-15.902782652999974
							],
							[
								136.7607454790001,
								-15.916253131999952
							],
							[
								136.7732153380001,
								-15.906372872999953
							],
							[
								136.77149527900008,
								-15.889432711999973
							],
							[
								136.7295056800001,
								-15.932383740999967
							],
							[
								136.7063857810001,
								-15.93121408099995
							],
							[
								136.6908056430001,
								-15.903394069999933
							],
							[
								136.71466547300008,
								-15.87724339999994
							],
							[
								136.71377546300005,
								-15.856793179999954
							],
							[
								136.70153547400002,
								-15.850673269999959
							],
							[
								136.7038854550001,
								-15.84175313999998
							],
							[
								136.69316551500003,
								-15.835753238999928
							],
							[
								136.69283544600012,
								-15.82705313899993
							],
							[
								136.67457552700012,
								-15.81447327899997
							],
							[
								136.67864552700007,
								-15.805223118999947
							],
							[
								136.67050555800006,
								-15.794133127999942
							],
							[
								136.64472564000005,
								-15.791593516999967
							],
							[
								136.65839558900007,
								-15.781573177999974
							],
							[
								136.64542060000008,
								-15.77895734699996
							],
							[
								136.6427956010001,
								-15.769113276999974
							],
							[
								136.6826754980001,
								-15.777902708999932
							],
							[
								136.72413496800004,
								-15.696331508999947
							],
							[
								136.7045450600001,
								-15.696741758999963
							],
							[
								136.6968750200001,
								-15.683511817999943
							],
							[
								136.68183508100003,
								-15.684602077999955
							],
							[
								136.6793050120001,
								-15.667772057999969
							],
							[
								136.67161497300003,
								-15.66391217699993
							],
							[
								136.66493511300007,
								-15.678472366999927
							],
							[
								136.64407518400003,
								-15.672432706999928
							],
							[
								136.62101543400001,
								-15.706153245999928
							],
							[
								136.5849256560001,
								-15.725033954999958
							],
							[
								136.55937576700012,
								-15.727564403999963
							],
							[
								136.56843579600002,
								-15.741824294999958
							],
							[
								136.55546588700008,
								-15.750384563999944
							],
							[
								136.5584058170001,
								-15.742134463999946
							],
							[
								136.54091599800006,
								-15.739144623999948
							],
							[
								136.5475958280001,
								-15.728884583999957
							],
							[
								136.5338960690001,
								-15.73193465299994
							],
							[
								136.46891709500005,
								-15.666424580999944
							],
							[
								136.4120782000001,
								-15.626144378999982
							],
							[
								136.391328541,
								-15.627074487999948
							],
							[
								136.36627884300003,
								-15.61311455699996
							],
							[
								136.3413292340001,
								-15.613394736999965
							],
							[
								136.32644924500005,
								-15.601965235999955
							],
							[
								136.3163895560001,
								-15.614684945999954
							],
							[
								136.31749955500004,
								-15.625975015999927
							],
							[
								136.31726945600008,
								-15.589594765999948
							],
							[
								136.29029979900008,
								-15.572344864999934
							],
							[
								136.27041996100002,
								-15.535764813999947
							],
							[
								136.26318033300004,
								-15.496714272999952
							],
							[
								136.2415501050001,
								-15.448604541999941
							],
							[
								136.23971996700004,
								-15.41607436199996
							],
							[
								136.2071305390001,
								-15.401124710999966
							],
							[
								136.209760479,
								-15.392864650999968
							],
							[
								136.16468141200005,
								-15.39232525899996
							],
							[
								136.1297022550001,
								-15.364275737999947
							],
							[
								136.07157367900004,
								-15.339156475999971
							],
							[
								136.04979420100005,
								-15.31677669499993
							],
							[
								135.981535516,
								-15.286977332999982
							],
							[
								135.9251767500001,
								-15.249198060999959
							],
							[
								135.86279843600005,
								-15.182729188999929
							],
							[
								135.7489798050001,
								-15.116500104999943
							],
							[
								135.72415013600005,
								-15.11628028499996
							],
							[
								135.7018804280001,
								-15.087510623999947
							],
							[
								135.66984087100002,
								-15.07157091299996
							],
							[
								135.65733108200004,
								-15.052521071999934
							],
							[
								135.63974126300002,
								-15.044431191999934
							],
							[
								135.61232158400003,
								-15.051981220999949
							],
							[
								135.57996200600007,
								-15.045291359999965
							],
							[
								135.54756237900006,
								-15.020071608999956
							],
							[
								135.53099262000012,
								-15.017171657999938
							],
							[
								135.50292292300003,
								-14.988411926999959
							],
							[
								135.4755931850001,
								-14.973832116999972
							],
							[
								135.48827306300007,
								-14.987171986999954
							],
							[
								135.47047321500008,
								-14.970212145999938
							],
							[
								135.4311435190001,
								-14.910692684999958
							],
							[
								135.43304348900006,
								-14.90134272499995
							],
							[
								135.415493641,
								-14.870583033999935
							],
							[
								135.410823681,
								-14.872733033999964
							],
							[
								135.41282362200002,
								-14.85079318399994
							],
							[
								135.39378384400004,
								-14.808613452999964
							],
							[
								135.3937938050001,
								-14.771863612999937
							],
							[
								135.38208391700005,
								-14.725723871999946
							],
							[
								135.3933438360001,
								-14.719173831999967
							],
							[
								135.40530371500006,
								-14.736583702999951
							],
							[
								135.41634361500007,
								-14.735013662999961
							],
							[
								135.43469344400012,
								-14.71375365299997
							],
							[
								135.44049336400008,
								-14.694123692999938
							],
							[
								135.46501315400008,
								-14.675773633999938
							],
							[
								135.48487298300006,
								-14.66707358399998
							],
							[
								135.49950280200005,
								-14.675773444999948
							],
							[
								135.5191226510001,
								-14.653273474999935
							],
							[
								135.53468249000002,
								-14.657793395999931
							],
							[
								135.54106243,
								-14.652703395999936
							],
							[
								135.53955243000007,
								-14.642533445999959
							],
							[
								135.52745260100005,
								-14.640933494999956
							],
							[
								135.51842269200006,
								-14.625463584999977
							],
							[
								135.5366225030001,
								-14.561123764999934
							],
							[
								135.55519235300005,
								-14.536243764999938
							],
							[
								135.566792232,
								-14.53748371599994
							],
							[
								135.5684122120001,
								-14.514983774999962
							],
							[
								135.58952199200007,
								-14.505133705999981
							],
							[
								135.586571982,
								-14.48470374599998
							],
							[
								135.61962164200008,
								-14.423093735999942
							],
							[
								135.62811157200008,
								-14.427553675999945
							],
							[
								135.63100153200003,
								-14.419523695999942
							],
							[
								135.65629133000004,
								-14.41838357699993
							],
							[
								135.6703311990001,
								-14.42436351799995
							],
							[
								135.66775123000002,
								-14.399153566999928
							],
							[
								135.71257071000002,
								-14.334893617999967
							],
							[
								135.73015050000004,
								-14.296663677999959
							],
							[
								135.7025407320001,
								-14.271353906999934
							],
							[
								135.72289046100002,
								-14.284713827999951
							],
							[
								135.7470996300001,
								-14.278696238999942
							],
							[
								135.79403980900008,
								-14.226053608999962
							],
							[
								135.79115980900008,
								-14.231503608999958
							],
							[
								135.8158295070001,
								-14.228953429999933
							],
							[
								135.88145850500007,
								-14.181263031999947
							],
							[
								135.89303835500004,
								-14.181352941999933
							],
							[
								135.89827821400002,
								-14.193782821999946
							],
							[
								135.90359816400007,
								-14.190502801999969
							],
							[
								135.87877856600005,
								-14.166813150999928
							],
							[
								135.8948785770001,
								-14.107413380999958
							],
							[
								135.8901286470001,
								-14.107533430999979
							],
							[
								135.89114863700001,
								-14.094303510999964
							],
							[
								135.90524840700004,
								-14.074603500999956
							],
							[
								135.91466814800003,
								-14.033993640999938
							],
							[
								135.9097479090001,
								-13.990423840999938
							],
							[
								135.9410476490001,
								-13.95373368099996
							],
							[
								135.95575746800012,
								-13.949283561999948
							],
							[
								135.96991716900004,
								-13.91365362199997
							],
							[
								135.9890868980001,
								-13.896113541999966
							],
							[
								135.99168671900009,
								-13.857833681999978
							],
							[
								136.01574638900001,
								-13.828333632999943
							],
							[
								136.00642630000004,
								-13.791583841999966
							],
							[
								136.01349606100007,
								-13.762803861999942
							],
							[
								136.0351757400001,
								-13.746743712999944
							],
							[
								136.03426551100006,
								-13.716463781999948
							],
							[
								136.05539521100002,
								-13.694643662999965
							],
							[
								136.054875121,
								-13.68063368299994
							],
							[
								136.06913494100002,
								-13.669843612999955
							],
							[
								136.07559489000005,
								-13.67275355299995
							],
							[
								136.08223476000012,
								-13.66018354299996
							],
							[
								136.08283474100006,
								-13.655213542999945
							],
							[
								136.05142492200002,
								-13.644763791999935
							],
							[
								136.04007506300002,
								-13.656053841999949
							],
							[
								136.02591515400002,
								-13.652043951999929
							],
							[
								136.0336053320001,
								-13.68246383199994
							],
							[
								136.0200454730001,
								-13.691323931999932
							],
							[
								136.01242548300002,
								-13.688473980999959
							],
							[
								136.00905565300002,
								-13.70743399099996
							],
							[
								135.99568581300002,
								-13.714004080999928
							],
							[
								135.98829584400005,
								-13.709944120999978
							],
							[
								135.9781760740001,
								-13.73160416099995
							],
							[
								135.9562463540001,
								-13.743344339999965
							],
							[
								135.91450645600003,
								-13.747224728999981
							],
							[
								135.87939630900007,
								-13.712025087999962
							],
							[
								135.8778362600001,
								-13.700385117999929
							],
							[
								135.88911615000006,
								-13.68801501799993
							],
							[
								135.90637604900007,
								-13.678274837999936
							],
							[
								135.91872603800005,
								-13.681834738999953
							],
							[
								135.92164600800004,
								-13.67596472899993
							],
							[
								135.9074059290001,
								-13.658164837999948
							],
							[
								135.89290605000008,
								-13.669444977999945
							],
							[
								135.88063610100005,
								-13.669075086999953
							],
							[
								135.8712360410001,
								-13.656635166999934
							],
							[
								135.86517580300006,
								-13.62225531699994
							],
							[
								135.8430458140001,
								-13.612965565999957
							],
							[
								135.83529562500007,
								-13.590815735999968
							],
							[
								135.83974541600003,
								-13.566345804999969
							],
							[
								135.86928526400004,
								-13.561725555999942
							],
							[
								135.86505498500003,
								-13.53142573599996
							],
							[
								135.85505490600008,
								-13.519965875999958
							],
							[
								135.8623446470001,
								-13.49447592599995
							],
							[
								135.8576745470001,
								-13.482246044999954
							],
							[
								135.86370445700004,
								-13.476856034999969
							],
							[
								135.85973398800002,
								-13.440226284999937
							],
							[
								135.8726138180001,
								-13.428886214999977
							],
							[
								135.89433379700006,
								-13.425155985999936
							],
							[
								135.89946394600008,
								-13.438955875999966
							],
							[
								135.91271398600009,
								-13.44399571699995
							],
							[
								135.9195541250001,
								-13.462445546999959
							],
							[
								135.93125416400005,
								-13.466805406999981
							],
							[
								135.93573406400003,
								-13.45822540699993
							],
							[
								135.92734402500002,
								-13.450165526999967
							],
							[
								135.92946394500007,
								-13.442385556999966
							],
							[
								135.94531385400012,
								-13.434995416999982
							],
							[
								135.95183395300012,
								-13.448135277999938
							],
							[
								135.96108389300002,
								-13.445575197999972
							],
							[
								135.97299340400002,
								-13.402315277999946
							],
							[
								135.9651735440001,
								-13.41046530799997
							],
							[
								135.92646368600003,
								-13.417735696999955
							],
							[
								135.9190935360001,
								-13.404425845999981
							],
							[
								135.9256434560001,
								-13.396265816999971
							],
							[
								135.9209054270001,
								-13.37810021599995
							],
							[
								135.90589243800002,
								-13.379132225999967
							],
							[
								135.87990546000003,
								-13.362128224999935
							],
							[
								135.88330846000008,
								-13.332038214999955
							],
							[
								135.89339345000008,
								-13.312070224999957
							],
							[
								135.91316845000006,
								-13.294579214999942
							],
							[
								135.91163224100012,
								-13.280626564999977
							],
							[
								135.9480044600001,
								-13.252179205999937
							],
							[
								135.96411843700002,
								-13.295535216999951
							],
							[
								135.96375244800004,
								-13.272865206999938
							],
							[
								135.9761114590001,
								-13.232446226999969
							],
							[
								136.0037144380001,
								-13.21216121699996
							],
							[
								136.01669945700007,
								-13.217651217999958
							],
							[
								136.03037144600012,
								-13.243795217999946
							],
							[
								136.041586434,
								-13.28997021899994
							],
							[
								136.03615443400008,
								-13.299704218999977
							],
							[
								136.0463774630001,
								-13.310233208999932
							],
							[
								136.062078444,
								-13.262870218999979
							],
							[
								136.05007045500008,
								-13.23920721899998
							],
							[
								136.0615904450001,
								-13.22631421899996
							],
							[
								136.084416443,
								-13.232504219999953
							],
							[
								136.0781154540001,
								-13.208074218999968
							],
							[
								136.1077474340001,
								-13.172352209999929
							],
							[
								136.09744745500007,
								-13.161171219999972
							],
							[
								136.14525245400011,
								-13.120554210999956
							],
							[
								136.15256143300007,
								-13.143409220999956
							],
							[
								136.15036443200006,
								-13.183293230999936
							],
							[
								136.13701243200012,
								-13.19452322099994
							],
							[
								136.1341444420001,
								-13.207174230999954
							],
							[
								136.14793845100007,
								-13.220023221999952
							],
							[
								136.14561844000002,
								-13.235272211999927
							],
							[
								136.15506445900007,
								-13.266262231999974
							],
							[
								136.1811724270001,
								-13.281658222999965
							],
							[
								136.1836894370001,
								-13.274539222999977
							],
							[
								136.159489419,
								-13.252238231999968
							],
							[
								136.1622054290001,
								-13.24197922199994
							],
							[
								136.17551043900005,
								-13.233020232999934
							],
							[
								136.18547544800003,
								-13.24475122299998
							],
							[
								136.20088644700002,
								-13.247170232999963
							],
							[
								136.21361242700004,
								-13.233171223999932
							],
							[
								136.21464942800003,
								-13.20881122399993
							],
							[
								136.22159143800002,
								-13.202482223999937
							],
							[
								136.23788842700003,
								-13.204524213999946
							],
							[
								136.24467844600008,
								-13.214440213999978
							],
							[
								136.235462417,
								-13.186692213999947
							],
							[
								136.24747044700007,
								-13.173019213999964
							],
							[
								136.23587344800012,
								-13.169273223999937
							],
							[
								136.23132641900008,
								-13.15545922399997
							],
							[
								136.2139934490001,
								-13.154791222999961
							],
							[
								136.223483449,
								-13.147251232999963
							],
							[
								136.21905845000003,
								-13.137240212999927
							],
							[
								136.24328944800004,
								-13.146017223999934
							],
							[
								136.25395543900004,
								-13.121135223999943
							],
							[
								136.25660942700006,
								-13.154688233999934
							],
							[
								136.27562241600003,
								-13.158178224999972
							],
							[
								136.28856144600002,
								-13.145197234999955
							],
							[
								136.29222342600008,
								-13.14833322499993
							],
							[
								136.2824884360001,
								-13.14843121499996
							],
							[
								136.28287044600006,
								-13.168232234999948
							],
							[
								136.30859644400005,
								-13.16668922599996
							],
							[
								136.31619443400007,
								-13.15938022599994
							],
							[
								136.3070404550001,
								-13.144131225999956
							],
							[
								136.32141444500007,
								-13.119870215999981
							],
							[
								136.31138843600002,
								-13.108533235999971
							],
							[
								136.29146042700006,
								-13.107269214999974
							],
							[
								136.306887447,
								-13.093581214999972
							],
							[
								136.3085504170001,
								-13.072466224999971
							],
							[
								136.33203243700007,
								-13.04723921599998
							],
							[
								136.33284142700006,
								-13.032308215999933
							],
							[
								136.3350854470001,
								-13.044675225999981
							],
							[
								136.36473242500006,
								-13.056448226999976
							],
							[
								136.3722864240001,
								-13.072898216999931
							],
							[
								136.36374042400007,
								-13.092808236999929
							],
							[
								136.3703934230001,
								-13.106690226999945
							],
							[
								136.3547694140001,
								-13.116554226999938
							],
							[
								136.37137144200005,
								-13.139753227999961
							],
							[
								136.35626442300008,
								-13.14788922699995
							],
							[
								136.369768431,
								-13.167353227999968
							],
							[
								136.36638043100004,
								-13.196603227999958
							],
							[
								136.38087644000007,
								-13.203363238999941
							],
							[
								136.38826243900007,
								-13.226367228999948
							],
							[
								136.36809041900005,
								-13.252514218999977
							],
							[
								136.35795841900006,
								-13.254405237999947
							],
							[
								136.35071043000005,
								-13.245990227999926
							],
							[
								136.32809744100007,
								-13.250181216999977
							],
							[
								136.3380464290001,
								-13.277413217999936
							],
							[
								136.31888043000004,
								-13.298720226999933
							],
							[
								136.33169841900008,
								-13.31187622799996
							],
							[
								136.33081442800005,
								-13.32415422799994
							],
							[
								136.3439054480001,
								-13.32571222799993
							],
							[
								136.37367542700008,
								-13.291375228999982
							],
							[
								136.39860744800012,
								-13.24448222899997
							],
							[
								136.43695240600005,
								-13.230869219999931
							],
							[
								136.4395934360001,
								-13.217896229999951
							],
							[
								136.45424041500007,
								-13.224476230999926
							],
							[
								136.4467944150001,
								-13.248448240999949
							],
							[
								136.45569143400007,
								-13.25500723099998
							],
							[
								136.46876843400003,
								-13.247129221999955
							],
							[
								136.47595543400007,
								-13.23439123199995
							],
							[
								136.4732844350001,
								-13.206374220999976
							],
							[
								136.484072415,
								-13.18548223199997
							],
							[
								136.4838584160001,
								-13.16084824099994
							],
							[
								136.51107941500004,
								-13.139429241999949
							],
							[
								136.5316944340001,
								-13.154228242999977
							],
							[
								136.53993343500008,
								-13.10916124299996
							],
							[
								136.56706341500012,
								-13.059152222999955
							],
							[
								136.53378344700002,
								-13.052566221999939
							],
							[
								136.5354014180001,
								-13.018829231999973
							],
							[
								136.52955641800008,
								-13.022597221999945
							],
							[
								136.51043741900003,
								-13.015770220999968
							],
							[
								136.50776741000004,
								-12.996324220999952
							],
							[
								136.48471142100004,
								-12.997433229999956
							],
							[
								136.4806834310001,
								-13.007160229999954
							],
							[
								136.47822742200003,
								-12.995557229999974
							],
							[
								136.4537054430001,
								-12.991743238999959
							],
							[
								136.45396444300002,
								-12.979208228999937
							],
							[
								136.46333345300002,
								-12.973249228999975
							],
							[
								136.475083422,
								-12.977029219999963
							],
							[
								136.49237142100003,
								-12.992231229999959
							],
							[
								136.51948643000003,
								-12.976289220999945
							],
							[
								136.53186142900006,
								-12.991890240999965
							],
							[
								136.53169341900002,
								-12.982241230999932
							],
							[
								136.54266443900008,
								-12.978431231999934
							],
							[
								136.53901744000007,
								-12.969879231999926
							],
							[
								136.556290439,
								-12.964029241999981
							],
							[
								136.56497141800003,
								-12.980408231999945
							],
							[
								136.55146842800002,
								-12.987056221999978
							],
							[
								136.5692294370001,
								-12.998666232999938
							],
							[
								136.56239341700007,
								-13.018666232999976
							],
							[
								136.57005341700005,
								-13.013579232999973
							],
							[
								136.58163443600006,
								-13.018711222999968
							],
							[
								136.5870204460001,
								-13.013529222999978
							],
							[
								136.57913144600002,
								-13.007391242999972
							],
							[
								136.58184740700005,
								-12.998592232999954
							],
							[
								136.59805340600008,
								-12.98970122399993
							],
							[
								136.60076842600006,
								-12.97449622299996
							],
							[
								136.62080341600006,
								-12.967762223999955
							],
							[
								136.63519241400002,
								-13.002429224999958
							],
							[
								136.62936343400008,
								-13.01700722499993
							],
							[
								136.65513542200006,
								-13.015759235999951
							],
							[
								136.66821243200002,
								-13.004275235999955
							],
							[
								136.64550742400002,
								-12.990929244999961
							],
							[
								136.63810642500005,
								-12.950128233999976
							],
							[
								136.62535040600005,
								-12.952871243999937
							],
							[
								136.59788543800005,
								-12.929664232999926
							],
							[
								136.55902144000004,
								-12.913627231999953
							],
							[
								136.55685444000005,
								-12.919342231999963
							],
							[
								136.54681343100003,
								-12.916135230999942
							],
							[
								136.54298342200002,
								-12.89550424099997
							],
							[
								136.55287141200006,
								-12.873846230999959
							],
							[
								136.53897145200006,
								-12.881202240999926
							],
							[
								136.51864544400007,
								-12.87534822999993
							],
							[
								136.50550843500002,
								-12.85081023999993
							],
							[
								136.48252744600006,
								-12.843071218999967
							],
							[
								136.47786045700002,
								-12.828022227999952
							],
							[
								136.48159845700002,
								-12.81627822799993
							],
							[
								136.490418427,
								-12.813253238999948
							],
							[
								136.48847943700002,
								-12.801329228999975
							],
							[
								136.46876541900008,
								-12.79459722799993
							],
							[
								136.46552943900008,
								-12.780610227999944
							],
							[
								136.48413042900006,
								-12.768478217999927
							],
							[
								136.51663242600011,
								-12.806158228999948
							],
							[
								136.542617435,
								-12.80655022999997
							],
							[
								136.5311884450001,
								-12.800589229999957
							],
							[
								136.53539945500006,
								-12.792053239999973
							],
							[
								136.525131417,
								-12.75816422899993
							],
							[
								136.53350842700002,
								-12.744277229999966
							],
							[
								136.55061243600005,
								-12.740064219999965
							],
							[
								136.56677244500008,
								-12.762907230999929
							],
							[
								136.5854944240001,
								-12.770504230999961
							],
							[
								136.58074942300004,
								-12.798621240999978
							],
							[
								136.58512741200002,
								-12.81806923199997
							],
							[
								136.62168844000007,
								-12.839477232999968
							],
							[
								136.608871431,
								-12.814832231999958
							],
							[
								136.62501443200006,
								-12.77237323299994
							],
							[
								136.6207264530001,
								-12.756727231999946
							],
							[
								136.60258441400003,
								-12.746641231999945
							],
							[
								136.6063064340001,
								-12.722528241999953
							],
							[
								136.6329174540001,
								-12.699082231999967
							],
							[
								136.64866544300003,
								-12.702527222999947
							],
							[
								136.6523724230001,
								-12.711623232999955
							],
							[
								136.676954442,
								-12.704029243999969
							],
							[
								136.68591045100004,
								-12.712602233999974
							],
							[
								136.69445542100004,
								-12.710604233999959
							],
							[
								136.69949144100008,
								-12.703399243999968
							],
							[
								136.68127243200001,
								-12.687570233999963
							],
							[
								136.67843444300001,
								-12.668073232999973
							],
							[
								136.69291443300006,
								-12.627839233999964
							],
							[
								136.72890942300012,
								-12.58432922399993
							],
							[
								136.747555443,
								-12.574011244999951
							],
							[
								136.7622034420001,
								-12.57733323499997
							],
							[
								136.7472804130001,
								-12.551017244999969
							],
							[
								136.734872203,
								-12.570910603999948
							],
							[
								136.72373222400006,
								-12.562760763999961
							],
							[
								136.71578245400008,
								-12.57189082399998
							],
							[
								136.6971526650001,
								-12.569151052999928
							],
							[
								136.69608281500007,
								-12.586651052999969
							],
							[
								136.68296292500008,
								-12.590801192999947
							],
							[
								136.6816830250001,
								-12.598591192999947
							],
							[
								136.67686297500006,
								-12.593611272999965
							],
							[
								136.68040307500007,
								-12.603561212999978
							],
							[
								136.669272986,
								-12.590551352999967
							],
							[
								136.6758528360001,
								-12.58119129299996
							],
							[
								136.69309284500002,
								-12.58619108299996
							],
							[
								136.69647260500005,
								-12.56463107299993
							],
							[
								136.71430241500002,
								-12.566250843999967
							],
							[
								136.71535233500003,
								-12.557210853999948
							],
							[
								136.725482144,
								-12.553170733999934
							],
							[
								136.7309821440001,
								-12.56289067399996
							],
							[
								136.73852242400005,
								-12.553782233999982
							],
							[
								136.74860744400007,
								-12.533761234999929
							],
							[
								136.73289142500005,
								-12.535490223999943
							],
							[
								136.72698641500006,
								-12.528513233999945
							],
							[
								136.74271744500004,
								-12.519054233999952
							],
							[
								136.726376436,
								-12.503213243999937
							],
							[
								136.72572045700008,
								-12.481826242999944
							],
							[
								136.7815054450001,
								-12.448702234999928
							],
							[
								136.79377342500004,
								-12.451870224999936
							],
							[
								136.79543643300008,
								-12.492702245999965
							],
							[
								136.775646434,
								-12.49619123499997
							],
							[
								136.77456241400012,
								-12.510490234999963
							],
							[
								136.76085944400006,
								-12.525818244999982
							],
							[
								136.77265543200008,
								-12.555569245999948
							],
							[
								136.77274643300007,
								-12.536099234999938
							],
							[
								136.78202444300007,
								-12.52150824599994
							],
							[
								136.80517142200006,
								-12.506603235999933
							],
							[
								136.8496504320001,
								-12.446227226999952
							],
							[
								136.89023745200006,
								-12.41341923799996
							],
							[
								136.90249042200003,
								-12.390012247999948
							],
							[
								136.94568744100002,
								-12.369149239999956
							],
							[
								136.9637684500001,
								-12.374058229999946
							],
							[
								136.96192242000006,
								-12.36410023999997
							],
							[
								136.97937844000012,
								-12.345211240999959
							],
							[
								136.965005431,
								-12.340050239999925
							],
							[
								136.9657374400001,
								-12.349270229999945
							],
							[
								136.94345945100008,
								-12.358001229999957
							],
							[
								136.92156342300007,
								-12.342803238999977
							],
							[
								136.91027142200005,
								-12.367785238999943
							],
							[
								136.88186143300004,
								-12.367701247999946
							],
							[
								136.87070644400012,
								-12.381769236999958
							],
							[
								136.87777142400012,
								-12.36713023699997
							],
							[
								136.89765344300008,
								-12.362551227999973
							],
							[
								136.91512643300007,
								-12.34092323799996
							],
							[
								136.92654243200002,
								-12.341925228999969
							],
							[
								136.93381443200008,
								-12.334661248999964
							],
							[
								136.93778643300004,
								-12.321990238999945
							],
							[
								136.926804424,
								-12.280676247999963
							],
							[
								136.90119442600007,
								-12.279489227999932
							],
							[
								136.902566427,
								-12.24754523699994
							],
							[
								136.88545441700012,
								-12.24663624699997
							],
							[
								136.8723084390001,
								-12.218575235999936
							],
							[
								136.81284545200003,
								-12.207315233999964
							],
							[
								136.79064345400002,
								-12.185549242999969
							],
							[
								136.78208343500012,
								-12.158596242999977
							],
							[
								136.72759444700011,
								-12.171792230999927
							],
							[
								136.72600746700004,
								-12.181352230999948
							],
							[
								136.71135643700006,
								-12.186753240999963
							],
							[
								136.68073643900004,
								-12.186306239999965
							],
							[
								136.67800843800012,
								-12.20169723999993
							],
							[
								136.69889643800002,
								-12.18968721999994
							],
							[
								136.72983645500005,
								-12.213291230999971
							],
							[
								136.72259642500012,
								-12.22932124099998
							],
							[
								136.74813146500003,
								-12.214163221999968
							],
							[
								136.75065146400004,
								-12.232829221999964
							],
							[
								136.7620184330001,
								-12.233188242999972
							],
							[
								136.76473545300007,
								-12.24261622299997
							],
							[
								136.74177046300008,
								-12.272261231999948
							],
							[
								136.72645144400008,
								-12.275664241999948
							],
							[
								136.72104944400007,
								-12.266805231999967
							],
							[
								136.70734745400011,
								-12.288152240999977
							],
							[
								136.69192146500006,
								-12.27534222099996
							],
							[
								136.6648364560001,
								-12.28342422999998
							],
							[
								136.64881543700005,
								-12.270125218999965
							],
							[
								136.6464044390001,
								-12.235265228999936
							],
							[
								136.60259644100006,
								-12.20596222699993
							],
							[
								136.5792954640001,
								-12.153752225999938
							],
							[
								136.58669544500003,
								-12.126044225999976
							],
							[
								136.58161544600011,
								-12.106870235999963
							],
							[
								136.590526446,
								-12.094622235999964
							],
							[
								136.58683446600003,
								-12.084066225999948
							],
							[
								136.5714064670001,
								-12.086813234999966
							],
							[
								136.5624344370001,
								-12.078724214999966
							],
							[
								136.53101546200003,
								-11.991355232999979
							],
							[
								136.51656646200001,
								-11.98741223299993
							],
							[
								136.50344446300005,
								-11.996872222999968
							],
							[
								136.50558047200002,
								-12.003373212999975
							],
							[
								136.4951424620001,
								-12.010518231999981
							],
							[
								136.49817948200007,
								-12.03078622299995
							],
							[
								136.49215245200003,
								-12.027835231999973
							],
							[
								136.48994044200003,
								-12.037558221999973
							],
							[
								136.48957347200007,
								-12.024881221999976
							],
							[
								136.47565847300007,
								-12.01577223199996
							],
							[
								136.46956946400007,
								-12.000071221999974
							],
							[
								136.45588247400008,
								-12.006163220999952
							],
							[
								136.45711847400003,
								-12.000082210999949
							],
							[
								136.4453694550001,
								-11.998297220999973
							],
							[
								136.45254145500007,
								-11.998805210999933
							],
							[
								136.44927546500003,
								-11.985361230999956
							],
							[
								136.45684447500003,
								-11.978447220999954
							],
							[
								136.47265145400002,
								-11.997772231999932
							],
							[
								136.47156846500002,
								-11.961381210999946
							],
							[
								136.5473274620001,
								-11.942289212999981
							],
							[
								136.580774452,
								-11.91573722399994
							],
							[
								136.58236147200012,
								-11.904068213999949
							],
							[
								136.5694824530001,
								-11.895355213999949
							],
							[
								136.56292146400006,
								-11.876837232999947
							],
							[
								136.55758148400002,
								-11.886687222999967
							],
							[
								136.57386245300006,
								-11.901992223999969
							],
							[
								136.56162447300005,
								-11.917743233999943
							],
							[
								136.5482734630001,
								-11.923406222999972
							],
							[
								136.53141346400002,
								-11.914816212999938
							],
							[
								136.52378346400008,
								-11.939263222999955
							],
							[
								136.51658146400007,
								-11.941969221999955
							],
							[
								136.51424645400004,
								-11.935958221999954
							],
							[
								136.50785347400006,
								-11.946994221999944
							],
							[
								136.490748445,
								-11.952936221999948
							],
							[
								136.4432024570001,
								-11.941402229999937
							],
							[
								136.44570445600004,
								-11.955773209999961
							],
							[
								136.43134645700002,
								-11.970980209999937
							],
							[
								136.4258234570001,
								-11.958474209999963
							],
							[
								136.4154614680001,
								-11.95777120899993
							],
							[
								136.38113047800005,
								-11.998357218999956
							],
							[
								136.3860594780001,
								-12.002399228999934
							],
							[
								136.37914747700006,
								-12.020334218999949
							],
							[
								136.36774844800004,
								-12.011491217999946
							],
							[
								136.36970247700003,
								-12.028294208999966
							],
							[
								136.35715844800006,
								-12.021904217999975
							],
							[
								136.35473346800006,
								-12.031688217999942
							],
							[
								136.3437784680001,
								-12.033522217999973
							],
							[
								136.3491794780001,
								-12.043853207999973
							],
							[
								136.34115246800002,
								-12.048455217999958
							],
							[
								136.3414734480001,
								-12.057628217999934
							],
							[
								136.33195246800005,
								-12.060599227999944
							],
							[
								136.32626145900008,
								-12.04554621699998
							],
							[
								136.30911046900007,
								-12.05592521699998
							],
							[
								136.30224347,
								-12.049015206999968
							],
							[
								136.26463146100002,
								-12.066933215999939
							],
							[
								136.26696648100005,
								-12.072949215999927
							],
							[
								136.24505546000012,
								-12.112968205999948
							],
							[
								136.2322224610001,
								-12.116824214999951
							],
							[
								136.23170346000006,
								-12.13320321499998
							],
							[
								136.21212647100003,
								-12.132316214999946
							],
							[
								136.21635346000005,
								-12.153410204999943
							],
							[
								136.20652748100008,
								-12.151926214999946
							],
							[
								136.1946704510001,
								-12.163746214999946
							],
							[
								136.176284462,
								-12.158561213999974
							],
							[
								136.1671594620001,
								-12.163540213999966
							],
							[
								136.17590248200008,
								-12.170333213999982
							],
							[
								136.16844148200005,
								-12.177809213999979
							],
							[
								136.16998247100003,
								-12.19211622399996
							],
							[
								136.19046047000006,
								-12.19631220499997
							],
							[
								136.21627746900003,
								-12.185623224999972
							],
							[
								136.22892646800005,
								-12.214377215999946
							],
							[
								136.29279945500002,
								-12.205296217999944
							],
							[
								136.3156104640001,
								-12.211366218999956
							],
							[
								136.3319984540001,
								-12.202616218999935
							],
							[
								136.35108747200002,
								-12.213368209999942
							],
							[
								136.36367545100006,
								-12.250410229999943
							],
							[
								136.37821745000008,
								-12.24714622099998
							],
							[
								136.34359647100007,
								-12.262009229999933
							],
							[
								136.35395644000005,
								-12.274411219999934
							],
							[
								136.35211046000006,
								-12.286811219999947
							],
							[
								136.34280245000002,
								-12.301333219999947
							],
							[
								136.32490445100007,
								-12.306797229999972
							],
							[
								136.33387644000004,
								-12.323196219999943
							],
							[
								136.32575843900008,
								-12.344220209999946
							],
							[
								136.30435145,
								-12.365694218999977
							],
							[
								136.3037864590001,
								-12.376983208999945
							],
							[
								136.31137046900005,
								-12.381616219999955
							],
							[
								136.30412244900003,
								-12.400204229999929
							],
							[
								136.23606845000006,
								-12.45433020799993
							],
							[
								136.22023147000004,
								-12.478977227999962
							],
							[
								136.2231304400001,
								-12.462147217999927
							],
							[
								136.19638145200008,
								-12.467964206999966
							],
							[
								136.16041647300005,
								-12.462587225999926
							],
							[
								136.16018747400005,
								-12.446692205999966
							],
							[
								136.15113945500002,
								-12.435825214999966
							],
							[
								136.12178148600003,
								-12.448753214999954
							],
							[
								136.1076524760001,
								-12.439267213999926
							],
							[
								136.10408244600012,
								-12.454303213999935
							],
							[
								136.08537546700006,
								-12.457688213999973
							],
							[
								136.0732434580001,
								-12.44705221299995
							],
							[
								136.0758534580001,
								-12.43586621299994
							],
							[
								136.0642404790001,
								-12.430100222999954
							],
							[
								136.04699947900008,
								-12.454207222999969
							],
							[
								136.04634247800004,
								-12.471072202999949
							],
							[
								136.0372184680001,
								-12.484324221999941
							],
							[
								136.03659245900008,
								-12.47486620199993
							],
							[
								136.030855459,
								-12.474612221999962
							],
							[
								136.01648244900002,
								-12.493561211999975
							],
							[
								136.01776346000008,
								-12.460234201999981
							],
							[
								135.9962344810001,
								-12.443497210999965
							],
							[
								136.0148184620001,
								-12.396607210999946
							],
							[
								135.9993774630001,
								-12.400627200999963
							],
							[
								135.97809146400004,
								-12.39429819999998
							],
							[
								135.96982045400011,
								-12.414074199999959
							],
							[
								135.96708846400008,
								-12.404795209999975
							],
							[
								135.97607648500002,
								-12.369892209999932
							],
							[
								135.995806484,
								-12.36038420999995
							],
							[
								136.00811947400007,
								-12.331064199999958
							],
							[
								136.0232404740001,
								-12.319753210999977
							],
							[
								136.00709747500002,
								-12.29708721999998
							],
							[
								136.00888148500007,
								-12.290404199999955
							],
							[
								136.02943547400002,
								-12.296188210999958
							],
							[
								136.03331147500012,
								-12.271543210999937
							],
							[
								136.05392547400004,
								-12.269457210999974
							],
							[
								136.0610514750001,
								-12.241056210999943
							],
							[
								136.04866045500012,
								-12.232099210999934
							],
							[
								136.02684148600008,
								-12.24048320999998
							],
							[
								136.01347548700005,
								-12.233588199999929
							],
							[
								136.001695476,
								-12.268190219999951
							],
							[
								135.96893547800005,
								-12.274005208999938
							],
							[
								135.95460747900006,
								-12.260816207999937
							],
							[
								135.95622446900006,
								-12.249098217999972
							],
							[
								135.93361148000008,
								-12.23772620699998
							],
							[
								135.9283774910001,
								-12.223909206999963
							],
							[
								135.94279648100007,
								-12.199174206999942
							],
							[
								135.95559849100005,
								-12.198050197999976
							],
							[
								135.9572454810001,
								-12.183385217999955
							],
							[
								135.97352748000003,
								-12.186098197999968
							],
							[
								135.9832164710001,
								-12.15237721799997
							],
							[
								136.01162749000002,
								-12.124334218999934
							],
							[
								136.0280774910001,
								-12.087435208999977
							],
							[
								136.04412848000004,
								-12.076097198999946
							],
							[
								136.04507448100003,
								-12.063069208999934
							],
							[
								136.04046647100006,
								-12.069975198999941
							],
							[
								136.03418048100002,
								-12.067019218999974
							],
							[
								136.03112849100012,
								-12.076787218999982
							],
							[
								136.01101746200004,
								-12.079910197999936
							],
							[
								136.0086215020001,
								-12.087830217999965
							],
							[
								136.00337349200004,
								-12.08443320799995
							],
							[
								135.9971774720001,
								-12.092978207999977
							],
							[
								136.003479491,
								-12.100004217999981
							],
							[
								135.99672049100002,
								-12.105941217999941
							],
							[
								136.00117550100003,
								-12.11818719799993
							],
							[
								135.97148249200006,
								-12.138420207999957
							],
							[
								135.96011449200012,
								-12.137270206999972
							],
							[
								135.9593984720001,
								-12.152190197999971
							],
							[
								135.9507914820001,
								-12.151833206999981
							],
							[
								135.9493114830001,
								-12.13860320699996
							],
							[
								135.94771048200005,
								-12.15191019699995
							],
							[
								135.93533450300004,
								-12.144075206999958
							],
							[
								135.92900346300007,
								-12.162550196999973
							],
							[
								135.92227447400012,
								-12.149551205999956
							],
							[
								135.91208049400007,
								-12.150553205999927
							],
							[
								135.89288547400008,
								-12.190408205999972
							],
							[
								135.8795034850001,
								-12.169102214999953
							],
							[
								135.88588149500004,
								-12.149718204999942
							],
							[
								135.86673249600005,
								-12.157869194999932
							],
							[
								135.8656794750001,
								-12.173769204999928
							],
							[
								135.85528846600005,
								-12.169456214999968
							],
							[
								135.85385449600005,
								-12.18269821499996
							],
							[
								135.83944947600003,
								-12.182087213999978
							],
							[
								135.83192748600004,
								-12.191501193999954
							],
							[
								135.82561050700008,
								-12.184408203999965
							],
							[
								135.8168974770001,
								-12.201147203999938
							],
							[
								135.8039284770001,
								-12.199124193999978
							],
							[
								135.79620650700008,
								-12.214769202999946
							],
							[
								135.77896547800003,
								-12.224694212999964
							],
							[
								135.78045949700004,
								-12.245682202999944
							],
							[
								135.76996249700005,
								-12.270653202999938
							],
							[
								135.76608648700005,
								-12.25484419299994
							],
							[
								135.74608247800006,
								-12.26325620199998
							],
							[
								135.73286849800002,
								-12.290253191999966
							],
							[
								135.71092750800005,
								-12.311220211999967
							],
							[
								135.7216524790001,
								-12.281813201999967
							],
							[
								135.7094014800001,
								-12.261823210999978
							],
							[
								135.67668551200006,
								-12.241030209999963
							],
							[
								135.6519365040001,
								-12.201693198999976
							],
							[
								135.65419450500008,
								-12.15665619899994
							],
							[
								135.7006104940001,
								-12.126593199999945
							],
							[
								135.7143894940001,
								-12.104314209999927
							],
							[
								135.72800049400007,
								-12.102221190999956
							],
							[
								135.7310514940001,
								-12.09124720099993
							],
							[
								135.74412849300006,
								-12.091324190999956
							],
							[
								135.7464635130001,
								-12.08139221099998
							],
							[
								135.75859348300003,
								-12.079784210999946
							],
							[
								135.77293648300008,
								-12.04452521099995
							],
							[
								135.7946804830001,
								-12.034712191999972
							],
							[
								135.83299548200011,
								-12.00123221299998
							],
							[
								135.82690647200002,
								-11.994625192999933
							],
							[
								135.83149949200003,
								-11.98462920299994
							],
							[
								135.86982850100003,
								-11.975998213999958
							],
							[
								135.87719847000005,
								-11.986498203999929
							],
							[
								135.91259847000003,
								-11.959419194999953
							],
							[
								135.91047750000007,
								-11.952537194999934
							],
							[
								135.885728491,
								-11.966173193999964
							],
							[
								135.80883949300005,
								-11.98150020199995
							],
							[
								135.75133147500003,
								-12.009441200999959
							],
							[
								135.7270844960001,
								-12.009660199999928
							],
							[
								135.686084477,
								-12.034130198999947
							],
							[
								135.6543464890001,
								-12.039296197999931
							],
							[
								135.63582248900002,
								-12.061417197999958
							],
							[
								135.56953951100002,
								-12.100640195999972
							],
							[
								135.54497249200006,
								-12.088144205999981
							],
							[
								135.53870150300008,
								-12.06504619499998
							],
							[
								135.51956751400007,
								-12.060525204999976
							],
							[
								135.50743651400012,
								-12.086647203999973
							],
							[
								135.4527345150001,
								-12.114846192999948
							],
							[
								135.41567150700007,
								-12.11534020199997
							],
							[
								135.40650051800003,
								-12.101212191999934
							],
							[
								135.42241549800008,
								-12.083427201999939
							],
							[
								135.39726849900012,
								-12.082543201999954
							],
							[
								135.3842235090001,
								-12.093625190999944
							],
							[
								135.36623153000005,
								-12.085237180999968
							],
							[
								135.3514324900001,
								-12.107401180999943
							],
							[
								135.3054565120001,
								-12.124758198999928
							],
							[
								135.30403750100004,
								-12.13638218999995
							],
							[
								135.31778552100002,
								-12.144233179999958
							],
							[
								135.30533551100007,
								-12.161551179999947
							],
							[
								135.28421752200006,
								-12.164453178999963
							],
							[
								135.2690655020001,
								-12.180043188999946
							],
							[
								135.235602523,
								-12.182621177999977
							],
							[
								135.222801494,
								-12.19000819799993
							],
							[
								135.24085249300003,
								-12.193457187999968
							],
							[
								135.252937502,
								-12.207563198999935
							],
							[
								135.27228553100008,
								-12.207238188999952
							],
							[
								135.28621652000004,
								-12.227119199999947
							],
							[
								135.31426150800007,
								-12.242490200999953
							],
							[
								135.35291351700005,
								-12.231002201999956
							],
							[
								135.34273552700006,
								-12.246642190999978
							],
							[
								135.2967315090001,
								-12.257760189999942
							],
							[
								135.28360749900003,
								-12.254078189999973
							],
							[
								135.26630453100006,
								-12.224913178999941
							],
							[
								135.20667349300004,
								-12.23484218799996
							],
							[
								135.19298552400005,
								-12.225950176999959
							],
							[
								135.1612185150001,
								-12.22553318699994
							],
							[
								135.1595085250001,
								-12.232750186999965
							],
							[
								135.18003152400001,
								-12.238278186999935
							],
							[
								135.18666952400008,
								-12.246350186999962
							],
							[
								135.18270150400008,
								-12.254436186999953
							],
							[
								135.21013650200007,
								-12.274924197999951
							],
							[
								135.2184675210001,
								-12.288865188999978
							],
							[
								135.2127935210001,
								-12.29598318799998
							],
							[
								135.164086504,
								-12.265075176999972
							],
							[
								135.15952451500004,
								-12.249517176999973
							],
							[
								135.1445105360001,
								-12.237045185999932
							],
							[
								135.13845350600002,
								-12.243073185999947
							],
							[
								135.12432252700012,
								-12.23765018599994
							],
							[
								135.05584250900006,
								-12.262296183999979
							],
							[
								135.00554854300003,
								-12.214891192999971
							],
							[
								134.98496451500012,
								-12.172780171999932
							],
							[
								134.97057552600006,
								-12.158570170999951
							],
							[
								134.93963151800006,
								-12.144184189999976
							],
							[
								134.90555850900012,
								-12.152097169999934
							],
							[
								134.8844865200001,
								-12.135430188999976
							],
							[
								134.8557545220001,
								-12.132172167999954
							],
							[
								134.84203753300005,
								-12.11382318799997
							],
							[
								134.8434555240001,
								-12.061241176999943
							],
							[
								134.79851854600008,
								-12.049429175999933
							],
							[
								134.77965954800004,
								-12.00416916599994
							],
							[
								134.7649495390001,
								-12.000900184999978
							],
							[
								134.7721515290001,
								-11.959454174999962
							],
							[
								134.74857655100004,
								-11.949119183999926
							],
							[
								134.7400775210001,
								-11.95996917399998
							],
							[
								134.70298454200008,
								-11.966876162999938
							],
							[
								134.6890075330001,
								-11.962255182999968
							],
							[
								134.6571785430001,
								-12.015666172999943
							],
							[
								134.6045355450001,
								-12.050475161999941
							],
							[
								134.49557454900003,
								-12.07265216999997
							],
							[
								134.47099256,
								-12.072291178999933
							],
							[
								134.4665825610001,
								-12.065228168999965
							],
							[
								134.4195095330001,
								-12.065943157999982
							],
							[
								134.39567456400005,
								-12.052601166999978
							],
							[
								134.36224355600007,
								-12.046790165999937
							],
							[
								134.30780055900004,
								-12.010182154999939
							],
							[
								134.28627056000005,
								-11.98332417399996
							],
							[
								134.26023956100005,
								-11.988842163999948
							],
							[
								134.24597256200002,
								-11.984570162999944
							],
							[
								134.2538305710001,
								-12.034563163999962
							],
							[
								134.22841054200012,
								-12.037051172999952
							],
							[
								134.19363557200006,
								-12.075144162999948
							],
							[
								134.18907354200007,
								-12.104374162999932
							],
							[
								134.17982755200012,
								-12.116827162999925
							],
							[
								134.18239058200004,
								-12.135510162999935
							],
							[
								134.16233956300005,
								-12.10104516299998
							],
							[
								134.19426155300005,
								-12.02957317299996
							],
							[
								134.1809095540001,
								-12.01548816199994
							],
							[
								134.18251256500002,
								-11.994277171999954
							],
							[
								134.173280545,
								-12.002656171999945
							],
							[
								134.1511405560001,
								-11.984577160999947
							],
							[
								134.15318558700005,
								-11.968259160999935
							],
							[
								134.17007555600003,
								-11.971993161999933
							],
							[
								134.17579857600003,
								-11.95616617199994
							],
							[
								134.16792457600002,
								-11.955338161999975
							],
							[
								134.135499578,
								-11.920282160999932
							],
							[
								134.13156258900005,
								-11.900045159999934
							],
							[
								134.12083658900008,
								-11.89669116999994
							],
							[
								134.12228657900005,
								-11.906413159999943
							],
							[
								134.10988056000008,
								-11.90816215999996
							],
							[
								134.1021745700001,
								-11.924367169999925
							],
							[
								134.08563456000002,
								-11.926758159999963
							],
							[
								134.0758225610001,
								-11.936505158999978
							],
							[
								134.06886559100008,
								-11.91747315899994
							],
							[
								134.08081258100003,
								-11.904607168999974
							],
							[
								134.07873756100003,
								-11.897868148999976
							],
							[
								134.06355557200004,
								-11.891690148999942
							],
							[
								134.06428757300012,
								-11.869933148999962
							],
							[
								134.0388965740001,
								-11.855303167999978
							],
							[
								134.00543556500008,
								-11.863928166999926
							],
							[
								133.9800755860001,
								-11.89785616699993
							],
							[
								133.91592756800003,
								-11.92093015599994
							],
							[
								133.9131055680001,
								-11.907100145999948
							],
							[
								133.88074157000005,
								-11.912530154999956
							],
							[
								133.85913459100004,
								-11.878239144999952
							],
							[
								133.83914657200012,
								-11.876969163999945
							],
							[
								133.82323158400004,
								-11.841294153999968
							],
							[
								133.84727859300006,
								-11.813572153999928
							],
							[
								133.86758759200006,
								-11.805580153999927
							],
							[
								133.89068957100005,
								-11.813051164999933
							],
							[
								133.90216356100007,
								-11.806751154999972
							],
							[
								133.90582557100004,
								-11.785706164999965
							],
							[
								133.91533258100003,
								-11.77456415499995
							],
							[
								133.92456358100003,
								-11.768690164999953
							],
							[
								133.93432857000005,
								-11.776533164999933
							],
							[
								133.94118057000003,
								-11.771088144999965
							],
							[
								133.92853058100002,
								-11.765287154999953
							],
							[
								133.91639958200005,
								-11.743379164999965
							],
							[
								133.8990055820001,
								-11.75524315399997
							],
							[
								133.86790857300002,
								-11.755073163999953
							],
							[
								133.84965959400006,
								-11.74658715299995
							],
							[
								133.8372075850001,
								-11.723426152999934
							],
							[
								133.81459459600012,
								-11.730930162999925
							],
							[
								133.7944675770001,
								-11.725590151999938
							],
							[
								133.77800458800004,
								-11.740758151999955
							],
							[
								133.77350358700005,
								-11.76271116199996
							],
							[
								133.73955157800003,
								-11.783130151999956
							],
							[
								133.69136658000002,
								-11.783668140999964
							],
							[
								133.66855459200008,
								-11.776020149999965
							],
							[
								133.66478458200004,
								-11.780283139999938
							],
							[
								133.67915960100004,
								-11.789162140999963
							],
							[
								133.65666760200008,
								-11.809376149999935
							],
							[
								133.66394658100012,
								-11.819336139999962
							],
							[
								133.6386925920001,
								-11.826107139999976
							],
							[
								133.63069760200005,
								-11.837138159999938
							],
							[
								133.61118159300008,
								-11.843336159999978
							],
							[
								133.6041936030001,
								-11.83944613999995
							],
							[
								133.59859260400003,
								-11.832910148999929
							],
							[
								133.60495561400012,
								-11.81108613899994
							],
							[
								133.5633916060001,
								-11.80844013899997
							],
							[
								133.55521260600005,
								-11.825812138999936
							],
							[
								133.54254758600007,
								-11.825087147999966
							],
							[
								133.53139460600005,
								-11.861650157999975
							],
							[
								133.51769159600008,
								-11.877037137999935
							],
							[
								133.51309858700006,
								-11.863215147999938
							],
							[
								133.52936458600004,
								-11.84239514799998
							],
							[
								133.52439058700008,
								-11.82223014799996
							],
							[
								133.53266060700003,
								-11.811052157999939
							],
							[
								133.52901360700002,
								-11.79176814799996
							],
							[
								133.5396945970001,
								-11.77045114799995
							],
							[
								133.53435358800004,
								-11.760987137999962
							],
							[
								133.50153260900004,
								-11.782042136999962
							],
							[
								133.47962159000008,
								-11.781982146999951
							],
							[
								133.4773176000001,
								-11.790486146999967
							],
							[
								133.45621461000007,
								-11.80247015699996
							],
							[
								133.4469216010001,
								-11.790540145999955
							],
							[
								133.4475936010001,
								-11.779148145999955
							],
							[
								133.43694360200004,
								-11.77469713599993
							],
							[
								133.4085466030001,
								-11.78028915599998
							],
							[
								133.39815560300008,
								-11.768572134999943
							],
							[
								133.39794160400004,
								-11.75767114499996
							],
							[
								133.41423761300007,
								-11.758032154999967
							],
							[
								133.40946260300007,
								-11.74742813499995
							],
							[
								133.41527559300005,
								-11.740619134999974
							],
							[
								133.40189360400007,
								-11.732736144999933
							],
							[
								133.38294261400006,
								-11.754547144999947
							],
							[
								133.3685996150001,
								-11.758321144999968
							],
							[
								133.37596962400005,
								-11.768499134999956
							],
							[
								133.3695916150001,
								-11.77709314499998
							],
							[
								133.35726260500007,
								-11.777336144999936
							],
							[
								133.35244059600006,
								-11.765270143999942
							],
							[
								133.31652159700002,
								-11.767829143999961
							],
							[
								133.30738159800012,
								-11.742233152999972
							],
							[
								133.31647560800002,
								-11.725211152999975
							],
							[
								133.33994361700002,
								-11.727994143999979
							],
							[
								133.344718617,
								-11.71939813399996
							],
							[
								133.35358461600003,
								-11.719452143999945
							],
							[
								133.3499526070001,
								-11.701685143999953
							],
							[
								133.33986659700008,
								-11.693982133999953
							],
							[
								133.29506759900005,
								-11.703047132999927
							],
							[
								133.28359261900005,
								-11.718057142999953
							],
							[
								133.24926159100005,
								-11.732867131999967
							],
							[
								133.1912026130001,
								-11.725553140999978
							],
							[
								133.15284162500006,
								-11.706942140999956
							],
							[
								133.13045760700004,
								-11.663727139999935
							],
							[
								133.10561563800002,
								-11.634554138999931
							],
							[
								133.09385161000012,
								-11.592552148999971
							],
							[
								133.0709026410001,
								-11.555523137999955
							],
							[
								133.07564764200004,
								-11.520305147999977
							],
							[
								133.04606063300002,
								-11.504487126999948
							],
							[
								133.0072426260001,
								-11.433236135999948
							],
							[
								132.96888163800008,
								-11.417679134999958
							],
							[
								132.94564264000007,
								-11.368823124999949
							],
							[
								132.9340166300001,
								-11.364566133999972
							],
							[
								132.91826863100005,
								-11.33224413399995
							],
							[
								132.89803562200007,
								-11.340616143999966
							],
							[
								132.8724016330001,
								-11.330124122999962
							],
							[
								132.8650616330001,
								-11.340157132999934
							],
							[
								132.8804576230001,
								-11.34791413299996
							],
							[
								132.89313765200006,
								-11.371481133999964
							],
							[
								132.90920564100009,
								-11.384669133999978
							],
							[
								132.89988263100008,
								-11.403094133999957
							],
							[
								132.9030716300001,
								-11.419331123999939
							],
							[
								132.89574762100006,
								-11.427036133999934
							],
							[
								132.88293064100003,
								-11.429706133999957
							],
							[
								132.8736226320001,
								-11.417601133999938
							],
							[
								132.85847064200004,
								-11.414119143999926
							],
							[
								132.84896462300003,
								-11.392585142999962
							],
							[
								132.82358861400007,
								-11.404162142999951
							],
							[
								132.82572561400002,
								-11.42027914299996
							],
							[
								132.80791862400008,
								-11.441793142999927
							],
							[
								132.784573625,
								-11.44616713299996
							],
							[
								132.77845465500002,
								-11.469983122999963
							],
							[
								132.76434064500006,
								-11.487711142999956
							],
							[
								132.7476166460001,
								-11.495716122999966
							],
							[
								132.73414365600001,
								-11.518111132999934
							],
							[
								132.71815263700012,
								-11.524002121999956
							],
							[
								132.69370862800008,
								-11.51421413199995
							],
							[
								132.6683936490001,
								-11.516231121999965
							],
							[
								132.639600631,
								-11.481570140999963
							],
							[
								132.62701163200006,
								-11.417067129999964
							],
							[
								132.5857526540001,
								-11.395368128999962
							],
							[
								132.57093664500007,
								-11.37350411899996
							],
							[
								132.55720363600005,
								-11.36574412899995
							],
							[
								132.5476826460001,
								-11.342676128999926
							],
							[
								132.532819667,
								-11.339731137999934
							],
							[
								132.52035363800007,
								-11.345486127999948
							],
							[
								132.51257165800007,
								-11.330728127999976
							],
							[
								132.50186065900004,
								-11.330205127999932
							],
							[
								132.50459165900008,
								-11.31867111799994
							],
							[
								132.51801865800007,
								-11.317482127999938
							],
							[
								132.50591865900003,
								-11.311641117999955
							],
							[
								132.512861648,
								-11.303948137999953
							],
							[
								132.5102066390001,
								-11.29248612799995
							],
							[
								132.48707466000008,
								-11.300046136999981
							],
							[
								132.49787762900007,
								-11.28235813699996
							],
							[
								132.5056596490001,
								-11.284966117999943
							],
							[
								132.5069256590001,
								-11.272284126999978
							],
							[
								132.47770565100006,
								-11.259411126999964
							],
							[
								132.4509876520001,
								-11.217876125999965
							],
							[
								132.43353164300004,
								-11.211703115999967
							],
							[
								132.41989064300003,
								-11.22714612599998
							],
							[
								132.41439666300005,
								-11.23902712599994
							],
							[
								132.4232016630001,
								-11.261814125999933
							],
							[
								132.41467165300003,
								-11.27068912599998
							],
							[
								132.40890366300005,
								-11.264290125999935
							],
							[
								132.40357967300008,
								-11.269236125999953
							],
							[
								132.397978673,
								-11.300143125999966
							],
							[
								132.3858636640001,
								-11.297167125999977
							],
							[
								132.38551264400007,
								-11.28756412599995
							],
							[
								132.37347366400002,
								-11.295042125999942
							],
							[
								132.3802336440001,
								-11.276889125999958
							],
							[
								132.37408365500005,
								-11.264255125999966
							],
							[
								132.38304064500005,
								-11.20823512499993
							],
							[
								132.36549265600001,
								-11.194032124999978
							],
							[
								132.3577106670001,
								-11.150165124999944
							],
							[
								132.34133764800004,
								-11.132894113999953
							],
							[
								132.34420665800008,
								-11.120130113999949
							],
							[
								132.33259465800006,
								-11.116656133999982
							],
							[
								132.3390236580001,
								-11.141398123999977
							],
							[
								132.32005266800002,
								-11.156119123999929
							],
							[
								132.3229976780001,
								-11.16487312399994
							],
							[
								132.31689465800002,
								-11.170674133999967
							],
							[
								132.30610663900006,
								-11.173882123999931
							],
							[
								132.2883446500001,
								-11.165481123999939
							],
							[
								132.26573166000003,
								-11.176177123999935
							],
							[
								132.27496368000004,
								-11.19934611399998
							],
							[
								132.26553364000006,
								-11.21465612399993
							],
							[
								132.28228765900008,
								-11.232532123999931
							],
							[
								132.2783656590001,
								-11.24588612399998
							],
							[
								132.2883146480001,
								-11.263375114999974
							],
							[
								132.282272658,
								-11.27487412499994
							],
							[
								132.26231364900002,
								-11.25961712399993
							],
							[
								132.25767567000003,
								-11.234157123999978
							],
							[
								132.25059566000004,
								-11.222053123999956
							],
							[
								132.2411196710001,
								-11.220070133999968
							],
							[
								132.24429368100004,
								-11.197767122999949
							],
							[
								132.22818068200002,
								-11.19468212299995
							],
							[
								132.22689865200005,
								-11.179669132999948
							],
							[
								132.2112586620001,
								-11.18363911299997
							],
							[
								132.19514566300006,
								-11.163818122999942
							],
							[
								132.18762264400004,
								-11.131107121999946
							],
							[
								132.13562766600012,
								-11.122361121999973
							],
							[
								132.14460867600008,
								-11.13433312199993
							],
							[
								132.14183168600005,
								-11.15490811199993
							],
							[
								132.16267467500006,
								-11.161336121999966
							],
							[
								132.16178966400003,
								-11.184952111999962
							],
							[
								132.1949476530001,
								-11.207610122999938
							],
							[
								132.20028767200006,
								-11.224467122999954
							],
							[
								132.19056867300003,
								-11.241116122999927
							],
							[
								132.180847663,
								-11.24141012299998
							],
							[
								132.1902786830001,
								-11.247233122999944
							],
							[
								132.19853366200005,
								-11.267969132999951
							],
							[
								132.1917126520001,
								-11.281236122999928
							],
							[
								132.19403164200003,
								-11.296599113999946
							],
							[
								132.17327968200004,
								-11.323500113999955
							],
							[
								132.1981516510001,
								-11.301621133999959
							],
							[
								132.22784466000007,
								-11.32184312399994
							],
							[
								132.23764165900002,
								-11.341675123999948
							],
							[
								132.23259063900002,
								-11.363791124999977
							],
							[
								132.2230236700001,
								-11.37042512499994
							],
							[
								132.19107168100004,
								-11.351854123999942
							],
							[
								132.18357965100006,
								-11.365653123999948
							],
							[
								132.1889206610001,
								-11.380505133999975
							],
							[
								132.20056266000006,
								-11.38207613399993
							],
							[
								132.19880767000006,
								-11.398052123999946
							],
							[
								132.20900066000002,
								-11.400488124999981
							],
							[
								132.20930667000005,
								-11.413985114999946
							],
							[
								132.19943466000007,
								-11.41773212499993
							],
							[
								132.1774456810001,
								-11.397092113999975
							],
							[
								132.18187167100007,
								-11.416217123999957
							],
							[
								132.1704576410001,
								-11.420657123999945
							],
							[
								132.1706406510001,
								-11.408193113999971
							],
							[
								132.15304765200005,
								-11.39240712399993
							],
							[
								132.15815966200012,
								-11.38194813399997
							],
							[
								132.14534166300007,
								-11.382745123999939
							],
							[
								132.1551986720001,
								-11.375685123999972
							],
							[
								132.15484765300005,
								-11.361312123999937
							],
							[
								132.14615065300006,
								-11.356356112999947
							],
							[
								132.15692366300004,
								-11.32296211299996
							],
							[
								132.14123666400008,
								-11.315389122999932
							],
							[
								132.13763567400008,
								-11.296923122999942
							],
							[
								132.12588665400006,
								-11.313068132999945
							],
							[
								132.12358266400008,
								-11.350762122999981
							],
							[
								132.10957564500006,
								-11.328630132999933
							],
							[
								132.10066464500005,
								-11.329943132999972
							],
							[
								132.10823266500006,
								-11.315937132999977
							],
							[
								132.099062666,
								-11.303976121999938
							],
							[
								132.10614267500011,
								-11.29007513199997
							],
							[
								132.11444266500007,
								-11.288136122999958
							],
							[
								132.117433655,
								-11.274079121999932
							],
							[
								132.11462567500007,
								-11.26878912199993
							],
							[
								132.10029767600008,
								-11.274394121999933
							],
							[
								132.09662066600004,
								-11.26271011199998
							],
							[
								132.1062336760001,
								-11.256784121999942
							],
							[
								132.114915676,
								-11.234485121999967
							],
							[
								132.11448865600005,
								-11.21183012199998
							],
							[
								132.11044467600004,
								-11.209235121999939
							],
							[
								132.09967265600005,
								-11.23227811199996
							],
							[
								132.08644267700004,
								-11.23268613199997
							],
							[
								132.07606667800007,
								-11.210684120999929
							],
							[
								132.0835286680001,
								-11.195100120999939
							],
							[
								132.07289267800002,
								-11.19792813099997
							],
							[
								132.0671406780001,
								-11.19184612099997
							],
							[
								132.07599064800002,
								-11.17979713099993
							],
							[
								132.06862067800012,
								-11.17523012099997
							],
							[
								132.0697036680001,
								-11.183149120999929
							],
							[
								132.055284679,
								-11.191850120999959
							],
							[
								132.05720665900003,
								-11.20248812099993
							],
							[
								132.05287366900006,
								-11.196372130999976
							],
							[
								132.04658664900012,
								-11.19967012099994
							],
							[
								132.04869266900005,
								-11.192378130999941
							],
							[
								132.03819467900007,
								-11.193469130999972
							],
							[
								132.0298936700001,
								-11.179129130999968
							],
							[
								132.01188866100006,
								-11.130384129999982
							],
							[
								131.99424967200002,
								-11.125095119999969
							],
							[
								131.9735436630001,
								-11.128986119999979
							],
							[
								131.97099566300005,
								-11.13616511999993
							],
							[
								131.98718466200012,
								-11.152426119999973
							],
							[
								131.98846668200008,
								-11.17663811999995
							],
							[
								131.9955776810001,
								-11.17385712999993
							],
							[
								131.9829736920001,
								-11.181082119999928
							],
							[
								131.970522662,
								-11.17145112999998
							],
							[
								131.9619316630001,
								-11.179286119999972
							],
							[
								131.98749067100005,
								-11.219569130999957
							],
							[
								131.97311668200007,
								-11.236514109999973
							],
							[
								131.96156567200012,
								-11.230234119999977
							],
							[
								131.961703682,
								-11.253202129999977
							],
							[
								131.94597167300003,
								-11.245076119999965
							],
							[
								131.94577365300006,
								-11.252665109999953
							],
							[
								131.92892766300008,
								-11.259173119999957
							],
							[
								131.9282566830001,
								-11.235703129999933
							],
							[
								131.92082568400008,
								-11.234376119999979
							],
							[
								131.9161256540001,
								-11.21958111999993
							],
							[
								131.9045596850001,
								-11.216216119999956
							],
							[
								131.91264666400002,
								-11.207574119999947
							],
							[
								131.90440667500002,
								-11.206787129999952
							],
							[
								131.90271365500007,
								-11.196018108999965
							],
							[
								131.88324368600001,
								-11.182115118999945
							],
							[
								131.8761786760001,
								-11.194053118999932
							],
							[
								131.8869046750001,
								-11.208366118999948
							],
							[
								131.87997766600006,
								-11.218081118999976
							],
							[
								131.88086267500012,
								-11.23519910899995
							],
							[
								131.86868668600005,
								-11.219816118999972
							],
							[
								131.85867666600006,
								-11.22273010899994
							],
							[
								131.86056867700006,
								-11.209541108999929
							],
							[
								131.83961866700008,
								-11.227411108999945
							],
							[
								131.82255965800005,
								-11.20697711899993
							],
							[
								131.8152966780001,
								-11.21291711899994
							],
							[
								131.83728467700007,
								-11.248084118999941
							],
							[
								131.84886568700006,
								-11.253502128999969
							],
							[
								131.84730968600002,
								-11.262460118999968
							],
							[
								131.8570896860001,
								-11.27358511899996
							],
							[
								131.85313866600006,
								-11.28023511999993
							],
							[
								131.84405969600004,
								-11.285273118999953
							],
							[
								131.8106126680001,
								-11.26606112899998
							],
							[
								131.79498766900008,
								-11.268693118999977
							],
							[
								131.8055766880001,
								-11.279009108999958
							],
							[
								131.80560767800011,
								-11.293914118999965
							],
							[
								131.799122688,
								-11.298709108999958
							],
							[
								131.78049165900006,
								-11.29187511899994
							],
							[
								131.77756267900008,
								-11.311741118999976
							],
							[
								131.77032969900006,
								-11.309044118999964
							],
							[
								131.77339667900003,
								-11.302394128999936
							],
							[
								131.75943467000002,
								-11.300690108999959
							],
							[
								131.7638756890001,
								-11.316793118999954
							],
							[
								131.77686067900004,
								-11.325623118999943
							],
							[
								131.83969567600002,
								-11.314457129999937
							],
							[
								131.86008067600005,
								-11.293719129999943
							],
							[
								131.91510365300007,
								-11.325330110999971
							],
							[
								131.931079672,
								-11.32488312099997
							],
							[
								131.93341366200002,
								-11.316911120999976
							],
							[
								131.94360669200012,
								-11.320269130999975
							],
							[
								131.94646066200005,
								-11.325389130999952
							],
							[
								131.92686768200008,
								-11.337020120999966
							],
							[
								131.9185216620001,
								-11.358998120999956
							],
							[
								131.9310036720001,
								-11.365974120999965
							],
							[
								131.92894369200008,
								-11.358352120999939
							],
							[
								131.93765667200012,
								-11.351437130999955
							],
							[
								131.950580671,
								-11.352780120999967
							],
							[
								131.9563936610001,
								-11.343102120999959
							],
							[
								131.9660826610001,
								-11.342915120999976
							],
							[
								131.9762146500001,
								-11.35186313099996
							],
							[
								131.96544266,
								-11.361347120999937
							],
							[
								131.9681126800001,
								-11.369287110999949
							],
							[
								131.98494267900003,
								-11.377544131999969
							],
							[
								131.9793586500001,
								-11.384619121999947
							],
							[
								131.95993368000006,
								-11.381392130999927
							],
							[
								131.940265661,
								-11.396936120999953
							],
							[
								131.9623906800001,
								-11.411283111999978
							],
							[
								131.99470865900003,
								-11.404523121999944
							],
							[
								131.9863466490001,
								-11.422538121999935
							],
							[
								131.9933356680001,
								-11.429295121999928
							],
							[
								132.0117526580001,
								-11.431219121999959
							],
							[
								132.04281867600002,
								-11.421279132999928
							],
							[
								132.06007664600008,
								-11.432200122999973
							],
							[
								132.05465968600004,
								-11.44064713299997
							],
							[
								132.0592676650001,
								-11.447146122999982
							],
							[
								132.04907467600003,
								-11.459726122999939
							],
							[
								132.03122266700007,
								-11.459930122999936
							],
							[
								132.03482364600006,
								-11.482996122999964
							],
							[
								132.0566596650001,
								-11.497526122999943
							],
							[
								132.06610367400003,
								-11.523844123999936
							],
							[
								132.10626465200005,
								-11.53134711399997
							],
							[
								132.11589365200007,
								-11.54044612499996
							],
							[
								132.1236756720001,
								-11.526807123999959
							],
							[
								132.11569465200012,
								-11.517184123999925
							],
							[
								132.13905567100005,
								-11.521818124999982
							],
							[
								132.15025566100007,
								-11.511844124999982
							],
							[
								132.14973667100003,
								-11.503433134999966
							],
							[
								132.1726246500001,
								-11.490054114999964
							],
							[
								132.19493366900008,
								-11.490812124999934
							],
							[
								132.21107666900002,
								-11.469774124999958
							],
							[
								132.2378856580001,
								-11.455969124999967
							],
							[
								132.30392565500006,
								-11.465659135999942
							],
							[
								132.35504164300005,
								-11.441355126999952
							],
							[
								132.40173364100008,
								-11.454946136999979
							],
							[
								132.45699963900006,
								-11.457277137999938
							],
							[
								132.4842366270001,
								-11.485590128999945
							],
							[
								132.5269766360001,
								-11.468718128999967
							],
							[
								132.49859565600002,
								-11.489400128999932
							],
							[
								132.497466636,
								-11.505384128999935
							],
							[
								132.51301465500012,
								-11.519885128999931
							],
							[
								132.5305776450001,
								-11.52155012999998
							],
							[
								132.52618363400006,
								-11.547052119999933
							],
							[
								132.55470163300004,
								-11.555425129999946
							],
							[
								132.54912435300002,
								-11.574211789999936
							],
							[
								132.53622365400008,
								-11.580314129999977
							],
							[
								132.53776464300006,
								-11.587373129999946
							],
							[
								132.5500936530001,
								-11.611335130999976
							],
							[
								132.59789963000003,
								-11.641281141999968
							],
							[
								132.59718263000002,
								-11.654180131999965
							],
							[
								132.574721661,
								-11.655553130999976
							],
							[
								132.55641165200007,
								-11.636543140999947
							],
							[
								132.50575265400005,
								-11.636704119999933
							],
							[
								132.49958863400002,
								-11.68040212099993
							],
							[
								132.51905865300012,
								-11.687621140999966
							],
							[
								132.54110665100006,
								-11.718982130999962
							],
							[
								132.5928346390001,
								-11.729990131999955
							],
							[
								132.63426162700011,
								-11.718300132999957
							],
							[
								132.6448506370001,
								-11.727995132999979
							],
							[
								132.62344261700002,
								-11.746953142999928
							],
							[
								132.619765647,
								-11.758789142999944
							],
							[
								132.5965726380001,
								-11.768200132999937
							],
							[
								132.58045963900008,
								-11.787522141999943
							],
							[
								132.59646565800006,
								-11.80597912299993
							],
							[
								132.6188656270001,
								-11.808330122999962
							],
							[
								132.63618462600004,
								-11.821125133999942
							],
							[
								132.6492306350001,
								-11.858914143999982
							],
							[
								132.64558362500009,
								-11.873846133999962
							],
							[
								132.65533120400005,
								-11.889801513999942
							],
							[
								132.64155563400004,
								-11.900653133999981
							],
							[
								132.63825964400007,
								-11.945188134999967
							],
							[
								132.61875963400007,
								-12.015072144999976
							],
							[
								132.62896864200002,
								-12.086891134999973
							],
							[
								132.5771806240001,
								-12.105852144999972
							],
							[
								132.55600664500002,
								-12.085688133999952
							],
							[
								132.5548205350001,
								-12.098290264999946
							],
							[
								132.51304085700008,
								-12.124129753999966
							],
							[
								132.44202156000006,
								-12.146459252999932
							],
							[
								132.41759157,
								-12.195319042999927
							],
							[
								132.4171214800001,
								-12.222398993999946
							],
							[
								132.38940174100003,
								-12.236398852999969
							],
							[
								132.35317224300002,
								-12.19880870299994
							],
							[
								132.2784713860001,
								-12.224197511999932
							],
							[
								132.2642912870001,
								-12.203007290999949
							],
							[
								132.2617313180001,
								-12.17341726099994
							],
							[
								132.2449610980001,
								-12.175406970999973
							],
							[
								132.23820104900005,
								-12.169746860999965
							],
							[
								132.224360799,
								-12.194556640999963
							],
							[
								132.1708113510001,
								-12.213266429999976
							],
							[
								132.14764181200007,
								-12.245836399999973
							],
							[
								132.07390305500007,
								-12.28896616999998
							],
							[
								132.0697229650001,
								-12.303526059999967
							],
							[
								132.02117413700012,
								-12.296706308999944
							],
							[
								131.93941644100005,
								-12.27291706799997
							],
							[
								131.91749709200008,
								-12.255877217999966
							],
							[
								131.90423752300012,
								-12.22433723699993
							],
							[
								131.87926780400005,
								-12.214537116999963
							],
							[
								131.830108106,
								-12.245246986999973
							],
							[
								131.7545488390001,
								-12.273886775999927
							],
							[
								131.6606690540001,
								-12.285507494999933
							],
							[
								131.54808111900002,
								-12.278197853999927
							],
							[
								131.47230410200007,
								-12.283697922999977
							],
							[
								131.426784364,
								-12.275397342999952
							],
							[
								131.3808836070001,
								-12.256476371999952
							],
							[
								131.33432340900004,
								-12.211455421999972
							],
							[
								131.31407394100006,
								-12.167465040999957
							],
							[
								131.32284387000004,
								-12.147225050999964
							],
							[
								131.31291412100006,
								-12.132435000999976
							],
							[
								131.3218439110001,
								-12.12260508099996
							],
							[
								131.31389418100002,
								-12.112685050999971
							],
							[
								131.3209340410001,
								-12.089855100999955
							],
							[
								131.2995145320001,
								-12.070155039999975
							],
							[
								131.30336448200012,
								-12.052975069999945
							],
							[
								131.2971345520001,
								-12.042595079999955
							],
							[
								131.26636443300004,
								-12.076915019999944
							],
							[
								131.27356442300004,
								-12.100114959999928
							],
							[
								131.2508242240001,
								-12.135924889999956
							],
							[
								131.25389413300002,
								-12.162794920999943
							],
							[
								131.228884074,
								-12.207265040999971
							],
							[
								131.23108407400002,
								-12.21437507099995
							],
							[
								131.25088394300008,
								-12.220015050999962
							],
							[
								131.21232428500002,
								-12.240175130999944
							],
							[
								131.20699444500008,
								-12.263125210999931
							],
							[
								131.2340040030001,
								-12.266325200999972
							],
							[
								131.22853415300006,
								-12.281365250999954
							],
							[
								131.22908413400012,
								-12.27322523099997
							],
							[
								131.22289424400003,
								-12.277875250999955
							],
							[
								131.2250142040001,
								-12.285025270999938
							],
							[
								131.2219742640001,
								-12.277995260999944
							],
							[
								131.23205406300008,
								-12.266775190999965
							],
							[
								131.20598448500004,
								-12.270375250999962
							],
							[
								131.20979432500008,
								-12.239625130999968
							],
							[
								131.1933645050001,
								-12.237715150999975
							],
							[
								131.2052043750001,
								-12.241665160999958
							],
							[
								131.222054124,
								-12.227165100999969
							],
							[
								131.17596426700004,
								-12.192085009999971
							],
							[
								131.17009411700008,
								-12.173994929999935
							],
							[
								131.15756402800002,
								-12.168824909999955
							],
							[
								131.1442842680001,
								-12.182414989999927
							],
							[
								131.12544442900003,
								-12.182575049999969
							],
							[
								131.11435446000007,
								-12.175035058999981
							],
							[
								131.1132042700001,
								-12.155044998999927
							],
							[
								131.08758452100005,
								-12.15375507899995
							],
							[
								131.06534481200003,
								-12.166795198999978
							],
							[
								131.05177495300006,
								-12.15824521899998
							],
							[
								131.04530496300004,
								-12.14266521899998
							],
							[
								131.01042534400005,
								-12.156075348999934
							],
							[
								131.00911536400008,
								-12.162405368999941
							],
							[
								131.004575455,
								-12.159475378999957
							],
							[
								130.99597550500005,
								-12.168635428999949
							],
							[
								130.99463555500006,
								-12.18604543899994
							],
							[
								131.00468553400003,
								-12.209065418999955
							],
							[
								131.02158544300005,
								-12.216255368999953
							],
							[
								131.03046548300006,
								-12.231495378999966
							],
							[
								131.01298585300003,
								-12.323265569999933
							],
							[
								131.01770585300005,
								-12.32686555999993
							],
							[
								131.02845576200002,
								-12.305485459999943
							],
							[
								131.02802582200002,
								-12.317805499999963
							],
							[
								131.060965871,
								-12.332115399999964
							],
							[
								131.02977585200006,
								-12.32559552999993
							],
							[
								131.0249659220001,
								-12.335205559999963
							],
							[
								131.0325659120001,
								-12.339255529999946
							],
							[
								131.0298259320001,
								-12.34638555999993
							],
							[
								131.05505590100006,
								-12.347775399999932
							],
							[
								131.03487603200006,
								-12.36086555999998
							],
							[
								131.00892603300008,
								-12.356365729999936
							],
							[
								131.013206093,
								-12.366305749999981
							],
							[
								131.0192860420001,
								-12.362105669999949
							],
							[
								131.01877610200006,
								-12.371635709999964
							],
							[
								131.01790605300005,
								-12.361775689999945
							],
							[
								131.01251606300002,
								-12.36698574999997
							],
							[
								131.00478602300007,
								-12.352195739999956
							],
							[
								130.9828059040001,
								-12.341855739999971
							],
							[
								130.95010588600007,
								-12.346025819999966
							],
							[
								130.94726596600003,
								-12.357165879999968
							],
							[
								130.94765589600001,
								-12.344075809999936
							],
							[
								130.93688456600012,
								-12.342984328999933
							],
							[
								130.9382212260001,
								-12.40958760999996
							],
							[
								130.92268219700009,
								-12.409910449999927
							],
							[
								130.92343109600006,
								-12.43308363999995
							],
							[
								130.95098589500003,
								-12.443354989999932
							],
							[
								131.00172739200002,
								-12.487106860999972
							],
							[
								130.99630670200008,
								-12.510210120999943
							],
							[
								130.9808002630001,
								-12.521671130999948
							],
							[
								130.97695393300012,
								-12.54130933099998
							],
							[
								130.9558779140001,
								-12.534037200999933
							],
							[
								130.9564872840001,
								-12.552877340999942
							],
							[
								130.94945720400005,
								-12.53962723099994
							],
							[
								130.93897736500003,
								-12.554067410999949
							],
							[
								130.94703725500005,
								-12.54166726099993
							],
							[
								130.93425714500006,
								-12.532197190999966
							],
							[
								130.93484724500001,
								-12.540617280999982
							],
							[
								130.9273671850001,
								-12.536617260999947
							],
							[
								130.93054706500004,
								-12.520227080999973
							],
							[
								130.92262696600005,
								-12.509236990999966
							],
							[
								130.91041709600006,
								-12.51744710099996
							],
							[
								130.9113671560001,
								-12.530547250999973
							],
							[
								130.91665717600006,
								-12.530877230999977
							],
							[
								130.90804726600004,
								-12.54072735099993
							],
							[
								130.90707705700004,
								-12.516437090999943
							],
							[
								130.8956071870001,
								-12.529787270999975
							],
							[
								130.90361707700004,
								-12.513277069999958
							],
							[
								130.8795971180001,
								-12.521117199999935
							],
							[
								130.86979697800007,
								-12.505767049999974
							],
							[
								130.85921697900005,
								-12.506577069999935
							],
							[
								130.862127159,
								-12.52623731999995
							],
							[
								130.87386716800006,
								-12.52801729999993
							],
							[
								130.87953736800011,
								-12.547897530999933
							],
							[
								130.8942874170001,
								-12.55848759099996
							],
							[
								130.90142740700003,
								-12.556247540999948
							],
							[
								130.89336747700008,
								-12.560517620999974
							],
							[
								130.8778276380001,
								-12.55241708099993
							],
							[
								130.88465755700008,
								-12.574777820999941
							],
							[
								130.90260759600005,
								-12.57891779099998
							],
							[
								130.907467536,
								-12.572827700999937
							],
							[
								130.92308756500006,
								-12.579897720999952
							],
							[
								130.9454577140001,
								-12.606507910999937
							],
							[
								130.95332766400008,
								-12.59684779099996
							],
							[
								130.948107724,
								-12.608427941999935
							],
							[
								130.95725791300003,
								-12.630888141999947
							],
							[
								130.96685785300008,
								-12.629768071999933
							],
							[
								130.94529803400007,
								-12.63784825199997
							],
							[
								130.93293781500006,
								-12.611088000999928
							],
							[
								130.8822979370001,
								-12.606188180999936
							],
							[
								130.8827980970001,
								-12.624598340999967
							],
							[
								130.89363815600007,
								-12.634298390999959
							],
							[
								130.89042823600005,
								-12.641758480999954
							],
							[
								130.90818829600005,
								-12.656418561999942
							],
							[
								130.8982984060001,
								-12.662758641999972
							],
							[
								130.89522860600005,
								-12.682458851999968
							],
							[
								130.90000832600003,
								-12.655298571999936
							],
							[
								130.88710830700006,
								-12.648208560999933
							],
							[
								130.87981816700005,
								-12.631268410999951
							],
							[
								130.87143827700004,
								-12.63964852099997
							],
							[
								130.8697684770001,
								-12.658718710999949
							],
							[
								130.86877829800005,
								-12.641118550999977
							],
							[
								130.87659809700006,
								-12.628788390999944
							],
							[
								130.86930798800006,
								-12.611628270999972
							],
							[
								130.8589781280001,
								-12.62056839099995
							],
							[
								130.84722807900005,
								-12.613478380999936
							],
							[
								130.85735803800003,
								-12.615158350999934
							],
							[
								130.86802785800012,
								-12.601468160999957
							],
							[
								130.84276763900004,
								-12.567277849999982
							],
							[
								130.84147750900001,
								-12.555307719999973
							],
							[
								130.816067631,
								-12.558167819999937
							],
							[
								130.82885785000008,
								-12.588128130999962
							],
							[
								130.82553781000001,
								-12.579848039999945
							],
							[
								130.81420785000012,
								-12.582008089999931
							],
							[
								130.811817721,
								-12.566647909999972
							],
							[
								130.80511774100012,
								-12.563497889999951
							],
							[
								130.810167481,
								-12.539877609999962
							],
							[
								130.7882076620001,
								-12.548267769999939
							],
							[
								130.79446788100006,
								-12.57842807999998
							],
							[
								130.7836780120001,
								-12.589408229999947
							],
							[
								130.79013810100003,
								-12.602618359999951
							],
							[
								130.78038837200006,
								-12.616868539999928
							],
							[
								130.79185842100003,
								-12.621888570999943
							],
							[
								130.7799284020001,
								-12.619458579999957
							],
							[
								130.7771381220001,
								-12.599578329999929
							],
							[
								130.77471839200007,
								-12.615988529999981
							],
							[
								130.772418162,
								-12.601618379999934
							],
							[
								130.76736816300001,
								-12.601678379999953
							],
							[
								130.78169788200012,
								-12.573698049999962
							],
							[
								130.77856775200007,
								-12.55912791999998
							],
							[
								130.74903805400004,
								-12.584028229999944
							],
							[
								130.73005812400004,
								-12.58303823999995
							],
							[
								130.73442885400004,
								-12.600668149999933
							],
							[
								130.7320382140001,
								-12.596918359999961
							],
							[
								130.7292980850001,
								-12.581578219999926
							],
							[
								130.74891800400007,
								-12.579958189999957
							],
							[
								130.77440770300007,
								-12.545577759999958
							],
							[
								130.76942757300003,
								-12.52705758999997
							],
							[
								130.77848738300008,
								-12.509537369999975
							],
							[
								130.77144729300005,
								-12.49383722899995
							],
							[
								130.7788971330001,
								-12.474736998999958
							],
							[
								130.76165726400006,
								-12.482437148999963
							],
							[
								130.73675769500005,
								-12.524617659999933
							],
							[
								130.7270777550001,
								-12.52621770899998
							],
							[
								130.75739728400004,
								-12.482217158999958
							],
							[
								130.76515692400005,
								-12.437356848999968
							],
							[
								130.7498470050001,
								-12.427096968999933
							],
							[
								130.71166723600004,
								-12.423407268999938
							],
							[
								130.70567725700005,
								-12.41403738799994
							],
							[
								130.68383755800005,
								-12.416097607999973
							],
							[
								130.654267999,
								-12.393978187999949
							],
							[
								130.62413852100008,
								-12.388918587999967
							],
							[
								130.61930859100005,
								-12.381358727999952
							],
							[
								130.6116086610001,
								-12.393108687999927
							],
							[
								130.57850907300008,
								-12.405338927999935
							],
							[
								130.58725881200007,
								-12.425218607999966
							],
							[
								130.6122184610001,
								-12.431758257999945
							],
							[
								130.62324822000005,
								-12.447747937999964
							],
							[
								130.5884386020001,
								-12.452788357999964
							],
							[
								130.58096870200006,
								-12.462628507999966
							],
							[
								130.604108601,
								-12.487918417999936
							],
							[
								130.60576866100007,
								-12.501438478999944
							],
							[
								130.58870881200005,
								-12.501258657999927
							],
							[
								130.58284896200007,
								-12.512788778999948
							],
							[
								130.56586938200007,
								-12.566699228999937
							],
							[
								130.56841945200006,
								-12.590089328999966
							],
							[
								130.5779693820001,
								-12.59572929899997
							],
							[
								130.58899917100007,
								-12.580469128999937
							],
							[
								130.6039490600001,
								-12.578378998999938
							],
							[
								130.5892392710001,
								-12.592109198999935
							],
							[
								130.61202917000003,
								-12.601469118999944
							],
							[
								130.61848942000006,
								-12.61287927899997
							],
							[
								130.63148918900004,
								-12.60901911999997
							],
							[
								130.64412942800004,
								-12.623789259999967
							],
							[
								130.6424498780001,
								-12.639409529999966
							],
							[
								130.64119000800008,
								-12.64414961999995
							],
							[
								130.642899488,
								-12.625169289999974
							],
							[
								130.6311392990001,
								-12.611399149999954
							],
							[
								130.61886949000007,
								-12.615629318999936
							],
							[
								130.60719931000006,
								-12.604299198999968
							],
							[
								130.5882402310001,
								-12.629399798999941
							],
							[
								130.588841021,
								-12.654370239999935
							],
							[
								130.59625088000007,
								-12.653980169999954
							],
							[
								130.5865111910001,
								-12.660440369999947
							],
							[
								130.58283009100012,
								-12.622959718999937
							],
							[
								130.55958050200002,
								-12.626479958999937
							],
							[
								130.54991026300002,
								-12.616089878999958
							],
							[
								130.54567101300006,
								-12.634290268999962
							],
							[
								130.57341112100005,
								-12.652230329999952
							],
							[
								130.58587196100007,
								-12.684430819999932
							],
							[
								130.59725135000008,
								-12.670750459999965
							],
							[
								130.61740120900004,
								-12.676380399999971
							],
							[
								130.61647100900007,
								-12.668700249999972
							],
							[
								130.6377310480001,
								-12.683660329999952
							],
							[
								130.6334111980001,
								-12.686310399999968
							],
							[
								130.67393065600004,
								-12.691460139999947
							],
							[
								130.6647310070001,
								-12.70051036999996
							],
							[
								130.6740710360001,
								-12.70784041099995
							],
							[
								130.6844208660001,
								-12.706820280999978
							],
							[
								130.70196016500006,
								-12.690469870999948
							],
							[
								130.67914106600006,
								-12.713490450999927
							],
							[
								130.69020100600005,
								-12.71980045099997
							],
							[
								130.7060705450001,
								-12.710970160999977
							],
							[
								130.73877023300008,
								-12.710529950999955
							],
							[
								130.70734063500004,
								-12.716500240999949
							],
							[
								130.70819075500003,
								-12.722660330999929
							],
							[
								130.68459164600006,
								-12.744440900999962
							],
							[
								130.6939414850001,
								-12.746660840999937
							],
							[
								130.68915166500005,
								-12.75148091099993
							],
							[
								130.67976178600009,
								-12.745240950999971
							],
							[
								130.69067122500007,
								-12.732680630999937
							],
							[
								130.6871512460001,
								-12.727940600999943
							],
							[
								130.66914148700005,
								-12.72401070099994
							],
							[
								130.66061143700006,
								-12.71464063999997
							],
							[
								130.63010203800002,
								-12.715230949999977
							],
							[
								130.62146193900003,
								-12.705190849999951
							],
							[
								130.61629999900003,
								-12.710871579999946
							],
							[
								130.63633222800001,
								-12.72709107999998
							],
							[
								130.64356250800006,
								-12.743681290999973
							],
							[
								130.6247531780001,
								-12.76970154099996
							],
							[
								130.63520301800008,
								-12.77418142099998
							],
							[
								130.62435379800002,
								-12.77509110099993
							],
							[
								130.62954241800003,
								-12.727781169999957
							],
							[
								130.61031261900007,
								-12.722261269999933
							],
							[
								130.60503300000005,
								-12.732701499999962
							],
							[
								130.59984299000007,
								-12.72905148999996
							],
							[
								130.60766260900004,
								-12.719891229999973
							],
							[
								130.59603276000007,
								-12.71798130999997
							],
							[
								130.58511338000005,
								-12.73188166999995
							],
							[
								130.5911534700001,
								-12.739181739999935
							],
							[
								130.58465352000007,
								-12.735271739999973
							],
							[
								130.56992409100008,
								-12.743762039999979
							],
							[
								130.58074357100008,
								-12.73392175999993
							],
							[
								130.5832630110001,
								-12.719231469999954
							],
							[
								130.56724294100002,
								-12.706361389999927
							],
							[
								130.55862354200008,
								-12.718571679999968
							],
							[
								130.55728301200008,
								-12.70198137999995
							],
							[
								130.53577399300002,
								-12.719011959999932
							],
							[
								130.52063390400008,
								-12.703481899999929
							],
							[
								130.51142433400003,
								-12.710242149999942
							],
							[
								130.51545459400006,
								-12.722672299999942
							],
							[
								130.5311143030001,
								-12.724922119999974
							],
							[
								130.5252547030001,
								-12.734302359999958
							],
							[
								130.53101483300009,
								-12.742152429999976
							],
							[
								130.52433475300006,
								-12.734072369999978
							],
							[
								130.52939434300004,
								-12.72503213999994
							],
							[
								130.51753462400006,
								-12.725602309999942
							],
							[
								130.51916522400006,
								-12.75012266999994
							],
							[
								130.51822480400006,
								-12.73148238999994
							],
							[
								130.50613457400004,
								-12.714992279999933
							],
							[
								130.50119477500004,
								-12.717952389999937
							],
							[
								130.518313604,
								-12.691361729999926
							],
							[
								130.51358305400004,
								-12.667751418999956
							],
							[
								130.49211368500005,
								-12.667271768999967
							],
							[
								130.46089395700005,
								-12.63916194899997
							],
							[
								130.44467463800004,
								-12.645502308999937
							],
							[
								130.4385646080001,
								-12.633642288999965
							],
							[
								130.42027540900006,
								-12.645412748999945
							],
							[
								130.4245458790001,
								-12.656943078999973
							],
							[
								130.41415556900006,
								-12.664511068999957
							],
							[
								130.41280582900004,
								-12.655592978999948
							],
							[
								130.39358643000003,
								-12.66227325899996
							],
							[
								130.39647665000007,
								-12.680133378999926
							],
							[
								130.40554652900005,
								-12.68532334899993
							],
							[
								130.40411674900008,
								-12.701463488999934
							],
							[
								130.37886689100003,
								-12.67766342899995
							],
							[
								130.3724870210001,
								-12.682023448999928
							],
							[
								130.35272727200004,
								-12.669533488999946
							],
							[
								130.34631784200008,
								-12.715213538999933
							],
							[
								130.35622791100002,
								-12.734763598999962
							],
							[
								130.35280823100004,
								-12.795363308999981
							],
							[
								130.3583481610001,
								-12.807223259999944
							],
							[
								130.33316875200012,
								-12.881062809999946
							],
							[
								130.3382487120001,
								-12.890102759999934
							],
							[
								130.2471306960001,
								-12.948363589999929
							],
							[
								130.21325125700002,
								-12.947013789999971
							],
							[
								130.19262145900007,
								-12.92779368999993
							],
							[
								130.1937712790001,
								-12.910493489999965
							],
							[
								130.1758015590001,
								-12.910263609999959
							],
							[
								130.15910197000005,
								-12.929213939999954
							],
							[
								130.1411222910001,
								-12.933444109999982
							],
							[
								130.1292427520001,
								-12.966564609999978
							],
							[
								130.1283228420001,
								-12.979114769999967
							],
							[
								130.13800275100004,
								-12.985334799999976
							],
							[
								130.14120281100008,
								-13.000654959999963
							],
							[
								130.120163702,
								-13.079365620999965
							],
							[
								130.13406366100003,
								-13.10746538099994
							],
							[
								130.1188940510001,
								-13.133385400999941
							],
							[
								130.11618425100005,
								-13.164125290999948
							],
							[
								130.1305241110001,
								-13.17652512099994
							],
							[
								130.16306360900012,
								-13.176904831999934
							],
							[
								130.225213036,
								-13.249183611999968
							],
							[
								130.23929673500004,
								-13.281950132999953
							],
							[
								130.18223446700006,
								-13.408622942999955
							],
							[
								130.14161529900002,
								-13.45710330399993
							],
							[
								130.12523552000005,
								-13.466183433999959
							],
							[
								130.10637560100008,
								-13.45629372299993
							],
							[
								130.06415675300002,
								-13.503684023999938
							],
							[
								130.05869679300008,
								-13.499434083999972
							],
							[
								130.0083780760001,
								-13.53332463399994
							],
							[
								129.9568489080001,
								-13.535795183999937
							],
							[
								129.92863927000008,
								-13.528265472999976
							],
							[
								129.90989951100005,
								-13.514325712999948
							],
							[
								129.900519561,
								-13.498585872999968
							],
							[
								129.89743929200006,
								-13.440396152999938
							],
							[
								129.86940988300012,
								-13.479756222999981
							],
							[
								129.87670977300002,
								-13.502413112999932
							],
							[
								129.83120058500003,
								-13.511456412999962
							],
							[
								129.8173306960001,
								-13.501746582999942
							],
							[
								129.82774064500006,
								-13.51812640299994
							],
							[
								129.83484084500003,
								-13.561176122999939
							],
							[
								129.79017206700007,
								-13.666895963999934
							],
							[
								129.7851022970001,
								-13.768165564999947
							],
							[
								129.7950617560001,
								-13.777865124999948
							],
							[
								129.7948422060001,
								-13.789505344999952
							],
							[
								129.78468575700003,
								-13.787271124999961
							],
							[
								129.74003311900003,
								-13.82685575499994
							],
							[
								129.72257345000003,
								-13.847895884999957
							],
							[
								129.71553373000006,
								-13.878865935999954
							],
							[
								129.71693384000002,
								-13.896275895999963
							],
							[
								129.7351136090001,
								-13.897185725999975
							],
							[
								129.74123363900003,
								-13.906085665999967
							],
							[
								129.74750364800002,
								-13.920655585999953
							],
							[
								129.7459138480001,
								-13.946985585999926
							],
							[
								129.75240380800005,
								-13.952185505999978
							],
							[
								129.72652450900011,
								-14.008225645999971
							],
							[
								129.6408858740001,
								-14.047186426999929
							],
							[
								129.60928625600002,
								-14.035596716999976
							],
							[
								129.59880615600002,
								-14.010476855999968
							],
							[
								129.59064647700006,
								-14.032846915999926
							],
							[
								129.61168631500004,
								-14.053566686999943
							],
							[
								129.60929647600005,
								-14.069576706999953
							],
							[
								129.5948772260001,
								-14.091217406999931
							],
							[
								129.58882070700008,
								-14.08717510699995
							],
							[
								129.58221274700009,
								-14.092763236999929
							],
							[
								129.57250078800007,
								-14.081485136999959
							],
							[
								129.567160918,
								-14.083845106999945
							],
							[
								129.55482110800006,
								-14.111855246999937
							],
							[
								129.55672125800004,
								-14.142145246999974
							],
							[
								129.5419993490001,
								-14.144514336999976
							],
							[
								129.5276713500001,
								-14.129985396999928
							],
							[
								129.54224064900006,
								-14.091135106999957
							],
							[
								129.53508063000004,
								-14.081405116999974
							],
							[
								129.5356007900001,
								-14.058345126999939
							],
							[
								129.52508091000004,
								-14.052325116999953
							],
							[
								129.5280807700001,
								-14.057985136999946
							],
							[
								129.5158411110001,
								-14.075355486999968
							],
							[
								129.5171608810001,
								-14.069495506999942
							],
							[
								129.5060408610001,
								-14.068335126999955
							],
							[
								129.49139115200012,
								-14.047385615999929
							],
							[
								129.47748122300004,
								-14.049955695999927
							],
							[
								129.48649124200006,
								-14.05833563699997
							],
							[
								129.48633134200008,
								-14.078455646999942
							],
							[
								129.50149081100005,
								-14.083125106999944
							],
							[
								129.50248135100003,
								-14.102005556999927
							],
							[
								129.50792131100002,
								-14.10360550699994
							],
							[
								129.49827147200006,
								-14.11646555699997
							],
							[
								129.51204143100006,
								-14.127035496999952
							],
							[
								129.50715152100008,
								-14.13321551699994
							],
							[
								129.49639154200008,
								-14.127875586999949
							],
							[
								129.463862123,
								-14.193665747999944
							],
							[
								129.45323219400007,
								-14.19117581699993
							],
							[
								129.431112535,
								-14.226375927999982
							],
							[
								129.40930272600008,
								-14.235926077999977
							],
							[
								129.41160295600002,
								-14.279446047999954
							],
							[
								129.4184129460001,
								-14.27711600799995
							],
							[
								129.41945297600012,
								-14.291106007999929
							],
							[
								129.41053303600006,
								-14.288256047999937
							],
							[
								129.393523307,
								-14.316806147999955
							],
							[
								129.368883578,
								-14.333686287999967
							],
							[
								129.373903648,
								-14.354716278999945
							],
							[
								129.36073389900002,
								-14.382486348999976
							],
							[
								129.3567741590001,
								-14.423616368999944
							],
							[
								129.379294038,
								-14.41939623899998
							],
							[
								129.39795392700012,
								-14.426456148999932
							],
							[
								129.39785384700008,
								-14.416116148999947
							],
							[
								129.40061393700012,
								-14.428266118999943
							],
							[
								129.42073394600004,
								-14.449916018999943
							],
							[
								129.4226639950001,
								-14.467325998999968
							],
							[
								129.45116392400007,
								-14.483565859999942
							],
							[
								129.44740405400012,
								-14.499605879999933
							],
							[
								129.45319405400005,
								-14.50504583999998
							],
							[
								129.47446380300005,
								-14.490975719999938
							],
							[
								129.46862369300004,
								-14.460555738999972
							],
							[
								129.4540036940001,
								-14.446375828999976
							],
							[
								129.46262364300003,
								-14.45104577899997
							],
							[
								129.46475360300008,
								-14.441795758999945
							],
							[
								129.4700236530001,
								-14.45818573899993
							],
							[
								129.48167354200007,
								-14.449635668999974
							],
							[
								129.47188365300008,
								-14.459435718999941
							],
							[
								129.482683822,
								-14.500935669999933
							],
							[
								129.50689350100004,
								-14.471725539999966
							],
							[
								129.4904435420001,
								-14.460155618999977
							],
							[
								129.50227344100006,
								-14.462215559999947
							],
							[
								129.50886348100005,
								-14.471955519999938
							],
							[
								129.52307337000002,
								-14.46554544999998
							],
							[
								129.50815352100005,
								-14.474775509999972
							],
							[
								129.48824383200008,
								-14.50332562999995
							],
							[
								129.52627968000002,
								-14.55227611999993
							],
							[
								129.55692864800005,
								-14.550795169999958
							],
							[
								129.56676959700008,
								-14.56253511999995
							],
							[
								129.66934875100003,
								-14.580474910999953
							],
							[
								129.776235745,
								-14.536822119999954
							],
							[
								129.7563080970001,
								-14.56970469099997
							],
							[
								129.71891841900003,
								-14.58281477099996
							],
							[
								129.6923887900001,
								-14.612774740999953
							],
							[
								129.585143656,
								-14.613815140999975
							],
							[
								129.5806836160001,
								-14.637915170999975
							],
							[
								129.5891999060001,
								-14.661244910999926
							],
							[
								129.59776988500005,
								-14.674374820999958
							],
							[
								129.61928469400004,
								-14.679638720999947
							],
							[
								129.64495956300004,
								-14.715264391999938
							],
							[
								129.66467241100008,
								-14.72604628199997
							],
							[
								129.66221946200005,
								-14.746144151999943
							],
							[
								129.67240946100003,
								-14.763454001999946
							],
							[
								129.7246493880001,
								-14.791453851999961
							],
							[
								129.77473921500007,
								-14.783043931999941
							],
							[
								129.77603915500003,
								-14.771283981999943
							],
							[
								129.79405898400012,
								-14.756394071999978
							],
							[
								129.80066903400007,
								-14.76679403199995
							],
							[
								129.8100589830001,
								-14.76030405199998
							],
							[
								129.804039073,
								-14.769404011999939
							],
							[
								129.79380907400002,
								-14.76904400199993
							],
							[
								129.7955591340001,
								-14.775253971999973
							],
							[
								129.77681923500006,
								-14.795363861999931
							],
							[
								129.75414934600008,
								-14.803023801999927
							],
							[
								129.74890943600008,
								-14.814313721999952
							],
							[
								129.75841944600006,
								-14.824613692999947
							],
							[
								129.81269939300012,
								-14.822863782999946
							],
							[
								129.83594931100004,
								-14.813283832999957
							],
							[
								129.83734923100008,
								-14.804243862999954
							],
							[
								129.86835901000006,
								-14.776193991999946
							],
							[
								129.902838878,
								-14.773203982999974
							],
							[
								129.8825591090001,
								-14.799413912999967
							],
							[
								129.86395919000006,
								-14.801663902999962
							],
							[
								129.86441923000007,
								-14.810593852999943
							],
							[
								129.8762791790001,
								-14.806873872999972
							],
							[
								129.88556926900003,
								-14.813883862999944
							],
							[
								129.88137928900005,
								-14.820093842999938
							],
							[
								129.85138932000007,
								-14.826173782999945
							],
							[
								129.846159381,
								-14.829673772999968
							],
							[
								129.85009948000004,
								-14.843293732999939
							],
							[
								129.80254962300012,
								-14.85800360299993
							],
							[
								129.77170956500004,
								-14.848963582999943
							],
							[
								129.76816979500006,
								-14.841343172999927
							],
							[
								129.74456958700011,
								-14.852313522999964
							],
							[
								129.68491958000004,
								-14.848803422999936
							],
							[
								129.648579562,
								-14.834393471999931
							],
							[
								129.63205966300006,
								-14.843853381999963
							],
							[
								129.6175697440001,
								-14.825523521999969
							],
							[
								129.5775548360001,
								-14.798285171999964
							],
							[
								129.57405495600005,
								-14.806755091999946
							],
							[
								129.58615992600005,
								-14.839363171999935
							],
							[
								129.61839990400006,
								-14.875593232999961
							],
							[
								129.6180399440001,
								-14.881573212999967
							],
							[
								129.59212585500006,
								-14.890995172999965
							],
							[
								129.57001575700008,
								-14.847545141999944
							],
							[
								129.53384582900003,
								-14.806785151999975
							],
							[
								129.49971545100004,
								-14.79009561199996
							],
							[
								129.5002655410001,
								-14.803205601999935
							],
							[
								129.53038584900003,
								-14.84384516199998
							],
							[
								129.53648568900007,
								-14.869015102999981
							],
							[
								129.5479156680001,
								-14.878505152999935
							],
							[
								129.59325589500008,
								-14.96705516299994
							],
							[
								129.59952564500009,
								-14.97034511299995
							],
							[
								129.59641562500008,
								-14.956895152999948
							],
							[
								129.60850033400004,
								-14.947672952999937
							],
							[
								129.62302029300008,
								-14.953242952999972
							],
							[
								129.62109057300006,
								-14.998572783999975
							],
							[
								129.63526074300012,
								-15.032842753999944
							],
							[
								129.6543105710001,
								-15.023382783999978
							],
							[
								129.66334067100001,
								-15.02808280399995
							],
							[
								129.64054083200006,
								-15.042152733999956
							],
							[
								129.6398310520001,
								-15.071202693999965
							],
							[
								129.65240125100001,
								-15.099332683999933
							],
							[
								129.685671479,
								-15.131012694999981
							],
							[
								129.6849915890001,
								-15.142652674999965
							],
							[
								129.6708616400001,
								-15.148532634999981
							],
							[
								129.65673158100003,
								-15.139492644999962
							],
							[
								129.62624170300012,
								-15.138012594999964
							],
							[
								129.61167185400006,
								-15.153722534999929
							],
							[
								129.5789420860001,
								-15.155612474999941
							],
							[
								129.5635924170001,
								-15.179902424999966
							],
							[
								129.55725236700005,
								-15.170522404999929
							],
							[
								129.56020215700005,
								-15.15512244499996
							],
							[
								129.60222171400005,
								-15.128892553999947
							],
							[
								129.6039115540001,
								-15.10799258399993
							],
							[
								129.5561212670001,
								-15.048712643999977
							],
							[
								129.52478678900002,
								-15.028075153999964
							],
							[
								129.52230671900008,
								-15.00567515299997
							],
							[
								129.4824864620001,
								-14.941045752999969
							],
							[
								129.43532624400007,
								-14.921376762999955
							],
							[
								129.4095257460001,
								-14.917578102999926
							],
							[
								129.40863572600006,
								-14.924918162999973
							],
							[
								129.40813571600006,
								-14.917798172999937
							],
							[
								129.3922255870001,
								-14.909048492999943
							],
							[
								129.36726575800003,
								-14.903158442999938
							],
							[
								129.35013571900004,
								-14.87366831199995
							],
							[
								129.33486584000002,
								-14.87297831199993
							],
							[
								129.31739588100004,
								-14.859438241999953
							],
							[
								129.29020608300004,
								-14.857318211999939
							],
							[
								129.25728637500004,
								-14.864998231999948
							],
							[
								129.26291627400008,
								-14.850098161999938
							],
							[
								129.2438664550001,
								-14.845288331999939
							],
							[
								129.24081640600002,
								-14.852568541999972
							],
							[
								129.24318652600004,
								-14.841328241999975
							],
							[
								129.2284366660001,
								-14.839358631999971
							],
							[
								129.2217465770001,
								-14.855389181999954
							],
							[
								129.24182690600003,
								-14.910678692999966
							],
							[
								129.23393746600004,
								-14.924368932999982
							],
							[
								129.23299806600005,
								-14.95714897299996
							],
							[
								129.24137737600006,
								-14.986448792999965
							],
							[
								129.23349738600007,
								-15.00827880299994
							],
							[
								129.26513740400003,
								-15.03288895399993
							],
							[
								129.28125727300005,
								-15.026828923999972
							],
							[
								129.29310732300007,
								-15.040498983999953
							],
							[
								129.3016272220001,
								-15.036518963999981
							],
							[
								129.29297731300005,
								-15.041748993999931
							],
							[
								129.27820729300004,
								-15.029278913999974
							],
							[
								129.26165753400005,
								-15.043488983999964
							],
							[
								129.25634755500005,
								-15.061976923999964
							],
							[
								129.26193752400002,
								-15.038398953999945
							],
							[
								129.25604748500007,
								-15.033938933999934
							],
							[
								129.25147757500008,
								-15.055957733999946
							],
							[
								129.23649757600003,
								-15.067775883999957
							],
							[
								129.249417375,
								-15.09152166399997
							],
							[
								129.235157586,
								-15.108572823999964
							],
							[
								129.23809777600002,
								-15.128726663999942
							],
							[
								129.21548824700005,
								-15.15382985399998
							],
							[
								129.22692822700003,
								-15.16173986399997
							],
							[
								129.23120828600008,
								-15.17591955499995
							],
							[
								129.20622841800002,
								-15.15893949399998
							],
							[
								129.19563852800002,
								-15.159289273999946
							],
							[
								129.19960834800008,
								-15.146669353999982
							],
							[
								129.18662872900006,
								-15.173898724999958
							],
							[
								129.18774883900005,
								-15.189398344999972
							],
							[
								129.18047887900002,
								-15.183108394999977
							],
							[
								129.17114908000008,
								-15.195677904999968
							],
							[
								129.158199211,
								-15.197587644999942
							],
							[
								129.15752910100002,
								-15.18434797499998
							],
							[
								129.1749288000001,
								-15.168358664999971
							],
							[
								129.17467863000002,
								-15.147439103999943
							],
							[
								129.2005581080001,
								-15.12259572399995
							],
							[
								129.195407928,
								-15.10264342399995
							],
							[
								129.1776180390001,
								-15.088906263999945
							],
							[
								129.1804279590001,
								-15.076386813999932
							],
							[
								129.16951789000007,
								-15.051518633999933
							],
							[
								129.18892767900002,
								-14.987159092999946
							],
							[
								129.15817876100004,
								-14.969299472999978
							],
							[
								129.1533483510001,
								-14.983409902999938
							],
							[
								129.1567788110001,
								-14.969069482999942
							],
							[
								129.13069890200006,
								-14.948959422999962
							],
							[
								129.12264875300002,
								-14.95310968299998
							],
							[
								129.10842839300005,
								-14.989220012999965
							],
							[
								129.11272900300003,
								-14.93442963299998
							],
							[
								129.10129932400002,
								-14.915049262999958
							],
							[
								129.06595060600011,
								-14.891059792999954
							],
							[
								129.0540709170001,
								-14.895300322999958
							],
							[
								129.0565904760001,
								-14.907850262999943
							],
							[
								129.04413061700006,
								-14.90746022299993
							],
							[
								129.03167082800007,
								-14.886389702999963
							],
							[
								129.00149340000007,
								-14.879594592999979
							],
							[
								129.0004656110001,
								-15.940396259999943
							],
							[
								129.00047358200004,
								-16.98012857799995
							],
							[
								129.0004812730001,
								-18.240764026999955
							],
							[
								129.00049298400006,
								-19.10635916299998
							],
							[
								129.00052181500007,
								-21.231994907999933
							],
							[
								129.000481766,
								-22.24680618499997
							],
							[
								129.00054424600012,
								-23.440298172999974
							],
							[
								129.00055232600005,
								-24.13743811699993
							],
							[
								129.00057414600008,
								-25.661145266999938
							],
							[
								129.0018469360001,
								-25.998591869999927
							],
							[
								130.1053245920001,
								-25.99856399199996
							],
							[
								131.2573457730001,
								-25.998576500999945
							],
							[
								132.37372427900004,
								-25.99856034399994
							],
							[
								133.50330305300008,
								-25.998534522999933
							],
							[
								134.60529752000002,
								-25.998528676999968
							],
							[
								135.73128661500004,
								-25.998515186999953
							],
							[
								136.91591723400006,
								-25.997755943999948
							],
							[
								137.99906130500005,
								-25.996849173999976
							],
							[
								137.99887185900002,
								-24.834774874999937
							],
							[
								137.99857096900007,
								-23.52090498499996
							],
							[
								137.9980149600001,
								-22.612171357999955
							],
							[
								137.9974155000001,
								-21.711170850999963
							],
							[
								137.99685004000003,
								-20.79196034399996
							],
							[
								137.99638107600003,
								-19.951700837999965
							],
							[
								137.99617811400003,
								-19.060189830999946
							],
							[
								137.9956146500001,
								-18.178286713999967
							],
							[
								137.99513568200007,
								-17.422316817999956
							],
							[
								137.99465396800008,
								-16.538296570999933
							]
						]
					],
					[
						[
							[
								129.69307948000005,
								-14.80637373199994
							],
							[
								129.7198594580001,
								-14.813253711999948
							],
							[
								129.73206943700006,
								-14.804123791999928
							],
							[
								129.67132950100006,
								-14.783573881999928
							],
							[
								129.69307948000005,
								-14.80637373199994
							]
						]
					],
					[
						[
							[
								130.08557499300002,
								-13.204985410999939
							],
							[
								130.09761480200007,
								-13.22123518199993
							],
							[
								130.1083546320001,
								-13.223585051999976
							],
							[
								130.10194469200007,
								-13.193995300999973
							],
							[
								130.09097483300002,
								-13.192775410999957
							],
							[
								130.08557499300002,
								-13.204985410999939
							]
						]
					],
					[
						[
							[
								130.0195158260001,
								-13.175626210999951
							],
							[
								130.04110550500002,
								-13.183155970999962
							],
							[
								130.047195385,
								-13.175915920999955
							],
							[
								130.0681151440001,
								-13.182425680999927
							],
							[
								130.07501495400004,
								-13.171225670999945
							],
							[
								130.05766508400006,
								-13.152045900999951
							],
							[
								130.0276655560001,
								-13.15085622099997
							],
							[
								130.018485477,
								-13.11120645099993
							],
							[
								130.0195158260001,
								-13.175626210999951
							]
						]
					],
					[
						[
							[
								130.3609067420001,
								-12.668283108999958
							],
							[
								130.37045675100012,
								-12.66975311899995
							],
							[
								130.35778672200001,
								-12.661503118999974
							],
							[
								130.3609067420001,
								-12.668283108999958
							]
						]
					],
					[
						[
							[
								130.51789064500008,
								-12.569219998999927
							],
							[
								130.5173105450001,
								-12.557579928999928
							],
							[
								130.50812105500006,
								-12.574190228999953
							],
							[
								130.484761896,
								-12.580350748999933
							],
							[
								130.4949117760001,
								-12.596390688999975
							],
							[
								130.4866527360001,
								-12.623641238999937
							],
							[
								130.499222905,
								-12.645451338999976
							],
							[
								130.52405257400005,
								-12.661761138999964
							],
							[
								130.5243037240001,
								-12.700061799999958
							],
							[
								130.53974363300006,
								-12.709881749999965
							],
							[
								130.542252673,
								-12.681181199999969
							],
							[
								130.51783242400006,
								-12.650571068999966
							],
							[
								130.51102170500008,
								-12.617020668999942
							],
							[
								130.50296181500005,
								-12.610240708999982
							],
							[
								130.51008113500006,
								-12.590690318999975
							],
							[
								130.52113071400004,
								-12.590010088999975
							],
							[
								130.51789064500008,
								-12.569219998999927
							]
						]
					],
					[
						[
							[
								130.45582772700004,
								-12.631819108999935
							],
							[
								130.46302672700006,
								-12.63649111899997
							],
							[
								130.4569287070001,
								-12.622373128999982
							],
							[
								130.45582772700004,
								-12.631819108999935
							]
						]
					],
					[
						[
							[
								130.3941155000001,
								-12.597612797999943
							],
							[
								130.40194540000005,
								-12.602012727999977
							],
							[
								130.4162047090001,
								-12.594992327999933
							],
							[
								130.40077492000012,
								-12.580872427999964
							],
							[
								130.3918053000001,
								-12.58709265799996
							],
							[
								130.3941155000001,
								-12.597612797999943
							]
						]
					],
					[
						[
							[
								130.40439543000002,
								-12.608192727999949
							],
							[
								130.3850257910001,
								-12.602472947999956
							],
							[
								130.39320577,
								-12.612982927999951
							],
							[
								130.40402554000002,
								-12.614562777999936
							],
							[
								130.40439543000002,
								-12.608192727999949
							]
						]
					],
					[
						[
							[
								130.380126431,
								-12.641573217999962
							],
							[
								130.38885621000009,
								-12.641473168999937
							],
							[
								130.39643588,
								-12.62655297799995
							],
							[
								130.3777861310001,
								-12.616723127999933
							],
							[
								130.36490652200007,
								-12.625773297999956
							],
							[
								130.36892667100005,
								-12.642713337999965
							],
							[
								130.380126431,
								-12.641573217999962
							]
						]
					],
					[
						[
							[
								130.40963464000004,
								-12.582672267999953
							],
							[
								130.41677461900008,
								-12.592052267999975
							],
							[
								130.43437367800004,
								-12.579831747999947
							],
							[
								130.42066376900004,
								-12.563561747999927
							],
							[
								130.40594449000002,
								-12.572162177999928
							],
							[
								130.40963464000004,
								-12.582672267999953
							]
						]
					],
					[
						[
							[
								130.86491134800008,
								-12.54555894999993
							],
							[
								130.86186506800004,
								-12.56222840099997
							],
							[
								130.87252743800002,
								-12.552647590999982
							],
							[
								130.86491134800008,
								-12.54555894999993
							]
						]
					],
					[
						[
							[
								96.88903231400008,
								-12.200947225999926
							],
							[
								96.88705576400008,
								-12.195080675999975
							],
							[
								96.88546009500004,
								-12.201955085999941
							],
							[
								96.89475547500007,
								-12.208693804999939
							],
							[
								96.92203875200005,
								-12.197152871999947
							],
							[
								96.92949957000008,
								-12.181498079999926
							],
							[
								96.92071145700004,
								-12.159414071999947
							],
							[
								96.92780049000004,
								-12.181970200999956
							],
							[
								96.92027043200005,
								-12.19635458199997
							],
							[
								96.90340101300006,
								-12.19684237399997
							],
							[
								96.90146903400006,
								-12.20570298399997
							],
							[
								96.88903231400008,
								-12.200947225999926
							]
						]
					],
					[
						[
							[
								96.81703561900008,
								-12.144150904999947
							],
							[
								96.81994752500003,
								-12.183029874999932
							],
							[
								96.84427090700007,
								-12.206390841999962
							],
							[
								96.86213882600003,
								-12.20174886999996
							],
							[
								96.85967036400007,
								-12.19273402999994
							],
							[
								96.86166596500004,
								-12.197372869999981
							],
							[
								96.84919854700007,
								-12.20541672099995
							],
							[
								96.84168247700006,
								-12.203800521999938
							],
							[
								96.82928688400006,
								-12.177558423999926
							],
							[
								96.82112420400006,
								-12.181226424999977
							],
							[
								96.82648211100008,
								-12.158478153999965
							],
							[
								96.83177122300003,
								-12.17397828299994
							],
							[
								96.83298119200003,
								-12.166968192999946
							],
							[
								96.82477993800006,
								-12.137013933999981
							],
							[
								96.81703561900008,
								-12.144150904999947
							]
						]
					],
					[
						[
							[
								96.81720796600007,
								-11.828194774999929
							],
							[
								96.82032798700004,
								-11.83376480399994
							],
							[
								96.82715903600007,
								-11.83115275299997
							],
							[
								96.81887097600008,
								-11.829374773999973
							],
							[
								96.82314892400007,
								-11.818490653999959
							],
							[
								96.82920901500006,
								-11.826438672999927
							],
							[
								96.82582393400008,
								-11.815210582999953
							],
							[
								96.81720796600007,
								-11.828194774999929
							]
						]
					],
					[
						[
							[
								96.84631130900004,
								-12.079590880999945
							],
							[
								96.84131087900005,
								-12.072640281999952
							],
							[
								96.83172426900006,
								-12.074974202999954
							],
							[
								96.84631130900004,
								-12.079590880999945
							]
						]
					],
					[
						[
							[
								96.89371594200009,
								-12.116470894999964
							],
							[
								96.90558735300004,
								-12.123076563999973
							],
							[
								96.88827992100005,
								-12.107112005999966
							],
							[
								96.89371594200009,
								-12.116470894999964
							]
						]
					],
					[
						[
							[
								105.68560519000005,
								-10.416389850999963
							],
							[
								105.67445867100008,
								-10.414182301999972
							],
							[
								105.67102669200005,
								-10.42806329299998
							],
							[
								105.66181065200004,
								-10.428289313999926
							],
							[
								105.66119369400008,
								-10.439070293999976
							],
							[
								105.64669867500004,
								-10.451873294999928
							],
							[
								105.60607267800003,
								-10.467121319999933
							],
							[
								105.56771165900005,
								-10.455773312999952
							],
							[
								105.55180666800004,
								-10.441936314999964
							],
							[
								105.54825770000008,
								-10.456751314999963
							],
							[
								105.55825370100007,
								-10.475730313999975
							],
							[
								105.53401070600006,
								-10.51366031699996
							],
							[
								105.54268069600005,
								-10.515828305999946
							],
							[
								105.55653269400005,
								-10.503927314999942
							],
							[
								105.57745467300003,
								-10.503833312999973
							],
							[
								105.62429272300005,
								-10.515106297999978
							],
							[
								105.63461167400004,
								-10.527396306999947
							],
							[
								105.64104268700004,
								-10.564715305999925
							],
							[
								105.64852766700005,
								-10.570179305999943
							],
							[
								105.66607569700005,
								-10.56804131399997
							],
							[
								105.66907770300008,
								-10.532702312999959
							],
							[
								105.67771167100005,
								-10.51784429299994
							],
							[
								105.67427668900007,
								-10.501737312999978
							],
							[
								105.69418167600008,
								-10.47547530099996
							],
							[
								105.71260668400004,
								-10.466958298999941
							],
							[
								105.70488967400007,
								-10.459060299999976
							],
							[
								105.70932668200004,
								-10.441810288999932
							],
							[
								105.70288566900007,
								-10.414050299999928
							],
							[
								105.68560519000005,
								-10.416389850999963
							]
						]
					],
					[
						[
							[
								96.91512206500005,
								-12.140441401999965
							],
							[
								96.91880622500008,
								-12.143645011999979
							],
							[
								96.91142461400005,
								-12.135356882999929
							],
							[
								96.91512206500005,
								-12.140441401999965
							]
						]
					],
					[
						[
							[
								130.63258061400006,
								-11.776981262999982
							],
							[
								130.6407306640001,
								-11.75415731299995
							],
							[
								130.61739128500005,
								-11.733951912999942
							],
							[
								130.5923017660001,
								-11.73050238299993
							],
							[
								130.5840821160001,
								-11.708302661999937
							],
							[
								130.5637827170001,
								-11.70615712199998
							],
							[
								130.55345273800003,
								-11.691134121999937
							],
							[
								130.51602374900006,
								-11.691063121999946
							],
							[
								130.49205171000006,
								-11.673162111999943
							],
							[
								130.46896572100002,
								-11.666717121999966
							],
							[
								130.46057273200006,
								-11.620489110999927
							],
							[
								130.46463175200006,
								-11.57609611099997
							],
							[
								130.42906374400002,
								-11.548608099999967
							],
							[
								130.41221775500003,
								-11.548862109999959
							],
							[
								130.4004687250001,
								-11.540131109999948
							],
							[
								130.37622272600004,
								-11.50758111999994
							],
							[
								130.3779617360001,
								-11.483324119999963
							],
							[
								130.39261071600004,
								-11.47293910999997
							],
							[
								130.4037637350001,
								-11.44815811999996
							],
							[
								130.40062075600008,
								-11.424078108999936
							],
							[
								130.39409071600005,
								-11.415276108999933
							],
							[
								130.386948726,
								-11.416675108999982
							],
							[
								130.38357674600002,
								-11.40366311899993
							],
							[
								130.3610247470001,
								-11.379031108999982
							],
							[
								130.35391374800008,
								-11.339029108999966
							],
							[
								130.3386397390001,
								-11.317995107999934
							],
							[
								130.30296475000011,
								-11.340994107999961
							],
							[
								130.25218475200006,
								-11.34559910799993
							],
							[
								130.24777474200005,
								-11.353809117999958
							],
							[
								130.25321876200007,
								-11.376307107999935
							],
							[
								130.24650473200006,
								-11.391680108999935
							],
							[
								130.25669673200002,
								-11.398382108999954
							],
							[
								130.24935873200002,
								-11.401080108999963
							],
							[
								130.2414917420001,
								-11.393735108999977
							],
							[
								130.24452475200007,
								-11.36647310799998
							],
							[
								130.22635173300012,
								-11.411685108999961
							],
							[
								130.18571774500003,
								-11.423679098999969
							],
							[
								130.16998675500008,
								-11.462315108999974
							],
							[
								130.1482727560001,
								-11.481661118999966
							],
							[
								130.1567267360001,
								-11.49095910899996
							],
							[
								130.18602375400008,
								-11.48460211899993
							],
							[
								130.20378472400012,
								-11.511049108999941
							],
							[
								130.23120575200005,
								-11.496855108999966
							],
							[
								130.238013732,
								-11.50436710899993
							],
							[
								130.235670722,
								-11.520137098999953
							],
							[
								130.26132475100007,
								-11.52657309999995
							],
							[
								130.26105775100007,
								-11.538473119999935
							],
							[
								130.27200275100006,
								-11.54410310999998
							],
							[
								130.26394475100005,
								-11.56201010999996
							],
							[
								130.25451472100008,
								-11.533049099999971
							],
							[
								130.23108373200012,
								-11.525663108999936
							],
							[
								130.22531275300003,
								-11.503508118999946
							],
							[
								130.21804173300006,
								-11.512019118999945
							],
							[
								130.1952857440001,
								-11.517223108999929
							],
							[
								130.19223375400009,
								-11.537363118999963
							],
							[
								130.17499174500006,
								-11.55841911999994
							],
							[
								130.18672576400002,
								-11.572703109999964
							],
							[
								130.19496476400002,
								-11.571421119999968
							],
							[
								130.2011447530001,
								-11.586260119999963
							],
							[
								130.19092172400008,
								-11.640336119999972
							],
							[
								130.2298317420001,
								-11.642451109999968
							],
							[
								130.23697954200009,
								-11.661780000999954
							],
							[
								130.25546573100007,
								-11.67429311099994
							],
							[
								130.26416072000006,
								-11.661733110999933
							],
							[
								130.25867474100005,
								-11.675780120999946
							],
							[
								130.24630949100003,
								-11.678599780999946
							],
							[
								130.2607307500001,
								-11.697706120999953
							],
							[
								130.27633975000003,
								-11.691290110999944
							],
							[
								130.29389873900004,
								-11.695153110999968
							],
							[
								130.3032427380001,
								-11.727570110999977
							],
							[
								130.28503572900001,
								-11.699108120999938
							],
							[
								130.26182972000004,
								-11.707412100999932
							],
							[
								130.22048074200006,
								-11.670052110999961
							],
							[
								130.20759974300006,
								-11.692727120999962
							],
							[
								130.22610575200008,
								-11.699936110999943
							],
							[
								130.21865172200012,
								-11.717807110999956
							],
							[
								130.23444874100005,
								-11.725596100999951
							],
							[
								130.23417576100007,
								-11.740507100999935
							],
							[
								130.22576473200002,
								-11.726628110999968
							],
							[
								130.21043473200007,
								-11.718610120999926
							],
							[
								130.2227227520001,
								-11.702681120999955
							],
							[
								130.20425773300008,
								-11.69545311099995
							],
							[
								130.21457274300008,
								-11.664216099999976
							],
							[
								130.20232002300008,
								-11.649420519999978
							],
							[
								130.15115873500008,
								-11.706910110999956
							],
							[
								130.11873374700008,
								-11.700085099999967
							],
							[
								130.09059574800006,
								-11.671006119999959
							],
							[
								130.07632873800003,
								-11.66889010999995
							],
							[
								130.06902074900006,
								-11.686495119999961
							],
							[
								130.07196574900001,
								-11.722942109999963
							],
							[
								130.06206274900012,
								-11.75064710099997
							],
							[
								130.0735527280001,
								-11.76484611099994
							],
							[
								130.0568907390001,
								-11.766237110999953
							],
							[
								130.04390473,
								-11.755380110999965
							],
							[
								130.03345376000004,
								-11.755744110999956
							],
							[
								130.02052875100003,
								-11.776352110999937
							],
							[
								130.02394577000007,
								-11.798098100999937
							],
							[
								130.049505769,
								-11.823989110999946
							],
							[
								130.06551174800006,
								-11.818341120999946
							],
							[
								130.08460073800006,
								-11.825050110999939
							],
							[
								130.09906575700006,
								-11.820429100999945
							],
							[
								130.1312917560001,
								-11.82503111099993
							],
							[
								130.31347973800007,
								-11.770704121999927
							],
							[
								130.35779172600007,
								-11.780848111999944
							],
							[
								130.39230674400005,
								-11.80103311199997
							],
							[
								130.5059997090001,
								-11.830739122999944
							],
							[
								130.5460837170001,
								-11.819404112999962
							],
							[
								130.56826973600005,
								-11.820783122999956
							],
							[
								130.56367671700002,
								-11.816541112999971
							],
							[
								130.5683307260001,
								-11.811199122999938
							],
							[
								130.58258273600006,
								-11.827013102999956
							],
							[
								130.6057597250001,
								-11.826991112999963
							],
							[
								130.63258061400006,
								-11.776981262999982
							]
						]
					],
					[
						[
							[
								130.41039866500012,
								-11.365113108999935
							],
							[
								130.41138073500008,
								-11.408274108999933
							],
							[
								130.42669773400007,
								-11.427325119999978
							],
							[
								130.41869073500004,
								-11.45588110999995
							],
							[
								130.43431273400006,
								-11.47567510999994
							],
							[
								130.43241973400006,
								-11.503459109999937
							],
							[
								130.45233274300006,
								-11.516876109999941
							],
							[
								130.46255672200004,
								-11.537212100999966
							],
							[
								130.4876567110001,
								-11.54892812099996
							],
							[
								130.49363775100005,
								-11.564827110999943
							],
							[
								130.48822173100007,
								-11.58737611099997
							],
							[
								130.4785327310001,
								-11.594143120999945
							],
							[
								130.47674672100004,
								-11.62062311099993
							],
							[
								130.49539402000005,
								-11.658404661999953
							],
							[
								130.53209071900005,
								-11.680563111999959
							],
							[
								130.54196272800004,
								-11.67242810199997
							],
							[
								130.55726771800005,
								-11.674280101999955
							],
							[
								130.5718397270001,
								-11.701340111999968
							],
							[
								130.586655736,
								-11.689813111999968
							],
							[
								130.58438218600008,
								-11.698592711999936
							],
							[
								130.59755178600005,
								-11.717212392999954
							],
							[
								130.62319124400005,
								-11.724501902999975
							],
							[
								130.6449206430001,
								-11.749721272999977
							],
							[
								130.67200995200005,
								-11.762780612999961
							],
							[
								130.68277074200012,
								-11.761133112999971
							],
							[
								130.67498872200008,
								-11.776040112999965
							],
							[
								130.68716472100004,
								-11.79653411399994
							],
							[
								130.72525072000008,
								-11.802751113999932
							],
							[
								130.80189716600012,
								-11.845047644999966
							],
							[
								130.86245672300004,
								-11.85487111499998
							],
							[
								130.92158472000006,
								-11.900736105999954
							],
							[
								130.93838368900003,
								-11.931425115999957
							],
							[
								130.9528187090001,
								-11.94032810699997
							],
							[
								130.97607271800007,
								-11.934100116999957
							],
							[
								131.01853768600006,
								-11.886475106999967
							],
							[
								131.0491466950001,
								-11.881672116999937
							],
							[
								131.0823346840001,
								-11.835742116999938
							],
							[
								131.10700671300003,
								-11.830164126999932
							],
							[
								131.18249171000002,
								-11.791745116999948
							],
							[
								131.200114019,
								-11.77188508699993
							],
							[
								131.25643467700002,
								-11.733683106999933
							],
							[
								131.28130669600012,
								-11.740056117999927
							],
							[
								131.2894237060001,
								-11.72372411699996
							],
							[
								131.33259068400002,
								-11.682548107999935
							],
							[
								131.38027370300006,
								-11.583696116999931
							],
							[
								131.40490069200007,
								-11.589945116999957
							],
							[
								131.42661370100006,
								-11.614323127999967
							],
							[
								131.43215268000006,
								-11.605548117999945
							],
							[
								131.44815968000012,
								-11.611982117999958
							],
							[
								131.472023669,
								-11.60661911799997
							],
							[
								131.47097068900007,
								-11.586893117999978
							],
							[
								131.45607869000003,
								-11.580614107999963
							],
							[
								131.46566069900007,
								-11.569915117999926
							],
							[
								131.4553766800001,
								-11.550702127999955
							],
							[
								131.4614486800001,
								-11.514028116999953
							],
							[
								131.4984206890001,
								-11.468796116999954
							],
							[
								131.51178768800003,
								-11.464932106999981
							],
							[
								131.51506768800004,
								-11.473804117999975
							],
							[
								131.52745768800003,
								-11.476624107999953
							],
							[
								131.5436936870001,
								-11.452910127999928
							],
							[
								131.533134678,
								-11.426437126999929
							],
							[
								131.538139698,
								-11.415587116999973
							],
							[
								131.5229716890001,
								-11.394250126999964
							],
							[
								131.5095906790001,
								-11.395539106999934
							],
							[
								131.4959027100001,
								-11.382725126999958
							],
							[
								131.48355870000012,
								-11.398516106999978
							],
							[
								131.46559869100008,
								-11.386017125999956
							],
							[
								131.4641957010001,
								-11.376487125999972
							],
							[
								131.47151968100002,
								-11.370570125999961
							],
							[
								131.45435370200005,
								-11.342955115999928
							],
							[
								131.46269245200006,
								-11.32799747599995
							],
							[
								131.42984771300007,
								-11.303688104999935
							],
							[
								131.4295576830001,
								-11.29544911499994
							],
							[
								131.44289368300008,
								-11.287695114999963
							],
							[
								131.43711070300003,
								-11.266914124999971
							],
							[
								131.41039270500005,
								-11.256189114999927
							],
							[
								131.40091668500008,
								-11.259140104999972
							],
							[
								131.39597370500007,
								-11.266770114999929
							],
							[
								131.40340470500007,
								-11.281403114999932
							],
							[
								131.4006887050001,
								-11.291130124999938
							],
							[
								131.38248469500002,
								-11.29901311499998
							],
							[
								131.3709186860001,
								-11.284105114999932
							],
							[
								131.37508468600004,
								-11.26433510499993
							],
							[
								131.35271470700002,
								-11.249983123999925
							],
							[
								131.32865270800005,
								-11.256299113999944
							],
							[
								131.32347970800004,
								-11.274775123999973
							],
							[
								131.303307689,
								-11.273739123999974
							],
							[
								131.29595268900005,
								-11.267344113999968
							],
							[
								131.30010368900003,
								-11.250882113999978
							],
							[
								131.31603370900007,
								-11.22890711399998
							],
							[
								131.29764669000008,
								-11.211536113999955
							],
							[
								131.29940069000008,
								-11.203877113999965
							],
							[
								131.2884607000001,
								-11.194093102999943
							],
							[
								131.28130469000007,
								-11.199506112999927
							],
							[
								131.27628371100002,
								-11.189739112999973
							],
							[
								131.27127971100003,
								-11.198137112999973
							],
							[
								131.26300968100009,
								-11.191141112999958
							],
							[
								131.25176371200007,
								-11.192690122999977
							],
							[
								131.24707871200008,
								-11.218862112999943
							],
							[
								131.21894269300003,
								-11.22498311299995
							],
							[
								131.20430969300003,
								-11.236533102999942
							],
							[
								131.19778484300002,
								-11.269540322999944
							],
							[
								131.203195713,
								-11.284531112999957
							],
							[
								131.19085170300002,
								-11.302625112999976
							],
							[
								131.2192477220001,
								-11.308487113999945
							],
							[
								131.20943670200006,
								-11.34382511399997
							],
							[
								131.20812471200009,
								-11.31111911399995
							],
							[
								131.1997777030001,
								-11.31275412399998
							],
							[
								131.18760444300005,
								-11.334888803999945
							],
							[
								131.1683747840001,
								-11.313439452999944
							],
							[
								131.17217491400004,
								-11.286350122999977
							],
							[
								131.16374509500008,
								-11.27807039299995
							],
							[
								131.16591870500008,
								-11.266097122999952
							],
							[
								131.14833544500004,
								-11.249861242999941
							],
							[
								131.11295570700008,
								-11.258887112999957
							],
							[
								131.11252070700004,
								-11.27902211299994
							],
							[
								131.088526698,
								-11.299027122999973
							],
							[
								131.0919146970001,
								-11.30404611299997
							],
							[
								131.072947698,
								-11.303475112999934
							],
							[
								131.04047670900002,
								-11.318614111999977
							],
							[
								131.05196771900012,
								-11.341961112999968
							],
							[
								131.03254671900004,
								-11.36723410299993
							],
							[
								130.99084073100005,
								-11.35501611199993
							],
							[
								130.98875070100007,
								-11.340008121999972
							],
							[
								130.8993497250001,
								-11.30930411099996
							],
							[
								130.8490877270001,
								-11.35474710099993
							],
							[
								130.80793572900006,
								-11.364548110999976
							],
							[
								130.7722796500001,
								-11.364383940999971
							],
							[
								130.76362273100005,
								-11.375014110999928
							],
							[
								130.70481772300002,
								-11.38496012099995
							],
							[
								130.69566272300005,
								-11.408282110999949
							],
							[
								130.69665373300006,
								-11.426610110999945
							],
							[
								130.72119071200007,
								-11.419795120999936
							],
							[
								130.7333367020001,
								-11.426883120999946
							],
							[
								130.74014972100008,
								-11.442472940999949
							],
							[
								130.75495774,
								-11.447202110999967
							],
							[
								130.7577957200001,
								-11.461558111999977
							],
							[
								130.77229173000012,
								-11.467175121999958
							],
							[
								130.76762272000008,
								-11.486069111999939
							],
							[
								130.79298270900006,
								-11.494339111999977
							],
							[
								130.80718872800003,
								-11.508660111999973
							],
							[
								130.81036170800007,
								-11.527370101999963
							],
							[
								130.79551072800007,
								-11.511069111999973
							],
							[
								130.76151971000002,
								-11.497930111999949
							],
							[
								130.75190572000008,
								-11.47791910199993
							],
							[
								130.72231973200007,
								-11.469743100999949
							],
							[
								130.7157737120001,
								-11.489497111999981
							],
							[
								130.71093673200005,
								-11.488685101999977
							],
							[
								130.69451874300012,
								-11.463831110999934
							],
							[
								130.70164372300007,
								-11.441108120999957
							],
							[
								130.6927637130001,
								-11.44701711099998
							],
							[
								130.68499673300005,
								-11.443220120999968
							],
							[
								130.67581001400004,
								-11.419176420999975
							],
							[
								130.65724070500005,
								-11.400040120999961
							],
							[
								130.66345070500006,
								-11.341262119999953
							],
							[
								130.65693571500003,
								-11.335603119999973
							],
							[
								130.6416467360001,
								-11.355496109999933
							],
							[
								130.63769473600007,
								-11.37492710999993
							],
							[
								130.6195217170001,
								-11.387341109999966
							],
							[
								130.60092073700002,
								-11.386349119999977
							],
							[
								130.58166472800008,
								-11.40219210999993
							],
							[
								130.56927472900009,
								-11.398028109999927
							],
							[
								130.55754073900005,
								-11.385072119999961
							],
							[
								130.55483973900004,
								-11.361816119999958
							],
							[
								130.56599373900008,
								-11.350474099999929
							],
							[
								130.5657197390001,
								-11.341362109999977
							],
							[
								130.58715771800007,
								-11.34237810999997
							],
							[
								130.58619674800002,
								-11.336263109999948
							],
							[
								130.60391172800007,
								-11.321097119999934
							],
							[
								130.60346872800005,
								-11.300098099999957
							],
							[
								130.59593070800008,
								-11.289453108999965
							],
							[
								130.5543667400001,
								-11.266132098999947
							],
							[
								130.54309072,
								-11.283060098999954
							],
							[
								130.51614460100006,
								-11.280048998999973
							],
							[
								130.48796072300001,
								-11.260270118999927
							],
							[
								130.444778745,
								-11.205260107999948
							],
							[
								130.40177973700008,
								-11.165647106999927
							],
							[
								130.37712172800002,
								-11.167497106999974
							],
							[
								130.36378571800003,
								-11.254030107999938
							],
							[
								130.38960373700002,
								-11.274579107999955
							],
							[
								130.40998971600004,
								-11.305187118999982
							],
							[
								130.40988175600012,
								-11.316507098999978
							],
							[
								130.3987137360001,
								-11.31750010899998
							],
							[
								130.39468472600004,
								-11.33542110899998
							],
							[
								130.38406475700003,
								-11.345995098999936
							],
							[
								130.39032074600004,
								-11.365875108999944
							],
							[
								130.41039866500012,
								-11.365113108999935
							]
						]
					],
					[
						[
							[
								130.65127671300002,
								-11.814472103999947
							],
							[
								130.64617971300004,
								-11.80907811399993
							],
							[
								130.64680572300006,
								-11.821441113999981
							],
							[
								130.66113372200005,
								-11.815608113999929
							],
							[
								130.65127671300002,
								-11.814472103999947
							]
						]
					],
					[
						[
							[
								130.65656972500005,
								-11.32128511999997
							],
							[
								130.6650677350001,
								-11.326662099999965
							],
							[
								130.6608727150001,
								-11.314589119999937
							],
							[
								130.65656972500005,
								-11.32128511999997
							]
						]
					],
					[
						[
							[
								131.032475104,
								-12.05830521799993
							],
							[
								131.0628749330001,
								-12.046825187999957
							],
							[
								131.06410494300007,
								-12.034065187999943
							],
							[
								131.02335510500006,
								-12.036185227999965
							],
							[
								131.00192526600006,
								-12.05237528799995
							],
							[
								131.032475104,
								-12.05830521799993
							]
						]
					],
					[
						[
							[
								131.04595835300006,
								-12.093977767999945
							],
							[
								131.03874219400006,
								-12.09427269799994
							],
							[
								131.0545548330001,
								-12.109008838999955
							],
							[
								131.03211141400004,
								-12.095270827999968
							],
							[
								131.00206224500005,
								-12.117873437999947
							],
							[
								131.03194125400012,
								-12.130088248999982
							],
							[
								131.0651446820001,
								-12.125522658999955
							],
							[
								131.07107246200007,
								-12.114063388999966
							],
							[
								131.04595835300006,
								-12.093977767999945
							]
						]
					],
					[
						[
							[
								131.35241328900008,
								-12.097205260999942
							],
							[
								131.34428346000004,
								-12.104685220999954
							],
							[
								131.34798335000005,
								-12.11246523099993
							],
							[
								131.357273189,
								-12.109045280999965
							],
							[
								131.35241328900008,
								-12.097205260999942
							]
						]
					],
					[
						[
							[
								132.111148651,
								-11.611618114999942
							],
							[
								132.1140476610001,
								-11.624321124999938
							],
							[
								132.1326476600001,
								-11.628084114999979
							],
							[
								132.14976765000006,
								-11.609014134999939
							],
							[
								132.13058767100006,
								-11.565196124999943
							],
							[
								132.12279065100006,
								-11.56489213499998
							],
							[
								132.11409266200008,
								-11.576193114999967
							],
							[
								132.121508661,
								-11.592902134999974
							],
							[
								132.111148651,
								-11.611618114999942
							]
						]
					],
					[
						[
							[
								132.1690706390001,
								-11.587255115999938
							],
							[
								132.17534064900008,
								-11.585795135999945
							],
							[
								132.17203064900002,
								-11.577207124999973
							],
							[
								132.1690706390001,
								-11.587255115999938
							]
						]
					],
					[
						[
							[
								131.08031693200007,
								-12.016411177999942
							],
							[
								131.11189279100006,
								-12.023819127999957
							],
							[
								131.13548974000003,
								-12.014657127999953
							],
							[
								131.12714683000002,
								-12.000947167999982
							],
							[
								131.07288695300008,
								-12.01495616799997
							],
							[
								131.08031693200007,
								-12.016411177999942
							]
						]
					],
					[
						[
							[
								131.06867482200005,
								-12.071895167999969
							],
							[
								131.1164345200001,
								-12.07325506899997
							],
							[
								131.12672452000004,
								-12.059445078999943
							],
							[
								131.09434457100008,
								-12.053535107999949
							],
							[
								131.0622349030001,
								-12.06840516799997
							],
							[
								131.06867482200005,
								-12.071895167999969
							]
						]
					],
					[
						[
							[
								131.94820068,
								-11.47825813199995
							],
							[
								131.95939968900007,
								-11.488712121999981
							],
							[
								131.96496965900008,
								-11.48442812199994
							],
							[
								131.95517368000003,
								-11.47303913199994
							],
							[
								131.94820068,
								-11.47825813199995
							]
						]
					],
					[
						[
							[
								132.29985265300002,
								-11.593331126999942
							],
							[
								132.3188186430001,
								-11.59871213699995
							],
							[
								132.32492165300005,
								-11.581748126999969
							],
							[
								132.3044136640001,
								-11.56366212699993
							],
							[
								132.296342664,
								-11.585651136999957
							],
							[
								132.29985265300002,
								-11.593331126999942
							]
						]
					],
					[
						[
							[
								132.58184066800004,
								-11.154124127999978
							],
							[
								132.589686668,
								-11.13962412799998
							],
							[
								132.60307062700008,
								-11.143388137999978
							],
							[
								132.61388864700007,
								-11.12883312799994
							],
							[
								132.60314665700002,
								-11.120187137999949
							],
							[
								132.57960164000008,
								-11.012049125999965
							],
							[
								132.58317266000006,
								-10.990874135999945
							],
							[
								132.5976066600001,
								-10.97749611599994
							],
							[
								132.59487565000006,
								-10.970153135999965
							],
							[
								132.56461767100006,
								-10.979392125999937
							],
							[
								132.55683565100003,
								-10.996907135999948
							],
							[
								132.56191667000007,
								-11.027081125999928
							],
							[
								132.5482446410001,
								-11.041722125999968
							],
							[
								132.52760064200004,
								-11.042857135999952
							],
							[
								132.52129866200005,
								-11.05408913599996
							],
							[
								132.50282065200008,
								-11.058755125999937
							],
							[
								132.4678626640001,
								-11.032768124999961
							],
							[
								132.46209566400012,
								-11.038685124999972
							],
							[
								132.48541066300004,
								-11.078674135999961
							],
							[
								132.50864966200004,
								-11.08227811599994
							],
							[
								132.51347065100003,
								-11.090888125999982
							],
							[
								132.50449866100007,
								-11.125453125999968
							],
							[
								132.51159466100012,
								-11.130607125999973
							],
							[
								132.50814665100006,
								-11.14191412599996
							],
							[
								132.493986661,
								-11.155405125999948
							],
							[
								132.477231662,
								-11.149244125999928
							],
							[
								132.47018264200005,
								-11.158074115999966
							],
							[
								132.490293661,
								-11.175102125999956
							],
							[
								132.50068467000006,
								-11.204954136999959
							],
							[
								132.53077566900004,
								-11.24435811799998
							],
							[
								132.5428596480001,
								-11.251066127999934
							],
							[
								132.55644063600005,
								-11.31358311799994
							],
							[
								132.5657026560001,
								-11.328890128999944
							],
							[
								132.58541663500012,
								-11.337561118999929
							],
							[
								132.58833163500003,
								-11.356564138999943
							],
							[
								132.60012566500006,
								-11.300334128999964
							],
							[
								132.61022765500002,
								-11.287456128999963
							],
							[
								132.61962662400003,
								-11.28682712899996
							],
							[
								132.61974864500007,
								-11.231797118999964
							],
							[
								132.60479463600007,
								-11.219792137999946
							],
							[
								132.6032986460001,
								-11.202270117999944
							],
							[
								132.61561264600005,
								-11.18643211799997
							],
							[
								132.6315436550001,
								-11.186834128999976
							],
							[
								132.62023563600007,
								-11.172104127999944
							],
							[
								132.60015562700005,
								-11.170532127999934
							],
							[
								132.60059863700008,
								-11.176936127999966
							],
							[
								132.58997866700008,
								-11.17869812799995
							],
							[
								132.58187566800007,
								-11.16870212799995
							],
							[
								132.58184066800004,
								-11.154124127999978
							]
						]
					],
					[
						[
							[
								132.8290046400001,
								-11.00195311999994
							],
							[
								132.8168896300001,
								-11.024046139999939
							],
							[
								132.82465563000005,
								-11.020140139999967
							],
							[
								132.8290046400001,
								-11.00195311999994
							]
						]
					],
					[
						[
							[
								132.8250066500001,
								-10.995190129999969
							],
							[
								132.83272764000003,
								-10.973992129999942
							],
							[
								132.83101864000002,
								-10.96731712999997
							],
							[
								132.82752464100008,
								-10.972767129999966
							],
							[
								132.8218016610001,
								-10.966819119999968
							],
							[
								132.8250066500001,
								-10.995190129999969
							]
						]
					],
					[
						[
							[
								132.65078364400006,
								-11.20460812899995
							],
							[
								132.6427126540001,
								-11.21028513899995
							],
							[
								132.661159644,
								-11.211738128999968
							],
							[
								132.6824306430001,
								-11.188531128999955
							],
							[
								132.66190764400005,
								-11.18669813899993
							],
							[
								132.65078364400006,
								-11.20460812899995
							]
						]
					],
					[
						[
							[
								132.73051165000004,
								-11.296318130999964
							],
							[
								132.73275363000005,
								-11.284890120999933
							],
							[
								132.71957063000002,
								-11.28457814099994
							],
							[
								132.73051165000004,
								-11.296318130999964
							]
						]
					],
					[
						[
							[
								132.779079646,
								-11.388484131999974
							],
							[
								132.7980926350001,
								-11.395576122999955
							],
							[
								132.802989625,
								-11.388771142999929
							],
							[
								132.77871361600012,
								-11.373136121999949
							],
							[
								132.779079646,
								-11.388484131999974
							]
						]
					],
					[
						[
							[
								132.331604663,
								-11.537688126999967
							],
							[
								132.338181673,
								-11.54056513699993
							],
							[
								132.33612164300007,
								-11.514810116999968
							],
							[
								132.331604663,
								-11.537688126999967
							]
						]
					],
					[
						[
							[
								132.33641272500006,
								-12.09351867199996
							],
							[
								132.38991212200006,
								-12.139708992999942
							],
							[
								132.4112719210001,
								-12.138279102999945
							],
							[
								132.4219819010001,
								-12.120569202999945
							],
							[
								132.413092182,
								-12.088139241999954
							],
							[
								132.4014023630001,
								-12.076149181999938
							],
							[
								132.37754264400007,
								-12.072939041999973
							],
							[
								132.36088276400005,
								-12.083068941999954
							],
							[
								132.3397628450001,
								-12.081448730999966
							],
							[
								132.33641272500006,
								-12.09351867199996
							]
						]
					],
					[
						[
							[
								132.35624244300004,
								-12.156578771999932
							],
							[
								132.34450232400002,
								-12.172138621999977
							],
							[
								132.35204231300008,
								-12.188978721999945
							],
							[
								132.3602222930001,
								-12.173868771999935
							],
							[
								132.35624244300004,
								-12.156578771999932
							]
						]
					],
					[
						[
							[
								132.4529416360001,
								-11.626319128999967
							],
							[
								132.45947265600012,
								-11.628714119999927
							],
							[
								132.4638366360001,
								-11.621006129999955
							],
							[
								132.45115762700004,
								-11.61720312899996
							],
							[
								132.4529416360001,
								-11.626319128999967
							]
						]
					],
					[
						[
							[
								135.60147190100008,
								-14.504233645999932
							],
							[
								135.61204179000003,
								-14.518243566999956
							],
							[
								135.6300115800001,
								-14.493583546999957
							],
							[
								135.6249016600001,
								-14.48839359699997
							],
							[
								135.60309185100004,
								-14.490323675999946
							],
							[
								135.60147190100008,
								-14.504233645999932
							]
						]
					],
					[
						[
							[
								135.68959077400007,
								-14.906131641999934
							],
							[
								135.70797056300012,
								-14.91290152199997
							],
							[
								135.73212024200006,
								-14.892181482999945
							],
							[
								135.73887015200012,
								-14.898851432999948
							],
							[
								135.7531600110001,
								-14.895891383999981
							],
							[
								135.7640998600001,
								-14.901761303999933
							],
							[
								135.76718984100012,
								-14.867161393999936
							],
							[
								135.7475101430001,
								-14.836541642999975
							],
							[
								135.72589034400005,
								-14.83475176199994
							],
							[
								135.70953057500003,
								-14.851951791999966
							],
							[
								135.72101044400006,
								-14.860421661999965
							],
							[
								135.71955044300012,
								-14.87580163299998
							],
							[
								135.69005078400005,
								-14.89889169199995
							],
							[
								135.68959077400007,
								-14.906131641999934
							]
						]
					],
					[
						[
							[
								135.73513045000004,
								-14.287973677999958
							],
							[
								135.72794050000005,
								-14.290443727999957
							],
							[
								135.73247048000007,
								-14.295193667999968
							],
							[
								135.73513045000004,
								-14.287973677999958
							]
						]
					],
					[
						[
							[
								136.07765842700007,
								-13.468673231999958
							],
							[
								136.07634544600012,
								-13.484839231999956
							],
							[
								136.08139642600008,
								-13.472716221999974
							],
							[
								136.10578043500004,
								-13.471799231999967
							],
							[
								136.1089084450001,
								-13.465272221999953
							],
							[
								136.10054542600005,
								-13.454733221999959
							],
							[
								136.085791437,
								-13.452412231999972
							],
							[
								136.0822054570001,
								-13.443803210999931
							],
							[
								136.07765842700007,
								-13.468673231999958
							]
						]
					],
					[
						[
							[
								136.1415614220001,
								-13.523767233999934
							],
							[
								136.14032644100007,
								-13.53305123399997
							],
							[
								136.12673045200006,
								-13.543418223999936
							],
							[
								136.13669443100002,
								-13.549660213999971
							],
							[
								136.1408144500001,
								-13.564618223999958
							],
							[
								136.15048844000012,
								-13.558773223999935
							],
							[
								136.1495414110001,
								-13.524759213999971
							],
							[
								136.15582843100003,
								-13.518823233999967
							],
							[
								136.16605244000004,
								-13.523602224999934
							],
							[
								136.1680974310001,
								-13.510138224999935
							],
							[
								136.155919422,
								-13.491587223999943
							],
							[
								136.14688742200008,
								-13.492232223999963
							],
							[
								136.1417444330001,
								-13.470882222999933
							],
							[
								136.1499384230001,
								-13.46807122399997
							],
							[
								136.16509041200004,
								-13.485415233999959
							],
							[
								136.1756954120001,
								-13.465510233999964
							],
							[
								136.19933044000004,
								-13.470065224999928
							],
							[
								136.20508343100005,
								-13.451467234999939
							],
							[
								136.19879645100002,
								-13.454449224999962
							],
							[
								136.17722042200012,
								-13.438216213999965
							],
							[
								136.18077643300012,
								-13.426756223999973
							],
							[
								136.1624964340001,
								-13.41871322399993
							],
							[
								136.1506554350001,
								-13.385289212999965
							],
							[
								136.14079842600006,
								-13.386691222999957
							],
							[
								136.11534642800007,
								-13.357842221999931
							],
							[
								136.09218444900011,
								-13.358002210999928
							],
							[
								136.09000144900006,
								-13.36565122099995
							],
							[
								136.1103414480001,
								-13.365572231999977
							],
							[
								136.12660843700007,
								-13.374612211999931
							],
							[
								136.12645443600002,
								-13.389900231999945
							],
							[
								136.14143943500005,
								-13.41908022299998
							],
							[
								136.12996544500004,
								-13.428844222999942
							],
							[
								136.13577745400005,
								-13.452456222999956
							],
							[
								136.1213444340001,
								-13.482581212999946
							],
							[
								136.13190345300006,
								-13.487632232999943
							],
							[
								136.12781344300004,
								-13.50331921299994
							],
							[
								136.14005141200005,
								-13.497950223999965
							],
							[
								136.14879444200005,
								-13.506050223999978
							],
							[
								136.1415614220001,
								-13.523767233999934
							]
						]
					],
					[
						[
							[
								136.0968684610001,
								-13.30258822099995
							],
							[
								136.09245845100008,
								-13.296641230999967
							],
							[
								136.07767245200012,
								-13.297684219999951
							],
							[
								136.09152745000006,
								-13.321596230999944
							],
							[
								136.0968684610001,
								-13.30258822099995
							]
						]
					],
					[
						[
							[
								135.97362445600004,
								-13.330655216999958
							],
							[
								135.96190543700004,
								-13.321205206999934
							],
							[
								135.96204344700004,
								-13.329933216999962
							],
							[
								135.97672144500007,
								-13.343665227999963
							],
							[
								135.97362445600004,
								-13.330655216999958
							]
						]
					],
					[
						[
							[
								134.1717855830001,
								-12.11306816299998
							],
							[
								134.1850155520001,
								-12.097207152999943
							],
							[
								134.18240554300007,
								-12.08710216299994
							],
							[
								134.16482754300011,
								-12.101260152999942
							],
							[
								134.1717855830001,
								-12.11306816299998
							]
						]
					],
					[
						[
							[
								134.21293757400008,
								-11.957576161999953
							],
							[
								134.20813154400003,
								-11.962332161999939
							],
							[
								134.21748456400007,
								-11.963996162999933
							],
							[
								134.22258157400006,
								-11.954126162999955
							],
							[
								134.21293757400008,
								-11.957576161999953
							]
						]
					],
					[
						[
							[
								133.31554460900009,
								-11.667426142999943
							],
							[
								133.32234958900005,
								-11.660739152999952
							],
							[
								133.3158036090001,
								-11.659241152999925
							],
							[
								133.31554460900009,
								-11.667426142999943
							]
						]
					],
					[
						[
							[
								132.90369564500008,
								-11.14342314199996
							],
							[
								132.878412636,
								-11.147199141999977
							],
							[
								132.86358064600006,
								-11.13999013199998
							],
							[
								132.8570356470001,
								-11.148026121999976
							],
							[
								132.8714846460001,
								-11.155348131999972
							],
							[
								132.8763066250001,
								-11.170772131999968
							],
							[
								132.9014836350001,
								-11.160102131999963
							],
							[
								132.92041965400006,
								-11.169673122999939
							],
							[
								132.9144076240001,
								-11.15878713199993
							],
							[
								132.9178256340001,
								-11.140487131999976
							],
							[
								132.90369564500008,
								-11.14342314199996
							]
						]
					],
					[
						[
							[
								132.85437965800008,
								-11.060483130999955
							],
							[
								132.8720646370001,
								-11.059905130999937
							],
							[
								132.87752663700007,
								-11.047958130999973
							],
							[
								132.85910965800008,
								-11.045162130999927
							],
							[
								132.85437965800008,
								-11.060483130999955
							]
						]
					],
					[
						[
							[
								132.9906856120001,
								-11.078717132999941
							],
							[
								132.993965612,
								-11.088283132999948
							],
							[
								133.00484564200008,
								-11.088030132999961
							],
							[
								133.01700664100008,
								-11.067945142999974
							],
							[
								132.97802062300002,
								-11.044143132999977
							],
							[
								132.9906856120001,
								-11.078717132999941
							]
						]
					],
					[
						[
							[
								133.02817564400004,
								-10.908394131999955
							],
							[
								133.0267106440001,
								-10.91277213199993
							],
							[
								133.04366263300005,
								-10.90673714299993
							],
							[
								133.02817564400004,
								-10.908394131999955
							]
						]
					],
					[
						[
							[
								133.39108960900012,
								-11.495423152999933
							],
							[
								133.40125160800005,
								-11.507580152999935
							],
							[
								133.3848486180001,
								-11.54772914299997
							],
							[
								133.4359656270001,
								-11.506304153999963
							],
							[
								133.45284161600011,
								-11.516480143999956
							],
							[
								133.49083559400003,
								-11.520214154999962
							],
							[
								133.49251361400002,
								-11.51501213499995
							],
							[
								133.4667576060001,
								-11.46471814399996
							],
							[
								133.42476559700003,
								-11.490457143999947
							],
							[
								133.3909676190001,
								-11.48869614299997
							],
							[
								133.39108960900012,
								-11.495423152999933
							]
						]
					],
					[
						[
							[
								133.38542962600002,
								-11.637622143999977
							],
							[
								133.41361159500002,
								-11.625683153999944
							],
							[
								133.42053959500004,
								-11.646265144999973
							],
							[
								133.42635261500004,
								-11.62965414499996
							],
							[
								133.43930759400007,
								-11.627281144999927
							],
							[
								133.44634162400007,
								-11.617991144999962
							],
							[
								133.478827603,
								-11.623972145999971
							],
							[
								133.481436593,
								-11.618989145999933
							],
							[
								133.46562858400011,
								-11.592217154999958
							],
							[
								133.44696661500006,
								-11.594832144999941
							],
							[
								133.40807261600003,
								-11.585237133999954
							],
							[
								133.39217361700003,
								-11.604347133999966
							],
							[
								133.348365628,
								-11.62416914299996
							],
							[
								133.36449362700012,
								-11.643406153999933
							],
							[
								133.35797858700005,
								-11.665386153999975
							],
							[
								133.36910262600009,
								-11.682110153999929
							],
							[
								133.3946306150001,
								-11.674658143999977
							],
							[
								133.40169558500008,
								-11.661571153999944
							],
							[
								133.38542962600002,
								-11.637622143999977
							]
						]
					],
					[
						[
							[
								134.81238854600008,
								-12.024541185999965
							],
							[
								134.80312754700003,
								-12.01422118599993
							],
							[
								134.79777055700004,
								-12.033595175999949
							],
							[
								134.83161451500007,
								-12.04723417699995
							],
							[
								134.81238854600008,
								-12.024541185999965
							]
						]
					],
					[
						[
							[
								134.8499855550001,
								-12.012729176999926
							],
							[
								134.83698553500005,
								-12.00762816699995
							],
							[
								134.8270985160001,
								-12.022110176999945
							],
							[
								134.8290815250001,
								-12.029052166999975
							],
							[
								134.85062755400008,
								-12.03894117699997
							],
							[
								134.86579352400008,
								-12.028371187999937
							],
							[
								134.86045353400004,
								-12.01616318799995
							],
							[
								134.8499855550001,
								-12.012729176999926
							]
						]
					],
					[
						[
							[
								134.90944952200005,
								-12.03343217899993
							],
							[
								134.93354252000006,
								-12.046300189999954
							],
							[
								134.94092752000006,
								-12.062799189999964
							],
							[
								134.95850551900003,
								-12.066111189999958
							],
							[
								134.9630215190001,
								-12.052274189999935
							],
							[
								134.99065552800005,
								-12.036589190999962
							],
							[
								134.9548275300001,
								-12.015538179999965
							],
							[
								134.9095715420001,
								-12.023395188999928
							],
							[
								134.90944952200005,
								-12.03343217899993
							]
						]
					],
					[
						[
							[
								134.9441625190001,
								-12.08059217999994
							],
							[
								134.9571785280001,
								-12.095789190999938
							],
							[
								134.95453851900004,
								-12.073809189999963
							],
							[
								134.9428965190001,
								-12.071422189999964
							],
							[
								134.9441625190001,
								-12.08059217999994
							]
						]
					],
					[
						[
							[
								134.91886353100006,
								-12.060022168999978
							],
							[
								134.9307805200001,
								-12.067137179999975
							],
							[
								134.92670753000004,
								-12.054158168999948
							],
							[
								134.9200235410001,
								-12.052699188999952
							],
							[
								134.91886353100006,
								-12.060022168999978
							]
						]
					],
					[
						[
							[
								134.9199345090001,
								-12.110961179999947
							],
							[
								134.92945352900006,
								-12.093496179999931
							],
							[
								134.91869654000004,
								-12.07618717899993
							],
							[
								134.84798754400003,
								-12.044370166999954
							],
							[
								134.8658855330001,
								-12.070749177999971
							],
							[
								134.8689535410001,
								-12.126959188999933
							],
							[
								134.90153051900006,
								-12.14021417999993
							],
							[
								134.91277550900008,
								-12.131811179999943
							],
							[
								134.9164225190001,
								-12.123454179999953
							],
							[
								134.9115245490001,
								-12.121498169999938
							],
							[
								134.9199345090001,
								-12.110961179999947
							]
						]
					],
					[
						[
							[
								134.99152652600003,
								-12.095678190999934
							],
							[
								135.00217652600008,
								-12.093351181999935
							],
							[
								135.00061951600003,
								-12.078322190999927
							],
							[
								134.97796052800004,
								-12.066269180999939
							],
							[
								134.99152652600003,
								-12.095678190999934
							]
						]
					],
					[
						[
							[
								135.05568852700003,
								-11.95394719199993
							],
							[
								135.090461526,
								-11.94015718299994
							],
							[
								135.10909250500004,
								-11.940534192999962
							],
							[
								135.12213852500008,
								-11.927016182999978
							],
							[
								135.0823595070001,
								-11.915197181999929
							],
							[
								135.06649051800002,
								-11.92188317199998
							],
							[
								135.05568753800003,
								-11.918788181999957
							],
							[
								135.0461515080001,
								-11.939300180999965
							],
							[
								135.05568852700003,
								-11.95394719199993
							]
						]
					],
					[
						[
							[
								135.15225855000006,
								-11.699978191999946
							],
							[
								135.168401549,
								-11.706700182999953
							],
							[
								135.15671454000005,
								-11.685867181999981
							],
							[
								135.14928354000006,
								-11.687341171999947
							],
							[
								135.15225855000006,
								-11.699978191999946
							]
						]
					],
					[
						[
							[
								135.5619700730001,
								-12.014104184999951
							],
							[
								135.56364396300012,
								-12.031961385999978
							],
							[
								135.5538225030001,
								-12.049120194999944
							],
							[
								135.56438151200007,
								-12.056969185999947
							],
							[
								135.56622849200005,
								-12.071721195999942
							],
							[
								135.58118151100007,
								-12.055421205999949
							],
							[
								135.59198449100006,
								-12.05636919699998
							],
							[
								135.60594549100006,
								-12.033009196999956
							],
							[
								135.62418048000006,
								-12.029654196999957
							],
							[
								135.6366015100001,
								-12.018285186999947
							],
							[
								135.73588851600005,
								-12.00198918999996
							],
							[
								135.74264849700012,
								-11.975218189999964
							],
							[
								135.78276250500005,
								-11.974075210999956
							],
							[
								135.8175535040001,
								-11.942950201999963
							],
							[
								135.85817048400008,
								-11.878648191999957
							],
							[
								135.90083449300005,
								-11.852470192999931
							],
							[
								135.9082334840001,
								-11.823957202999964
							],
							[
								135.92102151400002,
								-11.810358203999954
							],
							[
								135.93840051300003,
								-11.804435203999958
							],
							[
								135.9307094840001,
								-11.778970193999953
							],
							[
								135.91024849500002,
								-11.768780212999957
							],
							[
								135.90719647600008,
								-11.757832202999964
							],
							[
								135.88992351600007,
								-11.762878211999976
							],
							[
								135.875748487,
								-11.756628211999953
							],
							[
								135.8650374870001,
								-11.767838211999958
							],
							[
								135.8661355170001,
								-11.783775201999958
							],
							[
								135.8859415060001,
								-11.792350212999963
							],
							[
								135.889039485,
								-11.80542619299996
							],
							[
								135.88322550500004,
								-11.804669212999954
							],
							[
								135.8708655150001,
								-11.834229191999952
							],
							[
								135.8568124950001,
								-11.846528201999945
							],
							[
								135.84777947600003,
								-11.848994191999964
							],
							[
								135.83519150600011,
								-11.838348200999974
							],
							[
								135.8319565160001,
								-11.860779211999954
							],
							[
								135.7821824870001,
								-11.909522200999959
							],
							[
								135.7607135180001,
								-11.91224219999998
							],
							[
								135.73361448800006,
								-11.939375198999926
							],
							[
								135.71519750900006,
								-11.932431208999958
							],
							[
								135.6995125090001,
								-11.93908818899996
							],
							[
								135.66551549100006,
								-11.936413197999968
							],
							[
								135.6705965110001,
								-11.942250187999946
							],
							[
								135.66626349000012,
								-11.952572197999928
							],
							[
								135.64277950100006,
								-11.973083196999937
							],
							[
								135.62013650200004,
								-11.972641196999973
							],
							[
								135.61433749200012,
								-11.969615205999958
							],
							[
								135.61905249200004,
								-11.959949195999968
							],
							[
								135.60622051300004,
								-11.961547185999962
							],
							[
								135.59401451400004,
								-11.950618205999945
							],
							[
								135.58087550400012,
								-11.961282194999967
							],
							[
								135.58821550400012,
								-11.965172185999961
							],
							[
								135.585697513,
								-11.978795205999972
							],
							[
								135.5619700730001,
								-12.014104184999951
							]
						]
					],
					[
						[
							[
								135.9387664950001,
								-11.749050203999957
							],
							[
								135.94113049400005,
								-11.766175203999978
							],
							[
								135.95869451300007,
								-11.762062193999952
							],
							[
								135.97706550300006,
								-11.742570204999936
							],
							[
								135.9771874930001,
								-11.732795194999937
							],
							[
								135.95346048400006,
								-11.732990203999975
							],
							[
								135.95262051400005,
								-11.742819203999943
							],
							[
								135.94122250500004,
								-11.741391203999967
							],
							[
								135.9387664950001,
								-11.749050203999957
							]
						]
					],
					[
						[
							[
								135.99232349300007,
								-11.715655204999962
							],
							[
								135.99943548300007,
								-11.717160194999963
							],
							[
								136.0158685130001,
								-11.692956204999973
							],
							[
								136.02926448300002,
								-11.686178215999973
							],
							[
								136.03295748300002,
								-11.673308205999945
							],
							[
								136.05502147200002,
								-11.653429195999934
							],
							[
								136.0493144830001,
								-11.644715195999936
							],
							[
								136.03396448400008,
								-11.64682619599995
							],
							[
								136.02458047400012,
								-11.638560214999927
							],
							[
								135.95306350600003,
								-11.679448203999982
							],
							[
								135.95313950500008,
								-11.700662213999976
							],
							[
								135.98248250400002,
								-11.715807204999976
							],
							[
								135.99130248400002,
								-11.70475920499996
							],
							[
								135.99232349300007,
								-11.715655204999962
							]
						]
					],
					[
						[
							[
								136.05518948300005,
								-11.642038215999946
							],
							[
								136.06275750200007,
								-11.647267195999973
							],
							[
								136.0678234820001,
								-11.636285216999966
							],
							[
								136.06202447300006,
								-11.627466205999951
							],
							[
								136.05518948300005,
								-11.642038215999946
							]
						]
					],
					[
						[
							[
								136.07810751300008,
								-11.604404196999951
							],
							[
								136.0855235030001,
								-11.601285206999933
							],
							[
								136.08852950300002,
								-11.581752206999965
							],
							[
								136.0767804840001,
								-11.586513195999942
							],
							[
								136.07810751300008,
								-11.604404196999951
							]
						]
					],
					[
						[
							[
								136.10633650300008,
								-11.563004216999957
							],
							[
								136.11443847300006,
								-11.566127196999958
							],
							[
								136.1224494930001,
								-11.544236206999926
							],
							[
								136.11138649300005,
								-11.545963196999935
							],
							[
								136.10633650300008,
								-11.563004216999957
							]
						]
					],
					[
						[
							[
								136.1547675070001,
								-11.697956209999973
							],
							[
								136.13758647800012,
								-11.682790198999953
							],
							[
								136.14066747800007,
								-11.69747420899995
							],
							[
								136.12487549800005,
								-11.71099720899997
							],
							[
								136.1309344970001,
								-11.725508218999948
							],
							[
								136.1547675070001,
								-11.697956209999973
							]
						]
					],
					[
						[
							[
								136.07363749800004,
								-11.770975207999982
							],
							[
								136.08079349800005,
								-11.772359207999955
							],
							[
								136.09190249800008,
								-11.753602207999961
							],
							[
								136.1032854980001,
								-11.748998207999932
							],
							[
								136.10099646800006,
								-11.741800207999972
							],
							[
								136.076475479,
								-11.752684217999956
							],
							[
								136.07992446800006,
								-11.760267197999951
							],
							[
								136.07363749800004,
								-11.770975207999982
							]
						]
					],
					[
						[
							[
								136.04788148900002,
								-11.788105206999944
							],
							[
								136.0406484990001,
								-11.783148206999954
							],
							[
								136.0278164890001,
								-11.812645216999954
							],
							[
								136.04269249900005,
								-11.801857216999963
							],
							[
								136.04788148900002,
								-11.788105206999944
							]
						]
					],
					[
						[
							[
								135.94624450000003,
								-11.904952204999972
							],
							[
								135.95745850900005,
								-11.898288204999972
							],
							[
								135.96223450000002,
								-11.879936204999979
							],
							[
								135.97087148900005,
								-11.87725220599998
							],
							[
								135.9804385100001,
								-11.857407205999948
							],
							[
								135.99220248900008,
								-11.850811215999954
							],
							[
								135.98294051000005,
								-11.848400195999943
							],
							[
								135.96643050000011,
								-11.866844194999942
							],
							[
								135.94169649100002,
								-11.880219194999938
							],
							[
								135.94624450000003,
								-11.904952204999972
							]
						]
					],
					[
						[
							[
								136.02688649900006,
								-12.14977420899993
							],
							[
								136.0293424680001,
								-12.16001319999998
							],
							[
								136.0326694790001,
								-12.13559921999996
							],
							[
								136.04080248900004,
								-12.128727209999965
							],
							[
								136.0367584700001,
								-12.106828198999949
							],
							[
								136.04693546900012,
								-12.102940209999929
							],
							[
								136.03521846,
								-12.093270218999976
							],
							[
								136.02594049000004,
								-12.103825208999979
							],
							[
								136.02688649900006,
								-12.14977420899993
							]
						]
					],
					[
						[
							[
								136.14944349300004,
								-12.174623212999961
							],
							[
								136.13883947300008,
								-12.16956522299995
							],
							[
								136.128784493,
								-12.178123212999935
							],
							[
								136.11849948400004,
								-12.169276211999943
							],
							[
								136.11709646400004,
								-12.17752821199997
							],
							[
								136.10536149400002,
								-12.181155211999965
							],
							[
								136.10807847400008,
								-12.198334221999971
							],
							[
								136.1505884620001,
								-12.195451212999956
							],
							[
								136.1558074820001,
								-12.19011622399995
							],
							[
								136.14944349300004,
								-12.174623212999961
							]
						]
					],
					[
						[
							[
								136.04457147300002,
								-12.302424210999959
							],
							[
								136.05095046300005,
								-12.310692210999946
							],
							[
								136.05595447300004,
								-12.292071220999958
							],
							[
								136.06549148300007,
								-12.28937222199994
							],
							[
								136.0705734830001,
								-12.276551221999966
							],
							[
								136.0475924640001,
								-12.285597220999932
							],
							[
								136.04457147300002,
								-12.302424210999959
							]
						]
					],
					[
						[
							[
								136.0159314970001,
								-12.213443199999972
							],
							[
								136.01467946700006,
								-12.219313219999947
							],
							[
								136.0177314870001,
								-12.209265219999963
							],
							[
								136.0159314970001,
								-12.213443199999972
							]
						]
					],
					[
						[
							[
								136.02780246800012,
								-12.173964199999944
							],
							[
								136.02606246800008,
								-12.16659919999995
							],
							[
								136.02076748800005,
								-12.196345209999947
							],
							[
								136.02780246800012,
								-12.173964199999944
							]
						]
					],
					[
						[
							[
								136.577895785,
								-13.663668497999936
							],
							[
								136.59126540400007,
								-13.667518308999945
							],
							[
								136.60256511400007,
								-13.65698823899993
							],
							[
								136.5863055750001,
								-13.653798448999964
							],
							[
								136.577895785,
								-13.663668497999936
							]
						]
					],
					[
						[
							[
								136.53160440600004,
								-13.699192236999977
							],
							[
								136.53798139600008,
								-13.699105226999961
							],
							[
								136.5337403860001,
								-13.695385226999974
							],
							[
								136.53979840600005,
								-13.686882236999963
							],
							[
								136.52954442700002,
								-13.688147236999953
							],
							[
								136.53160440600004,
								-13.699192236999977
							]
						]
					],
					[
						[
							[
								136.3953904330001,
								-13.70380122299997
							],
							[
								136.38025132400003,
								-13.69455082199994
							],
							[
								136.38428140300005,
								-13.71139623299996
							],
							[
								136.40045542200005,
								-13.71559523299993
							],
							[
								136.3953904330001,
								-13.70380122299997
							]
						]
					],
					[
						[
							[
								136.66417142000012,
								-13.66542524099998
							],
							[
								136.6688094000001,
								-13.663594240999942
							],
							[
								136.65960841000003,
								-13.679775250999967
							],
							[
								136.66546841000002,
								-13.684715250999943
							],
							[
								136.67706438900007,
								-13.677375241999982
							],
							[
								136.68231341000012,
								-13.658572251999942
							],
							[
								136.66563642100004,
								-13.653916240999934
							],
							[
								136.66417142000012,
								-13.66542524099998
							]
						]
					],
					[
						[
							[
								136.63211241200008,
								-13.673713239999927
							],
							[
								136.642671381,
								-13.668496239999968
							],
							[
								136.6403054220001,
								-13.656370229999936
							],
							[
								136.6317924120001,
								-13.659890249999933
							],
							[
								136.63211241200008,
								-13.673713239999927
							]
						]
					],
					[
						[
							[
								136.65449640100007,
								-13.654970240999944
							],
							[
								136.64352640200002,
								-13.656772239999952
							],
							[
								136.64708139100003,
								-13.664888240999971
							],
							[
								136.65449640100007,
								-13.654970240999944
							]
						]
					],
					[
						[
							[
								136.68467840000005,
								-13.633509240999956
							],
							[
								136.6802833900001,
								-13.647307250999972
							],
							[
								136.68783740000003,
								-13.641232241999944
							],
							[
								136.68467840000005,
								-13.633509240999956
							]
						]
					],
					[
						[
							[
								136.39915091500006,
								-13.630101021999963
							],
							[
								136.42006038400007,
								-13.632420732999947
							],
							[
								136.417080445,
								-13.621790802999953
							],
							[
								136.40078089500003,
								-13.620791021999935
							],
							[
								136.39915091500006,
								-13.630101021999963
							]
						]
					],
					[
						[
							[
								136.3732174260001,
								-13.319311228999936
							],
							[
								136.38315140600002,
								-13.313285218999965
							],
							[
								136.36958643700007,
								-13.313197238999976
							],
							[
								136.3732174260001,
								-13.319311228999936
							]
						]
					],
					[
						[
							[
								136.24255840900003,
								-13.458519225999964
							],
							[
								136.24528941800008,
								-13.462246225999934
							],
							[
								136.252614418,
								-13.454188236999926
							],
							[
								136.26814742700003,
								-13.467338236999979
							],
							[
								136.27295341700005,
								-13.46226923699993
							],
							[
								136.24664743900007,
								-13.436038235999945
							],
							[
								136.23859042900006,
								-13.44276122599996
							],
							[
								136.24255840900003,
								-13.458519225999964
							]
						]
					],
					[
						[
							[
								136.2334644350001,
								-13.586312236999959
							],
							[
								136.23454841500006,
								-13.592646226999932
							],
							[
								136.21982343600007,
								-13.587239236999949
							],
							[
								136.225652415,
								-13.600500216999933
							],
							[
								136.24771742400003,
								-13.599578237999935
							],
							[
								136.24564141400003,
								-13.584179226999936
							],
							[
								136.23447241500003,
								-13.577242216999934
							],
							[
								136.2334644350001,
								-13.586312236999959
							]
						]
					],
					[
						[
							[
								136.1412344570001,
								-12.044625211999971
							],
							[
								136.14883346600004,
								-12.056937221999931
							],
							[
								136.14285148600004,
								-12.060673221999934
							],
							[
								136.1184994880001,
								-12.051450210999974
							],
							[
								136.11820847700005,
								-12.062502200999973
							],
							[
								136.12818946700008,
								-12.074457221999978
							],
							[
								136.160612495,
								-12.066087212999946
							],
							[
								136.17730547400004,
								-12.077246202999959
							],
							[
								136.19367846400007,
								-12.077117203999933
							],
							[
								136.20048348400007,
								-12.06960520399997
							],
							[
								136.19697448400007,
								-12.061374203999947
							],
							[
								136.276654451,
								-12.035353215999976
							],
							[
								136.28750346100003,
								-12.021586215999946
							],
							[
								136.30863583100006,
								-12.012675786999978
							],
							[
								136.3172884810001,
								-11.992745216999936
							],
							[
								136.31196346100012,
								-11.98571422699996
							],
							[
								136.30390649100002,
								-11.993895215999942
							],
							[
								136.31356548200006,
								-11.974219206999976
							],
							[
								136.27831747300002,
								-11.977035224999952
							],
							[
								136.27056549300005,
								-12.003322224999977
							],
							[
								136.2558564630001,
								-12.006803224999942
							],
							[
								136.2557204630001,
								-12.012615214999926
							],
							[
								136.2239364840001,
								-12.026810213999966
							],
							[
								136.21797048400003,
								-12.036265213999968
							],
							[
								136.19877448500006,
								-12.020837212999936
							],
							[
								136.20765547500002,
								-12.008101213999964
							],
							[
								136.20286448600007,
								-11.996195212999964
							],
							[
								136.19932347600002,
								-12.005974212999945
							],
							[
								136.189375476,
								-12.001248202999932
							],
							[
								136.19406047600012,
								-12.011685222999972
							],
							[
								136.186857486,
								-12.018174202999944
							],
							[
								136.19268646500007,
								-12.028078222999966
							],
							[
								136.18482848500003,
								-12.030230212999982
							],
							[
								136.1709734970001,
								-12.01379921299997
							],
							[
								136.17182846600008,
								-12.031634212999961
							],
							[
								136.15621847600005,
								-12.041366211999957
							],
							[
								136.14639249700008,
								-12.038369211999964
							],
							[
								136.146010487,
								-12.02767621199996
							],
							[
								136.1332694680001,
								-12.025723201999938
							],
							[
								136.13085845800003,
								-12.04037520199995
							],
							[
								136.14027246700005,
								-12.038984211999946
							],
							[
								136.1412344570001,
								-12.044625211999971
							]
						]
					],
					[
						[
							[
								136.32294949100003,
								-11.965975216999936
							],
							[
								136.31478546200003,
								-11.963245215999962
							],
							[
								136.3186774510001,
								-11.97180521699994
							],
							[
								136.32294949100003,
								-11.965975216999936
							]
						]
					],
					[
						[
							[
								136.2050594970001,
								-11.618612199999973
							],
							[
								136.19254748800006,
								-11.614051209999957
							],
							[
								136.1956454970001,
								-11.630528219999974
							],
							[
								136.20763848600006,
								-11.641054200999974
							],
							[
								136.2050594970001,
								-11.618612199999973
							]
						]
					],
					[
						[
							[
								136.3133654730001,
								-11.597787222999955
							],
							[
								136.32027748300004,
								-11.604917213999954
							],
							[
								136.30094547400006,
								-11.600239212999952
							],
							[
								136.28077247400006,
								-11.604880212999944
							],
							[
								136.28002550500003,
								-11.583401211999956
							],
							[
								136.27433347500005,
								-11.580232211999942
							],
							[
								136.2698634950001,
								-11.58821820199995
							],
							[
								136.2644454760001,
								-11.572242211999935
							],
							[
								136.23920747600005,
								-11.600508210999976
							],
							[
								136.2460284860001,
								-11.610516211999936
							],
							[
								136.2434204860001,
								-11.619585211999947
							],
							[
								136.223110506,
								-11.618365210999968
							],
							[
								136.23258648600006,
								-11.627920220999954
							],
							[
								136.230770505,
								-11.645785210999975
							],
							[
								136.2095144760001,
								-11.641536220999967
							],
							[
								136.20731848600008,
								-11.656898210999941
							],
							[
								136.19219649700005,
								-11.646434209999939
							],
							[
								136.16621149800005,
								-11.644481218999942
							],
							[
								136.18032549600002,
								-11.677894209999977
							],
							[
								136.163709497,
								-11.677970209999955
							],
							[
								136.15914647700004,
								-11.693339219999928
							],
							[
								136.18121047600005,
								-11.688852209999936
							],
							[
								136.2038394860001,
								-11.665380200999948
							],
							[
								136.21444449500007,
								-11.674224200999959
							],
							[
								136.213330476,
								-11.659036200999935
							],
							[
								136.22398048500008,
								-11.652645210999935
							],
							[
								136.23115247500004,
								-11.656090210999935
							],
							[
								136.23064848500007,
								-11.668357201999981
							],
							[
								136.2631494630001,
								-11.662847201999966
							],
							[
								136.27312849400005,
								-11.629650212999934
							],
							[
								136.25660348500003,
								-11.631757211999968
							],
							[
								136.2725184740001,
								-11.61593222199997
							],
							[
								136.2793234940001,
								-11.624197212999945
							],
							[
								136.29032448300006,
								-11.621871222999971
							],
							[
								136.2965194830001,
								-11.641694212999937
							],
							[
								136.31693546300005,
								-11.617631203999963
							],
							[
								136.3325914820001,
								-11.623361213999942
							],
							[
								136.33735247200002,
								-11.606626223999967
							],
							[
								136.35582950200012,
								-11.594334214999947
							],
							[
								136.364832481,
								-11.599345214999971
							],
							[
								136.3766424910001,
								-11.586756204999972
							],
							[
								136.36947050100002,
								-11.580990214999929
							],
							[
								136.3722634820001,
								-11.566433214999961
							],
							[
								136.36559548200012,
								-11.554255224999963
							],
							[
								136.36078948300008,
								-11.550106204999963
							],
							[
								136.35869847300012,
								-11.559986204999973
							],
							[
								136.34507247300007,
								-11.56449820399996
							],
							[
								136.34838350200005,
								-11.577508223999928
							],
							[
								136.33816047300002,
								-11.579941213999973
							],
							[
								136.34211247200005,
								-11.590224213999932
							],
							[
								136.32749550300002,
								-11.58232221399993
							],
							[
								136.32267348300002,
								-11.587121213999978
							],
							[
								136.3091234840001,
								-11.57073520299997
							],
							[
								136.29546748500002,
								-11.579859222999971
							],
							[
								136.297007494,
								-11.592880202999936
							],
							[
								136.31400648300007,
								-11.59279821299998
							],
							[
								136.3133654730001,
								-11.597787222999955
							]
						]
					],
					[
						[
							[
								136.410670481,
								-11.861017208999954
							],
							[
								136.40876347100004,
								-11.85462421799997
							],
							[
								136.40398748100006,
								-11.858124217999944
							],
							[
								136.41025946000002,
								-11.878706228999931
							],
							[
								136.39609946100006,
								-11.878128217999972
							],
							[
								136.39826647100006,
								-11.890105227999982
							],
							[
								136.36687848100007,
								-11.904087207999964
							],
							[
								136.3835254710001,
								-11.907311227999969
							],
							[
								136.4021254700001,
								-11.903482218999955
							],
							[
								136.40882417000012,
								-11.893594548999943
							],
							[
								136.43122446900009,
								-11.894224208999958
							],
							[
								136.4264484800001,
								-11.865985218999981
							],
							[
								136.4183314700001,
								-11.873944218999952
							],
							[
								136.410670481,
								-11.861017208999954
							]
						]
					],
					[
						[
							[
								136.37273648200005,
								-11.564160214999958
							],
							[
								136.40522247100012,
								-11.556076215999951
							],
							[
								136.41411748100006,
								-11.54340121599995
							],
							[
								136.4298194900001,
								-11.547331206999957
							],
							[
								136.4256384900001,
								-11.537541215999966
							],
							[
								136.45031146000008,
								-11.53215021699998
							],
							[
								136.45151750000002,
								-11.519719216999931
							],
							[
								136.4580174900001,
								-11.521319206999976
							],
							[
								136.4667444900001,
								-11.507599226999957
							],
							[
								136.46125146000008,
								-11.499387216999935
							],
							[
								136.47261848000005,
								-11.484406216999957
							],
							[
								136.4735804710001,
								-11.467100226999946
							],
							[
								136.45589647100007,
								-11.474302216999945
							],
							[
								136.44677049100005,
								-11.485896226999955
							],
							[
								136.4499454810001,
								-11.493101216999946
							],
							[
								136.42997049200005,
								-11.490858215999936
							],
							[
								136.42221949100008,
								-11.51271021599996
							],
							[
								136.4029334820001,
								-11.527670225999941
							],
							[
								136.40153049200012,
								-11.521980215999974
							],
							[
								136.38570548200005,
								-11.52540920499996
							],
							[
								136.38283749200002,
								-11.545989214999963
							],
							[
								136.3735294820001,
								-11.545814204999942
							],
							[
								136.36660247300006,
								-11.534234204999962
							],
							[
								136.3629404730001,
								-11.54081621499995
							],
							[
								136.37273648200005,
								-11.564160214999958
							]
						]
					],
					[
						[
							[
								136.43650346800007,
								-11.91453421999995
							],
							[
								136.4380144580001,
								-11.920713219999982
							],
							[
								136.45397546700008,
								-11.91770422999997
							],
							[
								136.45821647800005,
								-11.897070219999932
							],
							[
								136.43650346800007,
								-11.91453421999995
							]
						]
					],
					[
						[
							[
								136.32270548200006,
								-11.96174521699993
							],
							[
								136.33553848100007,
								-11.960816216999945
							],
							[
								136.33271448200003,
								-11.945372216999942
							],
							[
								136.32777048200012,
								-11.94870620699993
							],
							[
								136.33276149100004,
								-11.955468216999975
							],
							[
								136.32270548200006,
								-11.96174521699993
							]
						]
					],
					[
						[
							[
								136.571542474,
								-11.87017222399993
							],
							[
								136.5796604730001,
								-11.865352233999943
							],
							[
								136.5699704540001,
								-11.865182233999974
							],
							[
								136.571542474,
								-11.87017222399993
							]
						]
					],
					[
						[
							[
								136.4698134790001,
								-11.848838219999948
							],
							[
								136.4748174780001,
								-11.858907210999973
							],
							[
								136.4602154690001,
								-11.866958229999966
							],
							[
								136.47095847800006,
								-11.877637230999937
							],
							[
								136.460033478,
								-11.886425219999978
							],
							[
								136.46885147700004,
								-11.896958220999977
							],
							[
								136.46383145700008,
								-11.904467220999948
							],
							[
								136.4782364670001,
								-11.899408230999938
							],
							[
								136.48586547700006,
								-11.886231210999938
							],
							[
								136.47883145800006,
								-11.84721721099993
							],
							[
								136.50008547800007,
								-11.817923220999944
							],
							[
								136.49138847900008,
								-11.816773220999949
							],
							[
								136.49764545900007,
								-11.794239220999941
							],
							[
								136.4906564690001,
								-11.803118230999928
							],
							[
								136.4773664600001,
								-11.80106522999995
							],
							[
								136.4807084690001,
								-11.817110219999961
							],
							[
								136.4643654890001,
								-11.841930229999946
							],
							[
								136.47031746900007,
								-11.841360219999956
							],
							[
								136.4698134790001,
								-11.848838219999948
							]
						]
					],
					[
						[
							[
								136.51616847800005,
								-11.797246220999966
							],
							[
								136.51197246800007,
								-11.805612230999941
							],
							[
								136.58460345600008,
								-11.78667322299998
							],
							[
								136.59240047600008,
								-11.763795222999931
							],
							[
								136.6278774550001,
								-11.740814223999962
							],
							[
								136.614709456,
								-11.738557223999976
							],
							[
								136.60977947600009,
								-11.75165922399998
							],
							[
								136.58744147700008,
								-11.744409222999934
							],
							[
								136.58814347700002,
								-11.750911232999954
							],
							[
								136.5786984870001,
								-11.754976212999964
							],
							[
								136.5880664670001,
								-11.757480222999959
							],
							[
								136.5878844760001,
								-11.764580232999947
							],
							[
								136.56545347700012,
								-11.760479222999948
							],
							[
								136.57247245700012,
								-11.765378232999979
							],
							[
								136.56745246700007,
								-11.771038232999956
							],
							[
								136.57271744700006,
								-11.778226222999933
							],
							[
								136.55800747800004,
								-11.767783231999942
							],
							[
								136.55903045700006,
								-11.781553222999946
							],
							[
								136.54427547800003,
								-11.780547231999947
							],
							[
								136.5473124680001,
								-11.77255323199995
							],
							[
								136.5341884490001,
								-11.760854221999978
							],
							[
								136.53444946800005,
								-11.77718422199996
							],
							[
								136.51633648900008,
								-11.786664220999967
							],
							[
								136.51616847800005,
								-11.797246220999966
							]
						]
					],
					[
						[
							[
								136.49726149100002,
								-11.413061227999947
							],
							[
								136.49738347100003,
								-11.43578421799998
							],
							[
								136.47402248100002,
								-11.449144216999969
							],
							[
								136.49323349000008,
								-11.461417207999943
							],
							[
								136.50255749000007,
								-11.45547021799996
							],
							[
								136.49918449000006,
								-11.44201821799993
							],
							[
								136.51662547,
								-11.432399217999944
							],
							[
								136.52526148000004,
								-11.434357228999943
							],
							[
								136.5224084890001,
								-11.445115218999945
							],
							[
								136.53455448900002,
								-11.443536218999952
							],
							[
								136.5416334790001,
								-11.43270420899995
							],
							[
								136.53814046900004,
								-11.426156208999942
							],
							[
								136.55596246900006,
								-11.416678218999948
							],
							[
								136.56240047900008,
								-11.398848219999934
							],
							[
								136.58881348900002,
								-11.383470219999936
							],
							[
								136.59950947900006,
								-11.348048209999945
							],
							[
								136.61605047900002,
								-11.329240230999972
							],
							[
								136.6273724890001,
								-11.328793230999963
							],
							[
								136.62338847900003,
								-11.313685220999957
							],
							[
								136.62901947900002,
								-11.308507220999957
							],
							[
								136.62311447000002,
								-11.304202220999969
							],
							[
								136.6341164900001,
								-11.294921230999933
							],
							[
								136.62602849000007,
								-11.284277220999968
							],
							[
								136.63291049000009,
								-11.278538220999963
							],
							[
								136.6456814700001,
								-11.281669220999959
							],
							[
								136.6488864700001,
								-11.26397123099997
							],
							[
								136.662847499,
								-11.264488231999962
							],
							[
								136.66994350000004,
								-11.247640221999973
							],
							[
								136.6844074590001,
								-11.249336231999962
							],
							[
								136.66705949100003,
								-11.225087220999967
							],
							[
								136.68422547000011,
								-11.21397921199997
							],
							[
								136.6952724900001,
								-11.219289211999978
							],
							[
								136.70938648900005,
								-11.207712232999938
							],
							[
								136.71156846000008,
								-11.19564821299997
							],
							[
								136.71985348900012,
								-11.19467922299998
							],
							[
								136.7151234900001,
								-11.176759212999968
							],
							[
								136.7225544910001,
								-11.14937721299998
							],
							[
								136.7360124810001,
								-11.130699232999973
							],
							[
								136.74757849200012,
								-11.073298222999938
							],
							[
								136.76727648300005,
								-11.032717212999955
							],
							[
								136.760211464,
								-11.018436212999973
							],
							[
								136.75156049400005,
								-11.03010022199993
							],
							[
								136.73714149400007,
								-11.03408521199998
							],
							[
								136.74600647300008,
								-11.04814122199997
							],
							[
								136.73602748300004,
								-11.051016231999938
							],
							[
								136.72603349400003,
								-11.040118211999982
							],
							[
								136.71332247400005,
								-11.054729220999945
							],
							[
								136.73439447300007,
								-11.061819211999932
							],
							[
								136.73740050300012,
								-11.07797223199998
							],
							[
								136.72598947200004,
								-11.098506231999977
							],
							[
								136.7002464940001,
								-11.09303522099998
							],
							[
								136.70436548300006,
								-11.101206231999981
							],
							[
								136.71500048300004,
								-11.097776221999936
							],
							[
								136.72220347200005,
								-11.109884231999956
							],
							[
								136.71635949200004,
								-11.125011221999955
							],
							[
								136.694249473,
								-11.118945210999982
							],
							[
								136.70692847200007,
								-11.126358221999965
							],
							[
								136.70464047200005,
								-11.148558221999963
							],
							[
								136.696690482,
								-11.152126221999936
							],
							[
								136.70346546100006,
								-11.153826221999964
							],
							[
								136.70586249100006,
								-11.17013923199994
							],
							[
								136.68698746100006,
								-11.19362222199993
							],
							[
								136.67191147100004,
								-11.19740122099995
							],
							[
								136.66167347200007,
								-11.184491210999965
							],
							[
								136.65247150200003,
								-11.189750230999948
							],
							[
								136.64423250200002,
								-11.20985621099993
							],
							[
								136.62958446200003,
								-11.213031219999948
							],
							[
								136.6261354730001,
								-11.206267209999965
							],
							[
								136.62059550200001,
								-11.237704219999955
							],
							[
								136.6069094920001,
								-11.245268229999965
							],
							[
								136.5996614720001,
								-11.26608521999998
							],
							[
								136.58330549200002,
								-11.281800208999925
							],
							[
								136.58757749200004,
								-11.286982208999973
							],
							[
								136.57747648100008,
								-11.331412218999958
							],
							[
								136.56622948100005,
								-11.33531821899993
							],
							[
								136.56853449100004,
								-11.343107218999933
							],
							[
								136.56223247100002,
								-11.348293228999978
							],
							[
								136.5564344810001,
								-11.34340121899993
							],
							[
								136.5498124710001,
								-11.347340218999932
							],
							[
								136.55393248100006,
								-11.357299208999962
							],
							[
								136.54480748100002,
								-11.367268218999982
							],
							[
								136.53385150100007,
								-11.365432217999967
							],
							[
								136.51575549100005,
								-11.393081227999971
							],
							[
								136.4982544720001,
								-11.391521216999934
							],
							[
								136.4948814720001,
								-11.407650216999969
							],
							[
								136.50315149100004,
								-11.411367217999953
							],
							[
								136.49726149100002,
								-11.413061227999947
							]
						]
					],
					[
						[
							[
								136.65992047100008,
								-11.834404225999947
							],
							[
								136.642830472,
								-11.839496225999937
							],
							[
								136.66793145100007,
								-11.837881225999979
							],
							[
								136.68848446000004,
								-11.82182422699998
							],
							[
								136.65992047100008,
								-11.834404225999947
							]
						]
					],
					[
						[
							[
								136.6240674390001,
								-12.866480242999955
							],
							[
								136.63058242900001,
								-12.864809223999941
							],
							[
								136.62664542900006,
								-12.854367232999948
							],
							[
								136.6179934390001,
								-12.858217232999948
							],
							[
								136.6240674390001,
								-12.866480242999955
							]
						]
					],
					[
						[
							[
								136.6707274260001,
								-12.874969244999932
							],
							[
								136.6779294260001,
								-12.876765244999945
							],
							[
								136.67501540600006,
								-12.870277234999946
							],
							[
								136.66804241700004,
								-12.870267224999964
							],
							[
								136.6707274260001,
								-12.874969244999932
							]
						]
					],
					[
						[
							[
								136.69376048200002,
								-11.139943211999935
							],
							[
								136.6859794830001,
								-11.132547230999933
							],
							[
								136.6818744730001,
								-11.13582822099994
							],
							[
								136.69376048200002,
								-11.139943211999935
							]
						]
					],
					[
						[
							[
								136.7230875030001,
								-11.082116231999976
							],
							[
								136.7270095030001,
								-11.077585231999933
							],
							[
								136.71612947300002,
								-11.075973231999967
							],
							[
								136.7230875030001,
								-11.082116231999976
							]
						]
					],
					[
						[
							[
								136.73834647500007,
								-11.00738622199998
							],
							[
								136.74716549400011,
								-11.020690221999928
							],
							[
								136.76271449400008,
								-11.005729232999954
							],
							[
								136.75703848400008,
								-11.000988211999982
							],
							[
								136.7534224740001,
								-11.010505231999957
							],
							[
								136.73834647500007,
								-11.00738622199998
							]
						]
					],
					[
						[
							[
								136.8192194600001,
								-11.668178239999975
							],
							[
								136.80991247000009,
								-11.67436822999997
							],
							[
								136.8251714390001,
								-11.676496229999941
							],
							[
								136.8377434690001,
								-11.665231219999953
							],
							[
								136.83286045900002,
								-11.65718923999998
							],
							[
								136.8192194600001,
								-11.668178239999975
							]
						]
					],
					[
						[
							[
								136.79792045600004,
								-12.118577242999947
							],
							[
								136.79944644500006,
								-12.13228023299996
							],
							[
								136.81444645400006,
								-12.141412233999972
							],
							[
								136.8278434440001,
								-12.135033233999934
							],
							[
								136.82173944400006,
								-12.120646223999927
							],
							[
								136.82372343600002,
								-12.07252323299997
							],
							[
								136.7969904370001,
								-12.088422242999968
							],
							[
								136.79792045600004,
								-12.118577242999947
							]
						]
					],
					[
						[
							[
								136.69628544700004,
								-12.209602229999973
							],
							[
								136.70469945700006,
								-12.214547230999926
							],
							[
								136.69572844700008,
								-12.224294229999941
							],
							[
								136.70142044600004,
								-12.231116240999938
							],
							[
								136.70992143600006,
								-12.224798230999966
							],
							[
								136.71146345600005,
								-12.210690240999952
							],
							[
								136.7091824570001,
								-12.203125240999952
							],
							[
								136.69628544700004,
								-12.209602229999973
							]
						]
					],
					[
						[
							[
								136.68726260000005,
								-13.632127331999982
							],
							[
								136.70180219000008,
								-13.634967161999953
							],
							[
								136.69539239000005,
								-13.628017241999942
							],
							[
								136.70034211000007,
								-13.617327201999956
							],
							[
								136.68726260000005,
								-13.632127331999982
							]
						]
					],
					[
						[
							[
								136.75098038500005,
								-13.69154615399998
							],
							[
								136.7381908960001,
								-13.68634639399994
							],
							[
								136.733491006,
								-13.695686413999965
							],
							[
								136.75098038500005,
								-13.69154615399998
							]
						]
					],
					[
						[
							[
								136.92947336800012,
								-13.63947124899994
							],
							[
								136.92770439800006,
								-13.647139258999971
							],
							[
								136.94958439700008,
								-13.643171249999966
							],
							[
								136.951507396,
								-13.649062239999978
							],
							[
								136.96365339600004,
								-13.628312249999965
							],
							[
								136.9607383970001,
								-13.624596249999968
							],
							[
								136.92947336800012,
								-13.63947124899994
							]
						]
					],
					[
						[
							[
								136.92654438700004,
								-13.666729239999938
							],
							[
								136.93725538700005,
								-13.662511239999958
							],
							[
								136.9293523770001,
								-13.658722259999934
							],
							[
								136.92654438700004,
								-13.666729239999938
							]
						]
					],
					[
						[
							[
								136.9076994080001,
								-13.667899258999967
							],
							[
								136.91392436800004,
								-13.663181258999941
							],
							[
								136.90861536800003,
								-13.657963258999928
							],
							[
								136.88696338900002,
								-13.675817257999938
							],
							[
								136.90068037800006,
								-13.677825248999966
							],
							[
								136.9076994080001,
								-13.667899258999967
							]
						]
					],
					[
						[
							[
								136.97258236400012,
								-14.26063324599994
							],
							[
								136.98498835300006,
								-14.260314255999958
							],
							[
								136.975863354,
								-14.25426525599994
							],
							[
								136.97258236400012,
								-14.26063324599994
							]
						]
					],
					[
						[
							[
								136.95817734600007,
								-14.221502254999962
							],
							[
								136.9594753660001,
								-14.228595264999967
							],
							[
								136.96460237600002,
								-14.224326254999937
							],
							[
								136.95817734600007,
								-14.221502254999962
							]
						]
					],
					[
						[
							[
								136.9674093650001,
								-14.246249255999942
							],
							[
								136.96797435500002,
								-14.240663255999948
							],
							[
								136.96243536500003,
								-14.243861264999964
							],
							[
								136.9674093650001,
								-14.246249255999942
							]
						]
					],
					[
						[
							[
								136.93005636300006,
								-14.352404254999954
							],
							[
								136.9423403620001,
								-14.350242255999945
							],
							[
								136.93304735300012,
								-14.344576254999936
							],
							[
								136.93005636300006,
								-14.352404254999954
							]
						]
					],
					[
						[
							[
								136.95639337400007,
								-14.296660265999947
							],
							[
								136.9635953730001,
								-14.30035324599993
							],
							[
								136.95830035400002,
								-14.292042255999945
							],
							[
								136.95639337400007,
								-14.296660265999947
							]
						]
					],
					[
						[
							[
								136.95580240100003,
								-15.503897654999946
							],
							[
								136.95546236100006,
								-15.499267624999959
							],
							[
								136.94951246200003,
								-15.50286772499993
							],
							[
								136.95580240100003,
								-15.503897654999946
							]
						]
					],
					[
						[
							[
								136.8718937120001,
								-15.61039912299998
							],
							[
								136.8843635720001,
								-15.606918973999939
							],
							[
								136.88683349200005,
								-15.594048893999968
							],
							[
								136.89568343100007,
								-15.598578823999958
							],
							[
								136.9049032910001,
								-15.590118683999947
							],
							[
								136.8906933720001,
								-15.579598783999927
							],
							[
								136.87375328500002,
								-15.532028752999963
							],
							[
								136.88028317500005,
								-15.526618672999973
							],
							[
								136.880663066,
								-15.505608552999945
							],
							[
								136.87237318600012,
								-15.517348712999933
							],
							[
								136.86726321600008,
								-15.50750874199997
							],
							[
								136.85850336600004,
								-15.521278881999933
							],
							[
								136.86046341600002,
								-15.53268891199997
							],
							[
								136.84157356700007,
								-15.542369161999943
							],
							[
								136.8420036860001,
								-15.56292923199993
							],
							[
								136.85584371400012,
								-15.58180914299993
							],
							[
								136.83321393500012,
								-15.597469511999975
							],
							[
								136.83133400500003,
								-15.604919571999972
							],
							[
								136.84112392500003,
								-15.603919421999933
							],
							[
								136.84310394400006,
								-15.61024944199994
							],
							[
								136.8295640450001,
								-15.61790967199994
							],
							[
								136.8517039630001,
								-15.62471941299998
							],
							[
								136.8373640640001,
								-15.628539641999964
							],
							[
								136.8454941430001,
								-15.647179652999966
							],
							[
								136.8762837910001,
								-15.632999223999946
							],
							[
								136.88083377100008,
								-15.636729213999956
							],
							[
								136.88191362200007,
								-15.613469033999934
							],
							[
								136.87537373200007,
								-15.617179133999969
							],
							[
								136.86198378300003,
								-15.607339202999981
							],
							[
								136.8699836730001,
								-15.602909102999945
							],
							[
								136.8718937120001,
								-15.61039912299998
							]
						]
					],
					[
						[
							[
								136.83722375600007,
								-15.566759321999939
							],
							[
								136.82789384600005,
								-15.570589451999979
							],
							[
								136.83571375600002,
								-15.563599321999959
							],
							[
								136.83397372700006,
								-15.555459321999933
							],
							[
								136.79306397900007,
								-15.56001982999993
							],
							[
								136.77357414900007,
								-15.57862020999994
							],
							[
								136.7816041090001,
								-15.582370099999935
							],
							[
								136.795843998,
								-15.573019870999929
							],
							[
								136.8032840180001,
								-15.582969830999957
							],
							[
								136.83568385600006,
								-15.584829401999968
							],
							[
								136.83722375600007,
								-15.566759321999939
							]
						]
					],
					[
						[
							[
								136.79040418700004,
								-15.614120190999927
							],
							[
								136.81910398600007,
								-15.603209721999974
							],
							[
								136.78939411800002,
								-15.591080070999965
							],
							[
								136.77724421800008,
								-15.60799032999995
							],
							[
								136.79006414700007,
								-15.608810150999943
							],
							[
								136.79040418700004,
								-15.614120190999927
							]
						]
					],
					[
						[
							[
								136.64680479600008,
								-15.606482385999982
							],
							[
								136.67395470400004,
								-15.612191896999946
							],
							[
								136.68131467400008,
								-15.60532173699994
							],
							[
								136.66839462500002,
								-15.596701916999962
							],
							[
								136.66946465500007,
								-15.59049181699993
							],
							[
								136.65476471600005,
								-15.593622115999949
							],
							[
								136.64680479600008,
								-15.606482385999982
							]
						]
					],
					[
						[
							[
								136.7668371750001,
								-13.966613496999969
							],
							[
								136.77891681500012,
								-13.934003526999959
							],
							[
								136.79610645500009,
								-13.912003496999944
							],
							[
								136.81259587500006,
								-13.904123307999953
							],
							[
								136.85781401200006,
								-13.912822458999926
							],
							[
								136.85849433300007,
								-13.893202728999938
							],
							[
								136.884004763,
								-13.842793149999977
							],
							[
								136.9120347930001,
								-13.807543309999971
							],
							[
								136.92441454200002,
								-13.80651317099995
							],
							[
								136.9091142840001,
								-13.768663239999967
							],
							[
								136.88866523600007,
								-13.753923808999957
							],
							[
								136.87095576700005,
								-13.756604037999978
							],
							[
								136.8393868490001,
								-13.745394516999966
							],
							[
								136.83931668800005,
								-13.780294357999935
							],
							[
								136.81474758800005,
								-13.801904616999934
							],
							[
								136.79700775800006,
								-13.834174476999976
							],
							[
								136.81372745800002,
								-13.812054476999947
							],
							[
								136.8372867070001,
								-13.802424247999966
							],
							[
								136.84549610600004,
								-13.815033937999942
							],
							[
								136.83732594600008,
								-13.842893677999939
							],
							[
								136.80806440700007,
								-13.856441246999964
							],
							[
								136.75446952000004,
								-13.83234519499996
							],
							[
								136.7268604510001,
								-13.84318551499996
							],
							[
								136.71831095200002,
								-13.835785753999971
							],
							[
								136.729150752,
								-13.819705753999926
							],
							[
								136.71685138300006,
								-13.810786053999948
							],
							[
								136.71250175400007,
								-13.793796283999939
							],
							[
								136.72131135400002,
								-13.77839621399994
							],
							[
								136.73264092300008,
								-13.778266033999955
							],
							[
								136.73536082300006,
								-13.770946023999954
							],
							[
								136.72476130400003,
								-13.76753621399996
							],
							[
								136.71798153400005,
								-13.775766293999936
							],
							[
								136.69706232500005,
								-13.774906602999977
							],
							[
								136.6895325260001,
								-13.763886742999944
							],
							[
								136.6906325660001,
								-13.74457681299998
							],
							[
								136.68510438700002,
								-13.748307241999953
							],
							[
								136.68113737700003,
								-13.737058241999932
							],
							[
								136.68556238700012,
								-13.727429251999979
							],
							[
								136.6943973970001,
								-13.728614252999932
							],
							[
								136.70733638700005,
								-13.715239252999936
							],
							[
								136.72032239600003,
								-13.71688525299993
							],
							[
								136.73120037600006,
								-13.686435252999956
							],
							[
								136.72845440800006,
								-13.652072242999964
							],
							[
								136.71612540800004,
								-13.665938252999979
							],
							[
								136.7104653880001,
								-13.657406231999971
							],
							[
								136.69630539900004,
								-13.663033251999934
							],
							[
								136.69462639900007,
								-13.651434251999945
							],
							[
								136.67852839900002,
								-13.68056723199993
							],
							[
								136.67546140900004,
								-13.702720241999941
							],
							[
								136.66436840900008,
								-13.69427523099995
							],
							[
								136.66150037900002,
								-13.703837240999974
							],
							[
								136.6470954,
								-13.700024240999937
							],
							[
								136.63148640000009,
								-13.720083229999943
							],
							[
								136.61778338200008,
								-13.705043229999944
							],
							[
								136.63626140100007,
								-13.68834124999995
							],
							[
								136.61866840200003,
								-13.688392229999977
							],
							[
								136.6130533930001,
								-13.67796224999995
							],
							[
								136.59770240300008,
								-13.68711223899993
							],
							[
								136.5952624140001,
								-13.678898238999977
							],
							[
								136.577515424,
								-13.687249247999944
							],
							[
								136.57478441400008,
								-13.69458323799995
							],
							[
								136.5923784030001,
								-13.696265238999956
							],
							[
								136.58447440300006,
								-13.717242238999972
							],
							[
								136.58818240200003,
								-13.723354238999946
							],
							[
								136.60763741100004,
								-13.729740229999948
							],
							[
								136.61772239000004,
								-13.742633229999967
							],
							[
								136.60769840000012,
								-13.76341623999997
							],
							[
								136.6296404090001,
								-13.765057230999957
							],
							[
								136.62933438900006,
								-13.777428240999939
							],
							[
								136.63835240800006,
								-13.781928230999938
							],
							[
								136.62858737800002,
								-13.790064240999982
							],
							[
								136.59410521000007,
								-13.78701770999993
							],
							[
								136.60095341900012,
								-13.805925249999973
							],
							[
								136.58264341000006,
								-13.807885229999954
							],
							[
								136.57503039100004,
								-13.79768723899997
							],
							[
								136.57405339000002,
								-13.809084238999958
							],
							[
								136.55442632100005,
								-13.819827958999952
							],
							[
								136.53922677200012,
								-13.814028187999952
							],
							[
								136.54258663300004,
								-13.78908828799996
							],
							[
								136.530837033,
								-13.785028437999927
							],
							[
								136.52382724400002,
								-13.791518487999952
							],
							[
								136.52457720200005,
								-13.821468297999957
							],
							[
								136.49505841300004,
								-13.840219236999928
							],
							[
								136.4819673940001,
								-13.832868236999957
							],
							[
								136.46287939500007,
								-13.834180235999952
							],
							[
								136.45713918600006,
								-13.819219085999976
							],
							[
								136.44045956700006,
								-13.831379194999954
							],
							[
								136.44672942700004,
								-13.822129195999935
							],
							[
								136.434719287,
								-13.81509919499996
							],
							[
								136.42258044800008,
								-13.815629194999929
							],
							[
								136.4092404280001,
								-13.830959553999946
							],
							[
								136.40805030800004,
								-13.845299463999936
							],
							[
								136.41819992700005,
								-13.855269274999955
							],
							[
								136.4165223870001,
								-13.86219723499994
							],
							[
								136.429029516,
								-13.869299044999934
							],
							[
								136.43614913500005,
								-13.890778825999973
							],
							[
								136.40815958400003,
								-13.976318255999956
							],
							[
								136.41817861200002,
								-13.99599825599995
							],
							[
								136.41802812000003,
								-14.057987786999945
							],
							[
								136.4331673690001,
								-14.079747376999933
							],
							[
								136.42963737900004,
								-14.094227306999926
							],
							[
								136.4426165970001,
								-14.123456837999981
							],
							[
								136.4210371370001,
								-14.142307006999943
							],
							[
								136.422126917,
								-14.154966856999977
							],
							[
								136.4114170570001,
								-14.169476866999958
							],
							[
								136.3244689500001,
								-14.213307714999928
							],
							[
								136.32470863900005,
								-14.246097464999934
							],
							[
								136.35658792800007,
								-14.220097175999967
							],
							[
								136.39555699700009,
								-14.202316756999949
							],
							[
								136.43735599500008,
								-14.196286267999938
							],
							[
								136.45079555400002,
								-14.203926018999937
							],
							[
								136.45551529300008,
								-14.21803585899994
							],
							[
								136.49159839100003,
								-14.237829249999947
							],
							[
								136.52300038900012,
								-14.234377240999947
							],
							[
								136.53947937700002,
								-14.254770231999942
							],
							[
								136.62891039200008,
								-14.26643424499997
							],
							[
								136.6337163810001,
								-14.284625244999972
							],
							[
								136.64508438100006,
								-14.286653244999968
							],
							[
								136.64882238000007,
								-14.296777245999976
							],
							[
								136.66426338000008,
								-14.287877245999937
							],
							[
								136.68114137800012,
								-14.298447236999948
							],
							[
								136.67908036900008,
								-14.290324246999944
							],
							[
								136.6930423880001,
								-14.276667246999978
							],
							[
								136.75384736600006,
								-14.259042238999939
							],
							[
								136.80565137300005,
								-14.269717239999977
							],
							[
								136.812289372,
								-14.27893224099995
							],
							[
								136.8023553920001,
								-14.289268250999953
							],
							[
								136.81373839100002,
								-14.294810260999952
							],
							[
								136.8237473810001,
								-14.293654250999964
							],
							[
								136.81173935200002,
								-14.288321250999957
							],
							[
								136.8166213820001,
								-14.278681250999966
							],
							[
								136.8252283710001,
								-14.28404625099995
							],
							[
								136.82884439100008,
								-14.27815224099993
							],
							[
								136.84127939000007,
								-14.295522251999955
							],
							[
								136.8442403800001,
								-14.283955251999942
							],
							[
								136.8574233700001,
								-14.278595251999946
							],
							[
								136.86950935900006,
								-14.287222262999933
							],
							[
								136.87285035800005,
								-14.300973252999938
							],
							[
								136.88273838700002,
								-14.299863252999955
							],
							[
								136.88942135700006,
								-14.308436253999957
							],
							[
								136.89465435700004,
								-14.302308253999968
							],
							[
								136.90407036600004,
								-14.310816253999974
							],
							[
								136.89788935700005,
								-14.296919253999931
							],
							[
								136.91270937600007,
								-14.28524925399995
							],
							[
								136.95073134400002,
								-14.30408525599995
							],
							[
								136.95086837400004,
								-14.295197264999956
							],
							[
								136.93869134500005,
								-14.294422254999972
							],
							[
								136.93393036500004,
								-14.284649264999928
							],
							[
								136.94572635500003,
								-14.278426254999943
							],
							[
								136.96312134400011,
								-14.28457324599998
							],
							[
								136.9473283850001,
								-14.277161264999961
							],
							[
								136.93968236600006,
								-14.261236254999972
							],
							[
								136.959382365,
								-14.245075244999953
							],
							[
								136.95214937600008,
								-14.243291254999974
							],
							[
								136.9519203760001,
								-14.22973525499998
							],
							[
								136.9451143670001,
								-14.226700254999969
							],
							[
								136.9510043670001,
								-14.220469244999947
							],
							[
								136.93615835800006,
								-14.213704263999944
							],
							[
								136.93336537800008,
								-14.204832253999939
							],
							[
								136.94107136800005,
								-14.189164253999934
							],
							[
								136.95228537700007,
								-14.195029254999952
							],
							[
								136.96319635800012,
								-14.165502254999979
							],
							[
								136.94397038900001,
								-14.157636253999954
							],
							[
								136.93075636000003,
								-14.165490243999955
							],
							[
								136.92350936000003,
								-14.16273726299994
							],
							[
								136.92024236100008,
								-14.151477252999939
							],
							[
								136.92984036000007,
								-14.144085243999939
							],
							[
								136.9101873720001,
								-14.139250252999943
							],
							[
								136.91479535100007,
								-14.145122262999962
							],
							[
								136.90841738100005,
								-14.152766262999933
							],
							[
								136.91713507000009,
								-14.166011052999977
							],
							[
								136.89576838000005,
								-14.201565242999948
							],
							[
								136.86383237100006,
								-14.21173325199993
							],
							[
								136.85402136200003,
								-14.208507261999955
							],
							[
								136.84242337400008,
								-14.183594250999931
							],
							[
								136.80639838600007,
								-14.161300249999954
							],
							[
								136.79973038700007,
								-14.14774424899997
							],
							[
								136.78770637800005,
								-14.15261223899995
							],
							[
								136.775927388,
								-14.14516724899994
							],
							[
								136.7815263770001,
								-14.165019248999954
							],
							[
								136.76967037800011,
								-14.170311248999951
							],
							[
								136.787645386,
								-14.186172238999973
							],
							[
								136.78415138600008,
								-14.194285248999961
							],
							[
								136.76298736700005,
								-14.196717238999952
							],
							[
								136.74634037900012,
								-14.186264237999978
							],
							[
								136.72920537900006,
								-14.191108246999931
							],
							[
								136.70647037100002,
								-14.169816235999974
							],
							[
								136.71649637200005,
								-14.142018256999961
							],
							[
								136.70318939300012,
								-14.139075255999956
							],
							[
								136.69874839400006,
								-14.11648123599997
							],
							[
								136.70170836400007,
								-14.107461245999957
							],
							[
								136.71090837300005,
								-14.107451245999982
							],
							[
								136.70975037300002,
								-14.10138124599996
							],
							[
								136.71956139300005,
								-14.10555824599993
							],
							[
								136.712542374,
								-14.09497624599993
							],
							[
								136.72369636300004,
								-14.078625245999945
							],
							[
								136.72046137400002,
								-14.070235255999933
							],
							[
								136.7368794030001,
								-14.06724924699995
							],
							[
								136.73720038300007,
								-14.079885246999936
							],
							[
								136.75171037200005,
								-14.087694246999945
							],
							[
								136.74711739300005,
								-14.069071256999962
							],
							[
								136.75048937300005,
								-14.059724236999955
							],
							[
								136.75831837200008,
								-14.05863725699993
							],
							[
								136.75901939300002,
								-14.04805924699997
							],
							[
								136.77394237200008,
								-14.046420247999947
							],
							[
								136.77665838100006,
								-14.059362247999957
							],
							[
								136.78643939200003,
								-14.039173257999948
							],
							[
								136.80636737100008,
								-14.03767425899997
							],
							[
								136.80684037100002,
								-14.019060238999941
							],
							[
								136.7810073920001,
								-14.02587824799997
							],
							[
								136.7674883730001,
								-14.01572424699998
							],
							[
								136.76233037400004,
								-14.002698246999955
							],
							[
								136.7668371750001,
								-13.966613496999969
							]
						]
					],
					[
						[
							[
								136.58214040300004,
								-13.722957238999982
							],
							[
								136.56972040300002,
								-13.725646238999957
							],
							[
								136.57879839300006,
								-13.729377238999973
							],
							[
								136.58214040300004,
								-13.722957238999982
							]
						]
					],
					[
						[
							[
								136.572245801,
								-13.782367958999941
							],
							[
								136.5742984210001,
								-13.787168248999933
							],
							[
								136.57854041100006,
								-13.775158228999942
							],
							[
								136.57209582200005,
								-13.773748028999933
							],
							[
								136.572245801,
								-13.782367958999941
							]
						]
					],
					[
						[
							[
								136.49872239700005,
								-13.717300235999971
							],
							[
								136.4713653990001,
								-13.720706234999966
							],
							[
								136.46680040800004,
								-13.741406234999943
							],
							[
								136.48978040600002,
								-13.759325245999946
							],
							[
								136.4986304150001,
								-13.782483226999943
							],
							[
								136.51910739400012,
								-13.79190424799998
							],
							[
								136.5414003830001,
								-13.771487237999963
							],
							[
								136.5312223940001,
								-13.75164824799998
							],
							[
								136.53863740400004,
								-13.738904237999975
							],
							[
								136.52851716600003,
								-13.714268826999955
							],
							[
								136.53093711600002,
								-13.703448876999971
							],
							[
								136.50983774700012,
								-13.698499165999976
							],
							[
								136.51814539600002,
								-13.710183236999967
							],
							[
								136.51552141600007,
								-13.717307226999935
							],
							[
								136.49872239700005,
								-13.717300235999971
							]
						]
					],
					[
						[
							[
								136.1921842810001,
								-13.77338225699998
							],
							[
								136.18915544100003,
								-13.795358216999944
							],
							[
								136.21115339900007,
								-13.824643217999949
							],
							[
								136.20027840800003,
								-13.855240227999957
							],
							[
								136.24826740600008,
								-13.849849229999961
							],
							[
								136.24475741700007,
								-13.83733923899996
							],
							[
								136.25464333600007,
								-13.832071269999972
							],
							[
								136.2596954070001,
								-13.785014228999955
							],
							[
								136.27377940600002,
								-13.793304219999982
							],
							[
								136.2840634260001,
								-13.787665239999967
							],
							[
								136.2748324270001,
								-13.77420522999995
							],
							[
								136.27635739700008,
								-13.75672622999997
							],
							[
								136.25749843800008,
								-13.76035621899996
							],
							[
								136.253012409,
								-13.749482238999974
							],
							[
								136.2662103990001,
								-13.737475238999934
							],
							[
								136.30165741700011,
								-13.736261229999968
							],
							[
								136.29300442800002,
								-13.707990239999958
							],
							[
								136.27390040900002,
								-13.70494722899997
							],
							[
								136.2691254,
								-13.692771228999959
							],
							[
								136.2528284110001,
								-13.693656228999942
							],
							[
								136.2549494210001,
								-13.67487523799997
							],
							[
								136.2422544320001,
								-13.66675622799994
							],
							[
								136.21294241400005,
								-13.662345216999938
							],
							[
								136.19101540500003,
								-13.670635236999942
							],
							[
								136.18129542500003,
								-13.677849235999929
							],
							[
								136.19255742400003,
								-13.679478236999955
							],
							[
								136.1903604140001,
								-13.695111236999935
							],
							[
								136.17377342400005,
								-13.707070225999928
							],
							[
								136.18093042400005,
								-13.718157216999941
							],
							[
								136.1734834340001,
								-13.727084225999931
							],
							[
								136.181754403,
								-13.736809236999932
							],
							[
								136.17536143300003,
								-13.746765236999977
							],
							[
								136.1442944250001,
								-13.74658522599998
							],
							[
								136.1393054250001,
								-13.73544323599998
							],
							[
								136.1284864160001,
								-13.736350234999975
							],
							[
								136.12255484600007,
								-13.722253084999977
							],
							[
								136.1129250470001,
								-13.731253124999967
							],
							[
								136.10996241600003,
								-13.763612214999966
							],
							[
								136.12056643500011,
								-13.787316234999935
							],
							[
								136.10649841400004,
								-13.817378234999978
							],
							[
								136.12789526300003,
								-13.835802625999975
							],
							[
								136.1678684210001,
								-13.834566236999933
							],
							[
								136.169234651,
								-13.820592236999971
							],
							[
								136.155968432,
								-13.81807923699995
							],
							[
								136.15743143200007,
								-13.79989823699998
							],
							[
								136.1463384230001,
								-13.780908225999951
							],
							[
								136.1724164320001,
								-13.768149236999932
							],
							[
								136.1921842810001,
								-13.77338225699998
							]
						]
					],
					[
						[
							[
								136.36689115000001,
								-13.842359932999955
							],
							[
								136.37306122000007,
								-13.825550002999933
							],
							[
								136.36801145100003,
								-13.812320132999957
							],
							[
								136.35704170200006,
								-13.80935027299995
							],
							[
								136.33394180200003,
								-13.839210331999936
							],
							[
								136.3493014810001,
								-13.845930102999944
							],
							[
								136.36689115000001,
								-13.842359932999955
							]
						]
					],
					[
						[
							[
								136.61733492000008,
								-15.555352194999955
							],
							[
								136.6104250310001,
								-15.523821753999982
							],
							[
								136.5786552930001,
								-15.510861912999928
							],
							[
								136.56682527300006,
								-15.530592442999932
							],
							[
								136.52533591600002,
								-15.530932881999945
							],
							[
								136.52566583600003,
								-15.538382991999981
							],
							[
								136.511076096,
								-15.544553210999936
							],
							[
								136.5220858450001,
								-15.563003481999942
							],
							[
								136.5200658550001,
								-15.576213721999977
							],
							[
								136.50451620500007,
								-15.592084020999948
							],
							[
								136.51339650400007,
								-15.62261429199998
							],
							[
								136.49475650400007,
								-15.643534371999976
							],
							[
								136.52285599200002,
								-15.654384382999979
							],
							[
								136.5391856110001,
								-15.653754342999946
							],
							[
								136.55089536100002,
								-15.639854252999953
							],
							[
								136.57032528900004,
								-15.649323943999946
							],
							[
								136.58969518800006,
								-15.645303584999965
							],
							[
								136.59429509900008,
								-15.626003414999957
							],
							[
								136.605025038,
								-15.623773204999964
							],
							[
								136.59897505800006,
								-15.620033304999936
							],
							[
								136.604814948,
								-15.61518319499993
							],
							[
								136.59651499000006,
								-15.581282963999968
							],
							[
								136.60484499000006,
								-15.560862473999975
							],
							[
								136.61733492000008,
								-15.555352194999955
							]
						]
					],
					[
						[
							[
								136.75035459800006,
								-15.646680929999945
							],
							[
								136.73461466900005,
								-15.647671118999938
							],
							[
								136.74100479800006,
								-15.672861189999935
							],
							[
								136.7345548080001,
								-15.677601288999938
							],
							[
								136.73684488800006,
								-15.697141359999932
							],
							[
								136.72972497800004,
								-15.700181448999956
							],
							[
								136.75127494600008,
								-15.712761249999971
							],
							[
								136.749014976,
								-15.718621329999962
							],
							[
								136.73856498700002,
								-15.712391409999952
							],
							[
								136.72814514700008,
								-15.735641659999942
							],
							[
								136.72834524600012,
								-15.751341759999946
							],
							[
								136.73846523500004,
								-15.762651769999934
							],
							[
								136.74619516500002,
								-15.749901529999931
							],
							[
								136.76486502400007,
								-15.74260125099994
							],
							[
								136.77652498300006,
								-15.746341150999967
							],
							[
								136.8044447430001,
								-15.723800661999974
							],
							[
								136.79817466400004,
								-15.703350631999967
							],
							[
								136.78546474400002,
								-15.706490780999957
							],
							[
								136.7795247350001,
								-15.701290840999945
							],
							[
								136.7878246150001,
								-15.68673064099994
							],
							[
								136.80428451400007,
								-15.685240441999952
							],
							[
								136.8025046240001,
								-15.697820541999931
							],
							[
								136.81381455300004,
								-15.700330411999971
							],
							[
								136.82420446300011,
								-15.68826020199998
							],
							[
								136.837154402,
								-15.687260032999973
							],
							[
								136.82807440300007,
								-15.676860071999954
							],
							[
								136.829144293,
								-15.662969981999936
							],
							[
								136.7946643560001,
								-15.644960320999928
							],
							[
								136.78020444700007,
								-15.648210530999961
							],
							[
								136.7656444480001,
								-15.640390689999947
							],
							[
								136.75035459800006,
								-15.646680929999945
							]
						]
					],
					[
						[
							[
								136.71782532600002,
								-15.762502009999935
							],
							[
								136.72353530600003,
								-15.762061929999959
							],
							[
								136.71806527700005,
								-15.755721949999952
							],
							[
								136.71782532600002,
								-15.762502009999935
							]
						]
					],
					[
						[
							[
								136.72539473000006,
								-15.65330126899994
							],
							[
								136.73179470900004,
								-15.657381218999944
							],
							[
								136.7287846700001,
								-15.648791228999926
							],
							[
								136.72539473000006,
								-15.65330126899994
							]
						]
					],
					[
						[
							[
								137.06994313200005,
								-15.857768071999942
							],
							[
								137.06889321100005,
								-15.866238131999978
							],
							[
								137.07449311200003,
								-15.854717991999962
							],
							[
								137.06994313200005,
								-15.857768071999942
							]
						]
					],
					[
						[
							[
								136.94879362300003,
								-15.759669096999971
							],
							[
								136.9400337630001,
								-15.767679266999949
							],
							[
								136.94667374200003,
								-15.777179236999928
							],
							[
								136.94879362300003,
								-15.759669096999971
							]
						]
					],
					[
						[
							[
								136.81513483100002,
								-15.745840692999934
							],
							[
								136.8208547810001,
								-15.742240592999963
							],
							[
								136.8177247220001,
								-15.730600562999939
							],
							[
								136.82962463100012,
								-15.730730412999947
							],
							[
								136.8187846820001,
								-15.723830502999931
							],
							[
								136.79965474300002,
								-15.728310761999978
							],
							[
								136.8007948920001,
								-15.742210821999947
							],
							[
								136.8070848220001,
								-15.746060771999964
							],
							[
								136.81223479200003,
								-15.737250661999951
							],
							[
								136.81513483100002,
								-15.745840692999934
							]
						]
					],
					[
						[
							[
								136.9485734530001,
								-15.736408966999932
							],
							[
								136.95569343300008,
								-15.736638866999954
							],
							[
								136.94766340400008,
								-15.71765888699997
							],
							[
								136.95431333400006,
								-15.710218776999966
							],
							[
								136.960383244,
								-15.711798716999965
							],
							[
								136.96386330300004,
								-15.730548746999943
							],
							[
								136.97838307200004,
								-15.71240847799993
							],
							[
								136.98283308200007,
								-15.72355848799998
							],
							[
								136.97458320200008,
								-15.737558657999955
							],
							[
								136.98076316100003,
								-15.740498577999972
							],
							[
								136.96967333200007,
								-15.749078767999947
							],
							[
								136.98239318100002,
								-15.749538607999966
							],
							[
								136.97876329100006,
								-15.761958707999952
							],
							[
								136.9893831500001,
								-15.760608567999952
							],
							[
								136.99262332900003,
								-15.792118688999949
							],
							[
								137.01629324700002,
								-15.805568429999937
							],
							[
								137.03450302600004,
								-15.797108179999952
							],
							[
								137.0440531050001,
								-15.817218160999971
							],
							[
								137.039853224,
								-15.835508310999955
							],
							[
								137.074963012,
								-15.846137931999976
							],
							[
								137.07287299200004,
								-15.834387901999946
							],
							[
								137.0977226220001,
								-15.812037472999975
							],
							[
								137.10624231300005,
								-15.773987142999943
							],
							[
								137.07849242500004,
								-15.760657420999962
							],
							[
								137.08036238500006,
								-15.749707350999927
							],
							[
								137.07344242600004,
								-15.745837420999976
							],
							[
								137.0830423650001,
								-15.747897311999964
							],
							[
								137.07779235500004,
								-15.743267350999929
							],
							[
								137.0855021760001,
								-15.712897140999928
							],
							[
								137.07607203800012,
								-15.661627090999957
							],
							[
								137.08167197800003,
								-15.655756980999968
							],
							[
								137.0730419890001,
								-15.649427059999937
							],
							[
								137.06311212900005,
								-15.652687209999954
							],
							[
								137.06513200000006,
								-15.626837079999973
							],
							[
								137.05451215000005,
								-15.64038727999997
							],
							[
								137.0320223120001,
								-15.633937548999938
							],
							[
								137.0228323030001,
								-15.610897557999976
							],
							[
								137.02738224300003,
								-15.60558747899995
							],
							[
								137.00886233500012,
								-15.586717607999958
							],
							[
								137.00396238500002,
								-15.592357707999952
							],
							[
								136.9913824460001,
								-15.584447806999947
							],
							[
								136.9999725340001,
								-15.622847887999967
							],
							[
								136.9767728050001,
								-15.63445818699995
							],
							[
								136.98118284400005,
								-15.656148216999952
							],
							[
								136.995522713,
								-15.658978067999954
							],
							[
								136.9907327830001,
								-15.672868187999939
							],
							[
								136.9839628730001,
								-15.674448267999935
							],
							[
								136.98420285400005,
								-15.66698823799993
							],
							[
								136.9694029850001,
								-15.661108386999956
							],
							[
								136.97116290500003,
								-15.64518828699994
							],
							[
								136.96103298600008,
								-15.640088366999976
							],
							[
								136.94935316600004,
								-15.658268575999955
							],
							[
								136.93629332700004,
								-15.660398745999942
							],
							[
								136.94748320600002,
								-15.663338635999935
							],
							[
								136.94117333600002,
								-15.672258735999947
							],
							[
								136.94793324600005,
								-15.675988695999933
							],
							[
								136.94000340600007,
								-15.684228815999973
							],
							[
								136.9190135670001,
								-15.681949035999935
							],
							[
								136.9388334360001,
								-15.688968845999966
							],
							[
								136.93404349600007,
								-15.697318955999947
							],
							[
								136.9400835140001,
								-15.71990898699994
							],
							[
								136.9292336750001,
								-15.725439155999936
							],
							[
								136.9426435140001,
								-15.726238986999931
							],
							[
								136.94146358400008,
								-15.739789066999947
							],
							[
								136.9485734530001,
								-15.736408966999932
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "701",
				"CED_NAME21": "Lingiari",
				"STE_CODE21": "7",
				"STE_NAME21": "Northern Territory",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 1348089.9937,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/701",
				"SHAPE_Leng": 121.921791275,
				"SHAPE_Area": 116.219775392
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							130.93688456600012,
							-12.342984328999933
						],
						[
							130.92339584700005,
							-12.34479584899998
						],
						[
							130.8944056780001,
							-12.331175838999968
						],
						[
							130.87054581900009,
							-12.35539597899998
						],
						[
							130.86115597000003,
							-12.375766068999951
						],
						[
							130.84215801100004,
							-12.378894198999944
						],
						[
							130.84873404000007,
							-12.39053918899998
						],
						[
							130.84316622000006,
							-12.407746298999939
						],
						[
							130.81638642200005,
							-12.407116518999942
						],
						[
							130.81961645100012,
							-12.41456650899994
						],
						[
							130.8282263310001,
							-12.411616428999935
						],
						[
							130.83556841100005,
							-12.42727341899996
						],
						[
							130.82788462100007,
							-12.449304499999926
						],
						[
							130.81512571100006,
							-12.454143618999979
						],
						[
							130.8212047510001,
							-12.461907699999927
						],
						[
							130.83273667000003,
							-12.45980660999993
						],
						[
							130.8443096200001,
							-12.473697149999964
						],
						[
							130.85192938900002,
							-12.470520559999954
						],
						[
							130.8500576,
							-12.43882986999995
						],
						[
							130.86702640900012,
							-12.440586349999933
						],
						[
							130.85635643900002,
							-12.45099640999996
						],
						[
							130.8819065880001,
							-12.464516569999944
						],
						[
							130.88534656800005,
							-12.45885648999996
						],
						[
							130.8783164780001,
							-12.45050638999993
						],
						[
							130.8860064480001,
							-12.443036359999951
						],
						[
							130.89075659800005,
							-12.465176549999967
						],
						[
							130.91672670700007,
							-12.457446109999978
						],
						[
							130.87032601900012,
							-12.483147289999977
						],
						[
							130.89610365700003,
							-12.49543824999995
						],
						[
							130.90535677700007,
							-12.48068670999993
						],
						[
							130.92586678600003,
							-12.482956699999932
						],
						[
							130.93642670600002,
							-12.471416579999982
						],
						[
							130.94673671500004,
							-12.471036559999959
						],
						[
							130.93070682600012,
							-12.488036739999927
						],
						[
							130.94086693500003,
							-12.504276900999969
						],
						[
							130.94728687500003,
							-12.49647681099998
						],
						[
							130.94193707500006,
							-12.521787070999949
						],
						[
							130.9558779140001,
							-12.534037200999933
						],
						[
							130.97695393300012,
							-12.54130933099998
						],
						[
							130.9808002630001,
							-12.521671130999948
						],
						[
							130.99630670200008,
							-12.510210120999943
						],
						[
							131.00172739200002,
							-12.487106860999972
						],
						[
							130.95098589500003,
							-12.443354989999932
						],
						[
							130.92343109600006,
							-12.43308363999995
						],
						[
							130.92268219700009,
							-12.409910449999927
						],
						[
							130.9382212260001,
							-12.40958760999996
						],
						[
							130.93688456600012,
							-12.342984328999933
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "702",
				"CED_NAME21": "Solomon",
				"STE_CODE21": "7",
				"STE_NAME21": "Northern Territory",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 194.3608,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/702",
				"SHAPE_Leng": 1.1288844266,
				"SHAPE_Area": 0.0161591869813
			}
		},
		{
			"type": "Feature",
			"geometry": null,
			"properties": {
				"CED_CODE21": "794",
				"CED_NAME21": "No usual address (NT)",
				"STE_CODE21": "7",
				"STE_NAME21": "Northern Territory",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 0,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/794",
				"SHAPE_Leng": 0,
				"SHAPE_Area": 0
			}
		},
		{
			"type": "Feature",
			"geometry": null,
			"properties": {
				"CED_CODE21": "797",
				"CED_NAME21": "Migratory - Offshore - Shipping (NT)",
				"STE_CODE21": "7",
				"STE_NAME21": "Northern Territory",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 0,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/797",
				"SHAPE_Leng": 0,
				"SHAPE_Area": 0
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								148.96166256800007,
								-35.21833162599995
							],
							[
								148.8101399100001,
								-35.307435693999935
							],
							[
								148.80107450900005,
								-35.32175799299995
							],
							[
								148.79355220800005,
								-35.33910928299997
							],
							[
								148.80866523100008,
								-35.38244174399995
							],
							[
								148.7956926810001,
								-35.39299024299993
							],
							[
								148.7959819890001,
								-35.406624043999955
							],
							[
								148.78580004100002,
								-35.408897862999936
							],
							[
								148.78892181800006,
								-35.426481862999935
							],
							[
								148.76674716600007,
								-35.46716842199993
							],
							[
								148.7743865230001,
								-35.48613215199998
							],
							[
								148.76279568300004,
								-35.49548612099994
							],
							[
								148.7779544130001,
								-35.558506842999975
							],
							[
								148.77294533300005,
								-35.56778509299994
							],
							[
								148.7887788380001,
								-35.58832686399995
							],
							[
								148.76843939900004,
								-35.603292962999944
							],
							[
								148.78344799400008,
								-35.62849744399995
							],
							[
								148.76750406400004,
								-35.64739976299995
							],
							[
								148.79845373600006,
								-35.66658330599995
							],
							[
								148.79110332300002,
								-35.703412484999944
							],
							[
								148.8225000860001,
								-35.72095786799997
							],
							[
								148.8357971910001,
								-35.741909858999975
							],
							[
								148.85608899600004,
								-35.75353168099997
							],
							[
								148.85567113600007,
								-35.76094555099996
							],
							[
								148.87771954800007,
								-35.71494868199994
							],
							[
								148.88937302500005,
								-35.72277494399998
							],
							[
								148.88807889400005,
								-35.737045733999935
							],
							[
								148.90332515900002,
								-35.757924344999935
							],
							[
								148.89486838800008,
								-35.771865273999936
							],
							[
								148.89778257500006,
								-35.79464634499993
							],
							[
								148.88668449500005,
								-35.81005085399994
							],
							[
								148.9070689890001,
								-35.82956586599994
							],
							[
								148.90945125500002,
								-35.85306070599995
							],
							[
								148.96160460200008,
								-35.896707540999955
							],
							[
								148.97566167000002,
								-35.892163221999965
							],
							[
								148.9976681160001,
								-35.89641361399998
							],
							[
								148.99942254500002,
								-35.902664303999984
							],
							[
								149.01240047300007,
								-35.89961068499997
							],
							[
								149.04638631500006,
								-35.92051720799998
							],
							[
								149.05487563500003,
								-35.91393029899996
							],
							[
								149.0517860770001,
								-35.90208943799996
							],
							[
								149.06428931800008,
								-35.87493448899994
							],
							[
								149.09569287700003,
								-35.845623821999936
							],
							[
								149.09357740000007,
								-35.82409883099996
							],
							[
								149.10060541000007,
								-35.81469063199995
							],
							[
								149.0907150280001,
								-35.765604020999945
							],
							[
								149.10942325400003,
								-35.69657283199996
							],
							[
								149.09530366900003,
								-35.67926740099995
							],
							[
								149.0974849920001,
								-35.64728233099993
							],
							[
								149.08756849500003,
								-35.63963966999995
							],
							[
								149.0781532730001,
								-35.58640404899995
							],
							[
								149.08461994300012,
								-35.58080176899995
							],
							[
								149.14268707200006,
								-35.592776353999966
							],
							[
								149.1314590390001,
								-35.55358992299995
							],
							[
								149.1516156140001,
								-35.493187313999954
							],
							[
								149.13509793100002,
								-35.45402107299998
							],
							[
								149.15510071000006,
								-35.43597895399995
							],
							[
								149.13822591400003,
								-35.42909021299994
							],
							[
								149.2063651740001,
								-35.345920157999956
							],
							[
								149.17620033000003,
								-35.33761879499997
							],
							[
								149.10046693000004,
								-35.350684548999936
							],
							[
								149.08701602300005,
								-35.33658670799997
							],
							[
								149.08411825200005,
								-35.34885672699994
							],
							[
								149.06956150500002,
								-35.348356905999935
							],
							[
								149.06211157100006,
								-35.307180124999945
							],
							[
								149.08647057100006,
								-35.28061714699993
							],
							[
								149.03396555000006,
								-35.265874132999954
							],
							[
								149.01997058100005,
								-35.280451451999966
							],
							[
								148.99897746700003,
								-35.258590169999934
							],
							[
								148.98772060800002,
								-35.26233308899998
							],
							[
								148.9731870810001,
								-35.255983826999966
							],
							[
								148.96135009400007,
								-35.24558693599994
							],
							[
								148.9762597230001,
								-35.23882380799995
							],
							[
								148.96166256800007,
								-35.21833162599995
							]
						]
					],
					[
						[
							[
								167.97344729700012,
								-29.021911375999935
							],
							[
								167.95456724200005,
								-29.005510382999944
							],
							[
								167.919620247,
								-28.99528037799996
							],
							[
								167.91377425500002,
								-29.008142366999948
							],
							[
								167.9232922540001,
								-29.009460368999953
							],
							[
								167.9189122460001,
								-29.05180336799998
							],
							[
								167.93315822400007,
								-29.05391936999996
							],
							[
								167.9367172320001,
								-29.06322137099994
							],
							[
								167.94780925200007,
								-29.05636037299996
							],
							[
								167.96246322900004,
								-29.06287337499998
							],
							[
								167.98585224800001,
								-29.05688036899994
							],
							[
								167.98319126,
								-29.049179377999963
							],
							[
								167.9947662400001,
								-29.04608338999998
							],
							[
								167.99744425300003,
								-29.02717236999996
							],
							[
								167.97344729700012,
								-29.021911375999935
							]
						]
					],
					[
						[
							[
								167.94747223800005,
								-29.12756537299998
							],
							[
								167.95076923700003,
								-29.132949373999963
							],
							[
								167.95305622800004,
								-29.122400373999938
							],
							[
								167.96072421700012,
								-29.12402637499997
							],
							[
								167.96592922800005,
								-29.11674037599994
							],
							[
								167.94404722100012,
								-29.114806362999957
							],
							[
								167.94747223800005,
								-29.12756537299998
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "801",
				"CED_NAME21": "Bean",
				"STE_CODE21": "8",
				"STE_NAME21": "Australian Capital Territory",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 1914.0064,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/801",
				"SHAPE_Leng": 3.15241098202,
				"SHAPE_Area": 0.189990089315
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[
							149.03396555000006,
							-35.265874132999954
						],
						[
							149.08647057100006,
							-35.28061714699993
						],
						[
							149.06211157100006,
							-35.307180124999945
						],
						[
							149.06956150500002,
							-35.348356905999935
						],
						[
							149.08411825200005,
							-35.34885672699994
						],
						[
							149.08701602300005,
							-35.33658670799997
						],
						[
							149.10046693000004,
							-35.350684548999936
						],
						[
							149.17620033000003,
							-35.33761879499997
						],
						[
							149.2063651740001,
							-35.345920157999956
						],
						[
							149.25474977800002,
							-35.33010834199996
						],
						[
							149.281725133,
							-35.33806310399996
						],
						[
							149.2936679820001,
							-35.33212167499994
						],
						[
							149.33641903500006,
							-35.33971404899995
						],
						[
							149.35604362000004,
							-35.350636270999985
						],
						[
							149.39929254800006,
							-35.31907684399994
						],
						[
							149.39479073000007,
							-35.303175873999976
						],
						[
							149.3616713450001,
							-35.30901194099994
						],
						[
							149.3415037110001,
							-35.28668998899997
						],
						[
							149.32248233400003,
							-35.28672741699995
						],
						[
							149.315305856,
							-35.27621808699996
						],
						[
							149.27181343300003,
							-35.27347192299993
						],
						[
							149.27318448500012,
							-35.25916603299993
						],
						[
							149.23437914300007,
							-35.242778699999974
						],
						[
							149.24553711300007,
							-35.22670985999997
						],
						[
							149.21378999900003,
							-35.21959329799995
						],
						[
							149.20499151900003,
							-35.229087456999935
						],
						[
							149.20852309100007,
							-35.21149882699996
						],
						[
							149.20070222300012,
							-35.20555282599997
						],
						[
							149.15128836700012,
							-35.230955121999955
						],
						[
							149.14212248900003,
							-35.225549231999935
						],
						[
							149.1251252410001,
							-35.231378509999956
						],
						[
							149.11001191600008,
							-35.21054254899997
						],
						[
							149.09268507000002,
							-35.201938696999946
						],
						[
							149.0741847590001,
							-35.22584387599994
						],
						[
							149.0802886880001,
							-35.23100180599994
						],
						[
							149.075778086,
							-35.25043884599995
						],
						[
							149.03015477400004,
							-35.239583341999946
						],
						[
							149.02612557300006,
							-35.25505513199994
						],
						[
							149.03396555000006,
							-35.265874132999954
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "802",
				"CED_NAME21": "Canberra",
				"STE_CODE21": "8",
				"STE_NAME21": "Australian Capital Territory",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 311.9225,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/802",
				"SHAPE_Leng": 1.17476437618,
				"SHAPE_Area": 0.0309066111428
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								149.03396555000006,
								-35.265874132999954
							],
							[
								149.02612557300006,
								-35.25505513199994
							],
							[
								149.03015477400004,
								-35.239583341999946
							],
							[
								149.075778086,
								-35.25043884599995
							],
							[
								149.0802886880001,
								-35.23100180599994
							],
							[
								149.0741847590001,
								-35.22584387599994
							],
							[
								149.09268507000002,
								-35.201938696999946
							],
							[
								149.11001191600008,
								-35.21054254899997
							],
							[
								149.1251252410001,
								-35.231378509999956
							],
							[
								149.14212248900003,
								-35.225549231999935
							],
							[
								149.15128836700012,
								-35.230955121999955
							],
							[
								149.20070222300012,
								-35.20555282599997
							],
							[
								149.18954750500006,
								-35.20331081499995
							],
							[
								149.19704078600012,
								-35.18535545599997
							],
							[
								149.18364640900006,
								-35.17565604499998
							],
							[
								149.18561189000002,
								-35.16110917499998
							],
							[
								149.167583583,
								-35.15973914299997
							],
							[
								149.16428377600005,
								-35.141892232999965
							],
							[
								149.14673173800008,
								-35.14453988099996
							],
							[
								149.13899202200002,
								-35.12797041099998
							],
							[
								149.12095342500004,
								-35.124402938999935
							],
							[
								148.96166256800007,
								-35.21833162599995
							],
							[
								148.9762597230001,
								-35.23882380799995
							],
							[
								148.96135009400007,
								-35.24558693599994
							],
							[
								148.9731870810001,
								-35.255983826999966
							],
							[
								148.98772060800002,
								-35.26233308899998
							],
							[
								148.99897746700003,
								-35.258590169999934
							],
							[
								149.01997058100005,
								-35.280451451999966
							],
							[
								149.03396555000006,
								-35.265874132999954
							]
						]
					],
					[
						[
							[
								150.594496853,
								-35.18398433899995
							],
							[
								150.63262835000012,
								-35.16640927299994
							],
							[
								150.68262133200005,
								-35.16538028699995
							],
							[
								150.6957982990001,
								-35.17722927799997
							],
							[
								150.6951483460001,
								-35.20085926899998
							],
							[
								150.72487430500007,
								-35.17293828099997
							],
							[
								150.7374483420001,
								-35.18007129199998
							],
							[
								150.75560533100008,
								-35.17073828399998
							],
							[
								150.76492032600004,
								-35.124143293999964
							],
							[
								150.75301734700008,
								-35.12424528299994
							],
							[
								150.73843029800003,
								-35.13718928199995
							],
							[
								150.72187135100012,
								-35.13566228099995
							],
							[
								150.70195618500009,
								-35.12301691899995
							],
							[
								150.66135525200002,
								-35.11780707499997
							],
							[
								150.63375089200008,
								-35.14893223299998
							],
							[
								150.59397443900002,
								-35.14382316899997
							],
							[
								150.60617065500003,
								-35.15532991999993
							],
							[
								150.594496853,
								-35.18398433899995
							]
						]
					]
				]
			},
			"properties": {
				"CED_CODE21": "803",
				"CED_NAME21": "Fenner",
				"STE_CODE21": "8",
				"STE_NAME21": "Australian Capital Territory",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 238.0847,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/803",
				"SHAPE_Leng": 1.47256310131,
				"SHAPE_Area": 0.0235611483418
			}
		},
		{
			"type": "Feature",
			"geometry": null,
			"properties": {
				"CED_CODE21": "894",
				"CED_NAME21": "No usual address (ACT)",
				"STE_CODE21": "8",
				"STE_NAME21": "Australian Capital Territory",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 0,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/894",
				"SHAPE_Leng": 0,
				"SHAPE_Area": 0
			}
		},
		{
			"type": "Feature",
			"geometry": null,
			"properties": {
				"CED_CODE21": "897",
				"CED_NAME21": "Migratory - Offshore - Shipping (ACT)",
				"STE_CODE21": "8",
				"STE_NAME21": "Australian Capital Territory",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 0,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/897",
				"SHAPE_Leng": 0,
				"SHAPE_Area": 0
			}
		},
		{
			"type": "Feature",
			"geometry": null,
			"properties": {
				"CED_CODE21": "994",
				"CED_NAME21": "No usual address (OT)",
				"STE_CODE21": "9",
				"STE_NAME21": "Other Territories",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 0,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/994",
				"SHAPE_Leng": 0,
				"SHAPE_Area": 0
			}
		},
		{
			"type": "Feature",
			"geometry": null,
			"properties": {
				"CED_CODE21": "997",
				"CED_NAME21": "Migratory - Offshore - Shipping (OT)",
				"STE_CODE21": "9",
				"STE_NAME21": "Other Territories",
				"AUS_CODE21": "AUS",
				"AUS_NAME21": "Australia",
				"AREASQKM21": 0,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/997",
				"SHAPE_Leng": 0,
				"SHAPE_Area": 0
			}
		},
		{
			"type": "Feature",
			"geometry": null,
			"properties": {
				"CED_CODE21": "ZZZ",
				"CED_NAME21": "Outside Australia",
				"STE_CODE21": "Z",
				"STE_NAME21": "Outside Australia",
				"AUS_CODE21": "ZZZ",
				"AUS_NAME21": "Outside Australia",
				"AREASQKM21": 0,
				"LOCI_URI21": "http://linked.data.gov.au/dataset/asgsed3/CED2021/ZZZ",
				"SHAPE_Leng": 0,
				"SHAPE_Area": 0
			}
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/electorate.json
// module id = 823
// module chunks = 0